// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAuSURBVHgBxYyxDQAwDMJIL+YT+DjtzFRliUfLcklqBCRT4eCTxbD6kdL2/LgYXqpvCbs3kBv/AAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 version=%271.1%27%3e%3cline x1=%270%27 x2=%2720%27 y1=%270%27 y2=%2720%27 stroke=%27%23dc3545%27 stroke-width=%271%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27white%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/gif;base64,R0lGODlhAQC0AIABALi4uAAAACH5BAEAAAEALAAAAAABALQAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/gif;base64,R0lGODlhtAABAIABALi4uAAAACH5BAEAAAEALAAAAAC0AAEAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-sr-only {
    position: absolute;
    left: -1px;
    width: 1px;
    height: 1px;
    overflow: hidden;
}

.k-theme-test-class,
.k-common-test-class {
    opacity: 0;
}

.k-body {
    font-size: var(--kendo-font-size, inherit);
    font-family: var(--kendo-font-family, inherit);
    line-height: var(--kendo-line-height, normal);
    font-weight: var(--kendo-font-weight, normal);
    letter-spacing: var(--kendo-letter-spacing, normal);
    color: var(--kendo-body-text, initial);
    background-color: var(--kendo-body-bg, initial);
    margin: 0;
}

.k-hstack, .k-hbox {
    display: flex;
    flex-flow: row nowrap;
}

.k-vstack, .k-vbox {
    display: flex;
    flex-flow: column nowrap;
}

.k-spacer, .k-flex {
    flex: 1 1 auto;
}

.k-spacer-sized {
    flex: none;
}

.k-float-wrap::after, .k-floatwrap::after {
    content: "";
    display: block;
    clear: both;
}

.k-flex-layout {
    display: flex;
}

.k-grid-layout {
    display: grid;
}

.k-separator {
    width: auto;
    height: 0;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: inherit;
    display: block;
    flex-grow: 0 !important;
    flex-shrink: 0 !important;
    align-self: stretch;
}

.k-separator-horizontal,
.k-vstack > .k-separator,
.k-vbox > .k-separator {
    width: auto;
    height: 0;
    border-width: 1px 0 0;
}

.k-separator-vertical,
.k-hstack > .k-separator,
.k-hbox > .k-separator {
    width: 0;
    height: auto;
    border-width: 0 0 0 1px;
}

hr.k-separator {
    margin: 0;
    padding: 0;
}

.k-hidden {
    display: none !important;
}

.k-rtl {
    direction: rtl;
}

[hidden] {
    display: none !important;
}

script {
    display: none !important;
}

.k-disabled,
.k-widget[disabled],
.k-disabled {
    outline: none;
    cursor: default;
    color: var(--kendo-disabled-text, inherit);
    border-color: var(--kendo-disabled-border, inherit);
    pointer-events: none;
    box-shadow: none;
}

.k-disabled .k-link,
.k-widget[disabled] .k-link,
.k-disabled .k-link {
    cursor: default;
    outline: 0;
}

.k-hr {
    margin-block: 1rem;
    padding: 0;
    height: 0;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: var(--kendo-component-border, inherit);
    display: block;
    float: none;
    clear: both;
}

.k-d-flex-row > .k-hr {
    margin: 0;
    width: 0;
    height: auto;
    border-width: 0 0 0 1px;
    flex: 0 0 auto;
}

.k-d-flex-col > .k-hr {
    margin: 0;
    flex: 0 0 auto;
}

.k-sprite {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    overflow: hidden;
    background-repeat: no-repeat;
    font-size: 0;
    line-height: 0;
    text-align: center;
}

.k-image {
    display: inline-block;
}

.k-reset {
    margin: 0;
    padding: 0;
    border-width: 0;
    outline: 0;
    text-decoration: none;
    font: inherit;
    list-style: none;
}

kendo-sortable {
    display: block;
}

.k-link,
.k-link:hover {
    color: inherit;
    text-decoration: none;
    outline: 0;
    cursor: pointer;
}

.k-content {
    outline: 0;
}

.k-centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.k-no-click {
    pointer-events: none;
}

.k-pdf-export-shadow {
    position: absolute;
    overflow: hidden;
    left: -15000px;
    width: 14400px;
}

.kendo-pdf-hide-pseudo-elements::before,
.kendo-pdf-hide-pseudo-elements::after {
    display: none !important;
}

.k-dirty {
    margin: 0;
    padding: 0;
    width: 0;
    height: 0;
    border-width: 3px;
    border-style: solid;
    border-block-start-color: currentColor;
    border-block-end-color: transparent;
    border-inline-start-color: transparent;
    border-inline-end-color: currentColor;
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: 0;
}

.k-loading-mask,
.k-loading-image,
.k-loading-color {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
}

.k-loading-mask *,
.k-loading-mask *::before,
.k-loading-mask *::after, .k-loading-mask::before, .k-loading-mask::after,
.k-loading-image *,
.k-loading-image *::before,
.k-loading-image *::after,
.k-loading-image::before,
.k-loading-image::after,
.k-loading-color *,
.k-loading-color *::before,
.k-loading-color *::after,
.k-loading-color::before,
.k-loading-color::after {
    box-sizing: border-box;
}

.k-loading-mask {
    z-index: 100;
}

.k-loading-mask.k-opaque .k-loading-color {
    opacity: 1;
}

.k-loading-text {
    text-indent: -4000px;
    text-align: center;
    position: absolute;
}

.k-loading-image {
    z-index: 2;
}

.k-loading-color {
    opacity: 0.3;
}

.k-i-loading {
    width: 1em;
    height: 1em;
    line-height: 1;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    background-color: transparent;
    box-sizing: border-box;
}

.k-i-loading::before, .k-i-loading::after {
    box-sizing: border-box;
}

.k-i-loading::before,
.k-i-loading::after,
.k-loading-image::before,
.k-loading-image::after {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    content: "";
    box-sizing: inherit;
    border-radius: 50%;
    border-width: .05em;
    border-style: solid;
    border-color: currentColor;
    border-top-color: transparent;
    border-bottom-color: transparent;
    background-color: transparent;
}

.k-icon.k-i-loading::before,
.k-icon.k-i-loading::after {
    content: "";
}

.k-i-loading::before,
.k-loading-image::before {
    margin-top: -.5em;
    margin-left: -.5em;
    width: 1em;
    height: 1em;
    animation: k-loading-animation .7s linear infinite;
}

.k-i-loading::after,
.k-loading-image::after {
    margin-top: -.25em;
    margin-left: -.25em;
    width: .5em;
    height: .5em;
    animation: k-loading-animation reverse 1.4s linear infinite;
}

.k-loading-image::before,
.k-loading-image::after {
    content: "";
    border-width: 1px;
    border-width: clamp(0.015em, 1px, 1px);
    font-size: 4em;
}

@keyframes k-loading-animation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.k-marquee {
    position: absolute;
    z-index: 100000;
}

.k-marquee-color,
.k-marquee-text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.k-marquee-color {
    color: white;
    background-color: var(--kendo-primary-60, #0d6efd);
    border-color: var(--kendo-primary-100, #0c65e9);
    opacity: .6;
}

.k-marquee-text {
    color: white;
}

:root {
    --kendo-elevation-1: 0px 1px 2px rgba(0, 0, 0, 0.038);
    --kendo-elevation-2: 0px 2px 7px rgba(0, 0, 0, 0.075);
    --kendo-elevation-3: 0px 4px 10px rgba(0, 0, 0, 0.1);
    --kendo-elevation-4: 0px 6px 13px rgba(0, 0, 0, 0.125);
    --kendo-elevation-5: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
    --kendo-elevation-6: 0px 11px 24px 0px rgba(0, 0, 0, 0.159);
    --kendo-elevation-7: 0px 14px 36px 0px rgba(0, 0, 0, 0.168);
    --kendo-elevation-8: 0px 16px 48px 0px rgba(0, 0, 0, 0.176);
    --kendo-elevation-9: 0px 18px 60px 0px rgba(0, 0, 0, 0.185);
}

.k-reset {
    margin: 0;
    padding: 0;
    border-width: 0;
    outline: 0;
    text-decoration: none;
    font: inherit;
    list-style: none;
}

kendo-sortable {
    display: block;
}

.k-link,
.k-link:hover {
    color: inherit;
    text-decoration: none;
    outline: 0;
    cursor: pointer;
}

.k-content {
    outline: 0;
}

.k-centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.k-no-click {
    pointer-events: none;
}

.k-pdf-export-shadow {
    position: absolute;
    overflow: hidden;
    left: -15000px;
    width: 14400px;
}

.kendo-pdf-hide-pseudo-elements::before,
.kendo-pdf-hide-pseudo-elements::after {
    display: none !important;
}

.k-text-selection ::selection {
    background-color: #0d6efd;
    color: white;
}

.k-block,
.k-panel {
    border-radius: 0.375rem;
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
    padding: 0;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
}

.k-block > .k-header,
.k-panel > .k-header {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
    padding-inline: 0.5rem;
    padding-block: 0.25rem;
}

.k-block > .k-content,
.k-panel > .k-content {
    padding-inline: 0.5rem;
    padding-block: 0.25rem;
}

.k-content {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-disabled,
.k-widget[disabled] {
    outline: none;
    cursor: default;
    opacity: 0.65;
    filter: grayscale(0.1);
    pointer-events: none;
    box-shadow: none;
}

.k-disabled .k-link,
.k-widget[disabled] .k-link {
    cursor: default;
    outline: 0;
}

.k-disabled [disabled],
.k-disabled .k-disabled,
.k-widget[disabled] [disabled],
.k-widget[disabled] .k-disabled {
    opacity: 1;
    filter: grayscale(0);
}

.k-hr {
    margin: 1rem auto;
    padding: 0;
    height: 0;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: #dee2e6;
    display: block;
    float: none;
    clear: both;
}

.k-d-flex-row > .k-hr {
    margin: 0;
    width: 0;
    height: auto;
    border-width: 0 0 0 1px;
    flex: 0 0 auto;
}

.k-d-flex-col > .k-hr {
    margin: 0;
    flex: 0 0 auto;
}

.k-dirty {
    margin: 0;
    padding: 0;
    width: 0;
    height: 0;
    border-width: 3px;
    border-style: solid;
    border-color: #dc3545 #dc3545 transparent transparent;
    position: absolute;
    top: 0;
    right: 0;
}

[dir="rtl"] .k-dirty,
.k-rtl .k-dirty {
    border-color: transparent transparent #dc3545 #dc3545;
    right: auto;
    left: 0;
}

.k-animation-container {
    position: absolute;
    overflow: hidden;
    z-index: 100;
}

.k-animation-container-fixed {
    position: fixed;
}

.k-animation-container-relative {
    position: relative;
    display: inline-block;
}

.k-push-right-enter, .k-push-right-appear {
    transform: translate(-100%, 0);
}

.k-push-right-enter-active, .k-push-right-appear-active {
    transform: translate(0, 0);
    transition: transform 300ms ease-in-out;
}

.k-push-right-exit {
    transform: translate(0, 0);
}

.k-push-right-exit-active {
    transform: translate(100%, 0);
    transition: transform 300ms ease-in-out;
}

.k-push-left-enter, .k-push-left-appear {
    transform: translate(100%, 0);
}

.k-push-left-enter-active, .k-push-left-appear-active {
    transform: translate(0, 0);
    transition: transform 300ms ease-in-out;
}

.k-push-left-exit {
    transform: translate(0, 0);
}

.k-push-left-exit-active {
    transform: translate(-100%, 0);
    transition: transform 300ms ease-in-out;
}

.k-push-down-enter, .k-push-down-appear {
    transform: translate(0, -100%);
}

.k-push-down-enter-active, .k-push-down-appear-active {
    transform: translate(0, 0);
    transition: transform 300ms ease-in-out;
}

.k-push-down-exit {
    transform: translate(0, 0);
}

.k-push-down-exit-active {
    transform: translate(0, 100%);
    transition: transform 300ms ease-in-out;
}

.k-push-up-enter, .k-push-up-appear {
    transform: translate(0, 100%);
}

.k-push-up-enter-active, .k-push-up-appear-active {
    transform: translate(0, 0);
    transition: transform 300ms ease-in-out;
}

.k-push-up-exit {
    transform: translate(0, 0);
}

.k-push-up-exit-active {
    transform: translate(0, -100%);
    transition: transform 300ms ease-in-out;
}

.k-expand-vertical-enter, .k-expand-vertical-appear {
    transform: scaleY(0);
}

.k-expand-vertical-enter-active, .k-expand-vertical-appear-active {
    transform: scaleY(1);
    transition: transform 300ms ease-in-out;
}

.k-expand-vertical-exit {
    transform: scaleY(1);
}

.k-expand-vertical-exit-active {
    transform: scaleY(0);
    transition: transform 300ms ease-in-out;
}

.k-expand-horizontal-enter, .k-expand-horizontal-appear {
    transform: scaleX(0);
}

.k-expand-horizontal-enter-active, .k-expand-horizontal-appear-active {
    transform: scaleX(1);
    transition: transform 300ms ease-in-out;
}

.k-expand-horizontal-exit {
    transform: scaleX(1);
}

.k-expand-horizontal-exit-active {
    transform: scaleX(0);
    transition: transform 300ms ease-in-out;
}

.k-fade-enter, .k-fade-appear {
    opacity: 0;
}

.k-fade-enter-active, .k-fade-appear-active {
    opacity: 1;
    transition: opacity 500ms ease-in-out;
}

.k-fade-exit {
    opacity: 1;
}

.k-fade-exit-active {
    opacity: 0;
    transition: opacity 500ms ease-in-out;
}

.k-fade-exit-active + .k-fade-exit-active,
.k-fade-enter-active + .k-fade-enter-active {
    display: none;
}

.k-zoom-in-enter, .k-zoom-in-appear {
    opacity: 0;
    transform: scale(0);
}

.k-zoom-in-enter-active, .k-zoom-in-appear-active {
    opacity: 1;
    transform: scale(1);
    transition: transform, opacity 300ms ease-in-out;
}

.k-zoom-in-exit {
    opacity: 1;
    transform: scale(1);
}

.k-zoom-in-exit-active {
    opacity: 0;
    transform: scale(2);
    transition: transform, opacity 300ms ease-in-out;
}

.k-zoom-out-enter, .k-zoom-out-appear {
    opacity: 0;
    transform: scale(2);
}

.k-zoom-out-enter-active, .k-zoom-out-appear-active {
    opacity: 1;
    transform: scale(1);
    transition: transform, opacity 300ms ease-in-out;
}

.k-zoom-out-exit {
    opacity: 1;
    transform: scale(1);
}

.k-zoom-out-exit-active {
    opacity: 0;
    transform: scale(0);
    transition: transform, opacity 300ms ease-in-out;
}

.k-slide-in-appear {
    opacity: .1;
    transform: translate(0, -3em);
}

.k-slide-in-appear .k-centered {
    transform: translate(-50%, -60%);
}

.k-slide-in-appear-active {
    opacity: 1;
    transform: translate(0, 0);
    transition: transform 0.3s cubic-bezier(0.2, 0.6, 0.4, 1), opacity 0.3s cubic-bezier(0.2, 1, 0.2, 1);
}

.k-slide-in-appear-active .k-centered {
    transform: translate(-50%, -50%);
}

.k-slide-down-enter, .k-slide-down-appear {
    transform: translateY(-100%);
}

.k-slide-down-enter-active, .k-slide-down-appear-active {
    transform: translateY(0);
    transition: transform 300ms ease-in-out;
}

.k-slide-down-exit {
    transform: translateY(0);
}

.k-slide-down-exit-active {
    transform: translateY(-100%);
    transition: transform 300ms ease-in-out;
}

.k-slide-up-enter, .k-slide-up-appear {
    transform: translateY(100%);
}

.k-slide-up-enter-active, .k-slide-up-appear-active {
    transform: translateY(0);
    transition: transform 300ms ease-in-out;
}

.k-slide-up-exit {
    transform: translateY(0);
}

.k-slide-up-exit-active {
    transform: translateY(100%);
    transition: transform 300ms ease-in-out;
}

.k-slide-right-enter, .k-slide-right-appear {
    transform: translateX(-100%);
}

.k-slide-right-enter-active, .k-slide-right-appear-active {
    transform: translateX(0);
    transition: transform 300ms ease-in-out;
}

.k-slide-right-exit {
    transform: translateX(0);
}

.k-slide-right-exit-active {
    transform: translateX(-100%);
    transition: transform 300ms ease-in-out;
}

.k-slide-left-enter, .k-slide-left-appear {
    transform: translateX(100%);
}

.k-slide-left-enter-active, .k-slide-left-appear-active {
    transform: translateX(0);
    transition: transform 300ms ease-in-out;
}

.k-slide-left-exit {
    transform: translateX(0);
}

.k-slide-left-exit-active {
    transform: translateX(100%);
    transition: transform 300ms ease-in-out;
}

.k-reveal-vertical-enter, .k-reveal-vertical-appear {
    max-height: 0;
}

.k-reveal-vertical-enter-active, .k-reveal-vertical-appear-active {
    transition: max-height 300ms ease-in-out;
}

.k-reveal-vertical-exit-active {
    max-height: 0 !important;
    transition: max-height 300ms ease-in-out;
}

.k-reveal-horizontal-enter, .k-reveal-horizontal-appear {
    max-width: 0;
}

.k-reveal-horizontal-enter-active, .k-reveal-horizontal-appear-active {
    transition: max-width 300ms ease-in-out;
}

.k-reveal-horizontal-exit-active {
    max-width: 0 !important;
    transition: max-width 300ms ease-in-out;
}

.k-fx-end .k-fx-next,
.k-fx-end .k-fx-current {
    transition: all 350ms ease-out;
}

.k-fx {
    position: relative;
}

.k-fx .k-fx-current {
    z-index: 0;
}

.k-fx .k-fx-next {
    z-index: 1;
}

.k-fx-hidden,
.k-fx-hidden * {
    visibility: hidden !important;
}

.k-fx-reverse .k-fx-current {
    z-index: 1;
}

.k-fx-reverse .k-fx-next {
    z-index: 0;
}

.k-fx-zoom.k-fx-start .k-fx-next {
    transform: scale(0) !important;
}

.k-fx-zoom.k-fx-end .k-fx-next {
    transform: scale(1) !important;
}

.k-fx-zoom.k-fx-reverse.k-fx-start .k-fx-next,
.k-fx-zoom.k-fx-reverse.k-fx-end .k-fx-next {
    transform: scale(1) !important;
}

.k-fx-zoom.k-fx-reverse.k-fx-start .k-fx-current {
    transform: scale(1) !important;
}

.k-fx-zoom.k-fx-reverse.k-fx-end .k-fx-current {
    transform: scale(0) !important;
}

.k-fx-fade.k-fx-start .k-fx-next {
    will-change: opacity;
    opacity: 0;
}

.k-fx-fade.k-fx-end .k-fx-next {
    opacity: 1;
}

.k-fx-fade.k-fx-reverse.k-fx-start .k-fx-current {
    will-change: opacity;
    opacity: 1;
}

.k-fx-fade.k-fx-reverse.k-fx-end .k-fx-current {
    opacity: 0;
}

.k-fx-slide.k-fx-end .k-fx-next .k-content,
.k-fx-slide.k-fx-end .k-fx-next .k-header,
.k-fx-slide.k-fx-end .k-fx-next .k-footer,
.k-fx-slide.k-fx-end .k-fx-current .k-content,
.k-fx-slide.k-fx-end .k-fx-current .k-header,
.k-fx-slide.k-fx-end .k-fx-current .k-footer,
.k-fx-slide.k-fx-end .k-fx-next .km-content,
.k-fx-slide.k-fx-end .k-fx-next .km-header,
.k-fx-slide.k-fx-end .k-fx-next .km-footer,
.k-fx-slide.k-fx-end .k-fx-current .km-content,
.k-fx-slide.k-fx-end .k-fx-current .km-header,
.k-fx-slide.k-fx-end .k-fx-current .km-footer {
    transition: all 350ms ease-out;
}

.k-fx-slide.k-fx-start .k-fx-next .k-content,
.k-fx-slide.k-fx-start .k-fx-next .km-content {
    will-change: transform;
    transform: translateX(100%);
}

.k-fx-slide.k-fx-start .k-fx-next .k-header,
.k-fx-slide.k-fx-start .k-fx-next .k-footer,
.k-fx-slide.k-fx-start .k-fx-next .km-header,
.k-fx-slide.k-fx-start .k-fx-next .km-footer {
    will-change: opacity;
    opacity: 0;
}

.k-fx-slide.k-fx-end .k-fx-current .k-content,
.k-fx-slide.k-fx-end .k-fx-current .km-content {
    transform: translateX(-100%);
}

.k-fx-slide.k-fx-end .k-fx-next .k-header,
.k-fx-slide.k-fx-end .k-fx-next .k-footer,
.k-fx-slide.k-fx-end .k-fx-next .km-header,
.k-fx-slide.k-fx-end .k-fx-next .km-footer {
    opacity: 1;
}

.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-content,
.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-content {
    will-change: transform;
    transform: translateX(0);
}

.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-content,
.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-content {
    transform: translateX(100%);
}

.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-content,
.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-content {
    transform: translateX(-100%);
}

.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-content,
.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-content {
    transform: translateX(0);
}

.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-header,
.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-footer,
.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-header,
.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-footer {
    will-change: opacity;
    opacity: 1;
}

.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-header,
.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-footer,
.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-header,
.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-footer {
    opacity: 1;
}

.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-header,
.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-footer,
.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-header,
.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-footer {
    opacity: 0;
}

.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-header,
.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-footer,
.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-header,
.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-footer {
    opacity: 1;
}

.k-fx-slide.k-fx-right.k-fx-start .k-fx-next .k-content,
.k-fx-slide.k-fx-right.k-fx-start .k-fx-next .km-content {
    transform: translateX(-100%);
}

.k-fx-slide.k-fx-right.k-fx-end .k-fx-current .k-content,
.k-fx-slide.k-fx-right.k-fx-end .k-fx-current .km-content {
    transform: translateX(100%);
}

.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current .k-content,
.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current .km-content {
    transform: translateX(0);
}

.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current .k-content,
.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current .km-content {
    transform: translateX(-100%);
}

.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next .k-content,
.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next .km-content {
    transform: translateX(100%);
}

.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next .k-content,
.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next .km-content {
    transform: translateX(0%);
}

.k-fx-tile.k-fx-start .k-fx-next {
    will-change: transform;
    transform: translateX(100%);
}

.k-fx-tile.k-fx-end .k-fx-current {
    transform: translateX(-100%);
}

.k-fx-tile.k-fx-reverse.k-fx-start .k-fx-current {
    will-change: transform;
    transform: translateX(0);
}

.k-fx-tile.k-fx-reverse.k-fx-end .k-fx-current {
    transform: translateX(100%);
}

.k-fx-tile.k-fx-reverse.k-fx-start .k-fx-next {
    transform: translateX(-100%);
}

.k-fx-tile.k-fx-reverse.k-fx-end .k-fx-next {
    transform: translateX(0);
}

.k-fx-tile.k-fx-right.k-fx-start .k-fx-next {
    transform: translateX(-100%);
}

.k-fx-tile.k-fx-right.k-fx-end .k-fx-current {
    transform: translateX(100%);
}

.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current {
    transform: translateX(0);
}

.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current {
    transform: translateX(-100%);
}

.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next {
    transform: translateX(100%);
}

.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next {
    transform: translateX(0%);
}

.k-fx.k-fx-overlay.k-fx-start .k-fx-next,
.k-fx.k-fx-overlay.k-fx-left.k-fx-start .k-fx-next {
    will-change: transform;
    transform: translateX(100%);
}

.k-fx.k-fx-overlay.k-fx-right.k-fx-start .k-fx-next {
    transform: translateX(-100%);
}

.k-fx.k-fx-overlay.k-fx-up.k-fx-start .k-fx-next {
    transform: translateY(100%);
}

.k-fx.k-fx-overlay.k-fx-down.k-fx-start .k-fx-next {
    transform: translateY(-100%);
}

.k-fx.k-fx-overlay.k-fx-reverse.k-fx-start .k-fx-next {
    transform: none;
}

.k-fx.k-fx-overlay.k-fx-reverse.k-fx-start .k-fx-current {
    will-change: transform;
    transform: none;
}

.k-fx.k-fx-overlay.k-fx-reverse.k-fx-end .k-fx-current,
.k-fx.k-fx-overlay.k-fx-reverse.k-fx-left.k-fx-end .k-fx-current {
    transform: translateX(100%);
}

.k-fx.k-fx-overlay.k-fx-reverse.k-fx-right.k-fx-end .k-fx-current {
    transform: translateX(-100%);
}

.k-fx.k-fx-overlay.k-fx-reverse.k-fx-up.k-fx-end .k-fx-current {
    transform: translateY(100%);
}

.k-fx.k-fx-overlay.k-fx-reverse.k-fx-down.k-fx-end .k-fx-current {
    transform: translateY(-100%);
}

.k-current-time {
    position: absolute;
}

.k-current-time.k-current-time-arrow-left, .k-current-time.k-current-time-arrow-right, .k-current-time.k-current-time-arrow-down {
    width: 0;
    height: 0;
    background: transparent;
    border: 4px solid transparent;
}

.k-current-time {
    background: #ff0000;
}

.k-current-time.k-current-time-arrow-left {
    border-right-color: #ff0000;
}

.k-current-time.k-current-time-arrow-right {
    border-left-color: #ff0000;
}

.k-current-time.k-current-time-arrow-down {
    border-top-color: #ff0000;
}

.k-resize-handle,
.k-resize-hint {
    position: absolute;
    border-color: inherit;
    z-index: 200;
}

.k-resize-handle {
    display: flex;
    align-items: center;
    justify-content: center;
}

.k-resize-handle::before {
    content: "";
    border: 0 solid;
    border-color: inherit;
}

.k-resize-n {
    width: 100%;
    height: 6px;
    flex-direction: row;
    left: 0;
    top: -3px;
    cursor: n-resize;
}

.k-resize-s {
    width: 100%;
    height: 6px;
    flex-direction: row;
    left: 0;
    bottom: -3px;
    cursor: s-resize;
}

.k-resize-w {
    width: 6px;
    height: 100%;
    flex-direction: column;
    top: 0;
    left: -3px;
    cursor: w-resize;
}

.k-resize-e {
    width: 6px;
    height: 100%;
    flex-direction: column;
    top: 0;
    right: -3px;
    cursor: e-resize;
}

.k-resize-sw,
.k-resize-se,
.k-resize-nw,
.k-resize-ne {
    width: 5px;
    height: 5px;
}

.k-resize-sw {
    cursor: sw-resize;
    bottom: 0;
    left: 0;
}

.k-resize-se {
    cursor: se-resize;
    bottom: 0;
    right: 0;
}

.k-resize-nw {
    cursor: nw-resize;
    top: 0;
    left: 0;
}

.k-resize-ne {
    cursor: ne-resize;
    top: 0;
    right: 0;
}

.k-vertical-resize {
    cursor: row-resize;
}

.k-horizontal-resize {
    cursor: col-resize;
}

.k-resize-hint {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.k-resize-hint .k-resize-hint-handle {
    width: auto;
    height: 20px;
    align-self: stretch;
}

.k-resize-hint .k-resize-hint-marker {
    width: 2px;
    height: auto;
    flex: 1 1 auto;
}

.k-resize-hint-vertical {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.k-resize-hint-vertical .k-resize-hint-handle {
    width: 20px;
    height: auto;
    align-self: stretch;
}

.k-resize-hint-vertical .k-resize-hint-marker {
    width: auto;
    height: 2px;
    flex: 1 1 auto;
}

.k-scrollbar {
    position: absolute;
    overflow: scroll;
}

.k-scrollbar-vertical {
    top: 0;
    right: 0;
    width: 17px;
    height: 100%;
    overflow-x: hidden;
}

.k-touch-scrollbar {
    display: none;
    position: absolute;
    z-index: 200000;
    height: 8px;
    width: 8px;
    border: 1px solid #8a8a8a;
    background-color: #858585;
}

.k-ratio-auto {
    aspect-ratio: auto;
}

.\\!k-ratio-auto {
    aspect-ratio: auto !important;
}

.k-ratio-1 {
    aspect-ratio: 1;
}

.\\!k-ratio-1 {
    aspect-ratio: 1 !important;
}

.k-ratio-square {
    aspect-ratio: 1 / 1;
}

.\\!k-ratio-square {
    aspect-ratio: 1 / 1 !important;
}

.k-ratio-video {
    aspect-ratio: 16 / 9;
}

.\\!k-ratio-video {
    aspect-ratio: 16 / 9 !important;
}

.k-aspect-ratio-auto {
    aspect-ratio: auto;
}

.\\!k-aspect-ratio-auto {
    aspect-ratio: auto !important;
}

.k-aspect-ratio-1 {
    aspect-ratio: 1;
}

.\\!k-aspect-ratio-1 {
    aspect-ratio: 1 !important;
}

.k-aspect-ratio-square {
    aspect-ratio: 1 / 1;
}

.\\!k-aspect-ratio-square {
    aspect-ratio: 1 / 1 !important;
}

.k-aspect-ratio-video {
    aspect-ratio: 16 / 9;
}

.\\!k-aspect-ratio-video {
    aspect-ratio: 16 / 9 !important;
}

.k-box-sizing-border {
    box-sizing: border-box;
}

.\\!k-box-sizing-border {
    box-sizing: border-box !important;
}

.k-box-sizing-content {
    box-sizing: content-box;
}

.\\!k-box-sizing-content {
    box-sizing: content-box !important;
}

.k-clear-left {
    clear: left;
}

.\\!k-clear-left {
    clear: left !important;
}

.k-clear-right {
    clear: right;
}

.\\!k-clear-right {
    clear: right !important;
}

.k-clear-both {
    clear: both;
}

.\\!k-clear-both {
    clear: both !important;
}

.k-clear-none {
    clear: none;
}

.\\!k-clear-none {
    clear: none !important;
}

.k-columns-1 {
    columns: 1;
}

.\\!k-columns-1 {
    columns: 1 !important;
}

.k-columns-2 {
    columns: 2;
}

.\\!k-columns-2 {
    columns: 2 !important;
}

.k-columns-3 {
    columns: 3;
}

.\\!k-columns-3 {
    columns: 3 !important;
}

.k-columns-4 {
    columns: 4;
}

.\\!k-columns-4 {
    columns: 4 !important;
}

.k-columns-5 {
    columns: 5;
}

.\\!k-columns-5 {
    columns: 5 !important;
}

.k-columns-6 {
    columns: 6;
}

.\\!k-columns-6 {
    columns: 6 !important;
}

.k-columns-7 {
    columns: 7;
}

.\\!k-columns-7 {
    columns: 7 !important;
}

.k-columns-8 {
    columns: 8;
}

.\\!k-columns-8 {
    columns: 8 !important;
}

.k-columns-9 {
    columns: 9;
}

.\\!k-columns-9 {
    columns: 9 !important;
}

.k-columns-10 {
    columns: 10;
}

.\\!k-columns-10 {
    columns: 10 !important;
}

.k-columns-11 {
    columns: 11;
}

.\\!k-columns-11 {
    columns: 11 !important;
}

.k-columns-12 {
    columns: 12;
}

.\\!k-columns-12 {
    columns: 12 !important;
}

.k-columns-auto {
    columns: auto;
}

.\\!k-columns-auto {
    columns: auto !important;
}

.k-d-none {
    display: none;
}

.\\!k-d-none {
    display: none !important;
}

.k-d-contents {
    display: contents;
}

.\\!k-d-contents {
    display: contents !important;
}

.k-d-block {
    display: block;
}

.\\!k-d-block {
    display: block !important;
}

.k-d-inline {
    display: inline;
}

.\\!k-d-inline {
    display: inline !important;
}

.k-d-inline-block {
    display: inline-block;
}

.\\!k-d-inline-block {
    display: inline-block !important;
}

.k-d-flex, .k-d-flex-row, .k-d-flex-col {
    display: flex;
}

.\\!k-d-flex, .\\!k-d-flex-row, .\\!k-d-flex-col {
    display: flex !important;
}

.k-d-inline-flex {
    display: inline-flex;
}

.\\!k-d-inline-flex {
    display: inline-flex !important;
}

.k-d-grid {
    display: grid;
}

.\\!k-d-grid {
    display: grid !important;
}

.k-d-inline-grid {
    display: inline-grid;
}

.\\!k-d-inline-grid {
    display: inline-grid !important;
}

.k-d-table {
    display: table;
}

.\\!k-d-table {
    display: table !important;
}

.k-d-inline-table {
    display: inline-table;
}

.\\!k-d-inline-table {
    display: inline-table !important;
}

.k-d-table-row {
    display: table-row;
}

.\\!k-d-table-row {
    display: table-row !important;
}

.k-d-table-cell {
    display: table-cell;
}

.\\!k-d-table-cell {
    display: table-cell !important;
}

.k-d-list-item {
    display: list-item;
}

.\\!k-d-list-item {
    display: list-item !important;
}

.k-display-none {
    display: none;
}

.\\!k-display-none {
    display: none !important;
}

.k-display-contents {
    display: contents;
}

.\\!k-display-contents {
    display: contents !important;
}

.k-display-block {
    display: block;
}

.\\!k-display-block {
    display: block !important;
}

.k-display-inline {
    display: inline;
}

.\\!k-display-inline {
    display: inline !important;
}

.k-display-inline-block {
    display: inline-block;
}

.\\!k-display-inline-block {
    display: inline-block !important;
}

.k-display-flex {
    display: flex;
}

.\\!k-display-flex {
    display: flex !important;
}

.k-display-inline-flex {
    display: inline-flex;
}

.\\!k-display-inline-flex {
    display: inline-flex !important;
}

.k-display-grid {
    display: grid;
}

.\\!k-display-grid {
    display: grid !important;
}

.k-display-inline-grid {
    display: inline-grid;
}

.\\!k-display-inline-grid {
    display: inline-grid !important;
}

.k-display-table {
    display: table;
}

.\\!k-display-table {
    display: table !important;
}

.k-display-inline-table {
    display: inline-table;
}

.\\!k-display-inline-table {
    display: inline-table !important;
}

.k-display-table-row {
    display: table-row;
}

.\\!k-display-table-row {
    display: table-row !important;
}

.k-display-table-cell {
    display: table-cell;
}

.\\!k-display-table-cell {
    display: table-cell !important;
}

.k-display-list-item {
    display: list-item;
}

.\\!k-display-list-item {
    display: list-item !important;
}

.k-float-left {
    float: left;
}

.\\!k-float-left {
    float: left !important;
}

.k-float-right {
    float: right;
}

.\\!k-float-right {
    float: right !important;
}

.k-float-none {
    float: none;
}

.\\!k-float-none {
    float: none !important;
}

.k-object-fit-contain {
    object-fit: contain;
}

.\\!k-object-fit-contain {
    object-fit: contain !important;
}

.k-object-fit-cover {
    object-fit: cover;
}

.\\!k-object-fit-cover {
    object-fit: cover !important;
}

.k-object-fit-fill {
    object-fit: fill;
}

.\\!k-object-fit-fill {
    object-fit: fill !important;
}

.k-object-fit-scale-down {
    object-fit: scale-down;
}

.\\!k-object-fit-scale-down {
    object-fit: scale-down !important;
}

.k-object-fit-initial {
    object-fit: initial;
}

.\\!k-object-fit-initial {
    object-fit: initial !important;
}

.k-object-fit-none {
    object-fit: none;
}

.\\!k-object-fit-none {
    object-fit: none !important;
}

.k-object-position-center {
    object-position: center;
}

.\\!k-object-position-center {
    object-position: center !important;
}

.k-object-position-top {
    object-position: top;
}

.\\!k-object-position-top {
    object-position: top !important;
}

.k-object-position-right {
    object-position: right;
}

.\\!k-object-position-right {
    object-position: right !important;
}

.k-object-position-bottom {
    object-position: bottom;
}

.\\!k-object-position-bottom {
    object-position: bottom !important;
}

.k-object-position-left {
    object-position: left;
}

.\\!k-object-position-left {
    object-position: left !important;
}

.k-object-position-top-left {
    object-position: top left;
}

.\\!k-object-position-top-left {
    object-position: top left !important;
}

.k-object-position-top-right {
    object-position: top right;
}

.\\!k-object-position-top-right {
    object-position: top right !important;
}

.k-object-position-bottom-left {
    object-position: bottom left;
}

.\\!k-object-position-bottom-left {
    object-position: bottom left !important;
}

.k-object-position-bottom-right {
    object-position: bottom right;
}

.\\!k-object-position-bottom-right {
    object-position: bottom right !important;
}

.k-overflow-auto {
    overflow: auto;
}

.\\!k-overflow-auto {
    overflow: auto !important;
}

.k-overflow-hidden {
    overflow: hidden;
}

.\\!k-overflow-hidden {
    overflow: hidden !important;
}

.k-overflow-visible {
    overflow: visible;
}

.\\!k-overflow-visible {
    overflow: visible !important;
}

.k-overflow-scroll {
    overflow: scroll;
}

.\\!k-overflow-scroll {
    overflow: scroll !important;
}

.k-overflow-clip {
    overflow: clip;
}

.\\!k-overflow-clip {
    overflow: clip !important;
}

.k-overflow-x-auto {
    overflow-x: auto;
}

.\\!k-overflow-x-auto {
    overflow-x: auto !important;
}

.k-overflow-x-hidden {
    overflow-x: hidden;
}

.\\!k-overflow-x-hidden {
    overflow-x: hidden !important;
}

.k-overflow-x-visible {
    overflow-x: visible;
}

.\\!k-overflow-x-visible {
    overflow-x: visible !important;
}

.k-overflow-x-scroll {
    overflow-x: scroll;
}

.\\!k-overflow-x-scroll {
    overflow-x: scroll !important;
}

.k-overflow-x-clip {
    overflow-x: clip;
}

.\\!k-overflow-x-clip {
    overflow-x: clip !important;
}

.k-overflow-y-auto {
    overflow-y: auto;
}

.\\!k-overflow-y-auto {
    overflow-y: auto !important;
}

.k-overflow-y-hidden {
    overflow-y: hidden;
}

.\\!k-overflow-y-hidden {
    overflow-y: hidden !important;
}

.k-overflow-y-visible {
    overflow-y: visible;
}

.\\!k-overflow-y-visible {
    overflow-y: visible !important;
}

.k-overflow-y-scroll {
    overflow-y: scroll;
}

.\\!k-overflow-y-scroll {
    overflow-y: scroll !important;
}

.k-overflow-y-clip {
    overflow-y: clip;
}

.\\!k-overflow-y-clip {
    overflow-y: clip !important;
}

.k-top-0 {
    top: 0;
}

.\\!k-top-0 {
    top: 0 !important;
}

.k-top-1px {
    top: 1px;
}

.\\!k-top-1px {
    top: 1px !important;
}

.k-top-0\\.5 {
    top: 0.125rem;
}

.\\!k-top-0\\.5 {
    top: 0.125rem !important;
}

.k-top-1 {
    top: 0.25rem;
}

.\\!k-top-1 {
    top: 0.25rem !important;
}

.k-top-1\\.5 {
    top: 0.375rem;
}

.\\!k-top-1\\.5 {
    top: 0.375rem !important;
}

.k-top-2 {
    top: 0.5rem;
}

.\\!k-top-2 {
    top: 0.5rem !important;
}

.k-top-2\\.5 {
    top: 0.625rem;
}

.\\!k-top-2\\.5 {
    top: 0.625rem !important;
}

.k-top-3 {
    top: 0.75rem;
}

.\\!k-top-3 {
    top: 0.75rem !important;
}

.k-top-3\\.5 {
    top: 0.875rem;
}

.\\!k-top-3\\.5 {
    top: 0.875rem !important;
}

.k-top-4 {
    top: 1rem;
}

.\\!k-top-4 {
    top: 1rem !important;
}

.k-top-4\\.5 {
    top: 1.125rem;
}

.\\!k-top-4\\.5 {
    top: 1.125rem !important;
}

.k-top-5 {
    top: 1.25rem;
}

.\\!k-top-5 {
    top: 1.25rem !important;
}

.k-top-5\\.5 {
    top: 1.375rem;
}

.\\!k-top-5\\.5 {
    top: 1.375rem !important;
}

.k-top-6 {
    top: 1.5rem;
}

.\\!k-top-6 {
    top: 1.5rem !important;
}

.k-top-6\\.5 {
    top: 1.625rem;
}

.\\!k-top-6\\.5 {
    top: 1.625rem !important;
}

.k-top-7 {
    top: 1.75rem;
}

.\\!k-top-7 {
    top: 1.75rem !important;
}

.k-top-7\\.5 {
    top: 1.875rem;
}

.\\!k-top-7\\.5 {
    top: 1.875rem !important;
}

.k-top-8 {
    top: 2rem;
}

.\\!k-top-8 {
    top: 2rem !important;
}

.k-top-9 {
    top: 2.25rem;
}

.\\!k-top-9 {
    top: 2.25rem !important;
}

.k-top-10 {
    top: 2.5rem;
}

.\\!k-top-10 {
    top: 2.5rem !important;
}

.k-top-11 {
    top: 2.75rem;
}

.\\!k-top-11 {
    top: 2.75rem !important;
}

.k-top-12 {
    top: 3rem;
}

.\\!k-top-12 {
    top: 3rem !important;
}

.k-top-13 {
    top: 3.25rem;
}

.\\!k-top-13 {
    top: 3.25rem !important;
}

.k-top-14 {
    top: 3.5rem;
}

.\\!k-top-14 {
    top: 3.5rem !important;
}

.k-top-15 {
    top: 3.75rem;
}

.\\!k-top-15 {
    top: 3.75rem !important;
}

.k-top-16 {
    top: 4rem;
}

.\\!k-top-16 {
    top: 4rem !important;
}

.k-top-17 {
    top: 4.25rem;
}

.\\!k-top-17 {
    top: 4.25rem !important;
}

.k-top-18 {
    top: 4.5rem;
}

.\\!k-top-18 {
    top: 4.5rem !important;
}

.k-top-19 {
    top: 4.75rem;
}

.\\!k-top-19 {
    top: 4.75rem !important;
}

.k-top-20 {
    top: 5rem;
}

.\\!k-top-20 {
    top: 5rem !important;
}

.k-top-21 {
    top: 5.25rem;
}

.\\!k-top-21 {
    top: 5.25rem !important;
}

.k-top-22 {
    top: 5.5rem;
}

.\\!k-top-22 {
    top: 5.5rem !important;
}

.k-top-23 {
    top: 5.75rem;
}

.\\!k-top-23 {
    top: 5.75rem !important;
}

.k-top-24 {
    top: 6rem;
}

.\\!k-top-24 {
    top: 6rem !important;
}

.k-top--1 {
    top: -1px;
}

.\\!k-top--1 {
    top: -1px !important;
}

.k-right-0 {
    right: 0;
}

.\\!k-right-0 {
    right: 0 !important;
}

.k-right-1px {
    right: 1px;
}

.\\!k-right-1px {
    right: 1px !important;
}

.k-right-0\\.5 {
    right: 0.125rem;
}

.\\!k-right-0\\.5 {
    right: 0.125rem !important;
}

.k-right-1 {
    right: 0.25rem;
}

.\\!k-right-1 {
    right: 0.25rem !important;
}

.k-right-1\\.5 {
    right: 0.375rem;
}

.\\!k-right-1\\.5 {
    right: 0.375rem !important;
}

.k-right-2 {
    right: 0.5rem;
}

.\\!k-right-2 {
    right: 0.5rem !important;
}

.k-right-2\\.5 {
    right: 0.625rem;
}

.\\!k-right-2\\.5 {
    right: 0.625rem !important;
}

.k-right-3 {
    right: 0.75rem;
}

.\\!k-right-3 {
    right: 0.75rem !important;
}

.k-right-3\\.5 {
    right: 0.875rem;
}

.\\!k-right-3\\.5 {
    right: 0.875rem !important;
}

.k-right-4 {
    right: 1rem;
}

.\\!k-right-4 {
    right: 1rem !important;
}

.k-right-4\\.5 {
    right: 1.125rem;
}

.\\!k-right-4\\.5 {
    right: 1.125rem !important;
}

.k-right-5 {
    right: 1.25rem;
}

.\\!k-right-5 {
    right: 1.25rem !important;
}

.k-right-5\\.5 {
    right: 1.375rem;
}

.\\!k-right-5\\.5 {
    right: 1.375rem !important;
}

.k-right-6 {
    right: 1.5rem;
}

.\\!k-right-6 {
    right: 1.5rem !important;
}

.k-right-6\\.5 {
    right: 1.625rem;
}

.\\!k-right-6\\.5 {
    right: 1.625rem !important;
}

.k-right-7 {
    right: 1.75rem;
}

.\\!k-right-7 {
    right: 1.75rem !important;
}

.k-right-7\\.5 {
    right: 1.875rem;
}

.\\!k-right-7\\.5 {
    right: 1.875rem !important;
}

.k-right-8 {
    right: 2rem;
}

.\\!k-right-8 {
    right: 2rem !important;
}

.k-right-9 {
    right: 2.25rem;
}

.\\!k-right-9 {
    right: 2.25rem !important;
}

.k-right-10 {
    right: 2.5rem;
}

.\\!k-right-10 {
    right: 2.5rem !important;
}

.k-right-11 {
    right: 2.75rem;
}

.\\!k-right-11 {
    right: 2.75rem !important;
}

.k-right-12 {
    right: 3rem;
}

.\\!k-right-12 {
    right: 3rem !important;
}

.k-right-13 {
    right: 3.25rem;
}

.\\!k-right-13 {
    right: 3.25rem !important;
}

.k-right-14 {
    right: 3.5rem;
}

.\\!k-right-14 {
    right: 3.5rem !important;
}

.k-right-15 {
    right: 3.75rem;
}

.\\!k-right-15 {
    right: 3.75rem !important;
}

.k-right-16 {
    right: 4rem;
}

.\\!k-right-16 {
    right: 4rem !important;
}

.k-right-17 {
    right: 4.25rem;
}

.\\!k-right-17 {
    right: 4.25rem !important;
}

.k-right-18 {
    right: 4.5rem;
}

.\\!k-right-18 {
    right: 4.5rem !important;
}

.k-right-19 {
    right: 4.75rem;
}

.\\!k-right-19 {
    right: 4.75rem !important;
}

.k-right-20 {
    right: 5rem;
}

.\\!k-right-20 {
    right: 5rem !important;
}

.k-right-21 {
    right: 5.25rem;
}

.\\!k-right-21 {
    right: 5.25rem !important;
}

.k-right-22 {
    right: 5.5rem;
}

.\\!k-right-22 {
    right: 5.5rem !important;
}

.k-right-23 {
    right: 5.75rem;
}

.\\!k-right-23 {
    right: 5.75rem !important;
}

.k-right-24 {
    right: 6rem;
}

.\\!k-right-24 {
    right: 6rem !important;
}

.k-right--1 {
    right: -1px;
}

.\\!k-right--1 {
    right: -1px !important;
}

.k-bottom-0 {
    bottom: 0;
}

.\\!k-bottom-0 {
    bottom: 0 !important;
}

.k-bottom-1px {
    bottom: 1px;
}

.\\!k-bottom-1px {
    bottom: 1px !important;
}

.k-bottom-0\\.5 {
    bottom: 0.125rem;
}

.\\!k-bottom-0\\.5 {
    bottom: 0.125rem !important;
}

.k-bottom-1 {
    bottom: 0.25rem;
}

.\\!k-bottom-1 {
    bottom: 0.25rem !important;
}

.k-bottom-1\\.5 {
    bottom: 0.375rem;
}

.\\!k-bottom-1\\.5 {
    bottom: 0.375rem !important;
}

.k-bottom-2 {
    bottom: 0.5rem;
}

.\\!k-bottom-2 {
    bottom: 0.5rem !important;
}

.k-bottom-2\\.5 {
    bottom: 0.625rem;
}

.\\!k-bottom-2\\.5 {
    bottom: 0.625rem !important;
}

.k-bottom-3 {
    bottom: 0.75rem;
}

.\\!k-bottom-3 {
    bottom: 0.75rem !important;
}

.k-bottom-3\\.5 {
    bottom: 0.875rem;
}

.\\!k-bottom-3\\.5 {
    bottom: 0.875rem !important;
}

.k-bottom-4 {
    bottom: 1rem;
}

.\\!k-bottom-4 {
    bottom: 1rem !important;
}

.k-bottom-4\\.5 {
    bottom: 1.125rem;
}

.\\!k-bottom-4\\.5 {
    bottom: 1.125rem !important;
}

.k-bottom-5 {
    bottom: 1.25rem;
}

.\\!k-bottom-5 {
    bottom: 1.25rem !important;
}

.k-bottom-5\\.5 {
    bottom: 1.375rem;
}

.\\!k-bottom-5\\.5 {
    bottom: 1.375rem !important;
}

.k-bottom-6 {
    bottom: 1.5rem;
}

.\\!k-bottom-6 {
    bottom: 1.5rem !important;
}

.k-bottom-6\\.5 {
    bottom: 1.625rem;
}

.\\!k-bottom-6\\.5 {
    bottom: 1.625rem !important;
}

.k-bottom-7 {
    bottom: 1.75rem;
}

.\\!k-bottom-7 {
    bottom: 1.75rem !important;
}

.k-bottom-7\\.5 {
    bottom: 1.875rem;
}

.\\!k-bottom-7\\.5 {
    bottom: 1.875rem !important;
}

.k-bottom-8 {
    bottom: 2rem;
}

.\\!k-bottom-8 {
    bottom: 2rem !important;
}

.k-bottom-9 {
    bottom: 2.25rem;
}

.\\!k-bottom-9 {
    bottom: 2.25rem !important;
}

.k-bottom-10 {
    bottom: 2.5rem;
}

.\\!k-bottom-10 {
    bottom: 2.5rem !important;
}

.k-bottom-11 {
    bottom: 2.75rem;
}

.\\!k-bottom-11 {
    bottom: 2.75rem !important;
}

.k-bottom-12 {
    bottom: 3rem;
}

.\\!k-bottom-12 {
    bottom: 3rem !important;
}

.k-bottom-13 {
    bottom: 3.25rem;
}

.\\!k-bottom-13 {
    bottom: 3.25rem !important;
}

.k-bottom-14 {
    bottom: 3.5rem;
}

.\\!k-bottom-14 {
    bottom: 3.5rem !important;
}

.k-bottom-15 {
    bottom: 3.75rem;
}

.\\!k-bottom-15 {
    bottom: 3.75rem !important;
}

.k-bottom-16 {
    bottom: 4rem;
}

.\\!k-bottom-16 {
    bottom: 4rem !important;
}

.k-bottom-17 {
    bottom: 4.25rem;
}

.\\!k-bottom-17 {
    bottom: 4.25rem !important;
}

.k-bottom-18 {
    bottom: 4.5rem;
}

.\\!k-bottom-18 {
    bottom: 4.5rem !important;
}

.k-bottom-19 {
    bottom: 4.75rem;
}

.\\!k-bottom-19 {
    bottom: 4.75rem !important;
}

.k-bottom-20 {
    bottom: 5rem;
}

.\\!k-bottom-20 {
    bottom: 5rem !important;
}

.k-bottom-21 {
    bottom: 5.25rem;
}

.\\!k-bottom-21 {
    bottom: 5.25rem !important;
}

.k-bottom-22 {
    bottom: 5.5rem;
}

.\\!k-bottom-22 {
    bottom: 5.5rem !important;
}

.k-bottom-23 {
    bottom: 5.75rem;
}

.\\!k-bottom-23 {
    bottom: 5.75rem !important;
}

.k-bottom-24 {
    bottom: 6rem;
}

.\\!k-bottom-24 {
    bottom: 6rem !important;
}

.k-bottom--1 {
    bottom: -1px;
}

.\\!k-bottom--1 {
    bottom: -1px !important;
}

.k-left-0 {
    left: 0;
}

.\\!k-left-0 {
    left: 0 !important;
}

.k-left-1px {
    left: 1px;
}

.\\!k-left-1px {
    left: 1px !important;
}

.k-left-0\\.5 {
    left: 0.125rem;
}

.\\!k-left-0\\.5 {
    left: 0.125rem !important;
}

.k-left-1 {
    left: 0.25rem;
}

.\\!k-left-1 {
    left: 0.25rem !important;
}

.k-left-1\\.5 {
    left: 0.375rem;
}

.\\!k-left-1\\.5 {
    left: 0.375rem !important;
}

.k-left-2 {
    left: 0.5rem;
}

.\\!k-left-2 {
    left: 0.5rem !important;
}

.k-left-2\\.5 {
    left: 0.625rem;
}

.\\!k-left-2\\.5 {
    left: 0.625rem !important;
}

.k-left-3 {
    left: 0.75rem;
}

.\\!k-left-3 {
    left: 0.75rem !important;
}

.k-left-3\\.5 {
    left: 0.875rem;
}

.\\!k-left-3\\.5 {
    left: 0.875rem !important;
}

.k-left-4 {
    left: 1rem;
}

.\\!k-left-4 {
    left: 1rem !important;
}

.k-left-4\\.5 {
    left: 1.125rem;
}

.\\!k-left-4\\.5 {
    left: 1.125rem !important;
}

.k-left-5 {
    left: 1.25rem;
}

.\\!k-left-5 {
    left: 1.25rem !important;
}

.k-left-5\\.5 {
    left: 1.375rem;
}

.\\!k-left-5\\.5 {
    left: 1.375rem !important;
}

.k-left-6 {
    left: 1.5rem;
}

.\\!k-left-6 {
    left: 1.5rem !important;
}

.k-left-6\\.5 {
    left: 1.625rem;
}

.\\!k-left-6\\.5 {
    left: 1.625rem !important;
}

.k-left-7 {
    left: 1.75rem;
}

.\\!k-left-7 {
    left: 1.75rem !important;
}

.k-left-7\\.5 {
    left: 1.875rem;
}

.\\!k-left-7\\.5 {
    left: 1.875rem !important;
}

.k-left-8 {
    left: 2rem;
}

.\\!k-left-8 {
    left: 2rem !important;
}

.k-left-9 {
    left: 2.25rem;
}

.\\!k-left-9 {
    left: 2.25rem !important;
}

.k-left-10 {
    left: 2.5rem;
}

.\\!k-left-10 {
    left: 2.5rem !important;
}

.k-left-11 {
    left: 2.75rem;
}

.\\!k-left-11 {
    left: 2.75rem !important;
}

.k-left-12 {
    left: 3rem;
}

.\\!k-left-12 {
    left: 3rem !important;
}

.k-left-13 {
    left: 3.25rem;
}

.\\!k-left-13 {
    left: 3.25rem !important;
}

.k-left-14 {
    left: 3.5rem;
}

.\\!k-left-14 {
    left: 3.5rem !important;
}

.k-left-15 {
    left: 3.75rem;
}

.\\!k-left-15 {
    left: 3.75rem !important;
}

.k-left-16 {
    left: 4rem;
}

.\\!k-left-16 {
    left: 4rem !important;
}

.k-left-17 {
    left: 4.25rem;
}

.\\!k-left-17 {
    left: 4.25rem !important;
}

.k-left-18 {
    left: 4.5rem;
}

.\\!k-left-18 {
    left: 4.5rem !important;
}

.k-left-19 {
    left: 4.75rem;
}

.\\!k-left-19 {
    left: 4.75rem !important;
}

.k-left-20 {
    left: 5rem;
}

.\\!k-left-20 {
    left: 5rem !important;
}

.k-left-21 {
    left: 5.25rem;
}

.\\!k-left-21 {
    left: 5.25rem !important;
}

.k-left-22 {
    left: 5.5rem;
}

.\\!k-left-22 {
    left: 5.5rem !important;
}

.k-left-23 {
    left: 5.75rem;
}

.\\!k-left-23 {
    left: 5.75rem !important;
}

.k-left-24 {
    left: 6rem;
}

.\\!k-left-24 {
    left: 6rem !important;
}

.k-left--1 {
    left: -1px;
}

.\\!k-left--1 {
    left: -1px !important;
}

.k-top,
.k-pos-top {
    top: 0;
}

.k-right,
.k-pos-right {
    right: 0;
}

.k-bottom,
.k-pos-bottom {
    bottom: 0;
}

.k-left,
.k-pos-left {
    left: 0;
}

.k-inset-0 {
    inset: 0;
}

.\\!k-inset-0 {
    inset: 0 !important;
}

.k-inset-1 {
    inset: 1px;
}

.\\!k-inset-1 {
    inset: 1px !important;
}

.k-inset--1 {
    inset: -1px;
}

.\\!k-inset--1 {
    inset: -1px !important;
}

.k-inset-x-0 {
    inset-inline: 0;
}

.\\!k-inset-x-0 {
    inset-inline: 0 !important;
}

.k-inset-x-1 {
    inset-inline: 1px;
}

.\\!k-inset-x-1 {
    inset-inline: 1px !important;
}

.k-inset-x--1 {
    inset-inline: -1px;
}

.\\!k-inset-x--1 {
    inset-inline: -1px !important;
}

.k-inset-y-0 {
    inset-block: 0;
}

.\\!k-inset-y-0 {
    inset-block: 0 !important;
}

.k-inset-y-1 {
    inset-block: 1px;
}

.\\!k-inset-y-1 {
    inset-block: 1px !important;
}

.k-inset-y--1 {
    inset-block: -1px;
}

.\\!k-inset-y--1 {
    inset-block: -1px !important;
}

.k-top-left-0 {
    top: 0;
    left: 0;
}

.\\!k-top-left-0 {
    top: 0 !important;
    left: 0 !important;
}

.k-top-left-1 {
    top: 1px;
    left: 1px;
}

.\\!k-top-left-1 {
    top: 1px !important;
    left: 1px !important;
}

.k-top-left--1 {
    top: -1px;
    left: -1px;
}

.\\!k-top-left--1 {
    top: -1px !important;
    left: -1px !important;
}

.k-top-right-0 {
    top: 0;
    right: 0;
}

.\\!k-top-right-0 {
    top: 0 !important;
    right: 0 !important;
}

.k-top-right-1 {
    top: 1px;
    right: 1px;
}

.\\!k-top-right-1 {
    top: 1px !important;
    right: 1px !important;
}

.k-top-right--1 {
    top: -1px;
    right: -1px;
}

.\\!k-top-right--1 {
    top: -1px !important;
    right: -1px !important;
}

.k-bottom-left-0 {
    bottom: 0;
    left: 0;
}

.\\!k-bottom-left-0 {
    bottom: 0 !important;
    left: 0 !important;
}

.k-bottom-left-1 {
    bottom: 1px;
    left: 1px;
}

.\\!k-bottom-left-1 {
    bottom: 1px !important;
    left: 1px !important;
}

.k-bottom-left--1 {
    bottom: -1px;
    left: -1px;
}

.\\!k-bottom-left--1 {
    bottom: -1px !important;
    left: -1px !important;
}

.k-bottom-right-0 {
    bottom: 0;
    right: 0;
}

.\\!k-bottom-right-0 {
    bottom: 0 !important;
    right: 0 !important;
}

.k-bottom-right-1 {
    bottom: 1px;
    right: 1px;
}

.\\!k-bottom-right-1 {
    bottom: 1px !important;
    right: 1px !important;
}

.k-bottom-right--1 {
    bottom: -1px;
    right: -1px;
}

.\\!k-bottom-right--1 {
    bottom: -1px !important;
    right: -1px !important;
}

.k-top-start,
.k-pos-top-start {
    top: 0;
    inset-inline-start: 0;
}

.k-top-end,
.k-pos-top-end {
    top: 0;
    inset-inline-end: 0;
}

.k-bottom-start,
.k-pos-bottom-start {
    bottom: 0;
    inset-inline-start: 0;
}

.k-bottom-end,
.k-pos-bottom-end {
    bottom: 0;
    inset-inline-end: 0;
}

.k-top-center,
.k-pos-top-center {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}

.k-middle-left,
.k-middle-start,
.k-pos-middle-start {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}

.k-middle-center {
    top: 50%;
    left: 50%;
    transform: translateY(-50%);
}

.k-middle-right,
.k-middle-end,
.k-pos-middle-end {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}

.k-bottom-center,
.k-pos-bottom-center {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}

.k-pos-static, .k-static {
    position: static;
}

.\\!k-pos-static, .\\!k-static {
    position: static !important;
}

.k-pos-relative, .k-relative {
    position: relative;
}

.\\!k-pos-relative, .\\!k-relative {
    position: relative !important;
}

.k-pos-absolute, .k-absolute {
    position: absolute;
}

.\\!k-pos-absolute, .\\!k-absolute {
    position: absolute !important;
}

.k-pos-fixed, .k-fixed {
    position: fixed;
}

.\\!k-pos-fixed, .\\!k-fixed {
    position: fixed !important;
}

.k-pos-sticky, .k-sticky {
    position: sticky;
}

.\\!k-pos-sticky, .\\!k-sticky {
    position: sticky !important;
}

.k-visibility-visible, .k-visible {
    visibility: visible;
}

.\\!k-visibility-visible, .\\!k-visible {
    visibility: visible !important;
}

.k-visibility-invisible {
    visibility: hidden;
}

.\\!k-visibility-invisible {
    visibility: hidden !important;
}

.k-visibility-collapse {
    visibility: collapse;
}

.\\!k-visibility-collapse {
    visibility: collapse !important;
}

.k-z-0 {
    z-index: 0;
}

.\\!k-z-0 {
    z-index: 0 !important;
}

.k-z-10 {
    z-index: 10;
}

.\\!k-z-10 {
    z-index: 10 !important;
}

.k-z-20 {
    z-index: 20;
}

.\\!k-z-20 {
    z-index: 20 !important;
}

.k-z-30 {
    z-index: 30;
}

.\\!k-z-30 {
    z-index: 30 !important;
}

.k-z-40 {
    z-index: 40;
}

.\\!k-z-40 {
    z-index: 40 !important;
}

.k-z-50 {
    z-index: 50;
}

.\\!k-z-50 {
    z-index: 50 !important;
}

.k-z-auto {
    z-index: auto;
}

.\\!k-z-auto {
    z-index: auto !important;
}

.k-align-content-normal {
    align-content: normal;
}

.\\!k-align-content-normal {
    align-content: normal !important;
}

.k-align-content-stretch {
    align-content: stretch;
}

.\\!k-align-content-stretch {
    align-content: stretch !important;
}

.k-align-content-center {
    align-content: center;
}

.\\!k-align-content-center {
    align-content: center !important;
}

.k-align-content-start {
    align-content: start;
}

.\\!k-align-content-start {
    align-content: start !important;
}

.k-align-content-end {
    align-content: end;
}

.\\!k-align-content-end {
    align-content: end !important;
}

.k-align-content-flex-start {
    align-content: flex-start;
}

.\\!k-align-content-flex-start {
    align-content: flex-start !important;
}

.k-align-content-flex-end {
    align-content: flex-end;
}

.\\!k-align-content-flex-end {
    align-content: flex-end !important;
}

.k-align-content-baseline {
    align-content: baseline;
}

.\\!k-align-content-baseline {
    align-content: baseline !important;
}

.k-align-content-first-baseline {
    align-content: first baseline;
}

.\\!k-align-content-first-baseline {
    align-content: first baseline !important;
}

.k-align-content-last-baseline {
    align-content: last baseline;
}

.\\!k-align-content-last-baseline {
    align-content: last baseline !important;
}

.k-align-content-between {
    align-content: space-between;
}

.\\!k-align-content-between {
    align-content: space-between !important;
}

.k-align-content-around {
    align-content: space-around;
}

.\\!k-align-content-around {
    align-content: space-around !important;
}

.k-align-content-evenly {
    align-content: space-evenly;
}

.\\!k-align-content-evenly {
    align-content: space-evenly !important;
}

.k-align-items-normal {
    align-items: normal;
}

.\\!k-align-items-normal {
    align-items: normal !important;
}

.k-align-items-stretch {
    align-items: stretch;
}

.\\!k-align-items-stretch {
    align-items: stretch !important;
}

.k-align-items-center {
    align-items: center;
}

.\\!k-align-items-center {
    align-items: center !important;
}

.k-align-items-start {
    align-items: start;
}

.\\!k-align-items-start {
    align-items: start !important;
}

.k-align-items-end {
    align-items: end;
}

.\\!k-align-items-end {
    align-items: end !important;
}

.k-align-items-flex-start {
    align-items: flex-start;
}

.\\!k-align-items-flex-start {
    align-items: flex-start !important;
}

.k-align-items-flex-end {
    align-items: flex-end;
}

.\\!k-align-items-flex-end {
    align-items: flex-end !important;
}

.k-align-items-baseline {
    align-items: baseline;
}

.\\!k-align-items-baseline {
    align-items: baseline !important;
}

.k-align-items-first-baseline {
    align-items: first baseline;
}

.\\!k-align-items-first-baseline {
    align-items: first baseline !important;
}

.k-align-items-last-baseline {
    align-items: last baseline;
}

.\\!k-align-items-last-baseline {
    align-items: last baseline !important;
}

.k-align-items-self-start {
    align-items: self-start;
}

.\\!k-align-items-self-start {
    align-items: self-start !important;
}

.k-align-items-self-end {
    align-items: self-end;
}

.\\!k-align-items-self-end {
    align-items: self-end !important;
}

.k-align-self-auto {
    align-self: auto;
}

.\\!k-align-self-auto {
    align-self: auto !important;
}

.k-align-self-normal {
    align-self: normal;
}

.\\!k-align-self-normal {
    align-self: normal !important;
}

.k-align-self-stretch {
    align-self: stretch;
}

.\\!k-align-self-stretch {
    align-self: stretch !important;
}

.k-align-self-center {
    align-self: center;
}

.\\!k-align-self-center {
    align-self: center !important;
}

.k-align-self-start {
    align-self: start;
}

.\\!k-align-self-start {
    align-self: start !important;
}

.k-align-self-end {
    align-self: end;
}

.\\!k-align-self-end {
    align-self: end !important;
}

.k-align-self-flex-start {
    align-self: flex-start;
}

.\\!k-align-self-flex-start {
    align-self: flex-start !important;
}

.k-align-self-flex-end {
    align-self: flex-end;
}

.\\!k-align-self-flex-end {
    align-self: flex-end !important;
}

.k-align-self-baseline {
    align-self: baseline;
}

.\\!k-align-self-baseline {
    align-self: baseline !important;
}

.k-align-self-first-baseline {
    align-self: first baseline;
}

.\\!k-align-self-first-baseline {
    align-self: first baseline !important;
}

.k-align-self-last-baseline {
    align-self: last baseline;
}

.\\!k-align-self-last-baseline {
    align-self: last baseline !important;
}

.k-align-self-self-start {
    align-self: self-start;
}

.\\!k-align-self-self-start {
    align-self: self-start !important;
}

.k-align-self-self-end {
    align-self: self-end;
}

.\\!k-align-self-self-end {
    align-self: self-end !important;
}

.k-basis-0 {
    flex-basis: 0;
}

.\\!k-basis-0 {
    flex-basis: 0 !important;
}

.k-basis-1px {
    flex-basis: 1px;
}

.\\!k-basis-1px {
    flex-basis: 1px !important;
}

.k-basis-0\\.5 {
    flex-basis: 0.125rem;
}

.\\!k-basis-0\\.5 {
    flex-basis: 0.125rem !important;
}

.k-basis-1 {
    flex-basis: 0.25rem;
}

.\\!k-basis-1 {
    flex-basis: 0.25rem !important;
}

.k-basis-1\\.5 {
    flex-basis: 0.375rem;
}

.\\!k-basis-1\\.5 {
    flex-basis: 0.375rem !important;
}

.k-basis-2 {
    flex-basis: 0.5rem;
}

.\\!k-basis-2 {
    flex-basis: 0.5rem !important;
}

.k-basis-2\\.5 {
    flex-basis: 0.625rem;
}

.\\!k-basis-2\\.5 {
    flex-basis: 0.625rem !important;
}

.k-basis-3 {
    flex-basis: 0.75rem;
}

.\\!k-basis-3 {
    flex-basis: 0.75rem !important;
}

.k-basis-3\\.5 {
    flex-basis: 0.875rem;
}

.\\!k-basis-3\\.5 {
    flex-basis: 0.875rem !important;
}

.k-basis-4 {
    flex-basis: 1rem;
}

.\\!k-basis-4 {
    flex-basis: 1rem !important;
}

.k-basis-4\\.5 {
    flex-basis: 1.125rem;
}

.\\!k-basis-4\\.5 {
    flex-basis: 1.125rem !important;
}

.k-basis-5 {
    flex-basis: 1.25rem;
}

.\\!k-basis-5 {
    flex-basis: 1.25rem !important;
}

.k-basis-5\\.5 {
    flex-basis: 1.375rem;
}

.\\!k-basis-5\\.5 {
    flex-basis: 1.375rem !important;
}

.k-basis-6 {
    flex-basis: 1.5rem;
}

.\\!k-basis-6 {
    flex-basis: 1.5rem !important;
}

.k-basis-6\\.5 {
    flex-basis: 1.625rem;
}

.\\!k-basis-6\\.5 {
    flex-basis: 1.625rem !important;
}

.k-basis-7 {
    flex-basis: 1.75rem;
}

.\\!k-basis-7 {
    flex-basis: 1.75rem !important;
}

.k-basis-7\\.5 {
    flex-basis: 1.875rem;
}

.\\!k-basis-7\\.5 {
    flex-basis: 1.875rem !important;
}

.k-basis-8 {
    flex-basis: 2rem;
}

.\\!k-basis-8 {
    flex-basis: 2rem !important;
}

.k-basis-9 {
    flex-basis: 2.25rem;
}

.\\!k-basis-9 {
    flex-basis: 2.25rem !important;
}

.k-basis-10 {
    flex-basis: 2.5rem;
}

.\\!k-basis-10 {
    flex-basis: 2.5rem !important;
}

.k-basis-11 {
    flex-basis: 2.75rem;
}

.\\!k-basis-11 {
    flex-basis: 2.75rem !important;
}

.k-basis-12 {
    flex-basis: 3rem;
}

.\\!k-basis-12 {
    flex-basis: 3rem !important;
}

.k-basis-13 {
    flex-basis: 3.25rem;
}

.\\!k-basis-13 {
    flex-basis: 3.25rem !important;
}

.k-basis-14 {
    flex-basis: 3.5rem;
}

.\\!k-basis-14 {
    flex-basis: 3.5rem !important;
}

.k-basis-15 {
    flex-basis: 3.75rem;
}

.\\!k-basis-15 {
    flex-basis: 3.75rem !important;
}

.k-basis-16 {
    flex-basis: 4rem;
}

.\\!k-basis-16 {
    flex-basis: 4rem !important;
}

.k-basis-17 {
    flex-basis: 4.25rem;
}

.\\!k-basis-17 {
    flex-basis: 4.25rem !important;
}

.k-basis-18 {
    flex-basis: 4.5rem;
}

.\\!k-basis-18 {
    flex-basis: 4.5rem !important;
}

.k-basis-19 {
    flex-basis: 4.75rem;
}

.\\!k-basis-19 {
    flex-basis: 4.75rem !important;
}

.k-basis-20 {
    flex-basis: 5rem;
}

.\\!k-basis-20 {
    flex-basis: 5rem !important;
}

.k-basis-21 {
    flex-basis: 5.25rem;
}

.\\!k-basis-21 {
    flex-basis: 5.25rem !important;
}

.k-basis-22 {
    flex-basis: 5.5rem;
}

.\\!k-basis-22 {
    flex-basis: 5.5rem !important;
}

.k-basis-23 {
    flex-basis: 5.75rem;
}

.\\!k-basis-23 {
    flex-basis: 5.75rem !important;
}

.k-basis-24 {
    flex-basis: 6rem;
}

.\\!k-basis-24 {
    flex-basis: 6rem !important;
}

.k-basis-auto {
    flex-basis: auto;
}

.\\!k-basis-auto {
    flex-basis: auto !important;
}

.k-basis-1\\/2 {
    flex-basis: 50%;
}

.\\!k-basis-1\\/2 {
    flex-basis: 50% !important;
}

.k-basis-1\\/3 {
    flex-basis: 33.333333%;
}

.\\!k-basis-1\\/3 {
    flex-basis: 33.333333% !important;
}

.k-basis-2\\/3 {
    flex-basis: 66.666667%;
}

.\\!k-basis-2\\/3 {
    flex-basis: 66.666667% !important;
}

.k-basis-1\\/4 {
    flex-basis: 25%;
}

.\\!k-basis-1\\/4 {
    flex-basis: 25% !important;
}

.k-basis-2\\/4 {
    flex-basis: 50%;
}

.\\!k-basis-2\\/4 {
    flex-basis: 50% !important;
}

.k-basis-3\\/4 {
    flex-basis: 75%;
}

.\\!k-basis-3\\/4 {
    flex-basis: 75% !important;
}

.k-basis-1\\/5 {
    flex-basis: 20%;
}

.\\!k-basis-1\\/5 {
    flex-basis: 20% !important;
}

.k-basis-2\\/5 {
    flex-basis: 40%;
}

.\\!k-basis-2\\/5 {
    flex-basis: 40% !important;
}

.k-basis-3\\/5 {
    flex-basis: 60%;
}

.\\!k-basis-3\\/5 {
    flex-basis: 60% !important;
}

.k-basis-4\\/5 {
    flex-basis: 80%;
}

.\\!k-basis-4\\/5 {
    flex-basis: 80% !important;
}

.k-basis-1\\/6 {
    flex-basis: 16.666667%;
}

.\\!k-basis-1\\/6 {
    flex-basis: 16.666667% !important;
}

.k-basis-2\\/6 {
    flex-basis: 33.333333%;
}

.\\!k-basis-2\\/6 {
    flex-basis: 33.333333% !important;
}

.k-basis-3\\/6 {
    flex-basis: 50%;
}

.\\!k-basis-3\\/6 {
    flex-basis: 50% !important;
}

.k-basis-4\\/6 {
    flex-basis: 66.666667%;
}

.\\!k-basis-4\\/6 {
    flex-basis: 66.666667% !important;
}

.k-basis-5\\/6 {
    flex-basis: 83.333333%;
}

.\\!k-basis-5\\/6 {
    flex-basis: 83.333333% !important;
}

.k-basis-1\\/12 {
    flex-basis: 8.333333%;
}

.\\!k-basis-1\\/12 {
    flex-basis: 8.333333% !important;
}

.k-basis-2\\/12 {
    flex-basis: 16.666667%;
}

.\\!k-basis-2\\/12 {
    flex-basis: 16.666667% !important;
}

.k-basis-3\\/12 {
    flex-basis: 25%;
}

.\\!k-basis-3\\/12 {
    flex-basis: 25% !important;
}

.k-basis-4\\/12 {
    flex-basis: 33.333333%;
}

.\\!k-basis-4\\/12 {
    flex-basis: 33.333333% !important;
}

.k-basis-5\\/12 {
    flex-basis: 41.666667%;
}

.\\!k-basis-5\\/12 {
    flex-basis: 41.666667% !important;
}

.k-basis-6\\/12 {
    flex-basis: 50%;
}

.\\!k-basis-6\\/12 {
    flex-basis: 50% !important;
}

.k-basis-7\\/12 {
    flex-basis: 58.333333%;
}

.\\!k-basis-7\\/12 {
    flex-basis: 58.333333% !important;
}

.k-basis-8\\/12 {
    flex-basis: 66.666667%;
}

.\\!k-basis-8\\/12 {
    flex-basis: 66.666667% !important;
}

.k-basis-9\\/12 {
    flex-basis: 75%;
}

.\\!k-basis-9\\/12 {
    flex-basis: 75% !important;
}

.k-basis-10\\/12 {
    flex-basis: 83.333333%;
}

.\\!k-basis-10\\/12 {
    flex-basis: 83.333333% !important;
}

.k-basis-11\\/12 {
    flex-basis: 91.666667%;
}

.\\!k-basis-11\\/12 {
    flex-basis: 91.666667% !important;
}

.k-basis-full {
    flex-basis: 100%;
}

.\\!k-basis-full {
    flex-basis: 100% !important;
}

.k-basis-min {
    flex-basis: min-content;
}

.\\!k-basis-min {
    flex-basis: min-content !important;
}

.k-basis-max {
    flex-basis: max-content;
}

.\\!k-basis-max {
    flex-basis: max-content !important;
}

.k-basis-fit {
    flex-basis: fit-content;
}

.\\!k-basis-fit {
    flex-basis: fit-content !important;
}

.k-flex-basis-0 {
    flex-basis: 0;
}

.\\!k-flex-basis-0 {
    flex-basis: 0 !important;
}

.k-flex-basis-1px {
    flex-basis: 1px;
}

.\\!k-flex-basis-1px {
    flex-basis: 1px !important;
}

.k-flex-basis-0\\.5 {
    flex-basis: 0.125rem;
}

.\\!k-flex-basis-0\\.5 {
    flex-basis: 0.125rem !important;
}

.k-flex-basis-1 {
    flex-basis: 0.25rem;
}

.\\!k-flex-basis-1 {
    flex-basis: 0.25rem !important;
}

.k-flex-basis-1\\.5 {
    flex-basis: 0.375rem;
}

.\\!k-flex-basis-1\\.5 {
    flex-basis: 0.375rem !important;
}

.k-flex-basis-2 {
    flex-basis: 0.5rem;
}

.\\!k-flex-basis-2 {
    flex-basis: 0.5rem !important;
}

.k-flex-basis-2\\.5 {
    flex-basis: 0.625rem;
}

.\\!k-flex-basis-2\\.5 {
    flex-basis: 0.625rem !important;
}

.k-flex-basis-3 {
    flex-basis: 0.75rem;
}

.\\!k-flex-basis-3 {
    flex-basis: 0.75rem !important;
}

.k-flex-basis-3\\.5 {
    flex-basis: 0.875rem;
}

.\\!k-flex-basis-3\\.5 {
    flex-basis: 0.875rem !important;
}

.k-flex-basis-4 {
    flex-basis: 1rem;
}

.\\!k-flex-basis-4 {
    flex-basis: 1rem !important;
}

.k-flex-basis-4\\.5 {
    flex-basis: 1.125rem;
}

.\\!k-flex-basis-4\\.5 {
    flex-basis: 1.125rem !important;
}

.k-flex-basis-5 {
    flex-basis: 1.25rem;
}

.\\!k-flex-basis-5 {
    flex-basis: 1.25rem !important;
}

.k-flex-basis-5\\.5 {
    flex-basis: 1.375rem;
}

.\\!k-flex-basis-5\\.5 {
    flex-basis: 1.375rem !important;
}

.k-flex-basis-6 {
    flex-basis: 1.5rem;
}

.\\!k-flex-basis-6 {
    flex-basis: 1.5rem !important;
}

.k-flex-basis-6\\.5 {
    flex-basis: 1.625rem;
}

.\\!k-flex-basis-6\\.5 {
    flex-basis: 1.625rem !important;
}

.k-flex-basis-7 {
    flex-basis: 1.75rem;
}

.\\!k-flex-basis-7 {
    flex-basis: 1.75rem !important;
}

.k-flex-basis-7\\.5 {
    flex-basis: 1.875rem;
}

.\\!k-flex-basis-7\\.5 {
    flex-basis: 1.875rem !important;
}

.k-flex-basis-8 {
    flex-basis: 2rem;
}

.\\!k-flex-basis-8 {
    flex-basis: 2rem !important;
}

.k-flex-basis-9 {
    flex-basis: 2.25rem;
}

.\\!k-flex-basis-9 {
    flex-basis: 2.25rem !important;
}

.k-flex-basis-10 {
    flex-basis: 2.5rem;
}

.\\!k-flex-basis-10 {
    flex-basis: 2.5rem !important;
}

.k-flex-basis-11 {
    flex-basis: 2.75rem;
}

.\\!k-flex-basis-11 {
    flex-basis: 2.75rem !important;
}

.k-flex-basis-12 {
    flex-basis: 3rem;
}

.\\!k-flex-basis-12 {
    flex-basis: 3rem !important;
}

.k-flex-basis-13 {
    flex-basis: 3.25rem;
}

.\\!k-flex-basis-13 {
    flex-basis: 3.25rem !important;
}

.k-flex-basis-14 {
    flex-basis: 3.5rem;
}

.\\!k-flex-basis-14 {
    flex-basis: 3.5rem !important;
}

.k-flex-basis-15 {
    flex-basis: 3.75rem;
}

.\\!k-flex-basis-15 {
    flex-basis: 3.75rem !important;
}

.k-flex-basis-16 {
    flex-basis: 4rem;
}

.\\!k-flex-basis-16 {
    flex-basis: 4rem !important;
}

.k-flex-basis-17 {
    flex-basis: 4.25rem;
}

.\\!k-flex-basis-17 {
    flex-basis: 4.25rem !important;
}

.k-flex-basis-18 {
    flex-basis: 4.5rem;
}

.\\!k-flex-basis-18 {
    flex-basis: 4.5rem !important;
}

.k-flex-basis-19 {
    flex-basis: 4.75rem;
}

.\\!k-flex-basis-19 {
    flex-basis: 4.75rem !important;
}

.k-flex-basis-20 {
    flex-basis: 5rem;
}

.\\!k-flex-basis-20 {
    flex-basis: 5rem !important;
}

.k-flex-basis-21 {
    flex-basis: 5.25rem;
}

.\\!k-flex-basis-21 {
    flex-basis: 5.25rem !important;
}

.k-flex-basis-22 {
    flex-basis: 5.5rem;
}

.\\!k-flex-basis-22 {
    flex-basis: 5.5rem !important;
}

.k-flex-basis-23 {
    flex-basis: 5.75rem;
}

.\\!k-flex-basis-23 {
    flex-basis: 5.75rem !important;
}

.k-flex-basis-24 {
    flex-basis: 6rem;
}

.\\!k-flex-basis-24 {
    flex-basis: 6rem !important;
}

.k-flex-basis-auto {
    flex-basis: auto;
}

.\\!k-flex-basis-auto {
    flex-basis: auto !important;
}

.k-flex-basis-1\\/2 {
    flex-basis: 50%;
}

.\\!k-flex-basis-1\\/2 {
    flex-basis: 50% !important;
}

.k-flex-basis-1\\/3 {
    flex-basis: 33.333333%;
}

.\\!k-flex-basis-1\\/3 {
    flex-basis: 33.333333% !important;
}

.k-flex-basis-2\\/3 {
    flex-basis: 66.666667%;
}

.\\!k-flex-basis-2\\/3 {
    flex-basis: 66.666667% !important;
}

.k-flex-basis-1\\/4 {
    flex-basis: 25%;
}

.\\!k-flex-basis-1\\/4 {
    flex-basis: 25% !important;
}

.k-flex-basis-2\\/4 {
    flex-basis: 50%;
}

.\\!k-flex-basis-2\\/4 {
    flex-basis: 50% !important;
}

.k-flex-basis-3\\/4 {
    flex-basis: 75%;
}

.\\!k-flex-basis-3\\/4 {
    flex-basis: 75% !important;
}

.k-flex-basis-1\\/5 {
    flex-basis: 20%;
}

.\\!k-flex-basis-1\\/5 {
    flex-basis: 20% !important;
}

.k-flex-basis-2\\/5 {
    flex-basis: 40%;
}

.\\!k-flex-basis-2\\/5 {
    flex-basis: 40% !important;
}

.k-flex-basis-3\\/5 {
    flex-basis: 60%;
}

.\\!k-flex-basis-3\\/5 {
    flex-basis: 60% !important;
}

.k-flex-basis-4\\/5 {
    flex-basis: 80%;
}

.\\!k-flex-basis-4\\/5 {
    flex-basis: 80% !important;
}

.k-flex-basis-1\\/6 {
    flex-basis: 16.666667%;
}

.\\!k-flex-basis-1\\/6 {
    flex-basis: 16.666667% !important;
}

.k-flex-basis-2\\/6 {
    flex-basis: 33.333333%;
}

.\\!k-flex-basis-2\\/6 {
    flex-basis: 33.333333% !important;
}

.k-flex-basis-3\\/6 {
    flex-basis: 50%;
}

.\\!k-flex-basis-3\\/6 {
    flex-basis: 50% !important;
}

.k-flex-basis-4\\/6 {
    flex-basis: 66.666667%;
}

.\\!k-flex-basis-4\\/6 {
    flex-basis: 66.666667% !important;
}

.k-flex-basis-5\\/6 {
    flex-basis: 83.333333%;
}

.\\!k-flex-basis-5\\/6 {
    flex-basis: 83.333333% !important;
}

.k-flex-basis-1\\/12 {
    flex-basis: 8.333333%;
}

.\\!k-flex-basis-1\\/12 {
    flex-basis: 8.333333% !important;
}

.k-flex-basis-2\\/12 {
    flex-basis: 16.666667%;
}

.\\!k-flex-basis-2\\/12 {
    flex-basis: 16.666667% !important;
}

.k-flex-basis-3\\/12 {
    flex-basis: 25%;
}

.\\!k-flex-basis-3\\/12 {
    flex-basis: 25% !important;
}

.k-flex-basis-4\\/12 {
    flex-basis: 33.333333%;
}

.\\!k-flex-basis-4\\/12 {
    flex-basis: 33.333333% !important;
}

.k-flex-basis-5\\/12 {
    flex-basis: 41.666667%;
}

.\\!k-flex-basis-5\\/12 {
    flex-basis: 41.666667% !important;
}

.k-flex-basis-6\\/12 {
    flex-basis: 50%;
}

.\\!k-flex-basis-6\\/12 {
    flex-basis: 50% !important;
}

.k-flex-basis-7\\/12 {
    flex-basis: 58.333333%;
}

.\\!k-flex-basis-7\\/12 {
    flex-basis: 58.333333% !important;
}

.k-flex-basis-8\\/12 {
    flex-basis: 66.666667%;
}

.\\!k-flex-basis-8\\/12 {
    flex-basis: 66.666667% !important;
}

.k-flex-basis-9\\/12 {
    flex-basis: 75%;
}

.\\!k-flex-basis-9\\/12 {
    flex-basis: 75% !important;
}

.k-flex-basis-10\\/12 {
    flex-basis: 83.333333%;
}

.\\!k-flex-basis-10\\/12 {
    flex-basis: 83.333333% !important;
}

.k-flex-basis-11\\/12 {
    flex-basis: 91.666667%;
}

.\\!k-flex-basis-11\\/12 {
    flex-basis: 91.666667% !important;
}

.k-flex-basis-full {
    flex-basis: 100%;
}

.\\!k-flex-basis-full {
    flex-basis: 100% !important;
}

.k-flex-basis-min {
    flex-basis: min-content;
}

.\\!k-flex-basis-min {
    flex-basis: min-content !important;
}

.k-flex-basis-max {
    flex-basis: max-content;
}

.\\!k-flex-basis-max {
    flex-basis: max-content !important;
}

.k-flex-basis-fit {
    flex-basis: fit-content;
}

.\\!k-flex-basis-fit {
    flex-basis: fit-content !important;
}

.k-flex-row, .k-d-flex-row {
    flex-direction: row;
}

.\\!k-flex-row, .\\!k-d-flex-row, .\\!k-d-flex-col {
    flex-direction: row !important;
}

.k-flex-row-reverse {
    flex-direction: row-reverse;
}

.\\!k-flex-row-reverse {
    flex-direction: row-reverse !important;
}

.k-flex-col, .k-d-flex-col, .k-flex-column {
    flex-direction: column;
}

.\\!k-flex-col {
    flex-direction: column !important;
}

.k-flex-col-reverse, .k-flex-column-reverse {
    flex-direction: column-reverse;
}

.\\!k-flex-col-reverse {
    flex-direction: column-reverse !important;
}

.k-grow {
    flex-grow: 1;
}

.\\!k-grow {
    flex-grow: 1 !important;
}

.k-grow-0 {
    flex-grow: 0;
}

.\\!k-grow-0 {
    flex-grow: 0 !important;
}

.k-flex-grow {
    flex-grow: 1;
}

.\\!k-flex-grow {
    flex-grow: 1 !important;
}

.k-flex-grow-0 {
    flex-grow: 0;
}

.\\!k-flex-grow-0 {
    flex-grow: 0 !important;
}

.k-shrink {
    flex-shrink: 1;
}

.\\!k-shrink {
    flex-shrink: 1 !important;
}

.k-shrink-0 {
    flex-shrink: 0;
}

.\\!k-shrink-0 {
    flex-shrink: 0 !important;
}

.k-flex-shrink {
    flex-shrink: 1;
}

.\\!k-flex-shrink {
    flex-shrink: 1 !important;
}

.k-flex-shrink-0 {
    flex-shrink: 0;
}

.\\!k-flex-shrink-0 {
    flex-shrink: 0 !important;
}

.k-flex-wrap {
    flex-wrap: wrap;
}

.\\!k-flex-wrap {
    flex-wrap: wrap !important;
}

.k-flex-wrap-reverse {
    flex-wrap: wrap-reverse;
}

.\\!k-flex-wrap-reverse {
    flex-wrap: wrap-reverse !important;
}

.k-flex-nowrap {
    flex-wrap: nowrap;
}

.\\!k-flex-nowrap {
    flex-wrap: nowrap !important;
}

.k-flex-1 {
    flex: 1 1 0%;
}

.\\!k-flex-1 {
    flex: 1 1 0% !important;
}

.k-flex-auto {
    flex: 1 1 auto;
}

.\\!k-flex-auto {
    flex: 1 1 auto !important;
}

.k-flex-initial {
    flex: 0 1 auto;
}

.\\!k-flex-initial {
    flex: 0 1 auto !important;
}

.k-flex-none {
    flex: none;
}

.\\!k-flex-none {
    flex: none !important;
}

.k-gap-0 {
    gap: 0;
}

.\\!k-gap-0 {
    gap: 0 !important;
}

.k-gap-1px {
    gap: 1px;
}

.\\!k-gap-1px {
    gap: 1px !important;
}

.k-gap-0\\.5 {
    gap: 0.125rem;
}

.\\!k-gap-0\\.5 {
    gap: 0.125rem !important;
}

.k-gap-1 {
    gap: 0.25rem;
}

.\\!k-gap-1 {
    gap: 0.25rem !important;
}

.k-gap-1\\.5 {
    gap: 0.375rem;
}

.\\!k-gap-1\\.5 {
    gap: 0.375rem !important;
}

.k-gap-2 {
    gap: 0.5rem;
}

.\\!k-gap-2 {
    gap: 0.5rem !important;
}

.k-gap-2\\.5 {
    gap: 0.625rem;
}

.\\!k-gap-2\\.5 {
    gap: 0.625rem !important;
}

.k-gap-3 {
    gap: 0.75rem;
}

.\\!k-gap-3 {
    gap: 0.75rem !important;
}

.k-gap-3\\.5 {
    gap: 0.875rem;
}

.\\!k-gap-3\\.5 {
    gap: 0.875rem !important;
}

.k-gap-4 {
    gap: 1rem;
}

.\\!k-gap-4 {
    gap: 1rem !important;
}

.k-gap-4\\.5 {
    gap: 1.125rem;
}

.\\!k-gap-4\\.5 {
    gap: 1.125rem !important;
}

.k-gap-5 {
    gap: 1.25rem;
}

.\\!k-gap-5 {
    gap: 1.25rem !important;
}

.k-gap-5\\.5 {
    gap: 1.375rem;
}

.\\!k-gap-5\\.5 {
    gap: 1.375rem !important;
}

.k-gap-6 {
    gap: 1.5rem;
}

.\\!k-gap-6 {
    gap: 1.5rem !important;
}

.k-gap-6\\.5 {
    gap: 1.625rem;
}

.\\!k-gap-6\\.5 {
    gap: 1.625rem !important;
}

.k-gap-7 {
    gap: 1.75rem;
}

.\\!k-gap-7 {
    gap: 1.75rem !important;
}

.k-gap-7\\.5 {
    gap: 1.875rem;
}

.\\!k-gap-7\\.5 {
    gap: 1.875rem !important;
}

.k-gap-8 {
    gap: 2rem;
}

.\\!k-gap-8 {
    gap: 2rem !important;
}

.k-gap-9 {
    gap: 2.25rem;
}

.\\!k-gap-9 {
    gap: 2.25rem !important;
}

.k-gap-10 {
    gap: 2.5rem;
}

.\\!k-gap-10 {
    gap: 2.5rem !important;
}

.k-gap-11 {
    gap: 2.75rem;
}

.\\!k-gap-11 {
    gap: 2.75rem !important;
}

.k-gap-12 {
    gap: 3rem;
}

.\\!k-gap-12 {
    gap: 3rem !important;
}

.k-gap-13 {
    gap: 3.25rem;
}

.\\!k-gap-13 {
    gap: 3.25rem !important;
}

.k-gap-14 {
    gap: 3.5rem;
}

.\\!k-gap-14 {
    gap: 3.5rem !important;
}

.k-gap-15 {
    gap: 3.75rem;
}

.\\!k-gap-15 {
    gap: 3.75rem !important;
}

.k-gap-16 {
    gap: 4rem;
}

.\\!k-gap-16 {
    gap: 4rem !important;
}

.k-gap-17 {
    gap: 4.25rem;
}

.\\!k-gap-17 {
    gap: 4.25rem !important;
}

.k-gap-18 {
    gap: 4.5rem;
}

.\\!k-gap-18 {
    gap: 4.5rem !important;
}

.k-gap-19 {
    gap: 4.75rem;
}

.\\!k-gap-19 {
    gap: 4.75rem !important;
}

.k-gap-20 {
    gap: 5rem;
}

.\\!k-gap-20 {
    gap: 5rem !important;
}

.k-gap-21 {
    gap: 5.25rem;
}

.\\!k-gap-21 {
    gap: 5.25rem !important;
}

.k-gap-22 {
    gap: 5.5rem;
}

.\\!k-gap-22 {
    gap: 5.5rem !important;
}

.k-gap-23 {
    gap: 5.75rem;
}

.\\!k-gap-23 {
    gap: 5.75rem !important;
}

.k-gap-24 {
    gap: 6rem;
}

.\\!k-gap-24 {
    gap: 6rem !important;
}

.k-gap-xs {
    gap: 0.25rem;
}

.\\!k-gap-xs {
    gap: 0.25rem !important;
}

.k-gap-sm {
    gap: 0.5rem;
}

.\\!k-gap-sm {
    gap: 0.5rem !important;
}

.k-gap-md {
    gap: 0.75rem;
}

.\\!k-gap-md {
    gap: 0.75rem !important;
}

.k-gap-lg {
    gap: 1rem;
}

.\\!k-gap-lg {
    gap: 1rem !important;
}

.k-gap-xl {
    gap: 1.5rem;
}

.\\!k-gap-xl {
    gap: 1.5rem !important;
}

.k-gap-thin {
    gap: 0.125rem;
}

.\\!k-gap-thin {
    gap: 0.125rem !important;
}

.k-gap-hair {
    gap: 1px;
}

.\\!k-gap-hair {
    gap: 1px !important;
}

.k-gap-x-0 {
    column-gap: 0;
}

.\\!k-gap-x-0 {
    column-gap: 0 !important;
}

.k-gap-x-1px {
    column-gap: 1px;
}

.\\!k-gap-x-1px {
    column-gap: 1px !important;
}

.k-gap-x-0\\.5 {
    column-gap: 0.125rem;
}

.\\!k-gap-x-0\\.5 {
    column-gap: 0.125rem !important;
}

.k-gap-x-1 {
    column-gap: 0.25rem;
}

.\\!k-gap-x-1 {
    column-gap: 0.25rem !important;
}

.k-gap-x-1\\.5 {
    column-gap: 0.375rem;
}

.\\!k-gap-x-1\\.5 {
    column-gap: 0.375rem !important;
}

.k-gap-x-2 {
    column-gap: 0.5rem;
}

.\\!k-gap-x-2 {
    column-gap: 0.5rem !important;
}

.k-gap-x-2\\.5 {
    column-gap: 0.625rem;
}

.\\!k-gap-x-2\\.5 {
    column-gap: 0.625rem !important;
}

.k-gap-x-3 {
    column-gap: 0.75rem;
}

.\\!k-gap-x-3 {
    column-gap: 0.75rem !important;
}

.k-gap-x-3\\.5 {
    column-gap: 0.875rem;
}

.\\!k-gap-x-3\\.5 {
    column-gap: 0.875rem !important;
}

.k-gap-x-4 {
    column-gap: 1rem;
}

.\\!k-gap-x-4 {
    column-gap: 1rem !important;
}

.k-gap-x-4\\.5 {
    column-gap: 1.125rem;
}

.\\!k-gap-x-4\\.5 {
    column-gap: 1.125rem !important;
}

.k-gap-x-5 {
    column-gap: 1.25rem;
}

.\\!k-gap-x-5 {
    column-gap: 1.25rem !important;
}

.k-gap-x-5\\.5 {
    column-gap: 1.375rem;
}

.\\!k-gap-x-5\\.5 {
    column-gap: 1.375rem !important;
}

.k-gap-x-6 {
    column-gap: 1.5rem;
}

.\\!k-gap-x-6 {
    column-gap: 1.5rem !important;
}

.k-gap-x-6\\.5 {
    column-gap: 1.625rem;
}

.\\!k-gap-x-6\\.5 {
    column-gap: 1.625rem !important;
}

.k-gap-x-7 {
    column-gap: 1.75rem;
}

.\\!k-gap-x-7 {
    column-gap: 1.75rem !important;
}

.k-gap-x-7\\.5 {
    column-gap: 1.875rem;
}

.\\!k-gap-x-7\\.5 {
    column-gap: 1.875rem !important;
}

.k-gap-x-8 {
    column-gap: 2rem;
}

.\\!k-gap-x-8 {
    column-gap: 2rem !important;
}

.k-gap-x-9 {
    column-gap: 2.25rem;
}

.\\!k-gap-x-9 {
    column-gap: 2.25rem !important;
}

.k-gap-x-10 {
    column-gap: 2.5rem;
}

.\\!k-gap-x-10 {
    column-gap: 2.5rem !important;
}

.k-gap-x-11 {
    column-gap: 2.75rem;
}

.\\!k-gap-x-11 {
    column-gap: 2.75rem !important;
}

.k-gap-x-12 {
    column-gap: 3rem;
}

.\\!k-gap-x-12 {
    column-gap: 3rem !important;
}

.k-gap-x-13 {
    column-gap: 3.25rem;
}

.\\!k-gap-x-13 {
    column-gap: 3.25rem !important;
}

.k-gap-x-14 {
    column-gap: 3.5rem;
}

.\\!k-gap-x-14 {
    column-gap: 3.5rem !important;
}

.k-gap-x-15 {
    column-gap: 3.75rem;
}

.\\!k-gap-x-15 {
    column-gap: 3.75rem !important;
}

.k-gap-x-16 {
    column-gap: 4rem;
}

.\\!k-gap-x-16 {
    column-gap: 4rem !important;
}

.k-gap-x-17 {
    column-gap: 4.25rem;
}

.\\!k-gap-x-17 {
    column-gap: 4.25rem !important;
}

.k-gap-x-18 {
    column-gap: 4.5rem;
}

.\\!k-gap-x-18 {
    column-gap: 4.5rem !important;
}

.k-gap-x-19 {
    column-gap: 4.75rem;
}

.\\!k-gap-x-19 {
    column-gap: 4.75rem !important;
}

.k-gap-x-20 {
    column-gap: 5rem;
}

.\\!k-gap-x-20 {
    column-gap: 5rem !important;
}

.k-gap-x-21 {
    column-gap: 5.25rem;
}

.\\!k-gap-x-21 {
    column-gap: 5.25rem !important;
}

.k-gap-x-22 {
    column-gap: 5.5rem;
}

.\\!k-gap-x-22 {
    column-gap: 5.5rem !important;
}

.k-gap-x-23 {
    column-gap: 5.75rem;
}

.\\!k-gap-x-23 {
    column-gap: 5.75rem !important;
}

.k-gap-x-24 {
    column-gap: 6rem;
}

.\\!k-gap-x-24 {
    column-gap: 6rem !important;
}

.k-gap-x-xs {
    column-gap: 0.25rem;
}

.\\!k-gap-x-xs {
    column-gap: 0.25rem !important;
}

.k-gap-x-sm {
    column-gap: 0.5rem;
}

.\\!k-gap-x-sm {
    column-gap: 0.5rem !important;
}

.k-gap-x-md {
    column-gap: 0.75rem;
}

.\\!k-gap-x-md {
    column-gap: 0.75rem !important;
}

.k-gap-x-lg {
    column-gap: 1rem;
}

.\\!k-gap-x-lg {
    column-gap: 1rem !important;
}

.k-gap-x-xl {
    column-gap: 1.5rem;
}

.\\!k-gap-x-xl {
    column-gap: 1.5rem !important;
}

.k-gap-x-thin {
    column-gap: 0.125rem;
}

.\\!k-gap-x-thin {
    column-gap: 0.125rem !important;
}

.k-gap-x-hair {
    column-gap: 1px;
}

.\\!k-gap-x-hair {
    column-gap: 1px !important;
}

.k-gap-y-0 {
    row-gap: 0;
}

.\\!k-gap-y-0 {
    row-gap: 0 !important;
}

.k-gap-y-1px {
    row-gap: 1px;
}

.\\!k-gap-y-1px {
    row-gap: 1px !important;
}

.k-gap-y-0\\.5 {
    row-gap: 0.125rem;
}

.\\!k-gap-y-0\\.5 {
    row-gap: 0.125rem !important;
}

.k-gap-y-1 {
    row-gap: 0.25rem;
}

.\\!k-gap-y-1 {
    row-gap: 0.25rem !important;
}

.k-gap-y-1\\.5 {
    row-gap: 0.375rem;
}

.\\!k-gap-y-1\\.5 {
    row-gap: 0.375rem !important;
}

.k-gap-y-2 {
    row-gap: 0.5rem;
}

.\\!k-gap-y-2 {
    row-gap: 0.5rem !important;
}

.k-gap-y-2\\.5 {
    row-gap: 0.625rem;
}

.\\!k-gap-y-2\\.5 {
    row-gap: 0.625rem !important;
}

.k-gap-y-3 {
    row-gap: 0.75rem;
}

.\\!k-gap-y-3 {
    row-gap: 0.75rem !important;
}

.k-gap-y-3\\.5 {
    row-gap: 0.875rem;
}

.\\!k-gap-y-3\\.5 {
    row-gap: 0.875rem !important;
}

.k-gap-y-4 {
    row-gap: 1rem;
}

.\\!k-gap-y-4 {
    row-gap: 1rem !important;
}

.k-gap-y-4\\.5 {
    row-gap: 1.125rem;
}

.\\!k-gap-y-4\\.5 {
    row-gap: 1.125rem !important;
}

.k-gap-y-5 {
    row-gap: 1.25rem;
}

.\\!k-gap-y-5 {
    row-gap: 1.25rem !important;
}

.k-gap-y-5\\.5 {
    row-gap: 1.375rem;
}

.\\!k-gap-y-5\\.5 {
    row-gap: 1.375rem !important;
}

.k-gap-y-6 {
    row-gap: 1.5rem;
}

.\\!k-gap-y-6 {
    row-gap: 1.5rem !important;
}

.k-gap-y-6\\.5 {
    row-gap: 1.625rem;
}

.\\!k-gap-y-6\\.5 {
    row-gap: 1.625rem !important;
}

.k-gap-y-7 {
    row-gap: 1.75rem;
}

.\\!k-gap-y-7 {
    row-gap: 1.75rem !important;
}

.k-gap-y-7\\.5 {
    row-gap: 1.875rem;
}

.\\!k-gap-y-7\\.5 {
    row-gap: 1.875rem !important;
}

.k-gap-y-8 {
    row-gap: 2rem;
}

.\\!k-gap-y-8 {
    row-gap: 2rem !important;
}

.k-gap-y-9 {
    row-gap: 2.25rem;
}

.\\!k-gap-y-9 {
    row-gap: 2.25rem !important;
}

.k-gap-y-10 {
    row-gap: 2.5rem;
}

.\\!k-gap-y-10 {
    row-gap: 2.5rem !important;
}

.k-gap-y-11 {
    row-gap: 2.75rem;
}

.\\!k-gap-y-11 {
    row-gap: 2.75rem !important;
}

.k-gap-y-12 {
    row-gap: 3rem;
}

.\\!k-gap-y-12 {
    row-gap: 3rem !important;
}

.k-gap-y-13 {
    row-gap: 3.25rem;
}

.\\!k-gap-y-13 {
    row-gap: 3.25rem !important;
}

.k-gap-y-14 {
    row-gap: 3.5rem;
}

.\\!k-gap-y-14 {
    row-gap: 3.5rem !important;
}

.k-gap-y-15 {
    row-gap: 3.75rem;
}

.\\!k-gap-y-15 {
    row-gap: 3.75rem !important;
}

.k-gap-y-16 {
    row-gap: 4rem;
}

.\\!k-gap-y-16 {
    row-gap: 4rem !important;
}

.k-gap-y-17 {
    row-gap: 4.25rem;
}

.\\!k-gap-y-17 {
    row-gap: 4.25rem !important;
}

.k-gap-y-18 {
    row-gap: 4.5rem;
}

.\\!k-gap-y-18 {
    row-gap: 4.5rem !important;
}

.k-gap-y-19 {
    row-gap: 4.75rem;
}

.\\!k-gap-y-19 {
    row-gap: 4.75rem !important;
}

.k-gap-y-20 {
    row-gap: 5rem;
}

.\\!k-gap-y-20 {
    row-gap: 5rem !important;
}

.k-gap-y-21 {
    row-gap: 5.25rem;
}

.\\!k-gap-y-21 {
    row-gap: 5.25rem !important;
}

.k-gap-y-22 {
    row-gap: 5.5rem;
}

.\\!k-gap-y-22 {
    row-gap: 5.5rem !important;
}

.k-gap-y-23 {
    row-gap: 5.75rem;
}

.\\!k-gap-y-23 {
    row-gap: 5.75rem !important;
}

.k-gap-y-24 {
    row-gap: 6rem;
}

.\\!k-gap-y-24 {
    row-gap: 6rem !important;
}

.k-gap-y-xs {
    row-gap: 0.25rem;
}

.\\!k-gap-y-xs {
    row-gap: 0.25rem !important;
}

.k-gap-y-sm {
    row-gap: 0.5rem;
}

.\\!k-gap-y-sm {
    row-gap: 0.5rem !important;
}

.k-gap-y-md {
    row-gap: 0.75rem;
}

.\\!k-gap-y-md {
    row-gap: 0.75rem !important;
}

.k-gap-y-lg {
    row-gap: 1rem;
}

.\\!k-gap-y-lg {
    row-gap: 1rem !important;
}

.k-gap-y-xl {
    row-gap: 1.5rem;
}

.\\!k-gap-y-xl {
    row-gap: 1.5rem !important;
}

.k-gap-y-thin {
    row-gap: 0.125rem;
}

.\\!k-gap-y-thin {
    row-gap: 0.125rem !important;
}

.k-gap-y-hair {
    row-gap: 1px;
}

.\\!k-gap-y-hair {
    row-gap: 1px !important;
}

.k-grid-auto-cols-auto {
    grid-auto-columns: auto;
}

.\\!k-grid-auto-cols-auto {
    grid-auto-columns: auto !important;
}

.k-grid-auto-cols-min {
    grid-auto-columns: min-content;
}

.\\!k-grid-auto-cols-min {
    grid-auto-columns: min-content !important;
}

.k-grid-auto-cols-max {
    grid-auto-columns: max-content;
}

.\\!k-grid-auto-cols-max {
    grid-auto-columns: max-content !important;
}

.k-grid-auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
}

.\\!k-grid-auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr) !important;
}

.k-grid-flow-row {
    grid-auto-flow: row;
}

.\\!k-grid-flow-row {
    grid-auto-flow: row !important;
}

.k-grid-flow-col {
    grid-auto-flow: column;
}

.\\!k-grid-flow-col {
    grid-auto-flow: column !important;
}

.k-grid-flow-dense {
    grid-auto-flow: dense;
}

.\\!k-grid-flow-dense {
    grid-auto-flow: dense !important;
}

.k-grid-flow-row-dense {
    grid-auto-flow: row dense;
}

.\\!k-grid-flow-row-dense {
    grid-auto-flow: row dense !important;
}

.k-grid-flow-col-dense {
    grid-auto-flow: column dense;
}

.\\!k-grid-flow-col-dense {
    grid-auto-flow: column dense !important;
}

.k-grid-flow-unset {
    grid-auto-flow: unset;
}

.\\!k-grid-flow-unset {
    grid-auto-flow: unset !important;
}

.k-grid-auto-rows-auto {
    grid-auto-rows: auto;
}

.\\!k-grid-auto-rows-auto {
    grid-auto-rows: auto !important;
}

.k-grid-auto-rows-min {
    grid-auto-rows: min-content;
}

.\\!k-grid-auto-rows-min {
    grid-auto-rows: min-content !important;
}

.k-grid-auto-rows-max {
    grid-auto-rows: max-content;
}

.\\!k-grid-auto-rows-max {
    grid-auto-rows: max-content !important;
}

.k-grid-auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
}

.\\!k-grid-auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr) !important;
}

.k-col-start-1 {
    grid-column-start: 1;
}

.\\!k-col-start-1 {
    grid-column-start: 1 !important;
}

.k-col-start-2 {
    grid-column-start: 2;
}

.\\!k-col-start-2 {
    grid-column-start: 2 !important;
}

.k-col-start-3 {
    grid-column-start: 3;
}

.\\!k-col-start-3 {
    grid-column-start: 3 !important;
}

.k-col-start-4 {
    grid-column-start: 4;
}

.\\!k-col-start-4 {
    grid-column-start: 4 !important;
}

.k-col-start-5 {
    grid-column-start: 5;
}

.\\!k-col-start-5 {
    grid-column-start: 5 !important;
}

.k-col-start-6 {
    grid-column-start: 6;
}

.\\!k-col-start-6 {
    grid-column-start: 6 !important;
}

.k-col-start-7 {
    grid-column-start: 7;
}

.\\!k-col-start-7 {
    grid-column-start: 7 !important;
}

.k-col-start-8 {
    grid-column-start: 8;
}

.\\!k-col-start-8 {
    grid-column-start: 8 !important;
}

.k-col-start-9 {
    grid-column-start: 9;
}

.\\!k-col-start-9 {
    grid-column-start: 9 !important;
}

.k-col-start-10 {
    grid-column-start: 10;
}

.\\!k-col-start-10 {
    grid-column-start: 10 !important;
}

.k-col-start-11 {
    grid-column-start: 11;
}

.\\!k-col-start-11 {
    grid-column-start: 11 !important;
}

.k-col-start-12 {
    grid-column-start: 12;
}

.\\!k-col-start-12 {
    grid-column-start: 12 !important;
}

.k-col-start-13 {
    grid-column-start: 13;
}

.\\!k-col-start-13 {
    grid-column-start: 13 !important;
}

.k-col-start--1 {
    grid-column-start: -1;
}

.\\!k-col-start--1 {
    grid-column-start: -1 !important;
}

.k-col-start--2 {
    grid-column-start: -2;
}

.\\!k-col-start--2 {
    grid-column-start: -2 !important;
}

.k-col-start--3 {
    grid-column-start: -3;
}

.\\!k-col-start--3 {
    grid-column-start: -3 !important;
}

.k-col-start--4 {
    grid-column-start: -4;
}

.\\!k-col-start--4 {
    grid-column-start: -4 !important;
}

.k-col-start--5 {
    grid-column-start: -5;
}

.\\!k-col-start--5 {
    grid-column-start: -5 !important;
}

.k-col-start--6 {
    grid-column-start: -6;
}

.\\!k-col-start--6 {
    grid-column-start: -6 !important;
}

.k-col-start--7 {
    grid-column-start: -7;
}

.\\!k-col-start--7 {
    grid-column-start: -7 !important;
}

.k-col-start--8 {
    grid-column-start: -8;
}

.\\!k-col-start--8 {
    grid-column-start: -8 !important;
}

.k-col-start--9 {
    grid-column-start: -9;
}

.\\!k-col-start--9 {
    grid-column-start: -9 !important;
}

.k-col-start--10 {
    grid-column-start: -10;
}

.\\!k-col-start--10 {
    grid-column-start: -10 !important;
}

.k-col-start--11 {
    grid-column-start: -11;
}

.\\!k-col-start--11 {
    grid-column-start: -11 !important;
}

.k-col-start--12 {
    grid-column-start: -12;
}

.\\!k-col-start--12 {
    grid-column-start: -12 !important;
}

.k-col-start--13 {
    grid-column-start: -13;
}

.\\!k-col-start--13 {
    grid-column-start: -13 !important;
}

.k-col-start-auto {
    grid-column-start: auto;
}

.\\!k-col-start-auto {
    grid-column-start: auto !important;
}

.k-col-end-1 {
    grid-column-end: 1;
}

.\\!k-col-end-1 {
    grid-column-end: 1 !important;
}

.k-col-end-2 {
    grid-column-end: 2;
}

.\\!k-col-end-2 {
    grid-column-end: 2 !important;
}

.k-col-end-3 {
    grid-column-end: 3;
}

.\\!k-col-end-3 {
    grid-column-end: 3 !important;
}

.k-col-end-4 {
    grid-column-end: 4;
}

.\\!k-col-end-4 {
    grid-column-end: 4 !important;
}

.k-col-end-5 {
    grid-column-end: 5;
}

.\\!k-col-end-5 {
    grid-column-end: 5 !important;
}

.k-col-end-6 {
    grid-column-end: 6;
}

.\\!k-col-end-6 {
    grid-column-end: 6 !important;
}

.k-col-end-7 {
    grid-column-end: 7;
}

.\\!k-col-end-7 {
    grid-column-end: 7 !important;
}

.k-col-end-8 {
    grid-column-end: 8;
}

.\\!k-col-end-8 {
    grid-column-end: 8 !important;
}

.k-col-end-9 {
    grid-column-end: 9;
}

.\\!k-col-end-9 {
    grid-column-end: 9 !important;
}

.k-col-end-10 {
    grid-column-end: 10;
}

.\\!k-col-end-10 {
    grid-column-end: 10 !important;
}

.k-col-end-11 {
    grid-column-end: 11;
}

.\\!k-col-end-11 {
    grid-column-end: 11 !important;
}

.k-col-end-12 {
    grid-column-end: 12;
}

.\\!k-col-end-12 {
    grid-column-end: 12 !important;
}

.k-col-end-13 {
    grid-column-end: 13;
}

.\\!k-col-end-13 {
    grid-column-end: 13 !important;
}

.k-col-end--1 {
    grid-column-end: -1;
}

.\\!k-col-end--1 {
    grid-column-end: -1 !important;
}

.k-col-end--2 {
    grid-column-end: -2;
}

.\\!k-col-end--2 {
    grid-column-end: -2 !important;
}

.k-col-end--3 {
    grid-column-end: -3;
}

.\\!k-col-end--3 {
    grid-column-end: -3 !important;
}

.k-col-end--4 {
    grid-column-end: -4;
}

.\\!k-col-end--4 {
    grid-column-end: -4 !important;
}

.k-col-end--5 {
    grid-column-end: -5;
}

.\\!k-col-end--5 {
    grid-column-end: -5 !important;
}

.k-col-end--6 {
    grid-column-end: -6;
}

.\\!k-col-end--6 {
    grid-column-end: -6 !important;
}

.k-col-end--7 {
    grid-column-end: -7;
}

.\\!k-col-end--7 {
    grid-column-end: -7 !important;
}

.k-col-end--8 {
    grid-column-end: -8;
}

.\\!k-col-end--8 {
    grid-column-end: -8 !important;
}

.k-col-end--9 {
    grid-column-end: -9;
}

.\\!k-col-end--9 {
    grid-column-end: -9 !important;
}

.k-col-end--10 {
    grid-column-end: -10;
}

.\\!k-col-end--10 {
    grid-column-end: -10 !important;
}

.k-col-end--11 {
    grid-column-end: -11;
}

.\\!k-col-end--11 {
    grid-column-end: -11 !important;
}

.k-col-end--12 {
    grid-column-end: -12;
}

.\\!k-col-end--12 {
    grid-column-end: -12 !important;
}

.k-col-end--13 {
    grid-column-end: -13;
}

.\\!k-col-end--13 {
    grid-column-end: -13 !important;
}

.k-col-end-auto {
    grid-column-end: auto;
}

.\\!k-col-end-auto {
    grid-column-end: auto !important;
}

.k-col-span-1 {
    grid-column: span 1/span 1;
}

.\\!k-col-span-1 {
    grid-column: span 1/span 1 !important;
}

.k-col-span-2 {
    grid-column: span 2/span 2;
}

.\\!k-col-span-2 {
    grid-column: span 2/span 2 !important;
}

.k-col-span-3 {
    grid-column: span 3/span 3;
}

.\\!k-col-span-3 {
    grid-column: span 3/span 3 !important;
}

.k-col-span-4 {
    grid-column: span 4/span 4;
}

.\\!k-col-span-4 {
    grid-column: span 4/span 4 !important;
}

.k-col-span-5 {
    grid-column: span 5/span 5;
}

.\\!k-col-span-5 {
    grid-column: span 5/span 5 !important;
}

.k-col-span-6 {
    grid-column: span 6/span 6;
}

.\\!k-col-span-6 {
    grid-column: span 6/span 6 !important;
}

.k-col-span-7 {
    grid-column: span 7/span 7;
}

.\\!k-col-span-7 {
    grid-column: span 7/span 7 !important;
}

.k-col-span-8 {
    grid-column: span 8/span 8;
}

.\\!k-col-span-8 {
    grid-column: span 8/span 8 !important;
}

.k-col-span-9 {
    grid-column: span 9/span 9;
}

.\\!k-col-span-9 {
    grid-column: span 9/span 9 !important;
}

.k-col-span-10 {
    grid-column: span 10/span 10;
}

.\\!k-col-span-10 {
    grid-column: span 10/span 10 !important;
}

.k-col-span-11 {
    grid-column: span 11/span 11;
}

.\\!k-col-span-11 {
    grid-column: span 11/span 11 !important;
}

.k-col-span-12 {
    grid-column: span 12/span 12;
}

.\\!k-col-span-12 {
    grid-column: span 12/span 12 !important;
}

.k-col-span-full {
    grid-column: 1 / -1;
}

.\\!k-col-span-full {
    grid-column: 1 / -1 !important;
}

.k-col-span-auto {
    grid-column: auto;
}

.\\!k-col-span-auto {
    grid-column: auto !important;
}

.k-colspan-1 {
    grid-column: span 1/span 1;
}

.\\!k-colspan-1 {
    grid-column: span 1/span 1 !important;
}

.k-colspan-2 {
    grid-column: span 2/span 2;
}

.\\!k-colspan-2 {
    grid-column: span 2/span 2 !important;
}

.k-colspan-3 {
    grid-column: span 3/span 3;
}

.\\!k-colspan-3 {
    grid-column: span 3/span 3 !important;
}

.k-colspan-4 {
    grid-column: span 4/span 4;
}

.\\!k-colspan-4 {
    grid-column: span 4/span 4 !important;
}

.k-colspan-5 {
    grid-column: span 5/span 5;
}

.\\!k-colspan-5 {
    grid-column: span 5/span 5 !important;
}

.k-colspan-6 {
    grid-column: span 6/span 6;
}

.\\!k-colspan-6 {
    grid-column: span 6/span 6 !important;
}

.k-colspan-7 {
    grid-column: span 7/span 7;
}

.\\!k-colspan-7 {
    grid-column: span 7/span 7 !important;
}

.k-colspan-8 {
    grid-column: span 8/span 8;
}

.\\!k-colspan-8 {
    grid-column: span 8/span 8 !important;
}

.k-colspan-9 {
    grid-column: span 9/span 9;
}

.\\!k-colspan-9 {
    grid-column: span 9/span 9 !important;
}

.k-colspan-10 {
    grid-column: span 10/span 10;
}

.\\!k-colspan-10 {
    grid-column: span 10/span 10 !important;
}

.k-colspan-11 {
    grid-column: span 11/span 11;
}

.\\!k-colspan-11 {
    grid-column: span 11/span 11 !important;
}

.k-colspan-12 {
    grid-column: span 12/span 12;
}

.\\!k-colspan-12 {
    grid-column: span 12/span 12 !important;
}

.k-colspan-full, .k-colspan-all {
    grid-column: 1 / -1;
}

.\\!k-colspan-full, .\\!k-colspan-all {
    grid-column: 1 / -1 !important;
}

.k-colspan-auto {
    grid-column: auto;
}

.\\!k-colspan-auto {
    grid-column: auto !important;
}

.k-row-start-1 {
    grid-row-start: 1;
}

.\\!k-row-start-1 {
    grid-row-start: 1 !important;
}

.k-row-start-2 {
    grid-row-start: 2;
}

.\\!k-row-start-2 {
    grid-row-start: 2 !important;
}

.k-row-start-3 {
    grid-row-start: 3;
}

.\\!k-row-start-3 {
    grid-row-start: 3 !important;
}

.k-row-start-4 {
    grid-row-start: 4;
}

.\\!k-row-start-4 {
    grid-row-start: 4 !important;
}

.k-row-start-5 {
    grid-row-start: 5;
}

.\\!k-row-start-5 {
    grid-row-start: 5 !important;
}

.k-row-start-6 {
    grid-row-start: 6;
}

.\\!k-row-start-6 {
    grid-row-start: 6 !important;
}

.k-row-start-7 {
    grid-row-start: 7;
}

.\\!k-row-start-7 {
    grid-row-start: 7 !important;
}

.k-row-start-8 {
    grid-row-start: 8;
}

.\\!k-row-start-8 {
    grid-row-start: 8 !important;
}

.k-row-start-9 {
    grid-row-start: 9;
}

.\\!k-row-start-9 {
    grid-row-start: 9 !important;
}

.k-row-start-10 {
    grid-row-start: 10;
}

.\\!k-row-start-10 {
    grid-row-start: 10 !important;
}

.k-row-start-11 {
    grid-row-start: 11;
}

.\\!k-row-start-11 {
    grid-row-start: 11 !important;
}

.k-row-start-12 {
    grid-row-start: 12;
}

.\\!k-row-start-12 {
    grid-row-start: 12 !important;
}

.k-row-start-13 {
    grid-row-start: 13;
}

.\\!k-row-start-13 {
    grid-row-start: 13 !important;
}

.k-row-start--1 {
    grid-row-start: -1;
}

.\\!k-row-start--1 {
    grid-row-start: -1 !important;
}

.k-row-start--2 {
    grid-row-start: -2;
}

.\\!k-row-start--2 {
    grid-row-start: -2 !important;
}

.k-row-start--3 {
    grid-row-start: -3;
}

.\\!k-row-start--3 {
    grid-row-start: -3 !important;
}

.k-row-start--4 {
    grid-row-start: -4;
}

.\\!k-row-start--4 {
    grid-row-start: -4 !important;
}

.k-row-start--5 {
    grid-row-start: -5;
}

.\\!k-row-start--5 {
    grid-row-start: -5 !important;
}

.k-row-start--6 {
    grid-row-start: -6;
}

.\\!k-row-start--6 {
    grid-row-start: -6 !important;
}

.k-row-start--7 {
    grid-row-start: -7;
}

.\\!k-row-start--7 {
    grid-row-start: -7 !important;
}

.k-row-start--8 {
    grid-row-start: -8;
}

.\\!k-row-start--8 {
    grid-row-start: -8 !important;
}

.k-row-start--9 {
    grid-row-start: -9;
}

.\\!k-row-start--9 {
    grid-row-start: -9 !important;
}

.k-row-start--10 {
    grid-row-start: -10;
}

.\\!k-row-start--10 {
    grid-row-start: -10 !important;
}

.k-row-start--11 {
    grid-row-start: -11;
}

.\\!k-row-start--11 {
    grid-row-start: -11 !important;
}

.k-row-start--12 {
    grid-row-start: -12;
}

.\\!k-row-start--12 {
    grid-row-start: -12 !important;
}

.k-row-start--13 {
    grid-row-start: -13;
}

.\\!k-row-start--13 {
    grid-row-start: -13 !important;
}

.k-row-start-auto {
    grid-row-start: auto;
}

.\\!k-row-start-auto {
    grid-row-start: auto !important;
}

.k-row-end-1 {
    grid-row-end: 1;
}

.\\!k-row-end-1 {
    grid-row-end: 1 !important;
}

.k-row-end-2 {
    grid-row-end: 2;
}

.\\!k-row-end-2 {
    grid-row-end: 2 !important;
}

.k-row-end-3 {
    grid-row-end: 3;
}

.\\!k-row-end-3 {
    grid-row-end: 3 !important;
}

.k-row-end-4 {
    grid-row-end: 4;
}

.\\!k-row-end-4 {
    grid-row-end: 4 !important;
}

.k-row-end-5 {
    grid-row-end: 5;
}

.\\!k-row-end-5 {
    grid-row-end: 5 !important;
}

.k-row-end-6 {
    grid-row-end: 6;
}

.\\!k-row-end-6 {
    grid-row-end: 6 !important;
}

.k-row-end-7 {
    grid-row-end: 7;
}

.\\!k-row-end-7 {
    grid-row-end: 7 !important;
}

.k-row-end-8 {
    grid-row-end: 8;
}

.\\!k-row-end-8 {
    grid-row-end: 8 !important;
}

.k-row-end-9 {
    grid-row-end: 9;
}

.\\!k-row-end-9 {
    grid-row-end: 9 !important;
}

.k-row-end-10 {
    grid-row-end: 10;
}

.\\!k-row-end-10 {
    grid-row-end: 10 !important;
}

.k-row-end-11 {
    grid-row-end: 11;
}

.\\!k-row-end-11 {
    grid-row-end: 11 !important;
}

.k-row-end-12 {
    grid-row-end: 12;
}

.\\!k-row-end-12 {
    grid-row-end: 12 !important;
}

.k-row-end-13 {
    grid-row-end: 13;
}

.\\!k-row-end-13 {
    grid-row-end: 13 !important;
}

.k-row-end--1 {
    grid-row-end: -1;
}

.\\!k-row-end--1 {
    grid-row-end: -1 !important;
}

.k-row-end--2 {
    grid-row-end: -2;
}

.\\!k-row-end--2 {
    grid-row-end: -2 !important;
}

.k-row-end--3 {
    grid-row-end: -3;
}

.\\!k-row-end--3 {
    grid-row-end: -3 !important;
}

.k-row-end--4 {
    grid-row-end: -4;
}

.\\!k-row-end--4 {
    grid-row-end: -4 !important;
}

.k-row-end--5 {
    grid-row-end: -5;
}

.\\!k-row-end--5 {
    grid-row-end: -5 !important;
}

.k-row-end--6 {
    grid-row-end: -6;
}

.\\!k-row-end--6 {
    grid-row-end: -6 !important;
}

.k-row-end--7 {
    grid-row-end: -7;
}

.\\!k-row-end--7 {
    grid-row-end: -7 !important;
}

.k-row-end--8 {
    grid-row-end: -8;
}

.\\!k-row-end--8 {
    grid-row-end: -8 !important;
}

.k-row-end--9 {
    grid-row-end: -9;
}

.\\!k-row-end--9 {
    grid-row-end: -9 !important;
}

.k-row-end--10 {
    grid-row-end: -10;
}

.\\!k-row-end--10 {
    grid-row-end: -10 !important;
}

.k-row-end--11 {
    grid-row-end: -11;
}

.\\!k-row-end--11 {
    grid-row-end: -11 !important;
}

.k-row-end--12 {
    grid-row-end: -12;
}

.\\!k-row-end--12 {
    grid-row-end: -12 !important;
}

.k-row-end--13 {
    grid-row-end: -13;
}

.\\!k-row-end--13 {
    grid-row-end: -13 !important;
}

.k-row-end-auto {
    grid-row-end: auto;
}

.\\!k-row-end-auto {
    grid-row-end: auto !important;
}

.k-row-span-1 {
    grid-row: span 1/span 1;
}

.\\!k-row-span-1 {
    grid-row: span 1/span 1 !important;
}

.k-row-span-2 {
    grid-row: span 2/span 2;
}

.\\!k-row-span-2 {
    grid-row: span 2/span 2 !important;
}

.k-row-span-3 {
    grid-row: span 3/span 3;
}

.\\!k-row-span-3 {
    grid-row: span 3/span 3 !important;
}

.k-row-span-4 {
    grid-row: span 4/span 4;
}

.\\!k-row-span-4 {
    grid-row: span 4/span 4 !important;
}

.k-row-span-5 {
    grid-row: span 5/span 5;
}

.\\!k-row-span-5 {
    grid-row: span 5/span 5 !important;
}

.k-row-span-6 {
    grid-row: span 6/span 6;
}

.\\!k-row-span-6 {
    grid-row: span 6/span 6 !important;
}

.k-row-span-7 {
    grid-row: span 7/span 7;
}

.\\!k-row-span-7 {
    grid-row: span 7/span 7 !important;
}

.k-row-span-8 {
    grid-row: span 8/span 8;
}

.\\!k-row-span-8 {
    grid-row: span 8/span 8 !important;
}

.k-row-span-9 {
    grid-row: span 9/span 9;
}

.\\!k-row-span-9 {
    grid-row: span 9/span 9 !important;
}

.k-row-span-10 {
    grid-row: span 10/span 10;
}

.\\!k-row-span-10 {
    grid-row: span 10/span 10 !important;
}

.k-row-span-11 {
    grid-row: span 11/span 11;
}

.\\!k-row-span-11 {
    grid-row: span 11/span 11 !important;
}

.k-row-span-12 {
    grid-row: span 12/span 12;
}

.\\!k-row-span-12 {
    grid-row: span 12/span 12 !important;
}

.k-row-span-full {
    grid-row: span 1/span -1;
}

.\\!k-row-span-full {
    grid-row: span 1/span -1 !important;
}

.k-row-span-auto {
    grid-row: auto;
}

.\\!k-row-span-auto {
    grid-row: auto !important;
}

.k-rowspan-1 {
    grid-row: span 1/span 1;
}

.\\!k-rowspan-1 {
    grid-row: span 1/span 1 !important;
}

.k-rowspan-2 {
    grid-row: span 2/span 2;
}

.\\!k-rowspan-2 {
    grid-row: span 2/span 2 !important;
}

.k-rowspan-3 {
    grid-row: span 3/span 3;
}

.\\!k-rowspan-3 {
    grid-row: span 3/span 3 !important;
}

.k-rowspan-4 {
    grid-row: span 4/span 4;
}

.\\!k-rowspan-4 {
    grid-row: span 4/span 4 !important;
}

.k-rowspan-5 {
    grid-row: span 5/span 5;
}

.\\!k-rowspan-5 {
    grid-row: span 5/span 5 !important;
}

.k-rowspan-6 {
    grid-row: span 6/span 6;
}

.\\!k-rowspan-6 {
    grid-row: span 6/span 6 !important;
}

.k-rowspan-7 {
    grid-row: span 7/span 7;
}

.\\!k-rowspan-7 {
    grid-row: span 7/span 7 !important;
}

.k-rowspan-8 {
    grid-row: span 8/span 8;
}

.\\!k-rowspan-8 {
    grid-row: span 8/span 8 !important;
}

.k-rowspan-9 {
    grid-row: span 9/span 9;
}

.\\!k-rowspan-9 {
    grid-row: span 9/span 9 !important;
}

.k-rowspan-10 {
    grid-row: span 10/span 10;
}

.\\!k-rowspan-10 {
    grid-row: span 10/span 10 !important;
}

.k-rowspan-11 {
    grid-row: span 11/span 11;
}

.\\!k-rowspan-11 {
    grid-row: span 11/span 11 !important;
}

.k-rowspan-12 {
    grid-row: span 12/span 12;
}

.\\!k-rowspan-12 {
    grid-row: span 12/span 12 !important;
}

.k-rowspan-full, .k-rowspan-all {
    grid-row: span 1/span -1;
}

.\\!k-rowspan-full, .\\!k-rowspan-all {
    grid-row: span 1/span -1 !important;
}

.k-rowspan-auto {
    grid-row: auto;
}

.\\!k-rowspan-auto {
    grid-row: auto !important;
}

.k-grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}

.\\!k-grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}

.k-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.\\!k-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}

.k-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.\\!k-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}

.k-grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.\\!k-grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}

.k-grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
}

.\\!k-grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
}

.k-grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
}

.\\!k-grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
}

.k-grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
}

.\\!k-grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
}

.k-grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
}

.\\!k-grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
}

.k-grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
}

.\\!k-grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr)) !important;
}

.k-grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
}

.\\!k-grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
}

.k-grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
}

.\\!k-grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr)) !important;
}

.k-grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
}

.\\!k-grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
}

.k-grid-cols-none {
    grid-template-columns: none;
}

.\\!k-grid-cols-none {
    grid-template-columns: none !important;
}

.k-grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
}

.\\!k-grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr)) !important;
}

.k-grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
}

.\\!k-grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr)) !important;
}

.k-grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
}

.\\!k-grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
}

.k-grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
}

.\\!k-grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr)) !important;
}

.k-grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
}

.\\!k-grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr)) !important;
}

.k-grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
}

.\\!k-grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr)) !important;
}

.k-grid-rows-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
}

.\\!k-grid-rows-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr)) !important;
}

.k-grid-rows-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
}

.\\!k-grid-rows-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr)) !important;
}

.k-grid-rows-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
}

.\\!k-grid-rows-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr)) !important;
}

.k-grid-rows-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
}

.\\!k-grid-rows-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr)) !important;
}

.k-grid-rows-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
}

.\\!k-grid-rows-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr)) !important;
}

.k-grid-rows-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
}

.\\!k-grid-rows-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr)) !important;
}

.k-grid-rows-none {
    grid-template-rows: none;
}

.\\!k-grid-rows-none {
    grid-template-rows: none !important;
}

.k-justify-content-normal {
    justify-content: normal;
}

.\\!k-justify-content-normal {
    justify-content: normal !important;
}

.k-justify-content-stretch {
    justify-content: stretch;
}

.\\!k-justify-content-stretch {
    justify-content: stretch !important;
}

.k-justify-content-center {
    justify-content: center;
}

.\\!k-justify-content-center {
    justify-content: center !important;
}

.k-justify-content-start {
    justify-content: start;
}

.\\!k-justify-content-start {
    justify-content: start !important;
}

.k-justify-content-end {
    justify-content: end;
}

.\\!k-justify-content-end {
    justify-content: end !important;
}

.k-justify-content-flex-start {
    justify-content: flex-start;
}

.\\!k-justify-content-flex-start {
    justify-content: flex-start !important;
}

.k-justify-content-flex-end {
    justify-content: flex-end;
}

.\\!k-justify-content-flex-end {
    justify-content: flex-end !important;
}

.k-justify-content-left {
    justify-content: left;
}

.\\!k-justify-content-left {
    justify-content: left !important;
}

.k-justify-content-right {
    justify-content: right;
}

.\\!k-justify-content-right {
    justify-content: right !important;
}

.k-justify-content-baseline {
    justify-content: baseline;
}

.\\!k-justify-content-baseline {
    justify-content: baseline !important;
}

.k-justify-content-first-baseline {
    justify-content: first baseline;
}

.\\!k-justify-content-first-baseline {
    justify-content: first baseline !important;
}

.k-justify-content-last-baseline {
    justify-content: last baseline;
}

.\\!k-justify-content-last-baseline {
    justify-content: last baseline !important;
}

.k-justify-content-between {
    justify-content: space-between;
}

.\\!k-justify-content-between {
    justify-content: space-between !important;
}

.k-justify-content-around {
    justify-content: space-around;
}

.\\!k-justify-content-around {
    justify-content: space-around !important;
}

.k-justify-content-evenly {
    justify-content: space-evenly;
}

.\\!k-justify-content-evenly {
    justify-content: space-evenly !important;
}

.k-justify-content-stretch > * {
    flex: 1 0 0%;
}

.\\!.k-justify-content-stretch > * {
    flex: 1 0 0% !important;
}

.k-justify-items-normal {
    justify-items: normal;
}

.\\!k-justify-items-normal {
    justify-items: normal !important;
}

.k-justify-items-stretch {
    justify-items: stretch;
}

.\\!k-justify-items-stretch {
    justify-items: stretch !important;
}

.k-justify-items-center {
    justify-items: center;
}

.\\!k-justify-items-center {
    justify-items: center !important;
}

.k-justify-items-start {
    justify-items: start;
}

.\\!k-justify-items-start {
    justify-items: start !important;
}

.k-justify-items-end {
    justify-items: end;
}

.\\!k-justify-items-end {
    justify-items: end !important;
}

.k-justify-items-flex-start {
    justify-items: flex-start;
}

.\\!k-justify-items-flex-start {
    justify-items: flex-start !important;
}

.k-justify-items-flex-end {
    justify-items: flex-end;
}

.\\!k-justify-items-flex-end {
    justify-items: flex-end !important;
}

.k-justify-items-self-start {
    justify-items: self-start;
}

.\\!k-justify-items-self-start {
    justify-items: self-start !important;
}

.k-justify-items-self-end {
    justify-items: self-end;
}

.\\!k-justify-items-self-end {
    justify-items: self-end !important;
}

.k-justify-items-left {
    justify-items: left;
}

.\\!k-justify-items-left {
    justify-items: left !important;
}

.k-justify-items-right {
    justify-items: right;
}

.\\!k-justify-items-right {
    justify-items: right !important;
}

.k-justify-items-baseline {
    justify-items: baseline;
}

.\\!k-justify-items-baseline {
    justify-items: baseline !important;
}

.k-justify-items-first-baseline {
    justify-items: first baseline;
}

.\\!k-justify-items-first-baseline {
    justify-items: first baseline !important;
}

.k-justify-items-last-baseline {
    justify-items: last baseline;
}

.\\!k-justify-items-last-baseline {
    justify-items: last baseline !important;
}

.k-justify-self-auto {
    justify-self: auto;
}

.\\!k-justify-self-auto {
    justify-self: auto !important;
}

.k-justify-self-normal {
    justify-self: normal;
}

.\\!k-justify-self-normal {
    justify-self: normal !important;
}

.k-justify-self-stretch {
    justify-self: stretch;
}

.\\!k-justify-self-stretch {
    justify-self: stretch !important;
}

.k-justify-self-center {
    justify-self: center;
}

.\\!k-justify-self-center {
    justify-self: center !important;
}

.k-justify-self-start {
    justify-self: start;
}

.\\!k-justify-self-start {
    justify-self: start !important;
}

.k-justify-self-end {
    justify-self: end;
}

.\\!k-justify-self-end {
    justify-self: end !important;
}

.k-justify-self-flex-start {
    justify-self: flex-start;
}

.\\!k-justify-self-flex-start {
    justify-self: flex-start !important;
}

.k-justify-self-flex-end {
    justify-self: flex-end;
}

.\\!k-justify-self-flex-end {
    justify-self: flex-end !important;
}

.k-justify-self-self-start {
    justify-self: self-start;
}

.\\!k-justify-self-self-start {
    justify-self: self-start !important;
}

.k-justify-self-self-end {
    justify-self: self-end;
}

.\\!k-justify-self-self-end {
    justify-self: self-end !important;
}

.k-justify-self-baseline {
    justify-self: baseline;
}

.\\!k-justify-self-baseline {
    justify-self: baseline !important;
}

.k-justify-self-first-baseline {
    justify-self: first baseline;
}

.\\!k-justify-self-first-baseline {
    justify-self: first baseline !important;
}

.k-justify-self-last-baseline {
    justify-self: last baseline;
}

.\\!k-justify-self-last-baseline {
    justify-self: last baseline !important;
}

.k-order-1 {
    order: 1;
}

.\\!k-order-1 {
    order: 1 !important;
}

.k-order-2 {
    order: 2;
}

.\\!k-order-2 {
    order: 2 !important;
}

.k-order-3 {
    order: 3;
}

.\\!k-order-3 {
    order: 3 !important;
}

.k-order-4 {
    order: 4;
}

.\\!k-order-4 {
    order: 4 !important;
}

.k-order-5 {
    order: 5;
}

.\\!k-order-5 {
    order: 5 !important;
}

.k-order-6 {
    order: 6;
}

.\\!k-order-6 {
    order: 6 !important;
}

.k-order-7 {
    order: 7;
}

.\\!k-order-7 {
    order: 7 !important;
}

.k-order-8 {
    order: 8;
}

.\\!k-order-8 {
    order: 8 !important;
}

.k-order-9 {
    order: 9;
}

.\\!k-order-9 {
    order: 9 !important;
}

.k-order-10 {
    order: 10;
}

.\\!k-order-10 {
    order: 10 !important;
}

.k-order-11 {
    order: 11;
}

.\\!k-order-11 {
    order: 11 !important;
}

.k-order-12 {
    order: 12;
}

.\\!k-order-12 {
    order: 12 !important;
}

.k-order-first {
    order: -9999;
}

.\\!k-order-first {
    order: -9999 !important;
}

.k-order-last {
    order: 9999;
}

.\\!k-order-last {
    order: 9999 !important;
}

.k-order-none {
    order: 0;
}

.\\!k-order-none {
    order: 0 !important;
}

.k-place-content-normal {
    place-content: normal;
}

.\\!k-place-content-normal {
    place-content: normal !important;
}

.k-place-content-stretch {
    place-content: stretch;
}

.\\!k-place-content-stretch {
    place-content: stretch !important;
}

.k-place-content-center {
    place-content: center;
}

.\\!k-place-content-center {
    place-content: center !important;
}

.k-place-content-start {
    place-content: start;
}

.\\!k-place-content-start {
    place-content: start !important;
}

.k-place-content-end {
    place-content: end;
}

.\\!k-place-content-end {
    place-content: end !important;
}

.k-place-content-flex-start {
    place-content: flex-start;
}

.\\!k-place-content-flex-start {
    place-content: flex-start !important;
}

.k-place-content-flex-end {
    place-content: flex-end;
}

.\\!k-place-content-flex-end {
    place-content: flex-end !important;
}

.k-place-content-baseline {
    place-content: baseline;
}

.\\!k-place-content-baseline {
    place-content: baseline !important;
}

.k-place-content-between {
    place-content: space-between;
}

.\\!k-place-content-between {
    place-content: space-between !important;
}

.k-place-content-around {
    place-content: space-around;
}

.\\!k-place-content-around {
    place-content: space-around !important;
}

.k-place-content-evenly {
    place-content: space-evenly;
}

.\\!k-place-content-evenly {
    place-content: space-evenly !important;
}

.k-place-items-normal {
    place-items: normal;
}

.\\!k-place-items-normal {
    place-items: normal !important;
}

.k-place-items-stretch {
    place-items: stretch;
}

.\\!k-place-items-stretch {
    place-items: stretch !important;
}

.k-place-items-center {
    place-items: center;
}

.\\!k-place-items-center {
    place-items: center !important;
}

.k-place-items-start {
    place-items: start;
}

.\\!k-place-items-start {
    place-items: start !important;
}

.k-place-items-end {
    place-items: end;
}

.\\!k-place-items-end {
    place-items: end !important;
}

.k-place-items-flex-start {
    place-items: flex-start;
}

.\\!k-place-items-flex-start {
    place-items: flex-start !important;
}

.k-place-items-flex-end {
    place-items: flex-end;
}

.\\!k-place-items-flex-end {
    place-items: flex-end !important;
}

.k-place-items-self-start {
    place-items: self-start;
}

.\\!k-place-items-self-start {
    place-items: self-start !important;
}

.k-place-items-self-end {
    place-items: self-end;
}

.\\!k-place-items-self-end {
    place-items: self-end !important;
}

.k-place-items-baseline {
    place-items: baseline;
}

.\\!k-place-items-baseline {
    place-items: baseline !important;
}

.k-place-self-auto {
    place-self: auto;
}

.\\!k-place-self-auto {
    place-self: auto !important;
}

.k-place-self-normal {
    place-self: normal;
}

.\\!k-place-self-normal {
    place-self: normal !important;
}

.k-place-self-stretch {
    place-self: stretch;
}

.\\!k-place-self-stretch {
    place-self: stretch !important;
}

.k-place-self-center {
    place-self: center;
}

.\\!k-place-self-center {
    place-self: center !important;
}

.k-place-self-start {
    place-self: start;
}

.\\!k-place-self-start {
    place-self: start !important;
}

.k-place-self-end {
    place-self: end;
}

.\\!k-place-self-end {
    place-self: end !important;
}

.k-place-self-flex-start {
    place-self: flex-start;
}

.\\!k-place-self-flex-start {
    place-self: flex-start !important;
}

.k-place-self-flex-end {
    place-self: flex-end;
}

.\\!k-place-self-flex-end {
    place-self: flex-end !important;
}

.k-place-self-self-start {
    place-self: self-start;
}

.\\!k-place-self-self-start {
    place-self: self-start !important;
}

.k-place-self-self-end {
    place-self: self-end;
}

.\\!k-place-self-self-end {
    place-self: self-end !important;
}

.k-place-self-baseline {
    place-self: baseline;
}

.\\!k-place-self-baseline {
    place-self: baseline !important;
}

.k-m-0 {
    margin: 0;
}

.\\!k-m-0 {
    margin: 0 !important;
}

.k-m-1px {
    margin: 1px;
}

.\\!k-m-1px {
    margin: 1px !important;
}

.k-m-0\\.5 {
    margin: 0.125rem;
}

.\\!k-m-0\\.5 {
    margin: 0.125rem !important;
}

.k-m-1 {
    margin: 0.25rem;
}

.\\!k-m-1 {
    margin: 0.25rem !important;
}

.k-m-1\\.5 {
    margin: 0.375rem;
}

.\\!k-m-1\\.5 {
    margin: 0.375rem !important;
}

.k-m-2 {
    margin: 0.5rem;
}

.\\!k-m-2 {
    margin: 0.5rem !important;
}

.k-m-2\\.5 {
    margin: 0.625rem;
}

.\\!k-m-2\\.5 {
    margin: 0.625rem !important;
}

.k-m-3 {
    margin: 0.75rem;
}

.\\!k-m-3 {
    margin: 0.75rem !important;
}

.k-m-3\\.5 {
    margin: 0.875rem;
}

.\\!k-m-3\\.5 {
    margin: 0.875rem !important;
}

.k-m-4 {
    margin: 1rem;
}

.\\!k-m-4 {
    margin: 1rem !important;
}

.k-m-4\\.5 {
    margin: 1.125rem;
}

.\\!k-m-4\\.5 {
    margin: 1.125rem !important;
}

.k-m-5 {
    margin: 1.25rem;
}

.\\!k-m-5 {
    margin: 1.25rem !important;
}

.k-m-5\\.5 {
    margin: 1.375rem;
}

.\\!k-m-5\\.5 {
    margin: 1.375rem !important;
}

.k-m-6 {
    margin: 1.5rem;
}

.\\!k-m-6 {
    margin: 1.5rem !important;
}

.k-m-6\\.5 {
    margin: 1.625rem;
}

.\\!k-m-6\\.5 {
    margin: 1.625rem !important;
}

.k-m-7 {
    margin: 1.75rem;
}

.\\!k-m-7 {
    margin: 1.75rem !important;
}

.k-m-7\\.5 {
    margin: 1.875rem;
}

.\\!k-m-7\\.5 {
    margin: 1.875rem !important;
}

.k-m-8 {
    margin: 2rem;
}

.\\!k-m-8 {
    margin: 2rem !important;
}

.k-m-9 {
    margin: 2.25rem;
}

.\\!k-m-9 {
    margin: 2.25rem !important;
}

.k-m-10 {
    margin: 2.5rem;
}

.\\!k-m-10 {
    margin: 2.5rem !important;
}

.k-m-11 {
    margin: 2.75rem;
}

.\\!k-m-11 {
    margin: 2.75rem !important;
}

.k-m-12 {
    margin: 3rem;
}

.\\!k-m-12 {
    margin: 3rem !important;
}

.k-m-13 {
    margin: 3.25rem;
}

.\\!k-m-13 {
    margin: 3.25rem !important;
}

.k-m-14 {
    margin: 3.5rem;
}

.\\!k-m-14 {
    margin: 3.5rem !important;
}

.k-m-15 {
    margin: 3.75rem;
}

.\\!k-m-15 {
    margin: 3.75rem !important;
}

.k-m-16 {
    margin: 4rem;
}

.\\!k-m-16 {
    margin: 4rem !important;
}

.k-m-17 {
    margin: 4.25rem;
}

.\\!k-m-17 {
    margin: 4.25rem !important;
}

.k-m-18 {
    margin: 4.5rem;
}

.\\!k-m-18 {
    margin: 4.5rem !important;
}

.k-m-19 {
    margin: 4.75rem;
}

.\\!k-m-19 {
    margin: 4.75rem !important;
}

.k-m-20 {
    margin: 5rem;
}

.\\!k-m-20 {
    margin: 5rem !important;
}

.k-m-21 {
    margin: 5.25rem;
}

.\\!k-m-21 {
    margin: 5.25rem !important;
}

.k-m-22 {
    margin: 5.5rem;
}

.\\!k-m-22 {
    margin: 5.5rem !important;
}

.k-m-23 {
    margin: 5.75rem;
}

.\\!k-m-23 {
    margin: 5.75rem !important;
}

.k-m-24 {
    margin: 6rem;
}

.\\!k-m-24 {
    margin: 6rem !important;
}

.k-m--1px {
    margin: -1px;
}

.\\!k-m--1px {
    margin: -1px !important;
}

.k-m--0\\.5 {
    margin: -0.125rem;
}

.\\!k-m--0\\.5 {
    margin: -0.125rem !important;
}

.k-m--1 {
    margin: -0.25rem;
}

.\\!k-m--1 {
    margin: -0.25rem !important;
}

.k-m--1\\.5 {
    margin: -0.375rem;
}

.\\!k-m--1\\.5 {
    margin: -0.375rem !important;
}

.k-m--2 {
    margin: -0.5rem;
}

.\\!k-m--2 {
    margin: -0.5rem !important;
}

.k-m--2\\.5 {
    margin: -0.625rem;
}

.\\!k-m--2\\.5 {
    margin: -0.625rem !important;
}

.k-m--3 {
    margin: -0.75rem;
}

.\\!k-m--3 {
    margin: -0.75rem !important;
}

.k-m--3\\.5 {
    margin: -0.875rem;
}

.\\!k-m--3\\.5 {
    margin: -0.875rem !important;
}

.k-m--4 {
    margin: -1rem;
}

.\\!k-m--4 {
    margin: -1rem !important;
}

.k-m--4\\.5 {
    margin: -1.125rem;
}

.\\!k-m--4\\.5 {
    margin: -1.125rem !important;
}

.k-m--5 {
    margin: -1.25rem;
}

.\\!k-m--5 {
    margin: -1.25rem !important;
}

.k-m--5\\.5 {
    margin: -1.375rem;
}

.\\!k-m--5\\.5 {
    margin: -1.375rem !important;
}

.k-m--6 {
    margin: -1.5rem;
}

.\\!k-m--6 {
    margin: -1.5rem !important;
}

.k-m--6\\.5 {
    margin: -1.625rem;
}

.\\!k-m--6\\.5 {
    margin: -1.625rem !important;
}

.k-m--7 {
    margin: -1.75rem;
}

.\\!k-m--7 {
    margin: -1.75rem !important;
}

.k-m--7\\.5 {
    margin: -1.875rem;
}

.\\!k-m--7\\.5 {
    margin: -1.875rem !important;
}

.k-m--8 {
    margin: -2rem;
}

.\\!k-m--8 {
    margin: -2rem !important;
}

.k-m--9 {
    margin: -2.25rem;
}

.\\!k-m--9 {
    margin: -2.25rem !important;
}

.k-m--10 {
    margin: -2.5rem;
}

.\\!k-m--10 {
    margin: -2.5rem !important;
}

.k-m--11 {
    margin: -2.75rem;
}

.\\!k-m--11 {
    margin: -2.75rem !important;
}

.k-m--12 {
    margin: -3rem;
}

.\\!k-m--12 {
    margin: -3rem !important;
}

.k-m--13 {
    margin: -3.25rem;
}

.\\!k-m--13 {
    margin: -3.25rem !important;
}

.k-m--14 {
    margin: -3.5rem;
}

.\\!k-m--14 {
    margin: -3.5rem !important;
}

.k-m--15 {
    margin: -3.75rem;
}

.\\!k-m--15 {
    margin: -3.75rem !important;
}

.k-m--16 {
    margin: -4rem;
}

.\\!k-m--16 {
    margin: -4rem !important;
}

.k-m--17 {
    margin: -4.25rem;
}

.\\!k-m--17 {
    margin: -4.25rem !important;
}

.k-m--18 {
    margin: -4.5rem;
}

.\\!k-m--18 {
    margin: -4.5rem !important;
}

.k-m--19 {
    margin: -4.75rem;
}

.\\!k-m--19 {
    margin: -4.75rem !important;
}

.k-m--20 {
    margin: -5rem;
}

.\\!k-m--20 {
    margin: -5rem !important;
}

.k-m--21 {
    margin: -5.25rem;
}

.\\!k-m--21 {
    margin: -5.25rem !important;
}

.k-m--22 {
    margin: -5.5rem;
}

.\\!k-m--22 {
    margin: -5.5rem !important;
}

.k-m--23 {
    margin: -5.75rem;
}

.\\!k-m--23 {
    margin: -5.75rem !important;
}

.k-m--24 {
    margin: -6rem;
}

.\\!k-m--24 {
    margin: -6rem !important;
}

.k-m-xs {
    margin: 0.25rem;
}

.\\!k-m-xs {
    margin: 0.25rem !important;
}

.k-m-sm {
    margin: 0.5rem;
}

.\\!k-m-sm {
    margin: 0.5rem !important;
}

.k-m-md {
    margin: 0.75rem;
}

.\\!k-m-md {
    margin: 0.75rem !important;
}

.k-m-lg {
    margin: 1rem;
}

.\\!k-m-lg {
    margin: 1rem !important;
}

.k-m-xl {
    margin: 1.5rem;
}

.\\!k-m-xl {
    margin: 1.5rem !important;
}

.k-m-thin {
    margin: 0.125rem;
}

.\\!k-m-thin {
    margin: 0.125rem !important;
}

.k-m-hair {
    margin: 1px;
}

.\\!k-m-hair {
    margin: 1px !important;
}

.k-m-auto {
    margin: auto;
}

.\\!k-m-auto {
    margin: auto !important;
}

.k-mt-0 {
    margin-top: 0;
}

.\\!k-mt-0 {
    margin-top: 0 !important;
}

.k-mt-1px {
    margin-top: 1px;
}

.\\!k-mt-1px {
    margin-top: 1px !important;
}

.k-mt-0\\.5 {
    margin-top: 0.125rem;
}

.\\!k-mt-0\\.5 {
    margin-top: 0.125rem !important;
}

.k-mt-1 {
    margin-top: 0.25rem;
}

.\\!k-mt-1 {
    margin-top: 0.25rem !important;
}

.k-mt-1\\.5 {
    margin-top: 0.375rem;
}

.\\!k-mt-1\\.5 {
    margin-top: 0.375rem !important;
}

.k-mt-2 {
    margin-top: 0.5rem;
}

.\\!k-mt-2 {
    margin-top: 0.5rem !important;
}

.k-mt-2\\.5 {
    margin-top: 0.625rem;
}

.\\!k-mt-2\\.5 {
    margin-top: 0.625rem !important;
}

.k-mt-3 {
    margin-top: 0.75rem;
}

.\\!k-mt-3 {
    margin-top: 0.75rem !important;
}

.k-mt-3\\.5 {
    margin-top: 0.875rem;
}

.\\!k-mt-3\\.5 {
    margin-top: 0.875rem !important;
}

.k-mt-4 {
    margin-top: 1rem;
}

.\\!k-mt-4 {
    margin-top: 1rem !important;
}

.k-mt-4\\.5 {
    margin-top: 1.125rem;
}

.\\!k-mt-4\\.5 {
    margin-top: 1.125rem !important;
}

.k-mt-5 {
    margin-top: 1.25rem;
}

.\\!k-mt-5 {
    margin-top: 1.25rem !important;
}

.k-mt-5\\.5 {
    margin-top: 1.375rem;
}

.\\!k-mt-5\\.5 {
    margin-top: 1.375rem !important;
}

.k-mt-6 {
    margin-top: 1.5rem;
}

.\\!k-mt-6 {
    margin-top: 1.5rem !important;
}

.k-mt-6\\.5 {
    margin-top: 1.625rem;
}

.\\!k-mt-6\\.5 {
    margin-top: 1.625rem !important;
}

.k-mt-7 {
    margin-top: 1.75rem;
}

.\\!k-mt-7 {
    margin-top: 1.75rem !important;
}

.k-mt-7\\.5 {
    margin-top: 1.875rem;
}

.\\!k-mt-7\\.5 {
    margin-top: 1.875rem !important;
}

.k-mt-8 {
    margin-top: 2rem;
}

.\\!k-mt-8 {
    margin-top: 2rem !important;
}

.k-mt-9 {
    margin-top: 2.25rem;
}

.\\!k-mt-9 {
    margin-top: 2.25rem !important;
}

.k-mt-10 {
    margin-top: 2.5rem;
}

.\\!k-mt-10 {
    margin-top: 2.5rem !important;
}

.k-mt-11 {
    margin-top: 2.75rem;
}

.\\!k-mt-11 {
    margin-top: 2.75rem !important;
}

.k-mt-12 {
    margin-top: 3rem;
}

.\\!k-mt-12 {
    margin-top: 3rem !important;
}

.k-mt-13 {
    margin-top: 3.25rem;
}

.\\!k-mt-13 {
    margin-top: 3.25rem !important;
}

.k-mt-14 {
    margin-top: 3.5rem;
}

.\\!k-mt-14 {
    margin-top: 3.5rem !important;
}

.k-mt-15 {
    margin-top: 3.75rem;
}

.\\!k-mt-15 {
    margin-top: 3.75rem !important;
}

.k-mt-16 {
    margin-top: 4rem;
}

.\\!k-mt-16 {
    margin-top: 4rem !important;
}

.k-mt-17 {
    margin-top: 4.25rem;
}

.\\!k-mt-17 {
    margin-top: 4.25rem !important;
}

.k-mt-18 {
    margin-top: 4.5rem;
}

.\\!k-mt-18 {
    margin-top: 4.5rem !important;
}

.k-mt-19 {
    margin-top: 4.75rem;
}

.\\!k-mt-19 {
    margin-top: 4.75rem !important;
}

.k-mt-20 {
    margin-top: 5rem;
}

.\\!k-mt-20 {
    margin-top: 5rem !important;
}

.k-mt-21 {
    margin-top: 5.25rem;
}

.\\!k-mt-21 {
    margin-top: 5.25rem !important;
}

.k-mt-22 {
    margin-top: 5.5rem;
}

.\\!k-mt-22 {
    margin-top: 5.5rem !important;
}

.k-mt-23 {
    margin-top: 5.75rem;
}

.\\!k-mt-23 {
    margin-top: 5.75rem !important;
}

.k-mt-24 {
    margin-top: 6rem;
}

.\\!k-mt-24 {
    margin-top: 6rem !important;
}

.k-mt--1px {
    margin-top: -1px;
}

.\\!k-mt--1px {
    margin-top: -1px !important;
}

.k-mt--0\\.5 {
    margin-top: -0.125rem;
}

.\\!k-mt--0\\.5 {
    margin-top: -0.125rem !important;
}

.k-mt--1 {
    margin-top: -0.25rem;
}

.\\!k-mt--1 {
    margin-top: -0.25rem !important;
}

.k-mt--1\\.5 {
    margin-top: -0.375rem;
}

.\\!k-mt--1\\.5 {
    margin-top: -0.375rem !important;
}

.k-mt--2 {
    margin-top: -0.5rem;
}

.\\!k-mt--2 {
    margin-top: -0.5rem !important;
}

.k-mt--2\\.5 {
    margin-top: -0.625rem;
}

.\\!k-mt--2\\.5 {
    margin-top: -0.625rem !important;
}

.k-mt--3 {
    margin-top: -0.75rem;
}

.\\!k-mt--3 {
    margin-top: -0.75rem !important;
}

.k-mt--3\\.5 {
    margin-top: -0.875rem;
}

.\\!k-mt--3\\.5 {
    margin-top: -0.875rem !important;
}

.k-mt--4 {
    margin-top: -1rem;
}

.\\!k-mt--4 {
    margin-top: -1rem !important;
}

.k-mt--4\\.5 {
    margin-top: -1.125rem;
}

.\\!k-mt--4\\.5 {
    margin-top: -1.125rem !important;
}

.k-mt--5 {
    margin-top: -1.25rem;
}

.\\!k-mt--5 {
    margin-top: -1.25rem !important;
}

.k-mt--5\\.5 {
    margin-top: -1.375rem;
}

.\\!k-mt--5\\.5 {
    margin-top: -1.375rem !important;
}

.k-mt--6 {
    margin-top: -1.5rem;
}

.\\!k-mt--6 {
    margin-top: -1.5rem !important;
}

.k-mt--6\\.5 {
    margin-top: -1.625rem;
}

.\\!k-mt--6\\.5 {
    margin-top: -1.625rem !important;
}

.k-mt--7 {
    margin-top: -1.75rem;
}

.\\!k-mt--7 {
    margin-top: -1.75rem !important;
}

.k-mt--7\\.5 {
    margin-top: -1.875rem;
}

.\\!k-mt--7\\.5 {
    margin-top: -1.875rem !important;
}

.k-mt--8 {
    margin-top: -2rem;
}

.\\!k-mt--8 {
    margin-top: -2rem !important;
}

.k-mt--9 {
    margin-top: -2.25rem;
}

.\\!k-mt--9 {
    margin-top: -2.25rem !important;
}

.k-mt--10 {
    margin-top: -2.5rem;
}

.\\!k-mt--10 {
    margin-top: -2.5rem !important;
}

.k-mt--11 {
    margin-top: -2.75rem;
}

.\\!k-mt--11 {
    margin-top: -2.75rem !important;
}

.k-mt--12 {
    margin-top: -3rem;
}

.\\!k-mt--12 {
    margin-top: -3rem !important;
}

.k-mt--13 {
    margin-top: -3.25rem;
}

.\\!k-mt--13 {
    margin-top: -3.25rem !important;
}

.k-mt--14 {
    margin-top: -3.5rem;
}

.\\!k-mt--14 {
    margin-top: -3.5rem !important;
}

.k-mt--15 {
    margin-top: -3.75rem;
}

.\\!k-mt--15 {
    margin-top: -3.75rem !important;
}

.k-mt--16 {
    margin-top: -4rem;
}

.\\!k-mt--16 {
    margin-top: -4rem !important;
}

.k-mt--17 {
    margin-top: -4.25rem;
}

.\\!k-mt--17 {
    margin-top: -4.25rem !important;
}

.k-mt--18 {
    margin-top: -4.5rem;
}

.\\!k-mt--18 {
    margin-top: -4.5rem !important;
}

.k-mt--19 {
    margin-top: -4.75rem;
}

.\\!k-mt--19 {
    margin-top: -4.75rem !important;
}

.k-mt--20 {
    margin-top: -5rem;
}

.\\!k-mt--20 {
    margin-top: -5rem !important;
}

.k-mt--21 {
    margin-top: -5.25rem;
}

.\\!k-mt--21 {
    margin-top: -5.25rem !important;
}

.k-mt--22 {
    margin-top: -5.5rem;
}

.\\!k-mt--22 {
    margin-top: -5.5rem !important;
}

.k-mt--23 {
    margin-top: -5.75rem;
}

.\\!k-mt--23 {
    margin-top: -5.75rem !important;
}

.k-mt--24 {
    margin-top: -6rem;
}

.\\!k-mt--24 {
    margin-top: -6rem !important;
}

.k-mt-xs {
    margin-top: 0.25rem;
}

.\\!k-mt-xs {
    margin-top: 0.25rem !important;
}

.k-mt-sm {
    margin-top: 0.5rem;
}

.\\!k-mt-sm {
    margin-top: 0.5rem !important;
}

.k-mt-md {
    margin-top: 0.75rem;
}

.\\!k-mt-md {
    margin-top: 0.75rem !important;
}

.k-mt-lg {
    margin-top: 1rem;
}

.\\!k-mt-lg {
    margin-top: 1rem !important;
}

.k-mt-xl {
    margin-top: 1.5rem;
}

.\\!k-mt-xl {
    margin-top: 1.5rem !important;
}

.k-mt-thin {
    margin-top: 0.125rem;
}

.\\!k-mt-thin {
    margin-top: 0.125rem !important;
}

.k-mt-hair {
    margin-top: 1px;
}

.\\!k-mt-hair {
    margin-top: 1px !important;
}

.k-mt-auto {
    margin-top: auto;
}

.\\!k-mt-auto {
    margin-top: auto !important;
}

.k-mr-0 {
    margin-right: 0;
}

.\\!k-mr-0 {
    margin-right: 0 !important;
}

.k-mr-1px {
    margin-right: 1px;
}

.\\!k-mr-1px {
    margin-right: 1px !important;
}

.k-mr-0\\.5 {
    margin-right: 0.125rem;
}

.\\!k-mr-0\\.5 {
    margin-right: 0.125rem !important;
}

.k-mr-1 {
    margin-right: 0.25rem;
}

.\\!k-mr-1 {
    margin-right: 0.25rem !important;
}

.k-mr-1\\.5 {
    margin-right: 0.375rem;
}

.\\!k-mr-1\\.5 {
    margin-right: 0.375rem !important;
}

.k-mr-2 {
    margin-right: 0.5rem;
}

.\\!k-mr-2 {
    margin-right: 0.5rem !important;
}

.k-mr-2\\.5 {
    margin-right: 0.625rem;
}

.\\!k-mr-2\\.5 {
    margin-right: 0.625rem !important;
}

.k-mr-3 {
    margin-right: 0.75rem;
}

.\\!k-mr-3 {
    margin-right: 0.75rem !important;
}

.k-mr-3\\.5 {
    margin-right: 0.875rem;
}

.\\!k-mr-3\\.5 {
    margin-right: 0.875rem !important;
}

.k-mr-4 {
    margin-right: 1rem;
}

.\\!k-mr-4 {
    margin-right: 1rem !important;
}

.k-mr-4\\.5 {
    margin-right: 1.125rem;
}

.\\!k-mr-4\\.5 {
    margin-right: 1.125rem !important;
}

.k-mr-5 {
    margin-right: 1.25rem;
}

.\\!k-mr-5 {
    margin-right: 1.25rem !important;
}

.k-mr-5\\.5 {
    margin-right: 1.375rem;
}

.\\!k-mr-5\\.5 {
    margin-right: 1.375rem !important;
}

.k-mr-6 {
    margin-right: 1.5rem;
}

.\\!k-mr-6 {
    margin-right: 1.5rem !important;
}

.k-mr-6\\.5 {
    margin-right: 1.625rem;
}

.\\!k-mr-6\\.5 {
    margin-right: 1.625rem !important;
}

.k-mr-7 {
    margin-right: 1.75rem;
}

.\\!k-mr-7 {
    margin-right: 1.75rem !important;
}

.k-mr-7\\.5 {
    margin-right: 1.875rem;
}

.\\!k-mr-7\\.5 {
    margin-right: 1.875rem !important;
}

.k-mr-8 {
    margin-right: 2rem;
}

.\\!k-mr-8 {
    margin-right: 2rem !important;
}

.k-mr-9 {
    margin-right: 2.25rem;
}

.\\!k-mr-9 {
    margin-right: 2.25rem !important;
}

.k-mr-10 {
    margin-right: 2.5rem;
}

.\\!k-mr-10 {
    margin-right: 2.5rem !important;
}

.k-mr-11 {
    margin-right: 2.75rem;
}

.\\!k-mr-11 {
    margin-right: 2.75rem !important;
}

.k-mr-12 {
    margin-right: 3rem;
}

.\\!k-mr-12 {
    margin-right: 3rem !important;
}

.k-mr-13 {
    margin-right: 3.25rem;
}

.\\!k-mr-13 {
    margin-right: 3.25rem !important;
}

.k-mr-14 {
    margin-right: 3.5rem;
}

.\\!k-mr-14 {
    margin-right: 3.5rem !important;
}

.k-mr-15 {
    margin-right: 3.75rem;
}

.\\!k-mr-15 {
    margin-right: 3.75rem !important;
}

.k-mr-16 {
    margin-right: 4rem;
}

.\\!k-mr-16 {
    margin-right: 4rem !important;
}

.k-mr-17 {
    margin-right: 4.25rem;
}

.\\!k-mr-17 {
    margin-right: 4.25rem !important;
}

.k-mr-18 {
    margin-right: 4.5rem;
}

.\\!k-mr-18 {
    margin-right: 4.5rem !important;
}

.k-mr-19 {
    margin-right: 4.75rem;
}

.\\!k-mr-19 {
    margin-right: 4.75rem !important;
}

.k-mr-20 {
    margin-right: 5rem;
}

.\\!k-mr-20 {
    margin-right: 5rem !important;
}

.k-mr-21 {
    margin-right: 5.25rem;
}

.\\!k-mr-21 {
    margin-right: 5.25rem !important;
}

.k-mr-22 {
    margin-right: 5.5rem;
}

.\\!k-mr-22 {
    margin-right: 5.5rem !important;
}

.k-mr-23 {
    margin-right: 5.75rem;
}

.\\!k-mr-23 {
    margin-right: 5.75rem !important;
}

.k-mr-24 {
    margin-right: 6rem;
}

.\\!k-mr-24 {
    margin-right: 6rem !important;
}

.k-mr--1px {
    margin-right: -1px;
}

.\\!k-mr--1px {
    margin-right: -1px !important;
}

.k-mr--0\\.5 {
    margin-right: -0.125rem;
}

.\\!k-mr--0\\.5 {
    margin-right: -0.125rem !important;
}

.k-mr--1 {
    margin-right: -0.25rem;
}

.\\!k-mr--1 {
    margin-right: -0.25rem !important;
}

.k-mr--1\\.5 {
    margin-right: -0.375rem;
}

.\\!k-mr--1\\.5 {
    margin-right: -0.375rem !important;
}

.k-mr--2 {
    margin-right: -0.5rem;
}

.\\!k-mr--2 {
    margin-right: -0.5rem !important;
}

.k-mr--2\\.5 {
    margin-right: -0.625rem;
}

.\\!k-mr--2\\.5 {
    margin-right: -0.625rem !important;
}

.k-mr--3 {
    margin-right: -0.75rem;
}

.\\!k-mr--3 {
    margin-right: -0.75rem !important;
}

.k-mr--3\\.5 {
    margin-right: -0.875rem;
}

.\\!k-mr--3\\.5 {
    margin-right: -0.875rem !important;
}

.k-mr--4 {
    margin-right: -1rem;
}

.\\!k-mr--4 {
    margin-right: -1rem !important;
}

.k-mr--4\\.5 {
    margin-right: -1.125rem;
}

.\\!k-mr--4\\.5 {
    margin-right: -1.125rem !important;
}

.k-mr--5 {
    margin-right: -1.25rem;
}

.\\!k-mr--5 {
    margin-right: -1.25rem !important;
}

.k-mr--5\\.5 {
    margin-right: -1.375rem;
}

.\\!k-mr--5\\.5 {
    margin-right: -1.375rem !important;
}

.k-mr--6 {
    margin-right: -1.5rem;
}

.\\!k-mr--6 {
    margin-right: -1.5rem !important;
}

.k-mr--6\\.5 {
    margin-right: -1.625rem;
}

.\\!k-mr--6\\.5 {
    margin-right: -1.625rem !important;
}

.k-mr--7 {
    margin-right: -1.75rem;
}

.\\!k-mr--7 {
    margin-right: -1.75rem !important;
}

.k-mr--7\\.5 {
    margin-right: -1.875rem;
}

.\\!k-mr--7\\.5 {
    margin-right: -1.875rem !important;
}

.k-mr--8 {
    margin-right: -2rem;
}

.\\!k-mr--8 {
    margin-right: -2rem !important;
}

.k-mr--9 {
    margin-right: -2.25rem;
}

.\\!k-mr--9 {
    margin-right: -2.25rem !important;
}

.k-mr--10 {
    margin-right: -2.5rem;
}

.\\!k-mr--10 {
    margin-right: -2.5rem !important;
}

.k-mr--11 {
    margin-right: -2.75rem;
}

.\\!k-mr--11 {
    margin-right: -2.75rem !important;
}

.k-mr--12 {
    margin-right: -3rem;
}

.\\!k-mr--12 {
    margin-right: -3rem !important;
}

.k-mr--13 {
    margin-right: -3.25rem;
}

.\\!k-mr--13 {
    margin-right: -3.25rem !important;
}

.k-mr--14 {
    margin-right: -3.5rem;
}

.\\!k-mr--14 {
    margin-right: -3.5rem !important;
}

.k-mr--15 {
    margin-right: -3.75rem;
}

.\\!k-mr--15 {
    margin-right: -3.75rem !important;
}

.k-mr--16 {
    margin-right: -4rem;
}

.\\!k-mr--16 {
    margin-right: -4rem !important;
}

.k-mr--17 {
    margin-right: -4.25rem;
}

.\\!k-mr--17 {
    margin-right: -4.25rem !important;
}

.k-mr--18 {
    margin-right: -4.5rem;
}

.\\!k-mr--18 {
    margin-right: -4.5rem !important;
}

.k-mr--19 {
    margin-right: -4.75rem;
}

.\\!k-mr--19 {
    margin-right: -4.75rem !important;
}

.k-mr--20 {
    margin-right: -5rem;
}

.\\!k-mr--20 {
    margin-right: -5rem !important;
}

.k-mr--21 {
    margin-right: -5.25rem;
}

.\\!k-mr--21 {
    margin-right: -5.25rem !important;
}

.k-mr--22 {
    margin-right: -5.5rem;
}

.\\!k-mr--22 {
    margin-right: -5.5rem !important;
}

.k-mr--23 {
    margin-right: -5.75rem;
}

.\\!k-mr--23 {
    margin-right: -5.75rem !important;
}

.k-mr--24 {
    margin-right: -6rem;
}

.\\!k-mr--24 {
    margin-right: -6rem !important;
}

.k-mr-xs {
    margin-right: 0.25rem;
}

.\\!k-mr-xs {
    margin-right: 0.25rem !important;
}

.k-mr-sm {
    margin-right: 0.5rem;
}

.\\!k-mr-sm {
    margin-right: 0.5rem !important;
}

.k-mr-md {
    margin-right: 0.75rem;
}

.\\!k-mr-md {
    margin-right: 0.75rem !important;
}

.k-mr-lg {
    margin-right: 1rem;
}

.\\!k-mr-lg {
    margin-right: 1rem !important;
}

.k-mr-xl {
    margin-right: 1.5rem;
}

.\\!k-mr-xl {
    margin-right: 1.5rem !important;
}

.k-mr-thin {
    margin-right: 0.125rem;
}

.\\!k-mr-thin {
    margin-right: 0.125rem !important;
}

.k-mr-hair {
    margin-right: 1px;
}

.\\!k-mr-hair {
    margin-right: 1px !important;
}

.k-mr-auto {
    margin-right: auto;
}

.\\!k-mr-auto {
    margin-right: auto !important;
}

.k-mb-0 {
    margin-bottom: 0;
}

.\\!k-mb-0 {
    margin-bottom: 0 !important;
}

.k-mb-1px {
    margin-bottom: 1px;
}

.\\!k-mb-1px {
    margin-bottom: 1px !important;
}

.k-mb-0\\.5 {
    margin-bottom: 0.125rem;
}

.\\!k-mb-0\\.5 {
    margin-bottom: 0.125rem !important;
}

.k-mb-1 {
    margin-bottom: 0.25rem;
}

.\\!k-mb-1 {
    margin-bottom: 0.25rem !important;
}

.k-mb-1\\.5 {
    margin-bottom: 0.375rem;
}

.\\!k-mb-1\\.5 {
    margin-bottom: 0.375rem !important;
}

.k-mb-2 {
    margin-bottom: 0.5rem;
}

.\\!k-mb-2 {
    margin-bottom: 0.5rem !important;
}

.k-mb-2\\.5 {
    margin-bottom: 0.625rem;
}

.\\!k-mb-2\\.5 {
    margin-bottom: 0.625rem !important;
}

.k-mb-3 {
    margin-bottom: 0.75rem;
}

.\\!k-mb-3 {
    margin-bottom: 0.75rem !important;
}

.k-mb-3\\.5 {
    margin-bottom: 0.875rem;
}

.\\!k-mb-3\\.5 {
    margin-bottom: 0.875rem !important;
}

.k-mb-4 {
    margin-bottom: 1rem;
}

.\\!k-mb-4 {
    margin-bottom: 1rem !important;
}

.k-mb-4\\.5 {
    margin-bottom: 1.125rem;
}

.\\!k-mb-4\\.5 {
    margin-bottom: 1.125rem !important;
}

.k-mb-5 {
    margin-bottom: 1.25rem;
}

.\\!k-mb-5 {
    margin-bottom: 1.25rem !important;
}

.k-mb-5\\.5 {
    margin-bottom: 1.375rem;
}

.\\!k-mb-5\\.5 {
    margin-bottom: 1.375rem !important;
}

.k-mb-6 {
    margin-bottom: 1.5rem;
}

.\\!k-mb-6 {
    margin-bottom: 1.5rem !important;
}

.k-mb-6\\.5 {
    margin-bottom: 1.625rem;
}

.\\!k-mb-6\\.5 {
    margin-bottom: 1.625rem !important;
}

.k-mb-7 {
    margin-bottom: 1.75rem;
}

.\\!k-mb-7 {
    margin-bottom: 1.75rem !important;
}

.k-mb-7\\.5 {
    margin-bottom: 1.875rem;
}

.\\!k-mb-7\\.5 {
    margin-bottom: 1.875rem !important;
}

.k-mb-8 {
    margin-bottom: 2rem;
}

.\\!k-mb-8 {
    margin-bottom: 2rem !important;
}

.k-mb-9 {
    margin-bottom: 2.25rem;
}

.\\!k-mb-9 {
    margin-bottom: 2.25rem !important;
}

.k-mb-10 {
    margin-bottom: 2.5rem;
}

.\\!k-mb-10 {
    margin-bottom: 2.5rem !important;
}

.k-mb-11 {
    margin-bottom: 2.75rem;
}

.\\!k-mb-11 {
    margin-bottom: 2.75rem !important;
}

.k-mb-12 {
    margin-bottom: 3rem;
}

.\\!k-mb-12 {
    margin-bottom: 3rem !important;
}

.k-mb-13 {
    margin-bottom: 3.25rem;
}

.\\!k-mb-13 {
    margin-bottom: 3.25rem !important;
}

.k-mb-14 {
    margin-bottom: 3.5rem;
}

.\\!k-mb-14 {
    margin-bottom: 3.5rem !important;
}

.k-mb-15 {
    margin-bottom: 3.75rem;
}

.\\!k-mb-15 {
    margin-bottom: 3.75rem !important;
}

.k-mb-16 {
    margin-bottom: 4rem;
}

.\\!k-mb-16 {
    margin-bottom: 4rem !important;
}

.k-mb-17 {
    margin-bottom: 4.25rem;
}

.\\!k-mb-17 {
    margin-bottom: 4.25rem !important;
}

.k-mb-18 {
    margin-bottom: 4.5rem;
}

.\\!k-mb-18 {
    margin-bottom: 4.5rem !important;
}

.k-mb-19 {
    margin-bottom: 4.75rem;
}

.\\!k-mb-19 {
    margin-bottom: 4.75rem !important;
}

.k-mb-20 {
    margin-bottom: 5rem;
}

.\\!k-mb-20 {
    margin-bottom: 5rem !important;
}

.k-mb-21 {
    margin-bottom: 5.25rem;
}

.\\!k-mb-21 {
    margin-bottom: 5.25rem !important;
}

.k-mb-22 {
    margin-bottom: 5.5rem;
}

.\\!k-mb-22 {
    margin-bottom: 5.5rem !important;
}

.k-mb-23 {
    margin-bottom: 5.75rem;
}

.\\!k-mb-23 {
    margin-bottom: 5.75rem !important;
}

.k-mb-24 {
    margin-bottom: 6rem;
}

.\\!k-mb-24 {
    margin-bottom: 6rem !important;
}

.k-mb--1px {
    margin-bottom: -1px;
}

.\\!k-mb--1px {
    margin-bottom: -1px !important;
}

.k-mb--0\\.5 {
    margin-bottom: -0.125rem;
}

.\\!k-mb--0\\.5 {
    margin-bottom: -0.125rem !important;
}

.k-mb--1 {
    margin-bottom: -0.25rem;
}

.\\!k-mb--1 {
    margin-bottom: -0.25rem !important;
}

.k-mb--1\\.5 {
    margin-bottom: -0.375rem;
}

.\\!k-mb--1\\.5 {
    margin-bottom: -0.375rem !important;
}

.k-mb--2 {
    margin-bottom: -0.5rem;
}

.\\!k-mb--2 {
    margin-bottom: -0.5rem !important;
}

.k-mb--2\\.5 {
    margin-bottom: -0.625rem;
}

.\\!k-mb--2\\.5 {
    margin-bottom: -0.625rem !important;
}

.k-mb--3 {
    margin-bottom: -0.75rem;
}

.\\!k-mb--3 {
    margin-bottom: -0.75rem !important;
}

.k-mb--3\\.5 {
    margin-bottom: -0.875rem;
}

.\\!k-mb--3\\.5 {
    margin-bottom: -0.875rem !important;
}

.k-mb--4 {
    margin-bottom: -1rem;
}

.\\!k-mb--4 {
    margin-bottom: -1rem !important;
}

.k-mb--4\\.5 {
    margin-bottom: -1.125rem;
}

.\\!k-mb--4\\.5 {
    margin-bottom: -1.125rem !important;
}

.k-mb--5 {
    margin-bottom: -1.25rem;
}

.\\!k-mb--5 {
    margin-bottom: -1.25rem !important;
}

.k-mb--5\\.5 {
    margin-bottom: -1.375rem;
}

.\\!k-mb--5\\.5 {
    margin-bottom: -1.375rem !important;
}

.k-mb--6 {
    margin-bottom: -1.5rem;
}

.\\!k-mb--6 {
    margin-bottom: -1.5rem !important;
}

.k-mb--6\\.5 {
    margin-bottom: -1.625rem;
}

.\\!k-mb--6\\.5 {
    margin-bottom: -1.625rem !important;
}

.k-mb--7 {
    margin-bottom: -1.75rem;
}

.\\!k-mb--7 {
    margin-bottom: -1.75rem !important;
}

.k-mb--7\\.5 {
    margin-bottom: -1.875rem;
}

.\\!k-mb--7\\.5 {
    margin-bottom: -1.875rem !important;
}

.k-mb--8 {
    margin-bottom: -2rem;
}

.\\!k-mb--8 {
    margin-bottom: -2rem !important;
}

.k-mb--9 {
    margin-bottom: -2.25rem;
}

.\\!k-mb--9 {
    margin-bottom: -2.25rem !important;
}

.k-mb--10 {
    margin-bottom: -2.5rem;
}

.\\!k-mb--10 {
    margin-bottom: -2.5rem !important;
}

.k-mb--11 {
    margin-bottom: -2.75rem;
}

.\\!k-mb--11 {
    margin-bottom: -2.75rem !important;
}

.k-mb--12 {
    margin-bottom: -3rem;
}

.\\!k-mb--12 {
    margin-bottom: -3rem !important;
}

.k-mb--13 {
    margin-bottom: -3.25rem;
}

.\\!k-mb--13 {
    margin-bottom: -3.25rem !important;
}

.k-mb--14 {
    margin-bottom: -3.5rem;
}

.\\!k-mb--14 {
    margin-bottom: -3.5rem !important;
}

.k-mb--15 {
    margin-bottom: -3.75rem;
}

.\\!k-mb--15 {
    margin-bottom: -3.75rem !important;
}

.k-mb--16 {
    margin-bottom: -4rem;
}

.\\!k-mb--16 {
    margin-bottom: -4rem !important;
}

.k-mb--17 {
    margin-bottom: -4.25rem;
}

.\\!k-mb--17 {
    margin-bottom: -4.25rem !important;
}

.k-mb--18 {
    margin-bottom: -4.5rem;
}

.\\!k-mb--18 {
    margin-bottom: -4.5rem !important;
}

.k-mb--19 {
    margin-bottom: -4.75rem;
}

.\\!k-mb--19 {
    margin-bottom: -4.75rem !important;
}

.k-mb--20 {
    margin-bottom: -5rem;
}

.\\!k-mb--20 {
    margin-bottom: -5rem !important;
}

.k-mb--21 {
    margin-bottom: -5.25rem;
}

.\\!k-mb--21 {
    margin-bottom: -5.25rem !important;
}

.k-mb--22 {
    margin-bottom: -5.5rem;
}

.\\!k-mb--22 {
    margin-bottom: -5.5rem !important;
}

.k-mb--23 {
    margin-bottom: -5.75rem;
}

.\\!k-mb--23 {
    margin-bottom: -5.75rem !important;
}

.k-mb--24 {
    margin-bottom: -6rem;
}

.\\!k-mb--24 {
    margin-bottom: -6rem !important;
}

.k-mb-xs {
    margin-bottom: 0.25rem;
}

.\\!k-mb-xs {
    margin-bottom: 0.25rem !important;
}

.k-mb-sm {
    margin-bottom: 0.5rem;
}

.\\!k-mb-sm {
    margin-bottom: 0.5rem !important;
}

.k-mb-md {
    margin-bottom: 0.75rem;
}

.\\!k-mb-md {
    margin-bottom: 0.75rem !important;
}

.k-mb-lg {
    margin-bottom: 1rem;
}

.\\!k-mb-lg {
    margin-bottom: 1rem !important;
}

.k-mb-xl {
    margin-bottom: 1.5rem;
}

.\\!k-mb-xl {
    margin-bottom: 1.5rem !important;
}

.k-mb-thin {
    margin-bottom: 0.125rem;
}

.\\!k-mb-thin {
    margin-bottom: 0.125rem !important;
}

.k-mb-hair {
    margin-bottom: 1px;
}

.\\!k-mb-hair {
    margin-bottom: 1px !important;
}

.k-mb-auto {
    margin-bottom: auto;
}

.\\!k-mb-auto {
    margin-bottom: auto !important;
}

.k-ml-0 {
    margin-left: 0;
}

.\\!k-ml-0 {
    margin-left: 0 !important;
}

.k-ml-1px {
    margin-left: 1px;
}

.\\!k-ml-1px {
    margin-left: 1px !important;
}

.k-ml-0\\.5 {
    margin-left: 0.125rem;
}

.\\!k-ml-0\\.5 {
    margin-left: 0.125rem !important;
}

.k-ml-1 {
    margin-left: 0.25rem;
}

.\\!k-ml-1 {
    margin-left: 0.25rem !important;
}

.k-ml-1\\.5 {
    margin-left: 0.375rem;
}

.\\!k-ml-1\\.5 {
    margin-left: 0.375rem !important;
}

.k-ml-2 {
    margin-left: 0.5rem;
}

.\\!k-ml-2 {
    margin-left: 0.5rem !important;
}

.k-ml-2\\.5 {
    margin-left: 0.625rem;
}

.\\!k-ml-2\\.5 {
    margin-left: 0.625rem !important;
}

.k-ml-3 {
    margin-left: 0.75rem;
}

.\\!k-ml-3 {
    margin-left: 0.75rem !important;
}

.k-ml-3\\.5 {
    margin-left: 0.875rem;
}

.\\!k-ml-3\\.5 {
    margin-left: 0.875rem !important;
}

.k-ml-4 {
    margin-left: 1rem;
}

.\\!k-ml-4 {
    margin-left: 1rem !important;
}

.k-ml-4\\.5 {
    margin-left: 1.125rem;
}

.\\!k-ml-4\\.5 {
    margin-left: 1.125rem !important;
}

.k-ml-5 {
    margin-left: 1.25rem;
}

.\\!k-ml-5 {
    margin-left: 1.25rem !important;
}

.k-ml-5\\.5 {
    margin-left: 1.375rem;
}

.\\!k-ml-5\\.5 {
    margin-left: 1.375rem !important;
}

.k-ml-6 {
    margin-left: 1.5rem;
}

.\\!k-ml-6 {
    margin-left: 1.5rem !important;
}

.k-ml-6\\.5 {
    margin-left: 1.625rem;
}

.\\!k-ml-6\\.5 {
    margin-left: 1.625rem !important;
}

.k-ml-7 {
    margin-left: 1.75rem;
}

.\\!k-ml-7 {
    margin-left: 1.75rem !important;
}

.k-ml-7\\.5 {
    margin-left: 1.875rem;
}

.\\!k-ml-7\\.5 {
    margin-left: 1.875rem !important;
}

.k-ml-8 {
    margin-left: 2rem;
}

.\\!k-ml-8 {
    margin-left: 2rem !important;
}

.k-ml-9 {
    margin-left: 2.25rem;
}

.\\!k-ml-9 {
    margin-left: 2.25rem !important;
}

.k-ml-10 {
    margin-left: 2.5rem;
}

.\\!k-ml-10 {
    margin-left: 2.5rem !important;
}

.k-ml-11 {
    margin-left: 2.75rem;
}

.\\!k-ml-11 {
    margin-left: 2.75rem !important;
}

.k-ml-12 {
    margin-left: 3rem;
}

.\\!k-ml-12 {
    margin-left: 3rem !important;
}

.k-ml-13 {
    margin-left: 3.25rem;
}

.\\!k-ml-13 {
    margin-left: 3.25rem !important;
}

.k-ml-14 {
    margin-left: 3.5rem;
}

.\\!k-ml-14 {
    margin-left: 3.5rem !important;
}

.k-ml-15 {
    margin-left: 3.75rem;
}

.\\!k-ml-15 {
    margin-left: 3.75rem !important;
}

.k-ml-16 {
    margin-left: 4rem;
}

.\\!k-ml-16 {
    margin-left: 4rem !important;
}

.k-ml-17 {
    margin-left: 4.25rem;
}

.\\!k-ml-17 {
    margin-left: 4.25rem !important;
}

.k-ml-18 {
    margin-left: 4.5rem;
}

.\\!k-ml-18 {
    margin-left: 4.5rem !important;
}

.k-ml-19 {
    margin-left: 4.75rem;
}

.\\!k-ml-19 {
    margin-left: 4.75rem !important;
}

.k-ml-20 {
    margin-left: 5rem;
}

.\\!k-ml-20 {
    margin-left: 5rem !important;
}

.k-ml-21 {
    margin-left: 5.25rem;
}

.\\!k-ml-21 {
    margin-left: 5.25rem !important;
}

.k-ml-22 {
    margin-left: 5.5rem;
}

.\\!k-ml-22 {
    margin-left: 5.5rem !important;
}

.k-ml-23 {
    margin-left: 5.75rem;
}

.\\!k-ml-23 {
    margin-left: 5.75rem !important;
}

.k-ml-24 {
    margin-left: 6rem;
}

.\\!k-ml-24 {
    margin-left: 6rem !important;
}

.k-ml--1px {
    margin-left: -1px;
}

.\\!k-ml--1px {
    margin-left: -1px !important;
}

.k-ml--0\\.5 {
    margin-left: -0.125rem;
}

.\\!k-ml--0\\.5 {
    margin-left: -0.125rem !important;
}

.k-ml--1 {
    margin-left: -0.25rem;
}

.\\!k-ml--1 {
    margin-left: -0.25rem !important;
}

.k-ml--1\\.5 {
    margin-left: -0.375rem;
}

.\\!k-ml--1\\.5 {
    margin-left: -0.375rem !important;
}

.k-ml--2 {
    margin-left: -0.5rem;
}

.\\!k-ml--2 {
    margin-left: -0.5rem !important;
}

.k-ml--2\\.5 {
    margin-left: -0.625rem;
}

.\\!k-ml--2\\.5 {
    margin-left: -0.625rem !important;
}

.k-ml--3 {
    margin-left: -0.75rem;
}

.\\!k-ml--3 {
    margin-left: -0.75rem !important;
}

.k-ml--3\\.5 {
    margin-left: -0.875rem;
}

.\\!k-ml--3\\.5 {
    margin-left: -0.875rem !important;
}

.k-ml--4 {
    margin-left: -1rem;
}

.\\!k-ml--4 {
    margin-left: -1rem !important;
}

.k-ml--4\\.5 {
    margin-left: -1.125rem;
}

.\\!k-ml--4\\.5 {
    margin-left: -1.125rem !important;
}

.k-ml--5 {
    margin-left: -1.25rem;
}

.\\!k-ml--5 {
    margin-left: -1.25rem !important;
}

.k-ml--5\\.5 {
    margin-left: -1.375rem;
}

.\\!k-ml--5\\.5 {
    margin-left: -1.375rem !important;
}

.k-ml--6 {
    margin-left: -1.5rem;
}

.\\!k-ml--6 {
    margin-left: -1.5rem !important;
}

.k-ml--6\\.5 {
    margin-left: -1.625rem;
}

.\\!k-ml--6\\.5 {
    margin-left: -1.625rem !important;
}

.k-ml--7 {
    margin-left: -1.75rem;
}

.\\!k-ml--7 {
    margin-left: -1.75rem !important;
}

.k-ml--7\\.5 {
    margin-left: -1.875rem;
}

.\\!k-ml--7\\.5 {
    margin-left: -1.875rem !important;
}

.k-ml--8 {
    margin-left: -2rem;
}

.\\!k-ml--8 {
    margin-left: -2rem !important;
}

.k-ml--9 {
    margin-left: -2.25rem;
}

.\\!k-ml--9 {
    margin-left: -2.25rem !important;
}

.k-ml--10 {
    margin-left: -2.5rem;
}

.\\!k-ml--10 {
    margin-left: -2.5rem !important;
}

.k-ml--11 {
    margin-left: -2.75rem;
}

.\\!k-ml--11 {
    margin-left: -2.75rem !important;
}

.k-ml--12 {
    margin-left: -3rem;
}

.\\!k-ml--12 {
    margin-left: -3rem !important;
}

.k-ml--13 {
    margin-left: -3.25rem;
}

.\\!k-ml--13 {
    margin-left: -3.25rem !important;
}

.k-ml--14 {
    margin-left: -3.5rem;
}

.\\!k-ml--14 {
    margin-left: -3.5rem !important;
}

.k-ml--15 {
    margin-left: -3.75rem;
}

.\\!k-ml--15 {
    margin-left: -3.75rem !important;
}

.k-ml--16 {
    margin-left: -4rem;
}

.\\!k-ml--16 {
    margin-left: -4rem !important;
}

.k-ml--17 {
    margin-left: -4.25rem;
}

.\\!k-ml--17 {
    margin-left: -4.25rem !important;
}

.k-ml--18 {
    margin-left: -4.5rem;
}

.\\!k-ml--18 {
    margin-left: -4.5rem !important;
}

.k-ml--19 {
    margin-left: -4.75rem;
}

.\\!k-ml--19 {
    margin-left: -4.75rem !important;
}

.k-ml--20 {
    margin-left: -5rem;
}

.\\!k-ml--20 {
    margin-left: -5rem !important;
}

.k-ml--21 {
    margin-left: -5.25rem;
}

.\\!k-ml--21 {
    margin-left: -5.25rem !important;
}

.k-ml--22 {
    margin-left: -5.5rem;
}

.\\!k-ml--22 {
    margin-left: -5.5rem !important;
}

.k-ml--23 {
    margin-left: -5.75rem;
}

.\\!k-ml--23 {
    margin-left: -5.75rem !important;
}

.k-ml--24 {
    margin-left: -6rem;
}

.\\!k-ml--24 {
    margin-left: -6rem !important;
}

.k-ml-xs {
    margin-left: 0.25rem;
}

.\\!k-ml-xs {
    margin-left: 0.25rem !important;
}

.k-ml-sm {
    margin-left: 0.5rem;
}

.\\!k-ml-sm {
    margin-left: 0.5rem !important;
}

.k-ml-md {
    margin-left: 0.75rem;
}

.\\!k-ml-md {
    margin-left: 0.75rem !important;
}

.k-ml-lg {
    margin-left: 1rem;
}

.\\!k-ml-lg {
    margin-left: 1rem !important;
}

.k-ml-xl {
    margin-left: 1.5rem;
}

.\\!k-ml-xl {
    margin-left: 1.5rem !important;
}

.k-ml-thin {
    margin-left: 0.125rem;
}

.\\!k-ml-thin {
    margin-left: 0.125rem !important;
}

.k-ml-hair {
    margin-left: 1px;
}

.\\!k-ml-hair {
    margin-left: 1px !important;
}

.k-ml-auto {
    margin-left: auto;
}

.\\!k-ml-auto {
    margin-left: auto !important;
}

.k-mx-0 {
    margin-inline: 0;
}

.\\!k-mx-0 {
    margin-inline: 0 !important;
}

.k-mx-1px {
    margin-inline: 1px;
}

.\\!k-mx-1px {
    margin-inline: 1px !important;
}

.k-mx-0\\.5 {
    margin-inline: 0.125rem;
}

.\\!k-mx-0\\.5 {
    margin-inline: 0.125rem !important;
}

.k-mx-1 {
    margin-inline: 0.25rem;
}

.\\!k-mx-1 {
    margin-inline: 0.25rem !important;
}

.k-mx-1\\.5 {
    margin-inline: 0.375rem;
}

.\\!k-mx-1\\.5 {
    margin-inline: 0.375rem !important;
}

.k-mx-2 {
    margin-inline: 0.5rem;
}

.\\!k-mx-2 {
    margin-inline: 0.5rem !important;
}

.k-mx-2\\.5 {
    margin-inline: 0.625rem;
}

.\\!k-mx-2\\.5 {
    margin-inline: 0.625rem !important;
}

.k-mx-3 {
    margin-inline: 0.75rem;
}

.\\!k-mx-3 {
    margin-inline: 0.75rem !important;
}

.k-mx-3\\.5 {
    margin-inline: 0.875rem;
}

.\\!k-mx-3\\.5 {
    margin-inline: 0.875rem !important;
}

.k-mx-4 {
    margin-inline: 1rem;
}

.\\!k-mx-4 {
    margin-inline: 1rem !important;
}

.k-mx-4\\.5 {
    margin-inline: 1.125rem;
}

.\\!k-mx-4\\.5 {
    margin-inline: 1.125rem !important;
}

.k-mx-5 {
    margin-inline: 1.25rem;
}

.\\!k-mx-5 {
    margin-inline: 1.25rem !important;
}

.k-mx-5\\.5 {
    margin-inline: 1.375rem;
}

.\\!k-mx-5\\.5 {
    margin-inline: 1.375rem !important;
}

.k-mx-6 {
    margin-inline: 1.5rem;
}

.\\!k-mx-6 {
    margin-inline: 1.5rem !important;
}

.k-mx-6\\.5 {
    margin-inline: 1.625rem;
}

.\\!k-mx-6\\.5 {
    margin-inline: 1.625rem !important;
}

.k-mx-7 {
    margin-inline: 1.75rem;
}

.\\!k-mx-7 {
    margin-inline: 1.75rem !important;
}

.k-mx-7\\.5 {
    margin-inline: 1.875rem;
}

.\\!k-mx-7\\.5 {
    margin-inline: 1.875rem !important;
}

.k-mx-8 {
    margin-inline: 2rem;
}

.\\!k-mx-8 {
    margin-inline: 2rem !important;
}

.k-mx-9 {
    margin-inline: 2.25rem;
}

.\\!k-mx-9 {
    margin-inline: 2.25rem !important;
}

.k-mx-10 {
    margin-inline: 2.5rem;
}

.\\!k-mx-10 {
    margin-inline: 2.5rem !important;
}

.k-mx-11 {
    margin-inline: 2.75rem;
}

.\\!k-mx-11 {
    margin-inline: 2.75rem !important;
}

.k-mx-12 {
    margin-inline: 3rem;
}

.\\!k-mx-12 {
    margin-inline: 3rem !important;
}

.k-mx-13 {
    margin-inline: 3.25rem;
}

.\\!k-mx-13 {
    margin-inline: 3.25rem !important;
}

.k-mx-14 {
    margin-inline: 3.5rem;
}

.\\!k-mx-14 {
    margin-inline: 3.5rem !important;
}

.k-mx-15 {
    margin-inline: 3.75rem;
}

.\\!k-mx-15 {
    margin-inline: 3.75rem !important;
}

.k-mx-16 {
    margin-inline: 4rem;
}

.\\!k-mx-16 {
    margin-inline: 4rem !important;
}

.k-mx-17 {
    margin-inline: 4.25rem;
}

.\\!k-mx-17 {
    margin-inline: 4.25rem !important;
}

.k-mx-18 {
    margin-inline: 4.5rem;
}

.\\!k-mx-18 {
    margin-inline: 4.5rem !important;
}

.k-mx-19 {
    margin-inline: 4.75rem;
}

.\\!k-mx-19 {
    margin-inline: 4.75rem !important;
}

.k-mx-20 {
    margin-inline: 5rem;
}

.\\!k-mx-20 {
    margin-inline: 5rem !important;
}

.k-mx-21 {
    margin-inline: 5.25rem;
}

.\\!k-mx-21 {
    margin-inline: 5.25rem !important;
}

.k-mx-22 {
    margin-inline: 5.5rem;
}

.\\!k-mx-22 {
    margin-inline: 5.5rem !important;
}

.k-mx-23 {
    margin-inline: 5.75rem;
}

.\\!k-mx-23 {
    margin-inline: 5.75rem !important;
}

.k-mx-24 {
    margin-inline: 6rem;
}

.\\!k-mx-24 {
    margin-inline: 6rem !important;
}

.k-mx--1px {
    margin-inline: -1px;
}

.\\!k-mx--1px {
    margin-inline: -1px !important;
}

.k-mx--0\\.5 {
    margin-inline: -0.125rem;
}

.\\!k-mx--0\\.5 {
    margin-inline: -0.125rem !important;
}

.k-mx--1 {
    margin-inline: -0.25rem;
}

.\\!k-mx--1 {
    margin-inline: -0.25rem !important;
}

.k-mx--1\\.5 {
    margin-inline: -0.375rem;
}

.\\!k-mx--1\\.5 {
    margin-inline: -0.375rem !important;
}

.k-mx--2 {
    margin-inline: -0.5rem;
}

.\\!k-mx--2 {
    margin-inline: -0.5rem !important;
}

.k-mx--2\\.5 {
    margin-inline: -0.625rem;
}

.\\!k-mx--2\\.5 {
    margin-inline: -0.625rem !important;
}

.k-mx--3 {
    margin-inline: -0.75rem;
}

.\\!k-mx--3 {
    margin-inline: -0.75rem !important;
}

.k-mx--3\\.5 {
    margin-inline: -0.875rem;
}

.\\!k-mx--3\\.5 {
    margin-inline: -0.875rem !important;
}

.k-mx--4 {
    margin-inline: -1rem;
}

.\\!k-mx--4 {
    margin-inline: -1rem !important;
}

.k-mx--4\\.5 {
    margin-inline: -1.125rem;
}

.\\!k-mx--4\\.5 {
    margin-inline: -1.125rem !important;
}

.k-mx--5 {
    margin-inline: -1.25rem;
}

.\\!k-mx--5 {
    margin-inline: -1.25rem !important;
}

.k-mx--5\\.5 {
    margin-inline: -1.375rem;
}

.\\!k-mx--5\\.5 {
    margin-inline: -1.375rem !important;
}

.k-mx--6 {
    margin-inline: -1.5rem;
}

.\\!k-mx--6 {
    margin-inline: -1.5rem !important;
}

.k-mx--6\\.5 {
    margin-inline: -1.625rem;
}

.\\!k-mx--6\\.5 {
    margin-inline: -1.625rem !important;
}

.k-mx--7 {
    margin-inline: -1.75rem;
}

.\\!k-mx--7 {
    margin-inline: -1.75rem !important;
}

.k-mx--7\\.5 {
    margin-inline: -1.875rem;
}

.\\!k-mx--7\\.5 {
    margin-inline: -1.875rem !important;
}

.k-mx--8 {
    margin-inline: -2rem;
}

.\\!k-mx--8 {
    margin-inline: -2rem !important;
}

.k-mx--9 {
    margin-inline: -2.25rem;
}

.\\!k-mx--9 {
    margin-inline: -2.25rem !important;
}

.k-mx--10 {
    margin-inline: -2.5rem;
}

.\\!k-mx--10 {
    margin-inline: -2.5rem !important;
}

.k-mx--11 {
    margin-inline: -2.75rem;
}

.\\!k-mx--11 {
    margin-inline: -2.75rem !important;
}

.k-mx--12 {
    margin-inline: -3rem;
}

.\\!k-mx--12 {
    margin-inline: -3rem !important;
}

.k-mx--13 {
    margin-inline: -3.25rem;
}

.\\!k-mx--13 {
    margin-inline: -3.25rem !important;
}

.k-mx--14 {
    margin-inline: -3.5rem;
}

.\\!k-mx--14 {
    margin-inline: -3.5rem !important;
}

.k-mx--15 {
    margin-inline: -3.75rem;
}

.\\!k-mx--15 {
    margin-inline: -3.75rem !important;
}

.k-mx--16 {
    margin-inline: -4rem;
}

.\\!k-mx--16 {
    margin-inline: -4rem !important;
}

.k-mx--17 {
    margin-inline: -4.25rem;
}

.\\!k-mx--17 {
    margin-inline: -4.25rem !important;
}

.k-mx--18 {
    margin-inline: -4.5rem;
}

.\\!k-mx--18 {
    margin-inline: -4.5rem !important;
}

.k-mx--19 {
    margin-inline: -4.75rem;
}

.\\!k-mx--19 {
    margin-inline: -4.75rem !important;
}

.k-mx--20 {
    margin-inline: -5rem;
}

.\\!k-mx--20 {
    margin-inline: -5rem !important;
}

.k-mx--21 {
    margin-inline: -5.25rem;
}

.\\!k-mx--21 {
    margin-inline: -5.25rem !important;
}

.k-mx--22 {
    margin-inline: -5.5rem;
}

.\\!k-mx--22 {
    margin-inline: -5.5rem !important;
}

.k-mx--23 {
    margin-inline: -5.75rem;
}

.\\!k-mx--23 {
    margin-inline: -5.75rem !important;
}

.k-mx--24 {
    margin-inline: -6rem;
}

.\\!k-mx--24 {
    margin-inline: -6rem !important;
}

.k-mx-xs {
    margin-inline: 0.25rem;
}

.\\!k-mx-xs {
    margin-inline: 0.25rem !important;
}

.k-mx-sm {
    margin-inline: 0.5rem;
}

.\\!k-mx-sm {
    margin-inline: 0.5rem !important;
}

.k-mx-md {
    margin-inline: 0.75rem;
}

.\\!k-mx-md {
    margin-inline: 0.75rem !important;
}

.k-mx-lg {
    margin-inline: 1rem;
}

.\\!k-mx-lg {
    margin-inline: 1rem !important;
}

.k-mx-xl {
    margin-inline: 1.5rem;
}

.\\!k-mx-xl {
    margin-inline: 1.5rem !important;
}

.k-mx-thin {
    margin-inline: 0.125rem;
}

.\\!k-mx-thin {
    margin-inline: 0.125rem !important;
}

.k-mx-hair {
    margin-inline: 1px;
}

.\\!k-mx-hair {
    margin-inline: 1px !important;
}

.k-mx-auto {
    margin-inline: auto;
}

.\\!k-mx-auto {
    margin-inline: auto !important;
}

.k-my-0 {
    margin-block: 0;
}

.\\!k-my-0 {
    margin-block: 0 !important;
}

.k-my-1px {
    margin-block: 1px;
}

.\\!k-my-1px {
    margin-block: 1px !important;
}

.k-my-0\\.5 {
    margin-block: 0.125rem;
}

.\\!k-my-0\\.5 {
    margin-block: 0.125rem !important;
}

.k-my-1 {
    margin-block: 0.25rem;
}

.\\!k-my-1 {
    margin-block: 0.25rem !important;
}

.k-my-1\\.5 {
    margin-block: 0.375rem;
}

.\\!k-my-1\\.5 {
    margin-block: 0.375rem !important;
}

.k-my-2 {
    margin-block: 0.5rem;
}

.\\!k-my-2 {
    margin-block: 0.5rem !important;
}

.k-my-2\\.5 {
    margin-block: 0.625rem;
}

.\\!k-my-2\\.5 {
    margin-block: 0.625rem !important;
}

.k-my-3 {
    margin-block: 0.75rem;
}

.\\!k-my-3 {
    margin-block: 0.75rem !important;
}

.k-my-3\\.5 {
    margin-block: 0.875rem;
}

.\\!k-my-3\\.5 {
    margin-block: 0.875rem !important;
}

.k-my-4 {
    margin-block: 1rem;
}

.\\!k-my-4 {
    margin-block: 1rem !important;
}

.k-my-4\\.5 {
    margin-block: 1.125rem;
}

.\\!k-my-4\\.5 {
    margin-block: 1.125rem !important;
}

.k-my-5 {
    margin-block: 1.25rem;
}

.\\!k-my-5 {
    margin-block: 1.25rem !important;
}

.k-my-5\\.5 {
    margin-block: 1.375rem;
}

.\\!k-my-5\\.5 {
    margin-block: 1.375rem !important;
}

.k-my-6 {
    margin-block: 1.5rem;
}

.\\!k-my-6 {
    margin-block: 1.5rem !important;
}

.k-my-6\\.5 {
    margin-block: 1.625rem;
}

.\\!k-my-6\\.5 {
    margin-block: 1.625rem !important;
}

.k-my-7 {
    margin-block: 1.75rem;
}

.\\!k-my-7 {
    margin-block: 1.75rem !important;
}

.k-my-7\\.5 {
    margin-block: 1.875rem;
}

.\\!k-my-7\\.5 {
    margin-block: 1.875rem !important;
}

.k-my-8 {
    margin-block: 2rem;
}

.\\!k-my-8 {
    margin-block: 2rem !important;
}

.k-my-9 {
    margin-block: 2.25rem;
}

.\\!k-my-9 {
    margin-block: 2.25rem !important;
}

.k-my-10 {
    margin-block: 2.5rem;
}

.\\!k-my-10 {
    margin-block: 2.5rem !important;
}

.k-my-11 {
    margin-block: 2.75rem;
}

.\\!k-my-11 {
    margin-block: 2.75rem !important;
}

.k-my-12 {
    margin-block: 3rem;
}

.\\!k-my-12 {
    margin-block: 3rem !important;
}

.k-my-13 {
    margin-block: 3.25rem;
}

.\\!k-my-13 {
    margin-block: 3.25rem !important;
}

.k-my-14 {
    margin-block: 3.5rem;
}

.\\!k-my-14 {
    margin-block: 3.5rem !important;
}

.k-my-15 {
    margin-block: 3.75rem;
}

.\\!k-my-15 {
    margin-block: 3.75rem !important;
}

.k-my-16 {
    margin-block: 4rem;
}

.\\!k-my-16 {
    margin-block: 4rem !important;
}

.k-my-17 {
    margin-block: 4.25rem;
}

.\\!k-my-17 {
    margin-block: 4.25rem !important;
}

.k-my-18 {
    margin-block: 4.5rem;
}

.\\!k-my-18 {
    margin-block: 4.5rem !important;
}

.k-my-19 {
    margin-block: 4.75rem;
}

.\\!k-my-19 {
    margin-block: 4.75rem !important;
}

.k-my-20 {
    margin-block: 5rem;
}

.\\!k-my-20 {
    margin-block: 5rem !important;
}

.k-my-21 {
    margin-block: 5.25rem;
}

.\\!k-my-21 {
    margin-block: 5.25rem !important;
}

.k-my-22 {
    margin-block: 5.5rem;
}

.\\!k-my-22 {
    margin-block: 5.5rem !important;
}

.k-my-23 {
    margin-block: 5.75rem;
}

.\\!k-my-23 {
    margin-block: 5.75rem !important;
}

.k-my-24 {
    margin-block: 6rem;
}

.\\!k-my-24 {
    margin-block: 6rem !important;
}

.k-my--1px {
    margin-block: -1px;
}

.\\!k-my--1px {
    margin-block: -1px !important;
}

.k-my--0\\.5 {
    margin-block: -0.125rem;
}

.\\!k-my--0\\.5 {
    margin-block: -0.125rem !important;
}

.k-my--1 {
    margin-block: -0.25rem;
}

.\\!k-my--1 {
    margin-block: -0.25rem !important;
}

.k-my--1\\.5 {
    margin-block: -0.375rem;
}

.\\!k-my--1\\.5 {
    margin-block: -0.375rem !important;
}

.k-my--2 {
    margin-block: -0.5rem;
}

.\\!k-my--2 {
    margin-block: -0.5rem !important;
}

.k-my--2\\.5 {
    margin-block: -0.625rem;
}

.\\!k-my--2\\.5 {
    margin-block: -0.625rem !important;
}

.k-my--3 {
    margin-block: -0.75rem;
}

.\\!k-my--3 {
    margin-block: -0.75rem !important;
}

.k-my--3\\.5 {
    margin-block: -0.875rem;
}

.\\!k-my--3\\.5 {
    margin-block: -0.875rem !important;
}

.k-my--4 {
    margin-block: -1rem;
}

.\\!k-my--4 {
    margin-block: -1rem !important;
}

.k-my--4\\.5 {
    margin-block: -1.125rem;
}

.\\!k-my--4\\.5 {
    margin-block: -1.125rem !important;
}

.k-my--5 {
    margin-block: -1.25rem;
}

.\\!k-my--5 {
    margin-block: -1.25rem !important;
}

.k-my--5\\.5 {
    margin-block: -1.375rem;
}

.\\!k-my--5\\.5 {
    margin-block: -1.375rem !important;
}

.k-my--6 {
    margin-block: -1.5rem;
}

.\\!k-my--6 {
    margin-block: -1.5rem !important;
}

.k-my--6\\.5 {
    margin-block: -1.625rem;
}

.\\!k-my--6\\.5 {
    margin-block: -1.625rem !important;
}

.k-my--7 {
    margin-block: -1.75rem;
}

.\\!k-my--7 {
    margin-block: -1.75rem !important;
}

.k-my--7\\.5 {
    margin-block: -1.875rem;
}

.\\!k-my--7\\.5 {
    margin-block: -1.875rem !important;
}

.k-my--8 {
    margin-block: -2rem;
}

.\\!k-my--8 {
    margin-block: -2rem !important;
}

.k-my--9 {
    margin-block: -2.25rem;
}

.\\!k-my--9 {
    margin-block: -2.25rem !important;
}

.k-my--10 {
    margin-block: -2.5rem;
}

.\\!k-my--10 {
    margin-block: -2.5rem !important;
}

.k-my--11 {
    margin-block: -2.75rem;
}

.\\!k-my--11 {
    margin-block: -2.75rem !important;
}

.k-my--12 {
    margin-block: -3rem;
}

.\\!k-my--12 {
    margin-block: -3rem !important;
}

.k-my--13 {
    margin-block: -3.25rem;
}

.\\!k-my--13 {
    margin-block: -3.25rem !important;
}

.k-my--14 {
    margin-block: -3.5rem;
}

.\\!k-my--14 {
    margin-block: -3.5rem !important;
}

.k-my--15 {
    margin-block: -3.75rem;
}

.\\!k-my--15 {
    margin-block: -3.75rem !important;
}

.k-my--16 {
    margin-block: -4rem;
}

.\\!k-my--16 {
    margin-block: -4rem !important;
}

.k-my--17 {
    margin-block: -4.25rem;
}

.\\!k-my--17 {
    margin-block: -4.25rem !important;
}

.k-my--18 {
    margin-block: -4.5rem;
}

.\\!k-my--18 {
    margin-block: -4.5rem !important;
}

.k-my--19 {
    margin-block: -4.75rem;
}

.\\!k-my--19 {
    margin-block: -4.75rem !important;
}

.k-my--20 {
    margin-block: -5rem;
}

.\\!k-my--20 {
    margin-block: -5rem !important;
}

.k-my--21 {
    margin-block: -5.25rem;
}

.\\!k-my--21 {
    margin-block: -5.25rem !important;
}

.k-my--22 {
    margin-block: -5.5rem;
}

.\\!k-my--22 {
    margin-block: -5.5rem !important;
}

.k-my--23 {
    margin-block: -5.75rem;
}

.\\!k-my--23 {
    margin-block: -5.75rem !important;
}

.k-my--24 {
    margin-block: -6rem;
}

.\\!k-my--24 {
    margin-block: -6rem !important;
}

.k-my-xs {
    margin-block: 0.25rem;
}

.\\!k-my-xs {
    margin-block: 0.25rem !important;
}

.k-my-sm {
    margin-block: 0.5rem;
}

.\\!k-my-sm {
    margin-block: 0.5rem !important;
}

.k-my-md {
    margin-block: 0.75rem;
}

.\\!k-my-md {
    margin-block: 0.75rem !important;
}

.k-my-lg {
    margin-block: 1rem;
}

.\\!k-my-lg {
    margin-block: 1rem !important;
}

.k-my-xl {
    margin-block: 1.5rem;
}

.\\!k-my-xl {
    margin-block: 1.5rem !important;
}

.k-my-thin {
    margin-block: 0.125rem;
}

.\\!k-my-thin {
    margin-block: 0.125rem !important;
}

.k-my-hair {
    margin-block: 1px;
}

.\\!k-my-hair {
    margin-block: 1px !important;
}

.k-my-auto {
    margin-block: auto;
}

.\\!k-my-auto {
    margin-block: auto !important;
}

.k-p-0 {
    padding: 0;
}

.\\!k-p-0 {
    padding: 0 !important;
}

.k-p-1px {
    padding: 1px;
}

.\\!k-p-1px {
    padding: 1px !important;
}

.k-p-0\\.5 {
    padding: 0.125rem;
}

.\\!k-p-0\\.5 {
    padding: 0.125rem !important;
}

.k-p-1 {
    padding: 0.25rem;
}

.\\!k-p-1 {
    padding: 0.25rem !important;
}

.k-p-1\\.5 {
    padding: 0.375rem;
}

.\\!k-p-1\\.5 {
    padding: 0.375rem !important;
}

.k-p-2 {
    padding: 0.5rem;
}

.\\!k-p-2 {
    padding: 0.5rem !important;
}

.k-p-2\\.5 {
    padding: 0.625rem;
}

.\\!k-p-2\\.5 {
    padding: 0.625rem !important;
}

.k-p-3 {
    padding: 0.75rem;
}

.\\!k-p-3 {
    padding: 0.75rem !important;
}

.k-p-3\\.5 {
    padding: 0.875rem;
}

.\\!k-p-3\\.5 {
    padding: 0.875rem !important;
}

.k-p-4 {
    padding: 1rem;
}

.\\!k-p-4 {
    padding: 1rem !important;
}

.k-p-4\\.5 {
    padding: 1.125rem;
}

.\\!k-p-4\\.5 {
    padding: 1.125rem !important;
}

.k-p-5 {
    padding: 1.25rem;
}

.\\!k-p-5 {
    padding: 1.25rem !important;
}

.k-p-5\\.5 {
    padding: 1.375rem;
}

.\\!k-p-5\\.5 {
    padding: 1.375rem !important;
}

.k-p-6 {
    padding: 1.5rem;
}

.\\!k-p-6 {
    padding: 1.5rem !important;
}

.k-p-6\\.5 {
    padding: 1.625rem;
}

.\\!k-p-6\\.5 {
    padding: 1.625rem !important;
}

.k-p-7 {
    padding: 1.75rem;
}

.\\!k-p-7 {
    padding: 1.75rem !important;
}

.k-p-7\\.5 {
    padding: 1.875rem;
}

.\\!k-p-7\\.5 {
    padding: 1.875rem !important;
}

.k-p-8 {
    padding: 2rem;
}

.\\!k-p-8 {
    padding: 2rem !important;
}

.k-p-9 {
    padding: 2.25rem;
}

.\\!k-p-9 {
    padding: 2.25rem !important;
}

.k-p-10 {
    padding: 2.5rem;
}

.\\!k-p-10 {
    padding: 2.5rem !important;
}

.k-p-11 {
    padding: 2.75rem;
}

.\\!k-p-11 {
    padding: 2.75rem !important;
}

.k-p-12 {
    padding: 3rem;
}

.\\!k-p-12 {
    padding: 3rem !important;
}

.k-p-13 {
    padding: 3.25rem;
}

.\\!k-p-13 {
    padding: 3.25rem !important;
}

.k-p-14 {
    padding: 3.5rem;
}

.\\!k-p-14 {
    padding: 3.5rem !important;
}

.k-p-15 {
    padding: 3.75rem;
}

.\\!k-p-15 {
    padding: 3.75rem !important;
}

.k-p-16 {
    padding: 4rem;
}

.\\!k-p-16 {
    padding: 4rem !important;
}

.k-p-17 {
    padding: 4.25rem;
}

.\\!k-p-17 {
    padding: 4.25rem !important;
}

.k-p-18 {
    padding: 4.5rem;
}

.\\!k-p-18 {
    padding: 4.5rem !important;
}

.k-p-19 {
    padding: 4.75rem;
}

.\\!k-p-19 {
    padding: 4.75rem !important;
}

.k-p-20 {
    padding: 5rem;
}

.\\!k-p-20 {
    padding: 5rem !important;
}

.k-p-21 {
    padding: 5.25rem;
}

.\\!k-p-21 {
    padding: 5.25rem !important;
}

.k-p-22 {
    padding: 5.5rem;
}

.\\!k-p-22 {
    padding: 5.5rem !important;
}

.k-p-23 {
    padding: 5.75rem;
}

.\\!k-p-23 {
    padding: 5.75rem !important;
}

.k-p-24 {
    padding: 6rem;
}

.\\!k-p-24 {
    padding: 6rem !important;
}

.k-p-xs {
    padding: 0.25rem;
}

.\\!k-p-xs {
    padding: 0.25rem !important;
}

.k-p-sm {
    padding: 0.5rem;
}

.\\!k-p-sm {
    padding: 0.5rem !important;
}

.k-p-md {
    padding: 0.75rem;
}

.\\!k-p-md {
    padding: 0.75rem !important;
}

.k-p-lg {
    padding: 1rem;
}

.\\!k-p-lg {
    padding: 1rem !important;
}

.k-p-xl {
    padding: 1.5rem;
}

.\\!k-p-xl {
    padding: 1.5rem !important;
}

.k-p-thin {
    padding: 0.125rem;
}

.\\!k-p-thin {
    padding: 0.125rem !important;
}

.k-p-hair {
    padding: 1px;
}

.\\!k-p-hair {
    padding: 1px !important;
}

.k-pt-0 {
    padding-top: 0;
}

.\\!k-pt-0 {
    padding-top: 0 !important;
}

.k-pt-1px {
    padding-top: 1px;
}

.\\!k-pt-1px {
    padding-top: 1px !important;
}

.k-pt-0\\.5 {
    padding-top: 0.125rem;
}

.\\!k-pt-0\\.5 {
    padding-top: 0.125rem !important;
}

.k-pt-1 {
    padding-top: 0.25rem;
}

.\\!k-pt-1 {
    padding-top: 0.25rem !important;
}

.k-pt-1\\.5 {
    padding-top: 0.375rem;
}

.\\!k-pt-1\\.5 {
    padding-top: 0.375rem !important;
}

.k-pt-2 {
    padding-top: 0.5rem;
}

.\\!k-pt-2 {
    padding-top: 0.5rem !important;
}

.k-pt-2\\.5 {
    padding-top: 0.625rem;
}

.\\!k-pt-2\\.5 {
    padding-top: 0.625rem !important;
}

.k-pt-3 {
    padding-top: 0.75rem;
}

.\\!k-pt-3 {
    padding-top: 0.75rem !important;
}

.k-pt-3\\.5 {
    padding-top: 0.875rem;
}

.\\!k-pt-3\\.5 {
    padding-top: 0.875rem !important;
}

.k-pt-4 {
    padding-top: 1rem;
}

.\\!k-pt-4 {
    padding-top: 1rem !important;
}

.k-pt-4\\.5 {
    padding-top: 1.125rem;
}

.\\!k-pt-4\\.5 {
    padding-top: 1.125rem !important;
}

.k-pt-5 {
    padding-top: 1.25rem;
}

.\\!k-pt-5 {
    padding-top: 1.25rem !important;
}

.k-pt-5\\.5 {
    padding-top: 1.375rem;
}

.\\!k-pt-5\\.5 {
    padding-top: 1.375rem !important;
}

.k-pt-6 {
    padding-top: 1.5rem;
}

.\\!k-pt-6 {
    padding-top: 1.5rem !important;
}

.k-pt-6\\.5 {
    padding-top: 1.625rem;
}

.\\!k-pt-6\\.5 {
    padding-top: 1.625rem !important;
}

.k-pt-7 {
    padding-top: 1.75rem;
}

.\\!k-pt-7 {
    padding-top: 1.75rem !important;
}

.k-pt-7\\.5 {
    padding-top: 1.875rem;
}

.\\!k-pt-7\\.5 {
    padding-top: 1.875rem !important;
}

.k-pt-8 {
    padding-top: 2rem;
}

.\\!k-pt-8 {
    padding-top: 2rem !important;
}

.k-pt-9 {
    padding-top: 2.25rem;
}

.\\!k-pt-9 {
    padding-top: 2.25rem !important;
}

.k-pt-10 {
    padding-top: 2.5rem;
}

.\\!k-pt-10 {
    padding-top: 2.5rem !important;
}

.k-pt-11 {
    padding-top: 2.75rem;
}

.\\!k-pt-11 {
    padding-top: 2.75rem !important;
}

.k-pt-12 {
    padding-top: 3rem;
}

.\\!k-pt-12 {
    padding-top: 3rem !important;
}

.k-pt-13 {
    padding-top: 3.25rem;
}

.\\!k-pt-13 {
    padding-top: 3.25rem !important;
}

.k-pt-14 {
    padding-top: 3.5rem;
}

.\\!k-pt-14 {
    padding-top: 3.5rem !important;
}

.k-pt-15 {
    padding-top: 3.75rem;
}

.\\!k-pt-15 {
    padding-top: 3.75rem !important;
}

.k-pt-16 {
    padding-top: 4rem;
}

.\\!k-pt-16 {
    padding-top: 4rem !important;
}

.k-pt-17 {
    padding-top: 4.25rem;
}

.\\!k-pt-17 {
    padding-top: 4.25rem !important;
}

.k-pt-18 {
    padding-top: 4.5rem;
}

.\\!k-pt-18 {
    padding-top: 4.5rem !important;
}

.k-pt-19 {
    padding-top: 4.75rem;
}

.\\!k-pt-19 {
    padding-top: 4.75rem !important;
}

.k-pt-20 {
    padding-top: 5rem;
}

.\\!k-pt-20 {
    padding-top: 5rem !important;
}

.k-pt-21 {
    padding-top: 5.25rem;
}

.\\!k-pt-21 {
    padding-top: 5.25rem !important;
}

.k-pt-22 {
    padding-top: 5.5rem;
}

.\\!k-pt-22 {
    padding-top: 5.5rem !important;
}

.k-pt-23 {
    padding-top: 5.75rem;
}

.\\!k-pt-23 {
    padding-top: 5.75rem !important;
}

.k-pt-24 {
    padding-top: 6rem;
}

.\\!k-pt-24 {
    padding-top: 6rem !important;
}

.k-pt-xs {
    padding-top: 0.25rem;
}

.\\!k-pt-xs {
    padding-top: 0.25rem !important;
}

.k-pt-sm {
    padding-top: 0.5rem;
}

.\\!k-pt-sm {
    padding-top: 0.5rem !important;
}

.k-pt-md {
    padding-top: 0.75rem;
}

.\\!k-pt-md {
    padding-top: 0.75rem !important;
}

.k-pt-lg {
    padding-top: 1rem;
}

.\\!k-pt-lg {
    padding-top: 1rem !important;
}

.k-pt-xl {
    padding-top: 1.5rem;
}

.\\!k-pt-xl {
    padding-top: 1.5rem !important;
}

.k-pt-thin {
    padding-top: 0.125rem;
}

.\\!k-pt-thin {
    padding-top: 0.125rem !important;
}

.k-pt-hair {
    padding-top: 1px;
}

.\\!k-pt-hair {
    padding-top: 1px !important;
}

.k-pr-0 {
    padding-right: 0;
}

.\\!k-pr-0 {
    padding-right: 0 !important;
}

.k-pr-1px {
    padding-right: 1px;
}

.\\!k-pr-1px {
    padding-right: 1px !important;
}

.k-pr-0\\.5 {
    padding-right: 0.125rem;
}

.\\!k-pr-0\\.5 {
    padding-right: 0.125rem !important;
}

.k-pr-1 {
    padding-right: 0.25rem;
}

.\\!k-pr-1 {
    padding-right: 0.25rem !important;
}

.k-pr-1\\.5 {
    padding-right: 0.375rem;
}

.\\!k-pr-1\\.5 {
    padding-right: 0.375rem !important;
}

.k-pr-2 {
    padding-right: 0.5rem;
}

.\\!k-pr-2 {
    padding-right: 0.5rem !important;
}

.k-pr-2\\.5 {
    padding-right: 0.625rem;
}

.\\!k-pr-2\\.5 {
    padding-right: 0.625rem !important;
}

.k-pr-3 {
    padding-right: 0.75rem;
}

.\\!k-pr-3 {
    padding-right: 0.75rem !important;
}

.k-pr-3\\.5 {
    padding-right: 0.875rem;
}

.\\!k-pr-3\\.5 {
    padding-right: 0.875rem !important;
}

.k-pr-4 {
    padding-right: 1rem;
}

.\\!k-pr-4 {
    padding-right: 1rem !important;
}

.k-pr-4\\.5 {
    padding-right: 1.125rem;
}

.\\!k-pr-4\\.5 {
    padding-right: 1.125rem !important;
}

.k-pr-5 {
    padding-right: 1.25rem;
}

.\\!k-pr-5 {
    padding-right: 1.25rem !important;
}

.k-pr-5\\.5 {
    padding-right: 1.375rem;
}

.\\!k-pr-5\\.5 {
    padding-right: 1.375rem !important;
}

.k-pr-6 {
    padding-right: 1.5rem;
}

.\\!k-pr-6 {
    padding-right: 1.5rem !important;
}

.k-pr-6\\.5 {
    padding-right: 1.625rem;
}

.\\!k-pr-6\\.5 {
    padding-right: 1.625rem !important;
}

.k-pr-7 {
    padding-right: 1.75rem;
}

.\\!k-pr-7 {
    padding-right: 1.75rem !important;
}

.k-pr-7\\.5 {
    padding-right: 1.875rem;
}

.\\!k-pr-7\\.5 {
    padding-right: 1.875rem !important;
}

.k-pr-8 {
    padding-right: 2rem;
}

.\\!k-pr-8 {
    padding-right: 2rem !important;
}

.k-pr-9 {
    padding-right: 2.25rem;
}

.\\!k-pr-9 {
    padding-right: 2.25rem !important;
}

.k-pr-10 {
    padding-right: 2.5rem;
}

.\\!k-pr-10 {
    padding-right: 2.5rem !important;
}

.k-pr-11 {
    padding-right: 2.75rem;
}

.\\!k-pr-11 {
    padding-right: 2.75rem !important;
}

.k-pr-12 {
    padding-right: 3rem;
}

.\\!k-pr-12 {
    padding-right: 3rem !important;
}

.k-pr-13 {
    padding-right: 3.25rem;
}

.\\!k-pr-13 {
    padding-right: 3.25rem !important;
}

.k-pr-14 {
    padding-right: 3.5rem;
}

.\\!k-pr-14 {
    padding-right: 3.5rem !important;
}

.k-pr-15 {
    padding-right: 3.75rem;
}

.\\!k-pr-15 {
    padding-right: 3.75rem !important;
}

.k-pr-16 {
    padding-right: 4rem;
}

.\\!k-pr-16 {
    padding-right: 4rem !important;
}

.k-pr-17 {
    padding-right: 4.25rem;
}

.\\!k-pr-17 {
    padding-right: 4.25rem !important;
}

.k-pr-18 {
    padding-right: 4.5rem;
}

.\\!k-pr-18 {
    padding-right: 4.5rem !important;
}

.k-pr-19 {
    padding-right: 4.75rem;
}

.\\!k-pr-19 {
    padding-right: 4.75rem !important;
}

.k-pr-20 {
    padding-right: 5rem;
}

.\\!k-pr-20 {
    padding-right: 5rem !important;
}

.k-pr-21 {
    padding-right: 5.25rem;
}

.\\!k-pr-21 {
    padding-right: 5.25rem !important;
}

.k-pr-22 {
    padding-right: 5.5rem;
}

.\\!k-pr-22 {
    padding-right: 5.5rem !important;
}

.k-pr-23 {
    padding-right: 5.75rem;
}

.\\!k-pr-23 {
    padding-right: 5.75rem !important;
}

.k-pr-24 {
    padding-right: 6rem;
}

.\\!k-pr-24 {
    padding-right: 6rem !important;
}

.k-pr-xs {
    padding-right: 0.25rem;
}

.\\!k-pr-xs {
    padding-right: 0.25rem !important;
}

.k-pr-sm {
    padding-right: 0.5rem;
}

.\\!k-pr-sm {
    padding-right: 0.5rem !important;
}

.k-pr-md {
    padding-right: 0.75rem;
}

.\\!k-pr-md {
    padding-right: 0.75rem !important;
}

.k-pr-lg {
    padding-right: 1rem;
}

.\\!k-pr-lg {
    padding-right: 1rem !important;
}

.k-pr-xl {
    padding-right: 1.5rem;
}

.\\!k-pr-xl {
    padding-right: 1.5rem !important;
}

.k-pr-thin {
    padding-right: 0.125rem;
}

.\\!k-pr-thin {
    padding-right: 0.125rem !important;
}

.k-pr-hair {
    padding-right: 1px;
}

.\\!k-pr-hair {
    padding-right: 1px !important;
}

.k-pb-0 {
    padding-bottom: 0;
}

.\\!k-pb-0 {
    padding-bottom: 0 !important;
}

.k-pb-1px {
    padding-bottom: 1px;
}

.\\!k-pb-1px {
    padding-bottom: 1px !important;
}

.k-pb-0\\.5 {
    padding-bottom: 0.125rem;
}

.\\!k-pb-0\\.5 {
    padding-bottom: 0.125rem !important;
}

.k-pb-1 {
    padding-bottom: 0.25rem;
}

.\\!k-pb-1 {
    padding-bottom: 0.25rem !important;
}

.k-pb-1\\.5 {
    padding-bottom: 0.375rem;
}

.\\!k-pb-1\\.5 {
    padding-bottom: 0.375rem !important;
}

.k-pb-2 {
    padding-bottom: 0.5rem;
}

.\\!k-pb-2 {
    padding-bottom: 0.5rem !important;
}

.k-pb-2\\.5 {
    padding-bottom: 0.625rem;
}

.\\!k-pb-2\\.5 {
    padding-bottom: 0.625rem !important;
}

.k-pb-3 {
    padding-bottom: 0.75rem;
}

.\\!k-pb-3 {
    padding-bottom: 0.75rem !important;
}

.k-pb-3\\.5 {
    padding-bottom: 0.875rem;
}

.\\!k-pb-3\\.5 {
    padding-bottom: 0.875rem !important;
}

.k-pb-4 {
    padding-bottom: 1rem;
}

.\\!k-pb-4 {
    padding-bottom: 1rem !important;
}

.k-pb-4\\.5 {
    padding-bottom: 1.125rem;
}

.\\!k-pb-4\\.5 {
    padding-bottom: 1.125rem !important;
}

.k-pb-5 {
    padding-bottom: 1.25rem;
}

.\\!k-pb-5 {
    padding-bottom: 1.25rem !important;
}

.k-pb-5\\.5 {
    padding-bottom: 1.375rem;
}

.\\!k-pb-5\\.5 {
    padding-bottom: 1.375rem !important;
}

.k-pb-6 {
    padding-bottom: 1.5rem;
}

.\\!k-pb-6 {
    padding-bottom: 1.5rem !important;
}

.k-pb-6\\.5 {
    padding-bottom: 1.625rem;
}

.\\!k-pb-6\\.5 {
    padding-bottom: 1.625rem !important;
}

.k-pb-7 {
    padding-bottom: 1.75rem;
}

.\\!k-pb-7 {
    padding-bottom: 1.75rem !important;
}

.k-pb-7\\.5 {
    padding-bottom: 1.875rem;
}

.\\!k-pb-7\\.5 {
    padding-bottom: 1.875rem !important;
}

.k-pb-8 {
    padding-bottom: 2rem;
}

.\\!k-pb-8 {
    padding-bottom: 2rem !important;
}

.k-pb-9 {
    padding-bottom: 2.25rem;
}

.\\!k-pb-9 {
    padding-bottom: 2.25rem !important;
}

.k-pb-10 {
    padding-bottom: 2.5rem;
}

.\\!k-pb-10 {
    padding-bottom: 2.5rem !important;
}

.k-pb-11 {
    padding-bottom: 2.75rem;
}

.\\!k-pb-11 {
    padding-bottom: 2.75rem !important;
}

.k-pb-12 {
    padding-bottom: 3rem;
}

.\\!k-pb-12 {
    padding-bottom: 3rem !important;
}

.k-pb-13 {
    padding-bottom: 3.25rem;
}

.\\!k-pb-13 {
    padding-bottom: 3.25rem !important;
}

.k-pb-14 {
    padding-bottom: 3.5rem;
}

.\\!k-pb-14 {
    padding-bottom: 3.5rem !important;
}

.k-pb-15 {
    padding-bottom: 3.75rem;
}

.\\!k-pb-15 {
    padding-bottom: 3.75rem !important;
}

.k-pb-16 {
    padding-bottom: 4rem;
}

.\\!k-pb-16 {
    padding-bottom: 4rem !important;
}

.k-pb-17 {
    padding-bottom: 4.25rem;
}

.\\!k-pb-17 {
    padding-bottom: 4.25rem !important;
}

.k-pb-18 {
    padding-bottom: 4.5rem;
}

.\\!k-pb-18 {
    padding-bottom: 4.5rem !important;
}

.k-pb-19 {
    padding-bottom: 4.75rem;
}

.\\!k-pb-19 {
    padding-bottom: 4.75rem !important;
}

.k-pb-20 {
    padding-bottom: 5rem;
}

.\\!k-pb-20 {
    padding-bottom: 5rem !important;
}

.k-pb-21 {
    padding-bottom: 5.25rem;
}

.\\!k-pb-21 {
    padding-bottom: 5.25rem !important;
}

.k-pb-22 {
    padding-bottom: 5.5rem;
}

.\\!k-pb-22 {
    padding-bottom: 5.5rem !important;
}

.k-pb-23 {
    padding-bottom: 5.75rem;
}

.\\!k-pb-23 {
    padding-bottom: 5.75rem !important;
}

.k-pb-24 {
    padding-bottom: 6rem;
}

.\\!k-pb-24 {
    padding-bottom: 6rem !important;
}

.k-pb-xs {
    padding-bottom: 0.25rem;
}

.\\!k-pb-xs {
    padding-bottom: 0.25rem !important;
}

.k-pb-sm {
    padding-bottom: 0.5rem;
}

.\\!k-pb-sm {
    padding-bottom: 0.5rem !important;
}

.k-pb-md {
    padding-bottom: 0.75rem;
}

.\\!k-pb-md {
    padding-bottom: 0.75rem !important;
}

.k-pb-lg {
    padding-bottom: 1rem;
}

.\\!k-pb-lg {
    padding-bottom: 1rem !important;
}

.k-pb-xl {
    padding-bottom: 1.5rem;
}

.\\!k-pb-xl {
    padding-bottom: 1.5rem !important;
}

.k-pb-thin {
    padding-bottom: 0.125rem;
}

.\\!k-pb-thin {
    padding-bottom: 0.125rem !important;
}

.k-pb-hair {
    padding-bottom: 1px;
}

.\\!k-pb-hair {
    padding-bottom: 1px !important;
}

.k-pl-0 {
    padding-left: 0;
}

.\\!k-pl-0 {
    padding-left: 0 !important;
}

.k-pl-1px {
    padding-left: 1px;
}

.\\!k-pl-1px {
    padding-left: 1px !important;
}

.k-pl-0\\.5 {
    padding-left: 0.125rem;
}

.\\!k-pl-0\\.5 {
    padding-left: 0.125rem !important;
}

.k-pl-1 {
    padding-left: 0.25rem;
}

.\\!k-pl-1 {
    padding-left: 0.25rem !important;
}

.k-pl-1\\.5 {
    padding-left: 0.375rem;
}

.\\!k-pl-1\\.5 {
    padding-left: 0.375rem !important;
}

.k-pl-2 {
    padding-left: 0.5rem;
}

.\\!k-pl-2 {
    padding-left: 0.5rem !important;
}

.k-pl-2\\.5 {
    padding-left: 0.625rem;
}

.\\!k-pl-2\\.5 {
    padding-left: 0.625rem !important;
}

.k-pl-3 {
    padding-left: 0.75rem;
}

.\\!k-pl-3 {
    padding-left: 0.75rem !important;
}

.k-pl-3\\.5 {
    padding-left: 0.875rem;
}

.\\!k-pl-3\\.5 {
    padding-left: 0.875rem !important;
}

.k-pl-4 {
    padding-left: 1rem;
}

.\\!k-pl-4 {
    padding-left: 1rem !important;
}

.k-pl-4\\.5 {
    padding-left: 1.125rem;
}

.\\!k-pl-4\\.5 {
    padding-left: 1.125rem !important;
}

.k-pl-5 {
    padding-left: 1.25rem;
}

.\\!k-pl-5 {
    padding-left: 1.25rem !important;
}

.k-pl-5\\.5 {
    padding-left: 1.375rem;
}

.\\!k-pl-5\\.5 {
    padding-left: 1.375rem !important;
}

.k-pl-6 {
    padding-left: 1.5rem;
}

.\\!k-pl-6 {
    padding-left: 1.5rem !important;
}

.k-pl-6\\.5 {
    padding-left: 1.625rem;
}

.\\!k-pl-6\\.5 {
    padding-left: 1.625rem !important;
}

.k-pl-7 {
    padding-left: 1.75rem;
}

.\\!k-pl-7 {
    padding-left: 1.75rem !important;
}

.k-pl-7\\.5 {
    padding-left: 1.875rem;
}

.\\!k-pl-7\\.5 {
    padding-left: 1.875rem !important;
}

.k-pl-8 {
    padding-left: 2rem;
}

.\\!k-pl-8 {
    padding-left: 2rem !important;
}

.k-pl-9 {
    padding-left: 2.25rem;
}

.\\!k-pl-9 {
    padding-left: 2.25rem !important;
}

.k-pl-10 {
    padding-left: 2.5rem;
}

.\\!k-pl-10 {
    padding-left: 2.5rem !important;
}

.k-pl-11 {
    padding-left: 2.75rem;
}

.\\!k-pl-11 {
    padding-left: 2.75rem !important;
}

.k-pl-12 {
    padding-left: 3rem;
}

.\\!k-pl-12 {
    padding-left: 3rem !important;
}

.k-pl-13 {
    padding-left: 3.25rem;
}

.\\!k-pl-13 {
    padding-left: 3.25rem !important;
}

.k-pl-14 {
    padding-left: 3.5rem;
}

.\\!k-pl-14 {
    padding-left: 3.5rem !important;
}

.k-pl-15 {
    padding-left: 3.75rem;
}

.\\!k-pl-15 {
    padding-left: 3.75rem !important;
}

.k-pl-16 {
    padding-left: 4rem;
}

.\\!k-pl-16 {
    padding-left: 4rem !important;
}

.k-pl-17 {
    padding-left: 4.25rem;
}

.\\!k-pl-17 {
    padding-left: 4.25rem !important;
}

.k-pl-18 {
    padding-left: 4.5rem;
}

.\\!k-pl-18 {
    padding-left: 4.5rem !important;
}

.k-pl-19 {
    padding-left: 4.75rem;
}

.\\!k-pl-19 {
    padding-left: 4.75rem !important;
}

.k-pl-20 {
    padding-left: 5rem;
}

.\\!k-pl-20 {
    padding-left: 5rem !important;
}

.k-pl-21 {
    padding-left: 5.25rem;
}

.\\!k-pl-21 {
    padding-left: 5.25rem !important;
}

.k-pl-22 {
    padding-left: 5.5rem;
}

.\\!k-pl-22 {
    padding-left: 5.5rem !important;
}

.k-pl-23 {
    padding-left: 5.75rem;
}

.\\!k-pl-23 {
    padding-left: 5.75rem !important;
}

.k-pl-24 {
    padding-left: 6rem;
}

.\\!k-pl-24 {
    padding-left: 6rem !important;
}

.k-pl-xs {
    padding-left: 0.25rem;
}

.\\!k-pl-xs {
    padding-left: 0.25rem !important;
}

.k-pl-sm {
    padding-left: 0.5rem;
}

.\\!k-pl-sm {
    padding-left: 0.5rem !important;
}

.k-pl-md {
    padding-left: 0.75rem;
}

.\\!k-pl-md {
    padding-left: 0.75rem !important;
}

.k-pl-lg {
    padding-left: 1rem;
}

.\\!k-pl-lg {
    padding-left: 1rem !important;
}

.k-pl-xl {
    padding-left: 1.5rem;
}

.\\!k-pl-xl {
    padding-left: 1.5rem !important;
}

.k-pl-thin {
    padding-left: 0.125rem;
}

.\\!k-pl-thin {
    padding-left: 0.125rem !important;
}

.k-pl-hair {
    padding-left: 1px;
}

.\\!k-pl-hair {
    padding-left: 1px !important;
}

.k-px-0 {
    padding-inline: 0;
}

.\\!k-px-0 {
    padding-inline: 0 !important;
}

.k-px-1px {
    padding-inline: 1px;
}

.\\!k-px-1px {
    padding-inline: 1px !important;
}

.k-px-0\\.5 {
    padding-inline: 0.125rem;
}

.\\!k-px-0\\.5 {
    padding-inline: 0.125rem !important;
}

.k-px-1 {
    padding-inline: 0.25rem;
}

.\\!k-px-1 {
    padding-inline: 0.25rem !important;
}

.k-px-1\\.5 {
    padding-inline: 0.375rem;
}

.\\!k-px-1\\.5 {
    padding-inline: 0.375rem !important;
}

.k-px-2 {
    padding-inline: 0.5rem;
}

.\\!k-px-2 {
    padding-inline: 0.5rem !important;
}

.k-px-2\\.5 {
    padding-inline: 0.625rem;
}

.\\!k-px-2\\.5 {
    padding-inline: 0.625rem !important;
}

.k-px-3 {
    padding-inline: 0.75rem;
}

.\\!k-px-3 {
    padding-inline: 0.75rem !important;
}

.k-px-3\\.5 {
    padding-inline: 0.875rem;
}

.\\!k-px-3\\.5 {
    padding-inline: 0.875rem !important;
}

.k-px-4 {
    padding-inline: 1rem;
}

.\\!k-px-4 {
    padding-inline: 1rem !important;
}

.k-px-4\\.5 {
    padding-inline: 1.125rem;
}

.\\!k-px-4\\.5 {
    padding-inline: 1.125rem !important;
}

.k-px-5 {
    padding-inline: 1.25rem;
}

.\\!k-px-5 {
    padding-inline: 1.25rem !important;
}

.k-px-5\\.5 {
    padding-inline: 1.375rem;
}

.\\!k-px-5\\.5 {
    padding-inline: 1.375rem !important;
}

.k-px-6 {
    padding-inline: 1.5rem;
}

.\\!k-px-6 {
    padding-inline: 1.5rem !important;
}

.k-px-6\\.5 {
    padding-inline: 1.625rem;
}

.\\!k-px-6\\.5 {
    padding-inline: 1.625rem !important;
}

.k-px-7 {
    padding-inline: 1.75rem;
}

.\\!k-px-7 {
    padding-inline: 1.75rem !important;
}

.k-px-7\\.5 {
    padding-inline: 1.875rem;
}

.\\!k-px-7\\.5 {
    padding-inline: 1.875rem !important;
}

.k-px-8 {
    padding-inline: 2rem;
}

.\\!k-px-8 {
    padding-inline: 2rem !important;
}

.k-px-9 {
    padding-inline: 2.25rem;
}

.\\!k-px-9 {
    padding-inline: 2.25rem !important;
}

.k-px-10 {
    padding-inline: 2.5rem;
}

.\\!k-px-10 {
    padding-inline: 2.5rem !important;
}

.k-px-11 {
    padding-inline: 2.75rem;
}

.\\!k-px-11 {
    padding-inline: 2.75rem !important;
}

.k-px-12 {
    padding-inline: 3rem;
}

.\\!k-px-12 {
    padding-inline: 3rem !important;
}

.k-px-13 {
    padding-inline: 3.25rem;
}

.\\!k-px-13 {
    padding-inline: 3.25rem !important;
}

.k-px-14 {
    padding-inline: 3.5rem;
}

.\\!k-px-14 {
    padding-inline: 3.5rem !important;
}

.k-px-15 {
    padding-inline: 3.75rem;
}

.\\!k-px-15 {
    padding-inline: 3.75rem !important;
}

.k-px-16 {
    padding-inline: 4rem;
}

.\\!k-px-16 {
    padding-inline: 4rem !important;
}

.k-px-17 {
    padding-inline: 4.25rem;
}

.\\!k-px-17 {
    padding-inline: 4.25rem !important;
}

.k-px-18 {
    padding-inline: 4.5rem;
}

.\\!k-px-18 {
    padding-inline: 4.5rem !important;
}

.k-px-19 {
    padding-inline: 4.75rem;
}

.\\!k-px-19 {
    padding-inline: 4.75rem !important;
}

.k-px-20 {
    padding-inline: 5rem;
}

.\\!k-px-20 {
    padding-inline: 5rem !important;
}

.k-px-21 {
    padding-inline: 5.25rem;
}

.\\!k-px-21 {
    padding-inline: 5.25rem !important;
}

.k-px-22 {
    padding-inline: 5.5rem;
}

.\\!k-px-22 {
    padding-inline: 5.5rem !important;
}

.k-px-23 {
    padding-inline: 5.75rem;
}

.\\!k-px-23 {
    padding-inline: 5.75rem !important;
}

.k-px-24 {
    padding-inline: 6rem;
}

.\\!k-px-24 {
    padding-inline: 6rem !important;
}

.k-px-xs {
    padding-inline: 0.25rem;
}

.\\!k-px-xs {
    padding-inline: 0.25rem !important;
}

.k-px-sm {
    padding-inline: 0.5rem;
}

.\\!k-px-sm {
    padding-inline: 0.5rem !important;
}

.k-px-md {
    padding-inline: 0.75rem;
}

.\\!k-px-md {
    padding-inline: 0.75rem !important;
}

.k-px-lg {
    padding-inline: 1rem;
}

.\\!k-px-lg {
    padding-inline: 1rem !important;
}

.k-px-xl {
    padding-inline: 1.5rem;
}

.\\!k-px-xl {
    padding-inline: 1.5rem !important;
}

.k-px-thin {
    padding-inline: 0.125rem;
}

.\\!k-px-thin {
    padding-inline: 0.125rem !important;
}

.k-px-hair {
    padding-inline: 1px;
}

.\\!k-px-hair {
    padding-inline: 1px !important;
}

.k-py-0 {
    padding-block: 0;
}

.\\!k-py-0 {
    padding-block: 0 !important;
}

.k-py-1px {
    padding-block: 1px;
}

.\\!k-py-1px {
    padding-block: 1px !important;
}

.k-py-0\\.5 {
    padding-block: 0.125rem;
}

.\\!k-py-0\\.5 {
    padding-block: 0.125rem !important;
}

.k-py-1 {
    padding-block: 0.25rem;
}

.\\!k-py-1 {
    padding-block: 0.25rem !important;
}

.k-py-1\\.5 {
    padding-block: 0.375rem;
}

.\\!k-py-1\\.5 {
    padding-block: 0.375rem !important;
}

.k-py-2 {
    padding-block: 0.5rem;
}

.\\!k-py-2 {
    padding-block: 0.5rem !important;
}

.k-py-2\\.5 {
    padding-block: 0.625rem;
}

.\\!k-py-2\\.5 {
    padding-block: 0.625rem !important;
}

.k-py-3 {
    padding-block: 0.75rem;
}

.\\!k-py-3 {
    padding-block: 0.75rem !important;
}

.k-py-3\\.5 {
    padding-block: 0.875rem;
}

.\\!k-py-3\\.5 {
    padding-block: 0.875rem !important;
}

.k-py-4 {
    padding-block: 1rem;
}

.\\!k-py-4 {
    padding-block: 1rem !important;
}

.k-py-4\\.5 {
    padding-block: 1.125rem;
}

.\\!k-py-4\\.5 {
    padding-block: 1.125rem !important;
}

.k-py-5 {
    padding-block: 1.25rem;
}

.\\!k-py-5 {
    padding-block: 1.25rem !important;
}

.k-py-5\\.5 {
    padding-block: 1.375rem;
}

.\\!k-py-5\\.5 {
    padding-block: 1.375rem !important;
}

.k-py-6 {
    padding-block: 1.5rem;
}

.\\!k-py-6 {
    padding-block: 1.5rem !important;
}

.k-py-6\\.5 {
    padding-block: 1.625rem;
}

.\\!k-py-6\\.5 {
    padding-block: 1.625rem !important;
}

.k-py-7 {
    padding-block: 1.75rem;
}

.\\!k-py-7 {
    padding-block: 1.75rem !important;
}

.k-py-7\\.5 {
    padding-block: 1.875rem;
}

.\\!k-py-7\\.5 {
    padding-block: 1.875rem !important;
}

.k-py-8 {
    padding-block: 2rem;
}

.\\!k-py-8 {
    padding-block: 2rem !important;
}

.k-py-9 {
    padding-block: 2.25rem;
}

.\\!k-py-9 {
    padding-block: 2.25rem !important;
}

.k-py-10 {
    padding-block: 2.5rem;
}

.\\!k-py-10 {
    padding-block: 2.5rem !important;
}

.k-py-11 {
    padding-block: 2.75rem;
}

.\\!k-py-11 {
    padding-block: 2.75rem !important;
}

.k-py-12 {
    padding-block: 3rem;
}

.\\!k-py-12 {
    padding-block: 3rem !important;
}

.k-py-13 {
    padding-block: 3.25rem;
}

.\\!k-py-13 {
    padding-block: 3.25rem !important;
}

.k-py-14 {
    padding-block: 3.5rem;
}

.\\!k-py-14 {
    padding-block: 3.5rem !important;
}

.k-py-15 {
    padding-block: 3.75rem;
}

.\\!k-py-15 {
    padding-block: 3.75rem !important;
}

.k-py-16 {
    padding-block: 4rem;
}

.\\!k-py-16 {
    padding-block: 4rem !important;
}

.k-py-17 {
    padding-block: 4.25rem;
}

.\\!k-py-17 {
    padding-block: 4.25rem !important;
}

.k-py-18 {
    padding-block: 4.5rem;
}

.\\!k-py-18 {
    padding-block: 4.5rem !important;
}

.k-py-19 {
    padding-block: 4.75rem;
}

.\\!k-py-19 {
    padding-block: 4.75rem !important;
}

.k-py-20 {
    padding-block: 5rem;
}

.\\!k-py-20 {
    padding-block: 5rem !important;
}

.k-py-21 {
    padding-block: 5.25rem;
}

.\\!k-py-21 {
    padding-block: 5.25rem !important;
}

.k-py-22 {
    padding-block: 5.5rem;
}

.\\!k-py-22 {
    padding-block: 5.5rem !important;
}

.k-py-23 {
    padding-block: 5.75rem;
}

.\\!k-py-23 {
    padding-block: 5.75rem !important;
}

.k-py-24 {
    padding-block: 6rem;
}

.\\!k-py-24 {
    padding-block: 6rem !important;
}

.k-py-xs {
    padding-block: 0.25rem;
}

.\\!k-py-xs {
    padding-block: 0.25rem !important;
}

.k-py-sm {
    padding-block: 0.5rem;
}

.\\!k-py-sm {
    padding-block: 0.5rem !important;
}

.k-py-md {
    padding-block: 0.75rem;
}

.\\!k-py-md {
    padding-block: 0.75rem !important;
}

.k-py-lg {
    padding-block: 1rem;
}

.\\!k-py-lg {
    padding-block: 1rem !important;
}

.k-py-xl {
    padding-block: 1.5rem;
}

.\\!k-py-xl {
    padding-block: 1.5rem !important;
}

.k-py-thin {
    padding-block: 0.125rem;
}

.\\!k-py-thin {
    padding-block: 0.125rem !important;
}

.k-py-hair {
    padding-block: 1px;
}

.\\!k-py-hair {
    padding-block: 1px !important;
}

.k-h-0 {
    height: 0;
}

.\\!k-h-0 {
    height: 0 !important;
}

.k-h-1px {
    height: 1px;
}

.\\!k-h-1px {
    height: 1px !important;
}

.k-h-0\\.5 {
    height: 0.125rem;
}

.\\!k-h-0\\.5 {
    height: 0.125rem !important;
}

.k-h-1 {
    height: 0.25rem;
}

.\\!k-h-1 {
    height: 0.25rem !important;
}

.k-h-1\\.5 {
    height: 0.375rem;
}

.\\!k-h-1\\.5 {
    height: 0.375rem !important;
}

.k-h-2 {
    height: 0.5rem;
}

.\\!k-h-2 {
    height: 0.5rem !important;
}

.k-h-2\\.5 {
    height: 0.625rem;
}

.\\!k-h-2\\.5 {
    height: 0.625rem !important;
}

.k-h-3 {
    height: 0.75rem;
}

.\\!k-h-3 {
    height: 0.75rem !important;
}

.k-h-3\\.5 {
    height: 0.875rem;
}

.\\!k-h-3\\.5 {
    height: 0.875rem !important;
}

.k-h-4 {
    height: 1rem;
}

.\\!k-h-4 {
    height: 1rem !important;
}

.k-h-4\\.5 {
    height: 1.125rem;
}

.\\!k-h-4\\.5 {
    height: 1.125rem !important;
}

.k-h-5 {
    height: 1.25rem;
}

.\\!k-h-5 {
    height: 1.25rem !important;
}

.k-h-5\\.5 {
    height: 1.375rem;
}

.\\!k-h-5\\.5 {
    height: 1.375rem !important;
}

.k-h-6 {
    height: 1.5rem;
}

.\\!k-h-6 {
    height: 1.5rem !important;
}

.k-h-6\\.5 {
    height: 1.625rem;
}

.\\!k-h-6\\.5 {
    height: 1.625rem !important;
}

.k-h-7 {
    height: 1.75rem;
}

.\\!k-h-7 {
    height: 1.75rem !important;
}

.k-h-7\\.5 {
    height: 1.875rem;
}

.\\!k-h-7\\.5 {
    height: 1.875rem !important;
}

.k-h-8 {
    height: 2rem;
}

.\\!k-h-8 {
    height: 2rem !important;
}

.k-h-9 {
    height: 2.25rem;
}

.\\!k-h-9 {
    height: 2.25rem !important;
}

.k-h-10 {
    height: 2.5rem;
}

.\\!k-h-10 {
    height: 2.5rem !important;
}

.k-h-11 {
    height: 2.75rem;
}

.\\!k-h-11 {
    height: 2.75rem !important;
}

.k-h-12 {
    height: 3rem;
}

.\\!k-h-12 {
    height: 3rem !important;
}

.k-h-13 {
    height: 3.25rem;
}

.\\!k-h-13 {
    height: 3.25rem !important;
}

.k-h-14 {
    height: 3.5rem;
}

.\\!k-h-14 {
    height: 3.5rem !important;
}

.k-h-15 {
    height: 3.75rem;
}

.\\!k-h-15 {
    height: 3.75rem !important;
}

.k-h-16 {
    height: 4rem;
}

.\\!k-h-16 {
    height: 4rem !important;
}

.k-h-17 {
    height: 4.25rem;
}

.\\!k-h-17 {
    height: 4.25rem !important;
}

.k-h-18 {
    height: 4.5rem;
}

.\\!k-h-18 {
    height: 4.5rem !important;
}

.k-h-19 {
    height: 4.75rem;
}

.\\!k-h-19 {
    height: 4.75rem !important;
}

.k-h-20 {
    height: 5rem;
}

.\\!k-h-20 {
    height: 5rem !important;
}

.k-h-21 {
    height: 5.25rem;
}

.\\!k-h-21 {
    height: 5.25rem !important;
}

.k-h-22 {
    height: 5.5rem;
}

.\\!k-h-22 {
    height: 5.5rem !important;
}

.k-h-23 {
    height: 5.75rem;
}

.\\!k-h-23 {
    height: 5.75rem !important;
}

.k-h-24 {
    height: 6rem;
}

.\\!k-h-24 {
    height: 6rem !important;
}

.k-h-auto {
    height: auto;
}

.\\!k-h-auto {
    height: auto !important;
}

.k-h-1\\/2 {
    height: 50%;
}

.\\!k-h-1\\/2 {
    height: 50% !important;
}

.k-h-1\\/3 {
    height: 33.333333%;
}

.\\!k-h-1\\/3 {
    height: 33.333333% !important;
}

.k-h-2\\/3 {
    height: 66.666667%;
}

.\\!k-h-2\\/3 {
    height: 66.666667% !important;
}

.k-h-1\\/4 {
    height: 25%;
}

.\\!k-h-1\\/4 {
    height: 25% !important;
}

.k-h-2\\/4 {
    height: 50%;
}

.\\!k-h-2\\/4 {
    height: 50% !important;
}

.k-h-3\\/4 {
    height: 75%;
}

.\\!k-h-3\\/4 {
    height: 75% !important;
}

.k-h-1\\/5 {
    height: 20%;
}

.\\!k-h-1\\/5 {
    height: 20% !important;
}

.k-h-2\\/5 {
    height: 40%;
}

.\\!k-h-2\\/5 {
    height: 40% !important;
}

.k-h-3\\/5 {
    height: 60%;
}

.\\!k-h-3\\/5 {
    height: 60% !important;
}

.k-h-4\\/5 {
    height: 80%;
}

.\\!k-h-4\\/5 {
    height: 80% !important;
}

.k-h-1\\/6 {
    height: 16.666667%;
}

.\\!k-h-1\\/6 {
    height: 16.666667% !important;
}

.k-h-2\\/6 {
    height: 33.333333%;
}

.\\!k-h-2\\/6 {
    height: 33.333333% !important;
}

.k-h-3\\/6 {
    height: 50%;
}

.\\!k-h-3\\/6 {
    height: 50% !important;
}

.k-h-4\\/6 {
    height: 66.666667%;
}

.\\!k-h-4\\/6 {
    height: 66.666667% !important;
}

.k-h-5\\/6 {
    height: 83.333333%;
}

.\\!k-h-5\\/6 {
    height: 83.333333% !important;
}

.k-h-1\\/12 {
    height: 8.333333%;
}

.\\!k-h-1\\/12 {
    height: 8.333333% !important;
}

.k-h-2\\/12 {
    height: 16.666667%;
}

.\\!k-h-2\\/12 {
    height: 16.666667% !important;
}

.k-h-3\\/12 {
    height: 25%;
}

.\\!k-h-3\\/12 {
    height: 25% !important;
}

.k-h-4\\/12 {
    height: 33.333333%;
}

.\\!k-h-4\\/12 {
    height: 33.333333% !important;
}

.k-h-5\\/12 {
    height: 41.666667%;
}

.\\!k-h-5\\/12 {
    height: 41.666667% !important;
}

.k-h-6\\/12 {
    height: 50%;
}

.\\!k-h-6\\/12 {
    height: 50% !important;
}

.k-h-7\\/12 {
    height: 58.333333%;
}

.\\!k-h-7\\/12 {
    height: 58.333333% !important;
}

.k-h-8\\/12 {
    height: 66.666667%;
}

.\\!k-h-8\\/12 {
    height: 66.666667% !important;
}

.k-h-9\\/12 {
    height: 75%;
}

.\\!k-h-9\\/12 {
    height: 75% !important;
}

.k-h-10\\/12 {
    height: 83.333333%;
}

.\\!k-h-10\\/12 {
    height: 83.333333% !important;
}

.k-h-11\\/12 {
    height: 91.666667%;
}

.\\!k-h-11\\/12 {
    height: 91.666667% !important;
}

.k-h-full {
    height: 100%;
}

.\\!k-h-full {
    height: 100% !important;
}

.k-h-min {
    height: min-content;
}

.\\!k-h-min {
    height: min-content !important;
}

.k-h-max {
    height: max-content;
}

.\\!k-h-max {
    height: max-content !important;
}

.k-h-fit {
    height: -moz-fit-content;
    height: fit-content;
}

.\\!k-h-fit {
    height: -moz-fit-content !important;
    height: fit-content !important;
}

.k-h-screen {
    height: 100vh;
}

.\\!k-h-screen {
    height: 100vh !important;
}

.k-min-h-0 {
    min-height: 0;
}

.\\!k-min-h-0 {
    min-height: 0 !important;
}

.k-min-h-full {
    min-height: 100%;
}

.\\!k-min-h-full {
    min-height: 100% !important;
}

.k-min-h-screen {
    min-height: 100vh;
}

.\\!k-min-h-screen {
    min-height: 100vh !important;
}

.k-min-h-min {
    min-height: min-content;
}

.\\!k-min-h-min {
    min-height: min-content !important;
}

.k-min-h-max {
    min-height: max-content;
}

.\\!k-min-h-max {
    min-height: max-content !important;
}

.k-min-h-fit {
    min-height: -moz-fit-content;
    min-height: fit-content;
}

.\\!k-min-h-fit {
    min-height: -moz-fit-content !important;
    min-height: fit-content !important;
}

.k-max-h-none {
    max-height: none;
}

.\\!k-max-h-none {
    max-height: none !important;
}

.k-max-h-0 {
    max-height: 0;
}

.\\!k-max-h-0 {
    max-height: 0 !important;
}

.k-max-h-full {
    max-height: 100%;
}

.\\!k-max-h-full {
    max-height: 100% !important;
}

.k-max-h-screen {
    max-height: 100vh;
}

.\\!k-max-h-screen {
    max-height: 100vh !important;
}

.k-max-h-min {
    max-height: min-content;
}

.\\!k-max-h-min {
    max-height: min-content !important;
}

.k-max-h-max {
    max-height: max-content;
}

.\\!k-max-h-max {
    max-height: max-content !important;
}

.k-max-h-fit {
    max-height: -moz-fit-content;
    max-height: fit-content;
}

.\\!k-max-h-fit {
    max-height: -moz-fit-content !important;
    max-height: fit-content !important;
}

.k-w-0 {
    width: 0;
}

.\\!k-w-0 {
    width: 0 !important;
}

.k-w-1px {
    width: 1px;
}

.\\!k-w-1px {
    width: 1px !important;
}

.k-w-0\\.5 {
    width: 0.125rem;
}

.\\!k-w-0\\.5 {
    width: 0.125rem !important;
}

.k-w-1 {
    width: 0.25rem;
}

.\\!k-w-1 {
    width: 0.25rem !important;
}

.k-w-1\\.5 {
    width: 0.375rem;
}

.\\!k-w-1\\.5 {
    width: 0.375rem !important;
}

.k-w-2 {
    width: 0.5rem;
}

.\\!k-w-2 {
    width: 0.5rem !important;
}

.k-w-2\\.5 {
    width: 0.625rem;
}

.\\!k-w-2\\.5 {
    width: 0.625rem !important;
}

.k-w-3 {
    width: 0.75rem;
}

.\\!k-w-3 {
    width: 0.75rem !important;
}

.k-w-3\\.5 {
    width: 0.875rem;
}

.\\!k-w-3\\.5 {
    width: 0.875rem !important;
}

.k-w-4 {
    width: 1rem;
}

.\\!k-w-4 {
    width: 1rem !important;
}

.k-w-4\\.5 {
    width: 1.125rem;
}

.\\!k-w-4\\.5 {
    width: 1.125rem !important;
}

.k-w-5 {
    width: 1.25rem;
}

.\\!k-w-5 {
    width: 1.25rem !important;
}

.k-w-5\\.5 {
    width: 1.375rem;
}

.\\!k-w-5\\.5 {
    width: 1.375rem !important;
}

.k-w-6 {
    width: 1.5rem;
}

.\\!k-w-6 {
    width: 1.5rem !important;
}

.k-w-6\\.5 {
    width: 1.625rem;
}

.\\!k-w-6\\.5 {
    width: 1.625rem !important;
}

.k-w-7 {
    width: 1.75rem;
}

.\\!k-w-7 {
    width: 1.75rem !important;
}

.k-w-7\\.5 {
    width: 1.875rem;
}

.\\!k-w-7\\.5 {
    width: 1.875rem !important;
}

.k-w-8 {
    width: 2rem;
}

.\\!k-w-8 {
    width: 2rem !important;
}

.k-w-9 {
    width: 2.25rem;
}

.\\!k-w-9 {
    width: 2.25rem !important;
}

.k-w-10 {
    width: 2.5rem;
}

.\\!k-w-10 {
    width: 2.5rem !important;
}

.k-w-11 {
    width: 2.75rem;
}

.\\!k-w-11 {
    width: 2.75rem !important;
}

.k-w-12 {
    width: 3rem;
}

.\\!k-w-12 {
    width: 3rem !important;
}

.k-w-13 {
    width: 3.25rem;
}

.\\!k-w-13 {
    width: 3.25rem !important;
}

.k-w-14 {
    width: 3.5rem;
}

.\\!k-w-14 {
    width: 3.5rem !important;
}

.k-w-15 {
    width: 3.75rem;
}

.\\!k-w-15 {
    width: 3.75rem !important;
}

.k-w-16 {
    width: 4rem;
}

.\\!k-w-16 {
    width: 4rem !important;
}

.k-w-17 {
    width: 4.25rem;
}

.\\!k-w-17 {
    width: 4.25rem !important;
}

.k-w-18 {
    width: 4.5rem;
}

.\\!k-w-18 {
    width: 4.5rem !important;
}

.k-w-19 {
    width: 4.75rem;
}

.\\!k-w-19 {
    width: 4.75rem !important;
}

.k-w-20 {
    width: 5rem;
}

.\\!k-w-20 {
    width: 5rem !important;
}

.k-w-21 {
    width: 5.25rem;
}

.\\!k-w-21 {
    width: 5.25rem !important;
}

.k-w-22 {
    width: 5.5rem;
}

.\\!k-w-22 {
    width: 5.5rem !important;
}

.k-w-23 {
    width: 5.75rem;
}

.\\!k-w-23 {
    width: 5.75rem !important;
}

.k-w-24 {
    width: 6rem;
}

.\\!k-w-24 {
    width: 6rem !important;
}

.k-w-auto {
    width: auto;
}

.\\!k-w-auto {
    width: auto !important;
}

.k-w-1\\/2 {
    width: 50%;
}

.\\!k-w-1\\/2 {
    width: 50% !important;
}

.k-w-1\\/3 {
    width: 33.333333%;
}

.\\!k-w-1\\/3 {
    width: 33.333333% !important;
}

.k-w-2\\/3 {
    width: 66.666667%;
}

.\\!k-w-2\\/3 {
    width: 66.666667% !important;
}

.k-w-1\\/4 {
    width: 25%;
}

.\\!k-w-1\\/4 {
    width: 25% !important;
}

.k-w-2\\/4 {
    width: 50%;
}

.\\!k-w-2\\/4 {
    width: 50% !important;
}

.k-w-3\\/4 {
    width: 75%;
}

.\\!k-w-3\\/4 {
    width: 75% !important;
}

.k-w-1\\/5 {
    width: 20%;
}

.\\!k-w-1\\/5 {
    width: 20% !important;
}

.k-w-2\\/5 {
    width: 40%;
}

.\\!k-w-2\\/5 {
    width: 40% !important;
}

.k-w-3\\/5 {
    width: 60%;
}

.\\!k-w-3\\/5 {
    width: 60% !important;
}

.k-w-4\\/5 {
    width: 80%;
}

.\\!k-w-4\\/5 {
    width: 80% !important;
}

.k-w-1\\/6 {
    width: 16.666667%;
}

.\\!k-w-1\\/6 {
    width: 16.666667% !important;
}

.k-w-2\\/6 {
    width: 33.333333%;
}

.\\!k-w-2\\/6 {
    width: 33.333333% !important;
}

.k-w-3\\/6 {
    width: 50%;
}

.\\!k-w-3\\/6 {
    width: 50% !important;
}

.k-w-4\\/6 {
    width: 66.666667%;
}

.\\!k-w-4\\/6 {
    width: 66.666667% !important;
}

.k-w-5\\/6 {
    width: 83.333333%;
}

.\\!k-w-5\\/6 {
    width: 83.333333% !important;
}

.k-w-1\\/12 {
    width: 8.333333%;
}

.\\!k-w-1\\/12 {
    width: 8.333333% !important;
}

.k-w-2\\/12 {
    width: 16.666667%;
}

.\\!k-w-2\\/12 {
    width: 16.666667% !important;
}

.k-w-3\\/12 {
    width: 25%;
}

.\\!k-w-3\\/12 {
    width: 25% !important;
}

.k-w-4\\/12 {
    width: 33.333333%;
}

.\\!k-w-4\\/12 {
    width: 33.333333% !important;
}

.k-w-5\\/12 {
    width: 41.666667%;
}

.\\!k-w-5\\/12 {
    width: 41.666667% !important;
}

.k-w-6\\/12 {
    width: 50%;
}

.\\!k-w-6\\/12 {
    width: 50% !important;
}

.k-w-7\\/12 {
    width: 58.333333%;
}

.\\!k-w-7\\/12 {
    width: 58.333333% !important;
}

.k-w-8\\/12 {
    width: 66.666667%;
}

.\\!k-w-8\\/12 {
    width: 66.666667% !important;
}

.k-w-9\\/12 {
    width: 75%;
}

.\\!k-w-9\\/12 {
    width: 75% !important;
}

.k-w-10\\/12 {
    width: 83.333333%;
}

.\\!k-w-10\\/12 {
    width: 83.333333% !important;
}

.k-w-11\\/12 {
    width: 91.666667%;
}

.\\!k-w-11\\/12 {
    width: 91.666667% !important;
}

.k-w-full {
    width: 100%;
}

.\\!k-w-full {
    width: 100% !important;
}

.k-w-min {
    width: min-content;
}

.\\!k-w-min {
    width: min-content !important;
}

.k-w-max {
    width: max-content;
}

.\\!k-w-max {
    width: max-content !important;
}

.k-w-fit {
    width: -moz-fit-content;
    width: fit-content;
}

.\\!k-w-fit {
    width: -moz-fit-content !important;
    width: fit-content !important;
}

.k-w-screen {
    width: 100vw;
}

.\\!k-w-screen {
    width: 100vw !important;
}

.k-min-w-0 {
    min-width: 0;
}

.\\!k-min-w-0 {
    min-width: 0 !important;
}

.k-min-w-full {
    min-width: 100%;
}

.\\!k-min-w-full {
    min-width: 100% !important;
}

.k-min-w-screen {
    min-width: 100vw;
}

.\\!k-min-w-screen {
    min-width: 100vw !important;
}

.k-min-w-min {
    min-width: min-content;
}

.\\!k-min-w-min {
    min-width: min-content !important;
}

.k-min-w-max {
    min-width: max-content;
}

.\\!k-min-w-max {
    min-width: max-content !important;
}

.k-min-w-fit {
    min-width: -moz-fit-content;
    min-width: fit-content;
}

.\\!k-min-w-fit {
    min-width: -moz-fit-content !important;
    min-width: fit-content !important;
}

.k-max-w-none {
    max-width: none;
}

.\\!k-max-w-none {
    max-width: none !important;
}

.k-max-w-0 {
    max-width: 0;
}

.\\!k-max-w-0 {
    max-width: 0 !important;
}

.k-max-w-full {
    max-width: 100%;
}

.\\!k-max-w-full {
    max-width: 100% !important;
}

.k-max-w-screen {
    max-width: 100vw;
}

.\\!k-max-w-screen {
    max-width: 100vw !important;
}

.k-max-w-min {
    max-width: min-content;
}

.\\!k-max-w-min {
    max-width: min-content !important;
}

.k-max-w-max {
    max-width: max-content;
}

.\\!k-max-w-max {
    max-width: max-content !important;
}

.k-max-w-fit {
    max-width: -moz-fit-content;
    max-width: fit-content;
}

.\\!k-max-w-fit {
    max-width: -moz-fit-content !important;
    max-width: fit-content !important;
}

.k-font-size-xs {
    font-size: 0.75rem;
}

.\\!k-font-size-xs {
    font-size: 0.75rem !important;
}

.k-font-size-sm {
    font-size: 0.875rem;
}

.\\!k-font-size-sm {
    font-size: 0.875rem !important;
}

.k-font-size-md {
    font-size: 1rem;
}

.\\!k-font-size-md {
    font-size: 1rem !important;
}

.k-font-size-lg {
    font-size: 1.25rem;
}

.\\!k-font-size-lg {
    font-size: 1.25rem !important;
}

.k-font-size-xl {
    font-size: 1.5rem;
}

.\\!k-font-size-xl {
    font-size: 1.5rem !important;
}

.k-fs-xs {
    font-size: 0.75rem;
}

.\\!k-fs-xs {
    font-size: 0.75rem !important;
}

.k-fs-sm {
    font-size: 0.875rem;
}

.\\!k-fs-sm {
    font-size: 0.875rem !important;
}

.k-fs-md {
    font-size: 1rem;
}

.\\!k-fs-md {
    font-size: 1rem !important;
}

.k-fs-lg {
    font-size: 1.25rem;
}

.\\!k-fs-lg {
    font-size: 1.25rem !important;
}

.k-fs-xl {
    font-size: 1.5rem;
}

.\\!k-fs-xl {
    font-size: 1.5rem !important;
}

.k-font-italic {
    font-style: italic;
}

.\\!k-font-italic {
    font-style: italic !important;
}

.k-font-non-italic {
    font-style: normal;
}

.\\!k-font-non-italic {
    font-style: normal !important;
}

.k-font-thin {
    font-weight: 100;
}

.\\!k-font-thin {
    font-weight: 100 !important;
}

.k-font-extralight {
    font-weight: 200;
}

.\\!k-font-extralight {
    font-weight: 200 !important;
}

.k-font-light {
    font-weight: 300;
}

.\\!k-font-light {
    font-weight: 300 !important;
}

.k-font-normal {
    font-weight: 400;
}

.\\!k-font-normal {
    font-weight: 400 !important;
}

.k-font-medium {
    font-weight: 500;
}

.\\!k-font-medium {
    font-weight: 500 !important;
}

.k-font-semibold {
    font-weight: 600;
}

.\\!k-font-semibold {
    font-weight: 600 !important;
}

.k-font-bold {
    font-weight: 700;
}

.\\!k-font-bold {
    font-weight: 700 !important;
}

.k-font-extrabold {
    font-weight: 800;
}

.\\!k-font-extrabold {
    font-weight: 800 !important;
}

.k-font-black {
    font-weight: 900;
}

.\\!k-font-black {
    font-weight: 900 !important;
}

.k-font-weight-thin {
    font-weight: 100;
}

.\\!k-font-weight-thin {
    font-weight: 100 !important;
}

.k-font-weight-extralight {
    font-weight: 200;
}

.\\!k-font-weight-extralight {
    font-weight: 200 !important;
}

.k-font-weight-light {
    font-weight: 300;
}

.\\!k-font-weight-light {
    font-weight: 300 !important;
}

.k-font-weight-normal {
    font-weight: 400;
}

.\\!k-font-weight-normal {
    font-weight: 400 !important;
}

.k-font-weight-medium {
    font-weight: 500;
}

.\\!k-font-weight-medium {
    font-weight: 500 !important;
}

.k-font-weight-semibold {
    font-weight: 600;
}

.\\!k-font-weight-semibold {
    font-weight: 600 !important;
}

.k-font-weight-bold {
    font-weight: 700;
}

.\\!k-font-weight-bold {
    font-weight: 700 !important;
}

.k-font-weight-extrabold {
    font-weight: 800;
}

.\\!k-font-weight-extrabold {
    font-weight: 800 !important;
}

.k-font-weight-black {
    font-weight: 900;
}

.\\!k-font-weight-black {
    font-weight: 900 !important;
}

.k-list-none {
    list-style-type: none;
}

.\\!k-list-none {
    list-style-type: none !important;
}

.k-list-disc {
    list-style-type: disc;
}

.\\!k-list-disc {
    list-style-type: disc !important;
}

.k-list-decimal {
    list-style-type: decimal;
}

.\\!k-list-decimal {
    list-style-type: decimal !important;
}

.k-text-left {
    text-align: left;
}

.\\!k-text-left {
    text-align: left !important;
}

.k-text-right {
    text-align: right;
}

.\\!k-text-right {
    text-align: right !important;
}

.k-text-center {
    text-align: center;
}

.\\!k-text-center {
    text-align: center !important;
}

.k-text-justify {
    text-align: justify;
}

.\\!k-text-justify {
    text-align: justify !important;
}

.k-text-start {
    text-align: start;
}

.\\!k-text-start {
    text-align: start !important;
}

.k-text-end {
    text-align: end;
}

.\\!k-text-end {
    text-align: end !important;
}

.k-text-primary {
    color: #0d6efd;
}

.\\!k-text-primary {
    color: #0d6efd !important;
}

.k-text-secondary {
    color: #6c757d;
}

.\\!k-text-secondary {
    color: #6c757d !important;
}

.k-text-tertiary {
    color: #6f42c1;
}

.\\!k-text-tertiary {
    color: #6f42c1 !important;
}

.k-text-info {
    color: #0dcaf0;
}

.\\!k-text-info {
    color: #0dcaf0 !important;
}

.k-text-success {
    color: #198754;
}

.\\!k-text-success {
    color: #198754 !important;
}

.k-text-warning {
    color: #ffc107;
}

.\\!k-text-warning {
    color: #ffc107 !important;
}

.k-text-error {
    color: #dc3545;
}

.\\!k-text-error {
    color: #dc3545 !important;
}

.k-text-dark {
    color: #212529;
}

.\\!k-text-dark {
    color: #212529 !important;
}

.k-text-light {
    color: #f8f9fa;
}

.\\!k-text-light {
    color: #f8f9fa !important;
}

.k-text-inverse {
    color: #212529;
}

.\\!k-text-inverse {
    color: #212529 !important;
}

.k-text-inherit {
    color: inherit;
}

.\\!k-text-inherit {
    color: inherit !important;
}

.k-text-current {
    color: currentColor;
}

.\\!k-text-current {
    color: currentColor !important;
}

.k-text-transparent {
    color: transparent;
}

.\\!k-text-transparent {
    color: transparent !important;
}

.k-text-black {
    color: black;
}

.\\!k-text-black {
    color: black !important;
}

.k-text-white {
    color: white;
}

.\\!k-text-white {
    color: white !important;
}

.k-color-primary {
    color: #0d6efd;
}

.\\!k-color-primary {
    color: #0d6efd !important;
}

.k-color-secondary {
    color: #6c757d;
}

.\\!k-color-secondary {
    color: #6c757d !important;
}

.k-color-tertiary {
    color: #6f42c1;
}

.\\!k-color-tertiary {
    color: #6f42c1 !important;
}

.k-color-info {
    color: #0dcaf0;
}

.\\!k-color-info {
    color: #0dcaf0 !important;
}

.k-color-success {
    color: #198754;
}

.\\!k-color-success {
    color: #198754 !important;
}

.k-color-warning {
    color: #ffc107;
}

.\\!k-color-warning {
    color: #ffc107 !important;
}

.k-color-error {
    color: #dc3545;
}

.\\!k-color-error {
    color: #dc3545 !important;
}

.k-color-dark {
    color: #212529;
}

.\\!k-color-dark {
    color: #212529 !important;
}

.k-color-light {
    color: #f8f9fa;
}

.\\!k-color-light {
    color: #f8f9fa !important;
}

.k-color-inverse {
    color: #212529;
}

.\\!k-color-inverse {
    color: #212529 !important;
}

.k-color-inherit {
    color: inherit;
}

.\\!k-color-inherit {
    color: inherit !important;
}

.k-color-current {
    color: currentColor;
}

.\\!k-color-current {
    color: currentColor !important;
}

.k-color-transparent {
    color: transparent;
}

.\\!k-color-transparent {
    color: transparent !important;
}

.k-color-black {
    color: black;
}

.\\!k-color-black {
    color: black !important;
}

.k-color-white {
    color: white;
}

.\\!k-color-white {
    color: white !important;
}

.k-text-underline {
    text-decoration: underline;
}

.\\!k-text-underline {
    text-decoration: underline !important;
}

.k-text-overline {
    text-decoration: overline;
}

.\\!k-text-overline {
    text-decoration: overline !important;
}

.k-text-line-through {
    text-decoration: line-through;
}

.\\!k-text-line-through {
    text-decoration: line-through !important;
}

.k-text-no-underline {
    text-decoration: none;
}

.\\!k-text-no-underline {
    text-decoration: none !important;
}

.k-text-clip {
    text-overflow: clip;
}

.\\!k-text-clip {
    text-overflow: clip !important;
}

.k-text-ellipsis {
    text-overflow: ellipsis;
}

.\\!k-text-ellipsis {
    text-overflow: ellipsis !important;
}

.k-text-truncate, .k-text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.\\!k-text-truncate, .\\!k-text-ellipsis {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
}

.k-text-uppercase {
    text-transform: uppercase;
}

.\\!k-text-uppercase {
    text-transform: uppercase !important;
}

.k-text-lowercase {
    text-transform: lowercase;
}

.\\!k-text-lowercase {
    text-transform: lowercase !important;
}

.k-text-capitalize {
    text-transform: capitalize;
}

.\\!k-text-capitalize {
    text-transform: capitalize !important;
}

.k-text-normal-case {
    text-transform: none;
}

.\\!k-text-normal-case {
    text-transform: none !important;
}

.k-align-baseline {
    vertical-align: baseline;
}

.\\!k-align-baseline {
    vertical-align: baseline !important;
}

.k-align-top {
    vertical-align: top;
}

.\\!k-align-top {
    vertical-align: top !important;
}

.k-align-middle {
    vertical-align: middle;
}

.\\!k-align-middle {
    vertical-align: middle !important;
}

.k-align-bottom {
    vertical-align: bottom;
}

.\\!k-align-bottom {
    vertical-align: bottom !important;
}

.k-align-text-top {
    vertical-align: text-top;
}

.\\!k-align-text-top {
    vertical-align: text-top !important;
}

.k-align-text-bottom {
    vertical-align: text-bottom;
}

.\\!k-align-text-bottom {
    vertical-align: text-bottom !important;
}

.k-align-sub {
    vertical-align: sub;
}

.\\!k-align-sub {
    vertical-align: sub !important;
}

.k-align-super {
    vertical-align: super;
}

.\\!k-align-super {
    vertical-align: super !important;
}

.k-white-space-normal {
    white-space: normal;
}

.\\!k-white-space-normal {
    white-space: normal !important;
}

.k-white-space-nowrap, .k-text-nowrap {
    white-space: nowrap;
}

.\\!k-white-space-nowrap {
    white-space: nowrap !important;
}

.k-white-space-pre {
    white-space: pre;
}

.\\!k-white-space-pre {
    white-space: pre !important;
}

.k-white-space-pre-line {
    white-space: pre-line;
}

.\\!k-white-space-pre-line {
    white-space: pre-line !important;
}

.k-white-space-pre-wrap {
    white-space: pre-wrap;
}

.\\!k-white-space-pre-wrap {
    white-space: pre-wrap !important;
}

.k-white-space-break-spaces {
    white-space: break-spaces;
}

.\\!k-white-space-break-spaces {
    white-space: break-spaces !important;
}

.k-whitespace-normal {
    white-space: normal;
}

.\\!k-whitespace-normal {
    white-space: normal !important;
}

.k-whitespace-nowrap {
    white-space: nowrap;
}

.\\!k-whitespace-nowrap {
    white-space: nowrap !important;
}

.k-whitespace-pre {
    white-space: pre;
}

.\\!k-whitespace-pre {
    white-space: pre !important;
}

.k-whitespace-pre-line {
    white-space: pre-line;
}

.\\!k-whitespace-pre-line {
    white-space: pre-line !important;
}

.k-whitespace-pre-wrap {
    white-space: pre-wrap;
}

.\\!k-whitespace-pre-wrap {
    white-space: pre-wrap !important;
}

.k-whitespace-break-spaces {
    white-space: break-spaces;
}

.\\!k-whitespace-break-spaces {
    white-space: break-spaces !important;
}

.k-bg-clip-border {
    background-clip: border-box;
}

.\\!k-bg-clip-border {
    background-clip: border-box !important;
}

.k-bg-clip-padding {
    background-clip: padding-box;
}

.\\!k-bg-clip-padding {
    background-clip: padding-box !important;
}

.k-bg-clip-content {
    background-clip: content-box;
}

.\\!k-bg-clip-content {
    background-clip: content-box !important;
}

.k-bg-clip-text {
    -webkit-background-clip: text;
            background-clip: text;
}

.\\!k-bg-clip-text {
    -webkit-background-clip: text !important;
            background-clip: text !important;
}

.k-bg-primary {
    background-color: #0d6efd;
}

.\\!k-bg-primary {
    background-color: #0d6efd !important;
}

.k-bg-secondary {
    background-color: #6c757d;
}

.\\!k-bg-secondary {
    background-color: #6c757d !important;
}

.k-bg-tertiary {
    background-color: #6f42c1;
}

.\\!k-bg-tertiary {
    background-color: #6f42c1 !important;
}

.k-bg-info {
    background-color: #0dcaf0;
}

.\\!k-bg-info {
    background-color: #0dcaf0 !important;
}

.k-bg-success {
    background-color: #198754;
}

.\\!k-bg-success {
    background-color: #198754 !important;
}

.k-bg-warning {
    background-color: #ffc107;
}

.\\!k-bg-warning {
    background-color: #ffc107 !important;
}

.k-bg-error {
    background-color: #dc3545;
}

.\\!k-bg-error {
    background-color: #dc3545 !important;
}

.k-bg-dark {
    background-color: #212529;
}

.\\!k-bg-dark {
    background-color: #212529 !important;
}

.k-bg-light {
    background-color: #f8f9fa;
}

.\\!k-bg-light {
    background-color: #f8f9fa !important;
}

.k-bg-inverse {
    background-color: #212529;
}

.\\!k-bg-inverse {
    background-color: #212529 !important;
}

.k-bg-inherit {
    background-color: inherit;
}

.\\!k-bg-inherit {
    background-color: inherit !important;
}

.k-bg-transparent {
    background-color: transparent;
}

.\\!k-bg-transparent {
    background-color: transparent !important;
}

.k-bg-black {
    background-color: black;
}

.\\!k-bg-black {
    background-color: black !important;
}

.k-bg-white {
    background-color: white;
}

.\\!k-bg-white {
    background-color: white !important;
}

.k-bg-center {
    background-position: center;
}

.\\!k-bg-center {
    background-position: center !important;
}

.k-bg-top {
    background-position: top;
}

.\\!k-bg-top {
    background-position: top !important;
}

.k-bg-right {
    background-position: right;
}

.\\!k-bg-right {
    background-position: right !important;
}

.k-bg-bottom {
    background-position: bottom;
}

.\\!k-bg-bottom {
    background-position: bottom !important;
}

.k-bg-left {
    background-position: left;
}

.\\!k-bg-left {
    background-position: left !important;
}

.k-bg-top-left {
    background-position: top left;
}

.\\!k-bg-top-left {
    background-position: top left !important;
}

.k-bg-top-right {
    background-position: top right;
}

.\\!k-bg-top-right {
    background-position: top right !important;
}

.k-bg-bottom-left {
    background-position: bottom left;
}

.\\!k-bg-bottom-left {
    background-position: bottom left !important;
}

.k-bg-bottom-right {
    background-position: bottom right;
}

.\\!k-bg-bottom-right {
    background-position: bottom right !important;
}

.k-bg-auto {
    background-size: auto;
}

.\\!k-bg-auto {
    background-size: auto !important;
}

.k-bg-cover {
    background-size: cover;
}

.\\!k-bg-cover {
    background-size: cover !important;
}

.k-bg-contain {
    background-size: contain;
}

.\\!k-bg-contain {
    background-size: contain !important;
}

.k-border-primary {
    border-color: #0d6efd;
}

.\\!k-border-primary {
    border-color: #0d6efd !important;
}

.k-border-secondary {
    border-color: #6c757d;
}

.\\!k-border-secondary {
    border-color: #6c757d !important;
}

.k-border-tertiary {
    border-color: #6f42c1;
}

.\\!k-border-tertiary {
    border-color: #6f42c1 !important;
}

.k-border-info {
    border-color: #0dcaf0;
}

.\\!k-border-info {
    border-color: #0dcaf0 !important;
}

.k-border-success {
    border-color: #198754;
}

.\\!k-border-success {
    border-color: #198754 !important;
}

.k-border-warning {
    border-color: #ffc107;
}

.\\!k-border-warning {
    border-color: #ffc107 !important;
}

.k-border-error {
    border-color: #dc3545;
}

.\\!k-border-error {
    border-color: #dc3545 !important;
}

.k-border-dark {
    border-color: #212529;
}

.\\!k-border-dark {
    border-color: #212529 !important;
}

.k-border-light {
    border-color: #f8f9fa;
}

.\\!k-border-light {
    border-color: #f8f9fa !important;
}

.k-border-inverse {
    border-color: #212529;
}

.\\!k-border-inverse {
    border-color: #212529 !important;
}

.k-border-inherit {
    border-color: inherit;
}

.\\!k-border-inherit {
    border-color: inherit !important;
}

.k-border-current {
    border-color: currentColor;
}

.\\!k-border-current {
    border-color: currentColor !important;
}

.k-border-transparent {
    border-color: transparent;
}

.\\!k-border-transparent {
    border-color: transparent !important;
}

.k-border-black {
    border-color: black;
}

.\\!k-border-black {
    border-color: black !important;
}

.k-border-white {
    border-color: white;
}

.\\!k-border-white {
    border-color: white !important;
}

.k-border-t-primary {
    border-top-color: #0d6efd;
}

.\\!k-border-t-primary {
    border-top-color: #0d6efd !important;
}

.k-border-t-secondary {
    border-top-color: #6c757d;
}

.\\!k-border-t-secondary {
    border-top-color: #6c757d !important;
}

.k-border-t-tertiary {
    border-top-color: #6f42c1;
}

.\\!k-border-t-tertiary {
    border-top-color: #6f42c1 !important;
}

.k-border-t-info {
    border-top-color: #0dcaf0;
}

.\\!k-border-t-info {
    border-top-color: #0dcaf0 !important;
}

.k-border-t-success {
    border-top-color: #198754;
}

.\\!k-border-t-success {
    border-top-color: #198754 !important;
}

.k-border-t-warning {
    border-top-color: #ffc107;
}

.\\!k-border-t-warning {
    border-top-color: #ffc107 !important;
}

.k-border-t-error {
    border-top-color: #dc3545;
}

.\\!k-border-t-error {
    border-top-color: #dc3545 !important;
}

.k-border-t-dark {
    border-top-color: #212529;
}

.\\!k-border-t-dark {
    border-top-color: #212529 !important;
}

.k-border-t-light {
    border-top-color: #f8f9fa;
}

.\\!k-border-t-light {
    border-top-color: #f8f9fa !important;
}

.k-border-t-inverse {
    border-top-color: #212529;
}

.\\!k-border-t-inverse {
    border-top-color: #212529 !important;
}

.k-border-t-inherit {
    border-top-color: inherit;
}

.\\!k-border-t-inherit {
    border-top-color: inherit !important;
}

.k-border-t-current {
    border-top-color: currentColor;
}

.\\!k-border-t-current {
    border-top-color: currentColor !important;
}

.k-border-t-transparent {
    border-top-color: transparent;
}

.\\!k-border-t-transparent {
    border-top-color: transparent !important;
}

.k-border-t-black {
    border-top-color: black;
}

.\\!k-border-t-black {
    border-top-color: black !important;
}

.k-border-t-white {
    border-top-color: white;
}

.\\!k-border-t-white {
    border-top-color: white !important;
}

.k-border-r-primary {
    border-right-color: #0d6efd;
}

.\\!k-border-r-primary {
    border-right-color: #0d6efd !important;
}

.k-border-r-secondary {
    border-right-color: #6c757d;
}

.\\!k-border-r-secondary {
    border-right-color: #6c757d !important;
}

.k-border-r-tertiary {
    border-right-color: #6f42c1;
}

.\\!k-border-r-tertiary {
    border-right-color: #6f42c1 !important;
}

.k-border-r-info {
    border-right-color: #0dcaf0;
}

.\\!k-border-r-info {
    border-right-color: #0dcaf0 !important;
}

.k-border-r-success {
    border-right-color: #198754;
}

.\\!k-border-r-success {
    border-right-color: #198754 !important;
}

.k-border-r-warning {
    border-right-color: #ffc107;
}

.\\!k-border-r-warning {
    border-right-color: #ffc107 !important;
}

.k-border-r-error {
    border-right-color: #dc3545;
}

.\\!k-border-r-error {
    border-right-color: #dc3545 !important;
}

.k-border-r-dark {
    border-right-color: #212529;
}

.\\!k-border-r-dark {
    border-right-color: #212529 !important;
}

.k-border-r-light {
    border-right-color: #f8f9fa;
}

.\\!k-border-r-light {
    border-right-color: #f8f9fa !important;
}

.k-border-r-inverse {
    border-right-color: #212529;
}

.\\!k-border-r-inverse {
    border-right-color: #212529 !important;
}

.k-border-r-inherit {
    border-right-color: inherit;
}

.\\!k-border-r-inherit {
    border-right-color: inherit !important;
}

.k-border-r-current {
    border-right-color: currentColor;
}

.\\!k-border-r-current {
    border-right-color: currentColor !important;
}

.k-border-r-transparent {
    border-right-color: transparent;
}

.\\!k-border-r-transparent {
    border-right-color: transparent !important;
}

.k-border-r-black {
    border-right-color: black;
}

.\\!k-border-r-black {
    border-right-color: black !important;
}

.k-border-r-white {
    border-right-color: white;
}

.\\!k-border-r-white {
    border-right-color: white !important;
}

.k-border-b-primary {
    border-bottom-color: #0d6efd;
}

.\\!k-border-b-primary {
    border-bottom-color: #0d6efd !important;
}

.k-border-b-secondary {
    border-bottom-color: #6c757d;
}

.\\!k-border-b-secondary {
    border-bottom-color: #6c757d !important;
}

.k-border-b-tertiary {
    border-bottom-color: #6f42c1;
}

.\\!k-border-b-tertiary {
    border-bottom-color: #6f42c1 !important;
}

.k-border-b-info {
    border-bottom-color: #0dcaf0;
}

.\\!k-border-b-info {
    border-bottom-color: #0dcaf0 !important;
}

.k-border-b-success {
    border-bottom-color: #198754;
}

.\\!k-border-b-success {
    border-bottom-color: #198754 !important;
}

.k-border-b-warning {
    border-bottom-color: #ffc107;
}

.\\!k-border-b-warning {
    border-bottom-color: #ffc107 !important;
}

.k-border-b-error {
    border-bottom-color: #dc3545;
}

.\\!k-border-b-error {
    border-bottom-color: #dc3545 !important;
}

.k-border-b-dark {
    border-bottom-color: #212529;
}

.\\!k-border-b-dark {
    border-bottom-color: #212529 !important;
}

.k-border-b-light {
    border-bottom-color: #f8f9fa;
}

.\\!k-border-b-light {
    border-bottom-color: #f8f9fa !important;
}

.k-border-b-inverse {
    border-bottom-color: #212529;
}

.\\!k-border-b-inverse {
    border-bottom-color: #212529 !important;
}

.k-border-b-inherit {
    border-bottom-color: inherit;
}

.\\!k-border-b-inherit {
    border-bottom-color: inherit !important;
}

.k-border-b-current {
    border-bottom-color: currentColor;
}

.\\!k-border-b-current {
    border-bottom-color: currentColor !important;
}

.k-border-b-transparent {
    border-bottom-color: transparent;
}

.\\!k-border-b-transparent {
    border-bottom-color: transparent !important;
}

.k-border-b-black {
    border-bottom-color: black;
}

.\\!k-border-b-black {
    border-bottom-color: black !important;
}

.k-border-b-white {
    border-bottom-color: white;
}

.\\!k-border-b-white {
    border-bottom-color: white !important;
}

.k-border-l-primary {
    border-left-color: #0d6efd;
}

.\\!k-border-l-primary {
    border-left-color: #0d6efd !important;
}

.k-border-l-secondary {
    border-left-color: #6c757d;
}

.\\!k-border-l-secondary {
    border-left-color: #6c757d !important;
}

.k-border-l-tertiary {
    border-left-color: #6f42c1;
}

.\\!k-border-l-tertiary {
    border-left-color: #6f42c1 !important;
}

.k-border-l-info {
    border-left-color: #0dcaf0;
}

.\\!k-border-l-info {
    border-left-color: #0dcaf0 !important;
}

.k-border-l-success {
    border-left-color: #198754;
}

.\\!k-border-l-success {
    border-left-color: #198754 !important;
}

.k-border-l-warning {
    border-left-color: #ffc107;
}

.\\!k-border-l-warning {
    border-left-color: #ffc107 !important;
}

.k-border-l-error {
    border-left-color: #dc3545;
}

.\\!k-border-l-error {
    border-left-color: #dc3545 !important;
}

.k-border-l-dark {
    border-left-color: #212529;
}

.\\!k-border-l-dark {
    border-left-color: #212529 !important;
}

.k-border-l-light {
    border-left-color: #f8f9fa;
}

.\\!k-border-l-light {
    border-left-color: #f8f9fa !important;
}

.k-border-l-inverse {
    border-left-color: #212529;
}

.\\!k-border-l-inverse {
    border-left-color: #212529 !important;
}

.k-border-l-inherit {
    border-left-color: inherit;
}

.\\!k-border-l-inherit {
    border-left-color: inherit !important;
}

.k-border-l-current {
    border-left-color: currentColor;
}

.\\!k-border-l-current {
    border-left-color: currentColor !important;
}

.k-border-l-transparent {
    border-left-color: transparent;
}

.\\!k-border-l-transparent {
    border-left-color: transparent !important;
}

.k-border-l-black {
    border-left-color: black;
}

.\\!k-border-l-black {
    border-left-color: black !important;
}

.k-border-l-white {
    border-left-color: white;
}

.\\!k-border-l-white {
    border-left-color: white !important;
}

.k-border-x-primary {
    border-inline-color: #0d6efd;
}

.\\!k-border-x-primary {
    border-inline-color: #0d6efd !important;
}

.k-border-x-secondary {
    border-inline-color: #6c757d;
}

.\\!k-border-x-secondary {
    border-inline-color: #6c757d !important;
}

.k-border-x-tertiary {
    border-inline-color: #6f42c1;
}

.\\!k-border-x-tertiary {
    border-inline-color: #6f42c1 !important;
}

.k-border-x-info {
    border-inline-color: #0dcaf0;
}

.\\!k-border-x-info {
    border-inline-color: #0dcaf0 !important;
}

.k-border-x-success {
    border-inline-color: #198754;
}

.\\!k-border-x-success {
    border-inline-color: #198754 !important;
}

.k-border-x-warning {
    border-inline-color: #ffc107;
}

.\\!k-border-x-warning {
    border-inline-color: #ffc107 !important;
}

.k-border-x-error {
    border-inline-color: #dc3545;
}

.\\!k-border-x-error {
    border-inline-color: #dc3545 !important;
}

.k-border-x-dark {
    border-inline-color: #212529;
}

.\\!k-border-x-dark {
    border-inline-color: #212529 !important;
}

.k-border-x-light {
    border-inline-color: #f8f9fa;
}

.\\!k-border-x-light {
    border-inline-color: #f8f9fa !important;
}

.k-border-x-inverse {
    border-inline-color: #212529;
}

.\\!k-border-x-inverse {
    border-inline-color: #212529 !important;
}

.k-border-x-inherit {
    border-inline-color: inherit;
}

.\\!k-border-x-inherit {
    border-inline-color: inherit !important;
}

.k-border-x-current {
    border-inline-color: currentColor;
}

.\\!k-border-x-current {
    border-inline-color: currentColor !important;
}

.k-border-x-transparent {
    border-inline-color: transparent;
}

.\\!k-border-x-transparent {
    border-inline-color: transparent !important;
}

.k-border-x-black {
    border-inline-color: black;
}

.\\!k-border-x-black {
    border-inline-color: black !important;
}

.k-border-x-white {
    border-inline-color: white;
}

.\\!k-border-x-white {
    border-inline-color: white !important;
}

.k-border-y-primary {
    border-block-color: #0d6efd;
}

.\\!k-border-y-primary {
    border-block-color: #0d6efd !important;
}

.k-border-y-secondary {
    border-block-color: #6c757d;
}

.\\!k-border-y-secondary {
    border-block-color: #6c757d !important;
}

.k-border-y-tertiary {
    border-block-color: #6f42c1;
}

.\\!k-border-y-tertiary {
    border-block-color: #6f42c1 !important;
}

.k-border-y-info {
    border-block-color: #0dcaf0;
}

.\\!k-border-y-info {
    border-block-color: #0dcaf0 !important;
}

.k-border-y-success {
    border-block-color: #198754;
}

.\\!k-border-y-success {
    border-block-color: #198754 !important;
}

.k-border-y-warning {
    border-block-color: #ffc107;
}

.\\!k-border-y-warning {
    border-block-color: #ffc107 !important;
}

.k-border-y-error {
    border-block-color: #dc3545;
}

.\\!k-border-y-error {
    border-block-color: #dc3545 !important;
}

.k-border-y-dark {
    border-block-color: #212529;
}

.\\!k-border-y-dark {
    border-block-color: #212529 !important;
}

.k-border-y-light {
    border-block-color: #f8f9fa;
}

.\\!k-border-y-light {
    border-block-color: #f8f9fa !important;
}

.k-border-y-inverse {
    border-block-color: #212529;
}

.\\!k-border-y-inverse {
    border-block-color: #212529 !important;
}

.k-border-y-inherit {
    border-block-color: inherit;
}

.\\!k-border-y-inherit {
    border-block-color: inherit !important;
}

.k-border-y-current {
    border-block-color: currentColor;
}

.\\!k-border-y-current {
    border-block-color: currentColor !important;
}

.k-border-y-transparent {
    border-block-color: transparent;
}

.\\!k-border-y-transparent {
    border-block-color: transparent !important;
}

.k-border-y-black {
    border-block-color: black;
}

.\\!k-border-y-black {
    border-block-color: black !important;
}

.k-border-y-white {
    border-block-color: white;
}

.\\!k-border-y-white {
    border-block-color: white !important;
}

.k-rounded {
    border-radius: 0.375rem;
}

.\\!k-rounded {
    border-radius: 0.375rem !important;
}

.k-rounded-0 {
    border-radius: 0;
}

.\\!k-rounded-0 {
    border-radius: 0 !important;
}

.k-rounded-sm {
    border-radius: 0.25rem;
}

.\\!k-rounded-sm {
    border-radius: 0.25rem !important;
}

.k-rounded-md {
    border-radius: 0.375rem;
}

.\\!k-rounded-md {
    border-radius: 0.375rem !important;
}

.k-rounded-lg {
    border-radius: 0.5rem;
}

.\\!k-rounded-lg {
    border-radius: 0.5rem !important;
}

.k-rounded-full {
    border-radius: 9999px;
}

.\\!k-rounded-full {
    border-radius: 9999px !important;
}

.k-rounded-tl {
    border-top-left-radius: 0.375rem;
}

.\\!k-rounded-tl {
    border-top-left-radius: 0.375rem !important;
}

.k-rounded-tl-0 {
    border-top-left-radius: 0;
}

.\\!k-rounded-tl-0 {
    border-top-left-radius: 0 !important;
}

.k-rounded-tl-sm {
    border-top-left-radius: 0.25rem;
}

.\\!k-rounded-tl-sm {
    border-top-left-radius: 0.25rem !important;
}

.k-rounded-tl-md {
    border-top-left-radius: 0.375rem;
}

.\\!k-rounded-tl-md {
    border-top-left-radius: 0.375rem !important;
}

.k-rounded-tl-lg {
    border-top-left-radius: 0.5rem;
}

.\\!k-rounded-tl-lg {
    border-top-left-radius: 0.5rem !important;
}

.k-rounded-tl-full {
    border-top-left-radius: 9999px;
}

.\\!k-rounded-tl-full {
    border-top-left-radius: 9999px !important;
}

.k-rounded-tr {
    border-top-right-radius: 0.375rem;
}

.\\!k-rounded-tr {
    border-top-right-radius: 0.375rem !important;
}

.k-rounded-tr-0 {
    border-top-right-radius: 0;
}

.\\!k-rounded-tr-0 {
    border-top-right-radius: 0 !important;
}

.k-rounded-tr-sm {
    border-top-right-radius: 0.25rem;
}

.\\!k-rounded-tr-sm {
    border-top-right-radius: 0.25rem !important;
}

.k-rounded-tr-md {
    border-top-right-radius: 0.375rem;
}

.\\!k-rounded-tr-md {
    border-top-right-radius: 0.375rem !important;
}

.k-rounded-tr-lg {
    border-top-right-radius: 0.5rem;
}

.\\!k-rounded-tr-lg {
    border-top-right-radius: 0.5rem !important;
}

.k-rounded-tr-full {
    border-top-right-radius: 9999px;
}

.\\!k-rounded-tr-full {
    border-top-right-radius: 9999px !important;
}

.k-rounded-br {
    border-bottom-right-radius: 0.375rem;
}

.\\!k-rounded-br {
    border-bottom-right-radius: 0.375rem !important;
}

.k-rounded-br-0 {
    border-bottom-right-radius: 0;
}

.\\!k-rounded-br-0 {
    border-bottom-right-radius: 0 !important;
}

.k-rounded-br-sm {
    border-bottom-right-radius: 0.25rem;
}

.\\!k-rounded-br-sm {
    border-bottom-right-radius: 0.25rem !important;
}

.k-rounded-br-md {
    border-bottom-right-radius: 0.375rem;
}

.\\!k-rounded-br-md {
    border-bottom-right-radius: 0.375rem !important;
}

.k-rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
}

.\\!k-rounded-br-lg {
    border-bottom-right-radius: 0.5rem !important;
}

.k-rounded-br-full {
    border-bottom-right-radius: 9999px;
}

.\\!k-rounded-br-full {
    border-bottom-right-radius: 9999px !important;
}

.k-rounded-bl {
    border-bottom-left-radius: 0.375rem;
}

.\\!k-rounded-bl {
    border-bottom-left-radius: 0.375rem !important;
}

.k-rounded-bl-0 {
    border-bottom-left-radius: 0;
}

.\\!k-rounded-bl-0 {
    border-bottom-left-radius: 0 !important;
}

.k-rounded-bl-sm {
    border-bottom-left-radius: 0.25rem;
}

.\\!k-rounded-bl-sm {
    border-bottom-left-radius: 0.25rem !important;
}

.k-rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
}

.\\!k-rounded-bl-md {
    border-bottom-left-radius: 0.375rem !important;
}

.k-rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
}

.\\!k-rounded-bl-lg {
    border-bottom-left-radius: 0.5rem !important;
}

.k-rounded-bl-full {
    border-bottom-left-radius: 9999px;
}

.\\!k-rounded-bl-full {
    border-bottom-left-radius: 9999px !important;
}

.k-rounded-t {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
}

.\\!k-rounded-t {
    border-top-left-radius: 0.375rem !important;
    border-top-right-radius: 0.375rem !important;
}

.k-rounded-t-0 {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.\\!k-rounded-t-0 {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
}

.k-rounded-t-sm {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}

.\\!k-rounded-t-sm {
    border-top-left-radius: 0.25rem !important;
    border-top-right-radius: 0.25rem !important;
}

.k-rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
}

.\\!k-rounded-t-md {
    border-top-left-radius: 0.375rem !important;
    border-top-right-radius: 0.375rem !important;
}

.k-rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}

.\\!k-rounded-t-lg {
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
}

.k-rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
}

.\\!k-rounded-t-full {
    border-top-left-radius: 9999px !important;
    border-top-right-radius: 9999px !important;
}

.k-rounded-r {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}

.\\!k-rounded-r {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}

.k-rounded-r-0 {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.\\!k-rounded-r-0 {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.k-rounded-r-sm {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}

.\\!k-rounded-r-sm {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
}

.k-rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}

.\\!k-rounded-r-md {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}

.k-rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
}

.\\!k-rounded-r-lg {
    border-top-right-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
}

.k-rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
}

.\\!k-rounded-r-full {
    border-top-right-radius: 9999px !important;
    border-bottom-right-radius: 9999px !important;
}

.k-rounded-b {
    border-bottom-left-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}

.\\!k-rounded-b {
    border-bottom-left-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}

.k-rounded-b-0 {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.\\!k-rounded-b-0 {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.k-rounded-b-sm {
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}

.\\!k-rounded-b-sm {
    border-bottom-left-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
}

.k-rounded-b-md {
    border-bottom-left-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}

.\\!k-rounded-b-md {
    border-bottom-left-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}

.k-rounded-b-lg {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
}

.\\!k-rounded-b-lg {
    border-bottom-left-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
}

.k-rounded-b-full {
    border-bottom-left-radius: 9999px;
    border-bottom-right-radius: 9999px;
}

.\\!k-rounded-b-full {
    border-bottom-left-radius: 9999px !important;
    border-bottom-right-radius: 9999px !important;
}

.k-rounded-l {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
}

.\\!k-rounded-l {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
}

.k-rounded-l-0 {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.\\!k-rounded-l-0 {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}

.k-rounded-l-sm {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.\\!k-rounded-l-sm {
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
}

.k-rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
}

.\\!k-rounded-l-md {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
}

.k-rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
}

.\\!k-rounded-l-lg {
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
}

.k-rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
}

.\\!k-rounded-l-full {
    border-top-left-radius: 9999px !important;
    border-bottom-left-radius: 9999px !important;
}

.k-border-solid {
    border-style: solid;
}

.\\!k-border-solid {
    border-style: solid !important;
}

.k-border-dashed {
    border-style: dashed;
}

.\\!k-border-dashed {
    border-style: dashed !important;
}

.k-border-dotted {
    border-style: dotted;
}

.\\!k-border-dotted {
    border-style: dotted !important;
}

.k-border-double {
    border-style: double;
}

.\\!k-border-double {
    border-style: double !important;
}

.k-border-inset {
    border-style: inset;
}

.\\!k-border-inset {
    border-style: inset !important;
}

.k-border-outset {
    border-style: outset;
}

.\\!k-border-outset {
    border-style: outset !important;
}

.k-border-hidden {
    border-style: hidden;
}

.\\!k-border-hidden {
    border-style: hidden !important;
}

.k-border-none {
    border-style: none;
}

.\\!k-border-none {
    border-style: none !important;
}

.k-border-t-solid {
    border-top-style: solid;
}

.\\!k-border-t-solid {
    border-top-style: solid !important;
}

.k-border-t-dashed {
    border-top-style: dashed;
}

.\\!k-border-t-dashed {
    border-top-style: dashed !important;
}

.k-border-t-dotted {
    border-top-style: dotted;
}

.\\!k-border-t-dotted {
    border-top-style: dotted !important;
}

.k-border-t-double {
    border-top-style: double;
}

.\\!k-border-t-double {
    border-top-style: double !important;
}

.k-border-t-inset {
    border-top-style: inset;
}

.\\!k-border-t-inset {
    border-top-style: inset !important;
}

.k-border-t-outset {
    border-top-style: outset;
}

.\\!k-border-t-outset {
    border-top-style: outset !important;
}

.k-border-t-hidden {
    border-top-style: hidden;
}

.\\!k-border-t-hidden {
    border-top-style: hidden !important;
}

.k-border-t-none {
    border-top-style: none;
}

.\\!k-border-t-none {
    border-top-style: none !important;
}

.k-border-r-solid {
    border-right-style: solid;
}

.\\!k-border-r-solid {
    border-right-style: solid !important;
}

.k-border-r-dashed {
    border-right-style: dashed;
}

.\\!k-border-r-dashed {
    border-right-style: dashed !important;
}

.k-border-r-dotted {
    border-right-style: dotted;
}

.\\!k-border-r-dotted {
    border-right-style: dotted !important;
}

.k-border-r-double {
    border-right-style: double;
}

.\\!k-border-r-double {
    border-right-style: double !important;
}

.k-border-r-inset {
    border-right-style: inset;
}

.\\!k-border-r-inset {
    border-right-style: inset !important;
}

.k-border-r-outset {
    border-right-style: outset;
}

.\\!k-border-r-outset {
    border-right-style: outset !important;
}

.k-border-r-hidden {
    border-right-style: hidden;
}

.\\!k-border-r-hidden {
    border-right-style: hidden !important;
}

.k-border-r-none {
    border-right-style: none;
}

.\\!k-border-r-none {
    border-right-style: none !important;
}

.k-border-b-solid {
    border-bottom-style: solid;
}

.\\!k-border-b-solid {
    border-bottom-style: solid !important;
}

.k-border-b-dashed {
    border-bottom-style: dashed;
}

.\\!k-border-b-dashed {
    border-bottom-style: dashed !important;
}

.k-border-b-dotted {
    border-bottom-style: dotted;
}

.\\!k-border-b-dotted {
    border-bottom-style: dotted !important;
}

.k-border-b-double {
    border-bottom-style: double;
}

.\\!k-border-b-double {
    border-bottom-style: double !important;
}

.k-border-b-inset {
    border-bottom-style: inset;
}

.\\!k-border-b-inset {
    border-bottom-style: inset !important;
}

.k-border-b-outset {
    border-bottom-style: outset;
}

.\\!k-border-b-outset {
    border-bottom-style: outset !important;
}

.k-border-b-hidden {
    border-bottom-style: hidden;
}

.\\!k-border-b-hidden {
    border-bottom-style: hidden !important;
}

.k-border-b-none {
    border-bottom-style: none;
}

.\\!k-border-b-none {
    border-bottom-style: none !important;
}

.k-border-l-solid {
    border-left-style: solid;
}

.\\!k-border-l-solid {
    border-left-style: solid !important;
}

.k-border-l-dashed {
    border-left-style: dashed;
}

.\\!k-border-l-dashed {
    border-left-style: dashed !important;
}

.k-border-l-dotted {
    border-left-style: dotted;
}

.\\!k-border-l-dotted {
    border-left-style: dotted !important;
}

.k-border-l-double {
    border-left-style: double;
}

.\\!k-border-l-double {
    border-left-style: double !important;
}

.k-border-l-inset {
    border-left-style: inset;
}

.\\!k-border-l-inset {
    border-left-style: inset !important;
}

.k-border-l-outset {
    border-left-style: outset;
}

.\\!k-border-l-outset {
    border-left-style: outset !important;
}

.k-border-l-hidden {
    border-left-style: hidden;
}

.\\!k-border-l-hidden {
    border-left-style: hidden !important;
}

.k-border-l-none {
    border-left-style: none;
}

.\\!k-border-l-none {
    border-left-style: none !important;
}

.k-border-x-solid {
    border-inline-style: solid;
}

.\\!k-border-x-solid {
    border-inline-style: solid !important;
}

.k-border-x-dashed {
    border-inline-style: dashed;
}

.\\!k-border-x-dashed {
    border-inline-style: dashed !important;
}

.k-border-x-dotted {
    border-inline-style: dotted;
}

.\\!k-border-x-dotted {
    border-inline-style: dotted !important;
}

.k-border-x-double {
    border-inline-style: double;
}

.\\!k-border-x-double {
    border-inline-style: double !important;
}

.k-border-x-inset {
    border-inline-style: inset;
}

.\\!k-border-x-inset {
    border-inline-style: inset !important;
}

.k-border-x-outset {
    border-inline-style: outset;
}

.\\!k-border-x-outset {
    border-inline-style: outset !important;
}

.k-border-x-hidden {
    border-inline-style: hidden;
}

.\\!k-border-x-hidden {
    border-inline-style: hidden !important;
}

.k-border-x-none {
    border-inline-style: none;
}

.\\!k-border-x-none {
    border-inline-style: none !important;
}

.k-border-y-solid {
    border-block-style: solid;
}

.\\!k-border-y-solid {
    border-block-style: solid !important;
}

.k-border-y-dashed {
    border-block-style: dashed;
}

.\\!k-border-y-dashed {
    border-block-style: dashed !important;
}

.k-border-y-dotted {
    border-block-style: dotted;
}

.\\!k-border-y-dotted {
    border-block-style: dotted !important;
}

.k-border-y-double {
    border-block-style: double;
}

.\\!k-border-y-double {
    border-block-style: double !important;
}

.k-border-y-inset {
    border-block-style: inset;
}

.\\!k-border-y-inset {
    border-block-style: inset !important;
}

.k-border-y-outset {
    border-block-style: outset;
}

.\\!k-border-y-outset {
    border-block-style: outset !important;
}

.k-border-y-hidden {
    border-block-style: hidden;
}

.\\!k-border-y-hidden {
    border-block-style: hidden !important;
}

.k-border-y-none {
    border-block-style: none;
}

.\\!k-border-y-none {
    border-block-style: none !important;
}

.k-border {
    border-width: 1px;
}

.\\!k-border {
    border-width: 1px !important;
}

.k-border-0 {
    border-width: 0;
}

.\\!k-border-0 {
    border-width: 0 !important;
}

.k-border-2 {
    border-width: 2px;
}

.\\!k-border-2 {
    border-width: 2px !important;
}

.k-border-4 {
    border-width: 4px;
}

.\\!k-border-4 {
    border-width: 4px !important;
}

.k-border-8 {
    border-width: 8px;
}

.\\!k-border-8 {
    border-width: 8px !important;
}

.k-border-t {
    border-top-width: 1px;
}

.\\!k-border-t {
    border-top-width: 1px !important;
}

.k-border-t-0 {
    border-top-width: 0;
}

.\\!k-border-t-0 {
    border-top-width: 0 !important;
}

.k-border-t-2 {
    border-top-width: 2px;
}

.\\!k-border-t-2 {
    border-top-width: 2px !important;
}

.k-border-t-4 {
    border-top-width: 4px;
}

.\\!k-border-t-4 {
    border-top-width: 4px !important;
}

.k-border-t-8 {
    border-top-width: 8px;
}

.\\!k-border-t-8 {
    border-top-width: 8px !important;
}

.k-border-r {
    border-right-width: 1px;
}

.\\!k-border-r {
    border-right-width: 1px !important;
}

.k-border-r-0 {
    border-right-width: 0;
}

.\\!k-border-r-0 {
    border-right-width: 0 !important;
}

.k-border-r-2 {
    border-right-width: 2px;
}

.\\!k-border-r-2 {
    border-right-width: 2px !important;
}

.k-border-r-4 {
    border-right-width: 4px;
}

.\\!k-border-r-4 {
    border-right-width: 4px !important;
}

.k-border-r-8 {
    border-right-width: 8px;
}

.\\!k-border-r-8 {
    border-right-width: 8px !important;
}

.k-border-b {
    border-bottom-width: 1px;
}

.\\!k-border-b {
    border-bottom-width: 1px !important;
}

.k-border-b-0 {
    border-bottom-width: 0;
}

.\\!k-border-b-0 {
    border-bottom-width: 0 !important;
}

.k-border-b-2 {
    border-bottom-width: 2px;
}

.\\!k-border-b-2 {
    border-bottom-width: 2px !important;
}

.k-border-b-4 {
    border-bottom-width: 4px;
}

.\\!k-border-b-4 {
    border-bottom-width: 4px !important;
}

.k-border-b-8 {
    border-bottom-width: 8px;
}

.\\!k-border-b-8 {
    border-bottom-width: 8px !important;
}

.k-border-l {
    border-left-width: 1px;
}

.\\!k-border-l {
    border-left-width: 1px !important;
}

.k-border-l-0 {
    border-left-width: 0;
}

.\\!k-border-l-0 {
    border-left-width: 0 !important;
}

.k-border-l-2 {
    border-left-width: 2px;
}

.\\!k-border-l-2 {
    border-left-width: 2px !important;
}

.k-border-l-4 {
    border-left-width: 4px;
}

.\\!k-border-l-4 {
    border-left-width: 4px !important;
}

.k-border-l-8 {
    border-left-width: 8px;
}

.\\!k-border-l-8 {
    border-left-width: 8px !important;
}

.k-border-x {
    border-inline-width: 1px;
}

.\\!k-border-x {
    border-inline-width: 1px !important;
}

.k-border-x-0 {
    border-inline-width: 0;
}

.\\!k-border-x-0 {
    border-inline-width: 0 !important;
}

.k-border-x-2 {
    border-inline-width: 2px;
}

.\\!k-border-x-2 {
    border-inline-width: 2px !important;
}

.k-border-x-4 {
    border-inline-width: 4px;
}

.\\!k-border-x-4 {
    border-inline-width: 4px !important;
}

.k-border-x-8 {
    border-inline-width: 8px;
}

.\\!k-border-x-8 {
    border-inline-width: 8px !important;
}

.k-border-y {
    border-block-width: 1px;
}

.\\!k-border-y {
    border-block-width: 1px !important;
}

.k-border-y-0 {
    border-block-width: 0;
}

.\\!k-border-y-0 {
    border-block-width: 0 !important;
}

.k-border-y-2 {
    border-block-width: 2px;
}

.\\!k-border-y-2 {
    border-block-width: 2px !important;
}

.k-border-y-4 {
    border-block-width: 4px;
}

.\\!k-border-y-4 {
    border-block-width: 4px !important;
}

.k-border-y-8 {
    border-block-width: 8px;
}

.\\!k-border-y-8 {
    border-block-width: 8px !important;
}

.k-border-top {
    border-top-width: 1px;
}

.\\!k-border-top {
    border-top-width: 1px !important;
}

.k-border-top-0 {
    border-top-width: 0;
}

.\\!k-border-top-0 {
    border-top-width: 0 !important;
}

.k-border-top-2 {
    border-top-width: 2px;
}

.\\!k-border-top-2 {
    border-top-width: 2px !important;
}

.k-border-top-4 {
    border-top-width: 4px;
}

.\\!k-border-top-4 {
    border-top-width: 4px !important;
}

.k-border-top-8 {
    border-top-width: 8px;
}

.\\!k-border-top-8 {
    border-top-width: 8px !important;
}

.k-border-right {
    border-right-width: 1px;
}

.\\!k-border-right {
    border-right-width: 1px !important;
}

.k-border-right-0 {
    border-right-width: 0;
}

.\\!k-border-right-0 {
    border-right-width: 0 !important;
}

.k-border-right-2 {
    border-right-width: 2px;
}

.\\!k-border-right-2 {
    border-right-width: 2px !important;
}

.k-border-right-4 {
    border-right-width: 4px;
}

.\\!k-border-right-4 {
    border-right-width: 4px !important;
}

.k-border-right-8 {
    border-right-width: 8px;
}

.\\!k-border-right-8 {
    border-right-width: 8px !important;
}

.k-border-bottom {
    border-bottom-width: 1px;
}

.\\!k-border-bottom {
    border-bottom-width: 1px !important;
}

.k-border-bottom-0 {
    border-bottom-width: 0;
}

.\\!k-border-bottom-0 {
    border-bottom-width: 0 !important;
}

.k-border-bottom-2 {
    border-bottom-width: 2px;
}

.\\!k-border-bottom-2 {
    border-bottom-width: 2px !important;
}

.k-border-bottom-4 {
    border-bottom-width: 4px;
}

.\\!k-border-bottom-4 {
    border-bottom-width: 4px !important;
}

.k-border-bottom-8 {
    border-bottom-width: 8px;
}

.\\!k-border-bottom-8 {
    border-bottom-width: 8px !important;
}

.k-border-left {
    border-left-width: 1px;
}

.\\!k-border-left {
    border-left-width: 1px !important;
}

.k-border-left-0 {
    border-left-width: 0;
}

.\\!k-border-left-0 {
    border-left-width: 0 !important;
}

.k-border-left-2 {
    border-left-width: 2px;
}

.\\!k-border-left-2 {
    border-left-width: 2px !important;
}

.k-border-left-4 {
    border-left-width: 4px;
}

.\\!k-border-left-4 {
    border-left-width: 4px !important;
}

.k-border-left-8 {
    border-left-width: 8px;
}

.\\!k-border-left-8 {
    border-left-width: 8px !important;
}

.k-outline-primary {
    outline-color: #0d6efd;
}

.\\!k-outline-primary {
    outline-color: #0d6efd !important;
}

.k-outline-secondary {
    outline-color: #6c757d;
}

.\\!k-outline-secondary {
    outline-color: #6c757d !important;
}

.k-outline-tertiary {
    outline-color: #6f42c1;
}

.\\!k-outline-tertiary {
    outline-color: #6f42c1 !important;
}

.k-outline-info {
    outline-color: #0dcaf0;
}

.\\!k-outline-info {
    outline-color: #0dcaf0 !important;
}

.k-outline-success {
    outline-color: #198754;
}

.\\!k-outline-success {
    outline-color: #198754 !important;
}

.k-outline-warning {
    outline-color: #ffc107;
}

.\\!k-outline-warning {
    outline-color: #ffc107 !important;
}

.k-outline-error {
    outline-color: #dc3545;
}

.\\!k-outline-error {
    outline-color: #dc3545 !important;
}

.k-outline-dark {
    outline-color: #212529;
}

.\\!k-outline-dark {
    outline-color: #212529 !important;
}

.k-outline-light {
    outline-color: #f8f9fa;
}

.\\!k-outline-light {
    outline-color: #f8f9fa !important;
}

.k-outline-inverse {
    outline-color: #212529;
}

.\\!k-outline-inverse {
    outline-color: #212529 !important;
}

.k-outline-inherit {
    outline-color: inherit;
}

.\\!k-outline-inherit {
    outline-color: inherit !important;
}

.k-outline-current {
    outline-color: currentColor;
}

.\\!k-outline-current {
    outline-color: currentColor !important;
}

.k-outline-transparent {
    outline-color: transparent;
}

.\\!k-outline-transparent {
    outline-color: transparent !important;
}

.k-outline-black {
    outline-color: black;
}

.\\!k-outline-black {
    outline-color: black !important;
}

.k-outline-white {
    outline-color: white;
}

.\\!k-outline-white {
    outline-color: white !important;
}

.k-outline-offset-0 {
    outline-offset: 0;
}

.\\!k-outline-offset-0 {
    outline-offset: 0 !important;
}

.k-outline-offset-1 {
    outline-offset: 1px;
}

.\\!k-outline-offset-1 {
    outline-offset: 1px !important;
}

.k-outline-offset-2 {
    outline-offset: 2px;
}

.\\!k-outline-offset-2 {
    outline-offset: 2px !important;
}

.k-outline-offset-4 {
    outline-offset: 4px;
}

.\\!k-outline-offset-4 {
    outline-offset: 4px !important;
}

.k-outline-offset-8 {
    outline-offset: 8px;
}

.\\!k-outline-offset-8 {
    outline-offset: 8px !important;
}

.k-outline-solid {
    outline-style: solid;
}

.\\!k-outline-solid {
    outline-style: solid !important;
}

.k-outline-dashed {
    outline-style: dashed;
}

.\\!k-outline-dashed {
    outline-style: dashed !important;
}

.k-outline-dotted {
    outline-style: dotted;
}

.\\!k-outline-dotted {
    outline-style: dotted !important;
}

.k-outline-double {
    outline-style: double;
}

.\\!k-outline-double {
    outline-style: double !important;
}

.k-outline-inset {
    outline-style: inset;
}

.\\!k-outline-inset {
    outline-style: inset !important;
}

.k-outline-outset {
    outline-style: outset;
}

.\\!k-outline-outset {
    outline-style: outset !important;
}

.k-outline-none {
    outline-style: none;
}

.\\!k-outline-none {
    outline-style: none !important;
}

.k-outline {
    outline-width: 1px;
}

.\\!k-outline {
    outline-width: 1px !important;
}

.k-outline-0 {
    outline-width: 0;
}

.\\!k-outline-0 {
    outline-width: 0 !important;
}

.k-outline-2 {
    outline-width: 2px;
}

.\\!k-outline-2 {
    outline-width: 2px !important;
}

.k-outline-4 {
    outline-width: 4px;
}

.\\!k-outline-4 {
    outline-width: 4px !important;
}

.k-outline-8 {
    outline-width: 8px;
}

.\\!k-outline-8 {
    outline-width: 8px !important;
}

.k-opacity-0 {
    opacity: 0;
}

.\\!k-opacity-0 {
    opacity: 0 !important;
}

.k-opacity-5 {
    opacity: 0.05;
}

.\\!k-opacity-5 {
    opacity: 0.05 !important;
}

.k-opacity-10 {
    opacity: 0.1;
}

.\\!k-opacity-10 {
    opacity: 0.1 !important;
}

.k-opacity-20 {
    opacity: 0.2;
}

.\\!k-opacity-20 {
    opacity: 0.2 !important;
}

.k-opacity-30 {
    opacity: 0.3;
}

.\\!k-opacity-30 {
    opacity: 0.3 !important;
}

.k-opacity-40 {
    opacity: 0.4;
}

.\\!k-opacity-40 {
    opacity: 0.4 !important;
}

.k-opacity-50 {
    opacity: 0.5;
}

.\\!k-opacity-50 {
    opacity: 0.5 !important;
}

.k-opacity-60 {
    opacity: 0.6;
}

.\\!k-opacity-60 {
    opacity: 0.6 !important;
}

.k-opacity-70 {
    opacity: 0.7;
}

.\\!k-opacity-70 {
    opacity: 0.7 !important;
}

.k-opacity-80 {
    opacity: 0.8;
}

.\\!k-opacity-80 {
    opacity: 0.8 !important;
}

.k-opacity-90 {
    opacity: 0.9;
}

.\\!k-opacity-90 {
    opacity: 0.9 !important;
}

.k-opacity-100 {
    opacity: 1;
}

.\\!k-opacity-100 {
    opacity: 1 !important;
}

.k-backdrop-blur {
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px);
}

.\\!k-backdrop-blur {
    -webkit-backdrop-filter: blur(8px) !important;
            backdrop-filter: blur(8px) !important;
}

.k-backdrop-blur-none {
    -webkit-backdrop-filter: blur(0);
            backdrop-filter: blur(0);
}

.\\!k-backdrop-blur-none {
    -webkit-backdrop-filter: blur(0) !important;
            backdrop-filter: blur(0) !important;
}

.k-backdrop-blur-sm {
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
}

.\\!k-backdrop-blur-sm {
    -webkit-backdrop-filter: blur(4px) !important;
            backdrop-filter: blur(4px) !important;
}

.k-backdrop-blur-md {
    -webkit-backdrop-filter: blur(6px);
            backdrop-filter: blur(6px);
}

.\\!k-backdrop-blur-md {
    -webkit-backdrop-filter: blur(6px) !important;
            backdrop-filter: blur(6px) !important;
}

.k-backdrop-blur-lg {
    -webkit-backdrop-filter: blur(12px);
            backdrop-filter: blur(12px);
}

.\\!k-backdrop-blur-lg {
    -webkit-backdrop-filter: blur(12px) !important;
            backdrop-filter: blur(12px) !important;
}

.k-border-collapse {
    border-collapse: collapse;
}

.\\!k-border-collapse {
    border-collapse: collapse !important;
}

.k-border-separate {
    border-collapse: separate;
}

.\\!k-border-separate {
    border-collapse: separate !important;
}

.k-table-auto {
    table-layout: auto;
}

.\\!k-table-auto {
    table-layout: auto !important;
}

.k-table-fixed {
    table-layout: fixed;
}

.\\!k-table-fixed {
    table-layout: fixed !important;
}

.k-table-layout-auto {
    table-layout: auto;
}

.\\!k-table-layout-auto {
    table-layout: auto !important;
}

.k-table-layout-fixed {
    table-layout: fixed;
}

.\\!k-table-layout-fixed {
    table-layout: fixed !important;
}

.k-flip-h, .k-flip-x {
    transform: scaleX(-1);
}

.\\!k-flip-h, .\\!k-flip-x {
    transform: scaleX(-1) !important;
}

.k-flip-v, .k-flip-y {
    transform: scaleY(-1);
}

.\\!k-flip-v, .\\!k-flip-y {
    transform: scaleY(-1) !important;
}

.k-flip-h.k-flip-v, .k-flip-v.k-flip-x, .k-flip-x.k-flip-y, .k-flip-h.k-flip-y {
    transform: scale(-1, -1);
}

.\\!k-flip-h.\\!k-flip-v, .\\!k-flip-v.\\!k-flip-x, .\\!k-flip-x.\\!k-flip-y, .\\!k-flip-h.\\!k-flip-y {
    transform: scale(-1, -1) !important;
}

.k-origin-center {
    transform-origin: center;
}

.\\!k-origin-center {
    transform-origin: center !important;
}

.k-origin-top {
    transform-origin: top;
}

.\\!k-origin-top {
    transform-origin: top !important;
}

.k-origin-right {
    transform-origin: right;
}

.\\!k-origin-right {
    transform-origin: right !important;
}

.k-origin-bottom {
    transform-origin: bottom;
}

.\\!k-origin-bottom {
    transform-origin: bottom !important;
}

.k-origin-left {
    transform-origin: left;
}

.\\!k-origin-left {
    transform-origin: left !important;
}

.k-origin-top-left {
    transform-origin: top left;
}

.\\!k-origin-top-left {
    transform-origin: top left !important;
}

.k-origin-top-right {
    transform-origin: top right;
}

.\\!k-origin-top-right {
    transform-origin: top right !important;
}

.k-origin-bottom-left {
    transform-origin: bottom left;
}

.\\!k-origin-bottom-left {
    transform-origin: bottom left !important;
}

.k-origin-bottom-right {
    transform-origin: bottom right;
}

.\\!k-origin-bottom-right {
    transform-origin: bottom right !important;
}

.k-rotate-0 {
    transform: rotate(0deg);
}

.\\!k-rotate-0 {
    transform: rotate(0deg) !important;
}

.k-rotate-45 {
    transform: rotate(45deg);
}

.\\!k-rotate-45 {
    transform: rotate(45deg) !important;
}

.k-rotate-90 {
    transform: rotate(90deg);
}

.\\!k-rotate-90 {
    transform: rotate(90deg) !important;
}

.k-rotate-135 {
    transform: rotate(135deg);
}

.\\!k-rotate-135 {
    transform: rotate(135deg) !important;
}

.k-rotate-180 {
    transform: rotate(180deg);
}

.\\!k-rotate-180 {
    transform: rotate(180deg) !important;
}

.k-rotate-225 {
    transform: rotate(225deg);
}

.\\!k-rotate-225 {
    transform: rotate(225deg) !important;
}

.k-rotate-270 {
    transform: rotate(270deg);
}

.\\!k-rotate-270 {
    transform: rotate(270deg) !important;
}

.k-rotate-315 {
    transform: rotate(315deg);
}

.\\!k-rotate-315 {
    transform: rotate(315deg) !important;
}

.k-scale-0 {
    transform: scale(0);
}

.\\!k-scale-0 {
    transform: scale(0) !important;
}

.k-scale-0\\.25 {
    transform: scale(0.25);
}

.\\!k-scale-0\\.25 {
    transform: scale(0.25) !important;
}

.k-scale-0\\.5 {
    transform: scale(0.5);
}

.\\!k-scale-0\\.5 {
    transform: scale(0.5) !important;
}

.k-scale-0\\.75 {
    transform: scale(0.75);
}

.\\!k-scale-0\\.75 {
    transform: scale(0.75) !important;
}

.k-scale-1 {
    transform: scale(1);
}

.\\!k-scale-1 {
    transform: scale(1) !important;
}

.k-scale-1\\.25 {
    transform: scale(1.25);
}

.\\!k-scale-1\\.25 {
    transform: scale(1.25) !important;
}

.k-scale-1\\.5 {
    transform: scale(1.5);
}

.\\!k-scale-1\\.5 {
    transform: scale(1.5) !important;
}

.k-scale-2 {
    transform: scale(2);
}

.\\!k-scale-2 {
    transform: scale(2) !important;
}

.k-scale-x-0 {
    transform: scaleX(0);
}

.\\!k-scale-x-0 {
    transform: scaleX(0) !important;
}

.k-scale-x-0\\.25 {
    transform: scaleX(0.25);
}

.\\!k-scale-x-0\\.25 {
    transform: scaleX(0.25) !important;
}

.k-scale-x-0\\.5 {
    transform: scaleX(0.5);
}

.\\!k-scale-x-0\\.5 {
    transform: scaleX(0.5) !important;
}

.k-scale-x-0\\.75 {
    transform: scaleX(0.75);
}

.\\!k-scale-x-0\\.75 {
    transform: scaleX(0.75) !important;
}

.k-scale-x-1 {
    transform: scaleX(1);
}

.\\!k-scale-x-1 {
    transform: scaleX(1) !important;
}

.k-scale-x-1\\.25 {
    transform: scaleX(1.25);
}

.\\!k-scale-x-1\\.25 {
    transform: scaleX(1.25) !important;
}

.k-scale-x-1\\.5 {
    transform: scaleX(1.5);
}

.\\!k-scale-x-1\\.5 {
    transform: scaleX(1.5) !important;
}

.k-scale-x-2 {
    transform: scaleX(2);
}

.\\!k-scale-x-2 {
    transform: scaleX(2) !important;
}

.k-scale-y-0 {
    transform: scaleY(0);
}

.\\!k-scale-y-0 {
    transform: scaleY(0) !important;
}

.k-scale-y-0\\.25 {
    transform: scaleY(0.25);
}

.\\!k-scale-y-0\\.25 {
    transform: scaleY(0.25) !important;
}

.k-scale-y-0\\.5 {
    transform: scaleY(0.5);
}

.\\!k-scale-y-0\\.5 {
    transform: scaleY(0.5) !important;
}

.k-scale-y-0\\.75 {
    transform: scaleY(0.75);
}

.\\!k-scale-y-0\\.75 {
    transform: scaleY(0.75) !important;
}

.k-scale-y-1 {
    transform: scaleY(1);
}

.\\!k-scale-y-1 {
    transform: scaleY(1) !important;
}

.k-scale-y-1\\.25 {
    transform: scaleY(1.25);
}

.\\!k-scale-y-1\\.25 {
    transform: scaleY(1.25) !important;
}

.k-scale-y-1\\.5 {
    transform: scaleY(1.5);
}

.\\!k-scale-y-1\\.5 {
    transform: scaleY(1.5) !important;
}

.k-scale-y-2 {
    transform: scaleY(2);
}

.\\!k-scale-y-2 {
    transform: scaleY(2) !important;
}

.k-skew-x-0 {
    transform: skewX(0deg);
}

.\\!k-skew-x-0 {
    transform: skewX(0deg) !important;
}

.k-skew-x-1 {
    transform: skewX(1deg);
}

.\\!k-skew-x-1 {
    transform: skewX(1deg) !important;
}

.k-skew-x-2 {
    transform: skewX(2deg);
}

.\\!k-skew-x-2 {
    transform: skewX(2deg) !important;
}

.k-skew-x-3 {
    transform: skewX(3deg);
}

.\\!k-skew-x-3 {
    transform: skewX(3deg) !important;
}

.k-skew-x-4 {
    transform: skewX(4deg);
}

.\\!k-skew-x-4 {
    transform: skewX(4deg) !important;
}

.k-skew-x-5 {
    transform: skewX(5deg);
}

.\\!k-skew-x-5 {
    transform: skewX(5deg) !important;
}

.k-skew-x-6 {
    transform: skewX(6deg);
}

.\\!k-skew-x-6 {
    transform: skewX(6deg) !important;
}

.k-skew-x-7 {
    transform: skewX(7deg);
}

.\\!k-skew-x-7 {
    transform: skewX(7deg) !important;
}

.k-skew-x-8 {
    transform: skewX(8deg);
}

.\\!k-skew-x-8 {
    transform: skewX(8deg) !important;
}

.k-skew-x-9 {
    transform: skewX(9deg);
}

.\\!k-skew-x-9 {
    transform: skewX(9deg) !important;
}

.k-skew-x-10 {
    transform: skewX(10deg);
}

.\\!k-skew-x-10 {
    transform: skewX(10deg) !important;
}

.k-skew-x-11 {
    transform: skewX(11deg);
}

.\\!k-skew-x-11 {
    transform: skewX(11deg) !important;
}

.k-skew-x-12 {
    transform: skewX(12deg);
}

.\\!k-skew-x-12 {
    transform: skewX(12deg) !important;
}

.k-skew-y-0 {
    transform: skewY(0deg);
}

.\\!k-skew-y-0 {
    transform: skewY(0deg) !important;
}

.k-skew-y-1 {
    transform: skewY(1deg);
}

.\\!k-skew-y-1 {
    transform: skewY(1deg) !important;
}

.k-skew-y-2 {
    transform: skewY(2deg);
}

.\\!k-skew-y-2 {
    transform: skewY(2deg) !important;
}

.k-skew-y-3 {
    transform: skewY(3deg);
}

.\\!k-skew-y-3 {
    transform: skewY(3deg) !important;
}

.k-skew-y-4 {
    transform: skewY(4deg);
}

.\\!k-skew-y-4 {
    transform: skewY(4deg) !important;
}

.k-skew-y-5 {
    transform: skewY(5deg);
}

.\\!k-skew-y-5 {
    transform: skewY(5deg) !important;
}

.k-skew-y-6 {
    transform: skewY(6deg);
}

.\\!k-skew-y-6 {
    transform: skewY(6deg) !important;
}

.k-skew-y-7 {
    transform: skewY(7deg);
}

.\\!k-skew-y-7 {
    transform: skewY(7deg) !important;
}

.k-skew-y-8 {
    transform: skewY(8deg);
}

.\\!k-skew-y-8 {
    transform: skewY(8deg) !important;
}

.k-skew-y-9 {
    transform: skewY(9deg);
}

.\\!k-skew-y-9 {
    transform: skewY(9deg) !important;
}

.k-skew-y-10 {
    transform: skewY(10deg);
}

.\\!k-skew-y-10 {
    transform: skewY(10deg) !important;
}

.k-skew-y-11 {
    transform: skewY(11deg);
}

.\\!k-skew-y-11 {
    transform: skewY(11deg) !important;
}

.k-skew-y-12 {
    transform: skewY(12deg);
}

.\\!k-skew-y-12 {
    transform: skewY(12deg) !important;
}

.k-translate-0 {
    transform: translate(0, 0);
}

.\\!k-translate-0 {
    transform: translate(0, 0) !important;
}

.k-translate-0-50 {
    transform: translate(0, 50%);
}

.\\!k-translate-0-50 {
    transform: translate(0, 50%) !important;
}

.k-translate-0-100 {
    transform: translate(0, 100%);
}

.\\!k-translate-0-100 {
    transform: translate(0, 100%) !important;
}

.k-translate-50-0 {
    transform: translate(50%, 0);
}

.\\!k-translate-50-0 {
    transform: translate(50%, 0) !important;
}

.k-translate-50-50 {
    transform: translate(50%, 50%);
}

.\\!k-translate-50-50 {
    transform: translate(50%, 50%) !important;
}

.k-translate-50-100 {
    transform: translate(50%, 100%);
}

.\\!k-translate-50-100 {
    transform: translate(50%, 100%) !important;
}

.k-translate-100-0 {
    transform: translate(100%, 0);
}

.\\!k-translate-100-0 {
    transform: translate(100%, 0) !important;
}

.k-translate-100-50 {
    transform: translate(100%, 50%);
}

.\\!k-translate-100-50 {
    transform: translate(100%, 50%) !important;
}

.k-translate-100-100 {
    transform: translate(100%, 100%);
}

.\\!k-translate-100-100 {
    transform: translate(100%, 100%) !important;
}

.k-translate-x-0 {
    transform: translateX(0);
}

.\\!k-translate-x-0 {
    transform: translateX(0) !important;
}

.k-translate-x-1px {
    transform: translateX(1px);
}

.\\!k-translate-x-1px {
    transform: translateX(1px) !important;
}

.k-translate-x-0\\.5 {
    transform: translateX(0.125rem);
}

.\\!k-translate-x-0\\.5 {
    transform: translateX(0.125rem) !important;
}

.k-translate-x-1 {
    transform: translateX(0.25rem);
}

.\\!k-translate-x-1 {
    transform: translateX(0.25rem) !important;
}

.k-translate-x-1\\.5 {
    transform: translateX(0.375rem);
}

.\\!k-translate-x-1\\.5 {
    transform: translateX(0.375rem) !important;
}

.k-translate-x-2 {
    transform: translateX(0.5rem);
}

.\\!k-translate-x-2 {
    transform: translateX(0.5rem) !important;
}

.k-translate-x-2\\.5 {
    transform: translateX(0.625rem);
}

.\\!k-translate-x-2\\.5 {
    transform: translateX(0.625rem) !important;
}

.k-translate-x-3 {
    transform: translateX(0.75rem);
}

.\\!k-translate-x-3 {
    transform: translateX(0.75rem) !important;
}

.k-translate-x-3\\.5 {
    transform: translateX(0.875rem);
}

.\\!k-translate-x-3\\.5 {
    transform: translateX(0.875rem) !important;
}

.k-translate-x-4 {
    transform: translateX(1rem);
}

.\\!k-translate-x-4 {
    transform: translateX(1rem) !important;
}

.k-translate-x-4\\.5 {
    transform: translateX(1.125rem);
}

.\\!k-translate-x-4\\.5 {
    transform: translateX(1.125rem) !important;
}

.k-translate-x-5 {
    transform: translateX(1.25rem);
}

.\\!k-translate-x-5 {
    transform: translateX(1.25rem) !important;
}

.k-translate-x-5\\.5 {
    transform: translateX(1.375rem);
}

.\\!k-translate-x-5\\.5 {
    transform: translateX(1.375rem) !important;
}

.k-translate-x-6 {
    transform: translateX(1.5rem);
}

.\\!k-translate-x-6 {
    transform: translateX(1.5rem) !important;
}

.k-translate-x-6\\.5 {
    transform: translateX(1.625rem);
}

.\\!k-translate-x-6\\.5 {
    transform: translateX(1.625rem) !important;
}

.k-translate-x-7 {
    transform: translateX(1.75rem);
}

.\\!k-translate-x-7 {
    transform: translateX(1.75rem) !important;
}

.k-translate-x-7\\.5 {
    transform: translateX(1.875rem);
}

.\\!k-translate-x-7\\.5 {
    transform: translateX(1.875rem) !important;
}

.k-translate-x-8 {
    transform: translateX(2rem);
}

.\\!k-translate-x-8 {
    transform: translateX(2rem) !important;
}

.k-translate-x-9 {
    transform: translateX(2.25rem);
}

.\\!k-translate-x-9 {
    transform: translateX(2.25rem) !important;
}

.k-translate-x-10 {
    transform: translateX(2.5rem);
}

.\\!k-translate-x-10 {
    transform: translateX(2.5rem) !important;
}

.k-translate-x-11 {
    transform: translateX(2.75rem);
}

.\\!k-translate-x-11 {
    transform: translateX(2.75rem) !important;
}

.k-translate-x-12 {
    transform: translateX(3rem);
}

.\\!k-translate-x-12 {
    transform: translateX(3rem) !important;
}

.k-translate-x-13 {
    transform: translateX(3.25rem);
}

.\\!k-translate-x-13 {
    transform: translateX(3.25rem) !important;
}

.k-translate-x-14 {
    transform: translateX(3.5rem);
}

.\\!k-translate-x-14 {
    transform: translateX(3.5rem) !important;
}

.k-translate-x-15 {
    transform: translateX(3.75rem);
}

.\\!k-translate-x-15 {
    transform: translateX(3.75rem) !important;
}

.k-translate-x-16 {
    transform: translateX(4rem);
}

.\\!k-translate-x-16 {
    transform: translateX(4rem) !important;
}

.k-translate-x-17 {
    transform: translateX(4.25rem);
}

.\\!k-translate-x-17 {
    transform: translateX(4.25rem) !important;
}

.k-translate-x-18 {
    transform: translateX(4.5rem);
}

.\\!k-translate-x-18 {
    transform: translateX(4.5rem) !important;
}

.k-translate-x-19 {
    transform: translateX(4.75rem);
}

.\\!k-translate-x-19 {
    transform: translateX(4.75rem) !important;
}

.k-translate-x-20 {
    transform: translateX(5rem);
}

.\\!k-translate-x-20 {
    transform: translateX(5rem) !important;
}

.k-translate-x-21 {
    transform: translateX(5.25rem);
}

.\\!k-translate-x-21 {
    transform: translateX(5.25rem) !important;
}

.k-translate-x-22 {
    transform: translateX(5.5rem);
}

.\\!k-translate-x-22 {
    transform: translateX(5.5rem) !important;
}

.k-translate-x-23 {
    transform: translateX(5.75rem);
}

.\\!k-translate-x-23 {
    transform: translateX(5.75rem) !important;
}

.k-translate-x-24 {
    transform: translateX(6rem);
}

.\\!k-translate-x-24 {
    transform: translateX(6rem) !important;
}

.k-translate-x-1\\/2 {
    transform: translateX(50%);
}

.\\!k-translate-x-1\\/2 {
    transform: translateX(50%) !important;
}

.k-translate-x-1\\/3 {
    transform: translateX(33.333333%);
}

.\\!k-translate-x-1\\/3 {
    transform: translateX(33.333333%) !important;
}

.k-translate-x-2\\/3 {
    transform: translateX(66.666667%);
}

.\\!k-translate-x-2\\/3 {
    transform: translateX(66.666667%) !important;
}

.k-translate-x-1\\/4 {
    transform: translateX(25%);
}

.\\!k-translate-x-1\\/4 {
    transform: translateX(25%) !important;
}

.k-translate-x-2\\/4 {
    transform: translateX(50%);
}

.\\!k-translate-x-2\\/4 {
    transform: translateX(50%) !important;
}

.k-translate-x-3\\/4 {
    transform: translateX(75%);
}

.\\!k-translate-x-3\\/4 {
    transform: translateX(75%) !important;
}

.k-translate-x-1\\/5 {
    transform: translateX(20%);
}

.\\!k-translate-x-1\\/5 {
    transform: translateX(20%) !important;
}

.k-translate-x-2\\/5 {
    transform: translateX(40%);
}

.\\!k-translate-x-2\\/5 {
    transform: translateX(40%) !important;
}

.k-translate-x-3\\/5 {
    transform: translateX(60%);
}

.\\!k-translate-x-3\\/5 {
    transform: translateX(60%) !important;
}

.k-translate-x-4\\/5 {
    transform: translateX(80%);
}

.\\!k-translate-x-4\\/5 {
    transform: translateX(80%) !important;
}

.k-translate-x-1\\/6 {
    transform: translateX(16.666667%);
}

.\\!k-translate-x-1\\/6 {
    transform: translateX(16.666667%) !important;
}

.k-translate-x-2\\/6 {
    transform: translateX(33.333333%);
}

.\\!k-translate-x-2\\/6 {
    transform: translateX(33.333333%) !important;
}

.k-translate-x-3\\/6 {
    transform: translateX(50%);
}

.\\!k-translate-x-3\\/6 {
    transform: translateX(50%) !important;
}

.k-translate-x-4\\/6 {
    transform: translateX(66.666667%);
}

.\\!k-translate-x-4\\/6 {
    transform: translateX(66.666667%) !important;
}

.k-translate-x-5\\/6 {
    transform: translateX(83.333333%);
}

.\\!k-translate-x-5\\/6 {
    transform: translateX(83.333333%) !important;
}

.k-translate-x-1\\/12 {
    transform: translateX(8.333333%);
}

.\\!k-translate-x-1\\/12 {
    transform: translateX(8.333333%) !important;
}

.k-translate-x-2\\/12 {
    transform: translateX(16.666667%);
}

.\\!k-translate-x-2\\/12 {
    transform: translateX(16.666667%) !important;
}

.k-translate-x-3\\/12 {
    transform: translateX(25%);
}

.\\!k-translate-x-3\\/12 {
    transform: translateX(25%) !important;
}

.k-translate-x-4\\/12 {
    transform: translateX(33.333333%);
}

.\\!k-translate-x-4\\/12 {
    transform: translateX(33.333333%) !important;
}

.k-translate-x-5\\/12 {
    transform: translateX(41.666667%);
}

.\\!k-translate-x-5\\/12 {
    transform: translateX(41.666667%) !important;
}

.k-translate-x-6\\/12 {
    transform: translateX(50%);
}

.\\!k-translate-x-6\\/12 {
    transform: translateX(50%) !important;
}

.k-translate-x-7\\/12 {
    transform: translateX(58.333333%);
}

.\\!k-translate-x-7\\/12 {
    transform: translateX(58.333333%) !important;
}

.k-translate-x-8\\/12 {
    transform: translateX(66.666667%);
}

.\\!k-translate-x-8\\/12 {
    transform: translateX(66.666667%) !important;
}

.k-translate-x-9\\/12 {
    transform: translateX(75%);
}

.\\!k-translate-x-9\\/12 {
    transform: translateX(75%) !important;
}

.k-translate-x-10\\/12 {
    transform: translateX(83.333333%);
}

.\\!k-translate-x-10\\/12 {
    transform: translateX(83.333333%) !important;
}

.k-translate-x-11\\/12 {
    transform: translateX(91.666667%);
}

.\\!k-translate-x-11\\/12 {
    transform: translateX(91.666667%) !important;
}

.k-translate-x-full {
    transform: translateX(100%);
}

.\\!k-translate-x-full {
    transform: translateX(100%) !important;
}

.k-translate-y-0 {
    transform: translateY(0);
}

.\\!k-translate-y-0 {
    transform: translateY(0) !important;
}

.k-translate-y-1px {
    transform: translateY(1px);
}

.\\!k-translate-y-1px {
    transform: translateY(1px) !important;
}

.k-translate-y-0\\.5 {
    transform: translateY(0.125rem);
}

.\\!k-translate-y-0\\.5 {
    transform: translateY(0.125rem) !important;
}

.k-translate-y-1 {
    transform: translateY(0.25rem);
}

.\\!k-translate-y-1 {
    transform: translateY(0.25rem) !important;
}

.k-translate-y-1\\.5 {
    transform: translateY(0.375rem);
}

.\\!k-translate-y-1\\.5 {
    transform: translateY(0.375rem) !important;
}

.k-translate-y-2 {
    transform: translateY(0.5rem);
}

.\\!k-translate-y-2 {
    transform: translateY(0.5rem) !important;
}

.k-translate-y-2\\.5 {
    transform: translateY(0.625rem);
}

.\\!k-translate-y-2\\.5 {
    transform: translateY(0.625rem) !important;
}

.k-translate-y-3 {
    transform: translateY(0.75rem);
}

.\\!k-translate-y-3 {
    transform: translateY(0.75rem) !important;
}

.k-translate-y-3\\.5 {
    transform: translateY(0.875rem);
}

.\\!k-translate-y-3\\.5 {
    transform: translateY(0.875rem) !important;
}

.k-translate-y-4 {
    transform: translateY(1rem);
}

.\\!k-translate-y-4 {
    transform: translateY(1rem) !important;
}

.k-translate-y-4\\.5 {
    transform: translateY(1.125rem);
}

.\\!k-translate-y-4\\.5 {
    transform: translateY(1.125rem) !important;
}

.k-translate-y-5 {
    transform: translateY(1.25rem);
}

.\\!k-translate-y-5 {
    transform: translateY(1.25rem) !important;
}

.k-translate-y-5\\.5 {
    transform: translateY(1.375rem);
}

.\\!k-translate-y-5\\.5 {
    transform: translateY(1.375rem) !important;
}

.k-translate-y-6 {
    transform: translateY(1.5rem);
}

.\\!k-translate-y-6 {
    transform: translateY(1.5rem) !important;
}

.k-translate-y-6\\.5 {
    transform: translateY(1.625rem);
}

.\\!k-translate-y-6\\.5 {
    transform: translateY(1.625rem) !important;
}

.k-translate-y-7 {
    transform: translateY(1.75rem);
}

.\\!k-translate-y-7 {
    transform: translateY(1.75rem) !important;
}

.k-translate-y-7\\.5 {
    transform: translateY(1.875rem);
}

.\\!k-translate-y-7\\.5 {
    transform: translateY(1.875rem) !important;
}

.k-translate-y-8 {
    transform: translateY(2rem);
}

.\\!k-translate-y-8 {
    transform: translateY(2rem) !important;
}

.k-translate-y-9 {
    transform: translateY(2.25rem);
}

.\\!k-translate-y-9 {
    transform: translateY(2.25rem) !important;
}

.k-translate-y-10 {
    transform: translateY(2.5rem);
}

.\\!k-translate-y-10 {
    transform: translateY(2.5rem) !important;
}

.k-translate-y-11 {
    transform: translateY(2.75rem);
}

.\\!k-translate-y-11 {
    transform: translateY(2.75rem) !important;
}

.k-translate-y-12 {
    transform: translateY(3rem);
}

.\\!k-translate-y-12 {
    transform: translateY(3rem) !important;
}

.k-translate-y-13 {
    transform: translateY(3.25rem);
}

.\\!k-translate-y-13 {
    transform: translateY(3.25rem) !important;
}

.k-translate-y-14 {
    transform: translateY(3.5rem);
}

.\\!k-translate-y-14 {
    transform: translateY(3.5rem) !important;
}

.k-translate-y-15 {
    transform: translateY(3.75rem);
}

.\\!k-translate-y-15 {
    transform: translateY(3.75rem) !important;
}

.k-translate-y-16 {
    transform: translateY(4rem);
}

.\\!k-translate-y-16 {
    transform: translateY(4rem) !important;
}

.k-translate-y-17 {
    transform: translateY(4.25rem);
}

.\\!k-translate-y-17 {
    transform: translateY(4.25rem) !important;
}

.k-translate-y-18 {
    transform: translateY(4.5rem);
}

.\\!k-translate-y-18 {
    transform: translateY(4.5rem) !important;
}

.k-translate-y-19 {
    transform: translateY(4.75rem);
}

.\\!k-translate-y-19 {
    transform: translateY(4.75rem) !important;
}

.k-translate-y-20 {
    transform: translateY(5rem);
}

.\\!k-translate-y-20 {
    transform: translateY(5rem) !important;
}

.k-translate-y-21 {
    transform: translateY(5.25rem);
}

.\\!k-translate-y-21 {
    transform: translateY(5.25rem) !important;
}

.k-translate-y-22 {
    transform: translateY(5.5rem);
}

.\\!k-translate-y-22 {
    transform: translateY(5.5rem) !important;
}

.k-translate-y-23 {
    transform: translateY(5.75rem);
}

.\\!k-translate-y-23 {
    transform: translateY(5.75rem) !important;
}

.k-translate-y-24 {
    transform: translateY(6rem);
}

.\\!k-translate-y-24 {
    transform: translateY(6rem) !important;
}

.k-translate-y-1\\/2 {
    transform: translateY(50%);
}

.\\!k-translate-y-1\\/2 {
    transform: translateY(50%) !important;
}

.k-translate-y-1\\/3 {
    transform: translateY(33.333333%);
}

.\\!k-translate-y-1\\/3 {
    transform: translateY(33.333333%) !important;
}

.k-translate-y-2\\/3 {
    transform: translateY(66.666667%);
}

.\\!k-translate-y-2\\/3 {
    transform: translateY(66.666667%) !important;
}

.k-translate-y-1\\/4 {
    transform: translateY(25%);
}

.\\!k-translate-y-1\\/4 {
    transform: translateY(25%) !important;
}

.k-translate-y-2\\/4 {
    transform: translateY(50%);
}

.\\!k-translate-y-2\\/4 {
    transform: translateY(50%) !important;
}

.k-translate-y-3\\/4 {
    transform: translateY(75%);
}

.\\!k-translate-y-3\\/4 {
    transform: translateY(75%) !important;
}

.k-translate-y-1\\/5 {
    transform: translateY(20%);
}

.\\!k-translate-y-1\\/5 {
    transform: translateY(20%) !important;
}

.k-translate-y-2\\/5 {
    transform: translateY(40%);
}

.\\!k-translate-y-2\\/5 {
    transform: translateY(40%) !important;
}

.k-translate-y-3\\/5 {
    transform: translateY(60%);
}

.\\!k-translate-y-3\\/5 {
    transform: translateY(60%) !important;
}

.k-translate-y-4\\/5 {
    transform: translateY(80%);
}

.\\!k-translate-y-4\\/5 {
    transform: translateY(80%) !important;
}

.k-translate-y-1\\/6 {
    transform: translateY(16.666667%);
}

.\\!k-translate-y-1\\/6 {
    transform: translateY(16.666667%) !important;
}

.k-translate-y-2\\/6 {
    transform: translateY(33.333333%);
}

.\\!k-translate-y-2\\/6 {
    transform: translateY(33.333333%) !important;
}

.k-translate-y-3\\/6 {
    transform: translateY(50%);
}

.\\!k-translate-y-3\\/6 {
    transform: translateY(50%) !important;
}

.k-translate-y-4\\/6 {
    transform: translateY(66.666667%);
}

.\\!k-translate-y-4\\/6 {
    transform: translateY(66.666667%) !important;
}

.k-translate-y-5\\/6 {
    transform: translateY(83.333333%);
}

.\\!k-translate-y-5\\/6 {
    transform: translateY(83.333333%) !important;
}

.k-translate-y-1\\/12 {
    transform: translateY(8.333333%);
}

.\\!k-translate-y-1\\/12 {
    transform: translateY(8.333333%) !important;
}

.k-translate-y-2\\/12 {
    transform: translateY(16.666667%);
}

.\\!k-translate-y-2\\/12 {
    transform: translateY(16.666667%) !important;
}

.k-translate-y-3\\/12 {
    transform: translateY(25%);
}

.\\!k-translate-y-3\\/12 {
    transform: translateY(25%) !important;
}

.k-translate-y-4\\/12 {
    transform: translateY(33.333333%);
}

.\\!k-translate-y-4\\/12 {
    transform: translateY(33.333333%) !important;
}

.k-translate-y-5\\/12 {
    transform: translateY(41.666667%);
}

.\\!k-translate-y-5\\/12 {
    transform: translateY(41.666667%) !important;
}

.k-translate-y-6\\/12 {
    transform: translateY(50%);
}

.\\!k-translate-y-6\\/12 {
    transform: translateY(50%) !important;
}

.k-translate-y-7\\/12 {
    transform: translateY(58.333333%);
}

.\\!k-translate-y-7\\/12 {
    transform: translateY(58.333333%) !important;
}

.k-translate-y-8\\/12 {
    transform: translateY(66.666667%);
}

.\\!k-translate-y-8\\/12 {
    transform: translateY(66.666667%) !important;
}

.k-translate-y-9\\/12 {
    transform: translateY(75%);
}

.\\!k-translate-y-9\\/12 {
    transform: translateY(75%) !important;
}

.k-translate-y-10\\/12 {
    transform: translateY(83.333333%);
}

.\\!k-translate-y-10\\/12 {
    transform: translateY(83.333333%) !important;
}

.k-translate-y-11\\/12 {
    transform: translateY(91.666667%);
}

.\\!k-translate-y-11\\/12 {
    transform: translateY(91.666667%) !important;
}

.k-translate-y-full {
    transform: translateY(100%);
}

.\\!k-translate-y-full {
    transform: translateY(100%) !important;
}

.k-appearance-none {
    appearance: none;
}

.\\!k-appearance-none {
    appearance: none !important;
}

.k-appearance-auto {
    appearance: auto;
}

.\\!k-appearance-auto {
    appearance: auto !important;
}

.k-cursor-none {
    cursor: none;
}

.\\!k-cursor-none {
    cursor: none !important;
}

.k-cursor-auto {
    cursor: auto;
}

.\\!k-cursor-auto {
    cursor: auto !important;
}

.k-cursor-default {
    cursor: default;
}

.\\!k-cursor-default {
    cursor: default !important;
}

.k-cursor-context-menu {
    cursor: context-menu;
}

.\\!k-cursor-context-menu {
    cursor: context-menu !important;
}

.k-cursor-help {
    cursor: help;
}

.\\!k-cursor-help {
    cursor: help !important;
}

.k-cursor-pointer {
    cursor: pointer;
}

.\\!k-cursor-pointer {
    cursor: pointer !important;
}

.k-cursor-progress {
    cursor: progress;
}

.\\!k-cursor-progress {
    cursor: progress !important;
}

.k-cursor-wait {
    cursor: wait;
}

.\\!k-cursor-wait {
    cursor: wait !important;
}

.k-cursor-cell {
    cursor: cell;
}

.\\!k-cursor-cell {
    cursor: cell !important;
}

.k-cursor-crosshair {
    cursor: crosshair;
}

.\\!k-cursor-crosshair {
    cursor: crosshair !important;
}

.k-cursor-text {
    cursor: text;
}

.\\!k-cursor-text {
    cursor: text !important;
}

.k-cursor-vertical-text {
    cursor: vertical-text;
}

.\\!k-cursor-vertical-text {
    cursor: vertical-text !important;
}

.k-cursor-alias {
    cursor: alias;
}

.\\!k-cursor-alias {
    cursor: alias !important;
}

.k-cursor-copy {
    cursor: copy;
}

.\\!k-cursor-copy {
    cursor: copy !important;
}

.k-cursor-move {
    cursor: move;
}

.\\!k-cursor-move {
    cursor: move !important;
}

.k-cursor-no-drop {
    cursor: no-drop;
}

.\\!k-cursor-no-drop {
    cursor: no-drop !important;
}

.k-cursor-not-allowed {
    cursor: not-allowed;
}

.\\!k-cursor-not-allowed {
    cursor: not-allowed !important;
}

.k-cursor-e-resize {
    cursor: e-resize;
}

.\\!k-cursor-e-resize {
    cursor: e-resize !important;
}

.k-cursor-n-resize {
    cursor: n-resize;
}

.\\!k-cursor-n-resize {
    cursor: n-resize !important;
}

.k-cursor-ne-resize {
    cursor: ne-resize;
}

.\\!k-cursor-ne-resize {
    cursor: ne-resize !important;
}

.k-cursor-nw-resize {
    cursor: nw-resize;
}

.\\!k-cursor-nw-resize {
    cursor: nw-resize !important;
}

.k-cursor-s-resize {
    cursor: s-resize;
}

.\\!k-cursor-s-resize {
    cursor: s-resize !important;
}

.k-cursor-se-resize {
    cursor: se-resize;
}

.\\!k-cursor-se-resize {
    cursor: se-resize !important;
}

.k-cursor-sw-resize {
    cursor: sw-resize;
}

.\\!k-cursor-sw-resize {
    cursor: sw-resize !important;
}

.k-cursor-w-resize {
    cursor: w-resize;
}

.\\!k-cursor-w-resize {
    cursor: w-resize !important;
}

.k-cursor-ew-resize {
    cursor: ew-resize;
}

.\\!k-cursor-ew-resize {
    cursor: ew-resize !important;
}

.k-cursor-ns-resize {
    cursor: ns-resize;
}

.\\!k-cursor-ns-resize {
    cursor: ns-resize !important;
}

.k-cursor-nesw-resize {
    cursor: nesw-resize;
}

.\\!k-cursor-nesw-resize {
    cursor: nesw-resize !important;
}

.k-cursor-nwse-resize {
    cursor: nwse-resize;
}

.\\!k-cursor-nwse-resize {
    cursor: nwse-resize !important;
}

.k-cursor-col-resize {
    cursor: col-resize;
}

.\\!k-cursor-col-resize {
    cursor: col-resize !important;
}

.k-cursor-row-resize {
    cursor: row-resize;
}

.\\!k-cursor-row-resize {
    cursor: row-resize !important;
}

.k-cursor-all-scroll {
    cursor: all-scroll;
}

.\\!k-cursor-all-scroll {
    cursor: all-scroll !important;
}

.k-cursor-zoom-in {
    cursor: zoom-in;
}

.\\!k-cursor-zoom-in {
    cursor: zoom-in !important;
}

.k-cursor-zoom-out {
    cursor: zoom-out;
}

.\\!k-cursor-zoom-out {
    cursor: zoom-out !important;
}

.k-cursor-grab {
    cursor: grab;
}

.\\!k-cursor-grab {
    cursor: grab !important;
}

.k-cursor-grabbing {
    cursor: grabbing;
}

.\\!k-cursor-grabbing {
    cursor: grabbing !important;
}

.k-pointer-events-none {
    pointer-events: none;
}

.\\!k-pointer-events-none {
    pointer-events: none !important;
}

.k-pointer-events-auto {
    pointer-events: auto;
}

.\\!k-pointer-events-auto {
    pointer-events: auto !important;
}

.k-resize {
    resize: both;
}

.\\!k-resize {
    resize: both !important;
}

.k-resize-none {
    resize: none;
}

.\\!k-resize-none {
    resize: none !important;
}

.k-resize-x {
    resize: horizontal;
}

.\\!k-resize-x {
    resize: horizontal !important;
}

.k-resize-y {
    resize: vertical;
}

.\\!k-resize-y {
    resize: vertical !important;
}

.k-scroll-auto {
    scroll-behavior: auto;
}

.\\!k-scroll-auto {
    scroll-behavior: auto !important;
}

.k-scroll-smooth {
    scroll-behavior: smooth;
}

.\\!k-scroll-smooth {
    scroll-behavior: smooth !important;
}

.k-scroll-snap-none {
    -ms-scroll-snap-type: none;
        scroll-snap-type: none;
}

.\\!k-scroll-snap-none {
    -ms-scroll-snap-type: none !important;
        scroll-snap-type: none !important;
}

.k-scroll-snap-snap-x {
    -ms-scroll-snap-type: x var(--k-scroll-snap-strictness);
        scroll-snap-type: x var(--k-scroll-snap-strictness);
}

.\\!k-scroll-snap-snap-x {
    -ms-scroll-snap-type: x var(--k-scroll-snap-strictness) !important;
        scroll-snap-type: x var(--k-scroll-snap-strictness) !important;
}

.k-scroll-snap-snap-y {
    -ms-scroll-snap-type: y var(--k-scroll-snap-strictness);
        scroll-snap-type: y var(--k-scroll-snap-strictness);
}

.\\!k-scroll-snap-snap-y {
    -ms-scroll-snap-type: y var(--k-scroll-snap-strictness) !important;
        scroll-snap-type: y var(--k-scroll-snap-strictness) !important;
}

.k-scroll-snap-snap-both {
    -ms-scroll-snap-type: both var(--k-scroll-snap-strictness);
        scroll-snap-type: both var(--k-scroll-snap-strictness);
}

.\\!k-scroll-snap-snap-both {
    -ms-scroll-snap-type: both var(--k-scroll-snap-strictness) !important;
        scroll-snap-type: both var(--k-scroll-snap-strictness) !important;
}

.k-scroll-snap-mandatory {
    --k-scroll-snap-strictness: mandatory;
}

.k-scroll-snap-proximity {
    --k-scroll-snap-strictness: proximity;
}

.k-scroll-snap-stop-normal {
    scroll-snap-stop: normal;
}

.\\!k-scroll-snap-stop-normal {
    scroll-snap-stop: normal !important;
}

.k-scroll-snap-stop-always {
    scroll-snap-stop: always;
}

.\\!k-scroll-snap-stop-always {
    scroll-snap-stop: always !important;
}

.k-scroll-snap-align-start {
    scroll-snap-align: start;
}

.\\!k-scroll-snap-align-start {
    scroll-snap-align: start !important;
}

.k-scroll-snap-align-end {
    scroll-snap-align: end;
}

.\\!k-scroll-snap-align-end {
    scroll-snap-align: end !important;
}

.k-scroll-snap-align-center {
    scroll-snap-align: center;
}

.\\!k-scroll-snap-align-center {
    scroll-snap-align: center !important;
}

.k-scroll-snap-align-none {
    scroll-snap-align: none;
}

.\\!k-scroll-snap-align-none {
    scroll-snap-align: none !important;
}

.k-scroll-m-0 {
    scroll-margin: 0;
}

.\\!k-scroll-m-0 {
    scroll-margin: 0 !important;
}

.k-scroll-m-1px {
    scroll-margin: 1px;
}

.\\!k-scroll-m-1px {
    scroll-margin: 1px !important;
}

.k-scroll-m-0\\.5 {
    scroll-margin: 0.125rem;
}

.\\!k-scroll-m-0\\.5 {
    scroll-margin: 0.125rem !important;
}

.k-scroll-m-1 {
    scroll-margin: 0.25rem;
}

.\\!k-scroll-m-1 {
    scroll-margin: 0.25rem !important;
}

.k-scroll-m-1\\.5 {
    scroll-margin: 0.375rem;
}

.\\!k-scroll-m-1\\.5 {
    scroll-margin: 0.375rem !important;
}

.k-scroll-m-2 {
    scroll-margin: 0.5rem;
}

.\\!k-scroll-m-2 {
    scroll-margin: 0.5rem !important;
}

.k-scroll-m-2\\.5 {
    scroll-margin: 0.625rem;
}

.\\!k-scroll-m-2\\.5 {
    scroll-margin: 0.625rem !important;
}

.k-scroll-m-3 {
    scroll-margin: 0.75rem;
}

.\\!k-scroll-m-3 {
    scroll-margin: 0.75rem !important;
}

.k-scroll-m-3\\.5 {
    scroll-margin: 0.875rem;
}

.\\!k-scroll-m-3\\.5 {
    scroll-margin: 0.875rem !important;
}

.k-scroll-m-4 {
    scroll-margin: 1rem;
}

.\\!k-scroll-m-4 {
    scroll-margin: 1rem !important;
}

.k-scroll-m-4\\.5 {
    scroll-margin: 1.125rem;
}

.\\!k-scroll-m-4\\.5 {
    scroll-margin: 1.125rem !important;
}

.k-scroll-m-5 {
    scroll-margin: 1.25rem;
}

.\\!k-scroll-m-5 {
    scroll-margin: 1.25rem !important;
}

.k-scroll-m-5\\.5 {
    scroll-margin: 1.375rem;
}

.\\!k-scroll-m-5\\.5 {
    scroll-margin: 1.375rem !important;
}

.k-scroll-m-6 {
    scroll-margin: 1.5rem;
}

.\\!k-scroll-m-6 {
    scroll-margin: 1.5rem !important;
}

.k-scroll-m-6\\.5 {
    scroll-margin: 1.625rem;
}

.\\!k-scroll-m-6\\.5 {
    scroll-margin: 1.625rem !important;
}

.k-scroll-m-7 {
    scroll-margin: 1.75rem;
}

.\\!k-scroll-m-7 {
    scroll-margin: 1.75rem !important;
}

.k-scroll-m-7\\.5 {
    scroll-margin: 1.875rem;
}

.\\!k-scroll-m-7\\.5 {
    scroll-margin: 1.875rem !important;
}

.k-scroll-m-8 {
    scroll-margin: 2rem;
}

.\\!k-scroll-m-8 {
    scroll-margin: 2rem !important;
}

.k-scroll-m-9 {
    scroll-margin: 2.25rem;
}

.\\!k-scroll-m-9 {
    scroll-margin: 2.25rem !important;
}

.k-scroll-m-10 {
    scroll-margin: 2.5rem;
}

.\\!k-scroll-m-10 {
    scroll-margin: 2.5rem !important;
}

.k-scroll-m-11 {
    scroll-margin: 2.75rem;
}

.\\!k-scroll-m-11 {
    scroll-margin: 2.75rem !important;
}

.k-scroll-m-12 {
    scroll-margin: 3rem;
}

.\\!k-scroll-m-12 {
    scroll-margin: 3rem !important;
}

.k-scroll-m-13 {
    scroll-margin: 3.25rem;
}

.\\!k-scroll-m-13 {
    scroll-margin: 3.25rem !important;
}

.k-scroll-m-14 {
    scroll-margin: 3.5rem;
}

.\\!k-scroll-m-14 {
    scroll-margin: 3.5rem !important;
}

.k-scroll-m-15 {
    scroll-margin: 3.75rem;
}

.\\!k-scroll-m-15 {
    scroll-margin: 3.75rem !important;
}

.k-scroll-m-16 {
    scroll-margin: 4rem;
}

.\\!k-scroll-m-16 {
    scroll-margin: 4rem !important;
}

.k-scroll-m-17 {
    scroll-margin: 4.25rem;
}

.\\!k-scroll-m-17 {
    scroll-margin: 4.25rem !important;
}

.k-scroll-m-18 {
    scroll-margin: 4.5rem;
}

.\\!k-scroll-m-18 {
    scroll-margin: 4.5rem !important;
}

.k-scroll-m-19 {
    scroll-margin: 4.75rem;
}

.\\!k-scroll-m-19 {
    scroll-margin: 4.75rem !important;
}

.k-scroll-m-20 {
    scroll-margin: 5rem;
}

.\\!k-scroll-m-20 {
    scroll-margin: 5rem !important;
}

.k-scroll-m-21 {
    scroll-margin: 5.25rem;
}

.\\!k-scroll-m-21 {
    scroll-margin: 5.25rem !important;
}

.k-scroll-m-22 {
    scroll-margin: 5.5rem;
}

.\\!k-scroll-m-22 {
    scroll-margin: 5.5rem !important;
}

.k-scroll-m-23 {
    scroll-margin: 5.75rem;
}

.\\!k-scroll-m-23 {
    scroll-margin: 5.75rem !important;
}

.k-scroll-m-24 {
    scroll-margin: 6rem;
}

.\\!k-scroll-m-24 {
    scroll-margin: 6rem !important;
}

.k-scroll-mt-0 {
    scroll-margin-top: 0;
}

.\\!k-scroll-mt-0 {
    scroll-margin-top: 0 !important;
}

.k-scroll-mt-1px {
    scroll-margin-top: 1px;
}

.\\!k-scroll-mt-1px {
    scroll-margin-top: 1px !important;
}

.k-scroll-mt-0\\.5 {
    scroll-margin-top: 0.125rem;
}

.\\!k-scroll-mt-0\\.5 {
    scroll-margin-top: 0.125rem !important;
}

.k-scroll-mt-1 {
    scroll-margin-top: 0.25rem;
}

.\\!k-scroll-mt-1 {
    scroll-margin-top: 0.25rem !important;
}

.k-scroll-mt-1\\.5 {
    scroll-margin-top: 0.375rem;
}

.\\!k-scroll-mt-1\\.5 {
    scroll-margin-top: 0.375rem !important;
}

.k-scroll-mt-2 {
    scroll-margin-top: 0.5rem;
}

.\\!k-scroll-mt-2 {
    scroll-margin-top: 0.5rem !important;
}

.k-scroll-mt-2\\.5 {
    scroll-margin-top: 0.625rem;
}

.\\!k-scroll-mt-2\\.5 {
    scroll-margin-top: 0.625rem !important;
}

.k-scroll-mt-3 {
    scroll-margin-top: 0.75rem;
}

.\\!k-scroll-mt-3 {
    scroll-margin-top: 0.75rem !important;
}

.k-scroll-mt-3\\.5 {
    scroll-margin-top: 0.875rem;
}

.\\!k-scroll-mt-3\\.5 {
    scroll-margin-top: 0.875rem !important;
}

.k-scroll-mt-4 {
    scroll-margin-top: 1rem;
}

.\\!k-scroll-mt-4 {
    scroll-margin-top: 1rem !important;
}

.k-scroll-mt-4\\.5 {
    scroll-margin-top: 1.125rem;
}

.\\!k-scroll-mt-4\\.5 {
    scroll-margin-top: 1.125rem !important;
}

.k-scroll-mt-5 {
    scroll-margin-top: 1.25rem;
}

.\\!k-scroll-mt-5 {
    scroll-margin-top: 1.25rem !important;
}

.k-scroll-mt-5\\.5 {
    scroll-margin-top: 1.375rem;
}

.\\!k-scroll-mt-5\\.5 {
    scroll-margin-top: 1.375rem !important;
}

.k-scroll-mt-6 {
    scroll-margin-top: 1.5rem;
}

.\\!k-scroll-mt-6 {
    scroll-margin-top: 1.5rem !important;
}

.k-scroll-mt-6\\.5 {
    scroll-margin-top: 1.625rem;
}

.\\!k-scroll-mt-6\\.5 {
    scroll-margin-top: 1.625rem !important;
}

.k-scroll-mt-7 {
    scroll-margin-top: 1.75rem;
}

.\\!k-scroll-mt-7 {
    scroll-margin-top: 1.75rem !important;
}

.k-scroll-mt-7\\.5 {
    scroll-margin-top: 1.875rem;
}

.\\!k-scroll-mt-7\\.5 {
    scroll-margin-top: 1.875rem !important;
}

.k-scroll-mt-8 {
    scroll-margin-top: 2rem;
}

.\\!k-scroll-mt-8 {
    scroll-margin-top: 2rem !important;
}

.k-scroll-mt-9 {
    scroll-margin-top: 2.25rem;
}

.\\!k-scroll-mt-9 {
    scroll-margin-top: 2.25rem !important;
}

.k-scroll-mt-10 {
    scroll-margin-top: 2.5rem;
}

.\\!k-scroll-mt-10 {
    scroll-margin-top: 2.5rem !important;
}

.k-scroll-mt-11 {
    scroll-margin-top: 2.75rem;
}

.\\!k-scroll-mt-11 {
    scroll-margin-top: 2.75rem !important;
}

.k-scroll-mt-12 {
    scroll-margin-top: 3rem;
}

.\\!k-scroll-mt-12 {
    scroll-margin-top: 3rem !important;
}

.k-scroll-mt-13 {
    scroll-margin-top: 3.25rem;
}

.\\!k-scroll-mt-13 {
    scroll-margin-top: 3.25rem !important;
}

.k-scroll-mt-14 {
    scroll-margin-top: 3.5rem;
}

.\\!k-scroll-mt-14 {
    scroll-margin-top: 3.5rem !important;
}

.k-scroll-mt-15 {
    scroll-margin-top: 3.75rem;
}

.\\!k-scroll-mt-15 {
    scroll-margin-top: 3.75rem !important;
}

.k-scroll-mt-16 {
    scroll-margin-top: 4rem;
}

.\\!k-scroll-mt-16 {
    scroll-margin-top: 4rem !important;
}

.k-scroll-mt-17 {
    scroll-margin-top: 4.25rem;
}

.\\!k-scroll-mt-17 {
    scroll-margin-top: 4.25rem !important;
}

.k-scroll-mt-18 {
    scroll-margin-top: 4.5rem;
}

.\\!k-scroll-mt-18 {
    scroll-margin-top: 4.5rem !important;
}

.k-scroll-mt-19 {
    scroll-margin-top: 4.75rem;
}

.\\!k-scroll-mt-19 {
    scroll-margin-top: 4.75rem !important;
}

.k-scroll-mt-20 {
    scroll-margin-top: 5rem;
}

.\\!k-scroll-mt-20 {
    scroll-margin-top: 5rem !important;
}

.k-scroll-mt-21 {
    scroll-margin-top: 5.25rem;
}

.\\!k-scroll-mt-21 {
    scroll-margin-top: 5.25rem !important;
}

.k-scroll-mt-22 {
    scroll-margin-top: 5.5rem;
}

.\\!k-scroll-mt-22 {
    scroll-margin-top: 5.5rem !important;
}

.k-scroll-mt-23 {
    scroll-margin-top: 5.75rem;
}

.\\!k-scroll-mt-23 {
    scroll-margin-top: 5.75rem !important;
}

.k-scroll-mt-24 {
    scroll-margin-top: 6rem;
}

.\\!k-scroll-mt-24 {
    scroll-margin-top: 6rem !important;
}

.k-scroll-mr-0 {
    scroll-margin-right: 0;
}

.\\!k-scroll-mr-0 {
    scroll-margin-right: 0 !important;
}

.k-scroll-mr-1px {
    scroll-margin-right: 1px;
}

.\\!k-scroll-mr-1px {
    scroll-margin-right: 1px !important;
}

.k-scroll-mr-0\\.5 {
    scroll-margin-right: 0.125rem;
}

.\\!k-scroll-mr-0\\.5 {
    scroll-margin-right: 0.125rem !important;
}

.k-scroll-mr-1 {
    scroll-margin-right: 0.25rem;
}

.\\!k-scroll-mr-1 {
    scroll-margin-right: 0.25rem !important;
}

.k-scroll-mr-1\\.5 {
    scroll-margin-right: 0.375rem;
}

.\\!k-scroll-mr-1\\.5 {
    scroll-margin-right: 0.375rem !important;
}

.k-scroll-mr-2 {
    scroll-margin-right: 0.5rem;
}

.\\!k-scroll-mr-2 {
    scroll-margin-right: 0.5rem !important;
}

.k-scroll-mr-2\\.5 {
    scroll-margin-right: 0.625rem;
}

.\\!k-scroll-mr-2\\.5 {
    scroll-margin-right: 0.625rem !important;
}

.k-scroll-mr-3 {
    scroll-margin-right: 0.75rem;
}

.\\!k-scroll-mr-3 {
    scroll-margin-right: 0.75rem !important;
}

.k-scroll-mr-3\\.5 {
    scroll-margin-right: 0.875rem;
}

.\\!k-scroll-mr-3\\.5 {
    scroll-margin-right: 0.875rem !important;
}

.k-scroll-mr-4 {
    scroll-margin-right: 1rem;
}

.\\!k-scroll-mr-4 {
    scroll-margin-right: 1rem !important;
}

.k-scroll-mr-4\\.5 {
    scroll-margin-right: 1.125rem;
}

.\\!k-scroll-mr-4\\.5 {
    scroll-margin-right: 1.125rem !important;
}

.k-scroll-mr-5 {
    scroll-margin-right: 1.25rem;
}

.\\!k-scroll-mr-5 {
    scroll-margin-right: 1.25rem !important;
}

.k-scroll-mr-5\\.5 {
    scroll-margin-right: 1.375rem;
}

.\\!k-scroll-mr-5\\.5 {
    scroll-margin-right: 1.375rem !important;
}

.k-scroll-mr-6 {
    scroll-margin-right: 1.5rem;
}

.\\!k-scroll-mr-6 {
    scroll-margin-right: 1.5rem !important;
}

.k-scroll-mr-6\\.5 {
    scroll-margin-right: 1.625rem;
}

.\\!k-scroll-mr-6\\.5 {
    scroll-margin-right: 1.625rem !important;
}

.k-scroll-mr-7 {
    scroll-margin-right: 1.75rem;
}

.\\!k-scroll-mr-7 {
    scroll-margin-right: 1.75rem !important;
}

.k-scroll-mr-7\\.5 {
    scroll-margin-right: 1.875rem;
}

.\\!k-scroll-mr-7\\.5 {
    scroll-margin-right: 1.875rem !important;
}

.k-scroll-mr-8 {
    scroll-margin-right: 2rem;
}

.\\!k-scroll-mr-8 {
    scroll-margin-right: 2rem !important;
}

.k-scroll-mr-9 {
    scroll-margin-right: 2.25rem;
}

.\\!k-scroll-mr-9 {
    scroll-margin-right: 2.25rem !important;
}

.k-scroll-mr-10 {
    scroll-margin-right: 2.5rem;
}

.\\!k-scroll-mr-10 {
    scroll-margin-right: 2.5rem !important;
}

.k-scroll-mr-11 {
    scroll-margin-right: 2.75rem;
}

.\\!k-scroll-mr-11 {
    scroll-margin-right: 2.75rem !important;
}

.k-scroll-mr-12 {
    scroll-margin-right: 3rem;
}

.\\!k-scroll-mr-12 {
    scroll-margin-right: 3rem !important;
}

.k-scroll-mr-13 {
    scroll-margin-right: 3.25rem;
}

.\\!k-scroll-mr-13 {
    scroll-margin-right: 3.25rem !important;
}

.k-scroll-mr-14 {
    scroll-margin-right: 3.5rem;
}

.\\!k-scroll-mr-14 {
    scroll-margin-right: 3.5rem !important;
}

.k-scroll-mr-15 {
    scroll-margin-right: 3.75rem;
}

.\\!k-scroll-mr-15 {
    scroll-margin-right: 3.75rem !important;
}

.k-scroll-mr-16 {
    scroll-margin-right: 4rem;
}

.\\!k-scroll-mr-16 {
    scroll-margin-right: 4rem !important;
}

.k-scroll-mr-17 {
    scroll-margin-right: 4.25rem;
}

.\\!k-scroll-mr-17 {
    scroll-margin-right: 4.25rem !important;
}

.k-scroll-mr-18 {
    scroll-margin-right: 4.5rem;
}

.\\!k-scroll-mr-18 {
    scroll-margin-right: 4.5rem !important;
}

.k-scroll-mr-19 {
    scroll-margin-right: 4.75rem;
}

.\\!k-scroll-mr-19 {
    scroll-margin-right: 4.75rem !important;
}

.k-scroll-mr-20 {
    scroll-margin-right: 5rem;
}

.\\!k-scroll-mr-20 {
    scroll-margin-right: 5rem !important;
}

.k-scroll-mr-21 {
    scroll-margin-right: 5.25rem;
}

.\\!k-scroll-mr-21 {
    scroll-margin-right: 5.25rem !important;
}

.k-scroll-mr-22 {
    scroll-margin-right: 5.5rem;
}

.\\!k-scroll-mr-22 {
    scroll-margin-right: 5.5rem !important;
}

.k-scroll-mr-23 {
    scroll-margin-right: 5.75rem;
}

.\\!k-scroll-mr-23 {
    scroll-margin-right: 5.75rem !important;
}

.k-scroll-mr-24 {
    scroll-margin-right: 6rem;
}

.\\!k-scroll-mr-24 {
    scroll-margin-right: 6rem !important;
}

.k-scroll-mb-0 {
    scroll-margin-bottom: 0;
}

.\\!k-scroll-mb-0 {
    scroll-margin-bottom: 0 !important;
}

.k-scroll-mb-1px {
    scroll-margin-bottom: 1px;
}

.\\!k-scroll-mb-1px {
    scroll-margin-bottom: 1px !important;
}

.k-scroll-mb-0\\.5 {
    scroll-margin-bottom: 0.125rem;
}

.\\!k-scroll-mb-0\\.5 {
    scroll-margin-bottom: 0.125rem !important;
}

.k-scroll-mb-1 {
    scroll-margin-bottom: 0.25rem;
}

.\\!k-scroll-mb-1 {
    scroll-margin-bottom: 0.25rem !important;
}

.k-scroll-mb-1\\.5 {
    scroll-margin-bottom: 0.375rem;
}

.\\!k-scroll-mb-1\\.5 {
    scroll-margin-bottom: 0.375rem !important;
}

.k-scroll-mb-2 {
    scroll-margin-bottom: 0.5rem;
}

.\\!k-scroll-mb-2 {
    scroll-margin-bottom: 0.5rem !important;
}

.k-scroll-mb-2\\.5 {
    scroll-margin-bottom: 0.625rem;
}

.\\!k-scroll-mb-2\\.5 {
    scroll-margin-bottom: 0.625rem !important;
}

.k-scroll-mb-3 {
    scroll-margin-bottom: 0.75rem;
}

.\\!k-scroll-mb-3 {
    scroll-margin-bottom: 0.75rem !important;
}

.k-scroll-mb-3\\.5 {
    scroll-margin-bottom: 0.875rem;
}

.\\!k-scroll-mb-3\\.5 {
    scroll-margin-bottom: 0.875rem !important;
}

.k-scroll-mb-4 {
    scroll-margin-bottom: 1rem;
}

.\\!k-scroll-mb-4 {
    scroll-margin-bottom: 1rem !important;
}

.k-scroll-mb-4\\.5 {
    scroll-margin-bottom: 1.125rem;
}

.\\!k-scroll-mb-4\\.5 {
    scroll-margin-bottom: 1.125rem !important;
}

.k-scroll-mb-5 {
    scroll-margin-bottom: 1.25rem;
}

.\\!k-scroll-mb-5 {
    scroll-margin-bottom: 1.25rem !important;
}

.k-scroll-mb-5\\.5 {
    scroll-margin-bottom: 1.375rem;
}

.\\!k-scroll-mb-5\\.5 {
    scroll-margin-bottom: 1.375rem !important;
}

.k-scroll-mb-6 {
    scroll-margin-bottom: 1.5rem;
}

.\\!k-scroll-mb-6 {
    scroll-margin-bottom: 1.5rem !important;
}

.k-scroll-mb-6\\.5 {
    scroll-margin-bottom: 1.625rem;
}

.\\!k-scroll-mb-6\\.5 {
    scroll-margin-bottom: 1.625rem !important;
}

.k-scroll-mb-7 {
    scroll-margin-bottom: 1.75rem;
}

.\\!k-scroll-mb-7 {
    scroll-margin-bottom: 1.75rem !important;
}

.k-scroll-mb-7\\.5 {
    scroll-margin-bottom: 1.875rem;
}

.\\!k-scroll-mb-7\\.5 {
    scroll-margin-bottom: 1.875rem !important;
}

.k-scroll-mb-8 {
    scroll-margin-bottom: 2rem;
}

.\\!k-scroll-mb-8 {
    scroll-margin-bottom: 2rem !important;
}

.k-scroll-mb-9 {
    scroll-margin-bottom: 2.25rem;
}

.\\!k-scroll-mb-9 {
    scroll-margin-bottom: 2.25rem !important;
}

.k-scroll-mb-10 {
    scroll-margin-bottom: 2.5rem;
}

.\\!k-scroll-mb-10 {
    scroll-margin-bottom: 2.5rem !important;
}

.k-scroll-mb-11 {
    scroll-margin-bottom: 2.75rem;
}

.\\!k-scroll-mb-11 {
    scroll-margin-bottom: 2.75rem !important;
}

.k-scroll-mb-12 {
    scroll-margin-bottom: 3rem;
}

.\\!k-scroll-mb-12 {
    scroll-margin-bottom: 3rem !important;
}

.k-scroll-mb-13 {
    scroll-margin-bottom: 3.25rem;
}

.\\!k-scroll-mb-13 {
    scroll-margin-bottom: 3.25rem !important;
}

.k-scroll-mb-14 {
    scroll-margin-bottom: 3.5rem;
}

.\\!k-scroll-mb-14 {
    scroll-margin-bottom: 3.5rem !important;
}

.k-scroll-mb-15 {
    scroll-margin-bottom: 3.75rem;
}

.\\!k-scroll-mb-15 {
    scroll-margin-bottom: 3.75rem !important;
}

.k-scroll-mb-16 {
    scroll-margin-bottom: 4rem;
}

.\\!k-scroll-mb-16 {
    scroll-margin-bottom: 4rem !important;
}

.k-scroll-mb-17 {
    scroll-margin-bottom: 4.25rem;
}

.\\!k-scroll-mb-17 {
    scroll-margin-bottom: 4.25rem !important;
}

.k-scroll-mb-18 {
    scroll-margin-bottom: 4.5rem;
}

.\\!k-scroll-mb-18 {
    scroll-margin-bottom: 4.5rem !important;
}

.k-scroll-mb-19 {
    scroll-margin-bottom: 4.75rem;
}

.\\!k-scroll-mb-19 {
    scroll-margin-bottom: 4.75rem !important;
}

.k-scroll-mb-20 {
    scroll-margin-bottom: 5rem;
}

.\\!k-scroll-mb-20 {
    scroll-margin-bottom: 5rem !important;
}

.k-scroll-mb-21 {
    scroll-margin-bottom: 5.25rem;
}

.\\!k-scroll-mb-21 {
    scroll-margin-bottom: 5.25rem !important;
}

.k-scroll-mb-22 {
    scroll-margin-bottom: 5.5rem;
}

.\\!k-scroll-mb-22 {
    scroll-margin-bottom: 5.5rem !important;
}

.k-scroll-mb-23 {
    scroll-margin-bottom: 5.75rem;
}

.\\!k-scroll-mb-23 {
    scroll-margin-bottom: 5.75rem !important;
}

.k-scroll-mb-24 {
    scroll-margin-bottom: 6rem;
}

.\\!k-scroll-mb-24 {
    scroll-margin-bottom: 6rem !important;
}

.k-scroll-ml-0 {
    scroll-margin-left: 0;
}

.\\!k-scroll-ml-0 {
    scroll-margin-left: 0 !important;
}

.k-scroll-ml-1px {
    scroll-margin-left: 1px;
}

.\\!k-scroll-ml-1px {
    scroll-margin-left: 1px !important;
}

.k-scroll-ml-0\\.5 {
    scroll-margin-left: 0.125rem;
}

.\\!k-scroll-ml-0\\.5 {
    scroll-margin-left: 0.125rem !important;
}

.k-scroll-ml-1 {
    scroll-margin-left: 0.25rem;
}

.\\!k-scroll-ml-1 {
    scroll-margin-left: 0.25rem !important;
}

.k-scroll-ml-1\\.5 {
    scroll-margin-left: 0.375rem;
}

.\\!k-scroll-ml-1\\.5 {
    scroll-margin-left: 0.375rem !important;
}

.k-scroll-ml-2 {
    scroll-margin-left: 0.5rem;
}

.\\!k-scroll-ml-2 {
    scroll-margin-left: 0.5rem !important;
}

.k-scroll-ml-2\\.5 {
    scroll-margin-left: 0.625rem;
}

.\\!k-scroll-ml-2\\.5 {
    scroll-margin-left: 0.625rem !important;
}

.k-scroll-ml-3 {
    scroll-margin-left: 0.75rem;
}

.\\!k-scroll-ml-3 {
    scroll-margin-left: 0.75rem !important;
}

.k-scroll-ml-3\\.5 {
    scroll-margin-left: 0.875rem;
}

.\\!k-scroll-ml-3\\.5 {
    scroll-margin-left: 0.875rem !important;
}

.k-scroll-ml-4 {
    scroll-margin-left: 1rem;
}

.\\!k-scroll-ml-4 {
    scroll-margin-left: 1rem !important;
}

.k-scroll-ml-4\\.5 {
    scroll-margin-left: 1.125rem;
}

.\\!k-scroll-ml-4\\.5 {
    scroll-margin-left: 1.125rem !important;
}

.k-scroll-ml-5 {
    scroll-margin-left: 1.25rem;
}

.\\!k-scroll-ml-5 {
    scroll-margin-left: 1.25rem !important;
}

.k-scroll-ml-5\\.5 {
    scroll-margin-left: 1.375rem;
}

.\\!k-scroll-ml-5\\.5 {
    scroll-margin-left: 1.375rem !important;
}

.k-scroll-ml-6 {
    scroll-margin-left: 1.5rem;
}

.\\!k-scroll-ml-6 {
    scroll-margin-left: 1.5rem !important;
}

.k-scroll-ml-6\\.5 {
    scroll-margin-left: 1.625rem;
}

.\\!k-scroll-ml-6\\.5 {
    scroll-margin-left: 1.625rem !important;
}

.k-scroll-ml-7 {
    scroll-margin-left: 1.75rem;
}

.\\!k-scroll-ml-7 {
    scroll-margin-left: 1.75rem !important;
}

.k-scroll-ml-7\\.5 {
    scroll-margin-left: 1.875rem;
}

.\\!k-scroll-ml-7\\.5 {
    scroll-margin-left: 1.875rem !important;
}

.k-scroll-ml-8 {
    scroll-margin-left: 2rem;
}

.\\!k-scroll-ml-8 {
    scroll-margin-left: 2rem !important;
}

.k-scroll-ml-9 {
    scroll-margin-left: 2.25rem;
}

.\\!k-scroll-ml-9 {
    scroll-margin-left: 2.25rem !important;
}

.k-scroll-ml-10 {
    scroll-margin-left: 2.5rem;
}

.\\!k-scroll-ml-10 {
    scroll-margin-left: 2.5rem !important;
}

.k-scroll-ml-11 {
    scroll-margin-left: 2.75rem;
}

.\\!k-scroll-ml-11 {
    scroll-margin-left: 2.75rem !important;
}

.k-scroll-ml-12 {
    scroll-margin-left: 3rem;
}

.\\!k-scroll-ml-12 {
    scroll-margin-left: 3rem !important;
}

.k-scroll-ml-13 {
    scroll-margin-left: 3.25rem;
}

.\\!k-scroll-ml-13 {
    scroll-margin-left: 3.25rem !important;
}

.k-scroll-ml-14 {
    scroll-margin-left: 3.5rem;
}

.\\!k-scroll-ml-14 {
    scroll-margin-left: 3.5rem !important;
}

.k-scroll-ml-15 {
    scroll-margin-left: 3.75rem;
}

.\\!k-scroll-ml-15 {
    scroll-margin-left: 3.75rem !important;
}

.k-scroll-ml-16 {
    scroll-margin-left: 4rem;
}

.\\!k-scroll-ml-16 {
    scroll-margin-left: 4rem !important;
}

.k-scroll-ml-17 {
    scroll-margin-left: 4.25rem;
}

.\\!k-scroll-ml-17 {
    scroll-margin-left: 4.25rem !important;
}

.k-scroll-ml-18 {
    scroll-margin-left: 4.5rem;
}

.\\!k-scroll-ml-18 {
    scroll-margin-left: 4.5rem !important;
}

.k-scroll-ml-19 {
    scroll-margin-left: 4.75rem;
}

.\\!k-scroll-ml-19 {
    scroll-margin-left: 4.75rem !important;
}

.k-scroll-ml-20 {
    scroll-margin-left: 5rem;
}

.\\!k-scroll-ml-20 {
    scroll-margin-left: 5rem !important;
}

.k-scroll-ml-21 {
    scroll-margin-left: 5.25rem;
}

.\\!k-scroll-ml-21 {
    scroll-margin-left: 5.25rem !important;
}

.k-scroll-ml-22 {
    scroll-margin-left: 5.5rem;
}

.\\!k-scroll-ml-22 {
    scroll-margin-left: 5.5rem !important;
}

.k-scroll-ml-23 {
    scroll-margin-left: 5.75rem;
}

.\\!k-scroll-ml-23 {
    scroll-margin-left: 5.75rem !important;
}

.k-scroll-ml-24 {
    scroll-margin-left: 6rem;
}

.\\!k-scroll-ml-24 {
    scroll-margin-left: 6rem !important;
}

.k-scroll-mx-0 {
    scroll-margin-inline: 0;
}

.\\!k-scroll-mx-0 {
    scroll-margin-inline: 0 !important;
}

.k-scroll-mx-1px {
    scroll-margin-inline: 1px;
}

.\\!k-scroll-mx-1px {
    scroll-margin-inline: 1px !important;
}

.k-scroll-mx-0\\.5 {
    scroll-margin-inline: 0.125rem;
}

.\\!k-scroll-mx-0\\.5 {
    scroll-margin-inline: 0.125rem !important;
}

.k-scroll-mx-1 {
    scroll-margin-inline: 0.25rem;
}

.\\!k-scroll-mx-1 {
    scroll-margin-inline: 0.25rem !important;
}

.k-scroll-mx-1\\.5 {
    scroll-margin-inline: 0.375rem;
}

.\\!k-scroll-mx-1\\.5 {
    scroll-margin-inline: 0.375rem !important;
}

.k-scroll-mx-2 {
    scroll-margin-inline: 0.5rem;
}

.\\!k-scroll-mx-2 {
    scroll-margin-inline: 0.5rem !important;
}

.k-scroll-mx-2\\.5 {
    scroll-margin-inline: 0.625rem;
}

.\\!k-scroll-mx-2\\.5 {
    scroll-margin-inline: 0.625rem !important;
}

.k-scroll-mx-3 {
    scroll-margin-inline: 0.75rem;
}

.\\!k-scroll-mx-3 {
    scroll-margin-inline: 0.75rem !important;
}

.k-scroll-mx-3\\.5 {
    scroll-margin-inline: 0.875rem;
}

.\\!k-scroll-mx-3\\.5 {
    scroll-margin-inline: 0.875rem !important;
}

.k-scroll-mx-4 {
    scroll-margin-inline: 1rem;
}

.\\!k-scroll-mx-4 {
    scroll-margin-inline: 1rem !important;
}

.k-scroll-mx-4\\.5 {
    scroll-margin-inline: 1.125rem;
}

.\\!k-scroll-mx-4\\.5 {
    scroll-margin-inline: 1.125rem !important;
}

.k-scroll-mx-5 {
    scroll-margin-inline: 1.25rem;
}

.\\!k-scroll-mx-5 {
    scroll-margin-inline: 1.25rem !important;
}

.k-scroll-mx-5\\.5 {
    scroll-margin-inline: 1.375rem;
}

.\\!k-scroll-mx-5\\.5 {
    scroll-margin-inline: 1.375rem !important;
}

.k-scroll-mx-6 {
    scroll-margin-inline: 1.5rem;
}

.\\!k-scroll-mx-6 {
    scroll-margin-inline: 1.5rem !important;
}

.k-scroll-mx-6\\.5 {
    scroll-margin-inline: 1.625rem;
}

.\\!k-scroll-mx-6\\.5 {
    scroll-margin-inline: 1.625rem !important;
}

.k-scroll-mx-7 {
    scroll-margin-inline: 1.75rem;
}

.\\!k-scroll-mx-7 {
    scroll-margin-inline: 1.75rem !important;
}

.k-scroll-mx-7\\.5 {
    scroll-margin-inline: 1.875rem;
}

.\\!k-scroll-mx-7\\.5 {
    scroll-margin-inline: 1.875rem !important;
}

.k-scroll-mx-8 {
    scroll-margin-inline: 2rem;
}

.\\!k-scroll-mx-8 {
    scroll-margin-inline: 2rem !important;
}

.k-scroll-mx-9 {
    scroll-margin-inline: 2.25rem;
}

.\\!k-scroll-mx-9 {
    scroll-margin-inline: 2.25rem !important;
}

.k-scroll-mx-10 {
    scroll-margin-inline: 2.5rem;
}

.\\!k-scroll-mx-10 {
    scroll-margin-inline: 2.5rem !important;
}

.k-scroll-mx-11 {
    scroll-margin-inline: 2.75rem;
}

.\\!k-scroll-mx-11 {
    scroll-margin-inline: 2.75rem !important;
}

.k-scroll-mx-12 {
    scroll-margin-inline: 3rem;
}

.\\!k-scroll-mx-12 {
    scroll-margin-inline: 3rem !important;
}

.k-scroll-mx-13 {
    scroll-margin-inline: 3.25rem;
}

.\\!k-scroll-mx-13 {
    scroll-margin-inline: 3.25rem !important;
}

.k-scroll-mx-14 {
    scroll-margin-inline: 3.5rem;
}

.\\!k-scroll-mx-14 {
    scroll-margin-inline: 3.5rem !important;
}

.k-scroll-mx-15 {
    scroll-margin-inline: 3.75rem;
}

.\\!k-scroll-mx-15 {
    scroll-margin-inline: 3.75rem !important;
}

.k-scroll-mx-16 {
    scroll-margin-inline: 4rem;
}

.\\!k-scroll-mx-16 {
    scroll-margin-inline: 4rem !important;
}

.k-scroll-mx-17 {
    scroll-margin-inline: 4.25rem;
}

.\\!k-scroll-mx-17 {
    scroll-margin-inline: 4.25rem !important;
}

.k-scroll-mx-18 {
    scroll-margin-inline: 4.5rem;
}

.\\!k-scroll-mx-18 {
    scroll-margin-inline: 4.5rem !important;
}

.k-scroll-mx-19 {
    scroll-margin-inline: 4.75rem;
}

.\\!k-scroll-mx-19 {
    scroll-margin-inline: 4.75rem !important;
}

.k-scroll-mx-20 {
    scroll-margin-inline: 5rem;
}

.\\!k-scroll-mx-20 {
    scroll-margin-inline: 5rem !important;
}

.k-scroll-mx-21 {
    scroll-margin-inline: 5.25rem;
}

.\\!k-scroll-mx-21 {
    scroll-margin-inline: 5.25rem !important;
}

.k-scroll-mx-22 {
    scroll-margin-inline: 5.5rem;
}

.\\!k-scroll-mx-22 {
    scroll-margin-inline: 5.5rem !important;
}

.k-scroll-mx-23 {
    scroll-margin-inline: 5.75rem;
}

.\\!k-scroll-mx-23 {
    scroll-margin-inline: 5.75rem !important;
}

.k-scroll-mx-24 {
    scroll-margin-inline: 6rem;
}

.\\!k-scroll-mx-24 {
    scroll-margin-inline: 6rem !important;
}

.k-scroll-my-0 {
    scroll-margin-block: 0;
}

.\\!k-scroll-my-0 {
    scroll-margin-block: 0 !important;
}

.k-scroll-my-1px {
    scroll-margin-block: 1px;
}

.\\!k-scroll-my-1px {
    scroll-margin-block: 1px !important;
}

.k-scroll-my-0\\.5 {
    scroll-margin-block: 0.125rem;
}

.\\!k-scroll-my-0\\.5 {
    scroll-margin-block: 0.125rem !important;
}

.k-scroll-my-1 {
    scroll-margin-block: 0.25rem;
}

.\\!k-scroll-my-1 {
    scroll-margin-block: 0.25rem !important;
}

.k-scroll-my-1\\.5 {
    scroll-margin-block: 0.375rem;
}

.\\!k-scroll-my-1\\.5 {
    scroll-margin-block: 0.375rem !important;
}

.k-scroll-my-2 {
    scroll-margin-block: 0.5rem;
}

.\\!k-scroll-my-2 {
    scroll-margin-block: 0.5rem !important;
}

.k-scroll-my-2\\.5 {
    scroll-margin-block: 0.625rem;
}

.\\!k-scroll-my-2\\.5 {
    scroll-margin-block: 0.625rem !important;
}

.k-scroll-my-3 {
    scroll-margin-block: 0.75rem;
}

.\\!k-scroll-my-3 {
    scroll-margin-block: 0.75rem !important;
}

.k-scroll-my-3\\.5 {
    scroll-margin-block: 0.875rem;
}

.\\!k-scroll-my-3\\.5 {
    scroll-margin-block: 0.875rem !important;
}

.k-scroll-my-4 {
    scroll-margin-block: 1rem;
}

.\\!k-scroll-my-4 {
    scroll-margin-block: 1rem !important;
}

.k-scroll-my-4\\.5 {
    scroll-margin-block: 1.125rem;
}

.\\!k-scroll-my-4\\.5 {
    scroll-margin-block: 1.125rem !important;
}

.k-scroll-my-5 {
    scroll-margin-block: 1.25rem;
}

.\\!k-scroll-my-5 {
    scroll-margin-block: 1.25rem !important;
}

.k-scroll-my-5\\.5 {
    scroll-margin-block: 1.375rem;
}

.\\!k-scroll-my-5\\.5 {
    scroll-margin-block: 1.375rem !important;
}

.k-scroll-my-6 {
    scroll-margin-block: 1.5rem;
}

.\\!k-scroll-my-6 {
    scroll-margin-block: 1.5rem !important;
}

.k-scroll-my-6\\.5 {
    scroll-margin-block: 1.625rem;
}

.\\!k-scroll-my-6\\.5 {
    scroll-margin-block: 1.625rem !important;
}

.k-scroll-my-7 {
    scroll-margin-block: 1.75rem;
}

.\\!k-scroll-my-7 {
    scroll-margin-block: 1.75rem !important;
}

.k-scroll-my-7\\.5 {
    scroll-margin-block: 1.875rem;
}

.\\!k-scroll-my-7\\.5 {
    scroll-margin-block: 1.875rem !important;
}

.k-scroll-my-8 {
    scroll-margin-block: 2rem;
}

.\\!k-scroll-my-8 {
    scroll-margin-block: 2rem !important;
}

.k-scroll-my-9 {
    scroll-margin-block: 2.25rem;
}

.\\!k-scroll-my-9 {
    scroll-margin-block: 2.25rem !important;
}

.k-scroll-my-10 {
    scroll-margin-block: 2.5rem;
}

.\\!k-scroll-my-10 {
    scroll-margin-block: 2.5rem !important;
}

.k-scroll-my-11 {
    scroll-margin-block: 2.75rem;
}

.\\!k-scroll-my-11 {
    scroll-margin-block: 2.75rem !important;
}

.k-scroll-my-12 {
    scroll-margin-block: 3rem;
}

.\\!k-scroll-my-12 {
    scroll-margin-block: 3rem !important;
}

.k-scroll-my-13 {
    scroll-margin-block: 3.25rem;
}

.\\!k-scroll-my-13 {
    scroll-margin-block: 3.25rem !important;
}

.k-scroll-my-14 {
    scroll-margin-block: 3.5rem;
}

.\\!k-scroll-my-14 {
    scroll-margin-block: 3.5rem !important;
}

.k-scroll-my-15 {
    scroll-margin-block: 3.75rem;
}

.\\!k-scroll-my-15 {
    scroll-margin-block: 3.75rem !important;
}

.k-scroll-my-16 {
    scroll-margin-block: 4rem;
}

.\\!k-scroll-my-16 {
    scroll-margin-block: 4rem !important;
}

.k-scroll-my-17 {
    scroll-margin-block: 4.25rem;
}

.\\!k-scroll-my-17 {
    scroll-margin-block: 4.25rem !important;
}

.k-scroll-my-18 {
    scroll-margin-block: 4.5rem;
}

.\\!k-scroll-my-18 {
    scroll-margin-block: 4.5rem !important;
}

.k-scroll-my-19 {
    scroll-margin-block: 4.75rem;
}

.\\!k-scroll-my-19 {
    scroll-margin-block: 4.75rem !important;
}

.k-scroll-my-20 {
    scroll-margin-block: 5rem;
}

.\\!k-scroll-my-20 {
    scroll-margin-block: 5rem !important;
}

.k-scroll-my-21 {
    scroll-margin-block: 5.25rem;
}

.\\!k-scroll-my-21 {
    scroll-margin-block: 5.25rem !important;
}

.k-scroll-my-22 {
    scroll-margin-block: 5.5rem;
}

.\\!k-scroll-my-22 {
    scroll-margin-block: 5.5rem !important;
}

.k-scroll-my-23 {
    scroll-margin-block: 5.75rem;
}

.\\!k-scroll-my-23 {
    scroll-margin-block: 5.75rem !important;
}

.k-scroll-my-24 {
    scroll-margin-block: 6rem;
}

.\\!k-scroll-my-24 {
    scroll-margin-block: 6rem !important;
}

.k-scroll-p-0 {
    scroll-padding: 0;
}

.\\!k-scroll-p-0 {
    scroll-padding: 0 !important;
}

.k-scroll-p-1px {
    scroll-padding: 1px;
}

.\\!k-scroll-p-1px {
    scroll-padding: 1px !important;
}

.k-scroll-p-0\\.5 {
    scroll-padding: 0.125rem;
}

.\\!k-scroll-p-0\\.5 {
    scroll-padding: 0.125rem !important;
}

.k-scroll-p-1 {
    scroll-padding: 0.25rem;
}

.\\!k-scroll-p-1 {
    scroll-padding: 0.25rem !important;
}

.k-scroll-p-1\\.5 {
    scroll-padding: 0.375rem;
}

.\\!k-scroll-p-1\\.5 {
    scroll-padding: 0.375rem !important;
}

.k-scroll-p-2 {
    scroll-padding: 0.5rem;
}

.\\!k-scroll-p-2 {
    scroll-padding: 0.5rem !important;
}

.k-scroll-p-2\\.5 {
    scroll-padding: 0.625rem;
}

.\\!k-scroll-p-2\\.5 {
    scroll-padding: 0.625rem !important;
}

.k-scroll-p-3 {
    scroll-padding: 0.75rem;
}

.\\!k-scroll-p-3 {
    scroll-padding: 0.75rem !important;
}

.k-scroll-p-3\\.5 {
    scroll-padding: 0.875rem;
}

.\\!k-scroll-p-3\\.5 {
    scroll-padding: 0.875rem !important;
}

.k-scroll-p-4 {
    scroll-padding: 1rem;
}

.\\!k-scroll-p-4 {
    scroll-padding: 1rem !important;
}

.k-scroll-p-4\\.5 {
    scroll-padding: 1.125rem;
}

.\\!k-scroll-p-4\\.5 {
    scroll-padding: 1.125rem !important;
}

.k-scroll-p-5 {
    scroll-padding: 1.25rem;
}

.\\!k-scroll-p-5 {
    scroll-padding: 1.25rem !important;
}

.k-scroll-p-5\\.5 {
    scroll-padding: 1.375rem;
}

.\\!k-scroll-p-5\\.5 {
    scroll-padding: 1.375rem !important;
}

.k-scroll-p-6 {
    scroll-padding: 1.5rem;
}

.\\!k-scroll-p-6 {
    scroll-padding: 1.5rem !important;
}

.k-scroll-p-6\\.5 {
    scroll-padding: 1.625rem;
}

.\\!k-scroll-p-6\\.5 {
    scroll-padding: 1.625rem !important;
}

.k-scroll-p-7 {
    scroll-padding: 1.75rem;
}

.\\!k-scroll-p-7 {
    scroll-padding: 1.75rem !important;
}

.k-scroll-p-7\\.5 {
    scroll-padding: 1.875rem;
}

.\\!k-scroll-p-7\\.5 {
    scroll-padding: 1.875rem !important;
}

.k-scroll-p-8 {
    scroll-padding: 2rem;
}

.\\!k-scroll-p-8 {
    scroll-padding: 2rem !important;
}

.k-scroll-p-9 {
    scroll-padding: 2.25rem;
}

.\\!k-scroll-p-9 {
    scroll-padding: 2.25rem !important;
}

.k-scroll-p-10 {
    scroll-padding: 2.5rem;
}

.\\!k-scroll-p-10 {
    scroll-padding: 2.5rem !important;
}

.k-scroll-p-11 {
    scroll-padding: 2.75rem;
}

.\\!k-scroll-p-11 {
    scroll-padding: 2.75rem !important;
}

.k-scroll-p-12 {
    scroll-padding: 3rem;
}

.\\!k-scroll-p-12 {
    scroll-padding: 3rem !important;
}

.k-scroll-p-13 {
    scroll-padding: 3.25rem;
}

.\\!k-scroll-p-13 {
    scroll-padding: 3.25rem !important;
}

.k-scroll-p-14 {
    scroll-padding: 3.5rem;
}

.\\!k-scroll-p-14 {
    scroll-padding: 3.5rem !important;
}

.k-scroll-p-15 {
    scroll-padding: 3.75rem;
}

.\\!k-scroll-p-15 {
    scroll-padding: 3.75rem !important;
}

.k-scroll-p-16 {
    scroll-padding: 4rem;
}

.\\!k-scroll-p-16 {
    scroll-padding: 4rem !important;
}

.k-scroll-p-17 {
    scroll-padding: 4.25rem;
}

.\\!k-scroll-p-17 {
    scroll-padding: 4.25rem !important;
}

.k-scroll-p-18 {
    scroll-padding: 4.5rem;
}

.\\!k-scroll-p-18 {
    scroll-padding: 4.5rem !important;
}

.k-scroll-p-19 {
    scroll-padding: 4.75rem;
}

.\\!k-scroll-p-19 {
    scroll-padding: 4.75rem !important;
}

.k-scroll-p-20 {
    scroll-padding: 5rem;
}

.\\!k-scroll-p-20 {
    scroll-padding: 5rem !important;
}

.k-scroll-p-21 {
    scroll-padding: 5.25rem;
}

.\\!k-scroll-p-21 {
    scroll-padding: 5.25rem !important;
}

.k-scroll-p-22 {
    scroll-padding: 5.5rem;
}

.\\!k-scroll-p-22 {
    scroll-padding: 5.5rem !important;
}

.k-scroll-p-23 {
    scroll-padding: 5.75rem;
}

.\\!k-scroll-p-23 {
    scroll-padding: 5.75rem !important;
}

.k-scroll-p-24 {
    scroll-padding: 6rem;
}

.\\!k-scroll-p-24 {
    scroll-padding: 6rem !important;
}

.k-scroll-pt-0 {
    scroll-padding-top: 0;
}

.\\!k-scroll-pt-0 {
    scroll-padding-top: 0 !important;
}

.k-scroll-pt-1px {
    scroll-padding-top: 1px;
}

.\\!k-scroll-pt-1px {
    scroll-padding-top: 1px !important;
}

.k-scroll-pt-0\\.5 {
    scroll-padding-top: 0.125rem;
}

.\\!k-scroll-pt-0\\.5 {
    scroll-padding-top: 0.125rem !important;
}

.k-scroll-pt-1 {
    scroll-padding-top: 0.25rem;
}

.\\!k-scroll-pt-1 {
    scroll-padding-top: 0.25rem !important;
}

.k-scroll-pt-1\\.5 {
    scroll-padding-top: 0.375rem;
}

.\\!k-scroll-pt-1\\.5 {
    scroll-padding-top: 0.375rem !important;
}

.k-scroll-pt-2 {
    scroll-padding-top: 0.5rem;
}

.\\!k-scroll-pt-2 {
    scroll-padding-top: 0.5rem !important;
}

.k-scroll-pt-2\\.5 {
    scroll-padding-top: 0.625rem;
}

.\\!k-scroll-pt-2\\.5 {
    scroll-padding-top: 0.625rem !important;
}

.k-scroll-pt-3 {
    scroll-padding-top: 0.75rem;
}

.\\!k-scroll-pt-3 {
    scroll-padding-top: 0.75rem !important;
}

.k-scroll-pt-3\\.5 {
    scroll-padding-top: 0.875rem;
}

.\\!k-scroll-pt-3\\.5 {
    scroll-padding-top: 0.875rem !important;
}

.k-scroll-pt-4 {
    scroll-padding-top: 1rem;
}

.\\!k-scroll-pt-4 {
    scroll-padding-top: 1rem !important;
}

.k-scroll-pt-4\\.5 {
    scroll-padding-top: 1.125rem;
}

.\\!k-scroll-pt-4\\.5 {
    scroll-padding-top: 1.125rem !important;
}

.k-scroll-pt-5 {
    scroll-padding-top: 1.25rem;
}

.\\!k-scroll-pt-5 {
    scroll-padding-top: 1.25rem !important;
}

.k-scroll-pt-5\\.5 {
    scroll-padding-top: 1.375rem;
}

.\\!k-scroll-pt-5\\.5 {
    scroll-padding-top: 1.375rem !important;
}

.k-scroll-pt-6 {
    scroll-padding-top: 1.5rem;
}

.\\!k-scroll-pt-6 {
    scroll-padding-top: 1.5rem !important;
}

.k-scroll-pt-6\\.5 {
    scroll-padding-top: 1.625rem;
}

.\\!k-scroll-pt-6\\.5 {
    scroll-padding-top: 1.625rem !important;
}

.k-scroll-pt-7 {
    scroll-padding-top: 1.75rem;
}

.\\!k-scroll-pt-7 {
    scroll-padding-top: 1.75rem !important;
}

.k-scroll-pt-7\\.5 {
    scroll-padding-top: 1.875rem;
}

.\\!k-scroll-pt-7\\.5 {
    scroll-padding-top: 1.875rem !important;
}

.k-scroll-pt-8 {
    scroll-padding-top: 2rem;
}

.\\!k-scroll-pt-8 {
    scroll-padding-top: 2rem !important;
}

.k-scroll-pt-9 {
    scroll-padding-top: 2.25rem;
}

.\\!k-scroll-pt-9 {
    scroll-padding-top: 2.25rem !important;
}

.k-scroll-pt-10 {
    scroll-padding-top: 2.5rem;
}

.\\!k-scroll-pt-10 {
    scroll-padding-top: 2.5rem !important;
}

.k-scroll-pt-11 {
    scroll-padding-top: 2.75rem;
}

.\\!k-scroll-pt-11 {
    scroll-padding-top: 2.75rem !important;
}

.k-scroll-pt-12 {
    scroll-padding-top: 3rem;
}

.\\!k-scroll-pt-12 {
    scroll-padding-top: 3rem !important;
}

.k-scroll-pt-13 {
    scroll-padding-top: 3.25rem;
}

.\\!k-scroll-pt-13 {
    scroll-padding-top: 3.25rem !important;
}

.k-scroll-pt-14 {
    scroll-padding-top: 3.5rem;
}

.\\!k-scroll-pt-14 {
    scroll-padding-top: 3.5rem !important;
}

.k-scroll-pt-15 {
    scroll-padding-top: 3.75rem;
}

.\\!k-scroll-pt-15 {
    scroll-padding-top: 3.75rem !important;
}

.k-scroll-pt-16 {
    scroll-padding-top: 4rem;
}

.\\!k-scroll-pt-16 {
    scroll-padding-top: 4rem !important;
}

.k-scroll-pt-17 {
    scroll-padding-top: 4.25rem;
}

.\\!k-scroll-pt-17 {
    scroll-padding-top: 4.25rem !important;
}

.k-scroll-pt-18 {
    scroll-padding-top: 4.5rem;
}

.\\!k-scroll-pt-18 {
    scroll-padding-top: 4.5rem !important;
}

.k-scroll-pt-19 {
    scroll-padding-top: 4.75rem;
}

.\\!k-scroll-pt-19 {
    scroll-padding-top: 4.75rem !important;
}

.k-scroll-pt-20 {
    scroll-padding-top: 5rem;
}

.\\!k-scroll-pt-20 {
    scroll-padding-top: 5rem !important;
}

.k-scroll-pt-21 {
    scroll-padding-top: 5.25rem;
}

.\\!k-scroll-pt-21 {
    scroll-padding-top: 5.25rem !important;
}

.k-scroll-pt-22 {
    scroll-padding-top: 5.5rem;
}

.\\!k-scroll-pt-22 {
    scroll-padding-top: 5.5rem !important;
}

.k-scroll-pt-23 {
    scroll-padding-top: 5.75rem;
}

.\\!k-scroll-pt-23 {
    scroll-padding-top: 5.75rem !important;
}

.k-scroll-pt-24 {
    scroll-padding-top: 6rem;
}

.\\!k-scroll-pt-24 {
    scroll-padding-top: 6rem !important;
}

.k-scroll-pr-0 {
    scroll-padding-right: 0;
}

.\\!k-scroll-pr-0 {
    scroll-padding-right: 0 !important;
}

.k-scroll-pr-1px {
    scroll-padding-right: 1px;
}

.\\!k-scroll-pr-1px {
    scroll-padding-right: 1px !important;
}

.k-scroll-pr-0\\.5 {
    scroll-padding-right: 0.125rem;
}

.\\!k-scroll-pr-0\\.5 {
    scroll-padding-right: 0.125rem !important;
}

.k-scroll-pr-1 {
    scroll-padding-right: 0.25rem;
}

.\\!k-scroll-pr-1 {
    scroll-padding-right: 0.25rem !important;
}

.k-scroll-pr-1\\.5 {
    scroll-padding-right: 0.375rem;
}

.\\!k-scroll-pr-1\\.5 {
    scroll-padding-right: 0.375rem !important;
}

.k-scroll-pr-2 {
    scroll-padding-right: 0.5rem;
}

.\\!k-scroll-pr-2 {
    scroll-padding-right: 0.5rem !important;
}

.k-scroll-pr-2\\.5 {
    scroll-padding-right: 0.625rem;
}

.\\!k-scroll-pr-2\\.5 {
    scroll-padding-right: 0.625rem !important;
}

.k-scroll-pr-3 {
    scroll-padding-right: 0.75rem;
}

.\\!k-scroll-pr-3 {
    scroll-padding-right: 0.75rem !important;
}

.k-scroll-pr-3\\.5 {
    scroll-padding-right: 0.875rem;
}

.\\!k-scroll-pr-3\\.5 {
    scroll-padding-right: 0.875rem !important;
}

.k-scroll-pr-4 {
    scroll-padding-right: 1rem;
}

.\\!k-scroll-pr-4 {
    scroll-padding-right: 1rem !important;
}

.k-scroll-pr-4\\.5 {
    scroll-padding-right: 1.125rem;
}

.\\!k-scroll-pr-4\\.5 {
    scroll-padding-right: 1.125rem !important;
}

.k-scroll-pr-5 {
    scroll-padding-right: 1.25rem;
}

.\\!k-scroll-pr-5 {
    scroll-padding-right: 1.25rem !important;
}

.k-scroll-pr-5\\.5 {
    scroll-padding-right: 1.375rem;
}

.\\!k-scroll-pr-5\\.5 {
    scroll-padding-right: 1.375rem !important;
}

.k-scroll-pr-6 {
    scroll-padding-right: 1.5rem;
}

.\\!k-scroll-pr-6 {
    scroll-padding-right: 1.5rem !important;
}

.k-scroll-pr-6\\.5 {
    scroll-padding-right: 1.625rem;
}

.\\!k-scroll-pr-6\\.5 {
    scroll-padding-right: 1.625rem !important;
}

.k-scroll-pr-7 {
    scroll-padding-right: 1.75rem;
}

.\\!k-scroll-pr-7 {
    scroll-padding-right: 1.75rem !important;
}

.k-scroll-pr-7\\.5 {
    scroll-padding-right: 1.875rem;
}

.\\!k-scroll-pr-7\\.5 {
    scroll-padding-right: 1.875rem !important;
}

.k-scroll-pr-8 {
    scroll-padding-right: 2rem;
}

.\\!k-scroll-pr-8 {
    scroll-padding-right: 2rem !important;
}

.k-scroll-pr-9 {
    scroll-padding-right: 2.25rem;
}

.\\!k-scroll-pr-9 {
    scroll-padding-right: 2.25rem !important;
}

.k-scroll-pr-10 {
    scroll-padding-right: 2.5rem;
}

.\\!k-scroll-pr-10 {
    scroll-padding-right: 2.5rem !important;
}

.k-scroll-pr-11 {
    scroll-padding-right: 2.75rem;
}

.\\!k-scroll-pr-11 {
    scroll-padding-right: 2.75rem !important;
}

.k-scroll-pr-12 {
    scroll-padding-right: 3rem;
}

.\\!k-scroll-pr-12 {
    scroll-padding-right: 3rem !important;
}

.k-scroll-pr-13 {
    scroll-padding-right: 3.25rem;
}

.\\!k-scroll-pr-13 {
    scroll-padding-right: 3.25rem !important;
}

.k-scroll-pr-14 {
    scroll-padding-right: 3.5rem;
}

.\\!k-scroll-pr-14 {
    scroll-padding-right: 3.5rem !important;
}

.k-scroll-pr-15 {
    scroll-padding-right: 3.75rem;
}

.\\!k-scroll-pr-15 {
    scroll-padding-right: 3.75rem !important;
}

.k-scroll-pr-16 {
    scroll-padding-right: 4rem;
}

.\\!k-scroll-pr-16 {
    scroll-padding-right: 4rem !important;
}

.k-scroll-pr-17 {
    scroll-padding-right: 4.25rem;
}

.\\!k-scroll-pr-17 {
    scroll-padding-right: 4.25rem !important;
}

.k-scroll-pr-18 {
    scroll-padding-right: 4.5rem;
}

.\\!k-scroll-pr-18 {
    scroll-padding-right: 4.5rem !important;
}

.k-scroll-pr-19 {
    scroll-padding-right: 4.75rem;
}

.\\!k-scroll-pr-19 {
    scroll-padding-right: 4.75rem !important;
}

.k-scroll-pr-20 {
    scroll-padding-right: 5rem;
}

.\\!k-scroll-pr-20 {
    scroll-padding-right: 5rem !important;
}

.k-scroll-pr-21 {
    scroll-padding-right: 5.25rem;
}

.\\!k-scroll-pr-21 {
    scroll-padding-right: 5.25rem !important;
}

.k-scroll-pr-22 {
    scroll-padding-right: 5.5rem;
}

.\\!k-scroll-pr-22 {
    scroll-padding-right: 5.5rem !important;
}

.k-scroll-pr-23 {
    scroll-padding-right: 5.75rem;
}

.\\!k-scroll-pr-23 {
    scroll-padding-right: 5.75rem !important;
}

.k-scroll-pr-24 {
    scroll-padding-right: 6rem;
}

.\\!k-scroll-pr-24 {
    scroll-padding-right: 6rem !important;
}

.k-scroll-pb-0 {
    scroll-padding-bottom: 0;
}

.\\!k-scroll-pb-0 {
    scroll-padding-bottom: 0 !important;
}

.k-scroll-pb-1px {
    scroll-padding-bottom: 1px;
}

.\\!k-scroll-pb-1px {
    scroll-padding-bottom: 1px !important;
}

.k-scroll-pb-0\\.5 {
    scroll-padding-bottom: 0.125rem;
}

.\\!k-scroll-pb-0\\.5 {
    scroll-padding-bottom: 0.125rem !important;
}

.k-scroll-pb-1 {
    scroll-padding-bottom: 0.25rem;
}

.\\!k-scroll-pb-1 {
    scroll-padding-bottom: 0.25rem !important;
}

.k-scroll-pb-1\\.5 {
    scroll-padding-bottom: 0.375rem;
}

.\\!k-scroll-pb-1\\.5 {
    scroll-padding-bottom: 0.375rem !important;
}

.k-scroll-pb-2 {
    scroll-padding-bottom: 0.5rem;
}

.\\!k-scroll-pb-2 {
    scroll-padding-bottom: 0.5rem !important;
}

.k-scroll-pb-2\\.5 {
    scroll-padding-bottom: 0.625rem;
}

.\\!k-scroll-pb-2\\.5 {
    scroll-padding-bottom: 0.625rem !important;
}

.k-scroll-pb-3 {
    scroll-padding-bottom: 0.75rem;
}

.\\!k-scroll-pb-3 {
    scroll-padding-bottom: 0.75rem !important;
}

.k-scroll-pb-3\\.5 {
    scroll-padding-bottom: 0.875rem;
}

.\\!k-scroll-pb-3\\.5 {
    scroll-padding-bottom: 0.875rem !important;
}

.k-scroll-pb-4 {
    scroll-padding-bottom: 1rem;
}

.\\!k-scroll-pb-4 {
    scroll-padding-bottom: 1rem !important;
}

.k-scroll-pb-4\\.5 {
    scroll-padding-bottom: 1.125rem;
}

.\\!k-scroll-pb-4\\.5 {
    scroll-padding-bottom: 1.125rem !important;
}

.k-scroll-pb-5 {
    scroll-padding-bottom: 1.25rem;
}

.\\!k-scroll-pb-5 {
    scroll-padding-bottom: 1.25rem !important;
}

.k-scroll-pb-5\\.5 {
    scroll-padding-bottom: 1.375rem;
}

.\\!k-scroll-pb-5\\.5 {
    scroll-padding-bottom: 1.375rem !important;
}

.k-scroll-pb-6 {
    scroll-padding-bottom: 1.5rem;
}

.\\!k-scroll-pb-6 {
    scroll-padding-bottom: 1.5rem !important;
}

.k-scroll-pb-6\\.5 {
    scroll-padding-bottom: 1.625rem;
}

.\\!k-scroll-pb-6\\.5 {
    scroll-padding-bottom: 1.625rem !important;
}

.k-scroll-pb-7 {
    scroll-padding-bottom: 1.75rem;
}

.\\!k-scroll-pb-7 {
    scroll-padding-bottom: 1.75rem !important;
}

.k-scroll-pb-7\\.5 {
    scroll-padding-bottom: 1.875rem;
}

.\\!k-scroll-pb-7\\.5 {
    scroll-padding-bottom: 1.875rem !important;
}

.k-scroll-pb-8 {
    scroll-padding-bottom: 2rem;
}

.\\!k-scroll-pb-8 {
    scroll-padding-bottom: 2rem !important;
}

.k-scroll-pb-9 {
    scroll-padding-bottom: 2.25rem;
}

.\\!k-scroll-pb-9 {
    scroll-padding-bottom: 2.25rem !important;
}

.k-scroll-pb-10 {
    scroll-padding-bottom: 2.5rem;
}

.\\!k-scroll-pb-10 {
    scroll-padding-bottom: 2.5rem !important;
}

.k-scroll-pb-11 {
    scroll-padding-bottom: 2.75rem;
}

.\\!k-scroll-pb-11 {
    scroll-padding-bottom: 2.75rem !important;
}

.k-scroll-pb-12 {
    scroll-padding-bottom: 3rem;
}

.\\!k-scroll-pb-12 {
    scroll-padding-bottom: 3rem !important;
}

.k-scroll-pb-13 {
    scroll-padding-bottom: 3.25rem;
}

.\\!k-scroll-pb-13 {
    scroll-padding-bottom: 3.25rem !important;
}

.k-scroll-pb-14 {
    scroll-padding-bottom: 3.5rem;
}

.\\!k-scroll-pb-14 {
    scroll-padding-bottom: 3.5rem !important;
}

.k-scroll-pb-15 {
    scroll-padding-bottom: 3.75rem;
}

.\\!k-scroll-pb-15 {
    scroll-padding-bottom: 3.75rem !important;
}

.k-scroll-pb-16 {
    scroll-padding-bottom: 4rem;
}

.\\!k-scroll-pb-16 {
    scroll-padding-bottom: 4rem !important;
}

.k-scroll-pb-17 {
    scroll-padding-bottom: 4.25rem;
}

.\\!k-scroll-pb-17 {
    scroll-padding-bottom: 4.25rem !important;
}

.k-scroll-pb-18 {
    scroll-padding-bottom: 4.5rem;
}

.\\!k-scroll-pb-18 {
    scroll-padding-bottom: 4.5rem !important;
}

.k-scroll-pb-19 {
    scroll-padding-bottom: 4.75rem;
}

.\\!k-scroll-pb-19 {
    scroll-padding-bottom: 4.75rem !important;
}

.k-scroll-pb-20 {
    scroll-padding-bottom: 5rem;
}

.\\!k-scroll-pb-20 {
    scroll-padding-bottom: 5rem !important;
}

.k-scroll-pb-21 {
    scroll-padding-bottom: 5.25rem;
}

.\\!k-scroll-pb-21 {
    scroll-padding-bottom: 5.25rem !important;
}

.k-scroll-pb-22 {
    scroll-padding-bottom: 5.5rem;
}

.\\!k-scroll-pb-22 {
    scroll-padding-bottom: 5.5rem !important;
}

.k-scroll-pb-23 {
    scroll-padding-bottom: 5.75rem;
}

.\\!k-scroll-pb-23 {
    scroll-padding-bottom: 5.75rem !important;
}

.k-scroll-pb-24 {
    scroll-padding-bottom: 6rem;
}

.\\!k-scroll-pb-24 {
    scroll-padding-bottom: 6rem !important;
}

.k-scroll-pl-0 {
    scroll-padding-left: 0;
}

.\\!k-scroll-pl-0 {
    scroll-padding-left: 0 !important;
}

.k-scroll-pl-1px {
    scroll-padding-left: 1px;
}

.\\!k-scroll-pl-1px {
    scroll-padding-left: 1px !important;
}

.k-scroll-pl-0\\.5 {
    scroll-padding-left: 0.125rem;
}

.\\!k-scroll-pl-0\\.5 {
    scroll-padding-left: 0.125rem !important;
}

.k-scroll-pl-1 {
    scroll-padding-left: 0.25rem;
}

.\\!k-scroll-pl-1 {
    scroll-padding-left: 0.25rem !important;
}

.k-scroll-pl-1\\.5 {
    scroll-padding-left: 0.375rem;
}

.\\!k-scroll-pl-1\\.5 {
    scroll-padding-left: 0.375rem !important;
}

.k-scroll-pl-2 {
    scroll-padding-left: 0.5rem;
}

.\\!k-scroll-pl-2 {
    scroll-padding-left: 0.5rem !important;
}

.k-scroll-pl-2\\.5 {
    scroll-padding-left: 0.625rem;
}

.\\!k-scroll-pl-2\\.5 {
    scroll-padding-left: 0.625rem !important;
}

.k-scroll-pl-3 {
    scroll-padding-left: 0.75rem;
}

.\\!k-scroll-pl-3 {
    scroll-padding-left: 0.75rem !important;
}

.k-scroll-pl-3\\.5 {
    scroll-padding-left: 0.875rem;
}

.\\!k-scroll-pl-3\\.5 {
    scroll-padding-left: 0.875rem !important;
}

.k-scroll-pl-4 {
    scroll-padding-left: 1rem;
}

.\\!k-scroll-pl-4 {
    scroll-padding-left: 1rem !important;
}

.k-scroll-pl-4\\.5 {
    scroll-padding-left: 1.125rem;
}

.\\!k-scroll-pl-4\\.5 {
    scroll-padding-left: 1.125rem !important;
}

.k-scroll-pl-5 {
    scroll-padding-left: 1.25rem;
}

.\\!k-scroll-pl-5 {
    scroll-padding-left: 1.25rem !important;
}

.k-scroll-pl-5\\.5 {
    scroll-padding-left: 1.375rem;
}

.\\!k-scroll-pl-5\\.5 {
    scroll-padding-left: 1.375rem !important;
}

.k-scroll-pl-6 {
    scroll-padding-left: 1.5rem;
}

.\\!k-scroll-pl-6 {
    scroll-padding-left: 1.5rem !important;
}

.k-scroll-pl-6\\.5 {
    scroll-padding-left: 1.625rem;
}

.\\!k-scroll-pl-6\\.5 {
    scroll-padding-left: 1.625rem !important;
}

.k-scroll-pl-7 {
    scroll-padding-left: 1.75rem;
}

.\\!k-scroll-pl-7 {
    scroll-padding-left: 1.75rem !important;
}

.k-scroll-pl-7\\.5 {
    scroll-padding-left: 1.875rem;
}

.\\!k-scroll-pl-7\\.5 {
    scroll-padding-left: 1.875rem !important;
}

.k-scroll-pl-8 {
    scroll-padding-left: 2rem;
}

.\\!k-scroll-pl-8 {
    scroll-padding-left: 2rem !important;
}

.k-scroll-pl-9 {
    scroll-padding-left: 2.25rem;
}

.\\!k-scroll-pl-9 {
    scroll-padding-left: 2.25rem !important;
}

.k-scroll-pl-10 {
    scroll-padding-left: 2.5rem;
}

.\\!k-scroll-pl-10 {
    scroll-padding-left: 2.5rem !important;
}

.k-scroll-pl-11 {
    scroll-padding-left: 2.75rem;
}

.\\!k-scroll-pl-11 {
    scroll-padding-left: 2.75rem !important;
}

.k-scroll-pl-12 {
    scroll-padding-left: 3rem;
}

.\\!k-scroll-pl-12 {
    scroll-padding-left: 3rem !important;
}

.k-scroll-pl-13 {
    scroll-padding-left: 3.25rem;
}

.\\!k-scroll-pl-13 {
    scroll-padding-left: 3.25rem !important;
}

.k-scroll-pl-14 {
    scroll-padding-left: 3.5rem;
}

.\\!k-scroll-pl-14 {
    scroll-padding-left: 3.5rem !important;
}

.k-scroll-pl-15 {
    scroll-padding-left: 3.75rem;
}

.\\!k-scroll-pl-15 {
    scroll-padding-left: 3.75rem !important;
}

.k-scroll-pl-16 {
    scroll-padding-left: 4rem;
}

.\\!k-scroll-pl-16 {
    scroll-padding-left: 4rem !important;
}

.k-scroll-pl-17 {
    scroll-padding-left: 4.25rem;
}

.\\!k-scroll-pl-17 {
    scroll-padding-left: 4.25rem !important;
}

.k-scroll-pl-18 {
    scroll-padding-left: 4.5rem;
}

.\\!k-scroll-pl-18 {
    scroll-padding-left: 4.5rem !important;
}

.k-scroll-pl-19 {
    scroll-padding-left: 4.75rem;
}

.\\!k-scroll-pl-19 {
    scroll-padding-left: 4.75rem !important;
}

.k-scroll-pl-20 {
    scroll-padding-left: 5rem;
}

.\\!k-scroll-pl-20 {
    scroll-padding-left: 5rem !important;
}

.k-scroll-pl-21 {
    scroll-padding-left: 5.25rem;
}

.\\!k-scroll-pl-21 {
    scroll-padding-left: 5.25rem !important;
}

.k-scroll-pl-22 {
    scroll-padding-left: 5.5rem;
}

.\\!k-scroll-pl-22 {
    scroll-padding-left: 5.5rem !important;
}

.k-scroll-pl-23 {
    scroll-padding-left: 5.75rem;
}

.\\!k-scroll-pl-23 {
    scroll-padding-left: 5.75rem !important;
}

.k-scroll-pl-24 {
    scroll-padding-left: 6rem;
}

.\\!k-scroll-pl-24 {
    scroll-padding-left: 6rem !important;
}

.k-scroll-px-0 {
    scroll-padding-inline: 0;
}

.\\!k-scroll-px-0 {
    scroll-padding-inline: 0 !important;
}

.k-scroll-px-1px {
    scroll-padding-inline: 1px;
}

.\\!k-scroll-px-1px {
    scroll-padding-inline: 1px !important;
}

.k-scroll-px-0\\.5 {
    scroll-padding-inline: 0.125rem;
}

.\\!k-scroll-px-0\\.5 {
    scroll-padding-inline: 0.125rem !important;
}

.k-scroll-px-1 {
    scroll-padding-inline: 0.25rem;
}

.\\!k-scroll-px-1 {
    scroll-padding-inline: 0.25rem !important;
}

.k-scroll-px-1\\.5 {
    scroll-padding-inline: 0.375rem;
}

.\\!k-scroll-px-1\\.5 {
    scroll-padding-inline: 0.375rem !important;
}

.k-scroll-px-2 {
    scroll-padding-inline: 0.5rem;
}

.\\!k-scroll-px-2 {
    scroll-padding-inline: 0.5rem !important;
}

.k-scroll-px-2\\.5 {
    scroll-padding-inline: 0.625rem;
}

.\\!k-scroll-px-2\\.5 {
    scroll-padding-inline: 0.625rem !important;
}

.k-scroll-px-3 {
    scroll-padding-inline: 0.75rem;
}

.\\!k-scroll-px-3 {
    scroll-padding-inline: 0.75rem !important;
}

.k-scroll-px-3\\.5 {
    scroll-padding-inline: 0.875rem;
}

.\\!k-scroll-px-3\\.5 {
    scroll-padding-inline: 0.875rem !important;
}

.k-scroll-px-4 {
    scroll-padding-inline: 1rem;
}

.\\!k-scroll-px-4 {
    scroll-padding-inline: 1rem !important;
}

.k-scroll-px-4\\.5 {
    scroll-padding-inline: 1.125rem;
}

.\\!k-scroll-px-4\\.5 {
    scroll-padding-inline: 1.125rem !important;
}

.k-scroll-px-5 {
    scroll-padding-inline: 1.25rem;
}

.\\!k-scroll-px-5 {
    scroll-padding-inline: 1.25rem !important;
}

.k-scroll-px-5\\.5 {
    scroll-padding-inline: 1.375rem;
}

.\\!k-scroll-px-5\\.5 {
    scroll-padding-inline: 1.375rem !important;
}

.k-scroll-px-6 {
    scroll-padding-inline: 1.5rem;
}

.\\!k-scroll-px-6 {
    scroll-padding-inline: 1.5rem !important;
}

.k-scroll-px-6\\.5 {
    scroll-padding-inline: 1.625rem;
}

.\\!k-scroll-px-6\\.5 {
    scroll-padding-inline: 1.625rem !important;
}

.k-scroll-px-7 {
    scroll-padding-inline: 1.75rem;
}

.\\!k-scroll-px-7 {
    scroll-padding-inline: 1.75rem !important;
}

.k-scroll-px-7\\.5 {
    scroll-padding-inline: 1.875rem;
}

.\\!k-scroll-px-7\\.5 {
    scroll-padding-inline: 1.875rem !important;
}

.k-scroll-px-8 {
    scroll-padding-inline: 2rem;
}

.\\!k-scroll-px-8 {
    scroll-padding-inline: 2rem !important;
}

.k-scroll-px-9 {
    scroll-padding-inline: 2.25rem;
}

.\\!k-scroll-px-9 {
    scroll-padding-inline: 2.25rem !important;
}

.k-scroll-px-10 {
    scroll-padding-inline: 2.5rem;
}

.\\!k-scroll-px-10 {
    scroll-padding-inline: 2.5rem !important;
}

.k-scroll-px-11 {
    scroll-padding-inline: 2.75rem;
}

.\\!k-scroll-px-11 {
    scroll-padding-inline: 2.75rem !important;
}

.k-scroll-px-12 {
    scroll-padding-inline: 3rem;
}

.\\!k-scroll-px-12 {
    scroll-padding-inline: 3rem !important;
}

.k-scroll-px-13 {
    scroll-padding-inline: 3.25rem;
}

.\\!k-scroll-px-13 {
    scroll-padding-inline: 3.25rem !important;
}

.k-scroll-px-14 {
    scroll-padding-inline: 3.5rem;
}

.\\!k-scroll-px-14 {
    scroll-padding-inline: 3.5rem !important;
}

.k-scroll-px-15 {
    scroll-padding-inline: 3.75rem;
}

.\\!k-scroll-px-15 {
    scroll-padding-inline: 3.75rem !important;
}

.k-scroll-px-16 {
    scroll-padding-inline: 4rem;
}

.\\!k-scroll-px-16 {
    scroll-padding-inline: 4rem !important;
}

.k-scroll-px-17 {
    scroll-padding-inline: 4.25rem;
}

.\\!k-scroll-px-17 {
    scroll-padding-inline: 4.25rem !important;
}

.k-scroll-px-18 {
    scroll-padding-inline: 4.5rem;
}

.\\!k-scroll-px-18 {
    scroll-padding-inline: 4.5rem !important;
}

.k-scroll-px-19 {
    scroll-padding-inline: 4.75rem;
}

.\\!k-scroll-px-19 {
    scroll-padding-inline: 4.75rem !important;
}

.k-scroll-px-20 {
    scroll-padding-inline: 5rem;
}

.\\!k-scroll-px-20 {
    scroll-padding-inline: 5rem !important;
}

.k-scroll-px-21 {
    scroll-padding-inline: 5.25rem;
}

.\\!k-scroll-px-21 {
    scroll-padding-inline: 5.25rem !important;
}

.k-scroll-px-22 {
    scroll-padding-inline: 5.5rem;
}

.\\!k-scroll-px-22 {
    scroll-padding-inline: 5.5rem !important;
}

.k-scroll-px-23 {
    scroll-padding-inline: 5.75rem;
}

.\\!k-scroll-px-23 {
    scroll-padding-inline: 5.75rem !important;
}

.k-scroll-px-24 {
    scroll-padding-inline: 6rem;
}

.\\!k-scroll-px-24 {
    scroll-padding-inline: 6rem !important;
}

.k-scroll-py-0 {
    scroll-padding-block: 0;
}

.\\!k-scroll-py-0 {
    scroll-padding-block: 0 !important;
}

.k-scroll-py-1px {
    scroll-padding-block: 1px;
}

.\\!k-scroll-py-1px {
    scroll-padding-block: 1px !important;
}

.k-scroll-py-0\\.5 {
    scroll-padding-block: 0.125rem;
}

.\\!k-scroll-py-0\\.5 {
    scroll-padding-block: 0.125rem !important;
}

.k-scroll-py-1 {
    scroll-padding-block: 0.25rem;
}

.\\!k-scroll-py-1 {
    scroll-padding-block: 0.25rem !important;
}

.k-scroll-py-1\\.5 {
    scroll-padding-block: 0.375rem;
}

.\\!k-scroll-py-1\\.5 {
    scroll-padding-block: 0.375rem !important;
}

.k-scroll-py-2 {
    scroll-padding-block: 0.5rem;
}

.\\!k-scroll-py-2 {
    scroll-padding-block: 0.5rem !important;
}

.k-scroll-py-2\\.5 {
    scroll-padding-block: 0.625rem;
}

.\\!k-scroll-py-2\\.5 {
    scroll-padding-block: 0.625rem !important;
}

.k-scroll-py-3 {
    scroll-padding-block: 0.75rem;
}

.\\!k-scroll-py-3 {
    scroll-padding-block: 0.75rem !important;
}

.k-scroll-py-3\\.5 {
    scroll-padding-block: 0.875rem;
}

.\\!k-scroll-py-3\\.5 {
    scroll-padding-block: 0.875rem !important;
}

.k-scroll-py-4 {
    scroll-padding-block: 1rem;
}

.\\!k-scroll-py-4 {
    scroll-padding-block: 1rem !important;
}

.k-scroll-py-4\\.5 {
    scroll-padding-block: 1.125rem;
}

.\\!k-scroll-py-4\\.5 {
    scroll-padding-block: 1.125rem !important;
}

.k-scroll-py-5 {
    scroll-padding-block: 1.25rem;
}

.\\!k-scroll-py-5 {
    scroll-padding-block: 1.25rem !important;
}

.k-scroll-py-5\\.5 {
    scroll-padding-block: 1.375rem;
}

.\\!k-scroll-py-5\\.5 {
    scroll-padding-block: 1.375rem !important;
}

.k-scroll-py-6 {
    scroll-padding-block: 1.5rem;
}

.\\!k-scroll-py-6 {
    scroll-padding-block: 1.5rem !important;
}

.k-scroll-py-6\\.5 {
    scroll-padding-block: 1.625rem;
}

.\\!k-scroll-py-6\\.5 {
    scroll-padding-block: 1.625rem !important;
}

.k-scroll-py-7 {
    scroll-padding-block: 1.75rem;
}

.\\!k-scroll-py-7 {
    scroll-padding-block: 1.75rem !important;
}

.k-scroll-py-7\\.5 {
    scroll-padding-block: 1.875rem;
}

.\\!k-scroll-py-7\\.5 {
    scroll-padding-block: 1.875rem !important;
}

.k-scroll-py-8 {
    scroll-padding-block: 2rem;
}

.\\!k-scroll-py-8 {
    scroll-padding-block: 2rem !important;
}

.k-scroll-py-9 {
    scroll-padding-block: 2.25rem;
}

.\\!k-scroll-py-9 {
    scroll-padding-block: 2.25rem !important;
}

.k-scroll-py-10 {
    scroll-padding-block: 2.5rem;
}

.\\!k-scroll-py-10 {
    scroll-padding-block: 2.5rem !important;
}

.k-scroll-py-11 {
    scroll-padding-block: 2.75rem;
}

.\\!k-scroll-py-11 {
    scroll-padding-block: 2.75rem !important;
}

.k-scroll-py-12 {
    scroll-padding-block: 3rem;
}

.\\!k-scroll-py-12 {
    scroll-padding-block: 3rem !important;
}

.k-scroll-py-13 {
    scroll-padding-block: 3.25rem;
}

.\\!k-scroll-py-13 {
    scroll-padding-block: 3.25rem !important;
}

.k-scroll-py-14 {
    scroll-padding-block: 3.5rem;
}

.\\!k-scroll-py-14 {
    scroll-padding-block: 3.5rem !important;
}

.k-scroll-py-15 {
    scroll-padding-block: 3.75rem;
}

.\\!k-scroll-py-15 {
    scroll-padding-block: 3.75rem !important;
}

.k-scroll-py-16 {
    scroll-padding-block: 4rem;
}

.\\!k-scroll-py-16 {
    scroll-padding-block: 4rem !important;
}

.k-scroll-py-17 {
    scroll-padding-block: 4.25rem;
}

.\\!k-scroll-py-17 {
    scroll-padding-block: 4.25rem !important;
}

.k-scroll-py-18 {
    scroll-padding-block: 4.5rem;
}

.\\!k-scroll-py-18 {
    scroll-padding-block: 4.5rem !important;
}

.k-scroll-py-19 {
    scroll-padding-block: 4.75rem;
}

.\\!k-scroll-py-19 {
    scroll-padding-block: 4.75rem !important;
}

.k-scroll-py-20 {
    scroll-padding-block: 5rem;
}

.\\!k-scroll-py-20 {
    scroll-padding-block: 5rem !important;
}

.k-scroll-py-21 {
    scroll-padding-block: 5.25rem;
}

.\\!k-scroll-py-21 {
    scroll-padding-block: 5.25rem !important;
}

.k-scroll-py-22 {
    scroll-padding-block: 5.5rem;
}

.\\!k-scroll-py-22 {
    scroll-padding-block: 5.5rem !important;
}

.k-scroll-py-23 {
    scroll-padding-block: 5.75rem;
}

.\\!k-scroll-py-23 {
    scroll-padding-block: 5.75rem !important;
}

.k-scroll-py-24 {
    scroll-padding-block: 6rem;
}

.\\!k-scroll-py-24 {
    scroll-padding-block: 6rem !important;
}

.k-touch-action-none {
    touch-action: none;
}

.\\!k-touch-action-none {
    touch-action: none !important;
}

.k-touch-action-auto {
    touch-action: auto;
}

.\\!k-touch-action-auto {
    touch-action: auto !important;
}

.k-touch-action-pan-x {
    touch-action: pan-x;
}

.\\!k-touch-action-pan-x {
    touch-action: pan-x !important;
}

.k-touch-action-pan-left {
    touch-action: pan-left;
}

.\\!k-touch-action-pan-left {
    touch-action: pan-left !important;
}

.k-touch-action-pan-right {
    touch-action: pan-right;
}

.\\!k-touch-action-pan-right {
    touch-action: pan-right !important;
}

.k-touch-action-pan-y {
    touch-action: pan-y;
}

.\\!k-touch-action-pan-y {
    touch-action: pan-y !important;
}

.k-touch-action-pan-up {
    touch-action: pan-up;
}

.\\!k-touch-action-pan-up {
    touch-action: pan-up !important;
}

.k-touch-action-pan-down {
    touch-action: pan-down;
}

.\\!k-touch-action-pan-down {
    touch-action: pan-down !important;
}

.k-touch-action-pinch-zoom {
    touch-action: pinch-zoom;
}

.\\!k-touch-action-pinch-zoom {
    touch-action: pinch-zoom !important;
}

.k-touch-action-manipulation {
    touch-action: manipulation;
}

.\\!k-touch-action-manipulation {
    touch-action: manipulation !important;
}

.k-user-select-none {
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.\\!k-user-select-none {
    -webkit-user-select: none !important;
        -ms-user-select: none !important;
            user-select: none !important;
}

.k-user-select-auto {
    -webkit-user-select: auto;
        -ms-user-select: auto;
            user-select: auto;
}

.\\!k-user-select-auto {
    -webkit-user-select: auto !important;
        -ms-user-select: auto !important;
            user-select: auto !important;
}

.k-user-select-text {
    -webkit-user-select: text;
        -ms-user-select: text;
            user-select: text;
}

.\\!k-user-select-text {
    -webkit-user-select: text !important;
        -ms-user-select: text !important;
            user-select: text !important;
}

.k-user-select-all {
    -webkit-user-select: all;
            user-select: all;
}

.\\!k-user-select-all {
    -webkit-user-select: all !important;
            user-select: all !important;
}

.k-user-select-contain {
    -webkit-user-select: contain;
        -ms-user-select: element;
            user-select: contain;
}

.\\!k-user-select-contain {
    -webkit-user-select: contain !important;
        -ms-user-select: element !important;
            user-select: contain !important;
}

.k-will-change-auto {
    will-change: auto;
}

.\\!k-will-change-auto {
    will-change: auto !important;
}

.k-will-change-scroll {
    will-change: scroll-position;
}

.\\!k-will-change-scroll {
    will-change: scroll-position !important;
}

.k-will-change-contents {
    will-change: contents;
}

.\\!k-will-change-contents {
    will-change: contents !important;
}

.k-will-change-transform {
    will-change: transform;
}

.\\!k-will-change-transform {
    will-change: transform !important;
}

.k-fill-none {
    fill: none;
}

.\\!k-fill-none {
    fill: none !important;
}

.k-fill-inherit {
    fill: inherit;
}

.\\!k-fill-inherit {
    fill: inherit !important;
}

.k-fill-current {
    fill: currentColor;
}

.\\!k-fill-current {
    fill: currentColor !important;
}

.k-fill-transparent {
    fill: transparent;
}

.\\!k-fill-transparent {
    fill: transparent !important;
}

.k-fill-black {
    fill: black;
}

.\\!k-fill-black {
    fill: black !important;
}

.k-fill-white {
    fill: white;
}

.\\!k-fill-white {
    fill: white !important;
}

.k-stroke-none {
    stroke: none;
}

.\\!k-stroke-none {
    stroke: none !important;
}

.k-stroke-inherit {
    stroke: inherit;
}

.\\!k-stroke-inherit {
    stroke: inherit !important;
}

.k-stroke-current {
    stroke: currentColor;
}

.\\!k-stroke-current {
    stroke: currentColor !important;
}

.k-stroke-transparent {
    stroke: transparent;
}

.\\!k-stroke-transparent {
    stroke: transparent !important;
}

.k-stroke-black {
    stroke: black;
}

.\\!k-stroke-black {
    stroke: black !important;
}

.k-stroke-white {
    stroke: white;
}

.\\!k-stroke-white {
    stroke: white !important;
}

.k-elevation-1 {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.038);
}

.\\!k-elevation-1 {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.038) !important;
}

.k-elevation-2 {
    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.075);
}

.\\!k-elevation-2 {
    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.075) !important;
}

.k-elevation-3 {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.\\!k-elevation-3 {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1) !important;
}

.k-elevation-4 {
    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.125);
}

.\\!k-elevation-4 {
    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.125) !important;
}

.k-elevation-5 {
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
}

.\\!k-elevation-5 {
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15) !important;
}

.k-elevation-6 {
    box-shadow: 0px 11px 24px 0px rgba(0, 0, 0, 0.159);
}

.\\!k-elevation-6 {
    box-shadow: 0px 11px 24px 0px rgba(0, 0, 0, 0.159) !important;
}

.k-elevation-7 {
    box-shadow: 0px 14px 36px 0px rgba(0, 0, 0, 0.168);
}

.\\!k-elevation-7 {
    box-shadow: 0px 14px 36px 0px rgba(0, 0, 0, 0.168) !important;
}

.k-elevation-8 {
    box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.176);
}

.\\!k-elevation-8 {
    box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.176) !important;
}

.k-elevation-9 {
    box-shadow: 0px 18px 60px 0px rgba(0, 0, 0, 0.185);
}

.\\!k-elevation-9 {
    box-shadow: 0px 18px 60px 0px rgba(0, 0, 0, 0.185) !important;
}

.k-body,
.k-typography {
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    font-weight: 400;
    margin: 0;
}

.k-body p,
.k-typography p {
    margin: 0 0 1rem;
}

.k-h1 {
    font-size: 2.5rem;
    line-height: 1.2;
    font-weight: 500;
    margin: 0 0 0.5rem;
}

.k-h2 {
    font-size: 2rem;
    line-height: 1.2;
    font-weight: 500;
    margin: 0 0 0.5rem;
}

.k-h3 {
    font-size: 1.75rem;
    line-height: 1.2;
    font-weight: 500;
    margin: 0 0 0.5rem;
}

.k-h4 {
    font-size: 1.5rem;
    line-height: 1.2;
    font-weight: 500;
    margin: 0 0 0.5rem;
}

.k-h5 {
    font-size: 1.25rem;
    line-height: 1.2;
    font-weight: 500;
    margin: 0 0 0.5rem;
}

.k-h6 {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 500;
    margin: 0 0 0.5rem;
}

.k-paragraph {
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    font-weight: 400;
    margin: 0 0 1rem;
}

.k-pre,
.k-code {
    font-size: 0.875rem;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    line-height: 1.5;
    font-weight: 400;
    border-style: solid;
    border-width: 1px;
}

.k-pre {
    padding-block: 16px;
    padding-inline: 24px;
    overflow: auto;
}

.k-pre > .k-code {
    padding: 0;
    border-width: 0;
    border-color: transparent;
    background-color: transparent;
    font-family: inherit;
    font-size: inherit;
}

.k-code {
    padding-block: 0px;
    padding-inline: 4px;
}

.k-display-1 {
    font-size: 5rem;
    line-height: 1.2;
    font-weight: 300;
}

.k-display-2 {
    font-size: 4.5rem;
    line-height: 1.2;
    font-weight: 300;
}

.k-display-3 {
    font-size: 4rem;
    line-height: 1.2;
    font-weight: 300;
}

.k-display-4 {
    font-size: 3.5rem;
    line-height: 1.2;
    font-weight: 300;
}

.k-body {
    color: #212529;
    background-color: #ffffff;
}

.k-pre,
.k-code {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-svg-icon {
    width: 16px;
    height: 16px;
    outline: 0;
    line-height: 1;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
}

.k-svg-icon > svg {
    fill: currentColor;
    flex: 1 1 auto;
}

.k-svg-icon.k-icon-xs {
    width: 12px;
    height: 12px;
}

.k-svg-icon.k-icon-sm {
    width: 14px;
    height: 14px;
}

.k-svg-icon.k-icon-md {
    width: 16px;
    height: 16px;
}

.k-svg-icon.k-icon-lg {
    width: 20px;
    height: 20px;
}

.k-svg-icon.k-icon-xl {
    width: 24px;
    height: 24px;
}

.k-svg-icon.k-icon-xxl {
    width: 32px;
    height: 32px;
}

.k-svg-icon.k-icon-xxxl {
    width: 48px;
    height: 48px;
}

.k-flip-h.k-svg-icon, .k-svg-icon.k-flip-x,
.k-flip-v.k-svg-icon,
.k-svg-icon.k-flip-y,
.k-flip-h.k-flip-v.k-svg-icon,
.k-flip-v.k-svg-icon.k-flip-x,
.k-svg-icon.k-flip-x.k-flip-y,
.k-flip-h.k-svg-icon.k-flip-y {
    transform: none;
}

.k-flip-h > svg, .k-flip-x > svg {
    transform: scaleX(-1);
}

.k-flip-v > svg, .k-flip-y > svg {
    transform: scaleY(-1);
}

.k-flip-h.k-flip-v > svg, .k-flip-v.k-flip-x > svg, .k-flip-x.k-flip-y > svg, .k-flip-h.k-flip-y > svg,
.k-flip-both > svg {
    transform: scale(-1, -1);
}

.k-rotate-0.k-svg-icon {
    transform: none;
}

.k-rotate-0 > svg {
    transform: rotate(0deg);
}

.k-rotate-45.k-svg-icon {
    transform: none;
}

.k-rotate-45 > svg {
    transform: rotate(45deg);
}

.k-rotate-90.k-svg-icon {
    transform: none;
}

.k-rotate-90 > svg {
    transform: rotate(90deg);
}

.k-rotate-135.k-svg-icon {
    transform: none;
}

.k-rotate-135 > svg {
    transform: rotate(135deg);
}

.k-rotate-180.k-svg-icon {
    transform: none;
}

.k-rotate-180 > svg {
    transform: rotate(180deg);
}

.k-rotate-225.k-svg-icon {
    transform: none;
}

.k-rotate-225 > svg {
    transform: rotate(225deg);
}

.k-rotate-270.k-svg-icon {
    transform: none;
}

.k-rotate-270 > svg {
    transform: rotate(270deg);
}

.k-rotate-315.k-svg-icon {
    transform: none;
}

.k-rotate-315 > svg {
    transform: rotate(315deg);
}

.k-icon-wrap {
    flex: none;
    display: inline-flex;
    flex-flow: row nowrap;
    gap: 0;
    align-items: center;
    align-self: flex-start;
    vertical-align: middle;
    position: relative;
}

.k-icon-wrap::before {
    content: "\\200b";
    width: 0;
    overflow: hidden;
    flex: none;
    display: inline-block;
    vertical-align: top;
}

.k-icon-wrapper-host {
    display: contents;
}

.k-icon-with-modifier {
    position: relative;
    margin: .25em;
}

.k-icon.k-icon-modifier {
    width: 1em;
    height: 1em;
    position: absolute;
    font-size: .5em;
    bottom: 0;
    right: 0;
    margin: 0 -.5em -.5em 0;
}

.k-i-none::before {
    content: "";
    display: none;
}

.k-icon-action {
    display: inline-flex;
    padding: 0.25rem;
    line-height: 1;
    align-items: center;
    vertical-align: middle;
    cursor: pointer;
}

.k-sprite {
    display: inline-block;
    width: 16px;
    height: 16px;
    overflow: hidden;
    background-repeat: no-repeat;
    font-size: 0;
    line-height: 0;
    text-align: center;
}

.k-image {
    display: inline-block;
}

.k-messagebox {
    margin: 0 0 1rem 0;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    border-width: 0 0 0 4px;
    border-style: solid;
    box-sizing: border-box;
    font-size: 1rem;
    line-height: 1.5;
}

.k-messagebox a {
    color: inherit;
    font-style: normal;
    text-decoration: underline;
}

.k-messagebox-primary {
    border-color: #bbd6fe;
    color: #073984;
    background-color: #cfe2ff;
}

.k-messagebox-secondary {
    border-color: #d6d8db;
    color: #383d41;
    background-color: #e2e3e5;
}

.k-messagebox-tertiary {
    border-color: #d7caee;
    color: #3a2264;
    background-color: #e2d9f3;
}

.k-messagebox-info {
    border-color: #bbf0fb;
    color: #07697d;
    background-color: #cff4fc;
}

.k-messagebox-success {
    border-color: #bfddcf;
    color: #0d462c;
    background-color: #d1e7dd;
}

.k-messagebox-warning {
    border-color: #ffeeba;
    color: #856404;
    background-color: #fff3cd;
}

.k-messagebox-error {
    border-color: #f5c6cb;
    color: #721c24;
    background-color: #f8d7da;
}

.k-messagebox-dark {
    border-color: #c1c2c3;
    color: #111315;
    background-color: #d3d3d4;
}

.k-messagebox-light {
    border-color: #fdfdfe;
    color: #818182;
    background-color: #fefefe;
}

.k-messagebox-inverse {
    border-color: #c1c2c3;
    color: #111315;
    background-color: #d3d3d4;
}

.k-drag-clue {
    border-radius: 0.375rem;
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    white-space: nowrap;
    overflow: hidden;
    position: absolute;
    z-index: 20000;
    cursor: move;
}

.k-drag-status,
.k-drag-clue .k-drag-status {
    margin: 0;
    margin-right: .4ex;
}

.k-drop-hint {
    display: flex;
    gap: 4px;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    z-index: 1000;
    transform: translate(-50%, -50%);
}

.k-drop-hint-start,
.k-drop-hint-end {
    flex-shrink: 0;
    border-width: 4px;
    border-style: solid;
    border-color: transparent;
}

.k-drop-hint-line {
    flex-grow: 1;
    background-color: #0d6efd;
}

.k-drop-hint-h .k-drop-hint-start {
    border-left-width: 6.9282032304px;
    border-left-color: #0d6efd;
    border-right-width: 0;
}

.k-drop-hint-h .k-drop-hint-line {
    width: 20px;
    height: 1px;
}

.k-drop-hint-h .k-drop-hint-end {
    border-right-width: 6.9282032304px;
    border-right-color: #0d6efd;
    border-left-width: 0;
}

.k-drop-hint-v {
    flex-direction: column;
}

.k-drop-hint-v .k-drop-hint-start {
    border-top-width: 6.9282032304px;
    border-top-color: #0d6efd;
    border-bottom-width: 0;
}

.k-drop-hint-v .k-drop-hint-line {
    width: 1px;
    height: 20px;
}

.k-drop-hint-v .k-drop-hint-end {
    border-bottom-width: 6.9282032304px;
    border-bottom-color: #0d6efd;
    border-top-width: 0;
}

.k-reorder-cue {
    position: absolute;
}

.k-reorder-cue::before, .k-reorder-cue::after {
    content: "";
    width: 0;
    height: 0;
    border: 3px solid transparent;
    position: absolute;
    transform: translateX(-50%);
}

.k-reorder-cue::before {
    border-bottom-width: 0;
    border-top-color: currentColor;
    top: -4px;
}

.k-reorder-cue::after {
    border-top-width: 0;
    border-bottom-color: currentColor;
    bottom: -4px;
}

.k-drag-clue {
    border-color: #0c65e9;
    color: white;
    background-color: #0d6efd;
}

.k-checkbox {
    margin: 0;
    padding: 0;
    line-height: initial;
    border-width: 1px;
    border-style: solid;
    outline: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    flex: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    -webkit-appearance: none;
}

.k-checkbox:checked,
.k-checkbox.k-checked {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.k-checkbox:indeterminate,
.k-checkbox.k-indeterminate {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.k-checkbox:disabled,
.k-checkbox.k-disabled {
    outline: none;
    cursor: default;
    opacity: 0.65;
    filter: grayscale(0.1);
    pointer-events: none;
    box-shadow: none;
}

.k-checkbox-wrap {
    flex: none;
    display: inline-flex;
    flex-flow: row nowrap;
    gap: 0;
    align-items: center;
    align-self: flex-start;
    vertical-align: middle;
    position: relative;
}

.k-checkbox-wrap::before {
    content: "\\200b";
    width: 0px;
    overflow: hidden;
    flex: none;
    display: inline-block;
    vertical-align: top;
}

.k-checkbox-label {
    margin: 0;
    padding: 0;
    display: inline-flex;
    align-items: flex-start;
    gap: 0.25rem;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
}

.k-checkbox-label .k-ripple {
    visibility: hidden !important;
}

.k-checkbox + .k-label,
.k-checkbox-wrap + .k-label,
.k-checkbox + .k-checkbox-label,
.k-checkbox-wrap + .k-checkbox-label {
    display: inline;
    margin-inline-start: 0.25rem;
}

.k-checkbox-label:empty {
    display: none !important;
}

.k-checkbox-label.k-no-text {
    min-width: 1px;
}

.k-checkbox-list {
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: column nowrap;
    gap: 0;
    list-style: none;
}

.k-checkbox-item,
.k-checkbox-list-item {
    padding-block: 0.25rem;
    padding-inline: 0px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    gap: 0.25rem;
}

.k-checkbox-item .k-checkbox-label,
.k-checkbox-list-item .k-checkbox-label {
    margin: 0;
}

.k-checkbox-list-horizontal,
.k-checkbox-list.k-list-horizontal {
    display: flex;
    flex-flow: row wrap;
    gap: 1rem;
}

.k-ripple-container .k-checkbox::after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    border-radius: 100%;
    z-index: -1;
    transition: opacity 100ms linear, transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
    transform: translate(-50%, -50%) scale(0);
    transform-origin: center center;
}

.k-ripple-container .k-checkbox:focus,
.k-ripple-container .k-checkbox.k-focus {
    box-shadow: none !important;
}

.k-ripple-container .k-checkbox:disabled::after,
.k-ripple-container .k-checkbox.k-disabled::after {
    display: none;
}

.k-checkbox-sm {
    width: 0.75rem;
    height: 0.75rem;
}

.k-checkbox-sm::before {
    font-size: 0.625rem;
}

.k-ripple-container .k-checkbox-sm::after {
    width: 300%;
    height: 300%;
}

.k-checkbox-md {
    width: 1rem;
    height: 1rem;
}

.k-checkbox-md::before {
    font-size: 0.875rem;
}

.k-ripple-container .k-checkbox-md::after {
    width: 300%;
    height: 300%;
}

.k-checkbox-lg {
    width: 1.25rem;
    height: 1.25rem;
}

.k-checkbox-lg::before {
    font-size: 1.125rem;
}

.k-ripple-container .k-checkbox-lg::after {
    width: 300%;
    height: 300%;
}

.k-checkbox.k-rounded-sm {
    border-radius: 0.125rem;
}

.k-checkbox.k-rounded-md {
    border-radius: 0.25rem;
}

.k-checkbox.k-rounded-lg {
    border-radius: 0.375rem;
}

.k-checkbox {
    border-color: #ced4da;
    background-color: #ffffff;
}

.k-checkbox:focus,
.k-checkbox.k-focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-checkbox:indeterminate,
.k-checkbox.k-indeterminate {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-checkbox:checked,
.k-checkbox.k-checked {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-checkbox:checked:focus,
.k-checkbox.k-checked.k-focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-checkbox.k-invalid {
    border-color: #dc3545;
}

.k-checkbox.k-invalid + .k-checkbox-label {
    color: #dc3545;
}

.k-checkbox-wrap .k-ripple-blob {
    color: #0d6efd;
    opacity: 0.25;
}

.k-ripple-container .k-checkbox::after {
    background: #0d6efd;
    opacity: 0.25;
}

.k-list-container {
    display: flex;
    flex-flow: column nowrap;
}

.k-list-container > .k-list {
    flex: 1;
    height: 100%;
}

.k-list {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    display: flex;
    flex-flow: column nowrap;
    outline: none;
    position: relative;
    overflow: hidden;
}

.k-list *,
.k-list *::before,
.k-list *::after {
    box-sizing: border-box;
}

.k-popup > .k-list {
    height: 100%;
    border-width: 0;
}

.k-list-group-sticky-header {
    border-width: 0;
    border-width: 0 0 1px;
    border-style: solid;
    font-weight: 700;
    white-space: nowrap;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    flex: none;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.k-list-content {
    border-color: inherit;
    flex: 1 1 auto;
    overflow: hidden;
    overflow-y: auto;
    position: relative;
}

.k-list-ul {
    margin: 0;
    padding: 0;
    border-width: 0;
    border-color: inherit;
    height: auto;
    list-style: none;
}

.k-list-item, .k-list-optionlabel {
    border: 0;
    outline: none;
    cursor: pointer;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    gap: 0.5rem;
    position: relative;
    transition-property: color, background-color, outline-color, box-shadow;
    transition-duration: 200ms;
    transition-timing-function: ease;
}

.k-list-item.k-first::before, .k-first.k-list-optionlabel::before {
    content: "";
    border-width: 1px 0 0;
    border-style: solid;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.k-list-item-text::before,
.k-list-header-text::before,
.k-list-optionlabel::before {
    content: "\\200b";
    width: 0px;
    overflow: hidden;
}

.k-list-optionlabel {
    column-gap: 0;
}

.k-list-group-item {
    border-width: 0;
    border-width: 1px 0 0;
    border-style: solid;
    font-weight: 700;
    cursor: default;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    gap: 0.5rem;
    position: relative;
}

.k-list-item-group-label {
    padding-block: 0;
    padding-inline: .5em;
    font-size: .75em;
    position: absolute;
    top: 0;
    inset-inline-end: 0;
}

.k-virtual-content,
.k-virtual-list .k-list-content {
    overflow-y: scroll;
}

.k-virtual-list .k-list-item, .k-virtual-list .k-list-optionlabel,
.k-virtual-list .k-list-group-item,
.k-virtual-content .k-list-item,
.k-virtual-content .k-list-optionlabel,
.k-virtual-content .k-list-group-item {
    position: absolute;
    width: 100%;
}

.k-virtual-list .k-list-item-text,
.k-virtual-list .k-list-header-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-virtual-list .k-list-optionlabel {
    position: relative;
}

.k-list-filter {
    display: block;
    position: relative;
    padding: 1rem;
    box-sizing: border-box;
    flex: none;
}

.k-list-sm {
    font-size: 0.875rem;
    line-height: 1.4285714286;
}

.k-list-sm .k-list-group-sticky-header {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-list-sm .k-list-item, .k-list-sm .k-list-optionlabel {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-list-sm .k-list-group-item {
    padding-block: 0.125rem;
    padding-inline: 1rem;
}

.k-list-md {
    font-size: 1rem;
    line-height: 1.5;
}

.k-list-md .k-list-group-sticky-header {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-list-md .k-list-item, .k-list-md .k-list-optionlabel {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-list-md .k-list-group-item {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-list-lg {
    font-size: 1rem;
    line-height: 1.5;
}

.k-list-lg .k-list-group-sticky-header {
    padding-block: 0.5rem;
    padding-inline: 1rem;
}

.k-list-lg .k-list-item, .k-list-lg .k-list-optionlabel {
    padding-block: 0.5rem;
    padding-inline: 1rem;
}

.k-list-lg .k-list-group-item {
    padding-block: 0.375rem;
    padding-inline: 1rem;
}

.k-no-data, .k-nodata {
    min-height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: lighter;
    text-align: center;
    white-space: normal;
}

.k-list {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-list-group-sticky-header {
    border-color: inherit;
}

.k-list-item:hover, .k-list-optionlabel:hover, .k-list-item.k-hover, .k-hover.k-list-optionlabel {
    color: #212529;
    background-color: #e9ecef;
}

.k-list-item:focus, .k-list-optionlabel:focus, .k-list-item.k-focus, .k-focus.k-list-optionlabel {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-list-item.k-selected, .k-selected.k-list-optionlabel {
    color: white;
    background-color: #0d6efd;
}

.k-list-item.k-selected:hover, .k-selected.k-list-optionlabel:hover, .k-list-item.k-selected.k-hover, .k-selected.k-hover.k-list-optionlabel {
    color: white;
    background-color: #0c65e9;
}

.k-list-optionlabel,
.k-list-optionlabel.k-hover,
.k-list-optionlabel:hover {
    color: #6c757d;
}

.k-list-group-item {
    border-color: inherit;
}

.k-list-item-group-label {
    color: #ffffff;
    background-color: #212529;
}

.k-no-data, .k-nodata {
    color: #6c757d;
}

.k-listgroup {
    border-radius: 0.25rem;
    margin: 0;
    padding: 0;
    border-width: 1px;
    border-style: solid;
    font-size: 1rem;
    line-height: 1.5;
    list-style: none;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.k-listgroup > ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
}

.k-listgroup .k-listgroup-item + .k-listgroup-item {
    border-top-width: 1px;
}

.k-listgroup-flush {
    border-radius: 0;
    border-left-width: 0;
    border-right-width: 0;
}

.k-listgroup-item {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex: 0 0 auto;
    position: relative;
}

.k-listgroup-item > .k-link {
    margin-block: -0.5rem;
    margin-inline: -1rem;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    color: inherit;
    text-decoration: none;
    outline: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex: 1 1 auto;
    position: relative;
}

.k-listgroup-item > .k-link > .k-select {
    padding: 0.5rem;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    position: absolute;
    top: 50%;
    inset-inline-end: 0;
    transform: translateY(-50%);
}

.k-listgroup-item-segmented {
    align-items: stretch;
}

.k-listgroup-item-segmented > .k-link {
    margin-right: 0;
}

.k-listgroup-item-segmented > .k-select {
    margin: -0.5rem -1rem -0.5rem 0;
    padding: 0.5rem;
    border-width: 0 0 0 1px;
    border-style: solid;
    border-color: inherit;
    cursor: pointer;
}

.k-listgroup-form-row {
    margin-block: -0.5rem;
    margin-inline: -1rem;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 auto;
    position: relative;
}

.k-listgroup-form-row .k-listgroup-form-field-label {
    width: 40%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-listgroup-form-row .k-listgroup-form-field-wrapper {
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    text-align: end;
    position: relative;
}

.k-listgroup-form-row .k-listgroup-form-field-wrapper select,
.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type="text"],
.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type="password"],
.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type="date"],
.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type="time"],
.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type="datetime-local"],
.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type="number"],
.k-listgroup-form-row .k-listgroup-form-field-wrapper textarea {
    width: 100%;
    box-sizing: border-box;
    flex: 1 1 100%;
}

.k-listgroup-form-row .k-listgroup-form-field-wrapper textarea {
    min-height: 4em;
    resize: vertical;
}

.k-listgroup-item.k-listgroup-form-row {
    margin: 0;
}

[dir="rtl"] .k-listgroup-item > .k-link > .k-select {
    right: auto;
    left: 0;
}

[dir="rtl"] .k-listgroup-item-segmented > .k-link {
    margin-right: -1rem;
    margin-left: 0;
}

[dir="rtl"] .k-listgroup-item-segmented > .k-select {
    margin-right: 0;
    margin-left: -1rem;
    border-right-width: 1px;
    border-left-width: 0;
}

.k-noflexbox .k-listgroup,
.k-noflexbox .k-listgroup > ul .k-listgroup-item,
.k-noflexbox .k-listgroup-item > .k-link {
    display: block;
}

.k-listgroup {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-overlay {
    width: 100%;
    height: 100%;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10001;
}

.k-overlay {
    background-color: #000000;
}

.k-overlay-primary {
    background-color: #0d6efd;
}

.k-overlay-secondary {
    background-color: #6c757d;
}

.k-overlay-tertiary {
    background-color: #6f42c1;
}

.k-overlay-info {
    background-color: #0dcaf0;
}

.k-overlay-success {
    background-color: #198754;
}

.k-overlay-warning {
    background-color: #ffc107;
}

.k-overlay-error {
    background-color: #dc3545;
}

.k-overlay-dark {
    background-color: #212529;
}

.k-overlay-light {
    background-color: #f8f9fa;
}

.k-overlay-inverse {
    background-color: #212529;
}

.k-popup {
    border-radius: 0.375rem;
    margin: 0;
    padding: 0;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.k-popup .k-item {
    outline: none;
}

.k-animation-container {
    border-radius: 0 0 0.375rem 0.375rem;
}

.k-animation-container-shown {
    overflow: visible;
}

.k-popup > .k-colorpalette {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-popup.k-popup-transparent {
    border-width: 0;
    background-color: transparent;
    box-shadow: none;
}

.k-popup.k-popup-flush {
    padding: 0;
}

.k-popup > .k-widget,
.k-popup > .k-coloreditor {
    border-width: 0;
}

.k-shadow {
    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));
}

.k-popup.k-column-menu {
    padding-top: 0;
    padding-bottom: 0;
}

.k-popup {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));
}

.k-animation-container {
    border-radius: 0 0 0.375rem 0.375rem;
}

.k-ripple-target {
    position: relative;
}

.k-ripple {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    overflow: hidden;
    pointer-events: none;
}

.k-ripple-blob {
    pointer-events: none;
    position: absolute;
    border-radius: 50%;
    padding: 0;
    transform: translate(-50%, -50%) scale(0);
    transition: opacity 100ms linear, transform 500ms cubic-bezier(0.4, 0, 0.2, 1);
    opacity: .1;
    background-color: currentColor;
}

.k-primary .k-ripple-blob {
    opacity: .2;
}

.k-ripple-focus::after {
    visibility: visible;
    animation: ripple 600ms ease-out;
}

@keyframes ripple {
    0% {
        transform: translate(-50%, -50%) scale(0);
    }
    20% {
        transform: translate(-50%, -50%) scale(1);
    }
    100% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(1);
    }
}

.k-table {
    width: 100%;
    max-width: none;
    border-width: 1px;
    border-style: solid;
    text-align: start;
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
    outline: none;
}

.k-data-table {
    border-width: 1px;
    border-style: solid;
}

.k-data-table .k-table {
    table-layout: fixed;
}

.k-table-thead,
.k-table-tbody,
.k-table-tfoot,
.k-table-row,
.k-table-alt-row {
    border-color: inherit;
    text-align: inherit;
}

.k-table-th,
.k-table-td {
    border-width: 0 0 0px 1px;
    border-style: solid;
    border-color: inherit;
    box-sizing: border-box;
    font-weight: normal;
    text-align: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: table-cell;
    overflow: hidden;
    position: relative;
}

.k-table-th:first-child,
.k-table-td:first-child {
    border-left-width: 0;
}

.k-table-th {
    border-bottom-width: 1px;
}

.k-table-header {
    padding-inline-end: var(--kendo-scrollbar-width);
    border-width: 0 0 1px;
    border-style: solid;
    box-sizing: border-box;
}

.k-table-header .k-table {
    border-width: 0;
}

.k-table-header-wrap {
    margin-right: -1px;
    width: 100%;
    border-width: 0 1px 0 0;
    border-style: solid;
    border-color: inherit;
    overflow: hidden;
}

.k-table-header > .k-table,
.k-table-header-wrap > .k-table {
    margin-bottom: -1px;
}

.k-table-group-sticky-header {
    flex: none;
}

.k-table-group-sticky-header .k-table-th {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
}

.k-table-list {
    margin: 0;
    padding: 0;
    width: 100%;
    max-width: none;
    border-width: 0;
    display: table;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    empty-cells: show;
    list-style: none;
    outline: none;
}

.k-table-list .k-table-row {
    position: relative;
}

.k-table-list .k-table-row,
.k-table-list .k-table-group-row {
    width: 100%;
    box-sizing: border-box;
    display: table-row;
}

.k-table-list .k-table-row.k-first {
    border-top: 1px solid currentColor;
}

.k-table-list .k-table-th,
.k-table-list .k-table-td {
    vertical-align: middle;
}

.k-table-list .k-table-group-row {
    position: sticky;
}

.k-table-list .k-table-group-row::before {
    content: "\\200b";
    padding-inline: 0;
    width: 0;
    display: block;
    overflow: hidden;
}

.k-table-list .k-table-group-row .k-table-th {
    width: 100%;
    border-color: inherit;
    color: inherit;
    background-color: inherit;
    position: absolute;
    top: 0;
}

.k-table-list .k-table-spacer-td {
    padding: 0 !important;
    width: 0 !important;
    border-left-width: 0 !important;
    border-right-width: 0 !important;
}

.k-table-list .k-table-group-td {
    padding: 0 !important;
    width: 0 !important;
    border-left-width: 0 !important;
    border-right-width: 0 !important;
    overflow: visible;
}

.k-table-list .k-table-group-td > span {
    font-size: .75em;
    position: absolute;
    top: 0;
    right: 0;
}

.k-virtual-table .k-table-row,
.k-virtual-table .k-table-group-row {
    position: absolute;
    width: 100%;
}

.k-table-scroller {
    position: relative;
    overflow: auto;
}

.k-table-scroller > .k-table {
    border-width: 0;
}

.k-table-footer {
    padding-inline-end: var(--kendo-scrollbar-width);
    border-width: 1px 0 0;
    border-style: solid;
    box-sizing: border-box;
}

.k-table-footer .k-table {
    border-width: 0;
}

.k-table-footer-wrap {
    margin-right: -1px;
    width: 100%;
    border-width: 0 1px 0 0;
    border-style: solid;
    border-color: inherit;
    overflow: hidden;
}

.k-table-sm {
    font-size: 1rem;
    line-height: 1.5;
}

.k-table-sm .k-table-th,
.k-table-sm .k-table-td {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
}

.k-table-sm .k-table-list .k-table-group-td > span {
    padding-block: 0;
    padding-inline: 0.25rem;
}

.k-table-sm .k-table-list .k-table-group-row::before {
    padding-block: 0.25rem;
    padding-inline: 0;
}

.k-table-md {
    font-size: 1rem;
    line-height: 1.5;
}

.k-table-md .k-table-th,
.k-table-md .k-table-td {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-table-md .k-table-list .k-table-group-td > span {
    padding-block: 0;
    padding-inline: 0.25rem;
}

.k-table-md .k-table-list .k-table-group-row::before {
    padding-block: 0.5rem;
    padding-inline: 0;
}

.k-table-lg {
    font-size: 1rem;
    line-height: 1.5;
}

.k-table-lg .k-table-th,
.k-table-lg .k-table-td {
    padding-block: 0.625rem;
    padding-inline: 0.5rem;
}

.k-table-lg .k-table-list .k-table-group-td > span {
    padding-block: 0;
    padding-inline: 0.25rem;
}

.k-table-lg .k-table-list .k-table-group-row::before {
    padding-block: 0.625rem;
    padding-inline: 0;
}

.k-rtl.k-table .k-table-th,
.k-rtl.k-table .k-table-td,
.k-rtl .k-table .k-table-th,
.k-rtl .k-table .k-table-td,
[dir="rtl"].k-table .k-table-th,
[dir="rtl"].k-table .k-table-td,
[dir="rtl"] .k-table .k-table-th,
[dir="rtl"] .k-table .k-table-td {
    border-left-width: 0;
    border-right-width: 1px;
}

.k-rtl.k-table .k-table-th:first-child,
.k-rtl.k-table .k-table-td:first-child,
.k-rtl .k-table .k-table-th:first-child,
.k-rtl .k-table .k-table-td:first-child,
[dir="rtl"].k-table .k-table-th:first-child,
[dir="rtl"].k-table .k-table-td:first-child,
[dir="rtl"] .k-table .k-table-th:first-child,
[dir="rtl"] .k-table .k-table-td:first-child {
    border-right-width: 0;
}

.k-rtl.k-table .k-table-header-wrap,
.k-rtl.k-table .k-table-footer-wrap,
.k-rtl .k-table .k-table-header-wrap,
.k-rtl .k-table .k-table-footer-wrap,
[dir="rtl"].k-table .k-table-header-wrap,
[dir="rtl"].k-table .k-table-footer-wrap,
[dir="rtl"] .k-table .k-table-header-wrap,
[dir="rtl"] .k-table .k-table-footer-wrap {
    margin-right: 0;
    margin-left: -1px;
    border-left-width: 1px;
    border-right-width: 0;
}

.k-rtl .k-table-list .k-table-group-td > span,
[dir="rtl"] .k-table-list .k-table-group-td > span {
    left: 0;
    right: auto;
}

.k-table,
.k-data-table {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-table-thead,
.k-table-header,
.k-table-group-sticky-header {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-table-tfoot,
.k-table-footer {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-table-group-row {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-table-group-td > span {
    color: #ffffff;
    background-color: #212529;
}

.k-table-alt-row {
    background-color: rgba(0, 0, 0, 0.04);
}

.k-table-tbody .k-table-row:hover,
.k-table-list .k-table-row:hover,
.k-table-tbody .k-table-row.k-hover,
.k-table-list .k-table-row.k-hover {
    background-color: rgba(0, 0, 0, 0.08);
}

.k-table-tbody .k-table-row.k-focus, .k-table-tbody .k-table-row:focus,
.k-table-list .k-table-row.k-focus,
.k-table-list .k-table-row:focus,
.k-table-tbody .k-table-td.k-focus,
.k-table-tbody .k-table-td:focus,
.k-table-list .k-table-td.k-focus,
.k-table-list .k-table-td:focus {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);
}

.k-table-tbody .k-table-row.k-selected > .k-table-td,
.k-table-list .k-table-row.k-selected {
    color: #212529;
    background-color: rgba(13, 110, 253, 0.25);
}

.k-virtual-scroller {
    width: 100%;
    height: 100%;
    flex: 1 1 auto;
    overflow: auto;
    position: relative;
}

.k-virtual-scroller-wrap {
    position: relative;
    z-index: 1;
}

.k-virtual-scroller-content {
    position: absolute;
    width: 100%;
    top: 0;
    inset-inline-start: 0;
}

.k-virtual-scroller-size {
    position: relative;
    z-index: 0;
}

.k-avatar {
    border-width: 0;
    border-style: solid;
    box-sizing: border-box;
    vertical-align: middle;
    display: inline-flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    overflow: hidden;
}

.k-avatar *,
.k-avatar *::before,
.k-avatar *::after {
    box-sizing: border-box;
}

.k-avatar-text,
.k-avatar-initials {
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
}

.k-avatar-icon {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}

.k-avatar-image {
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.k-avatar-image > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: top;
}

.k-avatar-sm {
    width: 1rem;
    height: 1rem;
    flex-basis: 1rem;
}

.k-avatar-md {
    width: 2rem;
    height: 2rem;
    flex-basis: 2rem;
}

.k-avatar-lg {
    width: 4rem;
    height: 4rem;
    flex-basis: 4rem;
}

.k-avatar-bordered {
    border-width: 1px;
}

.k-avatar-solid-primary {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-avatar-solid-secondary {
    border-color: #6c757d;
    color: white;
    background-color: #6c757d;
}

.k-avatar-solid-tertiary {
    border-color: #6f42c1;
    color: white;
    background-color: #6f42c1;
}

.k-avatar-solid-info {
    border-color: #0dcaf0;
    color: white;
    background-color: #0dcaf0;
}

.k-avatar-solid-success {
    border-color: #198754;
    color: white;
    background-color: #198754;
}

.k-avatar-solid-warning {
    border-color: #ffc107;
    color: black;
    background-color: #ffc107;
}

.k-avatar-solid-error {
    border-color: #dc3545;
    color: white;
    background-color: #dc3545;
}

.k-avatar-solid-dark {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-avatar-solid-light {
    border-color: #f8f9fa;
    color: black;
    background-color: #f8f9fa;
}

.k-avatar-solid-inverse {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-avatar-outline {
    border-color: currentColor;
}

.k-avatar-outline-primary {
    color: #0d6efd;
}

.k-avatar-outline-secondary {
    color: #6c757d;
}

.k-avatar-outline-tertiary {
    color: #6f42c1;
}

.k-avatar-outline-info {
    color: #0dcaf0;
}

.k-avatar-outline-success {
    color: #198754;
}

.k-avatar-outline-warning {
    color: #ffc107;
}

.k-avatar-outline-error {
    color: #dc3545;
}

.k-avatar-outline-dark {
    color: #212529;
}

.k-avatar-outline-light {
    color: #f8f9fa;
}

.k-avatar-outline-inverse {
    color: #212529;
}

.k-badge {
    padding: 0;
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    box-sizing: border-box;
    color: inherit;
    background-color: transparent;
    font: inherit;
    text-align: center;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-badge *,
.k-badge *::before,
.k-badge *::after {
    box-sizing: border-box;
}

.k-badge > * {
    color: inherit;
}

a.k-badge,
.k-badge > a {
    text-decoration: none;
}

a.k-badge:hover,
.k-badge > a:hover {
    text-decoration: underline;
}

.k-badge-icon {
    max-width: 1em;
    max-height: 1em;
    font-size: inherit;
}

.k-badge-icon.k-svg-icon svg {
    fill: currentColor;
}

.k-badge-sm {
    padding-block: 0.175em;
    padding-inline: 0.325em;
    font-size: 0.75em;
    line-height: 1;
    min-width: calc(1.35em + 2px);
}

.k-badge-sm:empty {
    padding: 0.175em;
    min-width: auto;
}

.k-badge-md {
    padding-block: 0.35em;
    padding-inline: 0.65em;
    font-size: 0.75em;
    line-height: 1;
    min-width: calc(1.7em + 2px);
}

.k-badge-md:empty {
    padding: 0.35em;
    min-width: auto;
}

.k-badge-lg {
    padding-block: 0.525em;
    padding-inline: 0.975em;
    font-size: 0.75em;
    line-height: 1;
    min-width: calc(2.05em + 2px);
}

.k-badge-lg:empty {
    padding: 0.525em;
    min-width: auto;
}

kendo-badge-container {
    display: inline-block;
}

.k-badge-container {
    position: relative;
    overflow: visible;
}

.k-badge-inside {
    position: absolute;
    z-index: 9999;
}

.k-badge-edge {
    position: absolute;
    z-index: 9999;
}

.k-badge-edge.k-top-start {
    transform: translate(-50%, -50%);
}

.k-badge-edge.k-top-end {
    transform: translate(50%, -50%);
}

.k-badge-edge.k-bottom-start {
    transform: translate(-50%, 50%);
}

.k-badge-edge.k-bottom-end {
    transform: translate(50%, 50%);
}

.k-rtl .k-badge-edge.k-top-start,
[dir="rtl"].k-badge-edge.k-top-start,
[dir="rtl"] .k-badge-edge.k-top-start {
    transform: translate(50%, -50%);
}

.k-rtl .k-badge-edge.k-top-end,
[dir="rtl"].k-badge-edge.k-top-end,
[dir="rtl"] .k-badge-edge.k-top-end {
    transform: translate(-50%, -50%);
}

.k-rtl .k-badge-edge.k-bottom-start,
[dir="rtl"].k-badge-edge.k-bottom-start,
[dir="rtl"] .k-badge-edge.k-bottom-start {
    transform: translate(50%, 50%);
}

.k-rtl .k-badge-edge.k-bottom-end,
[dir="rtl"].k-badge-edge.k-bottom-end,
[dir="rtl"] .k-badge-edge.k-bottom-end {
    transform: translate(-50%, 50%);
}

.k-badge-outside {
    position: absolute;
    z-index: 9999;
}

.k-badge-outside.k-top-start {
    transform: translate(-100%, -100%);
}

.k-badge-outside.k-top-end {
    transform: translate(100%, -100%);
}

.k-badge-outside.k-bottom-start {
    transform: translate(-100%, 100%);
}

.k-badge-outside.k-bottom-end {
    transform: translate(100%, 100%);
}

.k-rtl .k-badge-outside.k-top-start,
[dir="rtl"].k-badge-outside.k-top-start,
[dir="rtl"] .k-badge-outside.k-top-start {
    transform: translate(100%, -100%);
}

.k-rtl .k-badge-outside.k-top-end,
[dir="rtl"].k-badge-outside.k-top-end,
[dir="rtl"] .k-badge-outside.k-top-end {
    transform: translate(-100%, -100%);
}

.k-rtl .k-badge-outside.k-bottom-start,
[dir="rtl"].k-badge-outside.k-bottom-start,
[dir="rtl"] .k-badge-outside.k-bottom-start {
    transform: translate(100%, 100%);
}

.k-rtl .k-badge-outside.k-bottom-end,
[dir="rtl"].k-badge-outside.k-bottom-end,
[dir="rtl"] .k-badge-outside.k-bottom-end {
    transform: translate(-100%, 100%);
}

.k-badge-border-cutout {
    box-shadow: 0 0 0 2px #ffffff;
}

.k-badge-solid-primary {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-badge-solid-secondary {
    border-color: #6c757d;
    color: white;
    background-color: #6c757d;
}

.k-badge-solid-tertiary {
    border-color: #6f42c1;
    color: white;
    background-color: #6f42c1;
}

.k-badge-solid-info {
    border-color: #0dcaf0;
    color: white;
    background-color: #0dcaf0;
}

.k-badge-solid-success {
    border-color: #198754;
    color: white;
    background-color: #198754;
}

.k-badge-solid-warning {
    border-color: #ffc107;
    color: black;
    background-color: #ffc107;
}

.k-badge-solid-error {
    border-color: #dc3545;
    color: white;
    background-color: #dc3545;
}

.k-badge-solid-dark {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-badge-solid-light {
    border-color: #f8f9fa;
    color: black;
    background-color: #f8f9fa;
}

.k-badge-solid-inverse {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-badge-outline {
    border-color: currentColor;
    background-color: #ffffff;
}

.k-badge-outline-primary {
    color: #0d6efd;
}

.k-badge-outline-secondary {
    color: #6c757d;
}

.k-badge-outline-tertiary {
    color: #6f42c1;
}

.k-badge-outline-info {
    color: #0dcaf0;
}

.k-badge-outline-success {
    color: #198754;
}

.k-badge-outline-warning {
    color: #ffc107;
}

.k-badge-outline-error {
    color: #dc3545;
}

.k-badge-outline-dark {
    color: #212529;
}

.k-badge-outline-light {
    color: #f8f9fa;
}

.k-badge-outline-inverse {
    color: #212529;
}

.k-chip {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    border-width: 1px;
    border-style: solid;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.25;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-chip *,
.k-chip *::before,
.k-chip *::after {
    box-sizing: border-box;
}

.k-chip .k-selected-icon-wrapper {
    display: none !important;
}

.k-chip-content {
    padding-block: .5em;
    padding-inline: 0;
    margin-block: -.5em;
    margin-inline: 0;
    min-width: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    overflow: hidden;
    flex: 1 1 auto;
}

.k-chip-content .k-icon-wrapper-host {
    display: initial;
}

.k-chip-content:first-child {
    margin-inline-start: 0.25rem;
}

.k-chip-content:last-child {
    margin-inline-end: 0.25rem;
}

.k-chip-text,
.k-chip-label {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    flex: 1 1 auto;
}

.k-chip-avatar {
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    flex: none;
}

.k-chip-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
}

.k-chip-actions {
    margin-block: -5em;
    margin-inline: 0;
    flex: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-self: center;
}

.k-chip-action {
    flex: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-self: center;
}

.k-remove-icon {
    font-size: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
}

.k-chip-list {
    min-width: 0px;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
}

.k-chip-sm {
    padding-block: 0.125rem;
    padding-inline: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.25;
}

.k-chip-sm .k-chip-action {
    padding: 0.125rem;
}

.k-chip-avatar {
    width: 1em;
    height: 1em;
    flex-basis: 1em;
}

.k-chip-md {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    font-size: 1rem;
    line-height: 1.25;
}

.k-chip-md .k-chip-action {
    padding: 0.25rem;
}

.k-chip-avatar {
    width: 1em;
    height: 1em;
    flex-basis: 1em;
}

.k-chip-lg {
    padding-block: 0.375rem;
    padding-inline: 0.25rem;
    font-size: 1rem;
    line-height: 1.25;
}

.k-chip-lg .k-chip-action {
    padding: 0.375rem;
}

.k-chip-avatar {
    width: 1em;
    height: 1em;
    flex-basis: 1em;
}

.k-chip-list-sm {
    gap: 0.25rem;
}

.k-chip-list-md {
    gap: 0.25rem;
}

.k-chip-list-lg {
    gap: 0.25rem;
}

.k-chip-solid-base {
    border-color: #e4e7eb;
    color: #212529;
    background-color: #e4e7eb;
}

.k-chip-solid-base:focus, .k-chip-solid-base.k-focus {
    box-shadow: 0 0 0 2px rgba(228, 231, 235, 0.16);
}

.k-chip-solid-base:hover, .k-chip-solid-base.k-hover {
    background-color: #ced3db;
}

.k-chip-solid-base.k-selected {
    background-color: #c7cdd5;
}

.k-chip-solid-error {
    border-color: #e56874;
    color: #4d1318;
    background-color: #f8d7da;
}

.k-chip-solid-error:focus, .k-chip-solid-error.k-focus {
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.16);
}

.k-chip-solid-error:hover, .k-chip-solid-error.k-hover {
    background-color: #f3b8be;
}

.k-chip-solid-error.k-selected {
    background-color: #ee9aa2;
}

.k-chip-solid-info {
    border-color: #4ad7f4;
    color: #054754;
    background-color: #cff4fc;
}

.k-chip-solid-info:focus, .k-chip-solid-info.k-focus {
    box-shadow: 0 0 0 2px rgba(13, 202, 240, 0.16);
}

.k-chip-solid-info:hover, .k-chip-solid-info.k-hover {
    background-color: #aaecfa;
}

.k-chip-solid-info.k-selected {
    background-color: #86e5f8;
}

.k-chip-solid-warning {
    border-color: #ffd145;
    color: #594402;
    background-color: #fff3cd;
}

.k-chip-solid-warning:focus, .k-chip-solid-warning.k-focus {
    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.16);
}

.k-chip-solid-warning:hover, .k-chip-solid-warning.k-hover {
    background-color: #ffe9a8;
}

.k-chip-solid-warning.k-selected {
    background-color: #ffe083;
}

.k-chip-solid-success {
    border-color: #53a57f;
    color: #092f1d;
    background-color: #d1e7dd;
}

.k-chip-solid-success:focus, .k-chip-solid-success.k-focus {
    box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.16);
}

.k-chip-solid-success:hover, .k-chip-solid-success.k-hover {
    background-color: #afd5c3;
}

.k-chip-solid-success.k-selected {
    background-color: #8cc3aa;
}

.k-chip-outline-base {
    border-color: #212529;
    color: #212529;
    background-color: #ffffff;
}

.k-chip-outline-base:focus, .k-chip-outline-base.k-focus {
    box-shadow: 0 0 0 2px rgba(228, 231, 235, 0.16);
}

.k-chip-outline-base:hover, .k-chip-outline-base.k-hover {
    color: white;
    background-color: #212529;
}

.k-chip-outline-base.k-selected {
    color: white;
    background-color: #212529;
}

.k-chip-outline-error {
    border-color: #a52834;
    color: #a52834;
    background-color: #ffffff;
}

.k-chip-outline-error:focus, .k-chip-outline-error.k-focus {
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.16);
}

.k-chip-outline-error:hover, .k-chip-outline-error.k-hover {
    border-color: #a52834;
    color: white;
    background-color: #a52834;
}

.k-chip-outline-error.k-selected {
    border-color: #a52834;
    color: white;
    background-color: #a52834;
}

.k-chip-outline-info {
    border-color: #0a98b4;
    color: #0a98b4;
    background-color: #ffffff;
}

.k-chip-outline-info:focus, .k-chip-outline-info.k-focus {
    box-shadow: 0 0 0 2px rgba(13, 202, 240, 0.16);
}

.k-chip-outline-info:hover, .k-chip-outline-info.k-hover {
    border-color: #0a98b4;
    color: white;
    background-color: #0a98b4;
}

.k-chip-outline-info.k-selected {
    border-color: #0a98b4;
    color: white;
    background-color: #0a98b4;
}

.k-chip-outline-warning {
    border-color: #ffc107;
    color: #212529;
    background-color: #ffffff;
}

.k-chip-outline-warning:focus, .k-chip-outline-warning.k-focus {
    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.16);
}

.k-chip-outline-warning:hover, .k-chip-outline-warning.k-hover {
    color: #332701;
    background-color: #ffc107;
}

.k-chip-outline-warning.k-selected {
    color: #332701;
    background-color: #ffc107;
}

.k-chip-outline-success {
    border-color: #13653f;
    color: #13653f;
    background-color: #ffffff;
}

.k-chip-outline-success:focus, .k-chip-outline-success.k-focus {
    box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.16);
}

.k-chip-outline-success:hover, .k-chip-outline-success.k-hover {
    border-color: #13653f;
    color: white;
    background-color: #13653f;
}

.k-chip-outline-success.k-selected {
    border-color: #13653f;
    color: white;
    background-color: #13653f;
}

.k-chip-outline-info {
    border-color: #0dcaf0;
    color: #212529;
}

.k-chip-outline-info:hover, .k-chip-outline-info.k-hover, .k-chip-outline-info.k-selected {
    border-color: #0dcaf0;
    color: #212529;
    background-color: #0dcaf0;
}

.k-color-preview {
    width: 100%;
    height: 100%;
    border-width: 1px;
    border-radius: 0.375rem;
    box-sizing: border-box;
    border-style: solid;
    display: inline-flex;
    flex-flow: row nowrap;
    position: relative;
    overflow: hidden;
}

.k-color-preview *,
.k-color-preview *::before,
.k-color-preview *::after {
    box-sizing: border-box;
}

.k-coloreditor-current-color {
    cursor: pointer;
}

.k-icon-color-preview {
    border-width: 0;
    border-radius: 0;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    gap: 2px;
}

.k-icon-color-preview .k-color-preview-mask {
    width: 14px;
    height: 2px;
}

.k-color-preview-mask {
    width: 100%;
    height: 100%;
    position: relative;
}

.k-color-preview-mask::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: contain;
    background-position: 0 0;
}

.k-no-color .k-color-preview-mask::before {
    content: "";
    background-color: #ffffff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 100% 100%;
    background-position: 0 0;
}

.k-color-preview {
    border-color: #dee2e6;
}

.k-color-preview:hover, .k-color-preview.k-hover {
    border-color: #d6d9dc;
}

.k-loader {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;
    line-height: 0;
}

.k-loader-canvas {
    display: flex;
    position: relative;
}

.k-loader-segment {
    border-radius: 50%;
    background-color: currentColor;
    position: absolute;
}

.k-loader-sm {
    padding: 0.125rem;
}

.k-loader-sm .k-loader-segment {
    width: 0.25rem;
    height: 0.25rem;
}

.k-loader-md {
    padding: 0.25rem;
}

.k-loader-md .k-loader-segment {
    width: 0.5rem;
    height: 0.5rem;
}

.k-loader-lg {
    padding: 0.5rem;
}

.k-loader-lg .k-loader-segment {
    width: 1rem;
    height: 1rem;
}

@keyframes pulsing-2-segment {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
    100% {
        transform: scale(1);
    }
}

.k-loader-pulsing-2 .k-loader-canvas {
    align-items: center;
}

.k-loader-pulsing-2 .k-loader-segment:nth-child(1) {
    left: 0;
    transform: scale(1.5);
    transform-origin: 0 50%;
    animation: pulsing-2-segment 1s ease infinite;
    animation-delay: -.5s;
}

.k-loader-pulsing-2 .k-loader-segment:nth-child(2) {
    right: 0;
    transform-origin: 100% 50%;
    animation: pulsing-2-segment 1s ease infinite;
}

.k-loader-pulsing-2.k-loader-sm .k-loader-canvas {
    width: 0.75rem;
    height: 0.375rem;
}

.k-loader-pulsing-2.k-loader-md .k-loader-canvas {
    width: 1.5rem;
    height: 0.75rem;
}

.k-loader-pulsing-2.k-loader-lg .k-loader-canvas {
    width: 3rem;
    height: 1.5rem;
}

@keyframes spinner-3-segment {
    0% {
        top: 0;
        left: 50%;
    }
    33.3333% {
        top: 100%;
        left: 0;
    }
    66.6666% {
        top: 100%;
        left: 100%;
    }
    100% {
        top: 0;
        left: 50%;
    }
}

.k-loader-spinner-3 .k-loader-segment {
    transform: translate(-50%, -50%);
}

.k-loader-spinner-3 .k-loader-segment:nth-child(1) {
    top: 0;
    left: 50%;
    animation: spinner-3-segment 2s ease infinite;
}

.k-loader-spinner-3 .k-loader-segment:nth-child(2) {
    top: 100%;
    left: 0;
    animation: spinner-3-segment 2s ease infinite;
    animation-delay: -0.6666666667s;
}

.k-loader-spinner-3 .k-loader-segment:nth-child(3) {
    top: 100%;
    left: 100%;
    animation: spinner-3-segment 2s ease infinite;
    animation-delay: -1.3333333333s;
}

.k-loader-spinner-3.k-loader-sm .k-loader-canvas {
    margin: 0.125rem;
    width: 0.75rem;
    height: 0.6160254038rem;
}

.k-loader-spinner-3.k-loader-md .k-loader-canvas {
    margin: 0.25rem;
    width: 1.5rem;
    height: 1.2320508076rem;
}

.k-loader-spinner-3.k-loader-lg .k-loader-canvas {
    margin: 0.5rem;
    width: 3rem;
    height: 2.4641016152rem;
}

@keyframes spinner-4-segment-1 {
    0% {
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
    33.3% {
        top: 0;
        left: 0;
        transform: translateX(0) translateY(0);
    }
    66.6% {
        top: 0;
        left: 0;
        transform: translateX(0) translateY(0);
    }
    100% {
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@keyframes spinner-4-segment-2 {
    0% {
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
    33.3% {
        top: 0;
        left: 100%;
        transform: translateX(-100%) translateY(0);
    }
    66.6% {
        top: 0;
        left: 100%;
        transform: translateX(-100%) translateY(0);
    }
    100% {
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@keyframes spinner-4-segment-3 {
    0% {
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
    33.3% {
        top: 100%;
        left: 100%;
        transform: translateX(-100%) translateY(-100%);
    }
    66.6% {
        top: 100%;
        left: 100%;
        transform: translateX(-100%) translateY(-100%);
    }
    100% {
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@keyframes spinner-4-segment-4 {
    0% {
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
    33.3% {
        top: 100%;
        left: 0;
        transform: translateX(0) translateY(-100%);
    }
    66.6% {
        top: 100%;
        left: 0;
        transform: translateX(0) translateY(-100%);
    }
    100% {
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@keyframes spinner-4 {
    0% {
        transform: rotate(0);
    }
    33.3% {
        transform: rotate(0);
    }
    66.6% {
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(180deg);
    }
}

.k-loader-spinner-4 .k-loader-canvas {
    animation: spinner-4 1.833s ease infinite;
}

.k-loader-spinner-4 .k-loader-segment {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}

.k-loader-spinner-4 .k-loader-segment:nth-child(1) {
    animation: spinner-4-segment-1 1.833s ease infinite;
}

.k-loader-spinner-4 .k-loader-segment:nth-child(2) {
    animation: spinner-4-segment-2 1.833s ease infinite;
}

.k-loader-spinner-4 .k-loader-segment:nth-child(3) {
    animation: spinner-4-segment-3 1.833s ease infinite;
}

.k-loader-spinner-4 .k-loader-segment:nth-child(4) {
    animation: spinner-4-segment-4 1.833s ease infinite;
}

.k-loader-spinner-4.k-loader-sm .k-loader-canvas {
    width: 1rem;
    height: 1rem;
}

.k-loader-spinner-4.k-loader-md .k-loader-canvas {
    width: 2rem;
    height: 2rem;
}

.k-loader-spinner-4.k-loader-lg .k-loader-canvas {
    width: 4rem;
    height: 4rem;
}

.k-loader-container {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2001;
}

.k-loader-container .k-loader {
    padding: 0;
}

.k-loader-container,
.k-loader-container-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.k-loader-container-overlay {
    opacity: 0.5;
}

.k-loader-container-inner {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
}

.k-loader-container-panel {
    border-width: 1px;
    border-style: solid;
    border-radius: 0.375rem;
}

.k-loader-container-sm .k-loader-container-inner {
    padding: 1rem;
    gap: 0.25rem;
}

.k-loader-container-sm .k-loader-container-label {
    font-size: 0.875rem;
}

.k-loader-container-md .k-loader-container-inner {
    padding: 1.25rem;
    gap: 0.5rem;
}

.k-loader-container-md .k-loader-container-label {
    font-size: 1rem;
}

.k-loader-container-lg .k-loader-container-inner {
    padding: 1.5rem;
    gap: 0.75rem;
}

.k-loader-container-lg .k-loader-container-label {
    font-size: 1.25rem;
}

.k-loader-top .k-loader-container-inner {
    flex-direction: column;
    text-align: center;
}

.k-loader-end .k-loader-container-label {
    order: -1;
}

.k-loading-mask,
.k-loading-image,
.k-loading-color {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
}

.k-loading-mask *,
.k-loading-mask *::before,
.k-loading-mask *::after, .k-loading-mask::before, .k-loading-mask::after,
.k-loading-image *,
.k-loading-image *::before,
.k-loading-image *::after,
.k-loading-image::before,
.k-loading-image::after,
.k-loading-color *,
.k-loading-color *::before,
.k-loading-color *::after,
.k-loading-color::before,
.k-loading-color::after {
    box-sizing: border-box;
}

.k-loading-mask {
    z-index: 100;
}

.k-loading-mask.k-opaque .k-loading-color {
    opacity: 1;
}

.k-loading-text {
    text-indent: -4000px;
    text-align: center;
    position: absolute;
    color: currentColor;
}

.k-loading-image {
    z-index: 2;
    color: currentColor;
}

.k-loading-color {
    background-color: #ffffff;
    opacity: 0.3;
}

.k-i-loading::before,
.k-loading-image::before {
    border-color: currentColor;
    border-right-color: transparent !important;
}

.k-i-loading::after,
.k-loading-image::after {
    display: none !important;
}

.k-loading-image::before {
    border-width: 0.25rem;
}

.k-loader-primary {
    color: #0d6efd;
}

.k-loader-secondary {
    color: #212529;
}

.k-loader-tertiary {
    color: #6f42c1;
}

.k-loader-info {
    color: #0dcaf0;
}

.k-loader-success {
    color: #198754;
}

.k-loader-warning {
    color: #ffc107;
}

.k-loader-error {
    color: #dc3545;
}

.k-loader-dark {
    color: #212529;
}

.k-loader-light {
    color: #f8f9fa;
}

.k-loader-inverse {
    color: #212529;
}

.k-loader-container-panel {
    background-color: #ffffff;
    border-color: #dee2e6;
}

.k-loader-container-inner .k-text-secondary,
.k-loader-container-inner .\\!k-text-secondary {
    color: #212529 !important;
}

.k-skeleton, .k-placeholder-line {
    display: block;
}

.k-skeleton-text, .k-placeholder-line {
    border-radius: 0.375rem;
    transform: scale(1, 0.6);
}

.k-skeleton-text:empty::before, .k-placeholder-line:empty::before {
    content: "\\200b";
}

.k-skeleton-rect {
    border-radius: 0;
}

.k-skeleton-circle {
    border-radius: 9999px;
}

@keyframes k-skeleton-wave {
    0% {
        transform: translateX(-100%);
    }
    60% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(100%);
    }
}

.k-skeleton-wave .k-skeleton, .k-skeleton-wave .k-placeholder-line, .k-skeleton-wave.k-skeleton, .k-skeleton-wave.k-placeholder-line {
    position: relative;
    overflow: hidden;
}

.k-skeleton-wave .k-skeleton::after, .k-skeleton-wave .k-placeholder-line::after, .k-skeleton-wave.k-skeleton::after, .k-skeleton-wave.k-placeholder-line::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    animation: k-skeleton-wave 1.6s linear .5s infinite;
}

@keyframes k-skeleton-pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: .4;
    }
    100% {
        opacity: 1;
    }
}

.k-skeleton-pulse .k-skeleton, .k-skeleton-pulse .k-placeholder-line, .k-skeleton-pulse.k-skeleton, .k-skeleton-pulse.k-placeholder-line {
    animation: k-skeleton-pulse 1.5s ease-in-out .5s infinite;
}

.k-skeleton, .k-placeholder-line {
    background-color: rgba(33, 37, 41, 0.2);
}

.k-skeleton-wave .k-skeleton::after, .k-skeleton-wave .k-placeholder-line::after, .k-skeleton-wave.k-skeleton::after, .k-skeleton-wave.k-placeholder-line::after {
    background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.04), transparent);
}

.k-button {
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    color: inherit;
    background: none;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    vertical-align: middle;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
    outline: none;
    -webkit-appearance: none;
    position: relative;
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.k-button *,
.k-button *::before,
.k-button *::after {
    box-sizing: border-box;
}

.k-button:disabled, .k-button.k-disabled {
    outline: none;
    cursor: default;
    opacity: 0.65;
    filter: grayscale(0.1);
    pointer-events: none;
    box-shadow: none;
}

.k-button::-moz-focus-inner {
    padding: 0;
    border: 0;
    outline: 0;
}

.k-button:hover, .k-button:focus {
    text-decoration: none;
    outline: 0;
}

.k-icon-button {
    gap: 0;
}

.k-icon-button .k-icon {
    display: inline-flex;
}

.k-button-icon {
    color: inherit;
    align-self: center;
    position: relative;
}

.k-button-sm {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.4285714286;
}

.k-button-sm.k-icon-button {
    padding: 0.25rem;
}

.k-button-sm.k-icon-button .k-button-icon {
    min-width: 1.25rem;
    min-height: 1.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.k-button-sm.k-icon-button .k-button-icon.k-svg-icon > svg,
.k-button-sm.k-icon-button .k-button-icon.k-icon-md > svg {
    width: 16px;
    height: 16px;
}

.k-button-sm.k-icon-button .k-button-icon.k-icon-xs > svg {
    width: 12px;
    height: 12px;
}

.k-button-sm.k-icon-button .k-button-icon.k-icon-sm > svg {
    width: 14px;
    height: 14px;
}

.k-button-sm.k-icon-button .k-button-icon.k-icon-lg > svg {
    width: 20px;
    height: 20px;
}

.k-button-sm.k-icon-button .k-button-icon.k-icon-xl > svg {
    width: 24px;
    height: 24px;
}

.k-button-sm.k-icon-button .k-button-icon.k-icon-xxl > svg {
    width: 32px;
    height: 32px;
}

.k-button-sm.k-icon-button .k-button-icon.k-icon-xxxl > svg {
    width: 48px;
    height: 48px;
}

.k-button-md {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
}

.k-button-md.k-icon-button {
    padding: 0.375rem;
}

.k-button-md.k-icon-button .k-button-icon {
    min-width: 1.5rem;
    min-height: 1.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.k-button-md.k-icon-button .k-button-icon.k-svg-icon > svg,
.k-button-md.k-icon-button .k-button-icon.k-icon-md > svg {
    width: 16px;
    height: 16px;
}

.k-button-md.k-icon-button .k-button-icon.k-icon-xs > svg {
    width: 12px;
    height: 12px;
}

.k-button-md.k-icon-button .k-button-icon.k-icon-sm > svg {
    width: 14px;
    height: 14px;
}

.k-button-md.k-icon-button .k-button-icon.k-icon-lg > svg {
    width: 20px;
    height: 20px;
}

.k-button-md.k-icon-button .k-button-icon.k-icon-xl > svg {
    width: 24px;
    height: 24px;
}

.k-button-md.k-icon-button .k-button-icon.k-icon-xxl > svg {
    width: 32px;
    height: 32px;
}

.k-button-md.k-icon-button .k-button-icon.k-icon-xxxl > svg {
    width: 48px;
    height: 48px;
}

.k-button-lg {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    font-size: 1rem;
    line-height: 1.5;
}

.k-button-lg.k-icon-button {
    padding: 0.5rem;
}

.k-button-lg.k-icon-button .k-button-icon {
    min-width: 1.5rem;
    min-height: 1.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.k-button-lg.k-icon-button .k-button-icon.k-svg-icon > svg,
.k-button-lg.k-icon-button .k-button-icon.k-icon-md > svg {
    width: 16px;
    height: 16px;
}

.k-button-lg.k-icon-button .k-button-icon.k-icon-xs > svg {
    width: 12px;
    height: 12px;
}

.k-button-lg.k-icon-button .k-button-icon.k-icon-sm > svg {
    width: 14px;
    height: 14px;
}

.k-button-lg.k-icon-button .k-button-icon.k-icon-lg > svg {
    width: 20px;
    height: 20px;
}

.k-button-lg.k-icon-button .k-button-icon.k-icon-xl > svg {
    width: 24px;
    height: 24px;
}

.k-button-lg.k-icon-button .k-button-icon.k-icon-xxl > svg {
    width: 32px;
    height: 32px;
}

.k-button-lg.k-icon-button .k-button-icon.k-icon-xxxl > svg {
    width: 48px;
    height: 48px;
}

.k-button-square {
    aspect-ratio: 1;
}

.k-button-group {
    margin: 0;
    padding: 0;
    border-width: 0;
    box-sizing: border-box;
    list-style: none;
    outline: 0;
    display: inline-flex;
    flex-flow: row nowrap;
    vertical-align: middle;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-button-group > .k-button + .k-button {
    margin-inline-start: -1px;
}

.k-button-group > .k-button:hover,
.k-button-group > .k-button.k-hover,
.k-button-group > .k-button:focus,
.k-button-group > .k-button.k-focus,
.k-button-group > .k-button:active,
.k-button-group > .k-button.k-active,
.k-button-group > .k-button.k-selected {
    z-index: 2;
}

.k-button-group .k-button:not(:first-child):not(:last-child) {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
    border-start-start-radius: 0;
    border-end-start-radius: 0;
}

.k-button-group > .k-button:first-child:not(:only-child) {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
}

.k-button-group > .k-button:last-child:not(:only-child) {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
}

.k-button-group:disabled, .k-button-group[disabled], .k-button-group.k-disabled {
    opacity: 1;
    filter: none;
}

.k-button-group-stretched {
    width: 100%;
}

.k-button-group-stretched > * {
    flex: 1 0 0%;
    overflow: hidden;
}

.k-button-flat {
    border-color: transparent !important;
    color: inherit;
    background: none !important;
    box-shadow: none !important;
}

.k-button-flat::before {
    display: block !important;
}

.k-button-flat::after {
    box-shadow: inset 0 0 0 2px currentColor;
    display: block !important;
}

.k-button-flat:focus::after, .k-button-flat.k-focus::after {
    opacity: 0.12;
}

.k-button-outline {
    border-color: currentColor;
    color: inherit;
    background: none;
}

.k-button-link {
    border-color: transparent;
    color: inherit;
    text-decoration: none;
    background: none;
}

.k-button-link:hover, .k-button-link.k-hover {
    text-decoration: underline;
}

.k-button-clear {
    border-color: transparent !important;
    color: inherit;
    background: none !important;
    box-shadow: none !important;
}

.k-button-overlay, .k-button::before {
    border-radius: inherit;
    content: "";
    background: currentColor;
    opacity: 0;
    display: none;
    pointer-events: none;
    position: absolute;
    left: -1px;
    right: -1px;
    top: -1px;
    bottom: -1px;
    z-index: 0;
    transition: opacity .2s ease-in-out;
}

.k-button:hover::before, .k-button.k-hover::before {
    opacity: 0.08;
}

.k-button.k-no-focus:not(:hover)::before, .k-button.k-no-focus:not(.k-hover)::before {
    opacity: 0;
}

.k-button:active::before, .k-button.k-active::before {
    opacity: 0.16;
}

.k-button.k-selected::before {
    opacity: 0.2;
}

.k-button::after {
    border-radius: inherit;
    content: "";
    opacity: 0;
    display: none;
    pointer-events: none;
    position: absolute;
    left: -1px;
    right: -1px;
    top: -1px;
    bottom: -1px;
    z-index: 0;
    transition: opacity .2s ease-in-out;
}

.k-button-solid-base {
    border-color: #e4e7eb;
    color: #212529;
    background-color: #e4e7eb;
}

.k-button-solid-base:hover, .k-button-solid-base.k-hover {
    border-color: #c7cdd5;
    background-color: #ced3db;
}

.k-button-solid-base:focus, .k-button-solid-base.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-button-solid-base:active, .k-button-solid-base.k-active {
    border-color: #bfc6d0;
    background-color: #c7cdd5;
}

.k-button-solid-base.k-selected {
    border-color: #0252c9;
    color: white;
    background-color: #0257d5;
}

.k-button-solid-primary {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-button-solid-primary:hover, .k-button-solid-primary.k-hover {
    border-color: #0257d5;
    background-color: #025ce2;
}

.k-button-solid-primary:focus, .k-button-solid-primary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5);
}

.k-button-solid-primary:active, .k-button-solid-primary.k-active {
    border-color: #0252c9;
    background-color: #0257d5;
}

.k-button-solid-primary.k-selected {
    border-color: #0252c9;
    background-color: #0257d5;
}

.k-button-solid-secondary {
    border-color: #6c757d;
    color: white;
    background-color: #6c757d;
}

.k-button-solid-secondary:hover, .k-button-solid-secondary.k-hover {
    border-color: #545b62;
    background-color: #5a6268;
}

.k-button-solid-secondary:focus, .k-button-solid-secondary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5);
}

.k-button-solid-secondary:active, .k-button-solid-secondary.k-active {
    border-color: #4e555b;
    background-color: #545b62;
}

.k-button-solid-secondary.k-selected {
    border-color: #4e555b;
    background-color: #545b62;
}

.k-button-solid-tertiary {
    border-color: #6f42c1;
    color: white;
    background-color: #6f42c1;
}

.k-button-solid-tertiary:hover, .k-button-solid-tertiary.k-hover {
    border-color: #59339d;
    background-color: #5e37a6;
}

.k-button-solid-tertiary:focus, .k-button-solid-tertiary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5);
}

.k-button-solid-tertiary:active, .k-button-solid-tertiary.k-active {
    border-color: #533093;
    background-color: #59339d;
}

.k-button-solid-tertiary.k-selected {
    border-color: #533093;
    background-color: #59339d;
}

.k-button-solid-info {
    border-color: #0dcaf0;
    color: white;
    background-color: #0dcaf0;
}

.k-button-solid-info:hover, .k-button-solid-info.k-hover {
    border-color: #0aa1c0;
    background-color: #0babcc;
}

.k-button-solid-info:focus, .k-button-solid-info.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5);
}

.k-button-solid-info:active, .k-button-solid-info.k-active {
    border-color: #0a97b4;
    background-color: #0aa1c0;
}

.k-button-solid-info.k-selected {
    border-color: #0a97b4;
    background-color: #0aa1c0;
}

.k-button-solid-success {
    border-color: #198754;
    color: white;
    background-color: #198754;
}

.k-button-solid-success:hover, .k-button-solid-success.k-hover {
    border-color: #115c39;
    background-color: #136740;
}

.k-button-solid-success:focus, .k-button-solid-success.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5);
}

.k-button-solid-success:active, .k-button-solid-success.k-active {
    border-color: #0f5133;
    background-color: #115c39;
}

.k-button-solid-success.k-selected {
    border-color: #0f5133;
    background-color: #115c39;
}

.k-button-solid-warning {
    border-color: #ffc107;
    color: black;
    background-color: #ffc107;
}

.k-button-solid-warning:hover, .k-button-solid-warning.k-hover {
    border-color: #d39e00;
    background-color: #e0a800;
}

.k-button-solid-warning:focus, .k-button-solid-warning.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5);
}

.k-button-solid-warning:active, .k-button-solid-warning.k-active {
    border-color: #c69500;
    background-color: #d39e00;
}

.k-button-solid-warning.k-selected {
    border-color: #c69500;
    background-color: #d39e00;
}

.k-button-solid-error {
    border-color: #dc3545;
    color: white;
    background-color: #dc3545;
}

.k-button-solid-error:hover, .k-button-solid-error.k-hover {
    border-color: #bd2130;
    background-color: #c82333;
}

.k-button-solid-error:focus, .k-button-solid-error.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5);
}

.k-button-solid-error:active, .k-button-solid-error.k-active {
    border-color: #b21f2d;
    background-color: #bd2130;
}

.k-button-solid-error.k-selected {
    border-color: #b21f2d;
    background-color: #bd2130;
}

.k-button-solid-dark {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-solid-dark:hover, .k-button-solid-dark.k-hover {
    border-color: #0a0c0d;
    background-color: #101214;
}

.k-button-solid-dark:focus, .k-button-solid-dark.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);
}

.k-button-solid-dark:active, .k-button-solid-dark.k-active {
    border-color: #050506;
    background-color: #0a0c0d;
}

.k-button-solid-dark.k-selected {
    border-color: #050506;
    background-color: #0a0c0d;
}

.k-button-solid-light {
    border-color: #f8f9fa;
    color: black;
    background-color: #f8f9fa;
}

.k-button-solid-light:hover, .k-button-solid-light.k-hover {
    border-color: #dae0e5;
    background-color: #e2e6ea;
}

.k-button-solid-light:focus, .k-button-solid-light.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5);
}

.k-button-solid-light:active, .k-button-solid-light.k-active {
    border-color: #d3d9df;
    background-color: #dae0e5;
}

.k-button-solid-light.k-selected {
    border-color: #d3d9df;
    background-color: #dae0e5;
}

.k-button-solid-inverse {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-solid-inverse:hover, .k-button-solid-inverse.k-hover {
    border-color: #0a0c0d;
    background-color: #101214;
}

.k-button-solid-inverse:focus, .k-button-solid-inverse.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);
}

.k-button-solid-inverse:active, .k-button-solid-inverse.k-active {
    border-color: #050506;
    background-color: #0a0c0d;
}

.k-button-solid-inverse.k-selected {
    border-color: #050506;
    background-color: #0a0c0d;
}

.k-button-outline-primary {
    box-shadow: none;
    border-color: currentColor;
    color: #0d6efd;
    background-color: transparent;
}

.k-button-outline-primary:hover, .k-button-outline-primary.k-hover {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-button-outline-primary:focus, .k-button-outline-primary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5);
}

.k-button-outline-primary:active, .k-button-outline-primary.k-active {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-button-outline-primary.k-selected {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-button-outline-secondary {
    box-shadow: none;
    border-color: currentColor;
    color: #6c757d;
    background-color: transparent;
}

.k-button-outline-secondary:hover, .k-button-outline-secondary.k-hover {
    border-color: #6c757d;
    color: white;
    background-color: #6c757d;
}

.k-button-outline-secondary:focus, .k-button-outline-secondary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5);
}

.k-button-outline-secondary:active, .k-button-outline-secondary.k-active {
    border-color: #6c757d;
    color: white;
    background-color: #6c757d;
}

.k-button-outline-secondary.k-selected {
    border-color: #6c757d;
    color: white;
    background-color: #6c757d;
}

.k-button-outline-tertiary {
    box-shadow: none;
    border-color: currentColor;
    color: #6f42c1;
    background-color: transparent;
}

.k-button-outline-tertiary:hover, .k-button-outline-tertiary.k-hover {
    border-color: #6f42c1;
    color: white;
    background-color: #6f42c1;
}

.k-button-outline-tertiary:focus, .k-button-outline-tertiary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5);
}

.k-button-outline-tertiary:active, .k-button-outline-tertiary.k-active {
    border-color: #6f42c1;
    color: white;
    background-color: #6f42c1;
}

.k-button-outline-tertiary.k-selected {
    border-color: #6f42c1;
    color: white;
    background-color: #6f42c1;
}

.k-button-outline-info {
    box-shadow: none;
    border-color: currentColor;
    color: #0dcaf0;
    background-color: transparent;
}

.k-button-outline-info:hover, .k-button-outline-info.k-hover {
    border-color: #0dcaf0;
    color: white;
    background-color: #0dcaf0;
}

.k-button-outline-info:focus, .k-button-outline-info.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5);
}

.k-button-outline-info:active, .k-button-outline-info.k-active {
    border-color: #0dcaf0;
    color: white;
    background-color: #0dcaf0;
}

.k-button-outline-info.k-selected {
    border-color: #0dcaf0;
    color: white;
    background-color: #0dcaf0;
}

.k-button-outline-success {
    box-shadow: none;
    border-color: currentColor;
    color: #198754;
    background-color: transparent;
}

.k-button-outline-success:hover, .k-button-outline-success.k-hover {
    border-color: #198754;
    color: white;
    background-color: #198754;
}

.k-button-outline-success:focus, .k-button-outline-success.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5);
}

.k-button-outline-success:active, .k-button-outline-success.k-active {
    border-color: #198754;
    color: white;
    background-color: #198754;
}

.k-button-outline-success.k-selected {
    border-color: #198754;
    color: white;
    background-color: #198754;
}

.k-button-outline-warning {
    box-shadow: none;
    border-color: currentColor;
    color: #ffc107;
    background-color: transparent;
}

.k-button-outline-warning:hover, .k-button-outline-warning.k-hover {
    border-color: #ffc107;
    color: black;
    background-color: #ffc107;
}

.k-button-outline-warning:focus, .k-button-outline-warning.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5);
}

.k-button-outline-warning:active, .k-button-outline-warning.k-active {
    border-color: #ffc107;
    color: black;
    background-color: #ffc107;
}

.k-button-outline-warning.k-selected {
    border-color: #ffc107;
    color: black;
    background-color: #ffc107;
}

.k-button-outline-error {
    box-shadow: none;
    border-color: currentColor;
    color: #dc3545;
    background-color: transparent;
}

.k-button-outline-error:hover, .k-button-outline-error.k-hover {
    border-color: #dc3545;
    color: white;
    background-color: #dc3545;
}

.k-button-outline-error:focus, .k-button-outline-error.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5);
}

.k-button-outline-error:active, .k-button-outline-error.k-active {
    border-color: #dc3545;
    color: white;
    background-color: #dc3545;
}

.k-button-outline-error.k-selected {
    border-color: #dc3545;
    color: white;
    background-color: #dc3545;
}

.k-button-outline-dark {
    box-shadow: none;
    border-color: currentColor;
    color: #212529;
    background-color: transparent;
}

.k-button-outline-dark:hover, .k-button-outline-dark.k-hover {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-outline-dark:focus, .k-button-outline-dark.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);
}

.k-button-outline-dark:active, .k-button-outline-dark.k-active {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-outline-dark.k-selected {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-outline-light {
    box-shadow: none;
    border-color: currentColor;
    color: #f8f9fa;
    background-color: transparent;
}

.k-button-outline-light:hover, .k-button-outline-light.k-hover {
    border-color: #f8f9fa;
    color: black;
    background-color: #f8f9fa;
}

.k-button-outline-light:focus, .k-button-outline-light.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5);
}

.k-button-outline-light:active, .k-button-outline-light.k-active {
    border-color: #f8f9fa;
    color: black;
    background-color: #f8f9fa;
}

.k-button-outline-light.k-selected {
    border-color: #f8f9fa;
    color: black;
    background-color: #f8f9fa;
}

.k-button-outline-inverse {
    box-shadow: none;
    border-color: currentColor;
    color: #212529;
    background-color: transparent;
}

.k-button-outline-inverse:hover, .k-button-outline-inverse.k-hover {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-outline-inverse:focus, .k-button-outline-inverse.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);
}

.k-button-outline-inverse:active, .k-button-outline-inverse.k-active {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-outline-inverse.k-selected {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-outline-base {
    box-shadow: none;
    border-color: currentColor;
    color: #212529;
    background-color: transparent;
}

.k-button-outline-base:hover, .k-button-outline-base.k-hover {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-outline-base:focus, .k-button-outline-base.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);
}

.k-button-outline-base:active, .k-button-outline-base.k-active {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-outline-base.k-selected {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-button-flat-primary {
    color: #0d6efd;
}

.k-button-flat-secondary {
    color: #6c757d;
}

.k-button-flat-tertiary {
    color: #6f42c1;
}

.k-button-flat-info {
    color: #0dcaf0;
}

.k-button-flat-success {
    color: #198754;
}

.k-button-flat-warning {
    color: #ffc107;
}

.k-button-flat-error {
    color: #dc3545;
}

.k-button-flat-dark {
    color: #212529;
}

.k-button-flat-light {
    color: #f8f9fa;
}

.k-button-flat-inverse {
    color: #212529;
}

.k-button-flat-base {
    color: inherit;
}

.k-button-link-primary {
    color: #0d6efd;
}

.k-button-link-primary:hover, .k-button-link-primary.k-hover {
    color: #0b5cd5;
}

.k-button-link-primary:focus, .k-button-link-primary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5);
}

.k-button-link-primary:active, .k-button-link-primary.k-active {
    color: #0b5cd5;
}

.k-button-link-primary.k-selected {
    color: #0b5cd5;
}

.k-button-link-secondary {
    color: #6c757d;
}

.k-button-link-secondary:hover, .k-button-link-secondary.k-hover {
    color: #5b6269;
}

.k-button-link-secondary:focus, .k-button-link-secondary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5);
}

.k-button-link-secondary:active, .k-button-link-secondary.k-active {
    color: #5b6269;
}

.k-button-link-secondary.k-selected {
    color: #5b6269;
}

.k-button-link-tertiary {
    color: #6f42c1;
}

.k-button-link-tertiary:hover, .k-button-link-tertiary.k-hover {
    color: #5d37a2;
}

.k-button-link-tertiary:focus, .k-button-link-tertiary.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5);
}

.k-button-link-tertiary:active, .k-button-link-tertiary.k-active {
    color: #5d37a2;
}

.k-button-link-tertiary.k-selected {
    color: #5d37a2;
}

.k-button-link-info {
    color: #0dcaf0;
}

.k-button-link-info:hover, .k-button-link-info.k-hover {
    color: #0baaca;
}

.k-button-link-info:focus, .k-button-link-info.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5);
}

.k-button-link-info:active, .k-button-link-info.k-active {
    color: #0baaca;
}

.k-button-link-info.k-selected {
    color: #0baaca;
}

.k-button-link-success {
    color: #198754;
}

.k-button-link-success:hover, .k-button-link-success.k-hover {
    color: #157147;
}

.k-button-link-success:focus, .k-button-link-success.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5);
}

.k-button-link-success:active, .k-button-link-success.k-active {
    color: #157147;
}

.k-button-link-success.k-selected {
    color: #157147;
}

.k-button-link-warning {
    color: #ffc107;
}

.k-button-link-warning:hover, .k-button-link-warning.k-hover {
    color: #d6a206;
}

.k-button-link-warning:focus, .k-button-link-warning.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5);
}

.k-button-link-warning:active, .k-button-link-warning.k-active {
    color: #d6a206;
}

.k-button-link-warning.k-selected {
    color: #d6a206;
}

.k-button-link-error {
    color: #dc3545;
}

.k-button-link-error:hover, .k-button-link-error.k-hover {
    color: #b92d3a;
}

.k-button-link-error:focus, .k-button-link-error.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5);
}

.k-button-link-error:active, .k-button-link-error.k-active {
    color: #b92d3a;
}

.k-button-link-error.k-selected {
    color: #b92d3a;
}

.k-button-link-dark {
    color: #212529;
}

.k-button-link-dark:hover, .k-button-link-dark.k-hover {
    color: #1c1f22;
}

.k-button-link-dark:focus, .k-button-link-dark.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);
}

.k-button-link-dark:active, .k-button-link-dark.k-active {
    color: #1c1f22;
}

.k-button-link-dark.k-selected {
    color: #1c1f22;
}

.k-button-link-light {
    color: #f8f9fa;
}

.k-button-link-light:hover, .k-button-link-light.k-hover {
    color: #d0d1d2;
}

.k-button-link-light:focus, .k-button-link-light.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5);
}

.k-button-link-light:active, .k-button-link-light.k-active {
    color: #d0d1d2;
}

.k-button-link-light.k-selected {
    color: #d0d1d2;
}

.k-button-link-inverse {
    color: #212529;
}

.k-button-link-inverse:hover, .k-button-link-inverse.k-hover {
    color: #1c1f22;
}

.k-button-link-inverse:focus, .k-button-link-inverse.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);
}

.k-button-link-inverse:active, .k-button-link-inverse.k-active {
    color: #1c1f22;
}

.k-button-link-inverse.k-selected {
    color: #1c1f22;
}

.k-button-link-base {
    color: #212529;
}

.k-button-link-base:hover, .k-button-link-base.k-hover {
    color: #1c1f22;
}

.k-button-link-base:focus, .k-button-link-base.k-focus {
    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);
}

.k-button-link-base:active, .k-button-link-base.k-active {
    color: #1c1f22;
}

.k-button-link-base.k-selected {
    color: #1c1f22;
}

.k-button-clear-primary {
    color: #0d6efd;
}

.k-button-clear-primary:focus::after, .k-button-clear-primary.k-focus::after, .k-button-clear-primary:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-secondary {
    color: #6c757d;
}

.k-button-clear-secondary:focus::after, .k-button-clear-secondary.k-focus::after, .k-button-clear-secondary:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-tertiary {
    color: #6f42c1;
}

.k-button-clear-tertiary:focus::after, .k-button-clear-tertiary.k-focus::after, .k-button-clear-tertiary:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-info {
    color: #0dcaf0;
}

.k-button-clear-info:focus::after, .k-button-clear-info.k-focus::after, .k-button-clear-info:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-success {
    color: #198754;
}

.k-button-clear-success:focus::after, .k-button-clear-success.k-focus::after, .k-button-clear-success:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-warning {
    color: #ffc107;
}

.k-button-clear-warning:focus::after, .k-button-clear-warning.k-focus::after, .k-button-clear-warning:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-error {
    color: #dc3545;
}

.k-button-clear-error:focus::after, .k-button-clear-error.k-focus::after, .k-button-clear-error:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-dark {
    color: #212529;
}

.k-button-clear-dark:focus::after, .k-button-clear-dark.k-focus::after, .k-button-clear-dark:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-light {
    color: #f8f9fa;
}

.k-button-clear-light:focus::after, .k-button-clear-light.k-focus::after, .k-button-clear-light:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-inverse {
    color: #212529;
}

.k-button-clear-inverse:focus::after, .k-button-clear-inverse.k-focus::after, .k-button-clear-inverse:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-button-clear-base {
    color: #212529;
}

.k-button-clear-base:focus::after, .k-button-clear-base.k-focus::after, .k-button-clear-base:active::after {
    background-color: currentColor;
    opacity: 0.1;
    display: block;
}

.k-menu-bar, .k-menu {
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    position: relative;
    cursor: default;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-menu-bar *, .k-menu *,
.k-menu-bar *::before,
.k-menu *::before,
.k-menu-bar *::after,
.k-menu *::after {
    box-sizing: border-box;
}

.k-menu-item {
    border-width: 0;
    outline: 0;
    display: flex;
    flex-flow: column nowrap;
    flex: none;
    position: relative;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-menu-item-content {
    display: block;
    height: auto;
    overflow: visible;
}

.k-menu-item-content .k-actions, .k-menu-item-content .k-edit-buttons,
.k-menu-item-content .k-action-buttons,
.k-menu-item-content .k-columnmenu-actions, .k-menu-item-content .k-form-buttons {
    margin-top: 0;
}

.k-menu-link {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    outline: 0;
    color: inherit;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 0.5rem;
    align-items: center;
    position: relative;
    white-space: nowrap;
    cursor: pointer;
}

.k-menu-link-text {
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-menu-expand-arrow {
    margin-inline-end: -0.5rem;
    display: inline-flex;
    flex-flow: row wrap;
    align-items: center;
    flex: none;
    position: relative;
}

.k-menu-horizontal {
    flex-direction: row;
}

.k-menu-horizontal > .k-menu-item + .k-menu-item {
    margin-inline-start: 0;
}

.k-menu-horizontal > .k-separator {
    margin-block: 0;
    margin-inline: 0.25rem;
    width: 0;
    height: auto;
    border-width: 0 0 0 1px;
    border-style: solid;
}

.k-menu-vertical {
    flex-direction: column;
}

.k-menu-vertical > .k-menu-item + .k-menu-item {
    margin-top: 0;
}

.k-menu-vertical > .k-menu-item > .k-menu-link {
    padding-block: 0.25rem;
    padding-inline: 1rem;
    padding-inline-end: calc(2rem + 16px);
}

.k-menu-vertical > .k-menu-item > .k-menu-link > .k-menu-expand-arrow {
    margin-inline-start: 1rem;
    margin-inline-end: calc(-1.5rem + -16px);
}

.k-menu-vertical > .k-separator {
    margin-block: 0.25rem;
    margin-inline: 0;
    height: 0;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: #dee2e6;
    display: block;
}

.k-menu-popup {
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    overflow: auto;
    max-height: 80vh;
}

.k-menu-popup *,
.k-menu-popup *::before,
.k-menu-popup *::after {
    box-sizing: border-box;
}

.k-menu-group {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: column nowrap;
    position: absolute;
}

.k-menu-group .k-menu-item + .k-menu-item {
    margin-top: 0px;
}

.k-menu-group .k-separator {
    margin-block: 0.25rem;
    margin-inline: 0;
    height: 0;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: #dee2e6;
    display: block;
}

.k-menu-popup .k-menu-group {
    position: relative;
}

.k-menu-group-sm {
    font-size: 1rem;
    line-height: 1.5;
}

.k-menu-group-sm .k-menu-item {
    font-size: 1rem;
    line-height: 1.5;
}

.k-menu-group-sm .k-menu-link {
    padding-block: 0.125rem;
    padding-inline: 1rem;
    padding-inline-end: calc(2rem + 16px);
}

.k-menu-group-sm .k-menu-expand-arrow {
    margin-inline-start: 1rem;
    margin-inline-end: calc(-1.5rem + -16px);
}

.k-menu-group-md {
    font-size: 1rem;
    line-height: 1.5;
}

.k-menu-group-md .k-menu-item {
    font-size: 1rem;
    line-height: 1.5;
}

.k-menu-group-md .k-menu-link {
    padding-block: 0.25rem;
    padding-inline: 1rem;
    padding-inline-end: calc(2rem + 16px);
}

.k-menu-group-md .k-menu-expand-arrow {
    margin-inline-start: 1rem;
    margin-inline-end: calc(-1.5rem + -16px);
}

.k-menu-group-lg {
    font-size: 1.25rem;
    line-height: 1.5;
}

.k-menu-group-lg .k-menu-item {
    font-size: 1.25rem;
    line-height: 1.5;
}

.k-menu-group-lg .k-menu-link {
    padding-block: 0.375rem;
    padding-inline: 1rem;
    padding-inline-end: calc(2rem + 16px);
}

.k-menu-group-lg .k-menu-expand-arrow {
    margin-inline-start: 1rem;
    margin-inline-end: calc(-1.5rem + -16px);
}

.k-popups-wrapper {
    position: relative;
    border: 0;
    margin: 0;
    padding: 0;
}

.k-context-menu {
    margin: 0;
    border-width: 1px;
    border-style: solid;
}

.k-animation-container .k-context-menu.k-menu-horizontal {
    display: flex !important;
    flex-wrap: nowrap;
}

.k-context-menu-popup {
    z-index: 12000;
}

.k-context-menu-popup .k-context-menu {
    border-width: 0;
}

.k-popup .k-context-menu,
.k-context-menu-popup .k-context-menu {
    border-width: 0;
}

.k-menu-scroll-wrapper {
    margin: 0;
    padding: 0;
    border: 0;
    position: relative;
}

.k-menu-scroll-wrapper .k-menu {
    overflow: hidden;
    flex-wrap: nowrap;
}

.k-menu-scroll-wrapper .k-menu-scroll-button {
    border-radius: 0;
    padding: 0;
    border-width: 0;
    border-color: inherit;
    color: inherit;
    background: inherit;
    position: absolute;
}

.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-left {
    top: 0;
    inset-inline-start: 0;
    height: 100%;
    width: 16px;
    border-right-width: 1px;
}

.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-right {
    top: 0;
    inset-inline-end: 0;
    height: 100%;
    width: 16px;
    border-left-width: 1px;
}

.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-up {
    top: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 16px;
    border-bottom-width: 1px;
}

.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-down {
    bottom: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 16px;
    border-top-width: 1px;
}

.k-menu.k-menu-horizontal:not(.k-context-menu) {
    padding-block: 0.5rem;
}

.k-menu.k-menu-vertical:not(.k-context-menu) {
    padding-block: 0.5rem;
    padding-inline: 0;
}

.k-menu-popup .k-menu-group, .k-menu-popup
.k-menu-vertical {
    padding: 0;
}

.k-context-menu-popup > .k-popup:not(.k-menu-popup) {
    padding: 0;
}

.k-context-menu-popup .k-context-menu {
    border-radius: 0.375rem;
}

.k-context-menu-popup .k-header {
    font-size: inherit;
    font-weight: inherit;
}

.k-menu:not(.k-context-menu) {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-menu:not(.k-context-menu) > .k-item {
    color: rgba(33, 37, 41, 0.5);
}

.k-menu:not(.k-context-menu) > .k-item:hover, .k-menu:not(.k-context-menu) > .k-item.k-hover {
    color: rgba(33, 37, 41, 0.7);
}

.k-menu:not(.k-context-menu) > .k-item:active, .k-menu:not(.k-context-menu) > .k-item.k-active {
    color: rgba(33, 37, 41, 0.9);
}

.k-menu:not(.k-context-menu) > .k-item:focus, .k-menu:not(.k-context-menu) > .k-item.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-menu-group,
.k-menu.k-context-menu {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-menu-group .k-item > .k-link:hover, .k-menu-group .k-item > .k-link.k-hover,
.k-menu.k-context-menu .k-item > .k-link:hover,
.k-menu.k-context-menu .k-item > .k-link.k-hover {
    color: #212529;
    background-color: #e9ecef;
}

.k-menu-group .k-item > .k-link:active, .k-menu-group .k-item > .k-link.k-active, .k-menu-group .k-item > .k-link.k-selected,
.k-menu.k-context-menu .k-item > .k-link:active,
.k-menu.k-context-menu .k-item > .k-link.k-active,
.k-menu.k-context-menu .k-item > .k-link.k-selected {
    color: white;
    background-color: #0d6efd;
}

.k-menu-group .k-item:focus > .k-link,
.k-menu-group .k-item.k-focus > .k-link,
.k-menu.k-context-menu .k-item:focus > .k-link,
.k-menu.k-context-menu .k-item.k-focus > .k-link {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-menu-scroll-wrapper .k-menu-scroll-button {
    border-color: #dee2e6;
    color: rgba(33, 37, 41, 0.5);
    background-color: #f8f9fa;
}

.k-menu-scroll-wrapper .k-menu-scroll-button:hover {
    color: rgba(33, 37, 41, 0.7);
}

.k-menu-scroll-wrapper .k-menu-scroll-button:hover::before {
    opacity: 0;
}

.k-toolbar {
    margin: 0;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    list-style: none;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-toolbar::before {
    content: "";
    height: calc(1.5em + 0.75rem + 2px);
}

.k-toolbar.k-toolbar-resizable {
    flex-wrap: nowrap;
}

.k-toolbar > * {
    flex-shrink: 0;
    display: inline-flex;
    align-content: center;
    vertical-align: middle;
}

.k-toolbar > * > label {
    align-self: center;
}

.k-toolbar .k-input,
.k-toolbar .k-picker {
    width: 10em;
}

.k-toolbar .k-color-picker, .k-toolbar .k-colorpicker {
    width: min-content;
}

.k-toolbar .k-toolbar-overflow-button {
    margin-inline-start: auto;
}

.k-toolbar .k-separator,
.k-toolbar .k-toolbar-separator {
    width: 0;
    height: 1.5em;
    border-width: 0 0 0 1px;
    border-style: solid;
    align-self: center;
}

.k-toolbar .k-toolbar-spacer {
    height: 1.5em;
    flex: 1 0 0%;
}

.k-toolbar .k-toolbar-item:focus,
.k-toolbar .k-toolbar-item.k-focus {
    text-decoration: none;
    outline: 0;
}

.k-toolbar-group {
    display: flex;
    flex-direction: inherit;
    flex-wrap: nowrap;
    gap: inherit;
}

.k-toolbar-renderer {
    display: inline-block;
    border-color: inherit;
}

.k-toolbar-sm {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    gap: 0.375rem;
}

.k-toolbar-sm::before {
    margin-inline-start: -0.375rem;
}

.k-toolbar-sm > * > label {
    margin-inline-end: 0.375rem;
}

.k-toolbar-md {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    gap: 0.5rem;
}

.k-toolbar-md::before {
    margin-inline-start: -0.5rem;
}

.k-toolbar-md > * > label {
    margin-inline-end: 0.5rem;
}

.k-toolbar-lg {
    padding-block: 0.625rem;
    padding-inline: 0.625rem;
    gap: 0.625rem;
}

.k-toolbar-lg::before {
    margin-inline-start: -0.625rem;
}

.k-toolbar-lg > * > label {
    margin-inline-end: 0.625rem;
}

.k-toolbar-sm::before {
    height: calc(1.4285714286em + 0.5rem + 2px);
}

.k-toolbar-md::before {
    height: calc(1.5em + 0.75rem + 2px);
}

.k-toolbar-lg::before {
    height: calc(1.5em + 1rem + 2px);
}

.k-floating-toolbar,
.editorToolbarWindow.k-window-content {
    padding-block: 0.5rem !important;
    padding-inline: 0.5rem !important;
    border-width: 1px;
    border-style: solid;
    display: flex;
    flex-flow: row nowrap;
    gap: 0.5rem;
    align-items: center;
}

.k-floating-toolbar .k-toolbar,
.editorToolbarWindow.k-window-content .k-toolbar {
    padding: 0;
    border-width: 0;
    flex-shrink: 1;
    color: inherit;
    background: none;
}

.k-editortoolbar-dragHandle {
    cursor: move;
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-shrink: 0;
}

.k-overflow-container {
    font-size: 1rem;
    line-height: 1.5;
}

.k-overflow-container > .k-item {
    border-color: inherit;
}

.k-overflow-container .k-separator {
    margin: 0.25rem 0;
}

.k-overflow-container .k-overflow-tool-group {
    display: block;
}

.k-overflow-container .k-overflow-button {
    padding-block: 0.25rem;
    padding-inline: 1rem;
    width: 100%;
    height: auto;
    border-width: 0;
    border-radius: 0;
    aspect-ratio: auto;
    color: inherit;
    background-color: transparent;
    background-image: none;
    font: inherit;
    cursor: pointer;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    gap: 0.5rem;
    justify-content: flex-start;
    position: relative;
}

.k-overflow-container .k-button-group {
    box-shadow: none;
    display: flex;
    flex-flow: column nowrap;
}

.k-overflow-container .k-button-group .k-button {
    margin: 0;
}

.k-overflow-container .k-split-button {
    display: flex;
    flex-direction: column;
}

.k-overflow-container .k-overflow-hidden {
    display: none;
}

.k-toolbar.k-toolbar-flat {
    border-width: 1px 0;
    border-top-color: transparent !important;
    border-bottom-color: inherit;
    color: inherit;
    background: none !important;
    box-shadow: none;
}

.k-toolbar {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-toolbar .k-separator,
.k-toolbar .k-toolbar-separator {
    border-color: inherit;
}

.k-toolbar .k-toolbar-item:focus,
.k-toolbar .k-toolbar-item.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-floating-toolbar,
.editorToolbarWindow.k-window-content {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-overflow-container .k-button:hover, .k-overflow-container .k-button.k-hover {
    color: #212529;
    background: #e9ecef;
}

.k-overflow-container .k-button:focus, .k-overflow-container .k-button.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-overflow-container .k-button:active, .k-overflow-container .k-button.k-active {
    color: #212529;
    background: #e9ecef;
}

.k-overflow-container .k-button.k-selected {
    color: white;
    background: #0d6efd;
}

.k-overflow-container .k-button:disabled, .k-overflow-container .k-button.k-disabled {
    color: inherit;
}

.k-actions, .k-edit-buttons,
.k-action-buttons,
.k-columnmenu-actions, .k-form-buttons {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    box-sizing: border-box;
    border-width: 0px 0 0 0;
    border-style: solid;
    border-color: inherit;
    flex-shrink: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 0.5rem;
    overflow: hidden;
    clear: both;
}

.k-actions *, .k-edit-buttons *, .k-action-buttons *, .k-columnmenu-actions *, .k-form-buttons *,
.k-actions *::before,
.k-edit-buttons *::before,
.k-action-buttons *::before,
.k-columnmenu-actions *::before,
.k-form-buttons *::before,
.k-actions *::after,
.k-edit-buttons *::after,
.k-action-buttons *::after,
.k-columnmenu-actions *::after,
.k-form-buttons *::after {
    box-sizing: border-box;
}

.k-popup .k-actions, .k-popup .k-edit-buttons,
.k-popup .k-action-buttons,
.k-popup .k-columnmenu-actions, .k-popup .k-form-buttons {
    margin-top: 1rem;
}

.k-actions-start {
    justify-content: flex-start;
}

.k-actions-center {
    justify-content: center;
}

.k-actions-end {
    justify-content: flex-end;
}

.k-actions-stretched > * {
    flex: 1 0 0%;
}

.k-actions-horizontal {
    width: 100%;
    flex-flow: row nowrap;
}

.k-actions-vertical {
    flex-flow: column nowrap;
}

.k-form,
.k-form-inline {
    font-size: 1rem;
    line-height: 1.5;
}

.k-fieldset {
    margin: 30px;
    border-width: 1px 0 0;
    border-style: solid;
    padding: 25px 0 0;
}

.k-fieldset > legend {
    margin-left: 0;
    padding: 0 1rem 0 0;
    text-transform: uppercase;
}

kendo-label > .k-label {
    margin: 0;
}

.k-label-optional {
    margin-left: 6px;
    font-size: 0.75rem;
    font-style: italic;
    align-self: center;
}

.k-label-empty::before {
    content: "";
    display: inline-block;
}

.k-input-label {
    margin-right: 10px;
    z-index: 1;
}

.k-input-label:dir(rtl),
.k-rtl .k-input-label, .k-input-label.k-rtl,
[dir="rtl"] .k-input-label, .k-input-label[dir="rtl"] {
    margin-right: 0;
    margin-left: 10px;
}

.k-form {
    border: 0;
}

.k-form .k-form-field > .k-label,
.k-form .k-form-field > kendo-label,
.k-form .k-form-label {
    margin-bottom: 0.5rem;
    display: flex;
    flex-flow: row nowrap;
}

.k-form .k-label + .k-radio {
    margin-left: 0;
}

.k-form .k-form-fieldset {
    margin: 2rem 0 0;
    padding: 0px;
    border: 0;
}

.k-form .k-form-fieldset > *:not(.k-hidden):first-child,
.k-form .k-form-fieldset > *.k-hidden + :not(.k-hidden) {
    margin-top: 0;
}

.k-form .k-form-legend {
    margin: 0 0 1rem;
    padding: 0px;
    border-width: 0 0 2px;
    border-style: solid;
    width: 100%;
    font-size: 0.875rem;
    text-transform: uppercase;
}

.k-form .k-form-group {
    padding: 0;
}

.k-form > *:not(.k-hidden):first-child,
.k-form > *.k-hidden + :not(.k-hidden) {
    margin-top: 0;
}

.k-form .k-form-field,
.k-form .k-form-field-wrap {
    display: block;
}

.k-form .k-form-field-disabled .k-label,
.k-form .k-form-field-disabled .k-form-label {
    outline: none;
    cursor: default;
    opacity: 0.65;
    filter: grayscale(0.1);
    pointer-events: none;
    box-shadow: none;
}

.k-form .k-alert-error {
    font-size: 0.875rem;
    margin-top: 1rem;
}

.k-form .k-field-info {
    display: inline-block;
    font-size: 0.75rem;
    line-height: 1;
    margin-block: 0;
    margin-inline: 1rem;
}

.k-form .k-multiselect,
.k-form .k-floating-label-container,
.k-form .k-daterangepicker .k-dateinput,
.k-form .k-signature {
    display: inline-flex;
    width: 100%;
}

.k-form-buttons {
    padding: 0;
    overflow: visible;
}

.k-form-hint,
.k-form-error {
    margin-top: 4px;
    display: flex;
    font-size: 0.75rem;
    font-style: normal;
}

.k-text-start,
.k-buttons-start {
    justify-content: flex-start;
}

.k-text-end,
.k-buttons-end {
    justify-content: flex-end;
}

.k-form-separator {
    margin: 1rem 0 0;
    border-width: 1px 0 0;
    border-style: solid;
    display: block;
    flex: 0 0 auto;
}

.k-form-horizontal .k-form-field {
    display: flex;
}

.k-form-horizontal .k-form-field > .k-label,
.k-form-horizontal .k-form-field > kendo-label,
.k-form-horizontal .k-form-field > .k-form-label {
    margin-right: 10px;
    padding-top: 5px;
    width: 25%;
    text-align: end;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
}

.k-form-horizontal .k-form-field .k-label-optional {
    margin: 0;
    align-self: inherit;
}

.k-form-horizontal .k-form-field-wrap {
    max-width: calc(75% - 10px);
    flex: 1 1 auto;
}

.k-form [dir="rtl"] .k-label-optional,
.k-rtl .k-form .k-label-optional {
    margin-left: 0;
    margin-right: 6px;
}

.k-form-horizontal [dir="rtl"].k-form-field > .k-label,
.k-form-horizontal [dir="rtl"].k-form-field > kendo-label,
.k-form-horizontal [dir="rtl"].k-form-field > .k-form-label,
.k-form-horizontal [dir="rtl"] .k-form-field > .k-label,
.k-form-horizontal [dir="rtl"] .k-form-field > kendo-label,
.k-form-horizontal [dir="rtl"] .k-form-field > .k-form-label,
.k-rtl .k-form-horizontal.k-form-field > .k-label,
.k-rtl .k-form-horizontal.k-form-field > kendo-label,
.k-rtl .k-form-horizontal.k-form-field > .k-form-label,
.k-rtl .k-form-horizontal .k-form-field > .k-label,
.k-rtl .k-form-horizontal .k-form-field > kendo-label,
.k-rtl .k-form-horizontal .k-form-field > .k-form-label {
    margin-right: 0;
    margin-left: 10px;
}

.k-form-sm .k-form-field,
.k-form-sm .k-form-buttons {
    margin-top: 1rem;
}

.k-form-md .k-form-field,
.k-form-md .k-form-buttons {
    margin-top: 1rem;
}

.k-form-lg .k-form-field,
.k-form-lg .k-form-buttons {
    margin-top: 1rem;
}

.k-form-inline {
    padding: 2rem;
}

.k-form-inline fieldset {
    border-width: 1px 0 0;
    border-style: solid;
    margin: 4rem 0;
    padding: 0;
}

.k-form-inline fieldset:first-child:first-of-type {
    margin-top: 0;
}

.k-form-inline fieldset:last-child:last-of-type {
    margin-bottom: 0;
}

.k-form-inline legend {
    font-size: 0.875rem;
    text-align: start;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 1.5rem;
    text-transform: uppercase;
    padding: 0 1rem 0 0;
    width: auto;
}

.k-form-inline .k-form-field {
    display: flex;
    align-items: flex-start;
    text-align: start;
    margin-bottom: 1.5rem;
}

.k-form-inline .k-form-field > span:not(.k-widget) {
    width: 25%;
    text-align: end;
    line-height: 1.5;
    padding: calc(0.5rem + 1px) 0;
    padding-right: 1.5rem;
    align-self: center;
}

.k-form-inline .k-form-field > input {
    align-self: center;
}

.k-form-inline .k-form-field > input:not(.k-checkbox):not(.k-radio) {
    flex: 1 1 auto;
}

.k-form-inline .k-form-field .k-alert-error {
    font-size: 0.875rem;
    margin-top: 1rem;
}

.k-form-inline .k-form-field .k-field-info {
    display: block;
    font-size: 0.75rem;
    line-height: 1;
    margin: 0;
}

.k-form-inline .k-form-field:last-child {
    margin-bottom: 0;
}

.k-edit-form-container {
    width: 400px;
    min-width: 400px;
    border-color: inherit;
    position: relative;
}

.k-popup-edit-form > .k-actions, .k-popup-edit-form > .k-edit-buttons,
.k-popup-edit-form > .k-action-buttons,
.k-popup-edit-form > .k-columnmenu-actions, .k-popup-edit-form > .k-form-buttons,
.k-edit-form-container .k-actions,
.k-edit-form-container .k-edit-buttons,
.k-edit-form-container .k-action-buttons,
.k-edit-form-container .k-columnmenu-actions,
.k-edit-form-container .k-form-buttons {
    margin: 1rem -1rem -1rem;
}

.k-edit-label {
    margin: 0 0 1rem 0;
    padding: calc(0.375rem + 1px) 0;
    width: 30%;
    line-height: 1.5;
    text-align: end;
    float: left;
    clear: both;
}

.k-edit-field {
    margin: 0 0 1rem 0;
    width: 65%;
    float: right;
    clear: right;
    position: relative;
}

.k-edit-field.k-no-editor {
    padding: calc(0.375rem + 1px) 0;
}

.k-edit-field > .k-widget {
    width: 100%;
    box-sizing: border-box;
}

.k-edit-field input[type="radio"]:not(.k-radio),
.k-edit-field input[type="checkbox"]:not(.k-checkbox) {
    margin-right: .4ex;
}

.k-edit-field .k-radio-label,
.k-edit-field .k-checkbox-label {
    margin-right: 1rem;
}

.k-edit-field > .k-reset > li + li {
    margin-top: 0.5rem;
}

.k-edit-field .k-reset .k-widget {
    margin: 0 .4ex 0 1ex;
}

.k-form legend,
.k-form-inline legend {
    font-size: 1.5rem;
    font-weight: normal;
    line-height: 1.5;
    text-transform: none;
}

.k-form .k-field-info,
.k-form-inline .k-field-info {
    opacity: .7;
}

.k-form legend {
    margin-bottom: 0.5rem;
}

.k-form .k-field-info {
    margin-block: 0;
    margin-inline: 0.5rem;
}

.k-form-inline legend {
    margin-bottom: 0;
}

.k-form-inline .k-form-field > span:not(.k-widget) {
    padding: calc(0.5rem - 1px) 0;
    padding-right: 1rem;
}

.k-edit-label {
    padding: calc(0.5rem - 1px) 0;
}

.k-form,
.k-form-inline {
    color: #212529;
}

.k-form .k-form-legend,
.k-form-inline .k-form-legend {
    border-color: #dee2e6;
}

.k-form .k-field-info,
.k-form-inline .k-field-info {
    color: #6c757d;
}

.k-form .k-alert-error,
.k-form-inline .k-alert-error {
    color: #dc3545;
}

.k-form-error,
.k-text-error,
.k-form-field-error .k-label {
    color: #dc3545;
}

.k-form-separator {
    border-color: #dee2e6;
}

.k-tooltip {
    border-radius: 0.375rem;
    margin: 0;
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    background-repeat: repeat-x;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 0.875rem;
    line-height: 1.5;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    position: absolute;
    z-index: 12000;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-tooltip *,
.k-tooltip *::before,
.k-tooltip *::after {
    box-sizing: border-box;
}

.k-tooltip-icon {
    margin-inline-end: 0.5rem;
    flex-shrink: 0;
}

.k-tooltip-title {
    margin-bottom: .25em;
    font-size: 1.09375rem;
    line-height: 1;
}

.k-tooltip-content {
    align-self: stretch;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-tooltip-button {
    margin-inline-start: 0.5rem;
    flex-shrink: 0;
}

.k-tooltip-button .k-icon {
    color: inherit;
    vertical-align: top;
}

.k-callout {
    width: 0.8rem;
    height: 0.8rem;
    border-width: 0.4rem;
    border-style: solid;
    border-color: transparent;
    position: absolute;
    pointer-events: none;
}

.k-callout-n {
    margin-left: -0.4rem;
    border-bottom-color: currentColor;
    top: -0.8rem;
    left: 50%;
    pointer-events: none;
}

.k-callout-e {
    margin-top: -0.4rem;
    border-left-color: currentColor;
    top: 50%;
    right: -0.8rem;
    pointer-events: none;
}

.k-callout-s {
    margin-left: -0.4rem;
    border-top-color: currentColor;
    bottom: -0.8rem;
    left: 50%;
    pointer-events: none;
}

.k-callout-w {
    margin-top: -0.4rem;
    border-right-color: currentColor;
    top: 50%;
    left: -0.8rem;
    pointer-events: none;
}

.k-tooltip {
    border-color: #000000;
    color: white;
    background-color: #000000;
    box-shadow: var(--kendo-elevation-2, 0px 2px 7px rgba(0, 0, 0, 0.075));
}

.k-tooltip .k-callout {
    color: #000000;
}

.k-tooltip-inverse {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-tooltip-inverse .k-callout {
    color: #212529;
}

.k-tooltip-light {
    border-color: #f8f9fa;
    color: black;
    background-color: #f8f9fa;
}

.k-tooltip-light .k-callout {
    color: #f8f9fa;
}

.k-tooltip-dark {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-tooltip-dark .k-callout {
    color: #212529;
}

.k-tooltip-error {
    border-color: #dc3545;
    color: white;
    background-color: #dc3545;
}

.k-tooltip-error .k-callout {
    color: #dc3545;
}

.k-tooltip-warning {
    border-color: #ffc107;
    color: black;
    background-color: #ffc107;
}

.k-tooltip-warning .k-callout {
    color: #ffc107;
}

.k-tooltip-success {
    border-color: #198754;
    color: white;
    background-color: #198754;
}

.k-tooltip-success .k-callout {
    color: #198754;
}

.k-tooltip-info {
    border-color: #0dcaf0;
    color: white;
    background-color: #0dcaf0;
}

.k-tooltip-info .k-callout {
    color: #0dcaf0;
}

.k-tooltip-tertiary {
    border-color: #6f42c1;
    color: white;
    background-color: #6f42c1;
}

.k-tooltip-tertiary .k-callout {
    color: #6f42c1;
}

.k-tooltip-secondary {
    border-color: #6c757d;
    color: white;
    background-color: #6c757d;
}

.k-tooltip-secondary .k-callout {
    color: #6c757d;
}

.k-tooltip-primary {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-tooltip-primary .k-callout {
    color: #0d6efd;
}

.k-validator-tooltip {
    margin-top: 0.4rem;
    width: auto;
    white-space: normal;
    display: flex;
    align-items: center;
    z-index: 9999;
}

.k-grid .k-validator-tooltip {
    max-width: 300px;
}

.k-input,
.k-picker {
    margin: 0;
    padding: 0;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    font-weight: normal;
    text-align: start;
    box-shadow: none;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: stretch;
    vertical-align: middle;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-appearance: none;
}

.k-input *,
.k-input *::before,
.k-input *::after,
.k-picker *,
.k-picker *::before,
.k-picker *::after {
    box-sizing: border-box;
}

.k-input > .k-input,
.k-input > .k-picker,
.k-picker > .k-input,
.k-picker > .k-picker {
    border-width: 0 !important;
    color: inherit;
    background: none;
    font: inherit;
    outline: 0;
    box-shadow: none;
}

.k-input > *,
.k-picker > * {
    margin: 0;
}

.k-input:-ms-input-placeholder, .k-picker:-ms-input-placeholder {
    color: #6c757d;
    opacity: 1;
    -ms-user-select: none;
        user-select: none;
}

.k-input::placeholder,
.k-picker::placeholder {
    color: #6c757d;
    opacity: 1;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

input.k-input,
textarea.k-textarea {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
}

input.k-input:disabled, input.k-input[disabled],
textarea.k-textarea:disabled,
textarea.k-textarea[disabled] {
    outline: none;
    cursor: default;
    opacity: 0.65;
    filter: grayscale(0.1);
    pointer-events: none;
    box-shadow: none;
}

[disabled] input.k-input:disabled,
.k-disabled input.k-input:disabled, [disabled] input.k-input[disabled],
.k-disabled input.k-input[disabled], [disabled]
textarea.k-textarea:disabled,
.k-disabled
textarea.k-textarea:disabled, [disabled]
textarea.k-textarea[disabled],
.k-disabled
textarea.k-textarea[disabled] {
    opacity: 1;
    filter: grayscale(0);
}

textarea.k-textarea {
    overflow: auto;
}

.k-picker {
    cursor: pointer;
}

select.k-picker {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
    appearance: auto;
}

select.k-picker:disabled, select.k-picker[disabled] {
    outline: none;
    cursor: default;
    opacity: 0.65;
    filter: grayscale(0.1);
    pointer-events: none;
    box-shadow: none;
}

[disabled] select.k-picker:disabled,
.k-disabled select.k-picker:disabled, [disabled] select.k-picker[disabled],
.k-disabled select.k-picker[disabled] {
    opacity: 1;
    filter: grayscale(0);
}

.k-input-inner {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
    width: 100%;
    border: 0;
    outline: 0;
    color: inherit;
    background: none;
    font: inherit;
    flex: 1;
    position: relative;
    z-index: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-appearance: none;
}

.k-input-inner:-ms-input-placeholder {
    color: #6c757d;
    opacity: 1;
    -ms-user-select: none;
        user-select: none;
}

.k-input-inner::placeholder {
    color: #6c757d;
    opacity: 1;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-input-inner:invalid {
    box-shadow: none;
}

span.k-input-inner {
    white-space: nowrap;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}

textarea.k-input-inner {
    margin: 0;
}

.k-input-value-icon {
    flex: none;
}

.k-input-value-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-input-value-text::before {
    content: "\\200b";
    width: 0px;
    overflow: hidden;
    flex: none;
    display: inline-block;
    vertical-align: top;
}

.k-input-values {
    min-width: 0px;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    cursor: text;
}

.k-input-values .k-chip-list {
    display: contents;
}

.k-icon-picker .k-input-inner {
    padding: 0.375rem;
    justify-content: center;
}

.k-input-prefix,
.k-input-suffix {
    border-color: inherit;
    display: flex;
    align-items: center;
    flex: none;
}

.k-input-prefix > *,
.k-input-suffix > * {
    flex-shrink: 0;
    border: none;
}

.k-input-prefix-vertical,
.k-input-suffix-vertical {
    flex-flow: column wrap;
}

.k-input-prefix-horizontal,
.k-input-suffix-horizontal {
    flex-flow: row wrap;
}

.k-input-separator {
    margin: 0;
    border-style: solid;
    border-color: inherit;
    border-width: 0 0 0 1px;
    height: 16px;
    align-self: center;
}

.k-input-separator-horizontal {
    height: auto;
    margin-inline: 0.375rem;
    align-self: stretch;
    border-width: 1px 0 0;
}

.k-input-separator-vertical {
    height: auto;
    margin-block: 0.375rem;
    align-self: stretch;
    border-width: 0 0 0 1px;
}

.k-input-icon,
.k-input-validation-icon,
.k-input-loading-icon {
    flex: none;
    align-self: center;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    box-sizing: content-box;
}

.k-input-loading-icon {
    width: 1em;
    height: 1em;
    font-size: 16px;
}

.k-input-icon.k-svg-icon > svg,
.k-input-icon.k-icon-md > svg,
.k-input-validation-icon.k-svg-icon > svg,
.k-input-validation-icon.k-icon-md > svg,
.k-input-loading-icon.k-svg-icon > svg,
.k-input-loading-icon.k-icon-md > svg {
    width: 16px;
    height: 16px;
}

.k-input-icon.k-icon-xs > svg,
.k-input-validation-icon.k-icon-xs > svg,
.k-input-loading-icon.k-icon-xs > svg {
    width: 12px;
    height: 12px;
}

.k-input-icon.k-icon-sm > svg,
.k-input-validation-icon.k-icon-sm > svg,
.k-input-loading-icon.k-icon-sm > svg {
    width: 14px;
    height: 14px;
}

.k-input-icon.k-icon-lg > svg,
.k-input-validation-icon.k-icon-lg > svg,
.k-input-loading-icon.k-icon-lg > svg {
    width: 20px;
    height: 20px;
}

.k-input-icon.k-icon-xl > svg,
.k-input-validation-icon.k-icon-xl > svg,
.k-input-loading-icon.k-icon-xl > svg {
    width: 24px;
    height: 24px;
}

.k-input-icon.k-icon-xxl > svg,
.k-input-validation-icon.k-icon-xxl > svg,
.k-input-loading-icon.k-icon-xxl > svg {
    width: 32px;
    height: 32px;
}

.k-input-icon.k-icon-xxxl > svg,
.k-input-validation-icon.k-icon-xxxl > svg,
.k-input-loading-icon.k-icon-xxxl > svg {
    width: 48px;
    height: 48px;
}

.k-clear-value {
    outline: 0;
    flex: none;
    align-self: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.5;
}

.k-clear-value:hover,
.k-clear-value.k-hover {
    opacity: 1;
}

.k-clear-value:focus-visible {
    outline: 1px dotted;
    outline-offset: -1px;
}

.k-input-button {
    width: auto;
    border-width: 0;
    border-inline-start-width: 1px;
    flex: none;
    aspect-ratio: auto;
    box-shadow: none;
}

.k-input-button > .k-button-icon {
    min-width: auto !important;
}

.k-input-button:focus {
    box-shadow: none;
}

.k-picker .k-input-button {
    color: inherit;
    background: none;
    border-color: transparent;
}

.k-input-spinner {
    width: auto;
    flex: none;
    display: flex;
    flex-flow: column nowrap;
}

.k-input-spinner .k-spinner-increase,
.k-input-spinner .k-spinner-decrease {
    border-width: 0;
    border-inline-start-width: 1px;
    flex: 1 1 50%;
    box-shadow: none;
    position: relative;
    aspect-ratio: auto;
}

.k-input-spinner .k-spinner-increase .k-button-icon,
.k-input-spinner .k-spinner-decrease .k-button-icon {
    margin-block: -1em;
    margin-inline: 0;
    min-width: auto !important;
    min-height: auto !important;
}

.k-input-spinner .k-spinner-increase .k-icon {
    bottom: auto;
}

.k-input-spinner .k-spinner-decrease .k-icon {
    top: auto;
}

.k-searchbar {
    flex: 1 1 auto;
    display: flex;
    flex-flow: row nowrap;
}

.k-picker-wrap,
.k-dropdown-wrap,
.k-dateinput-wrap,
.k-multiselect-wrap,
.k-numeric-wrap {
    width: 100%;
    border-width: 0;
    border-color: inherit;
    box-sizing: border-box;
    flex: 1 1 auto;
    display: flex;
    flex-flow: row nowrap;
    overflow: hidden;
    position: relative;
}

.k-input-flat,
.k-picker-flat {
    border-bottom-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-width: 1px 0;
    border-top-color: transparent !important;
    background-image: none !important;
}

.k-input-outline {
    background: none !important;
}

.k-input-sm,
.k-picker-sm {
    font-size: 0.875rem;
    line-height: 1.4285714286;
}

.k-input-sm .k-input-values,
.k-picker-sm .k-input-values {
    padding: 0.125rem;
    gap: 0.125rem;
}

.k-input-sm .k-input-values > .k-searchbar,
.k-input-sm .k-input-values > .k-input-inner,
.k-picker-sm .k-input-values > .k-searchbar,
.k-picker-sm .k-input-values > .k-input-inner {
    margin: -0.125rem;
}

.k-input-sm .k-input-inner,
.k-picker-sm .k-input-inner {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
}

.k-input-sm .k-input-button,
.k-input-sm .k-spinner-increase,
.k-input-sm .k-spinner-decrease,
.k-picker-sm .k-input-button,
.k-picker-sm .k-spinner-increase,
.k-picker-sm .k-spinner-decrease {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-input-sm .k-input-icon,
.k-input-sm .k-input-validation-icon,
.k-input-sm .k-input-loading-icon,
.k-input-sm .k-clear-value,
.k-input-sm .k-input-prefix > .k-icon,
.k-input-sm .k-input-prefix > .k-input-prefix-text,
.k-input-sm .k-input-suffix > .k-icon,
.k-input-sm .k-input-suffix > .k-input-suffix-text,
.k-picker-sm .k-input-icon,
.k-picker-sm .k-input-validation-icon,
.k-picker-sm .k-input-loading-icon,
.k-picker-sm .k-clear-value,
.k-picker-sm .k-input-prefix > .k-icon,
.k-picker-sm .k-input-prefix > .k-input-prefix-text,
.k-picker-sm .k-input-suffix > .k-icon,
.k-picker-sm .k-input-suffix > .k-input-suffix-text {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    box-sizing: content-box;
}

.k-input-sm .k-input-separator-horizontal,
.k-picker-sm .k-input-separator-horizontal {
    margin-inline: 0.25rem;
}

.k-input-sm .k-input-separator-vertical,
.k-picker-sm .k-input-separator-vertical {
    margin-block: 0.25rem;
}

.k-input-sm.k-icon-picker .k-input-inner,
.k-picker-sm.k-icon-picker .k-input-inner {
    width: 1.4285714286em;
    height: 1.4285714286em;
    padding: 0.25rem;
    box-sizing: content-box;
}

.k-dropdown-operator.k-picker-sm .k-input-button {
    padding: 0.25rem;
}

select.k-picker-sm {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
}

.k-input-md,
.k-picker-md {
    font-size: 1rem;
    line-height: 1.5;
}

.k-input-md .k-input-values,
.k-picker-md .k-input-values {
    padding: 0.1875rem;
    gap: 0.1875rem;
}

.k-input-md .k-input-values > .k-searchbar,
.k-input-md .k-input-values > .k-input-inner,
.k-picker-md .k-input-values > .k-searchbar,
.k-picker-md .k-input-values > .k-input-inner {
    margin: -0.1875rem;
}

.k-input-md .k-input-inner,
.k-picker-md .k-input-inner {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
}

.k-input-md .k-input-button,
.k-input-md .k-spinner-increase,
.k-input-md .k-spinner-decrease,
.k-picker-md .k-input-button,
.k-picker-md .k-spinner-increase,
.k-picker-md .k-spinner-decrease {
    padding-block: 0.375rem;
    padding-inline: 0.375rem;
}

.k-input-md .k-input-icon,
.k-input-md .k-input-validation-icon,
.k-input-md .k-input-loading-icon,
.k-input-md .k-clear-value,
.k-input-md .k-input-prefix > .k-icon,
.k-input-md .k-input-prefix > .k-input-prefix-text,
.k-input-md .k-input-suffix > .k-icon,
.k-input-md .k-input-suffix > .k-input-suffix-text,
.k-picker-md .k-input-icon,
.k-picker-md .k-input-validation-icon,
.k-picker-md .k-input-loading-icon,
.k-picker-md .k-clear-value,
.k-picker-md .k-input-prefix > .k-icon,
.k-picker-md .k-input-prefix > .k-input-prefix-text,
.k-picker-md .k-input-suffix > .k-icon,
.k-picker-md .k-input-suffix > .k-input-suffix-text {
    padding-block: 0.375rem;
    padding-inline: 0.375rem;
    box-sizing: content-box;
}

.k-input-md .k-input-separator-horizontal,
.k-picker-md .k-input-separator-horizontal {
    margin-inline: 0.375rem;
}

.k-input-md .k-input-separator-vertical,
.k-picker-md .k-input-separator-vertical {
    margin-block: 0.375rem;
}

.k-input-md.k-icon-picker .k-input-inner,
.k-picker-md.k-icon-picker .k-input-inner {
    width: 1.5em;
    height: 1.5em;
    padding: 0.375rem;
    box-sizing: content-box;
}

.k-dropdown-operator.k-picker-md .k-input-button {
    padding: 0.375rem;
}

select.k-picker-md {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
}

.k-input-lg,
.k-picker-lg {
    font-size: 1rem;
    line-height: 1.5;
}

.k-input-lg .k-input-values,
.k-picker-lg .k-input-values {
    padding: 0.25rem;
    gap: 0.25rem;
}

.k-input-lg .k-input-values > .k-searchbar,
.k-input-lg .k-input-values > .k-input-inner,
.k-picker-lg .k-input-values > .k-searchbar,
.k-picker-lg .k-input-values > .k-input-inner {
    margin: -0.25rem;
}

.k-input-lg .k-input-inner,
.k-picker-lg .k-input-inner {
    padding-block: 0.5rem;
    padding-inline: 1rem;
}

.k-input-lg .k-input-button,
.k-input-lg .k-spinner-increase,
.k-input-lg .k-spinner-decrease,
.k-picker-lg .k-input-button,
.k-picker-lg .k-spinner-increase,
.k-picker-lg .k-spinner-decrease {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-input-lg .k-input-icon,
.k-input-lg .k-input-validation-icon,
.k-input-lg .k-input-loading-icon,
.k-input-lg .k-clear-value,
.k-input-lg .k-input-prefix > .k-icon,
.k-input-lg .k-input-prefix > .k-input-prefix-text,
.k-input-lg .k-input-suffix > .k-icon,
.k-input-lg .k-input-suffix > .k-input-suffix-text,
.k-picker-lg .k-input-icon,
.k-picker-lg .k-input-validation-icon,
.k-picker-lg .k-input-loading-icon,
.k-picker-lg .k-clear-value,
.k-picker-lg .k-input-prefix > .k-icon,
.k-picker-lg .k-input-prefix > .k-input-prefix-text,
.k-picker-lg .k-input-suffix > .k-icon,
.k-picker-lg .k-input-suffix > .k-input-suffix-text {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    box-sizing: content-box;
}

.k-input-lg .k-input-separator-horizontal,
.k-picker-lg .k-input-separator-horizontal {
    margin-inline: 0.5rem;
}

.k-input-lg .k-input-separator-vertical,
.k-picker-lg .k-input-separator-vertical {
    margin-block: 0.5rem;
}

.k-input-lg.k-icon-picker .k-input-inner,
.k-picker-lg.k-icon-picker .k-input-inner {
    width: 1.5em;
    height: 1.5em;
    padding: 0.5rem;
    box-sizing: content-box;
}

.k-dropdown-operator.k-picker-lg .k-input-button {
    padding: 0.5rem;
}

select.k-picker-lg {
    padding-block: 0.5rem;
    padding-inline: 1rem;
}

.k-input > kendo-popup,
.k-picker > kendo-popup {
    position: fixed;
}

@keyframes autoFillStart {
    from {
    }
    to {
    }
}

@keyframes autoFillEnd {
    from {
    }
    to {
    }
}

.k-autofill:-webkit-autofill {
    animation-name: autoFillStart;
}

.k-autofill:not(:-webkit-autofill) {
    animation-name: autoFillEnd;
}

.k-input:-webkit-autofill {
    animation-name: autoFillStart;
}

.k-input:not(:-webkit-autofill) {
    animation-name: autoFillEnd;
}

.k-textbox {
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.k-input-solid {
    border-color: #ced4da;
    color: #212529;
    background-color: #ffffff;
}

.k-input-solid:focus, .k-input-solid.k-focus {
    border-color: #86b7fe;
    color: #212529;
    background-color: #ffffff;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-input-solid:focus-within {
    border-color: #86b7fe;
    color: #212529;
    background-color: #ffffff;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-input-solid.k-invalid, .k-input-solid.ng-invalid.ng-touched, .k-input-solid.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-input-solid.k-invalid .k-input-validation-icon, .k-input-solid.ng-invalid.ng-touched .k-input-validation-icon, .k-input-solid.ng-invalid.ng-dirty .k-input-validation-icon {
    color: #dc3545;
}

.k-input-solid.k-invalid:focus, .k-input-solid.k-invalid.k-focus, .k-input-solid.ng-invalid.ng-touched:focus, .k-input-solid.ng-invalid.ng-touched.k-focus, .k-input-solid.ng-invalid.ng-dirty:focus, .k-input-solid.ng-invalid.ng-dirty.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-input-solid.k-invalid:focus-within, .k-input-solid.ng-invalid.ng-touched:focus-within, .k-input-solid.ng-invalid.ng-dirty:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-input-solid .k-input-prefix {
    color: #6c757d;
}

.k-input-solid .k-input-suffix {
    color: #6c757d;
}

.k-input-solid .k-input-separator {
    border-color: #dee2e6;
}

.k-picker-solid {
    border-color: #e4e7eb;
    color: #212529;
    background-color: #e4e7eb;
}

.k-picker-solid:hover, .k-picker-solid.k-hover {
    border-color: #c7cdd5;
    background-color: #ced3db;
}

.k-picker-solid:focus, .k-picker-solid.k-focus {
    border-color: #bfc6d0;
    background-color: #c7cdd5;
    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-picker-solid:focus-within {
    border-color: #bfc6d0;
    background-color: #c7cdd5;
    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-picker-solid.k-invalid, .k-picker-solid.ng-invalid.ng-touched, .k-picker-solid.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-picker-solid.k-invalid .k-input-validation-icon, .k-picker-solid.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-solid.ng-invalid.ng-dirty .k-input-validation-icon {
    color: #dc3545;
}

.k-picker-solid.k-invalid:focus, .k-picker-solid.k-invalid.k-focus, .k-picker-solid.ng-invalid.ng-touched:focus, .k-picker-solid.ng-invalid.ng-touched.k-focus, .k-picker-solid.ng-invalid.ng-dirty:focus, .k-picker-solid.ng-invalid.ng-dirty.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-picker-solid.k-invalid:focus-within, .k-picker-solid.ng-invalid.ng-touched:focus-within, .k-picker-solid.ng-invalid.ng-dirty:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-input-outline {
    border-color: rgba(33, 37, 41, 0.5);
    color: #212529;
}

.k-input-outline > .k-input-button {
    border-color: inherit;
}

.k-input-outline > .k-input-spinner {
    border-color: inherit;
}

.k-input-outline > .k-input-spinner > .k-spinner-increase,
.k-input-outline > .k-input-spinner > .k-spinner-decrease {
    border-color: inherit;
}

.k-input-outline:focus, .k-input-outline.k-focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-input-outline:focus-within {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-input-outline.k-invalid, .k-input-outline.ng-invalid.ng-touched, .k-input-outline.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-input-outline.k-invalid .k-input-validation-icon, .k-input-outline.ng-invalid.ng-touched .k-input-validation-icon, .k-input-outline.ng-invalid.ng-dirty .k-input-validation-icon {
    color: #dc3545;
}

.k-input-outline.k-invalid:focus, .k-input-outline.k-invalid.k-focus, .k-input-outline.ng-invalid.ng-touched:focus, .k-input-outline.ng-invalid.ng-touched.k-focus, .k-input-outline.ng-invalid.ng-dirty:focus, .k-input-outline.ng-invalid.ng-dirty.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-input-outline.k-invalid:focus-within, .k-input-outline.ng-invalid.ng-touched:focus-within, .k-input-outline.ng-invalid.ng-dirty:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-input-outline .k-input-prefix {
    color: #6c757d;
}

.k-input-outline .k-input-suffix {
    color: #6c757d;
}

.k-input-outline .k-input-separator {
    border-color: #dee2e6;
}

.k-picker-outline {
    border-color: rgba(33, 37, 41, 0.5);
    color: #212529;
}

.k-picker-outline:hover, .k-picker-outline.k-hover {
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-picker-outline:focus, .k-picker-outline.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-picker-outline:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-picker-outline.k-invalid, .k-picker-outline.ng-invalid.ng-touched, .k-picker-outline.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-picker-outline.k-invalid .k-input-validation-icon, .k-picker-outline.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-outline.ng-invalid.ng-dirty .k-input-validation-icon {
    color: #dc3545;
}

.k-picker-outline.k-invalid:focus, .k-picker-outline.k-invalid.k-focus, .k-picker-outline.ng-invalid.ng-touched:focus, .k-picker-outline.ng-invalid.ng-touched.k-focus, .k-picker-outline.ng-invalid.ng-dirty:focus, .k-picker-outline.ng-invalid.ng-dirty.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-picker-outline.k-invalid:focus-within, .k-picker-outline.ng-invalid.ng-touched:focus-within, .k-picker-outline.ng-invalid.ng-dirty:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-input-flat {
    border-color: #ced4da;
    color: #212529;
}

.k-input-flat:focus, .k-input-flat.k-focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-input-flat:focus-within {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-input-flat.k-invalid, .k-input-flat.ng-invalid.ng-touched, .k-input-flat.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-input-flat.k-invalid .k-input-validation-icon, .k-input-flat.ng-invalid.ng-touched .k-input-validation-icon, .k-input-flat.ng-invalid.ng-dirty .k-input-validation-icon {
    color: #dc3545;
}

.k-input-flat.k-invalid:focus, .k-input-flat.k-invalid.k-focus, .k-input-flat.ng-invalid.ng-touched:focus, .k-input-flat.ng-invalid.ng-touched.k-focus, .k-input-flat.ng-invalid.ng-dirty:focus, .k-input-flat.ng-invalid.ng-dirty.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-input-flat.k-invalid:focus-within, .k-input-flat.ng-invalid.ng-touched:focus-within, .k-input-flat.ng-invalid.ng-dirty:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-input-flat .k-input-prefix {
    color: #6c757d;
}

.k-input-flat .k-input-suffix {
    color: #6c757d;
}

.k-input-flat .k-input-separator {
    border-color: #dee2e6;
}

.k-picker-flat {
    border-color: #e4e7eb;
    color: #212529;
}

.k-picker-flat:hover, .k-picker-flat.k-hover {
    background-color: rgba(33, 37, 41, 0.08);
}

.k-picker-flat:focus, .k-picker-flat.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-picker-flat:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-picker-flat.k-invalid, .k-picker-flat.ng-invalid.ng-touched, .k-picker-flat.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-picker-flat.k-invalid .k-input-validation-icon, .k-picker-flat.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-flat.ng-invalid.ng-dirty .k-input-validation-icon {
    color: #dc3545;
}

.k-picker-flat.k-invalid:focus, .k-picker-flat.k-invalid.k-focus, .k-picker-flat.ng-invalid.ng-touched:focus, .k-picker-flat.ng-invalid.ng-touched.k-focus, .k-picker-flat.ng-invalid.ng-dirty:focus, .k-picker-flat.ng-invalid.ng-dirty.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-picker-flat.k-invalid:focus-within, .k-picker-flat.ng-invalid.ng-touched:focus-within, .k-picker-flat.ng-invalid.ng-dirty:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.k-floating-label-container {
    padding-top: 1.5rem;
    box-sizing: border-box;
    display: inline-flex;
    vertical-align: middle;
    position: relative;
    flex-direction: column;
    justify-content: stretch;
}

.k-floating-label-container *,
.k-floating-label-container *::before,
.k-floating-label-container *::after {
    box-sizing: border-box;
}

.k-floating-label-container > .k-label {
    max-width: 90%;
    font-size: 1rem;
    line-height: 1.5;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: absolute;
    top: var(--kendo-floating-label-offset-y, calc(1.875rem + 1px));
    left: var(--kendo-floating-label-offset-x, calc(0.75rem + 1px));
    overflow: hidden;
    cursor: text;
    transform-origin: left center;
    transition: transform 0.2s ease-out, color 0.2s ease-out, top 0.2s ease-out, left 0.2s ease-out;
}

.k-floating-label-container > .k-widget {
    flex: 1 1 auto;
    width: auto;
}

.k-floating-label-container.k-empty > .k-label {
    top: var(--kendo-floating-label-offset-y, calc(1.875rem + 1px));
    left: var(--kendo-floating-label-offset-x, calc(0.75rem + 1px));
    transform: scale(1);
    pointer-events: none;
}

.k-floating-label-container > .k-label,
.k-floating-label-container.k-focus > .k-label {
    top: var(--kendo-floating-label-focus-offset-y, 0);
    left: var(--kendo-floating-label-focus-offset-x, 0);
    transform: scale(1);
}

.k-floating-label-container:focus-within > .k-label {
    top: var(--kendo-floating-label-focus-offset-y, 0);
    left: var(--kendo-floating-label-focus-offset-x, 0);
    transform: scale(1);
}

.k-floating-label-container.k-empty:not(.k-focus):not(:focus-within) :-ms-input-placeholder {
    color: transparent;
}

.k-floating-label-container.k-empty:not(.k-focus):not(:focus-within) ::placeholder {
    color: transparent;
}

[dir="rtl"] .k-floating-label-container > .k-label,
.k-rtl .k-floating-label-container > .k-label, .k-floating-label-container[dir="rtl"] > .k-label {
    transform-origin: right center;
    transition: transform 0.2s ease-out, color 0.2s ease-out, top 0.2s ease-out, right 0.2s ease-out;
}

[dir="rtl"] .k-floating-label-container.k-empty > .k-label,
.k-rtl .k-floating-label-container.k-empty > .k-label, .k-floating-label-container[dir="rtl"].k-empty > .k-label {
    left: auto;
    right: var(--kendo-floating-label-offset-x, calc(0.75rem + 1px));
}

[dir="rtl"] .k-floating-label-container > .k-label,
[dir="rtl"] .k-floating-label-container.k-focus > .k-label,
.k-rtl .k-floating-label-container > .k-label,
.k-rtl .k-floating-label-container.k-focus > .k-label, .k-floating-label-container[dir="rtl"] > .k-label,
.k-floating-label-container[dir="rtl"].k-focus > .k-label {
    left: auto;
    right: var(--kendo-floating-label-focus-offset-x, 0);
}

[dir="rtl"] .k-floating-label-container:focus-within > .k-label,
.k-rtl .k-floating-label-container:focus-within > .k-label, .k-floating-label-container[dir="rtl"]:focus-within > .k-label {
    left: auto;
    right: var(--kendo-floating-label-focus-offset-x, 0);
}

.k-floating-label-container.k-invalid > .k-label,
.k-floating-label-container.ng-invalid.ng-touched > .k-label,
.k-floating-label-container.ng-invalid.ng-dirty > .k-label {
    color: #dc3545;
}

.k-split-button .k-split-button-arrow {
    padding-block: 0.375rem;
    padding-inline: 0.375rem;
    width: auto;
    aspect-ratio: auto;
    flex: none;
}

.k-split-button .k-split-button-arrow.k-button-sm {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-split-button .k-split-button-arrow.k-button-md {
    padding-block: 0.375rem;
    padding-inline: 0.375rem;
}

.k-split-button .k-split-button-arrow.k-button-lg {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-split-button .k-split-button-arrow .k-button-icon {
    min-width: 0;
}

.k-split-button:focus,
.k-split-button.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-menu-button,
.k-dropdown-button {
    aspect-ratio: auto;
    outline: 0;
    display: inline-flex;
    flex-flow: row nowrap;
    vertical-align: middle;
}

.k-menu-button > .k-button-arrow,
.k-dropdown-button > .k-button-arrow {
    margin-inline-start: -0.375rem;
    margin-inline-end: -0.75rem;
    padding-left: 0.375rem;
    padding-right: 0.375rem;
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.k-menu-button.k-icon-button > .k-button-arrow,
.k-dropdown-button.k-icon-button > .k-button-arrow {
    margin-inline-start: 0;
    margin-inline-end: -0.375rem;
}

.k-textarea:has(.k-input-inner[style*="width"]) {
    width: max-content;
}

.k-listbox {
    width: 10em;
    height: 200px;
    border-width: 0;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    vertical-align: top;
    background-color: transparent;
    display: inline-flex;
    gap: 0.5rem;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-listbox .k-listbox-actions {
    display: flex;
    gap: 1rem;
}

.k-listbox.k-listbox-actions-left, .k-listbox.k-listbox-actions-right {
    flex-direction: row;
}

.k-listbox.k-listbox-actions-left .k-listbox-actions, .k-listbox.k-listbox-actions-right .k-listbox-actions {
    flex-direction: column;
}

.k-listbox.k-listbox-actions-right {
    flex-direction: row-reverse;
}

.k-listbox.k-listbox-actions-top, .k-listbox.k-listbox-actions-bottom {
    flex-direction: column;
}

.k-listbox.k-listbox-actions-top .k-listbox-actions, .k-listbox.k-listbox-actions-bottom .k-listbox-actions {
    flex-direction: row;
}

.k-listbox.k-listbox-actions-bottom {
    flex-direction: column-reverse;
}

.k-listbox .k-list-scroller {
    width: 100%;
    min-height: 0;
    height: inherit;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    display: flex;
    flex-flow: column nowrap;
}

.k-listbox .k-list-scroller .k-list-scroller {
    border-width: 0;
}

.k-listbox .k-list-scroller .k-list {
    height: inherit;
    background: transparent;
}

.k-listbox .k-drop-hint {
    border-top-width: 1px;
    border-top-style: solid;
}

.k-listbox .k-ghost {
    opacity: .5;
}

.k-item {
    cursor: default;
}

.k-listbox .k-list-scroller {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-listbox .k-drop-hint {
    border-top-color: #0d6efd;
}

.k-progressbar {
    border-radius: 0.375rem;
    --kendo-progressbar-value: 0;
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 0.75rem;
    line-height: 1;
    display: inline-grid;
    vertical-align: middle;
    position: relative;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-progressbar *,
.k-progressbar *::before,
.k-progressbar *::after {
    box-sizing: border-box;
}

.k-progressbar > .k-progressbar-value {
    border-width: 0;
    border-style: solid;
    display: flex;
    overflow: hidden;
    grid-column: 1 / -1;
    grid-row: 1 / -1;
}

.k-progressbar > .k-progressbar-chunks {
    border-width: inherit;
    border-style: inherit;
    white-space: nowrap;
    display: flex;
    align-items: stretch;
    flex: 1;
    gap: 1px;
    grid-column: 1 / -1;
    grid-row: 1 / -1;
}

.k-progressbar .k-progressbar-chunk {
    display: block;
    border-width: 0;
    flex: 1;
}

.k-progress-status-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    grid-column: 1 / -1;
    grid-row: 1 / -1;
}

.k-progress-status-wrap.k-progress-start {
    justify-content: flex-start;
}

.k-progress-status-wrap.k-progress-center {
    justify-content: center;
}

.k-progress-status-wrap.k-progress-end {
    justify-content: flex-end;
}

.k-progress-status {
    padding-block: 0;
    padding-inline: 0.5rem;
    min-width: 10px;
    text-align: center;
    display: inline-block;
    white-space: nowrap;
}

.k-progressbar-horizontal {
    width: 100%;
    height: var(--kendo-progressbar-height, 1rem);
    grid-template-columns: 1fr;
    grid-template-rows: 100%;
}

.k-progressbar-horizontal .k-progress-status-wrap {
    flex-direction: row;
}

.k-progressbar-horizontal > .k-progressbar-value {
    width: calc(var( --kendo-progressbar-value, 0 )*1%);
    flex-direction: row;
}

.k-progressbar-horizontal > .k-progressbar-value > .k-progress-status-wrap {
    width: calc(100%*(100/var( --kendo-progressbar-value, 1 )));
}

.k-progressbar-horizontal > .k-progressbar-chunks {
    flex-direction: row;
}

.k-progressbar-horizontal.k-progressbar-reverse > .k-progressbar-value {
    flex-direction: row-reverse;
    justify-self: flex-end;
}

.k-progressbar-horizontal.k-progressbar-reverse > .k-progressbar-chunks {
    flex-direction: row-reverse;
}

.k-progressbar-vertical {
    width: var(--kendo-progressbar-height, 1rem);
    height: 27em;
    grid-template-columns: 100%;
    grid-template-rows: 1fr;
}

.k-progressbar-vertical .k-progress-status-wrap {
    flex-direction: column-reverse;
}

.k-progressbar-vertical .k-progress-status {
    -ms-writing-mode: tb-lr;
        writing-mode: vertical-lr;
}

.k-progressbar-vertical > .k-progressbar-value {
    height: calc(var( --kendo-progressbar-value, 0 )*1%);
    flex-direction: column-reverse;
    align-self: flex-end;
    align-items: flex-end;
}

.k-progressbar-vertical > .k-progressbar-value > .k-progress-status-wrap {
    height: calc(100%*(100/var( --kendo-progressbar-value, 1 )));
}

.k-progressbar-vertical > .k-progressbar-chunks {
    flex-direction: column-reverse;
}

.k-progressbar-vertical.k-progressbar-reverse {
    flex-direction: column;
}

.k-progressbar-vertical.k-progressbar-reverse > .k-progressbar-value {
    flex-direction: column;
    align-self: flex-start;
}

.k-progressbar-vertical.k-progressbar-reverse > .k-progressbar-chunks {
    flex-direction: column;
}

.k-progressbar-indeterminate .k-progress-status-wrap,
.k-progressbar-indeterminate .k-progressbar-value,
.k-progressbar-indeterminate .k-progressbar-chunk {
    display: none;
}

.telerik-blazor.k-progressbar-horizontal > .k-progressbar-value,
.telerik-blazor.k-progressbar-horizontal > .k-progressbar-value > .k-progress-status-wrap {
    transition: width .1s ease-in-out;
}

.k-rtl .k-progressbar,
.k-progressbar[dir="rtl"] {
    direction: rtl;
}

.k-circular-progressbar {
    display: inline-block;
    text-align: start;
    position: relative;
}

.k-circular-progressbar-surface {
    height: 100%;
}

.k-circular-progressbar-surface > div {
    width: 100%;
    height: 100%;
}

.k-circular-progressbar-surface svg {
    width: 100%;
    height: 100%;
}

.k-circular-progressbar-scale {
    fill: none;
}

.k-circular-progressbar-arc {
    transform-box: fill-box;
    transform-origin: center center;
    transform: rotate(-90deg);
    stroke-linecap: round;
    fill: none;
}

.k-circular-progressbar-label {
    position: absolute;
    text-align: center;
    padding: 0;
    margin: 0;
}

@keyframes kendo-progressbar-indeterminate-animation {
    from {
        background-position: 0 0;
    }
    to {
        background-position: 1rem 0;
    }
}

.k-progressbar {
    color: black;
    background-color: #e9ecef;
}

.k-progressbar .k-selected {
    color: white;
    background-color: #0d6efd;
}

.k-chunk-progressbar {
    background-color: transparent;
}

.k-progressbar-chunk {
    background-color: #e9ecef;
}

.k-progressbar-chunk .k-selected {
    background-color: #0d6efd;
}

.k-progressbar-indeterminate {
    color: black;
    background-color: #e9ecef;
    background-image: linear-gradient(45deg, #d6d9dc 25%, transparent 25%, transparent 50%, #d6d9dc 50%, #d6d9dc 75%, transparent 75%, transparent);
    background-size: 1rem 1rem;
    animation: kendo-progressbar-indeterminate-animation 1s linear infinite;
}

.k-circular-progressbar-scale {
    stroke: #e9ecef;
}

.k-circular-progressbar-arc {
    stroke: #0d6efd;
    transition: stroke .5s ease;
}

.k-radio {
    border-radius: 50%;
    margin: 0;
    padding: 0;
    line-height: initial;
    border-width: 1px;
    border-style: solid;
    outline: 0;
    box-sizing: border-box;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    flex: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    -webkit-appearance: none;
}

.k-radio:checked,
.k-radio.k-checked {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.k-radio:disabled,
.k-radio.k-disabled {
    outline: none;
    cursor: default;
    opacity: 0.65;
    filter: grayscale(0.1);
    pointer-events: none;
    box-shadow: none;
}

.k-radio-wrap {
    flex: none;
    display: inline-flex;
    flex-flow: row nowrap;
    gap: 0;
    align-items: center;
    align-self: start;
    vertical-align: middle;
    position: relative;
}

.k-radio-wrap::before {
    content: "\\200b";
    width: 0px;
    overflow: hidden;
    flex: none;
    display: inline-block;
    vertical-align: top;
}

.k-radio-label {
    margin: 0;
    padding: 0;
    display: inline-flex;
    align-items: flex-start;
    gap: 0.25rem;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
}

.k-radio-label .k-ripple {
    visibility: hidden !important;
}

.k-radio + .k-label,
.k-radio-wrap + .k-label,
.k-radio + .k-radio-label,
.k-radio-wrap + .k-radio-label {
    display: inline;
    margin-inline-start: 0.25rem;
}

.k-radio-label:empty {
    display: none !important;
}

.k-radio-label.k-no-text {
    min-width: 1px;
}

.k-radio-list {
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: column nowrap;
    gap: 0;
    list-style: none;
}

.k-radio-item,
.k-radio-list-item {
    padding-block: 0.25rem;
    padding-inline: 0px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    gap: 0.25rem;
}

.k-radio-item .k-radio-label,
.k-radio-list-item .k-radio-label {
    margin: 0;
}

.k-radio-list-horizontal,
.k-radio-list.k-list-horizontal {
    display: flex;
    flex-flow: row wrap;
    gap: 1rem;
}

.k-ripple-container .k-radio::after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    border-radius: 100%;
    z-index: -1;
    transition: opacity 100ms linear, transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
    transform: translate(-50%, -50%) scale(0);
    transform-origin: center center;
}

.k-ripple-container .k-radio:focus,
.k-ripple-container .k-radio.k-focus {
    box-shadow: none !important;
}

.k-ripple-container .k-radio:disabled::after,
.k-ripple-container .k-radio.k-disabled::after {
    display: none;
}

.k-ripple-container .k-radio:disabled::after,
.k-ripple-container .k-radio.k-disabled::after {
    display: none;
}

.k-radio-sm {
    width: 0.75rem;
    height: 0.75rem;
}

.k-radio-sm::before {
    font-size: 0.625rem;
}

.k-ripple-container .k-radio-sm::after {
    width: 300%;
    height: 300%;
}

.k-radio-md {
    width: 1rem;
    height: 1rem;
}

.k-radio-md::before {
    font-size: 0.875rem;
}

.k-ripple-container .k-radio-md::after {
    width: 300%;
    height: 300%;
}

.k-radio-lg {
    width: 1.25rem;
    height: 1.25rem;
}

.k-radio-lg::before {
    font-size: 1.125rem;
}

.k-ripple-container .k-radio-lg::after {
    width: 300%;
    height: 300%;
}

.k-radio {
    border-color: #ced4da;
    background-color: #ffffff;
}

.k-radio:focus,
.k-radio.k-focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-radio.k-invalid,
.k-radio.ng-invalid.ng-touched,
.k-radio.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-radio.k-invalid + .k-radio-label,
.k-radio.ng-invalid.ng-touched + .k-radio-label,
.k-radio.ng-invalid.ng-dirty + .k-radio-label {
    color: #dc3545;
}

.k-radio:checked,
.k-radio.k-checked {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-radio:checked:focus,
.k-radio.k-checked.k-focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-ripple-container .k-radio::after {
    background: #0d6efd;
    opacity: 0.25;
}

.k-slider {
    border: 0;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    background: none;
    display: inline-flex;
    align-items: center;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-slider *,
.k-slider *::before,
.k-slider *::after {
    box-sizing: border-box;
}

.k-slider .k-label {
    width: auto;
    font-size: .92em;
    line-height: 1;
    white-space: nowrap;
    position: absolute;
}

.k-slider .k-tick,
.k-slider .k-slider-track {
    cursor: pointer;
}

.k-slider .k-tick {
    background-color: transparent;
    background-position: center center;
    background-repeat: no-repeat;
    margin: 0;
    padding: 0;
    position: relative;
}

.k-slider.k-disabled .k-tick,
.k-slider.k-disabled .k-slider-track,
.k-slider.k-disabled .k-draghandle {
    cursor: default;
}

.k-slider {
    width: min-content;
    height: min-content;
    gap: 7px;
}

.k-slider .k-button {
    flex: none;
}

.k-slider .k-slider-track-wrap {
    flex: 1 1 auto;
    display: flex;
    flex-flow: inherit;
    position: relative;
    touch-action: none;
}

.k-slider .k-slider-track-wrap .k-slider-items {
    margin: 0;
    padding: 0;
    list-style: none;
    flex: 1 1 100%;
    display: flex;
    flex-flow: inherit;
    justify-content: space-between;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-slider .k-slider-track-wrap .k-tick {
    flex: 0 0 1px;
}

.k-slider .k-slider-track-wrap .k-tick-horizontal {
    width: 1px;
    min-height: 100%;
}

.k-slider .k-slider-track-wrap .k-tick-vertical {
    width: 100%;
    min-height: 1px;
}

.k-slider .k-slider-track-wrap .k-draghandle {
    position: absolute;
}

.k-slider-horizontal .k-slider-track-wrap {
    height: 26px;
}

.k-slider-horizontal .k-slider-track-wrap .k-slider-track {
    width: 100%;
}

.k-slider-horizontal .k-slider-track-wrap .k-draghandle {
    top: 50%;
    transform: translate(-50%, -50%);
}

.k-slider-horizontal .k-slider-track-wrap .k-draghandle:focus,
.k-slider-horizontal .k-slider-track-wrap .k-draghandle:active {
    transform: translate(-50%, -50%) scale(1);
}

.k-slider-horizontal .k-slider-track-wrap .k-slider-selection {
    width: calc((var(--kendo-slider-end, 0) - var(--kendo-slider-start, 0))*1%);
    inset-inline-start: calc(var(--kendo-slider-start, 0)*1%);
}

.k-slider-horizontal .k-slider-track-wrap .k-draghandle-start {
    inset-inline-start: calc(var(--kendo-slider-start, 0)*1%);
}

.k-slider-horizontal .k-slider-track-wrap .k-draghandle-end {
    inset-inline-start: calc(var(--kendo-slider-end, 0)*1%);
}

.k-slider-vertical .k-slider-track-wrap {
    width: 26px;
}

.k-slider-vertical .k-slider-track-wrap .k-slider-track {
    height: 100%;
}

.k-slider-vertical .k-slider-track-wrap .k-draghandle {
    left: 50%;
    transform: translate(-50%, 50%);
}

.k-slider-vertical .k-slider-track-wrap .k-draghandle:focus,
.k-slider-vertical .k-slider-track-wrap .k-draghandle:active {
    transform: translate(-50%, 50%) scale(1);
}

.k-slider-vertical .k-slider-track-wrap .k-slider-selection {
    bottom: calc(var(--kendo-slider-start, 0)*1%);
    height: calc((var(--kendo-slider-end, 0) - var(--kendo-slider-start, 0))*1%);
}

.k-slider-vertical .k-slider-track-wrap .k-draghandle-start {
    bottom: calc(var(--kendo-slider-start, 0)*1%);
}

.k-slider-vertical .k-slider-track-wrap .k-draghandle-end {
    bottom: calc(var(--kendo-slider-end, 0)*1%);
}

.k-slider-vertical {
    height: 200px;
    flex-flow: column-reverse nowrap;
}

.k-slider-vertical .k-tick {
    text-align: end;
    margin-left: 2px;
}

.k-slider-vertical .k-slider-topleft .k-tick {
    text-align: start;
}

.k-slider-vertical .k-tick {
    background-position: -94px center;
}

.k-slider-vertical .k-slider-topleft .k-tick {
    background-position: -124px center;
}

.k-slider-vertical .k-slider-bottomright .k-tick {
    background-position: -154px center;
}

.k-slider-vertical .k-tick-large {
    display: flex;
    align-items: center;
    background-position: -4px center;
}

.k-slider-vertical .k-slider-topleft .k-tick-large {
    background-position: -34px center;
}

.k-slider-vertical .k-slider-bottomright .k-tick-large {
    background-position: -64px center;
}

.k-slider-vertical .k-first {
    background-position: -94px 100%;
}

.k-slider-vertical .k-tick-large.k-first {
    background-position: -4px 100%;
}

.k-slider-vertical .k-slider-topleft .k-first {
    background-position: -124px 100%;
}

.k-slider-vertical .k-slider-topleft .k-tick-large.k-first {
    background-position: -34px 100%;
}

.k-slider-vertical .k-slider-bottomright .k-first {
    background-position: -154px 100%;
}

.k-slider-vertical .k-slider-bottomright .k-tick-large.k-first {
    background-position: -64px 100%;
}

.k-slider-vertical .k-last {
    background-position: -94px 0;
}

.k-slider-vertical .k-tick-large.k-last {
    background-position: -4px 0;
}

.k-slider-vertical .k-slider-topleft .k-last {
    background-position: -124px 0;
}

.k-slider-vertical .k-slider-topleft .k-tick-large.k-last {
    background-position: -34px 0;
}

.k-slider-vertical .k-slider-bottomright .k-last {
    background-position: -154px 0;
}

.k-slider-vertical .k-slider-bottomright .k-tick-large.k-last {
    background-position: -64px 0;
}

.k-slider-vertical .k-label {
    text-align: start;
    inset-inline-start: 120%;
    top: 50%;
    transform: translateY(-50%);
}

.k-slider-vertical .k-first .k-label {
    top: 100%;
}

.k-slider-vertical .k-last .k-label {
    top: 0;
}

.k-slider-vertical .k-slider-topleft .k-label {
    inset-inline-start: auto;
    inset-inline-end: 120%;
}

.k-slider-horizontal {
    width: 200px;
    flex-flow: row nowrap;
}

.k-slider-horizontal .k-tick {
    background-position: center -92px;
}

.k-slider-horizontal .k-slider-topleft .k-tick {
    background-position: center -122px;
}

.k-slider-horizontal .k-slider-bottomright .k-tick {
    background-position: center -152px;
}

.k-slider-horizontal .k-tick-large {
    background-position: center -2px;
}

.k-slider-horizontal .k-slider-topleft .k-tick-large {
    background-position: center -32px;
}

.k-slider-horizontal .k-slider-bottomright .k-tick-large {
    background-position: center -62px;
}

.k-slider-horizontal .k-first {
    background-position: 0 -92px;
}

.k-slider-horizontal .k-tick-large.k-first {
    background-position: 0 -2px;
}

.k-slider-horizontal .k-slider-topleft .k-first {
    background-position: 0 -122px;
}

.k-slider-horizontal .k-slider-topleft .k-tick-large.k-first {
    background-position: 0 -32px;
}

.k-slider-horizontal .k-slider-bottomright .k-first {
    background-position: 0 -152px;
}

.k-slider-horizontal .k-slider-bottomright .k-tick-large.k-first {
    background-position: 0 -62px;
}

.k-slider-horizontal .k-last {
    background-position: 100% -92px;
}

.k-slider-horizontal .k-tick-large.k-last {
    background-position: 100% -2px;
}

.k-slider-horizontal .k-slider-topleft .k-last {
    background-position: 100% -122px;
}

.k-slider-horizontal .k-slider-topleft .k-tick-large.k-last {
    background-position: 100% -32px;
}

.k-slider-horizontal .k-slider-bottomright .k-last {
    background-position: 100% -152px;
}

.k-slider-horizontal .k-slider-bottomright .k-tick-large.k-last {
    background-position: 100% -62px;
}

.k-slider-horizontal .k-label {
    inset-inline-start: 50%;
    bottom: -1.2em;
    transform: translateX(-50%);
}

.k-slider-horizontal .k-first .k-label {
    inset-inline-start: 0;
}

.k-slider-horizontal .k-last .k-label {
    inset-inline-start: 100%;
}

.k-slider-horizontal .k-slider-topleft .k-label {
    top: -1.2em;
}

.k-slider-track,
.k-slider-selection {
    margin: 0;
    padding: 0;
    position: absolute;
}

.k-slider-horizontal .k-slider-track, .k-slider-horizontal
.k-slider-selection {
    height: 4px;
    left: 0;
    margin-top: -2px;
    top: 50%;
}

.k-slider-vertical .k-slider-track, .k-slider-vertical
.k-slider-selection {
    bottom: 0;
    left: 50%;
    margin-left: -2px;
    width: 4px;
}

.k-draghandle {
    background-color: transparent;
    background-repeat: no-repeat;
    border-style: solid;
    border-width: 1px;
    outline: 0;
    position: absolute;
    text-align: center;
    text-decoration: none;
    width: 14px;
    height: 14px;
}

.k-slider-transitions.k-slider-horizontal .k-draghandle {
    transition: inset-inline-start 0.3s ease-out, background-color 0.3s ease-out, transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.k-slider-transitions.k-slider-vertical .k-draghandle {
    transition: bottom 0.3s ease-out, background-color 0.3s ease-out, transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.k-draghandle.k-pressed {
    transition: none;
}

.k-slider-transitions.k-slider-horizontal .k-slider-selection {
    transition: width 0.3s ease-out;
}

.k-slider-transitions.k-slider-vertical .k-slider-selection {
    transition: height 0.3s ease-out;
}

.k-slider-selection.k-pressed {
    transition: none;
}

.k-slider.k-readonly .k-button,
.k-slider.k-readonly .k-slider-track,
.k-slider.k-readonly .k-tick,
.k-slider.k-readonly .k-draghandle {
    pointer-events: none;
}

.k-slider-tooltip .k-callout-n,
.k-slider-tooltip .k-callout-s {
    margin-inline-start: -0.2rem;
}

.k-slider-tooltip .k-callout-w,
.k-slider-tooltip .k-callout-e {
    margin-top: -0.2rem;
}

.k-slider-rtl.k-slider-horizontal .k-draghandle, .k-slider-horizontal.k-slider[dir="rtl"] .k-draghandle, [dir="rtl"] .k-slider-horizontal.k-slider .k-draghandle, .k-slider-horizontal.k-slider.k-rtl .k-draghandle, .k-rtl .k-slider-horizontal.k-slider .k-draghandle {
    transform: translate(50%, -50%);
}

.k-slider-rtl.k-slider-horizontal .k-draghandle:focus, .k-slider-horizontal.k-slider[dir="rtl"] .k-draghandle:focus, [dir="rtl"] .k-slider-horizontal.k-slider .k-draghandle:focus, .k-slider-horizontal.k-slider.k-rtl .k-draghandle:focus, .k-rtl .k-slider-horizontal.k-slider .k-draghandle:focus,
.k-slider-rtl.k-slider-horizontal .k-draghandle:active,
.k-slider-horizontal.k-slider[dir="rtl"] .k-draghandle:active,
[dir="rtl"] .k-slider-horizontal.k-slider .k-draghandle:active,
.k-slider-horizontal.k-slider.k-rtl .k-draghandle:active,
.k-rtl .k-slider-horizontal.k-slider .k-draghandle:active {
    transform: translate(50%, -50%) scale(1);
}

.k-slider-rtl.k-slider-horizontal .k-label, .k-slider-horizontal.k-slider[dir="rtl"] .k-label, [dir="rtl"] .k-slider-horizontal.k-slider .k-label, .k-slider-horizontal.k-slider.k-rtl .k-label, .k-rtl .k-slider-horizontal.k-slider .k-label {
    transform: translateX(50%);
}

.k-slider kendo-resize-sensor {
    position: absolute;
}

.k-slider {
    color: #212529;
}

.k-slider .k-slider-track,
.k-slider .k-slider-selection {
    border-radius: 0.375rem;
}

.k-slider .k-slider-track {
    background-color: #e9ecef;
}

.k-slider .k-slider-selection {
    background-color: #0d6efd;
}

.k-slider .k-draghandle {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
    border-radius: 50%;
}

.k-slider .k-draghandle:hover {
    border-color: #0257d5;
    color: white;
    background-color: #025ce2;
}

.k-slider .k-draghandle:active, .k-slider .k-draghandle.k-pressed {
    border-color: #0252c9;
    color: white;
    background-color: #0257d5;
}

.k-slider .k-draghandle:focus, .k-slider .k-draghandle.k-focus {
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5);
}

.k-slider.k-focus .k-draghandle {
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5);
}

.k-slider-horizontal .k-tick {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.k-slider-vertical .k-tick {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.k-calendar {
    inline-size: var(--INTERNAL--kendo-calendar-width, min-content);
    block-size: var(--INTERNAL--kendo-calendar-height, min-content);
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    position: relative;
    overflow: hidden;
    display: inline-flex;
    flex-flow: column nowrap;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-calendar > .k-calendar {
    border: 0;
}

.k-calendar-table {
    margin-block: 0;
    margin-inline: auto;
    border-width: 0;
    border-color: inherit;
    border-spacing: 0;
    border-collapse: separate;
    table-layout: fixed;
    text-align: center;
    outline: 0;
    display: table;
    position: relative;
    z-index: 1;
}

.k-calendar-caption,
.k-calendar-caption.k-calendar-th,
.k-calendar .k-meta-header,
.k-calendar .k-month-header {
    padding-block: 0.25rem;
    padding-inline: 0.75rem;
    height: 38px;
    box-sizing: border-box;
    text-transform: none;
    text-align: start;
    font-weight: bold;
    cursor: default;
}

.k-calendar-th,
.k-calendar-td {
    border-width: 0;
    padding: 0;
    text-align: center;
    border-style: solid;
    border-color: inherit;
    font-weight: normal;
    cursor: default;
}

.k-calendar-th {
    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 38px);
    block-size: var(--INTERNAL--kendo-calendar-cell-size, 38px);
    font-size: 0.875rem;
    line-height: 2;
    text-transform: uppercase;
}

.k-calendar-td {
    border-radius: 0.375rem;
    inline-size: var(--INTERNAL--kendo-calendar-cell-size, min-content);
    block-size: var(--INTERNAL--kendo-calendar-cell-size, min-content);
    border-color: transparent;
}

.k-calendar .k-calendar-cell-inner, .k-calendar .k-link {
    border-radius: 0.375rem;
    padding-inline: var(--INTERNAL--kendo-calendar-cell-padding-x, 0.25rem);
    padding-block: var(--INTERNAL--kendo-calendar-cell-padding-y, 0.25rem);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    white-space: normal;
    position: relative;
    overflow: hidden;
}

.k-calendar .k-header {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    position: relative;
    z-index: 2;
}

.k-calendar-header {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    min-width: 304px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 auto;
}

.k-calendar-header .k-title,
.k-calendar-header .k-calendar-title {
    font-weight: bold;
}

.k-calendar-header .k-calendar-nav {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}

.k-calendar-footer,
.k-calendar .k-footer {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    text-align: center;
    clear: both;
}

.k-calendar-view {
    margin: auto;
    padding-block: 0;
    padding-inline: 0.25rem;
    width: 304px;
    inline-size: var(--INTERNAL--kendo-calendar-view-width, 304px);
    min-height: 266px;
    box-sizing: content-box;
    gap: 1rem;
    position: relative;
    z-index: 1;
    overflow: hidden;
}

.k-month-calendar .k-calendar-td,
.k-calendar-monthview .k-calendar-td {
    width: 38px;
    height: 38px;
    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 38px);
    block-size: var(--INTERNAL--kendo-calendar-cell-size, 38px);
}

.k-year-calendar .k-calendar-td,
.k-calendar-yearview .k-calendar-td {
    width: 76px;
    height: 76px;
    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);
    block-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);
}

.k-decade-calendar .k-calendar-td,
.k-calendar-decadeview .k-calendar-td {
    width: 76px;
    height: 76px;
    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);
    block-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);
}

.k-century-calendar .k-calendar-td,
.k-calendar-centuryview .k-calendar-td {
    width: 76px;
    height: 76px;
    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);
    block-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);
}

.k-century-calendar .k-calendar-cell-inner, .k-century-calendar .k-link,
.k-calendar-centuryview .k-calendar-cell-inner,
.k-calendar-centuryview .k-link {
    text-align: start;
}

.k-popup .k-calendar {
    height: 100%;
}

.k-calendar-container,
.k-datetime-container {
    padding: 0;
}

.k-calendar-container .k-calendar,
.k-datetime-container .k-calendar {
    border-width: 0;
}

.k-calendar .k-content.k-scrollable,
.k-calendar .k-calendar-content.k-scrollable {
    box-sizing: content-box;
    overflow-x: hidden;
    overflow-y: auto;
    display: block;
    padding-right: 100px;
    padding-left: 100px;
    margin-left: -100px;
    margin-right: calc(-100px - var(--kendo-scrollbar-width, 17px));
}

.k-calendar .k-scrollable-placeholder {
    position: absolute;
    z-index: -1;
    width: 1px;
    top: 0;
    right: 0;
}

.k-calendar-sm {
    --INTERNAL--kendo-calendar-view-width: 272px;
    --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-sm-cell-padding-x, 0.125rem );
    --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-sm-cell-padding-y, 0.125rem );
    font-size: 1rem;
    line-height: 1.5;
}

.k-calendar-sm.k-month-calendar,
.k-calendar-sm .k-calendar-monthview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-month-cell-size, 34px );
}

.k-calendar-sm.k-year-calendar,
.k-calendar-sm .k-calendar-yearview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-year-cell-size, 68px );
}

.k-calendar-sm.k-decade-calendar,
.k-calendar-sm .k-calendar-decadeview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-decade-cell-size, 68px );
}

.k-calendar-sm.k-century-calendar,
.k-calendar-sm .k-calendar-centuryview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-century-cell-size, 68px );
}

.k-calendar-md {
    --INTERNAL--kendo-calendar-view-width: 304px;
    --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-md-cell-padding-x, 0.25rem );
    --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-md-cell-padding-y, 0.25rem );
    font-size: 1rem;
    line-height: 1.5;
}

.k-calendar-md.k-month-calendar,
.k-calendar-md .k-calendar-monthview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-month-cell-size, 38px );
}

.k-calendar-md.k-year-calendar,
.k-calendar-md .k-calendar-yearview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-year-cell-size, 76px );
}

.k-calendar-md.k-decade-calendar,
.k-calendar-md .k-calendar-decadeview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-decade-cell-size, 76px );
}

.k-calendar-md.k-century-calendar,
.k-calendar-md .k-calendar-centuryview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-century-cell-size, 76px );
}

.k-calendar-lg {
    --INTERNAL--kendo-calendar-view-width: 336px;
    --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-lg-cell-padding-x, 0.25rem );
    --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-lg-cell-padding-y, 0.25rem );
    font-size: 1.25rem;
    line-height: 2;
}

.k-calendar-lg.k-month-calendar,
.k-calendar-lg .k-calendar-monthview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-month-cell-size, 42px );
}

.k-calendar-lg.k-year-calendar,
.k-calendar-lg .k-calendar-yearview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-year-cell-size, 84px );
}

.k-calendar-lg.k-decade-calendar,
.k-calendar-lg .k-calendar-decadeview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-decade-cell-size, 84px );
}

.k-calendar-lg.k-century-calendar,
.k-calendar-lg .k-calendar-centuryview {
    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-century-cell-size, 84px );
}

.k-calendar-infinite {
    box-sizing: content-box;
    display: inline-flex;
    flex-flow: row nowrap;
}

.k-calendar-infinite .k-calendar-view {
    padding-block: 0px;
    padding-inline: 1rem;
    height: 342px;
    flex: 0 0 auto;
    display: flex;
    flex-flow: column nowrap;
    gap: 0;
    overflow: hidden;
}

.k-calendar-infinite .k-calendar-view .k-content.k-scrollable {
    position: relative;
}

.k-calendar-infinite .k-calendar-view::after {
    display: block;
    position: absolute;
    bottom: 0;
    content: "\\200b";
    height: 0;
    line-height: 0;
    z-index: 1;
    width: 150%;
    left: -25%;
    box-shadow: 0 0 38px 19px #ffffff;
}

.k-calendar-infinite .k-calendar-header {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    width: auto;
    min-width: 0;
}

.k-calendar-infinite .k-calendar-weekdays {
    flex: 0 0 auto;
}

.k-calendar-navigation {
    width: 5em;
    text-align: center;
    flex: 0 0 auto;
    display: block;
    overflow: hidden;
    position: relative;
    z-index: 1;
}

.k-calendar-navigation::before, .k-calendar-navigation::after {
    display: block;
    position: absolute;
    content: "\\200b";
    height: 0;
    line-height: 0;
    z-index: 1;
    width: 200%;
    left: -50%;
    box-shadow: 0 0 6em 3em #f8f9fa;
}

.k-calendar-navigation::before {
    top: 0;
}

.k-calendar-navigation::after {
    bottom: 0;
}

.k-calendar-navigation .k-content,
.k-calendar-navigation .k-calendar-content {
    background: transparent;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.k-calendar-navigation .k-content ul,
.k-calendar-navigation .k-calendar-content ul {
    width: 5em;
}

.k-calendar-navigation .k-content li,
.k-calendar-navigation .k-calendar-content li {
    height: 2em;
    line-height: 2em;
    cursor: pointer;
    padding-block: 0;
    padding-inline: 1em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: clip;
}

.k-calendar-navigation .k-calendar-navigation-marker {
    font-weight: bold;
}

.k-calendar-navigation .k-calendar-navigation-highlight {
    width: 100%;
    border-width: 1px 0;
    border-style: solid;
    height: 2em;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}

.k-calendar-range {
    width: auto;
}

.k-calendar-range .k-calendar-view {
    width: auto;
    white-space: nowrap;
}

.k-calendar-range .k-calendar-view::after {
    display: none;
}

.k-calendar-range .k-calendar-view:focus {
    outline: 0;
}

.k-calendar-range .k-range-start {
    border-color: inherit;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.k-calendar-range .k-range-end {
    border-color: inherit;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.k-calendar-range .k-range-mid {
    border-color: inherit;
    border-radius: 0;
}

.k-rtl .k-calendar .k-content.k-scrollable,
.k-rtl .k-calendar .k-calendar-content.k-scrollable,
[dir="rtl"] .k-calendar .k-content.k-scrollable,
[dir="rtl"] .k-calendar .k-calendar-content.k-scrollable,
.k-calendar.k-rtl .k-content.k-scrollable,
.k-calendar.k-rtl .k-calendar-content.k-scrollable,
.k-calendar[dir="rtl"] .k-content.k-scrollable,
.k-calendar[dir="rtl"] .k-calendar-content.k-scrollable {
    padding-right: 100px;
    padding-left: 100px;
    margin-left: calc(-100px - var(--kendo-scrollbar-width, 17px));
    margin-right: -100px;
}

.k-calendar {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-calendar .k-header {
    border-color: inherit;
    color: #212529;
    background-color: #f8f9fa;
    box-shadow: none;
}

.k-calendar .k-calendar-th,
.k-calendar .k-calendar-caption,
.k-calendar .k-meta-header,
.k-calendar .k-month-header {
    color: #6c757d;
}

.k-calendar .k-calendar-view .k-today .k-calendar-cell-inner, .k-calendar .k-calendar-view .k-today .k-link {
    box-shadow: inset 0 0 0 1px #0d6efd;
}

.k-calendar .k-calendar-view .k-today.k-focus .k-calendar-cell-inner, .k-calendar .k-calendar-view .k-today.k-focus .k-link {
    box-shadow: inset 0 0 0 1px #0d6efd, inset 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-calendar .k-other-month {
    color: #6c757d;
}

.k-calendar .k-alt {
    background-color: transparent;
    color: #6c757d;
}

.k-calendar .k-out-of-range {
    pointer-events: none;
}

.k-calendar .k-calendar-td:hover .k-calendar-cell-inner, .k-calendar .k-calendar-td:hover .k-link,
.k-calendar .k-calendar-td.k-hover .k-calendar-cell-inner,
.k-calendar .k-calendar-td.k-hover .k-link {
    border-color: #d6d9dc;
    color: #212529;
    background-color: #e9ecef;
}

.k-calendar .k-calendar-td.k-selected .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected .k-link {
    border-color: #0c65e9;
    color: white;
    background-color: #0d6efd;
}

.k-calendar .k-calendar-td.k-selected:hover .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected:hover .k-link,
.k-calendar .k-calendar-td.k-selected.k-hover .k-calendar-cell-inner,
.k-calendar .k-calendar-td.k-selected.k-hover .k-link {
    border-color: #e4e5e6;
    color: white;
    background-color: #0c6af3;
}

.k-calendar .k-calendar-td:focus .k-calendar-cell-inner, .k-calendar .k-calendar-td:focus .k-link,
.k-calendar .k-calendar-td.k-focus .k-calendar-cell-inner,
.k-calendar .k-calendar-td.k-focus .k-link {
    box-shadow: inset 0 0 0 0.25rem rgba(228, 231, 235, 0.5);
}

.k-calendar .k-calendar-td.k-selected:focus .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected:focus .k-link,
.k-calendar .k-calendar-td.k-selected.k-focus .k-calendar-cell-inner,
.k-calendar .k-calendar-td.k-selected.k-focus .k-link {
    box-shadow: inset 0 0 0 2px rgba(2, 82, 201, 0.5);
}

.k-calendar .k-calendar-navigation {
    color: #212529;
    background-color: #f8f9fa;
    box-shadow: inset -1px 0 #dee2e6;
}

.k-calendar .k-calendar-navigation li:hover,
.k-calendar .k-calendar-navigation li.k-hover {
    color: #0a58ca;
}

.k-calendar .k-calendar-navigation-highlight {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-calendar[dir="rtl"] .k-calendar-navigation,
.k-rtl .k-calendar .k-calendar-navigation {
    box-shadow: inset 1px 0 #dee2e6;
}

.k-calendar.k-invalid, .k-calendar.k-invalid:hover, .k-calendar.ng-invalid.ng-touched, .k-calendar.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-scheduler .k-calendar .k-other-month {
    color: #6c757d;
    background-color: transparent;
}

.k-calendar .k-range-start,
.k-calendar .k-range-end,
.k-calendar .k-range-mid {
    background-color: rgba(13, 110, 253, 0.25);
}

.k-calendar .k-range-start.k-range-end {
    background-image: none;
    background-color: transparent;
}

.k-calendar .k-range-start .k-calendar-cell-inner, .k-calendar .k-range-start .k-link,
.k-calendar .k-range-end .k-calendar-cell-inner,
.k-calendar .k-range-end .k-link {
    background-color: #0d6efd;
}

.k-calendar .k-range-start.k-active .k-calendar-cell-inner, .k-calendar .k-range-start.k-active .k-link,
.k-calendar .k-range-end.k-active .k-calendar-cell-inner,
.k-calendar .k-range-end.k-active .k-link {
    box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, 0.2);
}

.k-calendar .k-range-split-start,
.k-calendar .k-range-split-end {
    position: relative;
}

.k-calendar .k-range-split-start::after,
.k-calendar .k-range-split-end::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 5px;
}

.k-calendar .k-range-split-start::after {
    left: -5px;
    right: auto;
    background-image: linear-gradient(to left, rgba(13, 110, 253, 0.25), transparent 100%);
}

.k-calendar .k-range-split-end::after {
    right: -5px;
    left: auto;
    background-image: linear-gradient(to right, rgba(13, 110, 253, 0.25), transparent 100%);
}

.k-timeselector {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-popup > .k-timeselector {
    border-width: 0;
}

.k-time-header,
.k-time-selector-header {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 auto;
}

.k-time-header .k-title,
.k-time-header .k-time-selector-header-title,
.k-time-selector-header .k-title,
.k-time-selector-header .k-time-selector-header-title {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
    font-weight: bold;
    display: inline-block;
}

.k-time-header .k-time-now,
.k-time-selector-header .k-time-now {
    border-width: 0;
    line-height: inherit;
    cursor: pointer;
}

.k-actions.k-time-fast-selection, .k-time-fast-selection.k-edit-buttons,
.k-time-fast-selection.k-action-buttons,
.k-time-fast-selection.k-columnmenu-actions, .k-time-fast-selection.k-form-buttons {
    margin-top: 0;
}

.k-time-list-container {
    display: flex;
    position: relative;
    flex: 1 1 auto;
    overflow: hidden;
}

.k-time-highlight,
.k-time-list-highlight {
    width: 100%;
    height: 2rem;
    border-width: 1px 0px;
    border-style: solid;
    box-sizing: border-box;
    position: absolute;
    top: calc(50% + 0.65625rem);
    left: 0;
    right: 0;
    transform: translateY(-50%);
    z-index: 1;
}

.k-time-list-wrapper {
    min-width: 4em;
    height: 240px;
    box-sizing: content-box;
    display: inline-flex;
    flex-flow: column nowrap;
    align-items: stretch;
    overflow: hidden;
    position: relative;
    text-align: center;
    flex: 1 1 auto;
}

.k-time-list-wrapper .k-title {
    font-size: 0.875rem;
    line-height: 1.5;
    font-weight: bold;
    text-align: center;
    text-transform: capitalize;
    display: block;
}

.k-time-list-wrapper.k-focus::before, .k-time-list-wrapper.k-focus::after {
    display: block;
    content: "\\200b";
    position: absolute;
    width: 100%;
    left: 0;
    pointer-events: none;
    height: calc(50% - 1rem);
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
}

.k-time-list-wrapper.k-focus::before {
    top: 1.3125rem;
}

.k-time-list-wrapper.k-focus::after {
    bottom: 0;
}

.k-time-list {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    flex: 1;
    position: relative;
    z-index: 1;
    outline: 0;
    overflow: hidden;
}

.k-time-list::before, .k-time-list::after {
    display: block;
    position: absolute;
    content: "\\200b";
    height: 0;
    line-height: 0;
    z-index: 1;
    width: 200%;
    left: -50%;
}

.k-time-list::before {
    top: 0;
}

.k-time-list::after {
    bottom: 0;
}

.k-time-container,
.k-time-list-content {
    position: relative;
    flex: 1 1 auto;
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
    padding-right: 100px;
    padding-left: 100px;
    margin-left: -100px;
    margin-right: calc(-100px - var(--kendo-scrollbar-width, 17px));
}

.k-time-container > ul,
.k-time-list-content > ul {
    height: auto;
    width: 4em;
    margin: auto;
}

.k-time-container .k-scrollable-placeholder,
.k-time-list-content .k-scrollable-placeholder {
    position: absolute;
    width: 1px;
    top: 0;
    right: 0;
}

.k-time-list-item,
.k-time-list .k-item {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-time-separator {
    width: 0;
    height: 2rem;
    align-self: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 11;
    top: 0.65625rem;
}

.k-timeselector-sm {
    font-size: 0.875rem;
    line-height: 1.4285714286;
}

.k-timeselector-sm .k-time-highlight,
.k-timeselector-sm .k-time-list-highlight {
    height: 1.75rem;
}

.k-timeselector-sm .k-time-separator {
    height: 1.75rem;
}

.k-timeselector-sm .k-time-list-item,
.k-timeselector-sm .k-time-list .k-item {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-timeselector-md {
    font-size: 1rem;
    line-height: 1.5;
}

.k-timeselector-md .k-time-highlight,
.k-timeselector-md .k-time-list-highlight {
    height: 2rem;
}

.k-timeselector-md .k-time-separator {
    height: 2rem;
}

.k-timeselector-md .k-time-list-item,
.k-timeselector-md .k-time-list .k-item {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-timeselector-lg {
    font-size: 1rem;
    line-height: 1.5;
}

.k-timeselector-lg .k-time-highlight,
.k-timeselector-lg .k-time-list-highlight {
    height: 2.5rem;
}

.k-timeselector-lg .k-time-separator {
    height: 2.5rem;
}

.k-timeselector-lg .k-time-list-item,
.k-timeselector-lg .k-time-list .k-item {
    padding-block: 0.5rem;
    padding-inline: 1rem;
}

.k-rtl .k-time-container,
.k-rtl .k-time-list-content,
[dir="rtl"] .k-time-container,
[dir="rtl"] .k-time-list-content {
    padding-right: 100px;
    padding-left: 100px;
    margin-left: calc(-100px - var(--kendo-scrollbar-width, 17px));
    margin-right: -100px;
}

.k-timeselector {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-time-header .k-time-now,
.k-time-selector-header .k-time-now {
    color: #0d6efd;
}

.k-time-header .k-time-now:hover,
.k-time-selector-header .k-time-now:hover {
    color: #0a58ca;
}

.k-time-list-wrapper .k-title {
    color: #6c757d;
}

.k-time-list-wrapper.k-focus .k-title {
    color: #212529;
}

.k-time-list-wrapper.k-focus::before, .k-time-list-wrapper.k-focus::after {
    background-color: rgba(0, 0, 0, 0.02);
}

.k-time-list::before, .k-time-list::after {
    box-shadow: 0 0 3em 1.5em #ffffff;
}

.k-time-list .k-item:hover {
    color: #0d6efd;
}

.k-time-container {
    background: transparent;
}

.k-time-highlight {
    border-color: #dee2e6;
    background-color: #ffffff;
}

.k-captcha {
    width: 335px;
    box-sizing: border-box;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    display: flex;
    flex-flow: column nowrap;
    gap: 0.5rem;
}

.k-captcha *,
.k-captcha *::before,
.k-captcha *::after {
    box-sizing: border-box;
}

.k-captcha-image-wrap {
    position: relative;
    gap: 0.5rem;
}

.k-captcha-image-controls {
    position: relative;
    gap: 0.5rem;
}

.k-captcha-image {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.k-captcha-image > img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.k-captcha-loading .k-captcha-image {
    height: auto;
}

.k-captcha-volume-control {
    height: 100%;
}

.k-captcha-validation-message {
    margin-top: 0.25rem;
    font-size: 0.875rem;
    font-style: italic;
}

.k-captcha {
    border-color: #ffffff;
    color: #ffffff;
    background-color: #ffffff;
}

.k-colorpalette {
    border-width: 0;
    box-sizing: border-box;
    outline: 0;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 0;
    display: inline-flex;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-colorpalette *,
.k-colorpalette *::before,
.k-colorpalette *::after {
    box-sizing: border-box;
}

.k-colorpalette-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    position: relative;
}

.k-colorpalette-tile {
    width: 1.5rem;
    height: 1.5rem;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
}

.k-colorpalette-tile:hover, .k-colorpalette-tile.k-hover {
    position: relative;
    z-index: 101;
}

.k-colorpalette-tile:focus, .k-colorpalette-tile.k-focus, .k-colorpalette-tile.k-selected, .k-colorpalette-tile.k-selected:hover {
    position: relative;
    z-index: 100;
}

.k-colorpalette-tile:focus, .k-colorpalette-tile.k-focus {
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.5);
}

.k-colorpalette-tile:hover, .k-colorpalette-tile.k-hover {
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.8);
}

.k-colorpalette-tile.k-selected, .k-colorpalette-tile.k-selected:hover {
    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px white;
}

.k-colorgradient {
    border-radius: 0.375rem;
    width: 328px;
    padding-block: 1rem;
    padding-inline: 1rem;
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
    outline: 0;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-colorgradient *,
.k-colorgradient *::before,
.k-colorgradient *::after {
    box-sizing: border-box;
}

.k-colorgradient-canvas {
    gap: 0.75rem;
}

.k-colorgradient-canvas .k-hsv-rectangle {
    border-radius: 0.375rem;
    position: relative;
    flex: 1 1 auto;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-colorgradient-canvas .k-hsv-gradient {
    border-radius: 0.375rem;
    height: 180px;
}

.k-colorgradient-canvas .k-hsv-draghandle {
    margin-top: -7px;
    margin-left: -7px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    cursor: pointer;
}

.k-colorgradient-canvas .k-hsv-controls {
    position: relative;
    flex-shrink: 0;
    gap: 0.75rem;
}

.k-colorgradient .k-draghandle {
    border-radius: 50%;
    width: 14px;
    height: 14px;
    border-width: 1px;
    border-style: solid;
    outline-width: 1px;
    outline-style: solid;
    box-sizing: border-box;
}

.k-colorgradient-slider.k-slider-vertical {
    width: 10px;
    height: 180px;
    flex: 0 0 10px;
}

.k-colorgradient-slider.k-slider-vertical .k-slider-track {
    width: 10px;
    border-radius: 10px;
    margin-left: -5px;
}

.k-colorgradient-slider.k-slider-horizontal {
    width: 100%;
    height: 10px;
    flex: 0 0 10px;
}

.k-colorgradient-slider.k-slider-horizontal .k-slider-track {
    height: 10px;
    border-radius: 10px;
    margin-top: -5px;
}

.k-colorgradient-slider.k-alpha-slider .k-slider-track::before {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 10px;
    position: relative;
    z-index: -1;
}

.k-colorgradient-slider .k-slider-track-wrap {
    z-index: 1;
}

.k-colorgradient-slider .k-slider-selection {
    display: none;
}

.k-colorgradient-slider .k-draghandle {
    border-width: 3px;
}

.k-colorgradient-inputs {
    gap: 0.5rem;
}

.k-colorgradient-inputs .k-colorgradient-input-label {
    text-transform: uppercase;
}

.k-colorgradient-inputs > .k-vstack, .k-colorgradient-inputs > .k-vbox {
    gap: 0.25rem;
}

.k-colorgradient-inputs .k-numerictextbox {
    width: 56px;
}

.k-colorgradient-inputs .k-input-inner {
    padding-inline-start: 2px;
    padding-inline-end: 2px;
    text-align: center;
    text-overflow: clip;
}

.k-colorgradient-color-contrast > div {
    display: flex;
    flex-flow: row nowrap;
    gap: 0.5rem;
}

.k-colorgradient-color-contrast .k-contrast-ratio {
    margin-bottom: 0.5rem;
}

.k-colorgradient-color-contrast .k-contrast-ratio-text {
    font-weight: 700;
}

.k-colorgradient-color-contrast .k-contrast-validation {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
}

.k-colorgradient-color-contrast .k-contrast-validation .k-icon {
    vertical-align: middle;
}

.k-colorgradient-color-contrast .k-contrast-validation .k-icon + .k-icon,
.k-colorgradient-color-contrast .k-contrast-validation .k-icon-wrapper-host + .k-icon-wrapper-host .k-icon {
    margin-inline-start: -13px;
}

.k-color-contrast-svg {
    position: absolute;
    top: 0;
    left: 0;
    overflow: visible;
    pointer-events: none;
}

.k-colorgradient {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-colorgradient:focus,
.k-colorgradient.k-focus {
    border-color: #d6d9dc;
}

.k-colorgradient-canvas .k-hsv-gradient {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), black), linear-gradient(to right, white, rgba(255, 255, 255, 0));
}

.k-colorgradient .k-draghandle {
    border-color: rgba(255, 255, 255, 0.8);
    background-color: transparent;
    outline-color: #000000;
    box-shadow: rgba(0, 0, 0, 0.5);
}

.k-colorgradient .k-draghandle:focus, .k-colorgradient .k-draghandle.k-focus {
    border-color: #ffffff;
    background-color: transparent;
    outline-color: #000000;
    box-shadow: rgba(0, 0, 0, 0.5);
}

.k-colorgradient .k-draghandle:hover, .k-colorgradient .k-draghandle.k-hover, .k-colorgradient .k-draghandle.k-active, .k-colorgradient .k-draghandle:active {
    border-color: #ffffff;
    background-color: transparent;
    outline-color: #000000;
}

.k-colorgradient-slider.k-hue-slider.k-slider-horizontal .k-slider-track {
    background: linear-gradient(to right, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000);
}

.k-colorgradient-slider.k-hue-slider.k-slider-vertical .k-slider-track {
    background: linear-gradient(to top, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000);
}

.k-colorgradient-slider.k-alpha-slider .k-slider-track::before {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center repeat;
}

.k-colorgradient-input-label {
    color: #6c757d;
}

.k-rtl .k-colorgradient .k-hue-slider.k-slider-horizontal .k-slider-track,
[dir="rtl"] .k-colorgradient .k-hue-slider.k-slider-horizontal .k-slider-track {
    background: linear-gradient(to left, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000);
}

.k-coloreditor {
    border-radius: 0.375rem;
    min-width: 328px;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    display: inline-flex;
    flex-direction: column;
    align-items: stretch;
}

.k-coloreditor *,
.k-coloreditor *::before,
.k-coloreditor *::after {
    box-sizing: border-box;
}

.k-coloreditor-header {
    padding: 1rem 1rem 0;
}

.k-coloreditor-header-actions {
    gap: 0.5rem;
}

.k-coloreditor-preview {
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: center;
    gap: 0.25rem;
    position: relative;
    z-index: 1;
}

.k-coloreditor-preview .k-color-preview {
    width: 32px;
    height: 12px;
}

.k-coloreditor-views {
    min-width: calc(var(--kendo-color-preview-width, 1.5rem)*var(--kendo-color-preview-columns, 10));
    padding-block: 1rem;
    padding-inline: 1rem;
    gap: 1rem;
}

.k-coloreditor-views .k-colorgradient {
    padding: 0;
    width: auto;
    border-width: 0;
}

.k-coloreditor-views .k-colorgradient:focus,
.k-coloreditor-views .k-colorgradient.k-focus {
    outline: 2px dotted;
    outline-offset: 2px;
    border-radius: 0;
}

.k-coloreditor-views .k-colorpalette {
    align-self: center;
}

.k-coloreditor-views .k-colorpalette-tile {
    width: var(--kendo-color-preview-width, 1.5rem);
    height: var(--kendo-color-preview-height, 1.5rem);
}

.k-coloreditor-footer.k-actions, .k-coloreditor-footer.k-edit-buttons,
.k-coloreditor-footer.k-action-buttons,
.k-coloreditor-footer.k-columnmenu-actions, .k-coloreditor-footer.k-form-buttons {
    margin: 0;
}

.k-coloreditor {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-coloreditor:focus,
.k-coloreditor.k-focus {
    border-color: #d6d9dc;
}

.k-coloreditor .k-colorgradient:focus,
.k-coloreditor .k-colorgradient.k-focus {
    box-shadow: none;
    outline-color: rgba(0, 0, 0, 0.3);
}

.k-color-picker, .k-colorpicker {
    width: min-content;
}

.k-datetime-selector {
    display: flex;
    transition: transform .2s;
}

.k-datetime-wrap {
    width: calc(304px + 2rem);
    overflow: hidden;
}

.k-datetime-wrap .k-datetime-buttongroup {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-datetime-wrap .k-calendar,
.k-datetime-wrap .k-timeselector {
    width: 100%;
    border-width: 0;
}

.k-datetime-calendar-wrap,
.k-datetime-time-wrap {
    text-align: center;
    flex: 0 0 calc(304px + 2rem);
}

.k-date-tab .k-datetime-selector {
    transform: translateX(0);
}

.k-time-tab .k-datetime-selector {
    transform: translateX(-100%);
}

.k-time-tab .k-datetime-selector.k-rtl, .k-time-tab .k-datetime-selector[dir="rtl"],
.k-rtl .k-time-tab .k-datetime-selector,
[dir="rtl"] .k-time-tab .k-datetime-selector {
    transform: translateX(100%);
}

.k-daterange-picker, .k-daterangepicker {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    gap: 0.5rem;
}

.k-daterange-picker *, .k-daterangepicker *,
.k-daterange-picker *::before,
.k-daterangepicker *::before,
.k-daterange-picker *::after,
.k-daterangepicker *::after {
    box-sizing: border-box;
}

.k-daterange-picker .k-dateinput, .k-daterangepicker .k-dateinput {
    width: 10em;
}

.k-daterangepicker-wrap {
    display: inherit;
    flex-flow: inherit;
    align-items: inherit;
    gap: inherit;
}

.k-dropdowngrid-popup {
    overflow: hidden;
}

.k-dropdowngrid-popup > .k-data-table {
    border-width: 0;
}

.k-dropdown-operator {
    width: min-content;
    flex: none;
}

.k-dropdown-operator .k-input-button {
    border-width: 0;
    width: min-content;
}

.k-dropdown-operator .k-input-button .k-button-icon {
    width: auto;
    aspect-ratio: 1;
}

.k-dropdown-operator .k-input-inner {
    display: none;
}

.k-treeview {
    padding: 0;
    border-width: 0;
    background: none;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: block;
    cursor: default;
    overflow: auto;
    white-space: nowrap;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-treeview *,
.k-treeview *::before,
.k-treeview *::after {
    box-sizing: border-box;
}

.k-treeview-filter {
    padding: 0.5rem;
    display: block;
    position: relative;
    flex: none;
}

.k-treeview-group {
    margin: 0;
    padding: 0;
    list-style: none;
    position: relative;
    outline: 0;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-treeview-group.ng-animating {
    overflow: hidden;
}

.k-treeview-top,
.k-treeview-mid,
.k-treeview-bot {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
}

.k-treeview-item {
    outline-style: none;
    margin: 0;
    padding: 0 0 0 24px;
    border-width: 0;
    display: block;
}

.k-treeview-toggle {
    margin-inline-start: -24px;
    flex: none;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    cursor: pointer;
}

.k-treeview-toggle .k-icon {
    padding: 0.25rem;
    box-sizing: content-box;
}

.k-treeview-loading {
    margin-right: 0.5rem;
}

.k-treeview .k-checkbox-wrap,
.k-treeview .k-checkbox-wrapper {
    align-self: center;
}

.k-treeview-leaf {
    border-radius: 0.25rem;
    padding-block: 0.25rem;
    padding-inline: 0.75rem;
    border: 0px solid transparent;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    align-content: center;
    vertical-align: middle;
    position: relative;
}

.k-treeview-leaf .k-icon,
.k-treeview-leaf .k-image,
.k-treeview-leaf .k-sprite {
    margin-right: 0.5rem;
}

.k-treeview-leaf.k-focus {
    z-index: 1;
}

.k-treeview .k-treeview-load-more-button {
    cursor: pointer;
}

.k-treeview .k-treeview-load-more-button:hover, .k-treeview .k-treeview-load-more-button.k-hover, .k-treeview .k-treeview-load-more-button:focus, .k-treeview .k-treeview-load-more-button.k-focus {
    text-decoration: underline;
}

.k-rtl .k-treeview .k-treeview-item,
[dir="rtl"] .k-treeview .k-treeview-item,
.k-treeview.k-rtl .k-treeview-item,
.k-treeview[dir="rtl"] .k-treeview-item {
    padding-left: 0;
    padding-right: 24px;
}

.k-rtl .k-treeview .k-treeview-loading,
[dir="rtl"] .k-treeview .k-treeview-loading,
.k-treeview.k-rtl .k-treeview-loading,
.k-treeview[dir="rtl"] .k-treeview-loading {
    margin-right: 0;
    margin-left: 0.5rem;
}

.k-rtl .k-treeview .k-treeview-leaf .k-icon,
.k-rtl .k-treeview .k-treeview-leaf .k-image,
.k-rtl .k-treeview .k-treeview-leaf .k-sprite,
.k-rtl .k-treeview .k-in .k-icon,
.k-rtl .k-treeview .k-in .k-image,
.k-rtl .k-treeview .k-in .k-sprite,
[dir="rtl"] .k-treeview .k-treeview-leaf .k-icon,
[dir="rtl"] .k-treeview .k-treeview-leaf .k-image,
[dir="rtl"] .k-treeview .k-treeview-leaf .k-sprite,
[dir="rtl"] .k-treeview .k-in .k-icon,
[dir="rtl"] .k-treeview .k-in .k-image,
[dir="rtl"] .k-treeview .k-in .k-sprite,
.k-treeview.k-rtl .k-treeview-leaf .k-icon,
.k-treeview.k-rtl .k-treeview-leaf .k-image,
.k-treeview.k-rtl .k-treeview-leaf .k-sprite,
.k-treeview.k-rtl .k-in .k-icon,
.k-treeview.k-rtl .k-in .k-image,
.k-treeview.k-rtl .k-in .k-sprite,
.k-treeview[dir="rtl"] .k-treeview-leaf .k-icon,
.k-treeview[dir="rtl"] .k-treeview-leaf .k-image,
.k-treeview[dir="rtl"] .k-treeview-leaf .k-sprite,
.k-treeview[dir="rtl"] .k-in .k-icon,
.k-treeview[dir="rtl"] .k-in .k-image,
.k-treeview[dir="rtl"] .k-in .k-sprite {
    margin-right: 0;
    margin-left: 0.5rem;
}

.k-treeview-sm {
    font-size: 0.875rem;
    line-height: 1.4285714286;
}

.k-treeview-sm .k-treeview-leaf {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
}

.k-treeview-sm .k-checkbox-wrap {
    padding-block: 0.125rem;
    padding-inline: 0.25rem;
}

.k-treeview-md {
    font-size: 1rem;
    line-height: 1.5;
}

.k-treeview-md .k-treeview-leaf {
    padding-block: 0.25rem;
    padding-inline: 0.75rem;
}

.k-treeview-md .k-checkbox-wrap {
    padding-inline: 0.25rem;
}

.k-treeview-lg {
    font-size: 1rem;
    line-height: 1.5;
}

.k-treeview-lg .k-treeview-leaf {
    padding-block: 0.5rem;
    padding-inline: 0.75rem;
}

.k-treeview-lg .k-checkbox-wrap {
    padding-inline: 0.25rem;
}

.k-treeview-leaf {
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.k-treeview {
    color: #212529;
}

.k-treeview-leaf:hover, .k-treeview-leaf.k-hover {
    border-color: #e9ecef;
    color: #212529;
    background-color: #e9ecef;
}

.k-treeview-leaf:focus, .k-treeview-leaf.k-focus {
    box-shadow: inset 0 0 0 2px rgba(33, 37, 41, 0.15);
}

.k-treeview-leaf.k-selected {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-treeview .k-treeview-load-more-button {
    color: #0d6efd;
    background-color: transparent;
}

.k-treeview .k-treeview-load-more-button:hover, .k-treeview .k-treeview-load-more-button.k-hover {
    color: #0a58ca;
    background-color: transparent;
}

.k-treeview .k-treeview-load-more-button:focus, .k-treeview .k-treeview-load-more-button.k-focus {
    color: #0a58ca;
    background-color: transparent;
    box-shadow: inset 0 0 0 2px rgba(33, 37, 41, 0.15);
}

.k-popup-dropdowntree .k-treeview,
.k-dropdowntree-popup .k-treeview,
.k-multiselecttree-popup .k-treeview {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-popup-dropdowntree .k-check-all,
.k-dropdowntree-popup .k-check-all,
.k-multiselecttree-popup .k-check-all {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-multiselecttree .k-input-values {
    width: auto;
    max-width: 100%;
}

.k-multiselecttree .k-input-inner::before {
    content: "\\200b";
    width: 0px;
    overflow: hidden;
    flex: none;
    display: inline-block;
    vertical-align: top;
}

.k-rating {
    margin: 0;
    padding: 0;
    border-width: 0;
    box-sizing: border-box;
    outline: 0;
    background: none;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: inline-flex;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-rating *,
.k-rating *::before,
.k-rating *::after {
    box-sizing: border-box;
}

.k-rating.k-readonly {
    pointer-events: none;
}

.k-rating-container {
    flex: 0 1 auto;
    position: relative;
    margin-block: 0;
    margin-inline: 0.5rem;
}

.k-rating-container .k-rating-item {
    display: inline-flex;
    position: relative;
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    align-items: center;
    vertical-align: middle;
    margin: 0;
    outline: 0;
    overflow: hidden;
    transition: color 200ms ease-out 0s;
}

.k-rating-container .k-rating-item * {
    pointer-events: none;
}

.k-rating-container .k-rating-item .k-rating-precision-part,
.k-rating-container .k-rating-item .k-rating-precision-complement {
    display: inherit;
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    overflow: hidden;
}

.k-rating-container .k-rating-item .k-rating-precision-complement {
    direction: rtl;
}

.k-rating-container .k-rating-item svg {
    fill: currentColor;
}

.k-rating-label {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    line-height: 2;
    margin-block: 0.5rem;
    margin-inline: 1rem;
}

.k-rtl .k-rating-precision-part,
[dir="rtl"] .k-rating-precision-part {
    left: auto;
    right: 0.5rem;
}

.k-rtl .k-rating-item .k-rating-precision-complement,
[dir="rtl"] .k-rating-item .k-rating-precision-complement {
    direction: ltr;
}

.k-rating {
    color: #212529;
}

.k-rating:focus .k-rating-item > .k-icon, .k-rating.k-focus .k-rating-item > .k-icon {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.k-rating:focus .k-rating-item.k-selected > .k-icon, .k-rating.k-focus .k-rating-item.k-selected > .k-icon {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.k-rating-item {
    color: #6c757d;
}

.k-rating-item.k-selected {
    color: #0d6efd;
}

.k-rating-item.k-selected:focus, .k-rating-item.k-selected.k-focus {
    color: #0d6efd;
}

.k-rating-item:hover, .k-rating-item.k-hover {
    color: #0d6efd;
    cursor: pointer;
}

.k-switch {
    box-sizing: border-box;
    outline: 0;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    line-height: 1;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-switch *,
.k-switch *::before,
.k-switch *::after {
    box-sizing: border-box;
}

.k-switch [type="checkbox"] {
    display: none;
}

.k-switch[aria-readonly="true"] {
    pointer-events: none;
}

.k-switch.k-readonly {
    pointer-events: none;
}

.k-switch-track {
    border-width: 1px;
    border-style: solid;
    outline: 0;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 0 auto;
    position: relative;
    transition: background-color 200ms ease-in-out;
}

.k-switch-thumb-wrap {
    width: 0;
    height: 0;
    overflow: visible;
    position: absolute;
    transition: left 200ms ease-in-out;
    top: 50%;
}

.k-switch-thumb {
    display: block;
    position: absolute;
    transform: translate(-50%, -50%);
}

.k-switch-label-on,
.k-switch-label-off {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;
}

.k-switch-sm {
    width: 48px;
    height: 26px;
}

.k-switch-sm .k-switch-track {
    width: 48px;
    height: 26px;
}

.k-switch-sm .k-switch-thumb {
    width: 20px;
    height: 20px;
}

.k-switch-sm.k-switch-on .k-switch-thumb-wrap {
    left: calc(100% - 13px);
}

.k-switch-sm.k-switch-off .k-switch-thumb-wrap {
    left: 13px;
}

.k-switch-sm[dir="rtl"] .k-switch-label-on,
[dir="rtl"] .k-switch-sm .k-switch-label-on,
.k-rtl .k-switch-sm .k-switch-label-on {
    left: auto;
}

.k-switch-sm[dir="rtl"] .k-switch-label-off,
[dir="rtl"] .k-switch-sm .k-switch-label-off,
.k-rtl .k-switch-sm .k-switch-label-off {
    right: auto;
}

.k-switch-sm[dir="rtl"].k-switch-on .k-switch-thumb-wrap,
[dir="rtl"] .k-switch-sm.k-switch-on .k-switch-thumb-wrap,
.k-rtl .k-switch-sm.k-switch-on .k-switch-thumb-wrap {
    left: 13px;
}

.k-switch-sm[dir="rtl"].k-switch-off .k-switch-thumb-wrap,
[dir="rtl"] .k-switch-sm.k-switch-off .k-switch-thumb-wrap,
.k-rtl .k-switch-sm.k-switch-off .k-switch-thumb-wrap {
    left: calc(100% - 13px);
}

.k-switch-md {
    width: 56px;
    height: 30px;
}

.k-switch-md .k-switch-track {
    width: 56px;
    height: 30px;
}

.k-switch-md .k-switch-thumb {
    width: 24px;
    height: 24px;
}

.k-switch-md.k-switch-on .k-switch-thumb-wrap {
    left: calc(100% - 15px);
}

.k-switch-md.k-switch-off .k-switch-thumb-wrap {
    left: 15px;
}

.k-switch-md[dir="rtl"] .k-switch-label-on,
[dir="rtl"] .k-switch-md .k-switch-label-on,
.k-rtl .k-switch-md .k-switch-label-on {
    left: auto;
}

.k-switch-md[dir="rtl"] .k-switch-label-off,
[dir="rtl"] .k-switch-md .k-switch-label-off,
.k-rtl .k-switch-md .k-switch-label-off {
    right: auto;
}

.k-switch-md[dir="rtl"].k-switch-on .k-switch-thumb-wrap,
[dir="rtl"] .k-switch-md.k-switch-on .k-switch-thumb-wrap,
.k-rtl .k-switch-md.k-switch-on .k-switch-thumb-wrap {
    left: 15px;
}

.k-switch-md[dir="rtl"].k-switch-off .k-switch-thumb-wrap,
[dir="rtl"] .k-switch-md.k-switch-off .k-switch-thumb-wrap,
.k-rtl .k-switch-md.k-switch-off .k-switch-thumb-wrap {
    left: calc(100% - 15px);
}

.k-switch-lg {
    width: 64px;
    height: 34px;
}

.k-switch-lg .k-switch-track {
    width: 64px;
    height: 34px;
}

.k-switch-lg .k-switch-thumb {
    width: 28px;
    height: 28px;
}

.k-switch-lg.k-switch-on .k-switch-thumb-wrap {
    left: calc(100% - 17px);
}

.k-switch-lg.k-switch-off .k-switch-thumb-wrap {
    left: 17px;
}

.k-switch-lg[dir="rtl"] .k-switch-label-on,
[dir="rtl"] .k-switch-lg .k-switch-label-on,
.k-rtl .k-switch-lg .k-switch-label-on {
    left: auto;
}

.k-switch-lg[dir="rtl"] .k-switch-label-off,
[dir="rtl"] .k-switch-lg .k-switch-label-off,
.k-rtl .k-switch-lg .k-switch-label-off {
    right: auto;
}

.k-switch-lg[dir="rtl"].k-switch-on .k-switch-thumb-wrap,
[dir="rtl"] .k-switch-lg.k-switch-on .k-switch-thumb-wrap,
.k-rtl .k-switch-lg.k-switch-on .k-switch-thumb-wrap {
    left: 17px;
}

.k-switch-lg[dir="rtl"].k-switch-off .k-switch-thumb-wrap,
[dir="rtl"] .k-switch-lg.k-switch-off .k-switch-thumb-wrap,
.k-rtl .k-switch-lg.k-switch-off .k-switch-thumb-wrap {
    left: calc(100% - 17px);
}

.k-switch[dir="rtl"] .k-switch-thumb,
[dir="rtl"] .k-switch .k-switch-thumb,
.k-switch.k-rtl .k-switch-thumb,
.k-rtl .k-switch .k-switch-thumb {
    transform: translate(50%, -50%);
}

.k-switch.k-disabled {
    opacity: 1;
    filter: none;
}

.k-switch-off .k-switch-track {
    border-color: #adb5bd;
    background-color: #ffffff;
}

.k-switch-off .k-switch-thumb {
    background-color: #adb5bd;
}

.k-switch-off:focus .k-switch-track, .k-switch-off.k-focus .k-switch-track {
    border-color: #86b7fe;
    outline: 0.25rem solid rgba(13, 110, 253, 0.25);
}

.k-switch-off:disabled .k-switch-track, .k-switch-off.k-disabled .k-switch-track {
    background-color: #e9ecef;
}

.k-switch-off .k-switch-label-on {
    color: transparent;
}

.k-switch-on .k-switch-track {
    border-color: #0d6efd;
    background-color: #0d6efd;
}

.k-switch-on .k-switch-thumb {
    background-color: white;
}

.k-switch-on:focus .k-switch-track, .k-switch-on.k-focus .k-switch-track {
    outline: 0.25rem solid rgba(13, 110, 253, 0.25);
}

.k-switch-on:disabled .k-switch-track, .k-switch-on.k-disabled .k-switch-track {
    background-color: #86b7fe;
}

.k-switch-on .k-switch-label-off {
    color: transparent;
}

.k-external-dropzone {
    height: 220px;
    display: flex;
    flex-flow: row nowrap;
}

.k-dropzone-inner {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    position: relative;
}

.k-dropzone-inner .k-dropzone-icon {
    margin-bottom: 1.5rem;
}

.k-dropzone-inner .k-dropzone-hint {
    margin-bottom: 0.5rem;
}

.k-dropzone-inner .k-dropzone-note {
    font-size: 0.75rem;
}

.k-dropzone-inner {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-dropzone-inner .k-icon,
.k-dropzone-inner .k-dropzone-icon {
    color: #afb1b2;
}

.k-dropzone-inner .k-dropzone-note {
    color: #6c757d;
}

.k-external-dropzone-hover .k-icon,
.k-external-dropzone-hover .k-dropzone-icon {
    color: #0d6efd;
}

.k-upload {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    position: relative;
    display: block;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-upload *,
.k-upload *::before,
.k-upload *::after {
    box-sizing: border-box;
}

.k-upload .k-upload-button {
    min-width: 7em;
}

.k-upload .k-dropzone,
.k-upload .k-upload-dropzone {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 0;
    text-align: end;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    background-color: transparent;
}

.k-upload .k-dropzone .k-dropzone-hint,
.k-upload .k-upload-dropzone .k-dropzone-hint {
    font-style: normal;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    flex: 1;
}

.k-upload .k-dropzone .k-upload-status,
.k-upload .k-upload-dropzone .k-upload-status {
    font-weight: normal;
    display: flex;
    align-items: center;
    position: relative;
}

.k-upload .k-dropzone .k-upload-status > .k-icon,
.k-upload .k-upload-dropzone .k-upload-status > .k-icon {
    margin-inline-end: 0.5rem;
}

.k-upload .k-dropzone .k-upload-status + .k-dropzone-hint,
.k-upload .k-upload-dropzone .k-upload-status + .k-dropzone-hint {
    display: none;
}

.k-upload .k-dropzone-active .k-upload-status {
    display: none;
}

.k-upload .k-dropzone-active .k-upload-status + .k-dropzone-hint {
    display: block;
}

.k-upload .k-upload-files {
    max-height: 300px;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: inherit;
    list-style: none;
}

.k-upload .k-upload-files .k-file-multiple,
.k-upload .k-upload-files .k-file-single {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.k-upload .k-upload-files .k-file-single {
    align-items: center;
}

.k-upload .k-upload-files .k-file-multiple {
    align-items: flex-start;
}

.k-upload .k-upload-files .k-file {
    padding: 1rem 1rem calc(1rem + 2px);
    border-width: 0 0 1px;
    border-style: solid;
    outline: none;
    display: flex;
    align-items: flex-start;
    position: relative;
}

.k-upload .k-upload-files .k-file:last-child {
    border-width: 0;
}

.k-upload .k-upload-files .k-filename {
    margin-left: 1rem;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
}

.k-upload .k-upload-files .k-upload-pct {
    margin-block: 0;
    margin-inline: 0.5rem;
    font-weight: normal;
    vertical-align: middle;
}

.k-upload .k-upload-files ~ .k-clear-selected,
.k-upload .k-upload-files ~ .k-upload-selected {
    margin-top: -0.5rem;
    border-width: 0;
}

.k-upload .k-upload-files ~ .k-upload-selected {
    border-left-width: 1px;
    border-left-style: solid;
    margin-left: -1px;
}

.k-upload .k-upload-files .k-file-name,
.k-upload .k-upload-files .k-file-size,
.k-upload .k-upload-files .k-file-validation-message,
.k-upload .k-upload-files .k-file-summary {
    display: block;
}

.k-upload .k-upload-files .k-file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
}

.k-upload .k-upload-files .k-file-size,
.k-upload .k-upload-files .k-file-summary,
.k-upload .k-upload-files .k-file-validation-message {
    font-size: 11px;
    line-height: 1;
}

.k-upload .k-upload-files .k-file-icon-wrapper .k-file-state {
    position: absolute;
}

.k-upload .k-upload-files .k-file-state {
    visibility: hidden;
}

.k-upload .k-upload-files .k-file-info {
    min-height: 32px;
    display: block;
    overflow: hidden;
    flex: 1 0 0;
}

.k-upload .k-multiple-files-wrapper,
.k-upload .k-file-single > .k-file-info {
    margin-inline-start: 1rem;
    min-height: 32px;
    display: block;
    overflow: hidden;
    flex: 1 0 0;
}

.k-upload .k-multiple-files-wrapper .k-file-info {
    margin-bottom: 12px;
    display: block;
}

.k-upload .k-multiple-files-wrapper .k-file-summary {
    margin-top: -4px;
}

.k-upload .k-progressbar {
    --kendo-progressbar-height: 2px;
    position: absolute;
    left: 1rem;
    right: 1rem;
    bottom: 0.5rem;
    width: auto;
}

.k-upload .k-actions, .k-upload .k-edit-buttons,
.k-upload .k-action-buttons,
.k-upload .k-columnmenu-actions, .k-upload .k-form-buttons {
    border-top-width: 1px;
}

.k-upload-button-wrap {
    position: relative;
    direction: ltr;
}

.k-upload-button-wrap input {
    font: 170px monospace !important;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
}

.k-upload-button-wrap input[disabled],
.k-upload-button-wrap input.k-disabled {
    visibility: hidden;
}

.k-upload {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-upload .k-dropzone,
.k-upload .k-upload-dropzone {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-upload .k-dropzone.k-hover,
.k-upload .k-upload-dropzone.k-hover {
    background-color: #f4f5f6;
}

.k-upload .k-dropzone .k-dropzone-hint,
.k-upload .k-upload-dropzone .k-dropzone-hint {
    color: #6c757d;
}

.k-upload .k-upload-files,
.k-upload .k-file {
    border-color: #dee2e6;
}

.k-upload .k-file.k-focus {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13);
}

.k-upload .k-file .k-upload-action.k-focus {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13);
}

.k-upload .k-upload-status {
    color: #6c757d;
}

.k-upload .k-file-progress .k-progressbar .k-selected {
    background-color: #0dcaf0;
}

.k-upload .k-file-success .k-file-validation-message {
    color: #198754;
}

.k-upload .k-file-success .k-progressbar .k-selected {
    background-color: #198754;
}

.k-upload .k-file-error .k-file-validation-message {
    color: #dc3545;
}

.k-upload .k-file-error .k-progressbar .k-selected {
    background-color: #dc3545;
}

.k-upload .k-file-icon-wrapper {
    color: #6c757d;
    border-color: #6c757d;
}

.k-upload .k-file-size,
.k-upload .k-file-validation-message,
.k-upload .k-file-summary {
    color: #6c757d;
}

.k-upload .k-multiple-files-wrapper .k-file-summary {
    color: #212529;
}

.k-upload.k-invalid, .k-upload.ng-invalid.ng-touched, .k-upload.ng-invalid.ng-dirty {
    border-color: #dc3545;
}

.k-appbar {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    list-style: none;
    display: flex;
    gap: 0.5rem;
    flex-flow: row wrap;
    align-items: center;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-appbar *,
.k-appbar *::before,
.k-appbar *::after {
    box-sizing: border-box;
}

.k-appbar > * {
    flex-shrink: 0;
}

.k-appbar .k-appbar-section {
    display: inline-flex;
    flex-wrap: nowrap;
    align-items: center;
}

.k-appbar .k-appbar-spacer {
    flex: 1 0 auto;
}

.k-appbar .k-appbar-spacer-sized {
    flex-grow: 0;
}

.k-appbar .k-appbar-separator {
    margin: 0;
    width: 0;
    min-height: 1em;
    border-style: solid;
    border-width: 0 0 0 1px;
    display: inline-block;
}

.k-appbar .k-input,
.k-appbar .k-picker {
    width: 10em;
}

.k-appbar .k-color-picker, .k-appbar .k-colorpicker {
    width: min-content;
}

.k-appbar-static {
    position: static;
}

.k-appbar-sticky {
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 1000;
}

.k-appbar-fixed {
    width: 100%;
    position: fixed;
    z-index: 1;
}

.k-appbar-top {
    top: 0;
    bottom: auto;
}

.k-appbar-bottom {
    top: auto;
    bottom: 0;
}

.k-appbar-bottom.k-appbar-fixed {
    bottom: 0;
}

.k-appbar {
    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));
}

.k-appbar-bottom {
    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));
}

.k-appbar-primary {
    color: white;
    background-color: #0d6efd;
}

.k-appbar-secondary {
    color: white;
    background-color: #6c757d;
}

.k-appbar-tertiary {
    color: white;
    background-color: #6f42c1;
}

.k-appbar-info {
    color: white;
    background-color: #0dcaf0;
}

.k-appbar-success {
    color: white;
    background-color: #198754;
}

.k-appbar-warning {
    color: black;
    background-color: #ffc107;
}

.k-appbar-error {
    color: white;
    background-color: #dc3545;
}

.k-appbar-dark {
    color: white;
    background-color: #212529;
}

.k-appbar-light {
    color: black;
    background-color: #f8f9fa;
}

.k-appbar-inverse {
    color: white;
    background-color: #212529;
}

.k-fab {
    padding: 0;
    border-width: 0;
    border-style: solid;
    border-color: transparent;
    box-sizing: border-box;
    color: inherit;
    background-color: transparent;
    font-size: 1rem;
    line-height: 1.5;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    text-align: center;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    outline: none;
}

.k-fab *,
.k-fab *::before,
.k-fab *::after {
    box-sizing: border-box;
}

.k-fab:focus {
    outline: none;
}

.k-fab-icon {
    padding-inline: 0.25rem;
    padding-block: 0.25rem;
    box-sizing: content-box;
}

.k-icon-wrapper-host:not(:only-child) .k-fab-icon, .k-fab-icon:not(:only-child) {
    margin-inline-end: 0.125rem;
    margin-inline-start: -0.125rem;
}

.k-fab-sm {
    padding: 0.5rem 0.5rem;
}

.k-fab-md {
    padding: 1rem 1rem;
}

.k-fab-lg {
    padding: 1.5rem 1.5rem;
}

.k-fab-items {
    margin: 0;
    padding-block: 1rem;
    padding-inline: 0px;
    display: flex;
}

.k-fab-items-bottom {
    flex-direction: column;
}

.k-fab-items-bottom .k-fab-item:last-child {
    margin-block-end: 0;
}

.k-fab-items-top {
    flex-direction: column-reverse;
}

.k-fab-items-top .k-fab-item:first-child {
    margin-block-end: 0;
}

.k-fab-item {
    list-style-type: none;
    margin-block-end: 0.5rem;
    outline: none;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
}

.k-fab-item.k-text-right {
    flex-direction: row;
}

.k-fab-item.k-text-right .k-fab-item-text {
    margin-right: 0.5rem;
}

.k-fab-item.k-text-left {
    flex-direction: row-reverse;
}

.k-fab-item.k-text-left .k-fab-item-text {
    margin-left: 0.5rem;
}

.k-fab-item-text {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    border-width: 1px;
    border-radius: 4px;
    font-size: 0.75rem;
    line-height: 14px;
}

.k-fab-item-icon {
    padding-block: 0.75rem;
    padding-inline: 0.75rem;
    border-width: 0;
    border-radius: 50%;
    box-sizing: content-box;
    outline: none;
}

.k-rtl .k-fab-popup .k-fab-item.k-text-left,
[dir="rtl"] .k-fab-popup .k-fab-item.k-text-left {
    flex-direction: row;
}

.k-rtl .k-fab-popup .k-fab-item.k-text-right,
[dir="rtl"] .k-fab-popup .k-fab-item.k-text-right {
    flex-direction: row-reverse;
}

.k-fab-solid-primary {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #0d6efd;
    outline-offset: -1px;
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-fab-solid-secondary {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #6c757d;
    outline-offset: -1px;
    border-color: #6c757d;
    color: white;
    background-color: #6c757d;
}

.k-fab-solid-tertiary {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #6f42c1;
    outline-offset: -1px;
    border-color: #6f42c1;
    color: white;
    background-color: #6f42c1;
}

.k-fab-solid-info {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #0dcaf0;
    outline-offset: -1px;
    border-color: #0dcaf0;
    color: black;
    background-color: #0dcaf0;
}

.k-fab-solid-success {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #198754;
    outline-offset: -1px;
    border-color: #198754;
    color: white;
    background-color: #198754;
}

.k-fab-solid-warning {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #ffc107;
    outline-offset: -1px;
    border-color: #ffc107;
    color: black;
    background-color: #ffc107;
}

.k-fab-solid-error {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #dc3545;
    outline-offset: -1px;
    border-color: #dc3545;
    color: white;
    background-color: #dc3545;
}

.k-fab-solid-dark {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #212529;
    outline-offset: -1px;
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-fab-solid-light {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #f8f9fa;
    outline-offset: -1px;
    border-color: #f8f9fa;
    color: black;
    background-color: #f8f9fa;
}

.k-fab-solid-inverse {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #212529;
    outline-offset: -1px;
    border-color: #212529;
    color: white;
    background-color: #212529;
}

.k-fab-solid-primary:hover,
.k-fab-solid-primary.k-hover {
    border-color: #0257d5;
    color: white;
    background-color: #025ce2;
}

.k-fab-solid-secondary:hover,
.k-fab-solid-secondary.k-hover {
    border-color: #545b62;
    color: white;
    background-color: #5a6268;
}

.k-fab-solid-tertiary:hover,
.k-fab-solid-tertiary.k-hover {
    border-color: #59339d;
    color: white;
    background-color: #5e37a6;
}

.k-fab-solid-info:hover,
.k-fab-solid-info.k-hover {
    border-color: #0aa1c0;
    color: black;
    background-color: #0babcc;
}

.k-fab-solid-success:hover,
.k-fab-solid-success.k-hover {
    border-color: #115c39;
    color: white;
    background-color: #136740;
}

.k-fab-solid-warning:hover,
.k-fab-solid-warning.k-hover {
    border-color: #d39e00;
    color: black;
    background-color: #e0a800;
}

.k-fab-solid-error:hover,
.k-fab-solid-error.k-hover {
    border-color: #bd2130;
    color: white;
    background-color: #c82333;
}

.k-fab-solid-dark:hover,
.k-fab-solid-dark.k-hover {
    border-color: #0a0c0d;
    color: white;
    background-color: #101214;
}

.k-fab-solid-light:hover,
.k-fab-solid-light.k-hover {
    border-color: #dae0e5;
    color: black;
    background-color: #e2e6ea;
}

.k-fab-solid-inverse:hover,
.k-fab-solid-inverse.k-hover {
    border-color: #0a0c0d;
    color: white;
    background-color: #101214;
}

.k-fab-solid-primary:focus,
.k-fab-solid-primary.k-focus {
    outline: 3px solid rgba(13, 110, 253, 0.5);
}

.k-fab-solid-secondary:focus,
.k-fab-solid-secondary.k-focus {
    outline: 3px solid rgba(108, 117, 125, 0.5);
}

.k-fab-solid-tertiary:focus,
.k-fab-solid-tertiary.k-focus {
    outline: 3px solid rgba(111, 66, 193, 0.5);
}

.k-fab-solid-info:focus,
.k-fab-solid-info.k-focus {
    outline: 3px solid rgba(13, 202, 240, 0.5);
}

.k-fab-solid-success:focus,
.k-fab-solid-success.k-focus {
    outline: 3px solid rgba(25, 135, 84, 0.5);
}

.k-fab-solid-warning:focus,
.k-fab-solid-warning.k-focus {
    outline: 3px solid rgba(255, 193, 7, 0.5);
}

.k-fab-solid-error:focus,
.k-fab-solid-error.k-focus {
    outline: 3px solid rgba(220, 53, 69, 0.5);
}

.k-fab-solid-dark:focus,
.k-fab-solid-dark.k-focus {
    outline: 3px solid rgba(33, 37, 41, 0.5);
}

.k-fab-solid-light:focus,
.k-fab-solid-light.k-focus {
    outline: 3px solid rgba(248, 249, 250, 0.5);
}

.k-fab-solid-inverse:focus,
.k-fab-solid-inverse.k-focus {
    outline: 3px solid rgba(33, 37, 41, 0.5);
}

.k-fab-solid-primary:active,
.k-fab-solid-primary.k-active,
.k-fab-solid-primary.k-selected {
    border-color: #0252c9;
    color: white;
    background-color: #0257d5;
}

.k-fab-solid-secondary:active,
.k-fab-solid-secondary.k-active,
.k-fab-solid-secondary.k-selected {
    border-color: #4e555b;
    color: white;
    background-color: #545b62;
}

.k-fab-solid-tertiary:active,
.k-fab-solid-tertiary.k-active,
.k-fab-solid-tertiary.k-selected {
    border-color: #533093;
    color: white;
    background-color: #59339d;
}

.k-fab-solid-info:active,
.k-fab-solid-info.k-active,
.k-fab-solid-info.k-selected {
    border-color: #0a97b4;
    color: black;
    background-color: #0aa1c0;
}

.k-fab-solid-success:active,
.k-fab-solid-success.k-active,
.k-fab-solid-success.k-selected {
    border-color: #0f5133;
    color: white;
    background-color: #115c39;
}

.k-fab-solid-warning:active,
.k-fab-solid-warning.k-active,
.k-fab-solid-warning.k-selected {
    border-color: #c69500;
    color: black;
    background-color: #d39e00;
}

.k-fab-solid-error:active,
.k-fab-solid-error.k-active,
.k-fab-solid-error.k-selected {
    border-color: #b21f2d;
    color: white;
    background-color: #bd2130;
}

.k-fab-solid-dark:active,
.k-fab-solid-dark.k-active,
.k-fab-solid-dark.k-selected {
    border-color: #050506;
    color: white;
    background-color: #0a0c0d;
}

.k-fab-solid-light:active,
.k-fab-solid-light.k-active,
.k-fab-solid-light.k-selected {
    border-color: #d3d9df;
    color: black;
    background-color: #dae0e5;
}

.k-fab-solid-inverse:active,
.k-fab-solid-inverse.k-active,
.k-fab-solid-inverse.k-selected {
    border-color: #050506;
    color: white;
    background-color: #0a0c0d;
}

.k-fab-solid-primary:disabled,
.k-fab-solid-primary.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #64a2fe;
    color: white;
    opacity: 1;
}

.k-fab-solid-secondary:disabled,
.k-fab-solid-secondary.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #a1a7ac;
    color: white;
    opacity: 1;
}

.k-fab-solid-tertiary:disabled,
.k-fab-solid-tertiary.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #a386d7;
    color: white;
    opacity: 1;
}

.k-fab-solid-info:disabled,
.k-fab-solid-info.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #64ddf5;
    color: #666666;
    opacity: 1;
}

.k-fab-solid-success:disabled,
.k-fab-solid-success.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #6cb292;
    color: white;
    opacity: 1;
}

.k-fab-solid-warning:disabled,
.k-fab-solid-warning.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #ffd760;
    color: #666666;
    opacity: 1;
}

.k-fab-solid-error:disabled,
.k-fab-solid-error.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #e97e88;
    color: white;
    opacity: 1;
}

.k-fab-solid-dark:disabled,
.k-fab-solid-dark.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #717376;
    color: white;
    opacity: 1;
}

.k-fab-solid-light:disabled,
.k-fab-solid-light.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #fbfbfc;
    color: #666666;
    opacity: 1;
}

.k-fab-solid-inverse:disabled,
.k-fab-solid-inverse.k-disabled {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: #717376;
    color: white;
    opacity: 1;
}

.k-fab-item-text {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
}

.k-fab-item-icon {
    border-color: #e4e7eb;
    color: #212529;
    background-color: #e4e7eb;
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #e4e7eb;
    outline-offset: -1px;
}

.k-fab-item:hover .k-fab-item-icon,
.k-fab-item.k-hover .k-fab-item-icon {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    outline: 1px solid #c7cdd5;
    outline-offset: -1px;
    border-color: #c7cdd5;
    color: black;
    background-color: #ced3db;
}

.k-fab-item:focus .k-fab-item-text,
.k-fab-item.k-focus .k-fab-item-text,
.k-fab-item:focus .k-fab-item-icon,
.k-fab-item.k-focus .k-fab-item-icon {
    outline: 3px solid rgba(228, 231, 235, 0.5);
}

.k-fab-item:active .k-fab-item-icon,
.k-fab-item.k-active .k-fab-item-icon {
    outline: 1px solid #bfc6d0;
    outline-offset: -1px;
    border-color: #bfc6d0;
    color: black;
    background-color: #c7cdd5;
}

.k-fab-item:disabled,
.k-fab-item.k-disabled {
    opacity: 1;
}

.k-fab-item:disabled .k-fab-item-text,
.k-fab-item:disabled .k-fab-item-icon,
.k-fab-item.k-disabled .k-fab-item-text,
.k-fab-item.k-disabled .k-fab-item-icon {
    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));
    background-color: white;
    color: #afb1b2;
}

.k-fab-popup {
    box-shadow: none;
}

.k-actionsheet-container {
    width: 100%;
    height: 100%;
    max-width: clamp(100vw, 100%, 100%);
    max-height: clamp(100vh, 100%, 100%);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    overflow: hidden;
    transform: translateZ(0);
}

.k-actionsheet-container > .k-overlay {
    position: absolute;
    z-index: 1;
}

.k-actionsheet-container > .k-animation-container {
    width: 100%;
    height: 100%;
    border-radius: 0;
    overflow: hidden;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    pointer-events: none;
}

.k-actionsheet-container > .k-animation-container > .k-child-animation-container {
    position: absolute;
}

.k-actionsheet-container > .k-actionsheet {
    position: absolute;
    z-index: 2;
}

.k-actionsheet-container .k-actionsheet {
    pointer-events: all;
}

.k-actionsheet {
    width: var(--kendo-actionsheet-width, 360px);
    height: var(--kendo-actionsheet-height, 60vh);
    max-width: var(--kendo-actionsheet-max-width, 100%);
    max-height: var(--kendo-actionsheet-max-height, 60vh);
    border-width: 0;
    border-style: solid;
    border-color: transparent;
    box-sizing: border-box;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    overflow: hidden;
    position: relative;
}

.k-actionsheet *,
.k-actionsheet *::before,
.k-actionsheet *::after {
    box-sizing: border-box;
}

.k-actionsheet-titlebar, .k-actionsheet-jq .k-actionsheet-header {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    border-width: 0;
    border-style: solid;
    border-color: transparent;
    flex: none;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    gap: 1rem;
}

.k-actionsheet-titlebar-group {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 100%;
}

.k-actionsheet-title {
    flex: 1;
}

.k-actionsheet-subtitle {
    font-size: 0.875rem;
    line-height: 1.25;
}

.k-actionsheet-actions {
    flex: none;
}

.k-actionsheet-content {
    flex: 1;
    overflow: auto;
    position: relative;
}

.k-actionsheet-footer {
    flex: none;
}

.k-actionsheet-items {
    margin: 0;
    padding: 0;
    list-style: none;
    flex: none;
}

.k-actionsheet-item {
    padding: 0;
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    outline: none;
}

.k-actionsheet-action {
    margin: 0;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    min-height: 40px;
    box-sizing: border-box;
    color: inherit;
    text-decoration: none;
    outline: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    gap: 12px;
}

.k-actionsheet-item-text {
    display: flex;
    flex-flow: column nowrap;
}

.k-actionsheet-item-description {
    font-size: 0.875em;
}

.k-actionsheet .k-hr {
    margin: 0;
    flex: none;
}

.k-actionsheet-top {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-width: 0px;
    border-top-width: 0;
    top: 0;
    inset-inline-start: 50%;
    transform: translateX(-50%);
}

.k-actionsheet-bottom {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-width: 0px;
    border-bottom-width: 0;
    bottom: 0;
    inset-inline-start: 50%;
    transform: translateX(-50%);
}

.k-actionsheet-left {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-width: 0px;
    border-left-width: 0;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}

.k-actionsheet-right {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-width: 0px;
    border-right-width: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}

.k-actionsheet-fullscreen {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
}

.k-animation-container > .k-actionsheet {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
    transform: none;
}

.k-adaptive-actionsheet {
    max-width: 100%;
    width: 100%;
    font-size: 1.25rem;
    display: flex;
    flex-flow: column nowrap;
}

.k-adaptive-actionsheet .k-actionsheet-titlebar, .k-adaptive-actionsheet .k-actionsheet-jq .k-actionsheet-header, .k-actionsheet-jq .k-adaptive-actionsheet .k-actionsheet-header {
    padding-block: 1rem;
    padding-inline: 1rem;
    border-bottom-width: 1px;
}

.k-adaptive-actionsheet .k-actionsheet-content {
    padding-block: 0.5rem;
    padding-inline: 1rem;
}

.k-adaptive-actionsheet .k-actionsheet-footer {
    padding-block: 0.5rem;
    padding-inline: 1rem;
}

.k-adaptive-actionsheet .k-actionsheet-filter {
    width: calc(min(100%, calc( 360px - 2rem) ));
}

.k-adaptive-actionsheet .k-actionsheet-content,
.k-adaptive-actionsheet .k-actionsheet-footer {
    margin-inline: auto;
    width: min(100%, 360px);
}

.k-adaptive-actionsheet .k-list-container,
.k-adaptive-actionsheet .k-treeview {
    height: 100%;
}

.k-adaptive-actionsheet .k-list-filter {
    width: 100%;
    padding-inline: 0;
}

.k-adaptive-actionsheet .k-menu-group {
    height: 100%;
    overflow: auto;
    position: static;
}

.k-adaptive-actionsheet .k-calendar {
    margin-inline: auto;
    border-width: 0;
    display: flex;
}

.k-adaptive-actionsheet .k-timeselector {
    height: 100%;
    border-width: 0;
    overflow: hidden;
}

.k-adaptive-actionsheet .k-timeselector .k-time-part {
    display: contents;
}

.k-adaptive-actionsheet .k-timeselector .k-time-list-wrapper {
    height: 100%;
}

.k-adaptive-actionsheet .k-datetime-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
}

.k-adaptive-actionsheet .k-datetime-selector {
    flex: 1 1 auto;
}

.k-adaptive-actionsheet .k-datetime-calendar-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    flex: 0 0 100%;
}

.k-adaptive-actionsheet .k-datetime-time-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 100%;
    bottom: 0;
    flex: 0 0 100%;
}

.k-adaptive-actionsheet .k-scrollable-wrap {
    height: 100%;
    overflow-y: auto;
}

.k-adaptive-actionsheet .k-data-table {
    max-height: 100%;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
}

.k-actionsheet-jq.k-actionsheet {
    height: auto;
}

.k-actionsheet-jq .k-actionsheet-header {
    align-items: flex-start;
}

.k-actionsheet-jq .k-actionsheet-action {
    align-items: center;
}

.k-rtl .k-actionsheet-top,
.k-rtl .k-actionsheet-bottom,
[dir="rtl"] .k-actionsheet-top,
[dir="rtl"] .k-actionsheet-bottom {
    transform: translateX(50%);
}

.k-actionsheet {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
    box-shadow: var(--kendo-elevation-7, 0px 14px 36px 0px rgba(0, 0, 0, 0.168));
}

.k-actionsheet-subtitle {
    color: #6c757d;
}

.k-actionsheet-item:hover, .k-actionsheet-item.k-hover {
    background-color: #e9ecef;
}

.k-actionsheet-item:focus, .k-actionsheet-item.k-focus {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13);
}

.k-actionsheet-item-description {
    color: #6c757d;
}

.k-actionsheet .k-hr {
    border-color: #dee2e6;
}

.k-adaptive-actionsheet .k-actionsheet-titlebar, .k-adaptive-actionsheet .k-actionsheet-jq .k-actionsheet-header, .k-actionsheet-jq .k-adaptive-actionsheet .k-actionsheet-header {
    border-color: #dee2e6;
}

.k-window {
    border-radius: 0.375rem;
    padding: 0;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: inline-flex;
    flex-direction: column;
    position: absolute;
    z-index: 10002;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-window.k-window-maximized {
    max-width: 100vw;
    max-height: 100vh;
    box-shadow: none;
}

.k-window-sm {
    width: 300px;
}

.k-window-md {
    width: 800px;
}

.k-window-lg {
    width: 1200px;
}

.k-window-titlebar {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
    padding-block: 1rem;
    padding-inline: 1rem;
    border-width: 0 0 1px;
    border-style: solid;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
}

.k-window-minimized .k-window-titlebar {
    border-width: 0;
}

.k-window-title {
    padding-block: .5em;
    padding-inline: 0;
    margin-block: -.5em;
    margin-inline: 0;
    font-size: 1.25rem;
    line-height: 1.5;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
}

.k-window-title::before {
    content: "\\200b";
}

.k-window-titlebar-actions {
    margin-block: -5em;
    margin-inline: 0;
    margin-inline-end: 0rem;
    line-height: 1;
    display: flex;
    gap: 0.5rem;
    flex-flow: row nowrap;
    flex-shrink: 0;
    align-items: center;
    vertical-align: top;
}

.k-window-titlebar-action {
    flex-shrink: 0;
    opacity: 0.5;
}

.k-window-titlebar-action:hover {
    opacity: 0.75;
}

.k-window-content,
.k-prompt-container {
    padding-block: 1rem;
    padding-inline: 1rem;
    border-width: 0;
    border-color: inherit;
    color: inherit;
    background: none;
    outline: 0;
    overflow: auto;
    position: relative;
    flex: 1 1 auto;
}

.k-window-content + .k-prompt-container {
    margin-top: -0.5rem;
}

.k-window-content:first-child {
    padding-top: clamp(1rem, 1rem, 1rem);
}

.k-window-content:last-child {
    padding-bottom: clamp(1rem, 1rem, 1rem);
}

.k-window-iframecontent {
    padding: 0;
    overflow: visible;
}

.k-window-iframecontent .k-content-frame {
    vertical-align: top;
    border: 0;
    width: 100%;
    height: 100%;
}

.k-window-actions {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: inherit;
    flex: 0 0 auto;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    overflow: hidden;
}

.k-prompt-container > .k-textarea {
    width: 100%;
}

.k-window .k-resize-n {
    top: 0;
}

.k-window .k-resize-e {
    right: 0;
}

.k-window .k-resize-s {
    bottom: 0;
}

.k-window .k-resize-w {
    left: 0;
}

.k-window {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-window-titlebar {
    border-color: #dee2e6;
}

.k-window-primary .k-window-titlebar {
    color: white;
    background-color: #0d6efd;
}

.k-window-light .k-window-titlebar {
    color: black;
    background-color: #f8f9fa;
}

.k-window-dark .k-window-titlebar {
    color: white;
    background-color: #212529;
}

.k-dialog-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    outline: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10001;
}

.k-dialog-wrapper .k-dialog {
    position: relative;
}

.k-dialog {
    padding: 0;
    position: fixed;
    box-sizing: border-box;
}

.k-dialog.k-dialog-centered {
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
}

.k-dialog .k-multiselect {
    width: 100%;
}

.k-dialog-actions {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: inherit;
    flex: 0 0 auto;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    gap: 0.5rem;
    overflow: hidden;
}

.k-dialog-primary .k-dialog-titlebar {
    color: white;
    background-color: #0d6efd;
}

.k-dialog-light .k-dialog-titlebar {
    color: black;
    background-color: #f8f9fa;
}

.k-dialog-dark .k-dialog-titlebar {
    color: white;
    background-color: #212529;
}

.k-drawer-container {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
}

kendo-drawer.k-drawer,
kendo-drawer .k-drawer-wrapper {
    transition: none;
}

.k-drawer {
    height: 100%;
    max-width: 100%;
    border-width: 0;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    transition: all 300ms ease-in-out;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-drawer *,
.k-drawer *::before,
.k-drawer *::after {
    box-sizing: border-box;
}

.k-drawer-mini .k-drawer.k-drawer-start,
.k-drawer-expanded .k-drawer.k-drawer-start,
.k-drawer-left.k-drawer-mini .k-drawer,
.k-drawer-left.k-drawer-expanded .k-drawer {
    border-right-width: 1px;
}

.k-drawer-mini .k-drawer.k-drawer-end,
.k-drawer-expanded .k-drawer.k-drawer-end,
.k-drawer-right.k-drawer-mini .k-drawer,
.k-drawer-right.k-drawer-expanded .k-drawer {
    border-left-width: 1px;
}

.k-drawer.k-drawer-start,
.k-drawer-left .k-drawer {
    top: 0;
    left: 0;
}

.k-drawer.k-drawer-end,
.k-drawer-right .k-drawer {
    top: 0;
    right: 0;
}

.k-drawer-content {
    flex: 1 1 auto;
    overflow: auto;
}

.k-drawer-overlay .k-drawer {
    max-width: 80vw;
    position: fixed;
    z-index: 10002;
    border: 0;
}

.k-drawer-overlay > .k-overlay {
    display: none;
}

.k-drawer-overlay.k-drawer-expanded > .k-overlay {
    display: block;
}

.k-drawer-push {
    display: flex;
    flex-direction: row;
}

.k-drawer-push .k-drawer {
    height: auto;
    position: relative;
    align-self: stretch;
}

.k-drawer-push .k-drawer.k-drawer-end,
.k-drawer-push.k-drawer-right .k-drawer {
    order: 1;
}

.k-drawer-wrapper {
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: thin;
    transition: all 300ms ease-in-out;
}

.k-drawer-wrapper::-webkit-scrollbar {
    width: 7px;
}

.k-drawer-wrapper::-webkit-scrollbar-thumb {
    border-radius: 20px;
}

.k-drawer-items,
.k-drawer-items ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.k-drawer-item {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    outline: 0;
    color: inherit;
    font-size: 16px;
    line-height: 2;
    display: flex;
    flex-flow: row nowrap;
    gap: 1rem;
    cursor: pointer;
}

.k-drawer-item > .k-drawer-link {
    margin-block: -0.5rem;
    margin-inline: -1rem;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    color: inherit;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 0 auto;
    gap: 1rem;
}

.k-drawer-item .k-icon {
    flex-shrink: 0;
    padding-inline: 0;
    padding-block: 0.5rem;
    box-sizing: content-box;
}

.k-drawer-item .k-icon.k-i-none {
    margin: 0;
}

.k-drawer-item .k-item-text {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-drawer-item .k-drawer-toggle {
    margin-inline-start: auto;
    cursor: pointer;
    display: flex;
}

.k-drawer-item.k-level-1 {
    padding-inline-start: 2rem;
}

.k-drawer-item.k-level-2 {
    padding-inline-start: 3rem;
}

.k-drawer-item.k-level-3 {
    padding-inline-start: 4rem;
}

.k-drawer-item.k-level-4 {
    padding-inline-start: 5rem;
}

.k-drawer-item.k-level-5 {
    padding-inline-start: 6rem;
}

.k-drawer-separator {
    padding: 0;
    height: 1px;
}

.k-drawer-mini .k-drawer-wrapper {
    width: calc(2rem + 16px);
}

.k-rtl.k-drawer-mini .k-drawer-start,
.k-rtl .k-drawer-mini .k-drawer-start,
.k-rtl .k-drawer-expanded .k-drawer-start,
.k-rtl.k-drawer-expanded .k-drawer-start,
[dir="rtl"].k-drawer-mini .k-drawer-start,
[dir="rtl"] .k-drawer-mini .k-drawer-start,
[dir="rtl"] .k-drawer-expanded .k-drawer-start,
[dir="rtl"].k-drawer-expanded .k-drawer-start {
    border-left-width: 1px;
    border-right-width: 0;
}

.k-rtl.k-drawer-mini .k-drawer-end,
.k-rtl .k-drawer-mini .k-drawer-end,
.k-rtl.k-drawer-expanded .k-drawer-end .k-drawer-expanded .k-drawer-end,
[dir="rtl"].k-drawer-mini .k-drawer-end,
[dir="rtl"] .k-drawer-mini .k-drawer-end,
[dir="rtl"].k-drawer-expanded .k-drawer-end .k-drawer-expanded .k-drawer-end {
    border-left-width: 0;
    border-right-width: 1px;
}

.k-rtl.k-drawer-overlay .k-drawer-start,
.k-rtl .k-drawer-overlay .k-drawer-start,
[dir="rtl"].k-drawer-overlay .k-drawer-start,
[dir="rtl"] .k-drawer-overlay .k-drawer-start {
    left: auto;
    right: 0;
}

.k-rtl.k-drawer-overlay .k-drawer-end,
.k-rtl .k-drawer-overlay .k-drawer-end,
[dir="rtl"].k-drawer-overlay .k-drawer-end,
[dir="rtl"] .k-drawer-overlay .k-drawer-end {
    left: 0;
    right: auto;
}

.k-rtl .k-drawer-left.k-drawer-push .k-drawer,
[dir="rtl"] .k-drawer-left.k-drawer-push .k-drawer {
    order: 1;
}

.k-rtl .k-drawer-right.k-drawer-push .k-drawer,
[dir="rtl"] .k-drawer-right.k-drawer-push .k-drawer {
    order: 0;
}

.k-drawer {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-drawer-wrapper {
    scrollbar-color: rgba(156, 156, 156, 0.7) #dedede;
}

.k-drawer-wrapper::-webkit-scrollbar-track {
    background: #dedede;
}

.k-drawer-wrapper::-webkit-scrollbar-thumb {
    background: rgba(156, 156, 156, 0.7);
}

.k-drawer-wrapper::-webkit-scrollbar-thumb:hover {
    background: #9c9c9c;
}

.k-drawer-item:hover, .k-drawer-item.k-hover {
    color: #212529;
    background-color: #e9ecef;
}

.k-drawer-item:focus, .k-drawer-item.k-focus {
    background-color: #e9ecef;
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.15);
}

.k-drawer-item:focus:hover, .k-drawer-item:focus.k-hover, .k-drawer-item.k-focus:hover, .k-drawer-item.k-focus.k-hover {
    color: #212529;
    background-color: #e9ecef;
}

.k-drawer-item.k-selected {
    color: white;
    background-color: #0d6efd;
}

.k-drawer-item.k-selected:hover, .k-drawer-item.k-selected.k-hover {
    color: white;
    background-color: #0c65e9;
}

.k-drawer-separator {
    background-color: #dee2e6;
}

.k-notification-group {
    max-height: 100%;
    display: inline-flex;
    flex-flow: column-reverse wrap;
    position: fixed;
    z-index: 1000;
    gap: 0.75rem 0;
}

.k-notification-container-animating {
    overflow: hidden;
}

.k-notification {
    border-radius: 0.375rem;
    padding-block: 1rem;
    padding-inline: 1rem;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 0.875rem;
    line-height: 1.5;
    cursor: default;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-notification *,
.k-notification *::before,
.k-notification *::after {
    box-sizing: border-box;
}

.k-notification > .k-notification-content {
    flex: 1 1 auto;
}

.k-notification-actions {
    flex: none;
    display: flex;
    gap: 0.5rem;
    flex-flow: row nowrap;
    align-items: center;
    align-self: center;
    cursor: pointer;
}

.k-notification-action {
    flex: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-self: center;
}

.k-notification {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));
}

.k-notification-inverse {
    border-color: #d3d3d4;
    color: #111315;
    background-color: #c1c2c3;
}

.k-notification-light {
    border-color: #fefefe;
    color: #818182;
    background-color: #fdfdfe;
}

.k-notification-dark {
    border-color: #d3d3d4;
    color: #111315;
    background-color: #c1c2c3;
}

.k-notification-error {
    border-color: #f8d7da;
    color: #721c24;
    background-color: #f5c6cb;
}

.k-notification-warning {
    border-color: #fff3cd;
    color: #856404;
    background-color: #ffeeba;
}

.k-notification-success {
    border-color: #d1e7dd;
    color: #0d462c;
    background-color: #bfddcf;
}

.k-notification-info {
    border-color: #cff4fc;
    color: #07697d;
    background-color: #bbf0fb;
}

.k-notification-tertiary {
    border-color: #e2d9f3;
    color: #3a2264;
    background-color: #d7caee;
}

.k-notification-secondary {
    border-color: #e2e3e5;
    color: #383d41;
    background-color: #d6d8db;
}

.k-notification-primary {
    border-color: #cfe2ff;
    color: #073984;
    background-color: #bbd6fe;
}

kendo-card,
kendo-card-header,
kendo-card-body,
kendo-card-actions,
kendo-card-footer {
    display: block;
}

.k-card {
    border-radius: 0.375rem;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-card *,
.k-card *::before,
.k-card *::after {
    box-sizing: border-box;
}

.k-card .k-card-avatar,
.k-card .k-avatar {
    margin-right: 1rem;
    width: 45px;
    height: 45px;
    flex-basis: 45px;
}

.k-card > .k-card-inner {
    border-radius: calc(0.375rem - 1px);
    display: flex;
    flex-direction: inherit;
    overflow: hidden;
    position: relative;
}

.k-card-horizontal {
    flex-flow: row nowrap;
}

.k-card-vertical {
    flex-flow: column nowrap;
}

.k-card-header {
    padding-block: 1rem;
    padding-inline: 1rem;
    border-width: 0 0 1px;
    border-style: solid;
    outline: 0;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;
    z-index: 1;
}

.k-card-header .k-card-title,
.k-card-header .k-card-subtitle {
    margin-bottom: 0;
}

.k-card-header .k-card-title + .k-card-subtitle,
.k-card-header .k-card-subtitle + .k-card-subtitle {
    margin-top: 0.75rem;
}

.k-card-footer {
    padding-block: 1rem;
    padding-inline: 1rem;
    border-width: 1px 0 0;
    border-style: solid;
    outline: 0;
    flex-shrink: 0;
}

.k-card-body {
    padding-block: 1rem;
    padding-inline: 1rem;
    outline: 0;
    flex: 1 1 auto;
}

.k-card-body p {
    margin: 0 0 1rem;
}

.k-card-body > .k-last,
.k-card-body > :last-child {
    margin-bottom: 0;
}

.k-card-body > .k-card-actions {
    padding: 0;
}

.k-card-media {
    border: 0;
    max-width: 100%;
    flex-shrink: 0;
    overflow: hidden;
}

.k-card-horizontal .k-card-media {
    max-width: 100px;
    object-fit: cover;
}

.k-card-title {
    margin: 0 0 0.75rem;
    font-size: 1.25rem;
    line-height: 1.2;
    font-weight: 500;
}

.k-card-subtitle {
    margin: 0 0 0.75rem;
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 500;
}

.k-card-separator {
    margin: 0;
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    display: block;
    flex: 0 0 auto;
    align-self: stretch;
}

.k-card-separator.k-separator-horizontal,
.k-card-vertical > .k-card-separator {
    border-top-width: 1px;
}

.k-card-separator.k-separator-vertical,
.k-card-horizontal > .k-card-separator {
    border-left-width: 1px;
}

.k-card > .k-hr {
    margin: 0;
    flex: 0 0 auto;
    border-color: inherit;
}

.k-card-actions {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    overflow: hidden;
    display: flex;
    flex-shrink: 0;
    flex-basis: auto;
    gap: 0.5rem;
}

.k-card-horizontal .k-actions-horizontal {
    width: auto;
}

.k-card-list {
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    gap: 1rem;
    flex: 0 0 auto;
}

.k-card-list .k-card {
    flex: 0 0 auto;
}

.k-card-deck {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    gap: 1rem;
    flex: 0 0 auto;
}

.k-card-deck .k-card {
    flex: 0 0 auto;
}

.k-card-deck-scrollwrap {
    padding-bottom: 3px;
    width: 100%;
    box-sizing: content-box;
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    position: relative;
    overflow: hidden;
}

.k-card-deck-scrollwrap > .k-button {
    border-radius: 0px;
    flex: 0 0 auto;
    position: absolute;
    z-index: 1;
}

.k-card-deck-scrollwrap > .k-button:first-child {
    left: -1px;
}

.k-card-deck-scrollwrap > .k-button:last-child {
    right: -1px;
}

.k-card-deck-scrollwrap > .k-card-deck {
    margin-bottom: -20px;
    padding-bottom: 20px;
    flex: 1 1 auto;
}

.k-card-group {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    flex: 0 0 auto;
}

.k-card-group .k-card {
    border-radius: 0;
    flex: 0 0 auto;
}

.k-card-group .k-card + .k-card {
    margin-inline-start: 1px;
}

.k-card-group .k-card.k-first {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
}

.k-card-group .k-card.k-last {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}

.k-card-group .k-card.k-only {
    border-radius: 0.375rem;
}

.k-card-with-callout {
    overflow: visible;
}

.k-card-callout {
    margin: 0;
    width: 1.3em;
    height: 1.3em;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    position: absolute;
}

.k-card-callout.k-callout-n {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
}

.k-card-callout.k-callout-e {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%) rotate(-45deg);
}

.k-card-callout.k-callout-s {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%) rotate(45deg);
}

.k-card-callout.k-callout-w {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%) rotate(45deg);
}

.k-card-flat {
    box-shadow: none;
}

.k-card {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-card .k-card-inner {
    background-color: inherit;
    border-color: inherit;
}

.k-card:focus, .k-card.k-focus {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-card.k-selected {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-card-actions {
    border-color: #dee2e6;
}

.k-card-header {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-card-footer {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-card-separator,
.k-card .k-separator {
    border-color: #dee2e6;
}

.k-card-subtitle {
    color: #6c757d;
}

.k-card-primary {
    background-color: #cfe2ff;
    color: #073984;
    border-color: #bbd6fe;
}

.k-card-primary .k-card-subtitle {
    color: inherit;
}

.k-card-secondary {
    background-color: #e2e3e5;
    color: #383d41;
    border-color: #d6d8db;
}

.k-card-secondary .k-card-subtitle {
    color: inherit;
}

.k-card-tertiary {
    background-color: #e2d9f3;
    color: #3a2264;
    border-color: #d7caee;
}

.k-card-tertiary .k-card-subtitle {
    color: inherit;
}

.k-card-info {
    background-color: #cff4fc;
    color: #07697d;
    border-color: #bbf0fb;
}

.k-card-info .k-card-subtitle {
    color: inherit;
}

.k-card-success {
    background-color: #d1e7dd;
    color: #0d462c;
    border-color: #bfddcf;
}

.k-card-success .k-card-subtitle {
    color: inherit;
}

.k-card-warning {
    background-color: #fff3cd;
    color: #856404;
    border-color: #ffeeba;
}

.k-card-warning .k-card-subtitle {
    color: inherit;
}

.k-card-error {
    background-color: #f8d7da;
    color: #721c24;
    border-color: #f5c6cb;
}

.k-card-error .k-card-subtitle {
    color: inherit;
}

.k-card-dark {
    background-color: #d3d3d4;
    color: #111315;
    border-color: #c1c2c3;
}

.k-card-dark .k-card-subtitle {
    color: inherit;
}

.k-card-light {
    background-color: #fefefe;
    color: #818182;
    border-color: #fdfdfe;
}

.k-card-light .k-card-subtitle {
    color: inherit;
}

.k-card-inverse {
    background-color: #d3d3d4;
    color: #111315;
    border-color: #c1c2c3;
}

.k-card-inverse .k-card-subtitle {
    color: inherit;
}

.k-card-wrap:focus > .k-card, .k-card-wrap.k-focus > .k-card, .k-card-wrap.k-selected > .k-card {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-card-callout {
    border-color: inherit;
    background-color: inherit;
    box-shadow: inherit;
}

.k-popover {
    border-radius: 0.375rem;
    padding: 0;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    display: flex;
    flex-flow: column nowrap;
    z-index: 12000;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-popover *,
.k-popover *::before,
.k-popover *::after {
    box-sizing: border-box;
}

.k-popover-inner {
    height: inherit;
    position: relative;
    border-radius: inherit;
    border-color: inherit;
}

.k-popover-header {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
    padding-block: 1rem;
    padding-inline: 1rem;
    border-width: 0 0 1px;
    border-style: solid;
    border-color: inherit;
}

.k-popover-body {
    padding-block: 1rem;
    padding-inline: 1rem;
}

.k-popover-actions {
    border-width: 1px 0 0;
}

.k-popover-callout {
    margin: 0;
    width: 1.3em;
    height: 1.3em;
    border-width: 1px;
    border-style: solid;
    position: absolute;
}

.k-popover-callout.k-callout-n {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
}

.k-popover-callout.k-callout-e {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%) rotate(-45deg);
}

.k-popover-callout.k-callout-s {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%) rotate(45deg);
}

.k-popover-callout.k-callout-w {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%) rotate(45deg);
}

.k-popover {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-popover-inner {
    background-color: inherit;
    border-color: inherit;
}

.k-popover-callout {
    border-color: inherit;
    background-color: inherit;
    box-shadow: inherit;
}

.k-rpanel-left,
.k-rpanel-right {
    position: fixed;
    display: block;
    overflow: auto;
    min-width: 320px;
    height: 100%;
    top: 0;
}

.k-rpanel-left + *,
.k-rpanel-right + * {
    overflow: auto;
}

.k-rpanel-left.k-rpanel-expanded,
.k-rpanel-right.k-rpanel-expanded {
    transform: translateX(0) translateZ(0);
}

.k-rpanel-left {
    transform: translateX(-100%) translateZ(0);
    left: 0;
}

.k-rpanel-right {
    transform: translateX(100%) translateZ(0);
    right: 0;
}

.k-rpanel-top {
    position: static;
    max-height: 0;
}

.k-rpanel-top.k-rpanel-expanded {
    max-height: 568px;
    overflow: visible !important;
}

.k-rpanel-toggle {
    touch-action: manipulation;
}

.k-bottom-nav {
    padding-block: 0px;
    padding-inline: 0px;
    width: 100%;
    border-width: 0;
    border-style: solid;
    border-color: transparent;
    box-sizing: border-box;
    font-size: 1rem;
    line-height: normal;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    letter-spacing: 0.2px;
    display: flex;
    flex-flow: row nowrap;
    white-space: nowrap;
    gap: 0px;
    overflow: hidden;
    outline: none;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-bottom-nav *,
.k-bottom-nav *::before,
.k-bottom-nav *::after {
    box-sizing: border-box;
}

.k-bottom-nav-border {
    border-width: 1px 0px 0px 0px;
}

.k-bottom-nav-shadow {
    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));
}

.k-bottom-nav-item {
    padding-block: 0;
    padding-inline: 0.5rem;
    min-width: 72px;
    min-height: calc(40px + 1rem);
    border-width: 0;
    box-sizing: border-box;
    font: inherit;
    display: inline-flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    gap: 0 0.25rem;
    text-decoration: none;
    cursor: pointer;
    color: inherit;
    background-color: inherit;
    border-color: inherit;
    outline: none;
}

.k-bottom-nav-item:focus {
    outline: none;
}

.k-bottom-nav-item:hover {
    color: inherit;
    text-decoration: none;
}

.k-bottom-nav-item > .k-bottom-nav-link {
    margin-block: 0;
    margin-inline: -0.5rem;
    padding-block: 0;
    padding-inline: 0.5rem;
    width: 100%;
    color: inherit;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 0 auto;
    align-items: center;
    justify-content: center;
    outline: 0;
}

.k-bottom-nav-item.k-disabled {
    background-color: initial;
}

.k-bottom-nav-item-text {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.k-bottom-nav-item-flow-horizontal .k-bottom-nav-item {
    flex-flow: row nowrap;
}

.k-bottom-nav-item-flow-vertical .k-bottom-nav-item {
    flex-direction: column;
}

.k-bottom-nav.k-pos-fixed, .k-bottom-nav.k-fixed {
    bottom: 0;
    z-index: 1;
}

.k-bottom-nav-solid-primary, .k-bottom-nav-solid.k-bottom-nav-primary {
    color: #aaccfe;
    background-color: #0d6efd;
}

.k-bottom-nav-solid-primary .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-primary .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item:focus {
    background-color: rgba(170, 204, 254, 0.2);
}

.k-bottom-nav-solid-primary .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-selected {
    color: white;
}

.k-bottom-nav-solid-secondary, .k-bottom-nav-solid.k-bottom-nav-secondary {
    color: #cccfd2;
    background-color: #6c757d;
}

.k-bottom-nav-solid-secondary .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-secondary .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item:focus {
    background-color: rgba(204, 207, 210, 0.2);
}

.k-bottom-nav-solid-secondary .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-selected {
    color: white;
}

.k-bottom-nav-solid-tertiary, .k-bottom-nav-solid.k-bottom-nav-tertiary {
    color: #cdbde9;
    background-color: #6f42c1;
}

.k-bottom-nav-solid-tertiary .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-tertiary .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item:focus {
    background-color: rgba(205, 189, 233, 0.2);
}

.k-bottom-nav-solid-tertiary .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-selected {
    color: white;
}

.k-bottom-nav-solid-info, .k-bottom-nav-solid.k-bottom-nav-info {
    color: #aaecfa;
    background-color: #0dcaf0;
}

.k-bottom-nav-solid-info .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-info .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item:focus {
    background-color: rgba(170, 236, 250, 0.2);
}

.k-bottom-nav-solid-info .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-selected {
    color: white;
}

.k-bottom-nav-solid-success, .k-bottom-nav-solid.k-bottom-nav-success {
    color: #afd5c3;
    background-color: #198754;
}

.k-bottom-nav-solid-success .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-success .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item:focus {
    background-color: rgba(175, 213, 195, 0.2);
}

.k-bottom-nav-solid-success .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-selected {
    color: white;
}

.k-bottom-nav-solid-warning, .k-bottom-nav-solid.k-bottom-nav-warning {
    color: #594402;
    background-color: #ffc107;
}

.k-bottom-nav-solid-warning .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-warning .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item:focus {
    background-color: rgba(89, 68, 2, 0.2);
}

.k-bottom-nav-solid-warning .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-selected {
    color: black;
}

.k-bottom-nav-solid-error, .k-bottom-nav-solid.k-bottom-nav-error {
    color: #f3b8be;
    background-color: #dc3545;
}

.k-bottom-nav-solid-error .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-error .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item:focus {
    background-color: rgba(243, 184, 190, 0.2);
}

.k-bottom-nav-solid-error .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-selected {
    color: white;
}

.k-bottom-nav-solid-dark, .k-bottom-nav-solid.k-bottom-nav-dark {
    color: #b1b3b4;
    background-color: #212529;
}

.k-bottom-nav-solid-dark .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-dark .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item:focus {
    background-color: rgba(177, 179, 180, 0.2);
}

.k-bottom-nav-solid-dark .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-selected {
    color: white;
}

.k-bottom-nav-solid-light, .k-bottom-nav-solid.k-bottom-nav-light {
    color: #575758;
    background-color: #f8f9fa;
}

.k-bottom-nav-solid-light .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-light .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item:focus {
    background-color: rgba(87, 87, 88, 0.2);
}

.k-bottom-nav-solid-light .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-selected {
    color: black;
}

.k-bottom-nav-solid-inverse, .k-bottom-nav-solid.k-bottom-nav-inverse {
    color: #b1b3b4;
    background-color: #212529;
}

.k-bottom-nav-solid-inverse .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-focus,
.k-bottom-nav-solid-inverse .k-bottom-nav-item:focus,
.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item:focus {
    background-color: rgba(177, 179, 180, 0.2);
}

.k-bottom-nav-solid-inverse .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-selected {
    color: white;
}

.k-bottom-nav-flat-primary, .k-bottom-nav-flat.k-bottom-nav-primary {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-primary .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-primary .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-primary .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-primary .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-primary .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-primary .k-bottom-nav-item.k-selected {
    color: #0d6efd;
}

.k-bottom-nav-flat-secondary, .k-bottom-nav-flat.k-bottom-nav-secondary {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-secondary .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-secondary .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-secondary .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-secondary .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-secondary .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-secondary .k-bottom-nav-item.k-selected {
    color: #52595f;
}

.k-bottom-nav-flat-tertiary, .k-bottom-nav-flat.k-bottom-nav-tertiary {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-tertiary .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-tertiary .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-tertiary .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-tertiary .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-tertiary .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-tertiary .k-bottom-nav-item.k-selected {
    color: #6f42c1;
}

.k-bottom-nav-flat-info, .k-bottom-nav-flat.k-bottom-nav-info {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-info .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-info .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-info .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-info .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-info .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-info .k-bottom-nav-item.k-selected {
    color: #0dcaf0;
}

.k-bottom-nav-flat-success, .k-bottom-nav-flat.k-bottom-nav-success {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-success .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-success .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-success .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-success .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-success .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-success .k-bottom-nav-item.k-selected {
    color: #198754;
}

.k-bottom-nav-flat-warning, .k-bottom-nav-flat.k-bottom-nav-warning {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-warning .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-warning .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-warning .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-warning .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-warning .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-warning .k-bottom-nav-item.k-selected {
    color: #ffc107;
}

.k-bottom-nav-flat-error, .k-bottom-nav-flat.k-bottom-nav-error {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-error .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-error .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-error .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-error .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-error .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-error .k-bottom-nav-item.k-selected {
    color: #dc3545;
}

.k-bottom-nav-flat-dark, .k-bottom-nav-flat.k-bottom-nav-dark {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-dark .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-dark .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-dark .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-dark .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-dark .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-dark .k-bottom-nav-item.k-selected {
    color: #212529;
}

.k-bottom-nav-flat-light, .k-bottom-nav-flat.k-bottom-nav-light {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-light .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-light .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-light .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-light .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-light .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-light .k-bottom-nav-item.k-selected {
    color: #bcbdbe;
}

.k-bottom-nav-flat-inverse, .k-bottom-nav-flat.k-bottom-nav-inverse {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-bottom-nav-flat-inverse .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-inverse .k-bottom-nav-item.k-focus,
.k-bottom-nav-flat-inverse .k-bottom-nav-item:focus,
.k-bottom-nav-flat.k-bottom-nav-inverse .k-bottom-nav-item:focus {
    background-color: rgba(33, 37, 41, 0.05);
}

.k-bottom-nav-flat-inverse .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-inverse .k-bottom-nav-item.k-selected {
    color: #212529;
}

.k-breadcrumb {
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    display: flex;
    flex-direction: row;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-breadcrumb *,
.k-breadcrumb *::before,
.k-breadcrumb *::after {
    box-sizing: border-box;
}

.k-breadcrumb-container,
.k-breadcrumb-root-item-container {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: row nowrap;
    overflow: hidden;
}

.k-breadcrumb-root-item-container {
    align-items: flex-start;
    flex-shrink: 0;
}

.k-breadcrumb-item {
    vertical-align: middle;
    display: inline-flex;
    flex-direction: row;
    flex: none;
    align-items: center;
    overflow: hidden;
}

.k-breadcrumb-root-item {
    flex-shrink: 0;
}

.k-breadcrumb-link,
.k-breadcrumb-root-link {
    border-radius: 0.375rem;
    color: inherit;
    text-decoration: none;
    white-space: nowrap;
    outline: none;
    cursor: pointer;
    position: relative;
    display: inline-flex;
    align-items: center;
    align-self: stretch;
    overflow: hidden;
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.k-breadcrumb-link > .k-image,
.k-breadcrumb-icontext-link .k-icon {
    margin-inline-end: 0.5rem;
}

.k-breadcrumb-delimiter,
.k-breadcrumb-delimiter-icon {
    color: inherit;
    opacity: 0.65;
}

.k-breadcrumb-input-container {
    width: 100%;
}

.k-breadcrumb-input-container .k-breadcrumb-input-container {
    border-color: transparent;
}

.k-breadcrumb-sm {
    font-size: 0.875rem;
    line-height: 1.4285714286;
}

.k-breadcrumb-sm .k-breadcrumb-link,
.k-breadcrumb-sm .k-breadcrumb-root-link {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
}

.k-breadcrumb-sm .k-breadcrumb-icon-link {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-breadcrumb-md {
    font-size: 1rem;
    line-height: 1.5;
}

.k-breadcrumb-md .k-breadcrumb-link,
.k-breadcrumb-md .k-breadcrumb-root-link {
    padding-block: 0.5rem;
    padding-inline: 0.75rem;
}

.k-breadcrumb-md .k-breadcrumb-icon-link {
    padding-block: 0.75rem;
    padding-inline: 0.75rem;
}

.k-breadcrumb-lg {
    font-size: 1rem;
    line-height: 1.5;
}

.k-breadcrumb-lg .k-breadcrumb-link,
.k-breadcrumb-lg .k-breadcrumb-root-link {
    padding-block: 0.625rem;
    padding-inline: 0.75rem;
}

.k-breadcrumb-lg .k-breadcrumb-icon-link {
    padding-block: 0.875rem;
    padding-inline: 0.875rem;
}

.k-breadcrumb-link,
.k-breadcrumb-root-link {
    text-decoration: underline;
}

.k-breadcrumb-current-item .k-disabled, .k-breadcrumb-last-item .k-disabled {
    opacity: 1;
    filter: none;
}

.k-breadcrumb {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-breadcrumb:focus, .k-breadcrumb.k-focus {
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.06);
}

.k-breadcrumb-link {
    color: #0d6efd;
}

.k-breadcrumb-link:hover, .k-breadcrumb-link.k-hover {
    color: #0a58ca;
}

.k-breadcrumb-link:focus, .k-breadcrumb-link.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.25);
}

.k-breadcrumb-root-link {
    color: #0d6efd;
}

.k-breadcrumb-root-link:hover, .k-breadcrumb-root-link.k-hover {
    color: #0a58ca;
}

.k-breadcrumb-root-link:focus, .k-breadcrumb-root-link.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.25);
}

.k-breadcrumb-current-item .k-breadcrumb-link, .k-breadcrumb-last-item .k-breadcrumb-link {
    color: #6c757d;
}

.k-pager {
    padding: 0;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    white-space: nowrap;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    cursor: default;
    flex: 0 0 auto;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-pager *,
.k-pager *::before,
.k-pager *::after {
    box-sizing: border-box;
}

.k-pager-input, .k-pager-sizes, .k-pager-info {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.k-pager-nav {
    color: inherit;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.k-pager-nav:hover {
    z-index: 2;
}

.k-disabled.k-pager-nav {
    color: inherit;
}

.k-pager-numbers-wrap {
    display: flex;
    flex-direction: row;
    position: relative;
}

.k-pager-numbers-wrap select.k-dropdown-list, .k-pager-numbers-wrap select.k-dropdown,
.k-pager-numbers-wrap select.k-dropdownlist {
    width: 5em;
}

.k-pager-numbers {
    display: flex;
    flex-direction: row;
}

.k-pager-numbers .k-selected {
    cursor: inherit;
    z-index: 2;
}

.k-pager-nav + .k-pager-nav,
.k-pager-nav + .k-pager-numbers-wrap,
.k-pager-numbers-wrap + .k-pager-nav {
    margin-left: -1px;
}

.k-rtl .k-pager-nav + .k-pager-nav,
[dir="rtl"] .k-pager-nav + .k-pager-nav, .k-rtl
.k-pager-nav + .k-pager-numbers-wrap,
[dir="rtl"]
.k-pager-nav + .k-pager-numbers-wrap, .k-rtl
.k-pager-numbers-wrap + .k-pager-nav,
[dir="rtl"]
.k-pager-numbers-wrap + .k-pager-nav {
    margin-left: 0;
    margin-right: -1px;
}

.k-pager-input {
    gap: 1ex;
}

.k-pager-input .k-textbox,
.k-pager-input .k-numerictextbox {
    margin-block: 0;
    width: 5em;
}

.k-pager-sizes {
    gap: 1ex;
}

.k-pager-sizes .k-input-inner,
.k-pager-sizes .k-input-value-text {
    text-overflow: clip;
}

.k-pager-info {
    text-align: end;
    justify-content: flex-end;
    flex: 1 1 0%;
    order: 9;
}

.k-pager-refresh {
    margin-inline-start: auto;
    color: inherit;
    order: 10;
}

.k-pager-sm {
    padding-inline: 0.25rem;
    padding-block: 0.25rem;
    gap: 0.875rem;
}

.k-pager-sm .k-pager-numbers-wrap .k-button {
    min-width: calc(1.4285714286em + 0.5rem + 2px);
}

.k-pager-sm .k-pager-numbers-wrap .k-pager-input,
.k-pager-sm .k-pager-numbers-wrap > select.k-dropdown-list,
.k-pager-sm .k-pager-numbers-wrap > select.k-dropdown,
.k-pager-sm .k-pager-numbers-wrap > select.k-dropdownlist {
    margin-inline-start: 0.875rem;
    margin-inline-end: 0.875rem;
}

.k-pager-sm .k-pager-sizes .k-dropdown-list, .k-pager-sm .k-pager-sizes .k-dropdown,
.k-pager-sm .k-pager-sizes .k-dropdownlist,
.k-pager-sm .k-pager-sizes > select {
    width: 5em;
}

.k-pager-md {
    padding-inline: 0.5rem;
    padding-block: 0.5rem;
    gap: 1rem;
}

.k-pager-md .k-pager-numbers-wrap .k-button {
    min-width: calc(1.5em + 0.75rem + 2px);
}

.k-pager-md .k-pager-numbers-wrap .k-pager-input,
.k-pager-md .k-pager-numbers-wrap > select.k-dropdown-list,
.k-pager-md .k-pager-numbers-wrap > select.k-dropdown,
.k-pager-md .k-pager-numbers-wrap > select.k-dropdownlist {
    margin-inline-start: 1rem;
    margin-inline-end: 1rem;
}

.k-pager-md .k-pager-sizes .k-dropdown-list, .k-pager-md .k-pager-sizes .k-dropdown,
.k-pager-md .k-pager-sizes .k-dropdownlist,
.k-pager-md .k-pager-sizes > select {
    width: 5em;
}

.k-pager-lg {
    padding-inline: 0.625rem;
    padding-block: 0.625rem;
    gap: 1.125rem;
}

.k-pager-lg .k-pager-numbers-wrap .k-button {
    min-width: calc(1.5em + 1rem + 2px);
}

.k-pager-lg .k-pager-numbers-wrap .k-pager-input,
.k-pager-lg .k-pager-numbers-wrap > select.k-dropdown-list,
.k-pager-lg .k-pager-numbers-wrap > select.k-dropdown,
.k-pager-lg .k-pager-numbers-wrap > select.k-dropdownlist {
    margin-inline-start: 1.125rem;
    margin-inline-end: 1.125rem;
}

.k-pager-lg .k-pager-sizes .k-dropdown-list, .k-pager-lg .k-pager-sizes .k-dropdown,
.k-pager-lg .k-pager-sizes .k-dropdownlist,
.k-pager-lg .k-pager-sizes > select {
    width: 6em;
}

.k-pager-nav {
    border-radius: 0;
}

.k-pager-first {
    border-radius: 0.25rem 0 0 0.25rem;
}

.k-pager-last {
    border-radius: 0 0.25rem 0.25rem 0;
}

.k-rtl .k-pager-first,
[dir="rtl"] .k-pager-first {
    border-radius: 0 0.25rem 0.25rem 0;
}

.k-rtl .k-pager-last,
[dir="rtl"] .k-pager-last {
    border-radius: 0.25rem 0 0 0.25rem;
}

.k-pager {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-pager:focus, .k-pager.k-focus {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);
}

.k-stepper {
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-size: 1rem;
    line-height: 1.5;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    display: block;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    color: inherit;
    background: none;
}

.k-stepper *,
.k-stepper *::before,
.k-stepper *::after {
    box-sizing: border-box;
}

.k-stepper .k-step-list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    position: relative;
    z-index: 1;
}

.k-stepper .k-step-link {
    outline: none;
    color: inherit;
    text-decoration: none;
    white-space: nowrap;
    display: flex;
    align-items: center;
    overflow: hidden;
}

.k-stepper .k-step-indicator {
    border-radius: 50%;
    margin: 3px;
    width: 28px;
    height: 28px;
    border-width: 1px;
    border-style: solid;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    position: relative;
    z-index: 1;
    overflow: visible;
    transition-property: color, background-color, border-color;
    transition-duration: .4s;
    transition-timing-function: ease-in-out;
}

.k-stepper .k-step-indicator::before {
    border-radius: 50%;
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}

.k-stepper .k-step-indicator::after {
    border-radius: 100%;
    content: "";
    border-width: 1px;
    border-style: solid;
    border-color: inherit;
    pointer-events: none;
    display: none;
    position: absolute;
    top: -4px;
    right: -4px;
    bottom: -4px;
    left: -4px;
    z-index: 2;
}

.k-stepper .k-step.k-focus .k-step-indicator::after,
.k-stepper .k-step-link:focus .k-step-indicator::after {
    display: block;
}

.k-stepper .k-step-label {
    max-width: clamp(100%, 10em, 100%);
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.k-stepper .k-step-label:only-child {
    border-radius: 15px;
    padding-block: 5px;
    padding-inline: 12px;
    border-width: 0;
}

.k-stepper .k-step-label .k-step-text {
    max-width: calc(10em - 16px - 0.5rem);
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.k-stepper .k-step-label .k-icon {
    margin-left: 0.5rem;
}

.k-stepper .k-step-current .k-step-label {
    font-weight: bold;
}

.k-stepper .k-step-label-optional {
    flex-basis: 100%;
    font-size: 0.875rem;
}

.k-stepper .k-step-disabled,
.k-stepper .k-step.k-disabled {
    opacity: 1;
    pointer-events: none;
}

.k-stepper .k-step-disabled .k-step-link,
.k-stepper .k-step.k-disabled .k-step-link {
    cursor: default;
}

.k-stepper .k-step-disabled .k-step-label-optional,
.k-stepper .k-step.k-disabled .k-step-label-optional {
    color: inherit;
}

.k-stepper .k-progressbar {
    pointer-events: none;
    z-index: 0;
    overflow: visible;
}

.k-stepper .k-progressbar-horizontal {
    grid-row: 1 / -1;
}

.k-stepper .k-progressbar-vertical {
    position: absolute;
}

.k-step-list-horizontal {
    flex-direction: row;
    grid-row: 1;
}

.k-step-list-horizontal .k-step {
    flex: 1 0 auto;
    text-align: center;
}

.k-step-list-horizontal .k-step-link {
    margin: auto;
    max-width: 10em;
    flex-direction: column;
}

.k-step-list-horizontal .k-step-label {
    text-align: center;
}

.k-step-list-horizontal .k-step-indicator + .k-step-label {
    margin-top: 5px;
}

.k-step-list-horizontal ~ .k-progressbar {
    width: 100%;
    height: 2px;
    top: 17px;
}

.k-step-list-vertical {
    flex-direction: column;
}

.k-step-list-vertical .k-step {
    min-height: 54px;
}

.k-step-list-vertical .k-step-label {
    justify-content: flex-start;
}

.k-step-list-vertical .k-step-indicator + .k-step-label {
    margin-left: 12px;
}

.k-step-list-vertical ~ .k-progressbar {
    width: 2px;
    height: 100%;
    min-height: 20px;
    left: 17px;
}

.k-step-list-vertical .k-step-content {
    height: 0;
    overflow: hidden;
    transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.k-step-list-vertical .k-step-current .k-step-content {
    height: auto;
    overflow: visible;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 30px;
    padding-block: 20px;
    padding-inline: 10px;
}

.k-rtl .k-stepper,
.k-stepper[dir="rtl"] {
    direction: rtl;
}

.k-rtl .k-stepper .k-step-label .k-icon,
.k-stepper[dir="rtl"] .k-step-label .k-icon {
    margin-left: 0;
    margin-right: 0.5rem;
}

.k-rtl .k-stepper .k-step-list-vertical .k-step-indicator + .k-step-label,
.k-stepper[dir="rtl"] .k-step-list-vertical .k-step-indicator + .k-step-label {
    margin-left: 0;
    margin-right: 12px;
}

.k-rtl .k-stepper .k-step-list-vertical ~ .k-progressbar,
.k-stepper[dir="rtl"] .k-step-list-vertical ~ .k-progressbar {
    left: auto;
    right: 17px;
}

.k-stepper {
    color: #212529;
}

.k-stepper .k-step:hover .k-step-indicator, .k-stepper .k-step.k-hover .k-step-indicator, .k-stepper .k-step.k-step-hover .k-step-indicator {
    background-color: #ebebeb;
}

.k-stepper .k-step.k-focus .k-step-label:only-child,
.k-stepper .k-step .k-step-link:focus .k-step-label:only-child {
    box-shadow: inset 0 0 0 2px #dee2e6;
}

.k-stepper .k-step.k-step-disabled .k-step-indicator, .k-stepper .k-step.k-disabled .k-step-indicator, .k-stepper .k-step:disabled .k-step-indicator {
    color: #adb5bd;
}

.k-stepper .k-step.k-step-disabled .k-step-label, .k-stepper .k-step.k-disabled .k-step-label, .k-stepper .k-step:disabled .k-step-label {
    color: #adb5bd;
}

.k-stepper .k-step-indicator {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-stepper .k-step-indicator::after {
    box-shadow: inset 0 0 0 2px #ffffff;
}

.k-stepper .k-step-label:only-child {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-stepper .k-step-done .k-step-indicator {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-stepper .k-step-done:hover .k-step-indicator, .k-stepper .k-step-done.k-hover .k-step-indicator, .k-stepper .k-step-done.k-step-hover .k-step-indicator {
    background-color: #0c65e9;
}

.k-stepper .k-step-done.k-step-disabled .k-step-indicator, .k-stepper .k-step-done.k-disabled .k-step-indicator, .k-stepper .k-step-done:disabled .k-step-indicator {
    border-color: #6ea8fe;
    color: white;
    background-color: #6ea8fe;
}

.k-stepper .k-step-current .k-step-indicator {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-stepper .k-step-current:hover .k-step-indicator, .k-stepper .k-step-current.k-hover .k-step-indicator, .k-stepper .k-step-current.k-step-hover .k-step-indicator {
    background-color: #0c65e9;
}

.k-stepper .k-step-current.k-step-disabled .k-step-indicator, .k-stepper .k-step-current.k-disabled .k-step-indicator, .k-stepper .k-step-current:disabled .k-step-indicator {
    border-color: #6ea8fe;
    color: white;
    background-color: #6ea8fe;
}

.k-stepper .k-step-success .k-step-label .k-icon {
    color: #198754;
}

.k-stepper .k-step-error .k-step-label {
    color: #dc3545;
}

.k-stepper .k-step-error:hover .k-step-label, .k-stepper .k-step-error.k-hover .k-step-label, .k-stepper .k-step-error.k-step-hover .k-step-label {
    color: #dc3545;
}

.k-stepper .k-step-label-optional {
    color: #6c757d;
}

.k-tabstrip-wrapper {
    padding-block: 0px;
    padding-inline: 0px;
    box-sizing: border-box;
    border-width: 0px;
    border-style: solid;
    display: flex;
    flex-direction: column;
    position: relative;
}

.k-tabstrip {
    border-width: 0;
    border-color: transparent;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    color: inherit;
    background-color: transparent;
    display: flex;
    flex-flow: column nowrap;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-tabstrip-wrapper > .k-tabstrip {
    flex: 1 1 auto;
}

.k-tabstrip-items-wrapper {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    position: relative;
}

.k-tabstrip-items {
    box-sizing: border-box;
    outline: 0;
    display: flex;
    flex-direction: inherit;
    flex-wrap: wrap;
    flex: 1 1 auto;
    gap: 0;
}

.k-tabstrip-items *,
.k-tabstrip-items *::before,
.k-tabstrip-items *::after {
    box-sizing: border-box;
}

.k-tabstrip-items .k-item {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    position: relative;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-items: stretch;
    outline: 0;
}

.k-tabstrip-items .k-tab-on-top {
    z-index: 1;
}

.k-tabstrip-items .k-link {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    color: inherit;
    cursor: pointer;
    display: inline-flex;
    vertical-align: middle;
    flex: 1 1 auto;
    flex-direction: row;
    align-content: center;
    align-items: center;
}

.k-tabstrip-content,
.k-tabstrip > .k-content {
    margin: 0 !important;
    padding-block: 1rem;
    padding-inline: 1rem;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: inherit;
    display: none;
    overflow: auto;
    flex: 1 1 auto;
    position: relative;
}

.k-tabstrip-content.k-active,
.k-tabstrip > .k-content.k-active {
    display: block;
}

.k-tabstrip-content:focus, .k-tabstrip-content.k-focus,
.k-tabstrip > .k-content:focus,
.k-tabstrip > .k-content.k-focus {
    outline-width: 1px;
    outline-style: dotted;
    outline-offset: -1px;
}

.k-tabstrip-items .k-loading {
    width: 20%;
    height: 0;
    border: 0;
    border-top: 1px solid transparent;
    border-color: inherit;
    background: none;
    position: absolute;
    top: 0;
    left: 0;
    transition: width .2s linear;
    display: none;
}

.k-tabstrip-items .k-loading.k-complete {
    width: 100%;
    border-top-width: 0;
}

.k-tabstrip-scrollable > .k-tabstrip-items-wrapper > .k-tabstrip-items {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
}

.k-tabstrip-scrollable > .k-tabstrip-items-wrapper > .k-button {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    width: auto;
    height: auto;
    flex: none;
    align-self: stretch;
    aspect-ratio: auto;
}

.k-tabstrip-scrollable > .k-tabstrip-items-wrapper > .k-button .k-button-icon {
    min-width: auto;
    min-height: auto;
}

.k-tabstrip-horizontal, .k-tabstrip-top > .k-tabstrip-items-wrapper, .k-tabstrip-bottom > .k-tabstrip-items-wrapper {
    flex-direction: row;
}

.k-tabstrip-vertical, .k-tabstrip-left > .k-tabstrip-items-wrapper, .k-tabstrip-right > .k-tabstrip-items-wrapper {
    flex-direction: column;
}

.k-tabstrip-top > .k-tabstrip-items-wrapper {
    border-bottom-width: 1px;
}

.k-tabstrip-top > .k-tabstrip-items-wrapper .k-item {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    border-bottom-width: 0;
}

.k-tabstrip-top > .k-tabstrip-items-wrapper .k-item:active,
.k-tabstrip-top > .k-tabstrip-items-wrapper .k-item.k-active {
    margin-bottom: -1px;
    border-bottom-width: 1px;
    border-bottom-color: transparent !important;
}

.k-tabstrip-top > .k-content,
.k-tabstrip-top > .k-tabstrip-content {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-width: 0 !important;
}

.k-tabstrip-bottom > .k-tabstrip-items-wrapper {
    border-top-width: 1px;
}

.k-tabstrip-bottom > .k-tabstrip-items-wrapper .k-item {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-width: 0;
}

.k-tabstrip-bottom > .k-tabstrip-items-wrapper .k-item:active,
.k-tabstrip-bottom > .k-tabstrip-items-wrapper .k-item.k-active {
    margin-top: -1px;
    border-top-width: 1px;
    border-top-color: transparent !important;
}

.k-tabstrip-bottom > .k-content,
.k-tabstrip-bottom > .k-tabstrip-content {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    border-bottom-width: 0 !important;
}

.k-tabstrip-left {
    flex-direction: row;
}

.k-tabstrip-left > .k-tabstrip-items-wrapper {
    border-right-width: 1px;
}

.k-tabstrip-left > .k-tabstrip-items-wrapper .k-item {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-right-width: 0;
}

.k-tabstrip-left > .k-tabstrip-items-wrapper .k-item:active,
.k-tabstrip-left > .k-tabstrip-items-wrapper .k-item.k-active {
    margin-right: -1px;
    border-right-width: 1px;
    border-right-color: transparent !important;
}

.k-tabstrip-left > .k-content,
.k-tabstrip-left > .k-tabstrip-content {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-left-width: 0 !important;
}

.k-tabstrip-right {
    flex-direction: row-reverse;
}

.k-tabstrip-right > .k-tabstrip-items-wrapper {
    border-left-width: 1px;
}

.k-tabstrip-right > .k-tabstrip-items-wrapper .k-item {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-left-width: 0;
}

.k-tabstrip-right > .k-tabstrip-items-wrapper .k-item:active,
.k-tabstrip-right > .k-tabstrip-items-wrapper .k-item.k-active {
    margin-left: -1px;
    border-left-width: 1px;
    border-left-color: transparent !important;
}

.k-tabstrip-right > .k-content,
.k-tabstrip-right > .k-tabstrip-content {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-right-width: 0;
}

.k-tabstrip-items-start {
    justify-content: flex-start;
}

.k-tabstrip-items-center {
    justify-content: center;
}

.k-tabstrip-items-end {
    justify-content: flex-end;
}

.k-tabstrip-items-justify {
    justify-content: space-between;
}

.k-tabstrip-items-stretched > * {
    flex: 1 0 0;
}

.k-rtl .k-tabstrip.k-tabstrip-left > .k-tabstrip-items-wrapper, .k-rtl .k-tabstrip.k-tabstrip-right > .k-tabstrip-items-wrapper,
.k-tabstrip[dir="rtl"].k-tabstrip-left > .k-tabstrip-items-wrapper,
.k-tabstrip[dir="rtl"].k-tabstrip-right > .k-tabstrip-items-wrapper {
    order: 1;
}

.k-rtl .k-tabstrip.k-tabstrip-left > .k-content, .k-rtl .k-tabstrip.k-tabstrip-right > .k-content,
.k-tabstrip[dir="rtl"].k-tabstrip-left > .k-content,
.k-tabstrip[dir="rtl"].k-tabstrip-right > .k-content {
    order: 0;
}

.k-rtl .k-tabstrip.k-tabstrip-left > .k-tabstrip-content, .k-rtl .k-tabstrip.k-tabstrip-right > .k-tabstrip-content,
.k-tabstrip[dir="rtl"].k-tabstrip-left > .k-tabstrip-content,
.k-tabstrip[dir="rtl"].k-tabstrip-right > .k-tabstrip-content {
    order: 0;
}

.k-tabstrip-items-wrapper {
    border-color: #dee2e6;
    color: #212529;
}

.k-tabstrip-items-wrapper .k-item {
    color: #0d6efd;
}

.k-tabstrip-items-wrapper .k-item:hover, .k-tabstrip-items-wrapper .k-item.k-hover {
    border-color: #e9ecef;
    color: #0a58ca;
}

.k-tabstrip-items-wrapper .k-item:active, .k-tabstrip-items-wrapper .k-item.k-active, .k-tabstrip-items-wrapper .k-item.k-selected {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-tabstrip-items-wrapper .k-item:focus, .k-tabstrip-items-wrapper .k-item.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-tabstrip-items-wrapper .k-item.k-tabstrip-dragging {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-tabstrip-content,
.k-tabstrip > .k-content {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-tabstrip-content:focus, .k-tabstrip-content.k-focus,
.k-tabstrip > .k-content:focus,
.k-tabstrip > .k-content.k-focus {
    outline-color: #212529;
}

.k-wizard {
    padding-block: 1.25rem;
    padding-inline: 1.25rem;
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-size: 1rem;
    line-height: 1.5;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    position: relative;
    color: inherit;
    background: none;
    display: flex;
    align-items: stretch;
    overflow: hidden;
}

.k-wizard .k-wizard-steps {
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
}

.k-wizard .k-wizard-step {
    box-sizing: border-box;
    padding: calc(0.5rem + 2px);
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
}

.k-wizard .k-wizard-step:focus, .k-wizard .k-wizard-step.k-focus {
    outline-width: 1px;
    outline-style: dotted;
    outline-offset: -1px;
}

.k-wizard .k-wizard-content {
    box-sizing: border-box;
    overflow-y: auto;
}

.k-wizard .k-wizard-buttons {
    margin-top: 2rem;
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.k-wizard .k-wizard-buttons .k-button {
    margin-right: 10px;
}

.k-wizard .k-wizard-buttons .k-wizard-pager {
    vertical-align: middle;
}

.k-wizard .k-wizard-buttons-right .k-button:last-of-type {
    margin-right: 0;
}

.k-wizard .k-stepper .k-step-list-vertical .k-step {
    flex: 1 0 auto;
}

.k-wizard .k-stepper .k-step-indicator {
    flex-shrink: 0;
}

.k-wizard-horizontal {
    flex-direction: column;
}

.k-wizard-horizontal .k-wizard-steps {
    margin-top: 2rem;
}

.k-wizard-horizontal .k-wizard-steps,
.k-wizard-horizontal .k-wizard-content {
    flex: 1 1 auto;
}

.k-wizard-vertical .k-wizard-steps {
    margin-left: 2rem;
    flex: 1 0 0%;
}

.k-wizard-vertical .k-wizard-content {
    flex: 1 1 0%;
}

.k-wizard-left {
    flex-direction: row-reverse;
}

.k-wizard-left .k-wizard-steps {
    margin-right: 2rem;
    margin-left: 0;
}

.k-wizard-step:focus, .k-wizard-step.k-focus {
    outline-color: #656565;
}

.k-expander {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    overflow: hidden;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-expander *,
.k-expander *::before,
.k-expander *::after {
    box-sizing: border-box;
}

.k-rtl .k-expander .k-expander-indicator, .k-expander.k-rtl .k-expander-indicator, .k-expander[dir="rtl"] .k-expander-indicator {
    margin-left: 0;
    margin-right: 0.75rem;
}

.k-expander-header {
    padding-block: 1rem;
    padding-inline: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.k-expander-spacer {
    flex: 1 1 auto;
}

.k-expander-title {
    text-transform: uppercase;
    font-weight: 500;
}

.k-expander-indicator {
    margin-left: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.k-expander-content {
    padding-block: 1.5rem;
    padding-inline: 1.5rem;
}

.k-expander + .k-expander.k-expanded,
.k-expander.k-expanded + .k-expander {
    margin-top: 0.75rem;
}

.k-expander:not(.k-expanded) + .k-expander:not(.k-expanded) {
    border-top-width: 0;
}

.k-expander {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-expander.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-expander-header {
    color: #212529;
    background-color: transparent;
    outline: none;
}

.k-expander-header:hover, .k-expander-header.k-hover {
    background-color: rgba(0, 0, 0, 0.04);
}

.k-expander-header.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-expander-title {
    color: #0d6efd;
}

.k-expander-sub-title {
    color: #6c757d;
}

.k-panelbar {
    margin: 0;
    padding: 0;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    list-style: none;
    display: block;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-panelbar *,
.k-panelbar *::before,
.k-panelbar *::after {
    box-sizing: border-box;
}

.k-panelbar > .k-item,
.k-panelbar > .k-panelbar-header {
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    display: block;
}

.k-panelbar > .k-item > .k-link,
.k-panelbar > .k-panelbar-header > .k-link {
    padding-block: 1rem;
    padding-inline: 1.5rem;
    color: inherit;
    background: none;
    text-decoration: none;
    font-weight: 500;
    display: flex;
    flex-flow: row nowrap;
    gap: 0.5rem;
    align-items: center;
    align-content: center;
    position: relative;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: default;
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.k-panelbar > .k-item + .k-item,
.k-panelbar > .k-panelbar-header + .k-panelbar-header {
    border-top-width: 1px;
}

.k-panelbar .k-group,
.k-panelbar .k-panelbar-group {
    margin: 0;
    padding: 0;
    border-width: 0;
    border-color: inherit;
    color: inherit;
    background-color: transparent;
    list-style: none;
}

.k-panelbar .k-group > .k-item,
.k-panelbar .k-panelbar-group > .k-panelbar-item {
    display: block;
}

.k-panelbar .k-group > .k-item > .k-link,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link {
    padding-block: 0.75rem;
    padding-inline: 1.5rem;
    color: inherit;
    text-decoration: none;
    display: flex;
    flex-flow: row nowrap;
    gap: 0.5rem;
    align-items: center;
    align-content: center;
    position: relative;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: default;
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.k-panelbar .k-group > .k-item.k-level-1 .k-link,
.k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-1 .k-link {
    padding-left: 1.5rem;
}

.k-panelbar .k-group > .k-item.k-level-2 .k-link,
.k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-2 .k-link {
    padding-left: 3rem;
}

.k-panelbar .k-group > .k-item.k-level-3 .k-link,
.k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-3 .k-link {
    padding-left: 4.5rem;
}

.k-panelbar .k-group > .k-item.k-level-4 .k-link,
.k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-4 .k-link {
    padding-left: 6rem;
}

.k-panelbar .k-panelbar-item {
    outline-style: none;
}

.k-panelbar .k-panelbar-content {
    display: flow-root;
}

.k-panelbar .k-panelbar-expand,
.k-panelbar .k-panelbar-collapse,
.k-panelbar .k-panelbar-toggle {
    margin-inline-start: auto;
}

.k-panelbar .k-group .k-panelbar-expand,
.k-panelbar .k-group .k-panelbar-collapse,
.k-panelbar .k-panelbar-group .k-panelbar-toggle {
    margin-inline-end: 0rem;
}

.k-rtl .k-panelbar .k-group > .k-item.k-level-1 .k-link,
.k-rtl .k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-1 .k-link, .k-panelbar.k-rtl .k-group > .k-item.k-level-1 .k-link,
.k-panelbar.k-rtl .k-panelbar-group > .k-panelbar-item.k-level-1 .k-link, .k-panelbar[dir="rtl"] .k-group > .k-item.k-level-1 .k-link,
.k-panelbar[dir="rtl"] .k-panelbar-group > .k-panelbar-item.k-level-1 .k-link {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}

.k-rtl .k-panelbar .k-group > .k-item.k-level-2 .k-link,
.k-rtl .k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-2 .k-link, .k-panelbar.k-rtl .k-group > .k-item.k-level-2 .k-link,
.k-panelbar.k-rtl .k-panelbar-group > .k-panelbar-item.k-level-2 .k-link, .k-panelbar[dir="rtl"] .k-group > .k-item.k-level-2 .k-link,
.k-panelbar[dir="rtl"] .k-panelbar-group > .k-panelbar-item.k-level-2 .k-link {
    padding-left: 1.5rem;
    padding-right: 3rem;
}

.k-rtl .k-panelbar .k-group > .k-item.k-level-3 .k-link,
.k-rtl .k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-3 .k-link, .k-panelbar.k-rtl .k-group > .k-item.k-level-3 .k-link,
.k-panelbar.k-rtl .k-panelbar-group > .k-panelbar-item.k-level-3 .k-link, .k-panelbar[dir="rtl"] .k-group > .k-item.k-level-3 .k-link,
.k-panelbar[dir="rtl"] .k-panelbar-group > .k-panelbar-item.k-level-3 .k-link {
    padding-left: 1.5rem;
    padding-right: 4.5rem;
}

.k-rtl .k-panelbar .k-group > .k-item.k-level-4 .k-link,
.k-rtl .k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-4 .k-link, .k-panelbar.k-rtl .k-group > .k-item.k-level-4 .k-link,
.k-panelbar.k-rtl .k-panelbar-group > .k-panelbar-item.k-level-4 .k-link, .k-panelbar[dir="rtl"] .k-group > .k-item.k-level-4 .k-link,
.k-panelbar[dir="rtl"] .k-panelbar-group > .k-panelbar-item.k-level-4 .k-link {
    padding-left: 1.5rem;
    padding-right: 6rem;
}

.k-panelbar {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-panelbar > .k-item > .k-link,
.k-panelbar > .k-panelbar-header > .k-link {
    color: #0d6efd;
    background-color: #ffffff;
}

.k-panelbar > .k-item > .k-link .k-icon,
.k-panelbar > .k-item > .k-link .k-panelbar-item-icon,
.k-panelbar > .k-panelbar-header > .k-link .k-icon,
.k-panelbar > .k-panelbar-header > .k-link .k-panelbar-item-icon {
    color: #212529;
}

.k-panelbar > .k-item > .k-link:hover,
.k-panelbar > .k-item > .k-link.k-hover,
.k-panelbar > .k-panelbar-header > .k-link:hover,
.k-panelbar > .k-panelbar-header > .k-link.k-hover {
    background-color: whitesmoke;
}

.k-panelbar > .k-item > .k-link:focus,
.k-panelbar > .k-item > .k-link.k-focus,
.k-panelbar > .k-panelbar-header > .k-link:focus,
.k-panelbar > .k-panelbar-header > .k-link.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-panelbar > .k-item > .k-link.k-selected,
.k-panelbar > .k-panelbar-header > .k-link.k-selected {
    color: white;
    background-color: #0d6efd;
}

.k-panelbar > .k-item > .k-link.k-selected .k-icon,
.k-panelbar > .k-item > .k-link.k-selected .k-panelbar-item-icon,
.k-panelbar > .k-panelbar-header > .k-link.k-selected .k-icon,
.k-panelbar > .k-panelbar-header > .k-link.k-selected .k-panelbar-item-icon {
    color: inherit;
}

.k-panelbar > .k-item > .k-link.k-selected:hover,
.k-panelbar > .k-item > .k-link.k-selected.k-hover,
.k-panelbar > .k-panelbar-header > .k-link.k-selected:hover,
.k-panelbar > .k-panelbar-header > .k-link.k-selected.k-hover {
    background-color: #0c65e9;
}

.k-panelbar .k-group > .k-item > .k-link:hover,
.k-panelbar .k-group > .k-item > .k-link.k-hover,
.k-panelbar .k-group > .k-panelbar-item > .k-link:hover,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-hover,
.k-panelbar .k-panelbar-group > .k-item > .k-link:hover,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-hover,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link:hover,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-hover {
    background-color: #ebebeb;
}

.k-panelbar .k-group > .k-item > .k-link:focus,
.k-panelbar .k-group > .k-item > .k-link.k-focus,
.k-panelbar .k-group > .k-panelbar-item > .k-link:focus,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-focus,
.k-panelbar .k-panelbar-group > .k-item > .k-link:focus,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-focus,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link:focus,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-panelbar .k-group > .k-item > .k-link.k-selected,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-selected,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-selected,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-selected {
    color: white;
    background-color: #0d6efd;
}

.k-panelbar .k-group > .k-item > .k-link.k-selected:hover,
.k-panelbar .k-group > .k-item > .k-link.k-selected.k-hover,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-selected:hover,
.k-panelbar .k-group > .k-panelbar-item > .k-link.k-selected.k-hover,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-selected:hover,
.k-panelbar .k-panelbar-group > .k-item > .k-link.k-selected.k-hover,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-selected:hover,
.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-selected.k-hover {
    background-color: #0c65e9;
}

.k-splitter {
    height: 300px;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: block;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-splitter .k-pane {
    overflow: hidden;
    box-sizing: border-box;
}

.k-splitter .k-scrollable {
    overflow: auto;
}

.k-splitter .k-splitter-resizing {
    overflow: hidden;
}

.k-pane > .k-splitter {
    border-width: 0;
    overflow: hidden;
}

.k-splitter .k-pane-loading {
    position: static;
    top: 50%;
    left: 50%;
}

.k-ghost-splitbar,
.k-splitbar {
    border-style: solid;
    outline: 0;
    position: absolute;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.k-ghost-splitbar .k-collapse-prev,
.k-ghost-splitbar .k-collapse-next,
.k-splitbar .k-collapse-prev,
.k-splitbar .k-collapse-next {
    cursor: pointer;
    padding: 0.125rem;
}

.k-splitbar-draggable-horizontal {
    cursor: col-resize;
}

.k-splitbar-draggable-vertical {
    cursor: row-resize;
}

.k-ghost-splitbar-horizontal,
.k-splitbar-horizontal {
    width: 0.75rem;
    border-width: 0;
    background-repeat: repeat-y;
    flex-direction: column;
    top: 0;
}

.k-ghost-splitbar-vertical,
.k-splitbar-vertical {
    height: 0.75rem;
    border-width: 0;
    background-repeat: repeat-x;
    flex-direction: row;
    left: 0;
}

.k-splitbar-static-horizontal {
    width: 1px;
}

.k-splitbar-static-vertical {
    height: 1px;
}

.k-splitbar-draggable-horizontal .k-resize-handle {
    width: 2px;
    height: 20px;
    position: static;
    z-index: 1;
}

.k-splitbar .k-resize-handle {
    display: none;
    background-color: currentColor;
}

.k-splitbar-draggable-horizontal .k-resize-handle,
.k-splitbar-draggable-vertical .k-resize-handle {
    display: block;
}

.k-splitbar-horizontal .k-collapse-prev {
    margin-bottom: 7px;
}

.k-splitbar-horizontal .k-collapse-next {
    margin-top: 7px;
}

.k-splitbar-vertical .k-collapse-prev {
    margin-right: 7px;
}

.k-splitbar-vertical .k-collapse-next {
    margin-left: 7px;
}

.k-splitbar-draggable-vertical .k-resize-handle {
    width: 20px;
    height: 2px;
    position: static;
    z-index: 1;
}

.k-pane > .k-splitter-overlay {
    opacity: 0;
    position: absolute;
}

.k-splitter-flex {
    display: flex;
    width: 100%;
    height: auto;
}

.k-splitter-flex .k-pane {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    min-height: 0;
    max-height: 100%;
    height: 100%;
}

.k-splitter-flex .k-pane-static {
    flex-grow: 0;
    flex-shrink: 0;
}

.k-splitter-flex .k-pane-flex {
    display: flex;
}

.k-splitter-flex .k-splitbar {
    position: static;
    flex: 0 0 auto;
}

.k-splitter-flex .k-pane.k-hidden, .k-splitter-flex .k-pane[hidden],
.k-splitter-flex .k-pane-flex.k-hidden,
.k-splitter-flex .k-pane-flex[hidden] {
    flex: 0 1 0% !important;
    overflow: hidden !important;
    display: block !important;
}

.k-splitter-flex.k-splitter-horizontal {
    flex-direction: row;
}

.k-splitter-flex.k-splitter-vertical {
    flex-direction: column;
}

.k-splitter {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-splitbar {
    color: #212529;
    background-color: #f8f9fa;
}

.k-splitbar:hover,
.k-splitbar.k-hover,
.k-splitbar-horizontal-hover,
.k-splitbar-vertical-hover {
    color: #212529;
    background-color: #eeeff0;
}

.k-splitbar:focus,
.k-splitbar.k-focus {
    color: white;
    background: #0d6efd;
}

.k-ghost-splitbar {
    background-color: #eeeff0;
}

.k-tilelayout {
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    display: grid;
    position: relative;
    padding: 1rem 1rem;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-tilelayout .k-card {
    box-shadow: none;
    border-width: 1px;
}

.k-tilelayout-item {
    position: relative;
    z-index: 0;
}

.k-layout-item-hint {
    border-radius: 0.375rem;
    border-width: 1px;
    border-style: solid;
    position: relative;
}

.k-layout-item-hint.k-layout-item-hint-resize {
    z-index: 3;
}

.k-tilelayout-item-header.k-card-header {
    z-index: 0;
}

.k-tilelayout-item-body {
    min-height: 0;
}

.k-tilelayout {
    background-color: #f8f9fa;
}

.k-tilelayout-item:focus,
.k-tilelayout-item.k-focus {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-layout-item-hint {
    border-color: #dee2e6;
    background-color: rgba(255, 255, 255, 0.2);
}

.k-dock-manager {
    width: 100%;
    height: 100%;
    border-width: 1px;
    border-style: solid;
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    overflow: auto;
    box-sizing: border-box;
}

.k-dock-manager-toolbar {
    border-width: 0 1px 0 0;
    border-color: inherit;
    flex-shrink: 0;
    -ms-writing-mode: tb-lr;
        writing-mode: vertical-lr;
    box-shadow: none;
}

.k-dock-manager-toolbar::before {
    height: 0;
}

.k-dock-manager-toolbar .k-separator-horizontal {
    width: 1.5em;
    height: 0;
    border-width: 1px 0 0;
}

.k-dock-manager-pane-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-grow: 1;
    overflow: hidden;
}

.k-dock-manager-splitter,
.k-dock-manager-unpinned-container {
    height: 100%;
    border-width: 0;
    align-items: stretch;
}

.k-dock-manager-splitter > .k-pane,
.k-dock-manager-unpinned-container > .k-pane {
    height: auto;
    flex-direction: column;
    border-color: inherit;
}

.k-dock-manager-splitter .k-pane-header,
.k-dock-manager-unpinned-container .k-pane-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    border-block-end-width: 1px;
    border-block-end-style: solid;
    border-color: inherit;
}

.k-dock-manager-splitter .k-pane-title,
.k-dock-manager-unpinned-container .k-pane-title {
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1.25rem;
    line-height: 1.25;
    font-weight: 400;
    flex: 1 1 auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.k-dock-manager-splitter .k-pane-scrollable,
.k-dock-manager-unpinned-container .k-pane-scrollable {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-color: inherit;
}

.k-dock-manager-splitter .k-pane-content,
.k-dock-manager-unpinned-container .k-pane-content {
    height: 100%;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    overflow: auto;
    flex: 1;
}

.k-dock-manager-splitter .k-pane-actions,
.k-dock-manager-unpinned-container .k-pane-actions {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
}

.k-dock-manager-splitter .k-pane-tabbed,
.k-dock-manager-unpinned-container .k-pane-tabbed {
    padding-block-start: 0.875rem;
    padding-block-end: 0.5rem;
    padding-inline: 0.5rem;
}

.k-dock-manager-splitter .k-splitbar,
.k-dock-manager-unpinned-container .k-splitbar {
    border-width: 0 1px;
    border-style: solid;
    border-color: inherit;
}

.k-dock-manager-splitter .k-splitbar-vertical,
.k-dock-manager-unpinned-container .k-splitbar-vertical {
    border-width: 1px 0;
}

.k-dock-manager-unpinned-container {
    width: 300px;
    position: absolute;
    display: flex;
    height: 100%;
    border-color: inherit;
    z-index: 20;
}

.k-dock-manager-unpinned-container .k-pane {
    display: inline-flex;
    flex-direction: column;
    position: relative;
    flex: 1 1 auto;
}

.k-dock-manager-unpinned-container .k-splitbar {
    height: 100%;
    position: relative;
    flex: none;
}

.k-docking-preview {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    border-width: 1px;
    border-style: dashed;
    border-radius: 0.25rem;
    z-index: 10;
}

.k-dock-navigator-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    z-index: 10001;
    pointer-events: none;
}

.k-dock-navigator {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: repeat(3, auto);
    justify-content: center;
    position: absolute;
}

.k-dock-indicator {
    padding: 0.375rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    position: relative;
    pointer-events: all;
    outline-width: 1px;
    outline-style: solid;
}

.k-dock-indicator.k-dock-indicator-middle {
    filter: none;
}

.k-dock-indicator-top {
    grid-area: 1 / 2 / auto;
}

.k-dock-indicator-right {
    grid-area: 2 / 3 / auto;
}

.k-dock-indicator-bottom {
    grid-area: 3 / 2 / auto;
}

.k-dock-indicator-left {
    grid-area: 2 / 1 / auto;
}

.k-dock-indicator-middle {
    grid-area: 2 / 2 / auto;
}

.k-dock-manager {
    border-color: #e4e5e6;
}

.k-dock-manager-splitter .k-pane-header,
.k-dock-manager-unpinned-container .k-pane-header {
    background-color: #ffffff;
}

.k-dock-manager-unpinned-container {
    background-color: #ffffff;
    box-shadow: 4px 0px 5px 0px rgba(0, 0, 0, 0.04), 2px 0px 4px 0px rgba(0, 0, 0, 0.03);
}

.k-docking-preview {
    background-color: rgba(13, 110, 253, 0.16);
    border-color: #0d6efd;
}

.k-dock-indicator {
    color: #0d6efd;
    background-color: #ffffff;
    outline-color: #0d6efd;
    filter: drop-shadow(0px 1px 18px rgba(0, 0, 0, 0.12)) drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.14)) drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.2));
}

.k-dock-indicator:hover, .k-dock-indicator.k-hover {
    background-color: #0d6efd;
    color: #ffffff;
}

.k-pane-wrapper {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: block;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-pane-wrapper .k-pane {
    width: 100%;
    height: 100%;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    box-sizing: border-box;
    font-family: sans-serif;
    overflow-x: hidden;
}

.k-pane-wrapper .k-view {
    top: 0;
    left: 0;
    position: relative;
    border: 0;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    align-content: stretch;
    vertical-align: top;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-pane-wrapper .k-content {
    min-height: 1px;
    flex: 1;
    align-items: stretch;
    display: block;
    width: auto;
    overflow: hidden;
    position: relative;
}

.k-pane-wrapper > div.k-pane {
    box-shadow: none;
    font-weight: normal;
}

.k-pane-wrapper .k-popup-edit-form .k-content,
.k-pane-wrapper .k-grid-edit-form .k-content,
.k-pane-wrapper .k-grid-header-menu .k-content,
.k-pane-wrapper .k-grid-filter-menu .k-content {
    overflow-y: auto;
}

.k-pane-wrapper .k-popup-edit-form .k-content > .k-scroll-container,
.k-pane-wrapper .k-grid-edit-form .k-content > .k-scroll-container,
.k-pane-wrapper .k-grid-header-menu .k-content > .k-scroll-container,
.k-pane-wrapper .k-grid-filter-menu .k-content > .k-scroll-container {
    position: absolute;
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
}

.k-pane-wrapper .k-grid-edit-form .k-popup-edit-form,
.k-pane-wrapper .k-grid-edit-form .k-edit-form-container {
    width: auto;
    min-width: auto;
}

.k-grid.k-grid-mobile {
    border-width: 0;
}

.k-grid-mobile .k-resize-handle-inner::before {
    content: "\\e01e";
    position: absolute;
    font: 16px/1 "WebComponentsIcons";
    top: calc(50% - 1px);
    left: 50%;
    transform: translate(-50%, -50%);
    padding: .2em;
}

.k-grid-mobile .k-header a {
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-pane-wrapper .k-scheduler-edit-form .k-recur-view {
    padding: 0;
    flex-direction: column;
    align-items: stretch;
}

.k-pane-wrapper .k-scheduler-edit-form .k-recur-view > .k-listgroup-form-row {
    margin: 0;
}

.k-pane-wrapper .k-scheduler-edit-form .k-recur-items-wrap {
    width: 100%;
    margin-block: -1px;
    margin-inline: 0;
}

.k-pane-wrapper .k-scheduler-edit-form .k-scheduler-recur-end-wrap {
    white-space: nowrap;
}

.k-scheduler.k-scheduler-mobile {
    border-width: 0;
}

.k-scheduler-mobile th {
    font-weight: normal;
}

.k-scheduler-mobile .k-event:hover .k-resize-handle {
    visibility: hidden;
}

.k-scheduler-mobile .k-scheduler-toolbar {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-scheduler-mobile .k-scheduler-toolbar > * {
    margin: 0;
}

.k-scheduler-mobile .k-scheduler-toolbar::before {
    display: none;
}

.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-navigation {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin: 0;
}

.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-navigation .k-nav-current {
    line-height: 1;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: space-evenly;
    gap: 0;
}

.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-views-wrapper .k-views-dropdown {
    display: inline-block;
}

.k-scheduler-mobile .k-scheduler-footer {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    display: flex;
    justify-content: space-between;
}

.k-scheduler-mobile .k-scheduler-footer > * {
    margin: 0;
}

.k-scheduler-mobile .k-scheduler-footer::before {
    display: none;
}

.k-scheduler-mobile .k-scheduler-monthview .k-hidden {
    height: 40px;
}

.k-scheduler-mobile .k-scheduler-monthview .k-scheduler-table td {
    height: 40px;
    vertical-align: top;
    text-align: center;
}

.k-scheduler-mobile .k-scheduler-monthview .k-events-container {
    position: absolute;
    text-align: center;
    height: 6px;
    line-height: 6px;
}

.k-scheduler-mobile .k-scheduler-monthview .k-event {
    position: static;
    padding: 4px;
    border-radius: 50%;
    display: inline-block;
    width: 4px;
    height: 4px;
    min-height: 0;
    margin: 1px;
}

.k-scheduler-mobile .k-scheduler-dayview .k-mobile-header.k-mobile-horizontal-header .k-scheduler-times table tr:first-child {
    display: none;
}

.k-scheduler-mobile .k-scheduler-dayview .k-mobile-header .k-scheduler-header .k-scheduler-date-group {
    display: none;
}

.k-scheduler-mobile .k-scheduler-header-wrap > div {
    overflow: visible;
}

.k-scheduler-mobile .k-scheduler-agendaview .k-mobile-header {
    display: none;
}

.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table {
    table-layout: auto;
}

.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table .k-scheduler-groupcolumn {
    width: 1%;
}

.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table td {
    white-space: normal;
}

.k-scheduler-mobile .k-mobile-header .k-scheduler-table td,
.k-scheduler-mobile .k-mobile-header .k-scheduler-table th {
    height: 1.5em;
}

.k-scheduler-mobile .k-time-text,
.k-scheduler-mobile .k-time-period {
    display: block;
    line-height: 1;
}

.k-scheduler-mobile .k-time-period {
    font-size: .7em;
}

.k-scheduler-mobile .k-scheduler-table td,
.k-scheduler-mobile .k-scheduler-table th {
    height: 2em;
    vertical-align: middle;
}

.k-scheduler-mobile .k-scheduler-datecolumn-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.k-scheduler-mobile .k-task {
    display: flex;
    align-items: center;
    gap: .5em;
}

.k-scheduler-mobile .k-task .k-scheduler-mark {
    border-radius: 50%;
    margin: 0;
}

.k-scheduler-mobile .k-task .k-scheduler-task-text {
    flex: 1 1 0%;
}

.k-scheduler-mobile .k-scheduler-times .k-scheduler-group-cell,
.k-scheduler-mobile .k-scheduler-times .k-scheduler-groupcolumn,
.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-group-cell,
.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-groupcolumn {
    vertical-align: top;
}

.k-scheduler-mobile .k-scheduler-times .k-scheduler-group-cell .k-scheduler-group-text,
.k-scheduler-mobile .k-scheduler-times .k-scheduler-groupcolumn .k-scheduler-group-text,
.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-group-cell .k-scheduler-group-text,
.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-groupcolumn .k-scheduler-group-text {
    -ms-writing-mode: tb-lr;
        writing-mode: vertical-lr;
    transform: rotate(180deg);
    white-space: nowrap;
}

.k-scheduler-mobile .k-scrollbar-h tr + tr .k-scheduler-times {
    border-bottom-width: 0;
}

.k-pane-wrapper .k-appbar {
    padding: 0.25rem;
}

.k-pane-wrapper .k-list-title,
.k-pane-wrapper .k-filter-help-text {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    display: block;
}

.k-pane-wrapper .k-listgroup-title {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    font-weight: bold;
    text-transform: uppercase;
}

.k-pane-wrapper .k-listgroup .k-listgroup-item {
    border-color: inherit;
}

.k-pane-wrapper .k-listgroup + .k-listgroup {
    margin-top: 1rem;
}

.k-pane-wrapper .k-column-menu {
    padding: 0.5rem;
    display: flex;
    flex-flow: column nowrap;
    gap: 0.5rem;
}

.k-pane-wrapper .k-column-menu .k-filter-item .k-filterable * {
    pointer-events: none;
}

.k-pane-wrapper .k-column-menu .k-list-title,
.k-pane-wrapper .k-column-menu .k-listgroup-title {
    padding: 0;
}

.k-pane-wrapper .k-column-menu .k-listgroup {
    margin-inline: -0.5rem;
}

.k-pane-wrapper .k-filter-menu {
    padding: 0.5rem;
    display: flex;
    flex-flow: column nowrap;
    gap: 0.5rem;
}

.k-pane-wrapper .k-filter-menu .k-list-title {
    padding: 0;
}

.k-pane-wrapper .k-filter-menu .k-list-filter {
    padding: 0;
    display: flex;
    flex-flow: column nowrap;
    gap: inherit;
}

.k-pane-wrapper .k-filter-menu .k-filter-tools {
    display: flex;
    flex-flow: row nowrap;
    gap: inherit;
}

.k-pane-wrapper .k-filter-menu .k-listgroup {
    margin-inline: -0.5rem;
}

.k-pane-wrapper .k-popup-edit-form .k-recur-editor-wrap {
    display: flex;
}

.k-pane-wrapper .k-popup-edit-form .k-mobiletimezoneeditor {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    flex: 1 1 auto;
}

.k-pane-wrapper .k-multicheck-wrap.k-listgroup {
    overflow-y: auto;
}

.k-pane-wrapper .k-pager-wrap.k-pager-sm,
.k-pane-wrapper .k-pager.k-pager-sm {
    justify-content: center;
}

.k-pane-wrapper .k-pager-wrap.k-pager-sm .k-pager-refresh,
.k-pane-wrapper .k-pager.k-pager-sm .k-pager-refresh {
    display: none;
}

.k-rtl .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar > ul > li, .k-pane-wrapper[dir="rtl"] .k-scheduler-mobile .k-scheduler-toolbar > ul > li,
[dir="rtl"] .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar > ul > li {
    border: 0;
}

.k-rtl .k-pane-wrapper .k-scheduler-mobile .k-task .k-i-reload, .k-pane-wrapper[dir="rtl"] .k-scheduler-mobile .k-task .k-i-reload,
[dir="rtl"] .k-pane-wrapper .k-scheduler-mobile .k-task .k-i-reload {
    margin-left: .5em;
    margin-right: 0;
}

.k-pane-wrapper,
.k-view {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-pane-wrapper .k-pane > .k-view > .k-content {
    background-position: 50% 50%;
    background-color: #fafafa;
}

.k-pane-wrapper .k-pane .k-grid-mobile .k-column-active + th.k-header {
    border-left-color: #212529;
}

.k-pane-wrapper .k-pane .k-grid-mobile .k-resize-handle-inner::before {
    background-color: #f8f9fa;
}

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-nav-current {
    color: #0d6efd;
}

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendadate {
    color: inherit;
}

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-time-period,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendaweekday {
    color: #6c757d;
}

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-wrap,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-datecolumn,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-group-cell,
.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-all-day {
    background-color: #fafafa;
}

.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-tools > li {
    display: inline-block;
    background-color: inherit;
}

.k-pane-wrapper .k-pane .k-grid-edit-form .k-item,
.k-pane-wrapper .k-pane .k-grid-edit-form .k-link,
.k-pane-wrapper .k-pane .k-grid-header-menu .k-item,
.k-pane-wrapper .k-pane .k-grid-header-menu .k-link,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-item,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-link,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-item,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-link {
    color: #212529;
}

.k-pane-wrapper .k-pane .k-grid-edit-form .k-clear,
.k-pane-wrapper .k-pane .k-grid-edit-form .k-select-all,
.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-delete,
.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-resetSeries,
.k-pane-wrapper .k-pane .k-grid-header-menu .k-clear,
.k-pane-wrapper .k-pane .k-grid-header-menu .k-select-all,
.k-pane-wrapper .k-pane .k-grid-header-menu .k-scheduler-delete,
.k-pane-wrapper .k-pane .k-grid-header-menu .k-scheduler-resetSeries,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-clear,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-select-all,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-delete,
.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-resetSeries,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-clear,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-select-all,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-delete,
.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-resetSeries {
    color: #0d6efd;
}

.k-pane-wrapper .k-pane .k-column-menu .k-listgroup-item.k-selected {
    color: #0d6efd;
    background: none;
}

.k-pane-wrapper .k-pane .k-column-menu .k-listgroup-item.k-selected .k-link {
    color: inherit;
}

.k-grid {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-grid.k-grid-display-block {
    display: block;
}

.k-grid .k-grid-container {
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
    position: relative;
}

.k-grid .k-grid-aria-root {
    border-color: inherit;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: hidden;
}

.k-grid .k-table {
    margin: 0;
    width: 100%;
    max-width: none;
    border-width: 0;
    border-color: inherit;
    border-collapse: separate;
    border-spacing: 0;
    box-sizing: content-box;
    empty-cells: show;
    outline: 0;
}

.k-grid .k-grid-header .k-table,
.k-grid .k-grid-content .k-table,
.k-grid .k-grid-content-locked .k-table,
.k-grid .k-grid-footer .k-table {
    table-layout: fixed;
}

.k-grid .k-table-thead,
.k-grid .k-table-tbody,
.k-grid .k-table-tfoot {
    text-align: start;
    border-color: inherit;
}

.k-grid .k-table-row {
    border-color: inherit;
}

.k-grid .k-table-th,
.k-grid td,
.k-grid .k-table-td {
    border-width: 0;
    border-inline-start-width: 1px;
    border-style: solid;
    border-color: inherit;
    outline: 0;
    font-weight: inherit;
    text-align: inherit;
    position: static;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: content-box;
}

.k-grid .k-table-th:first-child,
.k-grid td:first-child,
.k-grid .k-table-td:first-child {
    border-inline-start-width: 0;
}

.k-grid .k-table-th:focus,
.k-grid td:focus,
.k-grid .k-table-td:focus {
    outline: none;
}

.k-grid .k-table-th > .k-radio,
.k-grid .k-table-th > .k-radio-wrap,
.k-grid .k-table-th > .k-checkbox,
.k-grid .k-table-th > .k-checkbox-wrap,
.k-grid td > .k-radio,
.k-grid td > .k-radio-wrap,
.k-grid td > .k-checkbox,
.k-grid td > .k-checkbox-wrap,
.k-grid .k-table-td > .k-radio,
.k-grid .k-table-td > .k-radio-wrap,
.k-grid .k-table-td > .k-checkbox,
.k-grid .k-table-td > .k-checkbox-wrap {
    vertical-align: top;
}

.k-grid .k-table-th {
    border-block-end-width: 1px;
    white-space: nowrap;
}

.k-grid td,
.k-grid .k-table-td {
    border-block-end-width: 0px;
    white-space: unset;
    vertical-align: middle;
}

.k-grid a {
    color: inherit;
    text-decoration: none;
}

.k-grid a:hover {
    text-decoration: none;
}

.k-grid .k-grid-header-wrap {
    box-sizing: content-box;
}

.k-grid .k-grid-header {
    border-bottom-width: 1px;
}

.k-grid .k-grid-header .k-table {
    margin-bottom: -1px;
}

.k-grid .k-grid-header.k-grid-draggable-header {
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    touch-action: none;
}

.k-grid .k-grid-header .k-table-th {
    position: relative;
    vertical-align: bottom;
    cursor: default;
}

.k-grid .k-grid-header .k-table-th:first-child {
    border-inline-start-width: 0;
}

.k-grid .k-grid-header .k-table-th.k-first {
    border-inline-start-width: 1px;
}

.k-grid .k-grid-header .k-table-th > .k-link {
    line-height: inherit;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    outline: 0;
}

.k-grid .k-grid-header .k-table-th > .k-link:focus {
    text-decoration: none;
}

.k-grid .k-grid-header .k-grid-filter,
.k-grid .k-grid-header .k-header-column-menu,
.k-grid .k-grid-header .k-grid-header-menu {
    box-sizing: border-box;
    outline: 0;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    position: absolute;
    inset-inline-end: 0.5rem;
    z-index: 1;
}

.k-grid .k-grid-header .k-grid-filter:hover,
.k-grid .k-grid-header .k-header-column-menu:hover,
.k-grid .k-grid-header .k-grid-header-menu:hover {
    cursor: pointer;
}

.k-grid .k-grid-header .k-cell-inner > .k-link > .k-sort-icon {
    vertical-align: text-top;
    margin-inline-start: calc(1rem - 1px);
}

.k-grid .k-grid-header .k-cell-inner > .k-link > .k-sort-icon .k-icon {
    display: flex;
}

.k-grid .k-grid-header .k-sort-order {
    display: inline-block;
    vertical-align: top;
    height: 16px;
    font-size: 12px;
    margin-top: 2px;
    margin-inline-start: -2px;
}

.k-grid .k-grid-header .k-filterable > .k-cell-inner .k-link {
    padding-inline-end: 0;
}

.k-grid .k-cell-inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: inherit;
    overflow: hidden;
}

.k-grid .k-cell-inner > .k-link {
    width: auto;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: inherit;
    flex: 1;
    overflow: hidden;
}

.k-grid .k-cell-inner > .k-link > .k-sort-icon {
    margin-inline-start: 0;
    display: inline-block;
    flex-shrink: 0;
}

.k-grid .k-cell-inner .k-sort-order {
    flex-shrink: 0;
    line-height: normal;
}

.k-grid .k-cell-inner .k-grid-filter,
.k-grid .k-cell-inner .k-header-column-menu,
.k-grid .k-cell-inner .k-grid-header-menu {
    position: static;
    margin-inline-end: 0.5rem;
}

.k-grid .k-group-col,
.k-grid .k-hierarchy-col {
    padding: 0;
    width: 32px;
}

.k-grid .k-grouping-row p {
    margin: 0;
    display: flex;
    align-items: center;
    align-content: center;
}

.k-grid .k-grouping-row td,
.k-grid .k-grouping-row .k-table-td {
    overflow: visible;
}

.k-grid .k-grouping-row + .k-table-row td,
.k-grid .k-grouping-row + .k-table-row .k-table-td {
    border-top-width: 1px;
}

.k-grid .k-grouping-row .k-group-cell,
.k-grid .k-grouping-row + .k-table-row .k-group-cell {
    border-top-width: 0;
    text-overflow: clip;
}

.k-grid .k-grouping-row .k-icon {
    margin-inline-start: calc(8px - 0.5rem);
    margin-inline-end: 8px;
    text-decoration: none;
}

.k-grid .k-table .k-group-footer td,
.k-grid .k-table .k-group-footer .k-table-td {
    border-style: solid;
    border-width: 1px 0;
}

.k-grid .k-group-footer .k-group-cell + td,
.k-grid .k-group-footer .k-group-cell + .k-table-td {
    border-inline-start-width: 1px;
}

.k-grid .k-hierarchy-cell,
.k-grid .k-drag-cell {
    text-align: center;
    overflow: visible;
}

.k-grid .k-hierarchy-cell > .k-font-icon,
.k-grid .k-drag-cell > .k-font-icon {
    padding-block: 0.5rem;
    padding-inline: 0;
    width: 100%;
    height: 100%;
    display: inline-block;
    outline: 0;
}

.k-grid .k-hierarchy-cell + .k-grid-content-sticky {
    border-inline-start-width: 1px;
}

.k-grid .k-detail-row .k-detail-cell {
    border-inline-start-width: 0;
}

.k-grid .k-dirty-cell {
    position: relative;
}

.k-grid .k-dirty-cell.k-edit-cell {
    position: static;
}

.k-grid .k-dirty-cell.k-grid-content-sticky {
    position: sticky;
}

.k-grid .k-dirty {
    border-width: 5px;
    border-color: transparent;
    border-block-start-color: currentColor;
    border-inline-start-color: currentColor;
    inset-inline-start: 0;
    inset-inline-end: auto;
}

.k-grid .k-grid-content-locked + .k-grid-content {
    box-sizing: content-box;
}

.k-grid .k-grid-content-expander {
    position: absolute;
    visibility: hidden;
    height: 1px;
    bottom: 1px;
}

.k-grid .k-grid-filter,
.k-grid .k-header-column-menu,
.k-grid .k-grid-header-menu,
.k-grid .k-hierarchy-cell .k-icon {
    border-width: 0;
}

.k-grid .k-drag-col {
    padding: 0;
    width: 48px;
}

.k-grid .k-drag-cell {
    cursor: move;
}

.k-grid-toolbar {
    border-width: 0 0 1px;
    flex-shrink: 0;
}

.k-grid-toolbar-bottom {
    border-width: 1px 0 0;
}

.k-grouping-header {
    border-width: 0 0 1px;
    border-style: solid;
    border-color: inherit;
    white-space: normal;
    display: flex;
    align-items: center;
    position: relative;
    flex-wrap: wrap;
}

.k-grouping-header::before {
    content: "";
    height: calc(1.25em + 0.5rem + 2px);
    display: inline-block;
    vertical-align: middle;
}

.k-grouping-header .k-chip-list {
    flex-grow: 0;
    display: contents;
}

.k-grouping-header > .k-grouping-drop-container {
    flex-grow: 1;
    padding-block: 0.5rem;
    margin-block: -0.5rem;
    display: inline-flex;
    align-self: stretch;
    align-items: center;
}

.k-grouping-dropclue {
    width: 12px;
    position: absolute;
    top: 3px;
    box-sizing: content-box;
}

.k-grouping-dropclue::before, .k-grouping-dropclue::after {
    display: inline-block;
    content: "";
    position: absolute;
}

.k-grouping-dropclue::before {
    border-width: 6px;
    border-style: solid;
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    top: 0;
}

.k-grouping-dropclue::after {
    width: 2px;
    height: calc(100% - 6px);
    top: 6px;
    inset-inline-start: 5px;
}

.k-grid-header-wrap,
.k-grid-footer-wrap {
    margin-inline-end: -1px;
    width: 100%;
    border-width: 0;
    border-inline-end-width: 1px;
    border-style: solid;
    border-color: inherit;
    position: relative;
    overflow: hidden;
}

.k-grid-header-locked + .k-grid-header-wrap.k-auto-scrollable {
    margin-inline-end: 0;
}

.k-grid-header,
.k-grid-footer {
    padding-inline-start: 0;
    padding-inline-end: var(--kendo-scrollbar-width, 17px);
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    flex: 0 0 auto;
}

div.k-grid-header,
div.k-grid-footer {
    display: flex;
    flex-direction: row;
    align-items: stretch;
}

.k-column-resizer {
    width: .5em;
    height: 1000%;
    display: block;
    position: absolute;
    top: 0;
    inset-inline-end: 0;
    cursor: col-resize;
}

.k-row-resizer {
    display: block;
    height: 0.125rem;
    width: 100%;
    background: none;
}

.k-grid-footer {
    border-top-width: 1px;
}

.k-grid-footer td,
.k-grid-footer .k-table-td {
    height: 1.5em;
}

.k-grid-footer td,
.k-group-footer td,
.k-grouping-row td,
.k-grid-footer .k-table-td,
.k-group-footer .k-table-td,
.k-grouping-row .k-table-td {
    font-weight: bold;
}

.k-grid-filter-popup {
    min-width: 250px;
    max-width: 320px;
}

.k-grid-column-menu-standalone a.k-grid-filter {
    position: initial;
    display: inline-block;
    margin-block: -4px;
    margin-inline: 0;
    padding-block: 4px;
    padding-inline: 8px;
}

.k-filter-row {
    line-height: 1.5;
}

.k-filter-row td,
.k-filter-row .k-table-td,
.k-filter-row .k-table-th {
    border-width: 0;
    border-block-end-width: 1px;
    border-inline-start-width: 1px;
    white-space: nowrap;
}

.k-filter-row td:first-child,
.k-filter-row .k-table-td:first-child {
    border-inline-start-width: 0;
}

.k-filter-row .k-multiselect {
    height: auto;
}

.k-filtercell {
    width: auto;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}

.k-filtercell > span,
.k-filtercell .k-filtercell-wrapper {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    flex: 1 1 auto;
}

.k-filtercell > span > .k-button,
.k-filtercell .k-filtercell-wrapper > .k-button {
    flex: none;
}

.k-grid-content,
.k-grid-content-locked {
    border-color: inherit;
    outline: 0;
}

.k-grid-content .k-table-row:last-child > td,
.k-grid-content .k-table-row:last-child > .k-table-td,
.k-grid-content-locked .k-table-row:last-child > td,
.k-grid-content-locked .k-table-row:last-child > .k-table-td {
    border-bottom-width: 0;
}

.k-grid-content {
    width: 100%;
    min-height: 0;
    overflow: auto;
    overflow-x: auto;
    overflow-y: scroll;
    position: relative;
    flex: 1;
}

.k-virtual-scrollable-wrap {
    height: 100%;
    overflow-y: hidden;
    position: relative;
}

.k-grid .k-edit-cell,
.k-grid .k-command-cell,
.k-grid .k-grid-edit-row td,
.k-grid .k-grid-edit-row .k-table-td {
    text-overflow: clip;
}

.k-grid .k-edit-cell > input:not([type="checkbox"]):not([type="radio"]),
.k-grid .k-edit-cell > select,
.k-grid .k-edit-cell > .k-widget:not(.k-switch),
.k-grid .k-grid-edit-row td > input:not([type="checkbox"]):not([type="radio"]),
.k-grid .k-grid-edit-row td > select,
.k-grid .k-grid-edit-row td > .k-widget:not(.k-switch),
.k-grid .k-grid-edit-row .k-table-td > input:not([type="checkbox"]):not([type="radio"]),
.k-grid .k-grid-edit-row .k-table-td > select,
.k-grid .k-grid-edit-row .k-table-td > .k-widget:not(.k-switch) {
    width: 100%;
    vertical-align: middle;
    box-sizing: border-box;
}

.k-grid .k-edit-cell > .k-radio,
.k-grid .k-edit-cell > .k-checkbox,
.k-grid .k-edit-cell > .k-radio-wrap,
.k-grid .k-edit-cell > .k-checkbox-wrap,
.k-grid .k-grid-edit-row td > .k-radio,
.k-grid .k-grid-edit-row td > .k-checkbox,
.k-grid .k-grid-edit-row td > .k-radio-wrap,
.k-grid .k-grid-edit-row td > .k-checkbox-wrap,
.k-grid .k-grid-edit-row .k-table-td > .k-radio,
.k-grid .k-grid-edit-row .k-table-td > .k-checkbox,
.k-grid .k-grid-edit-row .k-table-td > .k-radio-wrap,
.k-grid .k-grid-edit-row .k-table-td > .k-checkbox-wrap {
    vertical-align: middle;
}

.k-grid .k-command-cell > .k-button {
    margin-inline-end: 0.5rem;
    vertical-align: middle;
}

.k-grid .k-command-cell > .k-button:last-child {
    margin-inline-end: unset;
}

.k-grid > .k-resize-handle,
.k-grid-header .k-resize-handle {
    height: 25px;
    cursor: col-resize;
    position: absolute;
    z-index: 2;
}

.k-selection-aggregates {
    border-width: 1px 0 0;
    border-style: solid;
    line-height: 1.5;
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}

.k-selection-aggregates-item-value {
    font-weight: 700;
}

.k-grid-pager {
    border-width: 1px 0 0;
    border-color: inherit;
    font-size: inherit;
}

.k-grid-pager-top {
    border-width: 0 0 1px;
}

.k-grid-virtual .k-grid-content .k-grid-table-wrap {
    float: left;
    width: 100%;
}

.k-grid-virtual .k-grid-content .k-grid-table {
    position: relative;
    float: left;
    z-index: 1;
}

.k-grid-virtual .k-grid-content > .k-height-container {
    position: relative;
    float: left;
}

.k-grid-virtual .k-grid-content::after {
    content: "";
    display: block;
    clear: both;
}

.k-width-container {
    position: absolute;
    visibility: hidden;
}

.k-width-container div {
    height: 1px;
}

.k-grid-add-row td,
.k-grid-add-row .k-table-td {
    border-bottom-style: solid;
    border-bottom-width: 1px;
}

.k-grid-lockedcolumns {
    white-space: nowrap;
}

.k-grid-content,
.k-grid-content-locked {
    white-space: normal;
}

.k-grid-content-locked,
.k-grid-footer-locked,
.k-grid-header-locked {
    flex: 0 0 auto;
    display: inline-block;
    vertical-align: top;
    overflow: hidden;
    position: relative;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: 1px;
    box-sizing: content-box;
}

.k-grid-content-locked + .k-grid-content.k-auto-scrollable,
.k-grid-footer-locked + .k-grid-content.k-auto-scrollable,
.k-grid-header-locked + .k-grid-content.k-auto-scrollable {
    display: inline-block;
}

.k-grid-content-locked .k-table,
.k-grid-footer-locked .k-table,
.k-grid-header-locked .k-table {
    border-width: 0;
}

.k-grid-content,
.k-grid-footer-wrap,
.k-grid-header-wrap {
    flex: 1 1 auto;
    display: inline-block;
    vertical-align: top;
}

.k-grid-content.k-auto-scrollable,
.k-grid-footer-wrap.k-auto-scrollable,
.k-grid-header-wrap.k-auto-scrollable {
    display: block;
}

.k-grid-header-locked > .k-grid-header-table,
.k-grid-header-wrap > .k-grid-header-table {
    margin-bottom: -1px;
}

.k-grid-header .k-table-th.k-grid-header-sticky,
.k-grid-header .k-filter-row .k-grid-header-sticky,
.k-grid .k-grid-content-sticky,
.k-grid .k-grid-row-sticky,
.k-grid .k-grid-footer-sticky {
    position: sticky;
    z-index: 2;
}

.k-grid-header .k-table-th.k-grid-header-sticky.k-edit-cell,
.k-grid-header .k-filter-row .k-grid-header-sticky.k-edit-cell,
.k-grid .k-grid-content-sticky.k-edit-cell,
.k-grid .k-grid-row-sticky.k-edit-cell,
.k-grid .k-grid-footer-sticky.k-edit-cell {
    overflow: visible;
    z-index: 3;
}

.k-master-row .k-grid-content-sticky::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}

kendo-grid .k-table-row.k-grid-row-sticky {
    border: 0;
    position: static;
    z-index: auto;
}

kendo-grid .k-grid-row-sticky td,
kendo-grid .k-grid-row-sticky .k-table-td {
    border-bottom-width: 1px;
    border-top-width: 1px;
    position: sticky;
    top: inherit;
    bottom: inherit;
    z-index: 2;
}

kendo-grid .k-grid-row-sticky td.k-grid-content-sticky,
kendo-grid .k-grid-row-sticky.k-table-alt-row td.k-grid-content-sticky,
kendo-grid .k-grid-row-sticky .k-table-td.k-grid-content-sticky,
kendo-grid .k-grid-row-sticky.k-table-alt-row .k-table-td.k-grid-content-sticky {
    z-index: 3;
}

kendo-grid .k-grid-header-locked .k-table-th.k-grid-header-sticky:last-child,
kendo-grid .k-grid-content-locked .k-table-row .k-grid-content-sticky:last-child {
    border-inline-end: 0;
}

kendo-grid .k-grid-header .k-grid-column-menu,
kendo-grid .k-grid-header .k-grid-header-menu {
    z-index: 1;
}

.k-grid-content-sticky.k-grid-row-sticky {
    z-index: 3;
}

.k-grid .k-table .k-grid-header-sticky,
.k-grid .k-table .k-grid-content-sticky,
.k-grid .k-table .k-grid-footer-sticky {
    border-inline-end-width: 1px;
}

.k-grid .k-table .k-grid-header-sticky:not([style*="display: none"]) + td,
.k-grid .k-table .k-grid-header-sticky:not([style*="display: none"]) + .k-table-td,
.k-grid .k-table .k-grid-header-sticky:not([style*="display: none"]) + .k-table-th,
.k-grid .k-table .k-grid-content-sticky:not([style*="display: none"]) + td,
.k-grid .k-table .k-grid-content-sticky:not([style*="display: none"]) + .k-table-td,
.k-grid .k-table .k-grid-content-sticky:not([style*="display: none"]) + .k-table-th,
.k-grid .k-table .k-grid-footer-sticky:not([style*="display: none"]) + td,
.k-grid .k-table .k-grid-footer-sticky:not([style*="display: none"]) + .k-table-td,
.k-grid .k-table .k-grid-footer-sticky:not([style*="display: none"]) + .k-table-th {
    border-inline-start-width: 0;
}

.k-grid .k-grid-row-sticky {
    border-bottom-width: 1px;
    border-top-width: 1px;
}

.k-grid-header-sticky.k-table-th.k-grid-no-left-border.k-first {
    border-inline-start-width: 0;
}

.k-grid.k-grid-no-scrollbar .k-grid-header-wrap,
.k-grid.k-grid-no-scrollbar .k-grid-footer-wrap {
    margin: 0;
    border-width: 0;
}

.k-grid.k-grid-no-scrollbar .k-grid-header,
.k-grid.k-grid-no-scrollbar .k-grid-footer {
    padding: 0;
}

.k-grid.k-grid-no-scrollbar .k-grid-content {
    overflow-y: auto;
}

.k-grid-norecords {
    text-align: center;
}

div.k-grid-norecords {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}

.k-grid-norecords-template {
    box-sizing: border-box;
    margin-block: 0;
    margin-inline: auto;
    width: 20em;
    height: 4em;
    border: 1px solid;
    line-height: 4em;
}

.k-column-title {
    min-width: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
    overflow: hidden;
}

.k-grid .k-grid-sm .k-table-th,
.k-grid-sm .k-table-th {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-grid .k-grid-sm td,
.k-grid .k-grid-sm .k-table-td,
.k-grid-sm td,
.k-grid-sm .k-table-td {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-grid .k-grid-sm .k-grouping-header,
.k-grid-sm .k-grouping-header {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    gap: 0.25rem;
}

.k-grid .k-grid-sm .k-grouping-header::before,
.k-grid-sm .k-grouping-header::before {
    margin-inline-start: -0.25rem;
}

.k-grid .k-grid-sm .k-grid-header .k-table-th > .k-link,
.k-grid-sm .k-grid-header .k-table-th > .k-link {
    margin-block: -0.25rem;
    margin-inline: -0.25rem;
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-grid .k-grid-sm .k-grid-header .k-grid-filter,
.k-grid .k-grid-sm .k-grid-header .k-header-column-menu,
.k-grid .k-grid-sm .k-grid-header .k-grid-header-menu,
.k-grid-sm .k-grid-header .k-grid-filter,
.k-grid-sm .k-grid-header .k-header-column-menu,
.k-grid-sm .k-grid-header .k-grid-header-menu {
    padding: 0.25rem;
    width: calc(1.4285714286em + 0.5rem + 2px);
    height: calc(1.4285714286em + 0.5rem + 2px);
    bottom: -0.125rem;
}

.k-grid .k-grid-sm .k-table-th > .k-cell-inner,
.k-grid-sm .k-table-th > .k-cell-inner {
    margin-block: -0.25rem;
    margin-inline: -0.25rem;
}

.k-grid .k-grid-sm .k-table-th > .k-cell-inner > .k-link,
.k-grid-sm .k-table-th > .k-cell-inner > .k-link {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-grid .k-grid-sm .k-grouping-row .k-icon,
.k-grid-sm .k-grouping-row .k-icon {
    margin-inline-start: calc(8px - 0.25rem);
}

.k-grid .k-grid-sm .k-grouping-dropclue,
.k-grid-sm .k-grouping-dropclue {
    height: calc(1.25em + 0.25rem + 8px);
}

.k-grid .k-grid-sm .k-hierarchy-cell,
.k-grid .k-grid-sm .k-drag-cell,
.k-grid-sm .k-hierarchy-cell,
.k-grid-sm .k-drag-cell {
    padding: 0;
}

.k-grid .k-grid-sm .k-hierarchy-cell > .k-icon,
.k-grid .k-grid-sm .k-drag-cell > .k-icon,
.k-grid-sm .k-hierarchy-cell > .k-icon,
.k-grid-sm .k-drag-cell > .k-icon {
    padding-block: 0.25rem;
    padding-inline: 0;
}

.k-grid .k-grid-sm .k-edit-cell,
.k-grid .k-grid-sm .k-command-cell,
.k-grid .k-grid-sm .k-grid-edit-row td,
.k-grid .k-grid-sm .k-grid-edit-row .k-table-td,
.k-grid-sm .k-edit-cell,
.k-grid-sm .k-command-cell,
.k-grid-sm .k-grid-edit-row td,
.k-grid-sm .k-grid-edit-row .k-table-td {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-grid .k-grid-sm .k-filter-row td,
.k-grid .k-grid-sm .k-filter-row .k-table-td,
.k-grid .k-grid-sm .k-filter-row .k-table-th,
.k-grid-sm .k-filter-row td,
.k-grid-sm .k-filter-row .k-table-td,
.k-grid-sm .k-filter-row .k-table-th {
    padding-block: 0.375rem;
    padding-inline: 0.375rem;
}

.k-grid .k-grid-sm .k-filtercell > span,
.k-grid .k-grid-sm .k-filtercell .k-filtercell-wrapper,
.k-grid-sm .k-filtercell > span,
.k-grid-sm .k-filtercell .k-filtercell-wrapper {
    gap: 0.125rem;
}

.k-grid .k-grid-sm .k-selection-aggregates,
.k-grid-sm .k-selection-aggregates {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-grid .k-grid-sm .k-resizer-wrap,
.k-grid-sm .k-resizer-wrap {
    display: block;
    width: 100%;
    padding-block-start: 0.125rem;
    padding-block-end: 0.25rem;
    position: absolute;
    background: none;
    cursor: row-resize;
    z-index: 2;
}

.k-grid .k-grid-md .k-table-th,
.k-grid-md .k-table-th {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-grid .k-grid-md td,
.k-grid .k-grid-md .k-table-td,
.k-grid-md td,
.k-grid-md .k-table-td {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-grid .k-grid-md .k-grouping-header,
.k-grid-md .k-grouping-header {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    gap: 0.5rem;
}

.k-grid .k-grid-md .k-grouping-header::before,
.k-grid-md .k-grouping-header::before {
    margin-inline-start: -0.5rem;
}

.k-grid .k-grid-md .k-grid-header .k-table-th > .k-link,
.k-grid-md .k-grid-header .k-table-th > .k-link {
    margin-block: -0.5rem;
    margin-inline: -0.5rem;
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-grid .k-grid-md .k-grid-header .k-grid-filter,
.k-grid .k-grid-md .k-grid-header .k-header-column-menu,
.k-grid .k-grid-md .k-grid-header .k-grid-header-menu,
.k-grid-md .k-grid-header .k-grid-filter,
.k-grid-md .k-grid-header .k-header-column-menu,
.k-grid-md .k-grid-header .k-grid-header-menu {
    padding: 0.375rem;
    width: calc(1.5em + 0.75rem + 2px);
    height: calc(1.5em + 0.75rem + 2px);
    bottom: 0.125rem;
}

.k-grid .k-grid-md .k-table-th > .k-cell-inner,
.k-grid-md .k-table-th > .k-cell-inner {
    margin-block: -0.5rem;
    margin-inline: -0.5rem;
}

.k-grid .k-grid-md .k-table-th > .k-cell-inner > .k-link,
.k-grid-md .k-table-th > .k-cell-inner > .k-link {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-grid .k-grid-md .k-grouping-row .k-icon,
.k-grid-md .k-grouping-row .k-icon {
    margin-inline-start: calc(8px - 0.5rem);
}

.k-grid .k-grid-md .k-grouping-dropclue,
.k-grid-md .k-grouping-dropclue {
    height: calc(1.25em + 0.5rem + 8px);
}

.k-grid .k-grid-md .k-hierarchy-cell,
.k-grid .k-grid-md .k-drag-cell,
.k-grid-md .k-hierarchy-cell,
.k-grid-md .k-drag-cell {
    padding: 0;
}

.k-grid .k-grid-md .k-hierarchy-cell > .k-icon,
.k-grid .k-grid-md .k-drag-cell > .k-icon,
.k-grid-md .k-hierarchy-cell > .k-icon,
.k-grid-md .k-drag-cell > .k-icon {
    padding-block: 0.5rem;
    padding-inline: 0;
}

.k-grid .k-grid-md .k-edit-cell,
.k-grid .k-grid-md .k-command-cell,
.k-grid .k-grid-md .k-grid-edit-row td,
.k-grid .k-grid-md .k-grid-edit-row .k-table-td,
.k-grid-md .k-edit-cell,
.k-grid-md .k-command-cell,
.k-grid-md .k-grid-edit-row td,
.k-grid-md .k-grid-edit-row .k-table-td {
    padding-block: 5px;
    padding-inline: 0.5rem;
}

.k-grid .k-grid-md .k-filter-row td,
.k-grid .k-grid-md .k-filter-row .k-table-td,
.k-grid .k-grid-md .k-filter-row .k-table-th,
.k-grid-md .k-filter-row td,
.k-grid-md .k-filter-row .k-table-td,
.k-grid-md .k-filter-row .k-table-th {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-grid .k-grid-md .k-filtercell > span,
.k-grid .k-grid-md .k-filtercell .k-filtercell-wrapper,
.k-grid-md .k-filtercell > span,
.k-grid-md .k-filtercell .k-filtercell-wrapper {
    gap: 0.25rem;
}

.k-grid .k-grid-md .k-selection-aggregates,
.k-grid-md .k-selection-aggregates {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.k-grid .k-grid-md .k-resizer-wrap,
.k-grid-md .k-resizer-wrap {
    display: block;
    width: 100%;
    padding-block-start: calc(5px - 0.125rem);
    padding-block-end: 5px;
    position: absolute;
    background: none;
    cursor: row-resize;
    z-index: 2;
}

.k-loading-pdf-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 100;
}

.k-loading-pdf-mask > .k-i-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 64px;
}

.k-loading-pdf-mask .k-loading-pdf-progress {
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.k-pdf-export .k-loading-pdf-mask {
    display: none;
}

.k-grid-pdf-export-element {
    position: absolute;
    left: -10000px;
    top: -10000px;
}

.k-grid-pdf-export-element .k-filter-row {
    display: none;
}

.k-pdf-export-shadow .k-grid {
    float: left;
    width: auto !important;
}

.k-pdf-export-shadow .k-grid,
.k-pdf-export-shadow .k-grid-content,
.k-pdf-export-shadow .k-grid-content-locked {
    height: auto !important;
    overflow: visible;
}

.k-pdf-export-shadow .k-grid-header-locked + .k-grid-header-wrap,
.k-pdf-export-shadow .k-grid-header-locked + .k-grid-content,
.k-pdf-export-shadow .k-grid-header-locked + .k-grid-footer-wrap {
    width: auto !important;
}

.k-pdf-export-shadow .k-grid-header,
.k-pdf-export-shadow .k-grid[data-role="grid"] .k-grid-footer {
    padding: 0 !important;
}

.k-filter-menu-popup {
    min-width: 250px;
    max-width: 320px;
}

.k-filter-menu {
    box-sizing: border-box;
}

.k-filter-menu-container {
    padding: 0.5rem;
    box-sizing: border-box;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    gap: 0.5rem;
}

.k-filter-menu-container .k-filter-and {
    width: min-content;
    align-self: start;
}

.k-filter-menu-container .k-actions, .k-filter-menu-container .k-edit-buttons,
.k-filter-menu-container .k-action-buttons,
.k-filter-menu-container .k-columnmenu-actions, .k-filter-menu-container .k-form-buttons {
    margin: 0;
    padding: 0;
}

.k-filter-menu-container kendo-numeric-filter-menu,
.k-filter-menu-container kendo-grid-string-filter-menu,
.k-filter-menu-container kendo-grid-date-filter-menu,
.k-filter-menu-container kendo-grid-numeric-filter-menu,
.k-filter-menu-container kendo-grid-filter-menu-input-wrapper,
.k-filter-menu-container kendo-treelist-string-filter-menu,
.k-filter-menu-container kendo-treelist-date-filter-menu,
.k-filter-menu-container kendo-treelist-numeric-filter-menu,
.k-filter-menu-container kendo-treelist-filter-menu-input-wrapper {
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    gap: 0.5rem;
}

.k-filter-menu.k-popup .k-filter-menu-container,
.k-grid-filter-popup.k-popup .k-filter-menu-container {
    min-width: 250px;
    max-width: 320px;
}

.k-popup .k-multicheck-wrap {
    margin: 0;
    padding: 0;
    max-height: 300px;
    white-space: nowrap;
    overflow: auto;
    list-style: none;
}

.k-popup .k-multicheck-wrap .k-item,
.k-popup .k-multicheck-wrap .k-check-all-wrap {
    padding-block: 0.25rem;
    padding-inline: 1rem;
    display: flex;
    flex-flow: row nowrap;
}

.k-filter-selected-items {
    font-weight: bold;
    line-height: normal;
    white-space: nowrap;
}

.k-autofitting {
    width: auto !important;
    table-layout: auto !important;
}

.k-autofitting .k-table-th,
.k-autofitting td,
.k-autofitting .k-table-td {
    white-space: nowrap !important;
}

.k-autofitting .k-detail-row {
    display: none !important;
}

.k-column-menu-popup,
.k-grid-columnmenu-popup {
    min-width: 250px;
    box-sizing: border-box;
}

.k-column-menu-popup.k-popup,
.k-grid-columnmenu-popup.k-popup {
    max-width: 320px;
}

.k-column-menu-popup .k-actions, .k-column-menu-popup .k-edit-buttons,
.k-column-menu-popup .k-action-buttons,
.k-column-menu-popup .k-columnmenu-actions, .k-column-menu-popup .k-form-buttons,
.k-grid-columnmenu-popup .k-actions,
.k-grid-columnmenu-popup .k-edit-buttons,
.k-grid-columnmenu-popup .k-action-buttons,
.k-grid-columnmenu-popup .k-columnmenu-actions,
.k-grid-columnmenu-popup .k-form-buttons {
    margin: 0;
}

.k-column-menu {
    box-sizing: border-box;
}

.k-column-menu .k-menu:not(.k-context-menu) {
    font-weight: 400;
}

.k-column-menu .k-expander {
    border: 0;
    background: inherit;
}

.k-column-menu .k-expander .k-columnmenu-item {
    display: flex;
    align-items: center;
}

.k-column-menu-tabbed {
    border-radius: 0.25rem 0.25rem 0 0;
}

.k-column-menu-tabbed .k-tabstrip-items {
    margin: -1px -1px 0;
}

.k-column-menu-tabbed .k-tabstrip-items .k-item {
    flex: 1;
}

.k-column-menu-tabbed .k-tabstrip-items .k-link {
    justify-content: center;
}

.k-column-menu-tabbed .k-tabstrip-content {
    padding-inline: 0;
    padding-block: 0.5rem;
    border-width: 0;
}

.k-column-list {
    padding: 0;
    margin: 0;
    list-style: none;
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
}

.k-column-chooser-title,
.k-column-list-item {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-column-list-item {
    margin: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    position: relative;
}

.k-column-list-item .k-checkbox-label {
    margin: 0;
}

.k-column-list-item:focus {
    outline: none;
}

.k-columns-items-wrap {
    padding-block: 0.5rem;
    padding-inline: 0;
}

.k-columnmenu-item {
    padding-block: 0.25rem;
    padding-inline: 1rem;
    outline: 0;
    cursor: pointer;
}

.k-columnmenu-item > .k-icon,
.k-columnmenu-item > .k-expander-indicator {
    margin-inline-end: 0.5rem;
}

.k-columnmenu-item-wrapper + .k-columnmenu-item-wrapper {
    border-top: 1px solid;
    border-top-color: #dee2e6;
}

.k-columnmenu-item-content {
    overflow: hidden;
}

.k-column-menu-group-header {
    padding-block: 0.25rem;
    padding-inline: 1rem;
    display: flex;
    flex: 0 0 auto;
    position: relative;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-column-menu-group-header-text {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    font-size: 0.875rem;
    line-height: 1.5;
    font-weight: bold;
    text-transform: uppercase;
    flex: 1 1 auto;
}

.k-rtl .k-grid-virtual .k-grid-content .k-grid-table-wrap,
.k-rtl .k-grid-virtual .k-grid-content .k-grid-table,
.k-rtl .k-grid-virtual .k-grid-content > .k-height-container,
[dir="rtl"] .k-grid-virtual .k-grid-content .k-grid-table-wrap,
[dir="rtl"] .k-grid-virtual .k-grid-content .k-grid-table,
[dir="rtl"] .k-grid-virtual .k-grid-content > .k-height-container,
.k-rtl.k-grid-virtual .k-grid-content .k-grid-table-wrap,
.k-rtl.k-grid-virtual .k-grid-content .k-grid-table,
.k-rtl.k-grid-virtual .k-grid-content > .k-height-container,
[dir="rtl"].k-grid-virtual .k-grid-content .k-grid-table-wrap,
[dir="rtl"].k-grid-virtual .k-grid-content .k-grid-table,
[dir="rtl"].k-grid-virtual .k-grid-content > .k-height-container {
    float: right;
}

.k-grid {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-grid .k-table {
    background-color: inherit;
}

.k-grid td,
.k-grid .k-table-td,
.k-grid .k-grid-content,
.k-grid .k-grid-header-locked,
.k-grid .k-grid-content-locked {
    border-color: #dee2e6;
}

.k-grid .k-table-alt-row {
    background-color: rgba(0, 0, 0, 0.04);
}

.k-grid tbody > tr:not(.k-detail-row):hover,
.k-grid .k-table-tbody > .k-table-row:not(.k-detail-row).k-hover {
    background-color: rgba(0, 0, 0, 0.08);
}

.k-grid .k-table-th.k-selected,
.k-grid td.k-selected,
.k-grid .k-table-td.k-selected,
.k-grid .k-table-row.k-selected > td,
.k-grid .k-table-row.k-selected > .k-table-td {
    color: #212529;
    background-color: rgba(13, 110, 253, 0.25);
}

.k-grid .k-table-th:focus, .k-grid .k-table-th.k-focus,
.k-grid td:focus,
.k-grid td.k-focus,
.k-grid .k-table-td:focus,
.k-grid .k-table-td.k-focus,
.k-grid .k-master-row > td:focus,
.k-grid .k-master-row > td.k-focus,
.k-grid .k-grouping-row > td:focus,
.k-grid .k-grouping-row > td.k-focus,
.k-grid .k-detail-row > td:focus,
.k-grid .k-detail-row > td.k-focus,
.k-grid .k-group-footer > td:focus,
.k-grid .k-group-footer > td.k-focus,
.k-grid .k-master-row > .k-table-td:focus,
.k-grid .k-master-row > .k-table-td.k-focus,
.k-grid .k-grouping-row > .k-table-td:focus,
.k-grid .k-grouping-row > .k-table-td.k-focus,
.k-grid .k-detail-row > .k-table-td:focus,
.k-grid .k-detail-row > .k-table-td.k-focus,
.k-grid .k-group-footer > .k-table-td:focus,
.k-grid .k-group-footer > .k-table-td.k-focus,
.k-grid .k-grid-pager:focus,
.k-grid .k-grid-pager.k-focus {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);
}

.k-grid col.k-sorted,
.k-grid .k-table-th.k-sorted {
    background-color: rgba(0, 0, 0, 0.02);
}

.k-grid .k-grid-header-locked,
.k-grid .k-grid-content-locked,
.k-grid .k-grid-header-locked .k-header,
.k-grid .k-grid-content-locked td,
.k-grid .k-grid-content-locked .k-table-td {
    border-color: rgba(33, 37, 41, 0.5);
}

.k-grid .k-grid-header-locked .k-header {
    border-bottom-color: #dee2e6;
}

.k-grid .k-grid-content-locked .k-group-footer td,
.k-grid .k-grid-content-locked .k-group-footer .k-table-td,
.k-grid .k-grid-content-locked .k-group-cell {
    border-color: #dee2e6;
}

.k-grid .k-grid-content-locked .k-grouping-row + .k-table-row td,
.k-grid .k-grid-content-locked .k-grouping-row + .k-table-row .k-table-td {
    border-top-color: #dee2e6;
}

.k-grid .k-grid-content-locked .k-selected td,
.k-grid .k-grid-content-locked .k-selected .k-table-td {
    background-color: #c3dbff;
}

.k-grid .k-grid-content-locked .k-selected.k-table-alt-row td,
.k-grid .k-grid-content-locked .k-selected.k-table-alt-row .k-table-td {
    background-color: #bdd4f7;
}

.k-grid .k-grid-content-locked .k-selected:hover td,
.k-grid .k-grid-content-locked .k-selected.k-hover td,
.k-grid .k-grid-content-locked .k-selected:hover .k-table-td,
.k-grid .k-grid-content-locked .k-selected.k-hover .k-table-td {
    background-color: #b8cff1;
}

.k-grid-toolbar {
    border-color: inherit;
}

.k-grouping-header {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-grid-header {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-grid-header .k-sort-icon,
.k-grid-header .k-sort-order {
    color: #0d6efd;
}

.k-grid-header .k-grid-filter:focus, .k-grid-header .k-grid-filter.k-focus,
.k-grid-header .k-header-column-menu:focus,
.k-grid-header .k-header-column-menu.k-focus,
.k-grid-header .k-grid-header-menu:focus,
.k-grid-header .k-grid-header-menu.k-focus,
.k-grid-header .k-hierarchy-cell .k-icon:focus,
.k-grid-header .k-hierarchy-cell .k-icon.k-focus {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.k-grid-header .k-grid-filter.k-active,
.k-grid-header .k-header-column-menu.k-active,
.k-grid-header .k-grid-header-menu.k-active,
.k-grid-header .k-hierarchy-cell .k-icon.k-active {
    color: white;
    background-color: #0d6efd;
}

.k-grid-header .k-grid-header-sticky,
.k-grid-header .k-grid-header-sticky.k-sorted {
    color: #212529;
    background-color: #f8f9fa;
    border-right-color: rgba(33, 37, 41, 0.5);
    border-left-color: rgba(33, 37, 41, 0.5);
}

.k-selection-aggregates {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-master-row .k-grid-content-sticky {
    border-color: rgba(33, 37, 41, 0.5);
    color: #212529;
    background-color: #ffffff;
    border-top-color: #dee2e6;
}

.k-master-row .k-grid-row-sticky {
    border-top-color: rgba(33, 37, 41, 0.5);
    border-bottom-color: rgba(33, 37, 41, 0.5);
    background-color: #ffffff;
}

.k-master-row.k-table-alt-row .k-grid-content-sticky,
.k-master-row.k-table-alt-row .k-grid-row-sticky {
    background-color: whitesmoke;
}

.k-master-row.k-table-row.k-selected td.k-grid-content-sticky,
.k-master-row.k-table-row.k-selected .k-table-td.k-grid-row-sticky,
.k-master-row.k-table-row td.k-grid-content-sticky.k-selected,
.k-master-row.k-table-row .k-table-td.k-grid-content-sticky.k-selected {
    background-color: #c3dbff;
}

.k-master-row.k-selected.k-table-alt-row td.k-grid-content-sticky,
.k-master-row.k-selected.k-table-alt-row .k-table-td.k-grid-row-sticky,
.k-master-row.k-table-alt-row td.k-grid-content-sticky.k-selected,
.k-master-row.k-table-alt-row .k-table-td.k-grid-content-sticky.k-selected {
    background-color: #bdd4f7;
}

.k-master-row:hover .k-grid-content-sticky,
.k-master-row.k-hover .k-grid-content-sticky,
.k-master-row:hover .k-grid-row-sticky,
.k-master-row.k-hover .k-grid-row-sticky {
    background-color: #ebebeb;
}

.k-master-row.k-selected:hover td.k-grid-content-sticky,
.k-master-row.k-selected.k-hover .k-table-td.k-grid-content-sticky,
.k-master-row.k-selected:hover td.k-grid-row-sticky,
.k-master-row.k-selected.k-hover .k-table-td.k-grid-row-sticky,
.k-master-row:hover td.k-grid-content-sticky.k-selected,
.k-master-row.k-hover td.k-grid-content-sticky.k-selected,
.k-master-row:hover .k-table-td.k-grid-content-sticky.k-selected,
.k-master-row.k-hover .k-table-td.k-grid-content-sticky.k-selected {
    background-color: #b8cff1;
}

kendo-grid.k-grid .k-grid-content-sticky {
    border-top-color: #dee2e6;
    border-left-color: rgba(33, 37, 41, 0.5);
    border-right-color: rgba(33, 37, 41, 0.5);
    background-color: #ffffff;
}

kendo-grid.k-grid .k-grid-content-sticky:hover, kendo-grid.k-grid .k-grid-content-sticky.k-hover {
    background-color: #ebebeb;
}

kendo-grid.k-grid .k-grid-row-sticky td,
kendo-grid.k-grid .k-grid-row-sticky .k-table-td {
    border-top-color: rgba(33, 37, 41, 0.5);
    border-bottom-color: rgba(33, 37, 41, 0.5);
    background-color: #ffffff;
}

kendo-grid.k-grid .k-grid-row-sticky td:hover td,
kendo-grid.k-grid .k-grid-row-sticky td.k-hover td,
kendo-grid.k-grid .k-grid-row-sticky td:hover .k-table-td,
kendo-grid.k-grid .k-grid-row-sticky td.k-hover .k-table-td,
kendo-grid.k-grid .k-grid-row-sticky .k-table-td:hover td,
kendo-grid.k-grid .k-grid-row-sticky .k-table-td.k-hover td,
kendo-grid.k-grid .k-grid-row-sticky .k-table-td:hover .k-table-td,
kendo-grid.k-grid .k-grid-row-sticky .k-table-td.k-hover .k-table-td {
    background-color: #ebebeb;
}

kendo-grid.k-grid .k-table-alt-row .k-grid-content-sticky,
kendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row td,
kendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row .k-table-td {
    background-color: whitesmoke;
}

kendo-grid.k-grid .k-table-row.k-selected .k-grid-content-sticky,
kendo-grid.k-grid .k-selected.k-grid-row-sticky td,
kendo-grid.k-grid .k-grid-row-sticky td.k-selected,
kendo-grid.k-grid .k-selected.k-grid-row-sticky .k-table-td,
kendo-grid.k-grid .k-grid-row-sticky .k-table-td.k-selected,
kendo-grid.k-grid .k-selected.k-grid-content-sticky {
    background-color: #c3dbff;
}

kendo-grid.k-grid .k-table-row.k-selected.k-table-alt-row .k-grid-content-sticky,
kendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky td,
kendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky .k-table-td,
kendo-grid.k-grid .k-table-alt-row .k-selected.k-grid-content-sticky {
    background-color: #bdd4f7;
}

kendo-grid.k-grid .k-table-row:hover .k-grid-content-sticky,
kendo-grid.k-grid .k-table-row.k-hover .k-grid-content-sticky,
kendo-grid.k-grid .k-grid-row-sticky:hover td,
kendo-grid.k-grid .k-grid-row-sticky.k-hover td,
kendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row:hover td,
kendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row.k-hover td,
kendo-grid.k-grid .k-grid-row-sticky:hover .k-table-td,
kendo-grid.k-grid .k-grid-row-sticky.k-hover .k-table-td,
kendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row:hover .k-table-td,
kendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row.k-hover .k-table-td,
kendo-grid.k-grid .k-table-alt-row:hover .k-grid-content-sticky,
kendo-grid.k-grid .k-table-alt-row.k-hover .k-grid-content-sticky {
    background-color: #ebebeb;
}

kendo-grid.k-grid .k-table-row.k-selected:hover .k-grid-content-sticky,
kendo-grid.k-grid .k-table-row.k-selected.k-hover .k-grid-content-sticky,
kendo-grid.k-grid .k-selected.k-grid-row-sticky:hover td,
kendo-grid.k-grid .k-selected.k-grid-row-sticky.k-hover td,
kendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky:hover td,
kendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky.k-hover td,
kendo-grid.k-grid .k-selected.k-grid-row-sticky:hover .k-table-td,
kendo-grid.k-grid .k-selected.k-grid-row-sticky.k-hover .k-table-td,
kendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky:hover .k-table-td,
kendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky.k-hover .k-table-td,
kendo-grid.k-grid .k-table-row.k-selected.k-table-alt-row:hover .k-grid-content-sticky,
kendo-grid.k-grid .k-table-row.k-selected.k-table-alt-row.k-hover .k-grid-content-sticky,
kendo-grid.k-grid .k-grid-row-sticky:hover td.k-selected,
kendo-grid.k-grid .k-grid-row-sticky.k-hover td.k-selected,
kendo-grid.k-grid .k-grid-row-sticky:hover .k-table-td.k-selected,
kendo-grid.k-grid .k-grid-row-sticky.k-hover .k-table-td.k-selected,
kendo-grid.k-grid .k-table-row:hover .k-grid-content-sticky.k-selected,
kendo-grid.k-grid .k-table-row.k-hover .k-grid-content-sticky.k-selected {
    background-color: #b8cff1;
}

.k-grouping-row .k-grid-content-sticky {
    background-color: #f8f9fa;
}

.k-grouping-row:hover .k-grid-content-sticky,
.k-grouping-row.k-hover .k-grid-content-sticky {
    background-color: #ebebeb;
}

.k-group-footer td,
.k-group-footer .k-table-td,
.k-group-footer .k-grid-footer-sticky {
    background-color: #f8f9fa;
}

.k-group-footer:hover .k-grid-footer-sticky,
.k-group-footer.k-hover .k-grid-footer-sticky {
    background-color: #f8f9fa;
}

.k-grid-footer {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-grid-footer .k-grid-footer-locked {
    border-color: inherit;
}

.k-grid-footer .k-grid-footer-sticky {
    border-color: rgba(33, 37, 41, 0.5);
    background-color: #f8f9fa;
}

.k-grouping-row,
.k-group-cell {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-column-list-item:hover,
.k-columnmenu-item:hover {
    color: #212529;
    background-color: #e9ecef;
}

.k-column-list-item:focus,
.k-column-list-item.k-focus,
.k-columnmenu-item:focus,
.k-columnmenu-item.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-column-list-wrapper {
    border-color: inherit;
}

.k-columnmenu-item.k-selected {
    color: white;
    background-color: #0d6efd;
}

.k-column-menu .k-menu:not(.k-context-menu) {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-column-menu .k-menu:not(.k-context-menu) .k-item:hover, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-hover {
    color: #212529;
    background-color: #e9ecef;
}

.k-column-menu .k-menu:not(.k-context-menu) .k-item.k-selected {
    color: white;
    background-color: #0d6efd;
}

.k-column-menu .k-menu:not(.k-context-menu) .k-item:focus, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-column-menu-tabbed {
    background-color: #f8f9fa;
}

.k-column-menu-group-header-text {
    border-color: #dee2e6;
    color: #212529;
}

.k-check-all-wrap {
    border-color: #dee2e6;
}

.k-grid-norecords-template {
    background-color: #ffffff;
    border-color: #dee2e6;
}

.k-resizer-wrap.k-hover .k-row-resizer {
    background-color: rgba(0, 0, 0, 0.12);
}

.k-resizer-wrap.k-active .k-row-resizer {
    background-color: #0d6efd;
}

.k-listview {
    margin: 0;
    padding: 0;
    border-width: 0;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    flex-flow: column nowrap;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
}

.k-listview-bordered {
    border-width: 1px;
}

.k-listview-header {
    border-width: 0;
    border-style: solid;
    border-color: inherit;
}

.k-listview-bordered > .k-listview-header {
    border-bottom-width: 1px;
}

.k-listview-content {
    margin: 0;
    padding: 0;
    outline: 0;
    flex-grow: 1;
    position: relative;
    overflow: auto;
}

.k-listview-content::after {
    height: 0;
    clear: both;
    display: block;
}

.k-listview-content.k-d-flex::after, .k-listview-content.k-d-flex-row::after, .k-listview-content.k-d-flex-col::after,
.k-listview-content.k-d-grid::after {
    display: none;
}

.k-listview-content-padding-rectangle {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-listview-content-padding-square {
    padding: 0.25rem;
}

.k-listview-item {
    padding: 0;
    border-width: 0;
    outline: 0;
    border-style: solid;
    box-sizing: border-box;
    flex-shrink: 0;
}

.k-listview-item-padding-rectangle {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-listview-item-padding-rectangle .k-listview-link {
    margin-block: -0.25rem;
    margin-inline: -0.25rem;
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
}

.k-listview-item-padding-square {
    padding: 0.25rem;
}

.k-listview-item-padding-square .k-listview-link {
    margin: -0.25rem;
    padding: 0.25rem;
}

.k-listview-footer {
    border-width: 0;
    border-style: solid;
    border-color: inherit;
}

.k-listview-bordered > .k-listview-footer {
    border-top-width: 1px;
}

.k-listview-pager {
    border-width: 0;
    border-color: inherit;
}

.k-listview-bordered > .k-listview-pager-top {
    border-block-end-width: var(--kendo-listview-border-width, 1px);
}

.k-listview-bordered > .k-listview-pager-bottom {
    border-block-start-width: var(--kendo-listview-border-width, 1px);
}

.k-listview-borders-all .k-listview-item {
    border-width: 1px;
}

.k-listview-borders-horizontal .k-listview-item {
    border-top-width: 1px;
}

.k-listview-borders-horizontal .k-listview-item:first-child {
    border-top-width: 0;
}

.k-listview-borders-vertical .k-listview-item {
    border-left-width: 1px;
}

.k-listview-borders-vertical .k-listview-item:first-child {
    border-left-width: 0;
}

.k-listview {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-listview-content > .k-focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-listview-content > .k-selected {
    background-color: rgba(13, 110, 253, 0.25);
}

.k-listview-item {
    border-color: #dee2e6;
}

.k-spreadsheet {
    width: 800px;
    height: 600px;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    cursor: default;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-spreadsheet .k-vertical-align-center {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}

.k-spreadsheet .k-vertical-align-bottom {
    position: relative;
    top: 100%;
    transform: translateY(-100%);
}

.k-spreadsheet-toolbar {
    border-width: 0;
}

.k-spreadsheet-action-bar {
    border-width: 0 0 1px;
    border-style: solid;
    border-color: inherit;
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    font-size: 1rem;
    font-family: Arial, Verdana, sans-serif;
    position: relative;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.k-spreadsheet-name-editor {
    width: 10em;
}

.k-spreadsheet-formula-bar {
    min-width: 0px;
    border-color: inherit;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    gap: 0.5rem;
}

.k-spreadsheet-formula-bar > .k-icon {
    padding-block: 0;
    padding-inline: 0.5rem;
    box-sizing: content-box;
    border-width: 0 1px 0 0;
    border-style: solid;
    border-color: inherit;
    flex-shrink: 0;
}

.k-spreadsheet-formula-bar .k-tooltip,
.k-spreadsheet-formula-bar .k-group-header,
.k-spreadsheet-formula-bar .k-list-scroller {
    display: none;
}

.k-spreadsheet-formula-bar .k-spreadsheet-formula-input {
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
    line-height: 1.5;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-spreadsheet-formula-bar .k-spreadsheet-formula-input.k-spreadsheet-array-formula::before {
    content: "{";
    font-weight: 700;
}

.k-spreadsheet-formula-bar .k-spreadsheet-formula-input.k-spreadsheet-array-formula::after {
    content: "}";
    font-weight: 700;
}

.k-spreadsheet-formula-input {
    outline: 0;
    white-space: pre;
    flex: 1;
    box-sizing: border-box;
}

.k-spreadsheet-formula-input > .k-syntax-func.k-syntax-at-point,
.k-spreadsheet-formula-input > .k-syntax-bool.k-syntax-at-point,
.k-spreadsheet-formula-input > .k-syntax-ref.k-syntax-at-point,
.k-spreadsheet-formula-input > .k-syntax-str.k-syntax-at-point,
.k-spreadsheet-formula-input > .k-syntax-num.k-syntax-at-point {
    text-decoration: underline;
}

.k-spreadsheet-formula-input > .k-series-a,
.k-spreadsheet-formula-input > .k-series-b,
.k-spreadsheet-formula-input > .k-series-c,
.k-spreadsheet-formula-input > .k-series-d {
    background-color: transparent;
}

.k-spreadsheet-formula-list {
    min-width: 100px;
}

.k-spreadsheet-formula-list .k-item {
    padding-block: 0.25rem;
    padding-inline: 1rem;
}

.k-syntax-func,
.k-syntax-startexp {
    font-weight: bold;
}

.k-spreadsheet-cell-editor {
    padding-block: 0px;
    padding-inline: 0.25rem;
    line-height: 20px;
    display: none;
    overflow: hidden;
    position: absolute;
    z-index: 100;
}

.k-spreadsheet-sheets-bar {
    padding-block-end: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: inherit;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
}

.k-spreadsheet-sheets {
    flex: 1 1 auto;
    overflow: hidden;
}

.k-spreadsheet-sheets .k-tabstrip-items-wrapper {
    border-width: 0;
}

.k-spreadsheet-sheets-bar-add {
    align-self: center;
}

.k-spreadsheet-sheets-bar-add:not(:hover) {
    border-color: transparent;
    color: inherit;
    background: none;
}

.k-spreadsheet-sheets-items {
    flex: 1;
    overflow: hidden;
}

.k-spreadsheet-sheets-items .k-tabstrip-items-wrapper {
    margin: 0;
    border-width: 0;
}

.k-spreadsheet-sheets-items .k-item .k-link {
    display: inline-block;
}

.k-spreadsheet-sheets-items .k-item .k-spreadsheet-sheets-remove {
    margin-right: 0.5rem;
    margin-left: -0.5rem;
    padding: 0;
    line-height: 1;
    display: inline-flex;
    flex-direction: row;
    vertical-align: middle;
    align-self: center;
}

.k-spreadsheet-view {
    height: auto !important;
    border-color: inherit;
    font-size: 1rem;
    font-family: Arial, Verdana, sans-serif;
    flex: 1;
    position: relative;
    overflow: hidden;
}

.k-spreadsheet-view .k-disabled {
    pointer-events: auto;
}

.k-spreadsheet-fixed-container {
    width: calc(100% - var(--kendo-scrollbar-width, 17px));
    height: calc(100% - var(--kendo-scrollbar-width, 17px));
    border-color: inherit;
    box-sizing: border-box;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    position: absolute;
    z-index: 2;
    overflow: hidden;
}

.k-spreadsheet-overflow {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    border-color: inherit;
}

.k-spreadsheet-pane {
    padding: 0 1px 0 0;
    border-width: 2px 0 0 2px;
    border-style: solid;
    border-color: inherit;
    box-sizing: border-box;
    position: absolute;
    overflow: hidden;
}

.k-spreadsheet-pane.k-top {
    border-top-width: 0;
}

.k-spreadsheet-pane.k-left {
    border-left-width: 0;
}

.k-spreadsheet-top-corner {
    border-width: 0 1px 1px 0;
    border-style: solid;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000;
}

.k-spreadsheet-top-corner::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    right: 0;
    border: 6px solid transparent;
    border-right-color: inherit;
    border-bottom-color: inherit;
}

.k-spreadsheet-scroller {
    width: 100%;
    height: 100%;
    overflow: scroll;
    position: absolute;
    z-index: 1;
}

@media (hover: none), (pointer: coarse) {
    .k-spreadsheet-scroller {
        z-index: 3;
    }
}

.k-spreadsheet-haxis,
.k-spreadsheet-vaxis {
    border: 0 solid;
    border-color: inherit;
    position: absolute;
}

.k-spreadsheet-haxis {
    border-width: 1px 0 0;
    left: 0;
}

.k-spreadsheet-vaxis {
    border-width: 0 0 0 1px;
    top: 0;
}

.k-spreadsheet-row-header,
.k-spreadsheet-column-header {
    text-align: center;
    z-index: 100;
}

.k-spreadsheet-row-header > div,
.k-spreadsheet-column-header > div {
    position: relative;
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: inherit;
}

.k-spreadsheet-row-header > div::after,
.k-spreadsheet-column-header > div::after {
    content: "";
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.k-spreadsheet-row-header {
    position: relative;
}

.k-spreadsheet-column-header {
    position: absolute;
}

.k-spreadsheet-row-header > div {
    border-top-width: 1px;
}

.k-spreadsheet-row-header > div:first-child {
    border-top-width: 0;
}

.k-spreadsheet-row-header > .k-selection-partial::after,
.k-spreadsheet-row-header > .k-selection-full::after {
    border-right-width: 2px;
    display: block;
}

.k-spreadsheet-column-header > div {
    border-left-width: 1px;
}

.k-spreadsheet-column-header > div:first-child {
    border-left-width: 0;
}

.k-spreadsheet-column-header > .k-selection-partial::after,
.k-spreadsheet-column-header > .k-selection-full::after {
    border-bottom-width: 2px;
    display: block;
}

.k-spreadsheet-data {
    border-color: inherit;
    cursor: cell;
    position: relative;
}

.k-spreadsheet-cell {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    box-sizing: border-box;
    position: absolute;
    line-height: normal;
    white-space: pre;
    overflow: hidden;
}

.k-spreadsheet-merged-cells-wrapper {
    position: relative;
}

.k-spreadsheet-disabled-mask {
    position: absolute;
}

.k-spreadsheet .k-selection-wrapper {
    position: relative;
    cursor: cell;
}

.k-spreadsheet .k-spreadsheet-selection {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    position: absolute;
}

.k-spreadsheet .k-spreadsheet-selection-highlight {
    border-width: 2px;
    border-style: dashed;
    box-sizing: border-box;
    position: absolute;
}

.k-spreadsheet .k-spreadsheet-editor-button {
    position: absolute;
    padding: 0;
    z-index: 60;
}

.k-spreadsheet-active-cell {
    outline-color: transparent !important;
    z-index: 10;
}

.k-spreadsheet .k-auto-fill-wrapper {
    position: relative;
}

.k-spreadsheet .k-auto-fill,
.k-spreadsheet .k-auto-fill-punch,
.k-spreadsheet .k-auto-fill-br-hint {
    box-sizing: border-box;
    position: absolute;
}

.k-spreadsheet .k-auto-fill {
    border-width: 1px;
    border-style: solid;
    cursor: crosshair;
}

.k-spreadsheet .k-single-selection::after {
    content: "";
    margin-bottom: -4px;
    margin-right: -4px;
    width: 6px;
    height: 6px;
    border-width: 1px;
    border-style: solid;
    border-radius: 50%;
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 300;
    cursor: crosshair;
}

.k-spreadsheet .k-selection-full::after,
.k-spreadsheet .k-selection-partial::after {
    display: none;
}

.k-spreadsheet .k-autofill-wrapper {
    position: relative;
    cursor: cell;
}

.k-spreadsheet-vborder {
    position: absolute;
    border-left-style: solid;
    border-left-width: 1px;
}

.k-spreadsheet-hborder {
    position: absolute;
    border-top-style: solid;
    border-top-width: 1px;
}

.k-spreadsheet-has-comment::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    inset-inline-end: 0;
    inset-inline-start: auto;
    border-width: 3px;
    border-style: solid;
}

.k-spreadsheet-cell .k-dirty {
    inset-inline-start: 0;
    inset-inline-end: auto;
}

.k-spreadsheet .k-filter-wrapper {
    position: relative;
    z-index: 50;
}

.k-spreadsheet .k-filter-range {
    border-width: 2px;
    border-style: solid;
    position: absolute;
    box-sizing: border-box;
}

.k-spreadsheet-filter {
    border-radius: 0.375rem;
    padding: 0.5rem;
    line-height: 1;
    position: absolute;
    cursor: pointer;
}

.k-spreadsheet-filter .k-icon {
    vertical-align: middle;
}

.k-spreadsheet-filter-menu {
    width: 280px;
}

.k-spreadsheet-filter-menu .k-animation-container {
    position: relative;
}

.k-spreadsheet-filter-menu > .k-menu,
.k-spreadsheet-filter-menu > .k-menu.k-menu-vertical {
    border-width: 0;
}

.k-spreadsheet-filter-menu > .k-menu .k-item,
.k-spreadsheet-filter-menu > .k-menu.k-menu-vertical .k-item {
    color: inherit;
}

.k-spreadsheet-filter-menu > .k-menu .k-link,
.k-spreadsheet-filter-menu > .k-menu.k-menu-vertical .k-link {
    padding-left: calc(16px + 1rem);
}

.k-spreadsheet-filter-menu > .k-menu .k-icon,
.k-spreadsheet-filter-menu > .k-menu.k-menu-vertical .k-icon {
    margin-left: calc(-16px + -0.5rem);
    margin-right: 0.5rem;
}

.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper {
    height: 200px;
    border-width: 1px;
    border-style: solid;
    overflow-y: scroll;
    overflow-x: auto;
}

.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper .k-treeview {
    padding: 0.5rem;
    overflow: visible;
}

.k-spreadsheet-filter-menu .k-details,
.k-spreadsheet-filter-menu .k-expander {
    padding: 0;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: inherit;
}

.k-spreadsheet-filter-menu .k-expander {
    border: 0;
    background: inherit;
}

.k-spreadsheet-filter-menu .k-details-summary,
.k-spreadsheet-filter-menu .k-columnmenu-item {
    padding-block: 0.25rem;
    padding-inline: 1rem;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.k-spreadsheet-filter-menu .k-details-summary > .k-icon,
.k-spreadsheet-filter-menu .k-details-summary > .k-expander-indicator,
.k-spreadsheet-filter-menu .k-columnmenu-item > .k-icon,
.k-spreadsheet-filter-menu .k-columnmenu-item > .k-expander-indicator {
    margin-right: 0.5rem;
}

.k-spreadsheet-filter-menu .k-details-content,
.k-spreadsheet-filter-menu .k-columnmenu-item-content {
    padding: 0.5rem;
    display: flex;
    flex-flow: column nowrap;
    gap: 0.5rem;
}

.k-spreadsheet-filter-menu .k-details-content .k-filter-and,
.k-spreadsheet-filter-menu .k-columnmenu-item-content .k-filter-and {
    width: min-content;
    align-self: flex-start;
}

.k-spreadsheet-filter-menu .k-actions, .k-spreadsheet-filter-menu .k-edit-buttons,
.k-spreadsheet-filter-menu .k-action-buttons,
.k-spreadsheet-filter-menu .k-columnmenu-actions, .k-spreadsheet-filter-menu .k-form-buttons {
    margin: 0;
    padding: 0;
}

.k-spreadsheet-popup {
    padding: 0;
}

.k-spreadsheet-popup .k-separator {
    display: block;
}

.k-spreadsheet-popup .k-reset-color,
.k-spreadsheet-popup .k-custom-color {
    border-radius: 0;
    width: 100%;
    border-width: 0;
    box-sizing: border-box;
    display: flex;
}

.k-spreadsheet-popup .k-reset-color {
    border-bottom-width: 1px;
}

.k-spreadsheet-popup .k-custom-color {
    border-top-width: 1px;
}

.k-spreadsheet-popup .k-spreadsheet-border-type-palette {
    padding: 0.5rem;
    display: grid;
    grid-template-columns: repeat(5, max-content);
    gap: 0.5rem;
}

.k-spreadsheet-clipboard,
.k-spreadsheet-clipboard-paste {
    margin: 0;
    padding: 0;
    width: 1px;
    height: 1px;
    border: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
}

.k-spreadsheet-window .k-external-dropzone {
    margin-block-end: 1rem;
}

.k-spreadsheet-window .k-edit-form-container {
    width: auto;
    min-width: 0;
}

.k-spreadsheet-format-cells .k-spreadsheet-preview {
    margin-top: 0.5rem;
    text-align: center;
}

.k-spreadsheet-format-cells .k-list-scroller {
    margin-top: 0.5rem;
    height: 210px;
    border-width: 1px;
    border-style: solid;
    border-color: inherit;
}

.k-export-config {
    clear: both;
    position: relative;
}

.k-export-config::after {
    content: "";
    clear: both;
    display: block;
}

.k-export-config .k-edit-field {
    margin-left: 5%;
    width: 45%;
    float: left;
}

.k-export-config .k-page-orientation {
    position: absolute;
    right: 0;
    top: 0.5rem;
}

.k-export-config .k-page-orientation .k-font-icon {
    font-size: 6em;
}

.k-export-config .k-page-orientation .k-svg-icon {
    width: 6em;
    height: 6em;
}

.k-spreadsheet-insert-comment textarea {
    height: auto;
}

.k-spreadsheet-insert-image-dialog {
    border-radius: 0.375rem;
    border-style: dashed;
    border-width: 2px;
}

.k-spreadsheet-insert-image-dialog label {
    display: flex;
    justify-content: center;
    min-width: 100%;
    width: 355px;
    height: 230px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-size: auto 70%;
    background-position: 50% 30%;
    background-repeat: no-repeat;
}

.k-spreadsheet-insert-image-dialog label div {
    display: flex;
    align-self: flex-end;
    margin-bottom: 30px;
    pointer-events: none;
}

.k-spreadsheet-insert-image-dialog label input {
    display: none;
}

.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image {
    background-size: auto 90%;
    background-position: 50% 50%;
}

.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover div,
.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-hover div {
    margin: 0;
    align-self: center;
    opacity: 1;
}

.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image div {
    opacity: 0;
}

.k-spreadsheet-drawing {
    position: absolute;
    box-sizing: border-box;
    z-index: 101;
}

.k-spreadsheet-drawing.k-spreadsheet-active-drawing {
    outline-style: solid;
    outline-width: 2px;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: 50% 50%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: move;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle {
    width: 6px;
    height: 6px;
    border-style: solid;
    border-width: 1px;
    border-radius: 0.5rem;
    position: absolute;
    transform: translate(-50%, -50%);
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.N {
    left: 50%;
    top: 0;
    cursor: ns-resize;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.NE {
    left: 100%;
    top: 0;
    cursor: nesw-resize;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.E {
    left: 100%;
    top: 50%;
    cursor: ew-resize;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.SE {
    left: 100%;
    top: 100%;
    cursor: nwse-resize;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.S {
    left: 50%;
    top: 100%;
    cursor: ns-resize;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.SW {
    left: 0;
    top: 100%;
    cursor: nesw-resize;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.W {
    left: 0;
    top: 50%;
    cursor: ew-resize;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.NW {
    left: 0;
    top: 0;
    cursor: nwse-resize;
}

.k-spreadsheet-drawing .k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover, .k-spreadsheet-drawing .k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-hover {
    border-radius: 0.375rem;
}

.k-spreadsheet-legacy .k-spreadsheet,
.k-spreadsheet-legacy .k-spreadsheet-action-bar,
.k-spreadsheet-legacy .k-spreadsheet-view {
    font-size: 12px;
}

.k-spreadsheet-legacy .k-spreadsheet-cell {
    padding: 1px;
}

.k-spreadsheet-legacy .k-spreadsheet-filter {
    padding: 0px;
}

.k-spreadsheet-legacy .k-filter-range {
    border-width: 1px;
}

.k-spreadsheet-legacy .k-spreadsheet .k-spreadsheet-selection-highlight {
    border-width: 1px;
    border-style: solid;
}

.k-spreadsheet .k-tabstrip-wrapper {
    border-width: 0 0 1px;
    border-style: solid;
    border-color: inherit;
    position: relative;
}

.k-spreadsheet-quick-access-toolbar {
    padding: 0.5rem;
    display: inline-flex;
    flex-direction: row;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
}

.k-spreadsheet-tabstrip {
    padding-top: 0.5rem;
    position: relative;
    z-index: 1;
}

.k-spreadsheet-tabstrip .k-tabstrip-items-wrapper {
    margin: 0;
}

.k-spreadsheet-tabstrip .k-loading {
    display: none;
}

.k-spreadsheet-tabstrip .k-content,
.k-spreadsheet-tabstrip .k-tabstrip-content {
    border-radius: 0;
    padding: 0;
    border-width: 0;
    overflow: hidden;
}

.k-spreadsheet-menu {
    padding-inline: 0.5rem;
}

.k-spreadsheet-filter-menu > .k-menu,
.k-spreadsheet-filter-menu > .k-menu:not(.k-context-menu) {
    background: none;
    color: inherit;
    font-weight: inherit;
    font-size: inherit;
}

.k-spreadsheet-filter {
    padding: 0.25rem;
}

.k-spreadsheet {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-spreadsheet-header {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-spreadsheet-top-corner,
.k-spreadsheet-row-header,
.k-spreadsheet-column-header {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-spreadsheet-cell-editor {
    color: #212529;
    background-color: #ffffff;
}

.k-spreadsheet-merged-cell {
    background-color: #ffffff;
}

.k-spreadsheet-disabled-mask {
    background-color: #ffffff;
}

.k-spreadsheet .k-selection-full,
.k-spreadsheet .k-selection-partial {
    background-color: rgba(13, 110, 253, 0.25);
}

.k-spreadsheet-selection {
    border-color: #0d6efd;
    background-color: rgba(13, 110, 253, 0.25);
    box-shadow: inset 0 0 0 1px #0d6efd;
}

.k-spreadsheet-selection-highlight {
    border-color: #0d6efd;
}

.k-spreadsheet .k-single-selection::after {
    border-color: #ffffff;
    background-color: #0d6efd;
}

.k-spreadsheet-active-cell {
    background-color: #ffffff;
    box-shadow: inset 0 0 0 1px #0d6efd;
}

.k-spreadsheet .k-auto-fill {
    border-color: #0d6efd;
    background-color: rgba(13, 110, 253, 0.25);
    box-shadow: inset 0 0 0 1px #0d6efd;
}

.k-spreadsheet .k-auto-fill-punch {
    background-color: rgba(255, 255, 255, 0.5);
}

.k-spreadsheet .k-resize-handle,
.k-spreadsheet .k-resize-hint-handle,
.k-spreadsheet .k-resize-hint-marker {
    background-color: #0d6efd;
}

.k-spreadsheet-has-comment::after {
    border-block-color: #0d6efd transparent;
    border-inline-color: transparent #0d6efd;
}

.k-spreadsheet-cell .k-dirty {
    border-block-color: #dc3545 transparent;
    border-inline-color: #dc3545 transparent;
}

.k-spreadsheet .k-filter-range {
    border-color: #0d6efd;
}

.k-spreadsheet-filter {
    border-color: #e4e7eb;
    color: #212529;
    background-color: #e4e7eb;
    box-shadow: inset 0 0 0 1px #e4e7eb;
}

.k-spreadsheet-filter:hover {
    border-color: #c7cdd5;
    background-color: #ced3db;
}

.k-spreadsheet-filter.k-active {
    border-color: #bfc6d0;
    background-color: #c7cdd5;
}

.k-spreadsheet-filter-menu > .k-menu .k-item:hover,
.k-spreadsheet-filter-menu > .k-menu .k-item.k-hover,
.k-spreadsheet-filter-menu > .k-menu:not(.k-context-menu) .k-item:hover,
.k-spreadsheet-filter-menu > .k-menu:not(.k-context-menu) .k-item.k-hover {
    color: #212529;
    background-color: #e9ecef;
}

.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-spreadsheet-insert-image-dialog {
    border-color: #dee2e6;
}

.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover, .k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-hover {
    box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.5);
}

.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover div,
.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-hover div {
    color: #ffffff;
}

.k-spreadsheet-drawing.k-spreadsheet-active-drawing {
    outline-color: #0d6efd;
}

.k-spreadsheet-drawing .k-spreadsheet-drawing-handle {
    border-color: #0d6efd;
    background-color: #0d6efd;
}

.k-spreadsheet-drawing-anchor-cell {
    background: rgba(13, 110, 253, 0.25);
}

.k-syntax-ref {
    color: #ff8822;
}

.k-syntax-num {
    color: #0099ff;
}

.k-syntax-str {
    color: #38b714;
}

.k-syntax-error {
    color: red;
}

.k-syntax-bool {
    color: #a9169c;
}

.k-syntax-paren-match {
    background-color: #caf200;
}

.k-pivotgrid {
    border-width: 1px;
    border-style: solid;
    box-sizing: content-box;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    text-align: start;
    vertical-align: top;
    display: grid;
    grid-template-columns: 300px auto;
    grid-template-rows: 75px auto;
    position: relative;
}

.k-pivotgrid table {
    margin: 0;
    width: 100%;
    max-width: none;
    border-width: 0;
    border-color: inherit;
    border-collapse: separate;
    border-spacing: 0;
    outline: 0;
    text-align: inherit;
    empty-cells: show;
}

.k-pivotgrid thead,
.k-pivotgrid tbody,
.k-pivotgrid th,
.k-pivotgrid tr,
.k-pivotgrid td {
    border-color: inherit;
    text-align: inherit;
}

.k-pivotgrid-table {
    table-layout: fixed;
}

.k-pivotgrid-table th {
    font-weight: 400;
    text-transform: initial;
}

.k-pivotgrid-table .k-pivotgrid-header-root {
    font-weight: 600;
    text-transform: uppercase;
}

.k-pivotgrid-empty-cell {
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
}

.k-pivotgrid-empty-cell:focus {
    outline: none;
}

.k-pivotgrid-column-headers {
    overflow: hidden;
}

.k-pivotgrid-column-headers .k-pivotgrid-table {
    padding-inline-start: 0;
    padding-inline-end: var(--kendo-scrollbar-width, 17px);
}

.k-pivotgrid-column-headers .k-pivotgrid-cell {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-left-style: solid;
    border-left-width: 1px;
}

.k-pivotgrid-column-headers .k-pivotgrid-cell:first-child {
    border-left-width: 0;
}

.k-pivotgrid-column-headers .k-pivotgrid-cell.k-first {
    border-left-width: 1px;
}

.k-pivotgrid-row-headers {
    overflow: hidden;
}

.k-pivotgrid-row-headers .k-pivotgrid-table {
    padding-bottom: var(--kendo-scrollbar-width, 17px);
}

.k-pivotgrid-row-headers .k-pivotgrid-cell {
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    white-space: nowrap;
}

.k-pivotgrid-values {
    border-color: inherit;
    overflow: scroll;
}

.k-pivotgrid-values .k-pivotgrid-cell {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-left-style: solid;
    border-left-width: 1px;
}

.k-pivotgrid-values .k-pivotgrid-cell:first-child {
    border-left-width: 0;
}

.k-pivotgrid-cell {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;
    overflow: hidden;
}

.k-pivotgrid-cell:focus {
    outline: none;
}

.k-pivotgrid-cell .k-icon {
    cursor: pointer;
    padding-inline-end: 4px;
}

.k-pivotgrid-total {
    font-weight: 600;
}

.k-column-menu .k-treeview {
    padding-block: 0px;
    padding-inline: 1.5rem;
    overflow: auto;
}

.k-pivotgrid-configurator {
    display: flex;
}

.k-pivotgrid-configurator-panel {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 2;
}

.k-pivotgrid-configurator-button {
    padding-block: 0.25rem;
    padding-inline: 0.25rem;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-flex-row .k-pivotgrid-configurator-button, .k-d-flex-row .k-pivotgrid-configurator-button,
.k-flex-row-reverse .k-pivotgrid-configurator-button {
    display: flex;
    align-items: center;
}

.k-flex-row .k-pivotgrid-configurator-button span, .k-d-flex-row .k-pivotgrid-configurator-button span,
.k-flex-row-reverse .k-pivotgrid-configurator-button span {
    -ms-writing-mode: tb-rl;
        writing-mode: vertical-rl;
}

.k-flex-row .k-pivotgrid-configurator-button .k-icon, .k-d-flex-row .k-pivotgrid-configurator-button .k-icon,
.k-flex-row-reverse .k-pivotgrid-configurator-button .k-icon {
    vertical-align: baseline;
}

.k-flex-row-reverse .k-pivotgrid-configurator-button > span {
    transform: rotate(-180deg);
}

.k-flex-col .k-pivotgrid-configurator-button, .k-d-flex-col .k-pivotgrid-configurator-button, .k-flex-column .k-pivotgrid-configurator-button,
.k-flex-col-reverse .k-pivotgrid-configurator-button,
.k-flex-column-reverse .k-pivotgrid-configurator-button {
    text-align: center;
}

.k-pivotgrid-configurator-overlay {
    position: absolute;
    overflow: hidden;
    z-index: 2;
}

.k-flex-row .k-pivotgrid-configurator-overlay, .k-d-flex-row .k-pivotgrid-configurator-overlay {
    right: calc(1.5em + 0.5rem + 2px);
}

.k-flex-row-reverse .k-pivotgrid-configurator-overlay {
    left: calc(1.5em + 0.5rem + 2px);
}

.k-flex-col .k-pivotgrid-configurator-overlay, .k-d-flex-col .k-pivotgrid-configurator-overlay, .k-flex-column .k-pivotgrid-configurator-overlay {
    bottom: calc(1.5em + 0.5rem + 2px);
}

.k-flex-col-reverse .k-pivotgrid-configurator-overlay, .k-flex-column-reverse .k-pivotgrid-configurator-overlay {
    top: calc(1.5em + 0.5rem + 2px);
}

.k-pivotgrid-configurator-header {
    padding-block: 0.75rem;
    padding-inline: 1rem;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.k-pivotgrid-configurator-header-text {
    word-break: normal;
    overflow-wrap: anywhere;
}

.k-pivotgrid-configurator-content {
    padding-block: 0.25rem;
    padding-inline: 1rem;
    flex: 1 1 auto;
    overflow: auto;
}

.k-pivotgrid-configurator-content .k-form .k-label {
    font-size: 16px;
    font-weight: 500;
    align-items: flex-start;
}

.k-pivotgrid-configurator-content .k-form .k-dropdown-list, .k-pivotgrid-configurator-content .k-form .k-dropdown,
.k-pivotgrid-configurator-content .k-form .k-dropdownlist {
    max-width: 90px;
}

.k-pivotgrid-configurator-content .k-form .k-textbox {
    flex-basis: 50%;
}

.k-pivotgrid-configurator-content .k-row-fields,
.k-pivotgrid-configurator-content .k-column-fields,
.k-pivotgrid-configurator-content .k-filter-fields {
    margin-top: 0.5rem;
    flex-wrap: wrap;
}

.k-pivotgrid-configurator-content .k-value-fields {
    margin-block: 0.5rem;
    margin-inline: 0px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.k-pivotgrid-configurator-content .k-select-all .k-checkbox {
    margin-inline-end: 0.25rem;
}

.k-pivotgrid-configurator-content .k-fields-list-wrapper {
    max-height: 200px;
    border-width: 1px;
    border-style: solid;
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto;
}

.k-pivotgrid-configurator-content .k-settings-description {
    margin-top: 1rem;
    text-align: center;
}

.k-pivotgrid-configurator-content .k-treeview {
    padding-block: 0px;
    padding-inline: 1.5rem;
    overflow: auto;
}

.k-calculated-field {
    padding-block: 1rem;
    padding-inline: 1rem;
    border-width: 1px;
    border-radius: 0.375rem;
    border-style: solid;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.k-calculated-field-header {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.k-calculated-field-header .k-textbox {
    min-width: 200px;
}

.k-calculated-field-header-text {
    margin-right: 5px;
    word-break: normal;
    overflow-wrap: anywhere;
}

.k-calculated-field-header-actions {
    flex-shrink: 0;
    align-self: flex-start;
}

.k-calculated-field-content .k-textbox {
    width: 100%;
}

.k-calculated-field-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.k-calculated-field-actions .k-icon {
    margin-right: 0.5rem;
}

.k-calculated-field-actions .k-dropdown-list, .k-calculated-field-actions .k-dropdown,
.k-calculated-field-actions .k-dropdownlist {
    max-width: 100px;
}

.k-filter-menu .k-calculated-item {
    border-bottom-width: 1px;
    border-bottom-style: solid;
}

.k-pivotgrid-configurator-vertical {
    min-width: 320px;
}

.k-flex-row .k-pivotgrid-configurator-vertical.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel, .k-d-flex-row .k-pivotgrid-configurator-vertical.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel,
.k-flex-row-reverse .k-pivotgrid-configurator-vertical.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel {
    border-right-width: 0;
    border-left-width: 0;
}

.k-pivotgrid-configurator-horizontal {
    width: 100%;
    height: 420px;
}

.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form {
    display: flex;
    flex-direction: row;
}

.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper {
    padding-left: 1rem;
}

.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper > *:first-child {
    margin-top: 0;
}

.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper:first-child {
    padding-left: 0;
    flex: 1 1 30%;
}

.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper:nth-child(2) {
    flex: 1 1 30%;
}

.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper:last-child {
    border-left-width: 1px;
    border-left-style: solid;
    flex: 1 1 40%;
}

.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-row-fields,
.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-column-fields,
.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-filter-fields {
    max-height: 100px;
    overflow-x: hidden;
    overflow-y: auto;
}

.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-value-fields {
    max-height: 250px;
    flex-flow: row wrap;
    overflow-x: hidden;
    overflow-y: auto;
}

.k-flex-col .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel, .k-d-flex-col .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel, .k-flex-column .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel,
.k-flex-col-reverse .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel,
.k-flex-column-reverse .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel {
    border-top-width: 0;
    border-bottom-width: 0;
}

.k-pdf-export-shadow .k-pivotgrid {
    height: auto !important;
}

.k-pdf-export-shadow .k-pivotgrid-values {
    height: auto;
    overflow: visible;
}

.k-pdf-export-shadow .k-pivotgrid-column-headers .k-pivotgrid-table {
    padding-inline-end: 0;
}

.k-pivot {
    border-width: 1px;
    border-style: solid;
    position: relative;
}

.k-pivot .k-grid td {
    white-space: nowrap;
}

.k-pivot .k-grid-content {
    flex: 1 1 auto;
}

.k-pivot-toolbar {
    border-width: 0 0 1px;
    border-style: solid;
    align-items: flex-start;
    flex-wrap: wrap;
    box-shadow: none;
}

.k-pivot-toolbar > * {
    max-width: 100%;
}

.k-pivot-toolbar::before {
    display: none;
}

.k-pivot-layout {
    border-spacing: 0;
    table-layout: auto;
}

.k-pivot-layout .k-grid-footer,
.k-pivot-layout .k-grid .k-table-alt-row {
    font-weight: bold;
}

.k-pivot-layout > tbody,
.k-pivot .k-table-td,
.k-pivot td {
    vertical-align: top;
}

.k-pivot-layout > tbody > tr > td {
    padding: 0;
}

.k-pivot-rowheaders > .k-grid,
.k-pivot-table > .k-grid {
    border-width: 0;
    color: inherit;
    background: none;
}

.k-pivot-rowheaders > .k-grid td:first-child,
.k-pivot-table .k-grid-header .k-header.k-first {
    border-left-width: 1px;
}

.k-pivot-rowheaders > .k-grid td.k-first {
    border-left-width: 0;
}

.k-pivot-rowheaders > .k-grid {
    overflow: hidden;
}

.k-pivot-table {
    border-left-width: 1px;
    border-left-style: solid;
}

.k-pivot-table .k-grid-header-wrap {
    margin-right: -1px;
}

.k-pivot-table .k-grid-header-wrap > table {
    height: 100%;
}

.k-pivot .k-grid-header .k-header {
    vertical-align: top;
}

.k-pivot .k-grid tr .k-grid-footer {
    border-bottom-width: 0;
}

.k-pivot .k-grid tr:last-child:not(.k-grid-footer) td:not(.k-grid-footer) {
    border-bottom-width: 1px;
}

.k-pivot-layout .k-grid td {
    border-bottom-width: 1px;
}

.k-pivot-layout .k-grid-footer > td {
    border-top-width: 0;
}

.k-pivot-filter-window .k-treeview {
    max-height: 600px;
}

.k-pivotgrid-wrapper {
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    gap: 0.5rem;
}

.k-pivotgrid-wrapper > .k-pivotgrid-configurator-panel {
    max-width: 320px;
    flex: none;
}

.k-pivotgrid-wrapper > .k-pivot {
    flex: 1;
}

.k-pivotgrid-configurator-panel.kendo-jquery {
    box-sizing: border-box;
    display: inline-flex;
}

.k-pivotgrid-configurator-panel.kendo-jquery .k-pivotgrid-configurator {
    height: 100%;
}

.k-pivotgrid-configurator-panel.kendo-jquery .k-pivotgrid-configurator-content {
    padding: 1rem;
    max-height: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 1rem;
    overflow-x: hidden;
    overflow-y: auto;
}

.k-pivotgrid-configurator-panel.kendo-jquery .k-pivotgrid-targets {
    display: flex;
    flex-flow: column nowrap;
    gap: 1rem;
}

.k-pivotgrid-configurator-panel.kendo-jquery .k-pivotgrid-configurator-section {
    display: flex;
    flex-flow: column nowrap;
    gap: 0.5rem;
}

.k-pivotgrid-configurator-panel.kendo-jquery .k-column-fields {
    margin: 0;
    padding: 0.25rem;
    max-height: 200px;
    border-width: 1px;
    border-style: solid;
    display: flex;
    flex-flow: row wrap;
    gap: 0.25rem;
    overflow-x: hidden;
    overflow-y: auto;
}

.k-pivotgrid-configurator-panel.kendo-jquery .k-column-fields > * {
    margin: 0;
}

.k-pivotgrid-toggle {
    margin-block: -0.25rem;
    padding: 0.25rem;
    box-sizing: content-box;
    cursor: pointer;
}

.k-pivotgrid {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-pivotgrid-column-headers,
.k-pivotgrid-row-headers,
.k-pivotgrid-empty-cell {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-pivotgrid-empty-cell {
    border-color: #babec1;
}

.k-pivotgrid-row-headers .k-pivotgrid-row .k-pivotgrid-cell:last-child {
    border-right-color: #babec1;
}

.k-pivotgrid-column-headers .k-pivotgrid-column-total:nth-last-of-type(2) .k-pivotgrid-cell:not(.k-pivotgrid-expanded),
.k-pivotgrid-column-headers .k-pivotgrid-row:last-child {
    border-bottom-color: #babec1;
}

.k-pivotgrid-header-total,
.k-pivotgrid-total {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ebebeb;
}

.k-pivotgrid-row-headers tbody > .k-pivotgrid-row:hover,
.k-pivotgrid-row-headers tbody > .k-pivotgrid-row.k-hover,
.k-pivotgrid-column-headers tbody > .k-pivotgrid-row:hover,
.k-pivotgrid-column-headers tbody > .k-pivotgrid-row.k-hover,
.k-pivotgrid-values tbody > .k-pivotgrid-row:hover,
.k-pivotgrid-values tbody > .k-pivotgrid-row.k-hover {
    background-color: #ededed;
}

.k-pivotgrid-cell:focus,
.k-pivotgrid-cell.k-focus,
.k-pivotgrid-empty-cell:focus,
.k-pivotgrid-empty-cell.k-focus,
.k-master-row > .k-pivotgrid-cell:focus,
.k-grouping-row > .k-pivotgrid-cell:focus,
.k-detail-row > .k-pivotgrid-cell:focus,
.k-group-footer > .k-pivotgrid-cell:focus {
    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);
}

.k-pivotgrid-cell.k-selected,
.k-pivotgrid-row.k-selected > .k-pivotgrid-cell {
    background-color: rgba(13, 110, 253, 0.25);
}

.k-pivotgrid-configurator-button,
.k-pivotgrid-configurator-panel {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-pivotgrid-configurator-header {
    color: #212529;
}

.k-pivotgrid-configurator-content .k-fields-list-wrapper {
    border-color: #dee2e6;
}

.k-calculated-field {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-calculated-field-header {
    color: #212529;
}

.k-filter-menu .k-calculated-item {
    border-color: #dee2e6;
}

.k-pivotgrid-configurator-content .k-form-field-wrapper {
    border-color: #dee2e6;
}

.k-flex-row .k-pivotgrid-configurator-overlay, .k-d-flex-row .k-pivotgrid-configurator-overlay {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-flex-row-reverse .k-pivotgrid-configurator-overlay {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-flex-col .k-pivotgrid-configurator-overlay, .k-d-flex-col .k-pivotgrid-configurator-overlay, .k-flex-column .k-pivotgrid-configurator-overlay {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-flex-col-reverse .k-pivotgrid-configurator-overlay, .k-flex-column-reverse .k-pivotgrid-configurator-overlay {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-pivot {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-pivot-table {
    border-color: #dee2e6;
}

.k-pivot-rowheaders {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-pivot-toolbar {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-pivot-toolbar .k-empty {
    color: #6c757d;
}

.k-pivot .k-alt {
    background-color: #f8f9fa;
}

.k-pivot-toolbar,
.k-pivot-table,
.k-pivot-rowheaders > .k-grid td:first-child,
.k-pivot-table .k-grid-header .k-header.k-first {
    border-color: #dee2e6;
}

.k-header.k-alt {
    background-color: #eeeff0;
}

.k-pivot-layout .k-grid-footer {
    color: #212529;
    background-color: #f8f9fa;
}

.k-i-kpi-trend-increase,
.k-i-kpi-trend-decrease,
.k-i-kpi-trend-equal {
    color: inherit;
}

.k-i-kpi-status-hold {
    color: #ffc107;
}

.k-i-kpi-status-deny {
    color: #dc3545;
}

.k-i-kpi-status-open {
    color: #198754;
}

.k-pivotgrid-configurator-panel.kendo-jquery .k-column-fields {
    border-color: #dee2e6;
}

.k-treelist.k-grid-display-block.k-grid-lockedcolumns {
    display: block;
}

.k-treelist .k-status {
    padding-block: .4em;
    padding-inline: .6em;
    line-height: 1.6em;
}

.k-treelist .k-status .k-loading {
    vertical-align: baseline;
    margin-right: 5px;
    display: none;
}

.k-treelist tr.k-hidden {
    display: none;
}

.k-treelist .k-treelist-dragging,
.k-treelist .k-treelist-dragging .k-hover {
    cursor: default;
}

.k-treelist .k-drop-hint {
    transform: translate(0, -50%);
}

.k-treelist .k-table-row.k-footer td,
.k-treelist .k-table-row.k-footer-template td,
.k-treelist .k-table-row.k-footer .k-table-td,
.k-treelist .k-table-row.k-footer-template .k-table-td {
    border-width: 1px 0;
    border-style: solid;
    font-weight: bold;
}

.k-treelist .k-table-row.k-footer + .k-table-row.k-footer td,
.k-treelist .k-table-row.k-footer + .k-table-row.k-footer .k-table-td {
    border-top-width: 0;
}

.k-treelist-scrollable > .k-table,
.k-treelist-scrollable .k-grid-header .k-table-row,
.k-treelist-scrollable .k-grid-header .k-table-th {
    background-color: inherit;
}

.k-treelist-scrollable .k-grid-toolbar {
    position: sticky;
    z-index: 3;
    top: 0;
    left: 0;
}

.k-treelist-scrollable .k-grid-header .k-table-th {
    position: sticky;
    z-index: 1;
}

.k-treelist-scrollable .k-grid-header .k-table-th.k-grid-header-sticky {
    z-index: 3;
}

.k-treelist-scrollable thead.k-grid-header {
    padding-right: 0;
}

.k-treelist-scrollable .k-table-row.k-group-footer + .k-table-row.k-group-footer td {
    border-top-width: 0;
}

.k-treelist-scrollable[dir="rtl"] thead.k-grid-header,
.k-rtl .k-treelist-scrollable thead.k-grid-header {
    padding-left: 0;
}

.k-drag-separator {
    display: inline-block;
    border-right: 1px solid;
    height: 1em;
    vertical-align: top;
    margin-block: 0;
    margin-inline: .5em;
}

.k-treelist-toggle {
    margin-block: -0.25rem;
    padding: 0.25rem;
    box-sizing: content-box;
    cursor: pointer;
}

.k-treelist tr.k-footer td,
.k-treelist tr.k-footer-template td {
    font-weight: normal;
}

.k-treelist-scrollable .k-group-footer td {
    font-weight: normal;
}

.k-treelist tr.k-footer,
.k-treelist tr.k-footer-template {
    background-color: #f8f9fa;
}

.k-treelist tr.k-footer:hover,
.k-treelist tr.k-footer-template:hover {
    background-color: #f8f9fa;
}

.k-treelist-scrollable .k-group-footer td,
.k-treelist-scrollable .k-grouping-row td,
.k-treelist-scrollable tbody .k-group-cell {
    background-color: #f8f9fa;
}

.k-filter {
    box-sizing: border-box;
    border-width: 0;
    display: inline-block;
    background-color: transparent;
}

.k-filter *,
.k-filter *::before,
.k-filter *::after {
    box-sizing: border-box;
}

.k-filter ul {
    padding: 0;
}

.k-filter ul li {
    list-style-type: none;
}

.k-filter .k-filter-container,
.k-filter .k-filter-preview {
    margin-block-end: 2.1em;
}

.k-filter .k-filter-lines,
.k-filter .k-filter-item {
    padding-inline-start: 1rem;
}

.k-filter .k-filter-toolbar {
    display: inline-flex;
    position: relative;
    padding-block: 0.5rem;
    padding-inline: 0;
}

.k-filter .k-filter-toolbar::before {
    content: "";
    position: absolute;
    width: 1rem;
    height: 1px;
    inset-block-start: 50%;
    inset-inline-start: -1rem;
}

.k-filter .k-filter-toolbar .k-toolbar {
    border-style: solid;
}

.k-filter .k-filter-operator .k-dropdown-list, .k-filter .k-filter-operator .k-dropdown,
.k-filter .k-filter-operator .k-dropdownlist {
    width: 15em;
}

.k-filter .k-filter-item {
    position: relative;
}

.k-filter .k-filter-item::before {
    content: "";
    position: absolute;
    width: 1px;
    height: 100%;
    inset-block-start: -0.5rem;
    inset-inline-start: 0;
}

.k-filter .k-filter-lines .k-filter-item:last-child > .k-filter-toolbar::after,
.k-filter .k-filter-lines .k-filter-item:last-child > * > .k-filter-toolbar::after {
    content: "";
    position: absolute;
    width: 1px;
    inset-block-start: calc(-0.5rem - 1px);
    inset-block-end: 50%;
    inset-inline-start: -1rem;
}

.k-filter .k-filter-group-main::before,
.k-filter .k-filter-group-main > .k-filter-toolbar::before,
.k-filter .k-filter-group-main > .k-filter-toolbar::after,
.k-filter .k-filter-group-main > * > .k-filter-toolbar::before,
.k-filter .k-filter-group-main > * > .k-filter-toolbar::after,
.k-filter .k-filter-lines .k-filter-item:last-child::before {
    display: none;
}

.k-filter {
    color: #212529;
}

.k-filter .k-filter-preview-field {
    color: #0d6efd;
}

.k-filter .k-filter-preview-operator {
    color: #6c757d;
}

.k-filter .k-filter-item::before,
.k-filter .k-filter-toolbar::before,
.k-filter .k-filter-lines .k-filter-item:last-child > .k-filter-toolbar::after,
.k-filter .k-filter-lines .k-filter-item:last-child > * > .k-filter-toolbar::after {
    background-color: #dee2e6;
}

.k-filter .k-toolbar:focus,
.k-filter .k-toolbar.k-focus {
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.k-filemanager {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-flow: column nowrap;
}

.k-filemanager-header {
    border-color: inherit;
}

.k-filemanager-toolbar {
    border-width: 0;
    border-bottom-width: 1px;
    border-color: inherit;
    flex-shrink: 0;
    z-index: 1;
}

.k-filemanager-content-container {
    border-color: inherit;
    box-sizing: border-box;
    flex: 1 1 0%;
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    overflow: hidden;
}

.k-filemanager-splitter {
    border-width: 0;
}

.k-filemanager-navigation {
    padding-block: 1rem;
    padding-inline: 1rem;
    width: 20%;
    border-width: 0;
    border-right-width: 1px;
    border-style: solid;
    border-color: inherit;
    box-sizing: border-box;
    flex-shrink: 0;
    overflow: auto;
}

.k-filemanager-treeview {
    overflow: visible;
}

.k-filemanager-content {
    border-color: inherit;
    flex: 1 1 0%;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    overflow: hidden;
}

.k-filemanager-view {
    overflow: auto;
}

.k-filemanager-breadcrumb {
    border-width: 0;
    border-bottom-width: 1px;
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    flex-shrink: 0;
}

.k-filemanager-listview {
    border-width: 0;
    flex: 1 1 0%;
}

.k-filemanager-listview .k-listview-item {
    padding-block: 1rem;
    padding-inline: 1rem;
    width: 120px;
    height: 120px;
    text-align: center;
}

.k-filemanager-listview .k-file-preview {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.k-filemanager-listview .k-file-name {
    margin-top: 0.5rem;
    display: block;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.k-filemanager-listview .k-file-edit-input input {
    width: 100%;
}

.k-filemanager-grid {
    border-width: 0;
    flex: 1 1 0%;
}

.k-filemanager-grid .k-file-preview {
    margin-right: 0.5rem;
    display: inline-flex;
    flex-direction: row;
    vertical-align: middle;
}

.k-filemanager-grid .k-file-name {
    display: inline-flex;
    flex-direction: row;
    vertical-align: middle;
}

.k-filemanager-preview {
    padding: 3rem 1rem 1rem;
    width: 20%;
    min-height: calc(7rem + 96px);
    border-width: 0;
    border-left-width: 1px;
    border-style: solid;
    border-color: inherit;
    box-sizing: border-box;
    text-align: center;
    overflow-y: auto;
    flex-shrink: 0;
}

.k-filemanager-preview .k-file-preview {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.k-filemanager-preview .k-file-name {
    margin-top: 1rem;
    display: block;
}

.k-filemanager-preview .k-single-file-selected {
    font-weight: bold;
}

.k-filemanager-preview .k-multiple-files-selected {
    font-weight: bold;
}

.k-filemanager-preview .k-file-meta {
    margin: 1rem 0 0;
    box-sizing: border-box;
    text-align: start;
    display: flex;
    flex-flow: row wrap;
    grid-column-gap: 0.25rem;
}

.k-filemanager-preview .k-file-meta-label {
    display: inline-block;
}

.k-filemanager-preview .k-file-meta-value {
    margin: 0;
}

.k-filemanager-preview .k-file-type {
    text-transform: capitalize;
}

.k-filemanager-preview .k-line-break {
    margin: 1rem 0 0;
    width: 100%;
    flex: 1 1 100%;
    flex-flow: row nowrap;
}

.k-filemanager .k-splitbar {
    flex-shrink: 0;
    display: inline-flex;
    position: relative;
    border-width: 0 1px;
    border-style: solid;
    border-color: inherit;
}

.k-filemanager-upload-dialog .k-upload-files {
    max-height: 200px;
    overflow-y: auto;
}

.k-filemanager-drag-hint {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
}

.k-filemanager {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-filemanager-breadcrumb {
    background-color: #f8f9fa;
}

.k-filemanager-listview .k-listview-item .k-file-icon {
    color: #686b6d;
}

.k-filemanager-listview .k-listview-item.k-selected .k-file-icon {
    border-color: transparent;
    color: inherit;
    background-color: transparent;
}

.k-filemanager-preview .k-file-icon {
    color: #686b6d;
}

.k-taskboard {
    box-sizing: border-box;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    position: relative;
}

.k-taskboard *,
.k-taskboard *::before,
.k-taskboard *::after {
    box-sizing: border-box;
}

.k-taskboard-toolbar {
    padding-block: 1rem;
    padding-inline: 1rem;
    border-width: 0;
    box-shadow: none;
    background: none;
}

.k-taskboard-content {
    padding: 0 1rem 1rem;
    display: flex;
    position: relative;
    flex: 1 1 auto;
    overflow-x: auto;
}

.k-taskboard-columns-container {
    outline: none;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    gap: 1rem;
    overflow-x: visible;
}

.k-taskboard-column {
    width: 320px;
    border-width: 1px;
    border-radius: 0.25rem;
    border-style: solid;
    outline: none;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    overflow: hidden;
}

.k-taskboard-column-header {
    padding-block: 0.75rem;
    padding-inline: 0.75rem;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
}

.k-taskboard-column-header-actions {
    display: inline-flex;
    flex-shrink: 0;
    align-self: flex-start;
    gap: 0.5rem;
}

.k-taskboard-column-cards-container {
    margin-bottom: 0.75rem;
    padding-block: 0px;
    padding-inline: 0.75rem;
    outline: none;
    overflow: auto;
    flex: 1 1 auto;
}

.k-taskboard-column-cards {
    padding-block: 0.25rem;
    padding-inline: 0px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.75rem 0;
}

.k-taskboard-column-new .k-taskboard-column-header,
.k-taskboard-column-edit .k-taskboard-column-header {
    font-weight: inherit;
}

.k-taskboard-column-new .k-taskboard-column-header-text,
.k-taskboard-column-edit .k-taskboard-column-header-text {
    flex: 1 1 100%;
}

.k-taskboard-pane {
    width: 320px;
    border-width: 1px;
    border-style: solid;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 2;
}

.k-taskboard-pane-header {
    padding-block: 0.75rem;
    padding-inline: 1rem;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.k-taskboard-pane-header-text {
    word-break: normal;
    overflow-wrap: anywhere;
}

.k-taskboard-pane-header-actions {
    flex-shrink: 0;
    align-self: flex-start;
}

.k-taskboard-pane-content {
    padding-block: 0px;
    padding-inline: 1rem;
    overflow: auto;
    flex: 1 1 auto;
}

.k-taskboard-pane-actions {
    padding-block: 0.75rem;
    padding-inline: 1rem;
}

.k-taskboard-pane-start {
    right: auto;
    left: 0;
}

.k-taskboard-card {
    border-radius: 0.375rem;
    border-width: 1px;
}

.k-taskboard-card.k-taskboard-card-category {
    border-inline-start-width: 4px;
}

.k-taskboard-card .k-card-header .k-card-body,
.k-taskboard-card .k-card-footer {
    padding-block: 1rem;
    padding-inline: 1rem;
}

.k-taskboard-card .k-card-header {
    align-items: center;
}

.k-taskboard-card .k-card-title {
    font-size: inherit;
    font-weight: inherit;
    word-break: normal;
    overflow-wrap: anywhere;
}

.k-taskboard-card .k-card-title:focus, .k-taskboard-card .k-card-title.k-focus, .k-taskboard-card .k-card-title:hover, .k-taskboard-card .k-card-title.k-hover {
    text-decoration: underline;
}

.k-taskboard-card .k-card-header-actions {
    align-self: flex-start;
}

.k-taskboard-drag-placeholder {
    border-radius: 0.375rem;
    border-width: 1px;
    border-style: solid;
    position: relative;
}

.k-taskboard-column {
    border-color: transparent;
    background-color: #f8f9fa;
}

.k-taskboard-column:focus,
.k-taskboard-column.k-focus {
    border-color: #b6b7b8;
}

.k-taskboard-column-header {
    color: #212529;
}

.k-taskboard-pane {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-taskboard-pane-header {
    color: #212529;
}

.k-taskboard-card {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-taskboard-card .k-card-title {
    color: #0d6efd;
}

.k-taskboard-card .k-card-title:focus, .k-taskboard-card .k-card-title.k-focus {
    color: #0b5cd5;
}

.k-taskboard-card .k-card-title:hover, .k-taskboard-card .k-card-title.k-hover {
    color: #0b5cd5;
}

.k-taskboard-card:focus, .k-taskboard-card.k-focus {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
    border-color: #b6b9bd;
}

.k-taskboard-card:hover, .k-taskboard-card.k-hover {
    border-color: #c8cbcf;
}

.k-taskboard-card.k-selected {
    border-color: #b6d3fe;
    box-shadow: none;
}

.k-taskboard-card.k-disabled {
    outline: none;
    cursor: default;
    opacity: 0.65;
    filter: grayscale(0.1);
    pointer-events: none;
    box-shadow: none;
}

.k-taskboard-drag-placeholder {
    border-color: #dee2e6;
    background-color: rgba(0, 0, 0, 0.1);
}

.k-editor {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-editor.k-readonly .k-editor-content {
    pointer-events: auto;
}

.k-editor.k-readonly .k-editor-content.k-focus {
    outline-width: 1px;
    outline-style: dashed;
}

.k-editor-inline {
    border-radius: 0.375rem;
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    border: 1px solid transparent;
    word-wrap: break-word;
    overflow: auto;
    background: none;
}

.k-editor-resizable {
    resize: both;
    overflow: auto;
}

.k-editor-resize-handles-wrapper {
    position: absolute;
    visibility: hidden;
}

.k-editor-resize-handle {
    width: 8px;
    height: 8px;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    position: absolute;
    visibility: visible;
    z-index: 100;
}

.k-editor-resize-handle.northwest {
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
    cursor: nw-resize;
}

.k-editor-resize-handle.north {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: n-resize;
}

.k-editor-resize-handle.northeast {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    cursor: ne-resize;
}

.k-editor-resize-handle.southwest {
    left: 0;
    bottom: 0;
    transform: translate(-50%, 50%);
    cursor: sw-resize;
}

.k-editor-resize-handle.south {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    cursor: s-resize;
}

.k-editor-resize-handle.southeast {
    right: 0;
    bottom: 0;
    transform: translate(50%, 50%);
    cursor: se-resize;
}

.k-editor-resize-handle.west {
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    cursor: w-resize;
}

.k-editor-resize-handle.east {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    cursor: e-resize;
}

.ProseMirror-selectednode {
    outline-width: 2px;
    outline-style: solid;
}

.ProseMirror-hideselection {
    caret-color: transparent;
}

.ProseMirror-hideselection *::selection,
.ProseMirror-hideselection *::-moz-selection {
    background: transparent;
}

.k-editor-toolbar {
    border-width: 0 0 1px 0;
    flex-shrink: 0;
}

.k-editor-toolbar .k-editor-export .k-icon {
    margin-right: 0.25em;
}

.k-editor-toolbar .k-editor-export .k-icon,
.k-editor-toolbar .k-editor-export .k-export-tool-text {
    vertical-align: middle;
}

.k-editor-content {
    flex: 1 1 auto;
    overflow-y: auto;
}

.k-editor-content > .k-iframe {
    width: 100%;
    height: 100%;
    border-width: 0;
    display: block;
}

.k-editor-content > .ProseMirror {
    padding: 1rem;
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    outline: none;
    white-space: pre-wrap;
    overflow: auto;
}

.k-editor-content > .ProseMirror table {
    white-space: pre-wrap;
}

.k-editor-content > .ProseMirror .k-placeholder::before {
    content: attr(data-placeholder);
    height: 0;
    color: #6c757d;
    float: left;
    opacity: 1;
    cursor: text;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-editor-content > .ProseMirror[contenteditable="false"] {
    cursor: unset !important;
}

.k-editor-content > .ProseMirror[contenteditable="false"] .k-editor-resize-handles-wrapper,
.k-editor-content > .ProseMirror[contenteditable="false"] .k-editor-resize-handle,
.k-editor-content > .ProseMirror[contenteditable="false"] .row-resize-handle,
.k-editor-content > .ProseMirror[contenteditable="false"] .column-resize-handle {
    display: none;
}

.k-editor-content > .ProseMirror[contenteditable="false"] img,
.k-editor-content > .ProseMirror[contenteditable="false"] table {
    pointer-events: none;
}

.k-editor-content > .ProseMirror[contenteditable="false"] .ProseMirror-selectednode {
    outline: none;
}

.k-editor-content p {
    margin: 0 0 1rem;
}

.k-editor-content td p,
.k-editor-content th p,
.k-editor-content li p {
    margin: 0;
}

.k-editor-content table {
    margin: 0;
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    overflow: hidden;
}

.k-editor-content td,
.k-editor-content th {
    min-width: 1em;
    border: 1px solid;
    padding-block: 3px;
    padding-inline: 5px;
    vertical-align: top;
    box-sizing: border-box;
    position: relative;
}

.k-editor-content th {
    font-weight: bold;
    text-align: start;
}

.k-editor-content td {
    text-align: start;
}

.k-editor-content .selectedCell::after {
    z-index: 2;
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    pointer-events: none;
}

.k-edit-form-content {
    flex: 1 1 auto;
    overflow: auto;
    margin-block: -1rem;
    margin-inline: -1rem;
    padding-block: 1rem;
    padding-inline: 1rem;
}

.k-ct-popup {
    box-sizing: border-box;
    width: 190px;
    padding: 5px;
}

.k-ct-popup .k-button {
    width: 100%;
}

.k-ct-popup .k-ct-cell {
    margin: 1px;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    border: 1px solid;
    border-color: inherit;
    display: inline-block;
    vertical-align: top;
    overflow: hidden;
    opacity: .7;
    pointer-events: all;
}

.k-editor .k-resize-handle {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 13px 13px;
    border-color: transparent;
    border-bottom-color: inherit;
    cursor: se-resize;
}

.k-editor .k-resize-handle .k-i-arrow-45-down-right,
.k-editor .k-resize-handle .k-i-caret-br {
    display: none;
}

.k-editor-find-replace .k-content {
    position: relative;
}

.k-editor-find-replace .k-actions, .k-editor-find-replace .k-edit-buttons,
.k-editor-find-replace .k-action-buttons,
.k-editor-find-replace .k-columnmenu-actions, .k-editor-find-replace .k-form-buttons {
    padding: 0;
}

.k-editor-find-replace .k-search-options {
    display: flex;
    flex-direction: column;
    padding: 10px 0 40px;
}

.k-editor-find-replace .k-matches-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.k-textarea.k-editor-textarea {
    width: 100%;
    height: 100%;
    resize: none;
}

.k-filebrowser {
    max-width: 100%;
}

.k-filebrowser .k-floatwrap {
    display: flex;
}

.k-filebrowser .k-floatwrap::after {
    display: none;
}

.k-filebrowser .k-breadcrumbs {
    flex: 1;
}

.k-filebrowser .k-search-wrap {
    margin: 0 0 0 1rem;
    width: 150px;
    display: flex;
    align-items: center;
}

.k-filebrowser .k-search-wrap .k-input {
    flex: 1;
    width: 100px;
}

.k-filebrowser .k-search-wrap .k-icon {
    margin: 0;
    position: static;
}

.k-filebrowser .k-filebrowser-toolbar {
    margin: 1rem 0 0 0;
}

.k-filebrowser .k-upload {
    padding: 0;
    border-width: 0;
    background: none;
}

.k-filebrowser .k-upload .k-upload-button {
    margin: 0;
}

.k-filebrowser .k-upload .k-upload-status {
    display: none;
}

.k-filebrowser .k-upload-files {
    display: none;
}

.k-filebrowser .k-tiles {
    display: flex;
    flex-flow: row wrap;
    height: 390px;
    max-height: 50vh;
    margin: 0 0 1rem 0;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    border-top-width: 0;
    overflow: auto;
}

.k-filebrowser .k-tile {
    width: 33%;
    height: 90px;
    padding-block: 0.5rem;
    padding-inline: 1rem;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    border-radius: 0.375rem;
}

.k-filebrowser .k-tile .k-i-file,
.k-filebrowser .k-tile .k-i-folder {
    font-size: 4em;
}

.k-filebrowser .k-tile input {
    width: 100px;
}

.k-filebrowser .k-tile strong {
    display: block;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-filebrowser .k-tile-empty {
    display: block;
    margin: auto;
}

.k-filebrowser .k-tile-empty.k-selected {
    color: inherit;
    border-width: 0;
    background-image: none;
    background-color: transparent;
}

.k-filebrowser .k-tile-empty strong {
    opacity: .5;
    font-size: 3em;
    font-weight: 400;
}

.k-filebrowser .k-thumb {
    float: left;
    margin-right: 0.5rem;
}

.k-filebrowser .k-breadcrumbs-wrap {
    position: absolute;
    left: 0.75rem;
    top: 0.375rem;
}

.k-filebrowser .k-breadcrumbs-wrap .k-icon {
    position: static;
    margin-top: 0;
}

.k-editor-table-wizard-window .k-tabstrip-wrapper {
    display: flex;
    flex: 1 1 auto;
    overflow: auto;
}

.k-editor-table-wizard-window .k-tabstrip-wrapper .k-tabstrip.k-root-tabs {
    flex: 1 1 auto;
    margin-bottom: 0;
}

.k-editor-table-wizard-window .k-edit-field > .k-checkbox {
    position: relative;
}

.k-editor-inline .k-table {
    width: 100%;
    border-spacing: 0;
    margin: 0 0 1em;
}

.k-editor-inline .k-table,
.k-editor-inline .k-table td {
    outline: 0;
    border-width: 1px;
    border-style: dotted;
}

.k-editor-inline .k-table td {
    min-width: 1px;
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
}

.k-editor-inline .k-element-resize-handle-wrapper {
    position: absolute;
    width: 5px;
    height: 5px;
    border-width: 1px;
    border-style: solid;
    z-index: 100;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle {
    width: 100%;
    height: 100%;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-east {
    cursor: e-resize;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-north {
    cursor: n-resize;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-northeast {
    cursor: ne-resize;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-northwest {
    cursor: nw-resize;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-south {
    cursor: s-resize;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-southeast {
    cursor: se-resize;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-southwest {
    cursor: sw-resize;
}

.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-west {
    cursor: w-resize;
}

.k-editor-inline .k-column-resize-handle-wrapper {
    position: absolute;
    height: 10px;
    width: 10px;
    cursor: col-resize;
    z-index: 2;
}

.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle {
    width: 100%;
    height: 100%;
}

.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle .k-column-resize-marker {
    width: 2px;
    height: 100%;
    margin-block: 0;
    margin-inline: auto;
    display: none;
    opacity: .8;
}

.k-editor-inline .k-row-resize-handle-wrapper {
    position: absolute;
    z-index: 2;
    cursor: row-resize;
    width: 10px;
    height: 10px;
}

.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-handle {
    display: table;
    width: 100%;
    height: 100%;
}

.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker-wrapper {
    display: table-cell;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    vertical-align: middle;
}

.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker {
    display: none;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 2px;
    opacity: .8;
}

.k-editor {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-editor.k-readonly .k-editor-content.k-focus {
    outline-color: #212529;
}

.k-editor-inline .k-table,
.k-editor-inline .k-table td {
    border-color: #cccccc;
}

.k-editor-inline .k-element-resize-handle-wrapper {
    background-color: #ffffff;
    border-color: #000000;
}

.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle .k-column-resize-marker {
    background-color: #00b0ff;
}

.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker {
    background-color: #00b0ff;
}

.k-editor-inline:hover, .k-editor-inline.k-hover, .k-editor-inline.k-active {
    border-color: #dee2e6;
}

.k-editor-resize-handle {
    background-color: #ffffff;
    border-color: #000000;
}

.ProseMirror-selectednode {
    outline-color: #88ccff;
}

.k-ct-popup .k-selected {
    border-color: #0c65e9;
    color: white;
    background-color: #0d6efd;
    background-image: none;
}

.k-editor-content .k-text-selected, .k-editor-content::selection {
    color: white;
    background-color: #0d6efd;
}

.k-editor-content .k-text-highlighted {
    background-color: #cfe2ff;
}

.k-editor-content td,
.k-editor-content th {
    border-color: #dddddd;
}

.k-editor-content .selectedCell::after {
    background-color: rgba(200, 200, 255, 0.4);
}

.k-imageeditor {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-imageeditor *,
.k-imageeditor *::before,
.k-imageeditor *::after {
    box-sizing: border-box;
}

.k-imageeditor-toolbar {
    border-width: 0;
    border-bottom-width: 1px;
}

.k-imageeditor-content {
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    display: flex;
    flex-flow: row nowrap;
}

.k-imageeditor-canvas-container {
    flex: 1 1 100%;
    display: flex;
    flex-flow: row nowrap;
    overflow: auto;
}

.k-imageeditor-canvas {
    margin: auto;
    display: flex;
    flex-direction: column;
    position: relative;
}

.k-imageeditor-action-pane {
    padding-block: 2rem;
    padding-inline: 1rem;
    width: 241px;
    border-width: 0;
    border-left-width: 1px;
    border-style: solid;
    border-color: inherit;
    box-sizing: border-box;
    flex: none;
    overflow-y: auto;
}

.k-imageeditor-action-pane .k-input-inner,
.k-imageeditor-action-pane .k-input-value-text {
    text-overflow: clip;
}

.k-imageeditor-crop-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.k-imageeditor-crop {
    width: 100%;
    height: 100%;
    border-width: 1px;
    border-style: dashed;
    box-sizing: border-box;
    position: absolute;
}

.k-imageeditor-crop .k-resize-handle {
    margin-block: 1px;
    margin-inline: 1px;
    border-style: solid;
    border-width: 0 2px 2px 0;
}

.k-imageeditor-crop .k-resize-sw,
.k-imageeditor-crop .k-resize-se,
.k-imageeditor-crop .k-resize-nw,
.k-imageeditor-crop .k-resize-ne {
    width: 15px;
    height: 15px;
}

.k-imageeditor-crop .k-resize-n,
.k-imageeditor-crop .k-resize-s {
    left: calc(50% - 7.5px);
    width: 15px;
    height: 0;
}

.k-imageeditor-crop .k-resize-w,
.k-imageeditor-crop .k-resize-e {
    top: calc(50% - 7.5px);
    width: 0;
    height: 15px;
}

.k-imageeditor-crop .k-resize-ne {
    transform: rotate(-90deg);
}

.k-imageeditor-crop .k-resize-nw {
    transform: rotate(-180deg);
}

.k-imageeditor-crop .k-resize-sw {
    transform: rotate(90deg);
}

.k-imageeditor-crop .k-resize-n {
    top: 0;
}

.k-imageeditor-crop .k-resize-s {
    bottom: 0;
}

.k-imageeditor-crop .k-resize-w {
    left: 0;
}

.k-imageeditor-crop .k-resize-e {
    right: 0;
}

.k-imageeditor {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-imageeditor-content {
    background-color: #c6c6c6;
}

.k-imageeditor-canvas {
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.09) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.09) 75%, rgba(0, 0, 0, 0.09)), linear-gradient(45deg, rgba(0, 0, 0, 0.09) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.09) 75%, rgba(0, 0, 0, 0.09)), white;
    background-repeat: repeat, repeat;
    background-position: 0px 0px, 5px 5px;
    transform-origin: 0 0 0;
    background-origin: padding-box, padding-box;
    background-size: 10px 10px, 10px 10px;
    box-shadow: none;
    text-shadow: none;
    transition: none;
    transform: scaleX(1) scaleY(1) scaleZ(1);
}

.k-imageeditor-action-pane {
    background-color: #ffffff;
}

.k-imageeditor-crop {
    border-color: white;
}

.k-imageeditor-crop-overlay {
    background-color: rgba(0, 0, 0, 0.3);
}

.k-gantt {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    white-space: nowrap;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-gantt .k-table-td {
    white-space: nowrap;
}

.k-gantt td {
    overflow: hidden;
    white-space: nowrap;
    vertical-align: top;
}

.k-gantt .k-grid-header tr {
    height: calc(1.5em + 1rem + 1px);
}

.k-gantt .k-grid-header .k-header {
    position: static;
}

.k-gantt .k-treelist .k-grid-header .k-header {
    position: relative;
}

.k-gantt .k-grid-content tr {
    height: calc(1.5em + 1rem);
}

.k-gantt.k-gantt-planned .k-grid-content tr {
    height: calc(2.55em + 1rem);
}

.k-gantt .k-gantt-layout {
    white-space: normal;
    vertical-align: top;
    display: inline-block;
}

.k-gantt .k-splitbar {
    position: relative;
    display: inline-flex;
}

.k-gantt .k-gantt-splitter {
    border-width: 0;
}

.k-gantt .k-treelist-scrollable {
    width: 100%;
    border-width: 0;
    overflow: auto;
}

.k-gantt .k-treelist-scrollable .k-grid-header .k-header {
    position: sticky;
}

.k-gantt .k-treelist-scrollable .k-grid-header th,
.k-gantt .k-treelist-scrollable .k-grid-content-sticky {
    z-index: 4;
}

.k-gantt .k-treelist-scrollable .k-grid-header th.k-grid-header-sticky {
    z-index: 5;
}

.k-gantt .k-treelist-scrollable .k-grid-header tr:first-child th:last-child,
.k-gantt .k-treelist-scrollable tbody td:last-child {
    padding: 0;
    vertical-align: top;
}

.k-gantt .k-treelist-scrollable .k-grid-header th:last-child .k-header {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 0 0 1px 1px;
    white-space: nowrap;
}

.k-gantt .k-treelist-scrollable tr.k-selected > td:last-child {
    background: transparent;
}

.k-gantt .k-treelist-scrollable .k-task {
    display: inline-flex;
    flex-flow: row nowrap;
    white-space: nowrap;
    z-index: 3;
}

.k-gantt .k-treelist-scrollable .k-task:hover .k-task-start,
.k-gantt .k-treelist-scrollable .k-task:hover .k-task-end {
    display: block;
}

.k-gantt .k-treelist-scrollable .k-task:hover .k-task-draghandle {
    visibility: visible;
}

.k-gantt .k-treelist-scrollable .k-task-content {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    display: block;
    line-height: normal;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.k-gantt .k-treelist-scrollable .k-task-actions {
    flex-shrink: 0;
}

.k-gantt .k-treelist-scrollable .k-task-milestone {
    border: 0;
    transform: none;
    background: none;
}

.k-gantt .k-treelist-scrollable .k-task-milestone .k-task-milestone-content {
    width: 100%;
    height: 100%;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    transform: rotate(45deg);
}

.k-gantt .k-treelist-scrollable .k-task-summary {
    height: 15px;
    clip-path: polygon(-20px 0, calc(100% + 20px) 0, calc(100% + 20px) 100%, 100% 100%, calc(100% - 8px) calc(100% - 5px), 8px calc(100% - 5px), 0 100%, -20px 100%);
}

.k-gantt .k-treelist-scrollable .k-task-summary-complete {
    width: 100%;
    height: 15px;
}

.k-gantt .k-treelist-scrollable .k-task-start {
    transform: translateX(-140%) translateY(-50%);
}

.k-gantt .k-treelist-scrollable .k-task-end {
    transform: translateX(140%) translateY(-50%);
}

.k-gantt .k-treelist-scrollable .k-master-row:hover .k-task-dot {
    display: block;
}

.k-gantt .k-treelist-scrollable .k-gantt-columns {
    background: transparent;
    pointer-events: none;
    table-layout: fixed;
}

.k-gantt .k-gantt-dependencies-svg {
    position: absolute;
    top: 0;
    left: 0;
    overflow: visible;
    pointer-events: none;
    z-index: 2;
}

.k-gantt .k-gantt-dependencies-svg polyline {
    stroke-width: 2px;
}

.k-gantt-header {
    border-width: 0 0 1px;
    flex-shrink: 0;
    z-index: 6;
}

.k-gantt-footer {
    border-width: 1px 0 0;
    flex-shrink: 0;
}

.k-gantt-toggle {
    display: none;
}

.k-gantt-views-wrapper {
    margin-left: auto;
}

.k-gantt-views-wrapper .k-views-dropdown {
    width: auto;
    font-size: inherit;
    display: none;
    cursor: pointer;
}

@media (max-width: 480px) {
    .k-gantt-toolbar .k-gantt-toggle {
        display: inline-flex;
    }
    .k-gantt-toolbar .k-gantt-pdf,
    .k-gantt-toolbar .k-gantt-create {
        padding: 0.375rem;
        width: calc(1.5em + 0.75rem + 2px);
        height: calc(1.5em + 0.75rem + 2px);
    }
    .k-gantt-toolbar .k-gantt-pdf .k-button-text,
    .k-gantt-toolbar .k-gantt-create .k-button-text {
        display: none;
    }
}

@media (max-width: 1024px) {
    .k-gantt-views-wrapper .k-gantt-views {
        display: none;
    }
    .k-gantt-views-wrapper .k-views-dropdown {
        display: flex;
    }
}

.k-gantt-content {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    flex: 1 1 auto;
    overflow: hidden;
}

.k-gantt-treelist .k-treelist {
    height: 100%;
    border-width: 0;
}

.k-gantt-treelist .k-grid-header,
.k-gantt-treelist .k-grid-footer {
    padding: 0 !important;
}

.k-gantt-treelist .k-grid-header tr {
    height: calc(3em + 2rem + 2px);
    vertical-align: bottom;
}

.k-gantt-treelist .k-grid-content {
    overflow: hidden;
    overflow-x: scroll;
}

.k-gantt-treelist .k-grid-content td {
    vertical-align: middle;
}

.k-gantt-treelist .k-gantt-treelist-nested-columns .k-grid-header tr {
    height: calc(1.5em + 1rem + 1px);
}

.k-gantt-treelist.k-gantt-treelist-scrollable .k-grid-content {
    overflow: scroll;
}

.k-gantt-timeline-pane .k-gantt-timeline {
    height: 100%;
    border-width: 0;
    display: flex;
}

.k-gantt-timeline-pane .k-gantt-timeline *,
.k-gantt-timeline-pane .k-gantt-timeline *::before,
.k-gantt-timeline-pane .k-gantt-timeline *::after, .k-gantt-timeline-pane .k-gantt-timeline::before, .k-gantt-timeline-pane .k-gantt-timeline::after {
    box-sizing: border-box;
}

.k-gantt-timeline-pane .k-grid-content {
    overflow-x: scroll;
}

.k-gantt-timeline-pane .k-header {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    border-width: 0 0 1px 1px;
    white-space: nowrap;
}

.k-gantt-tables {
    position: relative;
    border-color: inherit;
}

.k-gantt-rows,
.k-gantt-columns {
    border-color: inherit;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
}

.k-gantt-dependencies {
    opacity: .7;
    position: absolute;
    top: 0;
    left: 0;
}

.k-gantt-dependencies .k-arrow-e,
.k-gantt-dependencies .k-arrow-w {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    top: -4px;
}

.k-gantt-dependencies .k-arrow-e {
    border-left-color: currentColor;
    right: -6px;
}

.k-gantt-dependencies .k-arrow-w {
    border-right-color: currentColor;
    left: -6px;
}

.k-gantt-line {
    background-color: currentColor;
    border-color: currentColor;
    position: absolute;
}

.k-gantt-line.k-selected {
    z-index: 3;
}

.k-gantt-line-h {
    height: 2px;
}

.k-gantt-line-v {
    width: 2px;
}

.k-gantt-dependency-hint {
    z-index: 4;
}

.k-gantt-tasks {
    position: relative;
}

.k-gantt-tasks td,
.k-gantt-tasks .k-table-td {
    padding: 0;
    border-width: 0;
    position: relative;
    vertical-align: middle;
}

.k-gantt-tasks td::after {
    content: "\\200b";
}

.k-task-wrap {
    margin-block: 0;
    margin-inline: -21px;
    padding-block: 5px;
    padding-inline: 21px;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    z-index: 2;
}

.k-task-wrap.k-drag-hint {
    position: absolute;
}

.k-task {
    position: relative;
    flex: 1 1 auto;
}

.k-task-dot {
    width: 16px;
    height: 16px;
    line-height: 1;
    cursor: pointer;
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.k-task-wrap:hover .k-task-dot,
.k-task-wrap.k-origin .k-task-dot {
    display: block;
}

.k-task-dot::before {
    content: "";
    width: 8px;
    height: 8px;
    border-width: 0;
    border-style: solid;
    border-radius: 100%;
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.k-task-dot:hover::before,
.k-task-dot.k-hover::before {
    border-width: 1px;
}

.k-task-start {
    left: 0;
}

.k-task-end {
    right: 0;
}

.k-task-draghandle {
    margin-left: 16px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-width: 0;
    border-bottom-color: inherit;
    position: absolute;
    bottom: 0;
    cursor: e-resize;
    visibility: hidden;
}

.k-task-wrap:hover .k-task-draghandle {
    visibility: visible;
}

.k-milestone-wrap {
    margin-block: 0;
    margin-inline: -2em;
}

.k-task-milestone {
    width: 1em;
    height: 1em;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    transform: rotate(45deg);
}

.k-task-summary {
    height: 10px;
    display: inline-block;
    vertical-align: top;
}

.k-task-summary,
.k-task-summary-complete {
    background-color: currentColor;
}

.k-task-summary::before, .k-task-summary::after,
.k-task-summary-complete::before,
.k-task-summary-complete::after {
    content: "";
    width: 0;
    height: 0;
    border: 8px solid transparent;
    position: absolute;
    top: 0;
    display: none;
}

.k-task-summary::before,
.k-task-summary-complete::before {
    border-left-color: currentColor;
    left: 0;
}

.k-task-summary::after,
.k-task-summary-complete::after {
    border-right-color: currentColor;
    right: 0;
}

.k-task-summary-complete {
    height: 10px;
    position: relative;
    z-index: 2;
}

.k-task-summary-progress {
    height: 15px;
    overflow: hidden;
}

.k-task-single {
    border-radius: 0.375rem;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    cursor: default;
}

.k-task-single .k-resize-handle {
    opacity: .5;
    z-index: 2;
    visibility: hidden;
}

.k-task-single .k-resize-handle::before {
    position: absolute;
    top: 2px;
    bottom: 2px;
}

.k-task-single .k-resize-w {
    left: 0;
}

.k-task-single .k-resize-w::before {
    left: 2px;
    border-left-width: 1px;
}

.k-task-single .k-resize-e {
    right: 0;
}

.k-task-single .k-resize-e::before {
    right: 2px;
    border-left-width: 1px;
}

.k-task-single:hover .k-resize-handle,
.k-task-single:hover .k-task-actions {
    visibility: visible;
}

.k-task-complete {
    border-radius: 0.375rem;
    width: 20%;
    position: absolute;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 0;
}

.k-task-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
}

.k-task-template {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    line-height: normal;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-task-actions {
    padding: 0.25rem;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    visibility: hidden;
    z-index: 1;
}

.k-task-actions > .k-link {
    display: inline-flex;
}

.k-resources-wrap {
    position: absolute;
    display: inline-block;
    z-index: 2;
    margin-left: 20px;
    margin-top: -2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.k-resources-wrap .k-resource {
    margin-block: 0;
    margin-inline: 5px;
}

.k-task-details {
    padding-block: 0.5rem;
    padding-inline: 1rem;
    white-space: nowrap;
}

.k-task-details strong {
    font-size: 1.25rem;
    font-weight: normal;
    display: block;
}

.k-task-details .k-task-pct {
    font-size: 32px;
}

.k-task-details ul {
    line-height: normal;
}

.k-gantt-planned .k-gantt-dependencies,
.k-gantt-planned .k-task-dot,
.k-gantt-planned .k-resources-wrap {
    margin-top: 0.6em;
}

.k-gantt-planned .k-task-wrap {
    flex-direction: column;
    align-items: flex-start;
}

.k-gantt-planned .k-task-inner-wrap {
    display: inline-flex;
}

.k-gantt-planned .k-task-wrap.k-drag-hint {
    top: 0.35em;
}

.k-gantt-planned .k-summary-wrap.k-drag-hint {
    top: 1em;
}

.k-gantt-planned .k-milestone-wrap.k-drag-hint {
    top: 0.85em;
}

.k-task-planned {
    margin: 0 0 0.35em;
    line-height: 0.75em;
    display: flex;
    align-items: center;
}

.k-task-planned .k-task-moment {
    border-width: 2px;
    border-radius: 5px;
    border-style: solid;
    height: 6px;
    width: 6px;
}

.k-task-planned .k-task-duration {
    height: 2px;
}

.k-task-planned .k-task-moment.k-moment-left {
    margin-left: -4px;
}

.k-task-planned:hover .k-task-duration {
    height: 3px;
}

.k-milestone-wrap .k-task-moment {
    margin-left: 6px;
}

.k-planned-tooltip .k-task-content {
    display: block;
}

.k-task-offset-wrap .k-task-content .k-resize-e {
    display: none;
}

.k-task-offset {
    flex-direction: row-reverse;
    display: flex;
}

.k-task-offset .k-resize-handle {
    right: 0;
    z-index: 2;
    visibility: hidden;
    margin-right: 1.2em;
}

.k-task-offset .k-resize-handle::before {
    border-left-width: 1px;
    position: absolute;
    top: 45%;
    bottom: .5em;
    margin-right: 2px;
}

.k-task-single:hover + .k-task-offset .k-task-actions,
.k-task-offset:hover .k-task-actions,
.k-task-single:hover + .k-task-offset .k-resize-handle,
.k-task-offset:hover .k-resize-handle {
    visibility: visible;
}

.k-gantt-tooltip-validation {
    max-width: 200px;
    display: block;
}

.k-gantt-tooltip-validation::before {
    content: "";
    width: 4px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.k-gantt-tooltip-validation-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.k-gantt-tooltip-validation-label {
    display: inline-flex;
    min-width: 50px;
}

.k-gantt-tooltip-validation-value {
    font-weight: 700;
}

.k-gantt-tooltip-validation-label,
.k-gantt-tooltip-validation-value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.k-pdf-export-shadow .k-gantt {
    float: left;
}

.k-pdf-export-shadow .k-gantt,
.k-pdf-export-shadow .k-gantt-timeline-pane,
.k-pdf-export-shadow .k-gantt-dependencies {
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
}

.k-pdf-export-shadow .k-gantt-treelist .k-treelist {
    display: block;
}

.k-pdf-export-shadow .k-gantt-layout.k-splitbar {
    display: none;
}

.k-gantt-edit-form .k-gantt-delete {
    float: left;
}

.k-rtl .k-gantt-rows,
.k-rtl .k-gantt-columns,
[dir="rtl"] .k-gantt-rows,
[dir="rtl"] .k-gantt-columns {
    left: auto;
    right: 0;
}

.k-rtl .k-task-wrap:not(.k-milestone-wrap),
[dir="rtl"] .k-task-wrap:not(.k-milestone-wrap) {
    margin-block: 0;
    margin-inline: -26px;
}

.k-rtl .k-gantt-timeline-pane .k-header,
[dir="rtl"] .k-gantt-timeline-pane .k-header {
    border-width: 0 1px 1px 0;
}

.k-rtl .k-gantt-timeline-pane .k-header:first-child,
[dir="rtl"] .k-gantt-timeline-pane .k-header:first-child {
    border-right-width: 0;
}

.k-rtl .k-gantt-timeline-pane .k-task-start,
[dir="rtl"] .k-gantt-timeline-pane .k-task-start {
    left: auto;
    right: 0;
}

.k-rtl .k-gantt-timeline-pane .k-task-end,
[dir="rtl"] .k-gantt-timeline-pane .k-task-end {
    right: auto;
    left: 0;
}

.k-rtl .k-task-content,
[dir="rtl"] .k-task-content {
    text-align: end;
}

.k-rtl .k-task-complete,
[dir="rtl"] .k-task-complete {
    left: auto;
    right: 0;
}

.k-rtl .k-task-draghandle,
[dir="rtl"] .k-task-draghandle {
    margin-left: 0;
    margin-right: 16px;
}

.k-rtl .k-gantt-dependencies,
[dir="rtl"] .k-gantt-dependencies {
    left: auto;
    right: 0;
}

.k-rtl .k-gantt-delete,
[dir="rtl"] .k-gantt-delete {
    float: right;
}

.k-rtl .k-task-offset-wrap .k-task-content .k-resize-e,
[dir="rtl"] .k-task-offset-wrap .k-task-content .k-resize-e {
    display: block;
}

.k-rtl .k-task-offset-wrap .k-task-content .k-resize-w,
[dir="rtl"] .k-task-offset-wrap .k-task-content .k-resize-w {
    display: none;
}

.k-rtl .k-milestone-wrap,
[dir="rtl"] .k-milestone-wrap {
    margin-left: -2.3em;
}

.k-rtl .k-milestone-wrap .k-task-moment,
[dir="rtl"] .k-milestone-wrap .k-task-moment {
    margin-right: 0.2em;
}

.k-rtl .k-gantt-timeline-pane .k-milestone-wrap .k-task-start,
[dir="rtl"] .k-gantt-timeline-pane .k-milestone-wrap .k-task-start {
    right: -0.1em;
}

.k-rtl .k-gantt-tooltip-validation::before,
[dir="rtl"] .k-gantt-tooltip-validation::before {
    left: auto;
    right: 0;
}

.k-gantt {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-gantt .k-treelist-scrollable .k-task-milestone .k-task-milestone-content {
    border-color: #babec1;
    background-color: #dee2e6;
}

.k-gantt .k-treelist-scrollable .k-task-milestone.k-selected .k-task-milestone-content {
    border-color: #0c65e9;
    background-color: #0d6efd;
}

.k-gantt .k-gantt-dependencies-svg polyline {
    fill: none;
    stroke: #909294;
}

.k-gantt .k-gantt-dependencies-svg polyline.k-selected {
    stroke: #0d6efd;
}

.k-gantt-footer {
    box-shadow: none;
}

.k-gantt-treelist .k-treelist,
.k-gantt-treelist .k-grid-content {
    background-color: transparent;
}

.k-gantt .k-nonwork-hour {
    background-color: rgba(0, 0, 0, 0.025);
}

.k-task-dot::before {
    background-color: #212529;
}

.k-task-dot:hover::before,
.k-task-dot.k-hover::before {
    border-color: #212529;
    background-color: #ffffff;
}

.k-task-milestone {
    border-color: #babec1;
    background-color: #dee2e6;
}

.k-task-milestone.k-task-delayed {
    background-image: repeating-linear-gradient(90deg, #ffffff, #ffffff 2px, #dc3545 2px, #dc3545 4px);
}

.k-task-milestone.k-task-advanced {
    background-color: #198754;
}

.k-task-milestone.k-selected {
    background-image: none;
    border-color: #0c65e9;
    background-color: #0d6efd;
}

.k-task-summary {
    color: #909294;
}

.k-task-summary.k-task-delayed {
    color: #ea868f;
}

.k-task-summary.k-task-advanced {
    color: #75b798;
}

.k-task-summary-complete {
    color: #212529;
}

.k-task-delayed .k-task-summary-complete {
    color: #dc3545;
}

.k-task-advanced .k-task-summary-complete {
    color: #198754;
}

.k-task-summary.k-selected {
    color: #86b7fe;
}

.k-task-summary.k-selected .k-task-summary-complete {
    color: #0d6efd;
}

.k-task-single {
    border-color: #ced4da;
    color: black;
    background-color: #dee2e6;
}

.k-task-single.k-task-delayed {
    background-color: #ea868f;
}

.k-task-single.k-task-advanced {
    background-color: #75b798;
}

.k-task-single .k-task-complete {
    background-color: #ced4da;
}

.k-task-delayed .k-task-complete {
    background-color: #dc3545;
}

.k-task-advanced .k-task-complete {
    background-color: #198754;
}

.k-task-single.k-selected {
    border-color: #0d6efd;
    color: white;
    background-color: #86b7fe;
}

.k-task-single.k-selected .k-task-complete {
    background-color: #0d6efd;
}

.k-gantt-line {
    color: #909294;
}

.k-gantt-line.k-selected {
    color: #0d6efd;
}

.k-task-planned .k-task-moment {
    border-color: #0d6efd;
    background-color: transparent;
}

.k-task-planned .k-task-duration {
    background-color: #0d6efd;
}

.k-task-planned:hover .k-task-moment {
    background-color: #0d6efd;
}

.k-task-offset {
    background-image: repeating-linear-gradient(135deg, #ffffff, #ffffff 2px, #dc3545 2px, #dc3545 4px);
}

.k-task-offset .k-resize-e::before {
    border-color: #000000;
}

.k-task-offset .k-task-actions {
    color: #000000;
}

.k-task-offset:hover {
    background-image: repeating-linear-gradient(135deg, #ffffff, #ffffff 2px, #ea868f 2px, #ea868f 4px);
}

.k-pdf-export .k-task-offset {
    background-color: #dc3545;
}

.k-offset-tooltip-delayed {
    background-color: #dc3545;
}

.k-planned-tooltip {
    background-color: #0d6efd;
}

.k-gantt-tooltip-validation::before {
    background-color: #656565;
}

.k-gantt-tooltip-valid::before {
    background-color: #198754;
}

.k-gantt-tooltip-invalid::before {
    background-color: #dc3545;
}

.k-scheduler {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-scheduler table,
.k-scheduler thead,
.k-scheduler tfoot,
.k-scheduler tbody,
.k-scheduler tr,
.k-scheduler th,
.k-scheduler td,
.k-scheduler div,
.k-scheduler .k-scheduler-edit-dialog,
.k-scheduler > * {
    border-color: inherit;
}

kendo-scheduler.k-scheduler {
    overflow: hidden;
}

kendo-scheduler.k-scheduler.k-readonly-scheduler .k-event-delete {
    display: none;
}

.k-scheduler-table {
    width: 100%;
    max-width: none;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
}

.k-scheduler-table td,
.k-scheduler-table th {
    padding-block: 0.75rem;
    padding-inline: 0.75rem;
    height: 1.5em;
    overflow: hidden;
    white-space: nowrap;
    border-style: solid;
    border-width: 0 0 1px 1px;
    vertical-align: top;
    box-sizing: content-box;
}

.k-scheduler-table td:first-child,
.k-scheduler-table th:first-child {
    border-left-width: 0;
}

.k-scheduler-table .k-middle-row td {
    border-bottom-style: dotted;
}

.k-scheduler-table .k-link {
    cursor: pointer;
}

.k-scheduler-layout-flex {
    overflow: auto;
}

.k-scheduler-layout-flex .k-scheduler-head {
    position: sticky;
    top: 0;
    z-index: 3;
}

.k-scheduler-layout-flex .k-scheduler-body {
    position: relative;
}

.k-scheduler-layout-flex .k-scheduler-head,
.k-scheduler-layout-flex .k-scheduler-body {
    display: flex;
    flex: 100%;
    flex-wrap: wrap;
}

.k-scheduler-layout-flex .k-scheduler-row {
    display: flex;
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
}

.k-scheduler-layout-flex .k-scheduler-group {
    display: flex;
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
    flex-wrap: wrap;
}

.k-scheduler-layout-flex .k-scheduler-group .k-group-cell {
    display: flex;
    flex: 1 1 auto;
    flex-wrap: wrap;
    overflow: auto;
}

.k-scheduler-layout-flex .k-scheduler-group .k-group-content {
    padding: 0;
    display: flex;
    flex: 1 1 100%;
    width: 100%;
    border-width: 0;
    flex-wrap: wrap;
}

.k-scheduler-layout-flex .k-scheduler-group.k-group-horizontal .k-group-cell {
    flex-basis: 100%;
    border-width: 0;
    padding: 0;
}

.k-scheduler-layout-flex.k-scheduler-timeline-view .k-scheduler-body .k-scheduler-cell {
    flex-basis: auto;
}

.k-scheduler-layout-flex .k-more-events {
    bottom: 2px;
    left: 0;
    width: 100%;
}

.k-scheduler-layout-flex .k-scheduler-cell {
    display: flex;
    flex: 1 1 100%;
    padding-block: 0.75rem;
    padding-inline: 0.75rem;
    min-height: 1.5em;
    overflow: hidden;
    white-space: nowrap;
    border-style: solid;
    border-width: 0 1px 1px 0;
    vertical-align: top;
    box-sizing: content-box;
}

.k-scheduler-layout-flex .k-scheduler-cell.k-slot-cell {
    position: relative;
}

.k-scheduler-layout-flex .k-scheduler-cell.k-heading-cell {
    justify-content: center;
    font-weight: bold;
}

.k-scheduler-layout-flex .k-scheduler-cell.k-side-cell {
    justify-content: flex-end;
    flex-grow: 0;
    flex-basis: auto;
    overflow: visible;
}

.k-scheduler-layout-flex .k-scheduler-cell.k-major-cell {
    border-bottom-width: 0;
}

.k-scheduler-layout-flex .k-middle-row .k-scheduler-cell {
    border-bottom-style: dotted;
}

.k-scheduler-layout-flex .k-resource-cell {
    flex: none;
    display: flex;
    flex-wrap: wrap;
    overflow: visible;
}

.k-scheduler-layout-flex .k-resource-content {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    border-width: 0;
}

.k-scheduler-layout-flex .k-sticky-cell {
    display: flex;
    flex-wrap: wrap;
    flex-basis: 0;
    position: sticky;
    left: 0;
    z-index: 3;
}

.k-scheduler-toolbar {
    border-width: 0;
    border-bottom-width: 1px;
    white-space: nowrap;
    flex-shrink: 0;
    position: relative;
    z-index: 2;
}

.k-scheduler-toolbar .k-widget {
    font-size: inherit;
}

.k-scheduler-toolbar .k-nav-current {
    color: inherit;
    outline: 0;
    text-decoration: none;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
}

.k-scheduler-toolbar .k-scheduler-search {
    display: inline-flex;
    flex-flow: row nowrap;
}

.k-scheduler-toolbar .k-views-dropdown {
    width: auto;
    font: inherit;
}

.k-scheduler-footer {
    box-shadow: none;
    border-width: 0;
    border-top-width: 1px;
    white-space: nowrap;
    flex-shrink: 0;
    position: relative;
}

.k-scheduler-layout {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    flex: 1 1 auto;
    position: relative;
    z-index: 1;
}

.k-scheduler-layout > tbody > tr > td {
    padding: 0;
    vertical-align: top;
}

.k-scheduler-layout td.k-selected,
.k-scheduler-layout .k-scheduler-cell.k-selected {
    outline: none;
}

.k-scheduler-layout tr + tr .k-scheduler-times tr th,
.k-scheduler-layout .k-scheduler-pane + .k-scheduler-pane .k-scheduler-times tr th {
    border-bottom-color: transparent;
}

.k-scheduler-layout tr + tr .k-scheduler-times tr .k-slot-cell,
.k-scheduler-layout tr + tr .k-scheduler-times tr .k-scheduler-times-all-day,
.k-scheduler-layout tr + tr .k-scheduler-times tr:last-child th,
.k-scheduler-layout .k-scheduler-pane + .k-scheduler-pane .k-scheduler-times tr .k-slot-cell,
.k-scheduler-layout .k-scheduler-pane + .k-scheduler-pane .k-scheduler-times tr .k-scheduler-times-all-day,
.k-scheduler-layout .k-scheduler-pane + .k-scheduler-pane .k-scheduler-times tr:last-child th {
    border-bottom-color: inherit;
}

.k-scheduler-layout.k-scheduler-flex-layout {
    display: flex;
    flex-direction: column;
}

.k-scheduler-layout.k-scheduler-flex-layout.k-scheduler-weekview .k-scheduler-pane:first-child .k-scheduler-table, .k-scheduler-layout.k-scheduler-flex-layout.k-scheduler-dayview .k-scheduler-pane:first-child .k-scheduler-table {
    table-layout: fixed;
}

.k-scheduler-header,
.k-scheduler-view-header {
    padding-inline-end: var(--kendo-scrollbar-width, 17px);
}

.k-scheduler-header th {
    text-align: center;
}

.k-scheduler-header,
.k-scheduler-header-wrap,
.k-scheduler-header-wrap > div {
    border-color: inherit;
    overflow: hidden;
}

.k-scheduler-header-wrap {
    border-width: 0;
    border-style: solid;
    position: relative;
}

.k-scheduler-times {
    border-color: inherit;
    position: relative;
    overflow: hidden;
}

.k-scheduler-times .k-scheduler-table {
    table-layout: auto;
}

.k-scheduler-times th {
    border-width: 0 1px 1px 0;
    text-align: end;
}

.k-scheduler-times .k-slot-cell,
.k-scheduler-times .k-scheduler-times-all-day {
    border-bottom-color: inherit;
}

.k-scheduler-times .k-slot-cell.k-last-resource {
    border-right: 0;
}

.k-scheduler-times .k-slot-cell.k-empty-slot {
    padding-left: 0;
    padding-right: 0;
}

.k-scheduler-datecolumn {
    width: 12em;
}

.k-scheduler-timecolumn {
    width: 11em;
    white-space: nowrap;
}

.k-scheduler-content {
    border-color: inherit;
    position: relative;
    overflow: auto;
}

.k-scheduler-content:focus {
    outline: none;
}

kendo-scheduler .k-event,
.k-event {
    border-radius: 0.375rem;
    min-height: 25px;
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-radius: 0.375rem;
    text-align: start;
    outline: 0;
    cursor: default;
    position: absolute;
    overflow: hidden;
    padding-right: 1rem;
}

kendo-scheduler .k-event > div,
.k-event > div {
    position: relative;
    z-index: 2;
}

kendo-scheduler .k-event .k-event-template,
.k-event .k-event-template {
    line-height: calc(25px - 0.5rem);
    padding-block: 0.5rem;
    padding-inline: 1rem;
}

kendo-scheduler .k-event .k-event-time,
.k-event .k-event-time {
    padding-bottom: 0;
    font-size: .875em;
    white-space: nowrap;
    display: none;
}

kendo-scheduler .k-event .k-event-actions,
.k-event .k-event-actions {
    white-space: nowrap;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 1rem;
    z-index: 2;
}

kendo-scheduler .k-event .k-event-actions .k-event-delete,
.k-event .k-event-actions .k-event-delete {
    opacity: .5;
    visibility: hidden;
}

kendo-scheduler .k-event .k-event-actions:hover .k-event-delete, kendo-scheduler .k-event .k-event-actions.k-hover .k-event-delete,
.k-event .k-event-actions:hover .k-event-delete,
.k-event .k-event-actions.k-hover .k-event-delete {
    opacity: 1;
}

kendo-scheduler .k-event .k-event-actions a,
.k-event .k-event-actions a {
    color: inherit;
}

kendo-scheduler .k-event .k-event-actions:first-child,
.k-event .k-event-actions:first-child {
    margin: 0.25rem 0.4ex 0 0.5rem;
    top: 0;
    right: 0;
    float: left;
    position: relative;
    opacity: 1;
    visibility: visible;
    line-height: normal;
}

kendo-scheduler .k-event .k-resize-handle,
.k-event .k-resize-handle {
    z-index: 4;
    opacity: .5;
    visibility: hidden;
}

kendo-scheduler .k-event .k-resize-handle::before,
.k-event .k-resize-handle::before {
    border-color: currentColor;
}

kendo-scheduler .k-event .k-resize-n,
.k-event .k-resize-n {
    height: .5em;
    top: 0;
}

kendo-scheduler .k-event .k-resize-s,
.k-event .k-resize-s {
    height: .5em;
    bottom: 0;
}

kendo-scheduler .k-event .k-resize-n::before,
kendo-scheduler .k-event .k-resize-s::before,
.k-event .k-resize-n::before,
.k-event .k-resize-s::before {
    width: 2rem;
    border-bottom-width: 1px;
}

kendo-scheduler .k-event .k-resize-w,
.k-event .k-resize-w {
    width: .5em;
    left: 0;
}

kendo-scheduler .k-event .k-resize-e,
.k-event .k-resize-e {
    width: .5em;
    right: 0;
}

kendo-scheduler .k-event .k-resize-w::before,
kendo-scheduler .k-event .k-resize-e::before,
.k-event .k-resize-w::before,
.k-event .k-resize-e::before {
    height: 2rem;
    border-left-width: 1px;
}

kendo-scheduler .k-event:hover .k-event-actions .k-event-delete,
kendo-scheduler .k-event:hover .k-resize-handle, kendo-scheduler .k-event.k-hover .k-event-actions .k-event-delete,
kendo-scheduler .k-event.k-hover .k-resize-handle,
.k-event:hover .k-event-actions .k-event-delete,
.k-event:hover .k-resize-handle,
.k-event.k-hover .k-event-actions .k-event-delete,
.k-event.k-hover .k-resize-handle {
    visibility: visible;
}

kendo-scheduler .k-event.k-event-drag-hint .k-event-time,
.k-event.k-event-drag-hint .k-event-time {
    display: block;
}

kendo-scheduler .k-event .k-event-top-actions,
kendo-scheduler .k-event .k-event-bottom-actions,
.k-event .k-event-top-actions,
.k-event .k-event-bottom-actions {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
}

kendo-scheduler .k-event .k-event-bottom-actions,
.k-event .k-event-bottom-actions {
    top: auto;
    bottom: 0;
}

.k-scheduler-mark {
    width: 1em;
    height: 1em;
    display: inline-block;
    vertical-align: middle;
}

.k-more-events {
    padding: 0;
    height: 13px;
    border-style: solid;
    border-width: 1px;
    overflow: hidden;
    position: absolute;
    justify-content: center;
}

.k-more-events > .k-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.k-event-drag-hint {
    opacity: .5;
    z-index: 3;
}

.k-event-drag-hint .k-event-actions,
.k-event-drag-hint .k-event-top-actions,
.k-event-drag-hint .k-event-bottom-actions,
.k-event-drag-hint .k-resize-handle {
    display: none;
}

.k-event-drag-hint .k-event-time {
    display: block;
}

.k-scheduler-marquee {
    border-width: 0;
    border-style: solid;
}

.k-scheduler-marquee .k-label-top,
.k-scheduler-marquee .k-label-bottom {
    font-size: .75em;
    position: absolute;
}

.k-scheduler-marquee .k-label-top {
    left: 0.5rem;
    top: 0.25rem;
}

.k-scheduler-marquee .k-label-bottom {
    right: 0.5rem;
    bottom: 0.25rem;
}

.k-scheduler-marquee.k-first::before, .k-scheduler-marquee.k-last::after {
    content: "";
    border-width: 3px;
    border-style: solid;
    position: absolute;
    width: 0;
    height: 0;
}

.k-scheduler-marquee.k-first::before {
    top: 0;
    left: 0;
    border-right-color: transparent;
    border-bottom-color: transparent;
}

.k-scheduler-marquee.k-last::after {
    bottom: 0;
    right: 0;
    border-left-color: transparent;
    border-top-color: transparent;
}

.k-pdf-export-shadow .k-scheduler,
.k-scheduler-pdf-export .k-scheduler-content,
.k-scheduler-pdf-export .k-scheduler-times {
    height: auto !important;
    overflow: visible !important;
}

.k-scheduler-pdf-export {
    overflow: hidden;
}

.k-scheduler-pdf-export .k-scheduler-header {
    padding: 0 !important;
}

.k-scheduler-pdf-export .k-scheduler-header-wrap {
    border-width: 0 !important;
}

.k-scheduler-pdf-export .k-scheduler-header .k-scheduler-table,
.k-scheduler-pdf-export .k-scheduler-content .k-scheduler-table {
    width: 100% !important;
}

.k-recurrence-editor {
    display: flex;
    flex-direction: column;
}

kendo-scheduler .k-recurrence-editor {
    display: block;
}

.k-scheduler-monthview .k-scheduler-table {
    height: 100%;
}

.k-scheduler-monthview .k-scheduler-table td {
    height: 80px;
    text-align: end;
}

.k-scheduler-monthview .k-scheduler-body .k-scheduler-cell {
    min-height: 80px;
}

.k-scheduler-monthview .k-hidden {
    padding-left: 0 !important;
    padding-right: 0 !important;
    border-right-width: 0 !important;
}

.k-scheduler-monthview .k-scheduler-table-auto,
.k-scheduler-monthview .k-scheduler-table-auto td,
.k-scheduler-monthview .k-scheduler-content .k-scheduler-table-auto {
    height: auto;
}

.k-scheduler-monthview .k-scheduler-content {
    overflow-y: scroll;
}

.k-scheduler-monthview.k-scheduler-flex-layout .k-scheduler-content {
    overflow-y: auto;
}

.k-scheduler-agendaview .k-scheduler-mark {
    margin-right: .5em;
    width: 1em;
    height: 1em;
    display: inline-block;
    vertical-align: middle;
}

.k-scheduler-agendaview .k-scheduler-table th:first-child,
.k-scheduler-agendaview .k-scheduler-table td:first-child {
    border-left-width: 1px;
}

.k-scheduler-agendaview .k-scheduler-table td.k-first {
    border-left-width: 0;
}

.k-scheduler-agendaview .k-task > .k-event-delete {
    color: inherit;
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    opacity: .5;
    visibility: hidden;
}

.k-scheduler-agendaview .k-hover .k-task > .k-event-delete,
.k-scheduler-agendaview .k-scheduler-content tr:hover .k-event-delete,
.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row:hover .k-event-delete,
.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row.k-hover .k-event-delete {
    visibility: visible;
}

.k-scheduler-agendaday {
    margin: 0 .2em 0 0;
    font-size: 3em;
    line-height: 1;
    font-weight: 400;
    float: left;
}

.k-scheduler-agendaweek {
    display: block;
    margin: .4em 0 0;
    line-height: 1;
    font-style: normal;
}

.k-scheduler-agendadate {
    font-size: .75em;
}

.k-scheduler-timelineview .k-slot-cell {
    overflow: hidden;
}

.k-scheduler-timelineview .k-scheduler-content {
    overflow: auto;
}

.k-scheduler-pane {
    display: flex;
    flex-direction: row;
}

.k-scheduler-pane .k-scheduler-times {
    flex: 0 0 auto;
}

.k-scheduler-pane .k-scheduler-times .k-scheduler-table {
    height: 100%;
}

.k-scheduler-pane .k-scheduler-header,
.k-scheduler-pane .k-scheduler-content {
    flex: 1 1 auto;
}

.k-scheduler-yearview .k-scheduler-body {
    padding-block: 1rem;
    padding-inline: 1rem;
    justify-content: center;
}

.k-scheduler-yearview .k-calendar {
    width: 100%;
    border-width: 0;
}

.k-scheduler-yearview .k-calendar .k-calendar-view {
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
}

.k-scheduler-yearview .k-calendar .k-content {
    flex: 0;
}

.k-scheduler-yearview .k-calendar .k-link {
    position: relative;
}

.k-scheduler-yearview .k-calendar td.k-selected {
    background-color: inherit;
}

.k-scheduler-yearview .k-day-indicator {
    margin-top: calc(38px - 0.5rem);
    width: 3px;
    height: 3px;
    border-radius: 50%;
    position: absolute;
    left: calc(50% - 1.5px);
}

.k-scheduler-tooltip {
    padding-block: 0.75rem;
    padding-inline: 0.75rem;
    border-width: 0;
    color: inherit;
}

.k-scheduler-tooltip .k-tooltip-title {
    margin-bottom: 0.75rem;
}

.k-scheduler-tooltip .k-tooltip-title .k-month {
    font-size: 0.875rem;
    text-transform: uppercase;
}

.k-scheduler-tooltip .k-tooltip-title .k-day {
    font-size: 1.75rem;
}

.k-scheduler-tooltip .k-tooltip-events-container {
    overflow: auto;
}

.k-scheduler-tooltip .k-tooltip-events {
    max-height: 250px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.k-scheduler-tooltip .k-tooltip-event {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    border-radius: 0.375rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    gap: 0.5rem;
}

.k-scheduler-tooltip .k-tooltip-event .k-event-time {
    display: flex;
    flex-shrink: 0;
    font-size: inherit;
}

.k-scheduler-tooltip .k-no-data, .k-scheduler-tooltip .k-nodata {
    height: auto;
    min-height: auto;
    color: inherit;
}

.k-scheduler-edit-dialog .k-dialog {
    max-height: 100vh;
}

.k-scheduler-edit-form .k-edit-form-container {
    width: 100%;
}

.k-scheduler-edit-form .k-edit-label {
    width: 17%;
}

.k-scheduler-edit-form .k-edit-field {
    width: 77%;
}

.k-scheduler-edit-form .k-edit-field > ul > li {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}

.k-scheduler-edit-form .k-recurrence-editor .k-radio-list .k-radio-wrap,
.k-scheduler-edit-form .k-recurrence-editor .k-checkbox-list .k-checkbox-wrap {
    align-self: center;
}

.k-scheduler-edit-form .k-recur-interval,
.k-scheduler-edit-form .k-recur-count,
.k-scheduler-edit-form .k-recur-monthday {
    width: 5em;
}

.k-scheduler-edit-form .k-recur-until,
.k-scheduler-edit-form .k-recur-month,
.k-scheduler-edit-form .k-recur-weekday,
.k-scheduler-edit-form .k-recur-weekday-offset {
    width: 10em;
}

.k-scheduler-edit-form .k-scheduler-datetime-picker {
    display: flex;
    flex-flow: row nowrap;
    gap: 0.5rem;
}

.k-rtl .k-scheduler-header th,
.k-rtl .k-scheduler-table td {
    border-width: 0 1px 1px 0;
}

.k-rtl .k-scheduler-table td:first-child,
.k-rtl .k-scheduler-table th:first-child {
    border-right-width: 0;
}

.k-rtl .k-scheduler-times th {
    border-width: 0 0 1px 1px;
}

.k-rtl .k-scheduler .k-scrollbar-v .k-scheduler-header-wrap {
    border-right-width: 0;
    border-left-width: 1px;
}

.k-rtl .k-event {
    padding-right: 0;
    padding-left: 1rem;
}

.k-rtl .k-event .k-resize-w {
    left: auto;
    right: 0;
}

.k-rtl .k-event .k-resize-e {
    right: auto;
    left: 0;
}

.k-rtl .k-event .k-event-actions {
    right: auto;
    left: 2px;
}

.k-rtl .k-event .k-event-actions:first-child {
    margin: 0.25rem 0.5rem 0 0.4ex;
    float: right;
}

.k-rtl .k-scheduler-agendaview .k-task > .k-event-delete {
    left: 2px;
    right: auto;
}

.k-rtl .k-scheduler-agendaview .k-task .k-scheduler-mark {
    margin-left: .5em;
    margin-right: 0;
}

.k-rtl .k-scheduler-marquee .k-label-top {
    left: auto;
    right: 4px;
}

.k-rtl .k-scheduler-marquee .k-label-bottom {
    left: 4px;
    right: auto;
}

.k-rtl .k-scheduler-edit-form .k-scheduler-delete {
    float: right;
}

.k-rtl .k-scheduler .k-scheduler-header-wrap, .k-rtl.k-scheduler .k-scheduler-header-wrap {
    border-right-width: 0;
}

.k-rtl .k-scheduler .k-scheduler-agendaday, .k-rtl.k-scheduler .k-scheduler-agendaday {
    float: right;
    margin: 0 0 0 .2em;
}

.k-rtl .k-scheduler .k-scheduler-agendaview .k-scheduler-table td:first-child,
.k-rtl .k-scheduler .k-scheduler-agendaview .k-scheduler-table th:first-child, .k-rtl.k-scheduler .k-scheduler-agendaview .k-scheduler-table td:first-child,
.k-rtl.k-scheduler .k-scheduler-agendaview .k-scheduler-table th:first-child {
    border-left-width: 0;
}

.k-rtl .k-scheduler .k-scheduler-agendaview .k-scheduler-table tr + tr td:first-child,
.k-rtl .k-scheduler .k-scheduler-agendaview .k-scheduler-table tr + tr th:first-child, .k-rtl.k-scheduler .k-scheduler-agendaview .k-scheduler-table tr + tr td:first-child,
.k-rtl.k-scheduler .k-scheduler-agendaview .k-scheduler-table tr + tr th:first-child {
    border-right-width: 1px;
}

.k-safari .k-scheduler-tooltip .k-tooltip-event:not(:last-child) {
    margin-bottom: 0.5rem;
}

.k-safari .k-scheduler-yearview .k-calendar-view .k-month {
    margin-block: 0;
    margin-inline: 0.5rem;
}

kendo-scheduler .k-event::before,
.k-event::before {
    display: none;
    left: 0;
}

.k-rtl kendo-scheduler .k-event::before, .k-rtl
.k-event::before {
    right: 0;
}

kendo-scheduler .k-event .k-event-template,
.k-event .k-event-template {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    font-size: 0.875rem;
}

kendo-scheduler .k-event .k-event-actions,
.k-event .k-event-actions {
    right: 0.5rem;
}

kendo-scheduler .k-event .k-event-actions:first-child,
.k-event .k-event-actions:first-child {
    margin: 0.1ex 0.4ex 0 0.5rem;
}

.k-scheduler {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-scheduler-toolbar {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-scheduler-footer {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-scheduler-header {
    background-color: #f8f9fa;
}

.k-scheduler-header-wrap {
    background-color: #ffffff;
}

.k-scheduler-nonwork,
.k-scheduler .k-nonwork-hour {
    background-color: whitesmoke;
}

.k-scheduler-other-month,
.k-scheduler .k-other-month {
    background-color: whitesmoke;
}

.k-scheduler-layout td.k-selected,
.k-scheduler-layout .k-scheduler-cell.k-selected {
    background-color: rgba(13, 110, 253, 0.25);
}

.k-scheduler-layout-flex .k-scheduler-head,
.k-scheduler-layout-flex .k-sticky-cell {
    background-color: #ffffff;
}

.k-event {
    color: white;
    background-color: #3485fd;
}

.k-event.k-selected {
    color: white;
    background-color: #0d6efd;
    box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.5);
}

.k-event.k-event-inverse {
    color: black;
}

.k-event.k-event-ongoing {
    box-shadow: inset 0px 0px 0px 1px #ff0000;
}

.k-scheduler-marquee::before,
.k-scheduler-marquee::after {
    border-color: #0d6efd;
}

.k-scheduler-edit-dialog .k-dialog-actions {
    border-color: #dee2e6;
}

.k-scheduler-agendaview .k-scheduler-content tr:hover,
.k-scheduler-agendaview .k-scheduler-content tr.k-hover,
.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row:hover,
.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row.k-hover {
    border-color: #d6d9dc;
    color: #212529;
    background-color: #e9ecef;
}

.k-scheduler-agendaview .k-scheduler-content tr:hover .k-scheduler-datecolumn,
.k-scheduler-agendaview .k-scheduler-content tr:hover .k-scheduler-groupcolumn,
.k-scheduler-agendaview .k-scheduler-content tr.k-hover .k-scheduler-datecolumn,
.k-scheduler-agendaview .k-scheduler-content tr.k-hover .k-scheduler-groupcolumn {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-scheduler-agendaview .k-scheduler-content tr.k-selected {
    background-color: rgba(13, 110, 253, 0.25);
}

.k-scheduler-agendaview .k-scheduler-content tr.k-selected .k-scheduler-datecolumn,
.k-scheduler-agendaview .k-scheduler-content tr.k-selected .k-scheduler-groupcolumn {
    background-color: #ffffff;
}

.k-scheduler-yearview .k-day-indicator {
    background-color: #0d6efd;
}

.k-scheduler-yearview .k-selected .k-day-indicator {
    background-color: white;
}

.k-tooltip.k-scheduler-tooltip {
    color: #212529;
    background-color: white;
    box-shadow: var(--kendo-elevation-2, 0px 2px 7px rgba(0, 0, 0, 0.075));
}

.k-tooltip.k-scheduler-tooltip .k-callout {
    color: white;
}

.k-chat {
    margin: auto;
    max-width: 500px;
    height: 600px;
    max-height: 100%;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-chat .k-message-list {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: flex-start;
    overflow-x: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
}

.k-chat .k-message-list-content {
    padding-block: 16px;
    padding-inline: 16px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: hidden;
}

.k-chat .k-message-list-content > * + * {
    margin-top: 16px;
}

.k-chat .k-message-group {
    max-width: 80%;
    background: none;
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    position: relative;
}

.k-chat .k-message-group:not(.k-alt) {
    align-items: flex-start;
    text-align: start;
}

.k-chat .k-message-group:not(.k-alt) .k-message-time {
    margin-inline-start: 8px;
    inset-inline-start: 100%;
}

.k-chat .k-message-group:not(.k-alt) .k-message-status {
    inset-inline-start: 0;
}

.k-chat .k-message-group:not(.k-alt) .k-first .k-chat-bubble,
.k-chat .k-message-group:not(.k-alt) .k-only .k-chat-bubble {
    border-bottom-left-radius: 2px;
}

.k-chat .k-message-group:not(.k-alt) .k-middle .k-chat-bubble,
.k-chat .k-message-group:not(.k-alt) .k-last .k-chat-bubble {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
}

.k-chat .k-message-group.k-alt {
    align-self: flex-end;
    align-items: flex-end;
    text-align: end;
}

.k-chat .k-message-group.k-alt .k-message-time {
    margin-inline-end: 8px;
    inset-inline-end: 100%;
}

.k-chat .k-message-group.k-alt .k-message-status {
    inset-inline-end: 0;
}

.k-chat .k-message-group.k-alt .k-first .k-chat-bubble,
.k-chat .k-message-group.k-alt .k-only .k-chat-bubble {
    border-bottom-right-radius: 2px;
}

.k-chat .k-message-group.k-alt .k-middle .k-chat-bubble,
.k-chat .k-message-group.k-alt .k-last .k-chat-bubble {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
}

.k-chat .k-message {
    max-width: 100%;
    margin: 2px 0 0;
    position: relative;
    transition: margin .2s ease-in-out;
    outline: none;
}

.k-chat .k-message-time,
.k-chat .k-message-status {
    font-size: smaller;
    line-height: normal;
    white-space: nowrap;
    pointer-events: none;
    position: absolute;
}

.k-chat .k-message-time {
    opacity: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: opacity .2s ease-in-out;
}

.k-chat .k-message-status {
    margin-top: 2px;
    height: 0;
    overflow: hidden;
    top: 100%;
    transition: height .2s ease-in-out;
}

.k-chat .k-chat-bubble {
    border-radius: 12px;
    padding-block: 8px;
    padding-inline: 16px;
    border-width: 1px;
    border-style: solid;
    line-height: 1.25;
    word-wrap: break-word;
    white-space: pre-wrap;
}

.k-chat .k-chat-bubble a {
    color: inherit;
    text-decoration: underline;
}

.k-chat .k-message.k-selected {
    margin-bottom: 16px;
    border: 0;
    color: inherit;
    background: none;
}

.k-chat .k-message.k-selected .k-message-time {
    opacity: 1;
}

.k-chat .k-message.k-selected .k-message-status {
    height: 1.2em;
}

.k-chat .k-message-error,
.k-chat .k-message-sending {
    margin-bottom: 16px;
}

.k-chat .k-message-error .k-message-status,
.k-chat .k-message-sending .k-message-status {
    height: 1.2em;
}

.k-chat .k-avatar {
    margin: 0;
    position: absolute;
}

.k-message-group:not(.k-alt) > .k-avatar {
    inset-inline-start: 0;
    bottom: 0;
}

.k-message-group.k-alt > .k-avatar {
    inset-inline-end: 0;
    bottom: 0;
}

.k-chat .k-avatars .k-message-group:not(.k-no-avatar) {
    padding-inline-start: 40px;
}

.k-chat .k-avatars .k-message-group.k-alt:not(.k-no-avatar) {
    padding-inline-end: 40px;
}

.k-author {
    margin: 0;
    font-size: smaller;
    line-height: normal;
}

.k-chat .k-author {
    margin: 0;
}

.k-chat .k-timestamp {
    font-size: smaller;
    text-transform: uppercase;
    text-align: center;
    align-self: stretch;
}

.k-quick-replies {
    display: block;
    max-width: 100%;
}

.k-quick-reply {
    border-radius: 100px;
    margin-inline-end: 8px;
    margin-block-end: 4px;
    padding-block: 8px;
    padding-inline: 12px;
    border-width: 1px;
    border-style: solid;
    line-height: 1.25;
    cursor: pointer;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    display: inline-block;
    flex: 0 0 auto;
    transition-property: color, background-color, border-color;
    transition-duration: .2s;
    transition-timing-function: ease-in-out;
    outline: none;
}

.k-scrollable-quick-replies {
    margin-inline-start: -16px;
    margin-inline-end: -16px;
    padding-inline-start: 16px;
    padding-inline-end: 16px;
    display: flex;
    flex-flow: row nowrap;
    flex: 0 0 auto;
    overflow-x: auto;
    overflow-y: hidden;
}

.k-scrollable-quick-replies::-webkit-scrollbar {
    display: none;
}

.k-scrollable-quick-replies .k-quick-reply {
    margin: 0;
}

.k-scrollable-quick-replies .k-quick-reply + .k-quick-reply {
    margin-inline-start: 8px;
}

.k-message-box {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    border-width: 1px 0 0;
    border-style: solid;
    border-color: inherit !important;
    border-radius: 0 !important;
    flex: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}

.k-message-box:focus, .k-message-box.k-focus, .k-message-box:focus-within {
    outline: 0;
    box-shadow: none;
}

.k-message-box .k-button {
    border-width: 0;
    flex-shrink: 0;
}

.k-message-box .k-button svg {
    width: 20px;
    height: 20px;
    fill: currentColor;
    display: inline-block;
}

.k-rtl .k-message-box .k-button,
[dir="rtl"] .k-message-box .k-button {
    transform: scaleX(-1);
}

.k-chat .k-card-list {
    margin: 2px 0 0;
}

.k-message-group.k-alt + .k-card-list,
.k-message-group.k-alt + kendo-chat-message-attachments.k-card-list {
    align-self: flex-end;
}

.k-chat .k-card-deck {
    max-width: calc(100% + 32px);
    box-sizing: border-box;
    margin-inline-start: -16px;
    margin-inline-end: -16px;
    padding: 16px 16px 16px;
    overflow: hidden;
    overflow-x: auto;
    scroll-behavior: smooth;
}

.k-chat .k-card-deck .k-card {
    width: 200px;
}

.k-chat .k-card-deck-scrollwrap {
    margin-right: -16px;
    margin-left: -16px;
    padding-left: 16px;
    padding-right: 16px;
}

.k-chat .k-card-deck-scrollwrap > .k-card-deck {
    margin-bottom: -20px;
    padding-bottom: 20px;
}

.k-chat .k-card-deck .k-card-wrap {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    flex: 0 0 auto;
    padding-bottom: 5px;
}

.k-chat .k-card-deck .k-card-wrap .k-card {
    flex: 0 0 auto;
}

.k-chat .k-card-deck .k-card-wrap.k-selected {
    background: none;
}

.k-typing-indicator {
    padding: 0;
    border-radius: 50px;
    display: inline-flex;
    flex-flow: row nowrap;
}

.k-typing-indicator span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex: 0 0 8px;
    background-color: currentColor;
    opacity: .4;
}

.k-typing-indicator span:nth-of-type(1) {
    animation: 1s k-animation-blink infinite 0.3333s;
}

.k-typing-indicator span:nth-of-type(2) {
    animation: 1s k-animation-blink infinite 0.6666s;
}

.k-typing-indicator span:nth-of-type(3) {
    animation: 1s k-animation-blink infinite 0.9999s;
}

.k-typing-indicator span + span {
    margin-left: 5px;
}

@keyframes k-animation-blink {
    50% {
        opacity: 1;
    }
}

.k-chat-toolbar,
.k-chat .k-toolbar-box {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    width: 100%;
    border-width: 1px 0 0;
    box-sizing: border-box;
    flex: none;
    overflow: hidden;
    position: relative;
    gap: 0.5rem;
}

.k-chat-toolbar::before,
.k-chat .k-toolbar-box::before {
    display: none;
}

.k-chat-toolbar .k-button-list,
.k-chat .k-toolbar-box .k-button-list {
    display: flex;
    flex-flow: row nowrap;
    overflow: hidden;
    scroll-behavior: smooth;
}

.k-chat-toolbar .k-button,
.k-chat .k-toolbar-box .k-button {
    flex: none;
}

.k-chat-toolbar .k-scroll-button,
.k-chat .k-toolbar-box .k-scroll-button {
    padding: 0 0.25rem;
    height: 100%;
    aspect-ratio: auto;
    position: absolute;
    z-index: 2;
    top: 0;
}

.k-chat-toolbar .k-scroll-button .k-button-icon,
.k-chat .k-toolbar-box .k-scroll-button .k-button-icon {
    min-width: auto;
    min-height: auto;
}

.k-chat-toolbar .k-scroll-button-left,
.k-chat .k-toolbar-box .k-scroll-button-left {
    left: 0;
}

.k-chat-toolbar .k-scroll-button-right,
.k-chat .k-toolbar-box .k-scroll-button-right {
    right: 0;
}

.k-chat {
    border-color: #dee2e6;
    color: #212529;
    background-color: #fafafa;
}

.k-chat .k-timestamp {
    color: #6c757d;
}

.k-chat .k-author {
    font-weight: bold;
}

.k-chat .k-chat-bubble {
    border-color: #e4e7eb;
    color: #212529;
    background-color: #e4e7eb;
    box-shadow: none;
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    order: -1;
}

.k-chat .k-chat-bubble a {
    color: #0d6efd;
}

.k-chat .k-chat-bubble a:hover {
    color: #0a58ca;
}

.k-chat .k-chat-bubble:hover {
    box-shadow: none;
}

.k-chat .k-selected .k-chat-bubble {
    box-shadow: none;
}

.k-chat .k-alt .k-chat-bubble {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
    box-shadow: none;
}

.k-chat .k-alt .k-chat-bubble:hover {
    box-shadow: none;
}

.k-chat .k-alt .k-selected .k-chat-bubble {
    box-shadow: none;
}

.k-chat .k-quick-reply {
    border-color: #0d6efd;
    color: #0d6efd;
    background-color: transparent;
}

.k-chat .k-quick-reply:hover {
    border-color: #0d6efd;
    color: white;
    background-color: #0d6efd;
}

.k-chat-toolbar,
.k-chat .k-toolbar-box {
    border-color: inherit;
    color: #212529;
    background-color: #f8f9fa;
}

.k-mediaplayer {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: block;
    position: relative;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-mediaplayer *,
.k-mediaplayer *::before,
.k-mediaplayer *::after {
    box-sizing: border-box;
}

.k-mediaplayer > iframe {
    width: 100%;
    height: 100%;
    border: 0;
    vertical-align: top;
}

.k-mediaplayer-titlebar {
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
}

.k-mediaplayer-toolbar-wrap {
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    right: 0;
}

.k-mediaplayer-toolbar {
    border-width: 0;
    width: 100% !important;
    box-shadow: none;
}

.k-mediaplayer-toolbar .k-dropdown-list, .k-mediaplayer-toolbar .k-dropdown,
.k-mediaplayer-toolbar .k-dropdownlist {
    width: auto;
}

.k-mediaplayer-time-wrap {
    flex: 1;
}

.k-mediaplayer-volume-wrap {
    padding: 0 7px;
    align-items: center;
}

.k-mediaplayer-volume {
    width: 100px;
}

.k-slider.k-mediaplayer-seekbar {
    width: 100%;
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    transform: translateY(-50%);
}

.k-mediaplayer-seekbar .k-slider-track {
    width: 100% !important;
    border-radius: 0;
}

.k-mediaplayer-seekbar .k-slider-selection {
    border-radius: 0;
}

.k-mediaplayer-fullscreen {
    z-index: 10000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
}

.k-mediaplayer {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-mediaplayer-titlebar {
    color: #ffffff;
    background-image: linear-gradient(rgba(33, 37, 41, 0.7), rgba(33, 37, 41, 0));
    text-shadow: 0 0 2px rgba(33, 37, 41, 0.5);
}

.k-timeline {
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: block;
    background-color: transparent;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-timeline *,
.k-timeline *::before,
.k-timeline *::after, .k-timeline::before, .k-timeline::after {
    box-sizing: border-box;
}

.k-timeline ul {
    margin: 0;
    padding: 0;
}

.k-timeline ul li {
    list-style-type: none;
}

.k-timeline .k-timeline-flag {
    display: inline-block;
    text-align: center;
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
    border-radius: 0.375rem;
    line-height: 1.5;
    min-width: 80px;
    max-width: 160px;
    position: relative;
    z-index: 1;
}

.k-timeline .k-timeline-circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
}

.k-timeline.k-timeline-dates-hidden .k-timeline-date {
    display: none;
}

.k-timeline.k-timeline-collapsible .k-card-header {
    cursor: pointer;
}

.k-timeline.k-timeline-collapsible .k-event-collapse {
    display: flex;
}

.k-timeline-card .k-card {
    position: relative;
    overflow: visible;
}

.k-timeline-card .k-card .k-card-header {
    overflow: visible;
    border-bottom: 0;
}

.k-timeline-card .k-card .k-card-header + .k-card-body {
    padding-top: 0;
}

.k-timeline-card .k-card .k-card-body {
    overflow-y: auto;
    scrollbar-width: thin;
}

.k-timeline-card .k-card .k-card-body::-webkit-scrollbar {
    width: 5px;
}

.k-timeline-card .k-card .k-card-body::-webkit-scrollbar-thumb {
    border-radius: 0.375rem;
}

.k-timeline-card .k-timeline-card-callout.k-callout-w, .k-timeline-card .k-timeline-card-callout.k-callout-e {
    top: 36px;
}

.k-timeline-vertical,
.k-timeline-horizontal {
    padding-block: 0;
    padding-inline: 40px;
    margin-block: 40px;
    margin-inline: 0;
    width: 100%;
    position: relative;
    border: 0;
}

.k-timeline-vertical::after,
.k-timeline-horizontal .k-timeline-track-wrap::after {
    content: "";
    position: absolute;
    top: 0;
    border-width: 1px;
    border-style: solid;
}

.k-timeline-vertical {
    padding-left: 127px;
}

.k-timeline-vertical.k-timeline-dates-hidden {
    padding-left: 77px;
}

.k-timeline-vertical::after {
    height: 100%;
    width: 6px;
    transform: translateX(-50%);
    border-radius: 0.5rem;
}

.k-timeline-vertical .k-timeline-flag-wrap {
    display: flex;
    align-items: center;
}

.k-timeline-vertical .k-timeline-flag-wrap:first-child {
    padding-top: 40px;
}

.k-timeline-vertical .k-timeline-flag {
    transform: translateX(-50%);
}

.k-timeline-vertical .k-timeline-date-wrap {
    position: absolute;
    padding-right: 1rem;
    margin-top: 36px;
    transform: translate(-100%, -50%);
    text-align: end;
}

.k-timeline-vertical .k-timeline-event {
    display: flex;
    align-items: flex-start;
    padding-block: 40px;
    padding-inline: 0;
}

.k-timeline-vertical .k-timeline-card {
    padding-left: 1rem;
}

.k-timeline-vertical .k-timeline-card .k-card {
    margin-left: 1rem;
    min-height: 70px;
    width: 400px;
    max-width: 100%;
}

.k-timeline-vertical .k-timeline-card .k-card .k-card-header {
    border-radius: 0.375rem;
}

.k-timeline-vertical .k-timeline-card .k-card .k-card-title {
    display: flex;
    justify-content: space-between;
}

.k-timeline-vertical .k-timeline-card .k-card .k-card-title .k-event-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.k-timeline-vertical .k-timeline-card .k-event-collapse {
    margin-block: -0.5rem;
    margin-inline: 0;
    transform: rotate(90deg);
    transition: transform .2s ease-in-out;
}

.k-timeline-vertical .k-timeline-card.k-collapsed .k-card-body,
.k-timeline-vertical .k-timeline-card.k-collapsed .k-card-actions {
    display: none;
}

.k-timeline-vertical .k-timeline-card.k-collapsed .k-event-collapse {
    transform: rotate(0deg);
}

.k-timeline-vertical .k-timeline-circle {
    margin-top: 36px;
    transform: translate(-50%, -50%);
    margin-right: -8px;
}

.k-timeline-vertical.k-timeline-alternating {
    padding-left: 40px;
}

.k-timeline-vertical.k-timeline-alternating::after {
    left: 50%;
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-flag-wrap {
    justify-content: center;
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-flag {
    transform: translateX(0);
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-event {
    justify-content: space-between;
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-event.k-reverse {
    flex-direction: row-reverse;
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-event.k-reverse .k-timeline-date-wrap {
    text-align: start;
    padding-right: 0;
    padding-left: 1rem;
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-event.k-reverse .k-timeline-card {
    padding-left: 0;
    padding-right: 1rem;
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-event.k-reverse .k-timeline-card .k-card {
    margin-right: 1rem;
    margin-left: auto;
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-card,
.k-timeline-vertical.k-timeline-alternating .k-timeline-date-wrap {
    flex-basis: 50%;
    min-width: 0;
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-date-wrap {
    position: static;
    transform: translateY(-50%);
}

.k-timeline-vertical.k-timeline-alternating .k-timeline-circle {
    transform: translateY(-50%);
    margin-right: 0;
}

.k-timeline-horizontal .k-timeline-track-item {
    flex: 1 0 20%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    flex-direction: column;
}

.k-timeline-horizontal .k-timeline-track-item:hover {
    cursor: pointer;
}

.k-timeline-horizontal .k-timeline-track-item.k-timeline-flag-wrap:hover {
    cursor: default;
}

.k-timeline-horizontal .k-timeline-date-wrap {
    margin-top: auto;
    margin-bottom: 10px;
}

.k-timeline-horizontal .k-timeline-card {
    height: 100%;
}

.k-timeline-horizontal .k-card {
    max-height: 100%;
}

.k-timeline-horizontal .k-timeline-events-list {
    overflow-x: hidden;
    padding-top: 1rem;
}

.k-timeline-horizontal .k-timeline-events-list .k-timeline-scrollable-wrap {
    position: relative;
    height: 600px;
}

.k-timeline-horizontal .k-timeline-events-list .k-timeline-scrollable-wrap .k-timeline-event {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.k-timeline-horizontal .k-timeline-track-wrap {
    position: relative;
    padding: 19px 0;
}

.k-timeline-horizontal .k-timeline-track-wrap::after {
    top: auto;
    bottom: 22px;
    left: 36px;
    right: 36px;
    transform: translateY(-50%);
    height: 6px;
}

.k-timeline-horizontal .k-timeline-track-wrap .k-timeline-track {
    overflow: hidden;
    margin-block: 0;
    margin-inline: 38px;
    position: relative;
    z-index: 2;
}

.k-timeline-horizontal .k-timeline-track-wrap .k-timeline-track .k-timeline-scrollable-wrap {
    transition: transform 1s ease-in-out;
}

.k-timeline-horizontal .k-timeline-track-wrap .k-timeline-flag {
    margin-bottom: 22px;
    position: relative;
    min-width: 80px;
}

.k-timeline-horizontal .k-timeline-track-wrap .k-timeline-flag::after {
    content: "";
    width: 10px;
    height: 10px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 50%) rotate(45deg);
}

.k-timeline-horizontal .k-timeline-scrollable-wrap {
    padding-bottom: 3px;
    display: flex;
    outline: 0;
}

.k-timeline-arrow {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    position: absolute;
    bottom: 11px;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
}

.k-timeline-arrow-left {
    left: 0;
}

.k-timeline-arrow-right {
    right: 0;
}

.k-timeline-mobile {
    padding-block: 0;
    padding-inline: 1rem;
    margin-block: 1rem;
    margin-inline: 0;
}

.k-timeline-mobile .k-timeline-flag {
    max-width: calc(80px + 2rem);
}

.k-timeline-mobile.k-timeline-horizontal .k-timeline-flag-wrap {
    display: none;
}

.k-timeline-mobile.k-timeline-vertical {
    padding-left: calc(1rem + 87px);
}

.k-timeline-mobile.k-timeline-vertical.k-timeline-dates-hidden {
    padding-left: calc(1rem + 37px);
}

.k-timeline-mobile.k-timeline-vertical.k-timeline-alternating {
    padding-left: 1rem;
}

.k-timeline-mobile.k-timeline-vertical .k-timeline-card {
    width: 100%;
}

.k-timeline-mobile.k-timeline-vertical .k-timeline-card .k-card {
    width: auto;
}

.k-timeline-card .k-card-header {
    padding-top: 1rem;
}

.k-timeline .k-timeline-flag {
    color: white;
    background-color: #0d6efd;
}

.k-timeline .k-timeline-circle {
    background-color: #0d6efd;
}

.k-timeline .k-timeline-card .k-card-header {
    background-color: #ffffff;
    color: #212529;
}

.k-timeline .k-timeline-card .k-card-body {
    scrollbar-color: #dee2e6 #ffffff;
}

.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-track {
    background: #ffffff;
}

.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-thumb {
    background: #dee2e6;
}

.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-thumb:hover {
    background: #d6d9dc;
}

.k-timeline .k-timeline-date {
    color: #212529;
}

.k-timeline .k-timeline-arrow.k-disabled {
    opacity: 1;
    color: #6f7174;
    background-color: #edeff2;
    border-color: #edeff2;
}

.k-timeline-vertical::after,
.k-timeline-horizontal .k-timeline-track-wrap::after {
    background-color: #e4e7eb;
    border-color: #e4e7eb;
}

.k-timeline-horizontal .k-timeline-flag::after {
    background-color: #0d6efd;
}

.k-timeline-track-item.k-focus .k-timeline-circle {
    box-shadow: var(--kendo-elevation-2, 0px 2px 7px rgba(0, 0, 0, 0.075));
}

.k-pdf-viewer {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    position: relative;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-pdf-viewer .k-toolbar {
    border-top-width: 0;
    border-right-width: 0;
    border-left-width: 0;
    border-color: inherit;
    flex: 0 0 auto;
    z-index: 2;
}

.k-pdf-viewer .k-toolbar .k-pager-wrap,
.k-pdf-viewer .k-toolbar .k-pager {
    padding: 0;
    border-width: 0;
    color: inherit;
    background: none;
    overflow: visible;
}

.k-pdf-viewer .k-canvas {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    outline: none;
}

.k-pdf-viewer .k-canvas.k-enable-text-select {
    -webkit-user-select: text;
        -ms-user-select: text;
            user-select: text;
    cursor: text;
}

.k-pdf-viewer .k-canvas.k-enable-panning {
    cursor: grab;
}

.k-pdf-viewer .k-canvas.k-enable-panning span::selection {
    background-color: transparent;
}

.k-pdf-viewer .k-pdf-viewer-pages {
    flex: 1 1 auto;
}

.k-pdf-viewer .k-page {
    position: relative;
    margin-block: 30px;
    margin-inline: auto;
}

.k-pdf-viewer .k-page canvas {
    direction: ltr;
}

.k-pdf-viewer .k-page .k-text-layer {
    position: absolute;
    top: 0;
    left: 0;
    opacity: .2;
    overflow: hidden;
}

.k-pdf-viewer .k-page .k-text-layer > span {
    position: absolute;
    line-height: 1.2;
    transform-origin: 0% 0%;
    color: transparent;
}

.k-pdf-viewer .k-page .k-text-layer .k-search-highlight-mark {
    color: transparent;
}

.k-pdf-viewer .k-blank-page {
    margin: 0;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    background-color: inherit !important;
}

.k-pdf-viewer .k-blank-page .k-upload,
.k-pdf-viewer .k-blank-page .k-dropzone,
.k-pdf-viewer .k-blank-page .k-dropzone-inner {
    border: 0;
    background: none;
}

.k-pdf-viewer-canvas > .k-search-panel {
    width: max-content;
    margin-top: calc(-1.5em + -2.75rem + -4px);
    padding-block: 1rem;
    padding-inline: 0.5rem;
    border-width: 1px;
    border-style: solid;
    border-radius: 0.25rem;
    display: flex;
    gap: 0.5rem;
    flex-flow: row nowrap;
    flex: 0 0 auto;
    justify-content: flex-start;
    align-items: center;
    z-index: 10;
    cursor: default;
}

.k-pdf-viewer-canvas > .k-search-panel .k-search-dialog-draghandle {
    cursor: move;
    margin-left: 0;
}

.k-pdf-viewer-canvas > .k-search-panel .k-textbox {
    width: 10em;
    flex: none;
}

.k-pdf-viewer-canvas > .k-search-panel .k-textbox .k-button {
    border-width: 0;
}

.k-pdf-viewer-canvas > .k-search-panel .k-search-matches {
    display: inline-flex;
    gap: 0.5rem;
}

.k-pdf-viewer {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-pdf-viewer .k-canvas {
    background-color: #fafafa;
}

.k-pdf-viewer .k-page {
    border-color: #dee2e6;
    color: #212529;
    background-color: white;
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-pdf-viewer .k-blank-page > .k-icon {
    color: #afb1b2;
}

.k-pdf-viewer .k-search-highlight {
    background-color: #212529;
}

.k-pdf-viewer .k-search-highlight-mark {
    background-color: yellow;
}

.k-pdf-viewer-canvas > .k-search-panel {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.km-scrollview,
.km-scroll-container {
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    border-collapse: separate;
}

.km-scroll-wrapper {
    position: relative;
}

.km-scroll-header {
    position: absolute;
    z-index: 1001;
    width: 100%;
    top: 0;
    left: 0;
}

.km-scroller-pull {
    width: 100%;
    display: block;
    position: absolute;
    line-height: 3em;
    font-size: 1.4em;
    text-align: center;
    transform: translate3d(0, -3em, 0);
}

.km-scroller-pull .km-template {
    display: inline-block;
    min-width: 200px;
    text-align: start;
}

.km-load-more .km-icon,
.km-widget .km-scroller-pull .km-icon {
    display: inline-block;
    height: 2rem;
    margin-right: 1rem;
    vertical-align: middle;
    width: 2rem;
    font-size: 2rem;
    transform: rotate(0deg);
    transition: transform 300ms linear;
}

.km-widget .km-scroller-release .km-icon {
    transform: rotate(180deg);
}

.km-widget .km-scroller-refresh .km-icon {
    transition: none;
}

.km-touch-scrollbar {
    position: absolute;
    visibility: hidden;
    z-index: 200000;
    height: .4em;
    width: .4em;
    opacity: 0;
    transform-origin: 0 0;
    transition: opacity .3s linear;
}

.k-map .km-touch-scrollbar,
.k-diagram .km-touch-scrollbar {
    display: none;
}

.km-vertical-scrollbar {
    height: 100%;
    right: 2px;
    top: 0;
}

.km-horizontal-scrollbar {
    width: 100%;
    left: 0;
    bottom: 2px;
}

.km-touch-scrollbar {
    background-color: #333333;
}

.k-scrollview {
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    position: relative;
    overflow: hidden;
    display: block;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-scrollview-wrap {
    position: absolute;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    cursor: default;
    white-space: nowrap;
}

.k-scrollview-wrap > .k-scrollview-view {
    display: inline-block;
    overflow: hidden;
    flex-shrink: 0;
}

.k-scrollview-wrap img {
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-scrollview-wrap.k-scrollview-animate {
    width: calc(var(--kendo-scrollview-views, 1)*100%);
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    transform: translateX(calc(-100%/var(--kendo-scrollview-views, 1)*(var(--kendo-scrollview-current, 1) - 1)));
}

[dir="rtl"] .k-scrollview-wrap.k-scrollview-animate,
.k-rtl .k-scrollview-wrap.k-scrollview-animate {
    transform: translateX(calc(100%/var(--kendo-scrollview-views, 1)*(var(--kendo-scrollview-current, 1) - 1)));
}

.k-scrollview-wrap.k-scrollview-animate .k-scrollview-view {
    width: calc(100%/var(--kendo-scrollview-views, 1));
    flex: 0 0 calc(100%/var(--kendo-scrollview-views, 1));
}

.k-scrollview-nav-wrap {
    padding: 0;
    margin: 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 50px;
    text-align: center;
}

kendo-scrollview.k-scrollview kendo-scrollview-pager {
    pointer-events: none;
}

kendo-scrollview.k-scrollview .k-scrollview-nav {
    pointer-events: initial;
}

.k-scrollview-nav {
    margin: 0;
    padding: 20px;
    max-width: 100%;
    box-sizing: border-box;
    line-height: 0;
    text-align: center;
    white-space: nowrap;
    list-style: none;
    display: inline-flex;
    align-items: center;
    overflow-x: scroll;
    overflow-y: hidden;
    pointer-events: initial;
}

.k-scrollview-nav:focus {
    outline: none;
}

.k-scrollview-nav > .k-link {
    margin-block: 0;
    margin-inline: 10px;
    padding: 0;
    width: 10px;
    height: 10px;
    border-width: 0px;
    border-style: solid;
    border-radius: 50%;
    box-sizing: content-box;
    display: inline-block;
    position: relative;
    flex: 0 0 auto;
    cursor: pointer;
    pointer-events: all;
    vertical-align: top;
}

.k-scrollview-nav > .k-link::before {
    content: "";
    width: 30px;
    height: 30px;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: initial;
    border-radius: 0;
}

.k-scrollview-next,
.k-scrollview-prev {
    display: table;
    position: absolute;
    padding: 0;
    height: 60%;
    top: 20%;
    text-decoration: none;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
}

.k-scrollview-next .k-icon,
.k-scrollview-prev .k-icon {
    display: table-cell;
    overflow: visible;
    margin: 0;
    padding: 0;
    vertical-align: middle;
    font-weight: normal;
}

.k-scrollview-prev {
    inset-inline-start: 0;
}

.k-scrollview-next {
    inset-inline-end: 0;
}

.k-scrollview-animation {
    transition-duration: .3s;
    transition-timing-function: ease-in-out;
}

.k-scrollview {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-scrollview.k-scrollview-dark kendo-scrollview-pager,
.k-scrollview.k-scrollview-dark .k-scrollview-nav-wrap {
    background-color: rgba(0, 0, 0, 0.4);
}

.k-scrollview.k-scrollview-dark .k-scrollview-next,
.k-scrollview.k-scrollview-dark .k-scrollview-prev {
    color: rgba(0, 0, 0, 0.4);
}

.k-scrollview.k-scrollview-light kendo-scrollview-pager,
.k-scrollview.k-scrollview-light .k-scrollview-nav-wrap {
    background-color: rgba(255, 255, 255, 0.4);
}

.k-scrollview:focus,
.k-scrollview-wrap:focus {
    outline: none;
}

.k-scrollview-next,
.k-scrollview-prev {
    color: white;
    background-color: rgba(0, 0, 0, 0);
    text-shadow: rgba(0, 0, 0, 0.3) 0 0 15px;
    opacity: 0.7;
    outline-width: 0;
}

.k-scrollview-next:focus, .k-scrollview-next.k-focus,
.k-scrollview-prev:focus,
.k-scrollview-prev.k-focus {
    color: white;
    opacity: 1;
}

.k-scrollview-next:focus .k-icon::before, .k-scrollview-next.k-focus .k-icon::before,
.k-scrollview-prev:focus .k-icon::before,
.k-scrollview-prev.k-focus .k-icon::before {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13);
}

.k-scrollview-next:hover, .k-scrollview-next.k-hover,
.k-scrollview-prev:hover,
.k-scrollview-prev.k-hover {
    color: white;
    opacity: 1;
}

.k-scrollview-nav > .k-link {
    background-color: #e4e7eb;
    border-color: #e4e7eb;
}

.k-scrollview-nav > .k-link.k-primary {
    background: #0d6efd;
    border: #0d6efd;
}

.k-scrollview-nav > .k-link:focus, .k-scrollview-nav > .k-link.k-focus {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13);
}

.k-scrollview-nav > .k-link:hover, .k-scrollview-nav > .k-link.k-hover {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13);
}

.k-prompt {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.k-prompt-content {
    padding-block: 1rem;
    padding-inline: 1rem;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    gap: 1rem;
    overflow: auto;
}

.k-prompt-view {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    gap: 1rem;
}

.k-prompt-expander {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: flex-start;
    gap: 0.5rem;
}

.k-prompt-expander-content {
    display: flex;
    flex-flow: column;
    flex: 0 0 auto;
    gap: 0.5rem;
    align-self: stretch;
}

.k-prompt-suggestion {
    border-width: 1px;
    border-style: solid;
    border-radius: 0.375rem;
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
    cursor: pointer;
}

.k-prompt-setting {
    display: flex;
    flex-direction: column;
}

.k-prompt-actions.k-actions, .k-prompt-actions.k-edit-buttons,
.k-prompt-actions.k-action-buttons,
.k-prompt-actions.k-columnmenu-actions, .k-prompt-actions.k-form-buttons {
    margin: 0;
}

.k-prompt {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-prompt-header {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-prompt-content {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-prompt-suggestion {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
    box-shadow: var(--kendo-elevation-1, 0px 1px 2px rgba(0, 0, 0, 0.038));
}

.k-barcode {
    display: inline-block;
}

.k-barcode > div {
    height: 150px;
}

.k-var--chart-font {
    font-size: 1rem;
}

.k-var--chart-title-font {
    font-size: 1.143em;
}

.k-var--chart-pane-title-font {
    font-size: 0.857em;
    font-weight: 400;
}

.k-var--chart-label-font {
    font-size: 0.857em;
}

.k-chart,
.k-sparkline,
.k-stockchart {
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-chart,
.k-stockchart {
    display: block;
    height: 400px;
}

.k-chart-surface {
    height: 100%;
}

.k-chart .k-popup {
    border-width: 0;
}

.k-chart-tooltip-wrapper .k-animation-container-shown,
.k-chart-tooltip-wrapper.k-animation-container-shown {
    transition: left 300ms cubic-bezier(0, 0.33, 0.19, 1), top 300ms cubic-bezier(0, 0.33, 0.19, 1);
}

.k-sparkline-tooltip-wrapper,
.k-chart-tooltip-wrapper {
    z-index: 12000;
}

.k-sparkline-tooltip-wrapper .k-popup,
.k-chart-tooltip-wrapper .k-popup {
    padding: 0;
    border-width: 0;
    background: transparent;
}

.k-chart-tooltip table {
    border-spacing: 0;
    border-collapse: collapse;
}

.k-chart-tooltip {
    border-radius: 0.375rem;
    font-size: 0.929rem;
    line-height: 1.5;
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
}

.k-chart-tooltip th {
    width: auto;
    text-align: center;
    padding: 1px;
}

.k-chart-tooltip td {
    width: auto;
    text-align: start;
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    line-height: 1.5;
    vertical-align: middle;
}

.k-chart-crosshair-tooltip,
.k-chart-shared-tooltip {
    border-width: 1px;
    border-style: solid;
}

.k-chart-shared-tooltip .k-chart-shared-tooltip-marker {
    display: block;
    width: 15px;
    height: 3px;
    vertical-align: middle;
}

.k-selector {
    position: absolute;
    transform: translateZ(0);
}

.k-selection {
    position: absolute;
    height: 100%;
    border-width: 1px;
    border-style: solid;
    border-bottom: 0;
}

.k-selection-bg {
    position: absolute;
    width: 100%;
    height: 100%;
}

.k-handle {
    border-radius: 50%;
    width: 22px;
    height: 22px;
    border-width: 1px;
    border-style: solid;
    z-index: 1;
    position: absolute;
    box-sizing: content-box;
}

.k-handle div {
    width: 100%;
    height: 100%;
}

.k-left-handle {
    left: -11px;
}

.k-right-handle {
    right: -11px;
}

.k-left-handle div {
    margin: -22px 0 0 -14.6666666667px;
    padding: 44px 29.3333333333px 0 0;
}

.k-right-handle div {
    margin: -22px 0 0 -14.6666666667px;
    padding: 44px 0 0 29.3333333333px;
}

.k-left-handle.k-handle-active div {
    margin-left: -44px;
    padding-left: 58.6666666667px;
}

.k-right-handle.k-handle-active div {
    margin-left: -44px;
    padding-right: 58.6666666667px;
}

.k-mask {
    position: absolute;
    height: 100%;
}

.k-navigator-hint div {
    position: absolute;
}

.k-navigator-hint .k-scroll {
    border-radius: 0.375rem;
    position: absolute;
    height: 4px;
}

.k-navigator-hint .k-tooltip {
    margin-top: 20px;
    min-width: 160px;
    opacity: 1;
    text-align: center;
}

.k-sparkline,
.k-sparkline span {
    display: inline-block;
    vertical-align: top;
}

.k-sparkline span {
    height: 100%;
    width: 100%;
}

.k-chart-dragging {
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.k-chart-donut-center {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-radius: 50%;
    text-align: center;
    border: 4px solid transparent;
    box-sizing: border-box;
}

.k-pdf-export .k-chart .k-animation-container,
.k-pdf-export .k-sparkline .k-animation-container,
.k-pdf-export .k-stockchart .k-animation-container {
    display: none;
}

.k-diagram {
    height: 600px;
}

.k-diagram .km-scroll-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
}

.k-diagram .km-scroll-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
}

.k-canvas-container {
    width: 100%;
    height: 100%;
}

.k-treemap {
    height: 400px;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    outline: 0;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    line-height: 1.5;
    display: block;
    overflow: hidden;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-treemap .k-treemap-tile {
    margin: -1px 0 0 -1px;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid;
    border-color: inherit;
    color: inherit;
    background-color: inherit;
    overflow: hidden;
    position: absolute;
}

.k-treemap > .k-treemap-tile {
    position: relative;
}

.k-treemap .k-treemap-title {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    border-width: 0 0 1px;
    border-style: solid;
    border-color: inherit;
    font-size: 1rem;
    background-position: 0 0;
    background-repeat: repeat-x;
}

.k-treemap .k-treemap-title-vertical {
    padding-block: 0.5rem;
    padding-inline: 0.25rem;
    width: 1.5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    top: 0;
    bottom: 0;
}

.k-treemap .k-treemap-title-vertical > div {
    transform-origin: right;
    transform: rotate(-90deg);
    position: absolute;
    top: 0;
    right: 1em;
}

.k-treemap .k-treemap-wrap {
    border-color: inherit;
    color: inherit;
    background-color: inherit;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.k-treemap .k-treemap-title + .k-treemap-wrap {
    top: calc(2rem + 1px);
}

.k-treemap .k-treemap-title-vertical + .k-treemap-wrap {
    left: calc(2rem + 1px);
}

.k-treemap .k-leaf {
    padding: 0.5rem;
}

.k-gauge {
    text-align: start;
    position: relative;
}

.k-arcgauge,
.k-circulargauge {
    display: inline-block;
}

.k-arcgauge-label,
.k-circulargauge-label {
    position: absolute;
    text-align: center;
    padding: 0;
    margin: 0;
}

.k-qrcode {
    display: inline-block;
}

.k-qrcode > div {
    height: 150px;
}

.k-var--primary {
    background-color: #0d6efd;
}

.k-var--primary-contrast {
    background-color: white;
}

.k-var--base {
    background-color: #f8f9fa;
}

.k-var--background {
    background-color: #ffffff;
}

.k-var--border-radius {
    margin-top: 0.375rem;
}

.k-var--normal-background {
    background-color: #f8f9fa;
}

.k-var--normal-text-color {
    background-color: #212529;
}

.k-var--hover-background {
    background-color: #e9ecef;
}

.k-var--hover-text-color {
    background-color: #212529;
}

.k-var--selected-background {
    background-color: #0d6efd;
}

.k-var--selected-text-color {
    background-color: white;
}

.k-var--success {
    background-color: #198754;
}

.k-var--info {
    background-color: #0dcaf0;
}

.k-var--warning {
    background-color: #ffc107;
}

.k-var--error {
    background-color: #dc3545;
}

.k-var--series-a {
    background-color: #0d6efd;
}

.k-var--series-b {
    background-color: #6f42c1;
}

.k-var--series-c {
    background-color: #20c997;
}

.k-var--series-d {
    background-color: #198754;
}

.k-var--series-e {
    background-color: #ffc107;
}

.k-var--series-f {
    background-color: #dc3545;
}

.k-var--series-1 {
    background-color: #0d6efd;
}

.k-var--series-2 {
    background-color: #6f42c1;
}

.k-var--series-3 {
    background-color: #20c997;
}

.k-var--series-4 {
    background-color: #198754;
}

.k-var--series-5 {
    background-color: #ffc107;
}

.k-var--series-6 {
    background-color: #dc3545;
}

.k-var--series-7 {
    background-color: #4a92fe;
}

.k-var--series-8 {
    background-color: #9371d1;
}

.k-var--series-9 {
    background-color: #58d7b1;
}

.k-var--series-10 {
    background-color: #53a57f;
}

.k-var--series-11 {
    background-color: #ffd145;
}

.k-var--series-12 {
    background-color: #e56874;
}

.k-var--series-13 {
    background-color: #0a53be;
}

.k-var--series-14 {
    background-color: #533291;
}

.k-var--series-15 {
    background-color: #189771;
}

.k-var--series-16 {
    background-color: #13653f;
}

.k-var--series-17 {
    background-color: #bf9105;
}

.k-var--series-18 {
    background-color: #a52834;
}

.k-var--series-19 {
    background-color: #86b7fe;
}

.k-var--series-20 {
    background-color: #b7a1e0;
}

.k-var--series-21 {
    background-color: #90e4cb;
}

.k-var--series-22 {
    background-color: #8cc3aa;
}

.k-var--series-23 {
    background-color: #ffe083;
}

.k-var--series-24 {
    background-color: #ee9aa2;
}

.k-var--series-25 {
    background-color: #07377f;
}

.k-var--series-26 {
    background-color: #382161;
}

.k-var--series-27 {
    background-color: #10654c;
}

.k-var--series-28 {
    background-color: #0d442a;
}

.k-var--series-29 {
    background-color: #806104;
}

.k-var--series-30 {
    background-color: #6e1b23;
}

.k-var--gauge-pointer {
    background-color: #0d6efd;
}

.k-var--gauge-track {
    background-color: #ebebeb;
}

.k-var--chart-inactive {
    background-color: rgba(33, 37, 41, 0.5);
}

.k-var--chart-major-lines {
    background-color: rgba(0, 0, 0, 0.08);
}

.k-var--chart-minor-lines {
    background-color: rgba(0, 0, 0, 0.04);
}

.k-var--chart-area-opacity {
    opacity: 0.6;
}

.k-var--chart-area-inactive-opacity {
    opacity: 0.1;
}

.k-var--chart-line-inactive-opacity {
    opacity: 0.3;
}

.k-var--chart-notes-background {
    background-color: rgba(0, 0, 0, 0.5);
}

.k-var--chart-notes-border {
    background-color: rgba(0, 0, 0, 0.5);
}

.k-var--chart-notes-lines {
    background-color: rgba(0, 0, 0, 0.5);
}

.k-var--chart-crosshair-background {
    background-color: rgba(0, 0, 0, 0.5);
}

.k-var--chart-error-bars-background {
    background-color: rgba(0, 0, 0, 0.5);
}

.k-chart,
.k-sparkline,
.k-stockchart {
    border-color: #dee2e6;
    color: #212529;
    background-color: transparent;
}

.k-chart .k-popup,
.k-sparkline .k-popup,
.k-stockchart .k-popup {
    background: transparent;
}

.k-chart-tooltip {
    color: #ffffff;
}

.k-chart-tooltip-inverse {
    color: #000000;
}

.k-chart-crosshair-tooltip,
.k-chart-shared-tooltip {
    color: #212529;
    background-color: #ebebeb;
    border-color: rgba(0, 0, 0, 0.08);
}

.k-selection {
    border-color: rgba(0, 0, 0, 0.08);
    box-shadow: inset 0 1px 7px rgba(0, 0, 0, 0.15);
}

.k-selection-bg {
    background-color: transparent;
}

.k-handle {
    cursor: e-resize;
    border-color: #e4e7eb;
    color: #212529;
    background-color: #e4e7eb;
}

.k-handle:hover {
    border-color: #c7cdd5;
    background-color: #ced3db;
}

.k-handle div {
    background-color: transparent;
}

.k-mask {
    background-color: #ffffff;
    opacity: .8;
}

.k-treemap {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-treemap .k-treemap-title {
    border-color: #dee2e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-treemap .k-leaf {
    color: #ffffff;
}

.k-treemap .k-leaf.k-inverse {
    color: #212529;
}

.k-treemap .k-leaf:hover,
.k-treemap .k-leaf.k-hover {
    box-shadow: inset 0 0 0 3px #dee2e6;
}

.k-map {
    height: 600px;
    box-sizing: border-box;
    border-width: 0px;
    border-style: solid;
    font-size: 1rem;
    line-height: 1.5;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.k-map *,
.k-map *::before,
.k-map *::after {
    box-sizing: border-box;
}

.k-map .km-scroll-wrapper {
    width: 100%;
    height: 100%;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    position: absolute;
}

.k-map .km-scroll-container {
    height: 100%;
}

.k-map .k-touch-scrollbar {
    display: none;
}

.k-map .k-layer {
    position: absolute;
    left: 0;
    top: 0;
}

.k-map .k-marker {
    transform: translate(-50%, -100%);
    cursor: pointer;
    position: absolute;
    overflow: visible;
}

.k-map .k-attribution {
    padding-block: 0.25rem;
    padding-inline: 0.5rem;
    border-width: 0;
    font-size: 0.75rem;
    z-index: 1000;
}

.k-map-controls {
    position: absolute;
    display: flex;
    align-items: center;
}

.k-navigator {
    margin: 1rem;
    width: 52px;
    height: 52px;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    border-radius: 50%;
    position: relative;
}

.k-pdf-export .k-navigator {
    display: none;
}

.k-navigator .k-button {
    padding: 0;
    width: auto;
    height: auto;
    line-height: 1;
    box-shadow: none;
    position: absolute;
}

.k-navigator .k-button .k-icon {
    min-width: 0;
    min-height: 0;
}

.k-navigator .k-navigator-n,
.k-navigator .k-navigator-up {
    transform: translateX(-50%);
    top: 2px;
    left: 50%;
}

.k-navigator .k-navigator-e,
.k-navigator .k-navigator-right {
    transform: translateY(-50%);
    right: 2px;
    top: 50%;
}

.k-navigator .k-navigator-s,
.k-navigator .k-navigator-down {
    transform: translateX(-50%);
    bottom: 2px;
    left: 50%;
}

.k-navigator .k-navigator-w,
.k-navigator .k-navigator-left {
    transform: translateY(-50%);
    left: 2px;
    top: 50%;
}

.k-zoom-control {
    margin: 1rem;
    border: 0;
    background: none;
    display: flex;
}

.k-pdf-export .k-zoom-control {
    display: none;
}

.k-map {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-map .k-navigator {
    border-color: #e4e7eb;
    color: #212529;
    background-color: #e4e7eb;
}

.k-map .k-marker {
    color: #0d6efd;
}

.k-map .k-attribution {
    background-color: rgba(255, 255, 255, 0.8);
}

.k-orgchart {
    width: 100%;
    padding-block: 1.5rem;
    padding-inline: 1.5rem;
    box-sizing: border-box;
    font-size: 1rem;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.5;
    overflow: auto;
}

.k-orgchart *,
.k-orgchart *::before,
.k-orgchart *::after {
    box-sizing: border-box;
}

.k-orgchart-container {
    margin-block: 0;
    margin-inline: auto;
    width: 100%;
    height: 100%;
    position: relative;
}

.k-orgchart-group {
    gap: 1.5rem;
}

.k-orgchart-group.k-vstack > .k-orgchart-node-container, .k-orgchart-group.k-vbox > .k-orgchart-node-container {
    gap: 0;
}

.k-orgchart-node-container {
    gap: 1.5rem;
}

.k-orgchart-node-group-container {
    border-radius: 0.375rem;
    padding-block: 1.5rem;
    padding-inline: 1.5rem;
    border-width: 1px;
    border-style: solid;
    outline: 0;
}

.k-orgchart-node-group-title {
    margin: 0 0 0.375rem;
    font-size: 1.25rem;
    line-height: 1.25;
}

.k-orgchart-node-group-subtitle {
    margin: 0 0 1.5rem;
    font-size: 1rem;
}

.k-orgchart-card {
    width: 300px;
    border-width: 1px;
}

.k-orgchart-card .k-card-title {
    margin: 0 0 0px;
}

.k-orgchart-card .k-card-subtitle {
    margin: 0 0 0px;
}

.k-orgchart-card .k-card-body {
    border-width: 2px 0 0;
    border-style: solid;
    flex-grow: 0;
}

.k-orgchart-card .k-card-body .k-card-title-wrap {
    margin: 0 0.75rem 0 0;
    min-width: 0;
    min-height: 45px;
}

.k-orgchart-line {
    background-color: currentColor;
}

.k-orgchart-line-h {
    height: 1px;
}

.k-orgchart-line-v {
    margin-block: 0;
    margin-inline: auto;
    width: 1px;
    height: 25px;
}

.k-orgchart-button {
    z-index: 1;
}

.k-orgchart {
    border-color: #dee2e6;
    color: #212529;
    background-color: #ffffff;
}

.k-orgchart-card .k-card-body {
    border-color: transparent;
}

.k-orgchart-card:focus, .k-orgchart-card.k-focus {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-orgchart-node-group-container {
    border-color: #e4e5e6;
    color: #212529;
    background-color: #f8f9fa;
}

.k-orgchart-node-group-container:focus,
.k-orgchart-node-group-container.k-focus {
    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));
}

.k-orgchart-node-group-subtitle {
    color: #6c757d;
}

.k-orgchart-line-h,
.k-orgchart-line-v {
    color: #e4e5e6;
}

.k-signature {
    width: 246px;
    min-height: 108px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.k-signature.k-signature-maximized {
    width: 750px;
    height: 252px;
}

.k-signature.k-signature-maximized > .k-signature-line {
    border-bottom-width: 3px;
}

.k-signature-actions {
    display: flex;
    width: min-content;
    margin-inline-start: auto;
    gap: 0.25rem;
    z-index: 2;
}

.k-signature-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    z-index: 1;
    outline: none;
}

.k-signature-line {
    position: absolute;
    bottom: 33%;
    z-index: 2;
    pointer-events: none;
    border-bottom-width: 1px;
    border-bottom-style: dashed;
}

.k-signature-sm {
    padding-inline: 0.5rem;
    padding-block: 0.125rem;
}

.k-signature-sm .k-signature-line {
    width: calc(100% - 1rem);
}

.k-signature-md {
    padding-inline: 0.75rem;
    padding-block: 0.25rem;
}

.k-signature-md .k-signature-line {
    width: calc(100% - 1.5rem);
}

.k-signature-lg {
    padding-inline: 1rem;
    padding-block: 0.5rem;
}

.k-signature-lg .k-signature-line {
    width: calc(100% - 2rem);
}

.k-signature-lg {
    min-height: 110px;
}

.k-signature .k-signature-line {
    border-bottom-color: rgba(13, 202, 240, 0.24);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@progress/kendo-theme-bootstrap/dist/all.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,8CAA8C;IAC9C,6CAA6C;IAC7C,6CAA6C;IAC7C,mDAAmD;IACnD,sCAAsC;IACtC,+CAA+C;IAC/C,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;IACX,SAAS;IACT,qBAAqB;AACzB;;AAEA;;;IAGI,QAAQ;IACR,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,aAAa;IACb,eAAe;IACf,0CAA0C;IAC1C,mDAAmD;IACnD,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,oDAAoD;IACpD,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,mCAAmC;IACnC,sCAAsC;IACtC,qCAAqC;IACrC,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;;;;;;;;;;;;;IAaI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;IAII,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,6BAA6B;IAC7B,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kDAAkD;AACtD;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,2DAA2D;AAC/D;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kDAAkD;IAClD,+CAA+C;IAC/C,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,qDAAqD;IACrD,oDAAoD;IACpD,sDAAsD;IACtD,yDAAyD;IACzD,2DAA2D;IAC3D,2DAA2D;IAC3D,2DAA2D;IAC3D,2DAA2D;AAC/D;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,gCAAgC;IAChC,iCAAiC;IACjC,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,UAAU;AACd;;AAEA;;;;IAII,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,qDAAqD;IACrD,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;;IAEI,qDAAqD;IACrD,WAAW;IACX,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,uCAAuC;AAC3C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,qCAAqC;AACzC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,oGAAoG;AACxG;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;;;;;;;;;;;IAYI,8BAA8B;AAClC;;AAEA;;IAEI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;;;;IAII,oBAAoB;IACpB,UAAU;AACd;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;IAEI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;;;IAII,oBAAoB;IACpB,UAAU;AACd;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,OAAO;IACP,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,MAAM;IACN,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,MAAM;IACN,WAAW;IACX,gBAAgB;AACpB;;AAEA;;;;IAII,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,MAAM;AACV;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,MAAM;IACN,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,OAAO;AACX;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;IAEI,MAAM;IACN,qBAAqB;AACzB;;AAEA;;IAEI,MAAM;IACN,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;IACT,qBAAqB;AACzB;;AAEA;;IAEI,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,MAAM;IACN,SAAS;IACT,2BAA2B;AAC/B;;AAEA;;;IAGI,QAAQ;IACR,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;;AAEA;;;IAGI,QAAQ;IACR,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;;IAEI,SAAS;IACT,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;YACrB,qBAAqB;AACjC;;AAEA;IACI,wCAAwC;YAChC,gCAAgC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,4CAA4C;AAChD;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,yCAAyC;IACzC,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,yCAAyC;IACzC,0CAA0C;AAC9C;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,4CAA4C;IAC5C,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,4CAA4C;IAC5C,+CAA+C;AACnD;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,0CAA0C;IAC1C,6CAA6C;AACjD;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,0CAA0C;IAC1C,6CAA6C;AACjD;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,8CAA8C;IAC9C,+CAA+C;AACnD;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,6CAA6C;IAC7C,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,8CAA8C;IAC9C,+CAA+C;AACnD;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,4CAA4C;IAC5C,6CAA6C;AACjD;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,4CAA4C;IAC5C,6CAA6C;AACjD;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,0CAA0C;IAC1C,6CAA6C;AACjD;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;YAC1B,0BAA0B;AACtC;;AAEA;IACI,6CAA6C;YACrC,qCAAqC;AACjD;;AAEA;IACI,gCAAgC;YACxB,wBAAwB;AACpC;;AAEA;IACI,2CAA2C;YACnC,mCAAmC;AAC/C;;AAEA;IACI,kCAAkC;YAC1B,0BAA0B;AACtC;;AAEA;IACI,6CAA6C;YACrC,qCAAqC;AACjD;;AAEA;IACI,kCAAkC;YAC1B,0BAA0B;AACtC;;AAEA;IACI,6CAA6C;YACrC,qCAAqC;AACjD;;AAEA;IACI,mCAAmC;YAC3B,2BAA2B;AACvC;;AAEA;IACI,8CAA8C;YACtC,sCAAsC;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;QACtB,sBAAsB;AAC9B;;AAEA;IACI,qCAAqC;QACjC,iCAAiC;AACzC;;AAEA;IACI,uDAAuD;QACnD,mDAAmD;AAC3D;;AAEA;IACI,kEAAkE;QAC9D,8DAA8D;AACtE;;AAEA;IACI,uDAAuD;QACnD,mDAAmD;AAC3D;;AAEA;IACI,kEAAkE;QAC9D,8DAA8D;AACtE;;AAEA;IACI,0DAA0D;QACtD,sDAAsD;AAC9D;;AAEA;IACI,qEAAqE;QACjE,iEAAiE;AACzE;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,oCAAoC;QAChC,gCAAgC;YAC5B,4BAA4B;AACxC;;AAEA;IACI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,oCAAoC;QAChC,gCAAgC;YAC5B,4BAA4B;AACxC;;AAEA;IACI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,oCAAoC;QAChC,gCAAgC;YAC5B,4BAA4B;AACxC;;AAEA;IACI,wBAAwB;YAChB,gBAAgB;AAC5B;;AAEA;IACI,mCAAmC;YAC3B,2BAA2B;AACvC;;AAEA;IACI,4BAA4B;QACxB,wBAAwB;YACpB,oBAAoB;AAChC;;AAEA;IACI,uCAAuC;QACnC,mCAAmC;YAC/B,+BAA+B;AAC3C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,6DAA6D;AACjE;;AAEA;;IAEI,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,iGAAiG;IACjG,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;;;IAOI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,MAAM;IACN,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gCAAgC;AACpC;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;;IAEI,yDAA8O;AAClP;;AAEA;;IAEI,yDAAwO;AAC5O;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,MAAM;IACN,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;;IAII,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,MAAM;IACN,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,8EAA8E;IAC9E,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,4MAA4M;IAC5M,aAAa;IACb,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,uEAAuE;IACvE,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;AACZ;;AAEA;;;IAGI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;;;;IAKI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;;;;;IAQI,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,MAAM;IACN,OAAO;IACP,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,uEAAuE;AAC3E;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,yCAAyC;IACzC,8EAA8E;IAC9E,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI;QACI,yCAAyC;IAC7C;IACA;QACI,yCAAyC;IAC7C;IACA;QACI,UAAU;QACV,yCAAyC;IAC7C;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;;IAKI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;IACR,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,+BAA+B;IAC/B,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;;;;;;;IAQI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;;;;;;;;IAQI,qBAAqB;AACzB;;AAEA;;;;;;;;IAQI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;IAEI,OAAO;IACP,WAAW;AACf;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;;;IAII,qCAAqC;AACzC;;AAEA;;;;;;;IAOI,+CAA+C;AACnD;;AAEA;;IAEI,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;IAEI,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;IAGI,+BAA+B;AACnC;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;;;IAGI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;IAGI,iCAAiC;AACrC;;AAEA;;;IAGI,kCAAkC;AACtC;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA;;;IAGI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,mDAAqP;IACrP,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yDAAoN;IACpN,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,qBAAqB;IACrB,uBAAuB;IACvB,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA;IACI,QAAQ;IACR,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI;QACI,MAAM;QACN,SAAS;IACb;IACA;QACI,SAAS;QACT,OAAO;IACX;IACA;QACI,SAAS;QACT,UAAU;IACd;IACA;QACI,MAAM;QACN,SAAS;IACb;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,MAAM;IACN,SAAS;IACT,6CAA6C;AACjD;;AAEA;IACI,SAAS;IACT,OAAO;IACP,6CAA6C;IAC7C,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,6CAA6C;IAC7C,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;QACT,4CAA4C;IAChD;IACA;QACI,MAAM;QACN,OAAO;QACP,sCAAsC;IAC1C;IACA;QACI,MAAM;QACN,OAAO;QACP,sCAAsC;IAC1C;IACA;QACI,QAAQ;QACR,SAAS;QACT,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;QACT,4CAA4C;IAChD;IACA;QACI,MAAM;QACN,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI,MAAM;QACN,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI,QAAQ;QACR,SAAS;QACT,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;QACT,4CAA4C;IAChD;IACA;QACI,SAAS;QACT,UAAU;QACV,8CAA8C;IAClD;IACA;QACI,SAAS;QACT,UAAU;QACV,8CAA8C;IAClD;IACA;QACI,QAAQ;QACR,SAAS;QACT,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;QACT,4CAA4C;IAChD;IACA;QACI,SAAS;QACT,OAAO;QACP,0CAA0C;IAC9C;IACA;QACI,SAAS;QACT,OAAO;QACP,0CAA0C;IAC9C;IACA;QACI,QAAQ;QACR,SAAS;QACT,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,4CAA4C;AAChD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;;;;;;;;;;;;;IAaI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,4BAA4B;IAC5B,mDAAmD;AACvD;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,4MAA4M;IAC5M,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,aAAa;IACb,wBAAwB;IACxB,kBAAkB;IAClB,iIAAiI;AACrI;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;;;IAOI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,wBAAwB;IACxB,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,UAAU;IACV,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,UAAU;IACV,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;;;IAKI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,MAAM;IACN,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,MAAM;IACN,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;;IAII,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;;IAII,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,gCAAgC;IAChC,iCAAiC;IACjC,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,4BAA4B;IAC5B,cAAc;IACd,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;;;;;;;;;;;IAWI,sBAAsB;AAC1B;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;;;IAGI,qBAAqB;IACrB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;;;;IAII,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;;;;;;;;;;IAYI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;;;;;;;IAQI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;IACV,4MAA4M;IAC5M,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,iCAAiC;IACjC,YAAY;IACZ,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,QAAQ;IACR,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,QAAQ;IACR,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;IACzB,sEAAsE;AAC1E;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;;;;;;IAMI,sBAAsB;AAC1B;;AAEA;;;;IAII,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,UAAU;IACV,qBAAqB;QACjB,iBAAiB;AACzB;;AAEA;;IAEI,cAAc;IACd,UAAU;IACV,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;;IAEI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;;IAGI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;;;;;;;;IASI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;;IAGI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,qBAAqB;QACjB,iBAAiB;AACzB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;IAGI,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;;;;;;IAMI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,UAAU;IACV,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,aAAa;IACb,wBAAwB;AAC5B;;AAEA;;IAEI,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;AACzB;;AAEA;;;;;IAKI,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,wCAAwC;IACxC,uCAAuC;IACvC,mBAAmB;IACnB,wCAAwC;IACxC,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;;;;IAII,iBAAiB;AACrB;;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;;;;;;;;;;;;;;IAgBI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;;IAEI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;;;;;IAMI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;;;;;;;;;;;;;;;;IAgBI,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;;;;;IAMI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;;;;;;;;;;;;;;;IAgBI,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI;IACA;IACA;IACA;AACJ;;AAEA;IACI;IACA;IACA;IACA;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iIAAiI;AACrI;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,+DAA+D;IAC/D,+DAA+D;IAC/D,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,+FAA+F;AACnG;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,+DAA+D;IAC/D,+DAA+D;IAC/D,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;IAEI,kDAAkD;IAClD,mDAAmD;IACnD,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,mDAAmD;IACnD,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,8BAA8B;IAC9B,gGAAgG;AACpG;;AAEA;;IAEI,UAAU;IACV,gEAAgE;AACpE;;AAEA;;;;;IAKI,UAAU;IACV,oDAAoD;AACxD;;AAEA;;IAEI,UAAU;IACV,oDAAoD;AACxD;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,WAAW;IACX,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mDAAmD;IACnD,mBAAmB;AACvB;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4CAA4C;IAC5C,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;QACnB,yBAAyB;AACjC;;AAEA;IACI,oDAAoD;IACpD,8BAA8B;IAC9B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,+IAA+I;IAC/I,0BAA0B;IAC1B,uEAAuE;AAC3E;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;;IAEI,yDAAsJ;AAC1J;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,MAAM;IACN,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;;IAII,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,MAAM;IACN,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,8EAA8E;IAC9E,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,4BAA4B;IAC5B,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,gCAAgC;AACpC;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;IACI,2EAA2E;IAC3E,yDAAyD;AAC7D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,+BAA+B;AACnC;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;IAC7C,4EAA4E;AAChF;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,OAAO;IACP,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;;IAEI,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6HAA6H;AACjI;;AAEA;IACI,iHAAiH;AACrH;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;IAII,oBAAoB;AACxB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;;;;IAMI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,yDAAiI;AACrI;;AAEA;IACI,yDAAiI;AACrI;;AAEA;IACI,+DAA+D;IAC/D,+DAA+D;IAC/D,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,wBAAwB;IACxB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;;IAII,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,4DAA4D;IAC5D,2DAA2D;IAC3D,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,mEAAmE;IACnE,kEAAkE;IAClE,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,uEAAuE;IACvE,sEAAsE;IACtE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,8DAA8D;IAC9D,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,4DAA4D;IAC5D,2DAA2D;AAC/D;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,4DAA4D;IAC5D,2DAA2D;AAC/D;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,4DAA4D;IAC5D,2DAA2D;AAC/D;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,4DAA4D;IAC5D,2DAA2D;AAC/D;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,+DAA+D;AACnE;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,4CAA4C;IAC5C,8FAA8F;IAC9F,8FAA8F;IAC9F,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,sFAAsF;AAC1F;;AAEA;;IAEI,qFAAqF;AACzF;;AAEA;;IAEI,uFAAuF;AAC3F;;AAEA;;IAEI,wFAAwF;AAC5F;;AAEA;IACI,4CAA4C;IAC5C,6FAA6F;IAC7F,6FAA6F;IAC7F,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,sFAAsF;AAC1F;;AAEA;;IAEI,qFAAqF;AACzF;;AAEA;;IAEI,uFAAuF;AAC3F;;AAEA;;IAEI,wFAAwF;AAC5F;;AAEA;IACI,4CAA4C;IAC5C,6FAA6F;IAC7F,6FAA6F;IAC7F,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,sFAAsF;AAC1F;;AAEA;;IAEI,qFAAqF;AACzF;;AAEA;;IAEI,uFAAuF;AAC3F;;AAEA;;IAEI,wFAAwF;AAC5F;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,cAAc;IACd,aAAa;IACb,wBAAwB;IACxB,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;AACZ;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;;;;;;;IAQI,oBAAoB;IACpB,mBAAmB;IACnB,8DAA8D;IAC9D,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iFAAiF;AACrF;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;;IAGI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,wDAAwD;AAC5D;;AAEA;;;IAGI,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;IAGI,gDAAgD;AACpD;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,sFAAsF;AAC1F;;AAEA;IACI,WAAW;IACX,UAAU;IACV,uFAAuF;AAC3F;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;;;;IAII,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;IACf,oBAAoB;IACpB,eAAe;AACnB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,oBAAoB;IACpB,wBAAwB;IACxB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,oBAAoB;IACpB,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,UAAU;AACd;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,+DAA+D;AACnE;;AAEA;;IAEI,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,QAAQ;AACZ;;AAEA;;IAEI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;;;IAII,oBAAoB;IACpB,mBAAmB;IACnB,8DAA8D;IAC9D,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,WAAW;AACf;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,4MAA4M;IAC5M,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,oFAAoF;AACxF;;AAEA;IACI,oFAAoF;AACxF;;AAEA;IACI,mEAAmE;AACvE;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,yHAAyH;AAC7H;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;IAC7B,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,oGAAoG;AACxG;;AAEA;IACI,kGAAkG;AACtG;;AAEA;IACI,iEAAiQ;AACrQ;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,mGAAmG;AACvG;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gGAAgG;IAChG,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;IAC/C,iDAAiD;AACrD;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;;IAGI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;;;;;IAKI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;;IAGI,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;;IAII,eAAe;IACf,mBAAmB;AACvB;;AAEA;;;;IAII,eAAe;IACf,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;IAwBI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iIAAiI;AACrI;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,kDAAkD;AACtD;;AAEA;;;IAGI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;IAGI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,aAAa;AACjB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;;;;IAII,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;AACX;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;;IAGI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;AACd;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,UAAU;AACd;;AAEA;IACI,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,4MAA4M;IAC5M,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,aAAa;AACjB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,2CAA2C;AAC/C;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,2CAA2C;AAC/C;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,0EAA0E;AAC9E;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;;IAEI,0EAA0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;;IAII,2CAA2C;AAC/C;;AAEA;;IAEI,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;AACd;;AAEA;;;;IAII,0EAA0E;IAC1E,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,oCAAoC;IACpC,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,6CAA6C;IAC7C,mDAAmD;IACnD,qDAAqD;IACrD,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,OAAO;IACP,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,MAAM;IACN,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;IACjB,oBAAoB;IACpB,OAAO;IACP,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,iBAAiB;IACjB,qBAAqB;IACrB,QAAQ;IACR,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;;IAEI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,4EAA4E;AAChF;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,OAAO;IACP,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;;IAII,uBAAuB;AAC3B;;AAEA;;;;IAII,sBAAsB;AAC1B;;AAEA;;IAEI,MAAM;IACN,OAAO;AACX;;AAEA;;IAEI,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,eAAe;IACf,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;;;;;;IAQI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;;;;;IAMI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;;;;IAII,UAAU;IACV,QAAQ;AACZ;;AAEA;;;;IAII,OAAO;IACP,WAAW;AACf;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;IACf,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,uEAAuE;AAC3E;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;;;IAKI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,oBAAoB;IACpB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,oBAAoB;IACpB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,SAAS;IACT,8CAA8C;AAClD;;AAEA;IACI,QAAQ;IACR,QAAQ;IACR,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,SAAS;IACT,6CAA6C;AACjD;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,SAAS;IACT,8CAA8C;AAClD;;AAEA;IACI,QAAQ;IACR,QAAQ;IACR,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,SAAS;IACT,6CAA6C;AACjD;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,MAAM;AACV;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;IAC1C,OAAO;AACX;;AAEA;IACI,yCAAyC;IACzC,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,4MAA4M;IAC5M,qBAAqB;IACrB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,sCAAsC;AAC1C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,uCAAuC;AAC3C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iIAAiI;AACrI;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;;;;;;;;IAQI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;;;;IAII,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;;;IAGI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;;;IAII,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;;;IAGI,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;;;IAII,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;;;IAGI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,4MAA4M;IAC5M,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;IAC7C,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,0DAA0D;IAC1D,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,UAAU;AACd;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,yDAAyD;AAC7D;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,aAAa;IACb,wBAAwB;IACxB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,MAAM;AACV;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,SAAS;IACT,iCAAiC;IACjC,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;IACnB,wBAAwB;IACxB,2CAA2C;AAC/C;;AAEA;;IAEI,mCAAmC;IACnC,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;;IAEI,+BAA+B;IAC/B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;;IAEI,gCAAgC;IAChC,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;;IAEI,+BAA+B;IAC/B,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;;;IAGI,QAAQ;AACZ;;AAEA;;;IAGI,QAAQ;AACZ;;AAEA;;;IAGI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qEAAqE;AACzE;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,4MAA4M;IAC5M,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;IAEI,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,iIAAiI;AACrI;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,iIAAiI;AACrI;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;;;;IAII,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;;;;IAII,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;;;IAII,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;;;;IAII,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;;;IAII,4BAA4B;AAChC;;AAEA;;;;IAII,kDAAkD;AACtD;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,kDAAkD;AACtD;;AAEA;;;;IAII,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,SAAS;AACb;;AAEA;;IAEI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;;IAII,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,sBAAsB;IACtB,MAAM;AACV;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;IAGI,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;;IAII,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,qEAAqE;AACzE;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;QACnB,yBAAyB;IAC7B,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;IAC3B,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;IAEI,4MAA4M;IAC5M,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,OAAO;AACX;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,6BAA6B;IAC7B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mCAAmC;IACnC,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,oFAAoF;AACxF;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,+IAA+I;AACnJ;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,OAAO;IACP,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA;;;;IAII,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,oBAAoB;IACpB,SAAS;IACT,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;IAC7B,MAAM;AACV;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;;;;IAII,uBAAuB;QACnB,yBAAyB;IAC7B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;;;;;IAOI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,cAAc;AAClB;;AAEA;;;;;;;;;;;;;;;;IAgBI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;IACjB,UAAU;AACd;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;;;IAGI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;;IAGI,4BAA4B;AAChC;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;;;;;;;;;;;IAYI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;IAEI,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;AACd;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;IACxB,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;IAGI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sCAAsC;IACtC,uCAAuC;IACvC,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;IAChC,MAAM;AACV;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;;IAEI,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,uBAAuB;IACvB,sDAAsD;IACtD,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;;;;IAMI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;IACf,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,qBAAqB;IACrB,UAAU;AACd;;AAEA;;;;IAII,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;;;;;;;;;IASI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;;;;;;;;;;;IAYI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;;;IAKI,gBAAgB;IAChB,UAAU;AACd;;AAEA;;;;;IAKI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,4BAA4B;AAChC;;AAEA;;;;;;;;;IASI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;;IAII,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;;;;IAMI,gBAAgB;IAChB,0CAA0C;IAC1C,2CAA2C;IAC3C,iBAAiB;AACrB;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;;;IAII,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;;;;;;IAQI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;;;;IAMI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;;;IAII,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;AACf;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,iBAAiB;IACjB,kCAAkC;IAClC,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;;;IAII,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;;;;;;;IAQI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;;;IAII,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;;IAGI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,wBAAwB;IACxB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;;IAGI,SAAS;IACT,UAAU;AACd;;AAEA;;;;;;;;;IASI,aAAa;IACb,wBAAwB;IACxB,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;;;;;;;IAQI,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;;;;;;;;;IAYI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;;;;IAKI,cAAc;IACd,0CAA0C;AAC9C;;AAEA;;;;;;;;;;;;;;;;;;;;;;;IAuBI,+CAA+C;AACnD;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;;;;IAKI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;;;;;IAOI,8CAA8C;AAClD;;AAEA;;;;IAII,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,yCAAyC;IACzC,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,uCAAuC;IACvC,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,yBAAyB;AAC7B;;AAEA;;;IAGI,4BAA4B;AAChC;;AAEA;;;;;;IAMI,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;IAYI,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;IAkBI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;;IAII,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,iEAAiE;AACrE;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,OAAO;IACP,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,OAAO;IACP,sBAAsB;AAC1B;;AAEA;;;;;IAKI,0BAA0B;AAC9B;;AAEA;;;;IAII,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;IACf,uCAAuC;IACvC,OAAO;IACP,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sDAAsD;IACtD,uDAAuD;IACvD,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,MAAM;AACV;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;;IAII,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,aAAa;IACb,wBAAwB;IACxB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;;IAGI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,6CAA6C;IAC7C,WAAW;AACf;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,yDAAqvY;IACrvY,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;;IAEI,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,MAAM;IACN,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;;;IAII,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,iCAAiC;IACjC,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;;;;IAKI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sDAAsD;AAC1D;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,0BAA0B;IAC1B,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;QACnB,yBAAyB;AACjC;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,aAAa;AACjB;;AAEA;;;IAGI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;IAGI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;;;;IAMI,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,kDAAkD;AACtD;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;;IAII,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,MAAM;IACN,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,sCAAsC;IACtC,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;;;;;;IAMI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qEAAqE;IACrE,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;IAC7B,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,MAAM;IACN,OAAO;IACP,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,SAAS;IACT,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,SAAS;IACT,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,SAAS;IACT,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,QAAQ;IACR,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,SAAS;IACT,cAAc;IACd,WAAW;IACX,UAAU;IACV,YAAY;IACZ,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;;;IAII,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;IACvB,WAAW;IACX,SAAS;AACb;;AAEA;;IAEI,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mRAAmR;IACnR,iCAAiC;IACjC,qCAAqC;IACrC,uBAAuB;IACvB,2CAA2C;IAC3C,qCAAqC;IACrC,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;AACd;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gKAAgK;AACpK;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI;QACI,oBAAoB;IACxB;IACA;;QAEI,iBAAiB;QACjB,kCAAkC;QAClC,mCAAmC;IACvC;IACA;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;;IAEI,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;;IAGI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,MAAM;IACN,aAAa;AACjB;;AAEA;;IAEI,+BAA+B;IAC/B,OAAO;AACX;;AAEA;;IAEI,gCAAgC;IAChC,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,OAAO;IACP,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;;;IAGI,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;;;;IAII,UAAU;IACV,QAAQ;AACZ;;AAEA;;IAEI,eAAe;IACf,oBAAoB;AACxB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,UAAU;IACV,QAAQ;AACZ;;AAEA;;IAEI,WAAW;IACX,OAAO;AACX;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,QAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,QAAQ;AACZ;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kGAAkG;AACtG;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mGAAmG;AACvG;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mGAAmG;AACvG;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;;;;;;;;IAUI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,OAAO;IACP,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;;;;;IAMI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,sDAAsD;AAC1D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,gCAAgC;IAChC,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,8BAA8B;IAC9B,MAAM;IACN,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,YAAY;IACZ,MAAM;AACV;;AAEA;;IAEI,YAAY;IACZ,SAAS;AACb;;AAEA;;;;IAII,WAAW;IACX,wBAAwB;AAC5B;;AAEA;;IAEI,WAAW;IACX,OAAO;AACX;;AAEA;;IAEI,WAAW;IACX,QAAQ;AACZ;;AAEA;;;;IAII,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;;;;;;;IAOI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;;IAII,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;IACT,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,MAAM;IACN,OAAO;IACP,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;;;IAGI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;;IAII,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;IAGI,oBAAoB;AACxB;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,OAAO;AACX;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;IAII,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;;IAII,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,sEAAsE;AAC1E;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,qBAAqB;IACrB,cAAc;IACd,0DAA0D;IAC1D,wBAAwB;IACxB,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,0BAA0B;IAC1B,wBAAwB;IACxB,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,gCAAgC;IAChC,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,MAAM;AACV;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,OAAO;AACX;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,iIAAiI;IACjI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,6EAA6E;IAC7E,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,qCAAqC;AACzC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;;;IAGI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,uBAAuB;IACvB,qEAAqE;AACzE;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,MAAM;AACV;;AAEA;IACI,WAAW;IACX,OAAO;IACP,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,kDAAkD;IAClD,yBAAyB;IACzB,uCAAuC;IACvC,4GAA4G;AAChH;;AAEA;;IAEI,2GAA2G;AAC/G;;AAEA;IACI,kDAAkD;IAClD,qDAAqD;AACzD;;AAEA;IACI,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,qBAAqB;IACrB,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,kCAAkC;IAClC,wCAAwC;IACxC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;;IAGI,YAAY;IACZ,UAAU;AACd;;AAEA;;;IAGI,yCAAyC;AAC7C;;AAEA;;;IAGI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,wBAAwB;IACxB,cAAc;IACd,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,sEAAsE;AAC1E;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;IAEI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,+FAA+F;AACnG;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,4MAA4M;IAC5M,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,qBAAqB;IACrB,cAAc;IACd,6BAA6B;AACjC;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,+CAA+C;AACnD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,4MAA4M;AAChN;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,2BAA2B;IAC3B,QAAQ;IACR,SAAS;AACb;;AAEA;;IAEI,2BAA2B;IAC3B,UAAU;IACV,QAAQ;AACZ;;AAEA;;IAEI,2BAA2B;IAC3B,WAAW;IACX,SAAS;AACb;;AAEA;;IAEI,2BAA2B;IAC3B,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,4MAA4M;IAC5M,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,qEAAqE;AACzE;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;AACjD","sourcesContent":[".k-sr-only {\n    position: absolute;\n    left: -1px;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n}\n\n.k-theme-test-class,\n.k-common-test-class {\n    opacity: 0;\n}\n\n.k-body {\n    font-size: var(--kendo-font-size, inherit);\n    font-family: var(--kendo-font-family, inherit);\n    line-height: var(--kendo-line-height, normal);\n    font-weight: var(--kendo-font-weight, normal);\n    letter-spacing: var(--kendo-letter-spacing, normal);\n    color: var(--kendo-body-text, initial);\n    background-color: var(--kendo-body-bg, initial);\n    margin: 0;\n}\n\n.k-hstack, .k-hbox {\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.k-vstack, .k-vbox {\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-spacer, .k-flex {\n    flex: 1 1 auto;\n}\n\n.k-spacer-sized {\n    flex: none;\n}\n\n.k-float-wrap::after, .k-floatwrap::after {\n    content: \"\";\n    display: block;\n    clear: both;\n}\n\n.k-flex-layout {\n    display: flex;\n}\n\n.k-grid-layout {\n    display: grid;\n}\n\n.k-separator {\n    width: auto;\n    height: 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n    display: block;\n    flex-grow: 0 !important;\n    flex-shrink: 0 !important;\n    align-self: stretch;\n}\n\n.k-separator-horizontal,\n.k-vstack > .k-separator,\n.k-vbox > .k-separator {\n    width: auto;\n    height: 0;\n    border-width: 1px 0 0;\n}\n\n.k-separator-vertical,\n.k-hstack > .k-separator,\n.k-hbox > .k-separator {\n    width: 0;\n    height: auto;\n    border-width: 0 0 0 1px;\n}\n\nhr.k-separator {\n    margin: 0;\n    padding: 0;\n}\n\n.k-hidden {\n    display: none !important;\n}\n\n.k-rtl {\n    direction: rtl;\n}\n\n[hidden] {\n    display: none !important;\n}\n\nscript {\n    display: none !important;\n}\n\n.k-disabled,\n.k-widget[disabled],\n.k-disabled {\n    outline: none;\n    cursor: default;\n    color: var(--kendo-disabled-text, inherit);\n    border-color: var(--kendo-disabled-border, inherit);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n.k-disabled .k-link,\n.k-widget[disabled] .k-link,\n.k-disabled .k-link {\n    cursor: default;\n    outline: 0;\n}\n\n.k-hr {\n    margin-block: 1rem;\n    padding: 0;\n    height: 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: var(--kendo-component-border, inherit);\n    display: block;\n    float: none;\n    clear: both;\n}\n\n.k-d-flex-row > .k-hr {\n    margin: 0;\n    width: 0;\n    height: auto;\n    border-width: 0 0 0 1px;\n    flex: 0 0 auto;\n}\n\n.k-d-flex-col > .k-hr {\n    margin: 0;\n    flex: 0 0 auto;\n}\n\n.k-sprite {\n    display: inline-block;\n    width: 1rem;\n    height: 1rem;\n    overflow: hidden;\n    background-repeat: no-repeat;\n    font-size: 0;\n    line-height: 0;\n    text-align: center;\n}\n\n.k-image {\n    display: inline-block;\n}\n\n.k-reset {\n    margin: 0;\n    padding: 0;\n    border-width: 0;\n    outline: 0;\n    text-decoration: none;\n    font: inherit;\n    list-style: none;\n}\n\nkendo-sortable {\n    display: block;\n}\n\n.k-link,\n.k-link:hover {\n    color: inherit;\n    text-decoration: none;\n    outline: 0;\n    cursor: pointer;\n}\n\n.k-content {\n    outline: 0;\n}\n\n.k-centered {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.k-no-click {\n    pointer-events: none;\n}\n\n.k-pdf-export-shadow {\n    position: absolute;\n    overflow: hidden;\n    left: -15000px;\n    width: 14400px;\n}\n\n.kendo-pdf-hide-pseudo-elements::before,\n.kendo-pdf-hide-pseudo-elements::after {\n    display: none !important;\n}\n\n.k-dirty {\n    margin: 0;\n    padding: 0;\n    width: 0;\n    height: 0;\n    border-width: 3px;\n    border-style: solid;\n    border-block-start-color: currentColor;\n    border-block-end-color: transparent;\n    border-inline-start-color: transparent;\n    border-inline-end-color: currentColor;\n    position: absolute;\n    inset-block-start: 0;\n    inset-inline-end: 0;\n}\n\n.k-loading-mask,\n.k-loading-image,\n.k-loading-color {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.k-loading-mask *,\n.k-loading-mask *::before,\n.k-loading-mask *::after, .k-loading-mask::before, .k-loading-mask::after,\n.k-loading-image *,\n.k-loading-image *::before,\n.k-loading-image *::after,\n.k-loading-image::before,\n.k-loading-image::after,\n.k-loading-color *,\n.k-loading-color *::before,\n.k-loading-color *::after,\n.k-loading-color::before,\n.k-loading-color::after {\n    box-sizing: border-box;\n}\n\n.k-loading-mask {\n    z-index: 100;\n}\n\n.k-loading-mask.k-opaque .k-loading-color {\n    opacity: 1;\n}\n\n.k-loading-text {\n    text-indent: -4000px;\n    text-align: center;\n    position: absolute;\n}\n\n.k-loading-image {\n    z-index: 2;\n}\n\n.k-loading-color {\n    opacity: 0.3;\n}\n\n.k-i-loading {\n    width: 1em;\n    height: 1em;\n    line-height: 1;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n    position: relative;\n    background-color: transparent;\n    box-sizing: border-box;\n}\n\n.k-i-loading::before, .k-i-loading::after {\n    box-sizing: border-box;\n}\n\n.k-i-loading::before,\n.k-i-loading::after,\n.k-loading-image::before,\n.k-loading-image::after {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: inline-block;\n    content: \"\";\n    box-sizing: inherit;\n    border-radius: 50%;\n    border-width: .05em;\n    border-style: solid;\n    border-color: currentColor;\n    border-top-color: transparent;\n    border-bottom-color: transparent;\n    background-color: transparent;\n}\n\n.k-icon.k-i-loading::before,\n.k-icon.k-i-loading::after {\n    content: \"\";\n}\n\n.k-i-loading::before,\n.k-loading-image::before {\n    margin-top: -.5em;\n    margin-left: -.5em;\n    width: 1em;\n    height: 1em;\n    animation: k-loading-animation .7s linear infinite;\n}\n\n.k-i-loading::after,\n.k-loading-image::after {\n    margin-top: -.25em;\n    margin-left: -.25em;\n    width: .5em;\n    height: .5em;\n    animation: k-loading-animation reverse 1.4s linear infinite;\n}\n\n.k-loading-image::before,\n.k-loading-image::after {\n    content: \"\";\n    border-width: 1px;\n    border-width: clamp(0.015em, 1px, 1px);\n    font-size: 4em;\n}\n\n@keyframes k-loading-animation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.k-marquee {\n    position: absolute;\n    z-index: 100000;\n}\n\n.k-marquee-color,\n.k-marquee-text {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.k-marquee-color {\n    color: white;\n    background-color: var(--kendo-primary-60, #0d6efd);\n    border-color: var(--kendo-primary-100, #0c65e9);\n    opacity: .6;\n}\n\n.k-marquee-text {\n    color: white;\n}\n\n:root {\n    --kendo-elevation-1: 0px 1px 2px rgba(0, 0, 0, 0.038);\n    --kendo-elevation-2: 0px 2px 7px rgba(0, 0, 0, 0.075);\n    --kendo-elevation-3: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    --kendo-elevation-4: 0px 6px 13px rgba(0, 0, 0, 0.125);\n    --kendo-elevation-5: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);\n    --kendo-elevation-6: 0px 11px 24px 0px rgba(0, 0, 0, 0.159);\n    --kendo-elevation-7: 0px 14px 36px 0px rgba(0, 0, 0, 0.168);\n    --kendo-elevation-8: 0px 16px 48px 0px rgba(0, 0, 0, 0.176);\n    --kendo-elevation-9: 0px 18px 60px 0px rgba(0, 0, 0, 0.185);\n}\n\n.k-reset {\n    margin: 0;\n    padding: 0;\n    border-width: 0;\n    outline: 0;\n    text-decoration: none;\n    font: inherit;\n    list-style: none;\n}\n\nkendo-sortable {\n    display: block;\n}\n\n.k-link,\n.k-link:hover {\n    color: inherit;\n    text-decoration: none;\n    outline: 0;\n    cursor: pointer;\n}\n\n.k-content {\n    outline: 0;\n}\n\n.k-centered {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.k-no-click {\n    pointer-events: none;\n}\n\n.k-pdf-export-shadow {\n    position: absolute;\n    overflow: hidden;\n    left: -15000px;\n    width: 14400px;\n}\n\n.kendo-pdf-hide-pseudo-elements::before,\n.kendo-pdf-hide-pseudo-elements::after {\n    display: none !important;\n}\n\n.k-text-selection ::selection {\n    background-color: #0d6efd;\n    color: white;\n}\n\n.k-block,\n.k-panel {\n    border-radius: 0.375rem;\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n}\n\n.k-block > .k-header,\n.k-panel > .k-header {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n    padding-inline: 0.5rem;\n    padding-block: 0.25rem;\n}\n\n.k-block > .k-content,\n.k-panel > .k-content {\n    padding-inline: 0.5rem;\n    padding-block: 0.25rem;\n}\n\n.k-content {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-disabled,\n.k-widget[disabled] {\n    outline: none;\n    cursor: default;\n    opacity: 0.65;\n    filter: grayscale(0.1);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n.k-disabled .k-link,\n.k-widget[disabled] .k-link {\n    cursor: default;\n    outline: 0;\n}\n\n.k-disabled [disabled],\n.k-disabled .k-disabled,\n.k-widget[disabled] [disabled],\n.k-widget[disabled] .k-disabled {\n    opacity: 1;\n    filter: grayscale(0);\n}\n\n.k-hr {\n    margin: 1rem auto;\n    padding: 0;\n    height: 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: #dee2e6;\n    display: block;\n    float: none;\n    clear: both;\n}\n\n.k-d-flex-row > .k-hr {\n    margin: 0;\n    width: 0;\n    height: auto;\n    border-width: 0 0 0 1px;\n    flex: 0 0 auto;\n}\n\n.k-d-flex-col > .k-hr {\n    margin: 0;\n    flex: 0 0 auto;\n}\n\n.k-dirty {\n    margin: 0;\n    padding: 0;\n    width: 0;\n    height: 0;\n    border-width: 3px;\n    border-style: solid;\n    border-color: #dc3545 #dc3545 transparent transparent;\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n[dir=\"rtl\"] .k-dirty,\n.k-rtl .k-dirty {\n    border-color: transparent transparent #dc3545 #dc3545;\n    right: auto;\n    left: 0;\n}\n\n.k-animation-container {\n    position: absolute;\n    overflow: hidden;\n    z-index: 100;\n}\n\n.k-animation-container-fixed {\n    position: fixed;\n}\n\n.k-animation-container-relative {\n    position: relative;\n    display: inline-block;\n}\n\n.k-push-right-enter, .k-push-right-appear {\n    transform: translate(-100%, 0);\n}\n\n.k-push-right-enter-active, .k-push-right-appear-active {\n    transform: translate(0, 0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-push-right-exit {\n    transform: translate(0, 0);\n}\n\n.k-push-right-exit-active {\n    transform: translate(100%, 0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-push-left-enter, .k-push-left-appear {\n    transform: translate(100%, 0);\n}\n\n.k-push-left-enter-active, .k-push-left-appear-active {\n    transform: translate(0, 0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-push-left-exit {\n    transform: translate(0, 0);\n}\n\n.k-push-left-exit-active {\n    transform: translate(-100%, 0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-push-down-enter, .k-push-down-appear {\n    transform: translate(0, -100%);\n}\n\n.k-push-down-enter-active, .k-push-down-appear-active {\n    transform: translate(0, 0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-push-down-exit {\n    transform: translate(0, 0);\n}\n\n.k-push-down-exit-active {\n    transform: translate(0, 100%);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-push-up-enter, .k-push-up-appear {\n    transform: translate(0, 100%);\n}\n\n.k-push-up-enter-active, .k-push-up-appear-active {\n    transform: translate(0, 0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-push-up-exit {\n    transform: translate(0, 0);\n}\n\n.k-push-up-exit-active {\n    transform: translate(0, -100%);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-expand-vertical-enter, .k-expand-vertical-appear {\n    transform: scaleY(0);\n}\n\n.k-expand-vertical-enter-active, .k-expand-vertical-appear-active {\n    transform: scaleY(1);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-expand-vertical-exit {\n    transform: scaleY(1);\n}\n\n.k-expand-vertical-exit-active {\n    transform: scaleY(0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-expand-horizontal-enter, .k-expand-horizontal-appear {\n    transform: scaleX(0);\n}\n\n.k-expand-horizontal-enter-active, .k-expand-horizontal-appear-active {\n    transform: scaleX(1);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-expand-horizontal-exit {\n    transform: scaleX(1);\n}\n\n.k-expand-horizontal-exit-active {\n    transform: scaleX(0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-fade-enter, .k-fade-appear {\n    opacity: 0;\n}\n\n.k-fade-enter-active, .k-fade-appear-active {\n    opacity: 1;\n    transition: opacity 500ms ease-in-out;\n}\n\n.k-fade-exit {\n    opacity: 1;\n}\n\n.k-fade-exit-active {\n    opacity: 0;\n    transition: opacity 500ms ease-in-out;\n}\n\n.k-fade-exit-active + .k-fade-exit-active,\n.k-fade-enter-active + .k-fade-enter-active {\n    display: none;\n}\n\n.k-zoom-in-enter, .k-zoom-in-appear {\n    opacity: 0;\n    transform: scale(0);\n}\n\n.k-zoom-in-enter-active, .k-zoom-in-appear-active {\n    opacity: 1;\n    transform: scale(1);\n    transition: transform, opacity 300ms ease-in-out;\n}\n\n.k-zoom-in-exit {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.k-zoom-in-exit-active {\n    opacity: 0;\n    transform: scale(2);\n    transition: transform, opacity 300ms ease-in-out;\n}\n\n.k-zoom-out-enter, .k-zoom-out-appear {\n    opacity: 0;\n    transform: scale(2);\n}\n\n.k-zoom-out-enter-active, .k-zoom-out-appear-active {\n    opacity: 1;\n    transform: scale(1);\n    transition: transform, opacity 300ms ease-in-out;\n}\n\n.k-zoom-out-exit {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.k-zoom-out-exit-active {\n    opacity: 0;\n    transform: scale(0);\n    transition: transform, opacity 300ms ease-in-out;\n}\n\n.k-slide-in-appear {\n    opacity: .1;\n    transform: translate(0, -3em);\n}\n\n.k-slide-in-appear .k-centered {\n    transform: translate(-50%, -60%);\n}\n\n.k-slide-in-appear-active {\n    opacity: 1;\n    transform: translate(0, 0);\n    transition: transform 0.3s cubic-bezier(0.2, 0.6, 0.4, 1), opacity 0.3s cubic-bezier(0.2, 1, 0.2, 1);\n}\n\n.k-slide-in-appear-active .k-centered {\n    transform: translate(-50%, -50%);\n}\n\n.k-slide-down-enter, .k-slide-down-appear {\n    transform: translateY(-100%);\n}\n\n.k-slide-down-enter-active, .k-slide-down-appear-active {\n    transform: translateY(0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-slide-down-exit {\n    transform: translateY(0);\n}\n\n.k-slide-down-exit-active {\n    transform: translateY(-100%);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-slide-up-enter, .k-slide-up-appear {\n    transform: translateY(100%);\n}\n\n.k-slide-up-enter-active, .k-slide-up-appear-active {\n    transform: translateY(0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-slide-up-exit {\n    transform: translateY(0);\n}\n\n.k-slide-up-exit-active {\n    transform: translateY(100%);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-slide-right-enter, .k-slide-right-appear {\n    transform: translateX(-100%);\n}\n\n.k-slide-right-enter-active, .k-slide-right-appear-active {\n    transform: translateX(0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-slide-right-exit {\n    transform: translateX(0);\n}\n\n.k-slide-right-exit-active {\n    transform: translateX(-100%);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-slide-left-enter, .k-slide-left-appear {\n    transform: translateX(100%);\n}\n\n.k-slide-left-enter-active, .k-slide-left-appear-active {\n    transform: translateX(0);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-slide-left-exit {\n    transform: translateX(0);\n}\n\n.k-slide-left-exit-active {\n    transform: translateX(100%);\n    transition: transform 300ms ease-in-out;\n}\n\n.k-reveal-vertical-enter, .k-reveal-vertical-appear {\n    max-height: 0;\n}\n\n.k-reveal-vertical-enter-active, .k-reveal-vertical-appear-active {\n    transition: max-height 300ms ease-in-out;\n}\n\n.k-reveal-vertical-exit-active {\n    max-height: 0 !important;\n    transition: max-height 300ms ease-in-out;\n}\n\n.k-reveal-horizontal-enter, .k-reveal-horizontal-appear {\n    max-width: 0;\n}\n\n.k-reveal-horizontal-enter-active, .k-reveal-horizontal-appear-active {\n    transition: max-width 300ms ease-in-out;\n}\n\n.k-reveal-horizontal-exit-active {\n    max-width: 0 !important;\n    transition: max-width 300ms ease-in-out;\n}\n\n.k-fx-end .k-fx-next,\n.k-fx-end .k-fx-current {\n    transition: all 350ms ease-out;\n}\n\n.k-fx {\n    position: relative;\n}\n\n.k-fx .k-fx-current {\n    z-index: 0;\n}\n\n.k-fx .k-fx-next {\n    z-index: 1;\n}\n\n.k-fx-hidden,\n.k-fx-hidden * {\n    visibility: hidden !important;\n}\n\n.k-fx-reverse .k-fx-current {\n    z-index: 1;\n}\n\n.k-fx-reverse .k-fx-next {\n    z-index: 0;\n}\n\n.k-fx-zoom.k-fx-start .k-fx-next {\n    transform: scale(0) !important;\n}\n\n.k-fx-zoom.k-fx-end .k-fx-next {\n    transform: scale(1) !important;\n}\n\n.k-fx-zoom.k-fx-reverse.k-fx-start .k-fx-next,\n.k-fx-zoom.k-fx-reverse.k-fx-end .k-fx-next {\n    transform: scale(1) !important;\n}\n\n.k-fx-zoom.k-fx-reverse.k-fx-start .k-fx-current {\n    transform: scale(1) !important;\n}\n\n.k-fx-zoom.k-fx-reverse.k-fx-end .k-fx-current {\n    transform: scale(0) !important;\n}\n\n.k-fx-fade.k-fx-start .k-fx-next {\n    will-change: opacity;\n    opacity: 0;\n}\n\n.k-fx-fade.k-fx-end .k-fx-next {\n    opacity: 1;\n}\n\n.k-fx-fade.k-fx-reverse.k-fx-start .k-fx-current {\n    will-change: opacity;\n    opacity: 1;\n}\n\n.k-fx-fade.k-fx-reverse.k-fx-end .k-fx-current {\n    opacity: 0;\n}\n\n.k-fx-slide.k-fx-end .k-fx-next .k-content,\n.k-fx-slide.k-fx-end .k-fx-next .k-header,\n.k-fx-slide.k-fx-end .k-fx-next .k-footer,\n.k-fx-slide.k-fx-end .k-fx-current .k-content,\n.k-fx-slide.k-fx-end .k-fx-current .k-header,\n.k-fx-slide.k-fx-end .k-fx-current .k-footer,\n.k-fx-slide.k-fx-end .k-fx-next .km-content,\n.k-fx-slide.k-fx-end .k-fx-next .km-header,\n.k-fx-slide.k-fx-end .k-fx-next .km-footer,\n.k-fx-slide.k-fx-end .k-fx-current .km-content,\n.k-fx-slide.k-fx-end .k-fx-current .km-header,\n.k-fx-slide.k-fx-end .k-fx-current .km-footer {\n    transition: all 350ms ease-out;\n}\n\n.k-fx-slide.k-fx-start .k-fx-next .k-content,\n.k-fx-slide.k-fx-start .k-fx-next .km-content {\n    will-change: transform;\n    transform: translateX(100%);\n}\n\n.k-fx-slide.k-fx-start .k-fx-next .k-header,\n.k-fx-slide.k-fx-start .k-fx-next .k-footer,\n.k-fx-slide.k-fx-start .k-fx-next .km-header,\n.k-fx-slide.k-fx-start .k-fx-next .km-footer {\n    will-change: opacity;\n    opacity: 0;\n}\n\n.k-fx-slide.k-fx-end .k-fx-current .k-content,\n.k-fx-slide.k-fx-end .k-fx-current .km-content {\n    transform: translateX(-100%);\n}\n\n.k-fx-slide.k-fx-end .k-fx-next .k-header,\n.k-fx-slide.k-fx-end .k-fx-next .k-footer,\n.k-fx-slide.k-fx-end .k-fx-next .km-header,\n.k-fx-slide.k-fx-end .k-fx-next .km-footer {\n    opacity: 1;\n}\n\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-content,\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-content {\n    will-change: transform;\n    transform: translateX(0);\n}\n\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-content,\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-content {\n    transform: translateX(100%);\n}\n\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-content,\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-content {\n    transform: translateX(-100%);\n}\n\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-content,\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-content {\n    transform: translateX(0);\n}\n\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-header,\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-footer,\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-header,\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-footer {\n    will-change: opacity;\n    opacity: 1;\n}\n\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-header,\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-footer,\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-header,\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-footer {\n    opacity: 1;\n}\n\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-header,\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-footer,\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-header,\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-footer {\n    opacity: 0;\n}\n\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-header,\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-footer,\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-header,\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-footer {\n    opacity: 1;\n}\n\n.k-fx-slide.k-fx-right.k-fx-start .k-fx-next .k-content,\n.k-fx-slide.k-fx-right.k-fx-start .k-fx-next .km-content {\n    transform: translateX(-100%);\n}\n\n.k-fx-slide.k-fx-right.k-fx-end .k-fx-current .k-content,\n.k-fx-slide.k-fx-right.k-fx-end .k-fx-current .km-content {\n    transform: translateX(100%);\n}\n\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current .k-content,\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current .km-content {\n    transform: translateX(0);\n}\n\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current .k-content,\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current .km-content {\n    transform: translateX(-100%);\n}\n\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next .k-content,\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next .km-content {\n    transform: translateX(100%);\n}\n\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next .k-content,\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next .km-content {\n    transform: translateX(0%);\n}\n\n.k-fx-tile.k-fx-start .k-fx-next {\n    will-change: transform;\n    transform: translateX(100%);\n}\n\n.k-fx-tile.k-fx-end .k-fx-current {\n    transform: translateX(-100%);\n}\n\n.k-fx-tile.k-fx-reverse.k-fx-start .k-fx-current {\n    will-change: transform;\n    transform: translateX(0);\n}\n\n.k-fx-tile.k-fx-reverse.k-fx-end .k-fx-current {\n    transform: translateX(100%);\n}\n\n.k-fx-tile.k-fx-reverse.k-fx-start .k-fx-next {\n    transform: translateX(-100%);\n}\n\n.k-fx-tile.k-fx-reverse.k-fx-end .k-fx-next {\n    transform: translateX(0);\n}\n\n.k-fx-tile.k-fx-right.k-fx-start .k-fx-next {\n    transform: translateX(-100%);\n}\n\n.k-fx-tile.k-fx-right.k-fx-end .k-fx-current {\n    transform: translateX(100%);\n}\n\n.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current {\n    transform: translateX(0);\n}\n\n.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current {\n    transform: translateX(-100%);\n}\n\n.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next {\n    transform: translateX(100%);\n}\n\n.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next {\n    transform: translateX(0%);\n}\n\n.k-fx.k-fx-overlay.k-fx-start .k-fx-next,\n.k-fx.k-fx-overlay.k-fx-left.k-fx-start .k-fx-next {\n    will-change: transform;\n    transform: translateX(100%);\n}\n\n.k-fx.k-fx-overlay.k-fx-right.k-fx-start .k-fx-next {\n    transform: translateX(-100%);\n}\n\n.k-fx.k-fx-overlay.k-fx-up.k-fx-start .k-fx-next {\n    transform: translateY(100%);\n}\n\n.k-fx.k-fx-overlay.k-fx-down.k-fx-start .k-fx-next {\n    transform: translateY(-100%);\n}\n\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-start .k-fx-next {\n    transform: none;\n}\n\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-start .k-fx-current {\n    will-change: transform;\n    transform: none;\n}\n\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-end .k-fx-current,\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-left.k-fx-end .k-fx-current {\n    transform: translateX(100%);\n}\n\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-right.k-fx-end .k-fx-current {\n    transform: translateX(-100%);\n}\n\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-up.k-fx-end .k-fx-current {\n    transform: translateY(100%);\n}\n\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-down.k-fx-end .k-fx-current {\n    transform: translateY(-100%);\n}\n\n.k-current-time {\n    position: absolute;\n}\n\n.k-current-time.k-current-time-arrow-left, .k-current-time.k-current-time-arrow-right, .k-current-time.k-current-time-arrow-down {\n    width: 0;\n    height: 0;\n    background: transparent;\n    border: 4px solid transparent;\n}\n\n.k-current-time {\n    background: #ff0000;\n}\n\n.k-current-time.k-current-time-arrow-left {\n    border-right-color: #ff0000;\n}\n\n.k-current-time.k-current-time-arrow-right {\n    border-left-color: #ff0000;\n}\n\n.k-current-time.k-current-time-arrow-down {\n    border-top-color: #ff0000;\n}\n\n.k-resize-handle,\n.k-resize-hint {\n    position: absolute;\n    border-color: inherit;\n    z-index: 200;\n}\n\n.k-resize-handle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.k-resize-handle::before {\n    content: \"\";\n    border: 0 solid;\n    border-color: inherit;\n}\n\n.k-resize-n {\n    width: 100%;\n    height: 6px;\n    flex-direction: row;\n    left: 0;\n    top: -3px;\n    cursor: n-resize;\n}\n\n.k-resize-s {\n    width: 100%;\n    height: 6px;\n    flex-direction: row;\n    left: 0;\n    bottom: -3px;\n    cursor: s-resize;\n}\n\n.k-resize-w {\n    width: 6px;\n    height: 100%;\n    flex-direction: column;\n    top: 0;\n    left: -3px;\n    cursor: w-resize;\n}\n\n.k-resize-e {\n    width: 6px;\n    height: 100%;\n    flex-direction: column;\n    top: 0;\n    right: -3px;\n    cursor: e-resize;\n}\n\n.k-resize-sw,\n.k-resize-se,\n.k-resize-nw,\n.k-resize-ne {\n    width: 5px;\n    height: 5px;\n}\n\n.k-resize-sw {\n    cursor: sw-resize;\n    bottom: 0;\n    left: 0;\n}\n\n.k-resize-se {\n    cursor: se-resize;\n    bottom: 0;\n    right: 0;\n}\n\n.k-resize-nw {\n    cursor: nw-resize;\n    top: 0;\n    left: 0;\n}\n\n.k-resize-ne {\n    cursor: ne-resize;\n    top: 0;\n    right: 0;\n}\n\n.k-vertical-resize {\n    cursor: row-resize;\n}\n\n.k-horizontal-resize {\n    cursor: col-resize;\n}\n\n.k-resize-hint {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.k-resize-hint .k-resize-hint-handle {\n    width: auto;\n    height: 20px;\n    align-self: stretch;\n}\n\n.k-resize-hint .k-resize-hint-marker {\n    width: 2px;\n    height: auto;\n    flex: 1 1 auto;\n}\n\n.k-resize-hint-vertical {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.k-resize-hint-vertical .k-resize-hint-handle {\n    width: 20px;\n    height: auto;\n    align-self: stretch;\n}\n\n.k-resize-hint-vertical .k-resize-hint-marker {\n    width: auto;\n    height: 2px;\n    flex: 1 1 auto;\n}\n\n.k-scrollbar {\n    position: absolute;\n    overflow: scroll;\n}\n\n.k-scrollbar-vertical {\n    top: 0;\n    right: 0;\n    width: 17px;\n    height: 100%;\n    overflow-x: hidden;\n}\n\n.k-touch-scrollbar {\n    display: none;\n    position: absolute;\n    z-index: 200000;\n    height: 8px;\n    width: 8px;\n    border: 1px solid #8a8a8a;\n    background-color: #858585;\n}\n\n.k-ratio-auto {\n    aspect-ratio: auto;\n}\n\n.\\!k-ratio-auto {\n    aspect-ratio: auto !important;\n}\n\n.k-ratio-1 {\n    aspect-ratio: 1;\n}\n\n.\\!k-ratio-1 {\n    aspect-ratio: 1 !important;\n}\n\n.k-ratio-square {\n    aspect-ratio: 1 / 1;\n}\n\n.\\!k-ratio-square {\n    aspect-ratio: 1 / 1 !important;\n}\n\n.k-ratio-video {\n    aspect-ratio: 16 / 9;\n}\n\n.\\!k-ratio-video {\n    aspect-ratio: 16 / 9 !important;\n}\n\n.k-aspect-ratio-auto {\n    aspect-ratio: auto;\n}\n\n.\\!k-aspect-ratio-auto {\n    aspect-ratio: auto !important;\n}\n\n.k-aspect-ratio-1 {\n    aspect-ratio: 1;\n}\n\n.\\!k-aspect-ratio-1 {\n    aspect-ratio: 1 !important;\n}\n\n.k-aspect-ratio-square {\n    aspect-ratio: 1 / 1;\n}\n\n.\\!k-aspect-ratio-square {\n    aspect-ratio: 1 / 1 !important;\n}\n\n.k-aspect-ratio-video {\n    aspect-ratio: 16 / 9;\n}\n\n.\\!k-aspect-ratio-video {\n    aspect-ratio: 16 / 9 !important;\n}\n\n.k-box-sizing-border {\n    box-sizing: border-box;\n}\n\n.\\!k-box-sizing-border {\n    box-sizing: border-box !important;\n}\n\n.k-box-sizing-content {\n    box-sizing: content-box;\n}\n\n.\\!k-box-sizing-content {\n    box-sizing: content-box !important;\n}\n\n.k-clear-left {\n    clear: left;\n}\n\n.\\!k-clear-left {\n    clear: left !important;\n}\n\n.k-clear-right {\n    clear: right;\n}\n\n.\\!k-clear-right {\n    clear: right !important;\n}\n\n.k-clear-both {\n    clear: both;\n}\n\n.\\!k-clear-both {\n    clear: both !important;\n}\n\n.k-clear-none {\n    clear: none;\n}\n\n.\\!k-clear-none {\n    clear: none !important;\n}\n\n.k-columns-1 {\n    columns: 1;\n}\n\n.\\!k-columns-1 {\n    columns: 1 !important;\n}\n\n.k-columns-2 {\n    columns: 2;\n}\n\n.\\!k-columns-2 {\n    columns: 2 !important;\n}\n\n.k-columns-3 {\n    columns: 3;\n}\n\n.\\!k-columns-3 {\n    columns: 3 !important;\n}\n\n.k-columns-4 {\n    columns: 4;\n}\n\n.\\!k-columns-4 {\n    columns: 4 !important;\n}\n\n.k-columns-5 {\n    columns: 5;\n}\n\n.\\!k-columns-5 {\n    columns: 5 !important;\n}\n\n.k-columns-6 {\n    columns: 6;\n}\n\n.\\!k-columns-6 {\n    columns: 6 !important;\n}\n\n.k-columns-7 {\n    columns: 7;\n}\n\n.\\!k-columns-7 {\n    columns: 7 !important;\n}\n\n.k-columns-8 {\n    columns: 8;\n}\n\n.\\!k-columns-8 {\n    columns: 8 !important;\n}\n\n.k-columns-9 {\n    columns: 9;\n}\n\n.\\!k-columns-9 {\n    columns: 9 !important;\n}\n\n.k-columns-10 {\n    columns: 10;\n}\n\n.\\!k-columns-10 {\n    columns: 10 !important;\n}\n\n.k-columns-11 {\n    columns: 11;\n}\n\n.\\!k-columns-11 {\n    columns: 11 !important;\n}\n\n.k-columns-12 {\n    columns: 12;\n}\n\n.\\!k-columns-12 {\n    columns: 12 !important;\n}\n\n.k-columns-auto {\n    columns: auto;\n}\n\n.\\!k-columns-auto {\n    columns: auto !important;\n}\n\n.k-d-none {\n    display: none;\n}\n\n.\\!k-d-none {\n    display: none !important;\n}\n\n.k-d-contents {\n    display: contents;\n}\n\n.\\!k-d-contents {\n    display: contents !important;\n}\n\n.k-d-block {\n    display: block;\n}\n\n.\\!k-d-block {\n    display: block !important;\n}\n\n.k-d-inline {\n    display: inline;\n}\n\n.\\!k-d-inline {\n    display: inline !important;\n}\n\n.k-d-inline-block {\n    display: inline-block;\n}\n\n.\\!k-d-inline-block {\n    display: inline-block !important;\n}\n\n.k-d-flex, .k-d-flex-row, .k-d-flex-col {\n    display: flex;\n}\n\n.\\!k-d-flex, .\\!k-d-flex-row, .\\!k-d-flex-col {\n    display: flex !important;\n}\n\n.k-d-inline-flex {\n    display: inline-flex;\n}\n\n.\\!k-d-inline-flex {\n    display: inline-flex !important;\n}\n\n.k-d-grid {\n    display: grid;\n}\n\n.\\!k-d-grid {\n    display: grid !important;\n}\n\n.k-d-inline-grid {\n    display: inline-grid;\n}\n\n.\\!k-d-inline-grid {\n    display: inline-grid !important;\n}\n\n.k-d-table {\n    display: table;\n}\n\n.\\!k-d-table {\n    display: table !important;\n}\n\n.k-d-inline-table {\n    display: inline-table;\n}\n\n.\\!k-d-inline-table {\n    display: inline-table !important;\n}\n\n.k-d-table-row {\n    display: table-row;\n}\n\n.\\!k-d-table-row {\n    display: table-row !important;\n}\n\n.k-d-table-cell {\n    display: table-cell;\n}\n\n.\\!k-d-table-cell {\n    display: table-cell !important;\n}\n\n.k-d-list-item {\n    display: list-item;\n}\n\n.\\!k-d-list-item {\n    display: list-item !important;\n}\n\n.k-display-none {\n    display: none;\n}\n\n.\\!k-display-none {\n    display: none !important;\n}\n\n.k-display-contents {\n    display: contents;\n}\n\n.\\!k-display-contents {\n    display: contents !important;\n}\n\n.k-display-block {\n    display: block;\n}\n\n.\\!k-display-block {\n    display: block !important;\n}\n\n.k-display-inline {\n    display: inline;\n}\n\n.\\!k-display-inline {\n    display: inline !important;\n}\n\n.k-display-inline-block {\n    display: inline-block;\n}\n\n.\\!k-display-inline-block {\n    display: inline-block !important;\n}\n\n.k-display-flex {\n    display: flex;\n}\n\n.\\!k-display-flex {\n    display: flex !important;\n}\n\n.k-display-inline-flex {\n    display: inline-flex;\n}\n\n.\\!k-display-inline-flex {\n    display: inline-flex !important;\n}\n\n.k-display-grid {\n    display: grid;\n}\n\n.\\!k-display-grid {\n    display: grid !important;\n}\n\n.k-display-inline-grid {\n    display: inline-grid;\n}\n\n.\\!k-display-inline-grid {\n    display: inline-grid !important;\n}\n\n.k-display-table {\n    display: table;\n}\n\n.\\!k-display-table {\n    display: table !important;\n}\n\n.k-display-inline-table {\n    display: inline-table;\n}\n\n.\\!k-display-inline-table {\n    display: inline-table !important;\n}\n\n.k-display-table-row {\n    display: table-row;\n}\n\n.\\!k-display-table-row {\n    display: table-row !important;\n}\n\n.k-display-table-cell {\n    display: table-cell;\n}\n\n.\\!k-display-table-cell {\n    display: table-cell !important;\n}\n\n.k-display-list-item {\n    display: list-item;\n}\n\n.\\!k-display-list-item {\n    display: list-item !important;\n}\n\n.k-float-left {\n    float: left;\n}\n\n.\\!k-float-left {\n    float: left !important;\n}\n\n.k-float-right {\n    float: right;\n}\n\n.\\!k-float-right {\n    float: right !important;\n}\n\n.k-float-none {\n    float: none;\n}\n\n.\\!k-float-none {\n    float: none !important;\n}\n\n.k-object-fit-contain {\n    object-fit: contain;\n}\n\n.\\!k-object-fit-contain {\n    object-fit: contain !important;\n}\n\n.k-object-fit-cover {\n    object-fit: cover;\n}\n\n.\\!k-object-fit-cover {\n    object-fit: cover !important;\n}\n\n.k-object-fit-fill {\n    object-fit: fill;\n}\n\n.\\!k-object-fit-fill {\n    object-fit: fill !important;\n}\n\n.k-object-fit-scale-down {\n    object-fit: scale-down;\n}\n\n.\\!k-object-fit-scale-down {\n    object-fit: scale-down !important;\n}\n\n.k-object-fit-initial {\n    object-fit: initial;\n}\n\n.\\!k-object-fit-initial {\n    object-fit: initial !important;\n}\n\n.k-object-fit-none {\n    object-fit: none;\n}\n\n.\\!k-object-fit-none {\n    object-fit: none !important;\n}\n\n.k-object-position-center {\n    object-position: center;\n}\n\n.\\!k-object-position-center {\n    object-position: center !important;\n}\n\n.k-object-position-top {\n    object-position: top;\n}\n\n.\\!k-object-position-top {\n    object-position: top !important;\n}\n\n.k-object-position-right {\n    object-position: right;\n}\n\n.\\!k-object-position-right {\n    object-position: right !important;\n}\n\n.k-object-position-bottom {\n    object-position: bottom;\n}\n\n.\\!k-object-position-bottom {\n    object-position: bottom !important;\n}\n\n.k-object-position-left {\n    object-position: left;\n}\n\n.\\!k-object-position-left {\n    object-position: left !important;\n}\n\n.k-object-position-top-left {\n    object-position: top left;\n}\n\n.\\!k-object-position-top-left {\n    object-position: top left !important;\n}\n\n.k-object-position-top-right {\n    object-position: top right;\n}\n\n.\\!k-object-position-top-right {\n    object-position: top right !important;\n}\n\n.k-object-position-bottom-left {\n    object-position: bottom left;\n}\n\n.\\!k-object-position-bottom-left {\n    object-position: bottom left !important;\n}\n\n.k-object-position-bottom-right {\n    object-position: bottom right;\n}\n\n.\\!k-object-position-bottom-right {\n    object-position: bottom right !important;\n}\n\n.k-overflow-auto {\n    overflow: auto;\n}\n\n.\\!k-overflow-auto {\n    overflow: auto !important;\n}\n\n.k-overflow-hidden {\n    overflow: hidden;\n}\n\n.\\!k-overflow-hidden {\n    overflow: hidden !important;\n}\n\n.k-overflow-visible {\n    overflow: visible;\n}\n\n.\\!k-overflow-visible {\n    overflow: visible !important;\n}\n\n.k-overflow-scroll {\n    overflow: scroll;\n}\n\n.\\!k-overflow-scroll {\n    overflow: scroll !important;\n}\n\n.k-overflow-clip {\n    overflow: clip;\n}\n\n.\\!k-overflow-clip {\n    overflow: clip !important;\n}\n\n.k-overflow-x-auto {\n    overflow-x: auto;\n}\n\n.\\!k-overflow-x-auto {\n    overflow-x: auto !important;\n}\n\n.k-overflow-x-hidden {\n    overflow-x: hidden;\n}\n\n.\\!k-overflow-x-hidden {\n    overflow-x: hidden !important;\n}\n\n.k-overflow-x-visible {\n    overflow-x: visible;\n}\n\n.\\!k-overflow-x-visible {\n    overflow-x: visible !important;\n}\n\n.k-overflow-x-scroll {\n    overflow-x: scroll;\n}\n\n.\\!k-overflow-x-scroll {\n    overflow-x: scroll !important;\n}\n\n.k-overflow-x-clip {\n    overflow-x: clip;\n}\n\n.\\!k-overflow-x-clip {\n    overflow-x: clip !important;\n}\n\n.k-overflow-y-auto {\n    overflow-y: auto;\n}\n\n.\\!k-overflow-y-auto {\n    overflow-y: auto !important;\n}\n\n.k-overflow-y-hidden {\n    overflow-y: hidden;\n}\n\n.\\!k-overflow-y-hidden {\n    overflow-y: hidden !important;\n}\n\n.k-overflow-y-visible {\n    overflow-y: visible;\n}\n\n.\\!k-overflow-y-visible {\n    overflow-y: visible !important;\n}\n\n.k-overflow-y-scroll {\n    overflow-y: scroll;\n}\n\n.\\!k-overflow-y-scroll {\n    overflow-y: scroll !important;\n}\n\n.k-overflow-y-clip {\n    overflow-y: clip;\n}\n\n.\\!k-overflow-y-clip {\n    overflow-y: clip !important;\n}\n\n.k-top-0 {\n    top: 0;\n}\n\n.\\!k-top-0 {\n    top: 0 !important;\n}\n\n.k-top-1px {\n    top: 1px;\n}\n\n.\\!k-top-1px {\n    top: 1px !important;\n}\n\n.k-top-0\\.5 {\n    top: 0.125rem;\n}\n\n.\\!k-top-0\\.5 {\n    top: 0.125rem !important;\n}\n\n.k-top-1 {\n    top: 0.25rem;\n}\n\n.\\!k-top-1 {\n    top: 0.25rem !important;\n}\n\n.k-top-1\\.5 {\n    top: 0.375rem;\n}\n\n.\\!k-top-1\\.5 {\n    top: 0.375rem !important;\n}\n\n.k-top-2 {\n    top: 0.5rem;\n}\n\n.\\!k-top-2 {\n    top: 0.5rem !important;\n}\n\n.k-top-2\\.5 {\n    top: 0.625rem;\n}\n\n.\\!k-top-2\\.5 {\n    top: 0.625rem !important;\n}\n\n.k-top-3 {\n    top: 0.75rem;\n}\n\n.\\!k-top-3 {\n    top: 0.75rem !important;\n}\n\n.k-top-3\\.5 {\n    top: 0.875rem;\n}\n\n.\\!k-top-3\\.5 {\n    top: 0.875rem !important;\n}\n\n.k-top-4 {\n    top: 1rem;\n}\n\n.\\!k-top-4 {\n    top: 1rem !important;\n}\n\n.k-top-4\\.5 {\n    top: 1.125rem;\n}\n\n.\\!k-top-4\\.5 {\n    top: 1.125rem !important;\n}\n\n.k-top-5 {\n    top: 1.25rem;\n}\n\n.\\!k-top-5 {\n    top: 1.25rem !important;\n}\n\n.k-top-5\\.5 {\n    top: 1.375rem;\n}\n\n.\\!k-top-5\\.5 {\n    top: 1.375rem !important;\n}\n\n.k-top-6 {\n    top: 1.5rem;\n}\n\n.\\!k-top-6 {\n    top: 1.5rem !important;\n}\n\n.k-top-6\\.5 {\n    top: 1.625rem;\n}\n\n.\\!k-top-6\\.5 {\n    top: 1.625rem !important;\n}\n\n.k-top-7 {\n    top: 1.75rem;\n}\n\n.\\!k-top-7 {\n    top: 1.75rem !important;\n}\n\n.k-top-7\\.5 {\n    top: 1.875rem;\n}\n\n.\\!k-top-7\\.5 {\n    top: 1.875rem !important;\n}\n\n.k-top-8 {\n    top: 2rem;\n}\n\n.\\!k-top-8 {\n    top: 2rem !important;\n}\n\n.k-top-9 {\n    top: 2.25rem;\n}\n\n.\\!k-top-9 {\n    top: 2.25rem !important;\n}\n\n.k-top-10 {\n    top: 2.5rem;\n}\n\n.\\!k-top-10 {\n    top: 2.5rem !important;\n}\n\n.k-top-11 {\n    top: 2.75rem;\n}\n\n.\\!k-top-11 {\n    top: 2.75rem !important;\n}\n\n.k-top-12 {\n    top: 3rem;\n}\n\n.\\!k-top-12 {\n    top: 3rem !important;\n}\n\n.k-top-13 {\n    top: 3.25rem;\n}\n\n.\\!k-top-13 {\n    top: 3.25rem !important;\n}\n\n.k-top-14 {\n    top: 3.5rem;\n}\n\n.\\!k-top-14 {\n    top: 3.5rem !important;\n}\n\n.k-top-15 {\n    top: 3.75rem;\n}\n\n.\\!k-top-15 {\n    top: 3.75rem !important;\n}\n\n.k-top-16 {\n    top: 4rem;\n}\n\n.\\!k-top-16 {\n    top: 4rem !important;\n}\n\n.k-top-17 {\n    top: 4.25rem;\n}\n\n.\\!k-top-17 {\n    top: 4.25rem !important;\n}\n\n.k-top-18 {\n    top: 4.5rem;\n}\n\n.\\!k-top-18 {\n    top: 4.5rem !important;\n}\n\n.k-top-19 {\n    top: 4.75rem;\n}\n\n.\\!k-top-19 {\n    top: 4.75rem !important;\n}\n\n.k-top-20 {\n    top: 5rem;\n}\n\n.\\!k-top-20 {\n    top: 5rem !important;\n}\n\n.k-top-21 {\n    top: 5.25rem;\n}\n\n.\\!k-top-21 {\n    top: 5.25rem !important;\n}\n\n.k-top-22 {\n    top: 5.5rem;\n}\n\n.\\!k-top-22 {\n    top: 5.5rem !important;\n}\n\n.k-top-23 {\n    top: 5.75rem;\n}\n\n.\\!k-top-23 {\n    top: 5.75rem !important;\n}\n\n.k-top-24 {\n    top: 6rem;\n}\n\n.\\!k-top-24 {\n    top: 6rem !important;\n}\n\n.k-top--1 {\n    top: -1px;\n}\n\n.\\!k-top--1 {\n    top: -1px !important;\n}\n\n.k-right-0 {\n    right: 0;\n}\n\n.\\!k-right-0 {\n    right: 0 !important;\n}\n\n.k-right-1px {\n    right: 1px;\n}\n\n.\\!k-right-1px {\n    right: 1px !important;\n}\n\n.k-right-0\\.5 {\n    right: 0.125rem;\n}\n\n.\\!k-right-0\\.5 {\n    right: 0.125rem !important;\n}\n\n.k-right-1 {\n    right: 0.25rem;\n}\n\n.\\!k-right-1 {\n    right: 0.25rem !important;\n}\n\n.k-right-1\\.5 {\n    right: 0.375rem;\n}\n\n.\\!k-right-1\\.5 {\n    right: 0.375rem !important;\n}\n\n.k-right-2 {\n    right: 0.5rem;\n}\n\n.\\!k-right-2 {\n    right: 0.5rem !important;\n}\n\n.k-right-2\\.5 {\n    right: 0.625rem;\n}\n\n.\\!k-right-2\\.5 {\n    right: 0.625rem !important;\n}\n\n.k-right-3 {\n    right: 0.75rem;\n}\n\n.\\!k-right-3 {\n    right: 0.75rem !important;\n}\n\n.k-right-3\\.5 {\n    right: 0.875rem;\n}\n\n.\\!k-right-3\\.5 {\n    right: 0.875rem !important;\n}\n\n.k-right-4 {\n    right: 1rem;\n}\n\n.\\!k-right-4 {\n    right: 1rem !important;\n}\n\n.k-right-4\\.5 {\n    right: 1.125rem;\n}\n\n.\\!k-right-4\\.5 {\n    right: 1.125rem !important;\n}\n\n.k-right-5 {\n    right: 1.25rem;\n}\n\n.\\!k-right-5 {\n    right: 1.25rem !important;\n}\n\n.k-right-5\\.5 {\n    right: 1.375rem;\n}\n\n.\\!k-right-5\\.5 {\n    right: 1.375rem !important;\n}\n\n.k-right-6 {\n    right: 1.5rem;\n}\n\n.\\!k-right-6 {\n    right: 1.5rem !important;\n}\n\n.k-right-6\\.5 {\n    right: 1.625rem;\n}\n\n.\\!k-right-6\\.5 {\n    right: 1.625rem !important;\n}\n\n.k-right-7 {\n    right: 1.75rem;\n}\n\n.\\!k-right-7 {\n    right: 1.75rem !important;\n}\n\n.k-right-7\\.5 {\n    right: 1.875rem;\n}\n\n.\\!k-right-7\\.5 {\n    right: 1.875rem !important;\n}\n\n.k-right-8 {\n    right: 2rem;\n}\n\n.\\!k-right-8 {\n    right: 2rem !important;\n}\n\n.k-right-9 {\n    right: 2.25rem;\n}\n\n.\\!k-right-9 {\n    right: 2.25rem !important;\n}\n\n.k-right-10 {\n    right: 2.5rem;\n}\n\n.\\!k-right-10 {\n    right: 2.5rem !important;\n}\n\n.k-right-11 {\n    right: 2.75rem;\n}\n\n.\\!k-right-11 {\n    right: 2.75rem !important;\n}\n\n.k-right-12 {\n    right: 3rem;\n}\n\n.\\!k-right-12 {\n    right: 3rem !important;\n}\n\n.k-right-13 {\n    right: 3.25rem;\n}\n\n.\\!k-right-13 {\n    right: 3.25rem !important;\n}\n\n.k-right-14 {\n    right: 3.5rem;\n}\n\n.\\!k-right-14 {\n    right: 3.5rem !important;\n}\n\n.k-right-15 {\n    right: 3.75rem;\n}\n\n.\\!k-right-15 {\n    right: 3.75rem !important;\n}\n\n.k-right-16 {\n    right: 4rem;\n}\n\n.\\!k-right-16 {\n    right: 4rem !important;\n}\n\n.k-right-17 {\n    right: 4.25rem;\n}\n\n.\\!k-right-17 {\n    right: 4.25rem !important;\n}\n\n.k-right-18 {\n    right: 4.5rem;\n}\n\n.\\!k-right-18 {\n    right: 4.5rem !important;\n}\n\n.k-right-19 {\n    right: 4.75rem;\n}\n\n.\\!k-right-19 {\n    right: 4.75rem !important;\n}\n\n.k-right-20 {\n    right: 5rem;\n}\n\n.\\!k-right-20 {\n    right: 5rem !important;\n}\n\n.k-right-21 {\n    right: 5.25rem;\n}\n\n.\\!k-right-21 {\n    right: 5.25rem !important;\n}\n\n.k-right-22 {\n    right: 5.5rem;\n}\n\n.\\!k-right-22 {\n    right: 5.5rem !important;\n}\n\n.k-right-23 {\n    right: 5.75rem;\n}\n\n.\\!k-right-23 {\n    right: 5.75rem !important;\n}\n\n.k-right-24 {\n    right: 6rem;\n}\n\n.\\!k-right-24 {\n    right: 6rem !important;\n}\n\n.k-right--1 {\n    right: -1px;\n}\n\n.\\!k-right--1 {\n    right: -1px !important;\n}\n\n.k-bottom-0 {\n    bottom: 0;\n}\n\n.\\!k-bottom-0 {\n    bottom: 0 !important;\n}\n\n.k-bottom-1px {\n    bottom: 1px;\n}\n\n.\\!k-bottom-1px {\n    bottom: 1px !important;\n}\n\n.k-bottom-0\\.5 {\n    bottom: 0.125rem;\n}\n\n.\\!k-bottom-0\\.5 {\n    bottom: 0.125rem !important;\n}\n\n.k-bottom-1 {\n    bottom: 0.25rem;\n}\n\n.\\!k-bottom-1 {\n    bottom: 0.25rem !important;\n}\n\n.k-bottom-1\\.5 {\n    bottom: 0.375rem;\n}\n\n.\\!k-bottom-1\\.5 {\n    bottom: 0.375rem !important;\n}\n\n.k-bottom-2 {\n    bottom: 0.5rem;\n}\n\n.\\!k-bottom-2 {\n    bottom: 0.5rem !important;\n}\n\n.k-bottom-2\\.5 {\n    bottom: 0.625rem;\n}\n\n.\\!k-bottom-2\\.5 {\n    bottom: 0.625rem !important;\n}\n\n.k-bottom-3 {\n    bottom: 0.75rem;\n}\n\n.\\!k-bottom-3 {\n    bottom: 0.75rem !important;\n}\n\n.k-bottom-3\\.5 {\n    bottom: 0.875rem;\n}\n\n.\\!k-bottom-3\\.5 {\n    bottom: 0.875rem !important;\n}\n\n.k-bottom-4 {\n    bottom: 1rem;\n}\n\n.\\!k-bottom-4 {\n    bottom: 1rem !important;\n}\n\n.k-bottom-4\\.5 {\n    bottom: 1.125rem;\n}\n\n.\\!k-bottom-4\\.5 {\n    bottom: 1.125rem !important;\n}\n\n.k-bottom-5 {\n    bottom: 1.25rem;\n}\n\n.\\!k-bottom-5 {\n    bottom: 1.25rem !important;\n}\n\n.k-bottom-5\\.5 {\n    bottom: 1.375rem;\n}\n\n.\\!k-bottom-5\\.5 {\n    bottom: 1.375rem !important;\n}\n\n.k-bottom-6 {\n    bottom: 1.5rem;\n}\n\n.\\!k-bottom-6 {\n    bottom: 1.5rem !important;\n}\n\n.k-bottom-6\\.5 {\n    bottom: 1.625rem;\n}\n\n.\\!k-bottom-6\\.5 {\n    bottom: 1.625rem !important;\n}\n\n.k-bottom-7 {\n    bottom: 1.75rem;\n}\n\n.\\!k-bottom-7 {\n    bottom: 1.75rem !important;\n}\n\n.k-bottom-7\\.5 {\n    bottom: 1.875rem;\n}\n\n.\\!k-bottom-7\\.5 {\n    bottom: 1.875rem !important;\n}\n\n.k-bottom-8 {\n    bottom: 2rem;\n}\n\n.\\!k-bottom-8 {\n    bottom: 2rem !important;\n}\n\n.k-bottom-9 {\n    bottom: 2.25rem;\n}\n\n.\\!k-bottom-9 {\n    bottom: 2.25rem !important;\n}\n\n.k-bottom-10 {\n    bottom: 2.5rem;\n}\n\n.\\!k-bottom-10 {\n    bottom: 2.5rem !important;\n}\n\n.k-bottom-11 {\n    bottom: 2.75rem;\n}\n\n.\\!k-bottom-11 {\n    bottom: 2.75rem !important;\n}\n\n.k-bottom-12 {\n    bottom: 3rem;\n}\n\n.\\!k-bottom-12 {\n    bottom: 3rem !important;\n}\n\n.k-bottom-13 {\n    bottom: 3.25rem;\n}\n\n.\\!k-bottom-13 {\n    bottom: 3.25rem !important;\n}\n\n.k-bottom-14 {\n    bottom: 3.5rem;\n}\n\n.\\!k-bottom-14 {\n    bottom: 3.5rem !important;\n}\n\n.k-bottom-15 {\n    bottom: 3.75rem;\n}\n\n.\\!k-bottom-15 {\n    bottom: 3.75rem !important;\n}\n\n.k-bottom-16 {\n    bottom: 4rem;\n}\n\n.\\!k-bottom-16 {\n    bottom: 4rem !important;\n}\n\n.k-bottom-17 {\n    bottom: 4.25rem;\n}\n\n.\\!k-bottom-17 {\n    bottom: 4.25rem !important;\n}\n\n.k-bottom-18 {\n    bottom: 4.5rem;\n}\n\n.\\!k-bottom-18 {\n    bottom: 4.5rem !important;\n}\n\n.k-bottom-19 {\n    bottom: 4.75rem;\n}\n\n.\\!k-bottom-19 {\n    bottom: 4.75rem !important;\n}\n\n.k-bottom-20 {\n    bottom: 5rem;\n}\n\n.\\!k-bottom-20 {\n    bottom: 5rem !important;\n}\n\n.k-bottom-21 {\n    bottom: 5.25rem;\n}\n\n.\\!k-bottom-21 {\n    bottom: 5.25rem !important;\n}\n\n.k-bottom-22 {\n    bottom: 5.5rem;\n}\n\n.\\!k-bottom-22 {\n    bottom: 5.5rem !important;\n}\n\n.k-bottom-23 {\n    bottom: 5.75rem;\n}\n\n.\\!k-bottom-23 {\n    bottom: 5.75rem !important;\n}\n\n.k-bottom-24 {\n    bottom: 6rem;\n}\n\n.\\!k-bottom-24 {\n    bottom: 6rem !important;\n}\n\n.k-bottom--1 {\n    bottom: -1px;\n}\n\n.\\!k-bottom--1 {\n    bottom: -1px !important;\n}\n\n.k-left-0 {\n    left: 0;\n}\n\n.\\!k-left-0 {\n    left: 0 !important;\n}\n\n.k-left-1px {\n    left: 1px;\n}\n\n.\\!k-left-1px {\n    left: 1px !important;\n}\n\n.k-left-0\\.5 {\n    left: 0.125rem;\n}\n\n.\\!k-left-0\\.5 {\n    left: 0.125rem !important;\n}\n\n.k-left-1 {\n    left: 0.25rem;\n}\n\n.\\!k-left-1 {\n    left: 0.25rem !important;\n}\n\n.k-left-1\\.5 {\n    left: 0.375rem;\n}\n\n.\\!k-left-1\\.5 {\n    left: 0.375rem !important;\n}\n\n.k-left-2 {\n    left: 0.5rem;\n}\n\n.\\!k-left-2 {\n    left: 0.5rem !important;\n}\n\n.k-left-2\\.5 {\n    left: 0.625rem;\n}\n\n.\\!k-left-2\\.5 {\n    left: 0.625rem !important;\n}\n\n.k-left-3 {\n    left: 0.75rem;\n}\n\n.\\!k-left-3 {\n    left: 0.75rem !important;\n}\n\n.k-left-3\\.5 {\n    left: 0.875rem;\n}\n\n.\\!k-left-3\\.5 {\n    left: 0.875rem !important;\n}\n\n.k-left-4 {\n    left: 1rem;\n}\n\n.\\!k-left-4 {\n    left: 1rem !important;\n}\n\n.k-left-4\\.5 {\n    left: 1.125rem;\n}\n\n.\\!k-left-4\\.5 {\n    left: 1.125rem !important;\n}\n\n.k-left-5 {\n    left: 1.25rem;\n}\n\n.\\!k-left-5 {\n    left: 1.25rem !important;\n}\n\n.k-left-5\\.5 {\n    left: 1.375rem;\n}\n\n.\\!k-left-5\\.5 {\n    left: 1.375rem !important;\n}\n\n.k-left-6 {\n    left: 1.5rem;\n}\n\n.\\!k-left-6 {\n    left: 1.5rem !important;\n}\n\n.k-left-6\\.5 {\n    left: 1.625rem;\n}\n\n.\\!k-left-6\\.5 {\n    left: 1.625rem !important;\n}\n\n.k-left-7 {\n    left: 1.75rem;\n}\n\n.\\!k-left-7 {\n    left: 1.75rem !important;\n}\n\n.k-left-7\\.5 {\n    left: 1.875rem;\n}\n\n.\\!k-left-7\\.5 {\n    left: 1.875rem !important;\n}\n\n.k-left-8 {\n    left: 2rem;\n}\n\n.\\!k-left-8 {\n    left: 2rem !important;\n}\n\n.k-left-9 {\n    left: 2.25rem;\n}\n\n.\\!k-left-9 {\n    left: 2.25rem !important;\n}\n\n.k-left-10 {\n    left: 2.5rem;\n}\n\n.\\!k-left-10 {\n    left: 2.5rem !important;\n}\n\n.k-left-11 {\n    left: 2.75rem;\n}\n\n.\\!k-left-11 {\n    left: 2.75rem !important;\n}\n\n.k-left-12 {\n    left: 3rem;\n}\n\n.\\!k-left-12 {\n    left: 3rem !important;\n}\n\n.k-left-13 {\n    left: 3.25rem;\n}\n\n.\\!k-left-13 {\n    left: 3.25rem !important;\n}\n\n.k-left-14 {\n    left: 3.5rem;\n}\n\n.\\!k-left-14 {\n    left: 3.5rem !important;\n}\n\n.k-left-15 {\n    left: 3.75rem;\n}\n\n.\\!k-left-15 {\n    left: 3.75rem !important;\n}\n\n.k-left-16 {\n    left: 4rem;\n}\n\n.\\!k-left-16 {\n    left: 4rem !important;\n}\n\n.k-left-17 {\n    left: 4.25rem;\n}\n\n.\\!k-left-17 {\n    left: 4.25rem !important;\n}\n\n.k-left-18 {\n    left: 4.5rem;\n}\n\n.\\!k-left-18 {\n    left: 4.5rem !important;\n}\n\n.k-left-19 {\n    left: 4.75rem;\n}\n\n.\\!k-left-19 {\n    left: 4.75rem !important;\n}\n\n.k-left-20 {\n    left: 5rem;\n}\n\n.\\!k-left-20 {\n    left: 5rem !important;\n}\n\n.k-left-21 {\n    left: 5.25rem;\n}\n\n.\\!k-left-21 {\n    left: 5.25rem !important;\n}\n\n.k-left-22 {\n    left: 5.5rem;\n}\n\n.\\!k-left-22 {\n    left: 5.5rem !important;\n}\n\n.k-left-23 {\n    left: 5.75rem;\n}\n\n.\\!k-left-23 {\n    left: 5.75rem !important;\n}\n\n.k-left-24 {\n    left: 6rem;\n}\n\n.\\!k-left-24 {\n    left: 6rem !important;\n}\n\n.k-left--1 {\n    left: -1px;\n}\n\n.\\!k-left--1 {\n    left: -1px !important;\n}\n\n.k-top,\n.k-pos-top {\n    top: 0;\n}\n\n.k-right,\n.k-pos-right {\n    right: 0;\n}\n\n.k-bottom,\n.k-pos-bottom {\n    bottom: 0;\n}\n\n.k-left,\n.k-pos-left {\n    left: 0;\n}\n\n.k-inset-0 {\n    inset: 0;\n}\n\n.\\!k-inset-0 {\n    inset: 0 !important;\n}\n\n.k-inset-1 {\n    inset: 1px;\n}\n\n.\\!k-inset-1 {\n    inset: 1px !important;\n}\n\n.k-inset--1 {\n    inset: -1px;\n}\n\n.\\!k-inset--1 {\n    inset: -1px !important;\n}\n\n.k-inset-x-0 {\n    inset-inline: 0;\n}\n\n.\\!k-inset-x-0 {\n    inset-inline: 0 !important;\n}\n\n.k-inset-x-1 {\n    inset-inline: 1px;\n}\n\n.\\!k-inset-x-1 {\n    inset-inline: 1px !important;\n}\n\n.k-inset-x--1 {\n    inset-inline: -1px;\n}\n\n.\\!k-inset-x--1 {\n    inset-inline: -1px !important;\n}\n\n.k-inset-y-0 {\n    inset-block: 0;\n}\n\n.\\!k-inset-y-0 {\n    inset-block: 0 !important;\n}\n\n.k-inset-y-1 {\n    inset-block: 1px;\n}\n\n.\\!k-inset-y-1 {\n    inset-block: 1px !important;\n}\n\n.k-inset-y--1 {\n    inset-block: -1px;\n}\n\n.\\!k-inset-y--1 {\n    inset-block: -1px !important;\n}\n\n.k-top-left-0 {\n    top: 0;\n    left: 0;\n}\n\n.\\!k-top-left-0 {\n    top: 0 !important;\n    left: 0 !important;\n}\n\n.k-top-left-1 {\n    top: 1px;\n    left: 1px;\n}\n\n.\\!k-top-left-1 {\n    top: 1px !important;\n    left: 1px !important;\n}\n\n.k-top-left--1 {\n    top: -1px;\n    left: -1px;\n}\n\n.\\!k-top-left--1 {\n    top: -1px !important;\n    left: -1px !important;\n}\n\n.k-top-right-0 {\n    top: 0;\n    right: 0;\n}\n\n.\\!k-top-right-0 {\n    top: 0 !important;\n    right: 0 !important;\n}\n\n.k-top-right-1 {\n    top: 1px;\n    right: 1px;\n}\n\n.\\!k-top-right-1 {\n    top: 1px !important;\n    right: 1px !important;\n}\n\n.k-top-right--1 {\n    top: -1px;\n    right: -1px;\n}\n\n.\\!k-top-right--1 {\n    top: -1px !important;\n    right: -1px !important;\n}\n\n.k-bottom-left-0 {\n    bottom: 0;\n    left: 0;\n}\n\n.\\!k-bottom-left-0 {\n    bottom: 0 !important;\n    left: 0 !important;\n}\n\n.k-bottom-left-1 {\n    bottom: 1px;\n    left: 1px;\n}\n\n.\\!k-bottom-left-1 {\n    bottom: 1px !important;\n    left: 1px !important;\n}\n\n.k-bottom-left--1 {\n    bottom: -1px;\n    left: -1px;\n}\n\n.\\!k-bottom-left--1 {\n    bottom: -1px !important;\n    left: -1px !important;\n}\n\n.k-bottom-right-0 {\n    bottom: 0;\n    right: 0;\n}\n\n.\\!k-bottom-right-0 {\n    bottom: 0 !important;\n    right: 0 !important;\n}\n\n.k-bottom-right-1 {\n    bottom: 1px;\n    right: 1px;\n}\n\n.\\!k-bottom-right-1 {\n    bottom: 1px !important;\n    right: 1px !important;\n}\n\n.k-bottom-right--1 {\n    bottom: -1px;\n    right: -1px;\n}\n\n.\\!k-bottom-right--1 {\n    bottom: -1px !important;\n    right: -1px !important;\n}\n\n.k-top-start,\n.k-pos-top-start {\n    top: 0;\n    inset-inline-start: 0;\n}\n\n.k-top-end,\n.k-pos-top-end {\n    top: 0;\n    inset-inline-end: 0;\n}\n\n.k-bottom-start,\n.k-pos-bottom-start {\n    bottom: 0;\n    inset-inline-start: 0;\n}\n\n.k-bottom-end,\n.k-pos-bottom-end {\n    bottom: 0;\n    inset-inline-end: 0;\n}\n\n.k-top-center,\n.k-pos-top-center {\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.k-middle-left,\n.k-middle-start,\n.k-pos-middle-start {\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n}\n\n.k-middle-center {\n    top: 50%;\n    left: 50%;\n    transform: translateY(-50%);\n}\n\n.k-middle-right,\n.k-middle-end,\n.k-pos-middle-end {\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n}\n\n.k-bottom-center,\n.k-pos-bottom-center {\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.k-pos-static, .k-static {\n    position: static;\n}\n\n.\\!k-pos-static, .\\!k-static {\n    position: static !important;\n}\n\n.k-pos-relative, .k-relative {\n    position: relative;\n}\n\n.\\!k-pos-relative, .\\!k-relative {\n    position: relative !important;\n}\n\n.k-pos-absolute, .k-absolute {\n    position: absolute;\n}\n\n.\\!k-pos-absolute, .\\!k-absolute {\n    position: absolute !important;\n}\n\n.k-pos-fixed, .k-fixed {\n    position: fixed;\n}\n\n.\\!k-pos-fixed, .\\!k-fixed {\n    position: fixed !important;\n}\n\n.k-pos-sticky, .k-sticky {\n    position: sticky;\n}\n\n.\\!k-pos-sticky, .\\!k-sticky {\n    position: sticky !important;\n}\n\n.k-visibility-visible, .k-visible {\n    visibility: visible;\n}\n\n.\\!k-visibility-visible, .\\!k-visible {\n    visibility: visible !important;\n}\n\n.k-visibility-invisible {\n    visibility: hidden;\n}\n\n.\\!k-visibility-invisible {\n    visibility: hidden !important;\n}\n\n.k-visibility-collapse {\n    visibility: collapse;\n}\n\n.\\!k-visibility-collapse {\n    visibility: collapse !important;\n}\n\n.k-z-0 {\n    z-index: 0;\n}\n\n.\\!k-z-0 {\n    z-index: 0 !important;\n}\n\n.k-z-10 {\n    z-index: 10;\n}\n\n.\\!k-z-10 {\n    z-index: 10 !important;\n}\n\n.k-z-20 {\n    z-index: 20;\n}\n\n.\\!k-z-20 {\n    z-index: 20 !important;\n}\n\n.k-z-30 {\n    z-index: 30;\n}\n\n.\\!k-z-30 {\n    z-index: 30 !important;\n}\n\n.k-z-40 {\n    z-index: 40;\n}\n\n.\\!k-z-40 {\n    z-index: 40 !important;\n}\n\n.k-z-50 {\n    z-index: 50;\n}\n\n.\\!k-z-50 {\n    z-index: 50 !important;\n}\n\n.k-z-auto {\n    z-index: auto;\n}\n\n.\\!k-z-auto {\n    z-index: auto !important;\n}\n\n.k-align-content-normal {\n    align-content: normal;\n}\n\n.\\!k-align-content-normal {\n    align-content: normal !important;\n}\n\n.k-align-content-stretch {\n    align-content: stretch;\n}\n\n.\\!k-align-content-stretch {\n    align-content: stretch !important;\n}\n\n.k-align-content-center {\n    align-content: center;\n}\n\n.\\!k-align-content-center {\n    align-content: center !important;\n}\n\n.k-align-content-start {\n    align-content: start;\n}\n\n.\\!k-align-content-start {\n    align-content: start !important;\n}\n\n.k-align-content-end {\n    align-content: end;\n}\n\n.\\!k-align-content-end {\n    align-content: end !important;\n}\n\n.k-align-content-flex-start {\n    align-content: flex-start;\n}\n\n.\\!k-align-content-flex-start {\n    align-content: flex-start !important;\n}\n\n.k-align-content-flex-end {\n    align-content: flex-end;\n}\n\n.\\!k-align-content-flex-end {\n    align-content: flex-end !important;\n}\n\n.k-align-content-baseline {\n    align-content: baseline;\n}\n\n.\\!k-align-content-baseline {\n    align-content: baseline !important;\n}\n\n.k-align-content-first-baseline {\n    align-content: first baseline;\n}\n\n.\\!k-align-content-first-baseline {\n    align-content: first baseline !important;\n}\n\n.k-align-content-last-baseline {\n    align-content: last baseline;\n}\n\n.\\!k-align-content-last-baseline {\n    align-content: last baseline !important;\n}\n\n.k-align-content-between {\n    align-content: space-between;\n}\n\n.\\!k-align-content-between {\n    align-content: space-between !important;\n}\n\n.k-align-content-around {\n    align-content: space-around;\n}\n\n.\\!k-align-content-around {\n    align-content: space-around !important;\n}\n\n.k-align-content-evenly {\n    align-content: space-evenly;\n}\n\n.\\!k-align-content-evenly {\n    align-content: space-evenly !important;\n}\n\n.k-align-items-normal {\n    align-items: normal;\n}\n\n.\\!k-align-items-normal {\n    align-items: normal !important;\n}\n\n.k-align-items-stretch {\n    align-items: stretch;\n}\n\n.\\!k-align-items-stretch {\n    align-items: stretch !important;\n}\n\n.k-align-items-center {\n    align-items: center;\n}\n\n.\\!k-align-items-center {\n    align-items: center !important;\n}\n\n.k-align-items-start {\n    align-items: start;\n}\n\n.\\!k-align-items-start {\n    align-items: start !important;\n}\n\n.k-align-items-end {\n    align-items: end;\n}\n\n.\\!k-align-items-end {\n    align-items: end !important;\n}\n\n.k-align-items-flex-start {\n    align-items: flex-start;\n}\n\n.\\!k-align-items-flex-start {\n    align-items: flex-start !important;\n}\n\n.k-align-items-flex-end {\n    align-items: flex-end;\n}\n\n.\\!k-align-items-flex-end {\n    align-items: flex-end !important;\n}\n\n.k-align-items-baseline {\n    align-items: baseline;\n}\n\n.\\!k-align-items-baseline {\n    align-items: baseline !important;\n}\n\n.k-align-items-first-baseline {\n    align-items: first baseline;\n}\n\n.\\!k-align-items-first-baseline {\n    align-items: first baseline !important;\n}\n\n.k-align-items-last-baseline {\n    align-items: last baseline;\n}\n\n.\\!k-align-items-last-baseline {\n    align-items: last baseline !important;\n}\n\n.k-align-items-self-start {\n    align-items: self-start;\n}\n\n.\\!k-align-items-self-start {\n    align-items: self-start !important;\n}\n\n.k-align-items-self-end {\n    align-items: self-end;\n}\n\n.\\!k-align-items-self-end {\n    align-items: self-end !important;\n}\n\n.k-align-self-auto {\n    align-self: auto;\n}\n\n.\\!k-align-self-auto {\n    align-self: auto !important;\n}\n\n.k-align-self-normal {\n    align-self: normal;\n}\n\n.\\!k-align-self-normal {\n    align-self: normal !important;\n}\n\n.k-align-self-stretch {\n    align-self: stretch;\n}\n\n.\\!k-align-self-stretch {\n    align-self: stretch !important;\n}\n\n.k-align-self-center {\n    align-self: center;\n}\n\n.\\!k-align-self-center {\n    align-self: center !important;\n}\n\n.k-align-self-start {\n    align-self: start;\n}\n\n.\\!k-align-self-start {\n    align-self: start !important;\n}\n\n.k-align-self-end {\n    align-self: end;\n}\n\n.\\!k-align-self-end {\n    align-self: end !important;\n}\n\n.k-align-self-flex-start {\n    align-self: flex-start;\n}\n\n.\\!k-align-self-flex-start {\n    align-self: flex-start !important;\n}\n\n.k-align-self-flex-end {\n    align-self: flex-end;\n}\n\n.\\!k-align-self-flex-end {\n    align-self: flex-end !important;\n}\n\n.k-align-self-baseline {\n    align-self: baseline;\n}\n\n.\\!k-align-self-baseline {\n    align-self: baseline !important;\n}\n\n.k-align-self-first-baseline {\n    align-self: first baseline;\n}\n\n.\\!k-align-self-first-baseline {\n    align-self: first baseline !important;\n}\n\n.k-align-self-last-baseline {\n    align-self: last baseline;\n}\n\n.\\!k-align-self-last-baseline {\n    align-self: last baseline !important;\n}\n\n.k-align-self-self-start {\n    align-self: self-start;\n}\n\n.\\!k-align-self-self-start {\n    align-self: self-start !important;\n}\n\n.k-align-self-self-end {\n    align-self: self-end;\n}\n\n.\\!k-align-self-self-end {\n    align-self: self-end !important;\n}\n\n.k-basis-0 {\n    flex-basis: 0;\n}\n\n.\\!k-basis-0 {\n    flex-basis: 0 !important;\n}\n\n.k-basis-1px {\n    flex-basis: 1px;\n}\n\n.\\!k-basis-1px {\n    flex-basis: 1px !important;\n}\n\n.k-basis-0\\.5 {\n    flex-basis: 0.125rem;\n}\n\n.\\!k-basis-0\\.5 {\n    flex-basis: 0.125rem !important;\n}\n\n.k-basis-1 {\n    flex-basis: 0.25rem;\n}\n\n.\\!k-basis-1 {\n    flex-basis: 0.25rem !important;\n}\n\n.k-basis-1\\.5 {\n    flex-basis: 0.375rem;\n}\n\n.\\!k-basis-1\\.5 {\n    flex-basis: 0.375rem !important;\n}\n\n.k-basis-2 {\n    flex-basis: 0.5rem;\n}\n\n.\\!k-basis-2 {\n    flex-basis: 0.5rem !important;\n}\n\n.k-basis-2\\.5 {\n    flex-basis: 0.625rem;\n}\n\n.\\!k-basis-2\\.5 {\n    flex-basis: 0.625rem !important;\n}\n\n.k-basis-3 {\n    flex-basis: 0.75rem;\n}\n\n.\\!k-basis-3 {\n    flex-basis: 0.75rem !important;\n}\n\n.k-basis-3\\.5 {\n    flex-basis: 0.875rem;\n}\n\n.\\!k-basis-3\\.5 {\n    flex-basis: 0.875rem !important;\n}\n\n.k-basis-4 {\n    flex-basis: 1rem;\n}\n\n.\\!k-basis-4 {\n    flex-basis: 1rem !important;\n}\n\n.k-basis-4\\.5 {\n    flex-basis: 1.125rem;\n}\n\n.\\!k-basis-4\\.5 {\n    flex-basis: 1.125rem !important;\n}\n\n.k-basis-5 {\n    flex-basis: 1.25rem;\n}\n\n.\\!k-basis-5 {\n    flex-basis: 1.25rem !important;\n}\n\n.k-basis-5\\.5 {\n    flex-basis: 1.375rem;\n}\n\n.\\!k-basis-5\\.5 {\n    flex-basis: 1.375rem !important;\n}\n\n.k-basis-6 {\n    flex-basis: 1.5rem;\n}\n\n.\\!k-basis-6 {\n    flex-basis: 1.5rem !important;\n}\n\n.k-basis-6\\.5 {\n    flex-basis: 1.625rem;\n}\n\n.\\!k-basis-6\\.5 {\n    flex-basis: 1.625rem !important;\n}\n\n.k-basis-7 {\n    flex-basis: 1.75rem;\n}\n\n.\\!k-basis-7 {\n    flex-basis: 1.75rem !important;\n}\n\n.k-basis-7\\.5 {\n    flex-basis: 1.875rem;\n}\n\n.\\!k-basis-7\\.5 {\n    flex-basis: 1.875rem !important;\n}\n\n.k-basis-8 {\n    flex-basis: 2rem;\n}\n\n.\\!k-basis-8 {\n    flex-basis: 2rem !important;\n}\n\n.k-basis-9 {\n    flex-basis: 2.25rem;\n}\n\n.\\!k-basis-9 {\n    flex-basis: 2.25rem !important;\n}\n\n.k-basis-10 {\n    flex-basis: 2.5rem;\n}\n\n.\\!k-basis-10 {\n    flex-basis: 2.5rem !important;\n}\n\n.k-basis-11 {\n    flex-basis: 2.75rem;\n}\n\n.\\!k-basis-11 {\n    flex-basis: 2.75rem !important;\n}\n\n.k-basis-12 {\n    flex-basis: 3rem;\n}\n\n.\\!k-basis-12 {\n    flex-basis: 3rem !important;\n}\n\n.k-basis-13 {\n    flex-basis: 3.25rem;\n}\n\n.\\!k-basis-13 {\n    flex-basis: 3.25rem !important;\n}\n\n.k-basis-14 {\n    flex-basis: 3.5rem;\n}\n\n.\\!k-basis-14 {\n    flex-basis: 3.5rem !important;\n}\n\n.k-basis-15 {\n    flex-basis: 3.75rem;\n}\n\n.\\!k-basis-15 {\n    flex-basis: 3.75rem !important;\n}\n\n.k-basis-16 {\n    flex-basis: 4rem;\n}\n\n.\\!k-basis-16 {\n    flex-basis: 4rem !important;\n}\n\n.k-basis-17 {\n    flex-basis: 4.25rem;\n}\n\n.\\!k-basis-17 {\n    flex-basis: 4.25rem !important;\n}\n\n.k-basis-18 {\n    flex-basis: 4.5rem;\n}\n\n.\\!k-basis-18 {\n    flex-basis: 4.5rem !important;\n}\n\n.k-basis-19 {\n    flex-basis: 4.75rem;\n}\n\n.\\!k-basis-19 {\n    flex-basis: 4.75rem !important;\n}\n\n.k-basis-20 {\n    flex-basis: 5rem;\n}\n\n.\\!k-basis-20 {\n    flex-basis: 5rem !important;\n}\n\n.k-basis-21 {\n    flex-basis: 5.25rem;\n}\n\n.\\!k-basis-21 {\n    flex-basis: 5.25rem !important;\n}\n\n.k-basis-22 {\n    flex-basis: 5.5rem;\n}\n\n.\\!k-basis-22 {\n    flex-basis: 5.5rem !important;\n}\n\n.k-basis-23 {\n    flex-basis: 5.75rem;\n}\n\n.\\!k-basis-23 {\n    flex-basis: 5.75rem !important;\n}\n\n.k-basis-24 {\n    flex-basis: 6rem;\n}\n\n.\\!k-basis-24 {\n    flex-basis: 6rem !important;\n}\n\n.k-basis-auto {\n    flex-basis: auto;\n}\n\n.\\!k-basis-auto {\n    flex-basis: auto !important;\n}\n\n.k-basis-1\\/2 {\n    flex-basis: 50%;\n}\n\n.\\!k-basis-1\\/2 {\n    flex-basis: 50% !important;\n}\n\n.k-basis-1\\/3 {\n    flex-basis: 33.333333%;\n}\n\n.\\!k-basis-1\\/3 {\n    flex-basis: 33.333333% !important;\n}\n\n.k-basis-2\\/3 {\n    flex-basis: 66.666667%;\n}\n\n.\\!k-basis-2\\/3 {\n    flex-basis: 66.666667% !important;\n}\n\n.k-basis-1\\/4 {\n    flex-basis: 25%;\n}\n\n.\\!k-basis-1\\/4 {\n    flex-basis: 25% !important;\n}\n\n.k-basis-2\\/4 {\n    flex-basis: 50%;\n}\n\n.\\!k-basis-2\\/4 {\n    flex-basis: 50% !important;\n}\n\n.k-basis-3\\/4 {\n    flex-basis: 75%;\n}\n\n.\\!k-basis-3\\/4 {\n    flex-basis: 75% !important;\n}\n\n.k-basis-1\\/5 {\n    flex-basis: 20%;\n}\n\n.\\!k-basis-1\\/5 {\n    flex-basis: 20% !important;\n}\n\n.k-basis-2\\/5 {\n    flex-basis: 40%;\n}\n\n.\\!k-basis-2\\/5 {\n    flex-basis: 40% !important;\n}\n\n.k-basis-3\\/5 {\n    flex-basis: 60%;\n}\n\n.\\!k-basis-3\\/5 {\n    flex-basis: 60% !important;\n}\n\n.k-basis-4\\/5 {\n    flex-basis: 80%;\n}\n\n.\\!k-basis-4\\/5 {\n    flex-basis: 80% !important;\n}\n\n.k-basis-1\\/6 {\n    flex-basis: 16.666667%;\n}\n\n.\\!k-basis-1\\/6 {\n    flex-basis: 16.666667% !important;\n}\n\n.k-basis-2\\/6 {\n    flex-basis: 33.333333%;\n}\n\n.\\!k-basis-2\\/6 {\n    flex-basis: 33.333333% !important;\n}\n\n.k-basis-3\\/6 {\n    flex-basis: 50%;\n}\n\n.\\!k-basis-3\\/6 {\n    flex-basis: 50% !important;\n}\n\n.k-basis-4\\/6 {\n    flex-basis: 66.666667%;\n}\n\n.\\!k-basis-4\\/6 {\n    flex-basis: 66.666667% !important;\n}\n\n.k-basis-5\\/6 {\n    flex-basis: 83.333333%;\n}\n\n.\\!k-basis-5\\/6 {\n    flex-basis: 83.333333% !important;\n}\n\n.k-basis-1\\/12 {\n    flex-basis: 8.333333%;\n}\n\n.\\!k-basis-1\\/12 {\n    flex-basis: 8.333333% !important;\n}\n\n.k-basis-2\\/12 {\n    flex-basis: 16.666667%;\n}\n\n.\\!k-basis-2\\/12 {\n    flex-basis: 16.666667% !important;\n}\n\n.k-basis-3\\/12 {\n    flex-basis: 25%;\n}\n\n.\\!k-basis-3\\/12 {\n    flex-basis: 25% !important;\n}\n\n.k-basis-4\\/12 {\n    flex-basis: 33.333333%;\n}\n\n.\\!k-basis-4\\/12 {\n    flex-basis: 33.333333% !important;\n}\n\n.k-basis-5\\/12 {\n    flex-basis: 41.666667%;\n}\n\n.\\!k-basis-5\\/12 {\n    flex-basis: 41.666667% !important;\n}\n\n.k-basis-6\\/12 {\n    flex-basis: 50%;\n}\n\n.\\!k-basis-6\\/12 {\n    flex-basis: 50% !important;\n}\n\n.k-basis-7\\/12 {\n    flex-basis: 58.333333%;\n}\n\n.\\!k-basis-7\\/12 {\n    flex-basis: 58.333333% !important;\n}\n\n.k-basis-8\\/12 {\n    flex-basis: 66.666667%;\n}\n\n.\\!k-basis-8\\/12 {\n    flex-basis: 66.666667% !important;\n}\n\n.k-basis-9\\/12 {\n    flex-basis: 75%;\n}\n\n.\\!k-basis-9\\/12 {\n    flex-basis: 75% !important;\n}\n\n.k-basis-10\\/12 {\n    flex-basis: 83.333333%;\n}\n\n.\\!k-basis-10\\/12 {\n    flex-basis: 83.333333% !important;\n}\n\n.k-basis-11\\/12 {\n    flex-basis: 91.666667%;\n}\n\n.\\!k-basis-11\\/12 {\n    flex-basis: 91.666667% !important;\n}\n\n.k-basis-full {\n    flex-basis: 100%;\n}\n\n.\\!k-basis-full {\n    flex-basis: 100% !important;\n}\n\n.k-basis-min {\n    flex-basis: min-content;\n}\n\n.\\!k-basis-min {\n    flex-basis: min-content !important;\n}\n\n.k-basis-max {\n    flex-basis: max-content;\n}\n\n.\\!k-basis-max {\n    flex-basis: max-content !important;\n}\n\n.k-basis-fit {\n    flex-basis: fit-content;\n}\n\n.\\!k-basis-fit {\n    flex-basis: fit-content !important;\n}\n\n.k-flex-basis-0 {\n    flex-basis: 0;\n}\n\n.\\!k-flex-basis-0 {\n    flex-basis: 0 !important;\n}\n\n.k-flex-basis-1px {\n    flex-basis: 1px;\n}\n\n.\\!k-flex-basis-1px {\n    flex-basis: 1px !important;\n}\n\n.k-flex-basis-0\\.5 {\n    flex-basis: 0.125rem;\n}\n\n.\\!k-flex-basis-0\\.5 {\n    flex-basis: 0.125rem !important;\n}\n\n.k-flex-basis-1 {\n    flex-basis: 0.25rem;\n}\n\n.\\!k-flex-basis-1 {\n    flex-basis: 0.25rem !important;\n}\n\n.k-flex-basis-1\\.5 {\n    flex-basis: 0.375rem;\n}\n\n.\\!k-flex-basis-1\\.5 {\n    flex-basis: 0.375rem !important;\n}\n\n.k-flex-basis-2 {\n    flex-basis: 0.5rem;\n}\n\n.\\!k-flex-basis-2 {\n    flex-basis: 0.5rem !important;\n}\n\n.k-flex-basis-2\\.5 {\n    flex-basis: 0.625rem;\n}\n\n.\\!k-flex-basis-2\\.5 {\n    flex-basis: 0.625rem !important;\n}\n\n.k-flex-basis-3 {\n    flex-basis: 0.75rem;\n}\n\n.\\!k-flex-basis-3 {\n    flex-basis: 0.75rem !important;\n}\n\n.k-flex-basis-3\\.5 {\n    flex-basis: 0.875rem;\n}\n\n.\\!k-flex-basis-3\\.5 {\n    flex-basis: 0.875rem !important;\n}\n\n.k-flex-basis-4 {\n    flex-basis: 1rem;\n}\n\n.\\!k-flex-basis-4 {\n    flex-basis: 1rem !important;\n}\n\n.k-flex-basis-4\\.5 {\n    flex-basis: 1.125rem;\n}\n\n.\\!k-flex-basis-4\\.5 {\n    flex-basis: 1.125rem !important;\n}\n\n.k-flex-basis-5 {\n    flex-basis: 1.25rem;\n}\n\n.\\!k-flex-basis-5 {\n    flex-basis: 1.25rem !important;\n}\n\n.k-flex-basis-5\\.5 {\n    flex-basis: 1.375rem;\n}\n\n.\\!k-flex-basis-5\\.5 {\n    flex-basis: 1.375rem !important;\n}\n\n.k-flex-basis-6 {\n    flex-basis: 1.5rem;\n}\n\n.\\!k-flex-basis-6 {\n    flex-basis: 1.5rem !important;\n}\n\n.k-flex-basis-6\\.5 {\n    flex-basis: 1.625rem;\n}\n\n.\\!k-flex-basis-6\\.5 {\n    flex-basis: 1.625rem !important;\n}\n\n.k-flex-basis-7 {\n    flex-basis: 1.75rem;\n}\n\n.\\!k-flex-basis-7 {\n    flex-basis: 1.75rem !important;\n}\n\n.k-flex-basis-7\\.5 {\n    flex-basis: 1.875rem;\n}\n\n.\\!k-flex-basis-7\\.5 {\n    flex-basis: 1.875rem !important;\n}\n\n.k-flex-basis-8 {\n    flex-basis: 2rem;\n}\n\n.\\!k-flex-basis-8 {\n    flex-basis: 2rem !important;\n}\n\n.k-flex-basis-9 {\n    flex-basis: 2.25rem;\n}\n\n.\\!k-flex-basis-9 {\n    flex-basis: 2.25rem !important;\n}\n\n.k-flex-basis-10 {\n    flex-basis: 2.5rem;\n}\n\n.\\!k-flex-basis-10 {\n    flex-basis: 2.5rem !important;\n}\n\n.k-flex-basis-11 {\n    flex-basis: 2.75rem;\n}\n\n.\\!k-flex-basis-11 {\n    flex-basis: 2.75rem !important;\n}\n\n.k-flex-basis-12 {\n    flex-basis: 3rem;\n}\n\n.\\!k-flex-basis-12 {\n    flex-basis: 3rem !important;\n}\n\n.k-flex-basis-13 {\n    flex-basis: 3.25rem;\n}\n\n.\\!k-flex-basis-13 {\n    flex-basis: 3.25rem !important;\n}\n\n.k-flex-basis-14 {\n    flex-basis: 3.5rem;\n}\n\n.\\!k-flex-basis-14 {\n    flex-basis: 3.5rem !important;\n}\n\n.k-flex-basis-15 {\n    flex-basis: 3.75rem;\n}\n\n.\\!k-flex-basis-15 {\n    flex-basis: 3.75rem !important;\n}\n\n.k-flex-basis-16 {\n    flex-basis: 4rem;\n}\n\n.\\!k-flex-basis-16 {\n    flex-basis: 4rem !important;\n}\n\n.k-flex-basis-17 {\n    flex-basis: 4.25rem;\n}\n\n.\\!k-flex-basis-17 {\n    flex-basis: 4.25rem !important;\n}\n\n.k-flex-basis-18 {\n    flex-basis: 4.5rem;\n}\n\n.\\!k-flex-basis-18 {\n    flex-basis: 4.5rem !important;\n}\n\n.k-flex-basis-19 {\n    flex-basis: 4.75rem;\n}\n\n.\\!k-flex-basis-19 {\n    flex-basis: 4.75rem !important;\n}\n\n.k-flex-basis-20 {\n    flex-basis: 5rem;\n}\n\n.\\!k-flex-basis-20 {\n    flex-basis: 5rem !important;\n}\n\n.k-flex-basis-21 {\n    flex-basis: 5.25rem;\n}\n\n.\\!k-flex-basis-21 {\n    flex-basis: 5.25rem !important;\n}\n\n.k-flex-basis-22 {\n    flex-basis: 5.5rem;\n}\n\n.\\!k-flex-basis-22 {\n    flex-basis: 5.5rem !important;\n}\n\n.k-flex-basis-23 {\n    flex-basis: 5.75rem;\n}\n\n.\\!k-flex-basis-23 {\n    flex-basis: 5.75rem !important;\n}\n\n.k-flex-basis-24 {\n    flex-basis: 6rem;\n}\n\n.\\!k-flex-basis-24 {\n    flex-basis: 6rem !important;\n}\n\n.k-flex-basis-auto {\n    flex-basis: auto;\n}\n\n.\\!k-flex-basis-auto {\n    flex-basis: auto !important;\n}\n\n.k-flex-basis-1\\/2 {\n    flex-basis: 50%;\n}\n\n.\\!k-flex-basis-1\\/2 {\n    flex-basis: 50% !important;\n}\n\n.k-flex-basis-1\\/3 {\n    flex-basis: 33.333333%;\n}\n\n.\\!k-flex-basis-1\\/3 {\n    flex-basis: 33.333333% !important;\n}\n\n.k-flex-basis-2\\/3 {\n    flex-basis: 66.666667%;\n}\n\n.\\!k-flex-basis-2\\/3 {\n    flex-basis: 66.666667% !important;\n}\n\n.k-flex-basis-1\\/4 {\n    flex-basis: 25%;\n}\n\n.\\!k-flex-basis-1\\/4 {\n    flex-basis: 25% !important;\n}\n\n.k-flex-basis-2\\/4 {\n    flex-basis: 50%;\n}\n\n.\\!k-flex-basis-2\\/4 {\n    flex-basis: 50% !important;\n}\n\n.k-flex-basis-3\\/4 {\n    flex-basis: 75%;\n}\n\n.\\!k-flex-basis-3\\/4 {\n    flex-basis: 75% !important;\n}\n\n.k-flex-basis-1\\/5 {\n    flex-basis: 20%;\n}\n\n.\\!k-flex-basis-1\\/5 {\n    flex-basis: 20% !important;\n}\n\n.k-flex-basis-2\\/5 {\n    flex-basis: 40%;\n}\n\n.\\!k-flex-basis-2\\/5 {\n    flex-basis: 40% !important;\n}\n\n.k-flex-basis-3\\/5 {\n    flex-basis: 60%;\n}\n\n.\\!k-flex-basis-3\\/5 {\n    flex-basis: 60% !important;\n}\n\n.k-flex-basis-4\\/5 {\n    flex-basis: 80%;\n}\n\n.\\!k-flex-basis-4\\/5 {\n    flex-basis: 80% !important;\n}\n\n.k-flex-basis-1\\/6 {\n    flex-basis: 16.666667%;\n}\n\n.\\!k-flex-basis-1\\/6 {\n    flex-basis: 16.666667% !important;\n}\n\n.k-flex-basis-2\\/6 {\n    flex-basis: 33.333333%;\n}\n\n.\\!k-flex-basis-2\\/6 {\n    flex-basis: 33.333333% !important;\n}\n\n.k-flex-basis-3\\/6 {\n    flex-basis: 50%;\n}\n\n.\\!k-flex-basis-3\\/6 {\n    flex-basis: 50% !important;\n}\n\n.k-flex-basis-4\\/6 {\n    flex-basis: 66.666667%;\n}\n\n.\\!k-flex-basis-4\\/6 {\n    flex-basis: 66.666667% !important;\n}\n\n.k-flex-basis-5\\/6 {\n    flex-basis: 83.333333%;\n}\n\n.\\!k-flex-basis-5\\/6 {\n    flex-basis: 83.333333% !important;\n}\n\n.k-flex-basis-1\\/12 {\n    flex-basis: 8.333333%;\n}\n\n.\\!k-flex-basis-1\\/12 {\n    flex-basis: 8.333333% !important;\n}\n\n.k-flex-basis-2\\/12 {\n    flex-basis: 16.666667%;\n}\n\n.\\!k-flex-basis-2\\/12 {\n    flex-basis: 16.666667% !important;\n}\n\n.k-flex-basis-3\\/12 {\n    flex-basis: 25%;\n}\n\n.\\!k-flex-basis-3\\/12 {\n    flex-basis: 25% !important;\n}\n\n.k-flex-basis-4\\/12 {\n    flex-basis: 33.333333%;\n}\n\n.\\!k-flex-basis-4\\/12 {\n    flex-basis: 33.333333% !important;\n}\n\n.k-flex-basis-5\\/12 {\n    flex-basis: 41.666667%;\n}\n\n.\\!k-flex-basis-5\\/12 {\n    flex-basis: 41.666667% !important;\n}\n\n.k-flex-basis-6\\/12 {\n    flex-basis: 50%;\n}\n\n.\\!k-flex-basis-6\\/12 {\n    flex-basis: 50% !important;\n}\n\n.k-flex-basis-7\\/12 {\n    flex-basis: 58.333333%;\n}\n\n.\\!k-flex-basis-7\\/12 {\n    flex-basis: 58.333333% !important;\n}\n\n.k-flex-basis-8\\/12 {\n    flex-basis: 66.666667%;\n}\n\n.\\!k-flex-basis-8\\/12 {\n    flex-basis: 66.666667% !important;\n}\n\n.k-flex-basis-9\\/12 {\n    flex-basis: 75%;\n}\n\n.\\!k-flex-basis-9\\/12 {\n    flex-basis: 75% !important;\n}\n\n.k-flex-basis-10\\/12 {\n    flex-basis: 83.333333%;\n}\n\n.\\!k-flex-basis-10\\/12 {\n    flex-basis: 83.333333% !important;\n}\n\n.k-flex-basis-11\\/12 {\n    flex-basis: 91.666667%;\n}\n\n.\\!k-flex-basis-11\\/12 {\n    flex-basis: 91.666667% !important;\n}\n\n.k-flex-basis-full {\n    flex-basis: 100%;\n}\n\n.\\!k-flex-basis-full {\n    flex-basis: 100% !important;\n}\n\n.k-flex-basis-min {\n    flex-basis: min-content;\n}\n\n.\\!k-flex-basis-min {\n    flex-basis: min-content !important;\n}\n\n.k-flex-basis-max {\n    flex-basis: max-content;\n}\n\n.\\!k-flex-basis-max {\n    flex-basis: max-content !important;\n}\n\n.k-flex-basis-fit {\n    flex-basis: fit-content;\n}\n\n.\\!k-flex-basis-fit {\n    flex-basis: fit-content !important;\n}\n\n.k-flex-row, .k-d-flex-row {\n    flex-direction: row;\n}\n\n.\\!k-flex-row, .\\!k-d-flex-row, .\\!k-d-flex-col {\n    flex-direction: row !important;\n}\n\n.k-flex-row-reverse {\n    flex-direction: row-reverse;\n}\n\n.\\!k-flex-row-reverse {\n    flex-direction: row-reverse !important;\n}\n\n.k-flex-col, .k-d-flex-col, .k-flex-column {\n    flex-direction: column;\n}\n\n.\\!k-flex-col {\n    flex-direction: column !important;\n}\n\n.k-flex-col-reverse, .k-flex-column-reverse {\n    flex-direction: column-reverse;\n}\n\n.\\!k-flex-col-reverse {\n    flex-direction: column-reverse !important;\n}\n\n.k-grow {\n    flex-grow: 1;\n}\n\n.\\!k-grow {\n    flex-grow: 1 !important;\n}\n\n.k-grow-0 {\n    flex-grow: 0;\n}\n\n.\\!k-grow-0 {\n    flex-grow: 0 !important;\n}\n\n.k-flex-grow {\n    flex-grow: 1;\n}\n\n.\\!k-flex-grow {\n    flex-grow: 1 !important;\n}\n\n.k-flex-grow-0 {\n    flex-grow: 0;\n}\n\n.\\!k-flex-grow-0 {\n    flex-grow: 0 !important;\n}\n\n.k-shrink {\n    flex-shrink: 1;\n}\n\n.\\!k-shrink {\n    flex-shrink: 1 !important;\n}\n\n.k-shrink-0 {\n    flex-shrink: 0;\n}\n\n.\\!k-shrink-0 {\n    flex-shrink: 0 !important;\n}\n\n.k-flex-shrink {\n    flex-shrink: 1;\n}\n\n.\\!k-flex-shrink {\n    flex-shrink: 1 !important;\n}\n\n.k-flex-shrink-0 {\n    flex-shrink: 0;\n}\n\n.\\!k-flex-shrink-0 {\n    flex-shrink: 0 !important;\n}\n\n.k-flex-wrap {\n    flex-wrap: wrap;\n}\n\n.\\!k-flex-wrap {\n    flex-wrap: wrap !important;\n}\n\n.k-flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n}\n\n.\\!k-flex-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n}\n\n.k-flex-nowrap {\n    flex-wrap: nowrap;\n}\n\n.\\!k-flex-nowrap {\n    flex-wrap: nowrap !important;\n}\n\n.k-flex-1 {\n    flex: 1 1 0%;\n}\n\n.\\!k-flex-1 {\n    flex: 1 1 0% !important;\n}\n\n.k-flex-auto {\n    flex: 1 1 auto;\n}\n\n.\\!k-flex-auto {\n    flex: 1 1 auto !important;\n}\n\n.k-flex-initial {\n    flex: 0 1 auto;\n}\n\n.\\!k-flex-initial {\n    flex: 0 1 auto !important;\n}\n\n.k-flex-none {\n    flex: none;\n}\n\n.\\!k-flex-none {\n    flex: none !important;\n}\n\n.k-gap-0 {\n    gap: 0;\n}\n\n.\\!k-gap-0 {\n    gap: 0 !important;\n}\n\n.k-gap-1px {\n    gap: 1px;\n}\n\n.\\!k-gap-1px {\n    gap: 1px !important;\n}\n\n.k-gap-0\\.5 {\n    gap: 0.125rem;\n}\n\n.\\!k-gap-0\\.5 {\n    gap: 0.125rem !important;\n}\n\n.k-gap-1 {\n    gap: 0.25rem;\n}\n\n.\\!k-gap-1 {\n    gap: 0.25rem !important;\n}\n\n.k-gap-1\\.5 {\n    gap: 0.375rem;\n}\n\n.\\!k-gap-1\\.5 {\n    gap: 0.375rem !important;\n}\n\n.k-gap-2 {\n    gap: 0.5rem;\n}\n\n.\\!k-gap-2 {\n    gap: 0.5rem !important;\n}\n\n.k-gap-2\\.5 {\n    gap: 0.625rem;\n}\n\n.\\!k-gap-2\\.5 {\n    gap: 0.625rem !important;\n}\n\n.k-gap-3 {\n    gap: 0.75rem;\n}\n\n.\\!k-gap-3 {\n    gap: 0.75rem !important;\n}\n\n.k-gap-3\\.5 {\n    gap: 0.875rem;\n}\n\n.\\!k-gap-3\\.5 {\n    gap: 0.875rem !important;\n}\n\n.k-gap-4 {\n    gap: 1rem;\n}\n\n.\\!k-gap-4 {\n    gap: 1rem !important;\n}\n\n.k-gap-4\\.5 {\n    gap: 1.125rem;\n}\n\n.\\!k-gap-4\\.5 {\n    gap: 1.125rem !important;\n}\n\n.k-gap-5 {\n    gap: 1.25rem;\n}\n\n.\\!k-gap-5 {\n    gap: 1.25rem !important;\n}\n\n.k-gap-5\\.5 {\n    gap: 1.375rem;\n}\n\n.\\!k-gap-5\\.5 {\n    gap: 1.375rem !important;\n}\n\n.k-gap-6 {\n    gap: 1.5rem;\n}\n\n.\\!k-gap-6 {\n    gap: 1.5rem !important;\n}\n\n.k-gap-6\\.5 {\n    gap: 1.625rem;\n}\n\n.\\!k-gap-6\\.5 {\n    gap: 1.625rem !important;\n}\n\n.k-gap-7 {\n    gap: 1.75rem;\n}\n\n.\\!k-gap-7 {\n    gap: 1.75rem !important;\n}\n\n.k-gap-7\\.5 {\n    gap: 1.875rem;\n}\n\n.\\!k-gap-7\\.5 {\n    gap: 1.875rem !important;\n}\n\n.k-gap-8 {\n    gap: 2rem;\n}\n\n.\\!k-gap-8 {\n    gap: 2rem !important;\n}\n\n.k-gap-9 {\n    gap: 2.25rem;\n}\n\n.\\!k-gap-9 {\n    gap: 2.25rem !important;\n}\n\n.k-gap-10 {\n    gap: 2.5rem;\n}\n\n.\\!k-gap-10 {\n    gap: 2.5rem !important;\n}\n\n.k-gap-11 {\n    gap: 2.75rem;\n}\n\n.\\!k-gap-11 {\n    gap: 2.75rem !important;\n}\n\n.k-gap-12 {\n    gap: 3rem;\n}\n\n.\\!k-gap-12 {\n    gap: 3rem !important;\n}\n\n.k-gap-13 {\n    gap: 3.25rem;\n}\n\n.\\!k-gap-13 {\n    gap: 3.25rem !important;\n}\n\n.k-gap-14 {\n    gap: 3.5rem;\n}\n\n.\\!k-gap-14 {\n    gap: 3.5rem !important;\n}\n\n.k-gap-15 {\n    gap: 3.75rem;\n}\n\n.\\!k-gap-15 {\n    gap: 3.75rem !important;\n}\n\n.k-gap-16 {\n    gap: 4rem;\n}\n\n.\\!k-gap-16 {\n    gap: 4rem !important;\n}\n\n.k-gap-17 {\n    gap: 4.25rem;\n}\n\n.\\!k-gap-17 {\n    gap: 4.25rem !important;\n}\n\n.k-gap-18 {\n    gap: 4.5rem;\n}\n\n.\\!k-gap-18 {\n    gap: 4.5rem !important;\n}\n\n.k-gap-19 {\n    gap: 4.75rem;\n}\n\n.\\!k-gap-19 {\n    gap: 4.75rem !important;\n}\n\n.k-gap-20 {\n    gap: 5rem;\n}\n\n.\\!k-gap-20 {\n    gap: 5rem !important;\n}\n\n.k-gap-21 {\n    gap: 5.25rem;\n}\n\n.\\!k-gap-21 {\n    gap: 5.25rem !important;\n}\n\n.k-gap-22 {\n    gap: 5.5rem;\n}\n\n.\\!k-gap-22 {\n    gap: 5.5rem !important;\n}\n\n.k-gap-23 {\n    gap: 5.75rem;\n}\n\n.\\!k-gap-23 {\n    gap: 5.75rem !important;\n}\n\n.k-gap-24 {\n    gap: 6rem;\n}\n\n.\\!k-gap-24 {\n    gap: 6rem !important;\n}\n\n.k-gap-xs {\n    gap: 0.25rem;\n}\n\n.\\!k-gap-xs {\n    gap: 0.25rem !important;\n}\n\n.k-gap-sm {\n    gap: 0.5rem;\n}\n\n.\\!k-gap-sm {\n    gap: 0.5rem !important;\n}\n\n.k-gap-md {\n    gap: 0.75rem;\n}\n\n.\\!k-gap-md {\n    gap: 0.75rem !important;\n}\n\n.k-gap-lg {\n    gap: 1rem;\n}\n\n.\\!k-gap-lg {\n    gap: 1rem !important;\n}\n\n.k-gap-xl {\n    gap: 1.5rem;\n}\n\n.\\!k-gap-xl {\n    gap: 1.5rem !important;\n}\n\n.k-gap-thin {\n    gap: 0.125rem;\n}\n\n.\\!k-gap-thin {\n    gap: 0.125rem !important;\n}\n\n.k-gap-hair {\n    gap: 1px;\n}\n\n.\\!k-gap-hair {\n    gap: 1px !important;\n}\n\n.k-gap-x-0 {\n    column-gap: 0;\n}\n\n.\\!k-gap-x-0 {\n    column-gap: 0 !important;\n}\n\n.k-gap-x-1px {\n    column-gap: 1px;\n}\n\n.\\!k-gap-x-1px {\n    column-gap: 1px !important;\n}\n\n.k-gap-x-0\\.5 {\n    column-gap: 0.125rem;\n}\n\n.\\!k-gap-x-0\\.5 {\n    column-gap: 0.125rem !important;\n}\n\n.k-gap-x-1 {\n    column-gap: 0.25rem;\n}\n\n.\\!k-gap-x-1 {\n    column-gap: 0.25rem !important;\n}\n\n.k-gap-x-1\\.5 {\n    column-gap: 0.375rem;\n}\n\n.\\!k-gap-x-1\\.5 {\n    column-gap: 0.375rem !important;\n}\n\n.k-gap-x-2 {\n    column-gap: 0.5rem;\n}\n\n.\\!k-gap-x-2 {\n    column-gap: 0.5rem !important;\n}\n\n.k-gap-x-2\\.5 {\n    column-gap: 0.625rem;\n}\n\n.\\!k-gap-x-2\\.5 {\n    column-gap: 0.625rem !important;\n}\n\n.k-gap-x-3 {\n    column-gap: 0.75rem;\n}\n\n.\\!k-gap-x-3 {\n    column-gap: 0.75rem !important;\n}\n\n.k-gap-x-3\\.5 {\n    column-gap: 0.875rem;\n}\n\n.\\!k-gap-x-3\\.5 {\n    column-gap: 0.875rem !important;\n}\n\n.k-gap-x-4 {\n    column-gap: 1rem;\n}\n\n.\\!k-gap-x-4 {\n    column-gap: 1rem !important;\n}\n\n.k-gap-x-4\\.5 {\n    column-gap: 1.125rem;\n}\n\n.\\!k-gap-x-4\\.5 {\n    column-gap: 1.125rem !important;\n}\n\n.k-gap-x-5 {\n    column-gap: 1.25rem;\n}\n\n.\\!k-gap-x-5 {\n    column-gap: 1.25rem !important;\n}\n\n.k-gap-x-5\\.5 {\n    column-gap: 1.375rem;\n}\n\n.\\!k-gap-x-5\\.5 {\n    column-gap: 1.375rem !important;\n}\n\n.k-gap-x-6 {\n    column-gap: 1.5rem;\n}\n\n.\\!k-gap-x-6 {\n    column-gap: 1.5rem !important;\n}\n\n.k-gap-x-6\\.5 {\n    column-gap: 1.625rem;\n}\n\n.\\!k-gap-x-6\\.5 {\n    column-gap: 1.625rem !important;\n}\n\n.k-gap-x-7 {\n    column-gap: 1.75rem;\n}\n\n.\\!k-gap-x-7 {\n    column-gap: 1.75rem !important;\n}\n\n.k-gap-x-7\\.5 {\n    column-gap: 1.875rem;\n}\n\n.\\!k-gap-x-7\\.5 {\n    column-gap: 1.875rem !important;\n}\n\n.k-gap-x-8 {\n    column-gap: 2rem;\n}\n\n.\\!k-gap-x-8 {\n    column-gap: 2rem !important;\n}\n\n.k-gap-x-9 {\n    column-gap: 2.25rem;\n}\n\n.\\!k-gap-x-9 {\n    column-gap: 2.25rem !important;\n}\n\n.k-gap-x-10 {\n    column-gap: 2.5rem;\n}\n\n.\\!k-gap-x-10 {\n    column-gap: 2.5rem !important;\n}\n\n.k-gap-x-11 {\n    column-gap: 2.75rem;\n}\n\n.\\!k-gap-x-11 {\n    column-gap: 2.75rem !important;\n}\n\n.k-gap-x-12 {\n    column-gap: 3rem;\n}\n\n.\\!k-gap-x-12 {\n    column-gap: 3rem !important;\n}\n\n.k-gap-x-13 {\n    column-gap: 3.25rem;\n}\n\n.\\!k-gap-x-13 {\n    column-gap: 3.25rem !important;\n}\n\n.k-gap-x-14 {\n    column-gap: 3.5rem;\n}\n\n.\\!k-gap-x-14 {\n    column-gap: 3.5rem !important;\n}\n\n.k-gap-x-15 {\n    column-gap: 3.75rem;\n}\n\n.\\!k-gap-x-15 {\n    column-gap: 3.75rem !important;\n}\n\n.k-gap-x-16 {\n    column-gap: 4rem;\n}\n\n.\\!k-gap-x-16 {\n    column-gap: 4rem !important;\n}\n\n.k-gap-x-17 {\n    column-gap: 4.25rem;\n}\n\n.\\!k-gap-x-17 {\n    column-gap: 4.25rem !important;\n}\n\n.k-gap-x-18 {\n    column-gap: 4.5rem;\n}\n\n.\\!k-gap-x-18 {\n    column-gap: 4.5rem !important;\n}\n\n.k-gap-x-19 {\n    column-gap: 4.75rem;\n}\n\n.\\!k-gap-x-19 {\n    column-gap: 4.75rem !important;\n}\n\n.k-gap-x-20 {\n    column-gap: 5rem;\n}\n\n.\\!k-gap-x-20 {\n    column-gap: 5rem !important;\n}\n\n.k-gap-x-21 {\n    column-gap: 5.25rem;\n}\n\n.\\!k-gap-x-21 {\n    column-gap: 5.25rem !important;\n}\n\n.k-gap-x-22 {\n    column-gap: 5.5rem;\n}\n\n.\\!k-gap-x-22 {\n    column-gap: 5.5rem !important;\n}\n\n.k-gap-x-23 {\n    column-gap: 5.75rem;\n}\n\n.\\!k-gap-x-23 {\n    column-gap: 5.75rem !important;\n}\n\n.k-gap-x-24 {\n    column-gap: 6rem;\n}\n\n.\\!k-gap-x-24 {\n    column-gap: 6rem !important;\n}\n\n.k-gap-x-xs {\n    column-gap: 0.25rem;\n}\n\n.\\!k-gap-x-xs {\n    column-gap: 0.25rem !important;\n}\n\n.k-gap-x-sm {\n    column-gap: 0.5rem;\n}\n\n.\\!k-gap-x-sm {\n    column-gap: 0.5rem !important;\n}\n\n.k-gap-x-md {\n    column-gap: 0.75rem;\n}\n\n.\\!k-gap-x-md {\n    column-gap: 0.75rem !important;\n}\n\n.k-gap-x-lg {\n    column-gap: 1rem;\n}\n\n.\\!k-gap-x-lg {\n    column-gap: 1rem !important;\n}\n\n.k-gap-x-xl {\n    column-gap: 1.5rem;\n}\n\n.\\!k-gap-x-xl {\n    column-gap: 1.5rem !important;\n}\n\n.k-gap-x-thin {\n    column-gap: 0.125rem;\n}\n\n.\\!k-gap-x-thin {\n    column-gap: 0.125rem !important;\n}\n\n.k-gap-x-hair {\n    column-gap: 1px;\n}\n\n.\\!k-gap-x-hair {\n    column-gap: 1px !important;\n}\n\n.k-gap-y-0 {\n    row-gap: 0;\n}\n\n.\\!k-gap-y-0 {\n    row-gap: 0 !important;\n}\n\n.k-gap-y-1px {\n    row-gap: 1px;\n}\n\n.\\!k-gap-y-1px {\n    row-gap: 1px !important;\n}\n\n.k-gap-y-0\\.5 {\n    row-gap: 0.125rem;\n}\n\n.\\!k-gap-y-0\\.5 {\n    row-gap: 0.125rem !important;\n}\n\n.k-gap-y-1 {\n    row-gap: 0.25rem;\n}\n\n.\\!k-gap-y-1 {\n    row-gap: 0.25rem !important;\n}\n\n.k-gap-y-1\\.5 {\n    row-gap: 0.375rem;\n}\n\n.\\!k-gap-y-1\\.5 {\n    row-gap: 0.375rem !important;\n}\n\n.k-gap-y-2 {\n    row-gap: 0.5rem;\n}\n\n.\\!k-gap-y-2 {\n    row-gap: 0.5rem !important;\n}\n\n.k-gap-y-2\\.5 {\n    row-gap: 0.625rem;\n}\n\n.\\!k-gap-y-2\\.5 {\n    row-gap: 0.625rem !important;\n}\n\n.k-gap-y-3 {\n    row-gap: 0.75rem;\n}\n\n.\\!k-gap-y-3 {\n    row-gap: 0.75rem !important;\n}\n\n.k-gap-y-3\\.5 {\n    row-gap: 0.875rem;\n}\n\n.\\!k-gap-y-3\\.5 {\n    row-gap: 0.875rem !important;\n}\n\n.k-gap-y-4 {\n    row-gap: 1rem;\n}\n\n.\\!k-gap-y-4 {\n    row-gap: 1rem !important;\n}\n\n.k-gap-y-4\\.5 {\n    row-gap: 1.125rem;\n}\n\n.\\!k-gap-y-4\\.5 {\n    row-gap: 1.125rem !important;\n}\n\n.k-gap-y-5 {\n    row-gap: 1.25rem;\n}\n\n.\\!k-gap-y-5 {\n    row-gap: 1.25rem !important;\n}\n\n.k-gap-y-5\\.5 {\n    row-gap: 1.375rem;\n}\n\n.\\!k-gap-y-5\\.5 {\n    row-gap: 1.375rem !important;\n}\n\n.k-gap-y-6 {\n    row-gap: 1.5rem;\n}\n\n.\\!k-gap-y-6 {\n    row-gap: 1.5rem !important;\n}\n\n.k-gap-y-6\\.5 {\n    row-gap: 1.625rem;\n}\n\n.\\!k-gap-y-6\\.5 {\n    row-gap: 1.625rem !important;\n}\n\n.k-gap-y-7 {\n    row-gap: 1.75rem;\n}\n\n.\\!k-gap-y-7 {\n    row-gap: 1.75rem !important;\n}\n\n.k-gap-y-7\\.5 {\n    row-gap: 1.875rem;\n}\n\n.\\!k-gap-y-7\\.5 {\n    row-gap: 1.875rem !important;\n}\n\n.k-gap-y-8 {\n    row-gap: 2rem;\n}\n\n.\\!k-gap-y-8 {\n    row-gap: 2rem !important;\n}\n\n.k-gap-y-9 {\n    row-gap: 2.25rem;\n}\n\n.\\!k-gap-y-9 {\n    row-gap: 2.25rem !important;\n}\n\n.k-gap-y-10 {\n    row-gap: 2.5rem;\n}\n\n.\\!k-gap-y-10 {\n    row-gap: 2.5rem !important;\n}\n\n.k-gap-y-11 {\n    row-gap: 2.75rem;\n}\n\n.\\!k-gap-y-11 {\n    row-gap: 2.75rem !important;\n}\n\n.k-gap-y-12 {\n    row-gap: 3rem;\n}\n\n.\\!k-gap-y-12 {\n    row-gap: 3rem !important;\n}\n\n.k-gap-y-13 {\n    row-gap: 3.25rem;\n}\n\n.\\!k-gap-y-13 {\n    row-gap: 3.25rem !important;\n}\n\n.k-gap-y-14 {\n    row-gap: 3.5rem;\n}\n\n.\\!k-gap-y-14 {\n    row-gap: 3.5rem !important;\n}\n\n.k-gap-y-15 {\n    row-gap: 3.75rem;\n}\n\n.\\!k-gap-y-15 {\n    row-gap: 3.75rem !important;\n}\n\n.k-gap-y-16 {\n    row-gap: 4rem;\n}\n\n.\\!k-gap-y-16 {\n    row-gap: 4rem !important;\n}\n\n.k-gap-y-17 {\n    row-gap: 4.25rem;\n}\n\n.\\!k-gap-y-17 {\n    row-gap: 4.25rem !important;\n}\n\n.k-gap-y-18 {\n    row-gap: 4.5rem;\n}\n\n.\\!k-gap-y-18 {\n    row-gap: 4.5rem !important;\n}\n\n.k-gap-y-19 {\n    row-gap: 4.75rem;\n}\n\n.\\!k-gap-y-19 {\n    row-gap: 4.75rem !important;\n}\n\n.k-gap-y-20 {\n    row-gap: 5rem;\n}\n\n.\\!k-gap-y-20 {\n    row-gap: 5rem !important;\n}\n\n.k-gap-y-21 {\n    row-gap: 5.25rem;\n}\n\n.\\!k-gap-y-21 {\n    row-gap: 5.25rem !important;\n}\n\n.k-gap-y-22 {\n    row-gap: 5.5rem;\n}\n\n.\\!k-gap-y-22 {\n    row-gap: 5.5rem !important;\n}\n\n.k-gap-y-23 {\n    row-gap: 5.75rem;\n}\n\n.\\!k-gap-y-23 {\n    row-gap: 5.75rem !important;\n}\n\n.k-gap-y-24 {\n    row-gap: 6rem;\n}\n\n.\\!k-gap-y-24 {\n    row-gap: 6rem !important;\n}\n\n.k-gap-y-xs {\n    row-gap: 0.25rem;\n}\n\n.\\!k-gap-y-xs {\n    row-gap: 0.25rem !important;\n}\n\n.k-gap-y-sm {\n    row-gap: 0.5rem;\n}\n\n.\\!k-gap-y-sm {\n    row-gap: 0.5rem !important;\n}\n\n.k-gap-y-md {\n    row-gap: 0.75rem;\n}\n\n.\\!k-gap-y-md {\n    row-gap: 0.75rem !important;\n}\n\n.k-gap-y-lg {\n    row-gap: 1rem;\n}\n\n.\\!k-gap-y-lg {\n    row-gap: 1rem !important;\n}\n\n.k-gap-y-xl {\n    row-gap: 1.5rem;\n}\n\n.\\!k-gap-y-xl {\n    row-gap: 1.5rem !important;\n}\n\n.k-gap-y-thin {\n    row-gap: 0.125rem;\n}\n\n.\\!k-gap-y-thin {\n    row-gap: 0.125rem !important;\n}\n\n.k-gap-y-hair {\n    row-gap: 1px;\n}\n\n.\\!k-gap-y-hair {\n    row-gap: 1px !important;\n}\n\n.k-grid-auto-cols-auto {\n    grid-auto-columns: auto;\n}\n\n.\\!k-grid-auto-cols-auto {\n    grid-auto-columns: auto !important;\n}\n\n.k-grid-auto-cols-min {\n    grid-auto-columns: min-content;\n}\n\n.\\!k-grid-auto-cols-min {\n    grid-auto-columns: min-content !important;\n}\n\n.k-grid-auto-cols-max {\n    grid-auto-columns: max-content;\n}\n\n.\\!k-grid-auto-cols-max {\n    grid-auto-columns: max-content !important;\n}\n\n.k-grid-auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n}\n\n.\\!k-grid-auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr) !important;\n}\n\n.k-grid-flow-row {\n    grid-auto-flow: row;\n}\n\n.\\!k-grid-flow-row {\n    grid-auto-flow: row !important;\n}\n\n.k-grid-flow-col {\n    grid-auto-flow: column;\n}\n\n.\\!k-grid-flow-col {\n    grid-auto-flow: column !important;\n}\n\n.k-grid-flow-dense {\n    grid-auto-flow: dense;\n}\n\n.\\!k-grid-flow-dense {\n    grid-auto-flow: dense !important;\n}\n\n.k-grid-flow-row-dense {\n    grid-auto-flow: row dense;\n}\n\n.\\!k-grid-flow-row-dense {\n    grid-auto-flow: row dense !important;\n}\n\n.k-grid-flow-col-dense {\n    grid-auto-flow: column dense;\n}\n\n.\\!k-grid-flow-col-dense {\n    grid-auto-flow: column dense !important;\n}\n\n.k-grid-flow-unset {\n    grid-auto-flow: unset;\n}\n\n.\\!k-grid-flow-unset {\n    grid-auto-flow: unset !important;\n}\n\n.k-grid-auto-rows-auto {\n    grid-auto-rows: auto;\n}\n\n.\\!k-grid-auto-rows-auto {\n    grid-auto-rows: auto !important;\n}\n\n.k-grid-auto-rows-min {\n    grid-auto-rows: min-content;\n}\n\n.\\!k-grid-auto-rows-min {\n    grid-auto-rows: min-content !important;\n}\n\n.k-grid-auto-rows-max {\n    grid-auto-rows: max-content;\n}\n\n.\\!k-grid-auto-rows-max {\n    grid-auto-rows: max-content !important;\n}\n\n.k-grid-auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n}\n\n.\\!k-grid-auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr) !important;\n}\n\n.k-col-start-1 {\n    grid-column-start: 1;\n}\n\n.\\!k-col-start-1 {\n    grid-column-start: 1 !important;\n}\n\n.k-col-start-2 {\n    grid-column-start: 2;\n}\n\n.\\!k-col-start-2 {\n    grid-column-start: 2 !important;\n}\n\n.k-col-start-3 {\n    grid-column-start: 3;\n}\n\n.\\!k-col-start-3 {\n    grid-column-start: 3 !important;\n}\n\n.k-col-start-4 {\n    grid-column-start: 4;\n}\n\n.\\!k-col-start-4 {\n    grid-column-start: 4 !important;\n}\n\n.k-col-start-5 {\n    grid-column-start: 5;\n}\n\n.\\!k-col-start-5 {\n    grid-column-start: 5 !important;\n}\n\n.k-col-start-6 {\n    grid-column-start: 6;\n}\n\n.\\!k-col-start-6 {\n    grid-column-start: 6 !important;\n}\n\n.k-col-start-7 {\n    grid-column-start: 7;\n}\n\n.\\!k-col-start-7 {\n    grid-column-start: 7 !important;\n}\n\n.k-col-start-8 {\n    grid-column-start: 8;\n}\n\n.\\!k-col-start-8 {\n    grid-column-start: 8 !important;\n}\n\n.k-col-start-9 {\n    grid-column-start: 9;\n}\n\n.\\!k-col-start-9 {\n    grid-column-start: 9 !important;\n}\n\n.k-col-start-10 {\n    grid-column-start: 10;\n}\n\n.\\!k-col-start-10 {\n    grid-column-start: 10 !important;\n}\n\n.k-col-start-11 {\n    grid-column-start: 11;\n}\n\n.\\!k-col-start-11 {\n    grid-column-start: 11 !important;\n}\n\n.k-col-start-12 {\n    grid-column-start: 12;\n}\n\n.\\!k-col-start-12 {\n    grid-column-start: 12 !important;\n}\n\n.k-col-start-13 {\n    grid-column-start: 13;\n}\n\n.\\!k-col-start-13 {\n    grid-column-start: 13 !important;\n}\n\n.k-col-start--1 {\n    grid-column-start: -1;\n}\n\n.\\!k-col-start--1 {\n    grid-column-start: -1 !important;\n}\n\n.k-col-start--2 {\n    grid-column-start: -2;\n}\n\n.\\!k-col-start--2 {\n    grid-column-start: -2 !important;\n}\n\n.k-col-start--3 {\n    grid-column-start: -3;\n}\n\n.\\!k-col-start--3 {\n    grid-column-start: -3 !important;\n}\n\n.k-col-start--4 {\n    grid-column-start: -4;\n}\n\n.\\!k-col-start--4 {\n    grid-column-start: -4 !important;\n}\n\n.k-col-start--5 {\n    grid-column-start: -5;\n}\n\n.\\!k-col-start--5 {\n    grid-column-start: -5 !important;\n}\n\n.k-col-start--6 {\n    grid-column-start: -6;\n}\n\n.\\!k-col-start--6 {\n    grid-column-start: -6 !important;\n}\n\n.k-col-start--7 {\n    grid-column-start: -7;\n}\n\n.\\!k-col-start--7 {\n    grid-column-start: -7 !important;\n}\n\n.k-col-start--8 {\n    grid-column-start: -8;\n}\n\n.\\!k-col-start--8 {\n    grid-column-start: -8 !important;\n}\n\n.k-col-start--9 {\n    grid-column-start: -9;\n}\n\n.\\!k-col-start--9 {\n    grid-column-start: -9 !important;\n}\n\n.k-col-start--10 {\n    grid-column-start: -10;\n}\n\n.\\!k-col-start--10 {\n    grid-column-start: -10 !important;\n}\n\n.k-col-start--11 {\n    grid-column-start: -11;\n}\n\n.\\!k-col-start--11 {\n    grid-column-start: -11 !important;\n}\n\n.k-col-start--12 {\n    grid-column-start: -12;\n}\n\n.\\!k-col-start--12 {\n    grid-column-start: -12 !important;\n}\n\n.k-col-start--13 {\n    grid-column-start: -13;\n}\n\n.\\!k-col-start--13 {\n    grid-column-start: -13 !important;\n}\n\n.k-col-start-auto {\n    grid-column-start: auto;\n}\n\n.\\!k-col-start-auto {\n    grid-column-start: auto !important;\n}\n\n.k-col-end-1 {\n    grid-column-end: 1;\n}\n\n.\\!k-col-end-1 {\n    grid-column-end: 1 !important;\n}\n\n.k-col-end-2 {\n    grid-column-end: 2;\n}\n\n.\\!k-col-end-2 {\n    grid-column-end: 2 !important;\n}\n\n.k-col-end-3 {\n    grid-column-end: 3;\n}\n\n.\\!k-col-end-3 {\n    grid-column-end: 3 !important;\n}\n\n.k-col-end-4 {\n    grid-column-end: 4;\n}\n\n.\\!k-col-end-4 {\n    grid-column-end: 4 !important;\n}\n\n.k-col-end-5 {\n    grid-column-end: 5;\n}\n\n.\\!k-col-end-5 {\n    grid-column-end: 5 !important;\n}\n\n.k-col-end-6 {\n    grid-column-end: 6;\n}\n\n.\\!k-col-end-6 {\n    grid-column-end: 6 !important;\n}\n\n.k-col-end-7 {\n    grid-column-end: 7;\n}\n\n.\\!k-col-end-7 {\n    grid-column-end: 7 !important;\n}\n\n.k-col-end-8 {\n    grid-column-end: 8;\n}\n\n.\\!k-col-end-8 {\n    grid-column-end: 8 !important;\n}\n\n.k-col-end-9 {\n    grid-column-end: 9;\n}\n\n.\\!k-col-end-9 {\n    grid-column-end: 9 !important;\n}\n\n.k-col-end-10 {\n    grid-column-end: 10;\n}\n\n.\\!k-col-end-10 {\n    grid-column-end: 10 !important;\n}\n\n.k-col-end-11 {\n    grid-column-end: 11;\n}\n\n.\\!k-col-end-11 {\n    grid-column-end: 11 !important;\n}\n\n.k-col-end-12 {\n    grid-column-end: 12;\n}\n\n.\\!k-col-end-12 {\n    grid-column-end: 12 !important;\n}\n\n.k-col-end-13 {\n    grid-column-end: 13;\n}\n\n.\\!k-col-end-13 {\n    grid-column-end: 13 !important;\n}\n\n.k-col-end--1 {\n    grid-column-end: -1;\n}\n\n.\\!k-col-end--1 {\n    grid-column-end: -1 !important;\n}\n\n.k-col-end--2 {\n    grid-column-end: -2;\n}\n\n.\\!k-col-end--2 {\n    grid-column-end: -2 !important;\n}\n\n.k-col-end--3 {\n    grid-column-end: -3;\n}\n\n.\\!k-col-end--3 {\n    grid-column-end: -3 !important;\n}\n\n.k-col-end--4 {\n    grid-column-end: -4;\n}\n\n.\\!k-col-end--4 {\n    grid-column-end: -4 !important;\n}\n\n.k-col-end--5 {\n    grid-column-end: -5;\n}\n\n.\\!k-col-end--5 {\n    grid-column-end: -5 !important;\n}\n\n.k-col-end--6 {\n    grid-column-end: -6;\n}\n\n.\\!k-col-end--6 {\n    grid-column-end: -6 !important;\n}\n\n.k-col-end--7 {\n    grid-column-end: -7;\n}\n\n.\\!k-col-end--7 {\n    grid-column-end: -7 !important;\n}\n\n.k-col-end--8 {\n    grid-column-end: -8;\n}\n\n.\\!k-col-end--8 {\n    grid-column-end: -8 !important;\n}\n\n.k-col-end--9 {\n    grid-column-end: -9;\n}\n\n.\\!k-col-end--9 {\n    grid-column-end: -9 !important;\n}\n\n.k-col-end--10 {\n    grid-column-end: -10;\n}\n\n.\\!k-col-end--10 {\n    grid-column-end: -10 !important;\n}\n\n.k-col-end--11 {\n    grid-column-end: -11;\n}\n\n.\\!k-col-end--11 {\n    grid-column-end: -11 !important;\n}\n\n.k-col-end--12 {\n    grid-column-end: -12;\n}\n\n.\\!k-col-end--12 {\n    grid-column-end: -12 !important;\n}\n\n.k-col-end--13 {\n    grid-column-end: -13;\n}\n\n.\\!k-col-end--13 {\n    grid-column-end: -13 !important;\n}\n\n.k-col-end-auto {\n    grid-column-end: auto;\n}\n\n.\\!k-col-end-auto {\n    grid-column-end: auto !important;\n}\n\n.k-col-span-1 {\n    grid-column: span 1/span 1;\n}\n\n.\\!k-col-span-1 {\n    grid-column: span 1/span 1 !important;\n}\n\n.k-col-span-2 {\n    grid-column: span 2/span 2;\n}\n\n.\\!k-col-span-2 {\n    grid-column: span 2/span 2 !important;\n}\n\n.k-col-span-3 {\n    grid-column: span 3/span 3;\n}\n\n.\\!k-col-span-3 {\n    grid-column: span 3/span 3 !important;\n}\n\n.k-col-span-4 {\n    grid-column: span 4/span 4;\n}\n\n.\\!k-col-span-4 {\n    grid-column: span 4/span 4 !important;\n}\n\n.k-col-span-5 {\n    grid-column: span 5/span 5;\n}\n\n.\\!k-col-span-5 {\n    grid-column: span 5/span 5 !important;\n}\n\n.k-col-span-6 {\n    grid-column: span 6/span 6;\n}\n\n.\\!k-col-span-6 {\n    grid-column: span 6/span 6 !important;\n}\n\n.k-col-span-7 {\n    grid-column: span 7/span 7;\n}\n\n.\\!k-col-span-7 {\n    grid-column: span 7/span 7 !important;\n}\n\n.k-col-span-8 {\n    grid-column: span 8/span 8;\n}\n\n.\\!k-col-span-8 {\n    grid-column: span 8/span 8 !important;\n}\n\n.k-col-span-9 {\n    grid-column: span 9/span 9;\n}\n\n.\\!k-col-span-9 {\n    grid-column: span 9/span 9 !important;\n}\n\n.k-col-span-10 {\n    grid-column: span 10/span 10;\n}\n\n.\\!k-col-span-10 {\n    grid-column: span 10/span 10 !important;\n}\n\n.k-col-span-11 {\n    grid-column: span 11/span 11;\n}\n\n.\\!k-col-span-11 {\n    grid-column: span 11/span 11 !important;\n}\n\n.k-col-span-12 {\n    grid-column: span 12/span 12;\n}\n\n.\\!k-col-span-12 {\n    grid-column: span 12/span 12 !important;\n}\n\n.k-col-span-full {\n    grid-column: 1 / -1;\n}\n\n.\\!k-col-span-full {\n    grid-column: 1 / -1 !important;\n}\n\n.k-col-span-auto {\n    grid-column: auto;\n}\n\n.\\!k-col-span-auto {\n    grid-column: auto !important;\n}\n\n.k-colspan-1 {\n    grid-column: span 1/span 1;\n}\n\n.\\!k-colspan-1 {\n    grid-column: span 1/span 1 !important;\n}\n\n.k-colspan-2 {\n    grid-column: span 2/span 2;\n}\n\n.\\!k-colspan-2 {\n    grid-column: span 2/span 2 !important;\n}\n\n.k-colspan-3 {\n    grid-column: span 3/span 3;\n}\n\n.\\!k-colspan-3 {\n    grid-column: span 3/span 3 !important;\n}\n\n.k-colspan-4 {\n    grid-column: span 4/span 4;\n}\n\n.\\!k-colspan-4 {\n    grid-column: span 4/span 4 !important;\n}\n\n.k-colspan-5 {\n    grid-column: span 5/span 5;\n}\n\n.\\!k-colspan-5 {\n    grid-column: span 5/span 5 !important;\n}\n\n.k-colspan-6 {\n    grid-column: span 6/span 6;\n}\n\n.\\!k-colspan-6 {\n    grid-column: span 6/span 6 !important;\n}\n\n.k-colspan-7 {\n    grid-column: span 7/span 7;\n}\n\n.\\!k-colspan-7 {\n    grid-column: span 7/span 7 !important;\n}\n\n.k-colspan-8 {\n    grid-column: span 8/span 8;\n}\n\n.\\!k-colspan-8 {\n    grid-column: span 8/span 8 !important;\n}\n\n.k-colspan-9 {\n    grid-column: span 9/span 9;\n}\n\n.\\!k-colspan-9 {\n    grid-column: span 9/span 9 !important;\n}\n\n.k-colspan-10 {\n    grid-column: span 10/span 10;\n}\n\n.\\!k-colspan-10 {\n    grid-column: span 10/span 10 !important;\n}\n\n.k-colspan-11 {\n    grid-column: span 11/span 11;\n}\n\n.\\!k-colspan-11 {\n    grid-column: span 11/span 11 !important;\n}\n\n.k-colspan-12 {\n    grid-column: span 12/span 12;\n}\n\n.\\!k-colspan-12 {\n    grid-column: span 12/span 12 !important;\n}\n\n.k-colspan-full, .k-colspan-all {\n    grid-column: 1 / -1;\n}\n\n.\\!k-colspan-full, .\\!k-colspan-all {\n    grid-column: 1 / -1 !important;\n}\n\n.k-colspan-auto {\n    grid-column: auto;\n}\n\n.\\!k-colspan-auto {\n    grid-column: auto !important;\n}\n\n.k-row-start-1 {\n    grid-row-start: 1;\n}\n\n.\\!k-row-start-1 {\n    grid-row-start: 1 !important;\n}\n\n.k-row-start-2 {\n    grid-row-start: 2;\n}\n\n.\\!k-row-start-2 {\n    grid-row-start: 2 !important;\n}\n\n.k-row-start-3 {\n    grid-row-start: 3;\n}\n\n.\\!k-row-start-3 {\n    grid-row-start: 3 !important;\n}\n\n.k-row-start-4 {\n    grid-row-start: 4;\n}\n\n.\\!k-row-start-4 {\n    grid-row-start: 4 !important;\n}\n\n.k-row-start-5 {\n    grid-row-start: 5;\n}\n\n.\\!k-row-start-5 {\n    grid-row-start: 5 !important;\n}\n\n.k-row-start-6 {\n    grid-row-start: 6;\n}\n\n.\\!k-row-start-6 {\n    grid-row-start: 6 !important;\n}\n\n.k-row-start-7 {\n    grid-row-start: 7;\n}\n\n.\\!k-row-start-7 {\n    grid-row-start: 7 !important;\n}\n\n.k-row-start-8 {\n    grid-row-start: 8;\n}\n\n.\\!k-row-start-8 {\n    grid-row-start: 8 !important;\n}\n\n.k-row-start-9 {\n    grid-row-start: 9;\n}\n\n.\\!k-row-start-9 {\n    grid-row-start: 9 !important;\n}\n\n.k-row-start-10 {\n    grid-row-start: 10;\n}\n\n.\\!k-row-start-10 {\n    grid-row-start: 10 !important;\n}\n\n.k-row-start-11 {\n    grid-row-start: 11;\n}\n\n.\\!k-row-start-11 {\n    grid-row-start: 11 !important;\n}\n\n.k-row-start-12 {\n    grid-row-start: 12;\n}\n\n.\\!k-row-start-12 {\n    grid-row-start: 12 !important;\n}\n\n.k-row-start-13 {\n    grid-row-start: 13;\n}\n\n.\\!k-row-start-13 {\n    grid-row-start: 13 !important;\n}\n\n.k-row-start--1 {\n    grid-row-start: -1;\n}\n\n.\\!k-row-start--1 {\n    grid-row-start: -1 !important;\n}\n\n.k-row-start--2 {\n    grid-row-start: -2;\n}\n\n.\\!k-row-start--2 {\n    grid-row-start: -2 !important;\n}\n\n.k-row-start--3 {\n    grid-row-start: -3;\n}\n\n.\\!k-row-start--3 {\n    grid-row-start: -3 !important;\n}\n\n.k-row-start--4 {\n    grid-row-start: -4;\n}\n\n.\\!k-row-start--4 {\n    grid-row-start: -4 !important;\n}\n\n.k-row-start--5 {\n    grid-row-start: -5;\n}\n\n.\\!k-row-start--5 {\n    grid-row-start: -5 !important;\n}\n\n.k-row-start--6 {\n    grid-row-start: -6;\n}\n\n.\\!k-row-start--6 {\n    grid-row-start: -6 !important;\n}\n\n.k-row-start--7 {\n    grid-row-start: -7;\n}\n\n.\\!k-row-start--7 {\n    grid-row-start: -7 !important;\n}\n\n.k-row-start--8 {\n    grid-row-start: -8;\n}\n\n.\\!k-row-start--8 {\n    grid-row-start: -8 !important;\n}\n\n.k-row-start--9 {\n    grid-row-start: -9;\n}\n\n.\\!k-row-start--9 {\n    grid-row-start: -9 !important;\n}\n\n.k-row-start--10 {\n    grid-row-start: -10;\n}\n\n.\\!k-row-start--10 {\n    grid-row-start: -10 !important;\n}\n\n.k-row-start--11 {\n    grid-row-start: -11;\n}\n\n.\\!k-row-start--11 {\n    grid-row-start: -11 !important;\n}\n\n.k-row-start--12 {\n    grid-row-start: -12;\n}\n\n.\\!k-row-start--12 {\n    grid-row-start: -12 !important;\n}\n\n.k-row-start--13 {\n    grid-row-start: -13;\n}\n\n.\\!k-row-start--13 {\n    grid-row-start: -13 !important;\n}\n\n.k-row-start-auto {\n    grid-row-start: auto;\n}\n\n.\\!k-row-start-auto {\n    grid-row-start: auto !important;\n}\n\n.k-row-end-1 {\n    grid-row-end: 1;\n}\n\n.\\!k-row-end-1 {\n    grid-row-end: 1 !important;\n}\n\n.k-row-end-2 {\n    grid-row-end: 2;\n}\n\n.\\!k-row-end-2 {\n    grid-row-end: 2 !important;\n}\n\n.k-row-end-3 {\n    grid-row-end: 3;\n}\n\n.\\!k-row-end-3 {\n    grid-row-end: 3 !important;\n}\n\n.k-row-end-4 {\n    grid-row-end: 4;\n}\n\n.\\!k-row-end-4 {\n    grid-row-end: 4 !important;\n}\n\n.k-row-end-5 {\n    grid-row-end: 5;\n}\n\n.\\!k-row-end-5 {\n    grid-row-end: 5 !important;\n}\n\n.k-row-end-6 {\n    grid-row-end: 6;\n}\n\n.\\!k-row-end-6 {\n    grid-row-end: 6 !important;\n}\n\n.k-row-end-7 {\n    grid-row-end: 7;\n}\n\n.\\!k-row-end-7 {\n    grid-row-end: 7 !important;\n}\n\n.k-row-end-8 {\n    grid-row-end: 8;\n}\n\n.\\!k-row-end-8 {\n    grid-row-end: 8 !important;\n}\n\n.k-row-end-9 {\n    grid-row-end: 9;\n}\n\n.\\!k-row-end-9 {\n    grid-row-end: 9 !important;\n}\n\n.k-row-end-10 {\n    grid-row-end: 10;\n}\n\n.\\!k-row-end-10 {\n    grid-row-end: 10 !important;\n}\n\n.k-row-end-11 {\n    grid-row-end: 11;\n}\n\n.\\!k-row-end-11 {\n    grid-row-end: 11 !important;\n}\n\n.k-row-end-12 {\n    grid-row-end: 12;\n}\n\n.\\!k-row-end-12 {\n    grid-row-end: 12 !important;\n}\n\n.k-row-end-13 {\n    grid-row-end: 13;\n}\n\n.\\!k-row-end-13 {\n    grid-row-end: 13 !important;\n}\n\n.k-row-end--1 {\n    grid-row-end: -1;\n}\n\n.\\!k-row-end--1 {\n    grid-row-end: -1 !important;\n}\n\n.k-row-end--2 {\n    grid-row-end: -2;\n}\n\n.\\!k-row-end--2 {\n    grid-row-end: -2 !important;\n}\n\n.k-row-end--3 {\n    grid-row-end: -3;\n}\n\n.\\!k-row-end--3 {\n    grid-row-end: -3 !important;\n}\n\n.k-row-end--4 {\n    grid-row-end: -4;\n}\n\n.\\!k-row-end--4 {\n    grid-row-end: -4 !important;\n}\n\n.k-row-end--5 {\n    grid-row-end: -5;\n}\n\n.\\!k-row-end--5 {\n    grid-row-end: -5 !important;\n}\n\n.k-row-end--6 {\n    grid-row-end: -6;\n}\n\n.\\!k-row-end--6 {\n    grid-row-end: -6 !important;\n}\n\n.k-row-end--7 {\n    grid-row-end: -7;\n}\n\n.\\!k-row-end--7 {\n    grid-row-end: -7 !important;\n}\n\n.k-row-end--8 {\n    grid-row-end: -8;\n}\n\n.\\!k-row-end--8 {\n    grid-row-end: -8 !important;\n}\n\n.k-row-end--9 {\n    grid-row-end: -9;\n}\n\n.\\!k-row-end--9 {\n    grid-row-end: -9 !important;\n}\n\n.k-row-end--10 {\n    grid-row-end: -10;\n}\n\n.\\!k-row-end--10 {\n    grid-row-end: -10 !important;\n}\n\n.k-row-end--11 {\n    grid-row-end: -11;\n}\n\n.\\!k-row-end--11 {\n    grid-row-end: -11 !important;\n}\n\n.k-row-end--12 {\n    grid-row-end: -12;\n}\n\n.\\!k-row-end--12 {\n    grid-row-end: -12 !important;\n}\n\n.k-row-end--13 {\n    grid-row-end: -13;\n}\n\n.\\!k-row-end--13 {\n    grid-row-end: -13 !important;\n}\n\n.k-row-end-auto {\n    grid-row-end: auto;\n}\n\n.\\!k-row-end-auto {\n    grid-row-end: auto !important;\n}\n\n.k-row-span-1 {\n    grid-row: span 1/span 1;\n}\n\n.\\!k-row-span-1 {\n    grid-row: span 1/span 1 !important;\n}\n\n.k-row-span-2 {\n    grid-row: span 2/span 2;\n}\n\n.\\!k-row-span-2 {\n    grid-row: span 2/span 2 !important;\n}\n\n.k-row-span-3 {\n    grid-row: span 3/span 3;\n}\n\n.\\!k-row-span-3 {\n    grid-row: span 3/span 3 !important;\n}\n\n.k-row-span-4 {\n    grid-row: span 4/span 4;\n}\n\n.\\!k-row-span-4 {\n    grid-row: span 4/span 4 !important;\n}\n\n.k-row-span-5 {\n    grid-row: span 5/span 5;\n}\n\n.\\!k-row-span-5 {\n    grid-row: span 5/span 5 !important;\n}\n\n.k-row-span-6 {\n    grid-row: span 6/span 6;\n}\n\n.\\!k-row-span-6 {\n    grid-row: span 6/span 6 !important;\n}\n\n.k-row-span-7 {\n    grid-row: span 7/span 7;\n}\n\n.\\!k-row-span-7 {\n    grid-row: span 7/span 7 !important;\n}\n\n.k-row-span-8 {\n    grid-row: span 8/span 8;\n}\n\n.\\!k-row-span-8 {\n    grid-row: span 8/span 8 !important;\n}\n\n.k-row-span-9 {\n    grid-row: span 9/span 9;\n}\n\n.\\!k-row-span-9 {\n    grid-row: span 9/span 9 !important;\n}\n\n.k-row-span-10 {\n    grid-row: span 10/span 10;\n}\n\n.\\!k-row-span-10 {\n    grid-row: span 10/span 10 !important;\n}\n\n.k-row-span-11 {\n    grid-row: span 11/span 11;\n}\n\n.\\!k-row-span-11 {\n    grid-row: span 11/span 11 !important;\n}\n\n.k-row-span-12 {\n    grid-row: span 12/span 12;\n}\n\n.\\!k-row-span-12 {\n    grid-row: span 12/span 12 !important;\n}\n\n.k-row-span-full {\n    grid-row: span 1/span -1;\n}\n\n.\\!k-row-span-full {\n    grid-row: span 1/span -1 !important;\n}\n\n.k-row-span-auto {\n    grid-row: auto;\n}\n\n.\\!k-row-span-auto {\n    grid-row: auto !important;\n}\n\n.k-rowspan-1 {\n    grid-row: span 1/span 1;\n}\n\n.\\!k-rowspan-1 {\n    grid-row: span 1/span 1 !important;\n}\n\n.k-rowspan-2 {\n    grid-row: span 2/span 2;\n}\n\n.\\!k-rowspan-2 {\n    grid-row: span 2/span 2 !important;\n}\n\n.k-rowspan-3 {\n    grid-row: span 3/span 3;\n}\n\n.\\!k-rowspan-3 {\n    grid-row: span 3/span 3 !important;\n}\n\n.k-rowspan-4 {\n    grid-row: span 4/span 4;\n}\n\n.\\!k-rowspan-4 {\n    grid-row: span 4/span 4 !important;\n}\n\n.k-rowspan-5 {\n    grid-row: span 5/span 5;\n}\n\n.\\!k-rowspan-5 {\n    grid-row: span 5/span 5 !important;\n}\n\n.k-rowspan-6 {\n    grid-row: span 6/span 6;\n}\n\n.\\!k-rowspan-6 {\n    grid-row: span 6/span 6 !important;\n}\n\n.k-rowspan-7 {\n    grid-row: span 7/span 7;\n}\n\n.\\!k-rowspan-7 {\n    grid-row: span 7/span 7 !important;\n}\n\n.k-rowspan-8 {\n    grid-row: span 8/span 8;\n}\n\n.\\!k-rowspan-8 {\n    grid-row: span 8/span 8 !important;\n}\n\n.k-rowspan-9 {\n    grid-row: span 9/span 9;\n}\n\n.\\!k-rowspan-9 {\n    grid-row: span 9/span 9 !important;\n}\n\n.k-rowspan-10 {\n    grid-row: span 10/span 10;\n}\n\n.\\!k-rowspan-10 {\n    grid-row: span 10/span 10 !important;\n}\n\n.k-rowspan-11 {\n    grid-row: span 11/span 11;\n}\n\n.\\!k-rowspan-11 {\n    grid-row: span 11/span 11 !important;\n}\n\n.k-rowspan-12 {\n    grid-row: span 12/span 12;\n}\n\n.\\!k-rowspan-12 {\n    grid-row: span 12/span 12 !important;\n}\n\n.k-rowspan-full, .k-rowspan-all {\n    grid-row: span 1/span -1;\n}\n\n.\\!k-rowspan-full, .\\!k-rowspan-all {\n    grid-row: span 1/span -1 !important;\n}\n\n.k-rowspan-auto {\n    grid-row: auto;\n}\n\n.\\!k-rowspan-auto {\n    grid-row: auto !important;\n}\n\n.k-grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n\n.\\!k-grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;\n}\n\n.k-grid-cols-none {\n    grid-template-columns: none;\n}\n\n.\\!k-grid-cols-none {\n    grid-template-columns: none !important;\n}\n\n.k-grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-7 {\n    grid-template-rows: repeat(7, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-7 {\n    grid-template-rows: repeat(7, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-8 {\n    grid-template-rows: repeat(8, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-8 {\n    grid-template-rows: repeat(8, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-9 {\n    grid-template-rows: repeat(9, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-9 {\n    grid-template-rows: repeat(9, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-10 {\n    grid-template-rows: repeat(10, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-10 {\n    grid-template-rows: repeat(10, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-11 {\n    grid-template-rows: repeat(11, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-11 {\n    grid-template-rows: repeat(11, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-12 {\n    grid-template-rows: repeat(12, minmax(0, 1fr));\n}\n\n.\\!k-grid-rows-12 {\n    grid-template-rows: repeat(12, minmax(0, 1fr)) !important;\n}\n\n.k-grid-rows-none {\n    grid-template-rows: none;\n}\n\n.\\!k-grid-rows-none {\n    grid-template-rows: none !important;\n}\n\n.k-justify-content-normal {\n    justify-content: normal;\n}\n\n.\\!k-justify-content-normal {\n    justify-content: normal !important;\n}\n\n.k-justify-content-stretch {\n    justify-content: stretch;\n}\n\n.\\!k-justify-content-stretch {\n    justify-content: stretch !important;\n}\n\n.k-justify-content-center {\n    justify-content: center;\n}\n\n.\\!k-justify-content-center {\n    justify-content: center !important;\n}\n\n.k-justify-content-start {\n    justify-content: start;\n}\n\n.\\!k-justify-content-start {\n    justify-content: start !important;\n}\n\n.k-justify-content-end {\n    justify-content: end;\n}\n\n.\\!k-justify-content-end {\n    justify-content: end !important;\n}\n\n.k-justify-content-flex-start {\n    justify-content: flex-start;\n}\n\n.\\!k-justify-content-flex-start {\n    justify-content: flex-start !important;\n}\n\n.k-justify-content-flex-end {\n    justify-content: flex-end;\n}\n\n.\\!k-justify-content-flex-end {\n    justify-content: flex-end !important;\n}\n\n.k-justify-content-left {\n    justify-content: left;\n}\n\n.\\!k-justify-content-left {\n    justify-content: left !important;\n}\n\n.k-justify-content-right {\n    justify-content: right;\n}\n\n.\\!k-justify-content-right {\n    justify-content: right !important;\n}\n\n.k-justify-content-baseline {\n    justify-content: baseline;\n}\n\n.\\!k-justify-content-baseline {\n    justify-content: baseline !important;\n}\n\n.k-justify-content-first-baseline {\n    justify-content: first baseline;\n}\n\n.\\!k-justify-content-first-baseline {\n    justify-content: first baseline !important;\n}\n\n.k-justify-content-last-baseline {\n    justify-content: last baseline;\n}\n\n.\\!k-justify-content-last-baseline {\n    justify-content: last baseline !important;\n}\n\n.k-justify-content-between {\n    justify-content: space-between;\n}\n\n.\\!k-justify-content-between {\n    justify-content: space-between !important;\n}\n\n.k-justify-content-around {\n    justify-content: space-around;\n}\n\n.\\!k-justify-content-around {\n    justify-content: space-around !important;\n}\n\n.k-justify-content-evenly {\n    justify-content: space-evenly;\n}\n\n.\\!k-justify-content-evenly {\n    justify-content: space-evenly !important;\n}\n\n.k-justify-content-stretch > * {\n    flex: 1 0 0%;\n}\n\n.\\!.k-justify-content-stretch > * {\n    flex: 1 0 0% !important;\n}\n\n.k-justify-items-normal {\n    justify-items: normal;\n}\n\n.\\!k-justify-items-normal {\n    justify-items: normal !important;\n}\n\n.k-justify-items-stretch {\n    justify-items: stretch;\n}\n\n.\\!k-justify-items-stretch {\n    justify-items: stretch !important;\n}\n\n.k-justify-items-center {\n    justify-items: center;\n}\n\n.\\!k-justify-items-center {\n    justify-items: center !important;\n}\n\n.k-justify-items-start {\n    justify-items: start;\n}\n\n.\\!k-justify-items-start {\n    justify-items: start !important;\n}\n\n.k-justify-items-end {\n    justify-items: end;\n}\n\n.\\!k-justify-items-end {\n    justify-items: end !important;\n}\n\n.k-justify-items-flex-start {\n    justify-items: flex-start;\n}\n\n.\\!k-justify-items-flex-start {\n    justify-items: flex-start !important;\n}\n\n.k-justify-items-flex-end {\n    justify-items: flex-end;\n}\n\n.\\!k-justify-items-flex-end {\n    justify-items: flex-end !important;\n}\n\n.k-justify-items-self-start {\n    justify-items: self-start;\n}\n\n.\\!k-justify-items-self-start {\n    justify-items: self-start !important;\n}\n\n.k-justify-items-self-end {\n    justify-items: self-end;\n}\n\n.\\!k-justify-items-self-end {\n    justify-items: self-end !important;\n}\n\n.k-justify-items-left {\n    justify-items: left;\n}\n\n.\\!k-justify-items-left {\n    justify-items: left !important;\n}\n\n.k-justify-items-right {\n    justify-items: right;\n}\n\n.\\!k-justify-items-right {\n    justify-items: right !important;\n}\n\n.k-justify-items-baseline {\n    justify-items: baseline;\n}\n\n.\\!k-justify-items-baseline {\n    justify-items: baseline !important;\n}\n\n.k-justify-items-first-baseline {\n    justify-items: first baseline;\n}\n\n.\\!k-justify-items-first-baseline {\n    justify-items: first baseline !important;\n}\n\n.k-justify-items-last-baseline {\n    justify-items: last baseline;\n}\n\n.\\!k-justify-items-last-baseline {\n    justify-items: last baseline !important;\n}\n\n.k-justify-self-auto {\n    justify-self: auto;\n}\n\n.\\!k-justify-self-auto {\n    justify-self: auto !important;\n}\n\n.k-justify-self-normal {\n    justify-self: normal;\n}\n\n.\\!k-justify-self-normal {\n    justify-self: normal !important;\n}\n\n.k-justify-self-stretch {\n    justify-self: stretch;\n}\n\n.\\!k-justify-self-stretch {\n    justify-self: stretch !important;\n}\n\n.k-justify-self-center {\n    justify-self: center;\n}\n\n.\\!k-justify-self-center {\n    justify-self: center !important;\n}\n\n.k-justify-self-start {\n    justify-self: start;\n}\n\n.\\!k-justify-self-start {\n    justify-self: start !important;\n}\n\n.k-justify-self-end {\n    justify-self: end;\n}\n\n.\\!k-justify-self-end {\n    justify-self: end !important;\n}\n\n.k-justify-self-flex-start {\n    justify-self: flex-start;\n}\n\n.\\!k-justify-self-flex-start {\n    justify-self: flex-start !important;\n}\n\n.k-justify-self-flex-end {\n    justify-self: flex-end;\n}\n\n.\\!k-justify-self-flex-end {\n    justify-self: flex-end !important;\n}\n\n.k-justify-self-self-start {\n    justify-self: self-start;\n}\n\n.\\!k-justify-self-self-start {\n    justify-self: self-start !important;\n}\n\n.k-justify-self-self-end {\n    justify-self: self-end;\n}\n\n.\\!k-justify-self-self-end {\n    justify-self: self-end !important;\n}\n\n.k-justify-self-baseline {\n    justify-self: baseline;\n}\n\n.\\!k-justify-self-baseline {\n    justify-self: baseline !important;\n}\n\n.k-justify-self-first-baseline {\n    justify-self: first baseline;\n}\n\n.\\!k-justify-self-first-baseline {\n    justify-self: first baseline !important;\n}\n\n.k-justify-self-last-baseline {\n    justify-self: last baseline;\n}\n\n.\\!k-justify-self-last-baseline {\n    justify-self: last baseline !important;\n}\n\n.k-order-1 {\n    order: 1;\n}\n\n.\\!k-order-1 {\n    order: 1 !important;\n}\n\n.k-order-2 {\n    order: 2;\n}\n\n.\\!k-order-2 {\n    order: 2 !important;\n}\n\n.k-order-3 {\n    order: 3;\n}\n\n.\\!k-order-3 {\n    order: 3 !important;\n}\n\n.k-order-4 {\n    order: 4;\n}\n\n.\\!k-order-4 {\n    order: 4 !important;\n}\n\n.k-order-5 {\n    order: 5;\n}\n\n.\\!k-order-5 {\n    order: 5 !important;\n}\n\n.k-order-6 {\n    order: 6;\n}\n\n.\\!k-order-6 {\n    order: 6 !important;\n}\n\n.k-order-7 {\n    order: 7;\n}\n\n.\\!k-order-7 {\n    order: 7 !important;\n}\n\n.k-order-8 {\n    order: 8;\n}\n\n.\\!k-order-8 {\n    order: 8 !important;\n}\n\n.k-order-9 {\n    order: 9;\n}\n\n.\\!k-order-9 {\n    order: 9 !important;\n}\n\n.k-order-10 {\n    order: 10;\n}\n\n.\\!k-order-10 {\n    order: 10 !important;\n}\n\n.k-order-11 {\n    order: 11;\n}\n\n.\\!k-order-11 {\n    order: 11 !important;\n}\n\n.k-order-12 {\n    order: 12;\n}\n\n.\\!k-order-12 {\n    order: 12 !important;\n}\n\n.k-order-first {\n    order: -9999;\n}\n\n.\\!k-order-first {\n    order: -9999 !important;\n}\n\n.k-order-last {\n    order: 9999;\n}\n\n.\\!k-order-last {\n    order: 9999 !important;\n}\n\n.k-order-none {\n    order: 0;\n}\n\n.\\!k-order-none {\n    order: 0 !important;\n}\n\n.k-place-content-normal {\n    place-content: normal;\n}\n\n.\\!k-place-content-normal {\n    place-content: normal !important;\n}\n\n.k-place-content-stretch {\n    place-content: stretch;\n}\n\n.\\!k-place-content-stretch {\n    place-content: stretch !important;\n}\n\n.k-place-content-center {\n    place-content: center;\n}\n\n.\\!k-place-content-center {\n    place-content: center !important;\n}\n\n.k-place-content-start {\n    place-content: start;\n}\n\n.\\!k-place-content-start {\n    place-content: start !important;\n}\n\n.k-place-content-end {\n    place-content: end;\n}\n\n.\\!k-place-content-end {\n    place-content: end !important;\n}\n\n.k-place-content-flex-start {\n    place-content: flex-start;\n}\n\n.\\!k-place-content-flex-start {\n    place-content: flex-start !important;\n}\n\n.k-place-content-flex-end {\n    place-content: flex-end;\n}\n\n.\\!k-place-content-flex-end {\n    place-content: flex-end !important;\n}\n\n.k-place-content-baseline {\n    place-content: baseline;\n}\n\n.\\!k-place-content-baseline {\n    place-content: baseline !important;\n}\n\n.k-place-content-between {\n    place-content: space-between;\n}\n\n.\\!k-place-content-between {\n    place-content: space-between !important;\n}\n\n.k-place-content-around {\n    place-content: space-around;\n}\n\n.\\!k-place-content-around {\n    place-content: space-around !important;\n}\n\n.k-place-content-evenly {\n    place-content: space-evenly;\n}\n\n.\\!k-place-content-evenly {\n    place-content: space-evenly !important;\n}\n\n.k-place-items-normal {\n    place-items: normal;\n}\n\n.\\!k-place-items-normal {\n    place-items: normal !important;\n}\n\n.k-place-items-stretch {\n    place-items: stretch;\n}\n\n.\\!k-place-items-stretch {\n    place-items: stretch !important;\n}\n\n.k-place-items-center {\n    place-items: center;\n}\n\n.\\!k-place-items-center {\n    place-items: center !important;\n}\n\n.k-place-items-start {\n    place-items: start;\n}\n\n.\\!k-place-items-start {\n    place-items: start !important;\n}\n\n.k-place-items-end {\n    place-items: end;\n}\n\n.\\!k-place-items-end {\n    place-items: end !important;\n}\n\n.k-place-items-flex-start {\n    place-items: flex-start;\n}\n\n.\\!k-place-items-flex-start {\n    place-items: flex-start !important;\n}\n\n.k-place-items-flex-end {\n    place-items: flex-end;\n}\n\n.\\!k-place-items-flex-end {\n    place-items: flex-end !important;\n}\n\n.k-place-items-self-start {\n    place-items: self-start;\n}\n\n.\\!k-place-items-self-start {\n    place-items: self-start !important;\n}\n\n.k-place-items-self-end {\n    place-items: self-end;\n}\n\n.\\!k-place-items-self-end {\n    place-items: self-end !important;\n}\n\n.k-place-items-baseline {\n    place-items: baseline;\n}\n\n.\\!k-place-items-baseline {\n    place-items: baseline !important;\n}\n\n.k-place-self-auto {\n    place-self: auto;\n}\n\n.\\!k-place-self-auto {\n    place-self: auto !important;\n}\n\n.k-place-self-normal {\n    place-self: normal;\n}\n\n.\\!k-place-self-normal {\n    place-self: normal !important;\n}\n\n.k-place-self-stretch {\n    place-self: stretch;\n}\n\n.\\!k-place-self-stretch {\n    place-self: stretch !important;\n}\n\n.k-place-self-center {\n    place-self: center;\n}\n\n.\\!k-place-self-center {\n    place-self: center !important;\n}\n\n.k-place-self-start {\n    place-self: start;\n}\n\n.\\!k-place-self-start {\n    place-self: start !important;\n}\n\n.k-place-self-end {\n    place-self: end;\n}\n\n.\\!k-place-self-end {\n    place-self: end !important;\n}\n\n.k-place-self-flex-start {\n    place-self: flex-start;\n}\n\n.\\!k-place-self-flex-start {\n    place-self: flex-start !important;\n}\n\n.k-place-self-flex-end {\n    place-self: flex-end;\n}\n\n.\\!k-place-self-flex-end {\n    place-self: flex-end !important;\n}\n\n.k-place-self-self-start {\n    place-self: self-start;\n}\n\n.\\!k-place-self-self-start {\n    place-self: self-start !important;\n}\n\n.k-place-self-self-end {\n    place-self: self-end;\n}\n\n.\\!k-place-self-self-end {\n    place-self: self-end !important;\n}\n\n.k-place-self-baseline {\n    place-self: baseline;\n}\n\n.\\!k-place-self-baseline {\n    place-self: baseline !important;\n}\n\n.k-m-0 {\n    margin: 0;\n}\n\n.\\!k-m-0 {\n    margin: 0 !important;\n}\n\n.k-m-1px {\n    margin: 1px;\n}\n\n.\\!k-m-1px {\n    margin: 1px !important;\n}\n\n.k-m-0\\.5 {\n    margin: 0.125rem;\n}\n\n.\\!k-m-0\\.5 {\n    margin: 0.125rem !important;\n}\n\n.k-m-1 {\n    margin: 0.25rem;\n}\n\n.\\!k-m-1 {\n    margin: 0.25rem !important;\n}\n\n.k-m-1\\.5 {\n    margin: 0.375rem;\n}\n\n.\\!k-m-1\\.5 {\n    margin: 0.375rem !important;\n}\n\n.k-m-2 {\n    margin: 0.5rem;\n}\n\n.\\!k-m-2 {\n    margin: 0.5rem !important;\n}\n\n.k-m-2\\.5 {\n    margin: 0.625rem;\n}\n\n.\\!k-m-2\\.5 {\n    margin: 0.625rem !important;\n}\n\n.k-m-3 {\n    margin: 0.75rem;\n}\n\n.\\!k-m-3 {\n    margin: 0.75rem !important;\n}\n\n.k-m-3\\.5 {\n    margin: 0.875rem;\n}\n\n.\\!k-m-3\\.5 {\n    margin: 0.875rem !important;\n}\n\n.k-m-4 {\n    margin: 1rem;\n}\n\n.\\!k-m-4 {\n    margin: 1rem !important;\n}\n\n.k-m-4\\.5 {\n    margin: 1.125rem;\n}\n\n.\\!k-m-4\\.5 {\n    margin: 1.125rem !important;\n}\n\n.k-m-5 {\n    margin: 1.25rem;\n}\n\n.\\!k-m-5 {\n    margin: 1.25rem !important;\n}\n\n.k-m-5\\.5 {\n    margin: 1.375rem;\n}\n\n.\\!k-m-5\\.5 {\n    margin: 1.375rem !important;\n}\n\n.k-m-6 {\n    margin: 1.5rem;\n}\n\n.\\!k-m-6 {\n    margin: 1.5rem !important;\n}\n\n.k-m-6\\.5 {\n    margin: 1.625rem;\n}\n\n.\\!k-m-6\\.5 {\n    margin: 1.625rem !important;\n}\n\n.k-m-7 {\n    margin: 1.75rem;\n}\n\n.\\!k-m-7 {\n    margin: 1.75rem !important;\n}\n\n.k-m-7\\.5 {\n    margin: 1.875rem;\n}\n\n.\\!k-m-7\\.5 {\n    margin: 1.875rem !important;\n}\n\n.k-m-8 {\n    margin: 2rem;\n}\n\n.\\!k-m-8 {\n    margin: 2rem !important;\n}\n\n.k-m-9 {\n    margin: 2.25rem;\n}\n\n.\\!k-m-9 {\n    margin: 2.25rem !important;\n}\n\n.k-m-10 {\n    margin: 2.5rem;\n}\n\n.\\!k-m-10 {\n    margin: 2.5rem !important;\n}\n\n.k-m-11 {\n    margin: 2.75rem;\n}\n\n.\\!k-m-11 {\n    margin: 2.75rem !important;\n}\n\n.k-m-12 {\n    margin: 3rem;\n}\n\n.\\!k-m-12 {\n    margin: 3rem !important;\n}\n\n.k-m-13 {\n    margin: 3.25rem;\n}\n\n.\\!k-m-13 {\n    margin: 3.25rem !important;\n}\n\n.k-m-14 {\n    margin: 3.5rem;\n}\n\n.\\!k-m-14 {\n    margin: 3.5rem !important;\n}\n\n.k-m-15 {\n    margin: 3.75rem;\n}\n\n.\\!k-m-15 {\n    margin: 3.75rem !important;\n}\n\n.k-m-16 {\n    margin: 4rem;\n}\n\n.\\!k-m-16 {\n    margin: 4rem !important;\n}\n\n.k-m-17 {\n    margin: 4.25rem;\n}\n\n.\\!k-m-17 {\n    margin: 4.25rem !important;\n}\n\n.k-m-18 {\n    margin: 4.5rem;\n}\n\n.\\!k-m-18 {\n    margin: 4.5rem !important;\n}\n\n.k-m-19 {\n    margin: 4.75rem;\n}\n\n.\\!k-m-19 {\n    margin: 4.75rem !important;\n}\n\n.k-m-20 {\n    margin: 5rem;\n}\n\n.\\!k-m-20 {\n    margin: 5rem !important;\n}\n\n.k-m-21 {\n    margin: 5.25rem;\n}\n\n.\\!k-m-21 {\n    margin: 5.25rem !important;\n}\n\n.k-m-22 {\n    margin: 5.5rem;\n}\n\n.\\!k-m-22 {\n    margin: 5.5rem !important;\n}\n\n.k-m-23 {\n    margin: 5.75rem;\n}\n\n.\\!k-m-23 {\n    margin: 5.75rem !important;\n}\n\n.k-m-24 {\n    margin: 6rem;\n}\n\n.\\!k-m-24 {\n    margin: 6rem !important;\n}\n\n.k-m--1px {\n    margin: -1px;\n}\n\n.\\!k-m--1px {\n    margin: -1px !important;\n}\n\n.k-m--0\\.5 {\n    margin: -0.125rem;\n}\n\n.\\!k-m--0\\.5 {\n    margin: -0.125rem !important;\n}\n\n.k-m--1 {\n    margin: -0.25rem;\n}\n\n.\\!k-m--1 {\n    margin: -0.25rem !important;\n}\n\n.k-m--1\\.5 {\n    margin: -0.375rem;\n}\n\n.\\!k-m--1\\.5 {\n    margin: -0.375rem !important;\n}\n\n.k-m--2 {\n    margin: -0.5rem;\n}\n\n.\\!k-m--2 {\n    margin: -0.5rem !important;\n}\n\n.k-m--2\\.5 {\n    margin: -0.625rem;\n}\n\n.\\!k-m--2\\.5 {\n    margin: -0.625rem !important;\n}\n\n.k-m--3 {\n    margin: -0.75rem;\n}\n\n.\\!k-m--3 {\n    margin: -0.75rem !important;\n}\n\n.k-m--3\\.5 {\n    margin: -0.875rem;\n}\n\n.\\!k-m--3\\.5 {\n    margin: -0.875rem !important;\n}\n\n.k-m--4 {\n    margin: -1rem;\n}\n\n.\\!k-m--4 {\n    margin: -1rem !important;\n}\n\n.k-m--4\\.5 {\n    margin: -1.125rem;\n}\n\n.\\!k-m--4\\.5 {\n    margin: -1.125rem !important;\n}\n\n.k-m--5 {\n    margin: -1.25rem;\n}\n\n.\\!k-m--5 {\n    margin: -1.25rem !important;\n}\n\n.k-m--5\\.5 {\n    margin: -1.375rem;\n}\n\n.\\!k-m--5\\.5 {\n    margin: -1.375rem !important;\n}\n\n.k-m--6 {\n    margin: -1.5rem;\n}\n\n.\\!k-m--6 {\n    margin: -1.5rem !important;\n}\n\n.k-m--6\\.5 {\n    margin: -1.625rem;\n}\n\n.\\!k-m--6\\.5 {\n    margin: -1.625rem !important;\n}\n\n.k-m--7 {\n    margin: -1.75rem;\n}\n\n.\\!k-m--7 {\n    margin: -1.75rem !important;\n}\n\n.k-m--7\\.5 {\n    margin: -1.875rem;\n}\n\n.\\!k-m--7\\.5 {\n    margin: -1.875rem !important;\n}\n\n.k-m--8 {\n    margin: -2rem;\n}\n\n.\\!k-m--8 {\n    margin: -2rem !important;\n}\n\n.k-m--9 {\n    margin: -2.25rem;\n}\n\n.\\!k-m--9 {\n    margin: -2.25rem !important;\n}\n\n.k-m--10 {\n    margin: -2.5rem;\n}\n\n.\\!k-m--10 {\n    margin: -2.5rem !important;\n}\n\n.k-m--11 {\n    margin: -2.75rem;\n}\n\n.\\!k-m--11 {\n    margin: -2.75rem !important;\n}\n\n.k-m--12 {\n    margin: -3rem;\n}\n\n.\\!k-m--12 {\n    margin: -3rem !important;\n}\n\n.k-m--13 {\n    margin: -3.25rem;\n}\n\n.\\!k-m--13 {\n    margin: -3.25rem !important;\n}\n\n.k-m--14 {\n    margin: -3.5rem;\n}\n\n.\\!k-m--14 {\n    margin: -3.5rem !important;\n}\n\n.k-m--15 {\n    margin: -3.75rem;\n}\n\n.\\!k-m--15 {\n    margin: -3.75rem !important;\n}\n\n.k-m--16 {\n    margin: -4rem;\n}\n\n.\\!k-m--16 {\n    margin: -4rem !important;\n}\n\n.k-m--17 {\n    margin: -4.25rem;\n}\n\n.\\!k-m--17 {\n    margin: -4.25rem !important;\n}\n\n.k-m--18 {\n    margin: -4.5rem;\n}\n\n.\\!k-m--18 {\n    margin: -4.5rem !important;\n}\n\n.k-m--19 {\n    margin: -4.75rem;\n}\n\n.\\!k-m--19 {\n    margin: -4.75rem !important;\n}\n\n.k-m--20 {\n    margin: -5rem;\n}\n\n.\\!k-m--20 {\n    margin: -5rem !important;\n}\n\n.k-m--21 {\n    margin: -5.25rem;\n}\n\n.\\!k-m--21 {\n    margin: -5.25rem !important;\n}\n\n.k-m--22 {\n    margin: -5.5rem;\n}\n\n.\\!k-m--22 {\n    margin: -5.5rem !important;\n}\n\n.k-m--23 {\n    margin: -5.75rem;\n}\n\n.\\!k-m--23 {\n    margin: -5.75rem !important;\n}\n\n.k-m--24 {\n    margin: -6rem;\n}\n\n.\\!k-m--24 {\n    margin: -6rem !important;\n}\n\n.k-m-xs {\n    margin: 0.25rem;\n}\n\n.\\!k-m-xs {\n    margin: 0.25rem !important;\n}\n\n.k-m-sm {\n    margin: 0.5rem;\n}\n\n.\\!k-m-sm {\n    margin: 0.5rem !important;\n}\n\n.k-m-md {\n    margin: 0.75rem;\n}\n\n.\\!k-m-md {\n    margin: 0.75rem !important;\n}\n\n.k-m-lg {\n    margin: 1rem;\n}\n\n.\\!k-m-lg {\n    margin: 1rem !important;\n}\n\n.k-m-xl {\n    margin: 1.5rem;\n}\n\n.\\!k-m-xl {\n    margin: 1.5rem !important;\n}\n\n.k-m-thin {\n    margin: 0.125rem;\n}\n\n.\\!k-m-thin {\n    margin: 0.125rem !important;\n}\n\n.k-m-hair {\n    margin: 1px;\n}\n\n.\\!k-m-hair {\n    margin: 1px !important;\n}\n\n.k-m-auto {\n    margin: auto;\n}\n\n.\\!k-m-auto {\n    margin: auto !important;\n}\n\n.k-mt-0 {\n    margin-top: 0;\n}\n\n.\\!k-mt-0 {\n    margin-top: 0 !important;\n}\n\n.k-mt-1px {\n    margin-top: 1px;\n}\n\n.\\!k-mt-1px {\n    margin-top: 1px !important;\n}\n\n.k-mt-0\\.5 {\n    margin-top: 0.125rem;\n}\n\n.\\!k-mt-0\\.5 {\n    margin-top: 0.125rem !important;\n}\n\n.k-mt-1 {\n    margin-top: 0.25rem;\n}\n\n.\\!k-mt-1 {\n    margin-top: 0.25rem !important;\n}\n\n.k-mt-1\\.5 {\n    margin-top: 0.375rem;\n}\n\n.\\!k-mt-1\\.5 {\n    margin-top: 0.375rem !important;\n}\n\n.k-mt-2 {\n    margin-top: 0.5rem;\n}\n\n.\\!k-mt-2 {\n    margin-top: 0.5rem !important;\n}\n\n.k-mt-2\\.5 {\n    margin-top: 0.625rem;\n}\n\n.\\!k-mt-2\\.5 {\n    margin-top: 0.625rem !important;\n}\n\n.k-mt-3 {\n    margin-top: 0.75rem;\n}\n\n.\\!k-mt-3 {\n    margin-top: 0.75rem !important;\n}\n\n.k-mt-3\\.5 {\n    margin-top: 0.875rem;\n}\n\n.\\!k-mt-3\\.5 {\n    margin-top: 0.875rem !important;\n}\n\n.k-mt-4 {\n    margin-top: 1rem;\n}\n\n.\\!k-mt-4 {\n    margin-top: 1rem !important;\n}\n\n.k-mt-4\\.5 {\n    margin-top: 1.125rem;\n}\n\n.\\!k-mt-4\\.5 {\n    margin-top: 1.125rem !important;\n}\n\n.k-mt-5 {\n    margin-top: 1.25rem;\n}\n\n.\\!k-mt-5 {\n    margin-top: 1.25rem !important;\n}\n\n.k-mt-5\\.5 {\n    margin-top: 1.375rem;\n}\n\n.\\!k-mt-5\\.5 {\n    margin-top: 1.375rem !important;\n}\n\n.k-mt-6 {\n    margin-top: 1.5rem;\n}\n\n.\\!k-mt-6 {\n    margin-top: 1.5rem !important;\n}\n\n.k-mt-6\\.5 {\n    margin-top: 1.625rem;\n}\n\n.\\!k-mt-6\\.5 {\n    margin-top: 1.625rem !important;\n}\n\n.k-mt-7 {\n    margin-top: 1.75rem;\n}\n\n.\\!k-mt-7 {\n    margin-top: 1.75rem !important;\n}\n\n.k-mt-7\\.5 {\n    margin-top: 1.875rem;\n}\n\n.\\!k-mt-7\\.5 {\n    margin-top: 1.875rem !important;\n}\n\n.k-mt-8 {\n    margin-top: 2rem;\n}\n\n.\\!k-mt-8 {\n    margin-top: 2rem !important;\n}\n\n.k-mt-9 {\n    margin-top: 2.25rem;\n}\n\n.\\!k-mt-9 {\n    margin-top: 2.25rem !important;\n}\n\n.k-mt-10 {\n    margin-top: 2.5rem;\n}\n\n.\\!k-mt-10 {\n    margin-top: 2.5rem !important;\n}\n\n.k-mt-11 {\n    margin-top: 2.75rem;\n}\n\n.\\!k-mt-11 {\n    margin-top: 2.75rem !important;\n}\n\n.k-mt-12 {\n    margin-top: 3rem;\n}\n\n.\\!k-mt-12 {\n    margin-top: 3rem !important;\n}\n\n.k-mt-13 {\n    margin-top: 3.25rem;\n}\n\n.\\!k-mt-13 {\n    margin-top: 3.25rem !important;\n}\n\n.k-mt-14 {\n    margin-top: 3.5rem;\n}\n\n.\\!k-mt-14 {\n    margin-top: 3.5rem !important;\n}\n\n.k-mt-15 {\n    margin-top: 3.75rem;\n}\n\n.\\!k-mt-15 {\n    margin-top: 3.75rem !important;\n}\n\n.k-mt-16 {\n    margin-top: 4rem;\n}\n\n.\\!k-mt-16 {\n    margin-top: 4rem !important;\n}\n\n.k-mt-17 {\n    margin-top: 4.25rem;\n}\n\n.\\!k-mt-17 {\n    margin-top: 4.25rem !important;\n}\n\n.k-mt-18 {\n    margin-top: 4.5rem;\n}\n\n.\\!k-mt-18 {\n    margin-top: 4.5rem !important;\n}\n\n.k-mt-19 {\n    margin-top: 4.75rem;\n}\n\n.\\!k-mt-19 {\n    margin-top: 4.75rem !important;\n}\n\n.k-mt-20 {\n    margin-top: 5rem;\n}\n\n.\\!k-mt-20 {\n    margin-top: 5rem !important;\n}\n\n.k-mt-21 {\n    margin-top: 5.25rem;\n}\n\n.\\!k-mt-21 {\n    margin-top: 5.25rem !important;\n}\n\n.k-mt-22 {\n    margin-top: 5.5rem;\n}\n\n.\\!k-mt-22 {\n    margin-top: 5.5rem !important;\n}\n\n.k-mt-23 {\n    margin-top: 5.75rem;\n}\n\n.\\!k-mt-23 {\n    margin-top: 5.75rem !important;\n}\n\n.k-mt-24 {\n    margin-top: 6rem;\n}\n\n.\\!k-mt-24 {\n    margin-top: 6rem !important;\n}\n\n.k-mt--1px {\n    margin-top: -1px;\n}\n\n.\\!k-mt--1px {\n    margin-top: -1px !important;\n}\n\n.k-mt--0\\.5 {\n    margin-top: -0.125rem;\n}\n\n.\\!k-mt--0\\.5 {\n    margin-top: -0.125rem !important;\n}\n\n.k-mt--1 {\n    margin-top: -0.25rem;\n}\n\n.\\!k-mt--1 {\n    margin-top: -0.25rem !important;\n}\n\n.k-mt--1\\.5 {\n    margin-top: -0.375rem;\n}\n\n.\\!k-mt--1\\.5 {\n    margin-top: -0.375rem !important;\n}\n\n.k-mt--2 {\n    margin-top: -0.5rem;\n}\n\n.\\!k-mt--2 {\n    margin-top: -0.5rem !important;\n}\n\n.k-mt--2\\.5 {\n    margin-top: -0.625rem;\n}\n\n.\\!k-mt--2\\.5 {\n    margin-top: -0.625rem !important;\n}\n\n.k-mt--3 {\n    margin-top: -0.75rem;\n}\n\n.\\!k-mt--3 {\n    margin-top: -0.75rem !important;\n}\n\n.k-mt--3\\.5 {\n    margin-top: -0.875rem;\n}\n\n.\\!k-mt--3\\.5 {\n    margin-top: -0.875rem !important;\n}\n\n.k-mt--4 {\n    margin-top: -1rem;\n}\n\n.\\!k-mt--4 {\n    margin-top: -1rem !important;\n}\n\n.k-mt--4\\.5 {\n    margin-top: -1.125rem;\n}\n\n.\\!k-mt--4\\.5 {\n    margin-top: -1.125rem !important;\n}\n\n.k-mt--5 {\n    margin-top: -1.25rem;\n}\n\n.\\!k-mt--5 {\n    margin-top: -1.25rem !important;\n}\n\n.k-mt--5\\.5 {\n    margin-top: -1.375rem;\n}\n\n.\\!k-mt--5\\.5 {\n    margin-top: -1.375rem !important;\n}\n\n.k-mt--6 {\n    margin-top: -1.5rem;\n}\n\n.\\!k-mt--6 {\n    margin-top: -1.5rem !important;\n}\n\n.k-mt--6\\.5 {\n    margin-top: -1.625rem;\n}\n\n.\\!k-mt--6\\.5 {\n    margin-top: -1.625rem !important;\n}\n\n.k-mt--7 {\n    margin-top: -1.75rem;\n}\n\n.\\!k-mt--7 {\n    margin-top: -1.75rem !important;\n}\n\n.k-mt--7\\.5 {\n    margin-top: -1.875rem;\n}\n\n.\\!k-mt--7\\.5 {\n    margin-top: -1.875rem !important;\n}\n\n.k-mt--8 {\n    margin-top: -2rem;\n}\n\n.\\!k-mt--8 {\n    margin-top: -2rem !important;\n}\n\n.k-mt--9 {\n    margin-top: -2.25rem;\n}\n\n.\\!k-mt--9 {\n    margin-top: -2.25rem !important;\n}\n\n.k-mt--10 {\n    margin-top: -2.5rem;\n}\n\n.\\!k-mt--10 {\n    margin-top: -2.5rem !important;\n}\n\n.k-mt--11 {\n    margin-top: -2.75rem;\n}\n\n.\\!k-mt--11 {\n    margin-top: -2.75rem !important;\n}\n\n.k-mt--12 {\n    margin-top: -3rem;\n}\n\n.\\!k-mt--12 {\n    margin-top: -3rem !important;\n}\n\n.k-mt--13 {\n    margin-top: -3.25rem;\n}\n\n.\\!k-mt--13 {\n    margin-top: -3.25rem !important;\n}\n\n.k-mt--14 {\n    margin-top: -3.5rem;\n}\n\n.\\!k-mt--14 {\n    margin-top: -3.5rem !important;\n}\n\n.k-mt--15 {\n    margin-top: -3.75rem;\n}\n\n.\\!k-mt--15 {\n    margin-top: -3.75rem !important;\n}\n\n.k-mt--16 {\n    margin-top: -4rem;\n}\n\n.\\!k-mt--16 {\n    margin-top: -4rem !important;\n}\n\n.k-mt--17 {\n    margin-top: -4.25rem;\n}\n\n.\\!k-mt--17 {\n    margin-top: -4.25rem !important;\n}\n\n.k-mt--18 {\n    margin-top: -4.5rem;\n}\n\n.\\!k-mt--18 {\n    margin-top: -4.5rem !important;\n}\n\n.k-mt--19 {\n    margin-top: -4.75rem;\n}\n\n.\\!k-mt--19 {\n    margin-top: -4.75rem !important;\n}\n\n.k-mt--20 {\n    margin-top: -5rem;\n}\n\n.\\!k-mt--20 {\n    margin-top: -5rem !important;\n}\n\n.k-mt--21 {\n    margin-top: -5.25rem;\n}\n\n.\\!k-mt--21 {\n    margin-top: -5.25rem !important;\n}\n\n.k-mt--22 {\n    margin-top: -5.5rem;\n}\n\n.\\!k-mt--22 {\n    margin-top: -5.5rem !important;\n}\n\n.k-mt--23 {\n    margin-top: -5.75rem;\n}\n\n.\\!k-mt--23 {\n    margin-top: -5.75rem !important;\n}\n\n.k-mt--24 {\n    margin-top: -6rem;\n}\n\n.\\!k-mt--24 {\n    margin-top: -6rem !important;\n}\n\n.k-mt-xs {\n    margin-top: 0.25rem;\n}\n\n.\\!k-mt-xs {\n    margin-top: 0.25rem !important;\n}\n\n.k-mt-sm {\n    margin-top: 0.5rem;\n}\n\n.\\!k-mt-sm {\n    margin-top: 0.5rem !important;\n}\n\n.k-mt-md {\n    margin-top: 0.75rem;\n}\n\n.\\!k-mt-md {\n    margin-top: 0.75rem !important;\n}\n\n.k-mt-lg {\n    margin-top: 1rem;\n}\n\n.\\!k-mt-lg {\n    margin-top: 1rem !important;\n}\n\n.k-mt-xl {\n    margin-top: 1.5rem;\n}\n\n.\\!k-mt-xl {\n    margin-top: 1.5rem !important;\n}\n\n.k-mt-thin {\n    margin-top: 0.125rem;\n}\n\n.\\!k-mt-thin {\n    margin-top: 0.125rem !important;\n}\n\n.k-mt-hair {\n    margin-top: 1px;\n}\n\n.\\!k-mt-hair {\n    margin-top: 1px !important;\n}\n\n.k-mt-auto {\n    margin-top: auto;\n}\n\n.\\!k-mt-auto {\n    margin-top: auto !important;\n}\n\n.k-mr-0 {\n    margin-right: 0;\n}\n\n.\\!k-mr-0 {\n    margin-right: 0 !important;\n}\n\n.k-mr-1px {\n    margin-right: 1px;\n}\n\n.\\!k-mr-1px {\n    margin-right: 1px !important;\n}\n\n.k-mr-0\\.5 {\n    margin-right: 0.125rem;\n}\n\n.\\!k-mr-0\\.5 {\n    margin-right: 0.125rem !important;\n}\n\n.k-mr-1 {\n    margin-right: 0.25rem;\n}\n\n.\\!k-mr-1 {\n    margin-right: 0.25rem !important;\n}\n\n.k-mr-1\\.5 {\n    margin-right: 0.375rem;\n}\n\n.\\!k-mr-1\\.5 {\n    margin-right: 0.375rem !important;\n}\n\n.k-mr-2 {\n    margin-right: 0.5rem;\n}\n\n.\\!k-mr-2 {\n    margin-right: 0.5rem !important;\n}\n\n.k-mr-2\\.5 {\n    margin-right: 0.625rem;\n}\n\n.\\!k-mr-2\\.5 {\n    margin-right: 0.625rem !important;\n}\n\n.k-mr-3 {\n    margin-right: 0.75rem;\n}\n\n.\\!k-mr-3 {\n    margin-right: 0.75rem !important;\n}\n\n.k-mr-3\\.5 {\n    margin-right: 0.875rem;\n}\n\n.\\!k-mr-3\\.5 {\n    margin-right: 0.875rem !important;\n}\n\n.k-mr-4 {\n    margin-right: 1rem;\n}\n\n.\\!k-mr-4 {\n    margin-right: 1rem !important;\n}\n\n.k-mr-4\\.5 {\n    margin-right: 1.125rem;\n}\n\n.\\!k-mr-4\\.5 {\n    margin-right: 1.125rem !important;\n}\n\n.k-mr-5 {\n    margin-right: 1.25rem;\n}\n\n.\\!k-mr-5 {\n    margin-right: 1.25rem !important;\n}\n\n.k-mr-5\\.5 {\n    margin-right: 1.375rem;\n}\n\n.\\!k-mr-5\\.5 {\n    margin-right: 1.375rem !important;\n}\n\n.k-mr-6 {\n    margin-right: 1.5rem;\n}\n\n.\\!k-mr-6 {\n    margin-right: 1.5rem !important;\n}\n\n.k-mr-6\\.5 {\n    margin-right: 1.625rem;\n}\n\n.\\!k-mr-6\\.5 {\n    margin-right: 1.625rem !important;\n}\n\n.k-mr-7 {\n    margin-right: 1.75rem;\n}\n\n.\\!k-mr-7 {\n    margin-right: 1.75rem !important;\n}\n\n.k-mr-7\\.5 {\n    margin-right: 1.875rem;\n}\n\n.\\!k-mr-7\\.5 {\n    margin-right: 1.875rem !important;\n}\n\n.k-mr-8 {\n    margin-right: 2rem;\n}\n\n.\\!k-mr-8 {\n    margin-right: 2rem !important;\n}\n\n.k-mr-9 {\n    margin-right: 2.25rem;\n}\n\n.\\!k-mr-9 {\n    margin-right: 2.25rem !important;\n}\n\n.k-mr-10 {\n    margin-right: 2.5rem;\n}\n\n.\\!k-mr-10 {\n    margin-right: 2.5rem !important;\n}\n\n.k-mr-11 {\n    margin-right: 2.75rem;\n}\n\n.\\!k-mr-11 {\n    margin-right: 2.75rem !important;\n}\n\n.k-mr-12 {\n    margin-right: 3rem;\n}\n\n.\\!k-mr-12 {\n    margin-right: 3rem !important;\n}\n\n.k-mr-13 {\n    margin-right: 3.25rem;\n}\n\n.\\!k-mr-13 {\n    margin-right: 3.25rem !important;\n}\n\n.k-mr-14 {\n    margin-right: 3.5rem;\n}\n\n.\\!k-mr-14 {\n    margin-right: 3.5rem !important;\n}\n\n.k-mr-15 {\n    margin-right: 3.75rem;\n}\n\n.\\!k-mr-15 {\n    margin-right: 3.75rem !important;\n}\n\n.k-mr-16 {\n    margin-right: 4rem;\n}\n\n.\\!k-mr-16 {\n    margin-right: 4rem !important;\n}\n\n.k-mr-17 {\n    margin-right: 4.25rem;\n}\n\n.\\!k-mr-17 {\n    margin-right: 4.25rem !important;\n}\n\n.k-mr-18 {\n    margin-right: 4.5rem;\n}\n\n.\\!k-mr-18 {\n    margin-right: 4.5rem !important;\n}\n\n.k-mr-19 {\n    margin-right: 4.75rem;\n}\n\n.\\!k-mr-19 {\n    margin-right: 4.75rem !important;\n}\n\n.k-mr-20 {\n    margin-right: 5rem;\n}\n\n.\\!k-mr-20 {\n    margin-right: 5rem !important;\n}\n\n.k-mr-21 {\n    margin-right: 5.25rem;\n}\n\n.\\!k-mr-21 {\n    margin-right: 5.25rem !important;\n}\n\n.k-mr-22 {\n    margin-right: 5.5rem;\n}\n\n.\\!k-mr-22 {\n    margin-right: 5.5rem !important;\n}\n\n.k-mr-23 {\n    margin-right: 5.75rem;\n}\n\n.\\!k-mr-23 {\n    margin-right: 5.75rem !important;\n}\n\n.k-mr-24 {\n    margin-right: 6rem;\n}\n\n.\\!k-mr-24 {\n    margin-right: 6rem !important;\n}\n\n.k-mr--1px {\n    margin-right: -1px;\n}\n\n.\\!k-mr--1px {\n    margin-right: -1px !important;\n}\n\n.k-mr--0\\.5 {\n    margin-right: -0.125rem;\n}\n\n.\\!k-mr--0\\.5 {\n    margin-right: -0.125rem !important;\n}\n\n.k-mr--1 {\n    margin-right: -0.25rem;\n}\n\n.\\!k-mr--1 {\n    margin-right: -0.25rem !important;\n}\n\n.k-mr--1\\.5 {\n    margin-right: -0.375rem;\n}\n\n.\\!k-mr--1\\.5 {\n    margin-right: -0.375rem !important;\n}\n\n.k-mr--2 {\n    margin-right: -0.5rem;\n}\n\n.\\!k-mr--2 {\n    margin-right: -0.5rem !important;\n}\n\n.k-mr--2\\.5 {\n    margin-right: -0.625rem;\n}\n\n.\\!k-mr--2\\.5 {\n    margin-right: -0.625rem !important;\n}\n\n.k-mr--3 {\n    margin-right: -0.75rem;\n}\n\n.\\!k-mr--3 {\n    margin-right: -0.75rem !important;\n}\n\n.k-mr--3\\.5 {\n    margin-right: -0.875rem;\n}\n\n.\\!k-mr--3\\.5 {\n    margin-right: -0.875rem !important;\n}\n\n.k-mr--4 {\n    margin-right: -1rem;\n}\n\n.\\!k-mr--4 {\n    margin-right: -1rem !important;\n}\n\n.k-mr--4\\.5 {\n    margin-right: -1.125rem;\n}\n\n.\\!k-mr--4\\.5 {\n    margin-right: -1.125rem !important;\n}\n\n.k-mr--5 {\n    margin-right: -1.25rem;\n}\n\n.\\!k-mr--5 {\n    margin-right: -1.25rem !important;\n}\n\n.k-mr--5\\.5 {\n    margin-right: -1.375rem;\n}\n\n.\\!k-mr--5\\.5 {\n    margin-right: -1.375rem !important;\n}\n\n.k-mr--6 {\n    margin-right: -1.5rem;\n}\n\n.\\!k-mr--6 {\n    margin-right: -1.5rem !important;\n}\n\n.k-mr--6\\.5 {\n    margin-right: -1.625rem;\n}\n\n.\\!k-mr--6\\.5 {\n    margin-right: -1.625rem !important;\n}\n\n.k-mr--7 {\n    margin-right: -1.75rem;\n}\n\n.\\!k-mr--7 {\n    margin-right: -1.75rem !important;\n}\n\n.k-mr--7\\.5 {\n    margin-right: -1.875rem;\n}\n\n.\\!k-mr--7\\.5 {\n    margin-right: -1.875rem !important;\n}\n\n.k-mr--8 {\n    margin-right: -2rem;\n}\n\n.\\!k-mr--8 {\n    margin-right: -2rem !important;\n}\n\n.k-mr--9 {\n    margin-right: -2.25rem;\n}\n\n.\\!k-mr--9 {\n    margin-right: -2.25rem !important;\n}\n\n.k-mr--10 {\n    margin-right: -2.5rem;\n}\n\n.\\!k-mr--10 {\n    margin-right: -2.5rem !important;\n}\n\n.k-mr--11 {\n    margin-right: -2.75rem;\n}\n\n.\\!k-mr--11 {\n    margin-right: -2.75rem !important;\n}\n\n.k-mr--12 {\n    margin-right: -3rem;\n}\n\n.\\!k-mr--12 {\n    margin-right: -3rem !important;\n}\n\n.k-mr--13 {\n    margin-right: -3.25rem;\n}\n\n.\\!k-mr--13 {\n    margin-right: -3.25rem !important;\n}\n\n.k-mr--14 {\n    margin-right: -3.5rem;\n}\n\n.\\!k-mr--14 {\n    margin-right: -3.5rem !important;\n}\n\n.k-mr--15 {\n    margin-right: -3.75rem;\n}\n\n.\\!k-mr--15 {\n    margin-right: -3.75rem !important;\n}\n\n.k-mr--16 {\n    margin-right: -4rem;\n}\n\n.\\!k-mr--16 {\n    margin-right: -4rem !important;\n}\n\n.k-mr--17 {\n    margin-right: -4.25rem;\n}\n\n.\\!k-mr--17 {\n    margin-right: -4.25rem !important;\n}\n\n.k-mr--18 {\n    margin-right: -4.5rem;\n}\n\n.\\!k-mr--18 {\n    margin-right: -4.5rem !important;\n}\n\n.k-mr--19 {\n    margin-right: -4.75rem;\n}\n\n.\\!k-mr--19 {\n    margin-right: -4.75rem !important;\n}\n\n.k-mr--20 {\n    margin-right: -5rem;\n}\n\n.\\!k-mr--20 {\n    margin-right: -5rem !important;\n}\n\n.k-mr--21 {\n    margin-right: -5.25rem;\n}\n\n.\\!k-mr--21 {\n    margin-right: -5.25rem !important;\n}\n\n.k-mr--22 {\n    margin-right: -5.5rem;\n}\n\n.\\!k-mr--22 {\n    margin-right: -5.5rem !important;\n}\n\n.k-mr--23 {\n    margin-right: -5.75rem;\n}\n\n.\\!k-mr--23 {\n    margin-right: -5.75rem !important;\n}\n\n.k-mr--24 {\n    margin-right: -6rem;\n}\n\n.\\!k-mr--24 {\n    margin-right: -6rem !important;\n}\n\n.k-mr-xs {\n    margin-right: 0.25rem;\n}\n\n.\\!k-mr-xs {\n    margin-right: 0.25rem !important;\n}\n\n.k-mr-sm {\n    margin-right: 0.5rem;\n}\n\n.\\!k-mr-sm {\n    margin-right: 0.5rem !important;\n}\n\n.k-mr-md {\n    margin-right: 0.75rem;\n}\n\n.\\!k-mr-md {\n    margin-right: 0.75rem !important;\n}\n\n.k-mr-lg {\n    margin-right: 1rem;\n}\n\n.\\!k-mr-lg {\n    margin-right: 1rem !important;\n}\n\n.k-mr-xl {\n    margin-right: 1.5rem;\n}\n\n.\\!k-mr-xl {\n    margin-right: 1.5rem !important;\n}\n\n.k-mr-thin {\n    margin-right: 0.125rem;\n}\n\n.\\!k-mr-thin {\n    margin-right: 0.125rem !important;\n}\n\n.k-mr-hair {\n    margin-right: 1px;\n}\n\n.\\!k-mr-hair {\n    margin-right: 1px !important;\n}\n\n.k-mr-auto {\n    margin-right: auto;\n}\n\n.\\!k-mr-auto {\n    margin-right: auto !important;\n}\n\n.k-mb-0 {\n    margin-bottom: 0;\n}\n\n.\\!k-mb-0 {\n    margin-bottom: 0 !important;\n}\n\n.k-mb-1px {\n    margin-bottom: 1px;\n}\n\n.\\!k-mb-1px {\n    margin-bottom: 1px !important;\n}\n\n.k-mb-0\\.5 {\n    margin-bottom: 0.125rem;\n}\n\n.\\!k-mb-0\\.5 {\n    margin-bottom: 0.125rem !important;\n}\n\n.k-mb-1 {\n    margin-bottom: 0.25rem;\n}\n\n.\\!k-mb-1 {\n    margin-bottom: 0.25rem !important;\n}\n\n.k-mb-1\\.5 {\n    margin-bottom: 0.375rem;\n}\n\n.\\!k-mb-1\\.5 {\n    margin-bottom: 0.375rem !important;\n}\n\n.k-mb-2 {\n    margin-bottom: 0.5rem;\n}\n\n.\\!k-mb-2 {\n    margin-bottom: 0.5rem !important;\n}\n\n.k-mb-2\\.5 {\n    margin-bottom: 0.625rem;\n}\n\n.\\!k-mb-2\\.5 {\n    margin-bottom: 0.625rem !important;\n}\n\n.k-mb-3 {\n    margin-bottom: 0.75rem;\n}\n\n.\\!k-mb-3 {\n    margin-bottom: 0.75rem !important;\n}\n\n.k-mb-3\\.5 {\n    margin-bottom: 0.875rem;\n}\n\n.\\!k-mb-3\\.5 {\n    margin-bottom: 0.875rem !important;\n}\n\n.k-mb-4 {\n    margin-bottom: 1rem;\n}\n\n.\\!k-mb-4 {\n    margin-bottom: 1rem !important;\n}\n\n.k-mb-4\\.5 {\n    margin-bottom: 1.125rem;\n}\n\n.\\!k-mb-4\\.5 {\n    margin-bottom: 1.125rem !important;\n}\n\n.k-mb-5 {\n    margin-bottom: 1.25rem;\n}\n\n.\\!k-mb-5 {\n    margin-bottom: 1.25rem !important;\n}\n\n.k-mb-5\\.5 {\n    margin-bottom: 1.375rem;\n}\n\n.\\!k-mb-5\\.5 {\n    margin-bottom: 1.375rem !important;\n}\n\n.k-mb-6 {\n    margin-bottom: 1.5rem;\n}\n\n.\\!k-mb-6 {\n    margin-bottom: 1.5rem !important;\n}\n\n.k-mb-6\\.5 {\n    margin-bottom: 1.625rem;\n}\n\n.\\!k-mb-6\\.5 {\n    margin-bottom: 1.625rem !important;\n}\n\n.k-mb-7 {\n    margin-bottom: 1.75rem;\n}\n\n.\\!k-mb-7 {\n    margin-bottom: 1.75rem !important;\n}\n\n.k-mb-7\\.5 {\n    margin-bottom: 1.875rem;\n}\n\n.\\!k-mb-7\\.5 {\n    margin-bottom: 1.875rem !important;\n}\n\n.k-mb-8 {\n    margin-bottom: 2rem;\n}\n\n.\\!k-mb-8 {\n    margin-bottom: 2rem !important;\n}\n\n.k-mb-9 {\n    margin-bottom: 2.25rem;\n}\n\n.\\!k-mb-9 {\n    margin-bottom: 2.25rem !important;\n}\n\n.k-mb-10 {\n    margin-bottom: 2.5rem;\n}\n\n.\\!k-mb-10 {\n    margin-bottom: 2.5rem !important;\n}\n\n.k-mb-11 {\n    margin-bottom: 2.75rem;\n}\n\n.\\!k-mb-11 {\n    margin-bottom: 2.75rem !important;\n}\n\n.k-mb-12 {\n    margin-bottom: 3rem;\n}\n\n.\\!k-mb-12 {\n    margin-bottom: 3rem !important;\n}\n\n.k-mb-13 {\n    margin-bottom: 3.25rem;\n}\n\n.\\!k-mb-13 {\n    margin-bottom: 3.25rem !important;\n}\n\n.k-mb-14 {\n    margin-bottom: 3.5rem;\n}\n\n.\\!k-mb-14 {\n    margin-bottom: 3.5rem !important;\n}\n\n.k-mb-15 {\n    margin-bottom: 3.75rem;\n}\n\n.\\!k-mb-15 {\n    margin-bottom: 3.75rem !important;\n}\n\n.k-mb-16 {\n    margin-bottom: 4rem;\n}\n\n.\\!k-mb-16 {\n    margin-bottom: 4rem !important;\n}\n\n.k-mb-17 {\n    margin-bottom: 4.25rem;\n}\n\n.\\!k-mb-17 {\n    margin-bottom: 4.25rem !important;\n}\n\n.k-mb-18 {\n    margin-bottom: 4.5rem;\n}\n\n.\\!k-mb-18 {\n    margin-bottom: 4.5rem !important;\n}\n\n.k-mb-19 {\n    margin-bottom: 4.75rem;\n}\n\n.\\!k-mb-19 {\n    margin-bottom: 4.75rem !important;\n}\n\n.k-mb-20 {\n    margin-bottom: 5rem;\n}\n\n.\\!k-mb-20 {\n    margin-bottom: 5rem !important;\n}\n\n.k-mb-21 {\n    margin-bottom: 5.25rem;\n}\n\n.\\!k-mb-21 {\n    margin-bottom: 5.25rem !important;\n}\n\n.k-mb-22 {\n    margin-bottom: 5.5rem;\n}\n\n.\\!k-mb-22 {\n    margin-bottom: 5.5rem !important;\n}\n\n.k-mb-23 {\n    margin-bottom: 5.75rem;\n}\n\n.\\!k-mb-23 {\n    margin-bottom: 5.75rem !important;\n}\n\n.k-mb-24 {\n    margin-bottom: 6rem;\n}\n\n.\\!k-mb-24 {\n    margin-bottom: 6rem !important;\n}\n\n.k-mb--1px {\n    margin-bottom: -1px;\n}\n\n.\\!k-mb--1px {\n    margin-bottom: -1px !important;\n}\n\n.k-mb--0\\.5 {\n    margin-bottom: -0.125rem;\n}\n\n.\\!k-mb--0\\.5 {\n    margin-bottom: -0.125rem !important;\n}\n\n.k-mb--1 {\n    margin-bottom: -0.25rem;\n}\n\n.\\!k-mb--1 {\n    margin-bottom: -0.25rem !important;\n}\n\n.k-mb--1\\.5 {\n    margin-bottom: -0.375rem;\n}\n\n.\\!k-mb--1\\.5 {\n    margin-bottom: -0.375rem !important;\n}\n\n.k-mb--2 {\n    margin-bottom: -0.5rem;\n}\n\n.\\!k-mb--2 {\n    margin-bottom: -0.5rem !important;\n}\n\n.k-mb--2\\.5 {\n    margin-bottom: -0.625rem;\n}\n\n.\\!k-mb--2\\.5 {\n    margin-bottom: -0.625rem !important;\n}\n\n.k-mb--3 {\n    margin-bottom: -0.75rem;\n}\n\n.\\!k-mb--3 {\n    margin-bottom: -0.75rem !important;\n}\n\n.k-mb--3\\.5 {\n    margin-bottom: -0.875rem;\n}\n\n.\\!k-mb--3\\.5 {\n    margin-bottom: -0.875rem !important;\n}\n\n.k-mb--4 {\n    margin-bottom: -1rem;\n}\n\n.\\!k-mb--4 {\n    margin-bottom: -1rem !important;\n}\n\n.k-mb--4\\.5 {\n    margin-bottom: -1.125rem;\n}\n\n.\\!k-mb--4\\.5 {\n    margin-bottom: -1.125rem !important;\n}\n\n.k-mb--5 {\n    margin-bottom: -1.25rem;\n}\n\n.\\!k-mb--5 {\n    margin-bottom: -1.25rem !important;\n}\n\n.k-mb--5\\.5 {\n    margin-bottom: -1.375rem;\n}\n\n.\\!k-mb--5\\.5 {\n    margin-bottom: -1.375rem !important;\n}\n\n.k-mb--6 {\n    margin-bottom: -1.5rem;\n}\n\n.\\!k-mb--6 {\n    margin-bottom: -1.5rem !important;\n}\n\n.k-mb--6\\.5 {\n    margin-bottom: -1.625rem;\n}\n\n.\\!k-mb--6\\.5 {\n    margin-bottom: -1.625rem !important;\n}\n\n.k-mb--7 {\n    margin-bottom: -1.75rem;\n}\n\n.\\!k-mb--7 {\n    margin-bottom: -1.75rem !important;\n}\n\n.k-mb--7\\.5 {\n    margin-bottom: -1.875rem;\n}\n\n.\\!k-mb--7\\.5 {\n    margin-bottom: -1.875rem !important;\n}\n\n.k-mb--8 {\n    margin-bottom: -2rem;\n}\n\n.\\!k-mb--8 {\n    margin-bottom: -2rem !important;\n}\n\n.k-mb--9 {\n    margin-bottom: -2.25rem;\n}\n\n.\\!k-mb--9 {\n    margin-bottom: -2.25rem !important;\n}\n\n.k-mb--10 {\n    margin-bottom: -2.5rem;\n}\n\n.\\!k-mb--10 {\n    margin-bottom: -2.5rem !important;\n}\n\n.k-mb--11 {\n    margin-bottom: -2.75rem;\n}\n\n.\\!k-mb--11 {\n    margin-bottom: -2.75rem !important;\n}\n\n.k-mb--12 {\n    margin-bottom: -3rem;\n}\n\n.\\!k-mb--12 {\n    margin-bottom: -3rem !important;\n}\n\n.k-mb--13 {\n    margin-bottom: -3.25rem;\n}\n\n.\\!k-mb--13 {\n    margin-bottom: -3.25rem !important;\n}\n\n.k-mb--14 {\n    margin-bottom: -3.5rem;\n}\n\n.\\!k-mb--14 {\n    margin-bottom: -3.5rem !important;\n}\n\n.k-mb--15 {\n    margin-bottom: -3.75rem;\n}\n\n.\\!k-mb--15 {\n    margin-bottom: -3.75rem !important;\n}\n\n.k-mb--16 {\n    margin-bottom: -4rem;\n}\n\n.\\!k-mb--16 {\n    margin-bottom: -4rem !important;\n}\n\n.k-mb--17 {\n    margin-bottom: -4.25rem;\n}\n\n.\\!k-mb--17 {\n    margin-bottom: -4.25rem !important;\n}\n\n.k-mb--18 {\n    margin-bottom: -4.5rem;\n}\n\n.\\!k-mb--18 {\n    margin-bottom: -4.5rem !important;\n}\n\n.k-mb--19 {\n    margin-bottom: -4.75rem;\n}\n\n.\\!k-mb--19 {\n    margin-bottom: -4.75rem !important;\n}\n\n.k-mb--20 {\n    margin-bottom: -5rem;\n}\n\n.\\!k-mb--20 {\n    margin-bottom: -5rem !important;\n}\n\n.k-mb--21 {\n    margin-bottom: -5.25rem;\n}\n\n.\\!k-mb--21 {\n    margin-bottom: -5.25rem !important;\n}\n\n.k-mb--22 {\n    margin-bottom: -5.5rem;\n}\n\n.\\!k-mb--22 {\n    margin-bottom: -5.5rem !important;\n}\n\n.k-mb--23 {\n    margin-bottom: -5.75rem;\n}\n\n.\\!k-mb--23 {\n    margin-bottom: -5.75rem !important;\n}\n\n.k-mb--24 {\n    margin-bottom: -6rem;\n}\n\n.\\!k-mb--24 {\n    margin-bottom: -6rem !important;\n}\n\n.k-mb-xs {\n    margin-bottom: 0.25rem;\n}\n\n.\\!k-mb-xs {\n    margin-bottom: 0.25rem !important;\n}\n\n.k-mb-sm {\n    margin-bottom: 0.5rem;\n}\n\n.\\!k-mb-sm {\n    margin-bottom: 0.5rem !important;\n}\n\n.k-mb-md {\n    margin-bottom: 0.75rem;\n}\n\n.\\!k-mb-md {\n    margin-bottom: 0.75rem !important;\n}\n\n.k-mb-lg {\n    margin-bottom: 1rem;\n}\n\n.\\!k-mb-lg {\n    margin-bottom: 1rem !important;\n}\n\n.k-mb-xl {\n    margin-bottom: 1.5rem;\n}\n\n.\\!k-mb-xl {\n    margin-bottom: 1.5rem !important;\n}\n\n.k-mb-thin {\n    margin-bottom: 0.125rem;\n}\n\n.\\!k-mb-thin {\n    margin-bottom: 0.125rem !important;\n}\n\n.k-mb-hair {\n    margin-bottom: 1px;\n}\n\n.\\!k-mb-hair {\n    margin-bottom: 1px !important;\n}\n\n.k-mb-auto {\n    margin-bottom: auto;\n}\n\n.\\!k-mb-auto {\n    margin-bottom: auto !important;\n}\n\n.k-ml-0 {\n    margin-left: 0;\n}\n\n.\\!k-ml-0 {\n    margin-left: 0 !important;\n}\n\n.k-ml-1px {\n    margin-left: 1px;\n}\n\n.\\!k-ml-1px {\n    margin-left: 1px !important;\n}\n\n.k-ml-0\\.5 {\n    margin-left: 0.125rem;\n}\n\n.\\!k-ml-0\\.5 {\n    margin-left: 0.125rem !important;\n}\n\n.k-ml-1 {\n    margin-left: 0.25rem;\n}\n\n.\\!k-ml-1 {\n    margin-left: 0.25rem !important;\n}\n\n.k-ml-1\\.5 {\n    margin-left: 0.375rem;\n}\n\n.\\!k-ml-1\\.5 {\n    margin-left: 0.375rem !important;\n}\n\n.k-ml-2 {\n    margin-left: 0.5rem;\n}\n\n.\\!k-ml-2 {\n    margin-left: 0.5rem !important;\n}\n\n.k-ml-2\\.5 {\n    margin-left: 0.625rem;\n}\n\n.\\!k-ml-2\\.5 {\n    margin-left: 0.625rem !important;\n}\n\n.k-ml-3 {\n    margin-left: 0.75rem;\n}\n\n.\\!k-ml-3 {\n    margin-left: 0.75rem !important;\n}\n\n.k-ml-3\\.5 {\n    margin-left: 0.875rem;\n}\n\n.\\!k-ml-3\\.5 {\n    margin-left: 0.875rem !important;\n}\n\n.k-ml-4 {\n    margin-left: 1rem;\n}\n\n.\\!k-ml-4 {\n    margin-left: 1rem !important;\n}\n\n.k-ml-4\\.5 {\n    margin-left: 1.125rem;\n}\n\n.\\!k-ml-4\\.5 {\n    margin-left: 1.125rem !important;\n}\n\n.k-ml-5 {\n    margin-left: 1.25rem;\n}\n\n.\\!k-ml-5 {\n    margin-left: 1.25rem !important;\n}\n\n.k-ml-5\\.5 {\n    margin-left: 1.375rem;\n}\n\n.\\!k-ml-5\\.5 {\n    margin-left: 1.375rem !important;\n}\n\n.k-ml-6 {\n    margin-left: 1.5rem;\n}\n\n.\\!k-ml-6 {\n    margin-left: 1.5rem !important;\n}\n\n.k-ml-6\\.5 {\n    margin-left: 1.625rem;\n}\n\n.\\!k-ml-6\\.5 {\n    margin-left: 1.625rem !important;\n}\n\n.k-ml-7 {\n    margin-left: 1.75rem;\n}\n\n.\\!k-ml-7 {\n    margin-left: 1.75rem !important;\n}\n\n.k-ml-7\\.5 {\n    margin-left: 1.875rem;\n}\n\n.\\!k-ml-7\\.5 {\n    margin-left: 1.875rem !important;\n}\n\n.k-ml-8 {\n    margin-left: 2rem;\n}\n\n.\\!k-ml-8 {\n    margin-left: 2rem !important;\n}\n\n.k-ml-9 {\n    margin-left: 2.25rem;\n}\n\n.\\!k-ml-9 {\n    margin-left: 2.25rem !important;\n}\n\n.k-ml-10 {\n    margin-left: 2.5rem;\n}\n\n.\\!k-ml-10 {\n    margin-left: 2.5rem !important;\n}\n\n.k-ml-11 {\n    margin-left: 2.75rem;\n}\n\n.\\!k-ml-11 {\n    margin-left: 2.75rem !important;\n}\n\n.k-ml-12 {\n    margin-left: 3rem;\n}\n\n.\\!k-ml-12 {\n    margin-left: 3rem !important;\n}\n\n.k-ml-13 {\n    margin-left: 3.25rem;\n}\n\n.\\!k-ml-13 {\n    margin-left: 3.25rem !important;\n}\n\n.k-ml-14 {\n    margin-left: 3.5rem;\n}\n\n.\\!k-ml-14 {\n    margin-left: 3.5rem !important;\n}\n\n.k-ml-15 {\n    margin-left: 3.75rem;\n}\n\n.\\!k-ml-15 {\n    margin-left: 3.75rem !important;\n}\n\n.k-ml-16 {\n    margin-left: 4rem;\n}\n\n.\\!k-ml-16 {\n    margin-left: 4rem !important;\n}\n\n.k-ml-17 {\n    margin-left: 4.25rem;\n}\n\n.\\!k-ml-17 {\n    margin-left: 4.25rem !important;\n}\n\n.k-ml-18 {\n    margin-left: 4.5rem;\n}\n\n.\\!k-ml-18 {\n    margin-left: 4.5rem !important;\n}\n\n.k-ml-19 {\n    margin-left: 4.75rem;\n}\n\n.\\!k-ml-19 {\n    margin-left: 4.75rem !important;\n}\n\n.k-ml-20 {\n    margin-left: 5rem;\n}\n\n.\\!k-ml-20 {\n    margin-left: 5rem !important;\n}\n\n.k-ml-21 {\n    margin-left: 5.25rem;\n}\n\n.\\!k-ml-21 {\n    margin-left: 5.25rem !important;\n}\n\n.k-ml-22 {\n    margin-left: 5.5rem;\n}\n\n.\\!k-ml-22 {\n    margin-left: 5.5rem !important;\n}\n\n.k-ml-23 {\n    margin-left: 5.75rem;\n}\n\n.\\!k-ml-23 {\n    margin-left: 5.75rem !important;\n}\n\n.k-ml-24 {\n    margin-left: 6rem;\n}\n\n.\\!k-ml-24 {\n    margin-left: 6rem !important;\n}\n\n.k-ml--1px {\n    margin-left: -1px;\n}\n\n.\\!k-ml--1px {\n    margin-left: -1px !important;\n}\n\n.k-ml--0\\.5 {\n    margin-left: -0.125rem;\n}\n\n.\\!k-ml--0\\.5 {\n    margin-left: -0.125rem !important;\n}\n\n.k-ml--1 {\n    margin-left: -0.25rem;\n}\n\n.\\!k-ml--1 {\n    margin-left: -0.25rem !important;\n}\n\n.k-ml--1\\.5 {\n    margin-left: -0.375rem;\n}\n\n.\\!k-ml--1\\.5 {\n    margin-left: -0.375rem !important;\n}\n\n.k-ml--2 {\n    margin-left: -0.5rem;\n}\n\n.\\!k-ml--2 {\n    margin-left: -0.5rem !important;\n}\n\n.k-ml--2\\.5 {\n    margin-left: -0.625rem;\n}\n\n.\\!k-ml--2\\.5 {\n    margin-left: -0.625rem !important;\n}\n\n.k-ml--3 {\n    margin-left: -0.75rem;\n}\n\n.\\!k-ml--3 {\n    margin-left: -0.75rem !important;\n}\n\n.k-ml--3\\.5 {\n    margin-left: -0.875rem;\n}\n\n.\\!k-ml--3\\.5 {\n    margin-left: -0.875rem !important;\n}\n\n.k-ml--4 {\n    margin-left: -1rem;\n}\n\n.\\!k-ml--4 {\n    margin-left: -1rem !important;\n}\n\n.k-ml--4\\.5 {\n    margin-left: -1.125rem;\n}\n\n.\\!k-ml--4\\.5 {\n    margin-left: -1.125rem !important;\n}\n\n.k-ml--5 {\n    margin-left: -1.25rem;\n}\n\n.\\!k-ml--5 {\n    margin-left: -1.25rem !important;\n}\n\n.k-ml--5\\.5 {\n    margin-left: -1.375rem;\n}\n\n.\\!k-ml--5\\.5 {\n    margin-left: -1.375rem !important;\n}\n\n.k-ml--6 {\n    margin-left: -1.5rem;\n}\n\n.\\!k-ml--6 {\n    margin-left: -1.5rem !important;\n}\n\n.k-ml--6\\.5 {\n    margin-left: -1.625rem;\n}\n\n.\\!k-ml--6\\.5 {\n    margin-left: -1.625rem !important;\n}\n\n.k-ml--7 {\n    margin-left: -1.75rem;\n}\n\n.\\!k-ml--7 {\n    margin-left: -1.75rem !important;\n}\n\n.k-ml--7\\.5 {\n    margin-left: -1.875rem;\n}\n\n.\\!k-ml--7\\.5 {\n    margin-left: -1.875rem !important;\n}\n\n.k-ml--8 {\n    margin-left: -2rem;\n}\n\n.\\!k-ml--8 {\n    margin-left: -2rem !important;\n}\n\n.k-ml--9 {\n    margin-left: -2.25rem;\n}\n\n.\\!k-ml--9 {\n    margin-left: -2.25rem !important;\n}\n\n.k-ml--10 {\n    margin-left: -2.5rem;\n}\n\n.\\!k-ml--10 {\n    margin-left: -2.5rem !important;\n}\n\n.k-ml--11 {\n    margin-left: -2.75rem;\n}\n\n.\\!k-ml--11 {\n    margin-left: -2.75rem !important;\n}\n\n.k-ml--12 {\n    margin-left: -3rem;\n}\n\n.\\!k-ml--12 {\n    margin-left: -3rem !important;\n}\n\n.k-ml--13 {\n    margin-left: -3.25rem;\n}\n\n.\\!k-ml--13 {\n    margin-left: -3.25rem !important;\n}\n\n.k-ml--14 {\n    margin-left: -3.5rem;\n}\n\n.\\!k-ml--14 {\n    margin-left: -3.5rem !important;\n}\n\n.k-ml--15 {\n    margin-left: -3.75rem;\n}\n\n.\\!k-ml--15 {\n    margin-left: -3.75rem !important;\n}\n\n.k-ml--16 {\n    margin-left: -4rem;\n}\n\n.\\!k-ml--16 {\n    margin-left: -4rem !important;\n}\n\n.k-ml--17 {\n    margin-left: -4.25rem;\n}\n\n.\\!k-ml--17 {\n    margin-left: -4.25rem !important;\n}\n\n.k-ml--18 {\n    margin-left: -4.5rem;\n}\n\n.\\!k-ml--18 {\n    margin-left: -4.5rem !important;\n}\n\n.k-ml--19 {\n    margin-left: -4.75rem;\n}\n\n.\\!k-ml--19 {\n    margin-left: -4.75rem !important;\n}\n\n.k-ml--20 {\n    margin-left: -5rem;\n}\n\n.\\!k-ml--20 {\n    margin-left: -5rem !important;\n}\n\n.k-ml--21 {\n    margin-left: -5.25rem;\n}\n\n.\\!k-ml--21 {\n    margin-left: -5.25rem !important;\n}\n\n.k-ml--22 {\n    margin-left: -5.5rem;\n}\n\n.\\!k-ml--22 {\n    margin-left: -5.5rem !important;\n}\n\n.k-ml--23 {\n    margin-left: -5.75rem;\n}\n\n.\\!k-ml--23 {\n    margin-left: -5.75rem !important;\n}\n\n.k-ml--24 {\n    margin-left: -6rem;\n}\n\n.\\!k-ml--24 {\n    margin-left: -6rem !important;\n}\n\n.k-ml-xs {\n    margin-left: 0.25rem;\n}\n\n.\\!k-ml-xs {\n    margin-left: 0.25rem !important;\n}\n\n.k-ml-sm {\n    margin-left: 0.5rem;\n}\n\n.\\!k-ml-sm {\n    margin-left: 0.5rem !important;\n}\n\n.k-ml-md {\n    margin-left: 0.75rem;\n}\n\n.\\!k-ml-md {\n    margin-left: 0.75rem !important;\n}\n\n.k-ml-lg {\n    margin-left: 1rem;\n}\n\n.\\!k-ml-lg {\n    margin-left: 1rem !important;\n}\n\n.k-ml-xl {\n    margin-left: 1.5rem;\n}\n\n.\\!k-ml-xl {\n    margin-left: 1.5rem !important;\n}\n\n.k-ml-thin {\n    margin-left: 0.125rem;\n}\n\n.\\!k-ml-thin {\n    margin-left: 0.125rem !important;\n}\n\n.k-ml-hair {\n    margin-left: 1px;\n}\n\n.\\!k-ml-hair {\n    margin-left: 1px !important;\n}\n\n.k-ml-auto {\n    margin-left: auto;\n}\n\n.\\!k-ml-auto {\n    margin-left: auto !important;\n}\n\n.k-mx-0 {\n    margin-inline: 0;\n}\n\n.\\!k-mx-0 {\n    margin-inline: 0 !important;\n}\n\n.k-mx-1px {\n    margin-inline: 1px;\n}\n\n.\\!k-mx-1px {\n    margin-inline: 1px !important;\n}\n\n.k-mx-0\\.5 {\n    margin-inline: 0.125rem;\n}\n\n.\\!k-mx-0\\.5 {\n    margin-inline: 0.125rem !important;\n}\n\n.k-mx-1 {\n    margin-inline: 0.25rem;\n}\n\n.\\!k-mx-1 {\n    margin-inline: 0.25rem !important;\n}\n\n.k-mx-1\\.5 {\n    margin-inline: 0.375rem;\n}\n\n.\\!k-mx-1\\.5 {\n    margin-inline: 0.375rem !important;\n}\n\n.k-mx-2 {\n    margin-inline: 0.5rem;\n}\n\n.\\!k-mx-2 {\n    margin-inline: 0.5rem !important;\n}\n\n.k-mx-2\\.5 {\n    margin-inline: 0.625rem;\n}\n\n.\\!k-mx-2\\.5 {\n    margin-inline: 0.625rem !important;\n}\n\n.k-mx-3 {\n    margin-inline: 0.75rem;\n}\n\n.\\!k-mx-3 {\n    margin-inline: 0.75rem !important;\n}\n\n.k-mx-3\\.5 {\n    margin-inline: 0.875rem;\n}\n\n.\\!k-mx-3\\.5 {\n    margin-inline: 0.875rem !important;\n}\n\n.k-mx-4 {\n    margin-inline: 1rem;\n}\n\n.\\!k-mx-4 {\n    margin-inline: 1rem !important;\n}\n\n.k-mx-4\\.5 {\n    margin-inline: 1.125rem;\n}\n\n.\\!k-mx-4\\.5 {\n    margin-inline: 1.125rem !important;\n}\n\n.k-mx-5 {\n    margin-inline: 1.25rem;\n}\n\n.\\!k-mx-5 {\n    margin-inline: 1.25rem !important;\n}\n\n.k-mx-5\\.5 {\n    margin-inline: 1.375rem;\n}\n\n.\\!k-mx-5\\.5 {\n    margin-inline: 1.375rem !important;\n}\n\n.k-mx-6 {\n    margin-inline: 1.5rem;\n}\n\n.\\!k-mx-6 {\n    margin-inline: 1.5rem !important;\n}\n\n.k-mx-6\\.5 {\n    margin-inline: 1.625rem;\n}\n\n.\\!k-mx-6\\.5 {\n    margin-inline: 1.625rem !important;\n}\n\n.k-mx-7 {\n    margin-inline: 1.75rem;\n}\n\n.\\!k-mx-7 {\n    margin-inline: 1.75rem !important;\n}\n\n.k-mx-7\\.5 {\n    margin-inline: 1.875rem;\n}\n\n.\\!k-mx-7\\.5 {\n    margin-inline: 1.875rem !important;\n}\n\n.k-mx-8 {\n    margin-inline: 2rem;\n}\n\n.\\!k-mx-8 {\n    margin-inline: 2rem !important;\n}\n\n.k-mx-9 {\n    margin-inline: 2.25rem;\n}\n\n.\\!k-mx-9 {\n    margin-inline: 2.25rem !important;\n}\n\n.k-mx-10 {\n    margin-inline: 2.5rem;\n}\n\n.\\!k-mx-10 {\n    margin-inline: 2.5rem !important;\n}\n\n.k-mx-11 {\n    margin-inline: 2.75rem;\n}\n\n.\\!k-mx-11 {\n    margin-inline: 2.75rem !important;\n}\n\n.k-mx-12 {\n    margin-inline: 3rem;\n}\n\n.\\!k-mx-12 {\n    margin-inline: 3rem !important;\n}\n\n.k-mx-13 {\n    margin-inline: 3.25rem;\n}\n\n.\\!k-mx-13 {\n    margin-inline: 3.25rem !important;\n}\n\n.k-mx-14 {\n    margin-inline: 3.5rem;\n}\n\n.\\!k-mx-14 {\n    margin-inline: 3.5rem !important;\n}\n\n.k-mx-15 {\n    margin-inline: 3.75rem;\n}\n\n.\\!k-mx-15 {\n    margin-inline: 3.75rem !important;\n}\n\n.k-mx-16 {\n    margin-inline: 4rem;\n}\n\n.\\!k-mx-16 {\n    margin-inline: 4rem !important;\n}\n\n.k-mx-17 {\n    margin-inline: 4.25rem;\n}\n\n.\\!k-mx-17 {\n    margin-inline: 4.25rem !important;\n}\n\n.k-mx-18 {\n    margin-inline: 4.5rem;\n}\n\n.\\!k-mx-18 {\n    margin-inline: 4.5rem !important;\n}\n\n.k-mx-19 {\n    margin-inline: 4.75rem;\n}\n\n.\\!k-mx-19 {\n    margin-inline: 4.75rem !important;\n}\n\n.k-mx-20 {\n    margin-inline: 5rem;\n}\n\n.\\!k-mx-20 {\n    margin-inline: 5rem !important;\n}\n\n.k-mx-21 {\n    margin-inline: 5.25rem;\n}\n\n.\\!k-mx-21 {\n    margin-inline: 5.25rem !important;\n}\n\n.k-mx-22 {\n    margin-inline: 5.5rem;\n}\n\n.\\!k-mx-22 {\n    margin-inline: 5.5rem !important;\n}\n\n.k-mx-23 {\n    margin-inline: 5.75rem;\n}\n\n.\\!k-mx-23 {\n    margin-inline: 5.75rem !important;\n}\n\n.k-mx-24 {\n    margin-inline: 6rem;\n}\n\n.\\!k-mx-24 {\n    margin-inline: 6rem !important;\n}\n\n.k-mx--1px {\n    margin-inline: -1px;\n}\n\n.\\!k-mx--1px {\n    margin-inline: -1px !important;\n}\n\n.k-mx--0\\.5 {\n    margin-inline: -0.125rem;\n}\n\n.\\!k-mx--0\\.5 {\n    margin-inline: -0.125rem !important;\n}\n\n.k-mx--1 {\n    margin-inline: -0.25rem;\n}\n\n.\\!k-mx--1 {\n    margin-inline: -0.25rem !important;\n}\n\n.k-mx--1\\.5 {\n    margin-inline: -0.375rem;\n}\n\n.\\!k-mx--1\\.5 {\n    margin-inline: -0.375rem !important;\n}\n\n.k-mx--2 {\n    margin-inline: -0.5rem;\n}\n\n.\\!k-mx--2 {\n    margin-inline: -0.5rem !important;\n}\n\n.k-mx--2\\.5 {\n    margin-inline: -0.625rem;\n}\n\n.\\!k-mx--2\\.5 {\n    margin-inline: -0.625rem !important;\n}\n\n.k-mx--3 {\n    margin-inline: -0.75rem;\n}\n\n.\\!k-mx--3 {\n    margin-inline: -0.75rem !important;\n}\n\n.k-mx--3\\.5 {\n    margin-inline: -0.875rem;\n}\n\n.\\!k-mx--3\\.5 {\n    margin-inline: -0.875rem !important;\n}\n\n.k-mx--4 {\n    margin-inline: -1rem;\n}\n\n.\\!k-mx--4 {\n    margin-inline: -1rem !important;\n}\n\n.k-mx--4\\.5 {\n    margin-inline: -1.125rem;\n}\n\n.\\!k-mx--4\\.5 {\n    margin-inline: -1.125rem !important;\n}\n\n.k-mx--5 {\n    margin-inline: -1.25rem;\n}\n\n.\\!k-mx--5 {\n    margin-inline: -1.25rem !important;\n}\n\n.k-mx--5\\.5 {\n    margin-inline: -1.375rem;\n}\n\n.\\!k-mx--5\\.5 {\n    margin-inline: -1.375rem !important;\n}\n\n.k-mx--6 {\n    margin-inline: -1.5rem;\n}\n\n.\\!k-mx--6 {\n    margin-inline: -1.5rem !important;\n}\n\n.k-mx--6\\.5 {\n    margin-inline: -1.625rem;\n}\n\n.\\!k-mx--6\\.5 {\n    margin-inline: -1.625rem !important;\n}\n\n.k-mx--7 {\n    margin-inline: -1.75rem;\n}\n\n.\\!k-mx--7 {\n    margin-inline: -1.75rem !important;\n}\n\n.k-mx--7\\.5 {\n    margin-inline: -1.875rem;\n}\n\n.\\!k-mx--7\\.5 {\n    margin-inline: -1.875rem !important;\n}\n\n.k-mx--8 {\n    margin-inline: -2rem;\n}\n\n.\\!k-mx--8 {\n    margin-inline: -2rem !important;\n}\n\n.k-mx--9 {\n    margin-inline: -2.25rem;\n}\n\n.\\!k-mx--9 {\n    margin-inline: -2.25rem !important;\n}\n\n.k-mx--10 {\n    margin-inline: -2.5rem;\n}\n\n.\\!k-mx--10 {\n    margin-inline: -2.5rem !important;\n}\n\n.k-mx--11 {\n    margin-inline: -2.75rem;\n}\n\n.\\!k-mx--11 {\n    margin-inline: -2.75rem !important;\n}\n\n.k-mx--12 {\n    margin-inline: -3rem;\n}\n\n.\\!k-mx--12 {\n    margin-inline: -3rem !important;\n}\n\n.k-mx--13 {\n    margin-inline: -3.25rem;\n}\n\n.\\!k-mx--13 {\n    margin-inline: -3.25rem !important;\n}\n\n.k-mx--14 {\n    margin-inline: -3.5rem;\n}\n\n.\\!k-mx--14 {\n    margin-inline: -3.5rem !important;\n}\n\n.k-mx--15 {\n    margin-inline: -3.75rem;\n}\n\n.\\!k-mx--15 {\n    margin-inline: -3.75rem !important;\n}\n\n.k-mx--16 {\n    margin-inline: -4rem;\n}\n\n.\\!k-mx--16 {\n    margin-inline: -4rem !important;\n}\n\n.k-mx--17 {\n    margin-inline: -4.25rem;\n}\n\n.\\!k-mx--17 {\n    margin-inline: -4.25rem !important;\n}\n\n.k-mx--18 {\n    margin-inline: -4.5rem;\n}\n\n.\\!k-mx--18 {\n    margin-inline: -4.5rem !important;\n}\n\n.k-mx--19 {\n    margin-inline: -4.75rem;\n}\n\n.\\!k-mx--19 {\n    margin-inline: -4.75rem !important;\n}\n\n.k-mx--20 {\n    margin-inline: -5rem;\n}\n\n.\\!k-mx--20 {\n    margin-inline: -5rem !important;\n}\n\n.k-mx--21 {\n    margin-inline: -5.25rem;\n}\n\n.\\!k-mx--21 {\n    margin-inline: -5.25rem !important;\n}\n\n.k-mx--22 {\n    margin-inline: -5.5rem;\n}\n\n.\\!k-mx--22 {\n    margin-inline: -5.5rem !important;\n}\n\n.k-mx--23 {\n    margin-inline: -5.75rem;\n}\n\n.\\!k-mx--23 {\n    margin-inline: -5.75rem !important;\n}\n\n.k-mx--24 {\n    margin-inline: -6rem;\n}\n\n.\\!k-mx--24 {\n    margin-inline: -6rem !important;\n}\n\n.k-mx-xs {\n    margin-inline: 0.25rem;\n}\n\n.\\!k-mx-xs {\n    margin-inline: 0.25rem !important;\n}\n\n.k-mx-sm {\n    margin-inline: 0.5rem;\n}\n\n.\\!k-mx-sm {\n    margin-inline: 0.5rem !important;\n}\n\n.k-mx-md {\n    margin-inline: 0.75rem;\n}\n\n.\\!k-mx-md {\n    margin-inline: 0.75rem !important;\n}\n\n.k-mx-lg {\n    margin-inline: 1rem;\n}\n\n.\\!k-mx-lg {\n    margin-inline: 1rem !important;\n}\n\n.k-mx-xl {\n    margin-inline: 1.5rem;\n}\n\n.\\!k-mx-xl {\n    margin-inline: 1.5rem !important;\n}\n\n.k-mx-thin {\n    margin-inline: 0.125rem;\n}\n\n.\\!k-mx-thin {\n    margin-inline: 0.125rem !important;\n}\n\n.k-mx-hair {\n    margin-inline: 1px;\n}\n\n.\\!k-mx-hair {\n    margin-inline: 1px !important;\n}\n\n.k-mx-auto {\n    margin-inline: auto;\n}\n\n.\\!k-mx-auto {\n    margin-inline: auto !important;\n}\n\n.k-my-0 {\n    margin-block: 0;\n}\n\n.\\!k-my-0 {\n    margin-block: 0 !important;\n}\n\n.k-my-1px {\n    margin-block: 1px;\n}\n\n.\\!k-my-1px {\n    margin-block: 1px !important;\n}\n\n.k-my-0\\.5 {\n    margin-block: 0.125rem;\n}\n\n.\\!k-my-0\\.5 {\n    margin-block: 0.125rem !important;\n}\n\n.k-my-1 {\n    margin-block: 0.25rem;\n}\n\n.\\!k-my-1 {\n    margin-block: 0.25rem !important;\n}\n\n.k-my-1\\.5 {\n    margin-block: 0.375rem;\n}\n\n.\\!k-my-1\\.5 {\n    margin-block: 0.375rem !important;\n}\n\n.k-my-2 {\n    margin-block: 0.5rem;\n}\n\n.\\!k-my-2 {\n    margin-block: 0.5rem !important;\n}\n\n.k-my-2\\.5 {\n    margin-block: 0.625rem;\n}\n\n.\\!k-my-2\\.5 {\n    margin-block: 0.625rem !important;\n}\n\n.k-my-3 {\n    margin-block: 0.75rem;\n}\n\n.\\!k-my-3 {\n    margin-block: 0.75rem !important;\n}\n\n.k-my-3\\.5 {\n    margin-block: 0.875rem;\n}\n\n.\\!k-my-3\\.5 {\n    margin-block: 0.875rem !important;\n}\n\n.k-my-4 {\n    margin-block: 1rem;\n}\n\n.\\!k-my-4 {\n    margin-block: 1rem !important;\n}\n\n.k-my-4\\.5 {\n    margin-block: 1.125rem;\n}\n\n.\\!k-my-4\\.5 {\n    margin-block: 1.125rem !important;\n}\n\n.k-my-5 {\n    margin-block: 1.25rem;\n}\n\n.\\!k-my-5 {\n    margin-block: 1.25rem !important;\n}\n\n.k-my-5\\.5 {\n    margin-block: 1.375rem;\n}\n\n.\\!k-my-5\\.5 {\n    margin-block: 1.375rem !important;\n}\n\n.k-my-6 {\n    margin-block: 1.5rem;\n}\n\n.\\!k-my-6 {\n    margin-block: 1.5rem !important;\n}\n\n.k-my-6\\.5 {\n    margin-block: 1.625rem;\n}\n\n.\\!k-my-6\\.5 {\n    margin-block: 1.625rem !important;\n}\n\n.k-my-7 {\n    margin-block: 1.75rem;\n}\n\n.\\!k-my-7 {\n    margin-block: 1.75rem !important;\n}\n\n.k-my-7\\.5 {\n    margin-block: 1.875rem;\n}\n\n.\\!k-my-7\\.5 {\n    margin-block: 1.875rem !important;\n}\n\n.k-my-8 {\n    margin-block: 2rem;\n}\n\n.\\!k-my-8 {\n    margin-block: 2rem !important;\n}\n\n.k-my-9 {\n    margin-block: 2.25rem;\n}\n\n.\\!k-my-9 {\n    margin-block: 2.25rem !important;\n}\n\n.k-my-10 {\n    margin-block: 2.5rem;\n}\n\n.\\!k-my-10 {\n    margin-block: 2.5rem !important;\n}\n\n.k-my-11 {\n    margin-block: 2.75rem;\n}\n\n.\\!k-my-11 {\n    margin-block: 2.75rem !important;\n}\n\n.k-my-12 {\n    margin-block: 3rem;\n}\n\n.\\!k-my-12 {\n    margin-block: 3rem !important;\n}\n\n.k-my-13 {\n    margin-block: 3.25rem;\n}\n\n.\\!k-my-13 {\n    margin-block: 3.25rem !important;\n}\n\n.k-my-14 {\n    margin-block: 3.5rem;\n}\n\n.\\!k-my-14 {\n    margin-block: 3.5rem !important;\n}\n\n.k-my-15 {\n    margin-block: 3.75rem;\n}\n\n.\\!k-my-15 {\n    margin-block: 3.75rem !important;\n}\n\n.k-my-16 {\n    margin-block: 4rem;\n}\n\n.\\!k-my-16 {\n    margin-block: 4rem !important;\n}\n\n.k-my-17 {\n    margin-block: 4.25rem;\n}\n\n.\\!k-my-17 {\n    margin-block: 4.25rem !important;\n}\n\n.k-my-18 {\n    margin-block: 4.5rem;\n}\n\n.\\!k-my-18 {\n    margin-block: 4.5rem !important;\n}\n\n.k-my-19 {\n    margin-block: 4.75rem;\n}\n\n.\\!k-my-19 {\n    margin-block: 4.75rem !important;\n}\n\n.k-my-20 {\n    margin-block: 5rem;\n}\n\n.\\!k-my-20 {\n    margin-block: 5rem !important;\n}\n\n.k-my-21 {\n    margin-block: 5.25rem;\n}\n\n.\\!k-my-21 {\n    margin-block: 5.25rem !important;\n}\n\n.k-my-22 {\n    margin-block: 5.5rem;\n}\n\n.\\!k-my-22 {\n    margin-block: 5.5rem !important;\n}\n\n.k-my-23 {\n    margin-block: 5.75rem;\n}\n\n.\\!k-my-23 {\n    margin-block: 5.75rem !important;\n}\n\n.k-my-24 {\n    margin-block: 6rem;\n}\n\n.\\!k-my-24 {\n    margin-block: 6rem !important;\n}\n\n.k-my--1px {\n    margin-block: -1px;\n}\n\n.\\!k-my--1px {\n    margin-block: -1px !important;\n}\n\n.k-my--0\\.5 {\n    margin-block: -0.125rem;\n}\n\n.\\!k-my--0\\.5 {\n    margin-block: -0.125rem !important;\n}\n\n.k-my--1 {\n    margin-block: -0.25rem;\n}\n\n.\\!k-my--1 {\n    margin-block: -0.25rem !important;\n}\n\n.k-my--1\\.5 {\n    margin-block: -0.375rem;\n}\n\n.\\!k-my--1\\.5 {\n    margin-block: -0.375rem !important;\n}\n\n.k-my--2 {\n    margin-block: -0.5rem;\n}\n\n.\\!k-my--2 {\n    margin-block: -0.5rem !important;\n}\n\n.k-my--2\\.5 {\n    margin-block: -0.625rem;\n}\n\n.\\!k-my--2\\.5 {\n    margin-block: -0.625rem !important;\n}\n\n.k-my--3 {\n    margin-block: -0.75rem;\n}\n\n.\\!k-my--3 {\n    margin-block: -0.75rem !important;\n}\n\n.k-my--3\\.5 {\n    margin-block: -0.875rem;\n}\n\n.\\!k-my--3\\.5 {\n    margin-block: -0.875rem !important;\n}\n\n.k-my--4 {\n    margin-block: -1rem;\n}\n\n.\\!k-my--4 {\n    margin-block: -1rem !important;\n}\n\n.k-my--4\\.5 {\n    margin-block: -1.125rem;\n}\n\n.\\!k-my--4\\.5 {\n    margin-block: -1.125rem !important;\n}\n\n.k-my--5 {\n    margin-block: -1.25rem;\n}\n\n.\\!k-my--5 {\n    margin-block: -1.25rem !important;\n}\n\n.k-my--5\\.5 {\n    margin-block: -1.375rem;\n}\n\n.\\!k-my--5\\.5 {\n    margin-block: -1.375rem !important;\n}\n\n.k-my--6 {\n    margin-block: -1.5rem;\n}\n\n.\\!k-my--6 {\n    margin-block: -1.5rem !important;\n}\n\n.k-my--6\\.5 {\n    margin-block: -1.625rem;\n}\n\n.\\!k-my--6\\.5 {\n    margin-block: -1.625rem !important;\n}\n\n.k-my--7 {\n    margin-block: -1.75rem;\n}\n\n.\\!k-my--7 {\n    margin-block: -1.75rem !important;\n}\n\n.k-my--7\\.5 {\n    margin-block: -1.875rem;\n}\n\n.\\!k-my--7\\.5 {\n    margin-block: -1.875rem !important;\n}\n\n.k-my--8 {\n    margin-block: -2rem;\n}\n\n.\\!k-my--8 {\n    margin-block: -2rem !important;\n}\n\n.k-my--9 {\n    margin-block: -2.25rem;\n}\n\n.\\!k-my--9 {\n    margin-block: -2.25rem !important;\n}\n\n.k-my--10 {\n    margin-block: -2.5rem;\n}\n\n.\\!k-my--10 {\n    margin-block: -2.5rem !important;\n}\n\n.k-my--11 {\n    margin-block: -2.75rem;\n}\n\n.\\!k-my--11 {\n    margin-block: -2.75rem !important;\n}\n\n.k-my--12 {\n    margin-block: -3rem;\n}\n\n.\\!k-my--12 {\n    margin-block: -3rem !important;\n}\n\n.k-my--13 {\n    margin-block: -3.25rem;\n}\n\n.\\!k-my--13 {\n    margin-block: -3.25rem !important;\n}\n\n.k-my--14 {\n    margin-block: -3.5rem;\n}\n\n.\\!k-my--14 {\n    margin-block: -3.5rem !important;\n}\n\n.k-my--15 {\n    margin-block: -3.75rem;\n}\n\n.\\!k-my--15 {\n    margin-block: -3.75rem !important;\n}\n\n.k-my--16 {\n    margin-block: -4rem;\n}\n\n.\\!k-my--16 {\n    margin-block: -4rem !important;\n}\n\n.k-my--17 {\n    margin-block: -4.25rem;\n}\n\n.\\!k-my--17 {\n    margin-block: -4.25rem !important;\n}\n\n.k-my--18 {\n    margin-block: -4.5rem;\n}\n\n.\\!k-my--18 {\n    margin-block: -4.5rem !important;\n}\n\n.k-my--19 {\n    margin-block: -4.75rem;\n}\n\n.\\!k-my--19 {\n    margin-block: -4.75rem !important;\n}\n\n.k-my--20 {\n    margin-block: -5rem;\n}\n\n.\\!k-my--20 {\n    margin-block: -5rem !important;\n}\n\n.k-my--21 {\n    margin-block: -5.25rem;\n}\n\n.\\!k-my--21 {\n    margin-block: -5.25rem !important;\n}\n\n.k-my--22 {\n    margin-block: -5.5rem;\n}\n\n.\\!k-my--22 {\n    margin-block: -5.5rem !important;\n}\n\n.k-my--23 {\n    margin-block: -5.75rem;\n}\n\n.\\!k-my--23 {\n    margin-block: -5.75rem !important;\n}\n\n.k-my--24 {\n    margin-block: -6rem;\n}\n\n.\\!k-my--24 {\n    margin-block: -6rem !important;\n}\n\n.k-my-xs {\n    margin-block: 0.25rem;\n}\n\n.\\!k-my-xs {\n    margin-block: 0.25rem !important;\n}\n\n.k-my-sm {\n    margin-block: 0.5rem;\n}\n\n.\\!k-my-sm {\n    margin-block: 0.5rem !important;\n}\n\n.k-my-md {\n    margin-block: 0.75rem;\n}\n\n.\\!k-my-md {\n    margin-block: 0.75rem !important;\n}\n\n.k-my-lg {\n    margin-block: 1rem;\n}\n\n.\\!k-my-lg {\n    margin-block: 1rem !important;\n}\n\n.k-my-xl {\n    margin-block: 1.5rem;\n}\n\n.\\!k-my-xl {\n    margin-block: 1.5rem !important;\n}\n\n.k-my-thin {\n    margin-block: 0.125rem;\n}\n\n.\\!k-my-thin {\n    margin-block: 0.125rem !important;\n}\n\n.k-my-hair {\n    margin-block: 1px;\n}\n\n.\\!k-my-hair {\n    margin-block: 1px !important;\n}\n\n.k-my-auto {\n    margin-block: auto;\n}\n\n.\\!k-my-auto {\n    margin-block: auto !important;\n}\n\n.k-p-0 {\n    padding: 0;\n}\n\n.\\!k-p-0 {\n    padding: 0 !important;\n}\n\n.k-p-1px {\n    padding: 1px;\n}\n\n.\\!k-p-1px {\n    padding: 1px !important;\n}\n\n.k-p-0\\.5 {\n    padding: 0.125rem;\n}\n\n.\\!k-p-0\\.5 {\n    padding: 0.125rem !important;\n}\n\n.k-p-1 {\n    padding: 0.25rem;\n}\n\n.\\!k-p-1 {\n    padding: 0.25rem !important;\n}\n\n.k-p-1\\.5 {\n    padding: 0.375rem;\n}\n\n.\\!k-p-1\\.5 {\n    padding: 0.375rem !important;\n}\n\n.k-p-2 {\n    padding: 0.5rem;\n}\n\n.\\!k-p-2 {\n    padding: 0.5rem !important;\n}\n\n.k-p-2\\.5 {\n    padding: 0.625rem;\n}\n\n.\\!k-p-2\\.5 {\n    padding: 0.625rem !important;\n}\n\n.k-p-3 {\n    padding: 0.75rem;\n}\n\n.\\!k-p-3 {\n    padding: 0.75rem !important;\n}\n\n.k-p-3\\.5 {\n    padding: 0.875rem;\n}\n\n.\\!k-p-3\\.5 {\n    padding: 0.875rem !important;\n}\n\n.k-p-4 {\n    padding: 1rem;\n}\n\n.\\!k-p-4 {\n    padding: 1rem !important;\n}\n\n.k-p-4\\.5 {\n    padding: 1.125rem;\n}\n\n.\\!k-p-4\\.5 {\n    padding: 1.125rem !important;\n}\n\n.k-p-5 {\n    padding: 1.25rem;\n}\n\n.\\!k-p-5 {\n    padding: 1.25rem !important;\n}\n\n.k-p-5\\.5 {\n    padding: 1.375rem;\n}\n\n.\\!k-p-5\\.5 {\n    padding: 1.375rem !important;\n}\n\n.k-p-6 {\n    padding: 1.5rem;\n}\n\n.\\!k-p-6 {\n    padding: 1.5rem !important;\n}\n\n.k-p-6\\.5 {\n    padding: 1.625rem;\n}\n\n.\\!k-p-6\\.5 {\n    padding: 1.625rem !important;\n}\n\n.k-p-7 {\n    padding: 1.75rem;\n}\n\n.\\!k-p-7 {\n    padding: 1.75rem !important;\n}\n\n.k-p-7\\.5 {\n    padding: 1.875rem;\n}\n\n.\\!k-p-7\\.5 {\n    padding: 1.875rem !important;\n}\n\n.k-p-8 {\n    padding: 2rem;\n}\n\n.\\!k-p-8 {\n    padding: 2rem !important;\n}\n\n.k-p-9 {\n    padding: 2.25rem;\n}\n\n.\\!k-p-9 {\n    padding: 2.25rem !important;\n}\n\n.k-p-10 {\n    padding: 2.5rem;\n}\n\n.\\!k-p-10 {\n    padding: 2.5rem !important;\n}\n\n.k-p-11 {\n    padding: 2.75rem;\n}\n\n.\\!k-p-11 {\n    padding: 2.75rem !important;\n}\n\n.k-p-12 {\n    padding: 3rem;\n}\n\n.\\!k-p-12 {\n    padding: 3rem !important;\n}\n\n.k-p-13 {\n    padding: 3.25rem;\n}\n\n.\\!k-p-13 {\n    padding: 3.25rem !important;\n}\n\n.k-p-14 {\n    padding: 3.5rem;\n}\n\n.\\!k-p-14 {\n    padding: 3.5rem !important;\n}\n\n.k-p-15 {\n    padding: 3.75rem;\n}\n\n.\\!k-p-15 {\n    padding: 3.75rem !important;\n}\n\n.k-p-16 {\n    padding: 4rem;\n}\n\n.\\!k-p-16 {\n    padding: 4rem !important;\n}\n\n.k-p-17 {\n    padding: 4.25rem;\n}\n\n.\\!k-p-17 {\n    padding: 4.25rem !important;\n}\n\n.k-p-18 {\n    padding: 4.5rem;\n}\n\n.\\!k-p-18 {\n    padding: 4.5rem !important;\n}\n\n.k-p-19 {\n    padding: 4.75rem;\n}\n\n.\\!k-p-19 {\n    padding: 4.75rem !important;\n}\n\n.k-p-20 {\n    padding: 5rem;\n}\n\n.\\!k-p-20 {\n    padding: 5rem !important;\n}\n\n.k-p-21 {\n    padding: 5.25rem;\n}\n\n.\\!k-p-21 {\n    padding: 5.25rem !important;\n}\n\n.k-p-22 {\n    padding: 5.5rem;\n}\n\n.\\!k-p-22 {\n    padding: 5.5rem !important;\n}\n\n.k-p-23 {\n    padding: 5.75rem;\n}\n\n.\\!k-p-23 {\n    padding: 5.75rem !important;\n}\n\n.k-p-24 {\n    padding: 6rem;\n}\n\n.\\!k-p-24 {\n    padding: 6rem !important;\n}\n\n.k-p-xs {\n    padding: 0.25rem;\n}\n\n.\\!k-p-xs {\n    padding: 0.25rem !important;\n}\n\n.k-p-sm {\n    padding: 0.5rem;\n}\n\n.\\!k-p-sm {\n    padding: 0.5rem !important;\n}\n\n.k-p-md {\n    padding: 0.75rem;\n}\n\n.\\!k-p-md {\n    padding: 0.75rem !important;\n}\n\n.k-p-lg {\n    padding: 1rem;\n}\n\n.\\!k-p-lg {\n    padding: 1rem !important;\n}\n\n.k-p-xl {\n    padding: 1.5rem;\n}\n\n.\\!k-p-xl {\n    padding: 1.5rem !important;\n}\n\n.k-p-thin {\n    padding: 0.125rem;\n}\n\n.\\!k-p-thin {\n    padding: 0.125rem !important;\n}\n\n.k-p-hair {\n    padding: 1px;\n}\n\n.\\!k-p-hair {\n    padding: 1px !important;\n}\n\n.k-pt-0 {\n    padding-top: 0;\n}\n\n.\\!k-pt-0 {\n    padding-top: 0 !important;\n}\n\n.k-pt-1px {\n    padding-top: 1px;\n}\n\n.\\!k-pt-1px {\n    padding-top: 1px !important;\n}\n\n.k-pt-0\\.5 {\n    padding-top: 0.125rem;\n}\n\n.\\!k-pt-0\\.5 {\n    padding-top: 0.125rem !important;\n}\n\n.k-pt-1 {\n    padding-top: 0.25rem;\n}\n\n.\\!k-pt-1 {\n    padding-top: 0.25rem !important;\n}\n\n.k-pt-1\\.5 {\n    padding-top: 0.375rem;\n}\n\n.\\!k-pt-1\\.5 {\n    padding-top: 0.375rem !important;\n}\n\n.k-pt-2 {\n    padding-top: 0.5rem;\n}\n\n.\\!k-pt-2 {\n    padding-top: 0.5rem !important;\n}\n\n.k-pt-2\\.5 {\n    padding-top: 0.625rem;\n}\n\n.\\!k-pt-2\\.5 {\n    padding-top: 0.625rem !important;\n}\n\n.k-pt-3 {\n    padding-top: 0.75rem;\n}\n\n.\\!k-pt-3 {\n    padding-top: 0.75rem !important;\n}\n\n.k-pt-3\\.5 {\n    padding-top: 0.875rem;\n}\n\n.\\!k-pt-3\\.5 {\n    padding-top: 0.875rem !important;\n}\n\n.k-pt-4 {\n    padding-top: 1rem;\n}\n\n.\\!k-pt-4 {\n    padding-top: 1rem !important;\n}\n\n.k-pt-4\\.5 {\n    padding-top: 1.125rem;\n}\n\n.\\!k-pt-4\\.5 {\n    padding-top: 1.125rem !important;\n}\n\n.k-pt-5 {\n    padding-top: 1.25rem;\n}\n\n.\\!k-pt-5 {\n    padding-top: 1.25rem !important;\n}\n\n.k-pt-5\\.5 {\n    padding-top: 1.375rem;\n}\n\n.\\!k-pt-5\\.5 {\n    padding-top: 1.375rem !important;\n}\n\n.k-pt-6 {\n    padding-top: 1.5rem;\n}\n\n.\\!k-pt-6 {\n    padding-top: 1.5rem !important;\n}\n\n.k-pt-6\\.5 {\n    padding-top: 1.625rem;\n}\n\n.\\!k-pt-6\\.5 {\n    padding-top: 1.625rem !important;\n}\n\n.k-pt-7 {\n    padding-top: 1.75rem;\n}\n\n.\\!k-pt-7 {\n    padding-top: 1.75rem !important;\n}\n\n.k-pt-7\\.5 {\n    padding-top: 1.875rem;\n}\n\n.\\!k-pt-7\\.5 {\n    padding-top: 1.875rem !important;\n}\n\n.k-pt-8 {\n    padding-top: 2rem;\n}\n\n.\\!k-pt-8 {\n    padding-top: 2rem !important;\n}\n\n.k-pt-9 {\n    padding-top: 2.25rem;\n}\n\n.\\!k-pt-9 {\n    padding-top: 2.25rem !important;\n}\n\n.k-pt-10 {\n    padding-top: 2.5rem;\n}\n\n.\\!k-pt-10 {\n    padding-top: 2.5rem !important;\n}\n\n.k-pt-11 {\n    padding-top: 2.75rem;\n}\n\n.\\!k-pt-11 {\n    padding-top: 2.75rem !important;\n}\n\n.k-pt-12 {\n    padding-top: 3rem;\n}\n\n.\\!k-pt-12 {\n    padding-top: 3rem !important;\n}\n\n.k-pt-13 {\n    padding-top: 3.25rem;\n}\n\n.\\!k-pt-13 {\n    padding-top: 3.25rem !important;\n}\n\n.k-pt-14 {\n    padding-top: 3.5rem;\n}\n\n.\\!k-pt-14 {\n    padding-top: 3.5rem !important;\n}\n\n.k-pt-15 {\n    padding-top: 3.75rem;\n}\n\n.\\!k-pt-15 {\n    padding-top: 3.75rem !important;\n}\n\n.k-pt-16 {\n    padding-top: 4rem;\n}\n\n.\\!k-pt-16 {\n    padding-top: 4rem !important;\n}\n\n.k-pt-17 {\n    padding-top: 4.25rem;\n}\n\n.\\!k-pt-17 {\n    padding-top: 4.25rem !important;\n}\n\n.k-pt-18 {\n    padding-top: 4.5rem;\n}\n\n.\\!k-pt-18 {\n    padding-top: 4.5rem !important;\n}\n\n.k-pt-19 {\n    padding-top: 4.75rem;\n}\n\n.\\!k-pt-19 {\n    padding-top: 4.75rem !important;\n}\n\n.k-pt-20 {\n    padding-top: 5rem;\n}\n\n.\\!k-pt-20 {\n    padding-top: 5rem !important;\n}\n\n.k-pt-21 {\n    padding-top: 5.25rem;\n}\n\n.\\!k-pt-21 {\n    padding-top: 5.25rem !important;\n}\n\n.k-pt-22 {\n    padding-top: 5.5rem;\n}\n\n.\\!k-pt-22 {\n    padding-top: 5.5rem !important;\n}\n\n.k-pt-23 {\n    padding-top: 5.75rem;\n}\n\n.\\!k-pt-23 {\n    padding-top: 5.75rem !important;\n}\n\n.k-pt-24 {\n    padding-top: 6rem;\n}\n\n.\\!k-pt-24 {\n    padding-top: 6rem !important;\n}\n\n.k-pt-xs {\n    padding-top: 0.25rem;\n}\n\n.\\!k-pt-xs {\n    padding-top: 0.25rem !important;\n}\n\n.k-pt-sm {\n    padding-top: 0.5rem;\n}\n\n.\\!k-pt-sm {\n    padding-top: 0.5rem !important;\n}\n\n.k-pt-md {\n    padding-top: 0.75rem;\n}\n\n.\\!k-pt-md {\n    padding-top: 0.75rem !important;\n}\n\n.k-pt-lg {\n    padding-top: 1rem;\n}\n\n.\\!k-pt-lg {\n    padding-top: 1rem !important;\n}\n\n.k-pt-xl {\n    padding-top: 1.5rem;\n}\n\n.\\!k-pt-xl {\n    padding-top: 1.5rem !important;\n}\n\n.k-pt-thin {\n    padding-top: 0.125rem;\n}\n\n.\\!k-pt-thin {\n    padding-top: 0.125rem !important;\n}\n\n.k-pt-hair {\n    padding-top: 1px;\n}\n\n.\\!k-pt-hair {\n    padding-top: 1px !important;\n}\n\n.k-pr-0 {\n    padding-right: 0;\n}\n\n.\\!k-pr-0 {\n    padding-right: 0 !important;\n}\n\n.k-pr-1px {\n    padding-right: 1px;\n}\n\n.\\!k-pr-1px {\n    padding-right: 1px !important;\n}\n\n.k-pr-0\\.5 {\n    padding-right: 0.125rem;\n}\n\n.\\!k-pr-0\\.5 {\n    padding-right: 0.125rem !important;\n}\n\n.k-pr-1 {\n    padding-right: 0.25rem;\n}\n\n.\\!k-pr-1 {\n    padding-right: 0.25rem !important;\n}\n\n.k-pr-1\\.5 {\n    padding-right: 0.375rem;\n}\n\n.\\!k-pr-1\\.5 {\n    padding-right: 0.375rem !important;\n}\n\n.k-pr-2 {\n    padding-right: 0.5rem;\n}\n\n.\\!k-pr-2 {\n    padding-right: 0.5rem !important;\n}\n\n.k-pr-2\\.5 {\n    padding-right: 0.625rem;\n}\n\n.\\!k-pr-2\\.5 {\n    padding-right: 0.625rem !important;\n}\n\n.k-pr-3 {\n    padding-right: 0.75rem;\n}\n\n.\\!k-pr-3 {\n    padding-right: 0.75rem !important;\n}\n\n.k-pr-3\\.5 {\n    padding-right: 0.875rem;\n}\n\n.\\!k-pr-3\\.5 {\n    padding-right: 0.875rem !important;\n}\n\n.k-pr-4 {\n    padding-right: 1rem;\n}\n\n.\\!k-pr-4 {\n    padding-right: 1rem !important;\n}\n\n.k-pr-4\\.5 {\n    padding-right: 1.125rem;\n}\n\n.\\!k-pr-4\\.5 {\n    padding-right: 1.125rem !important;\n}\n\n.k-pr-5 {\n    padding-right: 1.25rem;\n}\n\n.\\!k-pr-5 {\n    padding-right: 1.25rem !important;\n}\n\n.k-pr-5\\.5 {\n    padding-right: 1.375rem;\n}\n\n.\\!k-pr-5\\.5 {\n    padding-right: 1.375rem !important;\n}\n\n.k-pr-6 {\n    padding-right: 1.5rem;\n}\n\n.\\!k-pr-6 {\n    padding-right: 1.5rem !important;\n}\n\n.k-pr-6\\.5 {\n    padding-right: 1.625rem;\n}\n\n.\\!k-pr-6\\.5 {\n    padding-right: 1.625rem !important;\n}\n\n.k-pr-7 {\n    padding-right: 1.75rem;\n}\n\n.\\!k-pr-7 {\n    padding-right: 1.75rem !important;\n}\n\n.k-pr-7\\.5 {\n    padding-right: 1.875rem;\n}\n\n.\\!k-pr-7\\.5 {\n    padding-right: 1.875rem !important;\n}\n\n.k-pr-8 {\n    padding-right: 2rem;\n}\n\n.\\!k-pr-8 {\n    padding-right: 2rem !important;\n}\n\n.k-pr-9 {\n    padding-right: 2.25rem;\n}\n\n.\\!k-pr-9 {\n    padding-right: 2.25rem !important;\n}\n\n.k-pr-10 {\n    padding-right: 2.5rem;\n}\n\n.\\!k-pr-10 {\n    padding-right: 2.5rem !important;\n}\n\n.k-pr-11 {\n    padding-right: 2.75rem;\n}\n\n.\\!k-pr-11 {\n    padding-right: 2.75rem !important;\n}\n\n.k-pr-12 {\n    padding-right: 3rem;\n}\n\n.\\!k-pr-12 {\n    padding-right: 3rem !important;\n}\n\n.k-pr-13 {\n    padding-right: 3.25rem;\n}\n\n.\\!k-pr-13 {\n    padding-right: 3.25rem !important;\n}\n\n.k-pr-14 {\n    padding-right: 3.5rem;\n}\n\n.\\!k-pr-14 {\n    padding-right: 3.5rem !important;\n}\n\n.k-pr-15 {\n    padding-right: 3.75rem;\n}\n\n.\\!k-pr-15 {\n    padding-right: 3.75rem !important;\n}\n\n.k-pr-16 {\n    padding-right: 4rem;\n}\n\n.\\!k-pr-16 {\n    padding-right: 4rem !important;\n}\n\n.k-pr-17 {\n    padding-right: 4.25rem;\n}\n\n.\\!k-pr-17 {\n    padding-right: 4.25rem !important;\n}\n\n.k-pr-18 {\n    padding-right: 4.5rem;\n}\n\n.\\!k-pr-18 {\n    padding-right: 4.5rem !important;\n}\n\n.k-pr-19 {\n    padding-right: 4.75rem;\n}\n\n.\\!k-pr-19 {\n    padding-right: 4.75rem !important;\n}\n\n.k-pr-20 {\n    padding-right: 5rem;\n}\n\n.\\!k-pr-20 {\n    padding-right: 5rem !important;\n}\n\n.k-pr-21 {\n    padding-right: 5.25rem;\n}\n\n.\\!k-pr-21 {\n    padding-right: 5.25rem !important;\n}\n\n.k-pr-22 {\n    padding-right: 5.5rem;\n}\n\n.\\!k-pr-22 {\n    padding-right: 5.5rem !important;\n}\n\n.k-pr-23 {\n    padding-right: 5.75rem;\n}\n\n.\\!k-pr-23 {\n    padding-right: 5.75rem !important;\n}\n\n.k-pr-24 {\n    padding-right: 6rem;\n}\n\n.\\!k-pr-24 {\n    padding-right: 6rem !important;\n}\n\n.k-pr-xs {\n    padding-right: 0.25rem;\n}\n\n.\\!k-pr-xs {\n    padding-right: 0.25rem !important;\n}\n\n.k-pr-sm {\n    padding-right: 0.5rem;\n}\n\n.\\!k-pr-sm {\n    padding-right: 0.5rem !important;\n}\n\n.k-pr-md {\n    padding-right: 0.75rem;\n}\n\n.\\!k-pr-md {\n    padding-right: 0.75rem !important;\n}\n\n.k-pr-lg {\n    padding-right: 1rem;\n}\n\n.\\!k-pr-lg {\n    padding-right: 1rem !important;\n}\n\n.k-pr-xl {\n    padding-right: 1.5rem;\n}\n\n.\\!k-pr-xl {\n    padding-right: 1.5rem !important;\n}\n\n.k-pr-thin {\n    padding-right: 0.125rem;\n}\n\n.\\!k-pr-thin {\n    padding-right: 0.125rem !important;\n}\n\n.k-pr-hair {\n    padding-right: 1px;\n}\n\n.\\!k-pr-hair {\n    padding-right: 1px !important;\n}\n\n.k-pb-0 {\n    padding-bottom: 0;\n}\n\n.\\!k-pb-0 {\n    padding-bottom: 0 !important;\n}\n\n.k-pb-1px {\n    padding-bottom: 1px;\n}\n\n.\\!k-pb-1px {\n    padding-bottom: 1px !important;\n}\n\n.k-pb-0\\.5 {\n    padding-bottom: 0.125rem;\n}\n\n.\\!k-pb-0\\.5 {\n    padding-bottom: 0.125rem !important;\n}\n\n.k-pb-1 {\n    padding-bottom: 0.25rem;\n}\n\n.\\!k-pb-1 {\n    padding-bottom: 0.25rem !important;\n}\n\n.k-pb-1\\.5 {\n    padding-bottom: 0.375rem;\n}\n\n.\\!k-pb-1\\.5 {\n    padding-bottom: 0.375rem !important;\n}\n\n.k-pb-2 {\n    padding-bottom: 0.5rem;\n}\n\n.\\!k-pb-2 {\n    padding-bottom: 0.5rem !important;\n}\n\n.k-pb-2\\.5 {\n    padding-bottom: 0.625rem;\n}\n\n.\\!k-pb-2\\.5 {\n    padding-bottom: 0.625rem !important;\n}\n\n.k-pb-3 {\n    padding-bottom: 0.75rem;\n}\n\n.\\!k-pb-3 {\n    padding-bottom: 0.75rem !important;\n}\n\n.k-pb-3\\.5 {\n    padding-bottom: 0.875rem;\n}\n\n.\\!k-pb-3\\.5 {\n    padding-bottom: 0.875rem !important;\n}\n\n.k-pb-4 {\n    padding-bottom: 1rem;\n}\n\n.\\!k-pb-4 {\n    padding-bottom: 1rem !important;\n}\n\n.k-pb-4\\.5 {\n    padding-bottom: 1.125rem;\n}\n\n.\\!k-pb-4\\.5 {\n    padding-bottom: 1.125rem !important;\n}\n\n.k-pb-5 {\n    padding-bottom: 1.25rem;\n}\n\n.\\!k-pb-5 {\n    padding-bottom: 1.25rem !important;\n}\n\n.k-pb-5\\.5 {\n    padding-bottom: 1.375rem;\n}\n\n.\\!k-pb-5\\.5 {\n    padding-bottom: 1.375rem !important;\n}\n\n.k-pb-6 {\n    padding-bottom: 1.5rem;\n}\n\n.\\!k-pb-6 {\n    padding-bottom: 1.5rem !important;\n}\n\n.k-pb-6\\.5 {\n    padding-bottom: 1.625rem;\n}\n\n.\\!k-pb-6\\.5 {\n    padding-bottom: 1.625rem !important;\n}\n\n.k-pb-7 {\n    padding-bottom: 1.75rem;\n}\n\n.\\!k-pb-7 {\n    padding-bottom: 1.75rem !important;\n}\n\n.k-pb-7\\.5 {\n    padding-bottom: 1.875rem;\n}\n\n.\\!k-pb-7\\.5 {\n    padding-bottom: 1.875rem !important;\n}\n\n.k-pb-8 {\n    padding-bottom: 2rem;\n}\n\n.\\!k-pb-8 {\n    padding-bottom: 2rem !important;\n}\n\n.k-pb-9 {\n    padding-bottom: 2.25rem;\n}\n\n.\\!k-pb-9 {\n    padding-bottom: 2.25rem !important;\n}\n\n.k-pb-10 {\n    padding-bottom: 2.5rem;\n}\n\n.\\!k-pb-10 {\n    padding-bottom: 2.5rem !important;\n}\n\n.k-pb-11 {\n    padding-bottom: 2.75rem;\n}\n\n.\\!k-pb-11 {\n    padding-bottom: 2.75rem !important;\n}\n\n.k-pb-12 {\n    padding-bottom: 3rem;\n}\n\n.\\!k-pb-12 {\n    padding-bottom: 3rem !important;\n}\n\n.k-pb-13 {\n    padding-bottom: 3.25rem;\n}\n\n.\\!k-pb-13 {\n    padding-bottom: 3.25rem !important;\n}\n\n.k-pb-14 {\n    padding-bottom: 3.5rem;\n}\n\n.\\!k-pb-14 {\n    padding-bottom: 3.5rem !important;\n}\n\n.k-pb-15 {\n    padding-bottom: 3.75rem;\n}\n\n.\\!k-pb-15 {\n    padding-bottom: 3.75rem !important;\n}\n\n.k-pb-16 {\n    padding-bottom: 4rem;\n}\n\n.\\!k-pb-16 {\n    padding-bottom: 4rem !important;\n}\n\n.k-pb-17 {\n    padding-bottom: 4.25rem;\n}\n\n.\\!k-pb-17 {\n    padding-bottom: 4.25rem !important;\n}\n\n.k-pb-18 {\n    padding-bottom: 4.5rem;\n}\n\n.\\!k-pb-18 {\n    padding-bottom: 4.5rem !important;\n}\n\n.k-pb-19 {\n    padding-bottom: 4.75rem;\n}\n\n.\\!k-pb-19 {\n    padding-bottom: 4.75rem !important;\n}\n\n.k-pb-20 {\n    padding-bottom: 5rem;\n}\n\n.\\!k-pb-20 {\n    padding-bottom: 5rem !important;\n}\n\n.k-pb-21 {\n    padding-bottom: 5.25rem;\n}\n\n.\\!k-pb-21 {\n    padding-bottom: 5.25rem !important;\n}\n\n.k-pb-22 {\n    padding-bottom: 5.5rem;\n}\n\n.\\!k-pb-22 {\n    padding-bottom: 5.5rem !important;\n}\n\n.k-pb-23 {\n    padding-bottom: 5.75rem;\n}\n\n.\\!k-pb-23 {\n    padding-bottom: 5.75rem !important;\n}\n\n.k-pb-24 {\n    padding-bottom: 6rem;\n}\n\n.\\!k-pb-24 {\n    padding-bottom: 6rem !important;\n}\n\n.k-pb-xs {\n    padding-bottom: 0.25rem;\n}\n\n.\\!k-pb-xs {\n    padding-bottom: 0.25rem !important;\n}\n\n.k-pb-sm {\n    padding-bottom: 0.5rem;\n}\n\n.\\!k-pb-sm {\n    padding-bottom: 0.5rem !important;\n}\n\n.k-pb-md {\n    padding-bottom: 0.75rem;\n}\n\n.\\!k-pb-md {\n    padding-bottom: 0.75rem !important;\n}\n\n.k-pb-lg {\n    padding-bottom: 1rem;\n}\n\n.\\!k-pb-lg {\n    padding-bottom: 1rem !important;\n}\n\n.k-pb-xl {\n    padding-bottom: 1.5rem;\n}\n\n.\\!k-pb-xl {\n    padding-bottom: 1.5rem !important;\n}\n\n.k-pb-thin {\n    padding-bottom: 0.125rem;\n}\n\n.\\!k-pb-thin {\n    padding-bottom: 0.125rem !important;\n}\n\n.k-pb-hair {\n    padding-bottom: 1px;\n}\n\n.\\!k-pb-hair {\n    padding-bottom: 1px !important;\n}\n\n.k-pl-0 {\n    padding-left: 0;\n}\n\n.\\!k-pl-0 {\n    padding-left: 0 !important;\n}\n\n.k-pl-1px {\n    padding-left: 1px;\n}\n\n.\\!k-pl-1px {\n    padding-left: 1px !important;\n}\n\n.k-pl-0\\.5 {\n    padding-left: 0.125rem;\n}\n\n.\\!k-pl-0\\.5 {\n    padding-left: 0.125rem !important;\n}\n\n.k-pl-1 {\n    padding-left: 0.25rem;\n}\n\n.\\!k-pl-1 {\n    padding-left: 0.25rem !important;\n}\n\n.k-pl-1\\.5 {\n    padding-left: 0.375rem;\n}\n\n.\\!k-pl-1\\.5 {\n    padding-left: 0.375rem !important;\n}\n\n.k-pl-2 {\n    padding-left: 0.5rem;\n}\n\n.\\!k-pl-2 {\n    padding-left: 0.5rem !important;\n}\n\n.k-pl-2\\.5 {\n    padding-left: 0.625rem;\n}\n\n.\\!k-pl-2\\.5 {\n    padding-left: 0.625rem !important;\n}\n\n.k-pl-3 {\n    padding-left: 0.75rem;\n}\n\n.\\!k-pl-3 {\n    padding-left: 0.75rem !important;\n}\n\n.k-pl-3\\.5 {\n    padding-left: 0.875rem;\n}\n\n.\\!k-pl-3\\.5 {\n    padding-left: 0.875rem !important;\n}\n\n.k-pl-4 {\n    padding-left: 1rem;\n}\n\n.\\!k-pl-4 {\n    padding-left: 1rem !important;\n}\n\n.k-pl-4\\.5 {\n    padding-left: 1.125rem;\n}\n\n.\\!k-pl-4\\.5 {\n    padding-left: 1.125rem !important;\n}\n\n.k-pl-5 {\n    padding-left: 1.25rem;\n}\n\n.\\!k-pl-5 {\n    padding-left: 1.25rem !important;\n}\n\n.k-pl-5\\.5 {\n    padding-left: 1.375rem;\n}\n\n.\\!k-pl-5\\.5 {\n    padding-left: 1.375rem !important;\n}\n\n.k-pl-6 {\n    padding-left: 1.5rem;\n}\n\n.\\!k-pl-6 {\n    padding-left: 1.5rem !important;\n}\n\n.k-pl-6\\.5 {\n    padding-left: 1.625rem;\n}\n\n.\\!k-pl-6\\.5 {\n    padding-left: 1.625rem !important;\n}\n\n.k-pl-7 {\n    padding-left: 1.75rem;\n}\n\n.\\!k-pl-7 {\n    padding-left: 1.75rem !important;\n}\n\n.k-pl-7\\.5 {\n    padding-left: 1.875rem;\n}\n\n.\\!k-pl-7\\.5 {\n    padding-left: 1.875rem !important;\n}\n\n.k-pl-8 {\n    padding-left: 2rem;\n}\n\n.\\!k-pl-8 {\n    padding-left: 2rem !important;\n}\n\n.k-pl-9 {\n    padding-left: 2.25rem;\n}\n\n.\\!k-pl-9 {\n    padding-left: 2.25rem !important;\n}\n\n.k-pl-10 {\n    padding-left: 2.5rem;\n}\n\n.\\!k-pl-10 {\n    padding-left: 2.5rem !important;\n}\n\n.k-pl-11 {\n    padding-left: 2.75rem;\n}\n\n.\\!k-pl-11 {\n    padding-left: 2.75rem !important;\n}\n\n.k-pl-12 {\n    padding-left: 3rem;\n}\n\n.\\!k-pl-12 {\n    padding-left: 3rem !important;\n}\n\n.k-pl-13 {\n    padding-left: 3.25rem;\n}\n\n.\\!k-pl-13 {\n    padding-left: 3.25rem !important;\n}\n\n.k-pl-14 {\n    padding-left: 3.5rem;\n}\n\n.\\!k-pl-14 {\n    padding-left: 3.5rem !important;\n}\n\n.k-pl-15 {\n    padding-left: 3.75rem;\n}\n\n.\\!k-pl-15 {\n    padding-left: 3.75rem !important;\n}\n\n.k-pl-16 {\n    padding-left: 4rem;\n}\n\n.\\!k-pl-16 {\n    padding-left: 4rem !important;\n}\n\n.k-pl-17 {\n    padding-left: 4.25rem;\n}\n\n.\\!k-pl-17 {\n    padding-left: 4.25rem !important;\n}\n\n.k-pl-18 {\n    padding-left: 4.5rem;\n}\n\n.\\!k-pl-18 {\n    padding-left: 4.5rem !important;\n}\n\n.k-pl-19 {\n    padding-left: 4.75rem;\n}\n\n.\\!k-pl-19 {\n    padding-left: 4.75rem !important;\n}\n\n.k-pl-20 {\n    padding-left: 5rem;\n}\n\n.\\!k-pl-20 {\n    padding-left: 5rem !important;\n}\n\n.k-pl-21 {\n    padding-left: 5.25rem;\n}\n\n.\\!k-pl-21 {\n    padding-left: 5.25rem !important;\n}\n\n.k-pl-22 {\n    padding-left: 5.5rem;\n}\n\n.\\!k-pl-22 {\n    padding-left: 5.5rem !important;\n}\n\n.k-pl-23 {\n    padding-left: 5.75rem;\n}\n\n.\\!k-pl-23 {\n    padding-left: 5.75rem !important;\n}\n\n.k-pl-24 {\n    padding-left: 6rem;\n}\n\n.\\!k-pl-24 {\n    padding-left: 6rem !important;\n}\n\n.k-pl-xs {\n    padding-left: 0.25rem;\n}\n\n.\\!k-pl-xs {\n    padding-left: 0.25rem !important;\n}\n\n.k-pl-sm {\n    padding-left: 0.5rem;\n}\n\n.\\!k-pl-sm {\n    padding-left: 0.5rem !important;\n}\n\n.k-pl-md {\n    padding-left: 0.75rem;\n}\n\n.\\!k-pl-md {\n    padding-left: 0.75rem !important;\n}\n\n.k-pl-lg {\n    padding-left: 1rem;\n}\n\n.\\!k-pl-lg {\n    padding-left: 1rem !important;\n}\n\n.k-pl-xl {\n    padding-left: 1.5rem;\n}\n\n.\\!k-pl-xl {\n    padding-left: 1.5rem !important;\n}\n\n.k-pl-thin {\n    padding-left: 0.125rem;\n}\n\n.\\!k-pl-thin {\n    padding-left: 0.125rem !important;\n}\n\n.k-pl-hair {\n    padding-left: 1px;\n}\n\n.\\!k-pl-hair {\n    padding-left: 1px !important;\n}\n\n.k-px-0 {\n    padding-inline: 0;\n}\n\n.\\!k-px-0 {\n    padding-inline: 0 !important;\n}\n\n.k-px-1px {\n    padding-inline: 1px;\n}\n\n.\\!k-px-1px {\n    padding-inline: 1px !important;\n}\n\n.k-px-0\\.5 {\n    padding-inline: 0.125rem;\n}\n\n.\\!k-px-0\\.5 {\n    padding-inline: 0.125rem !important;\n}\n\n.k-px-1 {\n    padding-inline: 0.25rem;\n}\n\n.\\!k-px-1 {\n    padding-inline: 0.25rem !important;\n}\n\n.k-px-1\\.5 {\n    padding-inline: 0.375rem;\n}\n\n.\\!k-px-1\\.5 {\n    padding-inline: 0.375rem !important;\n}\n\n.k-px-2 {\n    padding-inline: 0.5rem;\n}\n\n.\\!k-px-2 {\n    padding-inline: 0.5rem !important;\n}\n\n.k-px-2\\.5 {\n    padding-inline: 0.625rem;\n}\n\n.\\!k-px-2\\.5 {\n    padding-inline: 0.625rem !important;\n}\n\n.k-px-3 {\n    padding-inline: 0.75rem;\n}\n\n.\\!k-px-3 {\n    padding-inline: 0.75rem !important;\n}\n\n.k-px-3\\.5 {\n    padding-inline: 0.875rem;\n}\n\n.\\!k-px-3\\.5 {\n    padding-inline: 0.875rem !important;\n}\n\n.k-px-4 {\n    padding-inline: 1rem;\n}\n\n.\\!k-px-4 {\n    padding-inline: 1rem !important;\n}\n\n.k-px-4\\.5 {\n    padding-inline: 1.125rem;\n}\n\n.\\!k-px-4\\.5 {\n    padding-inline: 1.125rem !important;\n}\n\n.k-px-5 {\n    padding-inline: 1.25rem;\n}\n\n.\\!k-px-5 {\n    padding-inline: 1.25rem !important;\n}\n\n.k-px-5\\.5 {\n    padding-inline: 1.375rem;\n}\n\n.\\!k-px-5\\.5 {\n    padding-inline: 1.375rem !important;\n}\n\n.k-px-6 {\n    padding-inline: 1.5rem;\n}\n\n.\\!k-px-6 {\n    padding-inline: 1.5rem !important;\n}\n\n.k-px-6\\.5 {\n    padding-inline: 1.625rem;\n}\n\n.\\!k-px-6\\.5 {\n    padding-inline: 1.625rem !important;\n}\n\n.k-px-7 {\n    padding-inline: 1.75rem;\n}\n\n.\\!k-px-7 {\n    padding-inline: 1.75rem !important;\n}\n\n.k-px-7\\.5 {\n    padding-inline: 1.875rem;\n}\n\n.\\!k-px-7\\.5 {\n    padding-inline: 1.875rem !important;\n}\n\n.k-px-8 {\n    padding-inline: 2rem;\n}\n\n.\\!k-px-8 {\n    padding-inline: 2rem !important;\n}\n\n.k-px-9 {\n    padding-inline: 2.25rem;\n}\n\n.\\!k-px-9 {\n    padding-inline: 2.25rem !important;\n}\n\n.k-px-10 {\n    padding-inline: 2.5rem;\n}\n\n.\\!k-px-10 {\n    padding-inline: 2.5rem !important;\n}\n\n.k-px-11 {\n    padding-inline: 2.75rem;\n}\n\n.\\!k-px-11 {\n    padding-inline: 2.75rem !important;\n}\n\n.k-px-12 {\n    padding-inline: 3rem;\n}\n\n.\\!k-px-12 {\n    padding-inline: 3rem !important;\n}\n\n.k-px-13 {\n    padding-inline: 3.25rem;\n}\n\n.\\!k-px-13 {\n    padding-inline: 3.25rem !important;\n}\n\n.k-px-14 {\n    padding-inline: 3.5rem;\n}\n\n.\\!k-px-14 {\n    padding-inline: 3.5rem !important;\n}\n\n.k-px-15 {\n    padding-inline: 3.75rem;\n}\n\n.\\!k-px-15 {\n    padding-inline: 3.75rem !important;\n}\n\n.k-px-16 {\n    padding-inline: 4rem;\n}\n\n.\\!k-px-16 {\n    padding-inline: 4rem !important;\n}\n\n.k-px-17 {\n    padding-inline: 4.25rem;\n}\n\n.\\!k-px-17 {\n    padding-inline: 4.25rem !important;\n}\n\n.k-px-18 {\n    padding-inline: 4.5rem;\n}\n\n.\\!k-px-18 {\n    padding-inline: 4.5rem !important;\n}\n\n.k-px-19 {\n    padding-inline: 4.75rem;\n}\n\n.\\!k-px-19 {\n    padding-inline: 4.75rem !important;\n}\n\n.k-px-20 {\n    padding-inline: 5rem;\n}\n\n.\\!k-px-20 {\n    padding-inline: 5rem !important;\n}\n\n.k-px-21 {\n    padding-inline: 5.25rem;\n}\n\n.\\!k-px-21 {\n    padding-inline: 5.25rem !important;\n}\n\n.k-px-22 {\n    padding-inline: 5.5rem;\n}\n\n.\\!k-px-22 {\n    padding-inline: 5.5rem !important;\n}\n\n.k-px-23 {\n    padding-inline: 5.75rem;\n}\n\n.\\!k-px-23 {\n    padding-inline: 5.75rem !important;\n}\n\n.k-px-24 {\n    padding-inline: 6rem;\n}\n\n.\\!k-px-24 {\n    padding-inline: 6rem !important;\n}\n\n.k-px-xs {\n    padding-inline: 0.25rem;\n}\n\n.\\!k-px-xs {\n    padding-inline: 0.25rem !important;\n}\n\n.k-px-sm {\n    padding-inline: 0.5rem;\n}\n\n.\\!k-px-sm {\n    padding-inline: 0.5rem !important;\n}\n\n.k-px-md {\n    padding-inline: 0.75rem;\n}\n\n.\\!k-px-md {\n    padding-inline: 0.75rem !important;\n}\n\n.k-px-lg {\n    padding-inline: 1rem;\n}\n\n.\\!k-px-lg {\n    padding-inline: 1rem !important;\n}\n\n.k-px-xl {\n    padding-inline: 1.5rem;\n}\n\n.\\!k-px-xl {\n    padding-inline: 1.5rem !important;\n}\n\n.k-px-thin {\n    padding-inline: 0.125rem;\n}\n\n.\\!k-px-thin {\n    padding-inline: 0.125rem !important;\n}\n\n.k-px-hair {\n    padding-inline: 1px;\n}\n\n.\\!k-px-hair {\n    padding-inline: 1px !important;\n}\n\n.k-py-0 {\n    padding-block: 0;\n}\n\n.\\!k-py-0 {\n    padding-block: 0 !important;\n}\n\n.k-py-1px {\n    padding-block: 1px;\n}\n\n.\\!k-py-1px {\n    padding-block: 1px !important;\n}\n\n.k-py-0\\.5 {\n    padding-block: 0.125rem;\n}\n\n.\\!k-py-0\\.5 {\n    padding-block: 0.125rem !important;\n}\n\n.k-py-1 {\n    padding-block: 0.25rem;\n}\n\n.\\!k-py-1 {\n    padding-block: 0.25rem !important;\n}\n\n.k-py-1\\.5 {\n    padding-block: 0.375rem;\n}\n\n.\\!k-py-1\\.5 {\n    padding-block: 0.375rem !important;\n}\n\n.k-py-2 {\n    padding-block: 0.5rem;\n}\n\n.\\!k-py-2 {\n    padding-block: 0.5rem !important;\n}\n\n.k-py-2\\.5 {\n    padding-block: 0.625rem;\n}\n\n.\\!k-py-2\\.5 {\n    padding-block: 0.625rem !important;\n}\n\n.k-py-3 {\n    padding-block: 0.75rem;\n}\n\n.\\!k-py-3 {\n    padding-block: 0.75rem !important;\n}\n\n.k-py-3\\.5 {\n    padding-block: 0.875rem;\n}\n\n.\\!k-py-3\\.5 {\n    padding-block: 0.875rem !important;\n}\n\n.k-py-4 {\n    padding-block: 1rem;\n}\n\n.\\!k-py-4 {\n    padding-block: 1rem !important;\n}\n\n.k-py-4\\.5 {\n    padding-block: 1.125rem;\n}\n\n.\\!k-py-4\\.5 {\n    padding-block: 1.125rem !important;\n}\n\n.k-py-5 {\n    padding-block: 1.25rem;\n}\n\n.\\!k-py-5 {\n    padding-block: 1.25rem !important;\n}\n\n.k-py-5\\.5 {\n    padding-block: 1.375rem;\n}\n\n.\\!k-py-5\\.5 {\n    padding-block: 1.375rem !important;\n}\n\n.k-py-6 {\n    padding-block: 1.5rem;\n}\n\n.\\!k-py-6 {\n    padding-block: 1.5rem !important;\n}\n\n.k-py-6\\.5 {\n    padding-block: 1.625rem;\n}\n\n.\\!k-py-6\\.5 {\n    padding-block: 1.625rem !important;\n}\n\n.k-py-7 {\n    padding-block: 1.75rem;\n}\n\n.\\!k-py-7 {\n    padding-block: 1.75rem !important;\n}\n\n.k-py-7\\.5 {\n    padding-block: 1.875rem;\n}\n\n.\\!k-py-7\\.5 {\n    padding-block: 1.875rem !important;\n}\n\n.k-py-8 {\n    padding-block: 2rem;\n}\n\n.\\!k-py-8 {\n    padding-block: 2rem !important;\n}\n\n.k-py-9 {\n    padding-block: 2.25rem;\n}\n\n.\\!k-py-9 {\n    padding-block: 2.25rem !important;\n}\n\n.k-py-10 {\n    padding-block: 2.5rem;\n}\n\n.\\!k-py-10 {\n    padding-block: 2.5rem !important;\n}\n\n.k-py-11 {\n    padding-block: 2.75rem;\n}\n\n.\\!k-py-11 {\n    padding-block: 2.75rem !important;\n}\n\n.k-py-12 {\n    padding-block: 3rem;\n}\n\n.\\!k-py-12 {\n    padding-block: 3rem !important;\n}\n\n.k-py-13 {\n    padding-block: 3.25rem;\n}\n\n.\\!k-py-13 {\n    padding-block: 3.25rem !important;\n}\n\n.k-py-14 {\n    padding-block: 3.5rem;\n}\n\n.\\!k-py-14 {\n    padding-block: 3.5rem !important;\n}\n\n.k-py-15 {\n    padding-block: 3.75rem;\n}\n\n.\\!k-py-15 {\n    padding-block: 3.75rem !important;\n}\n\n.k-py-16 {\n    padding-block: 4rem;\n}\n\n.\\!k-py-16 {\n    padding-block: 4rem !important;\n}\n\n.k-py-17 {\n    padding-block: 4.25rem;\n}\n\n.\\!k-py-17 {\n    padding-block: 4.25rem !important;\n}\n\n.k-py-18 {\n    padding-block: 4.5rem;\n}\n\n.\\!k-py-18 {\n    padding-block: 4.5rem !important;\n}\n\n.k-py-19 {\n    padding-block: 4.75rem;\n}\n\n.\\!k-py-19 {\n    padding-block: 4.75rem !important;\n}\n\n.k-py-20 {\n    padding-block: 5rem;\n}\n\n.\\!k-py-20 {\n    padding-block: 5rem !important;\n}\n\n.k-py-21 {\n    padding-block: 5.25rem;\n}\n\n.\\!k-py-21 {\n    padding-block: 5.25rem !important;\n}\n\n.k-py-22 {\n    padding-block: 5.5rem;\n}\n\n.\\!k-py-22 {\n    padding-block: 5.5rem !important;\n}\n\n.k-py-23 {\n    padding-block: 5.75rem;\n}\n\n.\\!k-py-23 {\n    padding-block: 5.75rem !important;\n}\n\n.k-py-24 {\n    padding-block: 6rem;\n}\n\n.\\!k-py-24 {\n    padding-block: 6rem !important;\n}\n\n.k-py-xs {\n    padding-block: 0.25rem;\n}\n\n.\\!k-py-xs {\n    padding-block: 0.25rem !important;\n}\n\n.k-py-sm {\n    padding-block: 0.5rem;\n}\n\n.\\!k-py-sm {\n    padding-block: 0.5rem !important;\n}\n\n.k-py-md {\n    padding-block: 0.75rem;\n}\n\n.\\!k-py-md {\n    padding-block: 0.75rem !important;\n}\n\n.k-py-lg {\n    padding-block: 1rem;\n}\n\n.\\!k-py-lg {\n    padding-block: 1rem !important;\n}\n\n.k-py-xl {\n    padding-block: 1.5rem;\n}\n\n.\\!k-py-xl {\n    padding-block: 1.5rem !important;\n}\n\n.k-py-thin {\n    padding-block: 0.125rem;\n}\n\n.\\!k-py-thin {\n    padding-block: 0.125rem !important;\n}\n\n.k-py-hair {\n    padding-block: 1px;\n}\n\n.\\!k-py-hair {\n    padding-block: 1px !important;\n}\n\n.k-h-0 {\n    height: 0;\n}\n\n.\\!k-h-0 {\n    height: 0 !important;\n}\n\n.k-h-1px {\n    height: 1px;\n}\n\n.\\!k-h-1px {\n    height: 1px !important;\n}\n\n.k-h-0\\.5 {\n    height: 0.125rem;\n}\n\n.\\!k-h-0\\.5 {\n    height: 0.125rem !important;\n}\n\n.k-h-1 {\n    height: 0.25rem;\n}\n\n.\\!k-h-1 {\n    height: 0.25rem !important;\n}\n\n.k-h-1\\.5 {\n    height: 0.375rem;\n}\n\n.\\!k-h-1\\.5 {\n    height: 0.375rem !important;\n}\n\n.k-h-2 {\n    height: 0.5rem;\n}\n\n.\\!k-h-2 {\n    height: 0.5rem !important;\n}\n\n.k-h-2\\.5 {\n    height: 0.625rem;\n}\n\n.\\!k-h-2\\.5 {\n    height: 0.625rem !important;\n}\n\n.k-h-3 {\n    height: 0.75rem;\n}\n\n.\\!k-h-3 {\n    height: 0.75rem !important;\n}\n\n.k-h-3\\.5 {\n    height: 0.875rem;\n}\n\n.\\!k-h-3\\.5 {\n    height: 0.875rem !important;\n}\n\n.k-h-4 {\n    height: 1rem;\n}\n\n.\\!k-h-4 {\n    height: 1rem !important;\n}\n\n.k-h-4\\.5 {\n    height: 1.125rem;\n}\n\n.\\!k-h-4\\.5 {\n    height: 1.125rem !important;\n}\n\n.k-h-5 {\n    height: 1.25rem;\n}\n\n.\\!k-h-5 {\n    height: 1.25rem !important;\n}\n\n.k-h-5\\.5 {\n    height: 1.375rem;\n}\n\n.\\!k-h-5\\.5 {\n    height: 1.375rem !important;\n}\n\n.k-h-6 {\n    height: 1.5rem;\n}\n\n.\\!k-h-6 {\n    height: 1.5rem !important;\n}\n\n.k-h-6\\.5 {\n    height: 1.625rem;\n}\n\n.\\!k-h-6\\.5 {\n    height: 1.625rem !important;\n}\n\n.k-h-7 {\n    height: 1.75rem;\n}\n\n.\\!k-h-7 {\n    height: 1.75rem !important;\n}\n\n.k-h-7\\.5 {\n    height: 1.875rem;\n}\n\n.\\!k-h-7\\.5 {\n    height: 1.875rem !important;\n}\n\n.k-h-8 {\n    height: 2rem;\n}\n\n.\\!k-h-8 {\n    height: 2rem !important;\n}\n\n.k-h-9 {\n    height: 2.25rem;\n}\n\n.\\!k-h-9 {\n    height: 2.25rem !important;\n}\n\n.k-h-10 {\n    height: 2.5rem;\n}\n\n.\\!k-h-10 {\n    height: 2.5rem !important;\n}\n\n.k-h-11 {\n    height: 2.75rem;\n}\n\n.\\!k-h-11 {\n    height: 2.75rem !important;\n}\n\n.k-h-12 {\n    height: 3rem;\n}\n\n.\\!k-h-12 {\n    height: 3rem !important;\n}\n\n.k-h-13 {\n    height: 3.25rem;\n}\n\n.\\!k-h-13 {\n    height: 3.25rem !important;\n}\n\n.k-h-14 {\n    height: 3.5rem;\n}\n\n.\\!k-h-14 {\n    height: 3.5rem !important;\n}\n\n.k-h-15 {\n    height: 3.75rem;\n}\n\n.\\!k-h-15 {\n    height: 3.75rem !important;\n}\n\n.k-h-16 {\n    height: 4rem;\n}\n\n.\\!k-h-16 {\n    height: 4rem !important;\n}\n\n.k-h-17 {\n    height: 4.25rem;\n}\n\n.\\!k-h-17 {\n    height: 4.25rem !important;\n}\n\n.k-h-18 {\n    height: 4.5rem;\n}\n\n.\\!k-h-18 {\n    height: 4.5rem !important;\n}\n\n.k-h-19 {\n    height: 4.75rem;\n}\n\n.\\!k-h-19 {\n    height: 4.75rem !important;\n}\n\n.k-h-20 {\n    height: 5rem;\n}\n\n.\\!k-h-20 {\n    height: 5rem !important;\n}\n\n.k-h-21 {\n    height: 5.25rem;\n}\n\n.\\!k-h-21 {\n    height: 5.25rem !important;\n}\n\n.k-h-22 {\n    height: 5.5rem;\n}\n\n.\\!k-h-22 {\n    height: 5.5rem !important;\n}\n\n.k-h-23 {\n    height: 5.75rem;\n}\n\n.\\!k-h-23 {\n    height: 5.75rem !important;\n}\n\n.k-h-24 {\n    height: 6rem;\n}\n\n.\\!k-h-24 {\n    height: 6rem !important;\n}\n\n.k-h-auto {\n    height: auto;\n}\n\n.\\!k-h-auto {\n    height: auto !important;\n}\n\n.k-h-1\\/2 {\n    height: 50%;\n}\n\n.\\!k-h-1\\/2 {\n    height: 50% !important;\n}\n\n.k-h-1\\/3 {\n    height: 33.333333%;\n}\n\n.\\!k-h-1\\/3 {\n    height: 33.333333% !important;\n}\n\n.k-h-2\\/3 {\n    height: 66.666667%;\n}\n\n.\\!k-h-2\\/3 {\n    height: 66.666667% !important;\n}\n\n.k-h-1\\/4 {\n    height: 25%;\n}\n\n.\\!k-h-1\\/4 {\n    height: 25% !important;\n}\n\n.k-h-2\\/4 {\n    height: 50%;\n}\n\n.\\!k-h-2\\/4 {\n    height: 50% !important;\n}\n\n.k-h-3\\/4 {\n    height: 75%;\n}\n\n.\\!k-h-3\\/4 {\n    height: 75% !important;\n}\n\n.k-h-1\\/5 {\n    height: 20%;\n}\n\n.\\!k-h-1\\/5 {\n    height: 20% !important;\n}\n\n.k-h-2\\/5 {\n    height: 40%;\n}\n\n.\\!k-h-2\\/5 {\n    height: 40% !important;\n}\n\n.k-h-3\\/5 {\n    height: 60%;\n}\n\n.\\!k-h-3\\/5 {\n    height: 60% !important;\n}\n\n.k-h-4\\/5 {\n    height: 80%;\n}\n\n.\\!k-h-4\\/5 {\n    height: 80% !important;\n}\n\n.k-h-1\\/6 {\n    height: 16.666667%;\n}\n\n.\\!k-h-1\\/6 {\n    height: 16.666667% !important;\n}\n\n.k-h-2\\/6 {\n    height: 33.333333%;\n}\n\n.\\!k-h-2\\/6 {\n    height: 33.333333% !important;\n}\n\n.k-h-3\\/6 {\n    height: 50%;\n}\n\n.\\!k-h-3\\/6 {\n    height: 50% !important;\n}\n\n.k-h-4\\/6 {\n    height: 66.666667%;\n}\n\n.\\!k-h-4\\/6 {\n    height: 66.666667% !important;\n}\n\n.k-h-5\\/6 {\n    height: 83.333333%;\n}\n\n.\\!k-h-5\\/6 {\n    height: 83.333333% !important;\n}\n\n.k-h-1\\/12 {\n    height: 8.333333%;\n}\n\n.\\!k-h-1\\/12 {\n    height: 8.333333% !important;\n}\n\n.k-h-2\\/12 {\n    height: 16.666667%;\n}\n\n.\\!k-h-2\\/12 {\n    height: 16.666667% !important;\n}\n\n.k-h-3\\/12 {\n    height: 25%;\n}\n\n.\\!k-h-3\\/12 {\n    height: 25% !important;\n}\n\n.k-h-4\\/12 {\n    height: 33.333333%;\n}\n\n.\\!k-h-4\\/12 {\n    height: 33.333333% !important;\n}\n\n.k-h-5\\/12 {\n    height: 41.666667%;\n}\n\n.\\!k-h-5\\/12 {\n    height: 41.666667% !important;\n}\n\n.k-h-6\\/12 {\n    height: 50%;\n}\n\n.\\!k-h-6\\/12 {\n    height: 50% !important;\n}\n\n.k-h-7\\/12 {\n    height: 58.333333%;\n}\n\n.\\!k-h-7\\/12 {\n    height: 58.333333% !important;\n}\n\n.k-h-8\\/12 {\n    height: 66.666667%;\n}\n\n.\\!k-h-8\\/12 {\n    height: 66.666667% !important;\n}\n\n.k-h-9\\/12 {\n    height: 75%;\n}\n\n.\\!k-h-9\\/12 {\n    height: 75% !important;\n}\n\n.k-h-10\\/12 {\n    height: 83.333333%;\n}\n\n.\\!k-h-10\\/12 {\n    height: 83.333333% !important;\n}\n\n.k-h-11\\/12 {\n    height: 91.666667%;\n}\n\n.\\!k-h-11\\/12 {\n    height: 91.666667% !important;\n}\n\n.k-h-full {\n    height: 100%;\n}\n\n.\\!k-h-full {\n    height: 100% !important;\n}\n\n.k-h-min {\n    height: min-content;\n}\n\n.\\!k-h-min {\n    height: min-content !important;\n}\n\n.k-h-max {\n    height: max-content;\n}\n\n.\\!k-h-max {\n    height: max-content !important;\n}\n\n.k-h-fit {\n    height: -moz-fit-content;\n    height: fit-content;\n}\n\n.\\!k-h-fit {\n    height: -moz-fit-content !important;\n    height: fit-content !important;\n}\n\n.k-h-screen {\n    height: 100vh;\n}\n\n.\\!k-h-screen {\n    height: 100vh !important;\n}\n\n.k-min-h-0 {\n    min-height: 0;\n}\n\n.\\!k-min-h-0 {\n    min-height: 0 !important;\n}\n\n.k-min-h-full {\n    min-height: 100%;\n}\n\n.\\!k-min-h-full {\n    min-height: 100% !important;\n}\n\n.k-min-h-screen {\n    min-height: 100vh;\n}\n\n.\\!k-min-h-screen {\n    min-height: 100vh !important;\n}\n\n.k-min-h-min {\n    min-height: min-content;\n}\n\n.\\!k-min-h-min {\n    min-height: min-content !important;\n}\n\n.k-min-h-max {\n    min-height: max-content;\n}\n\n.\\!k-min-h-max {\n    min-height: max-content !important;\n}\n\n.k-min-h-fit {\n    min-height: -moz-fit-content;\n    min-height: fit-content;\n}\n\n.\\!k-min-h-fit {\n    min-height: -moz-fit-content !important;\n    min-height: fit-content !important;\n}\n\n.k-max-h-none {\n    max-height: none;\n}\n\n.\\!k-max-h-none {\n    max-height: none !important;\n}\n\n.k-max-h-0 {\n    max-height: 0;\n}\n\n.\\!k-max-h-0 {\n    max-height: 0 !important;\n}\n\n.k-max-h-full {\n    max-height: 100%;\n}\n\n.\\!k-max-h-full {\n    max-height: 100% !important;\n}\n\n.k-max-h-screen {\n    max-height: 100vh;\n}\n\n.\\!k-max-h-screen {\n    max-height: 100vh !important;\n}\n\n.k-max-h-min {\n    max-height: min-content;\n}\n\n.\\!k-max-h-min {\n    max-height: min-content !important;\n}\n\n.k-max-h-max {\n    max-height: max-content;\n}\n\n.\\!k-max-h-max {\n    max-height: max-content !important;\n}\n\n.k-max-h-fit {\n    max-height: -moz-fit-content;\n    max-height: fit-content;\n}\n\n.\\!k-max-h-fit {\n    max-height: -moz-fit-content !important;\n    max-height: fit-content !important;\n}\n\n.k-w-0 {\n    width: 0;\n}\n\n.\\!k-w-0 {\n    width: 0 !important;\n}\n\n.k-w-1px {\n    width: 1px;\n}\n\n.\\!k-w-1px {\n    width: 1px !important;\n}\n\n.k-w-0\\.5 {\n    width: 0.125rem;\n}\n\n.\\!k-w-0\\.5 {\n    width: 0.125rem !important;\n}\n\n.k-w-1 {\n    width: 0.25rem;\n}\n\n.\\!k-w-1 {\n    width: 0.25rem !important;\n}\n\n.k-w-1\\.5 {\n    width: 0.375rem;\n}\n\n.\\!k-w-1\\.5 {\n    width: 0.375rem !important;\n}\n\n.k-w-2 {\n    width: 0.5rem;\n}\n\n.\\!k-w-2 {\n    width: 0.5rem !important;\n}\n\n.k-w-2\\.5 {\n    width: 0.625rem;\n}\n\n.\\!k-w-2\\.5 {\n    width: 0.625rem !important;\n}\n\n.k-w-3 {\n    width: 0.75rem;\n}\n\n.\\!k-w-3 {\n    width: 0.75rem !important;\n}\n\n.k-w-3\\.5 {\n    width: 0.875rem;\n}\n\n.\\!k-w-3\\.5 {\n    width: 0.875rem !important;\n}\n\n.k-w-4 {\n    width: 1rem;\n}\n\n.\\!k-w-4 {\n    width: 1rem !important;\n}\n\n.k-w-4\\.5 {\n    width: 1.125rem;\n}\n\n.\\!k-w-4\\.5 {\n    width: 1.125rem !important;\n}\n\n.k-w-5 {\n    width: 1.25rem;\n}\n\n.\\!k-w-5 {\n    width: 1.25rem !important;\n}\n\n.k-w-5\\.5 {\n    width: 1.375rem;\n}\n\n.\\!k-w-5\\.5 {\n    width: 1.375rem !important;\n}\n\n.k-w-6 {\n    width: 1.5rem;\n}\n\n.\\!k-w-6 {\n    width: 1.5rem !important;\n}\n\n.k-w-6\\.5 {\n    width: 1.625rem;\n}\n\n.\\!k-w-6\\.5 {\n    width: 1.625rem !important;\n}\n\n.k-w-7 {\n    width: 1.75rem;\n}\n\n.\\!k-w-7 {\n    width: 1.75rem !important;\n}\n\n.k-w-7\\.5 {\n    width: 1.875rem;\n}\n\n.\\!k-w-7\\.5 {\n    width: 1.875rem !important;\n}\n\n.k-w-8 {\n    width: 2rem;\n}\n\n.\\!k-w-8 {\n    width: 2rem !important;\n}\n\n.k-w-9 {\n    width: 2.25rem;\n}\n\n.\\!k-w-9 {\n    width: 2.25rem !important;\n}\n\n.k-w-10 {\n    width: 2.5rem;\n}\n\n.\\!k-w-10 {\n    width: 2.5rem !important;\n}\n\n.k-w-11 {\n    width: 2.75rem;\n}\n\n.\\!k-w-11 {\n    width: 2.75rem !important;\n}\n\n.k-w-12 {\n    width: 3rem;\n}\n\n.\\!k-w-12 {\n    width: 3rem !important;\n}\n\n.k-w-13 {\n    width: 3.25rem;\n}\n\n.\\!k-w-13 {\n    width: 3.25rem !important;\n}\n\n.k-w-14 {\n    width: 3.5rem;\n}\n\n.\\!k-w-14 {\n    width: 3.5rem !important;\n}\n\n.k-w-15 {\n    width: 3.75rem;\n}\n\n.\\!k-w-15 {\n    width: 3.75rem !important;\n}\n\n.k-w-16 {\n    width: 4rem;\n}\n\n.\\!k-w-16 {\n    width: 4rem !important;\n}\n\n.k-w-17 {\n    width: 4.25rem;\n}\n\n.\\!k-w-17 {\n    width: 4.25rem !important;\n}\n\n.k-w-18 {\n    width: 4.5rem;\n}\n\n.\\!k-w-18 {\n    width: 4.5rem !important;\n}\n\n.k-w-19 {\n    width: 4.75rem;\n}\n\n.\\!k-w-19 {\n    width: 4.75rem !important;\n}\n\n.k-w-20 {\n    width: 5rem;\n}\n\n.\\!k-w-20 {\n    width: 5rem !important;\n}\n\n.k-w-21 {\n    width: 5.25rem;\n}\n\n.\\!k-w-21 {\n    width: 5.25rem !important;\n}\n\n.k-w-22 {\n    width: 5.5rem;\n}\n\n.\\!k-w-22 {\n    width: 5.5rem !important;\n}\n\n.k-w-23 {\n    width: 5.75rem;\n}\n\n.\\!k-w-23 {\n    width: 5.75rem !important;\n}\n\n.k-w-24 {\n    width: 6rem;\n}\n\n.\\!k-w-24 {\n    width: 6rem !important;\n}\n\n.k-w-auto {\n    width: auto;\n}\n\n.\\!k-w-auto {\n    width: auto !important;\n}\n\n.k-w-1\\/2 {\n    width: 50%;\n}\n\n.\\!k-w-1\\/2 {\n    width: 50% !important;\n}\n\n.k-w-1\\/3 {\n    width: 33.333333%;\n}\n\n.\\!k-w-1\\/3 {\n    width: 33.333333% !important;\n}\n\n.k-w-2\\/3 {\n    width: 66.666667%;\n}\n\n.\\!k-w-2\\/3 {\n    width: 66.666667% !important;\n}\n\n.k-w-1\\/4 {\n    width: 25%;\n}\n\n.\\!k-w-1\\/4 {\n    width: 25% !important;\n}\n\n.k-w-2\\/4 {\n    width: 50%;\n}\n\n.\\!k-w-2\\/4 {\n    width: 50% !important;\n}\n\n.k-w-3\\/4 {\n    width: 75%;\n}\n\n.\\!k-w-3\\/4 {\n    width: 75% !important;\n}\n\n.k-w-1\\/5 {\n    width: 20%;\n}\n\n.\\!k-w-1\\/5 {\n    width: 20% !important;\n}\n\n.k-w-2\\/5 {\n    width: 40%;\n}\n\n.\\!k-w-2\\/5 {\n    width: 40% !important;\n}\n\n.k-w-3\\/5 {\n    width: 60%;\n}\n\n.\\!k-w-3\\/5 {\n    width: 60% !important;\n}\n\n.k-w-4\\/5 {\n    width: 80%;\n}\n\n.\\!k-w-4\\/5 {\n    width: 80% !important;\n}\n\n.k-w-1\\/6 {\n    width: 16.666667%;\n}\n\n.\\!k-w-1\\/6 {\n    width: 16.666667% !important;\n}\n\n.k-w-2\\/6 {\n    width: 33.333333%;\n}\n\n.\\!k-w-2\\/6 {\n    width: 33.333333% !important;\n}\n\n.k-w-3\\/6 {\n    width: 50%;\n}\n\n.\\!k-w-3\\/6 {\n    width: 50% !important;\n}\n\n.k-w-4\\/6 {\n    width: 66.666667%;\n}\n\n.\\!k-w-4\\/6 {\n    width: 66.666667% !important;\n}\n\n.k-w-5\\/6 {\n    width: 83.333333%;\n}\n\n.\\!k-w-5\\/6 {\n    width: 83.333333% !important;\n}\n\n.k-w-1\\/12 {\n    width: 8.333333%;\n}\n\n.\\!k-w-1\\/12 {\n    width: 8.333333% !important;\n}\n\n.k-w-2\\/12 {\n    width: 16.666667%;\n}\n\n.\\!k-w-2\\/12 {\n    width: 16.666667% !important;\n}\n\n.k-w-3\\/12 {\n    width: 25%;\n}\n\n.\\!k-w-3\\/12 {\n    width: 25% !important;\n}\n\n.k-w-4\\/12 {\n    width: 33.333333%;\n}\n\n.\\!k-w-4\\/12 {\n    width: 33.333333% !important;\n}\n\n.k-w-5\\/12 {\n    width: 41.666667%;\n}\n\n.\\!k-w-5\\/12 {\n    width: 41.666667% !important;\n}\n\n.k-w-6\\/12 {\n    width: 50%;\n}\n\n.\\!k-w-6\\/12 {\n    width: 50% !important;\n}\n\n.k-w-7\\/12 {\n    width: 58.333333%;\n}\n\n.\\!k-w-7\\/12 {\n    width: 58.333333% !important;\n}\n\n.k-w-8\\/12 {\n    width: 66.666667%;\n}\n\n.\\!k-w-8\\/12 {\n    width: 66.666667% !important;\n}\n\n.k-w-9\\/12 {\n    width: 75%;\n}\n\n.\\!k-w-9\\/12 {\n    width: 75% !important;\n}\n\n.k-w-10\\/12 {\n    width: 83.333333%;\n}\n\n.\\!k-w-10\\/12 {\n    width: 83.333333% !important;\n}\n\n.k-w-11\\/12 {\n    width: 91.666667%;\n}\n\n.\\!k-w-11\\/12 {\n    width: 91.666667% !important;\n}\n\n.k-w-full {\n    width: 100%;\n}\n\n.\\!k-w-full {\n    width: 100% !important;\n}\n\n.k-w-min {\n    width: min-content;\n}\n\n.\\!k-w-min {\n    width: min-content !important;\n}\n\n.k-w-max {\n    width: max-content;\n}\n\n.\\!k-w-max {\n    width: max-content !important;\n}\n\n.k-w-fit {\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.\\!k-w-fit {\n    width: -moz-fit-content !important;\n    width: fit-content !important;\n}\n\n.k-w-screen {\n    width: 100vw;\n}\n\n.\\!k-w-screen {\n    width: 100vw !important;\n}\n\n.k-min-w-0 {\n    min-width: 0;\n}\n\n.\\!k-min-w-0 {\n    min-width: 0 !important;\n}\n\n.k-min-w-full {\n    min-width: 100%;\n}\n\n.\\!k-min-w-full {\n    min-width: 100% !important;\n}\n\n.k-min-w-screen {\n    min-width: 100vw;\n}\n\n.\\!k-min-w-screen {\n    min-width: 100vw !important;\n}\n\n.k-min-w-min {\n    min-width: min-content;\n}\n\n.\\!k-min-w-min {\n    min-width: min-content !important;\n}\n\n.k-min-w-max {\n    min-width: max-content;\n}\n\n.\\!k-min-w-max {\n    min-width: max-content !important;\n}\n\n.k-min-w-fit {\n    min-width: -moz-fit-content;\n    min-width: fit-content;\n}\n\n.\\!k-min-w-fit {\n    min-width: -moz-fit-content !important;\n    min-width: fit-content !important;\n}\n\n.k-max-w-none {\n    max-width: none;\n}\n\n.\\!k-max-w-none {\n    max-width: none !important;\n}\n\n.k-max-w-0 {\n    max-width: 0;\n}\n\n.\\!k-max-w-0 {\n    max-width: 0 !important;\n}\n\n.k-max-w-full {\n    max-width: 100%;\n}\n\n.\\!k-max-w-full {\n    max-width: 100% !important;\n}\n\n.k-max-w-screen {\n    max-width: 100vw;\n}\n\n.\\!k-max-w-screen {\n    max-width: 100vw !important;\n}\n\n.k-max-w-min {\n    max-width: min-content;\n}\n\n.\\!k-max-w-min {\n    max-width: min-content !important;\n}\n\n.k-max-w-max {\n    max-width: max-content;\n}\n\n.\\!k-max-w-max {\n    max-width: max-content !important;\n}\n\n.k-max-w-fit {\n    max-width: -moz-fit-content;\n    max-width: fit-content;\n}\n\n.\\!k-max-w-fit {\n    max-width: -moz-fit-content !important;\n    max-width: fit-content !important;\n}\n\n.k-font-size-xs {\n    font-size: 0.75rem;\n}\n\n.\\!k-font-size-xs {\n    font-size: 0.75rem !important;\n}\n\n.k-font-size-sm {\n    font-size: 0.875rem;\n}\n\n.\\!k-font-size-sm {\n    font-size: 0.875rem !important;\n}\n\n.k-font-size-md {\n    font-size: 1rem;\n}\n\n.\\!k-font-size-md {\n    font-size: 1rem !important;\n}\n\n.k-font-size-lg {\n    font-size: 1.25rem;\n}\n\n.\\!k-font-size-lg {\n    font-size: 1.25rem !important;\n}\n\n.k-font-size-xl {\n    font-size: 1.5rem;\n}\n\n.\\!k-font-size-xl {\n    font-size: 1.5rem !important;\n}\n\n.k-fs-xs {\n    font-size: 0.75rem;\n}\n\n.\\!k-fs-xs {\n    font-size: 0.75rem !important;\n}\n\n.k-fs-sm {\n    font-size: 0.875rem;\n}\n\n.\\!k-fs-sm {\n    font-size: 0.875rem !important;\n}\n\n.k-fs-md {\n    font-size: 1rem;\n}\n\n.\\!k-fs-md {\n    font-size: 1rem !important;\n}\n\n.k-fs-lg {\n    font-size: 1.25rem;\n}\n\n.\\!k-fs-lg {\n    font-size: 1.25rem !important;\n}\n\n.k-fs-xl {\n    font-size: 1.5rem;\n}\n\n.\\!k-fs-xl {\n    font-size: 1.5rem !important;\n}\n\n.k-font-italic {\n    font-style: italic;\n}\n\n.\\!k-font-italic {\n    font-style: italic !important;\n}\n\n.k-font-non-italic {\n    font-style: normal;\n}\n\n.\\!k-font-non-italic {\n    font-style: normal !important;\n}\n\n.k-font-thin {\n    font-weight: 100;\n}\n\n.\\!k-font-thin {\n    font-weight: 100 !important;\n}\n\n.k-font-extralight {\n    font-weight: 200;\n}\n\n.\\!k-font-extralight {\n    font-weight: 200 !important;\n}\n\n.k-font-light {\n    font-weight: 300;\n}\n\n.\\!k-font-light {\n    font-weight: 300 !important;\n}\n\n.k-font-normal {\n    font-weight: 400;\n}\n\n.\\!k-font-normal {\n    font-weight: 400 !important;\n}\n\n.k-font-medium {\n    font-weight: 500;\n}\n\n.\\!k-font-medium {\n    font-weight: 500 !important;\n}\n\n.k-font-semibold {\n    font-weight: 600;\n}\n\n.\\!k-font-semibold {\n    font-weight: 600 !important;\n}\n\n.k-font-bold {\n    font-weight: 700;\n}\n\n.\\!k-font-bold {\n    font-weight: 700 !important;\n}\n\n.k-font-extrabold {\n    font-weight: 800;\n}\n\n.\\!k-font-extrabold {\n    font-weight: 800 !important;\n}\n\n.k-font-black {\n    font-weight: 900;\n}\n\n.\\!k-font-black {\n    font-weight: 900 !important;\n}\n\n.k-font-weight-thin {\n    font-weight: 100;\n}\n\n.\\!k-font-weight-thin {\n    font-weight: 100 !important;\n}\n\n.k-font-weight-extralight {\n    font-weight: 200;\n}\n\n.\\!k-font-weight-extralight {\n    font-weight: 200 !important;\n}\n\n.k-font-weight-light {\n    font-weight: 300;\n}\n\n.\\!k-font-weight-light {\n    font-weight: 300 !important;\n}\n\n.k-font-weight-normal {\n    font-weight: 400;\n}\n\n.\\!k-font-weight-normal {\n    font-weight: 400 !important;\n}\n\n.k-font-weight-medium {\n    font-weight: 500;\n}\n\n.\\!k-font-weight-medium {\n    font-weight: 500 !important;\n}\n\n.k-font-weight-semibold {\n    font-weight: 600;\n}\n\n.\\!k-font-weight-semibold {\n    font-weight: 600 !important;\n}\n\n.k-font-weight-bold {\n    font-weight: 700;\n}\n\n.\\!k-font-weight-bold {\n    font-weight: 700 !important;\n}\n\n.k-font-weight-extrabold {\n    font-weight: 800;\n}\n\n.\\!k-font-weight-extrabold {\n    font-weight: 800 !important;\n}\n\n.k-font-weight-black {\n    font-weight: 900;\n}\n\n.\\!k-font-weight-black {\n    font-weight: 900 !important;\n}\n\n.k-list-none {\n    list-style-type: none;\n}\n\n.\\!k-list-none {\n    list-style-type: none !important;\n}\n\n.k-list-disc {\n    list-style-type: disc;\n}\n\n.\\!k-list-disc {\n    list-style-type: disc !important;\n}\n\n.k-list-decimal {\n    list-style-type: decimal;\n}\n\n.\\!k-list-decimal {\n    list-style-type: decimal !important;\n}\n\n.k-text-left {\n    text-align: left;\n}\n\n.\\!k-text-left {\n    text-align: left !important;\n}\n\n.k-text-right {\n    text-align: right;\n}\n\n.\\!k-text-right {\n    text-align: right !important;\n}\n\n.k-text-center {\n    text-align: center;\n}\n\n.\\!k-text-center {\n    text-align: center !important;\n}\n\n.k-text-justify {\n    text-align: justify;\n}\n\n.\\!k-text-justify {\n    text-align: justify !important;\n}\n\n.k-text-start {\n    text-align: start;\n}\n\n.\\!k-text-start {\n    text-align: start !important;\n}\n\n.k-text-end {\n    text-align: end;\n}\n\n.\\!k-text-end {\n    text-align: end !important;\n}\n\n.k-text-primary {\n    color: #0d6efd;\n}\n\n.\\!k-text-primary {\n    color: #0d6efd !important;\n}\n\n.k-text-secondary {\n    color: #6c757d;\n}\n\n.\\!k-text-secondary {\n    color: #6c757d !important;\n}\n\n.k-text-tertiary {\n    color: #6f42c1;\n}\n\n.\\!k-text-tertiary {\n    color: #6f42c1 !important;\n}\n\n.k-text-info {\n    color: #0dcaf0;\n}\n\n.\\!k-text-info {\n    color: #0dcaf0 !important;\n}\n\n.k-text-success {\n    color: #198754;\n}\n\n.\\!k-text-success {\n    color: #198754 !important;\n}\n\n.k-text-warning {\n    color: #ffc107;\n}\n\n.\\!k-text-warning {\n    color: #ffc107 !important;\n}\n\n.k-text-error {\n    color: #dc3545;\n}\n\n.\\!k-text-error {\n    color: #dc3545 !important;\n}\n\n.k-text-dark {\n    color: #212529;\n}\n\n.\\!k-text-dark {\n    color: #212529 !important;\n}\n\n.k-text-light {\n    color: #f8f9fa;\n}\n\n.\\!k-text-light {\n    color: #f8f9fa !important;\n}\n\n.k-text-inverse {\n    color: #212529;\n}\n\n.\\!k-text-inverse {\n    color: #212529 !important;\n}\n\n.k-text-inherit {\n    color: inherit;\n}\n\n.\\!k-text-inherit {\n    color: inherit !important;\n}\n\n.k-text-current {\n    color: currentColor;\n}\n\n.\\!k-text-current {\n    color: currentColor !important;\n}\n\n.k-text-transparent {\n    color: transparent;\n}\n\n.\\!k-text-transparent {\n    color: transparent !important;\n}\n\n.k-text-black {\n    color: black;\n}\n\n.\\!k-text-black {\n    color: black !important;\n}\n\n.k-text-white {\n    color: white;\n}\n\n.\\!k-text-white {\n    color: white !important;\n}\n\n.k-color-primary {\n    color: #0d6efd;\n}\n\n.\\!k-color-primary {\n    color: #0d6efd !important;\n}\n\n.k-color-secondary {\n    color: #6c757d;\n}\n\n.\\!k-color-secondary {\n    color: #6c757d !important;\n}\n\n.k-color-tertiary {\n    color: #6f42c1;\n}\n\n.\\!k-color-tertiary {\n    color: #6f42c1 !important;\n}\n\n.k-color-info {\n    color: #0dcaf0;\n}\n\n.\\!k-color-info {\n    color: #0dcaf0 !important;\n}\n\n.k-color-success {\n    color: #198754;\n}\n\n.\\!k-color-success {\n    color: #198754 !important;\n}\n\n.k-color-warning {\n    color: #ffc107;\n}\n\n.\\!k-color-warning {\n    color: #ffc107 !important;\n}\n\n.k-color-error {\n    color: #dc3545;\n}\n\n.\\!k-color-error {\n    color: #dc3545 !important;\n}\n\n.k-color-dark {\n    color: #212529;\n}\n\n.\\!k-color-dark {\n    color: #212529 !important;\n}\n\n.k-color-light {\n    color: #f8f9fa;\n}\n\n.\\!k-color-light {\n    color: #f8f9fa !important;\n}\n\n.k-color-inverse {\n    color: #212529;\n}\n\n.\\!k-color-inverse {\n    color: #212529 !important;\n}\n\n.k-color-inherit {\n    color: inherit;\n}\n\n.\\!k-color-inherit {\n    color: inherit !important;\n}\n\n.k-color-current {\n    color: currentColor;\n}\n\n.\\!k-color-current {\n    color: currentColor !important;\n}\n\n.k-color-transparent {\n    color: transparent;\n}\n\n.\\!k-color-transparent {\n    color: transparent !important;\n}\n\n.k-color-black {\n    color: black;\n}\n\n.\\!k-color-black {\n    color: black !important;\n}\n\n.k-color-white {\n    color: white;\n}\n\n.\\!k-color-white {\n    color: white !important;\n}\n\n.k-text-underline {\n    text-decoration: underline;\n}\n\n.\\!k-text-underline {\n    text-decoration: underline !important;\n}\n\n.k-text-overline {\n    text-decoration: overline;\n}\n\n.\\!k-text-overline {\n    text-decoration: overline !important;\n}\n\n.k-text-line-through {\n    text-decoration: line-through;\n}\n\n.\\!k-text-line-through {\n    text-decoration: line-through !important;\n}\n\n.k-text-no-underline {\n    text-decoration: none;\n}\n\n.\\!k-text-no-underline {\n    text-decoration: none !important;\n}\n\n.k-text-clip {\n    text-overflow: clip;\n}\n\n.\\!k-text-clip {\n    text-overflow: clip !important;\n}\n\n.k-text-ellipsis {\n    text-overflow: ellipsis;\n}\n\n.\\!k-text-ellipsis {\n    text-overflow: ellipsis !important;\n}\n\n.k-text-truncate, .k-text-ellipsis {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.\\!k-text-truncate, .\\!k-text-ellipsis {\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n}\n\n.k-text-uppercase {\n    text-transform: uppercase;\n}\n\n.\\!k-text-uppercase {\n    text-transform: uppercase !important;\n}\n\n.k-text-lowercase {\n    text-transform: lowercase;\n}\n\n.\\!k-text-lowercase {\n    text-transform: lowercase !important;\n}\n\n.k-text-capitalize {\n    text-transform: capitalize;\n}\n\n.\\!k-text-capitalize {\n    text-transform: capitalize !important;\n}\n\n.k-text-normal-case {\n    text-transform: none;\n}\n\n.\\!k-text-normal-case {\n    text-transform: none !important;\n}\n\n.k-align-baseline {\n    vertical-align: baseline;\n}\n\n.\\!k-align-baseline {\n    vertical-align: baseline !important;\n}\n\n.k-align-top {\n    vertical-align: top;\n}\n\n.\\!k-align-top {\n    vertical-align: top !important;\n}\n\n.k-align-middle {\n    vertical-align: middle;\n}\n\n.\\!k-align-middle {\n    vertical-align: middle !important;\n}\n\n.k-align-bottom {\n    vertical-align: bottom;\n}\n\n.\\!k-align-bottom {\n    vertical-align: bottom !important;\n}\n\n.k-align-text-top {\n    vertical-align: text-top;\n}\n\n.\\!k-align-text-top {\n    vertical-align: text-top !important;\n}\n\n.k-align-text-bottom {\n    vertical-align: text-bottom;\n}\n\n.\\!k-align-text-bottom {\n    vertical-align: text-bottom !important;\n}\n\n.k-align-sub {\n    vertical-align: sub;\n}\n\n.\\!k-align-sub {\n    vertical-align: sub !important;\n}\n\n.k-align-super {\n    vertical-align: super;\n}\n\n.\\!k-align-super {\n    vertical-align: super !important;\n}\n\n.k-white-space-normal {\n    white-space: normal;\n}\n\n.\\!k-white-space-normal {\n    white-space: normal !important;\n}\n\n.k-white-space-nowrap, .k-text-nowrap {\n    white-space: nowrap;\n}\n\n.\\!k-white-space-nowrap {\n    white-space: nowrap !important;\n}\n\n.k-white-space-pre {\n    white-space: pre;\n}\n\n.\\!k-white-space-pre {\n    white-space: pre !important;\n}\n\n.k-white-space-pre-line {\n    white-space: pre-line;\n}\n\n.\\!k-white-space-pre-line {\n    white-space: pre-line !important;\n}\n\n.k-white-space-pre-wrap {\n    white-space: pre-wrap;\n}\n\n.\\!k-white-space-pre-wrap {\n    white-space: pre-wrap !important;\n}\n\n.k-white-space-break-spaces {\n    white-space: break-spaces;\n}\n\n.\\!k-white-space-break-spaces {\n    white-space: break-spaces !important;\n}\n\n.k-whitespace-normal {\n    white-space: normal;\n}\n\n.\\!k-whitespace-normal {\n    white-space: normal !important;\n}\n\n.k-whitespace-nowrap {\n    white-space: nowrap;\n}\n\n.\\!k-whitespace-nowrap {\n    white-space: nowrap !important;\n}\n\n.k-whitespace-pre {\n    white-space: pre;\n}\n\n.\\!k-whitespace-pre {\n    white-space: pre !important;\n}\n\n.k-whitespace-pre-line {\n    white-space: pre-line;\n}\n\n.\\!k-whitespace-pre-line {\n    white-space: pre-line !important;\n}\n\n.k-whitespace-pre-wrap {\n    white-space: pre-wrap;\n}\n\n.\\!k-whitespace-pre-wrap {\n    white-space: pre-wrap !important;\n}\n\n.k-whitespace-break-spaces {\n    white-space: break-spaces;\n}\n\n.\\!k-whitespace-break-spaces {\n    white-space: break-spaces !important;\n}\n\n.k-bg-clip-border {\n    background-clip: border-box;\n}\n\n.\\!k-bg-clip-border {\n    background-clip: border-box !important;\n}\n\n.k-bg-clip-padding {\n    background-clip: padding-box;\n}\n\n.\\!k-bg-clip-padding {\n    background-clip: padding-box !important;\n}\n\n.k-bg-clip-content {\n    background-clip: content-box;\n}\n\n.\\!k-bg-clip-content {\n    background-clip: content-box !important;\n}\n\n.k-bg-clip-text {\n    -webkit-background-clip: text;\n            background-clip: text;\n}\n\n.\\!k-bg-clip-text {\n    -webkit-background-clip: text !important;\n            background-clip: text !important;\n}\n\n.k-bg-primary {\n    background-color: #0d6efd;\n}\n\n.\\!k-bg-primary {\n    background-color: #0d6efd !important;\n}\n\n.k-bg-secondary {\n    background-color: #6c757d;\n}\n\n.\\!k-bg-secondary {\n    background-color: #6c757d !important;\n}\n\n.k-bg-tertiary {\n    background-color: #6f42c1;\n}\n\n.\\!k-bg-tertiary {\n    background-color: #6f42c1 !important;\n}\n\n.k-bg-info {\n    background-color: #0dcaf0;\n}\n\n.\\!k-bg-info {\n    background-color: #0dcaf0 !important;\n}\n\n.k-bg-success {\n    background-color: #198754;\n}\n\n.\\!k-bg-success {\n    background-color: #198754 !important;\n}\n\n.k-bg-warning {\n    background-color: #ffc107;\n}\n\n.\\!k-bg-warning {\n    background-color: #ffc107 !important;\n}\n\n.k-bg-error {\n    background-color: #dc3545;\n}\n\n.\\!k-bg-error {\n    background-color: #dc3545 !important;\n}\n\n.k-bg-dark {\n    background-color: #212529;\n}\n\n.\\!k-bg-dark {\n    background-color: #212529 !important;\n}\n\n.k-bg-light {\n    background-color: #f8f9fa;\n}\n\n.\\!k-bg-light {\n    background-color: #f8f9fa !important;\n}\n\n.k-bg-inverse {\n    background-color: #212529;\n}\n\n.\\!k-bg-inverse {\n    background-color: #212529 !important;\n}\n\n.k-bg-inherit {\n    background-color: inherit;\n}\n\n.\\!k-bg-inherit {\n    background-color: inherit !important;\n}\n\n.k-bg-transparent {\n    background-color: transparent;\n}\n\n.\\!k-bg-transparent {\n    background-color: transparent !important;\n}\n\n.k-bg-black {\n    background-color: black;\n}\n\n.\\!k-bg-black {\n    background-color: black !important;\n}\n\n.k-bg-white {\n    background-color: white;\n}\n\n.\\!k-bg-white {\n    background-color: white !important;\n}\n\n.k-bg-center {\n    background-position: center;\n}\n\n.\\!k-bg-center {\n    background-position: center !important;\n}\n\n.k-bg-top {\n    background-position: top;\n}\n\n.\\!k-bg-top {\n    background-position: top !important;\n}\n\n.k-bg-right {\n    background-position: right;\n}\n\n.\\!k-bg-right {\n    background-position: right !important;\n}\n\n.k-bg-bottom {\n    background-position: bottom;\n}\n\n.\\!k-bg-bottom {\n    background-position: bottom !important;\n}\n\n.k-bg-left {\n    background-position: left;\n}\n\n.\\!k-bg-left {\n    background-position: left !important;\n}\n\n.k-bg-top-left {\n    background-position: top left;\n}\n\n.\\!k-bg-top-left {\n    background-position: top left !important;\n}\n\n.k-bg-top-right {\n    background-position: top right;\n}\n\n.\\!k-bg-top-right {\n    background-position: top right !important;\n}\n\n.k-bg-bottom-left {\n    background-position: bottom left;\n}\n\n.\\!k-bg-bottom-left {\n    background-position: bottom left !important;\n}\n\n.k-bg-bottom-right {\n    background-position: bottom right;\n}\n\n.\\!k-bg-bottom-right {\n    background-position: bottom right !important;\n}\n\n.k-bg-auto {\n    background-size: auto;\n}\n\n.\\!k-bg-auto {\n    background-size: auto !important;\n}\n\n.k-bg-cover {\n    background-size: cover;\n}\n\n.\\!k-bg-cover {\n    background-size: cover !important;\n}\n\n.k-bg-contain {\n    background-size: contain;\n}\n\n.\\!k-bg-contain {\n    background-size: contain !important;\n}\n\n.k-border-primary {\n    border-color: #0d6efd;\n}\n\n.\\!k-border-primary {\n    border-color: #0d6efd !important;\n}\n\n.k-border-secondary {\n    border-color: #6c757d;\n}\n\n.\\!k-border-secondary {\n    border-color: #6c757d !important;\n}\n\n.k-border-tertiary {\n    border-color: #6f42c1;\n}\n\n.\\!k-border-tertiary {\n    border-color: #6f42c1 !important;\n}\n\n.k-border-info {\n    border-color: #0dcaf0;\n}\n\n.\\!k-border-info {\n    border-color: #0dcaf0 !important;\n}\n\n.k-border-success {\n    border-color: #198754;\n}\n\n.\\!k-border-success {\n    border-color: #198754 !important;\n}\n\n.k-border-warning {\n    border-color: #ffc107;\n}\n\n.\\!k-border-warning {\n    border-color: #ffc107 !important;\n}\n\n.k-border-error {\n    border-color: #dc3545;\n}\n\n.\\!k-border-error {\n    border-color: #dc3545 !important;\n}\n\n.k-border-dark {\n    border-color: #212529;\n}\n\n.\\!k-border-dark {\n    border-color: #212529 !important;\n}\n\n.k-border-light {\n    border-color: #f8f9fa;\n}\n\n.\\!k-border-light {\n    border-color: #f8f9fa !important;\n}\n\n.k-border-inverse {\n    border-color: #212529;\n}\n\n.\\!k-border-inverse {\n    border-color: #212529 !important;\n}\n\n.k-border-inherit {\n    border-color: inherit;\n}\n\n.\\!k-border-inherit {\n    border-color: inherit !important;\n}\n\n.k-border-current {\n    border-color: currentColor;\n}\n\n.\\!k-border-current {\n    border-color: currentColor !important;\n}\n\n.k-border-transparent {\n    border-color: transparent;\n}\n\n.\\!k-border-transparent {\n    border-color: transparent !important;\n}\n\n.k-border-black {\n    border-color: black;\n}\n\n.\\!k-border-black {\n    border-color: black !important;\n}\n\n.k-border-white {\n    border-color: white;\n}\n\n.\\!k-border-white {\n    border-color: white !important;\n}\n\n.k-border-t-primary {\n    border-top-color: #0d6efd;\n}\n\n.\\!k-border-t-primary {\n    border-top-color: #0d6efd !important;\n}\n\n.k-border-t-secondary {\n    border-top-color: #6c757d;\n}\n\n.\\!k-border-t-secondary {\n    border-top-color: #6c757d !important;\n}\n\n.k-border-t-tertiary {\n    border-top-color: #6f42c1;\n}\n\n.\\!k-border-t-tertiary {\n    border-top-color: #6f42c1 !important;\n}\n\n.k-border-t-info {\n    border-top-color: #0dcaf0;\n}\n\n.\\!k-border-t-info {\n    border-top-color: #0dcaf0 !important;\n}\n\n.k-border-t-success {\n    border-top-color: #198754;\n}\n\n.\\!k-border-t-success {\n    border-top-color: #198754 !important;\n}\n\n.k-border-t-warning {\n    border-top-color: #ffc107;\n}\n\n.\\!k-border-t-warning {\n    border-top-color: #ffc107 !important;\n}\n\n.k-border-t-error {\n    border-top-color: #dc3545;\n}\n\n.\\!k-border-t-error {\n    border-top-color: #dc3545 !important;\n}\n\n.k-border-t-dark {\n    border-top-color: #212529;\n}\n\n.\\!k-border-t-dark {\n    border-top-color: #212529 !important;\n}\n\n.k-border-t-light {\n    border-top-color: #f8f9fa;\n}\n\n.\\!k-border-t-light {\n    border-top-color: #f8f9fa !important;\n}\n\n.k-border-t-inverse {\n    border-top-color: #212529;\n}\n\n.\\!k-border-t-inverse {\n    border-top-color: #212529 !important;\n}\n\n.k-border-t-inherit {\n    border-top-color: inherit;\n}\n\n.\\!k-border-t-inherit {\n    border-top-color: inherit !important;\n}\n\n.k-border-t-current {\n    border-top-color: currentColor;\n}\n\n.\\!k-border-t-current {\n    border-top-color: currentColor !important;\n}\n\n.k-border-t-transparent {\n    border-top-color: transparent;\n}\n\n.\\!k-border-t-transparent {\n    border-top-color: transparent !important;\n}\n\n.k-border-t-black {\n    border-top-color: black;\n}\n\n.\\!k-border-t-black {\n    border-top-color: black !important;\n}\n\n.k-border-t-white {\n    border-top-color: white;\n}\n\n.\\!k-border-t-white {\n    border-top-color: white !important;\n}\n\n.k-border-r-primary {\n    border-right-color: #0d6efd;\n}\n\n.\\!k-border-r-primary {\n    border-right-color: #0d6efd !important;\n}\n\n.k-border-r-secondary {\n    border-right-color: #6c757d;\n}\n\n.\\!k-border-r-secondary {\n    border-right-color: #6c757d !important;\n}\n\n.k-border-r-tertiary {\n    border-right-color: #6f42c1;\n}\n\n.\\!k-border-r-tertiary {\n    border-right-color: #6f42c1 !important;\n}\n\n.k-border-r-info {\n    border-right-color: #0dcaf0;\n}\n\n.\\!k-border-r-info {\n    border-right-color: #0dcaf0 !important;\n}\n\n.k-border-r-success {\n    border-right-color: #198754;\n}\n\n.\\!k-border-r-success {\n    border-right-color: #198754 !important;\n}\n\n.k-border-r-warning {\n    border-right-color: #ffc107;\n}\n\n.\\!k-border-r-warning {\n    border-right-color: #ffc107 !important;\n}\n\n.k-border-r-error {\n    border-right-color: #dc3545;\n}\n\n.\\!k-border-r-error {\n    border-right-color: #dc3545 !important;\n}\n\n.k-border-r-dark {\n    border-right-color: #212529;\n}\n\n.\\!k-border-r-dark {\n    border-right-color: #212529 !important;\n}\n\n.k-border-r-light {\n    border-right-color: #f8f9fa;\n}\n\n.\\!k-border-r-light {\n    border-right-color: #f8f9fa !important;\n}\n\n.k-border-r-inverse {\n    border-right-color: #212529;\n}\n\n.\\!k-border-r-inverse {\n    border-right-color: #212529 !important;\n}\n\n.k-border-r-inherit {\n    border-right-color: inherit;\n}\n\n.\\!k-border-r-inherit {\n    border-right-color: inherit !important;\n}\n\n.k-border-r-current {\n    border-right-color: currentColor;\n}\n\n.\\!k-border-r-current {\n    border-right-color: currentColor !important;\n}\n\n.k-border-r-transparent {\n    border-right-color: transparent;\n}\n\n.\\!k-border-r-transparent {\n    border-right-color: transparent !important;\n}\n\n.k-border-r-black {\n    border-right-color: black;\n}\n\n.\\!k-border-r-black {\n    border-right-color: black !important;\n}\n\n.k-border-r-white {\n    border-right-color: white;\n}\n\n.\\!k-border-r-white {\n    border-right-color: white !important;\n}\n\n.k-border-b-primary {\n    border-bottom-color: #0d6efd;\n}\n\n.\\!k-border-b-primary {\n    border-bottom-color: #0d6efd !important;\n}\n\n.k-border-b-secondary {\n    border-bottom-color: #6c757d;\n}\n\n.\\!k-border-b-secondary {\n    border-bottom-color: #6c757d !important;\n}\n\n.k-border-b-tertiary {\n    border-bottom-color: #6f42c1;\n}\n\n.\\!k-border-b-tertiary {\n    border-bottom-color: #6f42c1 !important;\n}\n\n.k-border-b-info {\n    border-bottom-color: #0dcaf0;\n}\n\n.\\!k-border-b-info {\n    border-bottom-color: #0dcaf0 !important;\n}\n\n.k-border-b-success {\n    border-bottom-color: #198754;\n}\n\n.\\!k-border-b-success {\n    border-bottom-color: #198754 !important;\n}\n\n.k-border-b-warning {\n    border-bottom-color: #ffc107;\n}\n\n.\\!k-border-b-warning {\n    border-bottom-color: #ffc107 !important;\n}\n\n.k-border-b-error {\n    border-bottom-color: #dc3545;\n}\n\n.\\!k-border-b-error {\n    border-bottom-color: #dc3545 !important;\n}\n\n.k-border-b-dark {\n    border-bottom-color: #212529;\n}\n\n.\\!k-border-b-dark {\n    border-bottom-color: #212529 !important;\n}\n\n.k-border-b-light {\n    border-bottom-color: #f8f9fa;\n}\n\n.\\!k-border-b-light {\n    border-bottom-color: #f8f9fa !important;\n}\n\n.k-border-b-inverse {\n    border-bottom-color: #212529;\n}\n\n.\\!k-border-b-inverse {\n    border-bottom-color: #212529 !important;\n}\n\n.k-border-b-inherit {\n    border-bottom-color: inherit;\n}\n\n.\\!k-border-b-inherit {\n    border-bottom-color: inherit !important;\n}\n\n.k-border-b-current {\n    border-bottom-color: currentColor;\n}\n\n.\\!k-border-b-current {\n    border-bottom-color: currentColor !important;\n}\n\n.k-border-b-transparent {\n    border-bottom-color: transparent;\n}\n\n.\\!k-border-b-transparent {\n    border-bottom-color: transparent !important;\n}\n\n.k-border-b-black {\n    border-bottom-color: black;\n}\n\n.\\!k-border-b-black {\n    border-bottom-color: black !important;\n}\n\n.k-border-b-white {\n    border-bottom-color: white;\n}\n\n.\\!k-border-b-white {\n    border-bottom-color: white !important;\n}\n\n.k-border-l-primary {\n    border-left-color: #0d6efd;\n}\n\n.\\!k-border-l-primary {\n    border-left-color: #0d6efd !important;\n}\n\n.k-border-l-secondary {\n    border-left-color: #6c757d;\n}\n\n.\\!k-border-l-secondary {\n    border-left-color: #6c757d !important;\n}\n\n.k-border-l-tertiary {\n    border-left-color: #6f42c1;\n}\n\n.\\!k-border-l-tertiary {\n    border-left-color: #6f42c1 !important;\n}\n\n.k-border-l-info {\n    border-left-color: #0dcaf0;\n}\n\n.\\!k-border-l-info {\n    border-left-color: #0dcaf0 !important;\n}\n\n.k-border-l-success {\n    border-left-color: #198754;\n}\n\n.\\!k-border-l-success {\n    border-left-color: #198754 !important;\n}\n\n.k-border-l-warning {\n    border-left-color: #ffc107;\n}\n\n.\\!k-border-l-warning {\n    border-left-color: #ffc107 !important;\n}\n\n.k-border-l-error {\n    border-left-color: #dc3545;\n}\n\n.\\!k-border-l-error {\n    border-left-color: #dc3545 !important;\n}\n\n.k-border-l-dark {\n    border-left-color: #212529;\n}\n\n.\\!k-border-l-dark {\n    border-left-color: #212529 !important;\n}\n\n.k-border-l-light {\n    border-left-color: #f8f9fa;\n}\n\n.\\!k-border-l-light {\n    border-left-color: #f8f9fa !important;\n}\n\n.k-border-l-inverse {\n    border-left-color: #212529;\n}\n\n.\\!k-border-l-inverse {\n    border-left-color: #212529 !important;\n}\n\n.k-border-l-inherit {\n    border-left-color: inherit;\n}\n\n.\\!k-border-l-inherit {\n    border-left-color: inherit !important;\n}\n\n.k-border-l-current {\n    border-left-color: currentColor;\n}\n\n.\\!k-border-l-current {\n    border-left-color: currentColor !important;\n}\n\n.k-border-l-transparent {\n    border-left-color: transparent;\n}\n\n.\\!k-border-l-transparent {\n    border-left-color: transparent !important;\n}\n\n.k-border-l-black {\n    border-left-color: black;\n}\n\n.\\!k-border-l-black {\n    border-left-color: black !important;\n}\n\n.k-border-l-white {\n    border-left-color: white;\n}\n\n.\\!k-border-l-white {\n    border-left-color: white !important;\n}\n\n.k-border-x-primary {\n    border-inline-color: #0d6efd;\n}\n\n.\\!k-border-x-primary {\n    border-inline-color: #0d6efd !important;\n}\n\n.k-border-x-secondary {\n    border-inline-color: #6c757d;\n}\n\n.\\!k-border-x-secondary {\n    border-inline-color: #6c757d !important;\n}\n\n.k-border-x-tertiary {\n    border-inline-color: #6f42c1;\n}\n\n.\\!k-border-x-tertiary {\n    border-inline-color: #6f42c1 !important;\n}\n\n.k-border-x-info {\n    border-inline-color: #0dcaf0;\n}\n\n.\\!k-border-x-info {\n    border-inline-color: #0dcaf0 !important;\n}\n\n.k-border-x-success {\n    border-inline-color: #198754;\n}\n\n.\\!k-border-x-success {\n    border-inline-color: #198754 !important;\n}\n\n.k-border-x-warning {\n    border-inline-color: #ffc107;\n}\n\n.\\!k-border-x-warning {\n    border-inline-color: #ffc107 !important;\n}\n\n.k-border-x-error {\n    border-inline-color: #dc3545;\n}\n\n.\\!k-border-x-error {\n    border-inline-color: #dc3545 !important;\n}\n\n.k-border-x-dark {\n    border-inline-color: #212529;\n}\n\n.\\!k-border-x-dark {\n    border-inline-color: #212529 !important;\n}\n\n.k-border-x-light {\n    border-inline-color: #f8f9fa;\n}\n\n.\\!k-border-x-light {\n    border-inline-color: #f8f9fa !important;\n}\n\n.k-border-x-inverse {\n    border-inline-color: #212529;\n}\n\n.\\!k-border-x-inverse {\n    border-inline-color: #212529 !important;\n}\n\n.k-border-x-inherit {\n    border-inline-color: inherit;\n}\n\n.\\!k-border-x-inherit {\n    border-inline-color: inherit !important;\n}\n\n.k-border-x-current {\n    border-inline-color: currentColor;\n}\n\n.\\!k-border-x-current {\n    border-inline-color: currentColor !important;\n}\n\n.k-border-x-transparent {\n    border-inline-color: transparent;\n}\n\n.\\!k-border-x-transparent {\n    border-inline-color: transparent !important;\n}\n\n.k-border-x-black {\n    border-inline-color: black;\n}\n\n.\\!k-border-x-black {\n    border-inline-color: black !important;\n}\n\n.k-border-x-white {\n    border-inline-color: white;\n}\n\n.\\!k-border-x-white {\n    border-inline-color: white !important;\n}\n\n.k-border-y-primary {\n    border-block-color: #0d6efd;\n}\n\n.\\!k-border-y-primary {\n    border-block-color: #0d6efd !important;\n}\n\n.k-border-y-secondary {\n    border-block-color: #6c757d;\n}\n\n.\\!k-border-y-secondary {\n    border-block-color: #6c757d !important;\n}\n\n.k-border-y-tertiary {\n    border-block-color: #6f42c1;\n}\n\n.\\!k-border-y-tertiary {\n    border-block-color: #6f42c1 !important;\n}\n\n.k-border-y-info {\n    border-block-color: #0dcaf0;\n}\n\n.\\!k-border-y-info {\n    border-block-color: #0dcaf0 !important;\n}\n\n.k-border-y-success {\n    border-block-color: #198754;\n}\n\n.\\!k-border-y-success {\n    border-block-color: #198754 !important;\n}\n\n.k-border-y-warning {\n    border-block-color: #ffc107;\n}\n\n.\\!k-border-y-warning {\n    border-block-color: #ffc107 !important;\n}\n\n.k-border-y-error {\n    border-block-color: #dc3545;\n}\n\n.\\!k-border-y-error {\n    border-block-color: #dc3545 !important;\n}\n\n.k-border-y-dark {\n    border-block-color: #212529;\n}\n\n.\\!k-border-y-dark {\n    border-block-color: #212529 !important;\n}\n\n.k-border-y-light {\n    border-block-color: #f8f9fa;\n}\n\n.\\!k-border-y-light {\n    border-block-color: #f8f9fa !important;\n}\n\n.k-border-y-inverse {\n    border-block-color: #212529;\n}\n\n.\\!k-border-y-inverse {\n    border-block-color: #212529 !important;\n}\n\n.k-border-y-inherit {\n    border-block-color: inherit;\n}\n\n.\\!k-border-y-inherit {\n    border-block-color: inherit !important;\n}\n\n.k-border-y-current {\n    border-block-color: currentColor;\n}\n\n.\\!k-border-y-current {\n    border-block-color: currentColor !important;\n}\n\n.k-border-y-transparent {\n    border-block-color: transparent;\n}\n\n.\\!k-border-y-transparent {\n    border-block-color: transparent !important;\n}\n\n.k-border-y-black {\n    border-block-color: black;\n}\n\n.\\!k-border-y-black {\n    border-block-color: black !important;\n}\n\n.k-border-y-white {\n    border-block-color: white;\n}\n\n.\\!k-border-y-white {\n    border-block-color: white !important;\n}\n\n.k-rounded {\n    border-radius: 0.375rem;\n}\n\n.\\!k-rounded {\n    border-radius: 0.375rem !important;\n}\n\n.k-rounded-0 {\n    border-radius: 0;\n}\n\n.\\!k-rounded-0 {\n    border-radius: 0 !important;\n}\n\n.k-rounded-sm {\n    border-radius: 0.25rem;\n}\n\n.\\!k-rounded-sm {\n    border-radius: 0.25rem !important;\n}\n\n.k-rounded-md {\n    border-radius: 0.375rem;\n}\n\n.\\!k-rounded-md {\n    border-radius: 0.375rem !important;\n}\n\n.k-rounded-lg {\n    border-radius: 0.5rem;\n}\n\n.\\!k-rounded-lg {\n    border-radius: 0.5rem !important;\n}\n\n.k-rounded-full {\n    border-radius: 9999px;\n}\n\n.\\!k-rounded-full {\n    border-radius: 9999px !important;\n}\n\n.k-rounded-tl {\n    border-top-left-radius: 0.375rem;\n}\n\n.\\!k-rounded-tl {\n    border-top-left-radius: 0.375rem !important;\n}\n\n.k-rounded-tl-0 {\n    border-top-left-radius: 0;\n}\n\n.\\!k-rounded-tl-0 {\n    border-top-left-radius: 0 !important;\n}\n\n.k-rounded-tl-sm {\n    border-top-left-radius: 0.25rem;\n}\n\n.\\!k-rounded-tl-sm {\n    border-top-left-radius: 0.25rem !important;\n}\n\n.k-rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n}\n\n.\\!k-rounded-tl-md {\n    border-top-left-radius: 0.375rem !important;\n}\n\n.k-rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n}\n\n.\\!k-rounded-tl-lg {\n    border-top-left-radius: 0.5rem !important;\n}\n\n.k-rounded-tl-full {\n    border-top-left-radius: 9999px;\n}\n\n.\\!k-rounded-tl-full {\n    border-top-left-radius: 9999px !important;\n}\n\n.k-rounded-tr {\n    border-top-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-tr {\n    border-top-right-radius: 0.375rem !important;\n}\n\n.k-rounded-tr-0 {\n    border-top-right-radius: 0;\n}\n\n.\\!k-rounded-tr-0 {\n    border-top-right-radius: 0 !important;\n}\n\n.k-rounded-tr-sm {\n    border-top-right-radius: 0.25rem;\n}\n\n.\\!k-rounded-tr-sm {\n    border-top-right-radius: 0.25rem !important;\n}\n\n.k-rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-tr-md {\n    border-top-right-radius: 0.375rem !important;\n}\n\n.k-rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n}\n\n.\\!k-rounded-tr-lg {\n    border-top-right-radius: 0.5rem !important;\n}\n\n.k-rounded-tr-full {\n    border-top-right-radius: 9999px;\n}\n\n.\\!k-rounded-tr-full {\n    border-top-right-radius: 9999px !important;\n}\n\n.k-rounded-br {\n    border-bottom-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-br {\n    border-bottom-right-radius: 0.375rem !important;\n}\n\n.k-rounded-br-0 {\n    border-bottom-right-radius: 0;\n}\n\n.\\!k-rounded-br-0 {\n    border-bottom-right-radius: 0 !important;\n}\n\n.k-rounded-br-sm {\n    border-bottom-right-radius: 0.25rem;\n}\n\n.\\!k-rounded-br-sm {\n    border-bottom-right-radius: 0.25rem !important;\n}\n\n.k-rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-br-md {\n    border-bottom-right-radius: 0.375rem !important;\n}\n\n.k-rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n}\n\n.\\!k-rounded-br-lg {\n    border-bottom-right-radius: 0.5rem !important;\n}\n\n.k-rounded-br-full {\n    border-bottom-right-radius: 9999px;\n}\n\n.\\!k-rounded-br-full {\n    border-bottom-right-radius: 9999px !important;\n}\n\n.k-rounded-bl {\n    border-bottom-left-radius: 0.375rem;\n}\n\n.\\!k-rounded-bl {\n    border-bottom-left-radius: 0.375rem !important;\n}\n\n.k-rounded-bl-0 {\n    border-bottom-left-radius: 0;\n}\n\n.\\!k-rounded-bl-0 {\n    border-bottom-left-radius: 0 !important;\n}\n\n.k-rounded-bl-sm {\n    border-bottom-left-radius: 0.25rem;\n}\n\n.\\!k-rounded-bl-sm {\n    border-bottom-left-radius: 0.25rem !important;\n}\n\n.k-rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n}\n\n.\\!k-rounded-bl-md {\n    border-bottom-left-radius: 0.375rem !important;\n}\n\n.k-rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n}\n\n.\\!k-rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem !important;\n}\n\n.k-rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n}\n\n.\\!k-rounded-bl-full {\n    border-bottom-left-radius: 9999px !important;\n}\n\n.k-rounded-t {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-t {\n    border-top-left-radius: 0.375rem !important;\n    border-top-right-radius: 0.375rem !important;\n}\n\n.k-rounded-t-0 {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.\\!k-rounded-t-0 {\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.k-rounded-t-sm {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n}\n\n.\\!k-rounded-t-sm {\n    border-top-left-radius: 0.25rem !important;\n    border-top-right-radius: 0.25rem !important;\n}\n\n.k-rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-t-md {\n    border-top-left-radius: 0.375rem !important;\n    border-top-right-radius: 0.375rem !important;\n}\n\n.k-rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n}\n\n.\\!k-rounded-t-lg {\n    border-top-left-radius: 0.5rem !important;\n    border-top-right-radius: 0.5rem !important;\n}\n\n.k-rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n}\n\n.\\!k-rounded-t-full {\n    border-top-left-radius: 9999px !important;\n    border-top-right-radius: 9999px !important;\n}\n\n.k-rounded-r {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-r {\n    border-top-right-radius: 0.375rem !important;\n    border-bottom-right-radius: 0.375rem !important;\n}\n\n.k-rounded-r-0 {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.\\!k-rounded-r-0 {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.k-rounded-r-sm {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n}\n\n.\\!k-rounded-r-sm {\n    border-top-right-radius: 0.25rem !important;\n    border-bottom-right-radius: 0.25rem !important;\n}\n\n.k-rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-r-md {\n    border-top-right-radius: 0.375rem !important;\n    border-bottom-right-radius: 0.375rem !important;\n}\n\n.k-rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n}\n\n.\\!k-rounded-r-lg {\n    border-top-right-radius: 0.5rem !important;\n    border-bottom-right-radius: 0.5rem !important;\n}\n\n.k-rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n}\n\n.\\!k-rounded-r-full {\n    border-top-right-radius: 9999px !important;\n    border-bottom-right-radius: 9999px !important;\n}\n\n.k-rounded-b {\n    border-bottom-left-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-b {\n    border-bottom-left-radius: 0.375rem !important;\n    border-bottom-right-radius: 0.375rem !important;\n}\n\n.k-rounded-b-0 {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.\\!k-rounded-b-0 {\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.k-rounded-b-sm {\n    border-bottom-left-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n}\n\n.\\!k-rounded-b-sm {\n    border-bottom-left-radius: 0.25rem !important;\n    border-bottom-right-radius: 0.25rem !important;\n}\n\n.k-rounded-b-md {\n    border-bottom-left-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n}\n\n.\\!k-rounded-b-md {\n    border-bottom-left-radius: 0.375rem !important;\n    border-bottom-right-radius: 0.375rem !important;\n}\n\n.k-rounded-b-lg {\n    border-bottom-left-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n}\n\n.\\!k-rounded-b-lg {\n    border-bottom-left-radius: 0.5rem !important;\n    border-bottom-right-radius: 0.5rem !important;\n}\n\n.k-rounded-b-full {\n    border-bottom-left-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n}\n\n.\\!k-rounded-b-full {\n    border-bottom-left-radius: 9999px !important;\n    border-bottom-right-radius: 9999px !important;\n}\n\n.k-rounded-l {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n}\n\n.\\!k-rounded-l {\n    border-top-left-radius: 0.375rem !important;\n    border-bottom-left-radius: 0.375rem !important;\n}\n\n.k-rounded-l-0 {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.\\!k-rounded-l-0 {\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n}\n\n.k-rounded-l-sm {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n\n.\\!k-rounded-l-sm {\n    border-top-left-radius: 0.25rem !important;\n    border-bottom-left-radius: 0.25rem !important;\n}\n\n.k-rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n}\n\n.\\!k-rounded-l-md {\n    border-top-left-radius: 0.375rem !important;\n    border-bottom-left-radius: 0.375rem !important;\n}\n\n.k-rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n}\n\n.\\!k-rounded-l-lg {\n    border-top-left-radius: 0.5rem !important;\n    border-bottom-left-radius: 0.5rem !important;\n}\n\n.k-rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n\n.\\!k-rounded-l-full {\n    border-top-left-radius: 9999px !important;\n    border-bottom-left-radius: 9999px !important;\n}\n\n.k-border-solid {\n    border-style: solid;\n}\n\n.\\!k-border-solid {\n    border-style: solid !important;\n}\n\n.k-border-dashed {\n    border-style: dashed;\n}\n\n.\\!k-border-dashed {\n    border-style: dashed !important;\n}\n\n.k-border-dotted {\n    border-style: dotted;\n}\n\n.\\!k-border-dotted {\n    border-style: dotted !important;\n}\n\n.k-border-double {\n    border-style: double;\n}\n\n.\\!k-border-double {\n    border-style: double !important;\n}\n\n.k-border-inset {\n    border-style: inset;\n}\n\n.\\!k-border-inset {\n    border-style: inset !important;\n}\n\n.k-border-outset {\n    border-style: outset;\n}\n\n.\\!k-border-outset {\n    border-style: outset !important;\n}\n\n.k-border-hidden {\n    border-style: hidden;\n}\n\n.\\!k-border-hidden {\n    border-style: hidden !important;\n}\n\n.k-border-none {\n    border-style: none;\n}\n\n.\\!k-border-none {\n    border-style: none !important;\n}\n\n.k-border-t-solid {\n    border-top-style: solid;\n}\n\n.\\!k-border-t-solid {\n    border-top-style: solid !important;\n}\n\n.k-border-t-dashed {\n    border-top-style: dashed;\n}\n\n.\\!k-border-t-dashed {\n    border-top-style: dashed !important;\n}\n\n.k-border-t-dotted {\n    border-top-style: dotted;\n}\n\n.\\!k-border-t-dotted {\n    border-top-style: dotted !important;\n}\n\n.k-border-t-double {\n    border-top-style: double;\n}\n\n.\\!k-border-t-double {\n    border-top-style: double !important;\n}\n\n.k-border-t-inset {\n    border-top-style: inset;\n}\n\n.\\!k-border-t-inset {\n    border-top-style: inset !important;\n}\n\n.k-border-t-outset {\n    border-top-style: outset;\n}\n\n.\\!k-border-t-outset {\n    border-top-style: outset !important;\n}\n\n.k-border-t-hidden {\n    border-top-style: hidden;\n}\n\n.\\!k-border-t-hidden {\n    border-top-style: hidden !important;\n}\n\n.k-border-t-none {\n    border-top-style: none;\n}\n\n.\\!k-border-t-none {\n    border-top-style: none !important;\n}\n\n.k-border-r-solid {\n    border-right-style: solid;\n}\n\n.\\!k-border-r-solid {\n    border-right-style: solid !important;\n}\n\n.k-border-r-dashed {\n    border-right-style: dashed;\n}\n\n.\\!k-border-r-dashed {\n    border-right-style: dashed !important;\n}\n\n.k-border-r-dotted {\n    border-right-style: dotted;\n}\n\n.\\!k-border-r-dotted {\n    border-right-style: dotted !important;\n}\n\n.k-border-r-double {\n    border-right-style: double;\n}\n\n.\\!k-border-r-double {\n    border-right-style: double !important;\n}\n\n.k-border-r-inset {\n    border-right-style: inset;\n}\n\n.\\!k-border-r-inset {\n    border-right-style: inset !important;\n}\n\n.k-border-r-outset {\n    border-right-style: outset;\n}\n\n.\\!k-border-r-outset {\n    border-right-style: outset !important;\n}\n\n.k-border-r-hidden {\n    border-right-style: hidden;\n}\n\n.\\!k-border-r-hidden {\n    border-right-style: hidden !important;\n}\n\n.k-border-r-none {\n    border-right-style: none;\n}\n\n.\\!k-border-r-none {\n    border-right-style: none !important;\n}\n\n.k-border-b-solid {\n    border-bottom-style: solid;\n}\n\n.\\!k-border-b-solid {\n    border-bottom-style: solid !important;\n}\n\n.k-border-b-dashed {\n    border-bottom-style: dashed;\n}\n\n.\\!k-border-b-dashed {\n    border-bottom-style: dashed !important;\n}\n\n.k-border-b-dotted {\n    border-bottom-style: dotted;\n}\n\n.\\!k-border-b-dotted {\n    border-bottom-style: dotted !important;\n}\n\n.k-border-b-double {\n    border-bottom-style: double;\n}\n\n.\\!k-border-b-double {\n    border-bottom-style: double !important;\n}\n\n.k-border-b-inset {\n    border-bottom-style: inset;\n}\n\n.\\!k-border-b-inset {\n    border-bottom-style: inset !important;\n}\n\n.k-border-b-outset {\n    border-bottom-style: outset;\n}\n\n.\\!k-border-b-outset {\n    border-bottom-style: outset !important;\n}\n\n.k-border-b-hidden {\n    border-bottom-style: hidden;\n}\n\n.\\!k-border-b-hidden {\n    border-bottom-style: hidden !important;\n}\n\n.k-border-b-none {\n    border-bottom-style: none;\n}\n\n.\\!k-border-b-none {\n    border-bottom-style: none !important;\n}\n\n.k-border-l-solid {\n    border-left-style: solid;\n}\n\n.\\!k-border-l-solid {\n    border-left-style: solid !important;\n}\n\n.k-border-l-dashed {\n    border-left-style: dashed;\n}\n\n.\\!k-border-l-dashed {\n    border-left-style: dashed !important;\n}\n\n.k-border-l-dotted {\n    border-left-style: dotted;\n}\n\n.\\!k-border-l-dotted {\n    border-left-style: dotted !important;\n}\n\n.k-border-l-double {\n    border-left-style: double;\n}\n\n.\\!k-border-l-double {\n    border-left-style: double !important;\n}\n\n.k-border-l-inset {\n    border-left-style: inset;\n}\n\n.\\!k-border-l-inset {\n    border-left-style: inset !important;\n}\n\n.k-border-l-outset {\n    border-left-style: outset;\n}\n\n.\\!k-border-l-outset {\n    border-left-style: outset !important;\n}\n\n.k-border-l-hidden {\n    border-left-style: hidden;\n}\n\n.\\!k-border-l-hidden {\n    border-left-style: hidden !important;\n}\n\n.k-border-l-none {\n    border-left-style: none;\n}\n\n.\\!k-border-l-none {\n    border-left-style: none !important;\n}\n\n.k-border-x-solid {\n    border-inline-style: solid;\n}\n\n.\\!k-border-x-solid {\n    border-inline-style: solid !important;\n}\n\n.k-border-x-dashed {\n    border-inline-style: dashed;\n}\n\n.\\!k-border-x-dashed {\n    border-inline-style: dashed !important;\n}\n\n.k-border-x-dotted {\n    border-inline-style: dotted;\n}\n\n.\\!k-border-x-dotted {\n    border-inline-style: dotted !important;\n}\n\n.k-border-x-double {\n    border-inline-style: double;\n}\n\n.\\!k-border-x-double {\n    border-inline-style: double !important;\n}\n\n.k-border-x-inset {\n    border-inline-style: inset;\n}\n\n.\\!k-border-x-inset {\n    border-inline-style: inset !important;\n}\n\n.k-border-x-outset {\n    border-inline-style: outset;\n}\n\n.\\!k-border-x-outset {\n    border-inline-style: outset !important;\n}\n\n.k-border-x-hidden {\n    border-inline-style: hidden;\n}\n\n.\\!k-border-x-hidden {\n    border-inline-style: hidden !important;\n}\n\n.k-border-x-none {\n    border-inline-style: none;\n}\n\n.\\!k-border-x-none {\n    border-inline-style: none !important;\n}\n\n.k-border-y-solid {\n    border-block-style: solid;\n}\n\n.\\!k-border-y-solid {\n    border-block-style: solid !important;\n}\n\n.k-border-y-dashed {\n    border-block-style: dashed;\n}\n\n.\\!k-border-y-dashed {\n    border-block-style: dashed !important;\n}\n\n.k-border-y-dotted {\n    border-block-style: dotted;\n}\n\n.\\!k-border-y-dotted {\n    border-block-style: dotted !important;\n}\n\n.k-border-y-double {\n    border-block-style: double;\n}\n\n.\\!k-border-y-double {\n    border-block-style: double !important;\n}\n\n.k-border-y-inset {\n    border-block-style: inset;\n}\n\n.\\!k-border-y-inset {\n    border-block-style: inset !important;\n}\n\n.k-border-y-outset {\n    border-block-style: outset;\n}\n\n.\\!k-border-y-outset {\n    border-block-style: outset !important;\n}\n\n.k-border-y-hidden {\n    border-block-style: hidden;\n}\n\n.\\!k-border-y-hidden {\n    border-block-style: hidden !important;\n}\n\n.k-border-y-none {\n    border-block-style: none;\n}\n\n.\\!k-border-y-none {\n    border-block-style: none !important;\n}\n\n.k-border {\n    border-width: 1px;\n}\n\n.\\!k-border {\n    border-width: 1px !important;\n}\n\n.k-border-0 {\n    border-width: 0;\n}\n\n.\\!k-border-0 {\n    border-width: 0 !important;\n}\n\n.k-border-2 {\n    border-width: 2px;\n}\n\n.\\!k-border-2 {\n    border-width: 2px !important;\n}\n\n.k-border-4 {\n    border-width: 4px;\n}\n\n.\\!k-border-4 {\n    border-width: 4px !important;\n}\n\n.k-border-8 {\n    border-width: 8px;\n}\n\n.\\!k-border-8 {\n    border-width: 8px !important;\n}\n\n.k-border-t {\n    border-top-width: 1px;\n}\n\n.\\!k-border-t {\n    border-top-width: 1px !important;\n}\n\n.k-border-t-0 {\n    border-top-width: 0;\n}\n\n.\\!k-border-t-0 {\n    border-top-width: 0 !important;\n}\n\n.k-border-t-2 {\n    border-top-width: 2px;\n}\n\n.\\!k-border-t-2 {\n    border-top-width: 2px !important;\n}\n\n.k-border-t-4 {\n    border-top-width: 4px;\n}\n\n.\\!k-border-t-4 {\n    border-top-width: 4px !important;\n}\n\n.k-border-t-8 {\n    border-top-width: 8px;\n}\n\n.\\!k-border-t-8 {\n    border-top-width: 8px !important;\n}\n\n.k-border-r {\n    border-right-width: 1px;\n}\n\n.\\!k-border-r {\n    border-right-width: 1px !important;\n}\n\n.k-border-r-0 {\n    border-right-width: 0;\n}\n\n.\\!k-border-r-0 {\n    border-right-width: 0 !important;\n}\n\n.k-border-r-2 {\n    border-right-width: 2px;\n}\n\n.\\!k-border-r-2 {\n    border-right-width: 2px !important;\n}\n\n.k-border-r-4 {\n    border-right-width: 4px;\n}\n\n.\\!k-border-r-4 {\n    border-right-width: 4px !important;\n}\n\n.k-border-r-8 {\n    border-right-width: 8px;\n}\n\n.\\!k-border-r-8 {\n    border-right-width: 8px !important;\n}\n\n.k-border-b {\n    border-bottom-width: 1px;\n}\n\n.\\!k-border-b {\n    border-bottom-width: 1px !important;\n}\n\n.k-border-b-0 {\n    border-bottom-width: 0;\n}\n\n.\\!k-border-b-0 {\n    border-bottom-width: 0 !important;\n}\n\n.k-border-b-2 {\n    border-bottom-width: 2px;\n}\n\n.\\!k-border-b-2 {\n    border-bottom-width: 2px !important;\n}\n\n.k-border-b-4 {\n    border-bottom-width: 4px;\n}\n\n.\\!k-border-b-4 {\n    border-bottom-width: 4px !important;\n}\n\n.k-border-b-8 {\n    border-bottom-width: 8px;\n}\n\n.\\!k-border-b-8 {\n    border-bottom-width: 8px !important;\n}\n\n.k-border-l {\n    border-left-width: 1px;\n}\n\n.\\!k-border-l {\n    border-left-width: 1px !important;\n}\n\n.k-border-l-0 {\n    border-left-width: 0;\n}\n\n.\\!k-border-l-0 {\n    border-left-width: 0 !important;\n}\n\n.k-border-l-2 {\n    border-left-width: 2px;\n}\n\n.\\!k-border-l-2 {\n    border-left-width: 2px !important;\n}\n\n.k-border-l-4 {\n    border-left-width: 4px;\n}\n\n.\\!k-border-l-4 {\n    border-left-width: 4px !important;\n}\n\n.k-border-l-8 {\n    border-left-width: 8px;\n}\n\n.\\!k-border-l-8 {\n    border-left-width: 8px !important;\n}\n\n.k-border-x {\n    border-inline-width: 1px;\n}\n\n.\\!k-border-x {\n    border-inline-width: 1px !important;\n}\n\n.k-border-x-0 {\n    border-inline-width: 0;\n}\n\n.\\!k-border-x-0 {\n    border-inline-width: 0 !important;\n}\n\n.k-border-x-2 {\n    border-inline-width: 2px;\n}\n\n.\\!k-border-x-2 {\n    border-inline-width: 2px !important;\n}\n\n.k-border-x-4 {\n    border-inline-width: 4px;\n}\n\n.\\!k-border-x-4 {\n    border-inline-width: 4px !important;\n}\n\n.k-border-x-8 {\n    border-inline-width: 8px;\n}\n\n.\\!k-border-x-8 {\n    border-inline-width: 8px !important;\n}\n\n.k-border-y {\n    border-block-width: 1px;\n}\n\n.\\!k-border-y {\n    border-block-width: 1px !important;\n}\n\n.k-border-y-0 {\n    border-block-width: 0;\n}\n\n.\\!k-border-y-0 {\n    border-block-width: 0 !important;\n}\n\n.k-border-y-2 {\n    border-block-width: 2px;\n}\n\n.\\!k-border-y-2 {\n    border-block-width: 2px !important;\n}\n\n.k-border-y-4 {\n    border-block-width: 4px;\n}\n\n.\\!k-border-y-4 {\n    border-block-width: 4px !important;\n}\n\n.k-border-y-8 {\n    border-block-width: 8px;\n}\n\n.\\!k-border-y-8 {\n    border-block-width: 8px !important;\n}\n\n.k-border-top {\n    border-top-width: 1px;\n}\n\n.\\!k-border-top {\n    border-top-width: 1px !important;\n}\n\n.k-border-top-0 {\n    border-top-width: 0;\n}\n\n.\\!k-border-top-0 {\n    border-top-width: 0 !important;\n}\n\n.k-border-top-2 {\n    border-top-width: 2px;\n}\n\n.\\!k-border-top-2 {\n    border-top-width: 2px !important;\n}\n\n.k-border-top-4 {\n    border-top-width: 4px;\n}\n\n.\\!k-border-top-4 {\n    border-top-width: 4px !important;\n}\n\n.k-border-top-8 {\n    border-top-width: 8px;\n}\n\n.\\!k-border-top-8 {\n    border-top-width: 8px !important;\n}\n\n.k-border-right {\n    border-right-width: 1px;\n}\n\n.\\!k-border-right {\n    border-right-width: 1px !important;\n}\n\n.k-border-right-0 {\n    border-right-width: 0;\n}\n\n.\\!k-border-right-0 {\n    border-right-width: 0 !important;\n}\n\n.k-border-right-2 {\n    border-right-width: 2px;\n}\n\n.\\!k-border-right-2 {\n    border-right-width: 2px !important;\n}\n\n.k-border-right-4 {\n    border-right-width: 4px;\n}\n\n.\\!k-border-right-4 {\n    border-right-width: 4px !important;\n}\n\n.k-border-right-8 {\n    border-right-width: 8px;\n}\n\n.\\!k-border-right-8 {\n    border-right-width: 8px !important;\n}\n\n.k-border-bottom {\n    border-bottom-width: 1px;\n}\n\n.\\!k-border-bottom {\n    border-bottom-width: 1px !important;\n}\n\n.k-border-bottom-0 {\n    border-bottom-width: 0;\n}\n\n.\\!k-border-bottom-0 {\n    border-bottom-width: 0 !important;\n}\n\n.k-border-bottom-2 {\n    border-bottom-width: 2px;\n}\n\n.\\!k-border-bottom-2 {\n    border-bottom-width: 2px !important;\n}\n\n.k-border-bottom-4 {\n    border-bottom-width: 4px;\n}\n\n.\\!k-border-bottom-4 {\n    border-bottom-width: 4px !important;\n}\n\n.k-border-bottom-8 {\n    border-bottom-width: 8px;\n}\n\n.\\!k-border-bottom-8 {\n    border-bottom-width: 8px !important;\n}\n\n.k-border-left {\n    border-left-width: 1px;\n}\n\n.\\!k-border-left {\n    border-left-width: 1px !important;\n}\n\n.k-border-left-0 {\n    border-left-width: 0;\n}\n\n.\\!k-border-left-0 {\n    border-left-width: 0 !important;\n}\n\n.k-border-left-2 {\n    border-left-width: 2px;\n}\n\n.\\!k-border-left-2 {\n    border-left-width: 2px !important;\n}\n\n.k-border-left-4 {\n    border-left-width: 4px;\n}\n\n.\\!k-border-left-4 {\n    border-left-width: 4px !important;\n}\n\n.k-border-left-8 {\n    border-left-width: 8px;\n}\n\n.\\!k-border-left-8 {\n    border-left-width: 8px !important;\n}\n\n.k-outline-primary {\n    outline-color: #0d6efd;\n}\n\n.\\!k-outline-primary {\n    outline-color: #0d6efd !important;\n}\n\n.k-outline-secondary {\n    outline-color: #6c757d;\n}\n\n.\\!k-outline-secondary {\n    outline-color: #6c757d !important;\n}\n\n.k-outline-tertiary {\n    outline-color: #6f42c1;\n}\n\n.\\!k-outline-tertiary {\n    outline-color: #6f42c1 !important;\n}\n\n.k-outline-info {\n    outline-color: #0dcaf0;\n}\n\n.\\!k-outline-info {\n    outline-color: #0dcaf0 !important;\n}\n\n.k-outline-success {\n    outline-color: #198754;\n}\n\n.\\!k-outline-success {\n    outline-color: #198754 !important;\n}\n\n.k-outline-warning {\n    outline-color: #ffc107;\n}\n\n.\\!k-outline-warning {\n    outline-color: #ffc107 !important;\n}\n\n.k-outline-error {\n    outline-color: #dc3545;\n}\n\n.\\!k-outline-error {\n    outline-color: #dc3545 !important;\n}\n\n.k-outline-dark {\n    outline-color: #212529;\n}\n\n.\\!k-outline-dark {\n    outline-color: #212529 !important;\n}\n\n.k-outline-light {\n    outline-color: #f8f9fa;\n}\n\n.\\!k-outline-light {\n    outline-color: #f8f9fa !important;\n}\n\n.k-outline-inverse {\n    outline-color: #212529;\n}\n\n.\\!k-outline-inverse {\n    outline-color: #212529 !important;\n}\n\n.k-outline-inherit {\n    outline-color: inherit;\n}\n\n.\\!k-outline-inherit {\n    outline-color: inherit !important;\n}\n\n.k-outline-current {\n    outline-color: currentColor;\n}\n\n.\\!k-outline-current {\n    outline-color: currentColor !important;\n}\n\n.k-outline-transparent {\n    outline-color: transparent;\n}\n\n.\\!k-outline-transparent {\n    outline-color: transparent !important;\n}\n\n.k-outline-black {\n    outline-color: black;\n}\n\n.\\!k-outline-black {\n    outline-color: black !important;\n}\n\n.k-outline-white {\n    outline-color: white;\n}\n\n.\\!k-outline-white {\n    outline-color: white !important;\n}\n\n.k-outline-offset-0 {\n    outline-offset: 0;\n}\n\n.\\!k-outline-offset-0 {\n    outline-offset: 0 !important;\n}\n\n.k-outline-offset-1 {\n    outline-offset: 1px;\n}\n\n.\\!k-outline-offset-1 {\n    outline-offset: 1px !important;\n}\n\n.k-outline-offset-2 {\n    outline-offset: 2px;\n}\n\n.\\!k-outline-offset-2 {\n    outline-offset: 2px !important;\n}\n\n.k-outline-offset-4 {\n    outline-offset: 4px;\n}\n\n.\\!k-outline-offset-4 {\n    outline-offset: 4px !important;\n}\n\n.k-outline-offset-8 {\n    outline-offset: 8px;\n}\n\n.\\!k-outline-offset-8 {\n    outline-offset: 8px !important;\n}\n\n.k-outline-solid {\n    outline-style: solid;\n}\n\n.\\!k-outline-solid {\n    outline-style: solid !important;\n}\n\n.k-outline-dashed {\n    outline-style: dashed;\n}\n\n.\\!k-outline-dashed {\n    outline-style: dashed !important;\n}\n\n.k-outline-dotted {\n    outline-style: dotted;\n}\n\n.\\!k-outline-dotted {\n    outline-style: dotted !important;\n}\n\n.k-outline-double {\n    outline-style: double;\n}\n\n.\\!k-outline-double {\n    outline-style: double !important;\n}\n\n.k-outline-inset {\n    outline-style: inset;\n}\n\n.\\!k-outline-inset {\n    outline-style: inset !important;\n}\n\n.k-outline-outset {\n    outline-style: outset;\n}\n\n.\\!k-outline-outset {\n    outline-style: outset !important;\n}\n\n.k-outline-none {\n    outline-style: none;\n}\n\n.\\!k-outline-none {\n    outline-style: none !important;\n}\n\n.k-outline {\n    outline-width: 1px;\n}\n\n.\\!k-outline {\n    outline-width: 1px !important;\n}\n\n.k-outline-0 {\n    outline-width: 0;\n}\n\n.\\!k-outline-0 {\n    outline-width: 0 !important;\n}\n\n.k-outline-2 {\n    outline-width: 2px;\n}\n\n.\\!k-outline-2 {\n    outline-width: 2px !important;\n}\n\n.k-outline-4 {\n    outline-width: 4px;\n}\n\n.\\!k-outline-4 {\n    outline-width: 4px !important;\n}\n\n.k-outline-8 {\n    outline-width: 8px;\n}\n\n.\\!k-outline-8 {\n    outline-width: 8px !important;\n}\n\n.k-opacity-0 {\n    opacity: 0;\n}\n\n.\\!k-opacity-0 {\n    opacity: 0 !important;\n}\n\n.k-opacity-5 {\n    opacity: 0.05;\n}\n\n.\\!k-opacity-5 {\n    opacity: 0.05 !important;\n}\n\n.k-opacity-10 {\n    opacity: 0.1;\n}\n\n.\\!k-opacity-10 {\n    opacity: 0.1 !important;\n}\n\n.k-opacity-20 {\n    opacity: 0.2;\n}\n\n.\\!k-opacity-20 {\n    opacity: 0.2 !important;\n}\n\n.k-opacity-30 {\n    opacity: 0.3;\n}\n\n.\\!k-opacity-30 {\n    opacity: 0.3 !important;\n}\n\n.k-opacity-40 {\n    opacity: 0.4;\n}\n\n.\\!k-opacity-40 {\n    opacity: 0.4 !important;\n}\n\n.k-opacity-50 {\n    opacity: 0.5;\n}\n\n.\\!k-opacity-50 {\n    opacity: 0.5 !important;\n}\n\n.k-opacity-60 {\n    opacity: 0.6;\n}\n\n.\\!k-opacity-60 {\n    opacity: 0.6 !important;\n}\n\n.k-opacity-70 {\n    opacity: 0.7;\n}\n\n.\\!k-opacity-70 {\n    opacity: 0.7 !important;\n}\n\n.k-opacity-80 {\n    opacity: 0.8;\n}\n\n.\\!k-opacity-80 {\n    opacity: 0.8 !important;\n}\n\n.k-opacity-90 {\n    opacity: 0.9;\n}\n\n.\\!k-opacity-90 {\n    opacity: 0.9 !important;\n}\n\n.k-opacity-100 {\n    opacity: 1;\n}\n\n.\\!k-opacity-100 {\n    opacity: 1 !important;\n}\n\n.k-backdrop-blur {\n    -webkit-backdrop-filter: blur(8px);\n            backdrop-filter: blur(8px);\n}\n\n.\\!k-backdrop-blur {\n    -webkit-backdrop-filter: blur(8px) !important;\n            backdrop-filter: blur(8px) !important;\n}\n\n.k-backdrop-blur-none {\n    -webkit-backdrop-filter: blur(0);\n            backdrop-filter: blur(0);\n}\n\n.\\!k-backdrop-blur-none {\n    -webkit-backdrop-filter: blur(0) !important;\n            backdrop-filter: blur(0) !important;\n}\n\n.k-backdrop-blur-sm {\n    -webkit-backdrop-filter: blur(4px);\n            backdrop-filter: blur(4px);\n}\n\n.\\!k-backdrop-blur-sm {\n    -webkit-backdrop-filter: blur(4px) !important;\n            backdrop-filter: blur(4px) !important;\n}\n\n.k-backdrop-blur-md {\n    -webkit-backdrop-filter: blur(6px);\n            backdrop-filter: blur(6px);\n}\n\n.\\!k-backdrop-blur-md {\n    -webkit-backdrop-filter: blur(6px) !important;\n            backdrop-filter: blur(6px) !important;\n}\n\n.k-backdrop-blur-lg {\n    -webkit-backdrop-filter: blur(12px);\n            backdrop-filter: blur(12px);\n}\n\n.\\!k-backdrop-blur-lg {\n    -webkit-backdrop-filter: blur(12px) !important;\n            backdrop-filter: blur(12px) !important;\n}\n\n.k-border-collapse {\n    border-collapse: collapse;\n}\n\n.\\!k-border-collapse {\n    border-collapse: collapse !important;\n}\n\n.k-border-separate {\n    border-collapse: separate;\n}\n\n.\\!k-border-separate {\n    border-collapse: separate !important;\n}\n\n.k-table-auto {\n    table-layout: auto;\n}\n\n.\\!k-table-auto {\n    table-layout: auto !important;\n}\n\n.k-table-fixed {\n    table-layout: fixed;\n}\n\n.\\!k-table-fixed {\n    table-layout: fixed !important;\n}\n\n.k-table-layout-auto {\n    table-layout: auto;\n}\n\n.\\!k-table-layout-auto {\n    table-layout: auto !important;\n}\n\n.k-table-layout-fixed {\n    table-layout: fixed;\n}\n\n.\\!k-table-layout-fixed {\n    table-layout: fixed !important;\n}\n\n.k-flip-h, .k-flip-x {\n    transform: scaleX(-1);\n}\n\n.\\!k-flip-h, .\\!k-flip-x {\n    transform: scaleX(-1) !important;\n}\n\n.k-flip-v, .k-flip-y {\n    transform: scaleY(-1);\n}\n\n.\\!k-flip-v, .\\!k-flip-y {\n    transform: scaleY(-1) !important;\n}\n\n.k-flip-h.k-flip-v, .k-flip-v.k-flip-x, .k-flip-x.k-flip-y, .k-flip-h.k-flip-y {\n    transform: scale(-1, -1);\n}\n\n.\\!k-flip-h.\\!k-flip-v, .\\!k-flip-v.\\!k-flip-x, .\\!k-flip-x.\\!k-flip-y, .\\!k-flip-h.\\!k-flip-y {\n    transform: scale(-1, -1) !important;\n}\n\n.k-origin-center {\n    transform-origin: center;\n}\n\n.\\!k-origin-center {\n    transform-origin: center !important;\n}\n\n.k-origin-top {\n    transform-origin: top;\n}\n\n.\\!k-origin-top {\n    transform-origin: top !important;\n}\n\n.k-origin-right {\n    transform-origin: right;\n}\n\n.\\!k-origin-right {\n    transform-origin: right !important;\n}\n\n.k-origin-bottom {\n    transform-origin: bottom;\n}\n\n.\\!k-origin-bottom {\n    transform-origin: bottom !important;\n}\n\n.k-origin-left {\n    transform-origin: left;\n}\n\n.\\!k-origin-left {\n    transform-origin: left !important;\n}\n\n.k-origin-top-left {\n    transform-origin: top left;\n}\n\n.\\!k-origin-top-left {\n    transform-origin: top left !important;\n}\n\n.k-origin-top-right {\n    transform-origin: top right;\n}\n\n.\\!k-origin-top-right {\n    transform-origin: top right !important;\n}\n\n.k-origin-bottom-left {\n    transform-origin: bottom left;\n}\n\n.\\!k-origin-bottom-left {\n    transform-origin: bottom left !important;\n}\n\n.k-origin-bottom-right {\n    transform-origin: bottom right;\n}\n\n.\\!k-origin-bottom-right {\n    transform-origin: bottom right !important;\n}\n\n.k-rotate-0 {\n    transform: rotate(0deg);\n}\n\n.\\!k-rotate-0 {\n    transform: rotate(0deg) !important;\n}\n\n.k-rotate-45 {\n    transform: rotate(45deg);\n}\n\n.\\!k-rotate-45 {\n    transform: rotate(45deg) !important;\n}\n\n.k-rotate-90 {\n    transform: rotate(90deg);\n}\n\n.\\!k-rotate-90 {\n    transform: rotate(90deg) !important;\n}\n\n.k-rotate-135 {\n    transform: rotate(135deg);\n}\n\n.\\!k-rotate-135 {\n    transform: rotate(135deg) !important;\n}\n\n.k-rotate-180 {\n    transform: rotate(180deg);\n}\n\n.\\!k-rotate-180 {\n    transform: rotate(180deg) !important;\n}\n\n.k-rotate-225 {\n    transform: rotate(225deg);\n}\n\n.\\!k-rotate-225 {\n    transform: rotate(225deg) !important;\n}\n\n.k-rotate-270 {\n    transform: rotate(270deg);\n}\n\n.\\!k-rotate-270 {\n    transform: rotate(270deg) !important;\n}\n\n.k-rotate-315 {\n    transform: rotate(315deg);\n}\n\n.\\!k-rotate-315 {\n    transform: rotate(315deg) !important;\n}\n\n.k-scale-0 {\n    transform: scale(0);\n}\n\n.\\!k-scale-0 {\n    transform: scale(0) !important;\n}\n\n.k-scale-0\\.25 {\n    transform: scale(0.25);\n}\n\n.\\!k-scale-0\\.25 {\n    transform: scale(0.25) !important;\n}\n\n.k-scale-0\\.5 {\n    transform: scale(0.5);\n}\n\n.\\!k-scale-0\\.5 {\n    transform: scale(0.5) !important;\n}\n\n.k-scale-0\\.75 {\n    transform: scale(0.75);\n}\n\n.\\!k-scale-0\\.75 {\n    transform: scale(0.75) !important;\n}\n\n.k-scale-1 {\n    transform: scale(1);\n}\n\n.\\!k-scale-1 {\n    transform: scale(1) !important;\n}\n\n.k-scale-1\\.25 {\n    transform: scale(1.25);\n}\n\n.\\!k-scale-1\\.25 {\n    transform: scale(1.25) !important;\n}\n\n.k-scale-1\\.5 {\n    transform: scale(1.5);\n}\n\n.\\!k-scale-1\\.5 {\n    transform: scale(1.5) !important;\n}\n\n.k-scale-2 {\n    transform: scale(2);\n}\n\n.\\!k-scale-2 {\n    transform: scale(2) !important;\n}\n\n.k-scale-x-0 {\n    transform: scaleX(0);\n}\n\n.\\!k-scale-x-0 {\n    transform: scaleX(0) !important;\n}\n\n.k-scale-x-0\\.25 {\n    transform: scaleX(0.25);\n}\n\n.\\!k-scale-x-0\\.25 {\n    transform: scaleX(0.25) !important;\n}\n\n.k-scale-x-0\\.5 {\n    transform: scaleX(0.5);\n}\n\n.\\!k-scale-x-0\\.5 {\n    transform: scaleX(0.5) !important;\n}\n\n.k-scale-x-0\\.75 {\n    transform: scaleX(0.75);\n}\n\n.\\!k-scale-x-0\\.75 {\n    transform: scaleX(0.75) !important;\n}\n\n.k-scale-x-1 {\n    transform: scaleX(1);\n}\n\n.\\!k-scale-x-1 {\n    transform: scaleX(1) !important;\n}\n\n.k-scale-x-1\\.25 {\n    transform: scaleX(1.25);\n}\n\n.\\!k-scale-x-1\\.25 {\n    transform: scaleX(1.25) !important;\n}\n\n.k-scale-x-1\\.5 {\n    transform: scaleX(1.5);\n}\n\n.\\!k-scale-x-1\\.5 {\n    transform: scaleX(1.5) !important;\n}\n\n.k-scale-x-2 {\n    transform: scaleX(2);\n}\n\n.\\!k-scale-x-2 {\n    transform: scaleX(2) !important;\n}\n\n.k-scale-y-0 {\n    transform: scaleY(0);\n}\n\n.\\!k-scale-y-0 {\n    transform: scaleY(0) !important;\n}\n\n.k-scale-y-0\\.25 {\n    transform: scaleY(0.25);\n}\n\n.\\!k-scale-y-0\\.25 {\n    transform: scaleY(0.25) !important;\n}\n\n.k-scale-y-0\\.5 {\n    transform: scaleY(0.5);\n}\n\n.\\!k-scale-y-0\\.5 {\n    transform: scaleY(0.5) !important;\n}\n\n.k-scale-y-0\\.75 {\n    transform: scaleY(0.75);\n}\n\n.\\!k-scale-y-0\\.75 {\n    transform: scaleY(0.75) !important;\n}\n\n.k-scale-y-1 {\n    transform: scaleY(1);\n}\n\n.\\!k-scale-y-1 {\n    transform: scaleY(1) !important;\n}\n\n.k-scale-y-1\\.25 {\n    transform: scaleY(1.25);\n}\n\n.\\!k-scale-y-1\\.25 {\n    transform: scaleY(1.25) !important;\n}\n\n.k-scale-y-1\\.5 {\n    transform: scaleY(1.5);\n}\n\n.\\!k-scale-y-1\\.5 {\n    transform: scaleY(1.5) !important;\n}\n\n.k-scale-y-2 {\n    transform: scaleY(2);\n}\n\n.\\!k-scale-y-2 {\n    transform: scaleY(2) !important;\n}\n\n.k-skew-x-0 {\n    transform: skewX(0deg);\n}\n\n.\\!k-skew-x-0 {\n    transform: skewX(0deg) !important;\n}\n\n.k-skew-x-1 {\n    transform: skewX(1deg);\n}\n\n.\\!k-skew-x-1 {\n    transform: skewX(1deg) !important;\n}\n\n.k-skew-x-2 {\n    transform: skewX(2deg);\n}\n\n.\\!k-skew-x-2 {\n    transform: skewX(2deg) !important;\n}\n\n.k-skew-x-3 {\n    transform: skewX(3deg);\n}\n\n.\\!k-skew-x-3 {\n    transform: skewX(3deg) !important;\n}\n\n.k-skew-x-4 {\n    transform: skewX(4deg);\n}\n\n.\\!k-skew-x-4 {\n    transform: skewX(4deg) !important;\n}\n\n.k-skew-x-5 {\n    transform: skewX(5deg);\n}\n\n.\\!k-skew-x-5 {\n    transform: skewX(5deg) !important;\n}\n\n.k-skew-x-6 {\n    transform: skewX(6deg);\n}\n\n.\\!k-skew-x-6 {\n    transform: skewX(6deg) !important;\n}\n\n.k-skew-x-7 {\n    transform: skewX(7deg);\n}\n\n.\\!k-skew-x-7 {\n    transform: skewX(7deg) !important;\n}\n\n.k-skew-x-8 {\n    transform: skewX(8deg);\n}\n\n.\\!k-skew-x-8 {\n    transform: skewX(8deg) !important;\n}\n\n.k-skew-x-9 {\n    transform: skewX(9deg);\n}\n\n.\\!k-skew-x-9 {\n    transform: skewX(9deg) !important;\n}\n\n.k-skew-x-10 {\n    transform: skewX(10deg);\n}\n\n.\\!k-skew-x-10 {\n    transform: skewX(10deg) !important;\n}\n\n.k-skew-x-11 {\n    transform: skewX(11deg);\n}\n\n.\\!k-skew-x-11 {\n    transform: skewX(11deg) !important;\n}\n\n.k-skew-x-12 {\n    transform: skewX(12deg);\n}\n\n.\\!k-skew-x-12 {\n    transform: skewX(12deg) !important;\n}\n\n.k-skew-y-0 {\n    transform: skewY(0deg);\n}\n\n.\\!k-skew-y-0 {\n    transform: skewY(0deg) !important;\n}\n\n.k-skew-y-1 {\n    transform: skewY(1deg);\n}\n\n.\\!k-skew-y-1 {\n    transform: skewY(1deg) !important;\n}\n\n.k-skew-y-2 {\n    transform: skewY(2deg);\n}\n\n.\\!k-skew-y-2 {\n    transform: skewY(2deg) !important;\n}\n\n.k-skew-y-3 {\n    transform: skewY(3deg);\n}\n\n.\\!k-skew-y-3 {\n    transform: skewY(3deg) !important;\n}\n\n.k-skew-y-4 {\n    transform: skewY(4deg);\n}\n\n.\\!k-skew-y-4 {\n    transform: skewY(4deg) !important;\n}\n\n.k-skew-y-5 {\n    transform: skewY(5deg);\n}\n\n.\\!k-skew-y-5 {\n    transform: skewY(5deg) !important;\n}\n\n.k-skew-y-6 {\n    transform: skewY(6deg);\n}\n\n.\\!k-skew-y-6 {\n    transform: skewY(6deg) !important;\n}\n\n.k-skew-y-7 {\n    transform: skewY(7deg);\n}\n\n.\\!k-skew-y-7 {\n    transform: skewY(7deg) !important;\n}\n\n.k-skew-y-8 {\n    transform: skewY(8deg);\n}\n\n.\\!k-skew-y-8 {\n    transform: skewY(8deg) !important;\n}\n\n.k-skew-y-9 {\n    transform: skewY(9deg);\n}\n\n.\\!k-skew-y-9 {\n    transform: skewY(9deg) !important;\n}\n\n.k-skew-y-10 {\n    transform: skewY(10deg);\n}\n\n.\\!k-skew-y-10 {\n    transform: skewY(10deg) !important;\n}\n\n.k-skew-y-11 {\n    transform: skewY(11deg);\n}\n\n.\\!k-skew-y-11 {\n    transform: skewY(11deg) !important;\n}\n\n.k-skew-y-12 {\n    transform: skewY(12deg);\n}\n\n.\\!k-skew-y-12 {\n    transform: skewY(12deg) !important;\n}\n\n.k-translate-0 {\n    transform: translate(0, 0);\n}\n\n.\\!k-translate-0 {\n    transform: translate(0, 0) !important;\n}\n\n.k-translate-0-50 {\n    transform: translate(0, 50%);\n}\n\n.\\!k-translate-0-50 {\n    transform: translate(0, 50%) !important;\n}\n\n.k-translate-0-100 {\n    transform: translate(0, 100%);\n}\n\n.\\!k-translate-0-100 {\n    transform: translate(0, 100%) !important;\n}\n\n.k-translate-50-0 {\n    transform: translate(50%, 0);\n}\n\n.\\!k-translate-50-0 {\n    transform: translate(50%, 0) !important;\n}\n\n.k-translate-50-50 {\n    transform: translate(50%, 50%);\n}\n\n.\\!k-translate-50-50 {\n    transform: translate(50%, 50%) !important;\n}\n\n.k-translate-50-100 {\n    transform: translate(50%, 100%);\n}\n\n.\\!k-translate-50-100 {\n    transform: translate(50%, 100%) !important;\n}\n\n.k-translate-100-0 {\n    transform: translate(100%, 0);\n}\n\n.\\!k-translate-100-0 {\n    transform: translate(100%, 0) !important;\n}\n\n.k-translate-100-50 {\n    transform: translate(100%, 50%);\n}\n\n.\\!k-translate-100-50 {\n    transform: translate(100%, 50%) !important;\n}\n\n.k-translate-100-100 {\n    transform: translate(100%, 100%);\n}\n\n.\\!k-translate-100-100 {\n    transform: translate(100%, 100%) !important;\n}\n\n.k-translate-x-0 {\n    transform: translateX(0);\n}\n\n.\\!k-translate-x-0 {\n    transform: translateX(0) !important;\n}\n\n.k-translate-x-1px {\n    transform: translateX(1px);\n}\n\n.\\!k-translate-x-1px {\n    transform: translateX(1px) !important;\n}\n\n.k-translate-x-0\\.5 {\n    transform: translateX(0.125rem);\n}\n\n.\\!k-translate-x-0\\.5 {\n    transform: translateX(0.125rem) !important;\n}\n\n.k-translate-x-1 {\n    transform: translateX(0.25rem);\n}\n\n.\\!k-translate-x-1 {\n    transform: translateX(0.25rem) !important;\n}\n\n.k-translate-x-1\\.5 {\n    transform: translateX(0.375rem);\n}\n\n.\\!k-translate-x-1\\.5 {\n    transform: translateX(0.375rem) !important;\n}\n\n.k-translate-x-2 {\n    transform: translateX(0.5rem);\n}\n\n.\\!k-translate-x-2 {\n    transform: translateX(0.5rem) !important;\n}\n\n.k-translate-x-2\\.5 {\n    transform: translateX(0.625rem);\n}\n\n.\\!k-translate-x-2\\.5 {\n    transform: translateX(0.625rem) !important;\n}\n\n.k-translate-x-3 {\n    transform: translateX(0.75rem);\n}\n\n.\\!k-translate-x-3 {\n    transform: translateX(0.75rem) !important;\n}\n\n.k-translate-x-3\\.5 {\n    transform: translateX(0.875rem);\n}\n\n.\\!k-translate-x-3\\.5 {\n    transform: translateX(0.875rem) !important;\n}\n\n.k-translate-x-4 {\n    transform: translateX(1rem);\n}\n\n.\\!k-translate-x-4 {\n    transform: translateX(1rem) !important;\n}\n\n.k-translate-x-4\\.5 {\n    transform: translateX(1.125rem);\n}\n\n.\\!k-translate-x-4\\.5 {\n    transform: translateX(1.125rem) !important;\n}\n\n.k-translate-x-5 {\n    transform: translateX(1.25rem);\n}\n\n.\\!k-translate-x-5 {\n    transform: translateX(1.25rem) !important;\n}\n\n.k-translate-x-5\\.5 {\n    transform: translateX(1.375rem);\n}\n\n.\\!k-translate-x-5\\.5 {\n    transform: translateX(1.375rem) !important;\n}\n\n.k-translate-x-6 {\n    transform: translateX(1.5rem);\n}\n\n.\\!k-translate-x-6 {\n    transform: translateX(1.5rem) !important;\n}\n\n.k-translate-x-6\\.5 {\n    transform: translateX(1.625rem);\n}\n\n.\\!k-translate-x-6\\.5 {\n    transform: translateX(1.625rem) !important;\n}\n\n.k-translate-x-7 {\n    transform: translateX(1.75rem);\n}\n\n.\\!k-translate-x-7 {\n    transform: translateX(1.75rem) !important;\n}\n\n.k-translate-x-7\\.5 {\n    transform: translateX(1.875rem);\n}\n\n.\\!k-translate-x-7\\.5 {\n    transform: translateX(1.875rem) !important;\n}\n\n.k-translate-x-8 {\n    transform: translateX(2rem);\n}\n\n.\\!k-translate-x-8 {\n    transform: translateX(2rem) !important;\n}\n\n.k-translate-x-9 {\n    transform: translateX(2.25rem);\n}\n\n.\\!k-translate-x-9 {\n    transform: translateX(2.25rem) !important;\n}\n\n.k-translate-x-10 {\n    transform: translateX(2.5rem);\n}\n\n.\\!k-translate-x-10 {\n    transform: translateX(2.5rem) !important;\n}\n\n.k-translate-x-11 {\n    transform: translateX(2.75rem);\n}\n\n.\\!k-translate-x-11 {\n    transform: translateX(2.75rem) !important;\n}\n\n.k-translate-x-12 {\n    transform: translateX(3rem);\n}\n\n.\\!k-translate-x-12 {\n    transform: translateX(3rem) !important;\n}\n\n.k-translate-x-13 {\n    transform: translateX(3.25rem);\n}\n\n.\\!k-translate-x-13 {\n    transform: translateX(3.25rem) !important;\n}\n\n.k-translate-x-14 {\n    transform: translateX(3.5rem);\n}\n\n.\\!k-translate-x-14 {\n    transform: translateX(3.5rem) !important;\n}\n\n.k-translate-x-15 {\n    transform: translateX(3.75rem);\n}\n\n.\\!k-translate-x-15 {\n    transform: translateX(3.75rem) !important;\n}\n\n.k-translate-x-16 {\n    transform: translateX(4rem);\n}\n\n.\\!k-translate-x-16 {\n    transform: translateX(4rem) !important;\n}\n\n.k-translate-x-17 {\n    transform: translateX(4.25rem);\n}\n\n.\\!k-translate-x-17 {\n    transform: translateX(4.25rem) !important;\n}\n\n.k-translate-x-18 {\n    transform: translateX(4.5rem);\n}\n\n.\\!k-translate-x-18 {\n    transform: translateX(4.5rem) !important;\n}\n\n.k-translate-x-19 {\n    transform: translateX(4.75rem);\n}\n\n.\\!k-translate-x-19 {\n    transform: translateX(4.75rem) !important;\n}\n\n.k-translate-x-20 {\n    transform: translateX(5rem);\n}\n\n.\\!k-translate-x-20 {\n    transform: translateX(5rem) !important;\n}\n\n.k-translate-x-21 {\n    transform: translateX(5.25rem);\n}\n\n.\\!k-translate-x-21 {\n    transform: translateX(5.25rem) !important;\n}\n\n.k-translate-x-22 {\n    transform: translateX(5.5rem);\n}\n\n.\\!k-translate-x-22 {\n    transform: translateX(5.5rem) !important;\n}\n\n.k-translate-x-23 {\n    transform: translateX(5.75rem);\n}\n\n.\\!k-translate-x-23 {\n    transform: translateX(5.75rem) !important;\n}\n\n.k-translate-x-24 {\n    transform: translateX(6rem);\n}\n\n.\\!k-translate-x-24 {\n    transform: translateX(6rem) !important;\n}\n\n.k-translate-x-1\\/2 {\n    transform: translateX(50%);\n}\n\n.\\!k-translate-x-1\\/2 {\n    transform: translateX(50%) !important;\n}\n\n.k-translate-x-1\\/3 {\n    transform: translateX(33.333333%);\n}\n\n.\\!k-translate-x-1\\/3 {\n    transform: translateX(33.333333%) !important;\n}\n\n.k-translate-x-2\\/3 {\n    transform: translateX(66.666667%);\n}\n\n.\\!k-translate-x-2\\/3 {\n    transform: translateX(66.666667%) !important;\n}\n\n.k-translate-x-1\\/4 {\n    transform: translateX(25%);\n}\n\n.\\!k-translate-x-1\\/4 {\n    transform: translateX(25%) !important;\n}\n\n.k-translate-x-2\\/4 {\n    transform: translateX(50%);\n}\n\n.\\!k-translate-x-2\\/4 {\n    transform: translateX(50%) !important;\n}\n\n.k-translate-x-3\\/4 {\n    transform: translateX(75%);\n}\n\n.\\!k-translate-x-3\\/4 {\n    transform: translateX(75%) !important;\n}\n\n.k-translate-x-1\\/5 {\n    transform: translateX(20%);\n}\n\n.\\!k-translate-x-1\\/5 {\n    transform: translateX(20%) !important;\n}\n\n.k-translate-x-2\\/5 {\n    transform: translateX(40%);\n}\n\n.\\!k-translate-x-2\\/5 {\n    transform: translateX(40%) !important;\n}\n\n.k-translate-x-3\\/5 {\n    transform: translateX(60%);\n}\n\n.\\!k-translate-x-3\\/5 {\n    transform: translateX(60%) !important;\n}\n\n.k-translate-x-4\\/5 {\n    transform: translateX(80%);\n}\n\n.\\!k-translate-x-4\\/5 {\n    transform: translateX(80%) !important;\n}\n\n.k-translate-x-1\\/6 {\n    transform: translateX(16.666667%);\n}\n\n.\\!k-translate-x-1\\/6 {\n    transform: translateX(16.666667%) !important;\n}\n\n.k-translate-x-2\\/6 {\n    transform: translateX(33.333333%);\n}\n\n.\\!k-translate-x-2\\/6 {\n    transform: translateX(33.333333%) !important;\n}\n\n.k-translate-x-3\\/6 {\n    transform: translateX(50%);\n}\n\n.\\!k-translate-x-3\\/6 {\n    transform: translateX(50%) !important;\n}\n\n.k-translate-x-4\\/6 {\n    transform: translateX(66.666667%);\n}\n\n.\\!k-translate-x-4\\/6 {\n    transform: translateX(66.666667%) !important;\n}\n\n.k-translate-x-5\\/6 {\n    transform: translateX(83.333333%);\n}\n\n.\\!k-translate-x-5\\/6 {\n    transform: translateX(83.333333%) !important;\n}\n\n.k-translate-x-1\\/12 {\n    transform: translateX(8.333333%);\n}\n\n.\\!k-translate-x-1\\/12 {\n    transform: translateX(8.333333%) !important;\n}\n\n.k-translate-x-2\\/12 {\n    transform: translateX(16.666667%);\n}\n\n.\\!k-translate-x-2\\/12 {\n    transform: translateX(16.666667%) !important;\n}\n\n.k-translate-x-3\\/12 {\n    transform: translateX(25%);\n}\n\n.\\!k-translate-x-3\\/12 {\n    transform: translateX(25%) !important;\n}\n\n.k-translate-x-4\\/12 {\n    transform: translateX(33.333333%);\n}\n\n.\\!k-translate-x-4\\/12 {\n    transform: translateX(33.333333%) !important;\n}\n\n.k-translate-x-5\\/12 {\n    transform: translateX(41.666667%);\n}\n\n.\\!k-translate-x-5\\/12 {\n    transform: translateX(41.666667%) !important;\n}\n\n.k-translate-x-6\\/12 {\n    transform: translateX(50%);\n}\n\n.\\!k-translate-x-6\\/12 {\n    transform: translateX(50%) !important;\n}\n\n.k-translate-x-7\\/12 {\n    transform: translateX(58.333333%);\n}\n\n.\\!k-translate-x-7\\/12 {\n    transform: translateX(58.333333%) !important;\n}\n\n.k-translate-x-8\\/12 {\n    transform: translateX(66.666667%);\n}\n\n.\\!k-translate-x-8\\/12 {\n    transform: translateX(66.666667%) !important;\n}\n\n.k-translate-x-9\\/12 {\n    transform: translateX(75%);\n}\n\n.\\!k-translate-x-9\\/12 {\n    transform: translateX(75%) !important;\n}\n\n.k-translate-x-10\\/12 {\n    transform: translateX(83.333333%);\n}\n\n.\\!k-translate-x-10\\/12 {\n    transform: translateX(83.333333%) !important;\n}\n\n.k-translate-x-11\\/12 {\n    transform: translateX(91.666667%);\n}\n\n.\\!k-translate-x-11\\/12 {\n    transform: translateX(91.666667%) !important;\n}\n\n.k-translate-x-full {\n    transform: translateX(100%);\n}\n\n.\\!k-translate-x-full {\n    transform: translateX(100%) !important;\n}\n\n.k-translate-y-0 {\n    transform: translateY(0);\n}\n\n.\\!k-translate-y-0 {\n    transform: translateY(0) !important;\n}\n\n.k-translate-y-1px {\n    transform: translateY(1px);\n}\n\n.\\!k-translate-y-1px {\n    transform: translateY(1px) !important;\n}\n\n.k-translate-y-0\\.5 {\n    transform: translateY(0.125rem);\n}\n\n.\\!k-translate-y-0\\.5 {\n    transform: translateY(0.125rem) !important;\n}\n\n.k-translate-y-1 {\n    transform: translateY(0.25rem);\n}\n\n.\\!k-translate-y-1 {\n    transform: translateY(0.25rem) !important;\n}\n\n.k-translate-y-1\\.5 {\n    transform: translateY(0.375rem);\n}\n\n.\\!k-translate-y-1\\.5 {\n    transform: translateY(0.375rem) !important;\n}\n\n.k-translate-y-2 {\n    transform: translateY(0.5rem);\n}\n\n.\\!k-translate-y-2 {\n    transform: translateY(0.5rem) !important;\n}\n\n.k-translate-y-2\\.5 {\n    transform: translateY(0.625rem);\n}\n\n.\\!k-translate-y-2\\.5 {\n    transform: translateY(0.625rem) !important;\n}\n\n.k-translate-y-3 {\n    transform: translateY(0.75rem);\n}\n\n.\\!k-translate-y-3 {\n    transform: translateY(0.75rem) !important;\n}\n\n.k-translate-y-3\\.5 {\n    transform: translateY(0.875rem);\n}\n\n.\\!k-translate-y-3\\.5 {\n    transform: translateY(0.875rem) !important;\n}\n\n.k-translate-y-4 {\n    transform: translateY(1rem);\n}\n\n.\\!k-translate-y-4 {\n    transform: translateY(1rem) !important;\n}\n\n.k-translate-y-4\\.5 {\n    transform: translateY(1.125rem);\n}\n\n.\\!k-translate-y-4\\.5 {\n    transform: translateY(1.125rem) !important;\n}\n\n.k-translate-y-5 {\n    transform: translateY(1.25rem);\n}\n\n.\\!k-translate-y-5 {\n    transform: translateY(1.25rem) !important;\n}\n\n.k-translate-y-5\\.5 {\n    transform: translateY(1.375rem);\n}\n\n.\\!k-translate-y-5\\.5 {\n    transform: translateY(1.375rem) !important;\n}\n\n.k-translate-y-6 {\n    transform: translateY(1.5rem);\n}\n\n.\\!k-translate-y-6 {\n    transform: translateY(1.5rem) !important;\n}\n\n.k-translate-y-6\\.5 {\n    transform: translateY(1.625rem);\n}\n\n.\\!k-translate-y-6\\.5 {\n    transform: translateY(1.625rem) !important;\n}\n\n.k-translate-y-7 {\n    transform: translateY(1.75rem);\n}\n\n.\\!k-translate-y-7 {\n    transform: translateY(1.75rem) !important;\n}\n\n.k-translate-y-7\\.5 {\n    transform: translateY(1.875rem);\n}\n\n.\\!k-translate-y-7\\.5 {\n    transform: translateY(1.875rem) !important;\n}\n\n.k-translate-y-8 {\n    transform: translateY(2rem);\n}\n\n.\\!k-translate-y-8 {\n    transform: translateY(2rem) !important;\n}\n\n.k-translate-y-9 {\n    transform: translateY(2.25rem);\n}\n\n.\\!k-translate-y-9 {\n    transform: translateY(2.25rem) !important;\n}\n\n.k-translate-y-10 {\n    transform: translateY(2.5rem);\n}\n\n.\\!k-translate-y-10 {\n    transform: translateY(2.5rem) !important;\n}\n\n.k-translate-y-11 {\n    transform: translateY(2.75rem);\n}\n\n.\\!k-translate-y-11 {\n    transform: translateY(2.75rem) !important;\n}\n\n.k-translate-y-12 {\n    transform: translateY(3rem);\n}\n\n.\\!k-translate-y-12 {\n    transform: translateY(3rem) !important;\n}\n\n.k-translate-y-13 {\n    transform: translateY(3.25rem);\n}\n\n.\\!k-translate-y-13 {\n    transform: translateY(3.25rem) !important;\n}\n\n.k-translate-y-14 {\n    transform: translateY(3.5rem);\n}\n\n.\\!k-translate-y-14 {\n    transform: translateY(3.5rem) !important;\n}\n\n.k-translate-y-15 {\n    transform: translateY(3.75rem);\n}\n\n.\\!k-translate-y-15 {\n    transform: translateY(3.75rem) !important;\n}\n\n.k-translate-y-16 {\n    transform: translateY(4rem);\n}\n\n.\\!k-translate-y-16 {\n    transform: translateY(4rem) !important;\n}\n\n.k-translate-y-17 {\n    transform: translateY(4.25rem);\n}\n\n.\\!k-translate-y-17 {\n    transform: translateY(4.25rem) !important;\n}\n\n.k-translate-y-18 {\n    transform: translateY(4.5rem);\n}\n\n.\\!k-translate-y-18 {\n    transform: translateY(4.5rem) !important;\n}\n\n.k-translate-y-19 {\n    transform: translateY(4.75rem);\n}\n\n.\\!k-translate-y-19 {\n    transform: translateY(4.75rem) !important;\n}\n\n.k-translate-y-20 {\n    transform: translateY(5rem);\n}\n\n.\\!k-translate-y-20 {\n    transform: translateY(5rem) !important;\n}\n\n.k-translate-y-21 {\n    transform: translateY(5.25rem);\n}\n\n.\\!k-translate-y-21 {\n    transform: translateY(5.25rem) !important;\n}\n\n.k-translate-y-22 {\n    transform: translateY(5.5rem);\n}\n\n.\\!k-translate-y-22 {\n    transform: translateY(5.5rem) !important;\n}\n\n.k-translate-y-23 {\n    transform: translateY(5.75rem);\n}\n\n.\\!k-translate-y-23 {\n    transform: translateY(5.75rem) !important;\n}\n\n.k-translate-y-24 {\n    transform: translateY(6rem);\n}\n\n.\\!k-translate-y-24 {\n    transform: translateY(6rem) !important;\n}\n\n.k-translate-y-1\\/2 {\n    transform: translateY(50%);\n}\n\n.\\!k-translate-y-1\\/2 {\n    transform: translateY(50%) !important;\n}\n\n.k-translate-y-1\\/3 {\n    transform: translateY(33.333333%);\n}\n\n.\\!k-translate-y-1\\/3 {\n    transform: translateY(33.333333%) !important;\n}\n\n.k-translate-y-2\\/3 {\n    transform: translateY(66.666667%);\n}\n\n.\\!k-translate-y-2\\/3 {\n    transform: translateY(66.666667%) !important;\n}\n\n.k-translate-y-1\\/4 {\n    transform: translateY(25%);\n}\n\n.\\!k-translate-y-1\\/4 {\n    transform: translateY(25%) !important;\n}\n\n.k-translate-y-2\\/4 {\n    transform: translateY(50%);\n}\n\n.\\!k-translate-y-2\\/4 {\n    transform: translateY(50%) !important;\n}\n\n.k-translate-y-3\\/4 {\n    transform: translateY(75%);\n}\n\n.\\!k-translate-y-3\\/4 {\n    transform: translateY(75%) !important;\n}\n\n.k-translate-y-1\\/5 {\n    transform: translateY(20%);\n}\n\n.\\!k-translate-y-1\\/5 {\n    transform: translateY(20%) !important;\n}\n\n.k-translate-y-2\\/5 {\n    transform: translateY(40%);\n}\n\n.\\!k-translate-y-2\\/5 {\n    transform: translateY(40%) !important;\n}\n\n.k-translate-y-3\\/5 {\n    transform: translateY(60%);\n}\n\n.\\!k-translate-y-3\\/5 {\n    transform: translateY(60%) !important;\n}\n\n.k-translate-y-4\\/5 {\n    transform: translateY(80%);\n}\n\n.\\!k-translate-y-4\\/5 {\n    transform: translateY(80%) !important;\n}\n\n.k-translate-y-1\\/6 {\n    transform: translateY(16.666667%);\n}\n\n.\\!k-translate-y-1\\/6 {\n    transform: translateY(16.666667%) !important;\n}\n\n.k-translate-y-2\\/6 {\n    transform: translateY(33.333333%);\n}\n\n.\\!k-translate-y-2\\/6 {\n    transform: translateY(33.333333%) !important;\n}\n\n.k-translate-y-3\\/6 {\n    transform: translateY(50%);\n}\n\n.\\!k-translate-y-3\\/6 {\n    transform: translateY(50%) !important;\n}\n\n.k-translate-y-4\\/6 {\n    transform: translateY(66.666667%);\n}\n\n.\\!k-translate-y-4\\/6 {\n    transform: translateY(66.666667%) !important;\n}\n\n.k-translate-y-5\\/6 {\n    transform: translateY(83.333333%);\n}\n\n.\\!k-translate-y-5\\/6 {\n    transform: translateY(83.333333%) !important;\n}\n\n.k-translate-y-1\\/12 {\n    transform: translateY(8.333333%);\n}\n\n.\\!k-translate-y-1\\/12 {\n    transform: translateY(8.333333%) !important;\n}\n\n.k-translate-y-2\\/12 {\n    transform: translateY(16.666667%);\n}\n\n.\\!k-translate-y-2\\/12 {\n    transform: translateY(16.666667%) !important;\n}\n\n.k-translate-y-3\\/12 {\n    transform: translateY(25%);\n}\n\n.\\!k-translate-y-3\\/12 {\n    transform: translateY(25%) !important;\n}\n\n.k-translate-y-4\\/12 {\n    transform: translateY(33.333333%);\n}\n\n.\\!k-translate-y-4\\/12 {\n    transform: translateY(33.333333%) !important;\n}\n\n.k-translate-y-5\\/12 {\n    transform: translateY(41.666667%);\n}\n\n.\\!k-translate-y-5\\/12 {\n    transform: translateY(41.666667%) !important;\n}\n\n.k-translate-y-6\\/12 {\n    transform: translateY(50%);\n}\n\n.\\!k-translate-y-6\\/12 {\n    transform: translateY(50%) !important;\n}\n\n.k-translate-y-7\\/12 {\n    transform: translateY(58.333333%);\n}\n\n.\\!k-translate-y-7\\/12 {\n    transform: translateY(58.333333%) !important;\n}\n\n.k-translate-y-8\\/12 {\n    transform: translateY(66.666667%);\n}\n\n.\\!k-translate-y-8\\/12 {\n    transform: translateY(66.666667%) !important;\n}\n\n.k-translate-y-9\\/12 {\n    transform: translateY(75%);\n}\n\n.\\!k-translate-y-9\\/12 {\n    transform: translateY(75%) !important;\n}\n\n.k-translate-y-10\\/12 {\n    transform: translateY(83.333333%);\n}\n\n.\\!k-translate-y-10\\/12 {\n    transform: translateY(83.333333%) !important;\n}\n\n.k-translate-y-11\\/12 {\n    transform: translateY(91.666667%);\n}\n\n.\\!k-translate-y-11\\/12 {\n    transform: translateY(91.666667%) !important;\n}\n\n.k-translate-y-full {\n    transform: translateY(100%);\n}\n\n.\\!k-translate-y-full {\n    transform: translateY(100%) !important;\n}\n\n.k-appearance-none {\n    appearance: none;\n}\n\n.\\!k-appearance-none {\n    appearance: none !important;\n}\n\n.k-appearance-auto {\n    appearance: auto;\n}\n\n.\\!k-appearance-auto {\n    appearance: auto !important;\n}\n\n.k-cursor-none {\n    cursor: none;\n}\n\n.\\!k-cursor-none {\n    cursor: none !important;\n}\n\n.k-cursor-auto {\n    cursor: auto;\n}\n\n.\\!k-cursor-auto {\n    cursor: auto !important;\n}\n\n.k-cursor-default {\n    cursor: default;\n}\n\n.\\!k-cursor-default {\n    cursor: default !important;\n}\n\n.k-cursor-context-menu {\n    cursor: context-menu;\n}\n\n.\\!k-cursor-context-menu {\n    cursor: context-menu !important;\n}\n\n.k-cursor-help {\n    cursor: help;\n}\n\n.\\!k-cursor-help {\n    cursor: help !important;\n}\n\n.k-cursor-pointer {\n    cursor: pointer;\n}\n\n.\\!k-cursor-pointer {\n    cursor: pointer !important;\n}\n\n.k-cursor-progress {\n    cursor: progress;\n}\n\n.\\!k-cursor-progress {\n    cursor: progress !important;\n}\n\n.k-cursor-wait {\n    cursor: wait;\n}\n\n.\\!k-cursor-wait {\n    cursor: wait !important;\n}\n\n.k-cursor-cell {\n    cursor: cell;\n}\n\n.\\!k-cursor-cell {\n    cursor: cell !important;\n}\n\n.k-cursor-crosshair {\n    cursor: crosshair;\n}\n\n.\\!k-cursor-crosshair {\n    cursor: crosshair !important;\n}\n\n.k-cursor-text {\n    cursor: text;\n}\n\n.\\!k-cursor-text {\n    cursor: text !important;\n}\n\n.k-cursor-vertical-text {\n    cursor: vertical-text;\n}\n\n.\\!k-cursor-vertical-text {\n    cursor: vertical-text !important;\n}\n\n.k-cursor-alias {\n    cursor: alias;\n}\n\n.\\!k-cursor-alias {\n    cursor: alias !important;\n}\n\n.k-cursor-copy {\n    cursor: copy;\n}\n\n.\\!k-cursor-copy {\n    cursor: copy !important;\n}\n\n.k-cursor-move {\n    cursor: move;\n}\n\n.\\!k-cursor-move {\n    cursor: move !important;\n}\n\n.k-cursor-no-drop {\n    cursor: no-drop;\n}\n\n.\\!k-cursor-no-drop {\n    cursor: no-drop !important;\n}\n\n.k-cursor-not-allowed {\n    cursor: not-allowed;\n}\n\n.\\!k-cursor-not-allowed {\n    cursor: not-allowed !important;\n}\n\n.k-cursor-e-resize {\n    cursor: e-resize;\n}\n\n.\\!k-cursor-e-resize {\n    cursor: e-resize !important;\n}\n\n.k-cursor-n-resize {\n    cursor: n-resize;\n}\n\n.\\!k-cursor-n-resize {\n    cursor: n-resize !important;\n}\n\n.k-cursor-ne-resize {\n    cursor: ne-resize;\n}\n\n.\\!k-cursor-ne-resize {\n    cursor: ne-resize !important;\n}\n\n.k-cursor-nw-resize {\n    cursor: nw-resize;\n}\n\n.\\!k-cursor-nw-resize {\n    cursor: nw-resize !important;\n}\n\n.k-cursor-s-resize {\n    cursor: s-resize;\n}\n\n.\\!k-cursor-s-resize {\n    cursor: s-resize !important;\n}\n\n.k-cursor-se-resize {\n    cursor: se-resize;\n}\n\n.\\!k-cursor-se-resize {\n    cursor: se-resize !important;\n}\n\n.k-cursor-sw-resize {\n    cursor: sw-resize;\n}\n\n.\\!k-cursor-sw-resize {\n    cursor: sw-resize !important;\n}\n\n.k-cursor-w-resize {\n    cursor: w-resize;\n}\n\n.\\!k-cursor-w-resize {\n    cursor: w-resize !important;\n}\n\n.k-cursor-ew-resize {\n    cursor: ew-resize;\n}\n\n.\\!k-cursor-ew-resize {\n    cursor: ew-resize !important;\n}\n\n.k-cursor-ns-resize {\n    cursor: ns-resize;\n}\n\n.\\!k-cursor-ns-resize {\n    cursor: ns-resize !important;\n}\n\n.k-cursor-nesw-resize {\n    cursor: nesw-resize;\n}\n\n.\\!k-cursor-nesw-resize {\n    cursor: nesw-resize !important;\n}\n\n.k-cursor-nwse-resize {\n    cursor: nwse-resize;\n}\n\n.\\!k-cursor-nwse-resize {\n    cursor: nwse-resize !important;\n}\n\n.k-cursor-col-resize {\n    cursor: col-resize;\n}\n\n.\\!k-cursor-col-resize {\n    cursor: col-resize !important;\n}\n\n.k-cursor-row-resize {\n    cursor: row-resize;\n}\n\n.\\!k-cursor-row-resize {\n    cursor: row-resize !important;\n}\n\n.k-cursor-all-scroll {\n    cursor: all-scroll;\n}\n\n.\\!k-cursor-all-scroll {\n    cursor: all-scroll !important;\n}\n\n.k-cursor-zoom-in {\n    cursor: zoom-in;\n}\n\n.\\!k-cursor-zoom-in {\n    cursor: zoom-in !important;\n}\n\n.k-cursor-zoom-out {\n    cursor: zoom-out;\n}\n\n.\\!k-cursor-zoom-out {\n    cursor: zoom-out !important;\n}\n\n.k-cursor-grab {\n    cursor: grab;\n}\n\n.\\!k-cursor-grab {\n    cursor: grab !important;\n}\n\n.k-cursor-grabbing {\n    cursor: grabbing;\n}\n\n.\\!k-cursor-grabbing {\n    cursor: grabbing !important;\n}\n\n.k-pointer-events-none {\n    pointer-events: none;\n}\n\n.\\!k-pointer-events-none {\n    pointer-events: none !important;\n}\n\n.k-pointer-events-auto {\n    pointer-events: auto;\n}\n\n.\\!k-pointer-events-auto {\n    pointer-events: auto !important;\n}\n\n.k-resize {\n    resize: both;\n}\n\n.\\!k-resize {\n    resize: both !important;\n}\n\n.k-resize-none {\n    resize: none;\n}\n\n.\\!k-resize-none {\n    resize: none !important;\n}\n\n.k-resize-x {\n    resize: horizontal;\n}\n\n.\\!k-resize-x {\n    resize: horizontal !important;\n}\n\n.k-resize-y {\n    resize: vertical;\n}\n\n.\\!k-resize-y {\n    resize: vertical !important;\n}\n\n.k-scroll-auto {\n    scroll-behavior: auto;\n}\n\n.\\!k-scroll-auto {\n    scroll-behavior: auto !important;\n}\n\n.k-scroll-smooth {\n    scroll-behavior: smooth;\n}\n\n.\\!k-scroll-smooth {\n    scroll-behavior: smooth !important;\n}\n\n.k-scroll-snap-none {\n    -ms-scroll-snap-type: none;\n        scroll-snap-type: none;\n}\n\n.\\!k-scroll-snap-none {\n    -ms-scroll-snap-type: none !important;\n        scroll-snap-type: none !important;\n}\n\n.k-scroll-snap-snap-x {\n    -ms-scroll-snap-type: x var(--k-scroll-snap-strictness);\n        scroll-snap-type: x var(--k-scroll-snap-strictness);\n}\n\n.\\!k-scroll-snap-snap-x {\n    -ms-scroll-snap-type: x var(--k-scroll-snap-strictness) !important;\n        scroll-snap-type: x var(--k-scroll-snap-strictness) !important;\n}\n\n.k-scroll-snap-snap-y {\n    -ms-scroll-snap-type: y var(--k-scroll-snap-strictness);\n        scroll-snap-type: y var(--k-scroll-snap-strictness);\n}\n\n.\\!k-scroll-snap-snap-y {\n    -ms-scroll-snap-type: y var(--k-scroll-snap-strictness) !important;\n        scroll-snap-type: y var(--k-scroll-snap-strictness) !important;\n}\n\n.k-scroll-snap-snap-both {\n    -ms-scroll-snap-type: both var(--k-scroll-snap-strictness);\n        scroll-snap-type: both var(--k-scroll-snap-strictness);\n}\n\n.\\!k-scroll-snap-snap-both {\n    -ms-scroll-snap-type: both var(--k-scroll-snap-strictness) !important;\n        scroll-snap-type: both var(--k-scroll-snap-strictness) !important;\n}\n\n.k-scroll-snap-mandatory {\n    --k-scroll-snap-strictness: mandatory;\n}\n\n.k-scroll-snap-proximity {\n    --k-scroll-snap-strictness: proximity;\n}\n\n.k-scroll-snap-stop-normal {\n    scroll-snap-stop: normal;\n}\n\n.\\!k-scroll-snap-stop-normal {\n    scroll-snap-stop: normal !important;\n}\n\n.k-scroll-snap-stop-always {\n    scroll-snap-stop: always;\n}\n\n.\\!k-scroll-snap-stop-always {\n    scroll-snap-stop: always !important;\n}\n\n.k-scroll-snap-align-start {\n    scroll-snap-align: start;\n}\n\n.\\!k-scroll-snap-align-start {\n    scroll-snap-align: start !important;\n}\n\n.k-scroll-snap-align-end {\n    scroll-snap-align: end;\n}\n\n.\\!k-scroll-snap-align-end {\n    scroll-snap-align: end !important;\n}\n\n.k-scroll-snap-align-center {\n    scroll-snap-align: center;\n}\n\n.\\!k-scroll-snap-align-center {\n    scroll-snap-align: center !important;\n}\n\n.k-scroll-snap-align-none {\n    scroll-snap-align: none;\n}\n\n.\\!k-scroll-snap-align-none {\n    scroll-snap-align: none !important;\n}\n\n.k-scroll-m-0 {\n    scroll-margin: 0;\n}\n\n.\\!k-scroll-m-0 {\n    scroll-margin: 0 !important;\n}\n\n.k-scroll-m-1px {\n    scroll-margin: 1px;\n}\n\n.\\!k-scroll-m-1px {\n    scroll-margin: 1px !important;\n}\n\n.k-scroll-m-0\\.5 {\n    scroll-margin: 0.125rem;\n}\n\n.\\!k-scroll-m-0\\.5 {\n    scroll-margin: 0.125rem !important;\n}\n\n.k-scroll-m-1 {\n    scroll-margin: 0.25rem;\n}\n\n.\\!k-scroll-m-1 {\n    scroll-margin: 0.25rem !important;\n}\n\n.k-scroll-m-1\\.5 {\n    scroll-margin: 0.375rem;\n}\n\n.\\!k-scroll-m-1\\.5 {\n    scroll-margin: 0.375rem !important;\n}\n\n.k-scroll-m-2 {\n    scroll-margin: 0.5rem;\n}\n\n.\\!k-scroll-m-2 {\n    scroll-margin: 0.5rem !important;\n}\n\n.k-scroll-m-2\\.5 {\n    scroll-margin: 0.625rem;\n}\n\n.\\!k-scroll-m-2\\.5 {\n    scroll-margin: 0.625rem !important;\n}\n\n.k-scroll-m-3 {\n    scroll-margin: 0.75rem;\n}\n\n.\\!k-scroll-m-3 {\n    scroll-margin: 0.75rem !important;\n}\n\n.k-scroll-m-3\\.5 {\n    scroll-margin: 0.875rem;\n}\n\n.\\!k-scroll-m-3\\.5 {\n    scroll-margin: 0.875rem !important;\n}\n\n.k-scroll-m-4 {\n    scroll-margin: 1rem;\n}\n\n.\\!k-scroll-m-4 {\n    scroll-margin: 1rem !important;\n}\n\n.k-scroll-m-4\\.5 {\n    scroll-margin: 1.125rem;\n}\n\n.\\!k-scroll-m-4\\.5 {\n    scroll-margin: 1.125rem !important;\n}\n\n.k-scroll-m-5 {\n    scroll-margin: 1.25rem;\n}\n\n.\\!k-scroll-m-5 {\n    scroll-margin: 1.25rem !important;\n}\n\n.k-scroll-m-5\\.5 {\n    scroll-margin: 1.375rem;\n}\n\n.\\!k-scroll-m-5\\.5 {\n    scroll-margin: 1.375rem !important;\n}\n\n.k-scroll-m-6 {\n    scroll-margin: 1.5rem;\n}\n\n.\\!k-scroll-m-6 {\n    scroll-margin: 1.5rem !important;\n}\n\n.k-scroll-m-6\\.5 {\n    scroll-margin: 1.625rem;\n}\n\n.\\!k-scroll-m-6\\.5 {\n    scroll-margin: 1.625rem !important;\n}\n\n.k-scroll-m-7 {\n    scroll-margin: 1.75rem;\n}\n\n.\\!k-scroll-m-7 {\n    scroll-margin: 1.75rem !important;\n}\n\n.k-scroll-m-7\\.5 {\n    scroll-margin: 1.875rem;\n}\n\n.\\!k-scroll-m-7\\.5 {\n    scroll-margin: 1.875rem !important;\n}\n\n.k-scroll-m-8 {\n    scroll-margin: 2rem;\n}\n\n.\\!k-scroll-m-8 {\n    scroll-margin: 2rem !important;\n}\n\n.k-scroll-m-9 {\n    scroll-margin: 2.25rem;\n}\n\n.\\!k-scroll-m-9 {\n    scroll-margin: 2.25rem !important;\n}\n\n.k-scroll-m-10 {\n    scroll-margin: 2.5rem;\n}\n\n.\\!k-scroll-m-10 {\n    scroll-margin: 2.5rem !important;\n}\n\n.k-scroll-m-11 {\n    scroll-margin: 2.75rem;\n}\n\n.\\!k-scroll-m-11 {\n    scroll-margin: 2.75rem !important;\n}\n\n.k-scroll-m-12 {\n    scroll-margin: 3rem;\n}\n\n.\\!k-scroll-m-12 {\n    scroll-margin: 3rem !important;\n}\n\n.k-scroll-m-13 {\n    scroll-margin: 3.25rem;\n}\n\n.\\!k-scroll-m-13 {\n    scroll-margin: 3.25rem !important;\n}\n\n.k-scroll-m-14 {\n    scroll-margin: 3.5rem;\n}\n\n.\\!k-scroll-m-14 {\n    scroll-margin: 3.5rem !important;\n}\n\n.k-scroll-m-15 {\n    scroll-margin: 3.75rem;\n}\n\n.\\!k-scroll-m-15 {\n    scroll-margin: 3.75rem !important;\n}\n\n.k-scroll-m-16 {\n    scroll-margin: 4rem;\n}\n\n.\\!k-scroll-m-16 {\n    scroll-margin: 4rem !important;\n}\n\n.k-scroll-m-17 {\n    scroll-margin: 4.25rem;\n}\n\n.\\!k-scroll-m-17 {\n    scroll-margin: 4.25rem !important;\n}\n\n.k-scroll-m-18 {\n    scroll-margin: 4.5rem;\n}\n\n.\\!k-scroll-m-18 {\n    scroll-margin: 4.5rem !important;\n}\n\n.k-scroll-m-19 {\n    scroll-margin: 4.75rem;\n}\n\n.\\!k-scroll-m-19 {\n    scroll-margin: 4.75rem !important;\n}\n\n.k-scroll-m-20 {\n    scroll-margin: 5rem;\n}\n\n.\\!k-scroll-m-20 {\n    scroll-margin: 5rem !important;\n}\n\n.k-scroll-m-21 {\n    scroll-margin: 5.25rem;\n}\n\n.\\!k-scroll-m-21 {\n    scroll-margin: 5.25rem !important;\n}\n\n.k-scroll-m-22 {\n    scroll-margin: 5.5rem;\n}\n\n.\\!k-scroll-m-22 {\n    scroll-margin: 5.5rem !important;\n}\n\n.k-scroll-m-23 {\n    scroll-margin: 5.75rem;\n}\n\n.\\!k-scroll-m-23 {\n    scroll-margin: 5.75rem !important;\n}\n\n.k-scroll-m-24 {\n    scroll-margin: 6rem;\n}\n\n.\\!k-scroll-m-24 {\n    scroll-margin: 6rem !important;\n}\n\n.k-scroll-mt-0 {\n    scroll-margin-top: 0;\n}\n\n.\\!k-scroll-mt-0 {\n    scroll-margin-top: 0 !important;\n}\n\n.k-scroll-mt-1px {\n    scroll-margin-top: 1px;\n}\n\n.\\!k-scroll-mt-1px {\n    scroll-margin-top: 1px !important;\n}\n\n.k-scroll-mt-0\\.5 {\n    scroll-margin-top: 0.125rem;\n}\n\n.\\!k-scroll-mt-0\\.5 {\n    scroll-margin-top: 0.125rem !important;\n}\n\n.k-scroll-mt-1 {\n    scroll-margin-top: 0.25rem;\n}\n\n.\\!k-scroll-mt-1 {\n    scroll-margin-top: 0.25rem !important;\n}\n\n.k-scroll-mt-1\\.5 {\n    scroll-margin-top: 0.375rem;\n}\n\n.\\!k-scroll-mt-1\\.5 {\n    scroll-margin-top: 0.375rem !important;\n}\n\n.k-scroll-mt-2 {\n    scroll-margin-top: 0.5rem;\n}\n\n.\\!k-scroll-mt-2 {\n    scroll-margin-top: 0.5rem !important;\n}\n\n.k-scroll-mt-2\\.5 {\n    scroll-margin-top: 0.625rem;\n}\n\n.\\!k-scroll-mt-2\\.5 {\n    scroll-margin-top: 0.625rem !important;\n}\n\n.k-scroll-mt-3 {\n    scroll-margin-top: 0.75rem;\n}\n\n.\\!k-scroll-mt-3 {\n    scroll-margin-top: 0.75rem !important;\n}\n\n.k-scroll-mt-3\\.5 {\n    scroll-margin-top: 0.875rem;\n}\n\n.\\!k-scroll-mt-3\\.5 {\n    scroll-margin-top: 0.875rem !important;\n}\n\n.k-scroll-mt-4 {\n    scroll-margin-top: 1rem;\n}\n\n.\\!k-scroll-mt-4 {\n    scroll-margin-top: 1rem !important;\n}\n\n.k-scroll-mt-4\\.5 {\n    scroll-margin-top: 1.125rem;\n}\n\n.\\!k-scroll-mt-4\\.5 {\n    scroll-margin-top: 1.125rem !important;\n}\n\n.k-scroll-mt-5 {\n    scroll-margin-top: 1.25rem;\n}\n\n.\\!k-scroll-mt-5 {\n    scroll-margin-top: 1.25rem !important;\n}\n\n.k-scroll-mt-5\\.5 {\n    scroll-margin-top: 1.375rem;\n}\n\n.\\!k-scroll-mt-5\\.5 {\n    scroll-margin-top: 1.375rem !important;\n}\n\n.k-scroll-mt-6 {\n    scroll-margin-top: 1.5rem;\n}\n\n.\\!k-scroll-mt-6 {\n    scroll-margin-top: 1.5rem !important;\n}\n\n.k-scroll-mt-6\\.5 {\n    scroll-margin-top: 1.625rem;\n}\n\n.\\!k-scroll-mt-6\\.5 {\n    scroll-margin-top: 1.625rem !important;\n}\n\n.k-scroll-mt-7 {\n    scroll-margin-top: 1.75rem;\n}\n\n.\\!k-scroll-mt-7 {\n    scroll-margin-top: 1.75rem !important;\n}\n\n.k-scroll-mt-7\\.5 {\n    scroll-margin-top: 1.875rem;\n}\n\n.\\!k-scroll-mt-7\\.5 {\n    scroll-margin-top: 1.875rem !important;\n}\n\n.k-scroll-mt-8 {\n    scroll-margin-top: 2rem;\n}\n\n.\\!k-scroll-mt-8 {\n    scroll-margin-top: 2rem !important;\n}\n\n.k-scroll-mt-9 {\n    scroll-margin-top: 2.25rem;\n}\n\n.\\!k-scroll-mt-9 {\n    scroll-margin-top: 2.25rem !important;\n}\n\n.k-scroll-mt-10 {\n    scroll-margin-top: 2.5rem;\n}\n\n.\\!k-scroll-mt-10 {\n    scroll-margin-top: 2.5rem !important;\n}\n\n.k-scroll-mt-11 {\n    scroll-margin-top: 2.75rem;\n}\n\n.\\!k-scroll-mt-11 {\n    scroll-margin-top: 2.75rem !important;\n}\n\n.k-scroll-mt-12 {\n    scroll-margin-top: 3rem;\n}\n\n.\\!k-scroll-mt-12 {\n    scroll-margin-top: 3rem !important;\n}\n\n.k-scroll-mt-13 {\n    scroll-margin-top: 3.25rem;\n}\n\n.\\!k-scroll-mt-13 {\n    scroll-margin-top: 3.25rem !important;\n}\n\n.k-scroll-mt-14 {\n    scroll-margin-top: 3.5rem;\n}\n\n.\\!k-scroll-mt-14 {\n    scroll-margin-top: 3.5rem !important;\n}\n\n.k-scroll-mt-15 {\n    scroll-margin-top: 3.75rem;\n}\n\n.\\!k-scroll-mt-15 {\n    scroll-margin-top: 3.75rem !important;\n}\n\n.k-scroll-mt-16 {\n    scroll-margin-top: 4rem;\n}\n\n.\\!k-scroll-mt-16 {\n    scroll-margin-top: 4rem !important;\n}\n\n.k-scroll-mt-17 {\n    scroll-margin-top: 4.25rem;\n}\n\n.\\!k-scroll-mt-17 {\n    scroll-margin-top: 4.25rem !important;\n}\n\n.k-scroll-mt-18 {\n    scroll-margin-top: 4.5rem;\n}\n\n.\\!k-scroll-mt-18 {\n    scroll-margin-top: 4.5rem !important;\n}\n\n.k-scroll-mt-19 {\n    scroll-margin-top: 4.75rem;\n}\n\n.\\!k-scroll-mt-19 {\n    scroll-margin-top: 4.75rem !important;\n}\n\n.k-scroll-mt-20 {\n    scroll-margin-top: 5rem;\n}\n\n.\\!k-scroll-mt-20 {\n    scroll-margin-top: 5rem !important;\n}\n\n.k-scroll-mt-21 {\n    scroll-margin-top: 5.25rem;\n}\n\n.\\!k-scroll-mt-21 {\n    scroll-margin-top: 5.25rem !important;\n}\n\n.k-scroll-mt-22 {\n    scroll-margin-top: 5.5rem;\n}\n\n.\\!k-scroll-mt-22 {\n    scroll-margin-top: 5.5rem !important;\n}\n\n.k-scroll-mt-23 {\n    scroll-margin-top: 5.75rem;\n}\n\n.\\!k-scroll-mt-23 {\n    scroll-margin-top: 5.75rem !important;\n}\n\n.k-scroll-mt-24 {\n    scroll-margin-top: 6rem;\n}\n\n.\\!k-scroll-mt-24 {\n    scroll-margin-top: 6rem !important;\n}\n\n.k-scroll-mr-0 {\n    scroll-margin-right: 0;\n}\n\n.\\!k-scroll-mr-0 {\n    scroll-margin-right: 0 !important;\n}\n\n.k-scroll-mr-1px {\n    scroll-margin-right: 1px;\n}\n\n.\\!k-scroll-mr-1px {\n    scroll-margin-right: 1px !important;\n}\n\n.k-scroll-mr-0\\.5 {\n    scroll-margin-right: 0.125rem;\n}\n\n.\\!k-scroll-mr-0\\.5 {\n    scroll-margin-right: 0.125rem !important;\n}\n\n.k-scroll-mr-1 {\n    scroll-margin-right: 0.25rem;\n}\n\n.\\!k-scroll-mr-1 {\n    scroll-margin-right: 0.25rem !important;\n}\n\n.k-scroll-mr-1\\.5 {\n    scroll-margin-right: 0.375rem;\n}\n\n.\\!k-scroll-mr-1\\.5 {\n    scroll-margin-right: 0.375rem !important;\n}\n\n.k-scroll-mr-2 {\n    scroll-margin-right: 0.5rem;\n}\n\n.\\!k-scroll-mr-2 {\n    scroll-margin-right: 0.5rem !important;\n}\n\n.k-scroll-mr-2\\.5 {\n    scroll-margin-right: 0.625rem;\n}\n\n.\\!k-scroll-mr-2\\.5 {\n    scroll-margin-right: 0.625rem !important;\n}\n\n.k-scroll-mr-3 {\n    scroll-margin-right: 0.75rem;\n}\n\n.\\!k-scroll-mr-3 {\n    scroll-margin-right: 0.75rem !important;\n}\n\n.k-scroll-mr-3\\.5 {\n    scroll-margin-right: 0.875rem;\n}\n\n.\\!k-scroll-mr-3\\.5 {\n    scroll-margin-right: 0.875rem !important;\n}\n\n.k-scroll-mr-4 {\n    scroll-margin-right: 1rem;\n}\n\n.\\!k-scroll-mr-4 {\n    scroll-margin-right: 1rem !important;\n}\n\n.k-scroll-mr-4\\.5 {\n    scroll-margin-right: 1.125rem;\n}\n\n.\\!k-scroll-mr-4\\.5 {\n    scroll-margin-right: 1.125rem !important;\n}\n\n.k-scroll-mr-5 {\n    scroll-margin-right: 1.25rem;\n}\n\n.\\!k-scroll-mr-5 {\n    scroll-margin-right: 1.25rem !important;\n}\n\n.k-scroll-mr-5\\.5 {\n    scroll-margin-right: 1.375rem;\n}\n\n.\\!k-scroll-mr-5\\.5 {\n    scroll-margin-right: 1.375rem !important;\n}\n\n.k-scroll-mr-6 {\n    scroll-margin-right: 1.5rem;\n}\n\n.\\!k-scroll-mr-6 {\n    scroll-margin-right: 1.5rem !important;\n}\n\n.k-scroll-mr-6\\.5 {\n    scroll-margin-right: 1.625rem;\n}\n\n.\\!k-scroll-mr-6\\.5 {\n    scroll-margin-right: 1.625rem !important;\n}\n\n.k-scroll-mr-7 {\n    scroll-margin-right: 1.75rem;\n}\n\n.\\!k-scroll-mr-7 {\n    scroll-margin-right: 1.75rem !important;\n}\n\n.k-scroll-mr-7\\.5 {\n    scroll-margin-right: 1.875rem;\n}\n\n.\\!k-scroll-mr-7\\.5 {\n    scroll-margin-right: 1.875rem !important;\n}\n\n.k-scroll-mr-8 {\n    scroll-margin-right: 2rem;\n}\n\n.\\!k-scroll-mr-8 {\n    scroll-margin-right: 2rem !important;\n}\n\n.k-scroll-mr-9 {\n    scroll-margin-right: 2.25rem;\n}\n\n.\\!k-scroll-mr-9 {\n    scroll-margin-right: 2.25rem !important;\n}\n\n.k-scroll-mr-10 {\n    scroll-margin-right: 2.5rem;\n}\n\n.\\!k-scroll-mr-10 {\n    scroll-margin-right: 2.5rem !important;\n}\n\n.k-scroll-mr-11 {\n    scroll-margin-right: 2.75rem;\n}\n\n.\\!k-scroll-mr-11 {\n    scroll-margin-right: 2.75rem !important;\n}\n\n.k-scroll-mr-12 {\n    scroll-margin-right: 3rem;\n}\n\n.\\!k-scroll-mr-12 {\n    scroll-margin-right: 3rem !important;\n}\n\n.k-scroll-mr-13 {\n    scroll-margin-right: 3.25rem;\n}\n\n.\\!k-scroll-mr-13 {\n    scroll-margin-right: 3.25rem !important;\n}\n\n.k-scroll-mr-14 {\n    scroll-margin-right: 3.5rem;\n}\n\n.\\!k-scroll-mr-14 {\n    scroll-margin-right: 3.5rem !important;\n}\n\n.k-scroll-mr-15 {\n    scroll-margin-right: 3.75rem;\n}\n\n.\\!k-scroll-mr-15 {\n    scroll-margin-right: 3.75rem !important;\n}\n\n.k-scroll-mr-16 {\n    scroll-margin-right: 4rem;\n}\n\n.\\!k-scroll-mr-16 {\n    scroll-margin-right: 4rem !important;\n}\n\n.k-scroll-mr-17 {\n    scroll-margin-right: 4.25rem;\n}\n\n.\\!k-scroll-mr-17 {\n    scroll-margin-right: 4.25rem !important;\n}\n\n.k-scroll-mr-18 {\n    scroll-margin-right: 4.5rem;\n}\n\n.\\!k-scroll-mr-18 {\n    scroll-margin-right: 4.5rem !important;\n}\n\n.k-scroll-mr-19 {\n    scroll-margin-right: 4.75rem;\n}\n\n.\\!k-scroll-mr-19 {\n    scroll-margin-right: 4.75rem !important;\n}\n\n.k-scroll-mr-20 {\n    scroll-margin-right: 5rem;\n}\n\n.\\!k-scroll-mr-20 {\n    scroll-margin-right: 5rem !important;\n}\n\n.k-scroll-mr-21 {\n    scroll-margin-right: 5.25rem;\n}\n\n.\\!k-scroll-mr-21 {\n    scroll-margin-right: 5.25rem !important;\n}\n\n.k-scroll-mr-22 {\n    scroll-margin-right: 5.5rem;\n}\n\n.\\!k-scroll-mr-22 {\n    scroll-margin-right: 5.5rem !important;\n}\n\n.k-scroll-mr-23 {\n    scroll-margin-right: 5.75rem;\n}\n\n.\\!k-scroll-mr-23 {\n    scroll-margin-right: 5.75rem !important;\n}\n\n.k-scroll-mr-24 {\n    scroll-margin-right: 6rem;\n}\n\n.\\!k-scroll-mr-24 {\n    scroll-margin-right: 6rem !important;\n}\n\n.k-scroll-mb-0 {\n    scroll-margin-bottom: 0;\n}\n\n.\\!k-scroll-mb-0 {\n    scroll-margin-bottom: 0 !important;\n}\n\n.k-scroll-mb-1px {\n    scroll-margin-bottom: 1px;\n}\n\n.\\!k-scroll-mb-1px {\n    scroll-margin-bottom: 1px !important;\n}\n\n.k-scroll-mb-0\\.5 {\n    scroll-margin-bottom: 0.125rem;\n}\n\n.\\!k-scroll-mb-0\\.5 {\n    scroll-margin-bottom: 0.125rem !important;\n}\n\n.k-scroll-mb-1 {\n    scroll-margin-bottom: 0.25rem;\n}\n\n.\\!k-scroll-mb-1 {\n    scroll-margin-bottom: 0.25rem !important;\n}\n\n.k-scroll-mb-1\\.5 {\n    scroll-margin-bottom: 0.375rem;\n}\n\n.\\!k-scroll-mb-1\\.5 {\n    scroll-margin-bottom: 0.375rem !important;\n}\n\n.k-scroll-mb-2 {\n    scroll-margin-bottom: 0.5rem;\n}\n\n.\\!k-scroll-mb-2 {\n    scroll-margin-bottom: 0.5rem !important;\n}\n\n.k-scroll-mb-2\\.5 {\n    scroll-margin-bottom: 0.625rem;\n}\n\n.\\!k-scroll-mb-2\\.5 {\n    scroll-margin-bottom: 0.625rem !important;\n}\n\n.k-scroll-mb-3 {\n    scroll-margin-bottom: 0.75rem;\n}\n\n.\\!k-scroll-mb-3 {\n    scroll-margin-bottom: 0.75rem !important;\n}\n\n.k-scroll-mb-3\\.5 {\n    scroll-margin-bottom: 0.875rem;\n}\n\n.\\!k-scroll-mb-3\\.5 {\n    scroll-margin-bottom: 0.875rem !important;\n}\n\n.k-scroll-mb-4 {\n    scroll-margin-bottom: 1rem;\n}\n\n.\\!k-scroll-mb-4 {\n    scroll-margin-bottom: 1rem !important;\n}\n\n.k-scroll-mb-4\\.5 {\n    scroll-margin-bottom: 1.125rem;\n}\n\n.\\!k-scroll-mb-4\\.5 {\n    scroll-margin-bottom: 1.125rem !important;\n}\n\n.k-scroll-mb-5 {\n    scroll-margin-bottom: 1.25rem;\n}\n\n.\\!k-scroll-mb-5 {\n    scroll-margin-bottom: 1.25rem !important;\n}\n\n.k-scroll-mb-5\\.5 {\n    scroll-margin-bottom: 1.375rem;\n}\n\n.\\!k-scroll-mb-5\\.5 {\n    scroll-margin-bottom: 1.375rem !important;\n}\n\n.k-scroll-mb-6 {\n    scroll-margin-bottom: 1.5rem;\n}\n\n.\\!k-scroll-mb-6 {\n    scroll-margin-bottom: 1.5rem !important;\n}\n\n.k-scroll-mb-6\\.5 {\n    scroll-margin-bottom: 1.625rem;\n}\n\n.\\!k-scroll-mb-6\\.5 {\n    scroll-margin-bottom: 1.625rem !important;\n}\n\n.k-scroll-mb-7 {\n    scroll-margin-bottom: 1.75rem;\n}\n\n.\\!k-scroll-mb-7 {\n    scroll-margin-bottom: 1.75rem !important;\n}\n\n.k-scroll-mb-7\\.5 {\n    scroll-margin-bottom: 1.875rem;\n}\n\n.\\!k-scroll-mb-7\\.5 {\n    scroll-margin-bottom: 1.875rem !important;\n}\n\n.k-scroll-mb-8 {\n    scroll-margin-bottom: 2rem;\n}\n\n.\\!k-scroll-mb-8 {\n    scroll-margin-bottom: 2rem !important;\n}\n\n.k-scroll-mb-9 {\n    scroll-margin-bottom: 2.25rem;\n}\n\n.\\!k-scroll-mb-9 {\n    scroll-margin-bottom: 2.25rem !important;\n}\n\n.k-scroll-mb-10 {\n    scroll-margin-bottom: 2.5rem;\n}\n\n.\\!k-scroll-mb-10 {\n    scroll-margin-bottom: 2.5rem !important;\n}\n\n.k-scroll-mb-11 {\n    scroll-margin-bottom: 2.75rem;\n}\n\n.\\!k-scroll-mb-11 {\n    scroll-margin-bottom: 2.75rem !important;\n}\n\n.k-scroll-mb-12 {\n    scroll-margin-bottom: 3rem;\n}\n\n.\\!k-scroll-mb-12 {\n    scroll-margin-bottom: 3rem !important;\n}\n\n.k-scroll-mb-13 {\n    scroll-margin-bottom: 3.25rem;\n}\n\n.\\!k-scroll-mb-13 {\n    scroll-margin-bottom: 3.25rem !important;\n}\n\n.k-scroll-mb-14 {\n    scroll-margin-bottom: 3.5rem;\n}\n\n.\\!k-scroll-mb-14 {\n    scroll-margin-bottom: 3.5rem !important;\n}\n\n.k-scroll-mb-15 {\n    scroll-margin-bottom: 3.75rem;\n}\n\n.\\!k-scroll-mb-15 {\n    scroll-margin-bottom: 3.75rem !important;\n}\n\n.k-scroll-mb-16 {\n    scroll-margin-bottom: 4rem;\n}\n\n.\\!k-scroll-mb-16 {\n    scroll-margin-bottom: 4rem !important;\n}\n\n.k-scroll-mb-17 {\n    scroll-margin-bottom: 4.25rem;\n}\n\n.\\!k-scroll-mb-17 {\n    scroll-margin-bottom: 4.25rem !important;\n}\n\n.k-scroll-mb-18 {\n    scroll-margin-bottom: 4.5rem;\n}\n\n.\\!k-scroll-mb-18 {\n    scroll-margin-bottom: 4.5rem !important;\n}\n\n.k-scroll-mb-19 {\n    scroll-margin-bottom: 4.75rem;\n}\n\n.\\!k-scroll-mb-19 {\n    scroll-margin-bottom: 4.75rem !important;\n}\n\n.k-scroll-mb-20 {\n    scroll-margin-bottom: 5rem;\n}\n\n.\\!k-scroll-mb-20 {\n    scroll-margin-bottom: 5rem !important;\n}\n\n.k-scroll-mb-21 {\n    scroll-margin-bottom: 5.25rem;\n}\n\n.\\!k-scroll-mb-21 {\n    scroll-margin-bottom: 5.25rem !important;\n}\n\n.k-scroll-mb-22 {\n    scroll-margin-bottom: 5.5rem;\n}\n\n.\\!k-scroll-mb-22 {\n    scroll-margin-bottom: 5.5rem !important;\n}\n\n.k-scroll-mb-23 {\n    scroll-margin-bottom: 5.75rem;\n}\n\n.\\!k-scroll-mb-23 {\n    scroll-margin-bottom: 5.75rem !important;\n}\n\n.k-scroll-mb-24 {\n    scroll-margin-bottom: 6rem;\n}\n\n.\\!k-scroll-mb-24 {\n    scroll-margin-bottom: 6rem !important;\n}\n\n.k-scroll-ml-0 {\n    scroll-margin-left: 0;\n}\n\n.\\!k-scroll-ml-0 {\n    scroll-margin-left: 0 !important;\n}\n\n.k-scroll-ml-1px {\n    scroll-margin-left: 1px;\n}\n\n.\\!k-scroll-ml-1px {\n    scroll-margin-left: 1px !important;\n}\n\n.k-scroll-ml-0\\.5 {\n    scroll-margin-left: 0.125rem;\n}\n\n.\\!k-scroll-ml-0\\.5 {\n    scroll-margin-left: 0.125rem !important;\n}\n\n.k-scroll-ml-1 {\n    scroll-margin-left: 0.25rem;\n}\n\n.\\!k-scroll-ml-1 {\n    scroll-margin-left: 0.25rem !important;\n}\n\n.k-scroll-ml-1\\.5 {\n    scroll-margin-left: 0.375rem;\n}\n\n.\\!k-scroll-ml-1\\.5 {\n    scroll-margin-left: 0.375rem !important;\n}\n\n.k-scroll-ml-2 {\n    scroll-margin-left: 0.5rem;\n}\n\n.\\!k-scroll-ml-2 {\n    scroll-margin-left: 0.5rem !important;\n}\n\n.k-scroll-ml-2\\.5 {\n    scroll-margin-left: 0.625rem;\n}\n\n.\\!k-scroll-ml-2\\.5 {\n    scroll-margin-left: 0.625rem !important;\n}\n\n.k-scroll-ml-3 {\n    scroll-margin-left: 0.75rem;\n}\n\n.\\!k-scroll-ml-3 {\n    scroll-margin-left: 0.75rem !important;\n}\n\n.k-scroll-ml-3\\.5 {\n    scroll-margin-left: 0.875rem;\n}\n\n.\\!k-scroll-ml-3\\.5 {\n    scroll-margin-left: 0.875rem !important;\n}\n\n.k-scroll-ml-4 {\n    scroll-margin-left: 1rem;\n}\n\n.\\!k-scroll-ml-4 {\n    scroll-margin-left: 1rem !important;\n}\n\n.k-scroll-ml-4\\.5 {\n    scroll-margin-left: 1.125rem;\n}\n\n.\\!k-scroll-ml-4\\.5 {\n    scroll-margin-left: 1.125rem !important;\n}\n\n.k-scroll-ml-5 {\n    scroll-margin-left: 1.25rem;\n}\n\n.\\!k-scroll-ml-5 {\n    scroll-margin-left: 1.25rem !important;\n}\n\n.k-scroll-ml-5\\.5 {\n    scroll-margin-left: 1.375rem;\n}\n\n.\\!k-scroll-ml-5\\.5 {\n    scroll-margin-left: 1.375rem !important;\n}\n\n.k-scroll-ml-6 {\n    scroll-margin-left: 1.5rem;\n}\n\n.\\!k-scroll-ml-6 {\n    scroll-margin-left: 1.5rem !important;\n}\n\n.k-scroll-ml-6\\.5 {\n    scroll-margin-left: 1.625rem;\n}\n\n.\\!k-scroll-ml-6\\.5 {\n    scroll-margin-left: 1.625rem !important;\n}\n\n.k-scroll-ml-7 {\n    scroll-margin-left: 1.75rem;\n}\n\n.\\!k-scroll-ml-7 {\n    scroll-margin-left: 1.75rem !important;\n}\n\n.k-scroll-ml-7\\.5 {\n    scroll-margin-left: 1.875rem;\n}\n\n.\\!k-scroll-ml-7\\.5 {\n    scroll-margin-left: 1.875rem !important;\n}\n\n.k-scroll-ml-8 {\n    scroll-margin-left: 2rem;\n}\n\n.\\!k-scroll-ml-8 {\n    scroll-margin-left: 2rem !important;\n}\n\n.k-scroll-ml-9 {\n    scroll-margin-left: 2.25rem;\n}\n\n.\\!k-scroll-ml-9 {\n    scroll-margin-left: 2.25rem !important;\n}\n\n.k-scroll-ml-10 {\n    scroll-margin-left: 2.5rem;\n}\n\n.\\!k-scroll-ml-10 {\n    scroll-margin-left: 2.5rem !important;\n}\n\n.k-scroll-ml-11 {\n    scroll-margin-left: 2.75rem;\n}\n\n.\\!k-scroll-ml-11 {\n    scroll-margin-left: 2.75rem !important;\n}\n\n.k-scroll-ml-12 {\n    scroll-margin-left: 3rem;\n}\n\n.\\!k-scroll-ml-12 {\n    scroll-margin-left: 3rem !important;\n}\n\n.k-scroll-ml-13 {\n    scroll-margin-left: 3.25rem;\n}\n\n.\\!k-scroll-ml-13 {\n    scroll-margin-left: 3.25rem !important;\n}\n\n.k-scroll-ml-14 {\n    scroll-margin-left: 3.5rem;\n}\n\n.\\!k-scroll-ml-14 {\n    scroll-margin-left: 3.5rem !important;\n}\n\n.k-scroll-ml-15 {\n    scroll-margin-left: 3.75rem;\n}\n\n.\\!k-scroll-ml-15 {\n    scroll-margin-left: 3.75rem !important;\n}\n\n.k-scroll-ml-16 {\n    scroll-margin-left: 4rem;\n}\n\n.\\!k-scroll-ml-16 {\n    scroll-margin-left: 4rem !important;\n}\n\n.k-scroll-ml-17 {\n    scroll-margin-left: 4.25rem;\n}\n\n.\\!k-scroll-ml-17 {\n    scroll-margin-left: 4.25rem !important;\n}\n\n.k-scroll-ml-18 {\n    scroll-margin-left: 4.5rem;\n}\n\n.\\!k-scroll-ml-18 {\n    scroll-margin-left: 4.5rem !important;\n}\n\n.k-scroll-ml-19 {\n    scroll-margin-left: 4.75rem;\n}\n\n.\\!k-scroll-ml-19 {\n    scroll-margin-left: 4.75rem !important;\n}\n\n.k-scroll-ml-20 {\n    scroll-margin-left: 5rem;\n}\n\n.\\!k-scroll-ml-20 {\n    scroll-margin-left: 5rem !important;\n}\n\n.k-scroll-ml-21 {\n    scroll-margin-left: 5.25rem;\n}\n\n.\\!k-scroll-ml-21 {\n    scroll-margin-left: 5.25rem !important;\n}\n\n.k-scroll-ml-22 {\n    scroll-margin-left: 5.5rem;\n}\n\n.\\!k-scroll-ml-22 {\n    scroll-margin-left: 5.5rem !important;\n}\n\n.k-scroll-ml-23 {\n    scroll-margin-left: 5.75rem;\n}\n\n.\\!k-scroll-ml-23 {\n    scroll-margin-left: 5.75rem !important;\n}\n\n.k-scroll-ml-24 {\n    scroll-margin-left: 6rem;\n}\n\n.\\!k-scroll-ml-24 {\n    scroll-margin-left: 6rem !important;\n}\n\n.k-scroll-mx-0 {\n    scroll-margin-inline: 0;\n}\n\n.\\!k-scroll-mx-0 {\n    scroll-margin-inline: 0 !important;\n}\n\n.k-scroll-mx-1px {\n    scroll-margin-inline: 1px;\n}\n\n.\\!k-scroll-mx-1px {\n    scroll-margin-inline: 1px !important;\n}\n\n.k-scroll-mx-0\\.5 {\n    scroll-margin-inline: 0.125rem;\n}\n\n.\\!k-scroll-mx-0\\.5 {\n    scroll-margin-inline: 0.125rem !important;\n}\n\n.k-scroll-mx-1 {\n    scroll-margin-inline: 0.25rem;\n}\n\n.\\!k-scroll-mx-1 {\n    scroll-margin-inline: 0.25rem !important;\n}\n\n.k-scroll-mx-1\\.5 {\n    scroll-margin-inline: 0.375rem;\n}\n\n.\\!k-scroll-mx-1\\.5 {\n    scroll-margin-inline: 0.375rem !important;\n}\n\n.k-scroll-mx-2 {\n    scroll-margin-inline: 0.5rem;\n}\n\n.\\!k-scroll-mx-2 {\n    scroll-margin-inline: 0.5rem !important;\n}\n\n.k-scroll-mx-2\\.5 {\n    scroll-margin-inline: 0.625rem;\n}\n\n.\\!k-scroll-mx-2\\.5 {\n    scroll-margin-inline: 0.625rem !important;\n}\n\n.k-scroll-mx-3 {\n    scroll-margin-inline: 0.75rem;\n}\n\n.\\!k-scroll-mx-3 {\n    scroll-margin-inline: 0.75rem !important;\n}\n\n.k-scroll-mx-3\\.5 {\n    scroll-margin-inline: 0.875rem;\n}\n\n.\\!k-scroll-mx-3\\.5 {\n    scroll-margin-inline: 0.875rem !important;\n}\n\n.k-scroll-mx-4 {\n    scroll-margin-inline: 1rem;\n}\n\n.\\!k-scroll-mx-4 {\n    scroll-margin-inline: 1rem !important;\n}\n\n.k-scroll-mx-4\\.5 {\n    scroll-margin-inline: 1.125rem;\n}\n\n.\\!k-scroll-mx-4\\.5 {\n    scroll-margin-inline: 1.125rem !important;\n}\n\n.k-scroll-mx-5 {\n    scroll-margin-inline: 1.25rem;\n}\n\n.\\!k-scroll-mx-5 {\n    scroll-margin-inline: 1.25rem !important;\n}\n\n.k-scroll-mx-5\\.5 {\n    scroll-margin-inline: 1.375rem;\n}\n\n.\\!k-scroll-mx-5\\.5 {\n    scroll-margin-inline: 1.375rem !important;\n}\n\n.k-scroll-mx-6 {\n    scroll-margin-inline: 1.5rem;\n}\n\n.\\!k-scroll-mx-6 {\n    scroll-margin-inline: 1.5rem !important;\n}\n\n.k-scroll-mx-6\\.5 {\n    scroll-margin-inline: 1.625rem;\n}\n\n.\\!k-scroll-mx-6\\.5 {\n    scroll-margin-inline: 1.625rem !important;\n}\n\n.k-scroll-mx-7 {\n    scroll-margin-inline: 1.75rem;\n}\n\n.\\!k-scroll-mx-7 {\n    scroll-margin-inline: 1.75rem !important;\n}\n\n.k-scroll-mx-7\\.5 {\n    scroll-margin-inline: 1.875rem;\n}\n\n.\\!k-scroll-mx-7\\.5 {\n    scroll-margin-inline: 1.875rem !important;\n}\n\n.k-scroll-mx-8 {\n    scroll-margin-inline: 2rem;\n}\n\n.\\!k-scroll-mx-8 {\n    scroll-margin-inline: 2rem !important;\n}\n\n.k-scroll-mx-9 {\n    scroll-margin-inline: 2.25rem;\n}\n\n.\\!k-scroll-mx-9 {\n    scroll-margin-inline: 2.25rem !important;\n}\n\n.k-scroll-mx-10 {\n    scroll-margin-inline: 2.5rem;\n}\n\n.\\!k-scroll-mx-10 {\n    scroll-margin-inline: 2.5rem !important;\n}\n\n.k-scroll-mx-11 {\n    scroll-margin-inline: 2.75rem;\n}\n\n.\\!k-scroll-mx-11 {\n    scroll-margin-inline: 2.75rem !important;\n}\n\n.k-scroll-mx-12 {\n    scroll-margin-inline: 3rem;\n}\n\n.\\!k-scroll-mx-12 {\n    scroll-margin-inline: 3rem !important;\n}\n\n.k-scroll-mx-13 {\n    scroll-margin-inline: 3.25rem;\n}\n\n.\\!k-scroll-mx-13 {\n    scroll-margin-inline: 3.25rem !important;\n}\n\n.k-scroll-mx-14 {\n    scroll-margin-inline: 3.5rem;\n}\n\n.\\!k-scroll-mx-14 {\n    scroll-margin-inline: 3.5rem !important;\n}\n\n.k-scroll-mx-15 {\n    scroll-margin-inline: 3.75rem;\n}\n\n.\\!k-scroll-mx-15 {\n    scroll-margin-inline: 3.75rem !important;\n}\n\n.k-scroll-mx-16 {\n    scroll-margin-inline: 4rem;\n}\n\n.\\!k-scroll-mx-16 {\n    scroll-margin-inline: 4rem !important;\n}\n\n.k-scroll-mx-17 {\n    scroll-margin-inline: 4.25rem;\n}\n\n.\\!k-scroll-mx-17 {\n    scroll-margin-inline: 4.25rem !important;\n}\n\n.k-scroll-mx-18 {\n    scroll-margin-inline: 4.5rem;\n}\n\n.\\!k-scroll-mx-18 {\n    scroll-margin-inline: 4.5rem !important;\n}\n\n.k-scroll-mx-19 {\n    scroll-margin-inline: 4.75rem;\n}\n\n.\\!k-scroll-mx-19 {\n    scroll-margin-inline: 4.75rem !important;\n}\n\n.k-scroll-mx-20 {\n    scroll-margin-inline: 5rem;\n}\n\n.\\!k-scroll-mx-20 {\n    scroll-margin-inline: 5rem !important;\n}\n\n.k-scroll-mx-21 {\n    scroll-margin-inline: 5.25rem;\n}\n\n.\\!k-scroll-mx-21 {\n    scroll-margin-inline: 5.25rem !important;\n}\n\n.k-scroll-mx-22 {\n    scroll-margin-inline: 5.5rem;\n}\n\n.\\!k-scroll-mx-22 {\n    scroll-margin-inline: 5.5rem !important;\n}\n\n.k-scroll-mx-23 {\n    scroll-margin-inline: 5.75rem;\n}\n\n.\\!k-scroll-mx-23 {\n    scroll-margin-inline: 5.75rem !important;\n}\n\n.k-scroll-mx-24 {\n    scroll-margin-inline: 6rem;\n}\n\n.\\!k-scroll-mx-24 {\n    scroll-margin-inline: 6rem !important;\n}\n\n.k-scroll-my-0 {\n    scroll-margin-block: 0;\n}\n\n.\\!k-scroll-my-0 {\n    scroll-margin-block: 0 !important;\n}\n\n.k-scroll-my-1px {\n    scroll-margin-block: 1px;\n}\n\n.\\!k-scroll-my-1px {\n    scroll-margin-block: 1px !important;\n}\n\n.k-scroll-my-0\\.5 {\n    scroll-margin-block: 0.125rem;\n}\n\n.\\!k-scroll-my-0\\.5 {\n    scroll-margin-block: 0.125rem !important;\n}\n\n.k-scroll-my-1 {\n    scroll-margin-block: 0.25rem;\n}\n\n.\\!k-scroll-my-1 {\n    scroll-margin-block: 0.25rem !important;\n}\n\n.k-scroll-my-1\\.5 {\n    scroll-margin-block: 0.375rem;\n}\n\n.\\!k-scroll-my-1\\.5 {\n    scroll-margin-block: 0.375rem !important;\n}\n\n.k-scroll-my-2 {\n    scroll-margin-block: 0.5rem;\n}\n\n.\\!k-scroll-my-2 {\n    scroll-margin-block: 0.5rem !important;\n}\n\n.k-scroll-my-2\\.5 {\n    scroll-margin-block: 0.625rem;\n}\n\n.\\!k-scroll-my-2\\.5 {\n    scroll-margin-block: 0.625rem !important;\n}\n\n.k-scroll-my-3 {\n    scroll-margin-block: 0.75rem;\n}\n\n.\\!k-scroll-my-3 {\n    scroll-margin-block: 0.75rem !important;\n}\n\n.k-scroll-my-3\\.5 {\n    scroll-margin-block: 0.875rem;\n}\n\n.\\!k-scroll-my-3\\.5 {\n    scroll-margin-block: 0.875rem !important;\n}\n\n.k-scroll-my-4 {\n    scroll-margin-block: 1rem;\n}\n\n.\\!k-scroll-my-4 {\n    scroll-margin-block: 1rem !important;\n}\n\n.k-scroll-my-4\\.5 {\n    scroll-margin-block: 1.125rem;\n}\n\n.\\!k-scroll-my-4\\.5 {\n    scroll-margin-block: 1.125rem !important;\n}\n\n.k-scroll-my-5 {\n    scroll-margin-block: 1.25rem;\n}\n\n.\\!k-scroll-my-5 {\n    scroll-margin-block: 1.25rem !important;\n}\n\n.k-scroll-my-5\\.5 {\n    scroll-margin-block: 1.375rem;\n}\n\n.\\!k-scroll-my-5\\.5 {\n    scroll-margin-block: 1.375rem !important;\n}\n\n.k-scroll-my-6 {\n    scroll-margin-block: 1.5rem;\n}\n\n.\\!k-scroll-my-6 {\n    scroll-margin-block: 1.5rem !important;\n}\n\n.k-scroll-my-6\\.5 {\n    scroll-margin-block: 1.625rem;\n}\n\n.\\!k-scroll-my-6\\.5 {\n    scroll-margin-block: 1.625rem !important;\n}\n\n.k-scroll-my-7 {\n    scroll-margin-block: 1.75rem;\n}\n\n.\\!k-scroll-my-7 {\n    scroll-margin-block: 1.75rem !important;\n}\n\n.k-scroll-my-7\\.5 {\n    scroll-margin-block: 1.875rem;\n}\n\n.\\!k-scroll-my-7\\.5 {\n    scroll-margin-block: 1.875rem !important;\n}\n\n.k-scroll-my-8 {\n    scroll-margin-block: 2rem;\n}\n\n.\\!k-scroll-my-8 {\n    scroll-margin-block: 2rem !important;\n}\n\n.k-scroll-my-9 {\n    scroll-margin-block: 2.25rem;\n}\n\n.\\!k-scroll-my-9 {\n    scroll-margin-block: 2.25rem !important;\n}\n\n.k-scroll-my-10 {\n    scroll-margin-block: 2.5rem;\n}\n\n.\\!k-scroll-my-10 {\n    scroll-margin-block: 2.5rem !important;\n}\n\n.k-scroll-my-11 {\n    scroll-margin-block: 2.75rem;\n}\n\n.\\!k-scroll-my-11 {\n    scroll-margin-block: 2.75rem !important;\n}\n\n.k-scroll-my-12 {\n    scroll-margin-block: 3rem;\n}\n\n.\\!k-scroll-my-12 {\n    scroll-margin-block: 3rem !important;\n}\n\n.k-scroll-my-13 {\n    scroll-margin-block: 3.25rem;\n}\n\n.\\!k-scroll-my-13 {\n    scroll-margin-block: 3.25rem !important;\n}\n\n.k-scroll-my-14 {\n    scroll-margin-block: 3.5rem;\n}\n\n.\\!k-scroll-my-14 {\n    scroll-margin-block: 3.5rem !important;\n}\n\n.k-scroll-my-15 {\n    scroll-margin-block: 3.75rem;\n}\n\n.\\!k-scroll-my-15 {\n    scroll-margin-block: 3.75rem !important;\n}\n\n.k-scroll-my-16 {\n    scroll-margin-block: 4rem;\n}\n\n.\\!k-scroll-my-16 {\n    scroll-margin-block: 4rem !important;\n}\n\n.k-scroll-my-17 {\n    scroll-margin-block: 4.25rem;\n}\n\n.\\!k-scroll-my-17 {\n    scroll-margin-block: 4.25rem !important;\n}\n\n.k-scroll-my-18 {\n    scroll-margin-block: 4.5rem;\n}\n\n.\\!k-scroll-my-18 {\n    scroll-margin-block: 4.5rem !important;\n}\n\n.k-scroll-my-19 {\n    scroll-margin-block: 4.75rem;\n}\n\n.\\!k-scroll-my-19 {\n    scroll-margin-block: 4.75rem !important;\n}\n\n.k-scroll-my-20 {\n    scroll-margin-block: 5rem;\n}\n\n.\\!k-scroll-my-20 {\n    scroll-margin-block: 5rem !important;\n}\n\n.k-scroll-my-21 {\n    scroll-margin-block: 5.25rem;\n}\n\n.\\!k-scroll-my-21 {\n    scroll-margin-block: 5.25rem !important;\n}\n\n.k-scroll-my-22 {\n    scroll-margin-block: 5.5rem;\n}\n\n.\\!k-scroll-my-22 {\n    scroll-margin-block: 5.5rem !important;\n}\n\n.k-scroll-my-23 {\n    scroll-margin-block: 5.75rem;\n}\n\n.\\!k-scroll-my-23 {\n    scroll-margin-block: 5.75rem !important;\n}\n\n.k-scroll-my-24 {\n    scroll-margin-block: 6rem;\n}\n\n.\\!k-scroll-my-24 {\n    scroll-margin-block: 6rem !important;\n}\n\n.k-scroll-p-0 {\n    scroll-padding: 0;\n}\n\n.\\!k-scroll-p-0 {\n    scroll-padding: 0 !important;\n}\n\n.k-scroll-p-1px {\n    scroll-padding: 1px;\n}\n\n.\\!k-scroll-p-1px {\n    scroll-padding: 1px !important;\n}\n\n.k-scroll-p-0\\.5 {\n    scroll-padding: 0.125rem;\n}\n\n.\\!k-scroll-p-0\\.5 {\n    scroll-padding: 0.125rem !important;\n}\n\n.k-scroll-p-1 {\n    scroll-padding: 0.25rem;\n}\n\n.\\!k-scroll-p-1 {\n    scroll-padding: 0.25rem !important;\n}\n\n.k-scroll-p-1\\.5 {\n    scroll-padding: 0.375rem;\n}\n\n.\\!k-scroll-p-1\\.5 {\n    scroll-padding: 0.375rem !important;\n}\n\n.k-scroll-p-2 {\n    scroll-padding: 0.5rem;\n}\n\n.\\!k-scroll-p-2 {\n    scroll-padding: 0.5rem !important;\n}\n\n.k-scroll-p-2\\.5 {\n    scroll-padding: 0.625rem;\n}\n\n.\\!k-scroll-p-2\\.5 {\n    scroll-padding: 0.625rem !important;\n}\n\n.k-scroll-p-3 {\n    scroll-padding: 0.75rem;\n}\n\n.\\!k-scroll-p-3 {\n    scroll-padding: 0.75rem !important;\n}\n\n.k-scroll-p-3\\.5 {\n    scroll-padding: 0.875rem;\n}\n\n.\\!k-scroll-p-3\\.5 {\n    scroll-padding: 0.875rem !important;\n}\n\n.k-scroll-p-4 {\n    scroll-padding: 1rem;\n}\n\n.\\!k-scroll-p-4 {\n    scroll-padding: 1rem !important;\n}\n\n.k-scroll-p-4\\.5 {\n    scroll-padding: 1.125rem;\n}\n\n.\\!k-scroll-p-4\\.5 {\n    scroll-padding: 1.125rem !important;\n}\n\n.k-scroll-p-5 {\n    scroll-padding: 1.25rem;\n}\n\n.\\!k-scroll-p-5 {\n    scroll-padding: 1.25rem !important;\n}\n\n.k-scroll-p-5\\.5 {\n    scroll-padding: 1.375rem;\n}\n\n.\\!k-scroll-p-5\\.5 {\n    scroll-padding: 1.375rem !important;\n}\n\n.k-scroll-p-6 {\n    scroll-padding: 1.5rem;\n}\n\n.\\!k-scroll-p-6 {\n    scroll-padding: 1.5rem !important;\n}\n\n.k-scroll-p-6\\.5 {\n    scroll-padding: 1.625rem;\n}\n\n.\\!k-scroll-p-6\\.5 {\n    scroll-padding: 1.625rem !important;\n}\n\n.k-scroll-p-7 {\n    scroll-padding: 1.75rem;\n}\n\n.\\!k-scroll-p-7 {\n    scroll-padding: 1.75rem !important;\n}\n\n.k-scroll-p-7\\.5 {\n    scroll-padding: 1.875rem;\n}\n\n.\\!k-scroll-p-7\\.5 {\n    scroll-padding: 1.875rem !important;\n}\n\n.k-scroll-p-8 {\n    scroll-padding: 2rem;\n}\n\n.\\!k-scroll-p-8 {\n    scroll-padding: 2rem !important;\n}\n\n.k-scroll-p-9 {\n    scroll-padding: 2.25rem;\n}\n\n.\\!k-scroll-p-9 {\n    scroll-padding: 2.25rem !important;\n}\n\n.k-scroll-p-10 {\n    scroll-padding: 2.5rem;\n}\n\n.\\!k-scroll-p-10 {\n    scroll-padding: 2.5rem !important;\n}\n\n.k-scroll-p-11 {\n    scroll-padding: 2.75rem;\n}\n\n.\\!k-scroll-p-11 {\n    scroll-padding: 2.75rem !important;\n}\n\n.k-scroll-p-12 {\n    scroll-padding: 3rem;\n}\n\n.\\!k-scroll-p-12 {\n    scroll-padding: 3rem !important;\n}\n\n.k-scroll-p-13 {\n    scroll-padding: 3.25rem;\n}\n\n.\\!k-scroll-p-13 {\n    scroll-padding: 3.25rem !important;\n}\n\n.k-scroll-p-14 {\n    scroll-padding: 3.5rem;\n}\n\n.\\!k-scroll-p-14 {\n    scroll-padding: 3.5rem !important;\n}\n\n.k-scroll-p-15 {\n    scroll-padding: 3.75rem;\n}\n\n.\\!k-scroll-p-15 {\n    scroll-padding: 3.75rem !important;\n}\n\n.k-scroll-p-16 {\n    scroll-padding: 4rem;\n}\n\n.\\!k-scroll-p-16 {\n    scroll-padding: 4rem !important;\n}\n\n.k-scroll-p-17 {\n    scroll-padding: 4.25rem;\n}\n\n.\\!k-scroll-p-17 {\n    scroll-padding: 4.25rem !important;\n}\n\n.k-scroll-p-18 {\n    scroll-padding: 4.5rem;\n}\n\n.\\!k-scroll-p-18 {\n    scroll-padding: 4.5rem !important;\n}\n\n.k-scroll-p-19 {\n    scroll-padding: 4.75rem;\n}\n\n.\\!k-scroll-p-19 {\n    scroll-padding: 4.75rem !important;\n}\n\n.k-scroll-p-20 {\n    scroll-padding: 5rem;\n}\n\n.\\!k-scroll-p-20 {\n    scroll-padding: 5rem !important;\n}\n\n.k-scroll-p-21 {\n    scroll-padding: 5.25rem;\n}\n\n.\\!k-scroll-p-21 {\n    scroll-padding: 5.25rem !important;\n}\n\n.k-scroll-p-22 {\n    scroll-padding: 5.5rem;\n}\n\n.\\!k-scroll-p-22 {\n    scroll-padding: 5.5rem !important;\n}\n\n.k-scroll-p-23 {\n    scroll-padding: 5.75rem;\n}\n\n.\\!k-scroll-p-23 {\n    scroll-padding: 5.75rem !important;\n}\n\n.k-scroll-p-24 {\n    scroll-padding: 6rem;\n}\n\n.\\!k-scroll-p-24 {\n    scroll-padding: 6rem !important;\n}\n\n.k-scroll-pt-0 {\n    scroll-padding-top: 0;\n}\n\n.\\!k-scroll-pt-0 {\n    scroll-padding-top: 0 !important;\n}\n\n.k-scroll-pt-1px {\n    scroll-padding-top: 1px;\n}\n\n.\\!k-scroll-pt-1px {\n    scroll-padding-top: 1px !important;\n}\n\n.k-scroll-pt-0\\.5 {\n    scroll-padding-top: 0.125rem;\n}\n\n.\\!k-scroll-pt-0\\.5 {\n    scroll-padding-top: 0.125rem !important;\n}\n\n.k-scroll-pt-1 {\n    scroll-padding-top: 0.25rem;\n}\n\n.\\!k-scroll-pt-1 {\n    scroll-padding-top: 0.25rem !important;\n}\n\n.k-scroll-pt-1\\.5 {\n    scroll-padding-top: 0.375rem;\n}\n\n.\\!k-scroll-pt-1\\.5 {\n    scroll-padding-top: 0.375rem !important;\n}\n\n.k-scroll-pt-2 {\n    scroll-padding-top: 0.5rem;\n}\n\n.\\!k-scroll-pt-2 {\n    scroll-padding-top: 0.5rem !important;\n}\n\n.k-scroll-pt-2\\.5 {\n    scroll-padding-top: 0.625rem;\n}\n\n.\\!k-scroll-pt-2\\.5 {\n    scroll-padding-top: 0.625rem !important;\n}\n\n.k-scroll-pt-3 {\n    scroll-padding-top: 0.75rem;\n}\n\n.\\!k-scroll-pt-3 {\n    scroll-padding-top: 0.75rem !important;\n}\n\n.k-scroll-pt-3\\.5 {\n    scroll-padding-top: 0.875rem;\n}\n\n.\\!k-scroll-pt-3\\.5 {\n    scroll-padding-top: 0.875rem !important;\n}\n\n.k-scroll-pt-4 {\n    scroll-padding-top: 1rem;\n}\n\n.\\!k-scroll-pt-4 {\n    scroll-padding-top: 1rem !important;\n}\n\n.k-scroll-pt-4\\.5 {\n    scroll-padding-top: 1.125rem;\n}\n\n.\\!k-scroll-pt-4\\.5 {\n    scroll-padding-top: 1.125rem !important;\n}\n\n.k-scroll-pt-5 {\n    scroll-padding-top: 1.25rem;\n}\n\n.\\!k-scroll-pt-5 {\n    scroll-padding-top: 1.25rem !important;\n}\n\n.k-scroll-pt-5\\.5 {\n    scroll-padding-top: 1.375rem;\n}\n\n.\\!k-scroll-pt-5\\.5 {\n    scroll-padding-top: 1.375rem !important;\n}\n\n.k-scroll-pt-6 {\n    scroll-padding-top: 1.5rem;\n}\n\n.\\!k-scroll-pt-6 {\n    scroll-padding-top: 1.5rem !important;\n}\n\n.k-scroll-pt-6\\.5 {\n    scroll-padding-top: 1.625rem;\n}\n\n.\\!k-scroll-pt-6\\.5 {\n    scroll-padding-top: 1.625rem !important;\n}\n\n.k-scroll-pt-7 {\n    scroll-padding-top: 1.75rem;\n}\n\n.\\!k-scroll-pt-7 {\n    scroll-padding-top: 1.75rem !important;\n}\n\n.k-scroll-pt-7\\.5 {\n    scroll-padding-top: 1.875rem;\n}\n\n.\\!k-scroll-pt-7\\.5 {\n    scroll-padding-top: 1.875rem !important;\n}\n\n.k-scroll-pt-8 {\n    scroll-padding-top: 2rem;\n}\n\n.\\!k-scroll-pt-8 {\n    scroll-padding-top: 2rem !important;\n}\n\n.k-scroll-pt-9 {\n    scroll-padding-top: 2.25rem;\n}\n\n.\\!k-scroll-pt-9 {\n    scroll-padding-top: 2.25rem !important;\n}\n\n.k-scroll-pt-10 {\n    scroll-padding-top: 2.5rem;\n}\n\n.\\!k-scroll-pt-10 {\n    scroll-padding-top: 2.5rem !important;\n}\n\n.k-scroll-pt-11 {\n    scroll-padding-top: 2.75rem;\n}\n\n.\\!k-scroll-pt-11 {\n    scroll-padding-top: 2.75rem !important;\n}\n\n.k-scroll-pt-12 {\n    scroll-padding-top: 3rem;\n}\n\n.\\!k-scroll-pt-12 {\n    scroll-padding-top: 3rem !important;\n}\n\n.k-scroll-pt-13 {\n    scroll-padding-top: 3.25rem;\n}\n\n.\\!k-scroll-pt-13 {\n    scroll-padding-top: 3.25rem !important;\n}\n\n.k-scroll-pt-14 {\n    scroll-padding-top: 3.5rem;\n}\n\n.\\!k-scroll-pt-14 {\n    scroll-padding-top: 3.5rem !important;\n}\n\n.k-scroll-pt-15 {\n    scroll-padding-top: 3.75rem;\n}\n\n.\\!k-scroll-pt-15 {\n    scroll-padding-top: 3.75rem !important;\n}\n\n.k-scroll-pt-16 {\n    scroll-padding-top: 4rem;\n}\n\n.\\!k-scroll-pt-16 {\n    scroll-padding-top: 4rem !important;\n}\n\n.k-scroll-pt-17 {\n    scroll-padding-top: 4.25rem;\n}\n\n.\\!k-scroll-pt-17 {\n    scroll-padding-top: 4.25rem !important;\n}\n\n.k-scroll-pt-18 {\n    scroll-padding-top: 4.5rem;\n}\n\n.\\!k-scroll-pt-18 {\n    scroll-padding-top: 4.5rem !important;\n}\n\n.k-scroll-pt-19 {\n    scroll-padding-top: 4.75rem;\n}\n\n.\\!k-scroll-pt-19 {\n    scroll-padding-top: 4.75rem !important;\n}\n\n.k-scroll-pt-20 {\n    scroll-padding-top: 5rem;\n}\n\n.\\!k-scroll-pt-20 {\n    scroll-padding-top: 5rem !important;\n}\n\n.k-scroll-pt-21 {\n    scroll-padding-top: 5.25rem;\n}\n\n.\\!k-scroll-pt-21 {\n    scroll-padding-top: 5.25rem !important;\n}\n\n.k-scroll-pt-22 {\n    scroll-padding-top: 5.5rem;\n}\n\n.\\!k-scroll-pt-22 {\n    scroll-padding-top: 5.5rem !important;\n}\n\n.k-scroll-pt-23 {\n    scroll-padding-top: 5.75rem;\n}\n\n.\\!k-scroll-pt-23 {\n    scroll-padding-top: 5.75rem !important;\n}\n\n.k-scroll-pt-24 {\n    scroll-padding-top: 6rem;\n}\n\n.\\!k-scroll-pt-24 {\n    scroll-padding-top: 6rem !important;\n}\n\n.k-scroll-pr-0 {\n    scroll-padding-right: 0;\n}\n\n.\\!k-scroll-pr-0 {\n    scroll-padding-right: 0 !important;\n}\n\n.k-scroll-pr-1px {\n    scroll-padding-right: 1px;\n}\n\n.\\!k-scroll-pr-1px {\n    scroll-padding-right: 1px !important;\n}\n\n.k-scroll-pr-0\\.5 {\n    scroll-padding-right: 0.125rem;\n}\n\n.\\!k-scroll-pr-0\\.5 {\n    scroll-padding-right: 0.125rem !important;\n}\n\n.k-scroll-pr-1 {\n    scroll-padding-right: 0.25rem;\n}\n\n.\\!k-scroll-pr-1 {\n    scroll-padding-right: 0.25rem !important;\n}\n\n.k-scroll-pr-1\\.5 {\n    scroll-padding-right: 0.375rem;\n}\n\n.\\!k-scroll-pr-1\\.5 {\n    scroll-padding-right: 0.375rem !important;\n}\n\n.k-scroll-pr-2 {\n    scroll-padding-right: 0.5rem;\n}\n\n.\\!k-scroll-pr-2 {\n    scroll-padding-right: 0.5rem !important;\n}\n\n.k-scroll-pr-2\\.5 {\n    scroll-padding-right: 0.625rem;\n}\n\n.\\!k-scroll-pr-2\\.5 {\n    scroll-padding-right: 0.625rem !important;\n}\n\n.k-scroll-pr-3 {\n    scroll-padding-right: 0.75rem;\n}\n\n.\\!k-scroll-pr-3 {\n    scroll-padding-right: 0.75rem !important;\n}\n\n.k-scroll-pr-3\\.5 {\n    scroll-padding-right: 0.875rem;\n}\n\n.\\!k-scroll-pr-3\\.5 {\n    scroll-padding-right: 0.875rem !important;\n}\n\n.k-scroll-pr-4 {\n    scroll-padding-right: 1rem;\n}\n\n.\\!k-scroll-pr-4 {\n    scroll-padding-right: 1rem !important;\n}\n\n.k-scroll-pr-4\\.5 {\n    scroll-padding-right: 1.125rem;\n}\n\n.\\!k-scroll-pr-4\\.5 {\n    scroll-padding-right: 1.125rem !important;\n}\n\n.k-scroll-pr-5 {\n    scroll-padding-right: 1.25rem;\n}\n\n.\\!k-scroll-pr-5 {\n    scroll-padding-right: 1.25rem !important;\n}\n\n.k-scroll-pr-5\\.5 {\n    scroll-padding-right: 1.375rem;\n}\n\n.\\!k-scroll-pr-5\\.5 {\n    scroll-padding-right: 1.375rem !important;\n}\n\n.k-scroll-pr-6 {\n    scroll-padding-right: 1.5rem;\n}\n\n.\\!k-scroll-pr-6 {\n    scroll-padding-right: 1.5rem !important;\n}\n\n.k-scroll-pr-6\\.5 {\n    scroll-padding-right: 1.625rem;\n}\n\n.\\!k-scroll-pr-6\\.5 {\n    scroll-padding-right: 1.625rem !important;\n}\n\n.k-scroll-pr-7 {\n    scroll-padding-right: 1.75rem;\n}\n\n.\\!k-scroll-pr-7 {\n    scroll-padding-right: 1.75rem !important;\n}\n\n.k-scroll-pr-7\\.5 {\n    scroll-padding-right: 1.875rem;\n}\n\n.\\!k-scroll-pr-7\\.5 {\n    scroll-padding-right: 1.875rem !important;\n}\n\n.k-scroll-pr-8 {\n    scroll-padding-right: 2rem;\n}\n\n.\\!k-scroll-pr-8 {\n    scroll-padding-right: 2rem !important;\n}\n\n.k-scroll-pr-9 {\n    scroll-padding-right: 2.25rem;\n}\n\n.\\!k-scroll-pr-9 {\n    scroll-padding-right: 2.25rem !important;\n}\n\n.k-scroll-pr-10 {\n    scroll-padding-right: 2.5rem;\n}\n\n.\\!k-scroll-pr-10 {\n    scroll-padding-right: 2.5rem !important;\n}\n\n.k-scroll-pr-11 {\n    scroll-padding-right: 2.75rem;\n}\n\n.\\!k-scroll-pr-11 {\n    scroll-padding-right: 2.75rem !important;\n}\n\n.k-scroll-pr-12 {\n    scroll-padding-right: 3rem;\n}\n\n.\\!k-scroll-pr-12 {\n    scroll-padding-right: 3rem !important;\n}\n\n.k-scroll-pr-13 {\n    scroll-padding-right: 3.25rem;\n}\n\n.\\!k-scroll-pr-13 {\n    scroll-padding-right: 3.25rem !important;\n}\n\n.k-scroll-pr-14 {\n    scroll-padding-right: 3.5rem;\n}\n\n.\\!k-scroll-pr-14 {\n    scroll-padding-right: 3.5rem !important;\n}\n\n.k-scroll-pr-15 {\n    scroll-padding-right: 3.75rem;\n}\n\n.\\!k-scroll-pr-15 {\n    scroll-padding-right: 3.75rem !important;\n}\n\n.k-scroll-pr-16 {\n    scroll-padding-right: 4rem;\n}\n\n.\\!k-scroll-pr-16 {\n    scroll-padding-right: 4rem !important;\n}\n\n.k-scroll-pr-17 {\n    scroll-padding-right: 4.25rem;\n}\n\n.\\!k-scroll-pr-17 {\n    scroll-padding-right: 4.25rem !important;\n}\n\n.k-scroll-pr-18 {\n    scroll-padding-right: 4.5rem;\n}\n\n.\\!k-scroll-pr-18 {\n    scroll-padding-right: 4.5rem !important;\n}\n\n.k-scroll-pr-19 {\n    scroll-padding-right: 4.75rem;\n}\n\n.\\!k-scroll-pr-19 {\n    scroll-padding-right: 4.75rem !important;\n}\n\n.k-scroll-pr-20 {\n    scroll-padding-right: 5rem;\n}\n\n.\\!k-scroll-pr-20 {\n    scroll-padding-right: 5rem !important;\n}\n\n.k-scroll-pr-21 {\n    scroll-padding-right: 5.25rem;\n}\n\n.\\!k-scroll-pr-21 {\n    scroll-padding-right: 5.25rem !important;\n}\n\n.k-scroll-pr-22 {\n    scroll-padding-right: 5.5rem;\n}\n\n.\\!k-scroll-pr-22 {\n    scroll-padding-right: 5.5rem !important;\n}\n\n.k-scroll-pr-23 {\n    scroll-padding-right: 5.75rem;\n}\n\n.\\!k-scroll-pr-23 {\n    scroll-padding-right: 5.75rem !important;\n}\n\n.k-scroll-pr-24 {\n    scroll-padding-right: 6rem;\n}\n\n.\\!k-scroll-pr-24 {\n    scroll-padding-right: 6rem !important;\n}\n\n.k-scroll-pb-0 {\n    scroll-padding-bottom: 0;\n}\n\n.\\!k-scroll-pb-0 {\n    scroll-padding-bottom: 0 !important;\n}\n\n.k-scroll-pb-1px {\n    scroll-padding-bottom: 1px;\n}\n\n.\\!k-scroll-pb-1px {\n    scroll-padding-bottom: 1px !important;\n}\n\n.k-scroll-pb-0\\.5 {\n    scroll-padding-bottom: 0.125rem;\n}\n\n.\\!k-scroll-pb-0\\.5 {\n    scroll-padding-bottom: 0.125rem !important;\n}\n\n.k-scroll-pb-1 {\n    scroll-padding-bottom: 0.25rem;\n}\n\n.\\!k-scroll-pb-1 {\n    scroll-padding-bottom: 0.25rem !important;\n}\n\n.k-scroll-pb-1\\.5 {\n    scroll-padding-bottom: 0.375rem;\n}\n\n.\\!k-scroll-pb-1\\.5 {\n    scroll-padding-bottom: 0.375rem !important;\n}\n\n.k-scroll-pb-2 {\n    scroll-padding-bottom: 0.5rem;\n}\n\n.\\!k-scroll-pb-2 {\n    scroll-padding-bottom: 0.5rem !important;\n}\n\n.k-scroll-pb-2\\.5 {\n    scroll-padding-bottom: 0.625rem;\n}\n\n.\\!k-scroll-pb-2\\.5 {\n    scroll-padding-bottom: 0.625rem !important;\n}\n\n.k-scroll-pb-3 {\n    scroll-padding-bottom: 0.75rem;\n}\n\n.\\!k-scroll-pb-3 {\n    scroll-padding-bottom: 0.75rem !important;\n}\n\n.k-scroll-pb-3\\.5 {\n    scroll-padding-bottom: 0.875rem;\n}\n\n.\\!k-scroll-pb-3\\.5 {\n    scroll-padding-bottom: 0.875rem !important;\n}\n\n.k-scroll-pb-4 {\n    scroll-padding-bottom: 1rem;\n}\n\n.\\!k-scroll-pb-4 {\n    scroll-padding-bottom: 1rem !important;\n}\n\n.k-scroll-pb-4\\.5 {\n    scroll-padding-bottom: 1.125rem;\n}\n\n.\\!k-scroll-pb-4\\.5 {\n    scroll-padding-bottom: 1.125rem !important;\n}\n\n.k-scroll-pb-5 {\n    scroll-padding-bottom: 1.25rem;\n}\n\n.\\!k-scroll-pb-5 {\n    scroll-padding-bottom: 1.25rem !important;\n}\n\n.k-scroll-pb-5\\.5 {\n    scroll-padding-bottom: 1.375rem;\n}\n\n.\\!k-scroll-pb-5\\.5 {\n    scroll-padding-bottom: 1.375rem !important;\n}\n\n.k-scroll-pb-6 {\n    scroll-padding-bottom: 1.5rem;\n}\n\n.\\!k-scroll-pb-6 {\n    scroll-padding-bottom: 1.5rem !important;\n}\n\n.k-scroll-pb-6\\.5 {\n    scroll-padding-bottom: 1.625rem;\n}\n\n.\\!k-scroll-pb-6\\.5 {\n    scroll-padding-bottom: 1.625rem !important;\n}\n\n.k-scroll-pb-7 {\n    scroll-padding-bottom: 1.75rem;\n}\n\n.\\!k-scroll-pb-7 {\n    scroll-padding-bottom: 1.75rem !important;\n}\n\n.k-scroll-pb-7\\.5 {\n    scroll-padding-bottom: 1.875rem;\n}\n\n.\\!k-scroll-pb-7\\.5 {\n    scroll-padding-bottom: 1.875rem !important;\n}\n\n.k-scroll-pb-8 {\n    scroll-padding-bottom: 2rem;\n}\n\n.\\!k-scroll-pb-8 {\n    scroll-padding-bottom: 2rem !important;\n}\n\n.k-scroll-pb-9 {\n    scroll-padding-bottom: 2.25rem;\n}\n\n.\\!k-scroll-pb-9 {\n    scroll-padding-bottom: 2.25rem !important;\n}\n\n.k-scroll-pb-10 {\n    scroll-padding-bottom: 2.5rem;\n}\n\n.\\!k-scroll-pb-10 {\n    scroll-padding-bottom: 2.5rem !important;\n}\n\n.k-scroll-pb-11 {\n    scroll-padding-bottom: 2.75rem;\n}\n\n.\\!k-scroll-pb-11 {\n    scroll-padding-bottom: 2.75rem !important;\n}\n\n.k-scroll-pb-12 {\n    scroll-padding-bottom: 3rem;\n}\n\n.\\!k-scroll-pb-12 {\n    scroll-padding-bottom: 3rem !important;\n}\n\n.k-scroll-pb-13 {\n    scroll-padding-bottom: 3.25rem;\n}\n\n.\\!k-scroll-pb-13 {\n    scroll-padding-bottom: 3.25rem !important;\n}\n\n.k-scroll-pb-14 {\n    scroll-padding-bottom: 3.5rem;\n}\n\n.\\!k-scroll-pb-14 {\n    scroll-padding-bottom: 3.5rem !important;\n}\n\n.k-scroll-pb-15 {\n    scroll-padding-bottom: 3.75rem;\n}\n\n.\\!k-scroll-pb-15 {\n    scroll-padding-bottom: 3.75rem !important;\n}\n\n.k-scroll-pb-16 {\n    scroll-padding-bottom: 4rem;\n}\n\n.\\!k-scroll-pb-16 {\n    scroll-padding-bottom: 4rem !important;\n}\n\n.k-scroll-pb-17 {\n    scroll-padding-bottom: 4.25rem;\n}\n\n.\\!k-scroll-pb-17 {\n    scroll-padding-bottom: 4.25rem !important;\n}\n\n.k-scroll-pb-18 {\n    scroll-padding-bottom: 4.5rem;\n}\n\n.\\!k-scroll-pb-18 {\n    scroll-padding-bottom: 4.5rem !important;\n}\n\n.k-scroll-pb-19 {\n    scroll-padding-bottom: 4.75rem;\n}\n\n.\\!k-scroll-pb-19 {\n    scroll-padding-bottom: 4.75rem !important;\n}\n\n.k-scroll-pb-20 {\n    scroll-padding-bottom: 5rem;\n}\n\n.\\!k-scroll-pb-20 {\n    scroll-padding-bottom: 5rem !important;\n}\n\n.k-scroll-pb-21 {\n    scroll-padding-bottom: 5.25rem;\n}\n\n.\\!k-scroll-pb-21 {\n    scroll-padding-bottom: 5.25rem !important;\n}\n\n.k-scroll-pb-22 {\n    scroll-padding-bottom: 5.5rem;\n}\n\n.\\!k-scroll-pb-22 {\n    scroll-padding-bottom: 5.5rem !important;\n}\n\n.k-scroll-pb-23 {\n    scroll-padding-bottom: 5.75rem;\n}\n\n.\\!k-scroll-pb-23 {\n    scroll-padding-bottom: 5.75rem !important;\n}\n\n.k-scroll-pb-24 {\n    scroll-padding-bottom: 6rem;\n}\n\n.\\!k-scroll-pb-24 {\n    scroll-padding-bottom: 6rem !important;\n}\n\n.k-scroll-pl-0 {\n    scroll-padding-left: 0;\n}\n\n.\\!k-scroll-pl-0 {\n    scroll-padding-left: 0 !important;\n}\n\n.k-scroll-pl-1px {\n    scroll-padding-left: 1px;\n}\n\n.\\!k-scroll-pl-1px {\n    scroll-padding-left: 1px !important;\n}\n\n.k-scroll-pl-0\\.5 {\n    scroll-padding-left: 0.125rem;\n}\n\n.\\!k-scroll-pl-0\\.5 {\n    scroll-padding-left: 0.125rem !important;\n}\n\n.k-scroll-pl-1 {\n    scroll-padding-left: 0.25rem;\n}\n\n.\\!k-scroll-pl-1 {\n    scroll-padding-left: 0.25rem !important;\n}\n\n.k-scroll-pl-1\\.5 {\n    scroll-padding-left: 0.375rem;\n}\n\n.\\!k-scroll-pl-1\\.5 {\n    scroll-padding-left: 0.375rem !important;\n}\n\n.k-scroll-pl-2 {\n    scroll-padding-left: 0.5rem;\n}\n\n.\\!k-scroll-pl-2 {\n    scroll-padding-left: 0.5rem !important;\n}\n\n.k-scroll-pl-2\\.5 {\n    scroll-padding-left: 0.625rem;\n}\n\n.\\!k-scroll-pl-2\\.5 {\n    scroll-padding-left: 0.625rem !important;\n}\n\n.k-scroll-pl-3 {\n    scroll-padding-left: 0.75rem;\n}\n\n.\\!k-scroll-pl-3 {\n    scroll-padding-left: 0.75rem !important;\n}\n\n.k-scroll-pl-3\\.5 {\n    scroll-padding-left: 0.875rem;\n}\n\n.\\!k-scroll-pl-3\\.5 {\n    scroll-padding-left: 0.875rem !important;\n}\n\n.k-scroll-pl-4 {\n    scroll-padding-left: 1rem;\n}\n\n.\\!k-scroll-pl-4 {\n    scroll-padding-left: 1rem !important;\n}\n\n.k-scroll-pl-4\\.5 {\n    scroll-padding-left: 1.125rem;\n}\n\n.\\!k-scroll-pl-4\\.5 {\n    scroll-padding-left: 1.125rem !important;\n}\n\n.k-scroll-pl-5 {\n    scroll-padding-left: 1.25rem;\n}\n\n.\\!k-scroll-pl-5 {\n    scroll-padding-left: 1.25rem !important;\n}\n\n.k-scroll-pl-5\\.5 {\n    scroll-padding-left: 1.375rem;\n}\n\n.\\!k-scroll-pl-5\\.5 {\n    scroll-padding-left: 1.375rem !important;\n}\n\n.k-scroll-pl-6 {\n    scroll-padding-left: 1.5rem;\n}\n\n.\\!k-scroll-pl-6 {\n    scroll-padding-left: 1.5rem !important;\n}\n\n.k-scroll-pl-6\\.5 {\n    scroll-padding-left: 1.625rem;\n}\n\n.\\!k-scroll-pl-6\\.5 {\n    scroll-padding-left: 1.625rem !important;\n}\n\n.k-scroll-pl-7 {\n    scroll-padding-left: 1.75rem;\n}\n\n.\\!k-scroll-pl-7 {\n    scroll-padding-left: 1.75rem !important;\n}\n\n.k-scroll-pl-7\\.5 {\n    scroll-padding-left: 1.875rem;\n}\n\n.\\!k-scroll-pl-7\\.5 {\n    scroll-padding-left: 1.875rem !important;\n}\n\n.k-scroll-pl-8 {\n    scroll-padding-left: 2rem;\n}\n\n.\\!k-scroll-pl-8 {\n    scroll-padding-left: 2rem !important;\n}\n\n.k-scroll-pl-9 {\n    scroll-padding-left: 2.25rem;\n}\n\n.\\!k-scroll-pl-9 {\n    scroll-padding-left: 2.25rem !important;\n}\n\n.k-scroll-pl-10 {\n    scroll-padding-left: 2.5rem;\n}\n\n.\\!k-scroll-pl-10 {\n    scroll-padding-left: 2.5rem !important;\n}\n\n.k-scroll-pl-11 {\n    scroll-padding-left: 2.75rem;\n}\n\n.\\!k-scroll-pl-11 {\n    scroll-padding-left: 2.75rem !important;\n}\n\n.k-scroll-pl-12 {\n    scroll-padding-left: 3rem;\n}\n\n.\\!k-scroll-pl-12 {\n    scroll-padding-left: 3rem !important;\n}\n\n.k-scroll-pl-13 {\n    scroll-padding-left: 3.25rem;\n}\n\n.\\!k-scroll-pl-13 {\n    scroll-padding-left: 3.25rem !important;\n}\n\n.k-scroll-pl-14 {\n    scroll-padding-left: 3.5rem;\n}\n\n.\\!k-scroll-pl-14 {\n    scroll-padding-left: 3.5rem !important;\n}\n\n.k-scroll-pl-15 {\n    scroll-padding-left: 3.75rem;\n}\n\n.\\!k-scroll-pl-15 {\n    scroll-padding-left: 3.75rem !important;\n}\n\n.k-scroll-pl-16 {\n    scroll-padding-left: 4rem;\n}\n\n.\\!k-scroll-pl-16 {\n    scroll-padding-left: 4rem !important;\n}\n\n.k-scroll-pl-17 {\n    scroll-padding-left: 4.25rem;\n}\n\n.\\!k-scroll-pl-17 {\n    scroll-padding-left: 4.25rem !important;\n}\n\n.k-scroll-pl-18 {\n    scroll-padding-left: 4.5rem;\n}\n\n.\\!k-scroll-pl-18 {\n    scroll-padding-left: 4.5rem !important;\n}\n\n.k-scroll-pl-19 {\n    scroll-padding-left: 4.75rem;\n}\n\n.\\!k-scroll-pl-19 {\n    scroll-padding-left: 4.75rem !important;\n}\n\n.k-scroll-pl-20 {\n    scroll-padding-left: 5rem;\n}\n\n.\\!k-scroll-pl-20 {\n    scroll-padding-left: 5rem !important;\n}\n\n.k-scroll-pl-21 {\n    scroll-padding-left: 5.25rem;\n}\n\n.\\!k-scroll-pl-21 {\n    scroll-padding-left: 5.25rem !important;\n}\n\n.k-scroll-pl-22 {\n    scroll-padding-left: 5.5rem;\n}\n\n.\\!k-scroll-pl-22 {\n    scroll-padding-left: 5.5rem !important;\n}\n\n.k-scroll-pl-23 {\n    scroll-padding-left: 5.75rem;\n}\n\n.\\!k-scroll-pl-23 {\n    scroll-padding-left: 5.75rem !important;\n}\n\n.k-scroll-pl-24 {\n    scroll-padding-left: 6rem;\n}\n\n.\\!k-scroll-pl-24 {\n    scroll-padding-left: 6rem !important;\n}\n\n.k-scroll-px-0 {\n    scroll-padding-inline: 0;\n}\n\n.\\!k-scroll-px-0 {\n    scroll-padding-inline: 0 !important;\n}\n\n.k-scroll-px-1px {\n    scroll-padding-inline: 1px;\n}\n\n.\\!k-scroll-px-1px {\n    scroll-padding-inline: 1px !important;\n}\n\n.k-scroll-px-0\\.5 {\n    scroll-padding-inline: 0.125rem;\n}\n\n.\\!k-scroll-px-0\\.5 {\n    scroll-padding-inline: 0.125rem !important;\n}\n\n.k-scroll-px-1 {\n    scroll-padding-inline: 0.25rem;\n}\n\n.\\!k-scroll-px-1 {\n    scroll-padding-inline: 0.25rem !important;\n}\n\n.k-scroll-px-1\\.5 {\n    scroll-padding-inline: 0.375rem;\n}\n\n.\\!k-scroll-px-1\\.5 {\n    scroll-padding-inline: 0.375rem !important;\n}\n\n.k-scroll-px-2 {\n    scroll-padding-inline: 0.5rem;\n}\n\n.\\!k-scroll-px-2 {\n    scroll-padding-inline: 0.5rem !important;\n}\n\n.k-scroll-px-2\\.5 {\n    scroll-padding-inline: 0.625rem;\n}\n\n.\\!k-scroll-px-2\\.5 {\n    scroll-padding-inline: 0.625rem !important;\n}\n\n.k-scroll-px-3 {\n    scroll-padding-inline: 0.75rem;\n}\n\n.\\!k-scroll-px-3 {\n    scroll-padding-inline: 0.75rem !important;\n}\n\n.k-scroll-px-3\\.5 {\n    scroll-padding-inline: 0.875rem;\n}\n\n.\\!k-scroll-px-3\\.5 {\n    scroll-padding-inline: 0.875rem !important;\n}\n\n.k-scroll-px-4 {\n    scroll-padding-inline: 1rem;\n}\n\n.\\!k-scroll-px-4 {\n    scroll-padding-inline: 1rem !important;\n}\n\n.k-scroll-px-4\\.5 {\n    scroll-padding-inline: 1.125rem;\n}\n\n.\\!k-scroll-px-4\\.5 {\n    scroll-padding-inline: 1.125rem !important;\n}\n\n.k-scroll-px-5 {\n    scroll-padding-inline: 1.25rem;\n}\n\n.\\!k-scroll-px-5 {\n    scroll-padding-inline: 1.25rem !important;\n}\n\n.k-scroll-px-5\\.5 {\n    scroll-padding-inline: 1.375rem;\n}\n\n.\\!k-scroll-px-5\\.5 {\n    scroll-padding-inline: 1.375rem !important;\n}\n\n.k-scroll-px-6 {\n    scroll-padding-inline: 1.5rem;\n}\n\n.\\!k-scroll-px-6 {\n    scroll-padding-inline: 1.5rem !important;\n}\n\n.k-scroll-px-6\\.5 {\n    scroll-padding-inline: 1.625rem;\n}\n\n.\\!k-scroll-px-6\\.5 {\n    scroll-padding-inline: 1.625rem !important;\n}\n\n.k-scroll-px-7 {\n    scroll-padding-inline: 1.75rem;\n}\n\n.\\!k-scroll-px-7 {\n    scroll-padding-inline: 1.75rem !important;\n}\n\n.k-scroll-px-7\\.5 {\n    scroll-padding-inline: 1.875rem;\n}\n\n.\\!k-scroll-px-7\\.5 {\n    scroll-padding-inline: 1.875rem !important;\n}\n\n.k-scroll-px-8 {\n    scroll-padding-inline: 2rem;\n}\n\n.\\!k-scroll-px-8 {\n    scroll-padding-inline: 2rem !important;\n}\n\n.k-scroll-px-9 {\n    scroll-padding-inline: 2.25rem;\n}\n\n.\\!k-scroll-px-9 {\n    scroll-padding-inline: 2.25rem !important;\n}\n\n.k-scroll-px-10 {\n    scroll-padding-inline: 2.5rem;\n}\n\n.\\!k-scroll-px-10 {\n    scroll-padding-inline: 2.5rem !important;\n}\n\n.k-scroll-px-11 {\n    scroll-padding-inline: 2.75rem;\n}\n\n.\\!k-scroll-px-11 {\n    scroll-padding-inline: 2.75rem !important;\n}\n\n.k-scroll-px-12 {\n    scroll-padding-inline: 3rem;\n}\n\n.\\!k-scroll-px-12 {\n    scroll-padding-inline: 3rem !important;\n}\n\n.k-scroll-px-13 {\n    scroll-padding-inline: 3.25rem;\n}\n\n.\\!k-scroll-px-13 {\n    scroll-padding-inline: 3.25rem !important;\n}\n\n.k-scroll-px-14 {\n    scroll-padding-inline: 3.5rem;\n}\n\n.\\!k-scroll-px-14 {\n    scroll-padding-inline: 3.5rem !important;\n}\n\n.k-scroll-px-15 {\n    scroll-padding-inline: 3.75rem;\n}\n\n.\\!k-scroll-px-15 {\n    scroll-padding-inline: 3.75rem !important;\n}\n\n.k-scroll-px-16 {\n    scroll-padding-inline: 4rem;\n}\n\n.\\!k-scroll-px-16 {\n    scroll-padding-inline: 4rem !important;\n}\n\n.k-scroll-px-17 {\n    scroll-padding-inline: 4.25rem;\n}\n\n.\\!k-scroll-px-17 {\n    scroll-padding-inline: 4.25rem !important;\n}\n\n.k-scroll-px-18 {\n    scroll-padding-inline: 4.5rem;\n}\n\n.\\!k-scroll-px-18 {\n    scroll-padding-inline: 4.5rem !important;\n}\n\n.k-scroll-px-19 {\n    scroll-padding-inline: 4.75rem;\n}\n\n.\\!k-scroll-px-19 {\n    scroll-padding-inline: 4.75rem !important;\n}\n\n.k-scroll-px-20 {\n    scroll-padding-inline: 5rem;\n}\n\n.\\!k-scroll-px-20 {\n    scroll-padding-inline: 5rem !important;\n}\n\n.k-scroll-px-21 {\n    scroll-padding-inline: 5.25rem;\n}\n\n.\\!k-scroll-px-21 {\n    scroll-padding-inline: 5.25rem !important;\n}\n\n.k-scroll-px-22 {\n    scroll-padding-inline: 5.5rem;\n}\n\n.\\!k-scroll-px-22 {\n    scroll-padding-inline: 5.5rem !important;\n}\n\n.k-scroll-px-23 {\n    scroll-padding-inline: 5.75rem;\n}\n\n.\\!k-scroll-px-23 {\n    scroll-padding-inline: 5.75rem !important;\n}\n\n.k-scroll-px-24 {\n    scroll-padding-inline: 6rem;\n}\n\n.\\!k-scroll-px-24 {\n    scroll-padding-inline: 6rem !important;\n}\n\n.k-scroll-py-0 {\n    scroll-padding-block: 0;\n}\n\n.\\!k-scroll-py-0 {\n    scroll-padding-block: 0 !important;\n}\n\n.k-scroll-py-1px {\n    scroll-padding-block: 1px;\n}\n\n.\\!k-scroll-py-1px {\n    scroll-padding-block: 1px !important;\n}\n\n.k-scroll-py-0\\.5 {\n    scroll-padding-block: 0.125rem;\n}\n\n.\\!k-scroll-py-0\\.5 {\n    scroll-padding-block: 0.125rem !important;\n}\n\n.k-scroll-py-1 {\n    scroll-padding-block: 0.25rem;\n}\n\n.\\!k-scroll-py-1 {\n    scroll-padding-block: 0.25rem !important;\n}\n\n.k-scroll-py-1\\.5 {\n    scroll-padding-block: 0.375rem;\n}\n\n.\\!k-scroll-py-1\\.5 {\n    scroll-padding-block: 0.375rem !important;\n}\n\n.k-scroll-py-2 {\n    scroll-padding-block: 0.5rem;\n}\n\n.\\!k-scroll-py-2 {\n    scroll-padding-block: 0.5rem !important;\n}\n\n.k-scroll-py-2\\.5 {\n    scroll-padding-block: 0.625rem;\n}\n\n.\\!k-scroll-py-2\\.5 {\n    scroll-padding-block: 0.625rem !important;\n}\n\n.k-scroll-py-3 {\n    scroll-padding-block: 0.75rem;\n}\n\n.\\!k-scroll-py-3 {\n    scroll-padding-block: 0.75rem !important;\n}\n\n.k-scroll-py-3\\.5 {\n    scroll-padding-block: 0.875rem;\n}\n\n.\\!k-scroll-py-3\\.5 {\n    scroll-padding-block: 0.875rem !important;\n}\n\n.k-scroll-py-4 {\n    scroll-padding-block: 1rem;\n}\n\n.\\!k-scroll-py-4 {\n    scroll-padding-block: 1rem !important;\n}\n\n.k-scroll-py-4\\.5 {\n    scroll-padding-block: 1.125rem;\n}\n\n.\\!k-scroll-py-4\\.5 {\n    scroll-padding-block: 1.125rem !important;\n}\n\n.k-scroll-py-5 {\n    scroll-padding-block: 1.25rem;\n}\n\n.\\!k-scroll-py-5 {\n    scroll-padding-block: 1.25rem !important;\n}\n\n.k-scroll-py-5\\.5 {\n    scroll-padding-block: 1.375rem;\n}\n\n.\\!k-scroll-py-5\\.5 {\n    scroll-padding-block: 1.375rem !important;\n}\n\n.k-scroll-py-6 {\n    scroll-padding-block: 1.5rem;\n}\n\n.\\!k-scroll-py-6 {\n    scroll-padding-block: 1.5rem !important;\n}\n\n.k-scroll-py-6\\.5 {\n    scroll-padding-block: 1.625rem;\n}\n\n.\\!k-scroll-py-6\\.5 {\n    scroll-padding-block: 1.625rem !important;\n}\n\n.k-scroll-py-7 {\n    scroll-padding-block: 1.75rem;\n}\n\n.\\!k-scroll-py-7 {\n    scroll-padding-block: 1.75rem !important;\n}\n\n.k-scroll-py-7\\.5 {\n    scroll-padding-block: 1.875rem;\n}\n\n.\\!k-scroll-py-7\\.5 {\n    scroll-padding-block: 1.875rem !important;\n}\n\n.k-scroll-py-8 {\n    scroll-padding-block: 2rem;\n}\n\n.\\!k-scroll-py-8 {\n    scroll-padding-block: 2rem !important;\n}\n\n.k-scroll-py-9 {\n    scroll-padding-block: 2.25rem;\n}\n\n.\\!k-scroll-py-9 {\n    scroll-padding-block: 2.25rem !important;\n}\n\n.k-scroll-py-10 {\n    scroll-padding-block: 2.5rem;\n}\n\n.\\!k-scroll-py-10 {\n    scroll-padding-block: 2.5rem !important;\n}\n\n.k-scroll-py-11 {\n    scroll-padding-block: 2.75rem;\n}\n\n.\\!k-scroll-py-11 {\n    scroll-padding-block: 2.75rem !important;\n}\n\n.k-scroll-py-12 {\n    scroll-padding-block: 3rem;\n}\n\n.\\!k-scroll-py-12 {\n    scroll-padding-block: 3rem !important;\n}\n\n.k-scroll-py-13 {\n    scroll-padding-block: 3.25rem;\n}\n\n.\\!k-scroll-py-13 {\n    scroll-padding-block: 3.25rem !important;\n}\n\n.k-scroll-py-14 {\n    scroll-padding-block: 3.5rem;\n}\n\n.\\!k-scroll-py-14 {\n    scroll-padding-block: 3.5rem !important;\n}\n\n.k-scroll-py-15 {\n    scroll-padding-block: 3.75rem;\n}\n\n.\\!k-scroll-py-15 {\n    scroll-padding-block: 3.75rem !important;\n}\n\n.k-scroll-py-16 {\n    scroll-padding-block: 4rem;\n}\n\n.\\!k-scroll-py-16 {\n    scroll-padding-block: 4rem !important;\n}\n\n.k-scroll-py-17 {\n    scroll-padding-block: 4.25rem;\n}\n\n.\\!k-scroll-py-17 {\n    scroll-padding-block: 4.25rem !important;\n}\n\n.k-scroll-py-18 {\n    scroll-padding-block: 4.5rem;\n}\n\n.\\!k-scroll-py-18 {\n    scroll-padding-block: 4.5rem !important;\n}\n\n.k-scroll-py-19 {\n    scroll-padding-block: 4.75rem;\n}\n\n.\\!k-scroll-py-19 {\n    scroll-padding-block: 4.75rem !important;\n}\n\n.k-scroll-py-20 {\n    scroll-padding-block: 5rem;\n}\n\n.\\!k-scroll-py-20 {\n    scroll-padding-block: 5rem !important;\n}\n\n.k-scroll-py-21 {\n    scroll-padding-block: 5.25rem;\n}\n\n.\\!k-scroll-py-21 {\n    scroll-padding-block: 5.25rem !important;\n}\n\n.k-scroll-py-22 {\n    scroll-padding-block: 5.5rem;\n}\n\n.\\!k-scroll-py-22 {\n    scroll-padding-block: 5.5rem !important;\n}\n\n.k-scroll-py-23 {\n    scroll-padding-block: 5.75rem;\n}\n\n.\\!k-scroll-py-23 {\n    scroll-padding-block: 5.75rem !important;\n}\n\n.k-scroll-py-24 {\n    scroll-padding-block: 6rem;\n}\n\n.\\!k-scroll-py-24 {\n    scroll-padding-block: 6rem !important;\n}\n\n.k-touch-action-none {\n    touch-action: none;\n}\n\n.\\!k-touch-action-none {\n    touch-action: none !important;\n}\n\n.k-touch-action-auto {\n    touch-action: auto;\n}\n\n.\\!k-touch-action-auto {\n    touch-action: auto !important;\n}\n\n.k-touch-action-pan-x {\n    touch-action: pan-x;\n}\n\n.\\!k-touch-action-pan-x {\n    touch-action: pan-x !important;\n}\n\n.k-touch-action-pan-left {\n    touch-action: pan-left;\n}\n\n.\\!k-touch-action-pan-left {\n    touch-action: pan-left !important;\n}\n\n.k-touch-action-pan-right {\n    touch-action: pan-right;\n}\n\n.\\!k-touch-action-pan-right {\n    touch-action: pan-right !important;\n}\n\n.k-touch-action-pan-y {\n    touch-action: pan-y;\n}\n\n.\\!k-touch-action-pan-y {\n    touch-action: pan-y !important;\n}\n\n.k-touch-action-pan-up {\n    touch-action: pan-up;\n}\n\n.\\!k-touch-action-pan-up {\n    touch-action: pan-up !important;\n}\n\n.k-touch-action-pan-down {\n    touch-action: pan-down;\n}\n\n.\\!k-touch-action-pan-down {\n    touch-action: pan-down !important;\n}\n\n.k-touch-action-pinch-zoom {\n    touch-action: pinch-zoom;\n}\n\n.\\!k-touch-action-pinch-zoom {\n    touch-action: pinch-zoom !important;\n}\n\n.k-touch-action-manipulation {\n    touch-action: manipulation;\n}\n\n.\\!k-touch-action-manipulation {\n    touch-action: manipulation !important;\n}\n\n.k-user-select-none {\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.\\!k-user-select-none {\n    -webkit-user-select: none !important;\n        -ms-user-select: none !important;\n            user-select: none !important;\n}\n\n.k-user-select-auto {\n    -webkit-user-select: auto;\n        -ms-user-select: auto;\n            user-select: auto;\n}\n\n.\\!k-user-select-auto {\n    -webkit-user-select: auto !important;\n        -ms-user-select: auto !important;\n            user-select: auto !important;\n}\n\n.k-user-select-text {\n    -webkit-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n}\n\n.\\!k-user-select-text {\n    -webkit-user-select: text !important;\n        -ms-user-select: text !important;\n            user-select: text !important;\n}\n\n.k-user-select-all {\n    -webkit-user-select: all;\n            user-select: all;\n}\n\n.\\!k-user-select-all {\n    -webkit-user-select: all !important;\n            user-select: all !important;\n}\n\n.k-user-select-contain {\n    -webkit-user-select: contain;\n        -ms-user-select: element;\n            user-select: contain;\n}\n\n.\\!k-user-select-contain {\n    -webkit-user-select: contain !important;\n        -ms-user-select: element !important;\n            user-select: contain !important;\n}\n\n.k-will-change-auto {\n    will-change: auto;\n}\n\n.\\!k-will-change-auto {\n    will-change: auto !important;\n}\n\n.k-will-change-scroll {\n    will-change: scroll-position;\n}\n\n.\\!k-will-change-scroll {\n    will-change: scroll-position !important;\n}\n\n.k-will-change-contents {\n    will-change: contents;\n}\n\n.\\!k-will-change-contents {\n    will-change: contents !important;\n}\n\n.k-will-change-transform {\n    will-change: transform;\n}\n\n.\\!k-will-change-transform {\n    will-change: transform !important;\n}\n\n.k-fill-none {\n    fill: none;\n}\n\n.\\!k-fill-none {\n    fill: none !important;\n}\n\n.k-fill-inherit {\n    fill: inherit;\n}\n\n.\\!k-fill-inherit {\n    fill: inherit !important;\n}\n\n.k-fill-current {\n    fill: currentColor;\n}\n\n.\\!k-fill-current {\n    fill: currentColor !important;\n}\n\n.k-fill-transparent {\n    fill: transparent;\n}\n\n.\\!k-fill-transparent {\n    fill: transparent !important;\n}\n\n.k-fill-black {\n    fill: black;\n}\n\n.\\!k-fill-black {\n    fill: black !important;\n}\n\n.k-fill-white {\n    fill: white;\n}\n\n.\\!k-fill-white {\n    fill: white !important;\n}\n\n.k-stroke-none {\n    stroke: none;\n}\n\n.\\!k-stroke-none {\n    stroke: none !important;\n}\n\n.k-stroke-inherit {\n    stroke: inherit;\n}\n\n.\\!k-stroke-inherit {\n    stroke: inherit !important;\n}\n\n.k-stroke-current {\n    stroke: currentColor;\n}\n\n.\\!k-stroke-current {\n    stroke: currentColor !important;\n}\n\n.k-stroke-transparent {\n    stroke: transparent;\n}\n\n.\\!k-stroke-transparent {\n    stroke: transparent !important;\n}\n\n.k-stroke-black {\n    stroke: black;\n}\n\n.\\!k-stroke-black {\n    stroke: black !important;\n}\n\n.k-stroke-white {\n    stroke: white;\n}\n\n.\\!k-stroke-white {\n    stroke: white !important;\n}\n\n.k-elevation-1 {\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.038);\n}\n\n.\\!k-elevation-1 {\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.038) !important;\n}\n\n.k-elevation-2 {\n    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.075);\n}\n\n.\\!k-elevation-2 {\n    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.075) !important;\n}\n\n.k-elevation-3 {\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.\\!k-elevation-3 {\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.k-elevation-4 {\n    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.125);\n}\n\n.\\!k-elevation-4 {\n    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.125) !important;\n}\n\n.k-elevation-5 {\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);\n}\n\n.\\!k-elevation-5 {\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15) !important;\n}\n\n.k-elevation-6 {\n    box-shadow: 0px 11px 24px 0px rgba(0, 0, 0, 0.159);\n}\n\n.\\!k-elevation-6 {\n    box-shadow: 0px 11px 24px 0px rgba(0, 0, 0, 0.159) !important;\n}\n\n.k-elevation-7 {\n    box-shadow: 0px 14px 36px 0px rgba(0, 0, 0, 0.168);\n}\n\n.\\!k-elevation-7 {\n    box-shadow: 0px 14px 36px 0px rgba(0, 0, 0, 0.168) !important;\n}\n\n.k-elevation-8 {\n    box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.176);\n}\n\n.\\!k-elevation-8 {\n    box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.176) !important;\n}\n\n.k-elevation-9 {\n    box-shadow: 0px 18px 60px 0px rgba(0, 0, 0, 0.185);\n}\n\n.\\!k-elevation-9 {\n    box-shadow: 0px 18px 60px 0px rgba(0, 0, 0, 0.185) !important;\n}\n\n.k-body,\n.k-typography {\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    font-weight: 400;\n    margin: 0;\n}\n\n.k-body p,\n.k-typography p {\n    margin: 0 0 1rem;\n}\n\n.k-h1 {\n    font-size: 2.5rem;\n    line-height: 1.2;\n    font-weight: 500;\n    margin: 0 0 0.5rem;\n}\n\n.k-h2 {\n    font-size: 2rem;\n    line-height: 1.2;\n    font-weight: 500;\n    margin: 0 0 0.5rem;\n}\n\n.k-h3 {\n    font-size: 1.75rem;\n    line-height: 1.2;\n    font-weight: 500;\n    margin: 0 0 0.5rem;\n}\n\n.k-h4 {\n    font-size: 1.5rem;\n    line-height: 1.2;\n    font-weight: 500;\n    margin: 0 0 0.5rem;\n}\n\n.k-h5 {\n    font-size: 1.25rem;\n    line-height: 1.2;\n    font-weight: 500;\n    margin: 0 0 0.5rem;\n}\n\n.k-h6 {\n    font-size: 1rem;\n    line-height: 1.2;\n    font-weight: 500;\n    margin: 0 0 0.5rem;\n}\n\n.k-paragraph {\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    font-weight: 400;\n    margin: 0 0 1rem;\n}\n\n.k-pre,\n.k-code {\n    font-size: 0.875rem;\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    line-height: 1.5;\n    font-weight: 400;\n    border-style: solid;\n    border-width: 1px;\n}\n\n.k-pre {\n    padding-block: 16px;\n    padding-inline: 24px;\n    overflow: auto;\n}\n\n.k-pre > .k-code {\n    padding: 0;\n    border-width: 0;\n    border-color: transparent;\n    background-color: transparent;\n    font-family: inherit;\n    font-size: inherit;\n}\n\n.k-code {\n    padding-block: 0px;\n    padding-inline: 4px;\n}\n\n.k-display-1 {\n    font-size: 5rem;\n    line-height: 1.2;\n    font-weight: 300;\n}\n\n.k-display-2 {\n    font-size: 4.5rem;\n    line-height: 1.2;\n    font-weight: 300;\n}\n\n.k-display-3 {\n    font-size: 4rem;\n    line-height: 1.2;\n    font-weight: 300;\n}\n\n.k-display-4 {\n    font-size: 3.5rem;\n    line-height: 1.2;\n    font-weight: 300;\n}\n\n.k-body {\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-pre,\n.k-code {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-svg-icon {\n    width: 16px;\n    height: 16px;\n    outline: 0;\n    line-height: 1;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n    position: relative;\n}\n\n.k-svg-icon > svg {\n    fill: currentColor;\n    flex: 1 1 auto;\n}\n\n.k-svg-icon.k-icon-xs {\n    width: 12px;\n    height: 12px;\n}\n\n.k-svg-icon.k-icon-sm {\n    width: 14px;\n    height: 14px;\n}\n\n.k-svg-icon.k-icon-md {\n    width: 16px;\n    height: 16px;\n}\n\n.k-svg-icon.k-icon-lg {\n    width: 20px;\n    height: 20px;\n}\n\n.k-svg-icon.k-icon-xl {\n    width: 24px;\n    height: 24px;\n}\n\n.k-svg-icon.k-icon-xxl {\n    width: 32px;\n    height: 32px;\n}\n\n.k-svg-icon.k-icon-xxxl {\n    width: 48px;\n    height: 48px;\n}\n\n.k-flip-h.k-svg-icon, .k-svg-icon.k-flip-x,\n.k-flip-v.k-svg-icon,\n.k-svg-icon.k-flip-y,\n.k-flip-h.k-flip-v.k-svg-icon,\n.k-flip-v.k-svg-icon.k-flip-x,\n.k-svg-icon.k-flip-x.k-flip-y,\n.k-flip-h.k-svg-icon.k-flip-y {\n    transform: none;\n}\n\n.k-flip-h > svg, .k-flip-x > svg {\n    transform: scaleX(-1);\n}\n\n.k-flip-v > svg, .k-flip-y > svg {\n    transform: scaleY(-1);\n}\n\n.k-flip-h.k-flip-v > svg, .k-flip-v.k-flip-x > svg, .k-flip-x.k-flip-y > svg, .k-flip-h.k-flip-y > svg,\n.k-flip-both > svg {\n    transform: scale(-1, -1);\n}\n\n.k-rotate-0.k-svg-icon {\n    transform: none;\n}\n\n.k-rotate-0 > svg {\n    transform: rotate(0deg);\n}\n\n.k-rotate-45.k-svg-icon {\n    transform: none;\n}\n\n.k-rotate-45 > svg {\n    transform: rotate(45deg);\n}\n\n.k-rotate-90.k-svg-icon {\n    transform: none;\n}\n\n.k-rotate-90 > svg {\n    transform: rotate(90deg);\n}\n\n.k-rotate-135.k-svg-icon {\n    transform: none;\n}\n\n.k-rotate-135 > svg {\n    transform: rotate(135deg);\n}\n\n.k-rotate-180.k-svg-icon {\n    transform: none;\n}\n\n.k-rotate-180 > svg {\n    transform: rotate(180deg);\n}\n\n.k-rotate-225.k-svg-icon {\n    transform: none;\n}\n\n.k-rotate-225 > svg {\n    transform: rotate(225deg);\n}\n\n.k-rotate-270.k-svg-icon {\n    transform: none;\n}\n\n.k-rotate-270 > svg {\n    transform: rotate(270deg);\n}\n\n.k-rotate-315.k-svg-icon {\n    transform: none;\n}\n\n.k-rotate-315 > svg {\n    transform: rotate(315deg);\n}\n\n.k-icon-wrap {\n    flex: none;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    gap: 0;\n    align-items: center;\n    align-self: flex-start;\n    vertical-align: middle;\n    position: relative;\n}\n\n.k-icon-wrap::before {\n    content: \"\\200b\";\n    width: 0;\n    overflow: hidden;\n    flex: none;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.k-icon-wrapper-host {\n    display: contents;\n}\n\n.k-icon-with-modifier {\n    position: relative;\n    margin: .25em;\n}\n\n.k-icon.k-icon-modifier {\n    width: 1em;\n    height: 1em;\n    position: absolute;\n    font-size: .5em;\n    bottom: 0;\n    right: 0;\n    margin: 0 -.5em -.5em 0;\n}\n\n.k-i-none::before {\n    content: \"\";\n    display: none;\n}\n\n.k-icon-action {\n    display: inline-flex;\n    padding: 0.25rem;\n    line-height: 1;\n    align-items: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\n.k-sprite {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    overflow: hidden;\n    background-repeat: no-repeat;\n    font-size: 0;\n    line-height: 0;\n    text-align: center;\n}\n\n.k-image {\n    display: inline-block;\n}\n\n.k-messagebox {\n    margin: 0 0 1rem 0;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    border-width: 0 0 0 4px;\n    border-style: solid;\n    box-sizing: border-box;\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-messagebox a {\n    color: inherit;\n    font-style: normal;\n    text-decoration: underline;\n}\n\n.k-messagebox-primary {\n    border-color: #bbd6fe;\n    color: #073984;\n    background-color: #cfe2ff;\n}\n\n.k-messagebox-secondary {\n    border-color: #d6d8db;\n    color: #383d41;\n    background-color: #e2e3e5;\n}\n\n.k-messagebox-tertiary {\n    border-color: #d7caee;\n    color: #3a2264;\n    background-color: #e2d9f3;\n}\n\n.k-messagebox-info {\n    border-color: #bbf0fb;\n    color: #07697d;\n    background-color: #cff4fc;\n}\n\n.k-messagebox-success {\n    border-color: #bfddcf;\n    color: #0d462c;\n    background-color: #d1e7dd;\n}\n\n.k-messagebox-warning {\n    border-color: #ffeeba;\n    color: #856404;\n    background-color: #fff3cd;\n}\n\n.k-messagebox-error {\n    border-color: #f5c6cb;\n    color: #721c24;\n    background-color: #f8d7da;\n}\n\n.k-messagebox-dark {\n    border-color: #c1c2c3;\n    color: #111315;\n    background-color: #d3d3d4;\n}\n\n.k-messagebox-light {\n    border-color: #fdfdfe;\n    color: #818182;\n    background-color: #fefefe;\n}\n\n.k-messagebox-inverse {\n    border-color: #c1c2c3;\n    color: #111315;\n    background-color: #d3d3d4;\n}\n\n.k-drag-clue {\n    border-radius: 0.375rem;\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: center;\n    white-space: nowrap;\n    overflow: hidden;\n    position: absolute;\n    z-index: 20000;\n    cursor: move;\n}\n\n.k-drag-status,\n.k-drag-clue .k-drag-status {\n    margin: 0;\n    margin-right: .4ex;\n}\n\n.k-drop-hint {\n    display: flex;\n    gap: 4px;\n    justify-content: space-between;\n    align-items: center;\n    position: absolute;\n    z-index: 1000;\n    transform: translate(-50%, -50%);\n}\n\n.k-drop-hint-start,\n.k-drop-hint-end {\n    flex-shrink: 0;\n    border-width: 4px;\n    border-style: solid;\n    border-color: transparent;\n}\n\n.k-drop-hint-line {\n    flex-grow: 1;\n    background-color: #0d6efd;\n}\n\n.k-drop-hint-h .k-drop-hint-start {\n    border-left-width: 6.9282032304px;\n    border-left-color: #0d6efd;\n    border-right-width: 0;\n}\n\n.k-drop-hint-h .k-drop-hint-line {\n    width: 20px;\n    height: 1px;\n}\n\n.k-drop-hint-h .k-drop-hint-end {\n    border-right-width: 6.9282032304px;\n    border-right-color: #0d6efd;\n    border-left-width: 0;\n}\n\n.k-drop-hint-v {\n    flex-direction: column;\n}\n\n.k-drop-hint-v .k-drop-hint-start {\n    border-top-width: 6.9282032304px;\n    border-top-color: #0d6efd;\n    border-bottom-width: 0;\n}\n\n.k-drop-hint-v .k-drop-hint-line {\n    width: 1px;\n    height: 20px;\n}\n\n.k-drop-hint-v .k-drop-hint-end {\n    border-bottom-width: 6.9282032304px;\n    border-bottom-color: #0d6efd;\n    border-top-width: 0;\n}\n\n.k-reorder-cue {\n    position: absolute;\n}\n\n.k-reorder-cue::before, .k-reorder-cue::after {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border: 3px solid transparent;\n    position: absolute;\n    transform: translateX(-50%);\n}\n\n.k-reorder-cue::before {\n    border-bottom-width: 0;\n    border-top-color: currentColor;\n    top: -4px;\n}\n\n.k-reorder-cue::after {\n    border-top-width: 0;\n    border-bottom-color: currentColor;\n    bottom: -4px;\n}\n\n.k-drag-clue {\n    border-color: #0c65e9;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-checkbox {\n    margin: 0;\n    padding: 0;\n    line-height: initial;\n    border-width: 1px;\n    border-style: solid;\n    outline: 0;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: inline-block;\n    flex: none;\n    vertical-align: middle;\n    position: relative;\n    cursor: pointer;\n    -webkit-appearance: none;\n}\n\n.k-checkbox:checked,\n.k-checkbox.k-checked {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n\n.k-checkbox:indeterminate,\n.k-checkbox.k-indeterminate {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n\n.k-checkbox:disabled,\n.k-checkbox.k-disabled {\n    outline: none;\n    cursor: default;\n    opacity: 0.65;\n    filter: grayscale(0.1);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n.k-checkbox-wrap {\n    flex: none;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    gap: 0;\n    align-items: center;\n    align-self: flex-start;\n    vertical-align: middle;\n    position: relative;\n}\n\n.k-checkbox-wrap::before {\n    content: \"\\200b\";\n    width: 0px;\n    overflow: hidden;\n    flex: none;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.k-checkbox-label {\n    margin: 0;\n    padding: 0;\n    display: inline-flex;\n    align-items: flex-start;\n    gap: 0.25rem;\n    vertical-align: middle;\n    position: relative;\n    cursor: pointer;\n}\n\n.k-checkbox-label .k-ripple {\n    visibility: hidden !important;\n}\n\n.k-checkbox + .k-label,\n.k-checkbox-wrap + .k-label,\n.k-checkbox + .k-checkbox-label,\n.k-checkbox-wrap + .k-checkbox-label {\n    display: inline;\n    margin-inline-start: 0.25rem;\n}\n\n.k-checkbox-label:empty {\n    display: none !important;\n}\n\n.k-checkbox-label.k-no-text {\n    min-width: 1px;\n}\n\n.k-checkbox-list {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0;\n    list-style: none;\n}\n\n.k-checkbox-item,\n.k-checkbox-list-item {\n    padding-block: 0.25rem;\n    padding-inline: 0px;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: center;\n    gap: 0.25rem;\n}\n\n.k-checkbox-item .k-checkbox-label,\n.k-checkbox-list-item .k-checkbox-label {\n    margin: 0;\n}\n\n.k-checkbox-list-horizontal,\n.k-checkbox-list.k-list-horizontal {\n    display: flex;\n    flex-flow: row wrap;\n    gap: 1rem;\n}\n\n.k-ripple-container .k-checkbox::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    border-radius: 100%;\n    z-index: -1;\n    transition: opacity 100ms linear, transform 150ms cubic-bezier(0.4, 0, 0.2, 1);\n    transform: translate(-50%, -50%) scale(0);\n    transform-origin: center center;\n}\n\n.k-ripple-container .k-checkbox:focus,\n.k-ripple-container .k-checkbox.k-focus {\n    box-shadow: none !important;\n}\n\n.k-ripple-container .k-checkbox:disabled::after,\n.k-ripple-container .k-checkbox.k-disabled::after {\n    display: none;\n}\n\n.k-checkbox-sm {\n    width: 0.75rem;\n    height: 0.75rem;\n}\n\n.k-checkbox-sm::before {\n    font-size: 0.625rem;\n}\n\n.k-ripple-container .k-checkbox-sm::after {\n    width: 300%;\n    height: 300%;\n}\n\n.k-checkbox-md {\n    width: 1rem;\n    height: 1rem;\n}\n\n.k-checkbox-md::before {\n    font-size: 0.875rem;\n}\n\n.k-ripple-container .k-checkbox-md::after {\n    width: 300%;\n    height: 300%;\n}\n\n.k-checkbox-lg {\n    width: 1.25rem;\n    height: 1.25rem;\n}\n\n.k-checkbox-lg::before {\n    font-size: 1.125rem;\n}\n\n.k-ripple-container .k-checkbox-lg::after {\n    width: 300%;\n    height: 300%;\n}\n\n.k-checkbox.k-rounded-sm {\n    border-radius: 0.125rem;\n}\n\n.k-checkbox.k-rounded-md {\n    border-radius: 0.25rem;\n}\n\n.k-checkbox.k-rounded-lg {\n    border-radius: 0.375rem;\n}\n\n.k-checkbox {\n    border-color: #ced4da;\n    background-color: #ffffff;\n}\n\n.k-checkbox:focus,\n.k-checkbox.k-focus {\n    border-color: #86b7fe;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-checkbox:indeterminate,\n.k-checkbox.k-indeterminate {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-checkbox:checked,\n.k-checkbox.k-checked {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-checkbox:checked:focus,\n.k-checkbox.k-checked.k-focus {\n    border-color: #0d6efd;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-checkbox.k-invalid {\n    border-color: #dc3545;\n}\n\n.k-checkbox.k-invalid + .k-checkbox-label {\n    color: #dc3545;\n}\n\n.k-checkbox-wrap .k-ripple-blob {\n    color: #0d6efd;\n    opacity: 0.25;\n}\n\n.k-ripple-container .k-checkbox::after {\n    background: #0d6efd;\n    opacity: 0.25;\n}\n\n.k-list-container {\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-list-container > .k-list {\n    flex: 1;\n    height: 100%;\n}\n\n.k-list {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    display: flex;\n    flex-flow: column nowrap;\n    outline: none;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-list *,\n.k-list *::before,\n.k-list *::after {\n    box-sizing: border-box;\n}\n\n.k-popup > .k-list {\n    height: 100%;\n    border-width: 0;\n}\n\n.k-list-group-sticky-header {\n    border-width: 0;\n    border-width: 0 0 1px;\n    border-style: solid;\n    font-weight: 700;\n    white-space: nowrap;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    flex: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n}\n\n.k-list-content {\n    border-color: inherit;\n    flex: 1 1 auto;\n    overflow: hidden;\n    overflow-y: auto;\n    position: relative;\n}\n\n.k-list-ul {\n    margin: 0;\n    padding: 0;\n    border-width: 0;\n    border-color: inherit;\n    height: auto;\n    list-style: none;\n}\n\n.k-list-item, .k-list-optionlabel {\n    border: 0;\n    outline: none;\n    cursor: pointer;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: center;\n    gap: 0.5rem;\n    position: relative;\n    transition-property: color, background-color, outline-color, box-shadow;\n    transition-duration: 200ms;\n    transition-timing-function: ease;\n}\n\n.k-list-item.k-first::before, .k-first.k-list-optionlabel::before {\n    content: \"\";\n    border-width: 1px 0 0;\n    border-style: solid;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.k-list-item-text::before,\n.k-list-header-text::before,\n.k-list-optionlabel::before {\n    content: \"\\200b\";\n    width: 0px;\n    overflow: hidden;\n}\n\n.k-list-optionlabel {\n    column-gap: 0;\n}\n\n.k-list-group-item {\n    border-width: 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    font-weight: 700;\n    cursor: default;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: center;\n    gap: 0.5rem;\n    position: relative;\n}\n\n.k-list-item-group-label {\n    padding-block: 0;\n    padding-inline: .5em;\n    font-size: .75em;\n    position: absolute;\n    top: 0;\n    inset-inline-end: 0;\n}\n\n.k-virtual-content,\n.k-virtual-list .k-list-content {\n    overflow-y: scroll;\n}\n\n.k-virtual-list .k-list-item, .k-virtual-list .k-list-optionlabel,\n.k-virtual-list .k-list-group-item,\n.k-virtual-content .k-list-item,\n.k-virtual-content .k-list-optionlabel,\n.k-virtual-content .k-list-group-item {\n    position: absolute;\n    width: 100%;\n}\n\n.k-virtual-list .k-list-item-text,\n.k-virtual-list .k-list-header-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-virtual-list .k-list-optionlabel {\n    position: relative;\n}\n\n.k-list-filter {\n    display: block;\n    position: relative;\n    padding: 1rem;\n    box-sizing: border-box;\n    flex: none;\n}\n\n.k-list-sm {\n    font-size: 0.875rem;\n    line-height: 1.4285714286;\n}\n\n.k-list-sm .k-list-group-sticky-header {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-list-sm .k-list-item, .k-list-sm .k-list-optionlabel {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-list-sm .k-list-group-item {\n    padding-block: 0.125rem;\n    padding-inline: 1rem;\n}\n\n.k-list-md {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-list-md .k-list-group-sticky-header {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-list-md .k-list-item, .k-list-md .k-list-optionlabel {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-list-md .k-list-group-item {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-list-lg {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-list-lg .k-list-group-sticky-header {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n}\n\n.k-list-lg .k-list-item, .k-list-lg .k-list-optionlabel {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n}\n\n.k-list-lg .k-list-group-item {\n    padding-block: 0.375rem;\n    padding-inline: 1rem;\n}\n\n.k-no-data, .k-nodata {\n    min-height: 140px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: lighter;\n    text-align: center;\n    white-space: normal;\n}\n\n.k-list {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-list-group-sticky-header {\n    border-color: inherit;\n}\n\n.k-list-item:hover, .k-list-optionlabel:hover, .k-list-item.k-hover, .k-hover.k-list-optionlabel {\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-list-item:focus, .k-list-optionlabel:focus, .k-list-item.k-focus, .k-focus.k-list-optionlabel {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-list-item.k-selected, .k-selected.k-list-optionlabel {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-list-item.k-selected:hover, .k-selected.k-list-optionlabel:hover, .k-list-item.k-selected.k-hover, .k-selected.k-hover.k-list-optionlabel {\n    color: white;\n    background-color: #0c65e9;\n}\n\n.k-list-optionlabel,\n.k-list-optionlabel.k-hover,\n.k-list-optionlabel:hover {\n    color: #6c757d;\n}\n\n.k-list-group-item {\n    border-color: inherit;\n}\n\n.k-list-item-group-label {\n    color: #ffffff;\n    background-color: #212529;\n}\n\n.k-no-data, .k-nodata {\n    color: #6c757d;\n}\n\n.k-listgroup {\n    border-radius: 0.25rem;\n    margin: 0;\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    font-size: 1rem;\n    line-height: 1.5;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-listgroup > ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n}\n\n.k-listgroup .k-listgroup-item + .k-listgroup-item {\n    border-top-width: 1px;\n}\n\n.k-listgroup-flush {\n    border-radius: 0;\n    border-left-width: 0;\n    border-right-width: 0;\n}\n\n.k-listgroup-item {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    flex: 0 0 auto;\n    position: relative;\n}\n\n.k-listgroup-item > .k-link {\n    margin-block: -0.5rem;\n    margin-inline: -1rem;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    color: inherit;\n    text-decoration: none;\n    outline: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    flex: 1 1 auto;\n    position: relative;\n}\n\n.k-listgroup-item > .k-link > .k-select {\n    padding: 0.5rem;\n    display: flex;\n    align-items: center;\n    flex: 0 0 auto;\n    position: absolute;\n    top: 50%;\n    inset-inline-end: 0;\n    transform: translateY(-50%);\n}\n\n.k-listgroup-item-segmented {\n    align-items: stretch;\n}\n\n.k-listgroup-item-segmented > .k-link {\n    margin-right: 0;\n}\n\n.k-listgroup-item-segmented > .k-select {\n    margin: -0.5rem -1rem -0.5rem 0;\n    padding: 0.5rem;\n    border-width: 0 0 0 1px;\n    border-style: solid;\n    border-color: inherit;\n    cursor: pointer;\n}\n\n.k-listgroup-form-row {\n    margin-block: -0.5rem;\n    margin-inline: -1rem;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    flex: 1 1 auto;\n    position: relative;\n}\n\n.k-listgroup-form-row .k-listgroup-form-field-label {\n    width: 40%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-listgroup-form-row .k-listgroup-form-field-wrapper {\n    width: 50%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    text-align: end;\n    position: relative;\n}\n\n.k-listgroup-form-row .k-listgroup-form-field-wrapper select,\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=\"text\"],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=\"password\"],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=\"date\"],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=\"time\"],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=\"datetime-local\"],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=\"number\"],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper textarea {\n    width: 100%;\n    box-sizing: border-box;\n    flex: 1 1 100%;\n}\n\n.k-listgroup-form-row .k-listgroup-form-field-wrapper textarea {\n    min-height: 4em;\n    resize: vertical;\n}\n\n.k-listgroup-item.k-listgroup-form-row {\n    margin: 0;\n}\n\n[dir=\"rtl\"] .k-listgroup-item > .k-link > .k-select {\n    right: auto;\n    left: 0;\n}\n\n[dir=\"rtl\"] .k-listgroup-item-segmented > .k-link {\n    margin-right: -1rem;\n    margin-left: 0;\n}\n\n[dir=\"rtl\"] .k-listgroup-item-segmented > .k-select {\n    margin-right: 0;\n    margin-left: -1rem;\n    border-right-width: 1px;\n    border-left-width: 0;\n}\n\n.k-noflexbox .k-listgroup,\n.k-noflexbox .k-listgroup > ul .k-listgroup-item,\n.k-noflexbox .k-listgroup-item > .k-link {\n    display: block;\n}\n\n.k-listgroup {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-overlay {\n    width: 100%;\n    height: 100%;\n    opacity: 0.5;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 10001;\n}\n\n.k-overlay {\n    background-color: #000000;\n}\n\n.k-overlay-primary {\n    background-color: #0d6efd;\n}\n\n.k-overlay-secondary {\n    background-color: #6c757d;\n}\n\n.k-overlay-tertiary {\n    background-color: #6f42c1;\n}\n\n.k-overlay-info {\n    background-color: #0dcaf0;\n}\n\n.k-overlay-success {\n    background-color: #198754;\n}\n\n.k-overlay-warning {\n    background-color: #ffc107;\n}\n\n.k-overlay-error {\n    background-color: #dc3545;\n}\n\n.k-overlay-dark {\n    background-color: #212529;\n}\n\n.k-overlay-light {\n    background-color: #f8f9fa;\n}\n\n.k-overlay-inverse {\n    background-color: #212529;\n}\n\n.k-popup {\n    border-radius: 0.375rem;\n    margin: 0;\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n}\n\n.k-popup .k-item {\n    outline: none;\n}\n\n.k-animation-container {\n    border-radius: 0 0 0.375rem 0.375rem;\n}\n\n.k-animation-container-shown {\n    overflow: visible;\n}\n\n.k-popup > .k-colorpalette {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-popup.k-popup-transparent {\n    border-width: 0;\n    background-color: transparent;\n    box-shadow: none;\n}\n\n.k-popup.k-popup-flush {\n    padding: 0;\n}\n\n.k-popup > .k-widget,\n.k-popup > .k-coloreditor {\n    border-width: 0;\n}\n\n.k-shadow {\n    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));\n}\n\n.k-popup.k-column-menu {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n.k-popup {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));\n}\n\n.k-animation-container {\n    border-radius: 0 0 0.375rem 0.375rem;\n}\n\n.k-ripple-target {\n    position: relative;\n}\n\n.k-ripple {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.k-ripple-blob {\n    pointer-events: none;\n    position: absolute;\n    border-radius: 50%;\n    padding: 0;\n    transform: translate(-50%, -50%) scale(0);\n    transition: opacity 100ms linear, transform 500ms cubic-bezier(0.4, 0, 0.2, 1);\n    opacity: .1;\n    background-color: currentColor;\n}\n\n.k-primary .k-ripple-blob {\n    opacity: .2;\n}\n\n.k-ripple-focus::after {\n    visibility: visible;\n    animation: ripple 600ms ease-out;\n}\n\n@keyframes ripple {\n    0% {\n        transform: translate(-50%, -50%) scale(0);\n    }\n    20% {\n        transform: translate(-50%, -50%) scale(1);\n    }\n    100% {\n        opacity: 0;\n        transform: translate(-50%, -50%) scale(1);\n    }\n}\n\n.k-table {\n    width: 100%;\n    max-width: none;\n    border-width: 1px;\n    border-style: solid;\n    text-align: start;\n    border-collapse: collapse;\n    border-spacing: 0;\n    empty-cells: show;\n    outline: none;\n}\n\n.k-data-table {\n    border-width: 1px;\n    border-style: solid;\n}\n\n.k-data-table .k-table {\n    table-layout: fixed;\n}\n\n.k-table-thead,\n.k-table-tbody,\n.k-table-tfoot,\n.k-table-row,\n.k-table-alt-row {\n    border-color: inherit;\n    text-align: inherit;\n}\n\n.k-table-th,\n.k-table-td {\n    border-width: 0 0 0px 1px;\n    border-style: solid;\n    border-color: inherit;\n    box-sizing: border-box;\n    font-weight: normal;\n    text-align: inherit;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    display: table-cell;\n    overflow: hidden;\n    position: relative;\n}\n\n.k-table-th:first-child,\n.k-table-td:first-child {\n    border-left-width: 0;\n}\n\n.k-table-th {\n    border-bottom-width: 1px;\n}\n\n.k-table-header {\n    padding-inline-end: var(--kendo-scrollbar-width);\n    border-width: 0 0 1px;\n    border-style: solid;\n    box-sizing: border-box;\n}\n\n.k-table-header .k-table {\n    border-width: 0;\n}\n\n.k-table-header-wrap {\n    margin-right: -1px;\n    width: 100%;\n    border-width: 0 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n    overflow: hidden;\n}\n\n.k-table-header > .k-table,\n.k-table-header-wrap > .k-table {\n    margin-bottom: -1px;\n}\n\n.k-table-group-sticky-header {\n    flex: none;\n}\n\n.k-table-group-sticky-header .k-table-th {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: center;\n}\n\n.k-table-list {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    max-width: none;\n    border-width: 0;\n    display: table;\n    border-collapse: collapse;\n    border-spacing: 0;\n    table-layout: fixed;\n    empty-cells: show;\n    list-style: none;\n    outline: none;\n}\n\n.k-table-list .k-table-row {\n    position: relative;\n}\n\n.k-table-list .k-table-row,\n.k-table-list .k-table-group-row {\n    width: 100%;\n    box-sizing: border-box;\n    display: table-row;\n}\n\n.k-table-list .k-table-row.k-first {\n    border-top: 1px solid currentColor;\n}\n\n.k-table-list .k-table-th,\n.k-table-list .k-table-td {\n    vertical-align: middle;\n}\n\n.k-table-list .k-table-group-row {\n    position: sticky;\n}\n\n.k-table-list .k-table-group-row::before {\n    content: \"\\200b\";\n    padding-inline: 0;\n    width: 0;\n    display: block;\n    overflow: hidden;\n}\n\n.k-table-list .k-table-group-row .k-table-th {\n    width: 100%;\n    border-color: inherit;\n    color: inherit;\n    background-color: inherit;\n    position: absolute;\n    top: 0;\n}\n\n.k-table-list .k-table-spacer-td {\n    padding: 0 !important;\n    width: 0 !important;\n    border-left-width: 0 !important;\n    border-right-width: 0 !important;\n}\n\n.k-table-list .k-table-group-td {\n    padding: 0 !important;\n    width: 0 !important;\n    border-left-width: 0 !important;\n    border-right-width: 0 !important;\n    overflow: visible;\n}\n\n.k-table-list .k-table-group-td > span {\n    font-size: .75em;\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n.k-virtual-table .k-table-row,\n.k-virtual-table .k-table-group-row {\n    position: absolute;\n    width: 100%;\n}\n\n.k-table-scroller {\n    position: relative;\n    overflow: auto;\n}\n\n.k-table-scroller > .k-table {\n    border-width: 0;\n}\n\n.k-table-footer {\n    padding-inline-end: var(--kendo-scrollbar-width);\n    border-width: 1px 0 0;\n    border-style: solid;\n    box-sizing: border-box;\n}\n\n.k-table-footer .k-table {\n    border-width: 0;\n}\n\n.k-table-footer-wrap {\n    margin-right: -1px;\n    width: 100%;\n    border-width: 0 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n    overflow: hidden;\n}\n\n.k-table-sm {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-table-sm .k-table-th,\n.k-table-sm .k-table-td {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n}\n\n.k-table-sm .k-table-list .k-table-group-td > span {\n    padding-block: 0;\n    padding-inline: 0.25rem;\n}\n\n.k-table-sm .k-table-list .k-table-group-row::before {\n    padding-block: 0.25rem;\n    padding-inline: 0;\n}\n\n.k-table-md {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-table-md .k-table-th,\n.k-table-md .k-table-td {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-table-md .k-table-list .k-table-group-td > span {\n    padding-block: 0;\n    padding-inline: 0.25rem;\n}\n\n.k-table-md .k-table-list .k-table-group-row::before {\n    padding-block: 0.5rem;\n    padding-inline: 0;\n}\n\n.k-table-lg {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-table-lg .k-table-th,\n.k-table-lg .k-table-td {\n    padding-block: 0.625rem;\n    padding-inline: 0.5rem;\n}\n\n.k-table-lg .k-table-list .k-table-group-td > span {\n    padding-block: 0;\n    padding-inline: 0.25rem;\n}\n\n.k-table-lg .k-table-list .k-table-group-row::before {\n    padding-block: 0.625rem;\n    padding-inline: 0;\n}\n\n.k-rtl.k-table .k-table-th,\n.k-rtl.k-table .k-table-td,\n.k-rtl .k-table .k-table-th,\n.k-rtl .k-table .k-table-td,\n[dir=\"rtl\"].k-table .k-table-th,\n[dir=\"rtl\"].k-table .k-table-td,\n[dir=\"rtl\"] .k-table .k-table-th,\n[dir=\"rtl\"] .k-table .k-table-td {\n    border-left-width: 0;\n    border-right-width: 1px;\n}\n\n.k-rtl.k-table .k-table-th:first-child,\n.k-rtl.k-table .k-table-td:first-child,\n.k-rtl .k-table .k-table-th:first-child,\n.k-rtl .k-table .k-table-td:first-child,\n[dir=\"rtl\"].k-table .k-table-th:first-child,\n[dir=\"rtl\"].k-table .k-table-td:first-child,\n[dir=\"rtl\"] .k-table .k-table-th:first-child,\n[dir=\"rtl\"] .k-table .k-table-td:first-child {\n    border-right-width: 0;\n}\n\n.k-rtl.k-table .k-table-header-wrap,\n.k-rtl.k-table .k-table-footer-wrap,\n.k-rtl .k-table .k-table-header-wrap,\n.k-rtl .k-table .k-table-footer-wrap,\n[dir=\"rtl\"].k-table .k-table-header-wrap,\n[dir=\"rtl\"].k-table .k-table-footer-wrap,\n[dir=\"rtl\"] .k-table .k-table-header-wrap,\n[dir=\"rtl\"] .k-table .k-table-footer-wrap {\n    margin-right: 0;\n    margin-left: -1px;\n    border-left-width: 1px;\n    border-right-width: 0;\n}\n\n.k-rtl .k-table-list .k-table-group-td > span,\n[dir=\"rtl\"] .k-table-list .k-table-group-td > span {\n    left: 0;\n    right: auto;\n}\n\n.k-table,\n.k-data-table {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-table-thead,\n.k-table-header,\n.k-table-group-sticky-header {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-table-tfoot,\n.k-table-footer {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-table-group-row {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-table-group-td > span {\n    color: #ffffff;\n    background-color: #212529;\n}\n\n.k-table-alt-row {\n    background-color: rgba(0, 0, 0, 0.04);\n}\n\n.k-table-tbody .k-table-row:hover,\n.k-table-list .k-table-row:hover,\n.k-table-tbody .k-table-row.k-hover,\n.k-table-list .k-table-row.k-hover {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n.k-table-tbody .k-table-row.k-focus, .k-table-tbody .k-table-row:focus,\n.k-table-list .k-table-row.k-focus,\n.k-table-list .k-table-row:focus,\n.k-table-tbody .k-table-td.k-focus,\n.k-table-tbody .k-table-td:focus,\n.k-table-list .k-table-td.k-focus,\n.k-table-list .k-table-td:focus {\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n\n.k-table-tbody .k-table-row.k-selected > .k-table-td,\n.k-table-list .k-table-row.k-selected {\n    color: #212529;\n    background-color: rgba(13, 110, 253, 0.25);\n}\n\n.k-virtual-scroller {\n    width: 100%;\n    height: 100%;\n    flex: 1 1 auto;\n    overflow: auto;\n    position: relative;\n}\n\n.k-virtual-scroller-wrap {\n    position: relative;\n    z-index: 1;\n}\n\n.k-virtual-scroller-content {\n    position: absolute;\n    width: 100%;\n    top: 0;\n    inset-inline-start: 0;\n}\n\n.k-virtual-scroller-size {\n    position: relative;\n    z-index: 0;\n}\n\n.k-avatar {\n    border-width: 0;\n    border-style: solid;\n    box-sizing: border-box;\n    vertical-align: middle;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    overflow: hidden;\n}\n\n.k-avatar *,\n.k-avatar *::before,\n.k-avatar *::after {\n    box-sizing: border-box;\n}\n\n.k-avatar-text,\n.k-avatar-initials {\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n}\n\n.k-avatar-icon {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n}\n\n.k-avatar-image {\n    width: 100%;\n    height: 100%;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.k-avatar-image > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    vertical-align: top;\n}\n\n.k-avatar-sm {\n    width: 1rem;\n    height: 1rem;\n    flex-basis: 1rem;\n}\n\n.k-avatar-md {\n    width: 2rem;\n    height: 2rem;\n    flex-basis: 2rem;\n}\n\n.k-avatar-lg {\n    width: 4rem;\n    height: 4rem;\n    flex-basis: 4rem;\n}\n\n.k-avatar-bordered {\n    border-width: 1px;\n}\n\n.k-avatar-solid-primary {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-avatar-solid-secondary {\n    border-color: #6c757d;\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-avatar-solid-tertiary {\n    border-color: #6f42c1;\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-avatar-solid-info {\n    border-color: #0dcaf0;\n    color: white;\n    background-color: #0dcaf0;\n}\n\n.k-avatar-solid-success {\n    border-color: #198754;\n    color: white;\n    background-color: #198754;\n}\n\n.k-avatar-solid-warning {\n    border-color: #ffc107;\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-avatar-solid-error {\n    border-color: #dc3545;\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-avatar-solid-dark {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-avatar-solid-light {\n    border-color: #f8f9fa;\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-avatar-solid-inverse {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-avatar-outline {\n    border-color: currentColor;\n}\n\n.k-avatar-outline-primary {\n    color: #0d6efd;\n}\n\n.k-avatar-outline-secondary {\n    color: #6c757d;\n}\n\n.k-avatar-outline-tertiary {\n    color: #6f42c1;\n}\n\n.k-avatar-outline-info {\n    color: #0dcaf0;\n}\n\n.k-avatar-outline-success {\n    color: #198754;\n}\n\n.k-avatar-outline-warning {\n    color: #ffc107;\n}\n\n.k-avatar-outline-error {\n    color: #dc3545;\n}\n\n.k-avatar-outline-dark {\n    color: #212529;\n}\n\n.k-avatar-outline-light {\n    color: #f8f9fa;\n}\n\n.k-avatar-outline-inverse {\n    color: #212529;\n}\n\n.k-badge {\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    border-color: transparent;\n    box-sizing: border-box;\n    color: inherit;\n    background-color: transparent;\n    font: inherit;\n    text-align: center;\n    white-space: nowrap;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-badge *,\n.k-badge *::before,\n.k-badge *::after {\n    box-sizing: border-box;\n}\n\n.k-badge > * {\n    color: inherit;\n}\n\na.k-badge,\n.k-badge > a {\n    text-decoration: none;\n}\n\na.k-badge:hover,\n.k-badge > a:hover {\n    text-decoration: underline;\n}\n\n.k-badge-icon {\n    max-width: 1em;\n    max-height: 1em;\n    font-size: inherit;\n}\n\n.k-badge-icon.k-svg-icon svg {\n    fill: currentColor;\n}\n\n.k-badge-sm {\n    padding-block: 0.175em;\n    padding-inline: 0.325em;\n    font-size: 0.75em;\n    line-height: 1;\n    min-width: calc(1.35em + 2px);\n}\n\n.k-badge-sm:empty {\n    padding: 0.175em;\n    min-width: auto;\n}\n\n.k-badge-md {\n    padding-block: 0.35em;\n    padding-inline: 0.65em;\n    font-size: 0.75em;\n    line-height: 1;\n    min-width: calc(1.7em + 2px);\n}\n\n.k-badge-md:empty {\n    padding: 0.35em;\n    min-width: auto;\n}\n\n.k-badge-lg {\n    padding-block: 0.525em;\n    padding-inline: 0.975em;\n    font-size: 0.75em;\n    line-height: 1;\n    min-width: calc(2.05em + 2px);\n}\n\n.k-badge-lg:empty {\n    padding: 0.525em;\n    min-width: auto;\n}\n\nkendo-badge-container {\n    display: inline-block;\n}\n\n.k-badge-container {\n    position: relative;\n    overflow: visible;\n}\n\n.k-badge-inside {\n    position: absolute;\n    z-index: 9999;\n}\n\n.k-badge-edge {\n    position: absolute;\n    z-index: 9999;\n}\n\n.k-badge-edge.k-top-start {\n    transform: translate(-50%, -50%);\n}\n\n.k-badge-edge.k-top-end {\n    transform: translate(50%, -50%);\n}\n\n.k-badge-edge.k-bottom-start {\n    transform: translate(-50%, 50%);\n}\n\n.k-badge-edge.k-bottom-end {\n    transform: translate(50%, 50%);\n}\n\n.k-rtl .k-badge-edge.k-top-start,\n[dir=\"rtl\"].k-badge-edge.k-top-start,\n[dir=\"rtl\"] .k-badge-edge.k-top-start {\n    transform: translate(50%, -50%);\n}\n\n.k-rtl .k-badge-edge.k-top-end,\n[dir=\"rtl\"].k-badge-edge.k-top-end,\n[dir=\"rtl\"] .k-badge-edge.k-top-end {\n    transform: translate(-50%, -50%);\n}\n\n.k-rtl .k-badge-edge.k-bottom-start,\n[dir=\"rtl\"].k-badge-edge.k-bottom-start,\n[dir=\"rtl\"] .k-badge-edge.k-bottom-start {\n    transform: translate(50%, 50%);\n}\n\n.k-rtl .k-badge-edge.k-bottom-end,\n[dir=\"rtl\"].k-badge-edge.k-bottom-end,\n[dir=\"rtl\"] .k-badge-edge.k-bottom-end {\n    transform: translate(-50%, 50%);\n}\n\n.k-badge-outside {\n    position: absolute;\n    z-index: 9999;\n}\n\n.k-badge-outside.k-top-start {\n    transform: translate(-100%, -100%);\n}\n\n.k-badge-outside.k-top-end {\n    transform: translate(100%, -100%);\n}\n\n.k-badge-outside.k-bottom-start {\n    transform: translate(-100%, 100%);\n}\n\n.k-badge-outside.k-bottom-end {\n    transform: translate(100%, 100%);\n}\n\n.k-rtl .k-badge-outside.k-top-start,\n[dir=\"rtl\"].k-badge-outside.k-top-start,\n[dir=\"rtl\"] .k-badge-outside.k-top-start {\n    transform: translate(100%, -100%);\n}\n\n.k-rtl .k-badge-outside.k-top-end,\n[dir=\"rtl\"].k-badge-outside.k-top-end,\n[dir=\"rtl\"] .k-badge-outside.k-top-end {\n    transform: translate(-100%, -100%);\n}\n\n.k-rtl .k-badge-outside.k-bottom-start,\n[dir=\"rtl\"].k-badge-outside.k-bottom-start,\n[dir=\"rtl\"] .k-badge-outside.k-bottom-start {\n    transform: translate(100%, 100%);\n}\n\n.k-rtl .k-badge-outside.k-bottom-end,\n[dir=\"rtl\"].k-badge-outside.k-bottom-end,\n[dir=\"rtl\"] .k-badge-outside.k-bottom-end {\n    transform: translate(-100%, 100%);\n}\n\n.k-badge-border-cutout {\n    box-shadow: 0 0 0 2px #ffffff;\n}\n\n.k-badge-solid-primary {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-badge-solid-secondary {\n    border-color: #6c757d;\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-badge-solid-tertiary {\n    border-color: #6f42c1;\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-badge-solid-info {\n    border-color: #0dcaf0;\n    color: white;\n    background-color: #0dcaf0;\n}\n\n.k-badge-solid-success {\n    border-color: #198754;\n    color: white;\n    background-color: #198754;\n}\n\n.k-badge-solid-warning {\n    border-color: #ffc107;\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-badge-solid-error {\n    border-color: #dc3545;\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-badge-solid-dark {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-badge-solid-light {\n    border-color: #f8f9fa;\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-badge-solid-inverse {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-badge-outline {\n    border-color: currentColor;\n    background-color: #ffffff;\n}\n\n.k-badge-outline-primary {\n    color: #0d6efd;\n}\n\n.k-badge-outline-secondary {\n    color: #6c757d;\n}\n\n.k-badge-outline-tertiary {\n    color: #6f42c1;\n}\n\n.k-badge-outline-info {\n    color: #0dcaf0;\n}\n\n.k-badge-outline-success {\n    color: #198754;\n}\n\n.k-badge-outline-warning {\n    color: #ffc107;\n}\n\n.k-badge-outline-error {\n    color: #dc3545;\n}\n\n.k-badge-outline-dark {\n    color: #212529;\n}\n\n.k-badge-outline-light {\n    color: #f8f9fa;\n}\n\n.k-badge-outline-inverse {\n    color: #212529;\n}\n\n.k-chip {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    border-width: 1px;\n    border-style: solid;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.25;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: center;\n    gap: 0.25rem;\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-chip *,\n.k-chip *::before,\n.k-chip *::after {\n    box-sizing: border-box;\n}\n\n.k-chip .k-selected-icon-wrapper {\n    display: none !important;\n}\n\n.k-chip-content {\n    padding-block: .5em;\n    padding-inline: 0;\n    margin-block: -.5em;\n    margin-inline: 0;\n    min-width: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    overflow: hidden;\n    flex: 1 1 auto;\n}\n\n.k-chip-content .k-icon-wrapper-host {\n    display: initial;\n}\n\n.k-chip-content:first-child {\n    margin-inline-start: 0.25rem;\n}\n\n.k-chip-content:last-child {\n    margin-inline-end: 0.25rem;\n}\n\n.k-chip-text,\n.k-chip-label {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    flex: 1 1 auto;\n}\n\n.k-chip-avatar {\n    border-radius: 50%;\n    background-size: cover;\n    background-position: center;\n    flex: none;\n}\n\n.k-chip-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: none;\n}\n\n.k-chip-actions {\n    margin-block: -5em;\n    margin-inline: 0;\n    flex: none;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-self: center;\n}\n\n.k-chip-action {\n    flex: none;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-self: center;\n}\n\n.k-remove-icon {\n    font-size: inherit;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: none;\n}\n\n.k-chip-list {\n    min-width: 0px;\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n    position: relative;\n}\n\n.k-chip-sm {\n    padding-block: 0.125rem;\n    padding-inline: 0.25rem;\n    font-size: 0.875rem;\n    line-height: 1.25;\n}\n\n.k-chip-sm .k-chip-action {\n    padding: 0.125rem;\n}\n\n.k-chip-avatar {\n    width: 1em;\n    height: 1em;\n    flex-basis: 1em;\n}\n\n.k-chip-md {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    font-size: 1rem;\n    line-height: 1.25;\n}\n\n.k-chip-md .k-chip-action {\n    padding: 0.25rem;\n}\n\n.k-chip-avatar {\n    width: 1em;\n    height: 1em;\n    flex-basis: 1em;\n}\n\n.k-chip-lg {\n    padding-block: 0.375rem;\n    padding-inline: 0.25rem;\n    font-size: 1rem;\n    line-height: 1.25;\n}\n\n.k-chip-lg .k-chip-action {\n    padding: 0.375rem;\n}\n\n.k-chip-avatar {\n    width: 1em;\n    height: 1em;\n    flex-basis: 1em;\n}\n\n.k-chip-list-sm {\n    gap: 0.25rem;\n}\n\n.k-chip-list-md {\n    gap: 0.25rem;\n}\n\n.k-chip-list-lg {\n    gap: 0.25rem;\n}\n\n.k-chip-solid-base {\n    border-color: #e4e7eb;\n    color: #212529;\n    background-color: #e4e7eb;\n}\n\n.k-chip-solid-base:focus, .k-chip-solid-base.k-focus {\n    box-shadow: 0 0 0 2px rgba(228, 231, 235, 0.16);\n}\n\n.k-chip-solid-base:hover, .k-chip-solid-base.k-hover {\n    background-color: #ced3db;\n}\n\n.k-chip-solid-base.k-selected {\n    background-color: #c7cdd5;\n}\n\n.k-chip-solid-error {\n    border-color: #e56874;\n    color: #4d1318;\n    background-color: #f8d7da;\n}\n\n.k-chip-solid-error:focus, .k-chip-solid-error.k-focus {\n    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.16);\n}\n\n.k-chip-solid-error:hover, .k-chip-solid-error.k-hover {\n    background-color: #f3b8be;\n}\n\n.k-chip-solid-error.k-selected {\n    background-color: #ee9aa2;\n}\n\n.k-chip-solid-info {\n    border-color: #4ad7f4;\n    color: #054754;\n    background-color: #cff4fc;\n}\n\n.k-chip-solid-info:focus, .k-chip-solid-info.k-focus {\n    box-shadow: 0 0 0 2px rgba(13, 202, 240, 0.16);\n}\n\n.k-chip-solid-info:hover, .k-chip-solid-info.k-hover {\n    background-color: #aaecfa;\n}\n\n.k-chip-solid-info.k-selected {\n    background-color: #86e5f8;\n}\n\n.k-chip-solid-warning {\n    border-color: #ffd145;\n    color: #594402;\n    background-color: #fff3cd;\n}\n\n.k-chip-solid-warning:focus, .k-chip-solid-warning.k-focus {\n    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.16);\n}\n\n.k-chip-solid-warning:hover, .k-chip-solid-warning.k-hover {\n    background-color: #ffe9a8;\n}\n\n.k-chip-solid-warning.k-selected {\n    background-color: #ffe083;\n}\n\n.k-chip-solid-success {\n    border-color: #53a57f;\n    color: #092f1d;\n    background-color: #d1e7dd;\n}\n\n.k-chip-solid-success:focus, .k-chip-solid-success.k-focus {\n    box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.16);\n}\n\n.k-chip-solid-success:hover, .k-chip-solid-success.k-hover {\n    background-color: #afd5c3;\n}\n\n.k-chip-solid-success.k-selected {\n    background-color: #8cc3aa;\n}\n\n.k-chip-outline-base {\n    border-color: #212529;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-chip-outline-base:focus, .k-chip-outline-base.k-focus {\n    box-shadow: 0 0 0 2px rgba(228, 231, 235, 0.16);\n}\n\n.k-chip-outline-base:hover, .k-chip-outline-base.k-hover {\n    color: white;\n    background-color: #212529;\n}\n\n.k-chip-outline-base.k-selected {\n    color: white;\n    background-color: #212529;\n}\n\n.k-chip-outline-error {\n    border-color: #a52834;\n    color: #a52834;\n    background-color: #ffffff;\n}\n\n.k-chip-outline-error:focus, .k-chip-outline-error.k-focus {\n    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.16);\n}\n\n.k-chip-outline-error:hover, .k-chip-outline-error.k-hover {\n    border-color: #a52834;\n    color: white;\n    background-color: #a52834;\n}\n\n.k-chip-outline-error.k-selected {\n    border-color: #a52834;\n    color: white;\n    background-color: #a52834;\n}\n\n.k-chip-outline-info {\n    border-color: #0a98b4;\n    color: #0a98b4;\n    background-color: #ffffff;\n}\n\n.k-chip-outline-info:focus, .k-chip-outline-info.k-focus {\n    box-shadow: 0 0 0 2px rgba(13, 202, 240, 0.16);\n}\n\n.k-chip-outline-info:hover, .k-chip-outline-info.k-hover {\n    border-color: #0a98b4;\n    color: white;\n    background-color: #0a98b4;\n}\n\n.k-chip-outline-info.k-selected {\n    border-color: #0a98b4;\n    color: white;\n    background-color: #0a98b4;\n}\n\n.k-chip-outline-warning {\n    border-color: #ffc107;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-chip-outline-warning:focus, .k-chip-outline-warning.k-focus {\n    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.16);\n}\n\n.k-chip-outline-warning:hover, .k-chip-outline-warning.k-hover {\n    color: #332701;\n    background-color: #ffc107;\n}\n\n.k-chip-outline-warning.k-selected {\n    color: #332701;\n    background-color: #ffc107;\n}\n\n.k-chip-outline-success {\n    border-color: #13653f;\n    color: #13653f;\n    background-color: #ffffff;\n}\n\n.k-chip-outline-success:focus, .k-chip-outline-success.k-focus {\n    box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.16);\n}\n\n.k-chip-outline-success:hover, .k-chip-outline-success.k-hover {\n    border-color: #13653f;\n    color: white;\n    background-color: #13653f;\n}\n\n.k-chip-outline-success.k-selected {\n    border-color: #13653f;\n    color: white;\n    background-color: #13653f;\n}\n\n.k-chip-outline-info {\n    border-color: #0dcaf0;\n    color: #212529;\n}\n\n.k-chip-outline-info:hover, .k-chip-outline-info.k-hover, .k-chip-outline-info.k-selected {\n    border-color: #0dcaf0;\n    color: #212529;\n    background-color: #0dcaf0;\n}\n\n.k-color-preview {\n    width: 100%;\n    height: 100%;\n    border-width: 1px;\n    border-radius: 0.375rem;\n    box-sizing: border-box;\n    border-style: solid;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-color-preview *,\n.k-color-preview *::before,\n.k-color-preview *::after {\n    box-sizing: border-box;\n}\n\n.k-coloreditor-current-color {\n    cursor: pointer;\n}\n\n.k-icon-color-preview {\n    border-width: 0;\n    border-radius: 0;\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    justify-content: center;\n    gap: 2px;\n}\n\n.k-icon-color-preview .k-color-preview-mask {\n    width: 14px;\n    height: 2px;\n}\n\n.k-color-preview-mask {\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n\n.k-color-preview-mask::before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAuSURBVHgBxYyxDQAwDMJIL+YT+DjtzFRliUfLcklqBCRT4eCTxbD6kdL2/LgYXqpvCbs3kBv/AAAAAElFTkSuQmCC\");\n    background-size: contain;\n    background-position: 0 0;\n}\n\n.k-no-color .k-color-preview-mask::before {\n    content: \"\";\n    background-color: #ffffff;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' version='1.1'%3e%3cline x1='0' x2='20' y1='0' y2='20' stroke='%23dc3545' stroke-width='1'/%3e%3c/svg%3e\");\n    background-size: 100% 100%;\n    background-position: 0 0;\n}\n\n.k-color-preview {\n    border-color: #dee2e6;\n}\n\n.k-color-preview:hover, .k-color-preview.k-hover {\n    border-color: #d6d9dc;\n}\n\n.k-loader {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    box-sizing: border-box;\n    line-height: 0;\n}\n\n.k-loader-canvas {\n    display: flex;\n    position: relative;\n}\n\n.k-loader-segment {\n    border-radius: 50%;\n    background-color: currentColor;\n    position: absolute;\n}\n\n.k-loader-sm {\n    padding: 0.125rem;\n}\n\n.k-loader-sm .k-loader-segment {\n    width: 0.25rem;\n    height: 0.25rem;\n}\n\n.k-loader-md {\n    padding: 0.25rem;\n}\n\n.k-loader-md .k-loader-segment {\n    width: 0.5rem;\n    height: 0.5rem;\n}\n\n.k-loader-lg {\n    padding: 0.5rem;\n}\n\n.k-loader-lg .k-loader-segment {\n    width: 1rem;\n    height: 1rem;\n}\n\n@keyframes pulsing-2-segment {\n    0% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.5);\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n.k-loader-pulsing-2 .k-loader-canvas {\n    align-items: center;\n}\n\n.k-loader-pulsing-2 .k-loader-segment:nth-child(1) {\n    left: 0;\n    transform: scale(1.5);\n    transform-origin: 0 50%;\n    animation: pulsing-2-segment 1s ease infinite;\n    animation-delay: -.5s;\n}\n\n.k-loader-pulsing-2 .k-loader-segment:nth-child(2) {\n    right: 0;\n    transform-origin: 100% 50%;\n    animation: pulsing-2-segment 1s ease infinite;\n}\n\n.k-loader-pulsing-2.k-loader-sm .k-loader-canvas {\n    width: 0.75rem;\n    height: 0.375rem;\n}\n\n.k-loader-pulsing-2.k-loader-md .k-loader-canvas {\n    width: 1.5rem;\n    height: 0.75rem;\n}\n\n.k-loader-pulsing-2.k-loader-lg .k-loader-canvas {\n    width: 3rem;\n    height: 1.5rem;\n}\n\n@keyframes spinner-3-segment {\n    0% {\n        top: 0;\n        left: 50%;\n    }\n    33.3333% {\n        top: 100%;\n        left: 0;\n    }\n    66.6666% {\n        top: 100%;\n        left: 100%;\n    }\n    100% {\n        top: 0;\n        left: 50%;\n    }\n}\n\n.k-loader-spinner-3 .k-loader-segment {\n    transform: translate(-50%, -50%);\n}\n\n.k-loader-spinner-3 .k-loader-segment:nth-child(1) {\n    top: 0;\n    left: 50%;\n    animation: spinner-3-segment 2s ease infinite;\n}\n\n.k-loader-spinner-3 .k-loader-segment:nth-child(2) {\n    top: 100%;\n    left: 0;\n    animation: spinner-3-segment 2s ease infinite;\n    animation-delay: -0.6666666667s;\n}\n\n.k-loader-spinner-3 .k-loader-segment:nth-child(3) {\n    top: 100%;\n    left: 100%;\n    animation: spinner-3-segment 2s ease infinite;\n    animation-delay: -1.3333333333s;\n}\n\n.k-loader-spinner-3.k-loader-sm .k-loader-canvas {\n    margin: 0.125rem;\n    width: 0.75rem;\n    height: 0.6160254038rem;\n}\n\n.k-loader-spinner-3.k-loader-md .k-loader-canvas {\n    margin: 0.25rem;\n    width: 1.5rem;\n    height: 1.2320508076rem;\n}\n\n.k-loader-spinner-3.k-loader-lg .k-loader-canvas {\n    margin: 0.5rem;\n    width: 3rem;\n    height: 2.4641016152rem;\n}\n\n@keyframes spinner-4-segment-1 {\n    0% {\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n    33.3% {\n        top: 0;\n        left: 0;\n        transform: translateX(0) translateY(0);\n    }\n    66.6% {\n        top: 0;\n        left: 0;\n        transform: translateX(0) translateY(0);\n    }\n    100% {\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n}\n\n@keyframes spinner-4-segment-2 {\n    0% {\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n    33.3% {\n        top: 0;\n        left: 100%;\n        transform: translateX(-100%) translateY(0);\n    }\n    66.6% {\n        top: 0;\n        left: 100%;\n        transform: translateX(-100%) translateY(0);\n    }\n    100% {\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n}\n\n@keyframes spinner-4-segment-3 {\n    0% {\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n    33.3% {\n        top: 100%;\n        left: 100%;\n        transform: translateX(-100%) translateY(-100%);\n    }\n    66.6% {\n        top: 100%;\n        left: 100%;\n        transform: translateX(-100%) translateY(-100%);\n    }\n    100% {\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n}\n\n@keyframes spinner-4-segment-4 {\n    0% {\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n    33.3% {\n        top: 100%;\n        left: 0;\n        transform: translateX(0) translateY(-100%);\n    }\n    66.6% {\n        top: 100%;\n        left: 0;\n        transform: translateX(0) translateY(-100%);\n    }\n    100% {\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n}\n\n@keyframes spinner-4 {\n    0% {\n        transform: rotate(0);\n    }\n    33.3% {\n        transform: rotate(0);\n    }\n    66.6% {\n        transform: rotate(180deg);\n    }\n    100% {\n        transform: rotate(180deg);\n    }\n}\n\n.k-loader-spinner-4 .k-loader-canvas {\n    animation: spinner-4 1.833s ease infinite;\n}\n\n.k-loader-spinner-4 .k-loader-segment {\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n}\n\n.k-loader-spinner-4 .k-loader-segment:nth-child(1) {\n    animation: spinner-4-segment-1 1.833s ease infinite;\n}\n\n.k-loader-spinner-4 .k-loader-segment:nth-child(2) {\n    animation: spinner-4-segment-2 1.833s ease infinite;\n}\n\n.k-loader-spinner-4 .k-loader-segment:nth-child(3) {\n    animation: spinner-4-segment-3 1.833s ease infinite;\n}\n\n.k-loader-spinner-4 .k-loader-segment:nth-child(4) {\n    animation: spinner-4-segment-4 1.833s ease infinite;\n}\n\n.k-loader-spinner-4.k-loader-sm .k-loader-canvas {\n    width: 1rem;\n    height: 1rem;\n}\n\n.k-loader-spinner-4.k-loader-md .k-loader-canvas {\n    width: 2rem;\n    height: 2rem;\n}\n\n.k-loader-spinner-4.k-loader-lg .k-loader-canvas {\n    width: 4rem;\n    height: 4rem;\n}\n\n.k-loader-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2001;\n}\n\n.k-loader-container .k-loader {\n    padding: 0;\n}\n\n.k-loader-container,\n.k-loader-container-overlay {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.k-loader-container-overlay {\n    opacity: 0.5;\n}\n\n.k-loader-container-inner {\n    display: flex;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n}\n\n.k-loader-container-panel {\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 0.375rem;\n}\n\n.k-loader-container-sm .k-loader-container-inner {\n    padding: 1rem;\n    gap: 0.25rem;\n}\n\n.k-loader-container-sm .k-loader-container-label {\n    font-size: 0.875rem;\n}\n\n.k-loader-container-md .k-loader-container-inner {\n    padding: 1.25rem;\n    gap: 0.5rem;\n}\n\n.k-loader-container-md .k-loader-container-label {\n    font-size: 1rem;\n}\n\n.k-loader-container-lg .k-loader-container-inner {\n    padding: 1.5rem;\n    gap: 0.75rem;\n}\n\n.k-loader-container-lg .k-loader-container-label {\n    font-size: 1.25rem;\n}\n\n.k-loader-top .k-loader-container-inner {\n    flex-direction: column;\n    text-align: center;\n}\n\n.k-loader-end .k-loader-container-label {\n    order: -1;\n}\n\n.k-loading-mask,\n.k-loading-image,\n.k-loading-color {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.k-loading-mask *,\n.k-loading-mask *::before,\n.k-loading-mask *::after, .k-loading-mask::before, .k-loading-mask::after,\n.k-loading-image *,\n.k-loading-image *::before,\n.k-loading-image *::after,\n.k-loading-image::before,\n.k-loading-image::after,\n.k-loading-color *,\n.k-loading-color *::before,\n.k-loading-color *::after,\n.k-loading-color::before,\n.k-loading-color::after {\n    box-sizing: border-box;\n}\n\n.k-loading-mask {\n    z-index: 100;\n}\n\n.k-loading-mask.k-opaque .k-loading-color {\n    opacity: 1;\n}\n\n.k-loading-text {\n    text-indent: -4000px;\n    text-align: center;\n    position: absolute;\n    color: currentColor;\n}\n\n.k-loading-image {\n    z-index: 2;\n    color: currentColor;\n}\n\n.k-loading-color {\n    background-color: #ffffff;\n    opacity: 0.3;\n}\n\n.k-i-loading::before,\n.k-loading-image::before {\n    border-color: currentColor;\n    border-right-color: transparent !important;\n}\n\n.k-i-loading::after,\n.k-loading-image::after {\n    display: none !important;\n}\n\n.k-loading-image::before {\n    border-width: 0.25rem;\n}\n\n.k-loader-primary {\n    color: #0d6efd;\n}\n\n.k-loader-secondary {\n    color: #212529;\n}\n\n.k-loader-tertiary {\n    color: #6f42c1;\n}\n\n.k-loader-info {\n    color: #0dcaf0;\n}\n\n.k-loader-success {\n    color: #198754;\n}\n\n.k-loader-warning {\n    color: #ffc107;\n}\n\n.k-loader-error {\n    color: #dc3545;\n}\n\n.k-loader-dark {\n    color: #212529;\n}\n\n.k-loader-light {\n    color: #f8f9fa;\n}\n\n.k-loader-inverse {\n    color: #212529;\n}\n\n.k-loader-container-panel {\n    background-color: #ffffff;\n    border-color: #dee2e6;\n}\n\n.k-loader-container-inner .k-text-secondary,\n.k-loader-container-inner .\\!k-text-secondary {\n    color: #212529 !important;\n}\n\n.k-skeleton, .k-placeholder-line {\n    display: block;\n}\n\n.k-skeleton-text, .k-placeholder-line {\n    border-radius: 0.375rem;\n    transform: scale(1, 0.6);\n}\n\n.k-skeleton-text:empty::before, .k-placeholder-line:empty::before {\n    content: \"\\200b\";\n}\n\n.k-skeleton-rect {\n    border-radius: 0;\n}\n\n.k-skeleton-circle {\n    border-radius: 9999px;\n}\n\n@keyframes k-skeleton-wave {\n    0% {\n        transform: translateX(-100%);\n    }\n    60% {\n        transform: translateX(100%);\n    }\n    100% {\n        transform: translateX(100%);\n    }\n}\n\n.k-skeleton-wave .k-skeleton, .k-skeleton-wave .k-placeholder-line, .k-skeleton-wave.k-skeleton, .k-skeleton-wave.k-placeholder-line {\n    position: relative;\n    overflow: hidden;\n}\n\n.k-skeleton-wave .k-skeleton::after, .k-skeleton-wave .k-placeholder-line::after, .k-skeleton-wave.k-skeleton::after, .k-skeleton-wave.k-placeholder-line::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-100%);\n    animation: k-skeleton-wave 1.6s linear .5s infinite;\n}\n\n@keyframes k-skeleton-pulse {\n    0% {\n        opacity: 1;\n    }\n    50% {\n        opacity: .4;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n.k-skeleton-pulse .k-skeleton, .k-skeleton-pulse .k-placeholder-line, .k-skeleton-pulse.k-skeleton, .k-skeleton-pulse.k-placeholder-line {\n    animation: k-skeleton-pulse 1.5s ease-in-out .5s infinite;\n}\n\n.k-skeleton, .k-placeholder-line {\n    background-color: rgba(33, 37, 41, 0.2);\n}\n\n.k-skeleton-wave .k-skeleton::after, .k-skeleton-wave .k-placeholder-line::after, .k-skeleton-wave.k-skeleton::after, .k-skeleton-wave.k-placeholder-line::after {\n    background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.04), transparent);\n}\n\n.k-button {\n    box-sizing: border-box;\n    border-width: 1px;\n    border-style: solid;\n    color: inherit;\n    background: none;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    text-align: center;\n    text-decoration: none;\n    white-space: nowrap;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    vertical-align: middle;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n    outline: none;\n    -webkit-appearance: none;\n    position: relative;\n    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.k-button *,\n.k-button *::before,\n.k-button *::after {\n    box-sizing: border-box;\n}\n\n.k-button:disabled, .k-button.k-disabled {\n    outline: none;\n    cursor: default;\n    opacity: 0.65;\n    filter: grayscale(0.1);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n.k-button::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n    outline: 0;\n}\n\n.k-button:hover, .k-button:focus {\n    text-decoration: none;\n    outline: 0;\n}\n\n.k-icon-button {\n    gap: 0;\n}\n\n.k-icon-button .k-icon {\n    display: inline-flex;\n}\n\n.k-button-icon {\n    color: inherit;\n    align-self: center;\n    position: relative;\n}\n\n.k-button-sm {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    font-size: 0.875rem;\n    line-height: 1.4285714286;\n}\n\n.k-button-sm.k-icon-button {\n    padding: 0.25rem;\n}\n\n.k-button-sm.k-icon-button .k-button-icon {\n    min-width: 1.25rem;\n    min-height: 1.25rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.k-button-sm.k-icon-button .k-button-icon.k-svg-icon > svg,\n.k-button-sm.k-icon-button .k-button-icon.k-icon-md > svg {\n    width: 16px;\n    height: 16px;\n}\n\n.k-button-sm.k-icon-button .k-button-icon.k-icon-xs > svg {\n    width: 12px;\n    height: 12px;\n}\n\n.k-button-sm.k-icon-button .k-button-icon.k-icon-sm > svg {\n    width: 14px;\n    height: 14px;\n}\n\n.k-button-sm.k-icon-button .k-button-icon.k-icon-lg > svg {\n    width: 20px;\n    height: 20px;\n}\n\n.k-button-sm.k-icon-button .k-button-icon.k-icon-xl > svg {\n    width: 24px;\n    height: 24px;\n}\n\n.k-button-sm.k-icon-button .k-button-icon.k-icon-xxl > svg {\n    width: 32px;\n    height: 32px;\n}\n\n.k-button-sm.k-icon-button .k-button-icon.k-icon-xxxl > svg {\n    width: 48px;\n    height: 48px;\n}\n\n.k-button-md {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-button-md.k-icon-button {\n    padding: 0.375rem;\n}\n\n.k-button-md.k-icon-button .k-button-icon {\n    min-width: 1.5rem;\n    min-height: 1.5rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.k-button-md.k-icon-button .k-button-icon.k-svg-icon > svg,\n.k-button-md.k-icon-button .k-button-icon.k-icon-md > svg {\n    width: 16px;\n    height: 16px;\n}\n\n.k-button-md.k-icon-button .k-button-icon.k-icon-xs > svg {\n    width: 12px;\n    height: 12px;\n}\n\n.k-button-md.k-icon-button .k-button-icon.k-icon-sm > svg {\n    width: 14px;\n    height: 14px;\n}\n\n.k-button-md.k-icon-button .k-button-icon.k-icon-lg > svg {\n    width: 20px;\n    height: 20px;\n}\n\n.k-button-md.k-icon-button .k-button-icon.k-icon-xl > svg {\n    width: 24px;\n    height: 24px;\n}\n\n.k-button-md.k-icon-button .k-button-icon.k-icon-xxl > svg {\n    width: 32px;\n    height: 32px;\n}\n\n.k-button-md.k-icon-button .k-button-icon.k-icon-xxxl > svg {\n    width: 48px;\n    height: 48px;\n}\n\n.k-button-lg {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-button-lg.k-icon-button {\n    padding: 0.5rem;\n}\n\n.k-button-lg.k-icon-button .k-button-icon {\n    min-width: 1.5rem;\n    min-height: 1.5rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.k-button-lg.k-icon-button .k-button-icon.k-svg-icon > svg,\n.k-button-lg.k-icon-button .k-button-icon.k-icon-md > svg {\n    width: 16px;\n    height: 16px;\n}\n\n.k-button-lg.k-icon-button .k-button-icon.k-icon-xs > svg {\n    width: 12px;\n    height: 12px;\n}\n\n.k-button-lg.k-icon-button .k-button-icon.k-icon-sm > svg {\n    width: 14px;\n    height: 14px;\n}\n\n.k-button-lg.k-icon-button .k-button-icon.k-icon-lg > svg {\n    width: 20px;\n    height: 20px;\n}\n\n.k-button-lg.k-icon-button .k-button-icon.k-icon-xl > svg {\n    width: 24px;\n    height: 24px;\n}\n\n.k-button-lg.k-icon-button .k-button-icon.k-icon-xxl > svg {\n    width: 32px;\n    height: 32px;\n}\n\n.k-button-lg.k-icon-button .k-button-icon.k-icon-xxxl > svg {\n    width: 48px;\n    height: 48px;\n}\n\n.k-button-square {\n    aspect-ratio: 1;\n}\n\n.k-button-group {\n    margin: 0;\n    padding: 0;\n    border-width: 0;\n    box-sizing: border-box;\n    list-style: none;\n    outline: 0;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    vertical-align: middle;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-button-group > .k-button + .k-button {\n    margin-inline-start: -1px;\n}\n\n.k-button-group > .k-button:hover,\n.k-button-group > .k-button.k-hover,\n.k-button-group > .k-button:focus,\n.k-button-group > .k-button.k-focus,\n.k-button-group > .k-button:active,\n.k-button-group > .k-button.k-active,\n.k-button-group > .k-button.k-selected {\n    z-index: 2;\n}\n\n.k-button-group .k-button:not(:first-child):not(:last-child) {\n    border-start-end-radius: 0;\n    border-end-end-radius: 0;\n    border-start-start-radius: 0;\n    border-end-start-radius: 0;\n}\n\n.k-button-group > .k-button:first-child:not(:only-child) {\n    border-start-end-radius: 0;\n    border-end-end-radius: 0;\n}\n\n.k-button-group > .k-button:last-child:not(:only-child) {\n    border-start-start-radius: 0;\n    border-end-start-radius: 0;\n}\n\n.k-button-group:disabled, .k-button-group[disabled], .k-button-group.k-disabled {\n    opacity: 1;\n    filter: none;\n}\n\n.k-button-group-stretched {\n    width: 100%;\n}\n\n.k-button-group-stretched > * {\n    flex: 1 0 0%;\n    overflow: hidden;\n}\n\n.k-button-flat {\n    border-color: transparent !important;\n    color: inherit;\n    background: none !important;\n    box-shadow: none !important;\n}\n\n.k-button-flat::before {\n    display: block !important;\n}\n\n.k-button-flat::after {\n    box-shadow: inset 0 0 0 2px currentColor;\n    display: block !important;\n}\n\n.k-button-flat:focus::after, .k-button-flat.k-focus::after {\n    opacity: 0.12;\n}\n\n.k-button-outline {\n    border-color: currentColor;\n    color: inherit;\n    background: none;\n}\n\n.k-button-link {\n    border-color: transparent;\n    color: inherit;\n    text-decoration: none;\n    background: none;\n}\n\n.k-button-link:hover, .k-button-link.k-hover {\n    text-decoration: underline;\n}\n\n.k-button-clear {\n    border-color: transparent !important;\n    color: inherit;\n    background: none !important;\n    box-shadow: none !important;\n}\n\n.k-button-overlay, .k-button::before {\n    border-radius: inherit;\n    content: \"\";\n    background: currentColor;\n    opacity: 0;\n    display: none;\n    pointer-events: none;\n    position: absolute;\n    left: -1px;\n    right: -1px;\n    top: -1px;\n    bottom: -1px;\n    z-index: 0;\n    transition: opacity .2s ease-in-out;\n}\n\n.k-button:hover::before, .k-button.k-hover::before {\n    opacity: 0.08;\n}\n\n.k-button.k-no-focus:not(:hover)::before, .k-button.k-no-focus:not(.k-hover)::before {\n    opacity: 0;\n}\n\n.k-button:active::before, .k-button.k-active::before {\n    opacity: 0.16;\n}\n\n.k-button.k-selected::before {\n    opacity: 0.2;\n}\n\n.k-button::after {\n    border-radius: inherit;\n    content: \"\";\n    opacity: 0;\n    display: none;\n    pointer-events: none;\n    position: absolute;\n    left: -1px;\n    right: -1px;\n    top: -1px;\n    bottom: -1px;\n    z-index: 0;\n    transition: opacity .2s ease-in-out;\n}\n\n.k-button-solid-base {\n    border-color: #e4e7eb;\n    color: #212529;\n    background-color: #e4e7eb;\n}\n\n.k-button-solid-base:hover, .k-button-solid-base.k-hover {\n    border-color: #c7cdd5;\n    background-color: #ced3db;\n}\n\n.k-button-solid-base:focus, .k-button-solid-base.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-button-solid-base:active, .k-button-solid-base.k-active {\n    border-color: #bfc6d0;\n    background-color: #c7cdd5;\n}\n\n.k-button-solid-base.k-selected {\n    border-color: #0252c9;\n    color: white;\n    background-color: #0257d5;\n}\n\n.k-button-solid-primary {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-button-solid-primary:hover, .k-button-solid-primary.k-hover {\n    border-color: #0257d5;\n    background-color: #025ce2;\n}\n\n.k-button-solid-primary:focus, .k-button-solid-primary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5);\n}\n\n.k-button-solid-primary:active, .k-button-solid-primary.k-active {\n    border-color: #0252c9;\n    background-color: #0257d5;\n}\n\n.k-button-solid-primary.k-selected {\n    border-color: #0252c9;\n    background-color: #0257d5;\n}\n\n.k-button-solid-secondary {\n    border-color: #6c757d;\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-button-solid-secondary:hover, .k-button-solid-secondary.k-hover {\n    border-color: #545b62;\n    background-color: #5a6268;\n}\n\n.k-button-solid-secondary:focus, .k-button-solid-secondary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5);\n}\n\n.k-button-solid-secondary:active, .k-button-solid-secondary.k-active {\n    border-color: #4e555b;\n    background-color: #545b62;\n}\n\n.k-button-solid-secondary.k-selected {\n    border-color: #4e555b;\n    background-color: #545b62;\n}\n\n.k-button-solid-tertiary {\n    border-color: #6f42c1;\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-button-solid-tertiary:hover, .k-button-solid-tertiary.k-hover {\n    border-color: #59339d;\n    background-color: #5e37a6;\n}\n\n.k-button-solid-tertiary:focus, .k-button-solid-tertiary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5);\n}\n\n.k-button-solid-tertiary:active, .k-button-solid-tertiary.k-active {\n    border-color: #533093;\n    background-color: #59339d;\n}\n\n.k-button-solid-tertiary.k-selected {\n    border-color: #533093;\n    background-color: #59339d;\n}\n\n.k-button-solid-info {\n    border-color: #0dcaf0;\n    color: white;\n    background-color: #0dcaf0;\n}\n\n.k-button-solid-info:hover, .k-button-solid-info.k-hover {\n    border-color: #0aa1c0;\n    background-color: #0babcc;\n}\n\n.k-button-solid-info:focus, .k-button-solid-info.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5);\n}\n\n.k-button-solid-info:active, .k-button-solid-info.k-active {\n    border-color: #0a97b4;\n    background-color: #0aa1c0;\n}\n\n.k-button-solid-info.k-selected {\n    border-color: #0a97b4;\n    background-color: #0aa1c0;\n}\n\n.k-button-solid-success {\n    border-color: #198754;\n    color: white;\n    background-color: #198754;\n}\n\n.k-button-solid-success:hover, .k-button-solid-success.k-hover {\n    border-color: #115c39;\n    background-color: #136740;\n}\n\n.k-button-solid-success:focus, .k-button-solid-success.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5);\n}\n\n.k-button-solid-success:active, .k-button-solid-success.k-active {\n    border-color: #0f5133;\n    background-color: #115c39;\n}\n\n.k-button-solid-success.k-selected {\n    border-color: #0f5133;\n    background-color: #115c39;\n}\n\n.k-button-solid-warning {\n    border-color: #ffc107;\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-button-solid-warning:hover, .k-button-solid-warning.k-hover {\n    border-color: #d39e00;\n    background-color: #e0a800;\n}\n\n.k-button-solid-warning:focus, .k-button-solid-warning.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5);\n}\n\n.k-button-solid-warning:active, .k-button-solid-warning.k-active {\n    border-color: #c69500;\n    background-color: #d39e00;\n}\n\n.k-button-solid-warning.k-selected {\n    border-color: #c69500;\n    background-color: #d39e00;\n}\n\n.k-button-solid-error {\n    border-color: #dc3545;\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-button-solid-error:hover, .k-button-solid-error.k-hover {\n    border-color: #bd2130;\n    background-color: #c82333;\n}\n\n.k-button-solid-error:focus, .k-button-solid-error.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5);\n}\n\n.k-button-solid-error:active, .k-button-solid-error.k-active {\n    border-color: #b21f2d;\n    background-color: #bd2130;\n}\n\n.k-button-solid-error.k-selected {\n    border-color: #b21f2d;\n    background-color: #bd2130;\n}\n\n.k-button-solid-dark {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-solid-dark:hover, .k-button-solid-dark.k-hover {\n    border-color: #0a0c0d;\n    background-color: #101214;\n}\n\n.k-button-solid-dark:focus, .k-button-solid-dark.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);\n}\n\n.k-button-solid-dark:active, .k-button-solid-dark.k-active {\n    border-color: #050506;\n    background-color: #0a0c0d;\n}\n\n.k-button-solid-dark.k-selected {\n    border-color: #050506;\n    background-color: #0a0c0d;\n}\n\n.k-button-solid-light {\n    border-color: #f8f9fa;\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-button-solid-light:hover, .k-button-solid-light.k-hover {\n    border-color: #dae0e5;\n    background-color: #e2e6ea;\n}\n\n.k-button-solid-light:focus, .k-button-solid-light.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5);\n}\n\n.k-button-solid-light:active, .k-button-solid-light.k-active {\n    border-color: #d3d9df;\n    background-color: #dae0e5;\n}\n\n.k-button-solid-light.k-selected {\n    border-color: #d3d9df;\n    background-color: #dae0e5;\n}\n\n.k-button-solid-inverse {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-solid-inverse:hover, .k-button-solid-inverse.k-hover {\n    border-color: #0a0c0d;\n    background-color: #101214;\n}\n\n.k-button-solid-inverse:focus, .k-button-solid-inverse.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);\n}\n\n.k-button-solid-inverse:active, .k-button-solid-inverse.k-active {\n    border-color: #050506;\n    background-color: #0a0c0d;\n}\n\n.k-button-solid-inverse.k-selected {\n    border-color: #050506;\n    background-color: #0a0c0d;\n}\n\n.k-button-outline-primary {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #0d6efd;\n    background-color: transparent;\n}\n\n.k-button-outline-primary:hover, .k-button-outline-primary.k-hover {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-button-outline-primary:focus, .k-button-outline-primary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5);\n}\n\n.k-button-outline-primary:active, .k-button-outline-primary.k-active {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-button-outline-primary.k-selected {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-button-outline-secondary {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #6c757d;\n    background-color: transparent;\n}\n\n.k-button-outline-secondary:hover, .k-button-outline-secondary.k-hover {\n    border-color: #6c757d;\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-button-outline-secondary:focus, .k-button-outline-secondary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5);\n}\n\n.k-button-outline-secondary:active, .k-button-outline-secondary.k-active {\n    border-color: #6c757d;\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-button-outline-secondary.k-selected {\n    border-color: #6c757d;\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-button-outline-tertiary {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #6f42c1;\n    background-color: transparent;\n}\n\n.k-button-outline-tertiary:hover, .k-button-outline-tertiary.k-hover {\n    border-color: #6f42c1;\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-button-outline-tertiary:focus, .k-button-outline-tertiary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5);\n}\n\n.k-button-outline-tertiary:active, .k-button-outline-tertiary.k-active {\n    border-color: #6f42c1;\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-button-outline-tertiary.k-selected {\n    border-color: #6f42c1;\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-button-outline-info {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #0dcaf0;\n    background-color: transparent;\n}\n\n.k-button-outline-info:hover, .k-button-outline-info.k-hover {\n    border-color: #0dcaf0;\n    color: white;\n    background-color: #0dcaf0;\n}\n\n.k-button-outline-info:focus, .k-button-outline-info.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5);\n}\n\n.k-button-outline-info:active, .k-button-outline-info.k-active {\n    border-color: #0dcaf0;\n    color: white;\n    background-color: #0dcaf0;\n}\n\n.k-button-outline-info.k-selected {\n    border-color: #0dcaf0;\n    color: white;\n    background-color: #0dcaf0;\n}\n\n.k-button-outline-success {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #198754;\n    background-color: transparent;\n}\n\n.k-button-outline-success:hover, .k-button-outline-success.k-hover {\n    border-color: #198754;\n    color: white;\n    background-color: #198754;\n}\n\n.k-button-outline-success:focus, .k-button-outline-success.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5);\n}\n\n.k-button-outline-success:active, .k-button-outline-success.k-active {\n    border-color: #198754;\n    color: white;\n    background-color: #198754;\n}\n\n.k-button-outline-success.k-selected {\n    border-color: #198754;\n    color: white;\n    background-color: #198754;\n}\n\n.k-button-outline-warning {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #ffc107;\n    background-color: transparent;\n}\n\n.k-button-outline-warning:hover, .k-button-outline-warning.k-hover {\n    border-color: #ffc107;\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-button-outline-warning:focus, .k-button-outline-warning.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5);\n}\n\n.k-button-outline-warning:active, .k-button-outline-warning.k-active {\n    border-color: #ffc107;\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-button-outline-warning.k-selected {\n    border-color: #ffc107;\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-button-outline-error {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #dc3545;\n    background-color: transparent;\n}\n\n.k-button-outline-error:hover, .k-button-outline-error.k-hover {\n    border-color: #dc3545;\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-button-outline-error:focus, .k-button-outline-error.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5);\n}\n\n.k-button-outline-error:active, .k-button-outline-error.k-active {\n    border-color: #dc3545;\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-button-outline-error.k-selected {\n    border-color: #dc3545;\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-button-outline-dark {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #212529;\n    background-color: transparent;\n}\n\n.k-button-outline-dark:hover, .k-button-outline-dark.k-hover {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-outline-dark:focus, .k-button-outline-dark.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);\n}\n\n.k-button-outline-dark:active, .k-button-outline-dark.k-active {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-outline-dark.k-selected {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-outline-light {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #f8f9fa;\n    background-color: transparent;\n}\n\n.k-button-outline-light:hover, .k-button-outline-light.k-hover {\n    border-color: #f8f9fa;\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-button-outline-light:focus, .k-button-outline-light.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5);\n}\n\n.k-button-outline-light:active, .k-button-outline-light.k-active {\n    border-color: #f8f9fa;\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-button-outline-light.k-selected {\n    border-color: #f8f9fa;\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-button-outline-inverse {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #212529;\n    background-color: transparent;\n}\n\n.k-button-outline-inverse:hover, .k-button-outline-inverse.k-hover {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-outline-inverse:focus, .k-button-outline-inverse.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);\n}\n\n.k-button-outline-inverse:active, .k-button-outline-inverse.k-active {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-outline-inverse.k-selected {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-outline-base {\n    box-shadow: none;\n    border-color: currentColor;\n    color: #212529;\n    background-color: transparent;\n}\n\n.k-button-outline-base:hover, .k-button-outline-base.k-hover {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-outline-base:focus, .k-button-outline-base.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);\n}\n\n.k-button-outline-base:active, .k-button-outline-base.k-active {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-outline-base.k-selected {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-button-flat-primary {\n    color: #0d6efd;\n}\n\n.k-button-flat-secondary {\n    color: #6c757d;\n}\n\n.k-button-flat-tertiary {\n    color: #6f42c1;\n}\n\n.k-button-flat-info {\n    color: #0dcaf0;\n}\n\n.k-button-flat-success {\n    color: #198754;\n}\n\n.k-button-flat-warning {\n    color: #ffc107;\n}\n\n.k-button-flat-error {\n    color: #dc3545;\n}\n\n.k-button-flat-dark {\n    color: #212529;\n}\n\n.k-button-flat-light {\n    color: #f8f9fa;\n}\n\n.k-button-flat-inverse {\n    color: #212529;\n}\n\n.k-button-flat-base {\n    color: inherit;\n}\n\n.k-button-link-primary {\n    color: #0d6efd;\n}\n\n.k-button-link-primary:hover, .k-button-link-primary.k-hover {\n    color: #0b5cd5;\n}\n\n.k-button-link-primary:focus, .k-button-link-primary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(13, 110, 253, 0.5);\n}\n\n.k-button-link-primary:active, .k-button-link-primary.k-active {\n    color: #0b5cd5;\n}\n\n.k-button-link-primary.k-selected {\n    color: #0b5cd5;\n}\n\n.k-button-link-secondary {\n    color: #6c757d;\n}\n\n.k-button-link-secondary:hover, .k-button-link-secondary.k-hover {\n    color: #5b6269;\n}\n\n.k-button-link-secondary:focus, .k-button-link-secondary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(108, 117, 125, 0.5);\n}\n\n.k-button-link-secondary:active, .k-button-link-secondary.k-active {\n    color: #5b6269;\n}\n\n.k-button-link-secondary.k-selected {\n    color: #5b6269;\n}\n\n.k-button-link-tertiary {\n    color: #6f42c1;\n}\n\n.k-button-link-tertiary:hover, .k-button-link-tertiary.k-hover {\n    color: #5d37a2;\n}\n\n.k-button-link-tertiary:focus, .k-button-link-tertiary.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(111, 66, 193, 0.5);\n}\n\n.k-button-link-tertiary:active, .k-button-link-tertiary.k-active {\n    color: #5d37a2;\n}\n\n.k-button-link-tertiary.k-selected {\n    color: #5d37a2;\n}\n\n.k-button-link-info {\n    color: #0dcaf0;\n}\n\n.k-button-link-info:hover, .k-button-link-info.k-hover {\n    color: #0baaca;\n}\n\n.k-button-link-info:focus, .k-button-link-info.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(13, 202, 240, 0.5);\n}\n\n.k-button-link-info:active, .k-button-link-info.k-active {\n    color: #0baaca;\n}\n\n.k-button-link-info.k-selected {\n    color: #0baaca;\n}\n\n.k-button-link-success {\n    color: #198754;\n}\n\n.k-button-link-success:hover, .k-button-link-success.k-hover {\n    color: #157147;\n}\n\n.k-button-link-success:focus, .k-button-link-success.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(25, 135, 84, 0.5);\n}\n\n.k-button-link-success:active, .k-button-link-success.k-active {\n    color: #157147;\n}\n\n.k-button-link-success.k-selected {\n    color: #157147;\n}\n\n.k-button-link-warning {\n    color: #ffc107;\n}\n\n.k-button-link-warning:hover, .k-button-link-warning.k-hover {\n    color: #d6a206;\n}\n\n.k-button-link-warning:focus, .k-button-link-warning.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(255, 193, 7, 0.5);\n}\n\n.k-button-link-warning:active, .k-button-link-warning.k-active {\n    color: #d6a206;\n}\n\n.k-button-link-warning.k-selected {\n    color: #d6a206;\n}\n\n.k-button-link-error {\n    color: #dc3545;\n}\n\n.k-button-link-error:hover, .k-button-link-error.k-hover {\n    color: #b92d3a;\n}\n\n.k-button-link-error:focus, .k-button-link-error.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(220, 53, 69, 0.5);\n}\n\n.k-button-link-error:active, .k-button-link-error.k-active {\n    color: #b92d3a;\n}\n\n.k-button-link-error.k-selected {\n    color: #b92d3a;\n}\n\n.k-button-link-dark {\n    color: #212529;\n}\n\n.k-button-link-dark:hover, .k-button-link-dark.k-hover {\n    color: #1c1f22;\n}\n\n.k-button-link-dark:focus, .k-button-link-dark.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);\n}\n\n.k-button-link-dark:active, .k-button-link-dark.k-active {\n    color: #1c1f22;\n}\n\n.k-button-link-dark.k-selected {\n    color: #1c1f22;\n}\n\n.k-button-link-light {\n    color: #f8f9fa;\n}\n\n.k-button-link-light:hover, .k-button-link-light.k-hover {\n    color: #d0d1d2;\n}\n\n.k-button-link-light:focus, .k-button-link-light.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(248, 249, 250, 0.5);\n}\n\n.k-button-link-light:active, .k-button-link-light.k-active {\n    color: #d0d1d2;\n}\n\n.k-button-link-light.k-selected {\n    color: #d0d1d2;\n}\n\n.k-button-link-inverse {\n    color: #212529;\n}\n\n.k-button-link-inverse:hover, .k-button-link-inverse.k-hover {\n    color: #1c1f22;\n}\n\n.k-button-link-inverse:focus, .k-button-link-inverse.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);\n}\n\n.k-button-link-inverse:active, .k-button-link-inverse.k-active {\n    color: #1c1f22;\n}\n\n.k-button-link-inverse.k-selected {\n    color: #1c1f22;\n}\n\n.k-button-link-base {\n    color: #212529;\n}\n\n.k-button-link-base:hover, .k-button-link-base.k-hover {\n    color: #1c1f22;\n}\n\n.k-button-link-base:focus, .k-button-link-base.k-focus {\n    box-shadow: 0 0 0px 0.25rem rgba(33, 37, 41, 0.5);\n}\n\n.k-button-link-base:active, .k-button-link-base.k-active {\n    color: #1c1f22;\n}\n\n.k-button-link-base.k-selected {\n    color: #1c1f22;\n}\n\n.k-button-clear-primary {\n    color: #0d6efd;\n}\n\n.k-button-clear-primary:focus::after, .k-button-clear-primary.k-focus::after, .k-button-clear-primary:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-secondary {\n    color: #6c757d;\n}\n\n.k-button-clear-secondary:focus::after, .k-button-clear-secondary.k-focus::after, .k-button-clear-secondary:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-tertiary {\n    color: #6f42c1;\n}\n\n.k-button-clear-tertiary:focus::after, .k-button-clear-tertiary.k-focus::after, .k-button-clear-tertiary:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-info {\n    color: #0dcaf0;\n}\n\n.k-button-clear-info:focus::after, .k-button-clear-info.k-focus::after, .k-button-clear-info:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-success {\n    color: #198754;\n}\n\n.k-button-clear-success:focus::after, .k-button-clear-success.k-focus::after, .k-button-clear-success:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-warning {\n    color: #ffc107;\n}\n\n.k-button-clear-warning:focus::after, .k-button-clear-warning.k-focus::after, .k-button-clear-warning:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-error {\n    color: #dc3545;\n}\n\n.k-button-clear-error:focus::after, .k-button-clear-error.k-focus::after, .k-button-clear-error:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-dark {\n    color: #212529;\n}\n\n.k-button-clear-dark:focus::after, .k-button-clear-dark.k-focus::after, .k-button-clear-dark:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-light {\n    color: #f8f9fa;\n}\n\n.k-button-clear-light:focus::after, .k-button-clear-light.k-focus::after, .k-button-clear-light:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-inverse {\n    color: #212529;\n}\n\n.k-button-clear-inverse:focus::after, .k-button-clear-inverse.k-focus::after, .k-button-clear-inverse:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-button-clear-base {\n    color: #212529;\n}\n\n.k-button-clear-base:focus::after, .k-button-clear-base.k-focus::after, .k-button-clear-base:active::after {\n    background-color: currentColor;\n    opacity: 0.1;\n    display: block;\n}\n\n.k-menu-bar, .k-menu {\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    position: relative;\n    cursor: default;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-menu-bar *, .k-menu *,\n.k-menu-bar *::before,\n.k-menu *::before,\n.k-menu-bar *::after,\n.k-menu *::after {\n    box-sizing: border-box;\n}\n\n.k-menu-item {\n    border-width: 0;\n    outline: 0;\n    display: flex;\n    flex-flow: column nowrap;\n    flex: none;\n    position: relative;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-menu-item-content {\n    display: block;\n    height: auto;\n    overflow: visible;\n}\n\n.k-menu-item-content .k-actions, .k-menu-item-content .k-edit-buttons,\n.k-menu-item-content .k-action-buttons,\n.k-menu-item-content .k-columnmenu-actions, .k-menu-item-content .k-form-buttons {\n    margin-top: 0;\n}\n\n.k-menu-link {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    outline: 0;\n    color: inherit;\n    display: flex;\n    flex-flow: row nowrap;\n    flex: 1 1 auto;\n    gap: 0.5rem;\n    align-items: center;\n    position: relative;\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.k-menu-link-text {\n    display: flex;\n    flex-flow: row nowrap;\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-menu-expand-arrow {\n    margin-inline-end: -0.5rem;\n    display: inline-flex;\n    flex-flow: row wrap;\n    align-items: center;\n    flex: none;\n    position: relative;\n}\n\n.k-menu-horizontal {\n    flex-direction: row;\n}\n\n.k-menu-horizontal > .k-menu-item + .k-menu-item {\n    margin-inline-start: 0;\n}\n\n.k-menu-horizontal > .k-separator {\n    margin-block: 0;\n    margin-inline: 0.25rem;\n    width: 0;\n    height: auto;\n    border-width: 0 0 0 1px;\n    border-style: solid;\n}\n\n.k-menu-vertical {\n    flex-direction: column;\n}\n\n.k-menu-vertical > .k-menu-item + .k-menu-item {\n    margin-top: 0;\n}\n\n.k-menu-vertical > .k-menu-item > .k-menu-link {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n    padding-inline-end: calc(2rem + 16px);\n}\n\n.k-menu-vertical > .k-menu-item > .k-menu-link > .k-menu-expand-arrow {\n    margin-inline-start: 1rem;\n    margin-inline-end: calc(-1.5rem + -16px);\n}\n\n.k-menu-vertical > .k-separator {\n    margin-block: 0.25rem;\n    margin-inline: 0;\n    height: 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: #dee2e6;\n    display: block;\n}\n\n.k-menu-popup {\n    box-sizing: border-box;\n    border-width: 1px;\n    border-style: solid;\n    overflow: auto;\n    max-height: 80vh;\n}\n\n.k-menu-popup *,\n.k-menu-popup *::before,\n.k-menu-popup *::after {\n    box-sizing: border-box;\n}\n\n.k-menu-group {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-flow: column nowrap;\n    position: absolute;\n}\n\n.k-menu-group .k-menu-item + .k-menu-item {\n    margin-top: 0px;\n}\n\n.k-menu-group .k-separator {\n    margin-block: 0.25rem;\n    margin-inline: 0;\n    height: 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: #dee2e6;\n    display: block;\n}\n\n.k-menu-popup .k-menu-group {\n    position: relative;\n}\n\n.k-menu-group-sm {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-menu-group-sm .k-menu-item {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-menu-group-sm .k-menu-link {\n    padding-block: 0.125rem;\n    padding-inline: 1rem;\n    padding-inline-end: calc(2rem + 16px);\n}\n\n.k-menu-group-sm .k-menu-expand-arrow {\n    margin-inline-start: 1rem;\n    margin-inline-end: calc(-1.5rem + -16px);\n}\n\n.k-menu-group-md {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-menu-group-md .k-menu-item {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-menu-group-md .k-menu-link {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n    padding-inline-end: calc(2rem + 16px);\n}\n\n.k-menu-group-md .k-menu-expand-arrow {\n    margin-inline-start: 1rem;\n    margin-inline-end: calc(-1.5rem + -16px);\n}\n\n.k-menu-group-lg {\n    font-size: 1.25rem;\n    line-height: 1.5;\n}\n\n.k-menu-group-lg .k-menu-item {\n    font-size: 1.25rem;\n    line-height: 1.5;\n}\n\n.k-menu-group-lg .k-menu-link {\n    padding-block: 0.375rem;\n    padding-inline: 1rem;\n    padding-inline-end: calc(2rem + 16px);\n}\n\n.k-menu-group-lg .k-menu-expand-arrow {\n    margin-inline-start: 1rem;\n    margin-inline-end: calc(-1.5rem + -16px);\n}\n\n.k-popups-wrapper {\n    position: relative;\n    border: 0;\n    margin: 0;\n    padding: 0;\n}\n\n.k-context-menu {\n    margin: 0;\n    border-width: 1px;\n    border-style: solid;\n}\n\n.k-animation-container .k-context-menu.k-menu-horizontal {\n    display: flex !important;\n    flex-wrap: nowrap;\n}\n\n.k-context-menu-popup {\n    z-index: 12000;\n}\n\n.k-context-menu-popup .k-context-menu {\n    border-width: 0;\n}\n\n.k-popup .k-context-menu,\n.k-context-menu-popup .k-context-menu {\n    border-width: 0;\n}\n\n.k-menu-scroll-wrapper {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    position: relative;\n}\n\n.k-menu-scroll-wrapper .k-menu {\n    overflow: hidden;\n    flex-wrap: nowrap;\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button {\n    border-radius: 0;\n    padding: 0;\n    border-width: 0;\n    border-color: inherit;\n    color: inherit;\n    background: inherit;\n    position: absolute;\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-left {\n    top: 0;\n    inset-inline-start: 0;\n    height: 100%;\n    width: 16px;\n    border-right-width: 1px;\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-right {\n    top: 0;\n    inset-inline-end: 0;\n    height: 100%;\n    width: 16px;\n    border-left-width: 1px;\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-up {\n    top: 0;\n    inset-inline-start: 0;\n    width: 100%;\n    height: 16px;\n    border-bottom-width: 1px;\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-down {\n    bottom: 0;\n    inset-inline-start: 0;\n    width: 100%;\n    height: 16px;\n    border-top-width: 1px;\n}\n\n.k-menu.k-menu-horizontal:not(.k-context-menu) {\n    padding-block: 0.5rem;\n}\n\n.k-menu.k-menu-vertical:not(.k-context-menu) {\n    padding-block: 0.5rem;\n    padding-inline: 0;\n}\n\n.k-menu-popup .k-menu-group, .k-menu-popup\n.k-menu-vertical {\n    padding: 0;\n}\n\n.k-context-menu-popup > .k-popup:not(.k-menu-popup) {\n    padding: 0;\n}\n\n.k-context-menu-popup .k-context-menu {\n    border-radius: 0.375rem;\n}\n\n.k-context-menu-popup .k-header {\n    font-size: inherit;\n    font-weight: inherit;\n}\n\n.k-menu:not(.k-context-menu) {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-menu:not(.k-context-menu) > .k-item {\n    color: rgba(33, 37, 41, 0.5);\n}\n\n.k-menu:not(.k-context-menu) > .k-item:hover, .k-menu:not(.k-context-menu) > .k-item.k-hover {\n    color: rgba(33, 37, 41, 0.7);\n}\n\n.k-menu:not(.k-context-menu) > .k-item:active, .k-menu:not(.k-context-menu) > .k-item.k-active {\n    color: rgba(33, 37, 41, 0.9);\n}\n\n.k-menu:not(.k-context-menu) > .k-item:focus, .k-menu:not(.k-context-menu) > .k-item.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-menu-group,\n.k-menu.k-context-menu {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-menu-group .k-item > .k-link:hover, .k-menu-group .k-item > .k-link.k-hover,\n.k-menu.k-context-menu .k-item > .k-link:hover,\n.k-menu.k-context-menu .k-item > .k-link.k-hover {\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-menu-group .k-item > .k-link:active, .k-menu-group .k-item > .k-link.k-active, .k-menu-group .k-item > .k-link.k-selected,\n.k-menu.k-context-menu .k-item > .k-link:active,\n.k-menu.k-context-menu .k-item > .k-link.k-active,\n.k-menu.k-context-menu .k-item > .k-link.k-selected {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-menu-group .k-item:focus > .k-link,\n.k-menu-group .k-item.k-focus > .k-link,\n.k-menu.k-context-menu .k-item:focus > .k-link,\n.k-menu.k-context-menu .k-item.k-focus > .k-link {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button {\n    border-color: #dee2e6;\n    color: rgba(33, 37, 41, 0.5);\n    background-color: #f8f9fa;\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button:hover {\n    color: rgba(33, 37, 41, 0.7);\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button:hover::before {\n    opacity: 0;\n}\n\n.k-toolbar {\n    margin: 0;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    list-style: none;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    justify-content: flex-start;\n    position: relative;\n    overflow: hidden;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-toolbar::before {\n    content: \"\";\n    height: calc(1.5em + 0.75rem + 2px);\n}\n\n.k-toolbar.k-toolbar-resizable {\n    flex-wrap: nowrap;\n}\n\n.k-toolbar > * {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-content: center;\n    vertical-align: middle;\n}\n\n.k-toolbar > * > label {\n    align-self: center;\n}\n\n.k-toolbar .k-input,\n.k-toolbar .k-picker {\n    width: 10em;\n}\n\n.k-toolbar .k-color-picker, .k-toolbar .k-colorpicker {\n    width: min-content;\n}\n\n.k-toolbar .k-toolbar-overflow-button {\n    margin-inline-start: auto;\n}\n\n.k-toolbar .k-separator,\n.k-toolbar .k-toolbar-separator {\n    width: 0;\n    height: 1.5em;\n    border-width: 0 0 0 1px;\n    border-style: solid;\n    align-self: center;\n}\n\n.k-toolbar .k-toolbar-spacer {\n    height: 1.5em;\n    flex: 1 0 0%;\n}\n\n.k-toolbar .k-toolbar-item:focus,\n.k-toolbar .k-toolbar-item.k-focus {\n    text-decoration: none;\n    outline: 0;\n}\n\n.k-toolbar-group {\n    display: flex;\n    flex-direction: inherit;\n    flex-wrap: nowrap;\n    gap: inherit;\n}\n\n.k-toolbar-renderer {\n    display: inline-block;\n    border-color: inherit;\n}\n\n.k-toolbar-sm {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    gap: 0.375rem;\n}\n\n.k-toolbar-sm::before {\n    margin-inline-start: -0.375rem;\n}\n\n.k-toolbar-sm > * > label {\n    margin-inline-end: 0.375rem;\n}\n\n.k-toolbar-md {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    gap: 0.5rem;\n}\n\n.k-toolbar-md::before {\n    margin-inline-start: -0.5rem;\n}\n\n.k-toolbar-md > * > label {\n    margin-inline-end: 0.5rem;\n}\n\n.k-toolbar-lg {\n    padding-block: 0.625rem;\n    padding-inline: 0.625rem;\n    gap: 0.625rem;\n}\n\n.k-toolbar-lg::before {\n    margin-inline-start: -0.625rem;\n}\n\n.k-toolbar-lg > * > label {\n    margin-inline-end: 0.625rem;\n}\n\n.k-toolbar-sm::before {\n    height: calc(1.4285714286em + 0.5rem + 2px);\n}\n\n.k-toolbar-md::before {\n    height: calc(1.5em + 0.75rem + 2px);\n}\n\n.k-toolbar-lg::before {\n    height: calc(1.5em + 1rem + 2px);\n}\n\n.k-floating-toolbar,\n.editorToolbarWindow.k-window-content {\n    padding-block: 0.5rem !important;\n    padding-inline: 0.5rem !important;\n    border-width: 1px;\n    border-style: solid;\n    display: flex;\n    flex-flow: row nowrap;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n.k-floating-toolbar .k-toolbar,\n.editorToolbarWindow.k-window-content .k-toolbar {\n    padding: 0;\n    border-width: 0;\n    flex-shrink: 1;\n    color: inherit;\n    background: none;\n}\n\n.k-editortoolbar-dragHandle {\n    cursor: move;\n    display: flex;\n    align-items: center;\n    align-self: stretch;\n    flex-shrink: 0;\n}\n\n.k-overflow-container {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-overflow-container > .k-item {\n    border-color: inherit;\n}\n\n.k-overflow-container .k-separator {\n    margin: 0.25rem 0;\n}\n\n.k-overflow-container .k-overflow-tool-group {\n    display: block;\n}\n\n.k-overflow-container .k-overflow-button {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n    width: 100%;\n    height: auto;\n    border-width: 0;\n    border-radius: 0;\n    aspect-ratio: auto;\n    color: inherit;\n    background-color: transparent;\n    background-image: none;\n    font: inherit;\n    cursor: pointer;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: center;\n    gap: 0.5rem;\n    justify-content: flex-start;\n    position: relative;\n}\n\n.k-overflow-container .k-button-group {\n    box-shadow: none;\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-overflow-container .k-button-group .k-button {\n    margin: 0;\n}\n\n.k-overflow-container .k-split-button {\n    display: flex;\n    flex-direction: column;\n}\n\n.k-overflow-container .k-overflow-hidden {\n    display: none;\n}\n\n.k-toolbar.k-toolbar-flat {\n    border-width: 1px 0;\n    border-top-color: transparent !important;\n    border-bottom-color: inherit;\n    color: inherit;\n    background: none !important;\n    box-shadow: none;\n}\n\n.k-toolbar {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-toolbar .k-separator,\n.k-toolbar .k-toolbar-separator {\n    border-color: inherit;\n}\n\n.k-toolbar .k-toolbar-item:focus,\n.k-toolbar .k-toolbar-item.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-floating-toolbar,\n.editorToolbarWindow.k-window-content {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-overflow-container .k-button:hover, .k-overflow-container .k-button.k-hover {\n    color: #212529;\n    background: #e9ecef;\n}\n\n.k-overflow-container .k-button:focus, .k-overflow-container .k-button.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-overflow-container .k-button:active, .k-overflow-container .k-button.k-active {\n    color: #212529;\n    background: #e9ecef;\n}\n\n.k-overflow-container .k-button.k-selected {\n    color: white;\n    background: #0d6efd;\n}\n\n.k-overflow-container .k-button:disabled, .k-overflow-container .k-button.k-disabled {\n    color: inherit;\n}\n\n.k-actions, .k-edit-buttons,\n.k-action-buttons,\n.k-columnmenu-actions, .k-form-buttons {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    box-sizing: border-box;\n    border-width: 0px 0 0 0;\n    border-style: solid;\n    border-color: inherit;\n    flex-shrink: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    gap: 0.5rem;\n    overflow: hidden;\n    clear: both;\n}\n\n.k-actions *, .k-edit-buttons *, .k-action-buttons *, .k-columnmenu-actions *, .k-form-buttons *,\n.k-actions *::before,\n.k-edit-buttons *::before,\n.k-action-buttons *::before,\n.k-columnmenu-actions *::before,\n.k-form-buttons *::before,\n.k-actions *::after,\n.k-edit-buttons *::after,\n.k-action-buttons *::after,\n.k-columnmenu-actions *::after,\n.k-form-buttons *::after {\n    box-sizing: border-box;\n}\n\n.k-popup .k-actions, .k-popup .k-edit-buttons,\n.k-popup .k-action-buttons,\n.k-popup .k-columnmenu-actions, .k-popup .k-form-buttons {\n    margin-top: 1rem;\n}\n\n.k-actions-start {\n    justify-content: flex-start;\n}\n\n.k-actions-center {\n    justify-content: center;\n}\n\n.k-actions-end {\n    justify-content: flex-end;\n}\n\n.k-actions-stretched > * {\n    flex: 1 0 0%;\n}\n\n.k-actions-horizontal {\n    width: 100%;\n    flex-flow: row nowrap;\n}\n\n.k-actions-vertical {\n    flex-flow: column nowrap;\n}\n\n.k-form,\n.k-form-inline {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-fieldset {\n    margin: 30px;\n    border-width: 1px 0 0;\n    border-style: solid;\n    padding: 25px 0 0;\n}\n\n.k-fieldset > legend {\n    margin-left: 0;\n    padding: 0 1rem 0 0;\n    text-transform: uppercase;\n}\n\nkendo-label > .k-label {\n    margin: 0;\n}\n\n.k-label-optional {\n    margin-left: 6px;\n    font-size: 0.75rem;\n    font-style: italic;\n    align-self: center;\n}\n\n.k-label-empty::before {\n    content: \"\";\n    display: inline-block;\n}\n\n.k-input-label {\n    margin-right: 10px;\n    z-index: 1;\n}\n\n.k-input-label:dir(rtl),\n.k-rtl .k-input-label, .k-input-label.k-rtl,\n[dir=\"rtl\"] .k-input-label, .k-input-label[dir=\"rtl\"] {\n    margin-right: 0;\n    margin-left: 10px;\n}\n\n.k-form {\n    border: 0;\n}\n\n.k-form .k-form-field > .k-label,\n.k-form .k-form-field > kendo-label,\n.k-form .k-form-label {\n    margin-bottom: 0.5rem;\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.k-form .k-label + .k-radio {\n    margin-left: 0;\n}\n\n.k-form .k-form-fieldset {\n    margin: 2rem 0 0;\n    padding: 0px;\n    border: 0;\n}\n\n.k-form .k-form-fieldset > *:not(.k-hidden):first-child,\n.k-form .k-form-fieldset > *.k-hidden + :not(.k-hidden) {\n    margin-top: 0;\n}\n\n.k-form .k-form-legend {\n    margin: 0 0 1rem;\n    padding: 0px;\n    border-width: 0 0 2px;\n    border-style: solid;\n    width: 100%;\n    font-size: 0.875rem;\n    text-transform: uppercase;\n}\n\n.k-form .k-form-group {\n    padding: 0;\n}\n\n.k-form > *:not(.k-hidden):first-child,\n.k-form > *.k-hidden + :not(.k-hidden) {\n    margin-top: 0;\n}\n\n.k-form .k-form-field,\n.k-form .k-form-field-wrap {\n    display: block;\n}\n\n.k-form .k-form-field-disabled .k-label,\n.k-form .k-form-field-disabled .k-form-label {\n    outline: none;\n    cursor: default;\n    opacity: 0.65;\n    filter: grayscale(0.1);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n.k-form .k-alert-error {\n    font-size: 0.875rem;\n    margin-top: 1rem;\n}\n\n.k-form .k-field-info {\n    display: inline-block;\n    font-size: 0.75rem;\n    line-height: 1;\n    margin-block: 0;\n    margin-inline: 1rem;\n}\n\n.k-form .k-multiselect,\n.k-form .k-floating-label-container,\n.k-form .k-daterangepicker .k-dateinput,\n.k-form .k-signature {\n    display: inline-flex;\n    width: 100%;\n}\n\n.k-form-buttons {\n    padding: 0;\n    overflow: visible;\n}\n\n.k-form-hint,\n.k-form-error {\n    margin-top: 4px;\n    display: flex;\n    font-size: 0.75rem;\n    font-style: normal;\n}\n\n.k-text-start,\n.k-buttons-start {\n    justify-content: flex-start;\n}\n\n.k-text-end,\n.k-buttons-end {\n    justify-content: flex-end;\n}\n\n.k-form-separator {\n    margin: 1rem 0 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    display: block;\n    flex: 0 0 auto;\n}\n\n.k-form-horizontal .k-form-field {\n    display: flex;\n}\n\n.k-form-horizontal .k-form-field > .k-label,\n.k-form-horizontal .k-form-field > kendo-label,\n.k-form-horizontal .k-form-field > .k-form-label {\n    margin-right: 10px;\n    padding-top: 5px;\n    width: 25%;\n    text-align: end;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-start;\n}\n\n.k-form-horizontal .k-form-field .k-label-optional {\n    margin: 0;\n    align-self: inherit;\n}\n\n.k-form-horizontal .k-form-field-wrap {\n    max-width: calc(75% - 10px);\n    flex: 1 1 auto;\n}\n\n.k-form [dir=\"rtl\"] .k-label-optional,\n.k-rtl .k-form .k-label-optional {\n    margin-left: 0;\n    margin-right: 6px;\n}\n\n.k-form-horizontal [dir=\"rtl\"].k-form-field > .k-label,\n.k-form-horizontal [dir=\"rtl\"].k-form-field > kendo-label,\n.k-form-horizontal [dir=\"rtl\"].k-form-field > .k-form-label,\n.k-form-horizontal [dir=\"rtl\"] .k-form-field > .k-label,\n.k-form-horizontal [dir=\"rtl\"] .k-form-field > kendo-label,\n.k-form-horizontal [dir=\"rtl\"] .k-form-field > .k-form-label,\n.k-rtl .k-form-horizontal.k-form-field > .k-label,\n.k-rtl .k-form-horizontal.k-form-field > kendo-label,\n.k-rtl .k-form-horizontal.k-form-field > .k-form-label,\n.k-rtl .k-form-horizontal .k-form-field > .k-label,\n.k-rtl .k-form-horizontal .k-form-field > kendo-label,\n.k-rtl .k-form-horizontal .k-form-field > .k-form-label {\n    margin-right: 0;\n    margin-left: 10px;\n}\n\n.k-form-sm .k-form-field,\n.k-form-sm .k-form-buttons {\n    margin-top: 1rem;\n}\n\n.k-form-md .k-form-field,\n.k-form-md .k-form-buttons {\n    margin-top: 1rem;\n}\n\n.k-form-lg .k-form-field,\n.k-form-lg .k-form-buttons {\n    margin-top: 1rem;\n}\n\n.k-form-inline {\n    padding: 2rem;\n}\n\n.k-form-inline fieldset {\n    border-width: 1px 0 0;\n    border-style: solid;\n    margin: 4rem 0;\n    padding: 0;\n}\n\n.k-form-inline fieldset:first-child:first-of-type {\n    margin-top: 0;\n}\n\n.k-form-inline fieldset:last-child:last-of-type {\n    margin-bottom: 0;\n}\n\n.k-form-inline legend {\n    font-size: 0.875rem;\n    text-align: start;\n    font-weight: 600;\n    line-height: 1;\n    margin-bottom: 1.5rem;\n    text-transform: uppercase;\n    padding: 0 1rem 0 0;\n    width: auto;\n}\n\n.k-form-inline .k-form-field {\n    display: flex;\n    align-items: flex-start;\n    text-align: start;\n    margin-bottom: 1.5rem;\n}\n\n.k-form-inline .k-form-field > span:not(.k-widget) {\n    width: 25%;\n    text-align: end;\n    line-height: 1.5;\n    padding: calc(0.5rem + 1px) 0;\n    padding-right: 1.5rem;\n    align-self: center;\n}\n\n.k-form-inline .k-form-field > input {\n    align-self: center;\n}\n\n.k-form-inline .k-form-field > input:not(.k-checkbox):not(.k-radio) {\n    flex: 1 1 auto;\n}\n\n.k-form-inline .k-form-field .k-alert-error {\n    font-size: 0.875rem;\n    margin-top: 1rem;\n}\n\n.k-form-inline .k-form-field .k-field-info {\n    display: block;\n    font-size: 0.75rem;\n    line-height: 1;\n    margin: 0;\n}\n\n.k-form-inline .k-form-field:last-child {\n    margin-bottom: 0;\n}\n\n.k-edit-form-container {\n    width: 400px;\n    min-width: 400px;\n    border-color: inherit;\n    position: relative;\n}\n\n.k-popup-edit-form > .k-actions, .k-popup-edit-form > .k-edit-buttons,\n.k-popup-edit-form > .k-action-buttons,\n.k-popup-edit-form > .k-columnmenu-actions, .k-popup-edit-form > .k-form-buttons,\n.k-edit-form-container .k-actions,\n.k-edit-form-container .k-edit-buttons,\n.k-edit-form-container .k-action-buttons,\n.k-edit-form-container .k-columnmenu-actions,\n.k-edit-form-container .k-form-buttons {\n    margin: 1rem -1rem -1rem;\n}\n\n.k-edit-label {\n    margin: 0 0 1rem 0;\n    padding: calc(0.375rem + 1px) 0;\n    width: 30%;\n    line-height: 1.5;\n    text-align: end;\n    float: left;\n    clear: both;\n}\n\n.k-edit-field {\n    margin: 0 0 1rem 0;\n    width: 65%;\n    float: right;\n    clear: right;\n    position: relative;\n}\n\n.k-edit-field.k-no-editor {\n    padding: calc(0.375rem + 1px) 0;\n}\n\n.k-edit-field > .k-widget {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.k-edit-field input[type=\"radio\"]:not(.k-radio),\n.k-edit-field input[type=\"checkbox\"]:not(.k-checkbox) {\n    margin-right: .4ex;\n}\n\n.k-edit-field .k-radio-label,\n.k-edit-field .k-checkbox-label {\n    margin-right: 1rem;\n}\n\n.k-edit-field > .k-reset > li + li {\n    margin-top: 0.5rem;\n}\n\n.k-edit-field .k-reset .k-widget {\n    margin: 0 .4ex 0 1ex;\n}\n\n.k-form legend,\n.k-form-inline legend {\n    font-size: 1.5rem;\n    font-weight: normal;\n    line-height: 1.5;\n    text-transform: none;\n}\n\n.k-form .k-field-info,\n.k-form-inline .k-field-info {\n    opacity: .7;\n}\n\n.k-form legend {\n    margin-bottom: 0.5rem;\n}\n\n.k-form .k-field-info {\n    margin-block: 0;\n    margin-inline: 0.5rem;\n}\n\n.k-form-inline legend {\n    margin-bottom: 0;\n}\n\n.k-form-inline .k-form-field > span:not(.k-widget) {\n    padding: calc(0.5rem - 1px) 0;\n    padding-right: 1rem;\n}\n\n.k-edit-label {\n    padding: calc(0.5rem - 1px) 0;\n}\n\n.k-form,\n.k-form-inline {\n    color: #212529;\n}\n\n.k-form .k-form-legend,\n.k-form-inline .k-form-legend {\n    border-color: #dee2e6;\n}\n\n.k-form .k-field-info,\n.k-form-inline .k-field-info {\n    color: #6c757d;\n}\n\n.k-form .k-alert-error,\n.k-form-inline .k-alert-error {\n    color: #dc3545;\n}\n\n.k-form-error,\n.k-text-error,\n.k-form-field-error .k-label {\n    color: #dc3545;\n}\n\n.k-form-separator {\n    border-color: #dee2e6;\n}\n\n.k-tooltip {\n    border-radius: 0.375rem;\n    margin: 0;\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    background-repeat: repeat-x;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 0.875rem;\n    line-height: 1.5;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: flex-start;\n    position: absolute;\n    z-index: 12000;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-tooltip *,\n.k-tooltip *::before,\n.k-tooltip *::after {\n    box-sizing: border-box;\n}\n\n.k-tooltip-icon {\n    margin-inline-end: 0.5rem;\n    flex-shrink: 0;\n}\n\n.k-tooltip-title {\n    margin-bottom: .25em;\n    font-size: 1.09375rem;\n    line-height: 1;\n}\n\n.k-tooltip-content {\n    align-self: stretch;\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-tooltip-button {\n    margin-inline-start: 0.5rem;\n    flex-shrink: 0;\n}\n\n.k-tooltip-button .k-icon {\n    color: inherit;\n    vertical-align: top;\n}\n\n.k-callout {\n    width: 0.8rem;\n    height: 0.8rem;\n    border-width: 0.4rem;\n    border-style: solid;\n    border-color: transparent;\n    position: absolute;\n    pointer-events: none;\n}\n\n.k-callout-n {\n    margin-left: -0.4rem;\n    border-bottom-color: currentColor;\n    top: -0.8rem;\n    left: 50%;\n    pointer-events: none;\n}\n\n.k-callout-e {\n    margin-top: -0.4rem;\n    border-left-color: currentColor;\n    top: 50%;\n    right: -0.8rem;\n    pointer-events: none;\n}\n\n.k-callout-s {\n    margin-left: -0.4rem;\n    border-top-color: currentColor;\n    bottom: -0.8rem;\n    left: 50%;\n    pointer-events: none;\n}\n\n.k-callout-w {\n    margin-top: -0.4rem;\n    border-right-color: currentColor;\n    top: 50%;\n    left: -0.8rem;\n    pointer-events: none;\n}\n\n.k-tooltip {\n    border-color: #000000;\n    color: white;\n    background-color: #000000;\n    box-shadow: var(--kendo-elevation-2, 0px 2px 7px rgba(0, 0, 0, 0.075));\n}\n\n.k-tooltip .k-callout {\n    color: #000000;\n}\n\n.k-tooltip-inverse {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-tooltip-inverse .k-callout {\n    color: #212529;\n}\n\n.k-tooltip-light {\n    border-color: #f8f9fa;\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-tooltip-light .k-callout {\n    color: #f8f9fa;\n}\n\n.k-tooltip-dark {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-tooltip-dark .k-callout {\n    color: #212529;\n}\n\n.k-tooltip-error {\n    border-color: #dc3545;\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-tooltip-error .k-callout {\n    color: #dc3545;\n}\n\n.k-tooltip-warning {\n    border-color: #ffc107;\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-tooltip-warning .k-callout {\n    color: #ffc107;\n}\n\n.k-tooltip-success {\n    border-color: #198754;\n    color: white;\n    background-color: #198754;\n}\n\n.k-tooltip-success .k-callout {\n    color: #198754;\n}\n\n.k-tooltip-info {\n    border-color: #0dcaf0;\n    color: white;\n    background-color: #0dcaf0;\n}\n\n.k-tooltip-info .k-callout {\n    color: #0dcaf0;\n}\n\n.k-tooltip-tertiary {\n    border-color: #6f42c1;\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-tooltip-tertiary .k-callout {\n    color: #6f42c1;\n}\n\n.k-tooltip-secondary {\n    border-color: #6c757d;\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-tooltip-secondary .k-callout {\n    color: #6c757d;\n}\n\n.k-tooltip-primary {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-tooltip-primary .k-callout {\n    color: #0d6efd;\n}\n\n.k-validator-tooltip {\n    margin-top: 0.4rem;\n    width: auto;\n    white-space: normal;\n    display: flex;\n    align-items: center;\n    z-index: 9999;\n}\n\n.k-grid .k-validator-tooltip {\n    max-width: 300px;\n}\n\n.k-input,\n.k-picker {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    border-width: 1px;\n    border-style: solid;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    font-weight: normal;\n    text-align: start;\n    box-shadow: none;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: stretch;\n    vertical-align: middle;\n    position: relative;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-appearance: none;\n}\n\n.k-input *,\n.k-input *::before,\n.k-input *::after,\n.k-picker *,\n.k-picker *::before,\n.k-picker *::after {\n    box-sizing: border-box;\n}\n\n.k-input > .k-input,\n.k-input > .k-picker,\n.k-picker > .k-input,\n.k-picker > .k-picker {\n    border-width: 0 !important;\n    color: inherit;\n    background: none;\n    font: inherit;\n    outline: 0;\n    box-shadow: none;\n}\n\n.k-input > *,\n.k-picker > * {\n    margin: 0;\n}\n\n.k-input:-ms-input-placeholder, .k-picker:-ms-input-placeholder {\n    color: #6c757d;\n    opacity: 1;\n    -ms-user-select: none;\n        user-select: none;\n}\n\n.k-input::placeholder,\n.k-picker::placeholder {\n    color: #6c757d;\n    opacity: 1;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\ninput.k-input,\ntextarea.k-textarea {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n}\n\ninput.k-input:disabled, input.k-input[disabled],\ntextarea.k-textarea:disabled,\ntextarea.k-textarea[disabled] {\n    outline: none;\n    cursor: default;\n    opacity: 0.65;\n    filter: grayscale(0.1);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n[disabled] input.k-input:disabled,\n.k-disabled input.k-input:disabled, [disabled] input.k-input[disabled],\n.k-disabled input.k-input[disabled], [disabled]\ntextarea.k-textarea:disabled,\n.k-disabled\ntextarea.k-textarea:disabled, [disabled]\ntextarea.k-textarea[disabled],\n.k-disabled\ntextarea.k-textarea[disabled] {\n    opacity: 1;\n    filter: grayscale(0);\n}\n\ntextarea.k-textarea {\n    overflow: auto;\n}\n\n.k-picker {\n    cursor: pointer;\n}\n\nselect.k-picker {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n    appearance: auto;\n}\n\nselect.k-picker:disabled, select.k-picker[disabled] {\n    outline: none;\n    cursor: default;\n    opacity: 0.65;\n    filter: grayscale(0.1);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n[disabled] select.k-picker:disabled,\n.k-disabled select.k-picker:disabled, [disabled] select.k-picker[disabled],\n.k-disabled select.k-picker[disabled] {\n    opacity: 1;\n    filter: grayscale(0);\n}\n\n.k-input-inner {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n    width: 100%;\n    border: 0;\n    outline: 0;\n    color: inherit;\n    background: none;\n    font: inherit;\n    flex: 1;\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-appearance: none;\n}\n\n.k-input-inner:-ms-input-placeholder {\n    color: #6c757d;\n    opacity: 1;\n    -ms-user-select: none;\n        user-select: none;\n}\n\n.k-input-inner::placeholder {\n    color: #6c757d;\n    opacity: 1;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-input-inner:invalid {\n    box-shadow: none;\n}\n\nspan.k-input-inner {\n    white-space: nowrap;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n}\n\ntextarea.k-input-inner {\n    margin: 0;\n}\n\n.k-input-value-icon {\n    flex: none;\n}\n\n.k-input-value-text {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-input-value-text::before {\n    content: \"\\200b\";\n    width: 0px;\n    overflow: hidden;\n    flex: none;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.k-input-values {\n    min-width: 0px;\n    width: 100%;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    cursor: text;\n}\n\n.k-input-values .k-chip-list {\n    display: contents;\n}\n\n.k-icon-picker .k-input-inner {\n    padding: 0.375rem;\n    justify-content: center;\n}\n\n.k-input-prefix,\n.k-input-suffix {\n    border-color: inherit;\n    display: flex;\n    align-items: center;\n    flex: none;\n}\n\n.k-input-prefix > *,\n.k-input-suffix > * {\n    flex-shrink: 0;\n    border: none;\n}\n\n.k-input-prefix-vertical,\n.k-input-suffix-vertical {\n    flex-flow: column wrap;\n}\n\n.k-input-prefix-horizontal,\n.k-input-suffix-horizontal {\n    flex-flow: row wrap;\n}\n\n.k-input-separator {\n    margin: 0;\n    border-style: solid;\n    border-color: inherit;\n    border-width: 0 0 0 1px;\n    height: 16px;\n    align-self: center;\n}\n\n.k-input-separator-horizontal {\n    height: auto;\n    margin-inline: 0.375rem;\n    align-self: stretch;\n    border-width: 1px 0 0;\n}\n\n.k-input-separator-vertical {\n    height: auto;\n    margin-block: 0.375rem;\n    align-self: stretch;\n    border-width: 0 0 0 1px;\n}\n\n.k-input-icon,\n.k-input-validation-icon,\n.k-input-loading-icon {\n    flex: none;\n    align-self: center;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: center;\n    box-sizing: content-box;\n}\n\n.k-input-loading-icon {\n    width: 1em;\n    height: 1em;\n    font-size: 16px;\n}\n\n.k-input-icon.k-svg-icon > svg,\n.k-input-icon.k-icon-md > svg,\n.k-input-validation-icon.k-svg-icon > svg,\n.k-input-validation-icon.k-icon-md > svg,\n.k-input-loading-icon.k-svg-icon > svg,\n.k-input-loading-icon.k-icon-md > svg {\n    width: 16px;\n    height: 16px;\n}\n\n.k-input-icon.k-icon-xs > svg,\n.k-input-validation-icon.k-icon-xs > svg,\n.k-input-loading-icon.k-icon-xs > svg {\n    width: 12px;\n    height: 12px;\n}\n\n.k-input-icon.k-icon-sm > svg,\n.k-input-validation-icon.k-icon-sm > svg,\n.k-input-loading-icon.k-icon-sm > svg {\n    width: 14px;\n    height: 14px;\n}\n\n.k-input-icon.k-icon-lg > svg,\n.k-input-validation-icon.k-icon-lg > svg,\n.k-input-loading-icon.k-icon-lg > svg {\n    width: 20px;\n    height: 20px;\n}\n\n.k-input-icon.k-icon-xl > svg,\n.k-input-validation-icon.k-icon-xl > svg,\n.k-input-loading-icon.k-icon-xl > svg {\n    width: 24px;\n    height: 24px;\n}\n\n.k-input-icon.k-icon-xxl > svg,\n.k-input-validation-icon.k-icon-xxl > svg,\n.k-input-loading-icon.k-icon-xxl > svg {\n    width: 32px;\n    height: 32px;\n}\n\n.k-input-icon.k-icon-xxxl > svg,\n.k-input-validation-icon.k-icon-xxxl > svg,\n.k-input-loading-icon.k-icon-xxxl > svg {\n    width: 48px;\n    height: 48px;\n}\n\n.k-clear-value {\n    outline: 0;\n    flex: none;\n    align-self: center;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    opacity: 0.5;\n}\n\n.k-clear-value:hover,\n.k-clear-value.k-hover {\n    opacity: 1;\n}\n\n.k-clear-value:focus-visible {\n    outline: 1px dotted;\n    outline-offset: -1px;\n}\n\n.k-input-button {\n    width: auto;\n    border-width: 0;\n    border-inline-start-width: 1px;\n    flex: none;\n    aspect-ratio: auto;\n    box-shadow: none;\n}\n\n.k-input-button > .k-button-icon {\n    min-width: auto !important;\n}\n\n.k-input-button:focus {\n    box-shadow: none;\n}\n\n.k-picker .k-input-button {\n    color: inherit;\n    background: none;\n    border-color: transparent;\n}\n\n.k-input-spinner {\n    width: auto;\n    flex: none;\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-input-spinner .k-spinner-increase,\n.k-input-spinner .k-spinner-decrease {\n    border-width: 0;\n    border-inline-start-width: 1px;\n    flex: 1 1 50%;\n    box-shadow: none;\n    position: relative;\n    aspect-ratio: auto;\n}\n\n.k-input-spinner .k-spinner-increase .k-button-icon,\n.k-input-spinner .k-spinner-decrease .k-button-icon {\n    margin-block: -1em;\n    margin-inline: 0;\n    min-width: auto !important;\n    min-height: auto !important;\n}\n\n.k-input-spinner .k-spinner-increase .k-icon {\n    bottom: auto;\n}\n\n.k-input-spinner .k-spinner-decrease .k-icon {\n    top: auto;\n}\n\n.k-searchbar {\n    flex: 1 1 auto;\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.k-picker-wrap,\n.k-dropdown-wrap,\n.k-dateinput-wrap,\n.k-multiselect-wrap,\n.k-numeric-wrap {\n    width: 100%;\n    border-width: 0;\n    border-color: inherit;\n    box-sizing: border-box;\n    flex: 1 1 auto;\n    display: flex;\n    flex-flow: row nowrap;\n    overflow: hidden;\n    position: relative;\n}\n\n.k-input-flat,\n.k-picker-flat {\n    border-bottom-right-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n    border-width: 1px 0;\n    border-top-color: transparent !important;\n    background-image: none !important;\n}\n\n.k-input-outline {\n    background: none !important;\n}\n\n.k-input-sm,\n.k-picker-sm {\n    font-size: 0.875rem;\n    line-height: 1.4285714286;\n}\n\n.k-input-sm .k-input-values,\n.k-picker-sm .k-input-values {\n    padding: 0.125rem;\n    gap: 0.125rem;\n}\n\n.k-input-sm .k-input-values > .k-searchbar,\n.k-input-sm .k-input-values > .k-input-inner,\n.k-picker-sm .k-input-values > .k-searchbar,\n.k-picker-sm .k-input-values > .k-input-inner {\n    margin: -0.125rem;\n}\n\n.k-input-sm .k-input-inner,\n.k-picker-sm .k-input-inner {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n}\n\n.k-input-sm .k-input-button,\n.k-input-sm .k-spinner-increase,\n.k-input-sm .k-spinner-decrease,\n.k-picker-sm .k-input-button,\n.k-picker-sm .k-spinner-increase,\n.k-picker-sm .k-spinner-decrease {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-input-sm .k-input-icon,\n.k-input-sm .k-input-validation-icon,\n.k-input-sm .k-input-loading-icon,\n.k-input-sm .k-clear-value,\n.k-input-sm .k-input-prefix > .k-icon,\n.k-input-sm .k-input-prefix > .k-input-prefix-text,\n.k-input-sm .k-input-suffix > .k-icon,\n.k-input-sm .k-input-suffix > .k-input-suffix-text,\n.k-picker-sm .k-input-icon,\n.k-picker-sm .k-input-validation-icon,\n.k-picker-sm .k-input-loading-icon,\n.k-picker-sm .k-clear-value,\n.k-picker-sm .k-input-prefix > .k-icon,\n.k-picker-sm .k-input-prefix > .k-input-prefix-text,\n.k-picker-sm .k-input-suffix > .k-icon,\n.k-picker-sm .k-input-suffix > .k-input-suffix-text {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    box-sizing: content-box;\n}\n\n.k-input-sm .k-input-separator-horizontal,\n.k-picker-sm .k-input-separator-horizontal {\n    margin-inline: 0.25rem;\n}\n\n.k-input-sm .k-input-separator-vertical,\n.k-picker-sm .k-input-separator-vertical {\n    margin-block: 0.25rem;\n}\n\n.k-input-sm.k-icon-picker .k-input-inner,\n.k-picker-sm.k-icon-picker .k-input-inner {\n    width: 1.4285714286em;\n    height: 1.4285714286em;\n    padding: 0.25rem;\n    box-sizing: content-box;\n}\n\n.k-dropdown-operator.k-picker-sm .k-input-button {\n    padding: 0.25rem;\n}\n\nselect.k-picker-sm {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n}\n\n.k-input-md,\n.k-picker-md {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-input-md .k-input-values,\n.k-picker-md .k-input-values {\n    padding: 0.1875rem;\n    gap: 0.1875rem;\n}\n\n.k-input-md .k-input-values > .k-searchbar,\n.k-input-md .k-input-values > .k-input-inner,\n.k-picker-md .k-input-values > .k-searchbar,\n.k-picker-md .k-input-values > .k-input-inner {\n    margin: -0.1875rem;\n}\n\n.k-input-md .k-input-inner,\n.k-picker-md .k-input-inner {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n}\n\n.k-input-md .k-input-button,\n.k-input-md .k-spinner-increase,\n.k-input-md .k-spinner-decrease,\n.k-picker-md .k-input-button,\n.k-picker-md .k-spinner-increase,\n.k-picker-md .k-spinner-decrease {\n    padding-block: 0.375rem;\n    padding-inline: 0.375rem;\n}\n\n.k-input-md .k-input-icon,\n.k-input-md .k-input-validation-icon,\n.k-input-md .k-input-loading-icon,\n.k-input-md .k-clear-value,\n.k-input-md .k-input-prefix > .k-icon,\n.k-input-md .k-input-prefix > .k-input-prefix-text,\n.k-input-md .k-input-suffix > .k-icon,\n.k-input-md .k-input-suffix > .k-input-suffix-text,\n.k-picker-md .k-input-icon,\n.k-picker-md .k-input-validation-icon,\n.k-picker-md .k-input-loading-icon,\n.k-picker-md .k-clear-value,\n.k-picker-md .k-input-prefix > .k-icon,\n.k-picker-md .k-input-prefix > .k-input-prefix-text,\n.k-picker-md .k-input-suffix > .k-icon,\n.k-picker-md .k-input-suffix > .k-input-suffix-text {\n    padding-block: 0.375rem;\n    padding-inline: 0.375rem;\n    box-sizing: content-box;\n}\n\n.k-input-md .k-input-separator-horizontal,\n.k-picker-md .k-input-separator-horizontal {\n    margin-inline: 0.375rem;\n}\n\n.k-input-md .k-input-separator-vertical,\n.k-picker-md .k-input-separator-vertical {\n    margin-block: 0.375rem;\n}\n\n.k-input-md.k-icon-picker .k-input-inner,\n.k-picker-md.k-icon-picker .k-input-inner {\n    width: 1.5em;\n    height: 1.5em;\n    padding: 0.375rem;\n    box-sizing: content-box;\n}\n\n.k-dropdown-operator.k-picker-md .k-input-button {\n    padding: 0.375rem;\n}\n\nselect.k-picker-md {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n}\n\n.k-input-lg,\n.k-picker-lg {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-input-lg .k-input-values,\n.k-picker-lg .k-input-values {\n    padding: 0.25rem;\n    gap: 0.25rem;\n}\n\n.k-input-lg .k-input-values > .k-searchbar,\n.k-input-lg .k-input-values > .k-input-inner,\n.k-picker-lg .k-input-values > .k-searchbar,\n.k-picker-lg .k-input-values > .k-input-inner {\n    margin: -0.25rem;\n}\n\n.k-input-lg .k-input-inner,\n.k-picker-lg .k-input-inner {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n}\n\n.k-input-lg .k-input-button,\n.k-input-lg .k-spinner-increase,\n.k-input-lg .k-spinner-decrease,\n.k-picker-lg .k-input-button,\n.k-picker-lg .k-spinner-increase,\n.k-picker-lg .k-spinner-decrease {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-input-lg .k-input-icon,\n.k-input-lg .k-input-validation-icon,\n.k-input-lg .k-input-loading-icon,\n.k-input-lg .k-clear-value,\n.k-input-lg .k-input-prefix > .k-icon,\n.k-input-lg .k-input-prefix > .k-input-prefix-text,\n.k-input-lg .k-input-suffix > .k-icon,\n.k-input-lg .k-input-suffix > .k-input-suffix-text,\n.k-picker-lg .k-input-icon,\n.k-picker-lg .k-input-validation-icon,\n.k-picker-lg .k-input-loading-icon,\n.k-picker-lg .k-clear-value,\n.k-picker-lg .k-input-prefix > .k-icon,\n.k-picker-lg .k-input-prefix > .k-input-prefix-text,\n.k-picker-lg .k-input-suffix > .k-icon,\n.k-picker-lg .k-input-suffix > .k-input-suffix-text {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    box-sizing: content-box;\n}\n\n.k-input-lg .k-input-separator-horizontal,\n.k-picker-lg .k-input-separator-horizontal {\n    margin-inline: 0.5rem;\n}\n\n.k-input-lg .k-input-separator-vertical,\n.k-picker-lg .k-input-separator-vertical {\n    margin-block: 0.5rem;\n}\n\n.k-input-lg.k-icon-picker .k-input-inner,\n.k-picker-lg.k-icon-picker .k-input-inner {\n    width: 1.5em;\n    height: 1.5em;\n    padding: 0.5rem;\n    box-sizing: content-box;\n}\n\n.k-dropdown-operator.k-picker-lg .k-input-button {\n    padding: 0.5rem;\n}\n\nselect.k-picker-lg {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n}\n\n.k-input > kendo-popup,\n.k-picker > kendo-popup {\n    position: fixed;\n}\n\n@keyframes autoFillStart {\n    from {\n    }\n    to {\n    }\n}\n\n@keyframes autoFillEnd {\n    from {\n    }\n    to {\n    }\n}\n\n.k-autofill:-webkit-autofill {\n    animation-name: autoFillStart;\n}\n\n.k-autofill:not(:-webkit-autofill) {\n    animation-name: autoFillEnd;\n}\n\n.k-input:-webkit-autofill {\n    animation-name: autoFillStart;\n}\n\n.k-input:not(:-webkit-autofill) {\n    animation-name: autoFillEnd;\n}\n\n.k-textbox {\n    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.k-input-solid {\n    border-color: #ced4da;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-input-solid:focus, .k-input-solid.k-focus {\n    border-color: #86b7fe;\n    color: #212529;\n    background-color: #ffffff;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-input-solid:focus-within {\n    border-color: #86b7fe;\n    color: #212529;\n    background-color: #ffffff;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-input-solid.k-invalid, .k-input-solid.ng-invalid.ng-touched, .k-input-solid.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-input-solid.k-invalid .k-input-validation-icon, .k-input-solid.ng-invalid.ng-touched .k-input-validation-icon, .k-input-solid.ng-invalid.ng-dirty .k-input-validation-icon {\n    color: #dc3545;\n}\n\n.k-input-solid.k-invalid:focus, .k-input-solid.k-invalid.k-focus, .k-input-solid.ng-invalid.ng-touched:focus, .k-input-solid.ng-invalid.ng-touched.k-focus, .k-input-solid.ng-invalid.ng-dirty:focus, .k-input-solid.ng-invalid.ng-dirty.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-input-solid.k-invalid:focus-within, .k-input-solid.ng-invalid.ng-touched:focus-within, .k-input-solid.ng-invalid.ng-dirty:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-input-solid .k-input-prefix {\n    color: #6c757d;\n}\n\n.k-input-solid .k-input-suffix {\n    color: #6c757d;\n}\n\n.k-input-solid .k-input-separator {\n    border-color: #dee2e6;\n}\n\n.k-picker-solid {\n    border-color: #e4e7eb;\n    color: #212529;\n    background-color: #e4e7eb;\n}\n\n.k-picker-solid:hover, .k-picker-solid.k-hover {\n    border-color: #c7cdd5;\n    background-color: #ced3db;\n}\n\n.k-picker-solid:focus, .k-picker-solid.k-focus {\n    border-color: #bfc6d0;\n    background-color: #c7cdd5;\n    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-picker-solid:focus-within {\n    border-color: #bfc6d0;\n    background-color: #c7cdd5;\n    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-picker-solid.k-invalid, .k-picker-solid.ng-invalid.ng-touched, .k-picker-solid.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-picker-solid.k-invalid .k-input-validation-icon, .k-picker-solid.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-solid.ng-invalid.ng-dirty .k-input-validation-icon {\n    color: #dc3545;\n}\n\n.k-picker-solid.k-invalid:focus, .k-picker-solid.k-invalid.k-focus, .k-picker-solid.ng-invalid.ng-touched:focus, .k-picker-solid.ng-invalid.ng-touched.k-focus, .k-picker-solid.ng-invalid.ng-dirty:focus, .k-picker-solid.ng-invalid.ng-dirty.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-picker-solid.k-invalid:focus-within, .k-picker-solid.ng-invalid.ng-touched:focus-within, .k-picker-solid.ng-invalid.ng-dirty:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-input-outline {\n    border-color: rgba(33, 37, 41, 0.5);\n    color: #212529;\n}\n\n.k-input-outline > .k-input-button {\n    border-color: inherit;\n}\n\n.k-input-outline > .k-input-spinner {\n    border-color: inherit;\n}\n\n.k-input-outline > .k-input-spinner > .k-spinner-increase,\n.k-input-outline > .k-input-spinner > .k-spinner-decrease {\n    border-color: inherit;\n}\n\n.k-input-outline:focus, .k-input-outline.k-focus {\n    border-color: #86b7fe;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-input-outline:focus-within {\n    border-color: #86b7fe;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-input-outline.k-invalid, .k-input-outline.ng-invalid.ng-touched, .k-input-outline.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-input-outline.k-invalid .k-input-validation-icon, .k-input-outline.ng-invalid.ng-touched .k-input-validation-icon, .k-input-outline.ng-invalid.ng-dirty .k-input-validation-icon {\n    color: #dc3545;\n}\n\n.k-input-outline.k-invalid:focus, .k-input-outline.k-invalid.k-focus, .k-input-outline.ng-invalid.ng-touched:focus, .k-input-outline.ng-invalid.ng-touched.k-focus, .k-input-outline.ng-invalid.ng-dirty:focus, .k-input-outline.ng-invalid.ng-dirty.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-input-outline.k-invalid:focus-within, .k-input-outline.ng-invalid.ng-touched:focus-within, .k-input-outline.ng-invalid.ng-dirty:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-input-outline .k-input-prefix {\n    color: #6c757d;\n}\n\n.k-input-outline .k-input-suffix {\n    color: #6c757d;\n}\n\n.k-input-outline .k-input-separator {\n    border-color: #dee2e6;\n}\n\n.k-picker-outline {\n    border-color: rgba(33, 37, 41, 0.5);\n    color: #212529;\n}\n\n.k-picker-outline:hover, .k-picker-outline.k-hover {\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-picker-outline:focus, .k-picker-outline.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-picker-outline:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-picker-outline.k-invalid, .k-picker-outline.ng-invalid.ng-touched, .k-picker-outline.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-picker-outline.k-invalid .k-input-validation-icon, .k-picker-outline.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-outline.ng-invalid.ng-dirty .k-input-validation-icon {\n    color: #dc3545;\n}\n\n.k-picker-outline.k-invalid:focus, .k-picker-outline.k-invalid.k-focus, .k-picker-outline.ng-invalid.ng-touched:focus, .k-picker-outline.ng-invalid.ng-touched.k-focus, .k-picker-outline.ng-invalid.ng-dirty:focus, .k-picker-outline.ng-invalid.ng-dirty.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-picker-outline.k-invalid:focus-within, .k-picker-outline.ng-invalid.ng-touched:focus-within, .k-picker-outline.ng-invalid.ng-dirty:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-input-flat {\n    border-color: #ced4da;\n    color: #212529;\n}\n\n.k-input-flat:focus, .k-input-flat.k-focus {\n    border-color: #86b7fe;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-input-flat:focus-within {\n    border-color: #86b7fe;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-input-flat.k-invalid, .k-input-flat.ng-invalid.ng-touched, .k-input-flat.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-input-flat.k-invalid .k-input-validation-icon, .k-input-flat.ng-invalid.ng-touched .k-input-validation-icon, .k-input-flat.ng-invalid.ng-dirty .k-input-validation-icon {\n    color: #dc3545;\n}\n\n.k-input-flat.k-invalid:focus, .k-input-flat.k-invalid.k-focus, .k-input-flat.ng-invalid.ng-touched:focus, .k-input-flat.ng-invalid.ng-touched.k-focus, .k-input-flat.ng-invalid.ng-dirty:focus, .k-input-flat.ng-invalid.ng-dirty.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-input-flat.k-invalid:focus-within, .k-input-flat.ng-invalid.ng-touched:focus-within, .k-input-flat.ng-invalid.ng-dirty:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-input-flat .k-input-prefix {\n    color: #6c757d;\n}\n\n.k-input-flat .k-input-suffix {\n    color: #6c757d;\n}\n\n.k-input-flat .k-input-separator {\n    border-color: #dee2e6;\n}\n\n.k-picker-flat {\n    border-color: #e4e7eb;\n    color: #212529;\n}\n\n.k-picker-flat:hover, .k-picker-flat.k-hover {\n    background-color: rgba(33, 37, 41, 0.08);\n}\n\n.k-picker-flat:focus, .k-picker-flat.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-picker-flat:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-picker-flat.k-invalid, .k-picker-flat.ng-invalid.ng-touched, .k-picker-flat.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-picker-flat.k-invalid .k-input-validation-icon, .k-picker-flat.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-flat.ng-invalid.ng-dirty .k-input-validation-icon {\n    color: #dc3545;\n}\n\n.k-picker-flat.k-invalid:focus, .k-picker-flat.k-invalid.k-focus, .k-picker-flat.ng-invalid.ng-touched:focus, .k-picker-flat.ng-invalid.ng-touched.k-focus, .k-picker-flat.ng-invalid.ng-dirty:focus, .k-picker-flat.ng-invalid.ng-dirty.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-picker-flat.k-invalid:focus-within, .k-picker-flat.ng-invalid.ng-touched:focus-within, .k-picker-flat.ng-invalid.ng-dirty:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.k-floating-label-container {\n    padding-top: 1.5rem;\n    box-sizing: border-box;\n    display: inline-flex;\n    vertical-align: middle;\n    position: relative;\n    flex-direction: column;\n    justify-content: stretch;\n}\n\n.k-floating-label-container *,\n.k-floating-label-container *::before,\n.k-floating-label-container *::after {\n    box-sizing: border-box;\n}\n\n.k-floating-label-container > .k-label {\n    max-width: 90%;\n    font-size: 1rem;\n    line-height: 1.5;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    position: absolute;\n    top: var(--kendo-floating-label-offset-y, calc(1.875rem + 1px));\n    left: var(--kendo-floating-label-offset-x, calc(0.75rem + 1px));\n    overflow: hidden;\n    cursor: text;\n    transform-origin: left center;\n    transition: transform 0.2s ease-out, color 0.2s ease-out, top 0.2s ease-out, left 0.2s ease-out;\n}\n\n.k-floating-label-container > .k-widget {\n    flex: 1 1 auto;\n    width: auto;\n}\n\n.k-floating-label-container.k-empty > .k-label {\n    top: var(--kendo-floating-label-offset-y, calc(1.875rem + 1px));\n    left: var(--kendo-floating-label-offset-x, calc(0.75rem + 1px));\n    transform: scale(1);\n    pointer-events: none;\n}\n\n.k-floating-label-container > .k-label,\n.k-floating-label-container.k-focus > .k-label {\n    top: var(--kendo-floating-label-focus-offset-y, 0);\n    left: var(--kendo-floating-label-focus-offset-x, 0);\n    transform: scale(1);\n}\n\n.k-floating-label-container:focus-within > .k-label {\n    top: var(--kendo-floating-label-focus-offset-y, 0);\n    left: var(--kendo-floating-label-focus-offset-x, 0);\n    transform: scale(1);\n}\n\n.k-floating-label-container.k-empty:not(.k-focus):not(:focus-within) :-ms-input-placeholder {\n    color: transparent;\n}\n\n.k-floating-label-container.k-empty:not(.k-focus):not(:focus-within) ::placeholder {\n    color: transparent;\n}\n\n[dir=\"rtl\"] .k-floating-label-container > .k-label,\n.k-rtl .k-floating-label-container > .k-label, .k-floating-label-container[dir=\"rtl\"] > .k-label {\n    transform-origin: right center;\n    transition: transform 0.2s ease-out, color 0.2s ease-out, top 0.2s ease-out, right 0.2s ease-out;\n}\n\n[dir=\"rtl\"] .k-floating-label-container.k-empty > .k-label,\n.k-rtl .k-floating-label-container.k-empty > .k-label, .k-floating-label-container[dir=\"rtl\"].k-empty > .k-label {\n    left: auto;\n    right: var(--kendo-floating-label-offset-x, calc(0.75rem + 1px));\n}\n\n[dir=\"rtl\"] .k-floating-label-container > .k-label,\n[dir=\"rtl\"] .k-floating-label-container.k-focus > .k-label,\n.k-rtl .k-floating-label-container > .k-label,\n.k-rtl .k-floating-label-container.k-focus > .k-label, .k-floating-label-container[dir=\"rtl\"] > .k-label,\n.k-floating-label-container[dir=\"rtl\"].k-focus > .k-label {\n    left: auto;\n    right: var(--kendo-floating-label-focus-offset-x, 0);\n}\n\n[dir=\"rtl\"] .k-floating-label-container:focus-within > .k-label,\n.k-rtl .k-floating-label-container:focus-within > .k-label, .k-floating-label-container[dir=\"rtl\"]:focus-within > .k-label {\n    left: auto;\n    right: var(--kendo-floating-label-focus-offset-x, 0);\n}\n\n.k-floating-label-container.k-invalid > .k-label,\n.k-floating-label-container.ng-invalid.ng-touched > .k-label,\n.k-floating-label-container.ng-invalid.ng-dirty > .k-label {\n    color: #dc3545;\n}\n\n.k-split-button .k-split-button-arrow {\n    padding-block: 0.375rem;\n    padding-inline: 0.375rem;\n    width: auto;\n    aspect-ratio: auto;\n    flex: none;\n}\n\n.k-split-button .k-split-button-arrow.k-button-sm {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-split-button .k-split-button-arrow.k-button-md {\n    padding-block: 0.375rem;\n    padding-inline: 0.375rem;\n}\n\n.k-split-button .k-split-button-arrow.k-button-lg {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-split-button .k-split-button-arrow .k-button-icon {\n    min-width: 0;\n}\n\n.k-split-button:focus,\n.k-split-button.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-menu-button,\n.k-dropdown-button {\n    aspect-ratio: auto;\n    outline: 0;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    vertical-align: middle;\n}\n\n.k-menu-button > .k-button-arrow,\n.k-dropdown-button > .k-button-arrow {\n    margin-inline-start: -0.375rem;\n    margin-inline-end: -0.75rem;\n    padding-left: 0.375rem;\n    padding-right: 0.375rem;\n    flex: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.k-menu-button.k-icon-button > .k-button-arrow,\n.k-dropdown-button.k-icon-button > .k-button-arrow {\n    margin-inline-start: 0;\n    margin-inline-end: -0.375rem;\n}\n\n.k-textarea:has(.k-input-inner[style*=\"width\"]) {\n    width: max-content;\n}\n\n.k-listbox {\n    width: 10em;\n    height: 200px;\n    border-width: 0;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    vertical-align: top;\n    background-color: transparent;\n    display: inline-flex;\n    gap: 0.5rem;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-listbox .k-listbox-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.k-listbox.k-listbox-actions-left, .k-listbox.k-listbox-actions-right {\n    flex-direction: row;\n}\n\n.k-listbox.k-listbox-actions-left .k-listbox-actions, .k-listbox.k-listbox-actions-right .k-listbox-actions {\n    flex-direction: column;\n}\n\n.k-listbox.k-listbox-actions-right {\n    flex-direction: row-reverse;\n}\n\n.k-listbox.k-listbox-actions-top, .k-listbox.k-listbox-actions-bottom {\n    flex-direction: column;\n}\n\n.k-listbox.k-listbox-actions-top .k-listbox-actions, .k-listbox.k-listbox-actions-bottom .k-listbox-actions {\n    flex-direction: row;\n}\n\n.k-listbox.k-listbox-actions-bottom {\n    flex-direction: column-reverse;\n}\n\n.k-listbox .k-list-scroller {\n    width: 100%;\n    min-height: 0;\n    height: inherit;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-listbox .k-list-scroller .k-list-scroller {\n    border-width: 0;\n}\n\n.k-listbox .k-list-scroller .k-list {\n    height: inherit;\n    background: transparent;\n}\n\n.k-listbox .k-drop-hint {\n    border-top-width: 1px;\n    border-top-style: solid;\n}\n\n.k-listbox .k-ghost {\n    opacity: .5;\n}\n\n.k-item {\n    cursor: default;\n}\n\n.k-listbox .k-list-scroller {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-listbox .k-drop-hint {\n    border-top-color: #0d6efd;\n}\n\n.k-progressbar {\n    border-radius: 0.375rem;\n    --kendo-progressbar-value: 0;\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 0.75rem;\n    line-height: 1;\n    display: inline-grid;\n    vertical-align: middle;\n    position: relative;\n    overflow: hidden;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-progressbar *,\n.k-progressbar *::before,\n.k-progressbar *::after {\n    box-sizing: border-box;\n}\n\n.k-progressbar > .k-progressbar-value {\n    border-width: 0;\n    border-style: solid;\n    display: flex;\n    overflow: hidden;\n    grid-column: 1 / -1;\n    grid-row: 1 / -1;\n}\n\n.k-progressbar > .k-progressbar-chunks {\n    border-width: inherit;\n    border-style: inherit;\n    white-space: nowrap;\n    display: flex;\n    align-items: stretch;\n    flex: 1;\n    gap: 1px;\n    grid-column: 1 / -1;\n    grid-row: 1 / -1;\n}\n\n.k-progressbar .k-progressbar-chunk {\n    display: block;\n    border-width: 0;\n    flex: 1;\n}\n\n.k-progress-status-wrap {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    grid-column: 1 / -1;\n    grid-row: 1 / -1;\n}\n\n.k-progress-status-wrap.k-progress-start {\n    justify-content: flex-start;\n}\n\n.k-progress-status-wrap.k-progress-center {\n    justify-content: center;\n}\n\n.k-progress-status-wrap.k-progress-end {\n    justify-content: flex-end;\n}\n\n.k-progress-status {\n    padding-block: 0;\n    padding-inline: 0.5rem;\n    min-width: 10px;\n    text-align: center;\n    display: inline-block;\n    white-space: nowrap;\n}\n\n.k-progressbar-horizontal {\n    width: 100%;\n    height: var(--kendo-progressbar-height, 1rem);\n    grid-template-columns: 1fr;\n    grid-template-rows: 100%;\n}\n\n.k-progressbar-horizontal .k-progress-status-wrap {\n    flex-direction: row;\n}\n\n.k-progressbar-horizontal > .k-progressbar-value {\n    width: calc(var( --kendo-progressbar-value, 0 )*1%);\n    flex-direction: row;\n}\n\n.k-progressbar-horizontal > .k-progressbar-value > .k-progress-status-wrap {\n    width: calc(100%*(100/var( --kendo-progressbar-value, 1 )));\n}\n\n.k-progressbar-horizontal > .k-progressbar-chunks {\n    flex-direction: row;\n}\n\n.k-progressbar-horizontal.k-progressbar-reverse > .k-progressbar-value {\n    flex-direction: row-reverse;\n    justify-self: flex-end;\n}\n\n.k-progressbar-horizontal.k-progressbar-reverse > .k-progressbar-chunks {\n    flex-direction: row-reverse;\n}\n\n.k-progressbar-vertical {\n    width: var(--kendo-progressbar-height, 1rem);\n    height: 27em;\n    grid-template-columns: 100%;\n    grid-template-rows: 1fr;\n}\n\n.k-progressbar-vertical .k-progress-status-wrap {\n    flex-direction: column-reverse;\n}\n\n.k-progressbar-vertical .k-progress-status {\n    -ms-writing-mode: tb-lr;\n        writing-mode: vertical-lr;\n}\n\n.k-progressbar-vertical > .k-progressbar-value {\n    height: calc(var( --kendo-progressbar-value, 0 )*1%);\n    flex-direction: column-reverse;\n    align-self: flex-end;\n    align-items: flex-end;\n}\n\n.k-progressbar-vertical > .k-progressbar-value > .k-progress-status-wrap {\n    height: calc(100%*(100/var( --kendo-progressbar-value, 1 )));\n}\n\n.k-progressbar-vertical > .k-progressbar-chunks {\n    flex-direction: column-reverse;\n}\n\n.k-progressbar-vertical.k-progressbar-reverse {\n    flex-direction: column;\n}\n\n.k-progressbar-vertical.k-progressbar-reverse > .k-progressbar-value {\n    flex-direction: column;\n    align-self: flex-start;\n}\n\n.k-progressbar-vertical.k-progressbar-reverse > .k-progressbar-chunks {\n    flex-direction: column;\n}\n\n.k-progressbar-indeterminate .k-progress-status-wrap,\n.k-progressbar-indeterminate .k-progressbar-value,\n.k-progressbar-indeterminate .k-progressbar-chunk {\n    display: none;\n}\n\n.telerik-blazor.k-progressbar-horizontal > .k-progressbar-value,\n.telerik-blazor.k-progressbar-horizontal > .k-progressbar-value > .k-progress-status-wrap {\n    transition: width .1s ease-in-out;\n}\n\n.k-rtl .k-progressbar,\n.k-progressbar[dir=\"rtl\"] {\n    direction: rtl;\n}\n\n.k-circular-progressbar {\n    display: inline-block;\n    text-align: start;\n    position: relative;\n}\n\n.k-circular-progressbar-surface {\n    height: 100%;\n}\n\n.k-circular-progressbar-surface > div {\n    width: 100%;\n    height: 100%;\n}\n\n.k-circular-progressbar-surface svg {\n    width: 100%;\n    height: 100%;\n}\n\n.k-circular-progressbar-scale {\n    fill: none;\n}\n\n.k-circular-progressbar-arc {\n    transform-box: fill-box;\n    transform-origin: center center;\n    transform: rotate(-90deg);\n    stroke-linecap: round;\n    fill: none;\n}\n\n.k-circular-progressbar-label {\n    position: absolute;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n}\n\n@keyframes kendo-progressbar-indeterminate-animation {\n    from {\n        background-position: 0 0;\n    }\n    to {\n        background-position: 1rem 0;\n    }\n}\n\n.k-progressbar {\n    color: black;\n    background-color: #e9ecef;\n}\n\n.k-progressbar .k-selected {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-chunk-progressbar {\n    background-color: transparent;\n}\n\n.k-progressbar-chunk {\n    background-color: #e9ecef;\n}\n\n.k-progressbar-chunk .k-selected {\n    background-color: #0d6efd;\n}\n\n.k-progressbar-indeterminate {\n    color: black;\n    background-color: #e9ecef;\n    background-image: linear-gradient(45deg, #d6d9dc 25%, transparent 25%, transparent 50%, #d6d9dc 50%, #d6d9dc 75%, transparent 75%, transparent);\n    background-size: 1rem 1rem;\n    animation: kendo-progressbar-indeterminate-animation 1s linear infinite;\n}\n\n.k-circular-progressbar-scale {\n    stroke: #e9ecef;\n}\n\n.k-circular-progressbar-arc {\n    stroke: #0d6efd;\n    transition: stroke .5s ease;\n}\n\n.k-radio {\n    border-radius: 50%;\n    margin: 0;\n    padding: 0;\n    line-height: initial;\n    border-width: 1px;\n    border-style: solid;\n    outline: 0;\n    box-sizing: border-box;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: inline-block;\n    flex: none;\n    vertical-align: middle;\n    position: relative;\n    cursor: pointer;\n    -webkit-appearance: none;\n}\n\n.k-radio:checked,\n.k-radio.k-checked {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='white'/%3e%3c/svg%3e\");\n}\n\n.k-radio:disabled,\n.k-radio.k-disabled {\n    outline: none;\n    cursor: default;\n    opacity: 0.65;\n    filter: grayscale(0.1);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n.k-radio-wrap {\n    flex: none;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    gap: 0;\n    align-items: center;\n    align-self: start;\n    vertical-align: middle;\n    position: relative;\n}\n\n.k-radio-wrap::before {\n    content: \"\\200b\";\n    width: 0px;\n    overflow: hidden;\n    flex: none;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.k-radio-label {\n    margin: 0;\n    padding: 0;\n    display: inline-flex;\n    align-items: flex-start;\n    gap: 0.25rem;\n    vertical-align: middle;\n    position: relative;\n    cursor: pointer;\n}\n\n.k-radio-label .k-ripple {\n    visibility: hidden !important;\n}\n\n.k-radio + .k-label,\n.k-radio-wrap + .k-label,\n.k-radio + .k-radio-label,\n.k-radio-wrap + .k-radio-label {\n    display: inline;\n    margin-inline-start: 0.25rem;\n}\n\n.k-radio-label:empty {\n    display: none !important;\n}\n\n.k-radio-label.k-no-text {\n    min-width: 1px;\n}\n\n.k-radio-list {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0;\n    list-style: none;\n}\n\n.k-radio-item,\n.k-radio-list-item {\n    padding-block: 0.25rem;\n    padding-inline: 0px;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: center;\n    gap: 0.25rem;\n}\n\n.k-radio-item .k-radio-label,\n.k-radio-list-item .k-radio-label {\n    margin: 0;\n}\n\n.k-radio-list-horizontal,\n.k-radio-list.k-list-horizontal {\n    display: flex;\n    flex-flow: row wrap;\n    gap: 1rem;\n}\n\n.k-ripple-container .k-radio::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    border-radius: 100%;\n    z-index: -1;\n    transition: opacity 100ms linear, transform 150ms cubic-bezier(0.4, 0, 0.2, 1);\n    transform: translate(-50%, -50%) scale(0);\n    transform-origin: center center;\n}\n\n.k-ripple-container .k-radio:focus,\n.k-ripple-container .k-radio.k-focus {\n    box-shadow: none !important;\n}\n\n.k-ripple-container .k-radio:disabled::after,\n.k-ripple-container .k-radio.k-disabled::after {\n    display: none;\n}\n\n.k-ripple-container .k-radio:disabled::after,\n.k-ripple-container .k-radio.k-disabled::after {\n    display: none;\n}\n\n.k-radio-sm {\n    width: 0.75rem;\n    height: 0.75rem;\n}\n\n.k-radio-sm::before {\n    font-size: 0.625rem;\n}\n\n.k-ripple-container .k-radio-sm::after {\n    width: 300%;\n    height: 300%;\n}\n\n.k-radio-md {\n    width: 1rem;\n    height: 1rem;\n}\n\n.k-radio-md::before {\n    font-size: 0.875rem;\n}\n\n.k-ripple-container .k-radio-md::after {\n    width: 300%;\n    height: 300%;\n}\n\n.k-radio-lg {\n    width: 1.25rem;\n    height: 1.25rem;\n}\n\n.k-radio-lg::before {\n    font-size: 1.125rem;\n}\n\n.k-ripple-container .k-radio-lg::after {\n    width: 300%;\n    height: 300%;\n}\n\n.k-radio {\n    border-color: #ced4da;\n    background-color: #ffffff;\n}\n\n.k-radio:focus,\n.k-radio.k-focus {\n    border-color: #86b7fe;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-radio.k-invalid,\n.k-radio.ng-invalid.ng-touched,\n.k-radio.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-radio.k-invalid + .k-radio-label,\n.k-radio.ng-invalid.ng-touched + .k-radio-label,\n.k-radio.ng-invalid.ng-dirty + .k-radio-label {\n    color: #dc3545;\n}\n\n.k-radio:checked,\n.k-radio.k-checked {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-radio:checked:focus,\n.k-radio.k-checked.k-focus {\n    border-color: #0d6efd;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-ripple-container .k-radio::after {\n    background: #0d6efd;\n    opacity: 0.25;\n}\n\n.k-slider {\n    border: 0;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    background: none;\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-slider *,\n.k-slider *::before,\n.k-slider *::after {\n    box-sizing: border-box;\n}\n\n.k-slider .k-label {\n    width: auto;\n    font-size: .92em;\n    line-height: 1;\n    white-space: nowrap;\n    position: absolute;\n}\n\n.k-slider .k-tick,\n.k-slider .k-slider-track {\n    cursor: pointer;\n}\n\n.k-slider .k-tick {\n    background-color: transparent;\n    background-position: center center;\n    background-repeat: no-repeat;\n    margin: 0;\n    padding: 0;\n    position: relative;\n}\n\n.k-slider.k-disabled .k-tick,\n.k-slider.k-disabled .k-slider-track,\n.k-slider.k-disabled .k-draghandle {\n    cursor: default;\n}\n\n.k-slider {\n    width: min-content;\n    height: min-content;\n    gap: 7px;\n}\n\n.k-slider .k-button {\n    flex: none;\n}\n\n.k-slider .k-slider-track-wrap {\n    flex: 1 1 auto;\n    display: flex;\n    flex-flow: inherit;\n    position: relative;\n    touch-action: none;\n}\n\n.k-slider .k-slider-track-wrap .k-slider-items {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    flex: 1 1 100%;\n    display: flex;\n    flex-flow: inherit;\n    justify-content: space-between;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-slider .k-slider-track-wrap .k-tick {\n    flex: 0 0 1px;\n}\n\n.k-slider .k-slider-track-wrap .k-tick-horizontal {\n    width: 1px;\n    min-height: 100%;\n}\n\n.k-slider .k-slider-track-wrap .k-tick-vertical {\n    width: 100%;\n    min-height: 1px;\n}\n\n.k-slider .k-slider-track-wrap .k-draghandle {\n    position: absolute;\n}\n\n.k-slider-horizontal .k-slider-track-wrap {\n    height: 26px;\n}\n\n.k-slider-horizontal .k-slider-track-wrap .k-slider-track {\n    width: 100%;\n}\n\n.k-slider-horizontal .k-slider-track-wrap .k-draghandle {\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.k-slider-horizontal .k-slider-track-wrap .k-draghandle:focus,\n.k-slider-horizontal .k-slider-track-wrap .k-draghandle:active {\n    transform: translate(-50%, -50%) scale(1);\n}\n\n.k-slider-horizontal .k-slider-track-wrap .k-slider-selection {\n    width: calc((var(--kendo-slider-end, 0) - var(--kendo-slider-start, 0))*1%);\n    inset-inline-start: calc(var(--kendo-slider-start, 0)*1%);\n}\n\n.k-slider-horizontal .k-slider-track-wrap .k-draghandle-start {\n    inset-inline-start: calc(var(--kendo-slider-start, 0)*1%);\n}\n\n.k-slider-horizontal .k-slider-track-wrap .k-draghandle-end {\n    inset-inline-start: calc(var(--kendo-slider-end, 0)*1%);\n}\n\n.k-slider-vertical .k-slider-track-wrap {\n    width: 26px;\n}\n\n.k-slider-vertical .k-slider-track-wrap .k-slider-track {\n    height: 100%;\n}\n\n.k-slider-vertical .k-slider-track-wrap .k-draghandle {\n    left: 50%;\n    transform: translate(-50%, 50%);\n}\n\n.k-slider-vertical .k-slider-track-wrap .k-draghandle:focus,\n.k-slider-vertical .k-slider-track-wrap .k-draghandle:active {\n    transform: translate(-50%, 50%) scale(1);\n}\n\n.k-slider-vertical .k-slider-track-wrap .k-slider-selection {\n    bottom: calc(var(--kendo-slider-start, 0)*1%);\n    height: calc((var(--kendo-slider-end, 0) - var(--kendo-slider-start, 0))*1%);\n}\n\n.k-slider-vertical .k-slider-track-wrap .k-draghandle-start {\n    bottom: calc(var(--kendo-slider-start, 0)*1%);\n}\n\n.k-slider-vertical .k-slider-track-wrap .k-draghandle-end {\n    bottom: calc(var(--kendo-slider-end, 0)*1%);\n}\n\n.k-slider-vertical {\n    height: 200px;\n    flex-flow: column-reverse nowrap;\n}\n\n.k-slider-vertical .k-tick {\n    text-align: end;\n    margin-left: 2px;\n}\n\n.k-slider-vertical .k-slider-topleft .k-tick {\n    text-align: start;\n}\n\n.k-slider-vertical .k-tick {\n    background-position: -94px center;\n}\n\n.k-slider-vertical .k-slider-topleft .k-tick {\n    background-position: -124px center;\n}\n\n.k-slider-vertical .k-slider-bottomright .k-tick {\n    background-position: -154px center;\n}\n\n.k-slider-vertical .k-tick-large {\n    display: flex;\n    align-items: center;\n    background-position: -4px center;\n}\n\n.k-slider-vertical .k-slider-topleft .k-tick-large {\n    background-position: -34px center;\n}\n\n.k-slider-vertical .k-slider-bottomright .k-tick-large {\n    background-position: -64px center;\n}\n\n.k-slider-vertical .k-first {\n    background-position: -94px 100%;\n}\n\n.k-slider-vertical .k-tick-large.k-first {\n    background-position: -4px 100%;\n}\n\n.k-slider-vertical .k-slider-topleft .k-first {\n    background-position: -124px 100%;\n}\n\n.k-slider-vertical .k-slider-topleft .k-tick-large.k-first {\n    background-position: -34px 100%;\n}\n\n.k-slider-vertical .k-slider-bottomright .k-first {\n    background-position: -154px 100%;\n}\n\n.k-slider-vertical .k-slider-bottomright .k-tick-large.k-first {\n    background-position: -64px 100%;\n}\n\n.k-slider-vertical .k-last {\n    background-position: -94px 0;\n}\n\n.k-slider-vertical .k-tick-large.k-last {\n    background-position: -4px 0;\n}\n\n.k-slider-vertical .k-slider-topleft .k-last {\n    background-position: -124px 0;\n}\n\n.k-slider-vertical .k-slider-topleft .k-tick-large.k-last {\n    background-position: -34px 0;\n}\n\n.k-slider-vertical .k-slider-bottomright .k-last {\n    background-position: -154px 0;\n}\n\n.k-slider-vertical .k-slider-bottomright .k-tick-large.k-last {\n    background-position: -64px 0;\n}\n\n.k-slider-vertical .k-label {\n    text-align: start;\n    inset-inline-start: 120%;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.k-slider-vertical .k-first .k-label {\n    top: 100%;\n}\n\n.k-slider-vertical .k-last .k-label {\n    top: 0;\n}\n\n.k-slider-vertical .k-slider-topleft .k-label {\n    inset-inline-start: auto;\n    inset-inline-end: 120%;\n}\n\n.k-slider-horizontal {\n    width: 200px;\n    flex-flow: row nowrap;\n}\n\n.k-slider-horizontal .k-tick {\n    background-position: center -92px;\n}\n\n.k-slider-horizontal .k-slider-topleft .k-tick {\n    background-position: center -122px;\n}\n\n.k-slider-horizontal .k-slider-bottomright .k-tick {\n    background-position: center -152px;\n}\n\n.k-slider-horizontal .k-tick-large {\n    background-position: center -2px;\n}\n\n.k-slider-horizontal .k-slider-topleft .k-tick-large {\n    background-position: center -32px;\n}\n\n.k-slider-horizontal .k-slider-bottomright .k-tick-large {\n    background-position: center -62px;\n}\n\n.k-slider-horizontal .k-first {\n    background-position: 0 -92px;\n}\n\n.k-slider-horizontal .k-tick-large.k-first {\n    background-position: 0 -2px;\n}\n\n.k-slider-horizontal .k-slider-topleft .k-first {\n    background-position: 0 -122px;\n}\n\n.k-slider-horizontal .k-slider-topleft .k-tick-large.k-first {\n    background-position: 0 -32px;\n}\n\n.k-slider-horizontal .k-slider-bottomright .k-first {\n    background-position: 0 -152px;\n}\n\n.k-slider-horizontal .k-slider-bottomright .k-tick-large.k-first {\n    background-position: 0 -62px;\n}\n\n.k-slider-horizontal .k-last {\n    background-position: 100% -92px;\n}\n\n.k-slider-horizontal .k-tick-large.k-last {\n    background-position: 100% -2px;\n}\n\n.k-slider-horizontal .k-slider-topleft .k-last {\n    background-position: 100% -122px;\n}\n\n.k-slider-horizontal .k-slider-topleft .k-tick-large.k-last {\n    background-position: 100% -32px;\n}\n\n.k-slider-horizontal .k-slider-bottomright .k-last {\n    background-position: 100% -152px;\n}\n\n.k-slider-horizontal .k-slider-bottomright .k-tick-large.k-last {\n    background-position: 100% -62px;\n}\n\n.k-slider-horizontal .k-label {\n    inset-inline-start: 50%;\n    bottom: -1.2em;\n    transform: translateX(-50%);\n}\n\n.k-slider-horizontal .k-first .k-label {\n    inset-inline-start: 0;\n}\n\n.k-slider-horizontal .k-last .k-label {\n    inset-inline-start: 100%;\n}\n\n.k-slider-horizontal .k-slider-topleft .k-label {\n    top: -1.2em;\n}\n\n.k-slider-track,\n.k-slider-selection {\n    margin: 0;\n    padding: 0;\n    position: absolute;\n}\n\n.k-slider-horizontal .k-slider-track, .k-slider-horizontal\n.k-slider-selection {\n    height: 4px;\n    left: 0;\n    margin-top: -2px;\n    top: 50%;\n}\n\n.k-slider-vertical .k-slider-track, .k-slider-vertical\n.k-slider-selection {\n    bottom: 0;\n    left: 50%;\n    margin-left: -2px;\n    width: 4px;\n}\n\n.k-draghandle {\n    background-color: transparent;\n    background-repeat: no-repeat;\n    border-style: solid;\n    border-width: 1px;\n    outline: 0;\n    position: absolute;\n    text-align: center;\n    text-decoration: none;\n    width: 14px;\n    height: 14px;\n}\n\n.k-slider-transitions.k-slider-horizontal .k-draghandle {\n    transition: inset-inline-start 0.3s ease-out, background-color 0.3s ease-out, transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.k-slider-transitions.k-slider-vertical .k-draghandle {\n    transition: bottom 0.3s ease-out, background-color 0.3s ease-out, transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.k-draghandle.k-pressed {\n    transition: none;\n}\n\n.k-slider-transitions.k-slider-horizontal .k-slider-selection {\n    transition: width 0.3s ease-out;\n}\n\n.k-slider-transitions.k-slider-vertical .k-slider-selection {\n    transition: height 0.3s ease-out;\n}\n\n.k-slider-selection.k-pressed {\n    transition: none;\n}\n\n.k-slider.k-readonly .k-button,\n.k-slider.k-readonly .k-slider-track,\n.k-slider.k-readonly .k-tick,\n.k-slider.k-readonly .k-draghandle {\n    pointer-events: none;\n}\n\n.k-slider-tooltip .k-callout-n,\n.k-slider-tooltip .k-callout-s {\n    margin-inline-start: -0.2rem;\n}\n\n.k-slider-tooltip .k-callout-w,\n.k-slider-tooltip .k-callout-e {\n    margin-top: -0.2rem;\n}\n\n.k-slider-rtl.k-slider-horizontal .k-draghandle, .k-slider-horizontal.k-slider[dir=\"rtl\"] .k-draghandle, [dir=\"rtl\"] .k-slider-horizontal.k-slider .k-draghandle, .k-slider-horizontal.k-slider.k-rtl .k-draghandle, .k-rtl .k-slider-horizontal.k-slider .k-draghandle {\n    transform: translate(50%, -50%);\n}\n\n.k-slider-rtl.k-slider-horizontal .k-draghandle:focus, .k-slider-horizontal.k-slider[dir=\"rtl\"] .k-draghandle:focus, [dir=\"rtl\"] .k-slider-horizontal.k-slider .k-draghandle:focus, .k-slider-horizontal.k-slider.k-rtl .k-draghandle:focus, .k-rtl .k-slider-horizontal.k-slider .k-draghandle:focus,\n.k-slider-rtl.k-slider-horizontal .k-draghandle:active,\n.k-slider-horizontal.k-slider[dir=\"rtl\"] .k-draghandle:active,\n[dir=\"rtl\"] .k-slider-horizontal.k-slider .k-draghandle:active,\n.k-slider-horizontal.k-slider.k-rtl .k-draghandle:active,\n.k-rtl .k-slider-horizontal.k-slider .k-draghandle:active {\n    transform: translate(50%, -50%) scale(1);\n}\n\n.k-slider-rtl.k-slider-horizontal .k-label, .k-slider-horizontal.k-slider[dir=\"rtl\"] .k-label, [dir=\"rtl\"] .k-slider-horizontal.k-slider .k-label, .k-slider-horizontal.k-slider.k-rtl .k-label, .k-rtl .k-slider-horizontal.k-slider .k-label {\n    transform: translateX(50%);\n}\n\n.k-slider kendo-resize-sensor {\n    position: absolute;\n}\n\n.k-slider {\n    color: #212529;\n}\n\n.k-slider .k-slider-track,\n.k-slider .k-slider-selection {\n    border-radius: 0.375rem;\n}\n\n.k-slider .k-slider-track {\n    background-color: #e9ecef;\n}\n\n.k-slider .k-slider-selection {\n    background-color: #0d6efd;\n}\n\n.k-slider .k-draghandle {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n    border-radius: 50%;\n}\n\n.k-slider .k-draghandle:hover {\n    border-color: #0257d5;\n    color: white;\n    background-color: #025ce2;\n}\n\n.k-slider .k-draghandle:active, .k-slider .k-draghandle.k-pressed {\n    border-color: #0252c9;\n    color: white;\n    background-color: #0257d5;\n}\n\n.k-slider .k-draghandle:focus, .k-slider .k-draghandle.k-focus {\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5);\n}\n\n.k-slider.k-focus .k-draghandle {\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.5);\n}\n\n.k-slider-horizontal .k-tick {\n    background-image: url(data:image/gif;base64,R0lGODlhAQC0AIABALi4uAAAACH5BAEAAAEALAAAAAABALQAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7);\n}\n\n.k-slider-vertical .k-tick {\n    background-image: url(data:image/gif;base64,R0lGODlhtAABAIABALi4uAAAACH5BAEAAAEALAAAAAC0AAEAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7);\n}\n\n.k-calendar {\n    inline-size: var(--INTERNAL--kendo-calendar-width, min-content);\n    block-size: var(--INTERNAL--kendo-calendar-height, min-content);\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    position: relative;\n    overflow: hidden;\n    display: inline-flex;\n    flex-flow: column nowrap;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-calendar > .k-calendar {\n    border: 0;\n}\n\n.k-calendar-table {\n    margin-block: 0;\n    margin-inline: auto;\n    border-width: 0;\n    border-color: inherit;\n    border-spacing: 0;\n    border-collapse: separate;\n    table-layout: fixed;\n    text-align: center;\n    outline: 0;\n    display: table;\n    position: relative;\n    z-index: 1;\n}\n\n.k-calendar-caption,\n.k-calendar-caption.k-calendar-th,\n.k-calendar .k-meta-header,\n.k-calendar .k-month-header {\n    padding-block: 0.25rem;\n    padding-inline: 0.75rem;\n    height: 38px;\n    box-sizing: border-box;\n    text-transform: none;\n    text-align: start;\n    font-weight: bold;\n    cursor: default;\n}\n\n.k-calendar-th,\n.k-calendar-td {\n    border-width: 0;\n    padding: 0;\n    text-align: center;\n    border-style: solid;\n    border-color: inherit;\n    font-weight: normal;\n    cursor: default;\n}\n\n.k-calendar-th {\n    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 38px);\n    block-size: var(--INTERNAL--kendo-calendar-cell-size, 38px);\n    font-size: 0.875rem;\n    line-height: 2;\n    text-transform: uppercase;\n}\n\n.k-calendar-td {\n    border-radius: 0.375rem;\n    inline-size: var(--INTERNAL--kendo-calendar-cell-size, min-content);\n    block-size: var(--INTERNAL--kendo-calendar-cell-size, min-content);\n    border-color: transparent;\n}\n\n.k-calendar .k-calendar-cell-inner, .k-calendar .k-link {\n    border-radius: 0.375rem;\n    padding-inline: var(--INTERNAL--kendo-calendar-cell-padding-x, 0.25rem);\n    padding-block: var(--INTERNAL--kendo-calendar-cell-padding-y, 0.25rem);\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    white-space: normal;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-calendar .k-header {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n}\n\n.k-calendar-header {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    min-width: 304px;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex: 0 0 auto;\n}\n\n.k-calendar-header .k-title,\n.k-calendar-header .k-calendar-title {\n    font-weight: bold;\n}\n\n.k-calendar-header .k-calendar-nav {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n}\n\n.k-calendar-footer,\n.k-calendar .k-footer {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    text-align: center;\n    clear: both;\n}\n\n.k-calendar-view {\n    margin: auto;\n    padding-block: 0;\n    padding-inline: 0.25rem;\n    width: 304px;\n    inline-size: var(--INTERNAL--kendo-calendar-view-width, 304px);\n    min-height: 266px;\n    box-sizing: content-box;\n    gap: 1rem;\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n}\n\n.k-month-calendar .k-calendar-td,\n.k-calendar-monthview .k-calendar-td {\n    width: 38px;\n    height: 38px;\n    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 38px);\n    block-size: var(--INTERNAL--kendo-calendar-cell-size, 38px);\n}\n\n.k-year-calendar .k-calendar-td,\n.k-calendar-yearview .k-calendar-td {\n    width: 76px;\n    height: 76px;\n    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);\n    block-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);\n}\n\n.k-decade-calendar .k-calendar-td,\n.k-calendar-decadeview .k-calendar-td {\n    width: 76px;\n    height: 76px;\n    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);\n    block-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);\n}\n\n.k-century-calendar .k-calendar-td,\n.k-calendar-centuryview .k-calendar-td {\n    width: 76px;\n    height: 76px;\n    inline-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);\n    block-size: var(--INTERNAL--kendo-calendar-cell-size, 76px);\n}\n\n.k-century-calendar .k-calendar-cell-inner, .k-century-calendar .k-link,\n.k-calendar-centuryview .k-calendar-cell-inner,\n.k-calendar-centuryview .k-link {\n    text-align: start;\n}\n\n.k-popup .k-calendar {\n    height: 100%;\n}\n\n.k-calendar-container,\n.k-datetime-container {\n    padding: 0;\n}\n\n.k-calendar-container .k-calendar,\n.k-datetime-container .k-calendar {\n    border-width: 0;\n}\n\n.k-calendar .k-content.k-scrollable,\n.k-calendar .k-calendar-content.k-scrollable {\n    box-sizing: content-box;\n    overflow-x: hidden;\n    overflow-y: auto;\n    display: block;\n    padding-right: 100px;\n    padding-left: 100px;\n    margin-left: -100px;\n    margin-right: calc(-100px - var(--kendo-scrollbar-width, 17px));\n}\n\n.k-calendar .k-scrollable-placeholder {\n    position: absolute;\n    z-index: -1;\n    width: 1px;\n    top: 0;\n    right: 0;\n}\n\n.k-calendar-sm {\n    --INTERNAL--kendo-calendar-view-width: 272px;\n    --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-sm-cell-padding-x, 0.125rem );\n    --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-sm-cell-padding-y, 0.125rem );\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-calendar-sm.k-month-calendar,\n.k-calendar-sm .k-calendar-monthview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-month-cell-size, 34px );\n}\n\n.k-calendar-sm.k-year-calendar,\n.k-calendar-sm .k-calendar-yearview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-year-cell-size, 68px );\n}\n\n.k-calendar-sm.k-decade-calendar,\n.k-calendar-sm .k-calendar-decadeview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-decade-cell-size, 68px );\n}\n\n.k-calendar-sm.k-century-calendar,\n.k-calendar-sm .k-calendar-centuryview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-century-cell-size, 68px );\n}\n\n.k-calendar-md {\n    --INTERNAL--kendo-calendar-view-width: 304px;\n    --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-md-cell-padding-x, 0.25rem );\n    --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-md-cell-padding-y, 0.25rem );\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-calendar-md.k-month-calendar,\n.k-calendar-md .k-calendar-monthview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-month-cell-size, 38px );\n}\n\n.k-calendar-md.k-year-calendar,\n.k-calendar-md .k-calendar-yearview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-year-cell-size, 76px );\n}\n\n.k-calendar-md.k-decade-calendar,\n.k-calendar-md .k-calendar-decadeview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-decade-cell-size, 76px );\n}\n\n.k-calendar-md.k-century-calendar,\n.k-calendar-md .k-calendar-centuryview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-century-cell-size, 76px );\n}\n\n.k-calendar-lg {\n    --INTERNAL--kendo-calendar-view-width: 336px;\n    --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-lg-cell-padding-x, 0.25rem );\n    --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-lg-cell-padding-y, 0.25rem );\n    font-size: 1.25rem;\n    line-height: 2;\n}\n\n.k-calendar-lg.k-month-calendar,\n.k-calendar-lg .k-calendar-monthview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-month-cell-size, 42px );\n}\n\n.k-calendar-lg.k-year-calendar,\n.k-calendar-lg .k-calendar-yearview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-year-cell-size, 84px );\n}\n\n.k-calendar-lg.k-decade-calendar,\n.k-calendar-lg .k-calendar-decadeview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-decade-cell-size, 84px );\n}\n\n.k-calendar-lg.k-century-calendar,\n.k-calendar-lg .k-calendar-centuryview {\n    --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-century-cell-size, 84px );\n}\n\n.k-calendar-infinite {\n    box-sizing: content-box;\n    display: inline-flex;\n    flex-flow: row nowrap;\n}\n\n.k-calendar-infinite .k-calendar-view {\n    padding-block: 0px;\n    padding-inline: 1rem;\n    height: 342px;\n    flex: 0 0 auto;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0;\n    overflow: hidden;\n}\n\n.k-calendar-infinite .k-calendar-view .k-content.k-scrollable {\n    position: relative;\n}\n\n.k-calendar-infinite .k-calendar-view::after {\n    display: block;\n    position: absolute;\n    bottom: 0;\n    content: \"\\200b\";\n    height: 0;\n    line-height: 0;\n    z-index: 1;\n    width: 150%;\n    left: -25%;\n    box-shadow: 0 0 38px 19px #ffffff;\n}\n\n.k-calendar-infinite .k-calendar-header {\n    margin-left: -1rem;\n    margin-right: -1rem;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    width: auto;\n    min-width: 0;\n}\n\n.k-calendar-infinite .k-calendar-weekdays {\n    flex: 0 0 auto;\n}\n\n.k-calendar-navigation {\n    width: 5em;\n    text-align: center;\n    flex: 0 0 auto;\n    display: block;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n}\n\n.k-calendar-navigation::before, .k-calendar-navigation::after {\n    display: block;\n    position: absolute;\n    content: \"\\200b\";\n    height: 0;\n    line-height: 0;\n    z-index: 1;\n    width: 200%;\n    left: -50%;\n    box-shadow: 0 0 6em 3em #f8f9fa;\n}\n\n.k-calendar-navigation::before {\n    top: 0;\n}\n\n.k-calendar-navigation::after {\n    bottom: 0;\n}\n\n.k-calendar-navigation .k-content,\n.k-calendar-navigation .k-calendar-content {\n    background: transparent;\n    height: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.k-calendar-navigation .k-content ul,\n.k-calendar-navigation .k-calendar-content ul {\n    width: 5em;\n}\n\n.k-calendar-navigation .k-content li,\n.k-calendar-navigation .k-calendar-content li {\n    height: 2em;\n    line-height: 2em;\n    cursor: pointer;\n    padding-block: 0;\n    padding-inline: 1em;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: clip;\n}\n\n.k-calendar-navigation .k-calendar-navigation-marker {\n    font-weight: bold;\n}\n\n.k-calendar-navigation .k-calendar-navigation-highlight {\n    width: 100%;\n    border-width: 1px 0;\n    border-style: solid;\n    height: 2em;\n    box-sizing: border-box;\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n}\n\n.k-calendar-range {\n    width: auto;\n}\n\n.k-calendar-range .k-calendar-view {\n    width: auto;\n    white-space: nowrap;\n}\n\n.k-calendar-range .k-calendar-view::after {\n    display: none;\n}\n\n.k-calendar-range .k-calendar-view:focus {\n    outline: 0;\n}\n\n.k-calendar-range .k-range-start {\n    border-color: inherit;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.k-calendar-range .k-range-end {\n    border-color: inherit;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.k-calendar-range .k-range-mid {\n    border-color: inherit;\n    border-radius: 0;\n}\n\n.k-rtl .k-calendar .k-content.k-scrollable,\n.k-rtl .k-calendar .k-calendar-content.k-scrollable,\n[dir=\"rtl\"] .k-calendar .k-content.k-scrollable,\n[dir=\"rtl\"] .k-calendar .k-calendar-content.k-scrollable,\n.k-calendar.k-rtl .k-content.k-scrollable,\n.k-calendar.k-rtl .k-calendar-content.k-scrollable,\n.k-calendar[dir=\"rtl\"] .k-content.k-scrollable,\n.k-calendar[dir=\"rtl\"] .k-calendar-content.k-scrollable {\n    padding-right: 100px;\n    padding-left: 100px;\n    margin-left: calc(-100px - var(--kendo-scrollbar-width, 17px));\n    margin-right: -100px;\n}\n\n.k-calendar {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-calendar .k-header {\n    border-color: inherit;\n    color: #212529;\n    background-color: #f8f9fa;\n    box-shadow: none;\n}\n\n.k-calendar .k-calendar-th,\n.k-calendar .k-calendar-caption,\n.k-calendar .k-meta-header,\n.k-calendar .k-month-header {\n    color: #6c757d;\n}\n\n.k-calendar .k-calendar-view .k-today .k-calendar-cell-inner, .k-calendar .k-calendar-view .k-today .k-link {\n    box-shadow: inset 0 0 0 1px #0d6efd;\n}\n\n.k-calendar .k-calendar-view .k-today.k-focus .k-calendar-cell-inner, .k-calendar .k-calendar-view .k-today.k-focus .k-link {\n    box-shadow: inset 0 0 0 1px #0d6efd, inset 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-calendar .k-other-month {\n    color: #6c757d;\n}\n\n.k-calendar .k-alt {\n    background-color: transparent;\n    color: #6c757d;\n}\n\n.k-calendar .k-out-of-range {\n    pointer-events: none;\n}\n\n.k-calendar .k-calendar-td:hover .k-calendar-cell-inner, .k-calendar .k-calendar-td:hover .k-link,\n.k-calendar .k-calendar-td.k-hover .k-calendar-cell-inner,\n.k-calendar .k-calendar-td.k-hover .k-link {\n    border-color: #d6d9dc;\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-calendar .k-calendar-td.k-selected .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected .k-link {\n    border-color: #0c65e9;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-calendar .k-calendar-td.k-selected:hover .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected:hover .k-link,\n.k-calendar .k-calendar-td.k-selected.k-hover .k-calendar-cell-inner,\n.k-calendar .k-calendar-td.k-selected.k-hover .k-link {\n    border-color: #e4e5e6;\n    color: white;\n    background-color: #0c6af3;\n}\n\n.k-calendar .k-calendar-td:focus .k-calendar-cell-inner, .k-calendar .k-calendar-td:focus .k-link,\n.k-calendar .k-calendar-td.k-focus .k-calendar-cell-inner,\n.k-calendar .k-calendar-td.k-focus .k-link {\n    box-shadow: inset 0 0 0 0.25rem rgba(228, 231, 235, 0.5);\n}\n\n.k-calendar .k-calendar-td.k-selected:focus .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected:focus .k-link,\n.k-calendar .k-calendar-td.k-selected.k-focus .k-calendar-cell-inner,\n.k-calendar .k-calendar-td.k-selected.k-focus .k-link {\n    box-shadow: inset 0 0 0 2px rgba(2, 82, 201, 0.5);\n}\n\n.k-calendar .k-calendar-navigation {\n    color: #212529;\n    background-color: #f8f9fa;\n    box-shadow: inset -1px 0 #dee2e6;\n}\n\n.k-calendar .k-calendar-navigation li:hover,\n.k-calendar .k-calendar-navigation li.k-hover {\n    color: #0a58ca;\n}\n\n.k-calendar .k-calendar-navigation-highlight {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-calendar[dir=\"rtl\"] .k-calendar-navigation,\n.k-rtl .k-calendar .k-calendar-navigation {\n    box-shadow: inset 1px 0 #dee2e6;\n}\n\n.k-calendar.k-invalid, .k-calendar.k-invalid:hover, .k-calendar.ng-invalid.ng-touched, .k-calendar.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-scheduler .k-calendar .k-other-month {\n    color: #6c757d;\n    background-color: transparent;\n}\n\n.k-calendar .k-range-start,\n.k-calendar .k-range-end,\n.k-calendar .k-range-mid {\n    background-color: rgba(13, 110, 253, 0.25);\n}\n\n.k-calendar .k-range-start.k-range-end {\n    background-image: none;\n    background-color: transparent;\n}\n\n.k-calendar .k-range-start .k-calendar-cell-inner, .k-calendar .k-range-start .k-link,\n.k-calendar .k-range-end .k-calendar-cell-inner,\n.k-calendar .k-range-end .k-link {\n    background-color: #0d6efd;\n}\n\n.k-calendar .k-range-start.k-active .k-calendar-cell-inner, .k-calendar .k-range-start.k-active .k-link,\n.k-calendar .k-range-end.k-active .k-calendar-cell-inner,\n.k-calendar .k-range-end.k-active .k-link {\n    box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, 0.2);\n}\n\n.k-calendar .k-range-split-start,\n.k-calendar .k-range-split-end {\n    position: relative;\n}\n\n.k-calendar .k-range-split-start::after,\n.k-calendar .k-range-split-end::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 5px;\n}\n\n.k-calendar .k-range-split-start::after {\n    left: -5px;\n    right: auto;\n    background-image: linear-gradient(to left, rgba(13, 110, 253, 0.25), transparent 100%);\n}\n\n.k-calendar .k-range-split-end::after {\n    right: -5px;\n    left: auto;\n    background-image: linear-gradient(to right, rgba(13, 110, 253, 0.25), transparent 100%);\n}\n\n.k-timeselector {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    flex-flow: column nowrap;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-popup > .k-timeselector {\n    border-width: 0;\n}\n\n.k-time-header,\n.k-time-selector-header {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex: 0 0 auto;\n}\n\n.k-time-header .k-title,\n.k-time-header .k-time-selector-header-title,\n.k-time-selector-header .k-title,\n.k-time-selector-header .k-time-selector-header-title {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n    font-weight: bold;\n    display: inline-block;\n}\n\n.k-time-header .k-time-now,\n.k-time-selector-header .k-time-now {\n    border-width: 0;\n    line-height: inherit;\n    cursor: pointer;\n}\n\n.k-actions.k-time-fast-selection, .k-time-fast-selection.k-edit-buttons,\n.k-time-fast-selection.k-action-buttons,\n.k-time-fast-selection.k-columnmenu-actions, .k-time-fast-selection.k-form-buttons {\n    margin-top: 0;\n}\n\n.k-time-list-container {\n    display: flex;\n    position: relative;\n    flex: 1 1 auto;\n    overflow: hidden;\n}\n\n.k-time-highlight,\n.k-time-list-highlight {\n    width: 100%;\n    height: 2rem;\n    border-width: 1px 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    position: absolute;\n    top: calc(50% + 0.65625rem);\n    left: 0;\n    right: 0;\n    transform: translateY(-50%);\n    z-index: 1;\n}\n\n.k-time-list-wrapper {\n    min-width: 4em;\n    height: 240px;\n    box-sizing: content-box;\n    display: inline-flex;\n    flex-flow: column nowrap;\n    align-items: stretch;\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n    flex: 1 1 auto;\n}\n\n.k-time-list-wrapper .k-title {\n    font-size: 0.875rem;\n    line-height: 1.5;\n    font-weight: bold;\n    text-align: center;\n    text-transform: capitalize;\n    display: block;\n}\n\n.k-time-list-wrapper.k-focus::before, .k-time-list-wrapper.k-focus::after {\n    display: block;\n    content: \"\\200b\";\n    position: absolute;\n    width: 100%;\n    left: 0;\n    pointer-events: none;\n    height: calc(50% - 1rem);\n    box-sizing: border-box;\n    border-width: 0;\n    border-style: solid;\n}\n\n.k-time-list-wrapper.k-focus::before {\n    top: 1.3125rem;\n}\n\n.k-time-list-wrapper.k-focus::after {\n    bottom: 0;\n}\n\n.k-time-list {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: stretch;\n    flex: 1;\n    position: relative;\n    z-index: 1;\n    outline: 0;\n    overflow: hidden;\n}\n\n.k-time-list::before, .k-time-list::after {\n    display: block;\n    position: absolute;\n    content: \"\\200b\";\n    height: 0;\n    line-height: 0;\n    z-index: 1;\n    width: 200%;\n    left: -50%;\n}\n\n.k-time-list::before {\n    top: 0;\n}\n\n.k-time-list::after {\n    bottom: 0;\n}\n\n.k-time-container,\n.k-time-list-content {\n    position: relative;\n    flex: 1 1 auto;\n    display: block;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    padding-right: 100px;\n    padding-left: 100px;\n    margin-left: -100px;\n    margin-right: calc(-100px - var(--kendo-scrollbar-width, 17px));\n}\n\n.k-time-container > ul,\n.k-time-list-content > ul {\n    height: auto;\n    width: 4em;\n    margin: auto;\n}\n\n.k-time-container .k-scrollable-placeholder,\n.k-time-list-content .k-scrollable-placeholder {\n    position: absolute;\n    width: 1px;\n    top: 0;\n    right: 0;\n}\n\n.k-time-list-item,\n.k-time-list .k-item {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-time-separator {\n    width: 0;\n    height: 2rem;\n    align-self: center;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    z-index: 11;\n    top: 0.65625rem;\n}\n\n.k-timeselector-sm {\n    font-size: 0.875rem;\n    line-height: 1.4285714286;\n}\n\n.k-timeselector-sm .k-time-highlight,\n.k-timeselector-sm .k-time-list-highlight {\n    height: 1.75rem;\n}\n\n.k-timeselector-sm .k-time-separator {\n    height: 1.75rem;\n}\n\n.k-timeselector-sm .k-time-list-item,\n.k-timeselector-sm .k-time-list .k-item {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-timeselector-md {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-timeselector-md .k-time-highlight,\n.k-timeselector-md .k-time-list-highlight {\n    height: 2rem;\n}\n\n.k-timeselector-md .k-time-separator {\n    height: 2rem;\n}\n\n.k-timeselector-md .k-time-list-item,\n.k-timeselector-md .k-time-list .k-item {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-timeselector-lg {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-timeselector-lg .k-time-highlight,\n.k-timeselector-lg .k-time-list-highlight {\n    height: 2.5rem;\n}\n\n.k-timeselector-lg .k-time-separator {\n    height: 2.5rem;\n}\n\n.k-timeselector-lg .k-time-list-item,\n.k-timeselector-lg .k-time-list .k-item {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n}\n\n.k-rtl .k-time-container,\n.k-rtl .k-time-list-content,\n[dir=\"rtl\"] .k-time-container,\n[dir=\"rtl\"] .k-time-list-content {\n    padding-right: 100px;\n    padding-left: 100px;\n    margin-left: calc(-100px - var(--kendo-scrollbar-width, 17px));\n    margin-right: -100px;\n}\n\n.k-timeselector {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-time-header .k-time-now,\n.k-time-selector-header .k-time-now {\n    color: #0d6efd;\n}\n\n.k-time-header .k-time-now:hover,\n.k-time-selector-header .k-time-now:hover {\n    color: #0a58ca;\n}\n\n.k-time-list-wrapper .k-title {\n    color: #6c757d;\n}\n\n.k-time-list-wrapper.k-focus .k-title {\n    color: #212529;\n}\n\n.k-time-list-wrapper.k-focus::before, .k-time-list-wrapper.k-focus::after {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n.k-time-list::before, .k-time-list::after {\n    box-shadow: 0 0 3em 1.5em #ffffff;\n}\n\n.k-time-list .k-item:hover {\n    color: #0d6efd;\n}\n\n.k-time-container {\n    background: transparent;\n}\n\n.k-time-highlight {\n    border-color: #dee2e6;\n    background-color: #ffffff;\n}\n\n.k-captcha {\n    width: 335px;\n    box-sizing: border-box;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0.5rem;\n}\n\n.k-captcha *,\n.k-captcha *::before,\n.k-captcha *::after {\n    box-sizing: border-box;\n}\n\n.k-captcha-image-wrap {\n    position: relative;\n    gap: 0.5rem;\n}\n\n.k-captcha-image-controls {\n    position: relative;\n    gap: 0.5rem;\n}\n\n.k-captcha-image {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n.k-captcha-image > img {\n    width: 100%;\n    height: 100%;\n    display: block;\n    object-fit: cover;\n}\n\n.k-captcha-loading .k-captcha-image {\n    height: auto;\n}\n\n.k-captcha-volume-control {\n    height: 100%;\n}\n\n.k-captcha-validation-message {\n    margin-top: 0.25rem;\n    font-size: 0.875rem;\n    font-style: italic;\n}\n\n.k-captcha {\n    border-color: #ffffff;\n    color: #ffffff;\n    background-color: #ffffff;\n}\n\n.k-colorpalette {\n    border-width: 0;\n    box-sizing: border-box;\n    outline: 0;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 0;\n    display: inline-flex;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-colorpalette *,\n.k-colorpalette *::before,\n.k-colorpalette *::after {\n    box-sizing: border-box;\n}\n\n.k-colorpalette-table {\n    width: 100%;\n    height: 100%;\n    border-collapse: collapse;\n    position: relative;\n}\n\n.k-colorpalette-tile {\n    width: 1.5rem;\n    height: 1.5rem;\n    box-sizing: border-box;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n.k-colorpalette-tile:hover, .k-colorpalette-tile.k-hover {\n    position: relative;\n    z-index: 101;\n}\n\n.k-colorpalette-tile:focus, .k-colorpalette-tile.k-focus, .k-colorpalette-tile.k-selected, .k-colorpalette-tile.k-selected:hover {\n    position: relative;\n    z-index: 100;\n}\n\n.k-colorpalette-tile:focus, .k-colorpalette-tile.k-focus {\n    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.5);\n}\n\n.k-colorpalette-tile:hover, .k-colorpalette-tile.k-hover {\n    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.8);\n}\n\n.k-colorpalette-tile.k-selected, .k-colorpalette-tile.k-selected:hover {\n    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.3), inset 0 0 0 1px white;\n}\n\n.k-colorgradient {\n    border-radius: 0.375rem;\n    width: 328px;\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-style: solid;\n    border-width: 1px;\n    box-sizing: border-box;\n    outline: 0;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-colorgradient *,\n.k-colorgradient *::before,\n.k-colorgradient *::after {\n    box-sizing: border-box;\n}\n\n.k-colorgradient-canvas {\n    gap: 0.75rem;\n}\n\n.k-colorgradient-canvas .k-hsv-rectangle {\n    border-radius: 0.375rem;\n    position: relative;\n    flex: 1 1 auto;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-colorgradient-canvas .k-hsv-gradient {\n    border-radius: 0.375rem;\n    height: 180px;\n}\n\n.k-colorgradient-canvas .k-hsv-draghandle {\n    margin-top: -7px;\n    margin-left: -7px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    z-index: 1;\n    cursor: pointer;\n}\n\n.k-colorgradient-canvas .k-hsv-controls {\n    position: relative;\n    flex-shrink: 0;\n    gap: 0.75rem;\n}\n\n.k-colorgradient .k-draghandle {\n    border-radius: 50%;\n    width: 14px;\n    height: 14px;\n    border-width: 1px;\n    border-style: solid;\n    outline-width: 1px;\n    outline-style: solid;\n    box-sizing: border-box;\n}\n\n.k-colorgradient-slider.k-slider-vertical {\n    width: 10px;\n    height: 180px;\n    flex: 0 0 10px;\n}\n\n.k-colorgradient-slider.k-slider-vertical .k-slider-track {\n    width: 10px;\n    border-radius: 10px;\n    margin-left: -5px;\n}\n\n.k-colorgradient-slider.k-slider-horizontal {\n    width: 100%;\n    height: 10px;\n    flex: 0 0 10px;\n}\n\n.k-colorgradient-slider.k-slider-horizontal .k-slider-track {\n    height: 10px;\n    border-radius: 10px;\n    margin-top: -5px;\n}\n\n.k-colorgradient-slider.k-alpha-slider .k-slider-track::before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    display: block;\n    border-radius: 10px;\n    position: relative;\n    z-index: -1;\n}\n\n.k-colorgradient-slider .k-slider-track-wrap {\n    z-index: 1;\n}\n\n.k-colorgradient-slider .k-slider-selection {\n    display: none;\n}\n\n.k-colorgradient-slider .k-draghandle {\n    border-width: 3px;\n}\n\n.k-colorgradient-inputs {\n    gap: 0.5rem;\n}\n\n.k-colorgradient-inputs .k-colorgradient-input-label {\n    text-transform: uppercase;\n}\n\n.k-colorgradient-inputs > .k-vstack, .k-colorgradient-inputs > .k-vbox {\n    gap: 0.25rem;\n}\n\n.k-colorgradient-inputs .k-numerictextbox {\n    width: 56px;\n}\n\n.k-colorgradient-inputs .k-input-inner {\n    padding-inline-start: 2px;\n    padding-inline-end: 2px;\n    text-align: center;\n    text-overflow: clip;\n}\n\n.k-colorgradient-color-contrast > div {\n    display: flex;\n    flex-flow: row nowrap;\n    gap: 0.5rem;\n}\n\n.k-colorgradient-color-contrast .k-contrast-ratio {\n    margin-bottom: 0.5rem;\n}\n\n.k-colorgradient-color-contrast .k-contrast-ratio-text {\n    font-weight: 700;\n}\n\n.k-colorgradient-color-contrast .k-contrast-validation {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.k-colorgradient-color-contrast .k-contrast-validation .k-icon {\n    vertical-align: middle;\n}\n\n.k-colorgradient-color-contrast .k-contrast-validation .k-icon + .k-icon,\n.k-colorgradient-color-contrast .k-contrast-validation .k-icon-wrapper-host + .k-icon-wrapper-host .k-icon {\n    margin-inline-start: -13px;\n}\n\n.k-color-contrast-svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    overflow: visible;\n    pointer-events: none;\n}\n\n.k-colorgradient {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-colorgradient:focus,\n.k-colorgradient.k-focus {\n    border-color: #d6d9dc;\n}\n\n.k-colorgradient-canvas .k-hsv-gradient {\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), black), linear-gradient(to right, white, rgba(255, 255, 255, 0));\n}\n\n.k-colorgradient .k-draghandle {\n    border-color: rgba(255, 255, 255, 0.8);\n    background-color: transparent;\n    outline-color: #000000;\n    box-shadow: rgba(0, 0, 0, 0.5);\n}\n\n.k-colorgradient .k-draghandle:focus, .k-colorgradient .k-draghandle.k-focus {\n    border-color: #ffffff;\n    background-color: transparent;\n    outline-color: #000000;\n    box-shadow: rgba(0, 0, 0, 0.5);\n}\n\n.k-colorgradient .k-draghandle:hover, .k-colorgradient .k-draghandle.k-hover, .k-colorgradient .k-draghandle.k-active, .k-colorgradient .k-draghandle:active {\n    border-color: #ffffff;\n    background-color: transparent;\n    outline-color: #000000;\n}\n\n.k-colorgradient-slider.k-hue-slider.k-slider-horizontal .k-slider-track {\n    background: linear-gradient(to right, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000);\n}\n\n.k-colorgradient-slider.k-hue-slider.k-slider-vertical .k-slider-track {\n    background: linear-gradient(to top, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000);\n}\n\n.k-colorgradient-slider.k-alpha-slider .k-slider-track::before {\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAuSURBVHgBxYyxDQAwDMJIL+YT+DjtzFRliUfLcklqBCRT4eCTxbD6kdL2/LgYXqpvCbs3kBv/AAAAAElFTkSuQmCC) center repeat;\n}\n\n.k-colorgradient-input-label {\n    color: #6c757d;\n}\n\n.k-rtl .k-colorgradient .k-hue-slider.k-slider-horizontal .k-slider-track,\n[dir=\"rtl\"] .k-colorgradient .k-hue-slider.k-slider-horizontal .k-slider-track {\n    background: linear-gradient(to left, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000);\n}\n\n.k-coloreditor {\n    border-radius: 0.375rem;\n    min-width: 328px;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: stretch;\n}\n\n.k-coloreditor *,\n.k-coloreditor *::before,\n.k-coloreditor *::after {\n    box-sizing: border-box;\n}\n\n.k-coloreditor-header {\n    padding: 1rem 1rem 0;\n}\n\n.k-coloreditor-header-actions {\n    gap: 0.5rem;\n}\n\n.k-coloreditor-preview {\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: stretch;\n    justify-content: center;\n    gap: 0.25rem;\n    position: relative;\n    z-index: 1;\n}\n\n.k-coloreditor-preview .k-color-preview {\n    width: 32px;\n    height: 12px;\n}\n\n.k-coloreditor-views {\n    min-width: calc(var(--kendo-color-preview-width, 1.5rem)*var(--kendo-color-preview-columns, 10));\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    gap: 1rem;\n}\n\n.k-coloreditor-views .k-colorgradient {\n    padding: 0;\n    width: auto;\n    border-width: 0;\n}\n\n.k-coloreditor-views .k-colorgradient:focus,\n.k-coloreditor-views .k-colorgradient.k-focus {\n    outline: 2px dotted;\n    outline-offset: 2px;\n    border-radius: 0;\n}\n\n.k-coloreditor-views .k-colorpalette {\n    align-self: center;\n}\n\n.k-coloreditor-views .k-colorpalette-tile {\n    width: var(--kendo-color-preview-width, 1.5rem);\n    height: var(--kendo-color-preview-height, 1.5rem);\n}\n\n.k-coloreditor-footer.k-actions, .k-coloreditor-footer.k-edit-buttons,\n.k-coloreditor-footer.k-action-buttons,\n.k-coloreditor-footer.k-columnmenu-actions, .k-coloreditor-footer.k-form-buttons {\n    margin: 0;\n}\n\n.k-coloreditor {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-coloreditor:focus,\n.k-coloreditor.k-focus {\n    border-color: #d6d9dc;\n}\n\n.k-coloreditor .k-colorgradient:focus,\n.k-coloreditor .k-colorgradient.k-focus {\n    box-shadow: none;\n    outline-color: rgba(0, 0, 0, 0.3);\n}\n\n.k-color-picker, .k-colorpicker {\n    width: min-content;\n}\n\n.k-datetime-selector {\n    display: flex;\n    transition: transform .2s;\n}\n\n.k-datetime-wrap {\n    width: calc(304px + 2rem);\n    overflow: hidden;\n}\n\n.k-datetime-wrap .k-datetime-buttongroup {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-datetime-wrap .k-calendar,\n.k-datetime-wrap .k-timeselector {\n    width: 100%;\n    border-width: 0;\n}\n\n.k-datetime-calendar-wrap,\n.k-datetime-time-wrap {\n    text-align: center;\n    flex: 0 0 calc(304px + 2rem);\n}\n\n.k-date-tab .k-datetime-selector {\n    transform: translateX(0);\n}\n\n.k-time-tab .k-datetime-selector {\n    transform: translateX(-100%);\n}\n\n.k-time-tab .k-datetime-selector.k-rtl, .k-time-tab .k-datetime-selector[dir=\"rtl\"],\n.k-rtl .k-time-tab .k-datetime-selector,\n[dir=\"rtl\"] .k-time-tab .k-datetime-selector {\n    transform: translateX(100%);\n}\n\n.k-daterange-picker, .k-daterangepicker {\n    width: 100%;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: flex-end;\n    gap: 0.5rem;\n}\n\n.k-daterange-picker *, .k-daterangepicker *,\n.k-daterange-picker *::before,\n.k-daterangepicker *::before,\n.k-daterange-picker *::after,\n.k-daterangepicker *::after {\n    box-sizing: border-box;\n}\n\n.k-daterange-picker .k-dateinput, .k-daterangepicker .k-dateinput {\n    width: 10em;\n}\n\n.k-daterangepicker-wrap {\n    display: inherit;\n    flex-flow: inherit;\n    align-items: inherit;\n    gap: inherit;\n}\n\n.k-dropdowngrid-popup {\n    overflow: hidden;\n}\n\n.k-dropdowngrid-popup > .k-data-table {\n    border-width: 0;\n}\n\n.k-dropdown-operator {\n    width: min-content;\n    flex: none;\n}\n\n.k-dropdown-operator .k-input-button {\n    border-width: 0;\n    width: min-content;\n}\n\n.k-dropdown-operator .k-input-button .k-button-icon {\n    width: auto;\n    aspect-ratio: 1;\n}\n\n.k-dropdown-operator .k-input-inner {\n    display: none;\n}\n\n.k-treeview {\n    padding: 0;\n    border-width: 0;\n    background: none;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: block;\n    cursor: default;\n    overflow: auto;\n    white-space: nowrap;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-treeview *,\n.k-treeview *::before,\n.k-treeview *::after {\n    box-sizing: border-box;\n}\n\n.k-treeview-filter {\n    padding: 0.5rem;\n    display: block;\n    position: relative;\n    flex: none;\n}\n\n.k-treeview-group {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    position: relative;\n    outline: 0;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-treeview-group.ng-animating {\n    overflow: hidden;\n}\n\n.k-treeview-top,\n.k-treeview-mid,\n.k-treeview-bot {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    align-content: center;\n}\n\n.k-treeview-item {\n    outline-style: none;\n    margin: 0;\n    padding: 0 0 0 24px;\n    border-width: 0;\n    display: block;\n}\n\n.k-treeview-toggle {\n    margin-inline-start: -24px;\n    flex: none;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    cursor: pointer;\n}\n\n.k-treeview-toggle .k-icon {\n    padding: 0.25rem;\n    box-sizing: content-box;\n}\n\n.k-treeview-loading {\n    margin-right: 0.5rem;\n}\n\n.k-treeview .k-checkbox-wrap,\n.k-treeview .k-checkbox-wrapper {\n    align-self: center;\n}\n\n.k-treeview-leaf {\n    border-radius: 0.25rem;\n    padding-block: 0.25rem;\n    padding-inline: 0.75rem;\n    border: 0px solid transparent;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    align-content: center;\n    vertical-align: middle;\n    position: relative;\n}\n\n.k-treeview-leaf .k-icon,\n.k-treeview-leaf .k-image,\n.k-treeview-leaf .k-sprite {\n    margin-right: 0.5rem;\n}\n\n.k-treeview-leaf.k-focus {\n    z-index: 1;\n}\n\n.k-treeview .k-treeview-load-more-button {\n    cursor: pointer;\n}\n\n.k-treeview .k-treeview-load-more-button:hover, .k-treeview .k-treeview-load-more-button.k-hover, .k-treeview .k-treeview-load-more-button:focus, .k-treeview .k-treeview-load-more-button.k-focus {\n    text-decoration: underline;\n}\n\n.k-rtl .k-treeview .k-treeview-item,\n[dir=\"rtl\"] .k-treeview .k-treeview-item,\n.k-treeview.k-rtl .k-treeview-item,\n.k-treeview[dir=\"rtl\"] .k-treeview-item {\n    padding-left: 0;\n    padding-right: 24px;\n}\n\n.k-rtl .k-treeview .k-treeview-loading,\n[dir=\"rtl\"] .k-treeview .k-treeview-loading,\n.k-treeview.k-rtl .k-treeview-loading,\n.k-treeview[dir=\"rtl\"] .k-treeview-loading {\n    margin-right: 0;\n    margin-left: 0.5rem;\n}\n\n.k-rtl .k-treeview .k-treeview-leaf .k-icon,\n.k-rtl .k-treeview .k-treeview-leaf .k-image,\n.k-rtl .k-treeview .k-treeview-leaf .k-sprite,\n.k-rtl .k-treeview .k-in .k-icon,\n.k-rtl .k-treeview .k-in .k-image,\n.k-rtl .k-treeview .k-in .k-sprite,\n[dir=\"rtl\"] .k-treeview .k-treeview-leaf .k-icon,\n[dir=\"rtl\"] .k-treeview .k-treeview-leaf .k-image,\n[dir=\"rtl\"] .k-treeview .k-treeview-leaf .k-sprite,\n[dir=\"rtl\"] .k-treeview .k-in .k-icon,\n[dir=\"rtl\"] .k-treeview .k-in .k-image,\n[dir=\"rtl\"] .k-treeview .k-in .k-sprite,\n.k-treeview.k-rtl .k-treeview-leaf .k-icon,\n.k-treeview.k-rtl .k-treeview-leaf .k-image,\n.k-treeview.k-rtl .k-treeview-leaf .k-sprite,\n.k-treeview.k-rtl .k-in .k-icon,\n.k-treeview.k-rtl .k-in .k-image,\n.k-treeview.k-rtl .k-in .k-sprite,\n.k-treeview[dir=\"rtl\"] .k-treeview-leaf .k-icon,\n.k-treeview[dir=\"rtl\"] .k-treeview-leaf .k-image,\n.k-treeview[dir=\"rtl\"] .k-treeview-leaf .k-sprite,\n.k-treeview[dir=\"rtl\"] .k-in .k-icon,\n.k-treeview[dir=\"rtl\"] .k-in .k-image,\n.k-treeview[dir=\"rtl\"] .k-in .k-sprite {\n    margin-right: 0;\n    margin-left: 0.5rem;\n}\n\n.k-treeview-sm {\n    font-size: 0.875rem;\n    line-height: 1.4285714286;\n}\n\n.k-treeview-sm .k-treeview-leaf {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n}\n\n.k-treeview-sm .k-checkbox-wrap {\n    padding-block: 0.125rem;\n    padding-inline: 0.25rem;\n}\n\n.k-treeview-md {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-treeview-md .k-treeview-leaf {\n    padding-block: 0.25rem;\n    padding-inline: 0.75rem;\n}\n\n.k-treeview-md .k-checkbox-wrap {\n    padding-inline: 0.25rem;\n}\n\n.k-treeview-lg {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-treeview-lg .k-treeview-leaf {\n    padding-block: 0.5rem;\n    padding-inline: 0.75rem;\n}\n\n.k-treeview-lg .k-checkbox-wrap {\n    padding-inline: 0.25rem;\n}\n\n.k-treeview-leaf {\n    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.k-treeview {\n    color: #212529;\n}\n\n.k-treeview-leaf:hover, .k-treeview-leaf.k-hover {\n    border-color: #e9ecef;\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-treeview-leaf:focus, .k-treeview-leaf.k-focus {\n    box-shadow: inset 0 0 0 2px rgba(33, 37, 41, 0.15);\n}\n\n.k-treeview-leaf.k-selected {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-treeview .k-treeview-load-more-button {\n    color: #0d6efd;\n    background-color: transparent;\n}\n\n.k-treeview .k-treeview-load-more-button:hover, .k-treeview .k-treeview-load-more-button.k-hover {\n    color: #0a58ca;\n    background-color: transparent;\n}\n\n.k-treeview .k-treeview-load-more-button:focus, .k-treeview .k-treeview-load-more-button.k-focus {\n    color: #0a58ca;\n    background-color: transparent;\n    box-shadow: inset 0 0 0 2px rgba(33, 37, 41, 0.15);\n}\n\n.k-popup-dropdowntree .k-treeview,\n.k-dropdowntree-popup .k-treeview,\n.k-multiselecttree-popup .k-treeview {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-popup-dropdowntree .k-check-all,\n.k-dropdowntree-popup .k-check-all,\n.k-multiselecttree-popup .k-check-all {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-multiselecttree .k-input-values {\n    width: auto;\n    max-width: 100%;\n}\n\n.k-multiselecttree .k-input-inner::before {\n    content: \"\\200b\";\n    width: 0px;\n    overflow: hidden;\n    flex: none;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.k-rating {\n    margin: 0;\n    padding: 0;\n    border-width: 0;\n    box-sizing: border-box;\n    outline: 0;\n    background: none;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: inline-flex;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-rating *,\n.k-rating *::before,\n.k-rating *::after {\n    box-sizing: border-box;\n}\n\n.k-rating.k-readonly {\n    pointer-events: none;\n}\n\n.k-rating-container {\n    flex: 0 1 auto;\n    position: relative;\n    margin-block: 0;\n    margin-inline: 0.5rem;\n}\n\n.k-rating-container .k-rating-item {\n    display: inline-flex;\n    position: relative;\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    align-items: center;\n    vertical-align: middle;\n    margin: 0;\n    outline: 0;\n    overflow: hidden;\n    transition: color 200ms ease-out 0s;\n}\n\n.k-rating-container .k-rating-item * {\n    pointer-events: none;\n}\n\n.k-rating-container .k-rating-item .k-rating-precision-part,\n.k-rating-container .k-rating-item .k-rating-precision-complement {\n    display: inherit;\n    position: absolute;\n    top: 0.5rem;\n    left: 0.5rem;\n    overflow: hidden;\n}\n\n.k-rating-container .k-rating-item .k-rating-precision-complement {\n    direction: rtl;\n}\n\n.k-rating-container .k-rating-item svg {\n    fill: currentColor;\n}\n\n.k-rating-label {\n    display: inline-flex;\n    align-items: center;\n    vertical-align: middle;\n    line-height: 2;\n    margin-block: 0.5rem;\n    margin-inline: 1rem;\n}\n\n.k-rtl .k-rating-precision-part,\n[dir=\"rtl\"] .k-rating-precision-part {\n    left: auto;\n    right: 0.5rem;\n}\n\n.k-rtl .k-rating-item .k-rating-precision-complement,\n[dir=\"rtl\"] .k-rating-item .k-rating-precision-complement {\n    direction: ltr;\n}\n\n.k-rating {\n    color: #212529;\n}\n\n.k-rating:focus .k-rating-item > .k-icon, .k-rating.k-focus .k-rating-item > .k-icon {\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n.k-rating:focus .k-rating-item.k-selected > .k-icon, .k-rating.k-focus .k-rating-item.k-selected > .k-icon {\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n.k-rating-item {\n    color: #6c757d;\n}\n\n.k-rating-item.k-selected {\n    color: #0d6efd;\n}\n\n.k-rating-item.k-selected:focus, .k-rating-item.k-selected.k-focus {\n    color: #0d6efd;\n}\n\n.k-rating-item:hover, .k-rating-item.k-hover {\n    color: #0d6efd;\n    cursor: pointer;\n}\n\n.k-switch {\n    box-sizing: border-box;\n    outline: 0;\n    display: inline-flex;\n    align-items: center;\n    vertical-align: middle;\n    line-height: 1;\n    position: relative;\n    cursor: pointer;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-switch *,\n.k-switch *::before,\n.k-switch *::after {\n    box-sizing: border-box;\n}\n\n.k-switch [type=\"checkbox\"] {\n    display: none;\n}\n\n.k-switch[aria-readonly=\"true\"] {\n    pointer-events: none;\n}\n\n.k-switch.k-readonly {\n    pointer-events: none;\n}\n\n.k-switch-track {\n    border-width: 1px;\n    border-style: solid;\n    outline: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    flex: 1 0 auto;\n    position: relative;\n    transition: background-color 200ms ease-in-out;\n}\n\n.k-switch-thumb-wrap {\n    width: 0;\n    height: 0;\n    overflow: visible;\n    position: absolute;\n    transition: left 200ms ease-in-out;\n    top: 50%;\n}\n\n.k-switch-thumb {\n    display: block;\n    position: absolute;\n    transform: translate(-50%, -50%);\n}\n\n.k-switch-label-on,\n.k-switch-label-off {\n    display: none;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    overflow: hidden;\n}\n\n.k-switch-sm {\n    width: 48px;\n    height: 26px;\n}\n\n.k-switch-sm .k-switch-track {\n    width: 48px;\n    height: 26px;\n}\n\n.k-switch-sm .k-switch-thumb {\n    width: 20px;\n    height: 20px;\n}\n\n.k-switch-sm.k-switch-on .k-switch-thumb-wrap {\n    left: calc(100% - 13px);\n}\n\n.k-switch-sm.k-switch-off .k-switch-thumb-wrap {\n    left: 13px;\n}\n\n.k-switch-sm[dir=\"rtl\"] .k-switch-label-on,\n[dir=\"rtl\"] .k-switch-sm .k-switch-label-on,\n.k-rtl .k-switch-sm .k-switch-label-on {\n    left: auto;\n}\n\n.k-switch-sm[dir=\"rtl\"] .k-switch-label-off,\n[dir=\"rtl\"] .k-switch-sm .k-switch-label-off,\n.k-rtl .k-switch-sm .k-switch-label-off {\n    right: auto;\n}\n\n.k-switch-sm[dir=\"rtl\"].k-switch-on .k-switch-thumb-wrap,\n[dir=\"rtl\"] .k-switch-sm.k-switch-on .k-switch-thumb-wrap,\n.k-rtl .k-switch-sm.k-switch-on .k-switch-thumb-wrap {\n    left: 13px;\n}\n\n.k-switch-sm[dir=\"rtl\"].k-switch-off .k-switch-thumb-wrap,\n[dir=\"rtl\"] .k-switch-sm.k-switch-off .k-switch-thumb-wrap,\n.k-rtl .k-switch-sm.k-switch-off .k-switch-thumb-wrap {\n    left: calc(100% - 13px);\n}\n\n.k-switch-md {\n    width: 56px;\n    height: 30px;\n}\n\n.k-switch-md .k-switch-track {\n    width: 56px;\n    height: 30px;\n}\n\n.k-switch-md .k-switch-thumb {\n    width: 24px;\n    height: 24px;\n}\n\n.k-switch-md.k-switch-on .k-switch-thumb-wrap {\n    left: calc(100% - 15px);\n}\n\n.k-switch-md.k-switch-off .k-switch-thumb-wrap {\n    left: 15px;\n}\n\n.k-switch-md[dir=\"rtl\"] .k-switch-label-on,\n[dir=\"rtl\"] .k-switch-md .k-switch-label-on,\n.k-rtl .k-switch-md .k-switch-label-on {\n    left: auto;\n}\n\n.k-switch-md[dir=\"rtl\"] .k-switch-label-off,\n[dir=\"rtl\"] .k-switch-md .k-switch-label-off,\n.k-rtl .k-switch-md .k-switch-label-off {\n    right: auto;\n}\n\n.k-switch-md[dir=\"rtl\"].k-switch-on .k-switch-thumb-wrap,\n[dir=\"rtl\"] .k-switch-md.k-switch-on .k-switch-thumb-wrap,\n.k-rtl .k-switch-md.k-switch-on .k-switch-thumb-wrap {\n    left: 15px;\n}\n\n.k-switch-md[dir=\"rtl\"].k-switch-off .k-switch-thumb-wrap,\n[dir=\"rtl\"] .k-switch-md.k-switch-off .k-switch-thumb-wrap,\n.k-rtl .k-switch-md.k-switch-off .k-switch-thumb-wrap {\n    left: calc(100% - 15px);\n}\n\n.k-switch-lg {\n    width: 64px;\n    height: 34px;\n}\n\n.k-switch-lg .k-switch-track {\n    width: 64px;\n    height: 34px;\n}\n\n.k-switch-lg .k-switch-thumb {\n    width: 28px;\n    height: 28px;\n}\n\n.k-switch-lg.k-switch-on .k-switch-thumb-wrap {\n    left: calc(100% - 17px);\n}\n\n.k-switch-lg.k-switch-off .k-switch-thumb-wrap {\n    left: 17px;\n}\n\n.k-switch-lg[dir=\"rtl\"] .k-switch-label-on,\n[dir=\"rtl\"] .k-switch-lg .k-switch-label-on,\n.k-rtl .k-switch-lg .k-switch-label-on {\n    left: auto;\n}\n\n.k-switch-lg[dir=\"rtl\"] .k-switch-label-off,\n[dir=\"rtl\"] .k-switch-lg .k-switch-label-off,\n.k-rtl .k-switch-lg .k-switch-label-off {\n    right: auto;\n}\n\n.k-switch-lg[dir=\"rtl\"].k-switch-on .k-switch-thumb-wrap,\n[dir=\"rtl\"] .k-switch-lg.k-switch-on .k-switch-thumb-wrap,\n.k-rtl .k-switch-lg.k-switch-on .k-switch-thumb-wrap {\n    left: 17px;\n}\n\n.k-switch-lg[dir=\"rtl\"].k-switch-off .k-switch-thumb-wrap,\n[dir=\"rtl\"] .k-switch-lg.k-switch-off .k-switch-thumb-wrap,\n.k-rtl .k-switch-lg.k-switch-off .k-switch-thumb-wrap {\n    left: calc(100% - 17px);\n}\n\n.k-switch[dir=\"rtl\"] .k-switch-thumb,\n[dir=\"rtl\"] .k-switch .k-switch-thumb,\n.k-switch.k-rtl .k-switch-thumb,\n.k-rtl .k-switch .k-switch-thumb {\n    transform: translate(50%, -50%);\n}\n\n.k-switch.k-disabled {\n    opacity: 1;\n    filter: none;\n}\n\n.k-switch-off .k-switch-track {\n    border-color: #adb5bd;\n    background-color: #ffffff;\n}\n\n.k-switch-off .k-switch-thumb {\n    background-color: #adb5bd;\n}\n\n.k-switch-off:focus .k-switch-track, .k-switch-off.k-focus .k-switch-track {\n    border-color: #86b7fe;\n    outline: 0.25rem solid rgba(13, 110, 253, 0.25);\n}\n\n.k-switch-off:disabled .k-switch-track, .k-switch-off.k-disabled .k-switch-track {\n    background-color: #e9ecef;\n}\n\n.k-switch-off .k-switch-label-on {\n    color: transparent;\n}\n\n.k-switch-on .k-switch-track {\n    border-color: #0d6efd;\n    background-color: #0d6efd;\n}\n\n.k-switch-on .k-switch-thumb {\n    background-color: white;\n}\n\n.k-switch-on:focus .k-switch-track, .k-switch-on.k-focus .k-switch-track {\n    outline: 0.25rem solid rgba(13, 110, 253, 0.25);\n}\n\n.k-switch-on:disabled .k-switch-track, .k-switch-on.k-disabled .k-switch-track {\n    background-color: #86b7fe;\n}\n\n.k-switch-on .k-switch-label-off {\n    color: transparent;\n}\n\n.k-external-dropzone {\n    height: 220px;\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.k-dropzone-inner {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    flex: 1 1 auto;\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.k-dropzone-inner .k-dropzone-icon {\n    margin-bottom: 1.5rem;\n}\n\n.k-dropzone-inner .k-dropzone-hint {\n    margin-bottom: 0.5rem;\n}\n\n.k-dropzone-inner .k-dropzone-note {\n    font-size: 0.75rem;\n}\n\n.k-dropzone-inner {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-dropzone-inner .k-icon,\n.k-dropzone-inner .k-dropzone-icon {\n    color: #afb1b2;\n}\n\n.k-dropzone-inner .k-dropzone-note {\n    color: #6c757d;\n}\n\n.k-external-dropzone-hover .k-icon,\n.k-external-dropzone-hover .k-dropzone-icon {\n    color: #0d6efd;\n}\n\n.k-upload {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    position: relative;\n    display: block;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-upload *,\n.k-upload *::before,\n.k-upload *::after {\n    box-sizing: border-box;\n}\n\n.k-upload .k-upload-button {\n    min-width: 7em;\n}\n\n.k-upload .k-dropzone,\n.k-upload .k-upload-dropzone {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 0;\n    text-align: end;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    background-color: transparent;\n}\n\n.k-upload .k-dropzone .k-dropzone-hint,\n.k-upload .k-upload-dropzone .k-dropzone-hint {\n    font-style: normal;\n    font-weight: normal;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: relative;\n    flex: 1;\n}\n\n.k-upload .k-dropzone .k-upload-status,\n.k-upload .k-upload-dropzone .k-upload-status {\n    font-weight: normal;\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.k-upload .k-dropzone .k-upload-status > .k-icon,\n.k-upload .k-upload-dropzone .k-upload-status > .k-icon {\n    margin-inline-end: 0.5rem;\n}\n\n.k-upload .k-dropzone .k-upload-status + .k-dropzone-hint,\n.k-upload .k-upload-dropzone .k-upload-status + .k-dropzone-hint {\n    display: none;\n}\n\n.k-upload .k-dropzone-active .k-upload-status {\n    display: none;\n}\n\n.k-upload .k-dropzone-active .k-upload-status + .k-dropzone-hint {\n    display: block;\n}\n\n.k-upload .k-upload-files {\n    max-height: 300px;\n    overflow-y: auto;\n    margin: 0;\n    padding: 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n    list-style: none;\n}\n\n.k-upload .k-upload-files .k-file-multiple,\n.k-upload .k-upload-files .k-file-single {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.k-upload .k-upload-files .k-file-single {\n    align-items: center;\n}\n\n.k-upload .k-upload-files .k-file-multiple {\n    align-items: flex-start;\n}\n\n.k-upload .k-upload-files .k-file {\n    padding: 1rem 1rem calc(1rem + 2px);\n    border-width: 0 0 1px;\n    border-style: solid;\n    outline: none;\n    display: flex;\n    align-items: flex-start;\n    position: relative;\n}\n\n.k-upload .k-upload-files .k-file:last-child {\n    border-width: 0;\n}\n\n.k-upload .k-upload-files .k-filename {\n    margin-left: 1rem;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    position: relative;\n}\n\n.k-upload .k-upload-files .k-upload-pct {\n    margin-block: 0;\n    margin-inline: 0.5rem;\n    font-weight: normal;\n    vertical-align: middle;\n}\n\n.k-upload .k-upload-files ~ .k-clear-selected,\n.k-upload .k-upload-files ~ .k-upload-selected {\n    margin-top: -0.5rem;\n    border-width: 0;\n}\n\n.k-upload .k-upload-files ~ .k-upload-selected {\n    border-left-width: 1px;\n    border-left-style: solid;\n    margin-left: -1px;\n}\n\n.k-upload .k-upload-files .k-file-name,\n.k-upload .k-upload-files .k-file-size,\n.k-upload .k-upload-files .k-file-validation-message,\n.k-upload .k-upload-files .k-file-summary {\n    display: block;\n}\n\n.k-upload .k-upload-files .k-file-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    position: relative;\n}\n\n.k-upload .k-upload-files .k-file-size,\n.k-upload .k-upload-files .k-file-summary,\n.k-upload .k-upload-files .k-file-validation-message {\n    font-size: 11px;\n    line-height: 1;\n}\n\n.k-upload .k-upload-files .k-file-icon-wrapper .k-file-state {\n    position: absolute;\n}\n\n.k-upload .k-upload-files .k-file-state {\n    visibility: hidden;\n}\n\n.k-upload .k-upload-files .k-file-info {\n    min-height: 32px;\n    display: block;\n    overflow: hidden;\n    flex: 1 0 0;\n}\n\n.k-upload .k-multiple-files-wrapper,\n.k-upload .k-file-single > .k-file-info {\n    margin-inline-start: 1rem;\n    min-height: 32px;\n    display: block;\n    overflow: hidden;\n    flex: 1 0 0;\n}\n\n.k-upload .k-multiple-files-wrapper .k-file-info {\n    margin-bottom: 12px;\n    display: block;\n}\n\n.k-upload .k-multiple-files-wrapper .k-file-summary {\n    margin-top: -4px;\n}\n\n.k-upload .k-progressbar {\n    --kendo-progressbar-height: 2px;\n    position: absolute;\n    left: 1rem;\n    right: 1rem;\n    bottom: 0.5rem;\n    width: auto;\n}\n\n.k-upload .k-actions, .k-upload .k-edit-buttons,\n.k-upload .k-action-buttons,\n.k-upload .k-columnmenu-actions, .k-upload .k-form-buttons {\n    border-top-width: 1px;\n}\n\n.k-upload-button-wrap {\n    position: relative;\n    direction: ltr;\n}\n\n.k-upload-button-wrap input {\n    font: 170px monospace !important;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    z-index: 1;\n}\n\n.k-upload-button-wrap input[disabled],\n.k-upload-button-wrap input.k-disabled {\n    visibility: hidden;\n}\n\n.k-upload {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-upload .k-dropzone,\n.k-upload .k-upload-dropzone {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-upload .k-dropzone.k-hover,\n.k-upload .k-upload-dropzone.k-hover {\n    background-color: #f4f5f6;\n}\n\n.k-upload .k-dropzone .k-dropzone-hint,\n.k-upload .k-upload-dropzone .k-dropzone-hint {\n    color: #6c757d;\n}\n\n.k-upload .k-upload-files,\n.k-upload .k-file {\n    border-color: #dee2e6;\n}\n\n.k-upload .k-file.k-focus {\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13);\n}\n\n.k-upload .k-file .k-upload-action.k-focus {\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13);\n}\n\n.k-upload .k-upload-status {\n    color: #6c757d;\n}\n\n.k-upload .k-file-progress .k-progressbar .k-selected {\n    background-color: #0dcaf0;\n}\n\n.k-upload .k-file-success .k-file-validation-message {\n    color: #198754;\n}\n\n.k-upload .k-file-success .k-progressbar .k-selected {\n    background-color: #198754;\n}\n\n.k-upload .k-file-error .k-file-validation-message {\n    color: #dc3545;\n}\n\n.k-upload .k-file-error .k-progressbar .k-selected {\n    background-color: #dc3545;\n}\n\n.k-upload .k-file-icon-wrapper {\n    color: #6c757d;\n    border-color: #6c757d;\n}\n\n.k-upload .k-file-size,\n.k-upload .k-file-validation-message,\n.k-upload .k-file-summary {\n    color: #6c757d;\n}\n\n.k-upload .k-multiple-files-wrapper .k-file-summary {\n    color: #212529;\n}\n\n.k-upload.k-invalid, .k-upload.ng-invalid.ng-touched, .k-upload.ng-invalid.ng-dirty {\n    border-color: #dc3545;\n}\n\n.k-appbar {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    list-style: none;\n    display: flex;\n    gap: 0.5rem;\n    flex-flow: row wrap;\n    align-items: center;\n    overflow: hidden;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-appbar *,\n.k-appbar *::before,\n.k-appbar *::after {\n    box-sizing: border-box;\n}\n\n.k-appbar > * {\n    flex-shrink: 0;\n}\n\n.k-appbar .k-appbar-section {\n    display: inline-flex;\n    flex-wrap: nowrap;\n    align-items: center;\n}\n\n.k-appbar .k-appbar-spacer {\n    flex: 1 0 auto;\n}\n\n.k-appbar .k-appbar-spacer-sized {\n    flex-grow: 0;\n}\n\n.k-appbar .k-appbar-separator {\n    margin: 0;\n    width: 0;\n    min-height: 1em;\n    border-style: solid;\n    border-width: 0 0 0 1px;\n    display: inline-block;\n}\n\n.k-appbar .k-input,\n.k-appbar .k-picker {\n    width: 10em;\n}\n\n.k-appbar .k-color-picker, .k-appbar .k-colorpicker {\n    width: min-content;\n}\n\n.k-appbar-static {\n    position: static;\n}\n\n.k-appbar-sticky {\n    width: 100%;\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n}\n\n.k-appbar-fixed {\n    width: 100%;\n    position: fixed;\n    z-index: 1;\n}\n\n.k-appbar-top {\n    top: 0;\n    bottom: auto;\n}\n\n.k-appbar-bottom {\n    top: auto;\n    bottom: 0;\n}\n\n.k-appbar-bottom.k-appbar-fixed {\n    bottom: 0;\n}\n\n.k-appbar {\n    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));\n}\n\n.k-appbar-bottom {\n    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));\n}\n\n.k-appbar-primary {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-appbar-secondary {\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-appbar-tertiary {\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-appbar-info {\n    color: white;\n    background-color: #0dcaf0;\n}\n\n.k-appbar-success {\n    color: white;\n    background-color: #198754;\n}\n\n.k-appbar-warning {\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-appbar-error {\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-appbar-dark {\n    color: white;\n    background-color: #212529;\n}\n\n.k-appbar-light {\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-appbar-inverse {\n    color: white;\n    background-color: #212529;\n}\n\n.k-fab {\n    padding: 0;\n    border-width: 0;\n    border-style: solid;\n    border-color: transparent;\n    box-sizing: border-box;\n    color: inherit;\n    background-color: transparent;\n    font-size: 1rem;\n    line-height: 1.5;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    text-align: center;\n    white-space: nowrap;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    outline: none;\n}\n\n.k-fab *,\n.k-fab *::before,\n.k-fab *::after {\n    box-sizing: border-box;\n}\n\n.k-fab:focus {\n    outline: none;\n}\n\n.k-fab-icon {\n    padding-inline: 0.25rem;\n    padding-block: 0.25rem;\n    box-sizing: content-box;\n}\n\n.k-icon-wrapper-host:not(:only-child) .k-fab-icon, .k-fab-icon:not(:only-child) {\n    margin-inline-end: 0.125rem;\n    margin-inline-start: -0.125rem;\n}\n\n.k-fab-sm {\n    padding: 0.5rem 0.5rem;\n}\n\n.k-fab-md {\n    padding: 1rem 1rem;\n}\n\n.k-fab-lg {\n    padding: 1.5rem 1.5rem;\n}\n\n.k-fab-items {\n    margin: 0;\n    padding-block: 1rem;\n    padding-inline: 0px;\n    display: flex;\n}\n\n.k-fab-items-bottom {\n    flex-direction: column;\n}\n\n.k-fab-items-bottom .k-fab-item:last-child {\n    margin-block-end: 0;\n}\n\n.k-fab-items-top {\n    flex-direction: column-reverse;\n}\n\n.k-fab-items-top .k-fab-item:first-child {\n    margin-block-end: 0;\n}\n\n.k-fab-item {\n    list-style-type: none;\n    margin-block-end: 0.5rem;\n    outline: none;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    cursor: pointer;\n}\n\n.k-fab-item.k-text-right {\n    flex-direction: row;\n}\n\n.k-fab-item.k-text-right .k-fab-item-text {\n    margin-right: 0.5rem;\n}\n\n.k-fab-item.k-text-left {\n    flex-direction: row-reverse;\n}\n\n.k-fab-item.k-text-left .k-fab-item-text {\n    margin-left: 0.5rem;\n}\n\n.k-fab-item-text {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    border-width: 1px;\n    border-radius: 4px;\n    font-size: 0.75rem;\n    line-height: 14px;\n}\n\n.k-fab-item-icon {\n    padding-block: 0.75rem;\n    padding-inline: 0.75rem;\n    border-width: 0;\n    border-radius: 50%;\n    box-sizing: content-box;\n    outline: none;\n}\n\n.k-rtl .k-fab-popup .k-fab-item.k-text-left,\n[dir=\"rtl\"] .k-fab-popup .k-fab-item.k-text-left {\n    flex-direction: row;\n}\n\n.k-rtl .k-fab-popup .k-fab-item.k-text-right,\n[dir=\"rtl\"] .k-fab-popup .k-fab-item.k-text-right {\n    flex-direction: row-reverse;\n}\n\n.k-fab-solid-primary {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #0d6efd;\n    outline-offset: -1px;\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-fab-solid-secondary {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #6c757d;\n    outline-offset: -1px;\n    border-color: #6c757d;\n    color: white;\n    background-color: #6c757d;\n}\n\n.k-fab-solid-tertiary {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #6f42c1;\n    outline-offset: -1px;\n    border-color: #6f42c1;\n    color: white;\n    background-color: #6f42c1;\n}\n\n.k-fab-solid-info {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #0dcaf0;\n    outline-offset: -1px;\n    border-color: #0dcaf0;\n    color: black;\n    background-color: #0dcaf0;\n}\n\n.k-fab-solid-success {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #198754;\n    outline-offset: -1px;\n    border-color: #198754;\n    color: white;\n    background-color: #198754;\n}\n\n.k-fab-solid-warning {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #ffc107;\n    outline-offset: -1px;\n    border-color: #ffc107;\n    color: black;\n    background-color: #ffc107;\n}\n\n.k-fab-solid-error {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #dc3545;\n    outline-offset: -1px;\n    border-color: #dc3545;\n    color: white;\n    background-color: #dc3545;\n}\n\n.k-fab-solid-dark {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #212529;\n    outline-offset: -1px;\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-fab-solid-light {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #f8f9fa;\n    outline-offset: -1px;\n    border-color: #f8f9fa;\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-fab-solid-inverse {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #212529;\n    outline-offset: -1px;\n    border-color: #212529;\n    color: white;\n    background-color: #212529;\n}\n\n.k-fab-solid-primary:hover,\n.k-fab-solid-primary.k-hover {\n    border-color: #0257d5;\n    color: white;\n    background-color: #025ce2;\n}\n\n.k-fab-solid-secondary:hover,\n.k-fab-solid-secondary.k-hover {\n    border-color: #545b62;\n    color: white;\n    background-color: #5a6268;\n}\n\n.k-fab-solid-tertiary:hover,\n.k-fab-solid-tertiary.k-hover {\n    border-color: #59339d;\n    color: white;\n    background-color: #5e37a6;\n}\n\n.k-fab-solid-info:hover,\n.k-fab-solid-info.k-hover {\n    border-color: #0aa1c0;\n    color: black;\n    background-color: #0babcc;\n}\n\n.k-fab-solid-success:hover,\n.k-fab-solid-success.k-hover {\n    border-color: #115c39;\n    color: white;\n    background-color: #136740;\n}\n\n.k-fab-solid-warning:hover,\n.k-fab-solid-warning.k-hover {\n    border-color: #d39e00;\n    color: black;\n    background-color: #e0a800;\n}\n\n.k-fab-solid-error:hover,\n.k-fab-solid-error.k-hover {\n    border-color: #bd2130;\n    color: white;\n    background-color: #c82333;\n}\n\n.k-fab-solid-dark:hover,\n.k-fab-solid-dark.k-hover {\n    border-color: #0a0c0d;\n    color: white;\n    background-color: #101214;\n}\n\n.k-fab-solid-light:hover,\n.k-fab-solid-light.k-hover {\n    border-color: #dae0e5;\n    color: black;\n    background-color: #e2e6ea;\n}\n\n.k-fab-solid-inverse:hover,\n.k-fab-solid-inverse.k-hover {\n    border-color: #0a0c0d;\n    color: white;\n    background-color: #101214;\n}\n\n.k-fab-solid-primary:focus,\n.k-fab-solid-primary.k-focus {\n    outline: 3px solid rgba(13, 110, 253, 0.5);\n}\n\n.k-fab-solid-secondary:focus,\n.k-fab-solid-secondary.k-focus {\n    outline: 3px solid rgba(108, 117, 125, 0.5);\n}\n\n.k-fab-solid-tertiary:focus,\n.k-fab-solid-tertiary.k-focus {\n    outline: 3px solid rgba(111, 66, 193, 0.5);\n}\n\n.k-fab-solid-info:focus,\n.k-fab-solid-info.k-focus {\n    outline: 3px solid rgba(13, 202, 240, 0.5);\n}\n\n.k-fab-solid-success:focus,\n.k-fab-solid-success.k-focus {\n    outline: 3px solid rgba(25, 135, 84, 0.5);\n}\n\n.k-fab-solid-warning:focus,\n.k-fab-solid-warning.k-focus {\n    outline: 3px solid rgba(255, 193, 7, 0.5);\n}\n\n.k-fab-solid-error:focus,\n.k-fab-solid-error.k-focus {\n    outline: 3px solid rgba(220, 53, 69, 0.5);\n}\n\n.k-fab-solid-dark:focus,\n.k-fab-solid-dark.k-focus {\n    outline: 3px solid rgba(33, 37, 41, 0.5);\n}\n\n.k-fab-solid-light:focus,\n.k-fab-solid-light.k-focus {\n    outline: 3px solid rgba(248, 249, 250, 0.5);\n}\n\n.k-fab-solid-inverse:focus,\n.k-fab-solid-inverse.k-focus {\n    outline: 3px solid rgba(33, 37, 41, 0.5);\n}\n\n.k-fab-solid-primary:active,\n.k-fab-solid-primary.k-active,\n.k-fab-solid-primary.k-selected {\n    border-color: #0252c9;\n    color: white;\n    background-color: #0257d5;\n}\n\n.k-fab-solid-secondary:active,\n.k-fab-solid-secondary.k-active,\n.k-fab-solid-secondary.k-selected {\n    border-color: #4e555b;\n    color: white;\n    background-color: #545b62;\n}\n\n.k-fab-solid-tertiary:active,\n.k-fab-solid-tertiary.k-active,\n.k-fab-solid-tertiary.k-selected {\n    border-color: #533093;\n    color: white;\n    background-color: #59339d;\n}\n\n.k-fab-solid-info:active,\n.k-fab-solid-info.k-active,\n.k-fab-solid-info.k-selected {\n    border-color: #0a97b4;\n    color: black;\n    background-color: #0aa1c0;\n}\n\n.k-fab-solid-success:active,\n.k-fab-solid-success.k-active,\n.k-fab-solid-success.k-selected {\n    border-color: #0f5133;\n    color: white;\n    background-color: #115c39;\n}\n\n.k-fab-solid-warning:active,\n.k-fab-solid-warning.k-active,\n.k-fab-solid-warning.k-selected {\n    border-color: #c69500;\n    color: black;\n    background-color: #d39e00;\n}\n\n.k-fab-solid-error:active,\n.k-fab-solid-error.k-active,\n.k-fab-solid-error.k-selected {\n    border-color: #b21f2d;\n    color: white;\n    background-color: #bd2130;\n}\n\n.k-fab-solid-dark:active,\n.k-fab-solid-dark.k-active,\n.k-fab-solid-dark.k-selected {\n    border-color: #050506;\n    color: white;\n    background-color: #0a0c0d;\n}\n\n.k-fab-solid-light:active,\n.k-fab-solid-light.k-active,\n.k-fab-solid-light.k-selected {\n    border-color: #d3d9df;\n    color: black;\n    background-color: #dae0e5;\n}\n\n.k-fab-solid-inverse:active,\n.k-fab-solid-inverse.k-active,\n.k-fab-solid-inverse.k-selected {\n    border-color: #050506;\n    color: white;\n    background-color: #0a0c0d;\n}\n\n.k-fab-solid-primary:disabled,\n.k-fab-solid-primary.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #64a2fe;\n    color: white;\n    opacity: 1;\n}\n\n.k-fab-solid-secondary:disabled,\n.k-fab-solid-secondary.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #a1a7ac;\n    color: white;\n    opacity: 1;\n}\n\n.k-fab-solid-tertiary:disabled,\n.k-fab-solid-tertiary.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #a386d7;\n    color: white;\n    opacity: 1;\n}\n\n.k-fab-solid-info:disabled,\n.k-fab-solid-info.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #64ddf5;\n    color: #666666;\n    opacity: 1;\n}\n\n.k-fab-solid-success:disabled,\n.k-fab-solid-success.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #6cb292;\n    color: white;\n    opacity: 1;\n}\n\n.k-fab-solid-warning:disabled,\n.k-fab-solid-warning.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #ffd760;\n    color: #666666;\n    opacity: 1;\n}\n\n.k-fab-solid-error:disabled,\n.k-fab-solid-error.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #e97e88;\n    color: white;\n    opacity: 1;\n}\n\n.k-fab-solid-dark:disabled,\n.k-fab-solid-dark.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #717376;\n    color: white;\n    opacity: 1;\n}\n\n.k-fab-solid-light:disabled,\n.k-fab-solid-light.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #fbfbfc;\n    color: #666666;\n    opacity: 1;\n}\n\n.k-fab-solid-inverse:disabled,\n.k-fab-solid-inverse.k-disabled {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: #717376;\n    color: white;\n    opacity: 1;\n}\n\n.k-fab-item-text {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n}\n\n.k-fab-item-icon {\n    border-color: #e4e7eb;\n    color: #212529;\n    background-color: #e4e7eb;\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #e4e7eb;\n    outline-offset: -1px;\n}\n\n.k-fab-item:hover .k-fab-item-icon,\n.k-fab-item.k-hover .k-fab-item-icon {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    outline: 1px solid #c7cdd5;\n    outline-offset: -1px;\n    border-color: #c7cdd5;\n    color: black;\n    background-color: #ced3db;\n}\n\n.k-fab-item:focus .k-fab-item-text,\n.k-fab-item.k-focus .k-fab-item-text,\n.k-fab-item:focus .k-fab-item-icon,\n.k-fab-item.k-focus .k-fab-item-icon {\n    outline: 3px solid rgba(228, 231, 235, 0.5);\n}\n\n.k-fab-item:active .k-fab-item-icon,\n.k-fab-item.k-active .k-fab-item-icon {\n    outline: 1px solid #bfc6d0;\n    outline-offset: -1px;\n    border-color: #bfc6d0;\n    color: black;\n    background-color: #c7cdd5;\n}\n\n.k-fab-item:disabled,\n.k-fab-item.k-disabled {\n    opacity: 1;\n}\n\n.k-fab-item:disabled .k-fab-item-text,\n.k-fab-item:disabled .k-fab-item-icon,\n.k-fab-item.k-disabled .k-fab-item-text,\n.k-fab-item.k-disabled .k-fab-item-icon {\n    box-shadow: var(--kendo-elevation-5, 0px 8px 16px 0px rgba(0, 0, 0, 0.15));\n    background-color: white;\n    color: #afb1b2;\n}\n\n.k-fab-popup {\n    box-shadow: none;\n}\n\n.k-actionsheet-container {\n    width: 100%;\n    height: 100%;\n    max-width: clamp(100vw, 100%, 100%);\n    max-height: clamp(100vh, 100%, 100%);\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 9999;\n    overflow: hidden;\n    transform: translateZ(0);\n}\n\n.k-actionsheet-container > .k-overlay {\n    position: absolute;\n    z-index: 1;\n}\n\n.k-actionsheet-container > .k-animation-container {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n}\n\n.k-actionsheet-container > .k-animation-container > .k-child-animation-container {\n    position: absolute;\n}\n\n.k-actionsheet-container > .k-actionsheet {\n    position: absolute;\n    z-index: 2;\n}\n\n.k-actionsheet-container .k-actionsheet {\n    pointer-events: all;\n}\n\n.k-actionsheet {\n    width: var(--kendo-actionsheet-width, 360px);\n    height: var(--kendo-actionsheet-height, 60vh);\n    max-width: var(--kendo-actionsheet-max-width, 100%);\n    max-height: var(--kendo-actionsheet-max-height, 60vh);\n    border-width: 0;\n    border-style: solid;\n    border-color: transparent;\n    box-sizing: border-box;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    overflow: hidden;\n    position: relative;\n}\n\n.k-actionsheet *,\n.k-actionsheet *::before,\n.k-actionsheet *::after {\n    box-sizing: border-box;\n}\n\n.k-actionsheet-titlebar, .k-actionsheet-jq .k-actionsheet-header {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    border-width: 0;\n    border-style: solid;\n    border-color: transparent;\n    flex: none;\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    gap: 1rem;\n}\n\n.k-actionsheet-titlebar-group {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    width: 100%;\n}\n\n.k-actionsheet-title {\n    flex: 1;\n}\n\n.k-actionsheet-subtitle {\n    font-size: 0.875rem;\n    line-height: 1.25;\n}\n\n.k-actionsheet-actions {\n    flex: none;\n}\n\n.k-actionsheet-content {\n    flex: 1;\n    overflow: auto;\n    position: relative;\n}\n\n.k-actionsheet-footer {\n    flex: none;\n}\n\n.k-actionsheet-items {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    flex: none;\n}\n\n.k-actionsheet-item {\n    padding: 0;\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: row nowrap;\n    outline: none;\n}\n\n.k-actionsheet-action {\n    margin: 0;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    min-height: 40px;\n    box-sizing: border-box;\n    color: inherit;\n    text-decoration: none;\n    outline: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.k-actionsheet-item-text {\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-actionsheet-item-description {\n    font-size: 0.875em;\n}\n\n.k-actionsheet .k-hr {\n    margin: 0;\n    flex: none;\n}\n\n.k-actionsheet-top {\n    border-bottom-right-radius: 0px;\n    border-bottom-left-radius: 0px;\n    border-width: 0px;\n    border-top-width: 0;\n    top: 0;\n    inset-inline-start: 50%;\n    transform: translateX(-50%);\n}\n\n.k-actionsheet-bottom {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n    border-width: 0px;\n    border-bottom-width: 0;\n    bottom: 0;\n    inset-inline-start: 50%;\n    transform: translateX(-50%);\n}\n\n.k-actionsheet-left {\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n    border-width: 0px;\n    border-left-width: 0;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.k-actionsheet-right {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    border-width: 0px;\n    border-right-width: 0;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.k-actionsheet-fullscreen {\n    width: 100%;\n    max-width: 100%;\n    max-height: 100%;\n    height: 100%;\n}\n\n.k-animation-container > .k-actionsheet {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    transform: none;\n}\n\n.k-adaptive-actionsheet {\n    max-width: 100%;\n    width: 100%;\n    font-size: 1.25rem;\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-adaptive-actionsheet .k-actionsheet-titlebar, .k-adaptive-actionsheet .k-actionsheet-jq .k-actionsheet-header, .k-actionsheet-jq .k-adaptive-actionsheet .k-actionsheet-header {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-bottom-width: 1px;\n}\n\n.k-adaptive-actionsheet .k-actionsheet-content {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n}\n\n.k-adaptive-actionsheet .k-actionsheet-footer {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n}\n\n.k-adaptive-actionsheet .k-actionsheet-filter {\n    width: calc(min(100%, calc( 360px - 2rem) ));\n}\n\n.k-adaptive-actionsheet .k-actionsheet-content,\n.k-adaptive-actionsheet .k-actionsheet-footer {\n    margin-inline: auto;\n    width: min(100%, 360px);\n}\n\n.k-adaptive-actionsheet .k-list-container,\n.k-adaptive-actionsheet .k-treeview {\n    height: 100%;\n}\n\n.k-adaptive-actionsheet .k-list-filter {\n    width: 100%;\n    padding-inline: 0;\n}\n\n.k-adaptive-actionsheet .k-menu-group {\n    height: 100%;\n    overflow: auto;\n    position: static;\n}\n\n.k-adaptive-actionsheet .k-calendar {\n    margin-inline: auto;\n    border-width: 0;\n    display: flex;\n}\n\n.k-adaptive-actionsheet .k-timeselector {\n    height: 100%;\n    border-width: 0;\n    overflow: hidden;\n}\n\n.k-adaptive-actionsheet .k-timeselector .k-time-part {\n    display: contents;\n}\n\n.k-adaptive-actionsheet .k-timeselector .k-time-list-wrapper {\n    height: 100%;\n}\n\n.k-adaptive-actionsheet .k-datetime-wrap {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-adaptive-actionsheet .k-datetime-selector {\n    flex: 1 1 auto;\n}\n\n.k-adaptive-actionsheet .k-datetime-calendar-wrap {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    flex: 0 0 100%;\n}\n\n.k-adaptive-actionsheet .k-datetime-time-wrap {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 100%;\n    bottom: 0;\n    flex: 0 0 100%;\n}\n\n.k-adaptive-actionsheet .k-scrollable-wrap {\n    height: 100%;\n    overflow-y: auto;\n}\n\n.k-adaptive-actionsheet .k-data-table {\n    max-height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-actionsheet-jq.k-actionsheet {\n    height: auto;\n}\n\n.k-actionsheet-jq .k-actionsheet-header {\n    align-items: flex-start;\n}\n\n.k-actionsheet-jq .k-actionsheet-action {\n    align-items: center;\n}\n\n.k-rtl .k-actionsheet-top,\n.k-rtl .k-actionsheet-bottom,\n[dir=\"rtl\"] .k-actionsheet-top,\n[dir=\"rtl\"] .k-actionsheet-bottom {\n    transform: translateX(50%);\n}\n\n.k-actionsheet {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n    box-shadow: var(--kendo-elevation-7, 0px 14px 36px 0px rgba(0, 0, 0, 0.168));\n}\n\n.k-actionsheet-subtitle {\n    color: #6c757d;\n}\n\n.k-actionsheet-item:hover, .k-actionsheet-item.k-hover {\n    background-color: #e9ecef;\n}\n\n.k-actionsheet-item:focus, .k-actionsheet-item.k-focus {\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13);\n}\n\n.k-actionsheet-item-description {\n    color: #6c757d;\n}\n\n.k-actionsheet .k-hr {\n    border-color: #dee2e6;\n}\n\n.k-adaptive-actionsheet .k-actionsheet-titlebar, .k-adaptive-actionsheet .k-actionsheet-jq .k-actionsheet-header, .k-actionsheet-jq .k-adaptive-actionsheet .k-actionsheet-header {\n    border-color: #dee2e6;\n}\n\n.k-window {\n    border-radius: 0.375rem;\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: inline-flex;\n    flex-direction: column;\n    position: absolute;\n    z-index: 10002;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-window.k-window-maximized {\n    max-width: 100vw;\n    max-height: 100vh;\n    box-shadow: none;\n}\n\n.k-window-sm {\n    width: 300px;\n}\n\n.k-window-md {\n    width: 800px;\n}\n\n.k-window-lg {\n    width: 1200px;\n}\n\n.k-window-titlebar {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-width: 0 0 1px;\n    border-style: solid;\n    white-space: nowrap;\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    align-items: center;\n}\n\n.k-window-minimized .k-window-titlebar {\n    border-width: 0;\n}\n\n.k-window-title {\n    padding-block: .5em;\n    padding-inline: 0;\n    margin-block: -.5em;\n    margin-inline: 0;\n    font-size: 1.25rem;\n    line-height: 1.5;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    cursor: default;\n    flex: 1;\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.k-window-title::before {\n    content: \"\\200b\";\n}\n\n.k-window-titlebar-actions {\n    margin-block: -5em;\n    margin-inline: 0;\n    margin-inline-end: 0rem;\n    line-height: 1;\n    display: flex;\n    gap: 0.5rem;\n    flex-flow: row nowrap;\n    flex-shrink: 0;\n    align-items: center;\n    vertical-align: top;\n}\n\n.k-window-titlebar-action {\n    flex-shrink: 0;\n    opacity: 0.5;\n}\n\n.k-window-titlebar-action:hover {\n    opacity: 0.75;\n}\n\n.k-window-content,\n.k-prompt-container {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-width: 0;\n    border-color: inherit;\n    color: inherit;\n    background: none;\n    outline: 0;\n    overflow: auto;\n    position: relative;\n    flex: 1 1 auto;\n}\n\n.k-window-content + .k-prompt-container {\n    margin-top: -0.5rem;\n}\n\n.k-window-content:first-child {\n    padding-top: clamp(1rem, 1rem, 1rem);\n}\n\n.k-window-content:last-child {\n    padding-bottom: clamp(1rem, 1rem, 1rem);\n}\n\n.k-window-iframecontent {\n    padding: 0;\n    overflow: visible;\n}\n\n.k-window-iframecontent .k-content-frame {\n    vertical-align: top;\n    border: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.k-window-actions {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n    flex: 0 0 auto;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    overflow: hidden;\n}\n\n.k-prompt-container > .k-textarea {\n    width: 100%;\n}\n\n.k-window .k-resize-n {\n    top: 0;\n}\n\n.k-window .k-resize-e {\n    right: 0;\n}\n\n.k-window .k-resize-s {\n    bottom: 0;\n}\n\n.k-window .k-resize-w {\n    left: 0;\n}\n\n.k-window {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-window-titlebar {\n    border-color: #dee2e6;\n}\n\n.k-window-primary .k-window-titlebar {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-window-light .k-window-titlebar {\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-window-dark .k-window-titlebar {\n    color: white;\n    background-color: #212529;\n}\n\n.k-dialog-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    outline: 0;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10001;\n}\n\n.k-dialog-wrapper .k-dialog {\n    position: relative;\n}\n\n.k-dialog {\n    padding: 0;\n    position: fixed;\n    box-sizing: border-box;\n}\n\n.k-dialog.k-dialog-centered {\n    transform: translate(-50%, -50%);\n    top: 50%;\n    left: 50%;\n}\n\n.k-dialog .k-multiselect {\n    width: 100%;\n}\n\n.k-dialog-actions {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n    flex: 0 0 auto;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    gap: 0.5rem;\n    overflow: hidden;\n}\n\n.k-dialog-primary .k-dialog-titlebar {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-dialog-light .k-dialog-titlebar {\n    color: black;\n    background-color: #f8f9fa;\n}\n\n.k-dialog-dark .k-dialog-titlebar {\n    color: white;\n    background-color: #212529;\n}\n\n.k-drawer-container {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: flex-start;\n}\n\nkendo-drawer.k-drawer,\nkendo-drawer .k-drawer-wrapper {\n    transition: none;\n}\n\n.k-drawer {\n    height: 100%;\n    max-width: 100%;\n    border-width: 0;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 auto;\n    transition: all 300ms ease-in-out;\n    overflow: hidden;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-drawer *,\n.k-drawer *::before,\n.k-drawer *::after {\n    box-sizing: border-box;\n}\n\n.k-drawer-mini .k-drawer.k-drawer-start,\n.k-drawer-expanded .k-drawer.k-drawer-start,\n.k-drawer-left.k-drawer-mini .k-drawer,\n.k-drawer-left.k-drawer-expanded .k-drawer {\n    border-right-width: 1px;\n}\n\n.k-drawer-mini .k-drawer.k-drawer-end,\n.k-drawer-expanded .k-drawer.k-drawer-end,\n.k-drawer-right.k-drawer-mini .k-drawer,\n.k-drawer-right.k-drawer-expanded .k-drawer {\n    border-left-width: 1px;\n}\n\n.k-drawer.k-drawer-start,\n.k-drawer-left .k-drawer {\n    top: 0;\n    left: 0;\n}\n\n.k-drawer.k-drawer-end,\n.k-drawer-right .k-drawer {\n    top: 0;\n    right: 0;\n}\n\n.k-drawer-content {\n    flex: 1 1 auto;\n    overflow: auto;\n}\n\n.k-drawer-overlay .k-drawer {\n    max-width: 80vw;\n    position: fixed;\n    z-index: 10002;\n    border: 0;\n}\n\n.k-drawer-overlay > .k-overlay {\n    display: none;\n}\n\n.k-drawer-overlay.k-drawer-expanded > .k-overlay {\n    display: block;\n}\n\n.k-drawer-push {\n    display: flex;\n    flex-direction: row;\n}\n\n.k-drawer-push .k-drawer {\n    height: auto;\n    position: relative;\n    align-self: stretch;\n}\n\n.k-drawer-push .k-drawer.k-drawer-end,\n.k-drawer-push.k-drawer-right .k-drawer {\n    order: 1;\n}\n\n.k-drawer-wrapper {\n    overflow-x: hidden;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    transition: all 300ms ease-in-out;\n}\n\n.k-drawer-wrapper::-webkit-scrollbar {\n    width: 7px;\n}\n\n.k-drawer-wrapper::-webkit-scrollbar-thumb {\n    border-radius: 20px;\n}\n\n.k-drawer-items,\n.k-drawer-items ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n}\n\n.k-drawer-item {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    outline: 0;\n    color: inherit;\n    font-size: 16px;\n    line-height: 2;\n    display: flex;\n    flex-flow: row nowrap;\n    gap: 1rem;\n    cursor: pointer;\n}\n\n.k-drawer-item > .k-drawer-link {\n    margin-block: -0.5rem;\n    margin-inline: -1rem;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    color: inherit;\n    display: flex;\n    flex-flow: row nowrap;\n    flex: 1 0 auto;\n    gap: 1rem;\n}\n\n.k-drawer-item .k-icon {\n    flex-shrink: 0;\n    padding-inline: 0;\n    padding-block: 0.5rem;\n    box-sizing: content-box;\n}\n\n.k-drawer-item .k-icon.k-i-none {\n    margin: 0;\n}\n\n.k-drawer-item .k-item-text {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-drawer-item .k-drawer-toggle {\n    margin-inline-start: auto;\n    cursor: pointer;\n    display: flex;\n}\n\n.k-drawer-item.k-level-1 {\n    padding-inline-start: 2rem;\n}\n\n.k-drawer-item.k-level-2 {\n    padding-inline-start: 3rem;\n}\n\n.k-drawer-item.k-level-3 {\n    padding-inline-start: 4rem;\n}\n\n.k-drawer-item.k-level-4 {\n    padding-inline-start: 5rem;\n}\n\n.k-drawer-item.k-level-5 {\n    padding-inline-start: 6rem;\n}\n\n.k-drawer-separator {\n    padding: 0;\n    height: 1px;\n}\n\n.k-drawer-mini .k-drawer-wrapper {\n    width: calc(2rem + 16px);\n}\n\n.k-rtl.k-drawer-mini .k-drawer-start,\n.k-rtl .k-drawer-mini .k-drawer-start,\n.k-rtl .k-drawer-expanded .k-drawer-start,\n.k-rtl.k-drawer-expanded .k-drawer-start,\n[dir=\"rtl\"].k-drawer-mini .k-drawer-start,\n[dir=\"rtl\"] .k-drawer-mini .k-drawer-start,\n[dir=\"rtl\"] .k-drawer-expanded .k-drawer-start,\n[dir=\"rtl\"].k-drawer-expanded .k-drawer-start {\n    border-left-width: 1px;\n    border-right-width: 0;\n}\n\n.k-rtl.k-drawer-mini .k-drawer-end,\n.k-rtl .k-drawer-mini .k-drawer-end,\n.k-rtl.k-drawer-expanded .k-drawer-end .k-drawer-expanded .k-drawer-end,\n[dir=\"rtl\"].k-drawer-mini .k-drawer-end,\n[dir=\"rtl\"] .k-drawer-mini .k-drawer-end,\n[dir=\"rtl\"].k-drawer-expanded .k-drawer-end .k-drawer-expanded .k-drawer-end {\n    border-left-width: 0;\n    border-right-width: 1px;\n}\n\n.k-rtl.k-drawer-overlay .k-drawer-start,\n.k-rtl .k-drawer-overlay .k-drawer-start,\n[dir=\"rtl\"].k-drawer-overlay .k-drawer-start,\n[dir=\"rtl\"] .k-drawer-overlay .k-drawer-start {\n    left: auto;\n    right: 0;\n}\n\n.k-rtl.k-drawer-overlay .k-drawer-end,\n.k-rtl .k-drawer-overlay .k-drawer-end,\n[dir=\"rtl\"].k-drawer-overlay .k-drawer-end,\n[dir=\"rtl\"] .k-drawer-overlay .k-drawer-end {\n    left: 0;\n    right: auto;\n}\n\n.k-rtl .k-drawer-left.k-drawer-push .k-drawer,\n[dir=\"rtl\"] .k-drawer-left.k-drawer-push .k-drawer {\n    order: 1;\n}\n\n.k-rtl .k-drawer-right.k-drawer-push .k-drawer,\n[dir=\"rtl\"] .k-drawer-right.k-drawer-push .k-drawer {\n    order: 0;\n}\n\n.k-drawer {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-drawer-wrapper {\n    scrollbar-color: rgba(156, 156, 156, 0.7) #dedede;\n}\n\n.k-drawer-wrapper::-webkit-scrollbar-track {\n    background: #dedede;\n}\n\n.k-drawer-wrapper::-webkit-scrollbar-thumb {\n    background: rgba(156, 156, 156, 0.7);\n}\n\n.k-drawer-wrapper::-webkit-scrollbar-thumb:hover {\n    background: #9c9c9c;\n}\n\n.k-drawer-item:hover, .k-drawer-item.k-hover {\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-drawer-item:focus, .k-drawer-item.k-focus {\n    background-color: #e9ecef;\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.15);\n}\n\n.k-drawer-item:focus:hover, .k-drawer-item:focus.k-hover, .k-drawer-item.k-focus:hover, .k-drawer-item.k-focus.k-hover {\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-drawer-item.k-selected {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-drawer-item.k-selected:hover, .k-drawer-item.k-selected.k-hover {\n    color: white;\n    background-color: #0c65e9;\n}\n\n.k-drawer-separator {\n    background-color: #dee2e6;\n}\n\n.k-notification-group {\n    max-height: 100%;\n    display: inline-flex;\n    flex-flow: column-reverse wrap;\n    position: fixed;\n    z-index: 1000;\n    gap: 0.75rem 0;\n}\n\n.k-notification-container-animating {\n    overflow: hidden;\n}\n\n.k-notification {\n    border-radius: 0.375rem;\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 0.875rem;\n    line-height: 1.5;\n    cursor: default;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-notification *,\n.k-notification *::before,\n.k-notification *::after {\n    box-sizing: border-box;\n}\n\n.k-notification > .k-notification-content {\n    flex: 1 1 auto;\n}\n\n.k-notification-actions {\n    flex: none;\n    display: flex;\n    gap: 0.5rem;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-self: center;\n    cursor: pointer;\n}\n\n.k-notification-action {\n    flex: none;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-self: center;\n}\n\n.k-notification {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));\n}\n\n.k-notification-inverse {\n    border-color: #d3d3d4;\n    color: #111315;\n    background-color: #c1c2c3;\n}\n\n.k-notification-light {\n    border-color: #fefefe;\n    color: #818182;\n    background-color: #fdfdfe;\n}\n\n.k-notification-dark {\n    border-color: #d3d3d4;\n    color: #111315;\n    background-color: #c1c2c3;\n}\n\n.k-notification-error {\n    border-color: #f8d7da;\n    color: #721c24;\n    background-color: #f5c6cb;\n}\n\n.k-notification-warning {\n    border-color: #fff3cd;\n    color: #856404;\n    background-color: #ffeeba;\n}\n\n.k-notification-success {\n    border-color: #d1e7dd;\n    color: #0d462c;\n    background-color: #bfddcf;\n}\n\n.k-notification-info {\n    border-color: #cff4fc;\n    color: #07697d;\n    background-color: #bbf0fb;\n}\n\n.k-notification-tertiary {\n    border-color: #e2d9f3;\n    color: #3a2264;\n    background-color: #d7caee;\n}\n\n.k-notification-secondary {\n    border-color: #e2e3e5;\n    color: #383d41;\n    background-color: #d6d8db;\n}\n\n.k-notification-primary {\n    border-color: #cfe2ff;\n    color: #073984;\n    background-color: #bbd6fe;\n}\n\nkendo-card,\nkendo-card-header,\nkendo-card-body,\nkendo-card-actions,\nkendo-card-footer {\n    display: block;\n}\n\n.k-card {\n    border-radius: 0.375rem;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-card *,\n.k-card *::before,\n.k-card *::after {\n    box-sizing: border-box;\n}\n\n.k-card .k-card-avatar,\n.k-card .k-avatar {\n    margin-right: 1rem;\n    width: 45px;\n    height: 45px;\n    flex-basis: 45px;\n}\n\n.k-card > .k-card-inner {\n    border-radius: calc(0.375rem - 1px);\n    display: flex;\n    flex-direction: inherit;\n    overflow: hidden;\n    position: relative;\n}\n\n.k-card-horizontal {\n    flex-flow: row nowrap;\n}\n\n.k-card-vertical {\n    flex-flow: column nowrap;\n}\n\n.k-card-header {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-width: 0 0 1px;\n    border-style: solid;\n    outline: 0;\n    flex-shrink: 0;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n}\n\n.k-card-header .k-card-title,\n.k-card-header .k-card-subtitle {\n    margin-bottom: 0;\n}\n\n.k-card-header .k-card-title + .k-card-subtitle,\n.k-card-header .k-card-subtitle + .k-card-subtitle {\n    margin-top: 0.75rem;\n}\n\n.k-card-footer {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-width: 1px 0 0;\n    border-style: solid;\n    outline: 0;\n    flex-shrink: 0;\n}\n\n.k-card-body {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    outline: 0;\n    flex: 1 1 auto;\n}\n\n.k-card-body p {\n    margin: 0 0 1rem;\n}\n\n.k-card-body > .k-last,\n.k-card-body > :last-child {\n    margin-bottom: 0;\n}\n\n.k-card-body > .k-card-actions {\n    padding: 0;\n}\n\n.k-card-media {\n    border: 0;\n    max-width: 100%;\n    flex-shrink: 0;\n    overflow: hidden;\n}\n\n.k-card-horizontal .k-card-media {\n    max-width: 100px;\n    object-fit: cover;\n}\n\n.k-card-title {\n    margin: 0 0 0.75rem;\n    font-size: 1.25rem;\n    line-height: 1.2;\n    font-weight: 500;\n}\n\n.k-card-subtitle {\n    margin: 0 0 0.75rem;\n    font-size: 1rem;\n    line-height: 1.2;\n    font-weight: 500;\n}\n\n.k-card-separator {\n    margin: 0;\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n    display: block;\n    flex: 0 0 auto;\n    align-self: stretch;\n}\n\n.k-card-separator.k-separator-horizontal,\n.k-card-vertical > .k-card-separator {\n    border-top-width: 1px;\n}\n\n.k-card-separator.k-separator-vertical,\n.k-card-horizontal > .k-card-separator {\n    border-left-width: 1px;\n}\n\n.k-card > .k-hr {\n    margin: 0;\n    flex: 0 0 auto;\n    border-color: inherit;\n}\n\n.k-card-actions {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n    overflow: hidden;\n    display: flex;\n    flex-shrink: 0;\n    flex-basis: auto;\n    gap: 0.5rem;\n}\n\n.k-card-horizontal .k-actions-horizontal {\n    width: auto;\n}\n\n.k-card-list {\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: stretch;\n    gap: 1rem;\n    flex: 0 0 auto;\n}\n\n.k-card-list .k-card {\n    flex: 0 0 auto;\n}\n\n.k-card-deck {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: stretch;\n    gap: 1rem;\n    flex: 0 0 auto;\n}\n\n.k-card-deck .k-card {\n    flex: 0 0 auto;\n}\n\n.k-card-deck-scrollwrap {\n    padding-bottom: 3px;\n    width: 100%;\n    box-sizing: content-box;\n    display: flex;\n    flex: 0 0 auto;\n    align-items: center;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-card-deck-scrollwrap > .k-button {\n    border-radius: 0px;\n    flex: 0 0 auto;\n    position: absolute;\n    z-index: 1;\n}\n\n.k-card-deck-scrollwrap > .k-button:first-child {\n    left: -1px;\n}\n\n.k-card-deck-scrollwrap > .k-button:last-child {\n    right: -1px;\n}\n\n.k-card-deck-scrollwrap > .k-card-deck {\n    margin-bottom: -20px;\n    padding-bottom: 20px;\n    flex: 1 1 auto;\n}\n\n.k-card-group {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: stretch;\n    flex: 0 0 auto;\n}\n\n.k-card-group .k-card {\n    border-radius: 0;\n    flex: 0 0 auto;\n}\n\n.k-card-group .k-card + .k-card {\n    margin-inline-start: 1px;\n}\n\n.k-card-group .k-card.k-first {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n}\n\n.k-card-group .k-card.k-last {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n}\n\n.k-card-group .k-card.k-only {\n    border-radius: 0.375rem;\n}\n\n.k-card-with-callout {\n    overflow: visible;\n}\n\n.k-card-callout {\n    margin: 0;\n    width: 1.3em;\n    height: 1.3em;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    position: absolute;\n}\n\n.k-card-callout.k-callout-n {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.k-card-callout.k-callout-e {\n    top: 50%;\n    right: 0;\n    transform: translate(50%, -50%) rotate(-45deg);\n}\n\n.k-card-callout.k-callout-s {\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, 50%) rotate(45deg);\n}\n\n.k-card-callout.k-callout-w {\n    top: 50%;\n    left: 0;\n    transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.k-card-flat {\n    box-shadow: none;\n}\n\n.k-card {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-card .k-card-inner {\n    background-color: inherit;\n    border-color: inherit;\n}\n\n.k-card:focus, .k-card.k-focus {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-card.k-selected {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-card-actions {\n    border-color: #dee2e6;\n}\n\n.k-card-header {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-card-footer {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-card-separator,\n.k-card .k-separator {\n    border-color: #dee2e6;\n}\n\n.k-card-subtitle {\n    color: #6c757d;\n}\n\n.k-card-primary {\n    background-color: #cfe2ff;\n    color: #073984;\n    border-color: #bbd6fe;\n}\n\n.k-card-primary .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-secondary {\n    background-color: #e2e3e5;\n    color: #383d41;\n    border-color: #d6d8db;\n}\n\n.k-card-secondary .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-tertiary {\n    background-color: #e2d9f3;\n    color: #3a2264;\n    border-color: #d7caee;\n}\n\n.k-card-tertiary .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-info {\n    background-color: #cff4fc;\n    color: #07697d;\n    border-color: #bbf0fb;\n}\n\n.k-card-info .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-success {\n    background-color: #d1e7dd;\n    color: #0d462c;\n    border-color: #bfddcf;\n}\n\n.k-card-success .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-warning {\n    background-color: #fff3cd;\n    color: #856404;\n    border-color: #ffeeba;\n}\n\n.k-card-warning .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-error {\n    background-color: #f8d7da;\n    color: #721c24;\n    border-color: #f5c6cb;\n}\n\n.k-card-error .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-dark {\n    background-color: #d3d3d4;\n    color: #111315;\n    border-color: #c1c2c3;\n}\n\n.k-card-dark .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-light {\n    background-color: #fefefe;\n    color: #818182;\n    border-color: #fdfdfe;\n}\n\n.k-card-light .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-inverse {\n    background-color: #d3d3d4;\n    color: #111315;\n    border-color: #c1c2c3;\n}\n\n.k-card-inverse .k-card-subtitle {\n    color: inherit;\n}\n\n.k-card-wrap:focus > .k-card, .k-card-wrap.k-focus > .k-card, .k-card-wrap.k-selected > .k-card {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-card-callout {\n    border-color: inherit;\n    background-color: inherit;\n    box-shadow: inherit;\n}\n\n.k-popover {\n    border-radius: 0.375rem;\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    display: flex;\n    flex-flow: column nowrap;\n    z-index: 12000;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-popover *,\n.k-popover *::before,\n.k-popover *::after {\n    box-sizing: border-box;\n}\n\n.k-popover-inner {\n    height: inherit;\n    position: relative;\n    border-radius: inherit;\n    border-color: inherit;\n}\n\n.k-popover-header {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-width: 0 0 1px;\n    border-style: solid;\n    border-color: inherit;\n}\n\n.k-popover-body {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n}\n\n.k-popover-actions {\n    border-width: 1px 0 0;\n}\n\n.k-popover-callout {\n    margin: 0;\n    width: 1.3em;\n    height: 1.3em;\n    border-width: 1px;\n    border-style: solid;\n    position: absolute;\n}\n\n.k-popover-callout.k-callout-n {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.k-popover-callout.k-callout-e {\n    top: 50%;\n    right: 0;\n    transform: translate(50%, -50%) rotate(-45deg);\n}\n\n.k-popover-callout.k-callout-s {\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, 50%) rotate(45deg);\n}\n\n.k-popover-callout.k-callout-w {\n    top: 50%;\n    left: 0;\n    transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.k-popover {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-popover-inner {\n    background-color: inherit;\n    border-color: inherit;\n}\n\n.k-popover-callout {\n    border-color: inherit;\n    background-color: inherit;\n    box-shadow: inherit;\n}\n\n.k-rpanel-left,\n.k-rpanel-right {\n    position: fixed;\n    display: block;\n    overflow: auto;\n    min-width: 320px;\n    height: 100%;\n    top: 0;\n}\n\n.k-rpanel-left + *,\n.k-rpanel-right + * {\n    overflow: auto;\n}\n\n.k-rpanel-left.k-rpanel-expanded,\n.k-rpanel-right.k-rpanel-expanded {\n    transform: translateX(0) translateZ(0);\n}\n\n.k-rpanel-left {\n    transform: translateX(-100%) translateZ(0);\n    left: 0;\n}\n\n.k-rpanel-right {\n    transform: translateX(100%) translateZ(0);\n    right: 0;\n}\n\n.k-rpanel-top {\n    position: static;\n    max-height: 0;\n}\n\n.k-rpanel-top.k-rpanel-expanded {\n    max-height: 568px;\n    overflow: visible !important;\n}\n\n.k-rpanel-toggle {\n    touch-action: manipulation;\n}\n\n.k-bottom-nav {\n    padding-block: 0px;\n    padding-inline: 0px;\n    width: 100%;\n    border-width: 0;\n    border-style: solid;\n    border-color: transparent;\n    box-sizing: border-box;\n    font-size: 1rem;\n    line-height: normal;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    letter-spacing: 0.2px;\n    display: flex;\n    flex-flow: row nowrap;\n    white-space: nowrap;\n    gap: 0px;\n    overflow: hidden;\n    outline: none;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-bottom-nav *,\n.k-bottom-nav *::before,\n.k-bottom-nav *::after {\n    box-sizing: border-box;\n}\n\n.k-bottom-nav-border {\n    border-width: 1px 0px 0px 0px;\n}\n\n.k-bottom-nav-shadow {\n    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));\n}\n\n.k-bottom-nav-item {\n    padding-block: 0;\n    padding-inline: 0.5rem;\n    min-width: 72px;\n    min-height: calc(40px + 1rem);\n    border-width: 0;\n    box-sizing: border-box;\n    font: inherit;\n    display: inline-flex;\n    flex: 1 1 auto;\n    align-items: center;\n    justify-content: center;\n    gap: 0 0.25rem;\n    text-decoration: none;\n    cursor: pointer;\n    color: inherit;\n    background-color: inherit;\n    border-color: inherit;\n    outline: none;\n}\n\n.k-bottom-nav-item:focus {\n    outline: none;\n}\n\n.k-bottom-nav-item:hover {\n    color: inherit;\n    text-decoration: none;\n}\n\n.k-bottom-nav-item > .k-bottom-nav-link {\n    margin-block: 0;\n    margin-inline: -0.5rem;\n    padding-block: 0;\n    padding-inline: 0.5rem;\n    width: 100%;\n    color: inherit;\n    display: flex;\n    flex-flow: row nowrap;\n    flex: 1 0 auto;\n    align-items: center;\n    justify-content: center;\n    outline: 0;\n}\n\n.k-bottom-nav-item.k-disabled {\n    background-color: initial;\n}\n\n.k-bottom-nav-item-text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n}\n\n.k-bottom-nav-item-flow-horizontal .k-bottom-nav-item {\n    flex-flow: row nowrap;\n}\n\n.k-bottom-nav-item-flow-vertical .k-bottom-nav-item {\n    flex-direction: column;\n}\n\n.k-bottom-nav.k-pos-fixed, .k-bottom-nav.k-fixed {\n    bottom: 0;\n    z-index: 1;\n}\n\n.k-bottom-nav-solid-primary, .k-bottom-nav-solid.k-bottom-nav-primary {\n    color: #aaccfe;\n    background-color: #0d6efd;\n}\n\n.k-bottom-nav-solid-primary .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-primary .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item:focus {\n    background-color: rgba(170, 204, 254, 0.2);\n}\n\n.k-bottom-nav-solid-primary .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-primary .k-bottom-nav-item.k-selected {\n    color: white;\n}\n\n.k-bottom-nav-solid-secondary, .k-bottom-nav-solid.k-bottom-nav-secondary {\n    color: #cccfd2;\n    background-color: #6c757d;\n}\n\n.k-bottom-nav-solid-secondary .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-secondary .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item:focus {\n    background-color: rgba(204, 207, 210, 0.2);\n}\n\n.k-bottom-nav-solid-secondary .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-secondary .k-bottom-nav-item.k-selected {\n    color: white;\n}\n\n.k-bottom-nav-solid-tertiary, .k-bottom-nav-solid.k-bottom-nav-tertiary {\n    color: #cdbde9;\n    background-color: #6f42c1;\n}\n\n.k-bottom-nav-solid-tertiary .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-tertiary .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item:focus {\n    background-color: rgba(205, 189, 233, 0.2);\n}\n\n.k-bottom-nav-solid-tertiary .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-tertiary .k-bottom-nav-item.k-selected {\n    color: white;\n}\n\n.k-bottom-nav-solid-info, .k-bottom-nav-solid.k-bottom-nav-info {\n    color: #aaecfa;\n    background-color: #0dcaf0;\n}\n\n.k-bottom-nav-solid-info .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-info .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item:focus {\n    background-color: rgba(170, 236, 250, 0.2);\n}\n\n.k-bottom-nav-solid-info .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-info .k-bottom-nav-item.k-selected {\n    color: white;\n}\n\n.k-bottom-nav-solid-success, .k-bottom-nav-solid.k-bottom-nav-success {\n    color: #afd5c3;\n    background-color: #198754;\n}\n\n.k-bottom-nav-solid-success .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-success .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item:focus {\n    background-color: rgba(175, 213, 195, 0.2);\n}\n\n.k-bottom-nav-solid-success .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-success .k-bottom-nav-item.k-selected {\n    color: white;\n}\n\n.k-bottom-nav-solid-warning, .k-bottom-nav-solid.k-bottom-nav-warning {\n    color: #594402;\n    background-color: #ffc107;\n}\n\n.k-bottom-nav-solid-warning .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-warning .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item:focus {\n    background-color: rgba(89, 68, 2, 0.2);\n}\n\n.k-bottom-nav-solid-warning .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-warning .k-bottom-nav-item.k-selected {\n    color: black;\n}\n\n.k-bottom-nav-solid-error, .k-bottom-nav-solid.k-bottom-nav-error {\n    color: #f3b8be;\n    background-color: #dc3545;\n}\n\n.k-bottom-nav-solid-error .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-error .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item:focus {\n    background-color: rgba(243, 184, 190, 0.2);\n}\n\n.k-bottom-nav-solid-error .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-error .k-bottom-nav-item.k-selected {\n    color: white;\n}\n\n.k-bottom-nav-solid-dark, .k-bottom-nav-solid.k-bottom-nav-dark {\n    color: #b1b3b4;\n    background-color: #212529;\n}\n\n.k-bottom-nav-solid-dark .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-dark .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item:focus {\n    background-color: rgba(177, 179, 180, 0.2);\n}\n\n.k-bottom-nav-solid-dark .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-dark .k-bottom-nav-item.k-selected {\n    color: white;\n}\n\n.k-bottom-nav-solid-light, .k-bottom-nav-solid.k-bottom-nav-light {\n    color: #575758;\n    background-color: #f8f9fa;\n}\n\n.k-bottom-nav-solid-light .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-light .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item:focus {\n    background-color: rgba(87, 87, 88, 0.2);\n}\n\n.k-bottom-nav-solid-light .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-light .k-bottom-nav-item.k-selected {\n    color: black;\n}\n\n.k-bottom-nav-solid-inverse, .k-bottom-nav-solid.k-bottom-nav-inverse {\n    color: #b1b3b4;\n    background-color: #212529;\n}\n\n.k-bottom-nav-solid-inverse .k-bottom-nav-item.k-focus, .k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-focus,\n.k-bottom-nav-solid-inverse .k-bottom-nav-item:focus,\n.k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item:focus {\n    background-color: rgba(177, 179, 180, 0.2);\n}\n\n.k-bottom-nav-solid-inverse .k-bottom-nav-item.k-selected, .k-bottom-nav-solid.k-bottom-nav-inverse .k-bottom-nav-item.k-selected {\n    color: white;\n}\n\n.k-bottom-nav-flat-primary, .k-bottom-nav-flat.k-bottom-nav-primary {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-primary .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-primary .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-primary .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-primary .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-primary .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-primary .k-bottom-nav-item.k-selected {\n    color: #0d6efd;\n}\n\n.k-bottom-nav-flat-secondary, .k-bottom-nav-flat.k-bottom-nav-secondary {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-secondary .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-secondary .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-secondary .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-secondary .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-secondary .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-secondary .k-bottom-nav-item.k-selected {\n    color: #52595f;\n}\n\n.k-bottom-nav-flat-tertiary, .k-bottom-nav-flat.k-bottom-nav-tertiary {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-tertiary .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-tertiary .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-tertiary .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-tertiary .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-tertiary .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-tertiary .k-bottom-nav-item.k-selected {\n    color: #6f42c1;\n}\n\n.k-bottom-nav-flat-info, .k-bottom-nav-flat.k-bottom-nav-info {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-info .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-info .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-info .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-info .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-info .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-info .k-bottom-nav-item.k-selected {\n    color: #0dcaf0;\n}\n\n.k-bottom-nav-flat-success, .k-bottom-nav-flat.k-bottom-nav-success {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-success .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-success .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-success .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-success .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-success .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-success .k-bottom-nav-item.k-selected {\n    color: #198754;\n}\n\n.k-bottom-nav-flat-warning, .k-bottom-nav-flat.k-bottom-nav-warning {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-warning .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-warning .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-warning .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-warning .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-warning .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-warning .k-bottom-nav-item.k-selected {\n    color: #ffc107;\n}\n\n.k-bottom-nav-flat-error, .k-bottom-nav-flat.k-bottom-nav-error {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-error .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-error .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-error .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-error .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-error .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-error .k-bottom-nav-item.k-selected {\n    color: #dc3545;\n}\n\n.k-bottom-nav-flat-dark, .k-bottom-nav-flat.k-bottom-nav-dark {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-dark .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-dark .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-dark .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-dark .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-dark .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-dark .k-bottom-nav-item.k-selected {\n    color: #212529;\n}\n\n.k-bottom-nav-flat-light, .k-bottom-nav-flat.k-bottom-nav-light {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-light .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-light .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-light .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-light .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-light .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-light .k-bottom-nav-item.k-selected {\n    color: #bcbdbe;\n}\n\n.k-bottom-nav-flat-inverse, .k-bottom-nav-flat.k-bottom-nav-inverse {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-bottom-nav-flat-inverse .k-bottom-nav-item.k-focus, .k-bottom-nav-flat.k-bottom-nav-inverse .k-bottom-nav-item.k-focus,\n.k-bottom-nav-flat-inverse .k-bottom-nav-item:focus,\n.k-bottom-nav-flat.k-bottom-nav-inverse .k-bottom-nav-item:focus {\n    background-color: rgba(33, 37, 41, 0.05);\n}\n\n.k-bottom-nav-flat-inverse .k-bottom-nav-item.k-selected, .k-bottom-nav-flat.k-bottom-nav-inverse .k-bottom-nav-item.k-selected {\n    color: #212529;\n}\n\n.k-breadcrumb {\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    display: flex;\n    flex-direction: row;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-breadcrumb *,\n.k-breadcrumb *::before,\n.k-breadcrumb *::after {\n    box-sizing: border-box;\n}\n\n.k-breadcrumb-container,\n.k-breadcrumb-root-item-container {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-flow: row nowrap;\n    overflow: hidden;\n}\n\n.k-breadcrumb-root-item-container {\n    align-items: flex-start;\n    flex-shrink: 0;\n}\n\n.k-breadcrumb-item {\n    vertical-align: middle;\n    display: inline-flex;\n    flex-direction: row;\n    flex: none;\n    align-items: center;\n    overflow: hidden;\n}\n\n.k-breadcrumb-root-item {\n    flex-shrink: 0;\n}\n\n.k-breadcrumb-link,\n.k-breadcrumb-root-link {\n    border-radius: 0.375rem;\n    color: inherit;\n    text-decoration: none;\n    white-space: nowrap;\n    outline: none;\n    cursor: pointer;\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    align-self: stretch;\n    overflow: hidden;\n    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.k-breadcrumb-link > .k-image,\n.k-breadcrumb-icontext-link .k-icon {\n    margin-inline-end: 0.5rem;\n}\n\n.k-breadcrumb-delimiter,\n.k-breadcrumb-delimiter-icon {\n    color: inherit;\n    opacity: 0.65;\n}\n\n.k-breadcrumb-input-container {\n    width: 100%;\n}\n\n.k-breadcrumb-input-container .k-breadcrumb-input-container {\n    border-color: transparent;\n}\n\n.k-breadcrumb-sm {\n    font-size: 0.875rem;\n    line-height: 1.4285714286;\n}\n\n.k-breadcrumb-sm .k-breadcrumb-link,\n.k-breadcrumb-sm .k-breadcrumb-root-link {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n}\n\n.k-breadcrumb-sm .k-breadcrumb-icon-link {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-breadcrumb-md {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-breadcrumb-md .k-breadcrumb-link,\n.k-breadcrumb-md .k-breadcrumb-root-link {\n    padding-block: 0.5rem;\n    padding-inline: 0.75rem;\n}\n\n.k-breadcrumb-md .k-breadcrumb-icon-link {\n    padding-block: 0.75rem;\n    padding-inline: 0.75rem;\n}\n\n.k-breadcrumb-lg {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.k-breadcrumb-lg .k-breadcrumb-link,\n.k-breadcrumb-lg .k-breadcrumb-root-link {\n    padding-block: 0.625rem;\n    padding-inline: 0.75rem;\n}\n\n.k-breadcrumb-lg .k-breadcrumb-icon-link {\n    padding-block: 0.875rem;\n    padding-inline: 0.875rem;\n}\n\n.k-breadcrumb-link,\n.k-breadcrumb-root-link {\n    text-decoration: underline;\n}\n\n.k-breadcrumb-current-item .k-disabled, .k-breadcrumb-last-item .k-disabled {\n    opacity: 1;\n    filter: none;\n}\n\n.k-breadcrumb {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-breadcrumb:focus, .k-breadcrumb.k-focus {\n    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.06);\n}\n\n.k-breadcrumb-link {\n    color: #0d6efd;\n}\n\n.k-breadcrumb-link:hover, .k-breadcrumb-link.k-hover {\n    color: #0a58ca;\n}\n\n.k-breadcrumb-link:focus, .k-breadcrumb-link.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.25);\n}\n\n.k-breadcrumb-root-link {\n    color: #0d6efd;\n}\n\n.k-breadcrumb-root-link:hover, .k-breadcrumb-root-link.k-hover {\n    color: #0a58ca;\n}\n\n.k-breadcrumb-root-link:focus, .k-breadcrumb-root-link.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.25);\n}\n\n.k-breadcrumb-current-item .k-breadcrumb-link, .k-breadcrumb-last-item .k-breadcrumb-link {\n    color: #6c757d;\n}\n\n.k-pager {\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    position: relative;\n    overflow: hidden;\n    cursor: default;\n    flex: 0 0 auto;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-pager *,\n.k-pager *::before,\n.k-pager *::after {\n    box-sizing: border-box;\n}\n\n.k-pager-input, .k-pager-sizes, .k-pager-info {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.k-pager-nav {\n    color: inherit;\n    text-align: center;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.k-pager-nav:hover {\n    z-index: 2;\n}\n\n.k-disabled.k-pager-nav {\n    color: inherit;\n}\n\n.k-pager-numbers-wrap {\n    display: flex;\n    flex-direction: row;\n    position: relative;\n}\n\n.k-pager-numbers-wrap select.k-dropdown-list, .k-pager-numbers-wrap select.k-dropdown,\n.k-pager-numbers-wrap select.k-dropdownlist {\n    width: 5em;\n}\n\n.k-pager-numbers {\n    display: flex;\n    flex-direction: row;\n}\n\n.k-pager-numbers .k-selected {\n    cursor: inherit;\n    z-index: 2;\n}\n\n.k-pager-nav + .k-pager-nav,\n.k-pager-nav + .k-pager-numbers-wrap,\n.k-pager-numbers-wrap + .k-pager-nav {\n    margin-left: -1px;\n}\n\n.k-rtl .k-pager-nav + .k-pager-nav,\n[dir=\"rtl\"] .k-pager-nav + .k-pager-nav, .k-rtl\n.k-pager-nav + .k-pager-numbers-wrap,\n[dir=\"rtl\"]\n.k-pager-nav + .k-pager-numbers-wrap, .k-rtl\n.k-pager-numbers-wrap + .k-pager-nav,\n[dir=\"rtl\"]\n.k-pager-numbers-wrap + .k-pager-nav {\n    margin-left: 0;\n    margin-right: -1px;\n}\n\n.k-pager-input {\n    gap: 1ex;\n}\n\n.k-pager-input .k-textbox,\n.k-pager-input .k-numerictextbox {\n    margin-block: 0;\n    width: 5em;\n}\n\n.k-pager-sizes {\n    gap: 1ex;\n}\n\n.k-pager-sizes .k-input-inner,\n.k-pager-sizes .k-input-value-text {\n    text-overflow: clip;\n}\n\n.k-pager-info {\n    text-align: end;\n    justify-content: flex-end;\n    flex: 1 1 0%;\n    order: 9;\n}\n\n.k-pager-refresh {\n    margin-inline-start: auto;\n    color: inherit;\n    order: 10;\n}\n\n.k-pager-sm {\n    padding-inline: 0.25rem;\n    padding-block: 0.25rem;\n    gap: 0.875rem;\n}\n\n.k-pager-sm .k-pager-numbers-wrap .k-button {\n    min-width: calc(1.4285714286em + 0.5rem + 2px);\n}\n\n.k-pager-sm .k-pager-numbers-wrap .k-pager-input,\n.k-pager-sm .k-pager-numbers-wrap > select.k-dropdown-list,\n.k-pager-sm .k-pager-numbers-wrap > select.k-dropdown,\n.k-pager-sm .k-pager-numbers-wrap > select.k-dropdownlist {\n    margin-inline-start: 0.875rem;\n    margin-inline-end: 0.875rem;\n}\n\n.k-pager-sm .k-pager-sizes .k-dropdown-list, .k-pager-sm .k-pager-sizes .k-dropdown,\n.k-pager-sm .k-pager-sizes .k-dropdownlist,\n.k-pager-sm .k-pager-sizes > select {\n    width: 5em;\n}\n\n.k-pager-md {\n    padding-inline: 0.5rem;\n    padding-block: 0.5rem;\n    gap: 1rem;\n}\n\n.k-pager-md .k-pager-numbers-wrap .k-button {\n    min-width: calc(1.5em + 0.75rem + 2px);\n}\n\n.k-pager-md .k-pager-numbers-wrap .k-pager-input,\n.k-pager-md .k-pager-numbers-wrap > select.k-dropdown-list,\n.k-pager-md .k-pager-numbers-wrap > select.k-dropdown,\n.k-pager-md .k-pager-numbers-wrap > select.k-dropdownlist {\n    margin-inline-start: 1rem;\n    margin-inline-end: 1rem;\n}\n\n.k-pager-md .k-pager-sizes .k-dropdown-list, .k-pager-md .k-pager-sizes .k-dropdown,\n.k-pager-md .k-pager-sizes .k-dropdownlist,\n.k-pager-md .k-pager-sizes > select {\n    width: 5em;\n}\n\n.k-pager-lg {\n    padding-inline: 0.625rem;\n    padding-block: 0.625rem;\n    gap: 1.125rem;\n}\n\n.k-pager-lg .k-pager-numbers-wrap .k-button {\n    min-width: calc(1.5em + 1rem + 2px);\n}\n\n.k-pager-lg .k-pager-numbers-wrap .k-pager-input,\n.k-pager-lg .k-pager-numbers-wrap > select.k-dropdown-list,\n.k-pager-lg .k-pager-numbers-wrap > select.k-dropdown,\n.k-pager-lg .k-pager-numbers-wrap > select.k-dropdownlist {\n    margin-inline-start: 1.125rem;\n    margin-inline-end: 1.125rem;\n}\n\n.k-pager-lg .k-pager-sizes .k-dropdown-list, .k-pager-lg .k-pager-sizes .k-dropdown,\n.k-pager-lg .k-pager-sizes .k-dropdownlist,\n.k-pager-lg .k-pager-sizes > select {\n    width: 6em;\n}\n\n.k-pager-nav {\n    border-radius: 0;\n}\n\n.k-pager-first {\n    border-radius: 0.25rem 0 0 0.25rem;\n}\n\n.k-pager-last {\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n\n.k-rtl .k-pager-first,\n[dir=\"rtl\"] .k-pager-first {\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n\n.k-rtl .k-pager-last,\n[dir=\"rtl\"] .k-pager-last {\n    border-radius: 0.25rem 0 0 0.25rem;\n}\n\n.k-pager {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-pager:focus, .k-pager.k-focus {\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n\n.k-stepper {\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-size: 1rem;\n    line-height: 1.5;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    display: block;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    color: inherit;\n    background: none;\n}\n\n.k-stepper *,\n.k-stepper *::before,\n.k-stepper *::after {\n    box-sizing: border-box;\n}\n\n.k-stepper .k-step-list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    position: relative;\n    z-index: 1;\n}\n\n.k-stepper .k-step-link {\n    outline: none;\n    color: inherit;\n    text-decoration: none;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n}\n\n.k-stepper .k-step-indicator {\n    border-radius: 50%;\n    margin: 3px;\n    width: 28px;\n    height: 28px;\n    border-width: 1px;\n    border-style: solid;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: none;\n    position: relative;\n    z-index: 1;\n    overflow: visible;\n    transition-property: color, background-color, border-color;\n    transition-duration: .4s;\n    transition-timing-function: ease-in-out;\n}\n\n.k-stepper .k-step-indicator::before {\n    border-radius: 50%;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n}\n\n.k-stepper .k-step-indicator::after {\n    border-radius: 100%;\n    content: \"\";\n    border-width: 1px;\n    border-style: solid;\n    border-color: inherit;\n    pointer-events: none;\n    display: none;\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    bottom: -4px;\n    left: -4px;\n    z-index: 2;\n}\n\n.k-stepper .k-step.k-focus .k-step-indicator::after,\n.k-stepper .k-step-link:focus .k-step-indicator::after {\n    display: block;\n}\n\n.k-stepper .k-step-label {\n    max-width: clamp(100%, 10em, 100%);\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n}\n\n.k-stepper .k-step-label:only-child {\n    border-radius: 15px;\n    padding-block: 5px;\n    padding-inline: 12px;\n    border-width: 0;\n}\n\n.k-stepper .k-step-label .k-step-text {\n    max-width: calc(10em - 16px - 0.5rem);\n    flex-grow: 1;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.k-stepper .k-step-label .k-icon {\n    margin-left: 0.5rem;\n}\n\n.k-stepper .k-step-current .k-step-label {\n    font-weight: bold;\n}\n\n.k-stepper .k-step-label-optional {\n    flex-basis: 100%;\n    font-size: 0.875rem;\n}\n\n.k-stepper .k-step-disabled,\n.k-stepper .k-step.k-disabled {\n    opacity: 1;\n    pointer-events: none;\n}\n\n.k-stepper .k-step-disabled .k-step-link,\n.k-stepper .k-step.k-disabled .k-step-link {\n    cursor: default;\n}\n\n.k-stepper .k-step-disabled .k-step-label-optional,\n.k-stepper .k-step.k-disabled .k-step-label-optional {\n    color: inherit;\n}\n\n.k-stepper .k-progressbar {\n    pointer-events: none;\n    z-index: 0;\n    overflow: visible;\n}\n\n.k-stepper .k-progressbar-horizontal {\n    grid-row: 1 / -1;\n}\n\n.k-stepper .k-progressbar-vertical {\n    position: absolute;\n}\n\n.k-step-list-horizontal {\n    flex-direction: row;\n    grid-row: 1;\n}\n\n.k-step-list-horizontal .k-step {\n    flex: 1 0 auto;\n    text-align: center;\n}\n\n.k-step-list-horizontal .k-step-link {\n    margin: auto;\n    max-width: 10em;\n    flex-direction: column;\n}\n\n.k-step-list-horizontal .k-step-label {\n    text-align: center;\n}\n\n.k-step-list-horizontal .k-step-indicator + .k-step-label {\n    margin-top: 5px;\n}\n\n.k-step-list-horizontal ~ .k-progressbar {\n    width: 100%;\n    height: 2px;\n    top: 17px;\n}\n\n.k-step-list-vertical {\n    flex-direction: column;\n}\n\n.k-step-list-vertical .k-step {\n    min-height: 54px;\n}\n\n.k-step-list-vertical .k-step-label {\n    justify-content: flex-start;\n}\n\n.k-step-list-vertical .k-step-indicator + .k-step-label {\n    margin-left: 12px;\n}\n\n.k-step-list-vertical ~ .k-progressbar {\n    width: 2px;\n    height: 100%;\n    min-height: 20px;\n    left: 17px;\n}\n\n.k-step-list-vertical .k-step-content {\n    height: 0;\n    overflow: hidden;\n    transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.k-step-list-vertical .k-step-current .k-step-content {\n    height: auto;\n    overflow: visible;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin-left: 30px;\n    padding-block: 20px;\n    padding-inline: 10px;\n}\n\n.k-rtl .k-stepper,\n.k-stepper[dir=\"rtl\"] {\n    direction: rtl;\n}\n\n.k-rtl .k-stepper .k-step-label .k-icon,\n.k-stepper[dir=\"rtl\"] .k-step-label .k-icon {\n    margin-left: 0;\n    margin-right: 0.5rem;\n}\n\n.k-rtl .k-stepper .k-step-list-vertical .k-step-indicator + .k-step-label,\n.k-stepper[dir=\"rtl\"] .k-step-list-vertical .k-step-indicator + .k-step-label {\n    margin-left: 0;\n    margin-right: 12px;\n}\n\n.k-rtl .k-stepper .k-step-list-vertical ~ .k-progressbar,\n.k-stepper[dir=\"rtl\"] .k-step-list-vertical ~ .k-progressbar {\n    left: auto;\n    right: 17px;\n}\n\n.k-stepper {\n    color: #212529;\n}\n\n.k-stepper .k-step:hover .k-step-indicator, .k-stepper .k-step.k-hover .k-step-indicator, .k-stepper .k-step.k-step-hover .k-step-indicator {\n    background-color: #ebebeb;\n}\n\n.k-stepper .k-step.k-focus .k-step-label:only-child,\n.k-stepper .k-step .k-step-link:focus .k-step-label:only-child {\n    box-shadow: inset 0 0 0 2px #dee2e6;\n}\n\n.k-stepper .k-step.k-step-disabled .k-step-indicator, .k-stepper .k-step.k-disabled .k-step-indicator, .k-stepper .k-step:disabled .k-step-indicator {\n    color: #adb5bd;\n}\n\n.k-stepper .k-step.k-step-disabled .k-step-label, .k-stepper .k-step.k-disabled .k-step-label, .k-stepper .k-step:disabled .k-step-label {\n    color: #adb5bd;\n}\n\n.k-stepper .k-step-indicator {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-stepper .k-step-indicator::after {\n    box-shadow: inset 0 0 0 2px #ffffff;\n}\n\n.k-stepper .k-step-label:only-child {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-stepper .k-step-done .k-step-indicator {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-stepper .k-step-done:hover .k-step-indicator, .k-stepper .k-step-done.k-hover .k-step-indicator, .k-stepper .k-step-done.k-step-hover .k-step-indicator {\n    background-color: #0c65e9;\n}\n\n.k-stepper .k-step-done.k-step-disabled .k-step-indicator, .k-stepper .k-step-done.k-disabled .k-step-indicator, .k-stepper .k-step-done:disabled .k-step-indicator {\n    border-color: #6ea8fe;\n    color: white;\n    background-color: #6ea8fe;\n}\n\n.k-stepper .k-step-current .k-step-indicator {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-stepper .k-step-current:hover .k-step-indicator, .k-stepper .k-step-current.k-hover .k-step-indicator, .k-stepper .k-step-current.k-step-hover .k-step-indicator {\n    background-color: #0c65e9;\n}\n\n.k-stepper .k-step-current.k-step-disabled .k-step-indicator, .k-stepper .k-step-current.k-disabled .k-step-indicator, .k-stepper .k-step-current:disabled .k-step-indicator {\n    border-color: #6ea8fe;\n    color: white;\n    background-color: #6ea8fe;\n}\n\n.k-stepper .k-step-success .k-step-label .k-icon {\n    color: #198754;\n}\n\n.k-stepper .k-step-error .k-step-label {\n    color: #dc3545;\n}\n\n.k-stepper .k-step-error:hover .k-step-label, .k-stepper .k-step-error.k-hover .k-step-label, .k-stepper .k-step-error.k-step-hover .k-step-label {\n    color: #dc3545;\n}\n\n.k-stepper .k-step-label-optional {\n    color: #6c757d;\n}\n\n.k-tabstrip-wrapper {\n    padding-block: 0px;\n    padding-inline: 0px;\n    box-sizing: border-box;\n    border-width: 0px;\n    border-style: solid;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.k-tabstrip {\n    border-width: 0;\n    border-color: transparent;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    color: inherit;\n    background-color: transparent;\n    display: flex;\n    flex-flow: column nowrap;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-tabstrip-wrapper > .k-tabstrip {\n    flex: 1 1 auto;\n}\n\n.k-tabstrip-items-wrapper {\n    box-sizing: border-box;\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n    position: relative;\n}\n\n.k-tabstrip-items {\n    box-sizing: border-box;\n    outline: 0;\n    display: flex;\n    flex-direction: inherit;\n    flex-wrap: wrap;\n    flex: 1 1 auto;\n    gap: 0;\n}\n\n.k-tabstrip-items *,\n.k-tabstrip-items *::before,\n.k-tabstrip-items *::after {\n    box-sizing: border-box;\n}\n\n.k-tabstrip-items .k-item {\n    margin: 0;\n    padding: 0;\n    border: 1px solid transparent;\n    position: relative;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    justify-items: stretch;\n    outline: 0;\n}\n\n.k-tabstrip-items .k-tab-on-top {\n    z-index: 1;\n}\n\n.k-tabstrip-items .k-link {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    color: inherit;\n    cursor: pointer;\n    display: inline-flex;\n    vertical-align: middle;\n    flex: 1 1 auto;\n    flex-direction: row;\n    align-content: center;\n    align-items: center;\n}\n\n.k-tabstrip-content,\n.k-tabstrip > .k-content {\n    margin: 0 !important;\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    box-sizing: border-box;\n    border-width: 1px;\n    border-style: solid;\n    border-color: inherit;\n    display: none;\n    overflow: auto;\n    flex: 1 1 auto;\n    position: relative;\n}\n\n.k-tabstrip-content.k-active,\n.k-tabstrip > .k-content.k-active {\n    display: block;\n}\n\n.k-tabstrip-content:focus, .k-tabstrip-content.k-focus,\n.k-tabstrip > .k-content:focus,\n.k-tabstrip > .k-content.k-focus {\n    outline-width: 1px;\n    outline-style: dotted;\n    outline-offset: -1px;\n}\n\n.k-tabstrip-items .k-loading {\n    width: 20%;\n    height: 0;\n    border: 0;\n    border-top: 1px solid transparent;\n    border-color: inherit;\n    background: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    transition: width .2s linear;\n    display: none;\n}\n\n.k-tabstrip-items .k-loading.k-complete {\n    width: 100%;\n    border-top-width: 0;\n}\n\n.k-tabstrip-scrollable > .k-tabstrip-items-wrapper > .k-tabstrip-items {\n    flex-wrap: nowrap;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.k-tabstrip-scrollable > .k-tabstrip-items-wrapper > .k-button {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    width: auto;\n    height: auto;\n    flex: none;\n    align-self: stretch;\n    aspect-ratio: auto;\n}\n\n.k-tabstrip-scrollable > .k-tabstrip-items-wrapper > .k-button .k-button-icon {\n    min-width: auto;\n    min-height: auto;\n}\n\n.k-tabstrip-horizontal, .k-tabstrip-top > .k-tabstrip-items-wrapper, .k-tabstrip-bottom > .k-tabstrip-items-wrapper {\n    flex-direction: row;\n}\n\n.k-tabstrip-vertical, .k-tabstrip-left > .k-tabstrip-items-wrapper, .k-tabstrip-right > .k-tabstrip-items-wrapper {\n    flex-direction: column;\n}\n\n.k-tabstrip-top > .k-tabstrip-items-wrapper {\n    border-bottom-width: 1px;\n}\n\n.k-tabstrip-top > .k-tabstrip-items-wrapper .k-item {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n    border-bottom-width: 0;\n}\n\n.k-tabstrip-top > .k-tabstrip-items-wrapper .k-item:active,\n.k-tabstrip-top > .k-tabstrip-items-wrapper .k-item.k-active {\n    margin-bottom: -1px;\n    border-bottom-width: 1px;\n    border-bottom-color: transparent !important;\n}\n\n.k-tabstrip-top > .k-content,\n.k-tabstrip-top > .k-tabstrip-content {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-top-width: 0 !important;\n}\n\n.k-tabstrip-bottom > .k-tabstrip-items-wrapper {\n    border-top-width: 1px;\n}\n\n.k-tabstrip-bottom > .k-tabstrip-items-wrapper .k-item {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-top-width: 0;\n}\n\n.k-tabstrip-bottom > .k-tabstrip-items-wrapper .k-item:active,\n.k-tabstrip-bottom > .k-tabstrip-items-wrapper .k-item.k-active {\n    margin-top: -1px;\n    border-top-width: 1px;\n    border-top-color: transparent !important;\n}\n\n.k-tabstrip-bottom > .k-content,\n.k-tabstrip-bottom > .k-tabstrip-content {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n    border-bottom-width: 0 !important;\n}\n\n.k-tabstrip-left {\n    flex-direction: row;\n}\n\n.k-tabstrip-left > .k-tabstrip-items-wrapper {\n    border-right-width: 1px;\n}\n\n.k-tabstrip-left > .k-tabstrip-items-wrapper .k-item {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-right-width: 0;\n}\n\n.k-tabstrip-left > .k-tabstrip-items-wrapper .k-item:active,\n.k-tabstrip-left > .k-tabstrip-items-wrapper .k-item.k-active {\n    margin-right: -1px;\n    border-right-width: 1px;\n    border-right-color: transparent !important;\n}\n\n.k-tabstrip-left > .k-content,\n.k-tabstrip-left > .k-tabstrip-content {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n    border-left-width: 0 !important;\n}\n\n.k-tabstrip-right {\n    flex-direction: row-reverse;\n}\n\n.k-tabstrip-right > .k-tabstrip-items-wrapper {\n    border-left-width: 1px;\n}\n\n.k-tabstrip-right > .k-tabstrip-items-wrapper .k-item {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n    border-left-width: 0;\n}\n\n.k-tabstrip-right > .k-tabstrip-items-wrapper .k-item:active,\n.k-tabstrip-right > .k-tabstrip-items-wrapper .k-item.k-active {\n    margin-left: -1px;\n    border-left-width: 1px;\n    border-left-color: transparent !important;\n}\n\n.k-tabstrip-right > .k-content,\n.k-tabstrip-right > .k-tabstrip-content {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-right-width: 0;\n}\n\n.k-tabstrip-items-start {\n    justify-content: flex-start;\n}\n\n.k-tabstrip-items-center {\n    justify-content: center;\n}\n\n.k-tabstrip-items-end {\n    justify-content: flex-end;\n}\n\n.k-tabstrip-items-justify {\n    justify-content: space-between;\n}\n\n.k-tabstrip-items-stretched > * {\n    flex: 1 0 0;\n}\n\n.k-rtl .k-tabstrip.k-tabstrip-left > .k-tabstrip-items-wrapper, .k-rtl .k-tabstrip.k-tabstrip-right > .k-tabstrip-items-wrapper,\n.k-tabstrip[dir=\"rtl\"].k-tabstrip-left > .k-tabstrip-items-wrapper,\n.k-tabstrip[dir=\"rtl\"].k-tabstrip-right > .k-tabstrip-items-wrapper {\n    order: 1;\n}\n\n.k-rtl .k-tabstrip.k-tabstrip-left > .k-content, .k-rtl .k-tabstrip.k-tabstrip-right > .k-content,\n.k-tabstrip[dir=\"rtl\"].k-tabstrip-left > .k-content,\n.k-tabstrip[dir=\"rtl\"].k-tabstrip-right > .k-content {\n    order: 0;\n}\n\n.k-rtl .k-tabstrip.k-tabstrip-left > .k-tabstrip-content, .k-rtl .k-tabstrip.k-tabstrip-right > .k-tabstrip-content,\n.k-tabstrip[dir=\"rtl\"].k-tabstrip-left > .k-tabstrip-content,\n.k-tabstrip[dir=\"rtl\"].k-tabstrip-right > .k-tabstrip-content {\n    order: 0;\n}\n\n.k-tabstrip-items-wrapper {\n    border-color: #dee2e6;\n    color: #212529;\n}\n\n.k-tabstrip-items-wrapper .k-item {\n    color: #0d6efd;\n}\n\n.k-tabstrip-items-wrapper .k-item:hover, .k-tabstrip-items-wrapper .k-item.k-hover {\n    border-color: #e9ecef;\n    color: #0a58ca;\n}\n\n.k-tabstrip-items-wrapper .k-item:active, .k-tabstrip-items-wrapper .k-item.k-active, .k-tabstrip-items-wrapper .k-item.k-selected {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-tabstrip-items-wrapper .k-item:focus, .k-tabstrip-items-wrapper .k-item.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-tabstrip-items-wrapper .k-item.k-tabstrip-dragging {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-tabstrip-content,\n.k-tabstrip > .k-content {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-tabstrip-content:focus, .k-tabstrip-content.k-focus,\n.k-tabstrip > .k-content:focus,\n.k-tabstrip > .k-content.k-focus {\n    outline-color: #212529;\n}\n\n.k-wizard {\n    padding-block: 1.25rem;\n    padding-inline: 1.25rem;\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-size: 1rem;\n    line-height: 1.5;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    position: relative;\n    color: inherit;\n    background: none;\n    display: flex;\n    align-items: stretch;\n    overflow: hidden;\n}\n\n.k-wizard .k-wizard-steps {\n    box-sizing: border-box;\n    display: flex;\n    overflow: hidden;\n}\n\n.k-wizard .k-wizard-step {\n    box-sizing: border-box;\n    padding: calc(0.5rem + 2px);\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: space-between;\n}\n\n.k-wizard .k-wizard-step:focus, .k-wizard .k-wizard-step.k-focus {\n    outline-width: 1px;\n    outline-style: dotted;\n    outline-offset: -1px;\n}\n\n.k-wizard .k-wizard-content {\n    box-sizing: border-box;\n    overflow-y: auto;\n}\n\n.k-wizard .k-wizard-buttons {\n    margin-top: 2rem;\n    box-sizing: border-box;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n}\n\n.k-wizard .k-wizard-buttons .k-button {\n    margin-right: 10px;\n}\n\n.k-wizard .k-wizard-buttons .k-wizard-pager {\n    vertical-align: middle;\n}\n\n.k-wizard .k-wizard-buttons-right .k-button:last-of-type {\n    margin-right: 0;\n}\n\n.k-wizard .k-stepper .k-step-list-vertical .k-step {\n    flex: 1 0 auto;\n}\n\n.k-wizard .k-stepper .k-step-indicator {\n    flex-shrink: 0;\n}\n\n.k-wizard-horizontal {\n    flex-direction: column;\n}\n\n.k-wizard-horizontal .k-wizard-steps {\n    margin-top: 2rem;\n}\n\n.k-wizard-horizontal .k-wizard-steps,\n.k-wizard-horizontal .k-wizard-content {\n    flex: 1 1 auto;\n}\n\n.k-wizard-vertical .k-wizard-steps {\n    margin-left: 2rem;\n    flex: 1 0 0%;\n}\n\n.k-wizard-vertical .k-wizard-content {\n    flex: 1 1 0%;\n}\n\n.k-wizard-left {\n    flex-direction: row-reverse;\n}\n\n.k-wizard-left .k-wizard-steps {\n    margin-right: 2rem;\n    margin-left: 0;\n}\n\n.k-wizard-step:focus, .k-wizard-step.k-focus {\n    outline-color: #656565;\n}\n\n.k-expander {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    overflow: hidden;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-expander *,\n.k-expander *::before,\n.k-expander *::after {\n    box-sizing: border-box;\n}\n\n.k-rtl .k-expander .k-expander-indicator, .k-expander.k-rtl .k-expander-indicator, .k-expander[dir=\"rtl\"] .k-expander-indicator {\n    margin-left: 0;\n    margin-right: 0.75rem;\n}\n\n.k-expander-header {\n    padding-block: 1rem;\n    padding-inline: 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n}\n\n.k-expander-spacer {\n    flex: 1 1 auto;\n}\n\n.k-expander-title {\n    text-transform: uppercase;\n    font-weight: 500;\n}\n\n.k-expander-indicator {\n    margin-left: 0.75rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.k-expander-content {\n    padding-block: 1.5rem;\n    padding-inline: 1.5rem;\n}\n\n.k-expander + .k-expander.k-expanded,\n.k-expander.k-expanded + .k-expander {\n    margin-top: 0.75rem;\n}\n\n.k-expander:not(.k-expanded) + .k-expander:not(.k-expanded) {\n    border-top-width: 0;\n}\n\n.k-expander {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-expander.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-expander-header {\n    color: #212529;\n    background-color: transparent;\n    outline: none;\n}\n\n.k-expander-header:hover, .k-expander-header.k-hover {\n    background-color: rgba(0, 0, 0, 0.04);\n}\n\n.k-expander-header.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-expander-title {\n    color: #0d6efd;\n}\n\n.k-expander-sub-title {\n    color: #6c757d;\n}\n\n.k-panelbar {\n    margin: 0;\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    list-style: none;\n    display: block;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-panelbar *,\n.k-panelbar *::before,\n.k-panelbar *::after {\n    box-sizing: border-box;\n}\n\n.k-panelbar > .k-item,\n.k-panelbar > .k-panelbar-header {\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n    display: block;\n}\n\n.k-panelbar > .k-item > .k-link,\n.k-panelbar > .k-panelbar-header > .k-link {\n    padding-block: 1rem;\n    padding-inline: 1.5rem;\n    color: inherit;\n    background: none;\n    text-decoration: none;\n    font-weight: 500;\n    display: flex;\n    flex-flow: row nowrap;\n    gap: 0.5rem;\n    align-items: center;\n    align-content: center;\n    position: relative;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: default;\n    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.k-panelbar > .k-item + .k-item,\n.k-panelbar > .k-panelbar-header + .k-panelbar-header {\n    border-top-width: 1px;\n}\n\n.k-panelbar .k-group,\n.k-panelbar .k-panelbar-group {\n    margin: 0;\n    padding: 0;\n    border-width: 0;\n    border-color: inherit;\n    color: inherit;\n    background-color: transparent;\n    list-style: none;\n}\n\n.k-panelbar .k-group > .k-item,\n.k-panelbar .k-panelbar-group > .k-panelbar-item {\n    display: block;\n}\n\n.k-panelbar .k-group > .k-item > .k-link,\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link {\n    padding-block: 0.75rem;\n    padding-inline: 1.5rem;\n    color: inherit;\n    text-decoration: none;\n    display: flex;\n    flex-flow: row nowrap;\n    gap: 0.5rem;\n    align-items: center;\n    align-content: center;\n    position: relative;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: default;\n    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.k-panelbar .k-group > .k-item.k-level-1 .k-link,\n.k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-1 .k-link {\n    padding-left: 1.5rem;\n}\n\n.k-panelbar .k-group > .k-item.k-level-2 .k-link,\n.k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-2 .k-link {\n    padding-left: 3rem;\n}\n\n.k-panelbar .k-group > .k-item.k-level-3 .k-link,\n.k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-3 .k-link {\n    padding-left: 4.5rem;\n}\n\n.k-panelbar .k-group > .k-item.k-level-4 .k-link,\n.k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-4 .k-link {\n    padding-left: 6rem;\n}\n\n.k-panelbar .k-panelbar-item {\n    outline-style: none;\n}\n\n.k-panelbar .k-panelbar-content {\n    display: flow-root;\n}\n\n.k-panelbar .k-panelbar-expand,\n.k-panelbar .k-panelbar-collapse,\n.k-panelbar .k-panelbar-toggle {\n    margin-inline-start: auto;\n}\n\n.k-panelbar .k-group .k-panelbar-expand,\n.k-panelbar .k-group .k-panelbar-collapse,\n.k-panelbar .k-panelbar-group .k-panelbar-toggle {\n    margin-inline-end: 0rem;\n}\n\n.k-rtl .k-panelbar .k-group > .k-item.k-level-1 .k-link,\n.k-rtl .k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-1 .k-link, .k-panelbar.k-rtl .k-group > .k-item.k-level-1 .k-link,\n.k-panelbar.k-rtl .k-panelbar-group > .k-panelbar-item.k-level-1 .k-link, .k-panelbar[dir=\"rtl\"] .k-group > .k-item.k-level-1 .k-link,\n.k-panelbar[dir=\"rtl\"] .k-panelbar-group > .k-panelbar-item.k-level-1 .k-link {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n}\n\n.k-rtl .k-panelbar .k-group > .k-item.k-level-2 .k-link,\n.k-rtl .k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-2 .k-link, .k-panelbar.k-rtl .k-group > .k-item.k-level-2 .k-link,\n.k-panelbar.k-rtl .k-panelbar-group > .k-panelbar-item.k-level-2 .k-link, .k-panelbar[dir=\"rtl\"] .k-group > .k-item.k-level-2 .k-link,\n.k-panelbar[dir=\"rtl\"] .k-panelbar-group > .k-panelbar-item.k-level-2 .k-link {\n    padding-left: 1.5rem;\n    padding-right: 3rem;\n}\n\n.k-rtl .k-panelbar .k-group > .k-item.k-level-3 .k-link,\n.k-rtl .k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-3 .k-link, .k-panelbar.k-rtl .k-group > .k-item.k-level-3 .k-link,\n.k-panelbar.k-rtl .k-panelbar-group > .k-panelbar-item.k-level-3 .k-link, .k-panelbar[dir=\"rtl\"] .k-group > .k-item.k-level-3 .k-link,\n.k-panelbar[dir=\"rtl\"] .k-panelbar-group > .k-panelbar-item.k-level-3 .k-link {\n    padding-left: 1.5rem;\n    padding-right: 4.5rem;\n}\n\n.k-rtl .k-panelbar .k-group > .k-item.k-level-4 .k-link,\n.k-rtl .k-panelbar .k-panelbar-group > .k-panelbar-item.k-level-4 .k-link, .k-panelbar.k-rtl .k-group > .k-item.k-level-4 .k-link,\n.k-panelbar.k-rtl .k-panelbar-group > .k-panelbar-item.k-level-4 .k-link, .k-panelbar[dir=\"rtl\"] .k-group > .k-item.k-level-4 .k-link,\n.k-panelbar[dir=\"rtl\"] .k-panelbar-group > .k-panelbar-item.k-level-4 .k-link {\n    padding-left: 1.5rem;\n    padding-right: 6rem;\n}\n\n.k-panelbar {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-panelbar > .k-item > .k-link,\n.k-panelbar > .k-panelbar-header > .k-link {\n    color: #0d6efd;\n    background-color: #ffffff;\n}\n\n.k-panelbar > .k-item > .k-link .k-icon,\n.k-panelbar > .k-item > .k-link .k-panelbar-item-icon,\n.k-panelbar > .k-panelbar-header > .k-link .k-icon,\n.k-panelbar > .k-panelbar-header > .k-link .k-panelbar-item-icon {\n    color: #212529;\n}\n\n.k-panelbar > .k-item > .k-link:hover,\n.k-panelbar > .k-item > .k-link.k-hover,\n.k-panelbar > .k-panelbar-header > .k-link:hover,\n.k-panelbar > .k-panelbar-header > .k-link.k-hover {\n    background-color: whitesmoke;\n}\n\n.k-panelbar > .k-item > .k-link:focus,\n.k-panelbar > .k-item > .k-link.k-focus,\n.k-panelbar > .k-panelbar-header > .k-link:focus,\n.k-panelbar > .k-panelbar-header > .k-link.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-panelbar > .k-item > .k-link.k-selected,\n.k-panelbar > .k-panelbar-header > .k-link.k-selected {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-panelbar > .k-item > .k-link.k-selected .k-icon,\n.k-panelbar > .k-item > .k-link.k-selected .k-panelbar-item-icon,\n.k-panelbar > .k-panelbar-header > .k-link.k-selected .k-icon,\n.k-panelbar > .k-panelbar-header > .k-link.k-selected .k-panelbar-item-icon {\n    color: inherit;\n}\n\n.k-panelbar > .k-item > .k-link.k-selected:hover,\n.k-panelbar > .k-item > .k-link.k-selected.k-hover,\n.k-panelbar > .k-panelbar-header > .k-link.k-selected:hover,\n.k-panelbar > .k-panelbar-header > .k-link.k-selected.k-hover {\n    background-color: #0c65e9;\n}\n\n.k-panelbar .k-group > .k-item > .k-link:hover,\n.k-panelbar .k-group > .k-item > .k-link.k-hover,\n.k-panelbar .k-group > .k-panelbar-item > .k-link:hover,\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-hover,\n.k-panelbar .k-panelbar-group > .k-item > .k-link:hover,\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-hover,\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link:hover,\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-hover {\n    background-color: #ebebeb;\n}\n\n.k-panelbar .k-group > .k-item > .k-link:focus,\n.k-panelbar .k-group > .k-item > .k-link.k-focus,\n.k-panelbar .k-group > .k-panelbar-item > .k-link:focus,\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-focus,\n.k-panelbar .k-panelbar-group > .k-item > .k-link:focus,\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-focus,\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link:focus,\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-panelbar .k-group > .k-item > .k-link.k-selected,\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-selected,\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-selected,\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-selected {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-panelbar .k-group > .k-item > .k-link.k-selected:hover,\n.k-panelbar .k-group > .k-item > .k-link.k-selected.k-hover,\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-selected:hover,\n.k-panelbar .k-group > .k-panelbar-item > .k-link.k-selected.k-hover,\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-selected:hover,\n.k-panelbar .k-panelbar-group > .k-item > .k-link.k-selected.k-hover,\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-selected:hover,\n.k-panelbar .k-panelbar-group > .k-panelbar-item > .k-link.k-selected.k-hover {\n    background-color: #0c65e9;\n}\n\n.k-splitter {\n    height: 300px;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: block;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-splitter .k-pane {\n    overflow: hidden;\n    box-sizing: border-box;\n}\n\n.k-splitter .k-scrollable {\n    overflow: auto;\n}\n\n.k-splitter .k-splitter-resizing {\n    overflow: hidden;\n}\n\n.k-pane > .k-splitter {\n    border-width: 0;\n    overflow: hidden;\n}\n\n.k-splitter .k-pane-loading {\n    position: static;\n    top: 50%;\n    left: 50%;\n}\n\n.k-ghost-splitbar,\n.k-splitbar {\n    border-style: solid;\n    outline: 0;\n    position: absolute;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.k-ghost-splitbar .k-collapse-prev,\n.k-ghost-splitbar .k-collapse-next,\n.k-splitbar .k-collapse-prev,\n.k-splitbar .k-collapse-next {\n    cursor: pointer;\n    padding: 0.125rem;\n}\n\n.k-splitbar-draggable-horizontal {\n    cursor: col-resize;\n}\n\n.k-splitbar-draggable-vertical {\n    cursor: row-resize;\n}\n\n.k-ghost-splitbar-horizontal,\n.k-splitbar-horizontal {\n    width: 0.75rem;\n    border-width: 0;\n    background-repeat: repeat-y;\n    flex-direction: column;\n    top: 0;\n}\n\n.k-ghost-splitbar-vertical,\n.k-splitbar-vertical {\n    height: 0.75rem;\n    border-width: 0;\n    background-repeat: repeat-x;\n    flex-direction: row;\n    left: 0;\n}\n\n.k-splitbar-static-horizontal {\n    width: 1px;\n}\n\n.k-splitbar-static-vertical {\n    height: 1px;\n}\n\n.k-splitbar-draggable-horizontal .k-resize-handle {\n    width: 2px;\n    height: 20px;\n    position: static;\n    z-index: 1;\n}\n\n.k-splitbar .k-resize-handle {\n    display: none;\n    background-color: currentColor;\n}\n\n.k-splitbar-draggable-horizontal .k-resize-handle,\n.k-splitbar-draggable-vertical .k-resize-handle {\n    display: block;\n}\n\n.k-splitbar-horizontal .k-collapse-prev {\n    margin-bottom: 7px;\n}\n\n.k-splitbar-horizontal .k-collapse-next {\n    margin-top: 7px;\n}\n\n.k-splitbar-vertical .k-collapse-prev {\n    margin-right: 7px;\n}\n\n.k-splitbar-vertical .k-collapse-next {\n    margin-left: 7px;\n}\n\n.k-splitbar-draggable-vertical .k-resize-handle {\n    width: 20px;\n    height: 2px;\n    position: static;\n    z-index: 1;\n}\n\n.k-pane > .k-splitter-overlay {\n    opacity: 0;\n    position: absolute;\n}\n\n.k-splitter-flex {\n    display: flex;\n    width: 100%;\n    height: auto;\n}\n\n.k-splitter-flex .k-pane {\n    position: relative;\n    flex: 1 1 auto;\n    min-width: 0;\n    max-width: 100%;\n    min-height: 0;\n    max-height: 100%;\n    height: 100%;\n}\n\n.k-splitter-flex .k-pane-static {\n    flex-grow: 0;\n    flex-shrink: 0;\n}\n\n.k-splitter-flex .k-pane-flex {\n    display: flex;\n}\n\n.k-splitter-flex .k-splitbar {\n    position: static;\n    flex: 0 0 auto;\n}\n\n.k-splitter-flex .k-pane.k-hidden, .k-splitter-flex .k-pane[hidden],\n.k-splitter-flex .k-pane-flex.k-hidden,\n.k-splitter-flex .k-pane-flex[hidden] {\n    flex: 0 1 0% !important;\n    overflow: hidden !important;\n    display: block !important;\n}\n\n.k-splitter-flex.k-splitter-horizontal {\n    flex-direction: row;\n}\n\n.k-splitter-flex.k-splitter-vertical {\n    flex-direction: column;\n}\n\n.k-splitter {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-splitbar {\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-splitbar:hover,\n.k-splitbar.k-hover,\n.k-splitbar-horizontal-hover,\n.k-splitbar-vertical-hover {\n    color: #212529;\n    background-color: #eeeff0;\n}\n\n.k-splitbar:focus,\n.k-splitbar.k-focus {\n    color: white;\n    background: #0d6efd;\n}\n\n.k-ghost-splitbar {\n    background-color: #eeeff0;\n}\n\n.k-tilelayout {\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    display: grid;\n    position: relative;\n    padding: 1rem 1rem;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-tilelayout .k-card {\n    box-shadow: none;\n    border-width: 1px;\n}\n\n.k-tilelayout-item {\n    position: relative;\n    z-index: 0;\n}\n\n.k-layout-item-hint {\n    border-radius: 0.375rem;\n    border-width: 1px;\n    border-style: solid;\n    position: relative;\n}\n\n.k-layout-item-hint.k-layout-item-hint-resize {\n    z-index: 3;\n}\n\n.k-tilelayout-item-header.k-card-header {\n    z-index: 0;\n}\n\n.k-tilelayout-item-body {\n    min-height: 0;\n}\n\n.k-tilelayout {\n    background-color: #f8f9fa;\n}\n\n.k-tilelayout-item:focus,\n.k-tilelayout-item.k-focus {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-layout-item-hint {\n    border-color: #dee2e6;\n    background-color: rgba(255, 255, 255, 0.2);\n}\n\n.k-dock-manager {\n    width: 100%;\n    height: 100%;\n    border-width: 1px;\n    border-style: solid;\n    position: relative;\n    display: flex;\n    flex-flow: row nowrap;\n    overflow: auto;\n    box-sizing: border-box;\n}\n\n.k-dock-manager-toolbar {\n    border-width: 0 1px 0 0;\n    border-color: inherit;\n    flex-shrink: 0;\n    -ms-writing-mode: tb-lr;\n        writing-mode: vertical-lr;\n    box-shadow: none;\n}\n\n.k-dock-manager-toolbar::before {\n    height: 0;\n}\n\n.k-dock-manager-toolbar .k-separator-horizontal {\n    width: 1.5em;\n    height: 0;\n    border-width: 1px 0 0;\n}\n\n.k-dock-manager-pane-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-grow: 1;\n    overflow: hidden;\n}\n\n.k-dock-manager-splitter,\n.k-dock-manager-unpinned-container {\n    height: 100%;\n    border-width: 0;\n    align-items: stretch;\n}\n\n.k-dock-manager-splitter > .k-pane,\n.k-dock-manager-unpinned-container > .k-pane {\n    height: auto;\n    flex-direction: column;\n    border-color: inherit;\n}\n\n.k-dock-manager-splitter .k-pane-header,\n.k-dock-manager-unpinned-container .k-pane-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    border-block-end-width: 1px;\n    border-block-end-style: solid;\n    border-color: inherit;\n}\n\n.k-dock-manager-splitter .k-pane-title,\n.k-dock-manager-unpinned-container .k-pane-title {\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1.25rem;\n    line-height: 1.25;\n    font-weight: 400;\n    flex: 1 1 auto;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.k-dock-manager-splitter .k-pane-scrollable,\n.k-dock-manager-unpinned-container .k-pane-scrollable {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    border-color: inherit;\n}\n\n.k-dock-manager-splitter .k-pane-content,\n.k-dock-manager-unpinned-container .k-pane-content {\n    height: 100%;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    overflow: auto;\n    flex: 1;\n}\n\n.k-dock-manager-splitter .k-pane-actions,\n.k-dock-manager-unpinned-container .k-pane-actions {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: center;\n}\n\n.k-dock-manager-splitter .k-pane-tabbed,\n.k-dock-manager-unpinned-container .k-pane-tabbed {\n    padding-block-start: 0.875rem;\n    padding-block-end: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-dock-manager-splitter .k-splitbar,\n.k-dock-manager-unpinned-container .k-splitbar {\n    border-width: 0 1px;\n    border-style: solid;\n    border-color: inherit;\n}\n\n.k-dock-manager-splitter .k-splitbar-vertical,\n.k-dock-manager-unpinned-container .k-splitbar-vertical {\n    border-width: 1px 0;\n}\n\n.k-dock-manager-unpinned-container {\n    width: 300px;\n    position: absolute;\n    display: flex;\n    height: 100%;\n    border-color: inherit;\n    z-index: 20;\n}\n\n.k-dock-manager-unpinned-container .k-pane {\n    display: inline-flex;\n    flex-direction: column;\n    position: relative;\n    flex: 1 1 auto;\n}\n\n.k-dock-manager-unpinned-container .k-splitbar {\n    height: 100%;\n    position: relative;\n    flex: none;\n}\n\n.k-docking-preview {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    display: flex;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-width: 1px;\n    border-style: dashed;\n    border-radius: 0.25rem;\n    z-index: 10;\n}\n\n.k-dock-navigator-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: absolute;\n    z-index: 10001;\n    pointer-events: none;\n}\n\n.k-dock-navigator {\n    display: grid;\n    grid-template-columns: repeat(3, auto);\n    grid-template-rows: repeat(3, auto);\n    justify-content: center;\n    position: absolute;\n}\n\n.k-dock-indicator {\n    padding: 0.375rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    position: relative;\n    pointer-events: all;\n    outline-width: 1px;\n    outline-style: solid;\n}\n\n.k-dock-indicator.k-dock-indicator-middle {\n    filter: none;\n}\n\n.k-dock-indicator-top {\n    grid-area: 1 / 2 / auto;\n}\n\n.k-dock-indicator-right {\n    grid-area: 2 / 3 / auto;\n}\n\n.k-dock-indicator-bottom {\n    grid-area: 3 / 2 / auto;\n}\n\n.k-dock-indicator-left {\n    grid-area: 2 / 1 / auto;\n}\n\n.k-dock-indicator-middle {\n    grid-area: 2 / 2 / auto;\n}\n\n.k-dock-manager {\n    border-color: #e4e5e6;\n}\n\n.k-dock-manager-splitter .k-pane-header,\n.k-dock-manager-unpinned-container .k-pane-header {\n    background-color: #ffffff;\n}\n\n.k-dock-manager-unpinned-container {\n    background-color: #ffffff;\n    box-shadow: 4px 0px 5px 0px rgba(0, 0, 0, 0.04), 2px 0px 4px 0px rgba(0, 0, 0, 0.03);\n}\n\n.k-docking-preview {\n    background-color: rgba(13, 110, 253, 0.16);\n    border-color: #0d6efd;\n}\n\n.k-dock-indicator {\n    color: #0d6efd;\n    background-color: #ffffff;\n    outline-color: #0d6efd;\n    filter: drop-shadow(0px 1px 18px rgba(0, 0, 0, 0.12)) drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.14)) drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.2));\n}\n\n.k-dock-indicator:hover, .k-dock-indicator.k-hover {\n    background-color: #0d6efd;\n    color: #ffffff;\n}\n\n.k-pane-wrapper {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: block;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-pane-wrapper .k-pane {\n    width: 100%;\n    height: 100%;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    box-sizing: border-box;\n    font-family: sans-serif;\n    overflow-x: hidden;\n}\n\n.k-pane-wrapper .k-view {\n    top: 0;\n    left: 0;\n    position: relative;\n    border: 0;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    height: 100%;\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n    align-content: stretch;\n    vertical-align: top;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-pane-wrapper .k-content {\n    min-height: 1px;\n    flex: 1;\n    align-items: stretch;\n    display: block;\n    width: auto;\n    overflow: hidden;\n    position: relative;\n}\n\n.k-pane-wrapper > div.k-pane {\n    box-shadow: none;\n    font-weight: normal;\n}\n\n.k-pane-wrapper .k-popup-edit-form .k-content,\n.k-pane-wrapper .k-grid-edit-form .k-content,\n.k-pane-wrapper .k-grid-header-menu .k-content,\n.k-pane-wrapper .k-grid-filter-menu .k-content {\n    overflow-y: auto;\n}\n\n.k-pane-wrapper .k-popup-edit-form .k-content > .k-scroll-container,\n.k-pane-wrapper .k-grid-edit-form .k-content > .k-scroll-container,\n.k-pane-wrapper .k-grid-header-menu .k-content > .k-scroll-container,\n.k-pane-wrapper .k-grid-filter-menu .k-content > .k-scroll-container {\n    position: absolute;\n    width: 100%;\n    min-height: 100%;\n    box-sizing: border-box;\n}\n\n.k-pane-wrapper .k-grid-edit-form .k-popup-edit-form,\n.k-pane-wrapper .k-grid-edit-form .k-edit-form-container {\n    width: auto;\n    min-width: auto;\n}\n\n.k-grid.k-grid-mobile {\n    border-width: 0;\n}\n\n.k-grid-mobile .k-resize-handle-inner::before {\n    content: \"\\e01e\";\n    position: absolute;\n    font: 16px/1 \"WebComponentsIcons\";\n    top: calc(50% - 1px);\n    left: 50%;\n    transform: translate(-50%, -50%);\n    padding: .2em;\n}\n\n.k-grid-mobile .k-header a {\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-pane-wrapper .k-scheduler-edit-form .k-recur-view {\n    padding: 0;\n    flex-direction: column;\n    align-items: stretch;\n}\n\n.k-pane-wrapper .k-scheduler-edit-form .k-recur-view > .k-listgroup-form-row {\n    margin: 0;\n}\n\n.k-pane-wrapper .k-scheduler-edit-form .k-recur-items-wrap {\n    width: 100%;\n    margin-block: -1px;\n    margin-inline: 0;\n}\n\n.k-pane-wrapper .k-scheduler-edit-form .k-scheduler-recur-end-wrap {\n    white-space: nowrap;\n}\n\n.k-scheduler.k-scheduler-mobile {\n    border-width: 0;\n}\n\n.k-scheduler-mobile th {\n    font-weight: normal;\n}\n\n.k-scheduler-mobile .k-event:hover .k-resize-handle {\n    visibility: hidden;\n}\n\n.k-scheduler-mobile .k-scheduler-toolbar {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-scheduler-mobile .k-scheduler-toolbar > * {\n    margin: 0;\n}\n\n.k-scheduler-mobile .k-scheduler-toolbar::before {\n    display: none;\n}\n\n.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-navigation {\n    width: 100%;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    margin: 0;\n}\n\n.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-navigation .k-nav-current {\n    line-height: 1;\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    justify-content: space-evenly;\n    gap: 0;\n}\n\n.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-views-wrapper .k-views-dropdown {\n    display: inline-block;\n}\n\n.k-scheduler-mobile .k-scheduler-footer {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    display: flex;\n    justify-content: space-between;\n}\n\n.k-scheduler-mobile .k-scheduler-footer > * {\n    margin: 0;\n}\n\n.k-scheduler-mobile .k-scheduler-footer::before {\n    display: none;\n}\n\n.k-scheduler-mobile .k-scheduler-monthview .k-hidden {\n    height: 40px;\n}\n\n.k-scheduler-mobile .k-scheduler-monthview .k-scheduler-table td {\n    height: 40px;\n    vertical-align: top;\n    text-align: center;\n}\n\n.k-scheduler-mobile .k-scheduler-monthview .k-events-container {\n    position: absolute;\n    text-align: center;\n    height: 6px;\n    line-height: 6px;\n}\n\n.k-scheduler-mobile .k-scheduler-monthview .k-event {\n    position: static;\n    padding: 4px;\n    border-radius: 50%;\n    display: inline-block;\n    width: 4px;\n    height: 4px;\n    min-height: 0;\n    margin: 1px;\n}\n\n.k-scheduler-mobile .k-scheduler-dayview .k-mobile-header.k-mobile-horizontal-header .k-scheduler-times table tr:first-child {\n    display: none;\n}\n\n.k-scheduler-mobile .k-scheduler-dayview .k-mobile-header .k-scheduler-header .k-scheduler-date-group {\n    display: none;\n}\n\n.k-scheduler-mobile .k-scheduler-header-wrap > div {\n    overflow: visible;\n}\n\n.k-scheduler-mobile .k-scheduler-agendaview .k-mobile-header {\n    display: none;\n}\n\n.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table {\n    table-layout: auto;\n}\n\n.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table .k-scheduler-groupcolumn {\n    width: 1%;\n}\n\n.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table td {\n    white-space: normal;\n}\n\n.k-scheduler-mobile .k-mobile-header .k-scheduler-table td,\n.k-scheduler-mobile .k-mobile-header .k-scheduler-table th {\n    height: 1.5em;\n}\n\n.k-scheduler-mobile .k-time-text,\n.k-scheduler-mobile .k-time-period {\n    display: block;\n    line-height: 1;\n}\n\n.k-scheduler-mobile .k-time-period {\n    font-size: .7em;\n}\n\n.k-scheduler-mobile .k-scheduler-table td,\n.k-scheduler-mobile .k-scheduler-table th {\n    height: 2em;\n    vertical-align: middle;\n}\n\n.k-scheduler-mobile .k-scheduler-datecolumn-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.k-scheduler-mobile .k-task {\n    display: flex;\n    align-items: center;\n    gap: .5em;\n}\n\n.k-scheduler-mobile .k-task .k-scheduler-mark {\n    border-radius: 50%;\n    margin: 0;\n}\n\n.k-scheduler-mobile .k-task .k-scheduler-task-text {\n    flex: 1 1 0%;\n}\n\n.k-scheduler-mobile .k-scheduler-times .k-scheduler-group-cell,\n.k-scheduler-mobile .k-scheduler-times .k-scheduler-groupcolumn,\n.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-group-cell,\n.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-groupcolumn {\n    vertical-align: top;\n}\n\n.k-scheduler-mobile .k-scheduler-times .k-scheduler-group-cell .k-scheduler-group-text,\n.k-scheduler-mobile .k-scheduler-times .k-scheduler-groupcolumn .k-scheduler-group-text,\n.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-group-cell .k-scheduler-group-text,\n.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-groupcolumn .k-scheduler-group-text {\n    -ms-writing-mode: tb-lr;\n        writing-mode: vertical-lr;\n    transform: rotate(180deg);\n    white-space: nowrap;\n}\n\n.k-scheduler-mobile .k-scrollbar-h tr + tr .k-scheduler-times {\n    border-bottom-width: 0;\n}\n\n.k-pane-wrapper .k-appbar {\n    padding: 0.25rem;\n}\n\n.k-pane-wrapper .k-list-title,\n.k-pane-wrapper .k-filter-help-text {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    display: block;\n}\n\n.k-pane-wrapper .k-listgroup-title {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.k-pane-wrapper .k-listgroup .k-listgroup-item {\n    border-color: inherit;\n}\n\n.k-pane-wrapper .k-listgroup + .k-listgroup {\n    margin-top: 1rem;\n}\n\n.k-pane-wrapper .k-column-menu {\n    padding: 0.5rem;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0.5rem;\n}\n\n.k-pane-wrapper .k-column-menu .k-filter-item .k-filterable * {\n    pointer-events: none;\n}\n\n.k-pane-wrapper .k-column-menu .k-list-title,\n.k-pane-wrapper .k-column-menu .k-listgroup-title {\n    padding: 0;\n}\n\n.k-pane-wrapper .k-column-menu .k-listgroup {\n    margin-inline: -0.5rem;\n}\n\n.k-pane-wrapper .k-filter-menu {\n    padding: 0.5rem;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0.5rem;\n}\n\n.k-pane-wrapper .k-filter-menu .k-list-title {\n    padding: 0;\n}\n\n.k-pane-wrapper .k-filter-menu .k-list-filter {\n    padding: 0;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: inherit;\n}\n\n.k-pane-wrapper .k-filter-menu .k-filter-tools {\n    display: flex;\n    flex-flow: row nowrap;\n    gap: inherit;\n}\n\n.k-pane-wrapper .k-filter-menu .k-listgroup {\n    margin-inline: -0.5rem;\n}\n\n.k-pane-wrapper .k-popup-edit-form .k-recur-editor-wrap {\n    display: flex;\n}\n\n.k-pane-wrapper .k-popup-edit-form .k-mobiletimezoneeditor {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    position: relative;\n    flex: 1 1 auto;\n}\n\n.k-pane-wrapper .k-multicheck-wrap.k-listgroup {\n    overflow-y: auto;\n}\n\n.k-pane-wrapper .k-pager-wrap.k-pager-sm,\n.k-pane-wrapper .k-pager.k-pager-sm {\n    justify-content: center;\n}\n\n.k-pane-wrapper .k-pager-wrap.k-pager-sm .k-pager-refresh,\n.k-pane-wrapper .k-pager.k-pager-sm .k-pager-refresh {\n    display: none;\n}\n\n.k-rtl .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar > ul > li, .k-pane-wrapper[dir=\"rtl\"] .k-scheduler-mobile .k-scheduler-toolbar > ul > li,\n[dir=\"rtl\"] .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar > ul > li {\n    border: 0;\n}\n\n.k-rtl .k-pane-wrapper .k-scheduler-mobile .k-task .k-i-reload, .k-pane-wrapper[dir=\"rtl\"] .k-scheduler-mobile .k-task .k-i-reload,\n[dir=\"rtl\"] .k-pane-wrapper .k-scheduler-mobile .k-task .k-i-reload {\n    margin-left: .5em;\n    margin-right: 0;\n}\n\n.k-pane-wrapper,\n.k-view {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-pane-wrapper .k-pane > .k-view > .k-content {\n    background-position: 50% 50%;\n    background-color: #fafafa;\n}\n\n.k-pane-wrapper .k-pane .k-grid-mobile .k-column-active + th.k-header {\n    border-left-color: #212529;\n}\n\n.k-pane-wrapper .k-pane .k-grid-mobile .k-resize-handle-inner::before {\n    background-color: #f8f9fa;\n}\n\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-nav-current {\n    color: #0d6efd;\n}\n\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendadate {\n    color: inherit;\n}\n\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-time-period,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendaweekday {\n    color: #6c757d;\n}\n\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-wrap,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-datecolumn,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-group-cell,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-all-day {\n    background-color: #fafafa;\n}\n\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-tools > li {\n    display: inline-block;\n    background-color: inherit;\n}\n\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-item,\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-link,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-item,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-link,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-item,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-link,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-item,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-link {\n    color: #212529;\n}\n\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-clear,\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-select-all,\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-delete,\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-resetSeries,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-clear,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-select-all,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-scheduler-delete,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-scheduler-resetSeries,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-clear,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-select-all,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-delete,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-resetSeries,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-clear,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-select-all,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-delete,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-resetSeries {\n    color: #0d6efd;\n}\n\n.k-pane-wrapper .k-pane .k-column-menu .k-listgroup-item.k-selected {\n    color: #0d6efd;\n    background: none;\n}\n\n.k-pane-wrapper .k-pane .k-column-menu .k-listgroup-item.k-selected .k-link {\n    color: inherit;\n}\n\n.k-grid {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-grid.k-grid-display-block {\n    display: block;\n}\n\n.k-grid .k-grid-container {\n    display: flex;\n    flex: 1 1 auto;\n    overflow: hidden;\n    position: relative;\n}\n\n.k-grid .k-grid-aria-root {\n    border-color: inherit;\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    overflow: hidden;\n}\n\n.k-grid .k-table {\n    margin: 0;\n    width: 100%;\n    max-width: none;\n    border-width: 0;\n    border-color: inherit;\n    border-collapse: separate;\n    border-spacing: 0;\n    box-sizing: content-box;\n    empty-cells: show;\n    outline: 0;\n}\n\n.k-grid .k-grid-header .k-table,\n.k-grid .k-grid-content .k-table,\n.k-grid .k-grid-content-locked .k-table,\n.k-grid .k-grid-footer .k-table {\n    table-layout: fixed;\n}\n\n.k-grid .k-table-thead,\n.k-grid .k-table-tbody,\n.k-grid .k-table-tfoot {\n    text-align: start;\n    border-color: inherit;\n}\n\n.k-grid .k-table-row {\n    border-color: inherit;\n}\n\n.k-grid .k-table-th,\n.k-grid td,\n.k-grid .k-table-td {\n    border-width: 0;\n    border-inline-start-width: 1px;\n    border-style: solid;\n    border-color: inherit;\n    outline: 0;\n    font-weight: inherit;\n    text-align: inherit;\n    position: static;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    box-sizing: content-box;\n}\n\n.k-grid .k-table-th:first-child,\n.k-grid td:first-child,\n.k-grid .k-table-td:first-child {\n    border-inline-start-width: 0;\n}\n\n.k-grid .k-table-th:focus,\n.k-grid td:focus,\n.k-grid .k-table-td:focus {\n    outline: none;\n}\n\n.k-grid .k-table-th > .k-radio,\n.k-grid .k-table-th > .k-radio-wrap,\n.k-grid .k-table-th > .k-checkbox,\n.k-grid .k-table-th > .k-checkbox-wrap,\n.k-grid td > .k-radio,\n.k-grid td > .k-radio-wrap,\n.k-grid td > .k-checkbox,\n.k-grid td > .k-checkbox-wrap,\n.k-grid .k-table-td > .k-radio,\n.k-grid .k-table-td > .k-radio-wrap,\n.k-grid .k-table-td > .k-checkbox,\n.k-grid .k-table-td > .k-checkbox-wrap {\n    vertical-align: top;\n}\n\n.k-grid .k-table-th {\n    border-block-end-width: 1px;\n    white-space: nowrap;\n}\n\n.k-grid td,\n.k-grid .k-table-td {\n    border-block-end-width: 0px;\n    white-space: unset;\n    vertical-align: middle;\n}\n\n.k-grid a {\n    color: inherit;\n    text-decoration: none;\n}\n\n.k-grid a:hover {\n    text-decoration: none;\n}\n\n.k-grid .k-grid-header-wrap {\n    box-sizing: content-box;\n}\n\n.k-grid .k-grid-header {\n    border-bottom-width: 1px;\n}\n\n.k-grid .k-grid-header .k-table {\n    margin-bottom: -1px;\n}\n\n.k-grid .k-grid-header.k-grid-draggable-header {\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    touch-action: none;\n}\n\n.k-grid .k-grid-header .k-table-th {\n    position: relative;\n    vertical-align: bottom;\n    cursor: default;\n}\n\n.k-grid .k-grid-header .k-table-th:first-child {\n    border-inline-start-width: 0;\n}\n\n.k-grid .k-grid-header .k-table-th.k-first {\n    border-inline-start-width: 1px;\n}\n\n.k-grid .k-grid-header .k-table-th > .k-link {\n    line-height: inherit;\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    outline: 0;\n}\n\n.k-grid .k-grid-header .k-table-th > .k-link:focus {\n    text-decoration: none;\n}\n\n.k-grid .k-grid-header .k-grid-filter,\n.k-grid .k-grid-header .k-header-column-menu,\n.k-grid .k-grid-header .k-grid-header-menu {\n    box-sizing: border-box;\n    outline: 0;\n    display: flex;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    position: absolute;\n    inset-inline-end: 0.5rem;\n    z-index: 1;\n}\n\n.k-grid .k-grid-header .k-grid-filter:hover,\n.k-grid .k-grid-header .k-header-column-menu:hover,\n.k-grid .k-grid-header .k-grid-header-menu:hover {\n    cursor: pointer;\n}\n\n.k-grid .k-grid-header .k-cell-inner > .k-link > .k-sort-icon {\n    vertical-align: text-top;\n    margin-inline-start: calc(1rem - 1px);\n}\n\n.k-grid .k-grid-header .k-cell-inner > .k-link > .k-sort-icon .k-icon {\n    display: flex;\n}\n\n.k-grid .k-grid-header .k-sort-order {\n    display: inline-block;\n    vertical-align: top;\n    height: 16px;\n    font-size: 12px;\n    margin-top: 2px;\n    margin-inline-start: -2px;\n}\n\n.k-grid .k-grid-header .k-filterable > .k-cell-inner .k-link {\n    padding-inline-end: 0;\n}\n\n.k-grid .k-cell-inner {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: inherit;\n    overflow: hidden;\n}\n\n.k-grid .k-cell-inner > .k-link {\n    width: auto;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: inherit;\n    flex: 1;\n    overflow: hidden;\n}\n\n.k-grid .k-cell-inner > .k-link > .k-sort-icon {\n    margin-inline-start: 0;\n    display: inline-block;\n    flex-shrink: 0;\n}\n\n.k-grid .k-cell-inner .k-sort-order {\n    flex-shrink: 0;\n    line-height: normal;\n}\n\n.k-grid .k-cell-inner .k-grid-filter,\n.k-grid .k-cell-inner .k-header-column-menu,\n.k-grid .k-cell-inner .k-grid-header-menu {\n    position: static;\n    margin-inline-end: 0.5rem;\n}\n\n.k-grid .k-group-col,\n.k-grid .k-hierarchy-col {\n    padding: 0;\n    width: 32px;\n}\n\n.k-grid .k-grouping-row p {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    align-content: center;\n}\n\n.k-grid .k-grouping-row td,\n.k-grid .k-grouping-row .k-table-td {\n    overflow: visible;\n}\n\n.k-grid .k-grouping-row + .k-table-row td,\n.k-grid .k-grouping-row + .k-table-row .k-table-td {\n    border-top-width: 1px;\n}\n\n.k-grid .k-grouping-row .k-group-cell,\n.k-grid .k-grouping-row + .k-table-row .k-group-cell {\n    border-top-width: 0;\n    text-overflow: clip;\n}\n\n.k-grid .k-grouping-row .k-icon {\n    margin-inline-start: calc(8px - 0.5rem);\n    margin-inline-end: 8px;\n    text-decoration: none;\n}\n\n.k-grid .k-table .k-group-footer td,\n.k-grid .k-table .k-group-footer .k-table-td {\n    border-style: solid;\n    border-width: 1px 0;\n}\n\n.k-grid .k-group-footer .k-group-cell + td,\n.k-grid .k-group-footer .k-group-cell + .k-table-td {\n    border-inline-start-width: 1px;\n}\n\n.k-grid .k-hierarchy-cell,\n.k-grid .k-drag-cell {\n    text-align: center;\n    overflow: visible;\n}\n\n.k-grid .k-hierarchy-cell > .k-font-icon,\n.k-grid .k-drag-cell > .k-font-icon {\n    padding-block: 0.5rem;\n    padding-inline: 0;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    outline: 0;\n}\n\n.k-grid .k-hierarchy-cell + .k-grid-content-sticky {\n    border-inline-start-width: 1px;\n}\n\n.k-grid .k-detail-row .k-detail-cell {\n    border-inline-start-width: 0;\n}\n\n.k-grid .k-dirty-cell {\n    position: relative;\n}\n\n.k-grid .k-dirty-cell.k-edit-cell {\n    position: static;\n}\n\n.k-grid .k-dirty-cell.k-grid-content-sticky {\n    position: sticky;\n}\n\n.k-grid .k-dirty {\n    border-width: 5px;\n    border-color: transparent;\n    border-block-start-color: currentColor;\n    border-inline-start-color: currentColor;\n    inset-inline-start: 0;\n    inset-inline-end: auto;\n}\n\n.k-grid .k-grid-content-locked + .k-grid-content {\n    box-sizing: content-box;\n}\n\n.k-grid .k-grid-content-expander {\n    position: absolute;\n    visibility: hidden;\n    height: 1px;\n    bottom: 1px;\n}\n\n.k-grid .k-grid-filter,\n.k-grid .k-header-column-menu,\n.k-grid .k-grid-header-menu,\n.k-grid .k-hierarchy-cell .k-icon {\n    border-width: 0;\n}\n\n.k-grid .k-drag-col {\n    padding: 0;\n    width: 48px;\n}\n\n.k-grid .k-drag-cell {\n    cursor: move;\n}\n\n.k-grid-toolbar {\n    border-width: 0 0 1px;\n    flex-shrink: 0;\n}\n\n.k-grid-toolbar-bottom {\n    border-width: 1px 0 0;\n}\n\n.k-grouping-header {\n    border-width: 0 0 1px;\n    border-style: solid;\n    border-color: inherit;\n    white-space: normal;\n    display: flex;\n    align-items: center;\n    position: relative;\n    flex-wrap: wrap;\n}\n\n.k-grouping-header::before {\n    content: \"\";\n    height: calc(1.25em + 0.5rem + 2px);\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.k-grouping-header .k-chip-list {\n    flex-grow: 0;\n    display: contents;\n}\n\n.k-grouping-header > .k-grouping-drop-container {\n    flex-grow: 1;\n    padding-block: 0.5rem;\n    margin-block: -0.5rem;\n    display: inline-flex;\n    align-self: stretch;\n    align-items: center;\n}\n\n.k-grouping-dropclue {\n    width: 12px;\n    position: absolute;\n    top: 3px;\n    box-sizing: content-box;\n}\n\n.k-grouping-dropclue::before, .k-grouping-dropclue::after {\n    display: inline-block;\n    content: \"\";\n    position: absolute;\n}\n\n.k-grouping-dropclue::before {\n    border-width: 6px;\n    border-style: solid;\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n    top: 0;\n}\n\n.k-grouping-dropclue::after {\n    width: 2px;\n    height: calc(100% - 6px);\n    top: 6px;\n    inset-inline-start: 5px;\n}\n\n.k-grid-header-wrap,\n.k-grid-footer-wrap {\n    margin-inline-end: -1px;\n    width: 100%;\n    border-width: 0;\n    border-inline-end-width: 1px;\n    border-style: solid;\n    border-color: inherit;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-grid-header-locked + .k-grid-header-wrap.k-auto-scrollable {\n    margin-inline-end: 0;\n}\n\n.k-grid-header,\n.k-grid-footer {\n    padding-inline-start: 0;\n    padding-inline-end: var(--kendo-scrollbar-width, 17px);\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n    flex: 0 0 auto;\n}\n\ndiv.k-grid-header,\ndiv.k-grid-footer {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n}\n\n.k-column-resizer {\n    width: .5em;\n    height: 1000%;\n    display: block;\n    position: absolute;\n    top: 0;\n    inset-inline-end: 0;\n    cursor: col-resize;\n}\n\n.k-row-resizer {\n    display: block;\n    height: 0.125rem;\n    width: 100%;\n    background: none;\n}\n\n.k-grid-footer {\n    border-top-width: 1px;\n}\n\n.k-grid-footer td,\n.k-grid-footer .k-table-td {\n    height: 1.5em;\n}\n\n.k-grid-footer td,\n.k-group-footer td,\n.k-grouping-row td,\n.k-grid-footer .k-table-td,\n.k-group-footer .k-table-td,\n.k-grouping-row .k-table-td {\n    font-weight: bold;\n}\n\n.k-grid-filter-popup {\n    min-width: 250px;\n    max-width: 320px;\n}\n\n.k-grid-column-menu-standalone a.k-grid-filter {\n    position: initial;\n    display: inline-block;\n    margin-block: -4px;\n    margin-inline: 0;\n    padding-block: 4px;\n    padding-inline: 8px;\n}\n\n.k-filter-row {\n    line-height: 1.5;\n}\n\n.k-filter-row td,\n.k-filter-row .k-table-td,\n.k-filter-row .k-table-th {\n    border-width: 0;\n    border-block-end-width: 1px;\n    border-inline-start-width: 1px;\n    white-space: nowrap;\n}\n\n.k-filter-row td:first-child,\n.k-filter-row .k-table-td:first-child {\n    border-inline-start-width: 0;\n}\n\n.k-filter-row .k-multiselect {\n    height: auto;\n}\n\n.k-filtercell {\n    width: auto;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n}\n\n.k-filtercell > span,\n.k-filtercell .k-filtercell-wrapper {\n    width: 100%;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    flex: 1 1 auto;\n}\n\n.k-filtercell > span > .k-button,\n.k-filtercell .k-filtercell-wrapper > .k-button {\n    flex: none;\n}\n\n.k-grid-content,\n.k-grid-content-locked {\n    border-color: inherit;\n    outline: 0;\n}\n\n.k-grid-content .k-table-row:last-child > td,\n.k-grid-content .k-table-row:last-child > .k-table-td,\n.k-grid-content-locked .k-table-row:last-child > td,\n.k-grid-content-locked .k-table-row:last-child > .k-table-td {\n    border-bottom-width: 0;\n}\n\n.k-grid-content {\n    width: 100%;\n    min-height: 0;\n    overflow: auto;\n    overflow-x: auto;\n    overflow-y: scroll;\n    position: relative;\n    flex: 1;\n}\n\n.k-virtual-scrollable-wrap {\n    height: 100%;\n    overflow-y: hidden;\n    position: relative;\n}\n\n.k-grid .k-edit-cell,\n.k-grid .k-command-cell,\n.k-grid .k-grid-edit-row td,\n.k-grid .k-grid-edit-row .k-table-td {\n    text-overflow: clip;\n}\n\n.k-grid .k-edit-cell > input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n.k-grid .k-edit-cell > select,\n.k-grid .k-edit-cell > .k-widget:not(.k-switch),\n.k-grid .k-grid-edit-row td > input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n.k-grid .k-grid-edit-row td > select,\n.k-grid .k-grid-edit-row td > .k-widget:not(.k-switch),\n.k-grid .k-grid-edit-row .k-table-td > input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n.k-grid .k-grid-edit-row .k-table-td > select,\n.k-grid .k-grid-edit-row .k-table-td > .k-widget:not(.k-switch) {\n    width: 100%;\n    vertical-align: middle;\n    box-sizing: border-box;\n}\n\n.k-grid .k-edit-cell > .k-radio,\n.k-grid .k-edit-cell > .k-checkbox,\n.k-grid .k-edit-cell > .k-radio-wrap,\n.k-grid .k-edit-cell > .k-checkbox-wrap,\n.k-grid .k-grid-edit-row td > .k-radio,\n.k-grid .k-grid-edit-row td > .k-checkbox,\n.k-grid .k-grid-edit-row td > .k-radio-wrap,\n.k-grid .k-grid-edit-row td > .k-checkbox-wrap,\n.k-grid .k-grid-edit-row .k-table-td > .k-radio,\n.k-grid .k-grid-edit-row .k-table-td > .k-checkbox,\n.k-grid .k-grid-edit-row .k-table-td > .k-radio-wrap,\n.k-grid .k-grid-edit-row .k-table-td > .k-checkbox-wrap {\n    vertical-align: middle;\n}\n\n.k-grid .k-command-cell > .k-button {\n    margin-inline-end: 0.5rem;\n    vertical-align: middle;\n}\n\n.k-grid .k-command-cell > .k-button:last-child {\n    margin-inline-end: unset;\n}\n\n.k-grid > .k-resize-handle,\n.k-grid-header .k-resize-handle {\n    height: 25px;\n    cursor: col-resize;\n    position: absolute;\n    z-index: 2;\n}\n\n.k-selection-aggregates {\n    border-width: 1px 0 0;\n    border-style: solid;\n    line-height: 1.5;\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n}\n\n.k-selection-aggregates-item-value {\n    font-weight: 700;\n}\n\n.k-grid-pager {\n    border-width: 1px 0 0;\n    border-color: inherit;\n    font-size: inherit;\n}\n\n.k-grid-pager-top {\n    border-width: 0 0 1px;\n}\n\n.k-grid-virtual .k-grid-content .k-grid-table-wrap {\n    float: left;\n    width: 100%;\n}\n\n.k-grid-virtual .k-grid-content .k-grid-table {\n    position: relative;\n    float: left;\n    z-index: 1;\n}\n\n.k-grid-virtual .k-grid-content > .k-height-container {\n    position: relative;\n    float: left;\n}\n\n.k-grid-virtual .k-grid-content::after {\n    content: \"\";\n    display: block;\n    clear: both;\n}\n\n.k-width-container {\n    position: absolute;\n    visibility: hidden;\n}\n\n.k-width-container div {\n    height: 1px;\n}\n\n.k-grid-add-row td,\n.k-grid-add-row .k-table-td {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\n.k-grid-lockedcolumns {\n    white-space: nowrap;\n}\n\n.k-grid-content,\n.k-grid-content-locked {\n    white-space: normal;\n}\n\n.k-grid-content-locked,\n.k-grid-footer-locked,\n.k-grid-header-locked {\n    flex: 0 0 auto;\n    display: inline-block;\n    vertical-align: top;\n    overflow: hidden;\n    position: relative;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: 1px;\n    box-sizing: content-box;\n}\n\n.k-grid-content-locked + .k-grid-content.k-auto-scrollable,\n.k-grid-footer-locked + .k-grid-content.k-auto-scrollable,\n.k-grid-header-locked + .k-grid-content.k-auto-scrollable {\n    display: inline-block;\n}\n\n.k-grid-content-locked .k-table,\n.k-grid-footer-locked .k-table,\n.k-grid-header-locked .k-table {\n    border-width: 0;\n}\n\n.k-grid-content,\n.k-grid-footer-wrap,\n.k-grid-header-wrap {\n    flex: 1 1 auto;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.k-grid-content.k-auto-scrollable,\n.k-grid-footer-wrap.k-auto-scrollable,\n.k-grid-header-wrap.k-auto-scrollable {\n    display: block;\n}\n\n.k-grid-header-locked > .k-grid-header-table,\n.k-grid-header-wrap > .k-grid-header-table {\n    margin-bottom: -1px;\n}\n\n.k-grid-header .k-table-th.k-grid-header-sticky,\n.k-grid-header .k-filter-row .k-grid-header-sticky,\n.k-grid .k-grid-content-sticky,\n.k-grid .k-grid-row-sticky,\n.k-grid .k-grid-footer-sticky {\n    position: sticky;\n    z-index: 2;\n}\n\n.k-grid-header .k-table-th.k-grid-header-sticky.k-edit-cell,\n.k-grid-header .k-filter-row .k-grid-header-sticky.k-edit-cell,\n.k-grid .k-grid-content-sticky.k-edit-cell,\n.k-grid .k-grid-row-sticky.k-edit-cell,\n.k-grid .k-grid-footer-sticky.k-edit-cell {\n    overflow: visible;\n    z-index: 3;\n}\n\n.k-master-row .k-grid-content-sticky::before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n}\n\nkendo-grid .k-table-row.k-grid-row-sticky {\n    border: 0;\n    position: static;\n    z-index: auto;\n}\n\nkendo-grid .k-grid-row-sticky td,\nkendo-grid .k-grid-row-sticky .k-table-td {\n    border-bottom-width: 1px;\n    border-top-width: 1px;\n    position: sticky;\n    top: inherit;\n    bottom: inherit;\n    z-index: 2;\n}\n\nkendo-grid .k-grid-row-sticky td.k-grid-content-sticky,\nkendo-grid .k-grid-row-sticky.k-table-alt-row td.k-grid-content-sticky,\nkendo-grid .k-grid-row-sticky .k-table-td.k-grid-content-sticky,\nkendo-grid .k-grid-row-sticky.k-table-alt-row .k-table-td.k-grid-content-sticky {\n    z-index: 3;\n}\n\nkendo-grid .k-grid-header-locked .k-table-th.k-grid-header-sticky:last-child,\nkendo-grid .k-grid-content-locked .k-table-row .k-grid-content-sticky:last-child {\n    border-inline-end: 0;\n}\n\nkendo-grid .k-grid-header .k-grid-column-menu,\nkendo-grid .k-grid-header .k-grid-header-menu {\n    z-index: 1;\n}\n\n.k-grid-content-sticky.k-grid-row-sticky {\n    z-index: 3;\n}\n\n.k-grid .k-table .k-grid-header-sticky,\n.k-grid .k-table .k-grid-content-sticky,\n.k-grid .k-table .k-grid-footer-sticky {\n    border-inline-end-width: 1px;\n}\n\n.k-grid .k-table .k-grid-header-sticky:not([style*=\"display: none\"]) + td,\n.k-grid .k-table .k-grid-header-sticky:not([style*=\"display: none\"]) + .k-table-td,\n.k-grid .k-table .k-grid-header-sticky:not([style*=\"display: none\"]) + .k-table-th,\n.k-grid .k-table .k-grid-content-sticky:not([style*=\"display: none\"]) + td,\n.k-grid .k-table .k-grid-content-sticky:not([style*=\"display: none\"]) + .k-table-td,\n.k-grid .k-table .k-grid-content-sticky:not([style*=\"display: none\"]) + .k-table-th,\n.k-grid .k-table .k-grid-footer-sticky:not([style*=\"display: none\"]) + td,\n.k-grid .k-table .k-grid-footer-sticky:not([style*=\"display: none\"]) + .k-table-td,\n.k-grid .k-table .k-grid-footer-sticky:not([style*=\"display: none\"]) + .k-table-th {\n    border-inline-start-width: 0;\n}\n\n.k-grid .k-grid-row-sticky {\n    border-bottom-width: 1px;\n    border-top-width: 1px;\n}\n\n.k-grid-header-sticky.k-table-th.k-grid-no-left-border.k-first {\n    border-inline-start-width: 0;\n}\n\n.k-grid.k-grid-no-scrollbar .k-grid-header-wrap,\n.k-grid.k-grid-no-scrollbar .k-grid-footer-wrap {\n    margin: 0;\n    border-width: 0;\n}\n\n.k-grid.k-grid-no-scrollbar .k-grid-header,\n.k-grid.k-grid-no-scrollbar .k-grid-footer {\n    padding: 0;\n}\n\n.k-grid.k-grid-no-scrollbar .k-grid-content {\n    overflow-y: auto;\n}\n\n.k-grid-norecords {\n    text-align: center;\n}\n\ndiv.k-grid-norecords {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.k-grid-norecords-template {\n    box-sizing: border-box;\n    margin-block: 0;\n    margin-inline: auto;\n    width: 20em;\n    height: 4em;\n    border: 1px solid;\n    line-height: 4em;\n}\n\n.k-column-title {\n    min-width: 0;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex-shrink: 1;\n    overflow: hidden;\n}\n\n.k-grid .k-grid-sm .k-table-th,\n.k-grid-sm .k-table-th {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-grid .k-grid-sm td,\n.k-grid .k-grid-sm .k-table-td,\n.k-grid-sm td,\n.k-grid-sm .k-table-td {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-grid .k-grid-sm .k-grouping-header,\n.k-grid-sm .k-grouping-header {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    gap: 0.25rem;\n}\n\n.k-grid .k-grid-sm .k-grouping-header::before,\n.k-grid-sm .k-grouping-header::before {\n    margin-inline-start: -0.25rem;\n}\n\n.k-grid .k-grid-sm .k-grid-header .k-table-th > .k-link,\n.k-grid-sm .k-grid-header .k-table-th > .k-link {\n    margin-block: -0.25rem;\n    margin-inline: -0.25rem;\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-grid .k-grid-sm .k-grid-header .k-grid-filter,\n.k-grid .k-grid-sm .k-grid-header .k-header-column-menu,\n.k-grid .k-grid-sm .k-grid-header .k-grid-header-menu,\n.k-grid-sm .k-grid-header .k-grid-filter,\n.k-grid-sm .k-grid-header .k-header-column-menu,\n.k-grid-sm .k-grid-header .k-grid-header-menu {\n    padding: 0.25rem;\n    width: calc(1.4285714286em + 0.5rem + 2px);\n    height: calc(1.4285714286em + 0.5rem + 2px);\n    bottom: -0.125rem;\n}\n\n.k-grid .k-grid-sm .k-table-th > .k-cell-inner,\n.k-grid-sm .k-table-th > .k-cell-inner {\n    margin-block: -0.25rem;\n    margin-inline: -0.25rem;\n}\n\n.k-grid .k-grid-sm .k-table-th > .k-cell-inner > .k-link,\n.k-grid-sm .k-table-th > .k-cell-inner > .k-link {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-grid .k-grid-sm .k-grouping-row .k-icon,\n.k-grid-sm .k-grouping-row .k-icon {\n    margin-inline-start: calc(8px - 0.25rem);\n}\n\n.k-grid .k-grid-sm .k-grouping-dropclue,\n.k-grid-sm .k-grouping-dropclue {\n    height: calc(1.25em + 0.25rem + 8px);\n}\n\n.k-grid .k-grid-sm .k-hierarchy-cell,\n.k-grid .k-grid-sm .k-drag-cell,\n.k-grid-sm .k-hierarchy-cell,\n.k-grid-sm .k-drag-cell {\n    padding: 0;\n}\n\n.k-grid .k-grid-sm .k-hierarchy-cell > .k-icon,\n.k-grid .k-grid-sm .k-drag-cell > .k-icon,\n.k-grid-sm .k-hierarchy-cell > .k-icon,\n.k-grid-sm .k-drag-cell > .k-icon {\n    padding-block: 0.25rem;\n    padding-inline: 0;\n}\n\n.k-grid .k-grid-sm .k-edit-cell,\n.k-grid .k-grid-sm .k-command-cell,\n.k-grid .k-grid-sm .k-grid-edit-row td,\n.k-grid .k-grid-sm .k-grid-edit-row .k-table-td,\n.k-grid-sm .k-edit-cell,\n.k-grid-sm .k-command-cell,\n.k-grid-sm .k-grid-edit-row td,\n.k-grid-sm .k-grid-edit-row .k-table-td {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-grid .k-grid-sm .k-filter-row td,\n.k-grid .k-grid-sm .k-filter-row .k-table-td,\n.k-grid .k-grid-sm .k-filter-row .k-table-th,\n.k-grid-sm .k-filter-row td,\n.k-grid-sm .k-filter-row .k-table-td,\n.k-grid-sm .k-filter-row .k-table-th {\n    padding-block: 0.375rem;\n    padding-inline: 0.375rem;\n}\n\n.k-grid .k-grid-sm .k-filtercell > span,\n.k-grid .k-grid-sm .k-filtercell .k-filtercell-wrapper,\n.k-grid-sm .k-filtercell > span,\n.k-grid-sm .k-filtercell .k-filtercell-wrapper {\n    gap: 0.125rem;\n}\n\n.k-grid .k-grid-sm .k-selection-aggregates,\n.k-grid-sm .k-selection-aggregates {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-grid .k-grid-sm .k-resizer-wrap,\n.k-grid-sm .k-resizer-wrap {\n    display: block;\n    width: 100%;\n    padding-block-start: 0.125rem;\n    padding-block-end: 0.25rem;\n    position: absolute;\n    background: none;\n    cursor: row-resize;\n    z-index: 2;\n}\n\n.k-grid .k-grid-md .k-table-th,\n.k-grid-md .k-table-th {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-grid .k-grid-md td,\n.k-grid .k-grid-md .k-table-td,\n.k-grid-md td,\n.k-grid-md .k-table-td {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-grid .k-grid-md .k-grouping-header,\n.k-grid-md .k-grouping-header {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    gap: 0.5rem;\n}\n\n.k-grid .k-grid-md .k-grouping-header::before,\n.k-grid-md .k-grouping-header::before {\n    margin-inline-start: -0.5rem;\n}\n\n.k-grid .k-grid-md .k-grid-header .k-table-th > .k-link,\n.k-grid-md .k-grid-header .k-table-th > .k-link {\n    margin-block: -0.5rem;\n    margin-inline: -0.5rem;\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-grid .k-grid-md .k-grid-header .k-grid-filter,\n.k-grid .k-grid-md .k-grid-header .k-header-column-menu,\n.k-grid .k-grid-md .k-grid-header .k-grid-header-menu,\n.k-grid-md .k-grid-header .k-grid-filter,\n.k-grid-md .k-grid-header .k-header-column-menu,\n.k-grid-md .k-grid-header .k-grid-header-menu {\n    padding: 0.375rem;\n    width: calc(1.5em + 0.75rem + 2px);\n    height: calc(1.5em + 0.75rem + 2px);\n    bottom: 0.125rem;\n}\n\n.k-grid .k-grid-md .k-table-th > .k-cell-inner,\n.k-grid-md .k-table-th > .k-cell-inner {\n    margin-block: -0.5rem;\n    margin-inline: -0.5rem;\n}\n\n.k-grid .k-grid-md .k-table-th > .k-cell-inner > .k-link,\n.k-grid-md .k-table-th > .k-cell-inner > .k-link {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-grid .k-grid-md .k-grouping-row .k-icon,\n.k-grid-md .k-grouping-row .k-icon {\n    margin-inline-start: calc(8px - 0.5rem);\n}\n\n.k-grid .k-grid-md .k-grouping-dropclue,\n.k-grid-md .k-grouping-dropclue {\n    height: calc(1.25em + 0.5rem + 8px);\n}\n\n.k-grid .k-grid-md .k-hierarchy-cell,\n.k-grid .k-grid-md .k-drag-cell,\n.k-grid-md .k-hierarchy-cell,\n.k-grid-md .k-drag-cell {\n    padding: 0;\n}\n\n.k-grid .k-grid-md .k-hierarchy-cell > .k-icon,\n.k-grid .k-grid-md .k-drag-cell > .k-icon,\n.k-grid-md .k-hierarchy-cell > .k-icon,\n.k-grid-md .k-drag-cell > .k-icon {\n    padding-block: 0.5rem;\n    padding-inline: 0;\n}\n\n.k-grid .k-grid-md .k-edit-cell,\n.k-grid .k-grid-md .k-command-cell,\n.k-grid .k-grid-md .k-grid-edit-row td,\n.k-grid .k-grid-md .k-grid-edit-row .k-table-td,\n.k-grid-md .k-edit-cell,\n.k-grid-md .k-command-cell,\n.k-grid-md .k-grid-edit-row td,\n.k-grid-md .k-grid-edit-row .k-table-td {\n    padding-block: 5px;\n    padding-inline: 0.5rem;\n}\n\n.k-grid .k-grid-md .k-filter-row td,\n.k-grid .k-grid-md .k-filter-row .k-table-td,\n.k-grid .k-grid-md .k-filter-row .k-table-th,\n.k-grid-md .k-filter-row td,\n.k-grid-md .k-filter-row .k-table-td,\n.k-grid-md .k-filter-row .k-table-th {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-grid .k-grid-md .k-filtercell > span,\n.k-grid .k-grid-md .k-filtercell .k-filtercell-wrapper,\n.k-grid-md .k-filtercell > span,\n.k-grid-md .k-filtercell .k-filtercell-wrapper {\n    gap: 0.25rem;\n}\n\n.k-grid .k-grid-md .k-selection-aggregates,\n.k-grid-md .k-selection-aggregates {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n}\n\n.k-grid .k-grid-md .k-resizer-wrap,\n.k-grid-md .k-resizer-wrap {\n    display: block;\n    width: 100%;\n    padding-block-start: calc(5px - 0.125rem);\n    padding-block-end: 5px;\n    position: absolute;\n    background: none;\n    cursor: row-resize;\n    z-index: 2;\n}\n\n.k-loading-pdf-mask {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 100;\n}\n\n.k-loading-pdf-mask > .k-i-loading {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    font-size: 64px;\n}\n\n.k-loading-pdf-mask .k-loading-pdf-progress {\n    margin: auto;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n\n.k-pdf-export .k-loading-pdf-mask {\n    display: none;\n}\n\n.k-grid-pdf-export-element {\n    position: absolute;\n    left: -10000px;\n    top: -10000px;\n}\n\n.k-grid-pdf-export-element .k-filter-row {\n    display: none;\n}\n\n.k-pdf-export-shadow .k-grid {\n    float: left;\n    width: auto !important;\n}\n\n.k-pdf-export-shadow .k-grid,\n.k-pdf-export-shadow .k-grid-content,\n.k-pdf-export-shadow .k-grid-content-locked {\n    height: auto !important;\n    overflow: visible;\n}\n\n.k-pdf-export-shadow .k-grid-header-locked + .k-grid-header-wrap,\n.k-pdf-export-shadow .k-grid-header-locked + .k-grid-content,\n.k-pdf-export-shadow .k-grid-header-locked + .k-grid-footer-wrap {\n    width: auto !important;\n}\n\n.k-pdf-export-shadow .k-grid-header,\n.k-pdf-export-shadow .k-grid[data-role=\"grid\"] .k-grid-footer {\n    padding: 0 !important;\n}\n\n.k-filter-menu-popup {\n    min-width: 250px;\n    max-width: 320px;\n}\n\n.k-filter-menu {\n    box-sizing: border-box;\n}\n\n.k-filter-menu-container {\n    padding: 0.5rem;\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: stretch;\n    gap: 0.5rem;\n}\n\n.k-filter-menu-container .k-filter-and {\n    width: min-content;\n    align-self: start;\n}\n\n.k-filter-menu-container .k-actions, .k-filter-menu-container .k-edit-buttons,\n.k-filter-menu-container .k-action-buttons,\n.k-filter-menu-container .k-columnmenu-actions, .k-filter-menu-container .k-form-buttons {\n    margin: 0;\n    padding: 0;\n}\n\n.k-filter-menu-container kendo-numeric-filter-menu,\n.k-filter-menu-container kendo-grid-string-filter-menu,\n.k-filter-menu-container kendo-grid-date-filter-menu,\n.k-filter-menu-container kendo-grid-numeric-filter-menu,\n.k-filter-menu-container kendo-grid-filter-menu-input-wrapper,\n.k-filter-menu-container kendo-treelist-string-filter-menu,\n.k-filter-menu-container kendo-treelist-date-filter-menu,\n.k-filter-menu-container kendo-treelist-numeric-filter-menu,\n.k-filter-menu-container kendo-treelist-filter-menu-input-wrapper {\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: stretch;\n    gap: 0.5rem;\n}\n\n.k-filter-menu.k-popup .k-filter-menu-container,\n.k-grid-filter-popup.k-popup .k-filter-menu-container {\n    min-width: 250px;\n    max-width: 320px;\n}\n\n.k-popup .k-multicheck-wrap {\n    margin: 0;\n    padding: 0;\n    max-height: 300px;\n    white-space: nowrap;\n    overflow: auto;\n    list-style: none;\n}\n\n.k-popup .k-multicheck-wrap .k-item,\n.k-popup .k-multicheck-wrap .k-check-all-wrap {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.k-filter-selected-items {\n    font-weight: bold;\n    line-height: normal;\n    white-space: nowrap;\n}\n\n.k-autofitting {\n    width: auto !important;\n    table-layout: auto !important;\n}\n\n.k-autofitting .k-table-th,\n.k-autofitting td,\n.k-autofitting .k-table-td {\n    white-space: nowrap !important;\n}\n\n.k-autofitting .k-detail-row {\n    display: none !important;\n}\n\n.k-column-menu-popup,\n.k-grid-columnmenu-popup {\n    min-width: 250px;\n    box-sizing: border-box;\n}\n\n.k-column-menu-popup.k-popup,\n.k-grid-columnmenu-popup.k-popup {\n    max-width: 320px;\n}\n\n.k-column-menu-popup .k-actions, .k-column-menu-popup .k-edit-buttons,\n.k-column-menu-popup .k-action-buttons,\n.k-column-menu-popup .k-columnmenu-actions, .k-column-menu-popup .k-form-buttons,\n.k-grid-columnmenu-popup .k-actions,\n.k-grid-columnmenu-popup .k-edit-buttons,\n.k-grid-columnmenu-popup .k-action-buttons,\n.k-grid-columnmenu-popup .k-columnmenu-actions,\n.k-grid-columnmenu-popup .k-form-buttons {\n    margin: 0;\n}\n\n.k-column-menu {\n    box-sizing: border-box;\n}\n\n.k-column-menu .k-menu:not(.k-context-menu) {\n    font-weight: 400;\n}\n\n.k-column-menu .k-expander {\n    border: 0;\n    background: inherit;\n}\n\n.k-column-menu .k-expander .k-columnmenu-item {\n    display: flex;\n    align-items: center;\n}\n\n.k-column-menu-tabbed {\n    border-radius: 0.25rem 0.25rem 0 0;\n}\n\n.k-column-menu-tabbed .k-tabstrip-items {\n    margin: -1px -1px 0;\n}\n\n.k-column-menu-tabbed .k-tabstrip-items .k-item {\n    flex: 1;\n}\n\n.k-column-menu-tabbed .k-tabstrip-items .k-link {\n    justify-content: center;\n}\n\n.k-column-menu-tabbed .k-tabstrip-content {\n    padding-inline: 0;\n    padding-block: 0.5rem;\n    border-width: 0;\n}\n\n.k-column-list {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    max-height: 200px;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.k-column-chooser-title,\n.k-column-list-item {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-column-list-item {\n    margin: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    position: relative;\n}\n\n.k-column-list-item .k-checkbox-label {\n    margin: 0;\n}\n\n.k-column-list-item:focus {\n    outline: none;\n}\n\n.k-columns-items-wrap {\n    padding-block: 0.5rem;\n    padding-inline: 0;\n}\n\n.k-columnmenu-item {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n    outline: 0;\n    cursor: pointer;\n}\n\n.k-columnmenu-item > .k-icon,\n.k-columnmenu-item > .k-expander-indicator {\n    margin-inline-end: 0.5rem;\n}\n\n.k-columnmenu-item-wrapper + .k-columnmenu-item-wrapper {\n    border-top: 1px solid;\n    border-top-color: #dee2e6;\n}\n\n.k-columnmenu-item-content {\n    overflow: hidden;\n}\n\n.k-column-menu-group-header {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-column-menu-group-header-text {\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    font-weight: bold;\n    text-transform: uppercase;\n    flex: 1 1 auto;\n}\n\n.k-rtl .k-grid-virtual .k-grid-content .k-grid-table-wrap,\n.k-rtl .k-grid-virtual .k-grid-content .k-grid-table,\n.k-rtl .k-grid-virtual .k-grid-content > .k-height-container,\n[dir=\"rtl\"] .k-grid-virtual .k-grid-content .k-grid-table-wrap,\n[dir=\"rtl\"] .k-grid-virtual .k-grid-content .k-grid-table,\n[dir=\"rtl\"] .k-grid-virtual .k-grid-content > .k-height-container,\n.k-rtl.k-grid-virtual .k-grid-content .k-grid-table-wrap,\n.k-rtl.k-grid-virtual .k-grid-content .k-grid-table,\n.k-rtl.k-grid-virtual .k-grid-content > .k-height-container,\n[dir=\"rtl\"].k-grid-virtual .k-grid-content .k-grid-table-wrap,\n[dir=\"rtl\"].k-grid-virtual .k-grid-content .k-grid-table,\n[dir=\"rtl\"].k-grid-virtual .k-grid-content > .k-height-container {\n    float: right;\n}\n\n.k-grid {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-grid .k-table {\n    background-color: inherit;\n}\n\n.k-grid td,\n.k-grid .k-table-td,\n.k-grid .k-grid-content,\n.k-grid .k-grid-header-locked,\n.k-grid .k-grid-content-locked {\n    border-color: #dee2e6;\n}\n\n.k-grid .k-table-alt-row {\n    background-color: rgba(0, 0, 0, 0.04);\n}\n\n.k-grid tbody > tr:not(.k-detail-row):hover,\n.k-grid .k-table-tbody > .k-table-row:not(.k-detail-row).k-hover {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n.k-grid .k-table-th.k-selected,\n.k-grid td.k-selected,\n.k-grid .k-table-td.k-selected,\n.k-grid .k-table-row.k-selected > td,\n.k-grid .k-table-row.k-selected > .k-table-td {\n    color: #212529;\n    background-color: rgba(13, 110, 253, 0.25);\n}\n\n.k-grid .k-table-th:focus, .k-grid .k-table-th.k-focus,\n.k-grid td:focus,\n.k-grid td.k-focus,\n.k-grid .k-table-td:focus,\n.k-grid .k-table-td.k-focus,\n.k-grid .k-master-row > td:focus,\n.k-grid .k-master-row > td.k-focus,\n.k-grid .k-grouping-row > td:focus,\n.k-grid .k-grouping-row > td.k-focus,\n.k-grid .k-detail-row > td:focus,\n.k-grid .k-detail-row > td.k-focus,\n.k-grid .k-group-footer > td:focus,\n.k-grid .k-group-footer > td.k-focus,\n.k-grid .k-master-row > .k-table-td:focus,\n.k-grid .k-master-row > .k-table-td.k-focus,\n.k-grid .k-grouping-row > .k-table-td:focus,\n.k-grid .k-grouping-row > .k-table-td.k-focus,\n.k-grid .k-detail-row > .k-table-td:focus,\n.k-grid .k-detail-row > .k-table-td.k-focus,\n.k-grid .k-group-footer > .k-table-td:focus,\n.k-grid .k-group-footer > .k-table-td.k-focus,\n.k-grid .k-grid-pager:focus,\n.k-grid .k-grid-pager.k-focus {\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n\n.k-grid col.k-sorted,\n.k-grid .k-table-th.k-sorted {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n.k-grid .k-grid-header-locked,\n.k-grid .k-grid-content-locked,\n.k-grid .k-grid-header-locked .k-header,\n.k-grid .k-grid-content-locked td,\n.k-grid .k-grid-content-locked .k-table-td {\n    border-color: rgba(33, 37, 41, 0.5);\n}\n\n.k-grid .k-grid-header-locked .k-header {\n    border-bottom-color: #dee2e6;\n}\n\n.k-grid .k-grid-content-locked .k-group-footer td,\n.k-grid .k-grid-content-locked .k-group-footer .k-table-td,\n.k-grid .k-grid-content-locked .k-group-cell {\n    border-color: #dee2e6;\n}\n\n.k-grid .k-grid-content-locked .k-grouping-row + .k-table-row td,\n.k-grid .k-grid-content-locked .k-grouping-row + .k-table-row .k-table-td {\n    border-top-color: #dee2e6;\n}\n\n.k-grid .k-grid-content-locked .k-selected td,\n.k-grid .k-grid-content-locked .k-selected .k-table-td {\n    background-color: #c3dbff;\n}\n\n.k-grid .k-grid-content-locked .k-selected.k-table-alt-row td,\n.k-grid .k-grid-content-locked .k-selected.k-table-alt-row .k-table-td {\n    background-color: #bdd4f7;\n}\n\n.k-grid .k-grid-content-locked .k-selected:hover td,\n.k-grid .k-grid-content-locked .k-selected.k-hover td,\n.k-grid .k-grid-content-locked .k-selected:hover .k-table-td,\n.k-grid .k-grid-content-locked .k-selected.k-hover .k-table-td {\n    background-color: #b8cff1;\n}\n\n.k-grid-toolbar {\n    border-color: inherit;\n}\n\n.k-grouping-header {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-grid-header {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-grid-header .k-sort-icon,\n.k-grid-header .k-sort-order {\n    color: #0d6efd;\n}\n\n.k-grid-header .k-grid-filter:focus, .k-grid-header .k-grid-filter.k-focus,\n.k-grid-header .k-header-column-menu:focus,\n.k-grid-header .k-header-column-menu.k-focus,\n.k-grid-header .k-grid-header-menu:focus,\n.k-grid-header .k-grid-header-menu.k-focus,\n.k-grid-header .k-hierarchy-cell .k-icon:focus,\n.k-grid-header .k-hierarchy-cell .k-icon.k-focus {\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1);\n}\n\n.k-grid-header .k-grid-filter.k-active,\n.k-grid-header .k-header-column-menu.k-active,\n.k-grid-header .k-grid-header-menu.k-active,\n.k-grid-header .k-hierarchy-cell .k-icon.k-active {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-grid-header .k-grid-header-sticky,\n.k-grid-header .k-grid-header-sticky.k-sorted {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-right-color: rgba(33, 37, 41, 0.5);\n    border-left-color: rgba(33, 37, 41, 0.5);\n}\n\n.k-selection-aggregates {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-master-row .k-grid-content-sticky {\n    border-color: rgba(33, 37, 41, 0.5);\n    color: #212529;\n    background-color: #ffffff;\n    border-top-color: #dee2e6;\n}\n\n.k-master-row .k-grid-row-sticky {\n    border-top-color: rgba(33, 37, 41, 0.5);\n    border-bottom-color: rgba(33, 37, 41, 0.5);\n    background-color: #ffffff;\n}\n\n.k-master-row.k-table-alt-row .k-grid-content-sticky,\n.k-master-row.k-table-alt-row .k-grid-row-sticky {\n    background-color: whitesmoke;\n}\n\n.k-master-row.k-table-row.k-selected td.k-grid-content-sticky,\n.k-master-row.k-table-row.k-selected .k-table-td.k-grid-row-sticky,\n.k-master-row.k-table-row td.k-grid-content-sticky.k-selected,\n.k-master-row.k-table-row .k-table-td.k-grid-content-sticky.k-selected {\n    background-color: #c3dbff;\n}\n\n.k-master-row.k-selected.k-table-alt-row td.k-grid-content-sticky,\n.k-master-row.k-selected.k-table-alt-row .k-table-td.k-grid-row-sticky,\n.k-master-row.k-table-alt-row td.k-grid-content-sticky.k-selected,\n.k-master-row.k-table-alt-row .k-table-td.k-grid-content-sticky.k-selected {\n    background-color: #bdd4f7;\n}\n\n.k-master-row:hover .k-grid-content-sticky,\n.k-master-row.k-hover .k-grid-content-sticky,\n.k-master-row:hover .k-grid-row-sticky,\n.k-master-row.k-hover .k-grid-row-sticky {\n    background-color: #ebebeb;\n}\n\n.k-master-row.k-selected:hover td.k-grid-content-sticky,\n.k-master-row.k-selected.k-hover .k-table-td.k-grid-content-sticky,\n.k-master-row.k-selected:hover td.k-grid-row-sticky,\n.k-master-row.k-selected.k-hover .k-table-td.k-grid-row-sticky,\n.k-master-row:hover td.k-grid-content-sticky.k-selected,\n.k-master-row.k-hover td.k-grid-content-sticky.k-selected,\n.k-master-row:hover .k-table-td.k-grid-content-sticky.k-selected,\n.k-master-row.k-hover .k-table-td.k-grid-content-sticky.k-selected {\n    background-color: #b8cff1;\n}\n\nkendo-grid.k-grid .k-grid-content-sticky {\n    border-top-color: #dee2e6;\n    border-left-color: rgba(33, 37, 41, 0.5);\n    border-right-color: rgba(33, 37, 41, 0.5);\n    background-color: #ffffff;\n}\n\nkendo-grid.k-grid .k-grid-content-sticky:hover, kendo-grid.k-grid .k-grid-content-sticky.k-hover {\n    background-color: #ebebeb;\n}\n\nkendo-grid.k-grid .k-grid-row-sticky td,\nkendo-grid.k-grid .k-grid-row-sticky .k-table-td {\n    border-top-color: rgba(33, 37, 41, 0.5);\n    border-bottom-color: rgba(33, 37, 41, 0.5);\n    background-color: #ffffff;\n}\n\nkendo-grid.k-grid .k-grid-row-sticky td:hover td,\nkendo-grid.k-grid .k-grid-row-sticky td.k-hover td,\nkendo-grid.k-grid .k-grid-row-sticky td:hover .k-table-td,\nkendo-grid.k-grid .k-grid-row-sticky td.k-hover .k-table-td,\nkendo-grid.k-grid .k-grid-row-sticky .k-table-td:hover td,\nkendo-grid.k-grid .k-grid-row-sticky .k-table-td.k-hover td,\nkendo-grid.k-grid .k-grid-row-sticky .k-table-td:hover .k-table-td,\nkendo-grid.k-grid .k-grid-row-sticky .k-table-td.k-hover .k-table-td {\n    background-color: #ebebeb;\n}\n\nkendo-grid.k-grid .k-table-alt-row .k-grid-content-sticky,\nkendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row td,\nkendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row .k-table-td {\n    background-color: whitesmoke;\n}\n\nkendo-grid.k-grid .k-table-row.k-selected .k-grid-content-sticky,\nkendo-grid.k-grid .k-selected.k-grid-row-sticky td,\nkendo-grid.k-grid .k-grid-row-sticky td.k-selected,\nkendo-grid.k-grid .k-selected.k-grid-row-sticky .k-table-td,\nkendo-grid.k-grid .k-grid-row-sticky .k-table-td.k-selected,\nkendo-grid.k-grid .k-selected.k-grid-content-sticky {\n    background-color: #c3dbff;\n}\n\nkendo-grid.k-grid .k-table-row.k-selected.k-table-alt-row .k-grid-content-sticky,\nkendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky td,\nkendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky .k-table-td,\nkendo-grid.k-grid .k-table-alt-row .k-selected.k-grid-content-sticky {\n    background-color: #bdd4f7;\n}\n\nkendo-grid.k-grid .k-table-row:hover .k-grid-content-sticky,\nkendo-grid.k-grid .k-table-row.k-hover .k-grid-content-sticky,\nkendo-grid.k-grid .k-grid-row-sticky:hover td,\nkendo-grid.k-grid .k-grid-row-sticky.k-hover td,\nkendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row:hover td,\nkendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row.k-hover td,\nkendo-grid.k-grid .k-grid-row-sticky:hover .k-table-td,\nkendo-grid.k-grid .k-grid-row-sticky.k-hover .k-table-td,\nkendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row:hover .k-table-td,\nkendo-grid.k-grid .k-grid-row-sticky.k-table-alt-row.k-hover .k-table-td,\nkendo-grid.k-grid .k-table-alt-row:hover .k-grid-content-sticky,\nkendo-grid.k-grid .k-table-alt-row.k-hover .k-grid-content-sticky {\n    background-color: #ebebeb;\n}\n\nkendo-grid.k-grid .k-table-row.k-selected:hover .k-grid-content-sticky,\nkendo-grid.k-grid .k-table-row.k-selected.k-hover .k-grid-content-sticky,\nkendo-grid.k-grid .k-selected.k-grid-row-sticky:hover td,\nkendo-grid.k-grid .k-selected.k-grid-row-sticky.k-hover td,\nkendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky:hover td,\nkendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky.k-hover td,\nkendo-grid.k-grid .k-selected.k-grid-row-sticky:hover .k-table-td,\nkendo-grid.k-grid .k-selected.k-grid-row-sticky.k-hover .k-table-td,\nkendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky:hover .k-table-td,\nkendo-grid.k-grid .k-selected.k-table-alt-row.k-grid-row-sticky.k-hover .k-table-td,\nkendo-grid.k-grid .k-table-row.k-selected.k-table-alt-row:hover .k-grid-content-sticky,\nkendo-grid.k-grid .k-table-row.k-selected.k-table-alt-row.k-hover .k-grid-content-sticky,\nkendo-grid.k-grid .k-grid-row-sticky:hover td.k-selected,\nkendo-grid.k-grid .k-grid-row-sticky.k-hover td.k-selected,\nkendo-grid.k-grid .k-grid-row-sticky:hover .k-table-td.k-selected,\nkendo-grid.k-grid .k-grid-row-sticky.k-hover .k-table-td.k-selected,\nkendo-grid.k-grid .k-table-row:hover .k-grid-content-sticky.k-selected,\nkendo-grid.k-grid .k-table-row.k-hover .k-grid-content-sticky.k-selected {\n    background-color: #b8cff1;\n}\n\n.k-grouping-row .k-grid-content-sticky {\n    background-color: #f8f9fa;\n}\n\n.k-grouping-row:hover .k-grid-content-sticky,\n.k-grouping-row.k-hover .k-grid-content-sticky {\n    background-color: #ebebeb;\n}\n\n.k-group-footer td,\n.k-group-footer .k-table-td,\n.k-group-footer .k-grid-footer-sticky {\n    background-color: #f8f9fa;\n}\n\n.k-group-footer:hover .k-grid-footer-sticky,\n.k-group-footer.k-hover .k-grid-footer-sticky {\n    background-color: #f8f9fa;\n}\n\n.k-grid-footer {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-grid-footer .k-grid-footer-locked {\n    border-color: inherit;\n}\n\n.k-grid-footer .k-grid-footer-sticky {\n    border-color: rgba(33, 37, 41, 0.5);\n    background-color: #f8f9fa;\n}\n\n.k-grouping-row,\n.k-group-cell {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-column-list-item:hover,\n.k-columnmenu-item:hover {\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-column-list-item:focus,\n.k-column-list-item.k-focus,\n.k-columnmenu-item:focus,\n.k-columnmenu-item.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-column-list-wrapper {\n    border-color: inherit;\n}\n\n.k-columnmenu-item.k-selected {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-column-menu .k-menu:not(.k-context-menu) {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-column-menu .k-menu:not(.k-context-menu) .k-item:hover, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-hover {\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-column-menu .k-menu:not(.k-context-menu) .k-item.k-selected {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-column-menu .k-menu:not(.k-context-menu) .k-item:focus, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-column-menu-tabbed {\n    background-color: #f8f9fa;\n}\n\n.k-column-menu-group-header-text {\n    border-color: #dee2e6;\n    color: #212529;\n}\n\n.k-check-all-wrap {\n    border-color: #dee2e6;\n}\n\n.k-grid-norecords-template {\n    background-color: #ffffff;\n    border-color: #dee2e6;\n}\n\n.k-resizer-wrap.k-hover .k-row-resizer {\n    background-color: rgba(0, 0, 0, 0.12);\n}\n\n.k-resizer-wrap.k-active .k-row-resizer {\n    background-color: #0d6efd;\n}\n\n.k-listview {\n    margin: 0;\n    padding: 0;\n    border-width: 0;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    flex-flow: column nowrap;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.k-listview-bordered {\n    border-width: 1px;\n}\n\n.k-listview-header {\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n}\n\n.k-listview-bordered > .k-listview-header {\n    border-bottom-width: 1px;\n}\n\n.k-listview-content {\n    margin: 0;\n    padding: 0;\n    outline: 0;\n    flex-grow: 1;\n    position: relative;\n    overflow: auto;\n}\n\n.k-listview-content::after {\n    height: 0;\n    clear: both;\n    display: block;\n}\n\n.k-listview-content.k-d-flex::after, .k-listview-content.k-d-flex-row::after, .k-listview-content.k-d-flex-col::after,\n.k-listview-content.k-d-grid::after {\n    display: none;\n}\n\n.k-listview-content-padding-rectangle {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-listview-content-padding-square {\n    padding: 0.25rem;\n}\n\n.k-listview-item {\n    padding: 0;\n    border-width: 0;\n    outline: 0;\n    border-style: solid;\n    box-sizing: border-box;\n    flex-shrink: 0;\n}\n\n.k-listview-item-padding-rectangle {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-listview-item-padding-rectangle .k-listview-link {\n    margin-block: -0.25rem;\n    margin-inline: -0.25rem;\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n}\n\n.k-listview-item-padding-square {\n    padding: 0.25rem;\n}\n\n.k-listview-item-padding-square .k-listview-link {\n    margin: -0.25rem;\n    padding: 0.25rem;\n}\n\n.k-listview-footer {\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n}\n\n.k-listview-bordered > .k-listview-footer {\n    border-top-width: 1px;\n}\n\n.k-listview-pager {\n    border-width: 0;\n    border-color: inherit;\n}\n\n.k-listview-bordered > .k-listview-pager-top {\n    border-block-end-width: var(--kendo-listview-border-width, 1px);\n}\n\n.k-listview-bordered > .k-listview-pager-bottom {\n    border-block-start-width: var(--kendo-listview-border-width, 1px);\n}\n\n.k-listview-borders-all .k-listview-item {\n    border-width: 1px;\n}\n\n.k-listview-borders-horizontal .k-listview-item {\n    border-top-width: 1px;\n}\n\n.k-listview-borders-horizontal .k-listview-item:first-child {\n    border-top-width: 0;\n}\n\n.k-listview-borders-vertical .k-listview-item {\n    border-left-width: 1px;\n}\n\n.k-listview-borders-vertical .k-listview-item:first-child {\n    border-left-width: 0;\n}\n\n.k-listview {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-listview-content > .k-focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-listview-content > .k-selected {\n    background-color: rgba(13, 110, 253, 0.25);\n}\n\n.k-listview-item {\n    border-color: #dee2e6;\n}\n\n.k-spreadsheet {\n    width: 800px;\n    height: 600px;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    cursor: default;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-spreadsheet .k-vertical-align-center {\n    position: relative;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.k-spreadsheet .k-vertical-align-bottom {\n    position: relative;\n    top: 100%;\n    transform: translateY(-100%);\n}\n\n.k-spreadsheet-toolbar {\n    border-width: 0;\n}\n\n.k-spreadsheet-action-bar {\n    border-width: 0 0 1px;\n    border-style: solid;\n    border-color: inherit;\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    font-size: 1rem;\n    font-family: Arial, Verdana, sans-serif;\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n}\n\n.k-spreadsheet-name-editor {\n    width: 10em;\n}\n\n.k-spreadsheet-formula-bar {\n    min-width: 0px;\n    border-color: inherit;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex: 1;\n    gap: 0.5rem;\n}\n\n.k-spreadsheet-formula-bar > .k-icon {\n    padding-block: 0;\n    padding-inline: 0.5rem;\n    box-sizing: content-box;\n    border-width: 0 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n    flex-shrink: 0;\n}\n\n.k-spreadsheet-formula-bar .k-tooltip,\n.k-spreadsheet-formula-bar .k-group-header,\n.k-spreadsheet-formula-bar .k-list-scroller {\n    display: none;\n}\n\n.k-spreadsheet-formula-bar .k-spreadsheet-formula-input {\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n    line-height: 1.5;\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-spreadsheet-formula-bar .k-spreadsheet-formula-input.k-spreadsheet-array-formula::before {\n    content: \"{\";\n    font-weight: 700;\n}\n\n.k-spreadsheet-formula-bar .k-spreadsheet-formula-input.k-spreadsheet-array-formula::after {\n    content: \"}\";\n    font-weight: 700;\n}\n\n.k-spreadsheet-formula-input {\n    outline: 0;\n    white-space: pre;\n    flex: 1;\n    box-sizing: border-box;\n}\n\n.k-spreadsheet-formula-input > .k-syntax-func.k-syntax-at-point,\n.k-spreadsheet-formula-input > .k-syntax-bool.k-syntax-at-point,\n.k-spreadsheet-formula-input > .k-syntax-ref.k-syntax-at-point,\n.k-spreadsheet-formula-input > .k-syntax-str.k-syntax-at-point,\n.k-spreadsheet-formula-input > .k-syntax-num.k-syntax-at-point {\n    text-decoration: underline;\n}\n\n.k-spreadsheet-formula-input > .k-series-a,\n.k-spreadsheet-formula-input > .k-series-b,\n.k-spreadsheet-formula-input > .k-series-c,\n.k-spreadsheet-formula-input > .k-series-d {\n    background-color: transparent;\n}\n\n.k-spreadsheet-formula-list {\n    min-width: 100px;\n}\n\n.k-spreadsheet-formula-list .k-item {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n}\n\n.k-syntax-func,\n.k-syntax-startexp {\n    font-weight: bold;\n}\n\n.k-spreadsheet-cell-editor {\n    padding-block: 0px;\n    padding-inline: 0.25rem;\n    line-height: 20px;\n    display: none;\n    overflow: hidden;\n    position: absolute;\n    z-index: 100;\n}\n\n.k-spreadsheet-sheets-bar {\n    padding-block-end: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    position: relative;\n}\n\n.k-spreadsheet-sheets {\n    flex: 1 1 auto;\n    overflow: hidden;\n}\n\n.k-spreadsheet-sheets .k-tabstrip-items-wrapper {\n    border-width: 0;\n}\n\n.k-spreadsheet-sheets-bar-add {\n    align-self: center;\n}\n\n.k-spreadsheet-sheets-bar-add:not(:hover) {\n    border-color: transparent;\n    color: inherit;\n    background: none;\n}\n\n.k-spreadsheet-sheets-items {\n    flex: 1;\n    overflow: hidden;\n}\n\n.k-spreadsheet-sheets-items .k-tabstrip-items-wrapper {\n    margin: 0;\n    border-width: 0;\n}\n\n.k-spreadsheet-sheets-items .k-item .k-link {\n    display: inline-block;\n}\n\n.k-spreadsheet-sheets-items .k-item .k-spreadsheet-sheets-remove {\n    margin-right: 0.5rem;\n    margin-left: -0.5rem;\n    padding: 0;\n    line-height: 1;\n    display: inline-flex;\n    flex-direction: row;\n    vertical-align: middle;\n    align-self: center;\n}\n\n.k-spreadsheet-view {\n    height: auto !important;\n    border-color: inherit;\n    font-size: 1rem;\n    font-family: Arial, Verdana, sans-serif;\n    flex: 1;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-spreadsheet-view .k-disabled {\n    pointer-events: auto;\n}\n\n.k-spreadsheet-fixed-container {\n    width: calc(100% - var(--kendo-scrollbar-width, 17px));\n    height: calc(100% - var(--kendo-scrollbar-width, 17px));\n    border-color: inherit;\n    box-sizing: border-box;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    position: absolute;\n    z-index: 2;\n    overflow: hidden;\n}\n\n.k-spreadsheet-overflow {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow: hidden;\n    border-color: inherit;\n}\n\n.k-spreadsheet-pane {\n    padding: 0 1px 0 0;\n    border-width: 2px 0 0 2px;\n    border-style: solid;\n    border-color: inherit;\n    box-sizing: border-box;\n    position: absolute;\n    overflow: hidden;\n}\n\n.k-spreadsheet-pane.k-top {\n    border-top-width: 0;\n}\n\n.k-spreadsheet-pane.k-left {\n    border-left-width: 0;\n}\n\n.k-spreadsheet-top-corner {\n    border-width: 0 1px 1px 0;\n    border-style: solid;\n    box-sizing: border-box;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10000;\n}\n\n.k-spreadsheet-top-corner::after {\n    content: \"\";\n    display: block;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    border: 6px solid transparent;\n    border-right-color: inherit;\n    border-bottom-color: inherit;\n}\n\n.k-spreadsheet-scroller {\n    width: 100%;\n    height: 100%;\n    overflow: scroll;\n    position: absolute;\n    z-index: 1;\n}\n\n@media (hover: none), (pointer: coarse) {\n    .k-spreadsheet-scroller {\n        z-index: 3;\n    }\n}\n\n.k-spreadsheet-haxis,\n.k-spreadsheet-vaxis {\n    border: 0 solid;\n    border-color: inherit;\n    position: absolute;\n}\n\n.k-spreadsheet-haxis {\n    border-width: 1px 0 0;\n    left: 0;\n}\n\n.k-spreadsheet-vaxis {\n    border-width: 0 0 0 1px;\n    top: 0;\n}\n\n.k-spreadsheet-row-header,\n.k-spreadsheet-column-header {\n    text-align: center;\n    z-index: 100;\n}\n\n.k-spreadsheet-row-header > div,\n.k-spreadsheet-column-header > div {\n    position: relative;\n    box-sizing: border-box;\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n}\n\n.k-spreadsheet-row-header > div::after,\n.k-spreadsheet-column-header > div::after {\n    content: \"\";\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n    display: none;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.k-spreadsheet-row-header {\n    position: relative;\n}\n\n.k-spreadsheet-column-header {\n    position: absolute;\n}\n\n.k-spreadsheet-row-header > div {\n    border-top-width: 1px;\n}\n\n.k-spreadsheet-row-header > div:first-child {\n    border-top-width: 0;\n}\n\n.k-spreadsheet-row-header > .k-selection-partial::after,\n.k-spreadsheet-row-header > .k-selection-full::after {\n    border-right-width: 2px;\n    display: block;\n}\n\n.k-spreadsheet-column-header > div {\n    border-left-width: 1px;\n}\n\n.k-spreadsheet-column-header > div:first-child {\n    border-left-width: 0;\n}\n\n.k-spreadsheet-column-header > .k-selection-partial::after,\n.k-spreadsheet-column-header > .k-selection-full::after {\n    border-bottom-width: 2px;\n    display: block;\n}\n\n.k-spreadsheet-data {\n    border-color: inherit;\n    cursor: cell;\n    position: relative;\n}\n\n.k-spreadsheet-cell {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    box-sizing: border-box;\n    position: absolute;\n    line-height: normal;\n    white-space: pre;\n    overflow: hidden;\n}\n\n.k-spreadsheet-merged-cells-wrapper {\n    position: relative;\n}\n\n.k-spreadsheet-disabled-mask {\n    position: absolute;\n}\n\n.k-spreadsheet .k-selection-wrapper {\n    position: relative;\n    cursor: cell;\n}\n\n.k-spreadsheet .k-spreadsheet-selection {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    position: absolute;\n}\n\n.k-spreadsheet .k-spreadsheet-selection-highlight {\n    border-width: 2px;\n    border-style: dashed;\n    box-sizing: border-box;\n    position: absolute;\n}\n\n.k-spreadsheet .k-spreadsheet-editor-button {\n    position: absolute;\n    padding: 0;\n    z-index: 60;\n}\n\n.k-spreadsheet-active-cell {\n    outline-color: transparent !important;\n    z-index: 10;\n}\n\n.k-spreadsheet .k-auto-fill-wrapper {\n    position: relative;\n}\n\n.k-spreadsheet .k-auto-fill,\n.k-spreadsheet .k-auto-fill-punch,\n.k-spreadsheet .k-auto-fill-br-hint {\n    box-sizing: border-box;\n    position: absolute;\n}\n\n.k-spreadsheet .k-auto-fill {\n    border-width: 1px;\n    border-style: solid;\n    cursor: crosshair;\n}\n\n.k-spreadsheet .k-single-selection::after {\n    content: \"\";\n    margin-bottom: -4px;\n    margin-right: -4px;\n    width: 6px;\n    height: 6px;\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 50%;\n    display: block;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    z-index: 300;\n    cursor: crosshair;\n}\n\n.k-spreadsheet .k-selection-full::after,\n.k-spreadsheet .k-selection-partial::after {\n    display: none;\n}\n\n.k-spreadsheet .k-autofill-wrapper {\n    position: relative;\n    cursor: cell;\n}\n\n.k-spreadsheet-vborder {\n    position: absolute;\n    border-left-style: solid;\n    border-left-width: 1px;\n}\n\n.k-spreadsheet-hborder {\n    position: absolute;\n    border-top-style: solid;\n    border-top-width: 1px;\n}\n\n.k-spreadsheet-has-comment::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: 0;\n    inset-inline-end: 0;\n    inset-inline-start: auto;\n    border-width: 3px;\n    border-style: solid;\n}\n\n.k-spreadsheet-cell .k-dirty {\n    inset-inline-start: 0;\n    inset-inline-end: auto;\n}\n\n.k-spreadsheet .k-filter-wrapper {\n    position: relative;\n    z-index: 50;\n}\n\n.k-spreadsheet .k-filter-range {\n    border-width: 2px;\n    border-style: solid;\n    position: absolute;\n    box-sizing: border-box;\n}\n\n.k-spreadsheet-filter {\n    border-radius: 0.375rem;\n    padding: 0.5rem;\n    line-height: 1;\n    position: absolute;\n    cursor: pointer;\n}\n\n.k-spreadsheet-filter .k-icon {\n    vertical-align: middle;\n}\n\n.k-spreadsheet-filter-menu {\n    width: 280px;\n}\n\n.k-spreadsheet-filter-menu .k-animation-container {\n    position: relative;\n}\n\n.k-spreadsheet-filter-menu > .k-menu,\n.k-spreadsheet-filter-menu > .k-menu.k-menu-vertical {\n    border-width: 0;\n}\n\n.k-spreadsheet-filter-menu > .k-menu .k-item,\n.k-spreadsheet-filter-menu > .k-menu.k-menu-vertical .k-item {\n    color: inherit;\n}\n\n.k-spreadsheet-filter-menu > .k-menu .k-link,\n.k-spreadsheet-filter-menu > .k-menu.k-menu-vertical .k-link {\n    padding-left: calc(16px + 1rem);\n}\n\n.k-spreadsheet-filter-menu > .k-menu .k-icon,\n.k-spreadsheet-filter-menu > .k-menu.k-menu-vertical .k-icon {\n    margin-left: calc(-16px + -0.5rem);\n    margin-right: 0.5rem;\n}\n\n.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper {\n    height: 200px;\n    border-width: 1px;\n    border-style: solid;\n    overflow-y: scroll;\n    overflow-x: auto;\n}\n\n.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper .k-treeview {\n    padding: 0.5rem;\n    overflow: visible;\n}\n\n.k-spreadsheet-filter-menu .k-details,\n.k-spreadsheet-filter-menu .k-expander {\n    padding: 0;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: inherit;\n}\n\n.k-spreadsheet-filter-menu .k-expander {\n    border: 0;\n    background: inherit;\n}\n\n.k-spreadsheet-filter-menu .k-details-summary,\n.k-spreadsheet-filter-menu .k-columnmenu-item {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.k-spreadsheet-filter-menu .k-details-summary > .k-icon,\n.k-spreadsheet-filter-menu .k-details-summary > .k-expander-indicator,\n.k-spreadsheet-filter-menu .k-columnmenu-item > .k-icon,\n.k-spreadsheet-filter-menu .k-columnmenu-item > .k-expander-indicator {\n    margin-right: 0.5rem;\n}\n\n.k-spreadsheet-filter-menu .k-details-content,\n.k-spreadsheet-filter-menu .k-columnmenu-item-content {\n    padding: 0.5rem;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0.5rem;\n}\n\n.k-spreadsheet-filter-menu .k-details-content .k-filter-and,\n.k-spreadsheet-filter-menu .k-columnmenu-item-content .k-filter-and {\n    width: min-content;\n    align-self: flex-start;\n}\n\n.k-spreadsheet-filter-menu .k-actions, .k-spreadsheet-filter-menu .k-edit-buttons,\n.k-spreadsheet-filter-menu .k-action-buttons,\n.k-spreadsheet-filter-menu .k-columnmenu-actions, .k-spreadsheet-filter-menu .k-form-buttons {\n    margin: 0;\n    padding: 0;\n}\n\n.k-spreadsheet-popup {\n    padding: 0;\n}\n\n.k-spreadsheet-popup .k-separator {\n    display: block;\n}\n\n.k-spreadsheet-popup .k-reset-color,\n.k-spreadsheet-popup .k-custom-color {\n    border-radius: 0;\n    width: 100%;\n    border-width: 0;\n    box-sizing: border-box;\n    display: flex;\n}\n\n.k-spreadsheet-popup .k-reset-color {\n    border-bottom-width: 1px;\n}\n\n.k-spreadsheet-popup .k-custom-color {\n    border-top-width: 1px;\n}\n\n.k-spreadsheet-popup .k-spreadsheet-border-type-palette {\n    padding: 0.5rem;\n    display: grid;\n    grid-template-columns: repeat(5, max-content);\n    gap: 0.5rem;\n}\n\n.k-spreadsheet-clipboard,\n.k-spreadsheet-clipboard-paste {\n    margin: 0;\n    padding: 0;\n    width: 1px;\n    height: 1px;\n    border: 0;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    overflow: hidden;\n}\n\n.k-spreadsheet-window .k-external-dropzone {\n    margin-block-end: 1rem;\n}\n\n.k-spreadsheet-window .k-edit-form-container {\n    width: auto;\n    min-width: 0;\n}\n\n.k-spreadsheet-format-cells .k-spreadsheet-preview {\n    margin-top: 0.5rem;\n    text-align: center;\n}\n\n.k-spreadsheet-format-cells .k-list-scroller {\n    margin-top: 0.5rem;\n    height: 210px;\n    border-width: 1px;\n    border-style: solid;\n    border-color: inherit;\n}\n\n.k-export-config {\n    clear: both;\n    position: relative;\n}\n\n.k-export-config::after {\n    content: \"\";\n    clear: both;\n    display: block;\n}\n\n.k-export-config .k-edit-field {\n    margin-left: 5%;\n    width: 45%;\n    float: left;\n}\n\n.k-export-config .k-page-orientation {\n    position: absolute;\n    right: 0;\n    top: 0.5rem;\n}\n\n.k-export-config .k-page-orientation .k-font-icon {\n    font-size: 6em;\n}\n\n.k-export-config .k-page-orientation .k-svg-icon {\n    width: 6em;\n    height: 6em;\n}\n\n.k-spreadsheet-insert-comment textarea {\n    height: auto;\n}\n\n.k-spreadsheet-insert-image-dialog {\n    border-radius: 0.375rem;\n    border-style: dashed;\n    border-width: 2px;\n}\n\n.k-spreadsheet-insert-image-dialog label {\n    display: flex;\n    justify-content: center;\n    min-width: 100%;\n    width: 355px;\n    height: 230px;\n    background-image: url(data:image/png;base64,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);\n    background-size: auto 70%;\n    background-position: 50% 30%;\n    background-repeat: no-repeat;\n}\n\n.k-spreadsheet-insert-image-dialog label div {\n    display: flex;\n    align-self: flex-end;\n    margin-bottom: 30px;\n    pointer-events: none;\n}\n\n.k-spreadsheet-insert-image-dialog label input {\n    display: none;\n}\n\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image {\n    background-size: auto 90%;\n    background-position: 50% 50%;\n}\n\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover div,\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-hover div {\n    margin: 0;\n    align-self: center;\n    opacity: 1;\n}\n\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image div {\n    opacity: 0;\n}\n\n.k-spreadsheet-drawing {\n    position: absolute;\n    box-sizing: border-box;\n    z-index: 101;\n}\n\n.k-spreadsheet-drawing.k-spreadsheet-active-drawing {\n    outline-style: solid;\n    outline-width: 2px;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-position: 50% 50%;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    cursor: move;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle {\n    width: 6px;\n    height: 6px;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 0.5rem;\n    position: absolute;\n    transform: translate(-50%, -50%);\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.N {\n    left: 50%;\n    top: 0;\n    cursor: ns-resize;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.NE {\n    left: 100%;\n    top: 0;\n    cursor: nesw-resize;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.E {\n    left: 100%;\n    top: 50%;\n    cursor: ew-resize;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.SE {\n    left: 100%;\n    top: 100%;\n    cursor: nwse-resize;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.S {\n    left: 50%;\n    top: 100%;\n    cursor: ns-resize;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.SW {\n    left: 0;\n    top: 100%;\n    cursor: nesw-resize;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.W {\n    left: 0;\n    top: 50%;\n    cursor: ew-resize;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle.NW {\n    left: 0;\n    top: 0;\n    cursor: nwse-resize;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover, .k-spreadsheet-drawing .k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-hover {\n    border-radius: 0.375rem;\n}\n\n.k-spreadsheet-legacy .k-spreadsheet,\n.k-spreadsheet-legacy .k-spreadsheet-action-bar,\n.k-spreadsheet-legacy .k-spreadsheet-view {\n    font-size: 12px;\n}\n\n.k-spreadsheet-legacy .k-spreadsheet-cell {\n    padding: 1px;\n}\n\n.k-spreadsheet-legacy .k-spreadsheet-filter {\n    padding: 0px;\n}\n\n.k-spreadsheet-legacy .k-filter-range {\n    border-width: 1px;\n}\n\n.k-spreadsheet-legacy .k-spreadsheet .k-spreadsheet-selection-highlight {\n    border-width: 1px;\n    border-style: solid;\n}\n\n.k-spreadsheet .k-tabstrip-wrapper {\n    border-width: 0 0 1px;\n    border-style: solid;\n    border-color: inherit;\n    position: relative;\n}\n\n.k-spreadsheet-quick-access-toolbar {\n    padding: 0.5rem;\n    display: inline-flex;\n    flex-direction: row;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    left: 0;\n}\n\n.k-spreadsheet-tabstrip {\n    padding-top: 0.5rem;\n    position: relative;\n    z-index: 1;\n}\n\n.k-spreadsheet-tabstrip .k-tabstrip-items-wrapper {\n    margin: 0;\n}\n\n.k-spreadsheet-tabstrip .k-loading {\n    display: none;\n}\n\n.k-spreadsheet-tabstrip .k-content,\n.k-spreadsheet-tabstrip .k-tabstrip-content {\n    border-radius: 0;\n    padding: 0;\n    border-width: 0;\n    overflow: hidden;\n}\n\n.k-spreadsheet-menu {\n    padding-inline: 0.5rem;\n}\n\n.k-spreadsheet-filter-menu > .k-menu,\n.k-spreadsheet-filter-menu > .k-menu:not(.k-context-menu) {\n    background: none;\n    color: inherit;\n    font-weight: inherit;\n    font-size: inherit;\n}\n\n.k-spreadsheet-filter {\n    padding: 0.25rem;\n}\n\n.k-spreadsheet {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-spreadsheet-header {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-spreadsheet-top-corner,\n.k-spreadsheet-row-header,\n.k-spreadsheet-column-header {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-spreadsheet-cell-editor {\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-spreadsheet-merged-cell {\n    background-color: #ffffff;\n}\n\n.k-spreadsheet-disabled-mask {\n    background-color: #ffffff;\n}\n\n.k-spreadsheet .k-selection-full,\n.k-spreadsheet .k-selection-partial {\n    background-color: rgba(13, 110, 253, 0.25);\n}\n\n.k-spreadsheet-selection {\n    border-color: #0d6efd;\n    background-color: rgba(13, 110, 253, 0.25);\n    box-shadow: inset 0 0 0 1px #0d6efd;\n}\n\n.k-spreadsheet-selection-highlight {\n    border-color: #0d6efd;\n}\n\n.k-spreadsheet .k-single-selection::after {\n    border-color: #ffffff;\n    background-color: #0d6efd;\n}\n\n.k-spreadsheet-active-cell {\n    background-color: #ffffff;\n    box-shadow: inset 0 0 0 1px #0d6efd;\n}\n\n.k-spreadsheet .k-auto-fill {\n    border-color: #0d6efd;\n    background-color: rgba(13, 110, 253, 0.25);\n    box-shadow: inset 0 0 0 1px #0d6efd;\n}\n\n.k-spreadsheet .k-auto-fill-punch {\n    background-color: rgba(255, 255, 255, 0.5);\n}\n\n.k-spreadsheet .k-resize-handle,\n.k-spreadsheet .k-resize-hint-handle,\n.k-spreadsheet .k-resize-hint-marker {\n    background-color: #0d6efd;\n}\n\n.k-spreadsheet-has-comment::after {\n    border-block-color: #0d6efd transparent;\n    border-inline-color: transparent #0d6efd;\n}\n\n.k-spreadsheet-cell .k-dirty {\n    border-block-color: #dc3545 transparent;\n    border-inline-color: #dc3545 transparent;\n}\n\n.k-spreadsheet .k-filter-range {\n    border-color: #0d6efd;\n}\n\n.k-spreadsheet-filter {\n    border-color: #e4e7eb;\n    color: #212529;\n    background-color: #e4e7eb;\n    box-shadow: inset 0 0 0 1px #e4e7eb;\n}\n\n.k-spreadsheet-filter:hover {\n    border-color: #c7cdd5;\n    background-color: #ced3db;\n}\n\n.k-spreadsheet-filter.k-active {\n    border-color: #bfc6d0;\n    background-color: #c7cdd5;\n}\n\n.k-spreadsheet-filter-menu > .k-menu .k-item:hover,\n.k-spreadsheet-filter-menu > .k-menu .k-item.k-hover,\n.k-spreadsheet-filter-menu > .k-menu:not(.k-context-menu) .k-item:hover,\n.k-spreadsheet-filter-menu > .k-menu:not(.k-context-menu) .k-item.k-hover {\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-spreadsheet-filter-menu .k-spreadsheet-value-treeview-wrapper {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-spreadsheet-insert-image-dialog {\n    border-color: #dee2e6;\n}\n\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover, .k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-hover {\n    box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.5);\n}\n\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image:hover div,\n.k-spreadsheet-insert-image-dialog .k-spreadsheet-has-image.k-hover div {\n    color: #ffffff;\n}\n\n.k-spreadsheet-drawing.k-spreadsheet-active-drawing {\n    outline-color: #0d6efd;\n}\n\n.k-spreadsheet-drawing .k-spreadsheet-drawing-handle {\n    border-color: #0d6efd;\n    background-color: #0d6efd;\n}\n\n.k-spreadsheet-drawing-anchor-cell {\n    background: rgba(13, 110, 253, 0.25);\n}\n\n.k-syntax-ref {\n    color: #ff8822;\n}\n\n.k-syntax-num {\n    color: #0099ff;\n}\n\n.k-syntax-str {\n    color: #38b714;\n}\n\n.k-syntax-error {\n    color: red;\n}\n\n.k-syntax-bool {\n    color: #a9169c;\n}\n\n.k-syntax-paren-match {\n    background-color: #caf200;\n}\n\n.k-pivotgrid {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: content-box;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    text-align: start;\n    vertical-align: top;\n    display: grid;\n    grid-template-columns: 300px auto;\n    grid-template-rows: 75px auto;\n    position: relative;\n}\n\n.k-pivotgrid table {\n    margin: 0;\n    width: 100%;\n    max-width: none;\n    border-width: 0;\n    border-color: inherit;\n    border-collapse: separate;\n    border-spacing: 0;\n    outline: 0;\n    text-align: inherit;\n    empty-cells: show;\n}\n\n.k-pivotgrid thead,\n.k-pivotgrid tbody,\n.k-pivotgrid th,\n.k-pivotgrid tr,\n.k-pivotgrid td {\n    border-color: inherit;\n    text-align: inherit;\n}\n\n.k-pivotgrid-table {\n    table-layout: fixed;\n}\n\n.k-pivotgrid-table th {\n    font-weight: 400;\n    text-transform: initial;\n}\n\n.k-pivotgrid-table .k-pivotgrid-header-root {\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.k-pivotgrid-empty-cell {\n    border-right-style: solid;\n    border-right-width: 1px;\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\n.k-pivotgrid-empty-cell:focus {\n    outline: none;\n}\n\n.k-pivotgrid-column-headers {\n    overflow: hidden;\n}\n\n.k-pivotgrid-column-headers .k-pivotgrid-table {\n    padding-inline-start: 0;\n    padding-inline-end: var(--kendo-scrollbar-width, 17px);\n}\n\n.k-pivotgrid-column-headers .k-pivotgrid-cell {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    border-left-style: solid;\n    border-left-width: 1px;\n}\n\n.k-pivotgrid-column-headers .k-pivotgrid-cell:first-child {\n    border-left-width: 0;\n}\n\n.k-pivotgrid-column-headers .k-pivotgrid-cell.k-first {\n    border-left-width: 1px;\n}\n\n.k-pivotgrid-row-headers {\n    overflow: hidden;\n}\n\n.k-pivotgrid-row-headers .k-pivotgrid-table {\n    padding-bottom: var(--kendo-scrollbar-width, 17px);\n}\n\n.k-pivotgrid-row-headers .k-pivotgrid-cell {\n    border-right-style: solid;\n    border-right-width: 1px;\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    white-space: nowrap;\n}\n\n.k-pivotgrid-values {\n    border-color: inherit;\n    overflow: scroll;\n}\n\n.k-pivotgrid-values .k-pivotgrid-cell {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    border-left-style: solid;\n    border-left-width: 1px;\n}\n\n.k-pivotgrid-values .k-pivotgrid-cell:first-child {\n    border-left-width: 0;\n}\n\n.k-pivotgrid-cell {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: top;\n    overflow: hidden;\n}\n\n.k-pivotgrid-cell:focus {\n    outline: none;\n}\n\n.k-pivotgrid-cell .k-icon {\n    cursor: pointer;\n    padding-inline-end: 4px;\n}\n\n.k-pivotgrid-total {\n    font-weight: 600;\n}\n\n.k-column-menu .k-treeview {\n    padding-block: 0px;\n    padding-inline: 1.5rem;\n    overflow: auto;\n}\n\n.k-pivotgrid-configurator {\n    display: flex;\n}\n\n.k-pivotgrid-configurator-panel {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    z-index: 2;\n}\n\n.k-pivotgrid-configurator-button {\n    padding-block: 0.25rem;\n    padding-inline: 0.25rem;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    cursor: pointer;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-flex-row .k-pivotgrid-configurator-button, .k-d-flex-row .k-pivotgrid-configurator-button,\n.k-flex-row-reverse .k-pivotgrid-configurator-button {\n    display: flex;\n    align-items: center;\n}\n\n.k-flex-row .k-pivotgrid-configurator-button span, .k-d-flex-row .k-pivotgrid-configurator-button span,\n.k-flex-row-reverse .k-pivotgrid-configurator-button span {\n    -ms-writing-mode: tb-rl;\n        writing-mode: vertical-rl;\n}\n\n.k-flex-row .k-pivotgrid-configurator-button .k-icon, .k-d-flex-row .k-pivotgrid-configurator-button .k-icon,\n.k-flex-row-reverse .k-pivotgrid-configurator-button .k-icon {\n    vertical-align: baseline;\n}\n\n.k-flex-row-reverse .k-pivotgrid-configurator-button > span {\n    transform: rotate(-180deg);\n}\n\n.k-flex-col .k-pivotgrid-configurator-button, .k-d-flex-col .k-pivotgrid-configurator-button, .k-flex-column .k-pivotgrid-configurator-button,\n.k-flex-col-reverse .k-pivotgrid-configurator-button,\n.k-flex-column-reverse .k-pivotgrid-configurator-button {\n    text-align: center;\n}\n\n.k-pivotgrid-configurator-overlay {\n    position: absolute;\n    overflow: hidden;\n    z-index: 2;\n}\n\n.k-flex-row .k-pivotgrid-configurator-overlay, .k-d-flex-row .k-pivotgrid-configurator-overlay {\n    right: calc(1.5em + 0.5rem + 2px);\n}\n\n.k-flex-row-reverse .k-pivotgrid-configurator-overlay {\n    left: calc(1.5em + 0.5rem + 2px);\n}\n\n.k-flex-col .k-pivotgrid-configurator-overlay, .k-d-flex-col .k-pivotgrid-configurator-overlay, .k-flex-column .k-pivotgrid-configurator-overlay {\n    bottom: calc(1.5em + 0.5rem + 2px);\n}\n\n.k-flex-col-reverse .k-pivotgrid-configurator-overlay, .k-flex-column-reverse .k-pivotgrid-configurator-overlay {\n    top: calc(1.5em + 0.5rem + 2px);\n}\n\n.k-pivotgrid-configurator-header {\n    padding-block: 0.75rem;\n    padding-inline: 1rem;\n    font-size: 18px;\n    font-weight: 500;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.k-pivotgrid-configurator-header-text {\n    word-break: normal;\n    overflow-wrap: anywhere;\n}\n\n.k-pivotgrid-configurator-content {\n    padding-block: 0.25rem;\n    padding-inline: 1rem;\n    flex: 1 1 auto;\n    overflow: auto;\n}\n\n.k-pivotgrid-configurator-content .k-form .k-label {\n    font-size: 16px;\n    font-weight: 500;\n    align-items: flex-start;\n}\n\n.k-pivotgrid-configurator-content .k-form .k-dropdown-list, .k-pivotgrid-configurator-content .k-form .k-dropdown,\n.k-pivotgrid-configurator-content .k-form .k-dropdownlist {\n    max-width: 90px;\n}\n\n.k-pivotgrid-configurator-content .k-form .k-textbox {\n    flex-basis: 50%;\n}\n\n.k-pivotgrid-configurator-content .k-row-fields,\n.k-pivotgrid-configurator-content .k-column-fields,\n.k-pivotgrid-configurator-content .k-filter-fields {\n    margin-top: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.k-pivotgrid-configurator-content .k-value-fields {\n    margin-block: 0.5rem;\n    margin-inline: 0px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.k-pivotgrid-configurator-content .k-select-all .k-checkbox {\n    margin-inline-end: 0.25rem;\n}\n\n.k-pivotgrid-configurator-content .k-fields-list-wrapper {\n    max-height: 200px;\n    border-width: 1px;\n    border-style: solid;\n    flex: 1 1 auto;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.k-pivotgrid-configurator-content .k-settings-description {\n    margin-top: 1rem;\n    text-align: center;\n}\n\n.k-pivotgrid-configurator-content .k-treeview {\n    padding-block: 0px;\n    padding-inline: 1.5rem;\n    overflow: auto;\n}\n\n.k-calculated-field {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-width: 1px;\n    border-radius: 0.375rem;\n    border-style: solid;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.k-calculated-field-header {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.k-calculated-field-header .k-textbox {\n    min-width: 200px;\n}\n\n.k-calculated-field-header-text {\n    margin-right: 5px;\n    word-break: normal;\n    overflow-wrap: anywhere;\n}\n\n.k-calculated-field-header-actions {\n    flex-shrink: 0;\n    align-self: flex-start;\n}\n\n.k-calculated-field-content .k-textbox {\n    width: 100%;\n}\n\n.k-calculated-field-actions {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.k-calculated-field-actions .k-icon {\n    margin-right: 0.5rem;\n}\n\n.k-calculated-field-actions .k-dropdown-list, .k-calculated-field-actions .k-dropdown,\n.k-calculated-field-actions .k-dropdownlist {\n    max-width: 100px;\n}\n\n.k-filter-menu .k-calculated-item {\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n}\n\n.k-pivotgrid-configurator-vertical {\n    min-width: 320px;\n}\n\n.k-flex-row .k-pivotgrid-configurator-vertical.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel, .k-d-flex-row .k-pivotgrid-configurator-vertical.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel,\n.k-flex-row-reverse .k-pivotgrid-configurator-vertical.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel {\n    border-right-width: 0;\n    border-left-width: 0;\n}\n\n.k-pivotgrid-configurator-horizontal {\n    width: 100%;\n    height: 420px;\n}\n\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form {\n    display: flex;\n    flex-direction: row;\n}\n\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper {\n    padding-left: 1rem;\n}\n\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper > *:first-child {\n    margin-top: 0;\n}\n\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper:first-child {\n    padding-left: 0;\n    flex: 1 1 30%;\n}\n\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper:nth-child(2) {\n    flex: 1 1 30%;\n}\n\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-form-field-wrapper:last-child {\n    border-left-width: 1px;\n    border-left-style: solid;\n    flex: 1 1 40%;\n}\n\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-row-fields,\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-column-fields,\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-filter-fields {\n    max-height: 100px;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.k-pivotgrid-configurator-horizontal .k-pivotgrid-configurator-content .k-value-fields {\n    max-height: 250px;\n    flex-flow: row wrap;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.k-flex-col .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel, .k-d-flex-col .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel, .k-flex-column .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel,\n.k-flex-col-reverse .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel,\n.k-flex-column-reverse .k-pivotgrid-configurator-horizontal.k-pivotgrid-configurator-push .k-pivotgrid-configurator-panel {\n    border-top-width: 0;\n    border-bottom-width: 0;\n}\n\n.k-pdf-export-shadow .k-pivotgrid {\n    height: auto !important;\n}\n\n.k-pdf-export-shadow .k-pivotgrid-values {\n    height: auto;\n    overflow: visible;\n}\n\n.k-pdf-export-shadow .k-pivotgrid-column-headers .k-pivotgrid-table {\n    padding-inline-end: 0;\n}\n\n.k-pivot {\n    border-width: 1px;\n    border-style: solid;\n    position: relative;\n}\n\n.k-pivot .k-grid td {\n    white-space: nowrap;\n}\n\n.k-pivot .k-grid-content {\n    flex: 1 1 auto;\n}\n\n.k-pivot-toolbar {\n    border-width: 0 0 1px;\n    border-style: solid;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    box-shadow: none;\n}\n\n.k-pivot-toolbar > * {\n    max-width: 100%;\n}\n\n.k-pivot-toolbar::before {\n    display: none;\n}\n\n.k-pivot-layout {\n    border-spacing: 0;\n    table-layout: auto;\n}\n\n.k-pivot-layout .k-grid-footer,\n.k-pivot-layout .k-grid .k-table-alt-row {\n    font-weight: bold;\n}\n\n.k-pivot-layout > tbody,\n.k-pivot .k-table-td,\n.k-pivot td {\n    vertical-align: top;\n}\n\n.k-pivot-layout > tbody > tr > td {\n    padding: 0;\n}\n\n.k-pivot-rowheaders > .k-grid,\n.k-pivot-table > .k-grid {\n    border-width: 0;\n    color: inherit;\n    background: none;\n}\n\n.k-pivot-rowheaders > .k-grid td:first-child,\n.k-pivot-table .k-grid-header .k-header.k-first {\n    border-left-width: 1px;\n}\n\n.k-pivot-rowheaders > .k-grid td.k-first {\n    border-left-width: 0;\n}\n\n.k-pivot-rowheaders > .k-grid {\n    overflow: hidden;\n}\n\n.k-pivot-table {\n    border-left-width: 1px;\n    border-left-style: solid;\n}\n\n.k-pivot-table .k-grid-header-wrap {\n    margin-right: -1px;\n}\n\n.k-pivot-table .k-grid-header-wrap > table {\n    height: 100%;\n}\n\n.k-pivot .k-grid-header .k-header {\n    vertical-align: top;\n}\n\n.k-pivot .k-grid tr .k-grid-footer {\n    border-bottom-width: 0;\n}\n\n.k-pivot .k-grid tr:last-child:not(.k-grid-footer) td:not(.k-grid-footer) {\n    border-bottom-width: 1px;\n}\n\n.k-pivot-layout .k-grid td {\n    border-bottom-width: 1px;\n}\n\n.k-pivot-layout .k-grid-footer > td {\n    border-top-width: 0;\n}\n\n.k-pivot-filter-window .k-treeview {\n    max-height: 600px;\n}\n\n.k-pivotgrid-wrapper {\n    box-sizing: border-box;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: flex-start;\n    gap: 0.5rem;\n}\n\n.k-pivotgrid-wrapper > .k-pivotgrid-configurator-panel {\n    max-width: 320px;\n    flex: none;\n}\n\n.k-pivotgrid-wrapper > .k-pivot {\n    flex: 1;\n}\n\n.k-pivotgrid-configurator-panel.kendo-jquery {\n    box-sizing: border-box;\n    display: inline-flex;\n}\n\n.k-pivotgrid-configurator-panel.kendo-jquery .k-pivotgrid-configurator {\n    height: 100%;\n}\n\n.k-pivotgrid-configurator-panel.kendo-jquery .k-pivotgrid-configurator-content {\n    padding: 1rem;\n    max-height: 100%;\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 1rem;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.k-pivotgrid-configurator-panel.kendo-jquery .k-pivotgrid-targets {\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 1rem;\n}\n\n.k-pivotgrid-configurator-panel.kendo-jquery .k-pivotgrid-configurator-section {\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0.5rem;\n}\n\n.k-pivotgrid-configurator-panel.kendo-jquery .k-column-fields {\n    margin: 0;\n    padding: 0.25rem;\n    max-height: 200px;\n    border-width: 1px;\n    border-style: solid;\n    display: flex;\n    flex-flow: row wrap;\n    gap: 0.25rem;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.k-pivotgrid-configurator-panel.kendo-jquery .k-column-fields > * {\n    margin: 0;\n}\n\n.k-pivotgrid-toggle {\n    margin-block: -0.25rem;\n    padding: 0.25rem;\n    box-sizing: content-box;\n    cursor: pointer;\n}\n\n.k-pivotgrid {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-pivotgrid-column-headers,\n.k-pivotgrid-row-headers,\n.k-pivotgrid-empty-cell {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-pivotgrid-empty-cell {\n    border-color: #babec1;\n}\n\n.k-pivotgrid-row-headers .k-pivotgrid-row .k-pivotgrid-cell:last-child {\n    border-right-color: #babec1;\n}\n\n.k-pivotgrid-column-headers .k-pivotgrid-column-total:nth-last-of-type(2) .k-pivotgrid-cell:not(.k-pivotgrid-expanded),\n.k-pivotgrid-column-headers .k-pivotgrid-row:last-child {\n    border-bottom-color: #babec1;\n}\n\n.k-pivotgrid-header-total,\n.k-pivotgrid-total {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ebebeb;\n}\n\n.k-pivotgrid-row-headers tbody > .k-pivotgrid-row:hover,\n.k-pivotgrid-row-headers tbody > .k-pivotgrid-row.k-hover,\n.k-pivotgrid-column-headers tbody > .k-pivotgrid-row:hover,\n.k-pivotgrid-column-headers tbody > .k-pivotgrid-row.k-hover,\n.k-pivotgrid-values tbody > .k-pivotgrid-row:hover,\n.k-pivotgrid-values tbody > .k-pivotgrid-row.k-hover {\n    background-color: #ededed;\n}\n\n.k-pivotgrid-cell:focus,\n.k-pivotgrid-cell.k-focus,\n.k-pivotgrid-empty-cell:focus,\n.k-pivotgrid-empty-cell.k-focus,\n.k-master-row > .k-pivotgrid-cell:focus,\n.k-grouping-row > .k-pivotgrid-cell:focus,\n.k-detail-row > .k-pivotgrid-cell:focus,\n.k-group-footer > .k-pivotgrid-cell:focus {\n    box-shadow: inset 0 0 0 3px rgba(33, 37, 41, 0.15);\n}\n\n.k-pivotgrid-cell.k-selected,\n.k-pivotgrid-row.k-selected > .k-pivotgrid-cell {\n    background-color: rgba(13, 110, 253, 0.25);\n}\n\n.k-pivotgrid-configurator-button,\n.k-pivotgrid-configurator-panel {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-pivotgrid-configurator-header {\n    color: #212529;\n}\n\n.k-pivotgrid-configurator-content .k-fields-list-wrapper {\n    border-color: #dee2e6;\n}\n\n.k-calculated-field {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-calculated-field-header {\n    color: #212529;\n}\n\n.k-filter-menu .k-calculated-item {\n    border-color: #dee2e6;\n}\n\n.k-pivotgrid-configurator-content .k-form-field-wrapper {\n    border-color: #dee2e6;\n}\n\n.k-flex-row .k-pivotgrid-configurator-overlay, .k-d-flex-row .k-pivotgrid-configurator-overlay {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-flex-row-reverse .k-pivotgrid-configurator-overlay {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-flex-col .k-pivotgrid-configurator-overlay, .k-d-flex-col .k-pivotgrid-configurator-overlay, .k-flex-column .k-pivotgrid-configurator-overlay {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-flex-col-reverse .k-pivotgrid-configurator-overlay, .k-flex-column-reverse .k-pivotgrid-configurator-overlay {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-pivot {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-pivot-table {\n    border-color: #dee2e6;\n}\n\n.k-pivot-rowheaders {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-pivot-toolbar {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-pivot-toolbar .k-empty {\n    color: #6c757d;\n}\n\n.k-pivot .k-alt {\n    background-color: #f8f9fa;\n}\n\n.k-pivot-toolbar,\n.k-pivot-table,\n.k-pivot-rowheaders > .k-grid td:first-child,\n.k-pivot-table .k-grid-header .k-header.k-first {\n    border-color: #dee2e6;\n}\n\n.k-header.k-alt {\n    background-color: #eeeff0;\n}\n\n.k-pivot-layout .k-grid-footer {\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-i-kpi-trend-increase,\n.k-i-kpi-trend-decrease,\n.k-i-kpi-trend-equal {\n    color: inherit;\n}\n\n.k-i-kpi-status-hold {\n    color: #ffc107;\n}\n\n.k-i-kpi-status-deny {\n    color: #dc3545;\n}\n\n.k-i-kpi-status-open {\n    color: #198754;\n}\n\n.k-pivotgrid-configurator-panel.kendo-jquery .k-column-fields {\n    border-color: #dee2e6;\n}\n\n.k-treelist.k-grid-display-block.k-grid-lockedcolumns {\n    display: block;\n}\n\n.k-treelist .k-status {\n    padding-block: .4em;\n    padding-inline: .6em;\n    line-height: 1.6em;\n}\n\n.k-treelist .k-status .k-loading {\n    vertical-align: baseline;\n    margin-right: 5px;\n    display: none;\n}\n\n.k-treelist tr.k-hidden {\n    display: none;\n}\n\n.k-treelist .k-treelist-dragging,\n.k-treelist .k-treelist-dragging .k-hover {\n    cursor: default;\n}\n\n.k-treelist .k-drop-hint {\n    transform: translate(0, -50%);\n}\n\n.k-treelist .k-table-row.k-footer td,\n.k-treelist .k-table-row.k-footer-template td,\n.k-treelist .k-table-row.k-footer .k-table-td,\n.k-treelist .k-table-row.k-footer-template .k-table-td {\n    border-width: 1px 0;\n    border-style: solid;\n    font-weight: bold;\n}\n\n.k-treelist .k-table-row.k-footer + .k-table-row.k-footer td,\n.k-treelist .k-table-row.k-footer + .k-table-row.k-footer .k-table-td {\n    border-top-width: 0;\n}\n\n.k-treelist-scrollable > .k-table,\n.k-treelist-scrollable .k-grid-header .k-table-row,\n.k-treelist-scrollable .k-grid-header .k-table-th {\n    background-color: inherit;\n}\n\n.k-treelist-scrollable .k-grid-toolbar {\n    position: sticky;\n    z-index: 3;\n    top: 0;\n    left: 0;\n}\n\n.k-treelist-scrollable .k-grid-header .k-table-th {\n    position: sticky;\n    z-index: 1;\n}\n\n.k-treelist-scrollable .k-grid-header .k-table-th.k-grid-header-sticky {\n    z-index: 3;\n}\n\n.k-treelist-scrollable thead.k-grid-header {\n    padding-right: 0;\n}\n\n.k-treelist-scrollable .k-table-row.k-group-footer + .k-table-row.k-group-footer td {\n    border-top-width: 0;\n}\n\n.k-treelist-scrollable[dir=\"rtl\"] thead.k-grid-header,\n.k-rtl .k-treelist-scrollable thead.k-grid-header {\n    padding-left: 0;\n}\n\n.k-drag-separator {\n    display: inline-block;\n    border-right: 1px solid;\n    height: 1em;\n    vertical-align: top;\n    margin-block: 0;\n    margin-inline: .5em;\n}\n\n.k-treelist-toggle {\n    margin-block: -0.25rem;\n    padding: 0.25rem;\n    box-sizing: content-box;\n    cursor: pointer;\n}\n\n.k-treelist tr.k-footer td,\n.k-treelist tr.k-footer-template td {\n    font-weight: normal;\n}\n\n.k-treelist-scrollable .k-group-footer td {\n    font-weight: normal;\n}\n\n.k-treelist tr.k-footer,\n.k-treelist tr.k-footer-template {\n    background-color: #f8f9fa;\n}\n\n.k-treelist tr.k-footer:hover,\n.k-treelist tr.k-footer-template:hover {\n    background-color: #f8f9fa;\n}\n\n.k-treelist-scrollable .k-group-footer td,\n.k-treelist-scrollable .k-grouping-row td,\n.k-treelist-scrollable tbody .k-group-cell {\n    background-color: #f8f9fa;\n}\n\n.k-filter {\n    box-sizing: border-box;\n    border-width: 0;\n    display: inline-block;\n    background-color: transparent;\n}\n\n.k-filter *,\n.k-filter *::before,\n.k-filter *::after {\n    box-sizing: border-box;\n}\n\n.k-filter ul {\n    padding: 0;\n}\n\n.k-filter ul li {\n    list-style-type: none;\n}\n\n.k-filter .k-filter-container,\n.k-filter .k-filter-preview {\n    margin-block-end: 2.1em;\n}\n\n.k-filter .k-filter-lines,\n.k-filter .k-filter-item {\n    padding-inline-start: 1rem;\n}\n\n.k-filter .k-filter-toolbar {\n    display: inline-flex;\n    position: relative;\n    padding-block: 0.5rem;\n    padding-inline: 0;\n}\n\n.k-filter .k-filter-toolbar::before {\n    content: \"\";\n    position: absolute;\n    width: 1rem;\n    height: 1px;\n    inset-block-start: 50%;\n    inset-inline-start: -1rem;\n}\n\n.k-filter .k-filter-toolbar .k-toolbar {\n    border-style: solid;\n}\n\n.k-filter .k-filter-operator .k-dropdown-list, .k-filter .k-filter-operator .k-dropdown,\n.k-filter .k-filter-operator .k-dropdownlist {\n    width: 15em;\n}\n\n.k-filter .k-filter-item {\n    position: relative;\n}\n\n.k-filter .k-filter-item::before {\n    content: \"\";\n    position: absolute;\n    width: 1px;\n    height: 100%;\n    inset-block-start: -0.5rem;\n    inset-inline-start: 0;\n}\n\n.k-filter .k-filter-lines .k-filter-item:last-child > .k-filter-toolbar::after,\n.k-filter .k-filter-lines .k-filter-item:last-child > * > .k-filter-toolbar::after {\n    content: \"\";\n    position: absolute;\n    width: 1px;\n    inset-block-start: calc(-0.5rem - 1px);\n    inset-block-end: 50%;\n    inset-inline-start: -1rem;\n}\n\n.k-filter .k-filter-group-main::before,\n.k-filter .k-filter-group-main > .k-filter-toolbar::before,\n.k-filter .k-filter-group-main > .k-filter-toolbar::after,\n.k-filter .k-filter-group-main > * > .k-filter-toolbar::before,\n.k-filter .k-filter-group-main > * > .k-filter-toolbar::after,\n.k-filter .k-filter-lines .k-filter-item:last-child::before {\n    display: none;\n}\n\n.k-filter {\n    color: #212529;\n}\n\n.k-filter .k-filter-preview-field {\n    color: #0d6efd;\n}\n\n.k-filter .k-filter-preview-operator {\n    color: #6c757d;\n}\n\n.k-filter .k-filter-item::before,\n.k-filter .k-filter-toolbar::before,\n.k-filter .k-filter-lines .k-filter-item:last-child > .k-filter-toolbar::after,\n.k-filter .k-filter-lines .k-filter-item:last-child > * > .k-filter-toolbar::after {\n    background-color: #dee2e6;\n}\n\n.k-filter .k-toolbar:focus,\n.k-filter .k-toolbar.k-focus {\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.k-filemanager {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-flow: column nowrap;\n}\n\n.k-filemanager-header {\n    border-color: inherit;\n}\n\n.k-filemanager-toolbar {\n    border-width: 0;\n    border-bottom-width: 1px;\n    border-color: inherit;\n    flex-shrink: 0;\n    z-index: 1;\n}\n\n.k-filemanager-content-container {\n    border-color: inherit;\n    box-sizing: border-box;\n    flex: 1 1 0%;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: stretch;\n    overflow: hidden;\n}\n\n.k-filemanager-splitter {\n    border-width: 0;\n}\n\n.k-filemanager-navigation {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    width: 20%;\n    border-width: 0;\n    border-right-width: 1px;\n    border-style: solid;\n    border-color: inherit;\n    box-sizing: border-box;\n    flex-shrink: 0;\n    overflow: auto;\n}\n\n.k-filemanager-treeview {\n    overflow: visible;\n}\n\n.k-filemanager-content {\n    border-color: inherit;\n    flex: 1 1 0%;\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: stretch;\n    overflow: hidden;\n}\n\n.k-filemanager-view {\n    overflow: auto;\n}\n\n.k-filemanager-breadcrumb {\n    border-width: 0;\n    border-bottom-width: 1px;\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    flex-shrink: 0;\n}\n\n.k-filemanager-listview {\n    border-width: 0;\n    flex: 1 1 0%;\n}\n\n.k-filemanager-listview .k-listview-item {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    width: 120px;\n    height: 120px;\n    text-align: center;\n}\n\n.k-filemanager-listview .k-file-preview {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.k-filemanager-listview .k-file-name {\n    margin-top: 0.5rem;\n    display: block;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.k-filemanager-listview .k-file-edit-input input {\n    width: 100%;\n}\n\n.k-filemanager-grid {\n    border-width: 0;\n    flex: 1 1 0%;\n}\n\n.k-filemanager-grid .k-file-preview {\n    margin-right: 0.5rem;\n    display: inline-flex;\n    flex-direction: row;\n    vertical-align: middle;\n}\n\n.k-filemanager-grid .k-file-name {\n    display: inline-flex;\n    flex-direction: row;\n    vertical-align: middle;\n}\n\n.k-filemanager-preview {\n    padding: 3rem 1rem 1rem;\n    width: 20%;\n    min-height: calc(7rem + 96px);\n    border-width: 0;\n    border-left-width: 1px;\n    border-style: solid;\n    border-color: inherit;\n    box-sizing: border-box;\n    text-align: center;\n    overflow-y: auto;\n    flex-shrink: 0;\n}\n\n.k-filemanager-preview .k-file-preview {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.k-filemanager-preview .k-file-name {\n    margin-top: 1rem;\n    display: block;\n}\n\n.k-filemanager-preview .k-single-file-selected {\n    font-weight: bold;\n}\n\n.k-filemanager-preview .k-multiple-files-selected {\n    font-weight: bold;\n}\n\n.k-filemanager-preview .k-file-meta {\n    margin: 1rem 0 0;\n    box-sizing: border-box;\n    text-align: start;\n    display: flex;\n    flex-flow: row wrap;\n    grid-column-gap: 0.25rem;\n}\n\n.k-filemanager-preview .k-file-meta-label {\n    display: inline-block;\n}\n\n.k-filemanager-preview .k-file-meta-value {\n    margin: 0;\n}\n\n.k-filemanager-preview .k-file-type {\n    text-transform: capitalize;\n}\n\n.k-filemanager-preview .k-line-break {\n    margin: 1rem 0 0;\n    width: 100%;\n    flex: 1 1 100%;\n    flex-flow: row nowrap;\n}\n\n.k-filemanager .k-splitbar {\n    flex-shrink: 0;\n    display: inline-flex;\n    position: relative;\n    border-width: 0 1px;\n    border-style: solid;\n    border-color: inherit;\n}\n\n.k-filemanager-upload-dialog .k-upload-files {\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.k-filemanager-drag-hint {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.k-filemanager {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-filemanager-breadcrumb {\n    background-color: #f8f9fa;\n}\n\n.k-filemanager-listview .k-listview-item .k-file-icon {\n    color: #686b6d;\n}\n\n.k-filemanager-listview .k-listview-item.k-selected .k-file-icon {\n    border-color: transparent;\n    color: inherit;\n    background-color: transparent;\n}\n\n.k-filemanager-preview .k-file-icon {\n    color: #686b6d;\n}\n\n.k-taskboard {\n    box-sizing: border-box;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.k-taskboard *,\n.k-taskboard *::before,\n.k-taskboard *::after {\n    box-sizing: border-box;\n}\n\n.k-taskboard-toolbar {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    border-width: 0;\n    box-shadow: none;\n    background: none;\n}\n\n.k-taskboard-content {\n    padding: 0 1rem 1rem;\n    display: flex;\n    position: relative;\n    flex: 1 1 auto;\n    overflow-x: auto;\n}\n\n.k-taskboard-columns-container {\n    outline: none;\n    display: flex;\n    flex-direction: row;\n    overflow: hidden;\n    gap: 1rem;\n    overflow-x: visible;\n}\n\n.k-taskboard-column {\n    width: 320px;\n    border-width: 1px;\n    border-radius: 0.25rem;\n    border-style: solid;\n    outline: none;\n    display: flex;\n    flex-direction: column;\n    flex-shrink: 0;\n    overflow: hidden;\n}\n\n.k-taskboard-column-header {\n    padding-block: 0.75rem;\n    padding-inline: 0.75rem;\n    font-weight: 500;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.k-taskboard-column-header-actions {\n    display: inline-flex;\n    flex-shrink: 0;\n    align-self: flex-start;\n    gap: 0.5rem;\n}\n\n.k-taskboard-column-cards-container {\n    margin-bottom: 0.75rem;\n    padding-block: 0px;\n    padding-inline: 0.75rem;\n    outline: none;\n    overflow: auto;\n    flex: 1 1 auto;\n}\n\n.k-taskboard-column-cards {\n    padding-block: 0.25rem;\n    padding-inline: 0px;\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem 0;\n}\n\n.k-taskboard-column-new .k-taskboard-column-header,\n.k-taskboard-column-edit .k-taskboard-column-header {\n    font-weight: inherit;\n}\n\n.k-taskboard-column-new .k-taskboard-column-header-text,\n.k-taskboard-column-edit .k-taskboard-column-header-text {\n    flex: 1 1 100%;\n}\n\n.k-taskboard-pane {\n    width: 320px;\n    border-width: 1px;\n    border-style: solid;\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    overflow: hidden;\n    z-index: 2;\n}\n\n.k-taskboard-pane-header {\n    padding-block: 0.75rem;\n    padding-inline: 1rem;\n    font-weight: 500;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.k-taskboard-pane-header-text {\n    word-break: normal;\n    overflow-wrap: anywhere;\n}\n\n.k-taskboard-pane-header-actions {\n    flex-shrink: 0;\n    align-self: flex-start;\n}\n\n.k-taskboard-pane-content {\n    padding-block: 0px;\n    padding-inline: 1rem;\n    overflow: auto;\n    flex: 1 1 auto;\n}\n\n.k-taskboard-pane-actions {\n    padding-block: 0.75rem;\n    padding-inline: 1rem;\n}\n\n.k-taskboard-pane-start {\n    right: auto;\n    left: 0;\n}\n\n.k-taskboard-card {\n    border-radius: 0.375rem;\n    border-width: 1px;\n}\n\n.k-taskboard-card.k-taskboard-card-category {\n    border-inline-start-width: 4px;\n}\n\n.k-taskboard-card .k-card-header .k-card-body,\n.k-taskboard-card .k-card-footer {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n}\n\n.k-taskboard-card .k-card-header {\n    align-items: center;\n}\n\n.k-taskboard-card .k-card-title {\n    font-size: inherit;\n    font-weight: inherit;\n    word-break: normal;\n    overflow-wrap: anywhere;\n}\n\n.k-taskboard-card .k-card-title:focus, .k-taskboard-card .k-card-title.k-focus, .k-taskboard-card .k-card-title:hover, .k-taskboard-card .k-card-title.k-hover {\n    text-decoration: underline;\n}\n\n.k-taskboard-card .k-card-header-actions {\n    align-self: flex-start;\n}\n\n.k-taskboard-drag-placeholder {\n    border-radius: 0.375rem;\n    border-width: 1px;\n    border-style: solid;\n    position: relative;\n}\n\n.k-taskboard-column {\n    border-color: transparent;\n    background-color: #f8f9fa;\n}\n\n.k-taskboard-column:focus,\n.k-taskboard-column.k-focus {\n    border-color: #b6b7b8;\n}\n\n.k-taskboard-column-header {\n    color: #212529;\n}\n\n.k-taskboard-pane {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-taskboard-pane-header {\n    color: #212529;\n}\n\n.k-taskboard-card {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-taskboard-card .k-card-title {\n    color: #0d6efd;\n}\n\n.k-taskboard-card .k-card-title:focus, .k-taskboard-card .k-card-title.k-focus {\n    color: #0b5cd5;\n}\n\n.k-taskboard-card .k-card-title:hover, .k-taskboard-card .k-card-title.k-hover {\n    color: #0b5cd5;\n}\n\n.k-taskboard-card:focus, .k-taskboard-card.k-focus {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n    border-color: #b6b9bd;\n}\n\n.k-taskboard-card:hover, .k-taskboard-card.k-hover {\n    border-color: #c8cbcf;\n}\n\n.k-taskboard-card.k-selected {\n    border-color: #b6d3fe;\n    box-shadow: none;\n}\n\n.k-taskboard-card.k-disabled {\n    outline: none;\n    cursor: default;\n    opacity: 0.65;\n    filter: grayscale(0.1);\n    pointer-events: none;\n    box-shadow: none;\n}\n\n.k-taskboard-drag-placeholder {\n    border-color: #dee2e6;\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.k-editor {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-flow: column nowrap;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-editor.k-readonly .k-editor-content {\n    pointer-events: auto;\n}\n\n.k-editor.k-readonly .k-editor-content.k-focus {\n    outline-width: 1px;\n    outline-style: dashed;\n}\n\n.k-editor-inline {\n    border-radius: 0.375rem;\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    border: 1px solid transparent;\n    word-wrap: break-word;\n    overflow: auto;\n    background: none;\n}\n\n.k-editor-resizable {\n    resize: both;\n    overflow: auto;\n}\n\n.k-editor-resize-handles-wrapper {\n    position: absolute;\n    visibility: hidden;\n}\n\n.k-editor-resize-handle {\n    width: 8px;\n    height: 8px;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    position: absolute;\n    visibility: visible;\n    z-index: 100;\n}\n\n.k-editor-resize-handle.northwest {\n    top: 0;\n    left: 0;\n    transform: translate(-50%, -50%);\n    cursor: nw-resize;\n}\n\n.k-editor-resize-handle.north {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    cursor: n-resize;\n}\n\n.k-editor-resize-handle.northeast {\n    top: 0;\n    right: 0;\n    transform: translate(50%, -50%);\n    cursor: ne-resize;\n}\n\n.k-editor-resize-handle.southwest {\n    left: 0;\n    bottom: 0;\n    transform: translate(-50%, 50%);\n    cursor: sw-resize;\n}\n\n.k-editor-resize-handle.south {\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, 50%);\n    cursor: s-resize;\n}\n\n.k-editor-resize-handle.southeast {\n    right: 0;\n    bottom: 0;\n    transform: translate(50%, 50%);\n    cursor: se-resize;\n}\n\n.k-editor-resize-handle.west {\n    top: 50%;\n    left: 0;\n    transform: translate(-50%, -50%);\n    cursor: w-resize;\n}\n\n.k-editor-resize-handle.east {\n    top: 50%;\n    right: 0;\n    transform: translate(50%, -50%);\n    cursor: e-resize;\n}\n\n.ProseMirror-selectednode {\n    outline-width: 2px;\n    outline-style: solid;\n}\n\n.ProseMirror-hideselection {\n    caret-color: transparent;\n}\n\n.ProseMirror-hideselection *::selection,\n.ProseMirror-hideselection *::-moz-selection {\n    background: transparent;\n}\n\n.k-editor-toolbar {\n    border-width: 0 0 1px 0;\n    flex-shrink: 0;\n}\n\n.k-editor-toolbar .k-editor-export .k-icon {\n    margin-right: 0.25em;\n}\n\n.k-editor-toolbar .k-editor-export .k-icon,\n.k-editor-toolbar .k-editor-export .k-export-tool-text {\n    vertical-align: middle;\n}\n\n.k-editor-content {\n    flex: 1 1 auto;\n    overflow-y: auto;\n}\n\n.k-editor-content > .k-iframe {\n    width: 100%;\n    height: 100%;\n    border-width: 0;\n    display: block;\n}\n\n.k-editor-content > .ProseMirror {\n    padding: 1rem;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    box-sizing: border-box;\n    outline: none;\n    white-space: pre-wrap;\n    overflow: auto;\n}\n\n.k-editor-content > .ProseMirror table {\n    white-space: pre-wrap;\n}\n\n.k-editor-content > .ProseMirror .k-placeholder::before {\n    content: attr(data-placeholder);\n    height: 0;\n    color: #6c757d;\n    float: left;\n    opacity: 1;\n    cursor: text;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-editor-content > .ProseMirror[contenteditable=\"false\"] {\n    cursor: unset !important;\n}\n\n.k-editor-content > .ProseMirror[contenteditable=\"false\"] .k-editor-resize-handles-wrapper,\n.k-editor-content > .ProseMirror[contenteditable=\"false\"] .k-editor-resize-handle,\n.k-editor-content > .ProseMirror[contenteditable=\"false\"] .row-resize-handle,\n.k-editor-content > .ProseMirror[contenteditable=\"false\"] .column-resize-handle {\n    display: none;\n}\n\n.k-editor-content > .ProseMirror[contenteditable=\"false\"] img,\n.k-editor-content > .ProseMirror[contenteditable=\"false\"] table {\n    pointer-events: none;\n}\n\n.k-editor-content > .ProseMirror[contenteditable=\"false\"] .ProseMirror-selectednode {\n    outline: none;\n}\n\n.k-editor-content p {\n    margin: 0 0 1rem;\n}\n\n.k-editor-content td p,\n.k-editor-content th p,\n.k-editor-content li p {\n    margin: 0;\n}\n\n.k-editor-content table {\n    margin: 0;\n    border-collapse: collapse;\n    table-layout: fixed;\n    width: 100%;\n    overflow: hidden;\n}\n\n.k-editor-content td,\n.k-editor-content th {\n    min-width: 1em;\n    border: 1px solid;\n    padding-block: 3px;\n    padding-inline: 5px;\n    vertical-align: top;\n    box-sizing: border-box;\n    position: relative;\n}\n\n.k-editor-content th {\n    font-weight: bold;\n    text-align: start;\n}\n\n.k-editor-content td {\n    text-align: start;\n}\n\n.k-editor-content .selectedCell::after {\n    z-index: 2;\n    position: absolute;\n    content: \"\";\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    pointer-events: none;\n}\n\n.k-edit-form-content {\n    flex: 1 1 auto;\n    overflow: auto;\n    margin-block: -1rem;\n    margin-inline: -1rem;\n    padding-block: 1rem;\n    padding-inline: 1rem;\n}\n\n.k-ct-popup {\n    box-sizing: border-box;\n    width: 190px;\n    padding: 5px;\n}\n\n.k-ct-popup .k-button {\n    width: 100%;\n}\n\n.k-ct-popup .k-ct-cell {\n    margin: 1px;\n    width: 20px;\n    height: 20px;\n    box-sizing: border-box;\n    border: 1px solid;\n    border-color: inherit;\n    display: inline-block;\n    vertical-align: top;\n    overflow: hidden;\n    opacity: .7;\n    pointer-events: all;\n}\n\n.k-editor .k-resize-handle {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    padding: 0;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 0 13px 13px;\n    border-color: transparent;\n    border-bottom-color: inherit;\n    cursor: se-resize;\n}\n\n.k-editor .k-resize-handle .k-i-arrow-45-down-right,\n.k-editor .k-resize-handle .k-i-caret-br {\n    display: none;\n}\n\n.k-editor-find-replace .k-content {\n    position: relative;\n}\n\n.k-editor-find-replace .k-actions, .k-editor-find-replace .k-edit-buttons,\n.k-editor-find-replace .k-action-buttons,\n.k-editor-find-replace .k-columnmenu-actions, .k-editor-find-replace .k-form-buttons {\n    padding: 0;\n}\n\n.k-editor-find-replace .k-search-options {\n    display: flex;\n    flex-direction: column;\n    padding: 10px 0 40px;\n}\n\n.k-editor-find-replace .k-matches-container {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.k-textarea.k-editor-textarea {\n    width: 100%;\n    height: 100%;\n    resize: none;\n}\n\n.k-filebrowser {\n    max-width: 100%;\n}\n\n.k-filebrowser .k-floatwrap {\n    display: flex;\n}\n\n.k-filebrowser .k-floatwrap::after {\n    display: none;\n}\n\n.k-filebrowser .k-breadcrumbs {\n    flex: 1;\n}\n\n.k-filebrowser .k-search-wrap {\n    margin: 0 0 0 1rem;\n    width: 150px;\n    display: flex;\n    align-items: center;\n}\n\n.k-filebrowser .k-search-wrap .k-input {\n    flex: 1;\n    width: 100px;\n}\n\n.k-filebrowser .k-search-wrap .k-icon {\n    margin: 0;\n    position: static;\n}\n\n.k-filebrowser .k-filebrowser-toolbar {\n    margin: 1rem 0 0 0;\n}\n\n.k-filebrowser .k-upload {\n    padding: 0;\n    border-width: 0;\n    background: none;\n}\n\n.k-filebrowser .k-upload .k-upload-button {\n    margin: 0;\n}\n\n.k-filebrowser .k-upload .k-upload-status {\n    display: none;\n}\n\n.k-filebrowser .k-upload-files {\n    display: none;\n}\n\n.k-filebrowser .k-tiles {\n    display: flex;\n    flex-flow: row wrap;\n    height: 390px;\n    max-height: 50vh;\n    margin: 0 0 1rem 0;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    border-top-width: 0;\n    overflow: auto;\n}\n\n.k-filebrowser .k-tile {\n    width: 33%;\n    height: 90px;\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    box-sizing: border-box;\n    white-space: nowrap;\n    overflow: hidden;\n    cursor: pointer;\n    border-radius: 0.375rem;\n}\n\n.k-filebrowser .k-tile .k-i-file,\n.k-filebrowser .k-tile .k-i-folder {\n    font-size: 4em;\n}\n\n.k-filebrowser .k-tile input {\n    width: 100px;\n}\n\n.k-filebrowser .k-tile strong {\n    display: block;\n    font-weight: 400;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-filebrowser .k-tile-empty {\n    display: block;\n    margin: auto;\n}\n\n.k-filebrowser .k-tile-empty.k-selected {\n    color: inherit;\n    border-width: 0;\n    background-image: none;\n    background-color: transparent;\n}\n\n.k-filebrowser .k-tile-empty strong {\n    opacity: .5;\n    font-size: 3em;\n    font-weight: 400;\n}\n\n.k-filebrowser .k-thumb {\n    float: left;\n    margin-right: 0.5rem;\n}\n\n.k-filebrowser .k-breadcrumbs-wrap {\n    position: absolute;\n    left: 0.75rem;\n    top: 0.375rem;\n}\n\n.k-filebrowser .k-breadcrumbs-wrap .k-icon {\n    position: static;\n    margin-top: 0;\n}\n\n.k-editor-table-wizard-window .k-tabstrip-wrapper {\n    display: flex;\n    flex: 1 1 auto;\n    overflow: auto;\n}\n\n.k-editor-table-wizard-window .k-tabstrip-wrapper .k-tabstrip.k-root-tabs {\n    flex: 1 1 auto;\n    margin-bottom: 0;\n}\n\n.k-editor-table-wizard-window .k-edit-field > .k-checkbox {\n    position: relative;\n}\n\n.k-editor-inline .k-table {\n    width: 100%;\n    border-spacing: 0;\n    margin: 0 0 1em;\n}\n\n.k-editor-inline .k-table,\n.k-editor-inline .k-table td {\n    outline: 0;\n    border-width: 1px;\n    border-style: dotted;\n}\n\n.k-editor-inline .k-table td {\n    min-width: 1px;\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper {\n    position: absolute;\n    width: 5px;\n    height: 5px;\n    border-width: 1px;\n    border-style: solid;\n    z-index: 100;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle {\n    width: 100%;\n    height: 100%;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-east {\n    cursor: e-resize;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-north {\n    cursor: n-resize;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-northeast {\n    cursor: ne-resize;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-northwest {\n    cursor: nw-resize;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-south {\n    cursor: s-resize;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-southeast {\n    cursor: se-resize;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-southwest {\n    cursor: sw-resize;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper .k-element-resize-handle.k-resize-west {\n    cursor: w-resize;\n}\n\n.k-editor-inline .k-column-resize-handle-wrapper {\n    position: absolute;\n    height: 10px;\n    width: 10px;\n    cursor: col-resize;\n    z-index: 2;\n}\n\n.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle {\n    width: 100%;\n    height: 100%;\n}\n\n.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle .k-column-resize-marker {\n    width: 2px;\n    height: 100%;\n    margin-block: 0;\n    margin-inline: auto;\n    display: none;\n    opacity: .8;\n}\n\n.k-editor-inline .k-row-resize-handle-wrapper {\n    position: absolute;\n    z-index: 2;\n    cursor: row-resize;\n    width: 10px;\n    height: 10px;\n}\n\n.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-handle {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n\n.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker-wrapper {\n    display: table-cell;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    vertical-align: middle;\n}\n\n.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker {\n    display: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 2px;\n    opacity: .8;\n}\n\n.k-editor {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-editor.k-readonly .k-editor-content.k-focus {\n    outline-color: #212529;\n}\n\n.k-editor-inline .k-table,\n.k-editor-inline .k-table td {\n    border-color: #cccccc;\n}\n\n.k-editor-inline .k-element-resize-handle-wrapper {\n    background-color: #ffffff;\n    border-color: #000000;\n}\n\n.k-editor-inline .k-column-resize-handle-wrapper .k-column-resize-handle .k-column-resize-marker {\n    background-color: #00b0ff;\n}\n\n.k-editor-inline .k-row-resize-handle-wrapper .k-row-resize-marker {\n    background-color: #00b0ff;\n}\n\n.k-editor-inline:hover, .k-editor-inline.k-hover, .k-editor-inline.k-active {\n    border-color: #dee2e6;\n}\n\n.k-editor-resize-handle {\n    background-color: #ffffff;\n    border-color: #000000;\n}\n\n.ProseMirror-selectednode {\n    outline-color: #88ccff;\n}\n\n.k-ct-popup .k-selected {\n    border-color: #0c65e9;\n    color: white;\n    background-color: #0d6efd;\n    background-image: none;\n}\n\n.k-editor-content .k-text-selected, .k-editor-content::selection {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-editor-content .k-text-highlighted {\n    background-color: #cfe2ff;\n}\n\n.k-editor-content td,\n.k-editor-content th {\n    border-color: #dddddd;\n}\n\n.k-editor-content .selectedCell::after {\n    background-color: rgba(200, 200, 255, 0.4);\n}\n\n.k-imageeditor {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-imageeditor *,\n.k-imageeditor *::before,\n.k-imageeditor *::after {\n    box-sizing: border-box;\n}\n\n.k-imageeditor-toolbar {\n    border-width: 0;\n    border-bottom-width: 1px;\n}\n\n.k-imageeditor-content {\n    border-width: 0;\n    border-style: solid;\n    border-color: inherit;\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.k-imageeditor-canvas-container {\n    flex: 1 1 100%;\n    display: flex;\n    flex-flow: row nowrap;\n    overflow: auto;\n}\n\n.k-imageeditor-canvas {\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.k-imageeditor-action-pane {\n    padding-block: 2rem;\n    padding-inline: 1rem;\n    width: 241px;\n    border-width: 0;\n    border-left-width: 1px;\n    border-style: solid;\n    border-color: inherit;\n    box-sizing: border-box;\n    flex: none;\n    overflow-y: auto;\n}\n\n.k-imageeditor-action-pane .k-input-inner,\n.k-imageeditor-action-pane .k-input-value-text {\n    text-overflow: clip;\n}\n\n.k-imageeditor-crop-overlay {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.k-imageeditor-crop {\n    width: 100%;\n    height: 100%;\n    border-width: 1px;\n    border-style: dashed;\n    box-sizing: border-box;\n    position: absolute;\n}\n\n.k-imageeditor-crop .k-resize-handle {\n    margin-block: 1px;\n    margin-inline: 1px;\n    border-style: solid;\n    border-width: 0 2px 2px 0;\n}\n\n.k-imageeditor-crop .k-resize-sw,\n.k-imageeditor-crop .k-resize-se,\n.k-imageeditor-crop .k-resize-nw,\n.k-imageeditor-crop .k-resize-ne {\n    width: 15px;\n    height: 15px;\n}\n\n.k-imageeditor-crop .k-resize-n,\n.k-imageeditor-crop .k-resize-s {\n    left: calc(50% - 7.5px);\n    width: 15px;\n    height: 0;\n}\n\n.k-imageeditor-crop .k-resize-w,\n.k-imageeditor-crop .k-resize-e {\n    top: calc(50% - 7.5px);\n    width: 0;\n    height: 15px;\n}\n\n.k-imageeditor-crop .k-resize-ne {\n    transform: rotate(-90deg);\n}\n\n.k-imageeditor-crop .k-resize-nw {\n    transform: rotate(-180deg);\n}\n\n.k-imageeditor-crop .k-resize-sw {\n    transform: rotate(90deg);\n}\n\n.k-imageeditor-crop .k-resize-n {\n    top: 0;\n}\n\n.k-imageeditor-crop .k-resize-s {\n    bottom: 0;\n}\n\n.k-imageeditor-crop .k-resize-w {\n    left: 0;\n}\n\n.k-imageeditor-crop .k-resize-e {\n    right: 0;\n}\n\n.k-imageeditor {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-imageeditor-content {\n    background-color: #c6c6c6;\n}\n\n.k-imageeditor-canvas {\n    background: linear-gradient(45deg, rgba(0, 0, 0, 0.09) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.09) 75%, rgba(0, 0, 0, 0.09)), linear-gradient(45deg, rgba(0, 0, 0, 0.09) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.09) 75%, rgba(0, 0, 0, 0.09)), white;\n    background-repeat: repeat, repeat;\n    background-position: 0px 0px, 5px 5px;\n    transform-origin: 0 0 0;\n    background-origin: padding-box, padding-box;\n    background-size: 10px 10px, 10px 10px;\n    box-shadow: none;\n    text-shadow: none;\n    transition: none;\n    transform: scaleX(1) scaleY(1) scaleZ(1);\n}\n\n.k-imageeditor-action-pane {\n    background-color: #ffffff;\n}\n\n.k-imageeditor-crop {\n    border-color: white;\n}\n\n.k-imageeditor-crop-overlay {\n    background-color: rgba(0, 0, 0, 0.3);\n}\n\n.k-gantt {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-flow: column nowrap;\n    position: relative;\n    white-space: nowrap;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-gantt .k-table-td {\n    white-space: nowrap;\n}\n\n.k-gantt td {\n    overflow: hidden;\n    white-space: nowrap;\n    vertical-align: top;\n}\n\n.k-gantt .k-grid-header tr {\n    height: calc(1.5em + 1rem + 1px);\n}\n\n.k-gantt .k-grid-header .k-header {\n    position: static;\n}\n\n.k-gantt .k-treelist .k-grid-header .k-header {\n    position: relative;\n}\n\n.k-gantt .k-grid-content tr {\n    height: calc(1.5em + 1rem);\n}\n\n.k-gantt.k-gantt-planned .k-grid-content tr {\n    height: calc(2.55em + 1rem);\n}\n\n.k-gantt .k-gantt-layout {\n    white-space: normal;\n    vertical-align: top;\n    display: inline-block;\n}\n\n.k-gantt .k-splitbar {\n    position: relative;\n    display: inline-flex;\n}\n\n.k-gantt .k-gantt-splitter {\n    border-width: 0;\n}\n\n.k-gantt .k-treelist-scrollable {\n    width: 100%;\n    border-width: 0;\n    overflow: auto;\n}\n\n.k-gantt .k-treelist-scrollable .k-grid-header .k-header {\n    position: sticky;\n}\n\n.k-gantt .k-treelist-scrollable .k-grid-header th,\n.k-gantt .k-treelist-scrollable .k-grid-content-sticky {\n    z-index: 4;\n}\n\n.k-gantt .k-treelist-scrollable .k-grid-header th.k-grid-header-sticky {\n    z-index: 5;\n}\n\n.k-gantt .k-treelist-scrollable .k-grid-header tr:first-child th:last-child,\n.k-gantt .k-treelist-scrollable tbody td:last-child {\n    padding: 0;\n    vertical-align: top;\n}\n\n.k-gantt .k-treelist-scrollable .k-grid-header th:last-child .k-header {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 0 0 1px 1px;\n    white-space: nowrap;\n}\n\n.k-gantt .k-treelist-scrollable tr.k-selected > td:last-child {\n    background: transparent;\n}\n\n.k-gantt .k-treelist-scrollable .k-task {\n    display: inline-flex;\n    flex-flow: row nowrap;\n    white-space: nowrap;\n    z-index: 3;\n}\n\n.k-gantt .k-treelist-scrollable .k-task:hover .k-task-start,\n.k-gantt .k-treelist-scrollable .k-task:hover .k-task-end {\n    display: block;\n}\n\n.k-gantt .k-treelist-scrollable .k-task:hover .k-task-draghandle {\n    visibility: visible;\n}\n\n.k-gantt .k-treelist-scrollable .k-task-content {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    display: block;\n    line-height: normal;\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.k-gantt .k-treelist-scrollable .k-task-actions {\n    flex-shrink: 0;\n}\n\n.k-gantt .k-treelist-scrollable .k-task-milestone {\n    border: 0;\n    transform: none;\n    background: none;\n}\n\n.k-gantt .k-treelist-scrollable .k-task-milestone .k-task-milestone-content {\n    width: 100%;\n    height: 100%;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    transform: rotate(45deg);\n}\n\n.k-gantt .k-treelist-scrollable .k-task-summary {\n    height: 15px;\n    clip-path: polygon(-20px 0, calc(100% + 20px) 0, calc(100% + 20px) 100%, 100% 100%, calc(100% - 8px) calc(100% - 5px), 8px calc(100% - 5px), 0 100%, -20px 100%);\n}\n\n.k-gantt .k-treelist-scrollable .k-task-summary-complete {\n    width: 100%;\n    height: 15px;\n}\n\n.k-gantt .k-treelist-scrollable .k-task-start {\n    transform: translateX(-140%) translateY(-50%);\n}\n\n.k-gantt .k-treelist-scrollable .k-task-end {\n    transform: translateX(140%) translateY(-50%);\n}\n\n.k-gantt .k-treelist-scrollable .k-master-row:hover .k-task-dot {\n    display: block;\n}\n\n.k-gantt .k-treelist-scrollable .k-gantt-columns {\n    background: transparent;\n    pointer-events: none;\n    table-layout: fixed;\n}\n\n.k-gantt .k-gantt-dependencies-svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    overflow: visible;\n    pointer-events: none;\n    z-index: 2;\n}\n\n.k-gantt .k-gantt-dependencies-svg polyline {\n    stroke-width: 2px;\n}\n\n.k-gantt-header {\n    border-width: 0 0 1px;\n    flex-shrink: 0;\n    z-index: 6;\n}\n\n.k-gantt-footer {\n    border-width: 1px 0 0;\n    flex-shrink: 0;\n}\n\n.k-gantt-toggle {\n    display: none;\n}\n\n.k-gantt-views-wrapper {\n    margin-left: auto;\n}\n\n.k-gantt-views-wrapper .k-views-dropdown {\n    width: auto;\n    font-size: inherit;\n    display: none;\n    cursor: pointer;\n}\n\n@media (max-width: 480px) {\n    .k-gantt-toolbar .k-gantt-toggle {\n        display: inline-flex;\n    }\n    .k-gantt-toolbar .k-gantt-pdf,\n    .k-gantt-toolbar .k-gantt-create {\n        padding: 0.375rem;\n        width: calc(1.5em + 0.75rem + 2px);\n        height: calc(1.5em + 0.75rem + 2px);\n    }\n    .k-gantt-toolbar .k-gantt-pdf .k-button-text,\n    .k-gantt-toolbar .k-gantt-create .k-button-text {\n        display: none;\n    }\n}\n\n@media (max-width: 1024px) {\n    .k-gantt-views-wrapper .k-gantt-views {\n        display: none;\n    }\n    .k-gantt-views-wrapper .k-views-dropdown {\n        display: flex;\n    }\n}\n\n.k-gantt-content {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: stretch;\n    flex: 1 1 auto;\n    overflow: hidden;\n}\n\n.k-gantt-treelist .k-treelist {\n    height: 100%;\n    border-width: 0;\n}\n\n.k-gantt-treelist .k-grid-header,\n.k-gantt-treelist .k-grid-footer {\n    padding: 0 !important;\n}\n\n.k-gantt-treelist .k-grid-header tr {\n    height: calc(3em + 2rem + 2px);\n    vertical-align: bottom;\n}\n\n.k-gantt-treelist .k-grid-content {\n    overflow: hidden;\n    overflow-x: scroll;\n}\n\n.k-gantt-treelist .k-grid-content td {\n    vertical-align: middle;\n}\n\n.k-gantt-treelist .k-gantt-treelist-nested-columns .k-grid-header tr {\n    height: calc(1.5em + 1rem + 1px);\n}\n\n.k-gantt-treelist.k-gantt-treelist-scrollable .k-grid-content {\n    overflow: scroll;\n}\n\n.k-gantt-timeline-pane .k-gantt-timeline {\n    height: 100%;\n    border-width: 0;\n    display: flex;\n}\n\n.k-gantt-timeline-pane .k-gantt-timeline *,\n.k-gantt-timeline-pane .k-gantt-timeline *::before,\n.k-gantt-timeline-pane .k-gantt-timeline *::after, .k-gantt-timeline-pane .k-gantt-timeline::before, .k-gantt-timeline-pane .k-gantt-timeline::after {\n    box-sizing: border-box;\n}\n\n.k-gantt-timeline-pane .k-grid-content {\n    overflow-x: scroll;\n}\n\n.k-gantt-timeline-pane .k-header {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    border-width: 0 0 1px 1px;\n    white-space: nowrap;\n}\n\n.k-gantt-tables {\n    position: relative;\n    border-color: inherit;\n}\n\n.k-gantt-rows,\n.k-gantt-columns {\n    border-color: inherit;\n    position: absolute;\n    z-index: 0;\n    top: 0;\n    left: 0;\n}\n\n.k-gantt-dependencies {\n    opacity: .7;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.k-gantt-dependencies .k-arrow-e,\n.k-gantt-dependencies .k-arrow-w {\n    width: 0;\n    height: 0;\n    border: 5px solid transparent;\n    position: absolute;\n    top: -4px;\n}\n\n.k-gantt-dependencies .k-arrow-e {\n    border-left-color: currentColor;\n    right: -6px;\n}\n\n.k-gantt-dependencies .k-arrow-w {\n    border-right-color: currentColor;\n    left: -6px;\n}\n\n.k-gantt-line {\n    background-color: currentColor;\n    border-color: currentColor;\n    position: absolute;\n}\n\n.k-gantt-line.k-selected {\n    z-index: 3;\n}\n\n.k-gantt-line-h {\n    height: 2px;\n}\n\n.k-gantt-line-v {\n    width: 2px;\n}\n\n.k-gantt-dependency-hint {\n    z-index: 4;\n}\n\n.k-gantt-tasks {\n    position: relative;\n}\n\n.k-gantt-tasks td,\n.k-gantt-tasks .k-table-td {\n    padding: 0;\n    border-width: 0;\n    position: relative;\n    vertical-align: middle;\n}\n\n.k-gantt-tasks td::after {\n    content: \"\\200b\";\n}\n\n.k-task-wrap {\n    margin-block: 0;\n    margin-inline: -21px;\n    padding-block: 5px;\n    padding-inline: 21px;\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n}\n\n.k-task-wrap.k-drag-hint {\n    position: absolute;\n}\n\n.k-task {\n    position: relative;\n    flex: 1 1 auto;\n}\n\n.k-task-dot {\n    width: 16px;\n    height: 16px;\n    line-height: 1;\n    cursor: pointer;\n    display: none;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.k-task-wrap:hover .k-task-dot,\n.k-task-wrap.k-origin .k-task-dot {\n    display: block;\n}\n\n.k-task-dot::before {\n    content: \"\";\n    width: 8px;\n    height: 8px;\n    border-width: 0;\n    border-style: solid;\n    border-radius: 100%;\n    display: inline-block;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.k-task-dot:hover::before,\n.k-task-dot.k-hover::before {\n    border-width: 1px;\n}\n\n.k-task-start {\n    left: 0;\n}\n\n.k-task-end {\n    right: 0;\n}\n\n.k-task-draghandle {\n    margin-left: 16px;\n    width: 0;\n    height: 0;\n    border: 5px solid transparent;\n    border-top-width: 0;\n    border-bottom-color: inherit;\n    position: absolute;\n    bottom: 0;\n    cursor: e-resize;\n    visibility: hidden;\n}\n\n.k-task-wrap:hover .k-task-draghandle {\n    visibility: visible;\n}\n\n.k-milestone-wrap {\n    margin-block: 0;\n    margin-inline: -2em;\n}\n\n.k-task-milestone {\n    width: 1em;\n    height: 1em;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    transform: rotate(45deg);\n}\n\n.k-task-summary {\n    height: 10px;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.k-task-summary,\n.k-task-summary-complete {\n    background-color: currentColor;\n}\n\n.k-task-summary::before, .k-task-summary::after,\n.k-task-summary-complete::before,\n.k-task-summary-complete::after {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border: 8px solid transparent;\n    position: absolute;\n    top: 0;\n    display: none;\n}\n\n.k-task-summary::before,\n.k-task-summary-complete::before {\n    border-left-color: currentColor;\n    left: 0;\n}\n\n.k-task-summary::after,\n.k-task-summary-complete::after {\n    border-right-color: currentColor;\n    right: 0;\n}\n\n.k-task-summary-complete {\n    height: 10px;\n    position: relative;\n    z-index: 2;\n}\n\n.k-task-summary-progress {\n    height: 15px;\n    overflow: hidden;\n}\n\n.k-task-single {\n    border-radius: 0.375rem;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    cursor: default;\n}\n\n.k-task-single .k-resize-handle {\n    opacity: .5;\n    z-index: 2;\n    visibility: hidden;\n}\n\n.k-task-single .k-resize-handle::before {\n    position: absolute;\n    top: 2px;\n    bottom: 2px;\n}\n\n.k-task-single .k-resize-w {\n    left: 0;\n}\n\n.k-task-single .k-resize-w::before {\n    left: 2px;\n    border-left-width: 1px;\n}\n\n.k-task-single .k-resize-e {\n    right: 0;\n}\n\n.k-task-single .k-resize-e::before {\n    right: 2px;\n    border-left-width: 1px;\n}\n\n.k-task-single:hover .k-resize-handle,\n.k-task-single:hover .k-task-actions {\n    visibility: visible;\n}\n\n.k-task-complete {\n    border-radius: 0.375rem;\n    width: 20%;\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.k-task-content {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    white-space: nowrap;\n}\n\n.k-task-template {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    line-height: normal;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-task-actions {\n    padding: 0.25rem;\n    white-space: nowrap;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    visibility: hidden;\n    z-index: 1;\n}\n\n.k-task-actions > .k-link {\n    display: inline-flex;\n}\n\n.k-resources-wrap {\n    position: absolute;\n    display: inline-block;\n    z-index: 2;\n    margin-left: 20px;\n    margin-top: -2px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.k-resources-wrap .k-resource {\n    margin-block: 0;\n    margin-inline: 5px;\n}\n\n.k-task-details {\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n    white-space: nowrap;\n}\n\n.k-task-details strong {\n    font-size: 1.25rem;\n    font-weight: normal;\n    display: block;\n}\n\n.k-task-details .k-task-pct {\n    font-size: 32px;\n}\n\n.k-task-details ul {\n    line-height: normal;\n}\n\n.k-gantt-planned .k-gantt-dependencies,\n.k-gantt-planned .k-task-dot,\n.k-gantt-planned .k-resources-wrap {\n    margin-top: 0.6em;\n}\n\n.k-gantt-planned .k-task-wrap {\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.k-gantt-planned .k-task-inner-wrap {\n    display: inline-flex;\n}\n\n.k-gantt-planned .k-task-wrap.k-drag-hint {\n    top: 0.35em;\n}\n\n.k-gantt-planned .k-summary-wrap.k-drag-hint {\n    top: 1em;\n}\n\n.k-gantt-planned .k-milestone-wrap.k-drag-hint {\n    top: 0.85em;\n}\n\n.k-task-planned {\n    margin: 0 0 0.35em;\n    line-height: 0.75em;\n    display: flex;\n    align-items: center;\n}\n\n.k-task-planned .k-task-moment {\n    border-width: 2px;\n    border-radius: 5px;\n    border-style: solid;\n    height: 6px;\n    width: 6px;\n}\n\n.k-task-planned .k-task-duration {\n    height: 2px;\n}\n\n.k-task-planned .k-task-moment.k-moment-left {\n    margin-left: -4px;\n}\n\n.k-task-planned:hover .k-task-duration {\n    height: 3px;\n}\n\n.k-milestone-wrap .k-task-moment {\n    margin-left: 6px;\n}\n\n.k-planned-tooltip .k-task-content {\n    display: block;\n}\n\n.k-task-offset-wrap .k-task-content .k-resize-e {\n    display: none;\n}\n\n.k-task-offset {\n    flex-direction: row-reverse;\n    display: flex;\n}\n\n.k-task-offset .k-resize-handle {\n    right: 0;\n    z-index: 2;\n    visibility: hidden;\n    margin-right: 1.2em;\n}\n\n.k-task-offset .k-resize-handle::before {\n    border-left-width: 1px;\n    position: absolute;\n    top: 45%;\n    bottom: .5em;\n    margin-right: 2px;\n}\n\n.k-task-single:hover + .k-task-offset .k-task-actions,\n.k-task-offset:hover .k-task-actions,\n.k-task-single:hover + .k-task-offset .k-resize-handle,\n.k-task-offset:hover .k-resize-handle {\n    visibility: visible;\n}\n\n.k-gantt-tooltip-validation {\n    max-width: 200px;\n    display: block;\n}\n\n.k-gantt-tooltip-validation::before {\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.k-gantt-tooltip-validation-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.k-gantt-tooltip-validation-label {\n    display: inline-flex;\n    min-width: 50px;\n}\n\n.k-gantt-tooltip-validation-value {\n    font-weight: 700;\n}\n\n.k-gantt-tooltip-validation-label,\n.k-gantt-tooltip-validation-value {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.k-pdf-export-shadow .k-gantt {\n    float: left;\n}\n\n.k-pdf-export-shadow .k-gantt,\n.k-pdf-export-shadow .k-gantt-timeline-pane,\n.k-pdf-export-shadow .k-gantt-dependencies {\n    width: auto !important;\n    height: auto !important;\n    overflow: visible !important;\n}\n\n.k-pdf-export-shadow .k-gantt-treelist .k-treelist {\n    display: block;\n}\n\n.k-pdf-export-shadow .k-gantt-layout.k-splitbar {\n    display: none;\n}\n\n.k-gantt-edit-form .k-gantt-delete {\n    float: left;\n}\n\n.k-rtl .k-gantt-rows,\n.k-rtl .k-gantt-columns,\n[dir=\"rtl\"] .k-gantt-rows,\n[dir=\"rtl\"] .k-gantt-columns {\n    left: auto;\n    right: 0;\n}\n\n.k-rtl .k-task-wrap:not(.k-milestone-wrap),\n[dir=\"rtl\"] .k-task-wrap:not(.k-milestone-wrap) {\n    margin-block: 0;\n    margin-inline: -26px;\n}\n\n.k-rtl .k-gantt-timeline-pane .k-header,\n[dir=\"rtl\"] .k-gantt-timeline-pane .k-header {\n    border-width: 0 1px 1px 0;\n}\n\n.k-rtl .k-gantt-timeline-pane .k-header:first-child,\n[dir=\"rtl\"] .k-gantt-timeline-pane .k-header:first-child {\n    border-right-width: 0;\n}\n\n.k-rtl .k-gantt-timeline-pane .k-task-start,\n[dir=\"rtl\"] .k-gantt-timeline-pane .k-task-start {\n    left: auto;\n    right: 0;\n}\n\n.k-rtl .k-gantt-timeline-pane .k-task-end,\n[dir=\"rtl\"] .k-gantt-timeline-pane .k-task-end {\n    right: auto;\n    left: 0;\n}\n\n.k-rtl .k-task-content,\n[dir=\"rtl\"] .k-task-content {\n    text-align: end;\n}\n\n.k-rtl .k-task-complete,\n[dir=\"rtl\"] .k-task-complete {\n    left: auto;\n    right: 0;\n}\n\n.k-rtl .k-task-draghandle,\n[dir=\"rtl\"] .k-task-draghandle {\n    margin-left: 0;\n    margin-right: 16px;\n}\n\n.k-rtl .k-gantt-dependencies,\n[dir=\"rtl\"] .k-gantt-dependencies {\n    left: auto;\n    right: 0;\n}\n\n.k-rtl .k-gantt-delete,\n[dir=\"rtl\"] .k-gantt-delete {\n    float: right;\n}\n\n.k-rtl .k-task-offset-wrap .k-task-content .k-resize-e,\n[dir=\"rtl\"] .k-task-offset-wrap .k-task-content .k-resize-e {\n    display: block;\n}\n\n.k-rtl .k-task-offset-wrap .k-task-content .k-resize-w,\n[dir=\"rtl\"] .k-task-offset-wrap .k-task-content .k-resize-w {\n    display: none;\n}\n\n.k-rtl .k-milestone-wrap,\n[dir=\"rtl\"] .k-milestone-wrap {\n    margin-left: -2.3em;\n}\n\n.k-rtl .k-milestone-wrap .k-task-moment,\n[dir=\"rtl\"] .k-milestone-wrap .k-task-moment {\n    margin-right: 0.2em;\n}\n\n.k-rtl .k-gantt-timeline-pane .k-milestone-wrap .k-task-start,\n[dir=\"rtl\"] .k-gantt-timeline-pane .k-milestone-wrap .k-task-start {\n    right: -0.1em;\n}\n\n.k-rtl .k-gantt-tooltip-validation::before,\n[dir=\"rtl\"] .k-gantt-tooltip-validation::before {\n    left: auto;\n    right: 0;\n}\n\n.k-gantt {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-gantt .k-treelist-scrollable .k-task-milestone .k-task-milestone-content {\n    border-color: #babec1;\n    background-color: #dee2e6;\n}\n\n.k-gantt .k-treelist-scrollable .k-task-milestone.k-selected .k-task-milestone-content {\n    border-color: #0c65e9;\n    background-color: #0d6efd;\n}\n\n.k-gantt .k-gantt-dependencies-svg polyline {\n    fill: none;\n    stroke: #909294;\n}\n\n.k-gantt .k-gantt-dependencies-svg polyline.k-selected {\n    stroke: #0d6efd;\n}\n\n.k-gantt-footer {\n    box-shadow: none;\n}\n\n.k-gantt-treelist .k-treelist,\n.k-gantt-treelist .k-grid-content {\n    background-color: transparent;\n}\n\n.k-gantt .k-nonwork-hour {\n    background-color: rgba(0, 0, 0, 0.025);\n}\n\n.k-task-dot::before {\n    background-color: #212529;\n}\n\n.k-task-dot:hover::before,\n.k-task-dot.k-hover::before {\n    border-color: #212529;\n    background-color: #ffffff;\n}\n\n.k-task-milestone {\n    border-color: #babec1;\n    background-color: #dee2e6;\n}\n\n.k-task-milestone.k-task-delayed {\n    background-image: repeating-linear-gradient(90deg, #ffffff, #ffffff 2px, #dc3545 2px, #dc3545 4px);\n}\n\n.k-task-milestone.k-task-advanced {\n    background-color: #198754;\n}\n\n.k-task-milestone.k-selected {\n    background-image: none;\n    border-color: #0c65e9;\n    background-color: #0d6efd;\n}\n\n.k-task-summary {\n    color: #909294;\n}\n\n.k-task-summary.k-task-delayed {\n    color: #ea868f;\n}\n\n.k-task-summary.k-task-advanced {\n    color: #75b798;\n}\n\n.k-task-summary-complete {\n    color: #212529;\n}\n\n.k-task-delayed .k-task-summary-complete {\n    color: #dc3545;\n}\n\n.k-task-advanced .k-task-summary-complete {\n    color: #198754;\n}\n\n.k-task-summary.k-selected {\n    color: #86b7fe;\n}\n\n.k-task-summary.k-selected .k-task-summary-complete {\n    color: #0d6efd;\n}\n\n.k-task-single {\n    border-color: #ced4da;\n    color: black;\n    background-color: #dee2e6;\n}\n\n.k-task-single.k-task-delayed {\n    background-color: #ea868f;\n}\n\n.k-task-single.k-task-advanced {\n    background-color: #75b798;\n}\n\n.k-task-single .k-task-complete {\n    background-color: #ced4da;\n}\n\n.k-task-delayed .k-task-complete {\n    background-color: #dc3545;\n}\n\n.k-task-advanced .k-task-complete {\n    background-color: #198754;\n}\n\n.k-task-single.k-selected {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #86b7fe;\n}\n\n.k-task-single.k-selected .k-task-complete {\n    background-color: #0d6efd;\n}\n\n.k-gantt-line {\n    color: #909294;\n}\n\n.k-gantt-line.k-selected {\n    color: #0d6efd;\n}\n\n.k-task-planned .k-task-moment {\n    border-color: #0d6efd;\n    background-color: transparent;\n}\n\n.k-task-planned .k-task-duration {\n    background-color: #0d6efd;\n}\n\n.k-task-planned:hover .k-task-moment {\n    background-color: #0d6efd;\n}\n\n.k-task-offset {\n    background-image: repeating-linear-gradient(135deg, #ffffff, #ffffff 2px, #dc3545 2px, #dc3545 4px);\n}\n\n.k-task-offset .k-resize-e::before {\n    border-color: #000000;\n}\n\n.k-task-offset .k-task-actions {\n    color: #000000;\n}\n\n.k-task-offset:hover {\n    background-image: repeating-linear-gradient(135deg, #ffffff, #ffffff 2px, #ea868f 2px, #ea868f 4px);\n}\n\n.k-pdf-export .k-task-offset {\n    background-color: #dc3545;\n}\n\n.k-offset-tooltip-delayed {\n    background-color: #dc3545;\n}\n\n.k-planned-tooltip {\n    background-color: #0d6efd;\n}\n\n.k-gantt-tooltip-validation::before {\n    background-color: #656565;\n}\n\n.k-gantt-tooltip-valid::before {\n    background-color: #198754;\n}\n\n.k-gantt-tooltip-invalid::before {\n    background-color: #dc3545;\n}\n\n.k-scheduler {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-scheduler table,\n.k-scheduler thead,\n.k-scheduler tfoot,\n.k-scheduler tbody,\n.k-scheduler tr,\n.k-scheduler th,\n.k-scheduler td,\n.k-scheduler div,\n.k-scheduler .k-scheduler-edit-dialog,\n.k-scheduler > * {\n    border-color: inherit;\n}\n\nkendo-scheduler.k-scheduler {\n    overflow: hidden;\n}\n\nkendo-scheduler.k-scheduler.k-readonly-scheduler .k-event-delete {\n    display: none;\n}\n\n.k-scheduler-table {\n    width: 100%;\n    max-width: none;\n    border-collapse: separate;\n    border-spacing: 0;\n    table-layout: fixed;\n}\n\n.k-scheduler-table td,\n.k-scheduler-table th {\n    padding-block: 0.75rem;\n    padding-inline: 0.75rem;\n    height: 1.5em;\n    overflow: hidden;\n    white-space: nowrap;\n    border-style: solid;\n    border-width: 0 0 1px 1px;\n    vertical-align: top;\n    box-sizing: content-box;\n}\n\n.k-scheduler-table td:first-child,\n.k-scheduler-table th:first-child {\n    border-left-width: 0;\n}\n\n.k-scheduler-table .k-middle-row td {\n    border-bottom-style: dotted;\n}\n\n.k-scheduler-table .k-link {\n    cursor: pointer;\n}\n\n.k-scheduler-layout-flex {\n    overflow: auto;\n}\n\n.k-scheduler-layout-flex .k-scheduler-head {\n    position: sticky;\n    top: 0;\n    z-index: 3;\n}\n\n.k-scheduler-layout-flex .k-scheduler-body {\n    position: relative;\n}\n\n.k-scheduler-layout-flex .k-scheduler-head,\n.k-scheduler-layout-flex .k-scheduler-body {\n    display: flex;\n    flex: 100%;\n    flex-wrap: wrap;\n}\n\n.k-scheduler-layout-flex .k-scheduler-row {\n    display: flex;\n    flex: 1 1 100%;\n    width: 100%;\n    min-width: 0;\n}\n\n.k-scheduler-layout-flex .k-scheduler-group {\n    display: flex;\n    flex: 1 1 100%;\n    width: 100%;\n    min-width: 0;\n    flex-wrap: wrap;\n}\n\n.k-scheduler-layout-flex .k-scheduler-group .k-group-cell {\n    display: flex;\n    flex: 1 1 auto;\n    flex-wrap: wrap;\n    overflow: auto;\n}\n\n.k-scheduler-layout-flex .k-scheduler-group .k-group-content {\n    padding: 0;\n    display: flex;\n    flex: 1 1 100%;\n    width: 100%;\n    border-width: 0;\n    flex-wrap: wrap;\n}\n\n.k-scheduler-layout-flex .k-scheduler-group.k-group-horizontal .k-group-cell {\n    flex-basis: 100%;\n    border-width: 0;\n    padding: 0;\n}\n\n.k-scheduler-layout-flex.k-scheduler-timeline-view .k-scheduler-body .k-scheduler-cell {\n    flex-basis: auto;\n}\n\n.k-scheduler-layout-flex .k-more-events {\n    bottom: 2px;\n    left: 0;\n    width: 100%;\n}\n\n.k-scheduler-layout-flex .k-scheduler-cell {\n    display: flex;\n    flex: 1 1 100%;\n    padding-block: 0.75rem;\n    padding-inline: 0.75rem;\n    min-height: 1.5em;\n    overflow: hidden;\n    white-space: nowrap;\n    border-style: solid;\n    border-width: 0 1px 1px 0;\n    vertical-align: top;\n    box-sizing: content-box;\n}\n\n.k-scheduler-layout-flex .k-scheduler-cell.k-slot-cell {\n    position: relative;\n}\n\n.k-scheduler-layout-flex .k-scheduler-cell.k-heading-cell {\n    justify-content: center;\n    font-weight: bold;\n}\n\n.k-scheduler-layout-flex .k-scheduler-cell.k-side-cell {\n    justify-content: flex-end;\n    flex-grow: 0;\n    flex-basis: auto;\n    overflow: visible;\n}\n\n.k-scheduler-layout-flex .k-scheduler-cell.k-major-cell {\n    border-bottom-width: 0;\n}\n\n.k-scheduler-layout-flex .k-middle-row .k-scheduler-cell {\n    border-bottom-style: dotted;\n}\n\n.k-scheduler-layout-flex .k-resource-cell {\n    flex: none;\n    display: flex;\n    flex-wrap: wrap;\n    overflow: visible;\n}\n\n.k-scheduler-layout-flex .k-resource-content {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0;\n    border-width: 0;\n}\n\n.k-scheduler-layout-flex .k-sticky-cell {\n    display: flex;\n    flex-wrap: wrap;\n    flex-basis: 0;\n    position: sticky;\n    left: 0;\n    z-index: 3;\n}\n\n.k-scheduler-toolbar {\n    border-width: 0;\n    border-bottom-width: 1px;\n    white-space: nowrap;\n    flex-shrink: 0;\n    position: relative;\n    z-index: 2;\n}\n\n.k-scheduler-toolbar .k-widget {\n    font-size: inherit;\n}\n\n.k-scheduler-toolbar .k-nav-current {\n    color: inherit;\n    outline: 0;\n    text-decoration: none;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n}\n\n.k-scheduler-toolbar .k-scheduler-search {\n    display: inline-flex;\n    flex-flow: row nowrap;\n}\n\n.k-scheduler-toolbar .k-views-dropdown {\n    width: auto;\n    font: inherit;\n}\n\n.k-scheduler-footer {\n    box-shadow: none;\n    border-width: 0;\n    border-top-width: 1px;\n    white-space: nowrap;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.k-scheduler-layout {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    flex: 1 1 auto;\n    position: relative;\n    z-index: 1;\n}\n\n.k-scheduler-layout > tbody > tr > td {\n    padding: 0;\n    vertical-align: top;\n}\n\n.k-scheduler-layout td.k-selected,\n.k-scheduler-layout .k-scheduler-cell.k-selected {\n    outline: none;\n}\n\n.k-scheduler-layout tr + tr .k-scheduler-times tr th,\n.k-scheduler-layout .k-scheduler-pane + .k-scheduler-pane .k-scheduler-times tr th {\n    border-bottom-color: transparent;\n}\n\n.k-scheduler-layout tr + tr .k-scheduler-times tr .k-slot-cell,\n.k-scheduler-layout tr + tr .k-scheduler-times tr .k-scheduler-times-all-day,\n.k-scheduler-layout tr + tr .k-scheduler-times tr:last-child th,\n.k-scheduler-layout .k-scheduler-pane + .k-scheduler-pane .k-scheduler-times tr .k-slot-cell,\n.k-scheduler-layout .k-scheduler-pane + .k-scheduler-pane .k-scheduler-times tr .k-scheduler-times-all-day,\n.k-scheduler-layout .k-scheduler-pane + .k-scheduler-pane .k-scheduler-times tr:last-child th {\n    border-bottom-color: inherit;\n}\n\n.k-scheduler-layout.k-scheduler-flex-layout {\n    display: flex;\n    flex-direction: column;\n}\n\n.k-scheduler-layout.k-scheduler-flex-layout.k-scheduler-weekview .k-scheduler-pane:first-child .k-scheduler-table, .k-scheduler-layout.k-scheduler-flex-layout.k-scheduler-dayview .k-scheduler-pane:first-child .k-scheduler-table {\n    table-layout: fixed;\n}\n\n.k-scheduler-header,\n.k-scheduler-view-header {\n    padding-inline-end: var(--kendo-scrollbar-width, 17px);\n}\n\n.k-scheduler-header th {\n    text-align: center;\n}\n\n.k-scheduler-header,\n.k-scheduler-header-wrap,\n.k-scheduler-header-wrap > div {\n    border-color: inherit;\n    overflow: hidden;\n}\n\n.k-scheduler-header-wrap {\n    border-width: 0;\n    border-style: solid;\n    position: relative;\n}\n\n.k-scheduler-times {\n    border-color: inherit;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-scheduler-times .k-scheduler-table {\n    table-layout: auto;\n}\n\n.k-scheduler-times th {\n    border-width: 0 1px 1px 0;\n    text-align: end;\n}\n\n.k-scheduler-times .k-slot-cell,\n.k-scheduler-times .k-scheduler-times-all-day {\n    border-bottom-color: inherit;\n}\n\n.k-scheduler-times .k-slot-cell.k-last-resource {\n    border-right: 0;\n}\n\n.k-scheduler-times .k-slot-cell.k-empty-slot {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.k-scheduler-datecolumn {\n    width: 12em;\n}\n\n.k-scheduler-timecolumn {\n    width: 11em;\n    white-space: nowrap;\n}\n\n.k-scheduler-content {\n    border-color: inherit;\n    position: relative;\n    overflow: auto;\n}\n\n.k-scheduler-content:focus {\n    outline: none;\n}\n\nkendo-scheduler .k-event,\n.k-event {\n    border-radius: 0.375rem;\n    min-height: 25px;\n    box-sizing: border-box;\n    border-width: 0;\n    border-style: solid;\n    border-radius: 0.375rem;\n    text-align: start;\n    outline: 0;\n    cursor: default;\n    position: absolute;\n    overflow: hidden;\n    padding-right: 1rem;\n}\n\nkendo-scheduler .k-event > div,\n.k-event > div {\n    position: relative;\n    z-index: 2;\n}\n\nkendo-scheduler .k-event .k-event-template,\n.k-event .k-event-template {\n    line-height: calc(25px - 0.5rem);\n    padding-block: 0.5rem;\n    padding-inline: 1rem;\n}\n\nkendo-scheduler .k-event .k-event-time,\n.k-event .k-event-time {\n    padding-bottom: 0;\n    font-size: .875em;\n    white-space: nowrap;\n    display: none;\n}\n\nkendo-scheduler .k-event .k-event-actions,\n.k-event .k-event-actions {\n    white-space: nowrap;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 1rem;\n    z-index: 2;\n}\n\nkendo-scheduler .k-event .k-event-actions .k-event-delete,\n.k-event .k-event-actions .k-event-delete {\n    opacity: .5;\n    visibility: hidden;\n}\n\nkendo-scheduler .k-event .k-event-actions:hover .k-event-delete, kendo-scheduler .k-event .k-event-actions.k-hover .k-event-delete,\n.k-event .k-event-actions:hover .k-event-delete,\n.k-event .k-event-actions.k-hover .k-event-delete {\n    opacity: 1;\n}\n\nkendo-scheduler .k-event .k-event-actions a,\n.k-event .k-event-actions a {\n    color: inherit;\n}\n\nkendo-scheduler .k-event .k-event-actions:first-child,\n.k-event .k-event-actions:first-child {\n    margin: 0.25rem 0.4ex 0 0.5rem;\n    top: 0;\n    right: 0;\n    float: left;\n    position: relative;\n    opacity: 1;\n    visibility: visible;\n    line-height: normal;\n}\n\nkendo-scheduler .k-event .k-resize-handle,\n.k-event .k-resize-handle {\n    z-index: 4;\n    opacity: .5;\n    visibility: hidden;\n}\n\nkendo-scheduler .k-event .k-resize-handle::before,\n.k-event .k-resize-handle::before {\n    border-color: currentColor;\n}\n\nkendo-scheduler .k-event .k-resize-n,\n.k-event .k-resize-n {\n    height: .5em;\n    top: 0;\n}\n\nkendo-scheduler .k-event .k-resize-s,\n.k-event .k-resize-s {\n    height: .5em;\n    bottom: 0;\n}\n\nkendo-scheduler .k-event .k-resize-n::before,\nkendo-scheduler .k-event .k-resize-s::before,\n.k-event .k-resize-n::before,\n.k-event .k-resize-s::before {\n    width: 2rem;\n    border-bottom-width: 1px;\n}\n\nkendo-scheduler .k-event .k-resize-w,\n.k-event .k-resize-w {\n    width: .5em;\n    left: 0;\n}\n\nkendo-scheduler .k-event .k-resize-e,\n.k-event .k-resize-e {\n    width: .5em;\n    right: 0;\n}\n\nkendo-scheduler .k-event .k-resize-w::before,\nkendo-scheduler .k-event .k-resize-e::before,\n.k-event .k-resize-w::before,\n.k-event .k-resize-e::before {\n    height: 2rem;\n    border-left-width: 1px;\n}\n\nkendo-scheduler .k-event:hover .k-event-actions .k-event-delete,\nkendo-scheduler .k-event:hover .k-resize-handle, kendo-scheduler .k-event.k-hover .k-event-actions .k-event-delete,\nkendo-scheduler .k-event.k-hover .k-resize-handle,\n.k-event:hover .k-event-actions .k-event-delete,\n.k-event:hover .k-resize-handle,\n.k-event.k-hover .k-event-actions .k-event-delete,\n.k-event.k-hover .k-resize-handle {\n    visibility: visible;\n}\n\nkendo-scheduler .k-event.k-event-drag-hint .k-event-time,\n.k-event.k-event-drag-hint .k-event-time {\n    display: block;\n}\n\nkendo-scheduler .k-event .k-event-top-actions,\nkendo-scheduler .k-event .k-event-bottom-actions,\n.k-event .k-event-top-actions,\n.k-event .k-event-bottom-actions {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n}\n\nkendo-scheduler .k-event .k-event-bottom-actions,\n.k-event .k-event-bottom-actions {\n    top: auto;\n    bottom: 0;\n}\n\n.k-scheduler-mark {\n    width: 1em;\n    height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.k-more-events {\n    padding: 0;\n    height: 13px;\n    border-style: solid;\n    border-width: 1px;\n    overflow: hidden;\n    position: absolute;\n    justify-content: center;\n}\n\n.k-more-events > .k-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.k-event-drag-hint {\n    opacity: .5;\n    z-index: 3;\n}\n\n.k-event-drag-hint .k-event-actions,\n.k-event-drag-hint .k-event-top-actions,\n.k-event-drag-hint .k-event-bottom-actions,\n.k-event-drag-hint .k-resize-handle {\n    display: none;\n}\n\n.k-event-drag-hint .k-event-time {\n    display: block;\n}\n\n.k-scheduler-marquee {\n    border-width: 0;\n    border-style: solid;\n}\n\n.k-scheduler-marquee .k-label-top,\n.k-scheduler-marquee .k-label-bottom {\n    font-size: .75em;\n    position: absolute;\n}\n\n.k-scheduler-marquee .k-label-top {\n    left: 0.5rem;\n    top: 0.25rem;\n}\n\n.k-scheduler-marquee .k-label-bottom {\n    right: 0.5rem;\n    bottom: 0.25rem;\n}\n\n.k-scheduler-marquee.k-first::before, .k-scheduler-marquee.k-last::after {\n    content: \"\";\n    border-width: 3px;\n    border-style: solid;\n    position: absolute;\n    width: 0;\n    height: 0;\n}\n\n.k-scheduler-marquee.k-first::before {\n    top: 0;\n    left: 0;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n}\n\n.k-scheduler-marquee.k-last::after {\n    bottom: 0;\n    right: 0;\n    border-left-color: transparent;\n    border-top-color: transparent;\n}\n\n.k-pdf-export-shadow .k-scheduler,\n.k-scheduler-pdf-export .k-scheduler-content,\n.k-scheduler-pdf-export .k-scheduler-times {\n    height: auto !important;\n    overflow: visible !important;\n}\n\n.k-scheduler-pdf-export {\n    overflow: hidden;\n}\n\n.k-scheduler-pdf-export .k-scheduler-header {\n    padding: 0 !important;\n}\n\n.k-scheduler-pdf-export .k-scheduler-header-wrap {\n    border-width: 0 !important;\n}\n\n.k-scheduler-pdf-export .k-scheduler-header .k-scheduler-table,\n.k-scheduler-pdf-export .k-scheduler-content .k-scheduler-table {\n    width: 100% !important;\n}\n\n.k-recurrence-editor {\n    display: flex;\n    flex-direction: column;\n}\n\nkendo-scheduler .k-recurrence-editor {\n    display: block;\n}\n\n.k-scheduler-monthview .k-scheduler-table {\n    height: 100%;\n}\n\n.k-scheduler-monthview .k-scheduler-table td {\n    height: 80px;\n    text-align: end;\n}\n\n.k-scheduler-monthview .k-scheduler-body .k-scheduler-cell {\n    min-height: 80px;\n}\n\n.k-scheduler-monthview .k-hidden {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    border-right-width: 0 !important;\n}\n\n.k-scheduler-monthview .k-scheduler-table-auto,\n.k-scheduler-monthview .k-scheduler-table-auto td,\n.k-scheduler-monthview .k-scheduler-content .k-scheduler-table-auto {\n    height: auto;\n}\n\n.k-scheduler-monthview .k-scheduler-content {\n    overflow-y: scroll;\n}\n\n.k-scheduler-monthview.k-scheduler-flex-layout .k-scheduler-content {\n    overflow-y: auto;\n}\n\n.k-scheduler-agendaview .k-scheduler-mark {\n    margin-right: .5em;\n    width: 1em;\n    height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.k-scheduler-agendaview .k-scheduler-table th:first-child,\n.k-scheduler-agendaview .k-scheduler-table td:first-child {\n    border-left-width: 1px;\n}\n\n.k-scheduler-agendaview .k-scheduler-table td.k-first {\n    border-left-width: 0;\n}\n\n.k-scheduler-agendaview .k-task > .k-event-delete {\n    color: inherit;\n    position: absolute;\n    top: 0.25rem;\n    right: 0.25rem;\n    opacity: .5;\n    visibility: hidden;\n}\n\n.k-scheduler-agendaview .k-hover .k-task > .k-event-delete,\n.k-scheduler-agendaview .k-scheduler-content tr:hover .k-event-delete,\n.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row:hover .k-event-delete,\n.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row.k-hover .k-event-delete {\n    visibility: visible;\n}\n\n.k-scheduler-agendaday {\n    margin: 0 .2em 0 0;\n    font-size: 3em;\n    line-height: 1;\n    font-weight: 400;\n    float: left;\n}\n\n.k-scheduler-agendaweek {\n    display: block;\n    margin: .4em 0 0;\n    line-height: 1;\n    font-style: normal;\n}\n\n.k-scheduler-agendadate {\n    font-size: .75em;\n}\n\n.k-scheduler-timelineview .k-slot-cell {\n    overflow: hidden;\n}\n\n.k-scheduler-timelineview .k-scheduler-content {\n    overflow: auto;\n}\n\n.k-scheduler-pane {\n    display: flex;\n    flex-direction: row;\n}\n\n.k-scheduler-pane .k-scheduler-times {\n    flex: 0 0 auto;\n}\n\n.k-scheduler-pane .k-scheduler-times .k-scheduler-table {\n    height: 100%;\n}\n\n.k-scheduler-pane .k-scheduler-header,\n.k-scheduler-pane .k-scheduler-content {\n    flex: 1 1 auto;\n}\n\n.k-scheduler-yearview .k-scheduler-body {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    justify-content: center;\n}\n\n.k-scheduler-yearview .k-calendar {\n    width: 100%;\n    border-width: 0;\n}\n\n.k-scheduler-yearview .k-calendar .k-calendar-view {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.k-scheduler-yearview .k-calendar .k-content {\n    flex: 0;\n}\n\n.k-scheduler-yearview .k-calendar .k-link {\n    position: relative;\n}\n\n.k-scheduler-yearview .k-calendar td.k-selected {\n    background-color: inherit;\n}\n\n.k-scheduler-yearview .k-day-indicator {\n    margin-top: calc(38px - 0.5rem);\n    width: 3px;\n    height: 3px;\n    border-radius: 50%;\n    position: absolute;\n    left: calc(50% - 1.5px);\n}\n\n.k-scheduler-tooltip {\n    padding-block: 0.75rem;\n    padding-inline: 0.75rem;\n    border-width: 0;\n    color: inherit;\n}\n\n.k-scheduler-tooltip .k-tooltip-title {\n    margin-bottom: 0.75rem;\n}\n\n.k-scheduler-tooltip .k-tooltip-title .k-month {\n    font-size: 0.875rem;\n    text-transform: uppercase;\n}\n\n.k-scheduler-tooltip .k-tooltip-title .k-day {\n    font-size: 1.75rem;\n}\n\n.k-scheduler-tooltip .k-tooltip-events-container {\n    overflow: auto;\n}\n\n.k-scheduler-tooltip .k-tooltip-events {\n    max-height: 250px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.k-scheduler-tooltip .k-tooltip-event {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    border-radius: 0.375rem;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-shrink: 0;\n    position: relative;\n    gap: 0.5rem;\n}\n\n.k-scheduler-tooltip .k-tooltip-event .k-event-time {\n    display: flex;\n    flex-shrink: 0;\n    font-size: inherit;\n}\n\n.k-scheduler-tooltip .k-no-data, .k-scheduler-tooltip .k-nodata {\n    height: auto;\n    min-height: auto;\n    color: inherit;\n}\n\n.k-scheduler-edit-dialog .k-dialog {\n    max-height: 100vh;\n}\n\n.k-scheduler-edit-form .k-edit-form-container {\n    width: 100%;\n}\n\n.k-scheduler-edit-form .k-edit-label {\n    width: 17%;\n}\n\n.k-scheduler-edit-form .k-edit-field {\n    width: 77%;\n}\n\n.k-scheduler-edit-form .k-edit-field > ul > li {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n}\n\n.k-scheduler-edit-form .k-recurrence-editor .k-radio-list .k-radio-wrap,\n.k-scheduler-edit-form .k-recurrence-editor .k-checkbox-list .k-checkbox-wrap {\n    align-self: center;\n}\n\n.k-scheduler-edit-form .k-recur-interval,\n.k-scheduler-edit-form .k-recur-count,\n.k-scheduler-edit-form .k-recur-monthday {\n    width: 5em;\n}\n\n.k-scheduler-edit-form .k-recur-until,\n.k-scheduler-edit-form .k-recur-month,\n.k-scheduler-edit-form .k-recur-weekday,\n.k-scheduler-edit-form .k-recur-weekday-offset {\n    width: 10em;\n}\n\n.k-scheduler-edit-form .k-scheduler-datetime-picker {\n    display: flex;\n    flex-flow: row nowrap;\n    gap: 0.5rem;\n}\n\n.k-rtl .k-scheduler-header th,\n.k-rtl .k-scheduler-table td {\n    border-width: 0 1px 1px 0;\n}\n\n.k-rtl .k-scheduler-table td:first-child,\n.k-rtl .k-scheduler-table th:first-child {\n    border-right-width: 0;\n}\n\n.k-rtl .k-scheduler-times th {\n    border-width: 0 0 1px 1px;\n}\n\n.k-rtl .k-scheduler .k-scrollbar-v .k-scheduler-header-wrap {\n    border-right-width: 0;\n    border-left-width: 1px;\n}\n\n.k-rtl .k-event {\n    padding-right: 0;\n    padding-left: 1rem;\n}\n\n.k-rtl .k-event .k-resize-w {\n    left: auto;\n    right: 0;\n}\n\n.k-rtl .k-event .k-resize-e {\n    right: auto;\n    left: 0;\n}\n\n.k-rtl .k-event .k-event-actions {\n    right: auto;\n    left: 2px;\n}\n\n.k-rtl .k-event .k-event-actions:first-child {\n    margin: 0.25rem 0.5rem 0 0.4ex;\n    float: right;\n}\n\n.k-rtl .k-scheduler-agendaview .k-task > .k-event-delete {\n    left: 2px;\n    right: auto;\n}\n\n.k-rtl .k-scheduler-agendaview .k-task .k-scheduler-mark {\n    margin-left: .5em;\n    margin-right: 0;\n}\n\n.k-rtl .k-scheduler-marquee .k-label-top {\n    left: auto;\n    right: 4px;\n}\n\n.k-rtl .k-scheduler-marquee .k-label-bottom {\n    left: 4px;\n    right: auto;\n}\n\n.k-rtl .k-scheduler-edit-form .k-scheduler-delete {\n    float: right;\n}\n\n.k-rtl .k-scheduler .k-scheduler-header-wrap, .k-rtl.k-scheduler .k-scheduler-header-wrap {\n    border-right-width: 0;\n}\n\n.k-rtl .k-scheduler .k-scheduler-agendaday, .k-rtl.k-scheduler .k-scheduler-agendaday {\n    float: right;\n    margin: 0 0 0 .2em;\n}\n\n.k-rtl .k-scheduler .k-scheduler-agendaview .k-scheduler-table td:first-child,\n.k-rtl .k-scheduler .k-scheduler-agendaview .k-scheduler-table th:first-child, .k-rtl.k-scheduler .k-scheduler-agendaview .k-scheduler-table td:first-child,\n.k-rtl.k-scheduler .k-scheduler-agendaview .k-scheduler-table th:first-child {\n    border-left-width: 0;\n}\n\n.k-rtl .k-scheduler .k-scheduler-agendaview .k-scheduler-table tr + tr td:first-child,\n.k-rtl .k-scheduler .k-scheduler-agendaview .k-scheduler-table tr + tr th:first-child, .k-rtl.k-scheduler .k-scheduler-agendaview .k-scheduler-table tr + tr td:first-child,\n.k-rtl.k-scheduler .k-scheduler-agendaview .k-scheduler-table tr + tr th:first-child {\n    border-right-width: 1px;\n}\n\n.k-safari .k-scheduler-tooltip .k-tooltip-event:not(:last-child) {\n    margin-bottom: 0.5rem;\n}\n\n.k-safari .k-scheduler-yearview .k-calendar-view .k-month {\n    margin-block: 0;\n    margin-inline: 0.5rem;\n}\n\nkendo-scheduler .k-event::before,\n.k-event::before {\n    display: none;\n    left: 0;\n}\n\n.k-rtl kendo-scheduler .k-event::before, .k-rtl\n.k-event::before {\n    right: 0;\n}\n\nkendo-scheduler .k-event .k-event-template,\n.k-event .k-event-template {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    font-size: 0.875rem;\n}\n\nkendo-scheduler .k-event .k-event-actions,\n.k-event .k-event-actions {\n    right: 0.5rem;\n}\n\nkendo-scheduler .k-event .k-event-actions:first-child,\n.k-event .k-event-actions:first-child {\n    margin: 0.1ex 0.4ex 0 0.5rem;\n}\n\n.k-scheduler {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-scheduler-toolbar {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-scheduler-footer {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-scheduler-header {\n    background-color: #f8f9fa;\n}\n\n.k-scheduler-header-wrap {\n    background-color: #ffffff;\n}\n\n.k-scheduler-nonwork,\n.k-scheduler .k-nonwork-hour {\n    background-color: whitesmoke;\n}\n\n.k-scheduler-other-month,\n.k-scheduler .k-other-month {\n    background-color: whitesmoke;\n}\n\n.k-scheduler-layout td.k-selected,\n.k-scheduler-layout .k-scheduler-cell.k-selected {\n    background-color: rgba(13, 110, 253, 0.25);\n}\n\n.k-scheduler-layout-flex .k-scheduler-head,\n.k-scheduler-layout-flex .k-sticky-cell {\n    background-color: #ffffff;\n}\n\n.k-event {\n    color: white;\n    background-color: #3485fd;\n}\n\n.k-event.k-selected {\n    color: white;\n    background-color: #0d6efd;\n    box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.5);\n}\n\n.k-event.k-event-inverse {\n    color: black;\n}\n\n.k-event.k-event-ongoing {\n    box-shadow: inset 0px 0px 0px 1px #ff0000;\n}\n\n.k-scheduler-marquee::before,\n.k-scheduler-marquee::after {\n    border-color: #0d6efd;\n}\n\n.k-scheduler-edit-dialog .k-dialog-actions {\n    border-color: #dee2e6;\n}\n\n.k-scheduler-agendaview .k-scheduler-content tr:hover,\n.k-scheduler-agendaview .k-scheduler-content tr.k-hover,\n.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row:hover,\n.k-scheduler-agendaview .k-scheduler-content .k-scheduler-row.k-hover {\n    border-color: #d6d9dc;\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.k-scheduler-agendaview .k-scheduler-content tr:hover .k-scheduler-datecolumn,\n.k-scheduler-agendaview .k-scheduler-content tr:hover .k-scheduler-groupcolumn,\n.k-scheduler-agendaview .k-scheduler-content tr.k-hover .k-scheduler-datecolumn,\n.k-scheduler-agendaview .k-scheduler-content tr.k-hover .k-scheduler-groupcolumn {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-scheduler-agendaview .k-scheduler-content tr.k-selected {\n    background-color: rgba(13, 110, 253, 0.25);\n}\n\n.k-scheduler-agendaview .k-scheduler-content tr.k-selected .k-scheduler-datecolumn,\n.k-scheduler-agendaview .k-scheduler-content tr.k-selected .k-scheduler-groupcolumn {\n    background-color: #ffffff;\n}\n\n.k-scheduler-yearview .k-day-indicator {\n    background-color: #0d6efd;\n}\n\n.k-scheduler-yearview .k-selected .k-day-indicator {\n    background-color: white;\n}\n\n.k-tooltip.k-scheduler-tooltip {\n    color: #212529;\n    background-color: white;\n    box-shadow: var(--kendo-elevation-2, 0px 2px 7px rgba(0, 0, 0, 0.075));\n}\n\n.k-tooltip.k-scheduler-tooltip .k-callout {\n    color: white;\n}\n\n.k-chat {\n    margin: auto;\n    max-width: 500px;\n    height: 600px;\n    max-height: 100%;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-chat .k-message-list {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-items: flex-start;\n    overflow-x: hidden;\n    overflow-y: auto;\n    scroll-behavior: smooth;\n}\n\n.k-chat .k-message-list-content {\n    padding-block: 16px;\n    padding-inline: 16px;\n    width: 100%;\n    box-sizing: border-box;\n    position: relative;\n    flex: 0 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    overflow: hidden;\n}\n\n.k-chat .k-message-list-content > * + * {\n    margin-top: 16px;\n}\n\n.k-chat .k-message-group {\n    max-width: 80%;\n    background: none;\n    box-sizing: border-box;\n    display: flex;\n    flex-shrink: 0;\n    flex-direction: column;\n    position: relative;\n}\n\n.k-chat .k-message-group:not(.k-alt) {\n    align-items: flex-start;\n    text-align: start;\n}\n\n.k-chat .k-message-group:not(.k-alt) .k-message-time {\n    margin-inline-start: 8px;\n    inset-inline-start: 100%;\n}\n\n.k-chat .k-message-group:not(.k-alt) .k-message-status {\n    inset-inline-start: 0;\n}\n\n.k-chat .k-message-group:not(.k-alt) .k-first .k-chat-bubble,\n.k-chat .k-message-group:not(.k-alt) .k-only .k-chat-bubble {\n    border-bottom-left-radius: 2px;\n}\n\n.k-chat .k-message-group:not(.k-alt) .k-middle .k-chat-bubble,\n.k-chat .k-message-group:not(.k-alt) .k-last .k-chat-bubble {\n    border-top-left-radius: 2px;\n    border-bottom-left-radius: 2px;\n}\n\n.k-chat .k-message-group.k-alt {\n    align-self: flex-end;\n    align-items: flex-end;\n    text-align: end;\n}\n\n.k-chat .k-message-group.k-alt .k-message-time {\n    margin-inline-end: 8px;\n    inset-inline-end: 100%;\n}\n\n.k-chat .k-message-group.k-alt .k-message-status {\n    inset-inline-end: 0;\n}\n\n.k-chat .k-message-group.k-alt .k-first .k-chat-bubble,\n.k-chat .k-message-group.k-alt .k-only .k-chat-bubble {\n    border-bottom-right-radius: 2px;\n}\n\n.k-chat .k-message-group.k-alt .k-middle .k-chat-bubble,\n.k-chat .k-message-group.k-alt .k-last .k-chat-bubble {\n    border-top-right-radius: 2px;\n    border-bottom-right-radius: 2px;\n}\n\n.k-chat .k-message {\n    max-width: 100%;\n    margin: 2px 0 0;\n    position: relative;\n    transition: margin .2s ease-in-out;\n    outline: none;\n}\n\n.k-chat .k-message-time,\n.k-chat .k-message-status {\n    font-size: smaller;\n    line-height: normal;\n    white-space: nowrap;\n    pointer-events: none;\n    position: absolute;\n}\n\n.k-chat .k-message-time {\n    opacity: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: opacity .2s ease-in-out;\n}\n\n.k-chat .k-message-status {\n    margin-top: 2px;\n    height: 0;\n    overflow: hidden;\n    top: 100%;\n    transition: height .2s ease-in-out;\n}\n\n.k-chat .k-chat-bubble {\n    border-radius: 12px;\n    padding-block: 8px;\n    padding-inline: 16px;\n    border-width: 1px;\n    border-style: solid;\n    line-height: 1.25;\n    word-wrap: break-word;\n    white-space: pre-wrap;\n}\n\n.k-chat .k-chat-bubble a {\n    color: inherit;\n    text-decoration: underline;\n}\n\n.k-chat .k-message.k-selected {\n    margin-bottom: 16px;\n    border: 0;\n    color: inherit;\n    background: none;\n}\n\n.k-chat .k-message.k-selected .k-message-time {\n    opacity: 1;\n}\n\n.k-chat .k-message.k-selected .k-message-status {\n    height: 1.2em;\n}\n\n.k-chat .k-message-error,\n.k-chat .k-message-sending {\n    margin-bottom: 16px;\n}\n\n.k-chat .k-message-error .k-message-status,\n.k-chat .k-message-sending .k-message-status {\n    height: 1.2em;\n}\n\n.k-chat .k-avatar {\n    margin: 0;\n    position: absolute;\n}\n\n.k-message-group:not(.k-alt) > .k-avatar {\n    inset-inline-start: 0;\n    bottom: 0;\n}\n\n.k-message-group.k-alt > .k-avatar {\n    inset-inline-end: 0;\n    bottom: 0;\n}\n\n.k-chat .k-avatars .k-message-group:not(.k-no-avatar) {\n    padding-inline-start: 40px;\n}\n\n.k-chat .k-avatars .k-message-group.k-alt:not(.k-no-avatar) {\n    padding-inline-end: 40px;\n}\n\n.k-author {\n    margin: 0;\n    font-size: smaller;\n    line-height: normal;\n}\n\n.k-chat .k-author {\n    margin: 0;\n}\n\n.k-chat .k-timestamp {\n    font-size: smaller;\n    text-transform: uppercase;\n    text-align: center;\n    align-self: stretch;\n}\n\n.k-quick-replies {\n    display: block;\n    max-width: 100%;\n}\n\n.k-quick-reply {\n    border-radius: 100px;\n    margin-inline-end: 8px;\n    margin-block-end: 4px;\n    padding-block: 8px;\n    padding-inline: 12px;\n    border-width: 1px;\n    border-style: solid;\n    line-height: 1.25;\n    cursor: pointer;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    display: inline-block;\n    flex: 0 0 auto;\n    transition-property: color, background-color, border-color;\n    transition-duration: .2s;\n    transition-timing-function: ease-in-out;\n    outline: none;\n}\n\n.k-scrollable-quick-replies {\n    margin-inline-start: -16px;\n    margin-inline-end: -16px;\n    padding-inline-start: 16px;\n    padding-inline-end: 16px;\n    display: flex;\n    flex-flow: row nowrap;\n    flex: 0 0 auto;\n    overflow-x: auto;\n    overflow-y: hidden;\n}\n\n.k-scrollable-quick-replies::-webkit-scrollbar {\n    display: none;\n}\n\n.k-scrollable-quick-replies .k-quick-reply {\n    margin: 0;\n}\n\n.k-scrollable-quick-replies .k-quick-reply + .k-quick-reply {\n    margin-inline-start: 8px;\n}\n\n.k-message-box {\n    width: 100%;\n    height: auto;\n    box-sizing: border-box;\n    border-width: 1px 0 0;\n    border-style: solid;\n    border-color: inherit !important;\n    border-radius: 0 !important;\n    flex: none;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n}\n\n.k-message-box:focus, .k-message-box.k-focus, .k-message-box:focus-within {\n    outline: 0;\n    box-shadow: none;\n}\n\n.k-message-box .k-button {\n    border-width: 0;\n    flex-shrink: 0;\n}\n\n.k-message-box .k-button svg {\n    width: 20px;\n    height: 20px;\n    fill: currentColor;\n    display: inline-block;\n}\n\n.k-rtl .k-message-box .k-button,\n[dir=\"rtl\"] .k-message-box .k-button {\n    transform: scaleX(-1);\n}\n\n.k-chat .k-card-list {\n    margin: 2px 0 0;\n}\n\n.k-message-group.k-alt + .k-card-list,\n.k-message-group.k-alt + kendo-chat-message-attachments.k-card-list {\n    align-self: flex-end;\n}\n\n.k-chat .k-card-deck {\n    max-width: calc(100% + 32px);\n    box-sizing: border-box;\n    margin-inline-start: -16px;\n    margin-inline-end: -16px;\n    padding: 16px 16px 16px;\n    overflow: hidden;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n}\n\n.k-chat .k-card-deck .k-card {\n    width: 200px;\n}\n\n.k-chat .k-card-deck-scrollwrap {\n    margin-right: -16px;\n    margin-left: -16px;\n    padding-left: 16px;\n    padding-right: 16px;\n}\n\n.k-chat .k-card-deck-scrollwrap > .k-card-deck {\n    margin-bottom: -20px;\n    padding-bottom: 20px;\n}\n\n.k-chat .k-card-deck .k-card-wrap {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: stretch;\n    flex: 0 0 auto;\n    padding-bottom: 5px;\n}\n\n.k-chat .k-card-deck .k-card-wrap .k-card {\n    flex: 0 0 auto;\n}\n\n.k-chat .k-card-deck .k-card-wrap.k-selected {\n    background: none;\n}\n\n.k-typing-indicator {\n    padding: 0;\n    border-radius: 50px;\n    display: inline-flex;\n    flex-flow: row nowrap;\n}\n\n.k-typing-indicator span {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex: 0 0 8px;\n    background-color: currentColor;\n    opacity: .4;\n}\n\n.k-typing-indicator span:nth-of-type(1) {\n    animation: 1s k-animation-blink infinite 0.3333s;\n}\n\n.k-typing-indicator span:nth-of-type(2) {\n    animation: 1s k-animation-blink infinite 0.6666s;\n}\n\n.k-typing-indicator span:nth-of-type(3) {\n    animation: 1s k-animation-blink infinite 0.9999s;\n}\n\n.k-typing-indicator span + span {\n    margin-left: 5px;\n}\n\n@keyframes k-animation-blink {\n    50% {\n        opacity: 1;\n    }\n}\n\n.k-chat-toolbar,\n.k-chat .k-toolbar-box {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    width: 100%;\n    border-width: 1px 0 0;\n    box-sizing: border-box;\n    flex: none;\n    overflow: hidden;\n    position: relative;\n    gap: 0.5rem;\n}\n\n.k-chat-toolbar::before,\n.k-chat .k-toolbar-box::before {\n    display: none;\n}\n\n.k-chat-toolbar .k-button-list,\n.k-chat .k-toolbar-box .k-button-list {\n    display: flex;\n    flex-flow: row nowrap;\n    overflow: hidden;\n    scroll-behavior: smooth;\n}\n\n.k-chat-toolbar .k-button,\n.k-chat .k-toolbar-box .k-button {\n    flex: none;\n}\n\n.k-chat-toolbar .k-scroll-button,\n.k-chat .k-toolbar-box .k-scroll-button {\n    padding: 0 0.25rem;\n    height: 100%;\n    aspect-ratio: auto;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n}\n\n.k-chat-toolbar .k-scroll-button .k-button-icon,\n.k-chat .k-toolbar-box .k-scroll-button .k-button-icon {\n    min-width: auto;\n    min-height: auto;\n}\n\n.k-chat-toolbar .k-scroll-button-left,\n.k-chat .k-toolbar-box .k-scroll-button-left {\n    left: 0;\n}\n\n.k-chat-toolbar .k-scroll-button-right,\n.k-chat .k-toolbar-box .k-scroll-button-right {\n    right: 0;\n}\n\n.k-chat {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #fafafa;\n}\n\n.k-chat .k-timestamp {\n    color: #6c757d;\n}\n\n.k-chat .k-author {\n    font-weight: bold;\n}\n\n.k-chat .k-chat-bubble {\n    border-color: #e4e7eb;\n    color: #212529;\n    background-color: #e4e7eb;\n    box-shadow: none;\n    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n    order: -1;\n}\n\n.k-chat .k-chat-bubble a {\n    color: #0d6efd;\n}\n\n.k-chat .k-chat-bubble a:hover {\n    color: #0a58ca;\n}\n\n.k-chat .k-chat-bubble:hover {\n    box-shadow: none;\n}\n\n.k-chat .k-selected .k-chat-bubble {\n    box-shadow: none;\n}\n\n.k-chat .k-alt .k-chat-bubble {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n    box-shadow: none;\n}\n\n.k-chat .k-alt .k-chat-bubble:hover {\n    box-shadow: none;\n}\n\n.k-chat .k-alt .k-selected .k-chat-bubble {\n    box-shadow: none;\n}\n\n.k-chat .k-quick-reply {\n    border-color: #0d6efd;\n    color: #0d6efd;\n    background-color: transparent;\n}\n\n.k-chat .k-quick-reply:hover {\n    border-color: #0d6efd;\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-chat-toolbar,\n.k-chat .k-toolbar-box {\n    border-color: inherit;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-mediaplayer {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: block;\n    position: relative;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-mediaplayer *,\n.k-mediaplayer *::before,\n.k-mediaplayer *::after {\n    box-sizing: border-box;\n}\n\n.k-mediaplayer > iframe {\n    width: 100%;\n    height: 100%;\n    border: 0;\n    vertical-align: top;\n}\n\n.k-mediaplayer-titlebar {\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.k-mediaplayer-toolbar-wrap {\n    position: absolute;\n    z-index: 2;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n\n.k-mediaplayer-toolbar {\n    border-width: 0;\n    width: 100% !important;\n    box-shadow: none;\n}\n\n.k-mediaplayer-toolbar .k-dropdown-list, .k-mediaplayer-toolbar .k-dropdown,\n.k-mediaplayer-toolbar .k-dropdownlist {\n    width: auto;\n}\n\n.k-mediaplayer-time-wrap {\n    flex: 1;\n}\n\n.k-mediaplayer-volume-wrap {\n    padding: 0 7px;\n    align-items: center;\n}\n\n.k-mediaplayer-volume {\n    width: 100px;\n}\n\n.k-slider.k-mediaplayer-seekbar {\n    width: 100%;\n    position: absolute;\n    z-index: 3;\n    top: 0;\n    left: 0;\n    transform: translateY(-50%);\n}\n\n.k-mediaplayer-seekbar .k-slider-track {\n    width: 100% !important;\n    border-radius: 0;\n}\n\n.k-mediaplayer-seekbar .k-slider-selection {\n    border-radius: 0;\n}\n\n.k-mediaplayer-fullscreen {\n    z-index: 10000;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.k-mediaplayer {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-mediaplayer-titlebar {\n    color: #ffffff;\n    background-image: linear-gradient(rgba(33, 37, 41, 0.7), rgba(33, 37, 41, 0));\n    text-shadow: 0 0 2px rgba(33, 37, 41, 0.5);\n}\n\n.k-timeline {\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: block;\n    background-color: transparent;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-timeline *,\n.k-timeline *::before,\n.k-timeline *::after, .k-timeline::before, .k-timeline::after {\n    box-sizing: border-box;\n}\n\n.k-timeline ul {\n    margin: 0;\n    padding: 0;\n}\n\n.k-timeline ul li {\n    list-style-type: none;\n}\n\n.k-timeline .k-timeline-flag {\n    display: inline-block;\n    text-align: center;\n    padding-block: 0.375rem;\n    padding-inline: 0.75rem;\n    border-radius: 0.375rem;\n    line-height: 1.5;\n    min-width: 80px;\n    max-width: 160px;\n    position: relative;\n    z-index: 1;\n}\n\n.k-timeline .k-timeline-circle {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    position: relative;\n    z-index: 1;\n}\n\n.k-timeline.k-timeline-dates-hidden .k-timeline-date {\n    display: none;\n}\n\n.k-timeline.k-timeline-collapsible .k-card-header {\n    cursor: pointer;\n}\n\n.k-timeline.k-timeline-collapsible .k-event-collapse {\n    display: flex;\n}\n\n.k-timeline-card .k-card {\n    position: relative;\n    overflow: visible;\n}\n\n.k-timeline-card .k-card .k-card-header {\n    overflow: visible;\n    border-bottom: 0;\n}\n\n.k-timeline-card .k-card .k-card-header + .k-card-body {\n    padding-top: 0;\n}\n\n.k-timeline-card .k-card .k-card-body {\n    overflow-y: auto;\n    scrollbar-width: thin;\n}\n\n.k-timeline-card .k-card .k-card-body::-webkit-scrollbar {\n    width: 5px;\n}\n\n.k-timeline-card .k-card .k-card-body::-webkit-scrollbar-thumb {\n    border-radius: 0.375rem;\n}\n\n.k-timeline-card .k-timeline-card-callout.k-callout-w, .k-timeline-card .k-timeline-card-callout.k-callout-e {\n    top: 36px;\n}\n\n.k-timeline-vertical,\n.k-timeline-horizontal {\n    padding-block: 0;\n    padding-inline: 40px;\n    margin-block: 40px;\n    margin-inline: 0;\n    width: 100%;\n    position: relative;\n    border: 0;\n}\n\n.k-timeline-vertical::after,\n.k-timeline-horizontal .k-timeline-track-wrap::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    border-width: 1px;\n    border-style: solid;\n}\n\n.k-timeline-vertical {\n    padding-left: 127px;\n}\n\n.k-timeline-vertical.k-timeline-dates-hidden {\n    padding-left: 77px;\n}\n\n.k-timeline-vertical::after {\n    height: 100%;\n    width: 6px;\n    transform: translateX(-50%);\n    border-radius: 0.5rem;\n}\n\n.k-timeline-vertical .k-timeline-flag-wrap {\n    display: flex;\n    align-items: center;\n}\n\n.k-timeline-vertical .k-timeline-flag-wrap:first-child {\n    padding-top: 40px;\n}\n\n.k-timeline-vertical .k-timeline-flag {\n    transform: translateX(-50%);\n}\n\n.k-timeline-vertical .k-timeline-date-wrap {\n    position: absolute;\n    padding-right: 1rem;\n    margin-top: 36px;\n    transform: translate(-100%, -50%);\n    text-align: end;\n}\n\n.k-timeline-vertical .k-timeline-event {\n    display: flex;\n    align-items: flex-start;\n    padding-block: 40px;\n    padding-inline: 0;\n}\n\n.k-timeline-vertical .k-timeline-card {\n    padding-left: 1rem;\n}\n\n.k-timeline-vertical .k-timeline-card .k-card {\n    margin-left: 1rem;\n    min-height: 70px;\n    width: 400px;\n    max-width: 100%;\n}\n\n.k-timeline-vertical .k-timeline-card .k-card .k-card-header {\n    border-radius: 0.375rem;\n}\n\n.k-timeline-vertical .k-timeline-card .k-card .k-card-title {\n    display: flex;\n    justify-content: space-between;\n}\n\n.k-timeline-vertical .k-timeline-card .k-card .k-card-title .k-event-title {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.k-timeline-vertical .k-timeline-card .k-event-collapse {\n    margin-block: -0.5rem;\n    margin-inline: 0;\n    transform: rotate(90deg);\n    transition: transform .2s ease-in-out;\n}\n\n.k-timeline-vertical .k-timeline-card.k-collapsed .k-card-body,\n.k-timeline-vertical .k-timeline-card.k-collapsed .k-card-actions {\n    display: none;\n}\n\n.k-timeline-vertical .k-timeline-card.k-collapsed .k-event-collapse {\n    transform: rotate(0deg);\n}\n\n.k-timeline-vertical .k-timeline-circle {\n    margin-top: 36px;\n    transform: translate(-50%, -50%);\n    margin-right: -8px;\n}\n\n.k-timeline-vertical.k-timeline-alternating {\n    padding-left: 40px;\n}\n\n.k-timeline-vertical.k-timeline-alternating::after {\n    left: 50%;\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-flag-wrap {\n    justify-content: center;\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-flag {\n    transform: translateX(0);\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-event {\n    justify-content: space-between;\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-event.k-reverse {\n    flex-direction: row-reverse;\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-event.k-reverse .k-timeline-date-wrap {\n    text-align: start;\n    padding-right: 0;\n    padding-left: 1rem;\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-event.k-reverse .k-timeline-card {\n    padding-left: 0;\n    padding-right: 1rem;\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-event.k-reverse .k-timeline-card .k-card {\n    margin-right: 1rem;\n    margin-left: auto;\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-card,\n.k-timeline-vertical.k-timeline-alternating .k-timeline-date-wrap {\n    flex-basis: 50%;\n    min-width: 0;\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-date-wrap {\n    position: static;\n    transform: translateY(-50%);\n}\n\n.k-timeline-vertical.k-timeline-alternating .k-timeline-circle {\n    transform: translateY(-50%);\n    margin-right: 0;\n}\n\n.k-timeline-horizontal .k-timeline-track-item {\n    flex: 1 0 20%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    position: relative;\n    flex-direction: column;\n}\n\n.k-timeline-horizontal .k-timeline-track-item:hover {\n    cursor: pointer;\n}\n\n.k-timeline-horizontal .k-timeline-track-item.k-timeline-flag-wrap:hover {\n    cursor: default;\n}\n\n.k-timeline-horizontal .k-timeline-date-wrap {\n    margin-top: auto;\n    margin-bottom: 10px;\n}\n\n.k-timeline-horizontal .k-timeline-card {\n    height: 100%;\n}\n\n.k-timeline-horizontal .k-card {\n    max-height: 100%;\n}\n\n.k-timeline-horizontal .k-timeline-events-list {\n    overflow-x: hidden;\n    padding-top: 1rem;\n}\n\n.k-timeline-horizontal .k-timeline-events-list .k-timeline-scrollable-wrap {\n    position: relative;\n    height: 600px;\n}\n\n.k-timeline-horizontal .k-timeline-events-list .k-timeline-scrollable-wrap .k-timeline-event {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.k-timeline-horizontal .k-timeline-track-wrap {\n    position: relative;\n    padding: 19px 0;\n}\n\n.k-timeline-horizontal .k-timeline-track-wrap::after {\n    top: auto;\n    bottom: 22px;\n    left: 36px;\n    right: 36px;\n    transform: translateY(-50%);\n    height: 6px;\n}\n\n.k-timeline-horizontal .k-timeline-track-wrap .k-timeline-track {\n    overflow: hidden;\n    margin-block: 0;\n    margin-inline: 38px;\n    position: relative;\n    z-index: 2;\n}\n\n.k-timeline-horizontal .k-timeline-track-wrap .k-timeline-track .k-timeline-scrollable-wrap {\n    transition: transform 1s ease-in-out;\n}\n\n.k-timeline-horizontal .k-timeline-track-wrap .k-timeline-flag {\n    margin-bottom: 22px;\n    position: relative;\n    min-width: 80px;\n}\n\n.k-timeline-horizontal .k-timeline-track-wrap .k-timeline-flag::after {\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n    transform: translate(-50%, 50%) rotate(45deg);\n}\n\n.k-timeline-horizontal .k-timeline-scrollable-wrap {\n    padding-bottom: 3px;\n    display: flex;\n    outline: 0;\n}\n\n.k-timeline-arrow {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 11px;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.k-timeline-arrow-left {\n    left: 0;\n}\n\n.k-timeline-arrow-right {\n    right: 0;\n}\n\n.k-timeline-mobile {\n    padding-block: 0;\n    padding-inline: 1rem;\n    margin-block: 1rem;\n    margin-inline: 0;\n}\n\n.k-timeline-mobile .k-timeline-flag {\n    max-width: calc(80px + 2rem);\n}\n\n.k-timeline-mobile.k-timeline-horizontal .k-timeline-flag-wrap {\n    display: none;\n}\n\n.k-timeline-mobile.k-timeline-vertical {\n    padding-left: calc(1rem + 87px);\n}\n\n.k-timeline-mobile.k-timeline-vertical.k-timeline-dates-hidden {\n    padding-left: calc(1rem + 37px);\n}\n\n.k-timeline-mobile.k-timeline-vertical.k-timeline-alternating {\n    padding-left: 1rem;\n}\n\n.k-timeline-mobile.k-timeline-vertical .k-timeline-card {\n    width: 100%;\n}\n\n.k-timeline-mobile.k-timeline-vertical .k-timeline-card .k-card {\n    width: auto;\n}\n\n.k-timeline-card .k-card-header {\n    padding-top: 1rem;\n}\n\n.k-timeline .k-timeline-flag {\n    color: white;\n    background-color: #0d6efd;\n}\n\n.k-timeline .k-timeline-circle {\n    background-color: #0d6efd;\n}\n\n.k-timeline .k-timeline-card .k-card-header {\n    background-color: #ffffff;\n    color: #212529;\n}\n\n.k-timeline .k-timeline-card .k-card-body {\n    scrollbar-color: #dee2e6 #ffffff;\n}\n\n.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-track {\n    background: #ffffff;\n}\n\n.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-thumb {\n    background: #dee2e6;\n}\n\n.k-timeline .k-timeline-card .k-card-body::-webkit-scrollbar-thumb:hover {\n    background: #d6d9dc;\n}\n\n.k-timeline .k-timeline-date {\n    color: #212529;\n}\n\n.k-timeline .k-timeline-arrow.k-disabled {\n    opacity: 1;\n    color: #6f7174;\n    background-color: #edeff2;\n    border-color: #edeff2;\n}\n\n.k-timeline-vertical::after,\n.k-timeline-horizontal .k-timeline-track-wrap::after {\n    background-color: #e4e7eb;\n    border-color: #e4e7eb;\n}\n\n.k-timeline-horizontal .k-timeline-flag::after {\n    background-color: #0d6efd;\n}\n\n.k-timeline-track-item.k-focus .k-timeline-circle {\n    box-shadow: var(--kendo-elevation-2, 0px 2px 7px rgba(0, 0, 0, 0.075));\n}\n\n.k-pdf-viewer {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    position: relative;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-pdf-viewer .k-toolbar {\n    border-top-width: 0;\n    border-right-width: 0;\n    border-left-width: 0;\n    border-color: inherit;\n    flex: 0 0 auto;\n    z-index: 2;\n}\n\n.k-pdf-viewer .k-toolbar .k-pager-wrap,\n.k-pdf-viewer .k-toolbar .k-pager {\n    padding: 0;\n    border-width: 0;\n    color: inherit;\n    background: none;\n    overflow: visible;\n}\n\n.k-pdf-viewer .k-canvas {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    outline: none;\n}\n\n.k-pdf-viewer .k-canvas.k-enable-text-select {\n    -webkit-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n    cursor: text;\n}\n\n.k-pdf-viewer .k-canvas.k-enable-panning {\n    cursor: grab;\n}\n\n.k-pdf-viewer .k-canvas.k-enable-panning span::selection {\n    background-color: transparent;\n}\n\n.k-pdf-viewer .k-pdf-viewer-pages {\n    flex: 1 1 auto;\n}\n\n.k-pdf-viewer .k-page {\n    position: relative;\n    margin-block: 30px;\n    margin-inline: auto;\n}\n\n.k-pdf-viewer .k-page canvas {\n    direction: ltr;\n}\n\n.k-pdf-viewer .k-page .k-text-layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: .2;\n    overflow: hidden;\n}\n\n.k-pdf-viewer .k-page .k-text-layer > span {\n    position: absolute;\n    line-height: 1.2;\n    transform-origin: 0% 0%;\n    color: transparent;\n}\n\n.k-pdf-viewer .k-page .k-text-layer .k-search-highlight-mark {\n    color: transparent;\n}\n\n.k-pdf-viewer .k-blank-page {\n    margin: 0;\n    display: flex;\n    flex-flow: column nowrap;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    background-color: inherit !important;\n}\n\n.k-pdf-viewer .k-blank-page .k-upload,\n.k-pdf-viewer .k-blank-page .k-dropzone,\n.k-pdf-viewer .k-blank-page .k-dropzone-inner {\n    border: 0;\n    background: none;\n}\n\n.k-pdf-viewer-canvas > .k-search-panel {\n    width: max-content;\n    margin-top: calc(-1.5em + -2.75rem + -4px);\n    padding-block: 1rem;\n    padding-inline: 0.5rem;\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 0.25rem;\n    display: flex;\n    gap: 0.5rem;\n    flex-flow: row nowrap;\n    flex: 0 0 auto;\n    justify-content: flex-start;\n    align-items: center;\n    z-index: 10;\n    cursor: default;\n}\n\n.k-pdf-viewer-canvas > .k-search-panel .k-search-dialog-draghandle {\n    cursor: move;\n    margin-left: 0;\n}\n\n.k-pdf-viewer-canvas > .k-search-panel .k-textbox {\n    width: 10em;\n    flex: none;\n}\n\n.k-pdf-viewer-canvas > .k-search-panel .k-textbox .k-button {\n    border-width: 0;\n}\n\n.k-pdf-viewer-canvas > .k-search-panel .k-search-matches {\n    display: inline-flex;\n    gap: 0.5rem;\n}\n\n.k-pdf-viewer {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-pdf-viewer .k-canvas {\n    background-color: #fafafa;\n}\n\n.k-pdf-viewer .k-page {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: white;\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-pdf-viewer .k-blank-page > .k-icon {\n    color: #afb1b2;\n}\n\n.k-pdf-viewer .k-search-highlight {\n    background-color: #212529;\n}\n\n.k-pdf-viewer .k-search-highlight-mark {\n    background-color: yellow;\n}\n\n.k-pdf-viewer-canvas > .k-search-panel {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.km-scrollview,\n.km-scroll-container {\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    border-collapse: separate;\n}\n\n.km-scroll-wrapper {\n    position: relative;\n}\n\n.km-scroll-header {\n    position: absolute;\n    z-index: 1001;\n    width: 100%;\n    top: 0;\n    left: 0;\n}\n\n.km-scroller-pull {\n    width: 100%;\n    display: block;\n    position: absolute;\n    line-height: 3em;\n    font-size: 1.4em;\n    text-align: center;\n    transform: translate3d(0, -3em, 0);\n}\n\n.km-scroller-pull .km-template {\n    display: inline-block;\n    min-width: 200px;\n    text-align: start;\n}\n\n.km-load-more .km-icon,\n.km-widget .km-scroller-pull .km-icon {\n    display: inline-block;\n    height: 2rem;\n    margin-right: 1rem;\n    vertical-align: middle;\n    width: 2rem;\n    font-size: 2rem;\n    transform: rotate(0deg);\n    transition: transform 300ms linear;\n}\n\n.km-widget .km-scroller-release .km-icon {\n    transform: rotate(180deg);\n}\n\n.km-widget .km-scroller-refresh .km-icon {\n    transition: none;\n}\n\n.km-touch-scrollbar {\n    position: absolute;\n    visibility: hidden;\n    z-index: 200000;\n    height: .4em;\n    width: .4em;\n    opacity: 0;\n    transform-origin: 0 0;\n    transition: opacity .3s linear;\n}\n\n.k-map .km-touch-scrollbar,\n.k-diagram .km-touch-scrollbar {\n    display: none;\n}\n\n.km-vertical-scrollbar {\n    height: 100%;\n    right: 2px;\n    top: 0;\n}\n\n.km-horizontal-scrollbar {\n    width: 100%;\n    left: 0;\n    bottom: 2px;\n}\n\n.km-touch-scrollbar {\n    background-color: #333333;\n}\n\n.k-scrollview {\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    position: relative;\n    overflow: hidden;\n    display: block;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-scrollview-wrap {\n    position: absolute;\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-flow: row nowrap;\n    cursor: default;\n    white-space: nowrap;\n}\n\n.k-scrollview-wrap > .k-scrollview-view {\n    display: inline-block;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n\n.k-scrollview-wrap img {\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-scrollview-wrap.k-scrollview-animate {\n    width: calc(var(--kendo-scrollview-views, 1)*100%);\n    transition-duration: 0.3s;\n    transition-timing-function: ease-in-out;\n    transform: translateX(calc(-100%/var(--kendo-scrollview-views, 1)*(var(--kendo-scrollview-current, 1) - 1)));\n}\n\n[dir=\"rtl\"] .k-scrollview-wrap.k-scrollview-animate,\n.k-rtl .k-scrollview-wrap.k-scrollview-animate {\n    transform: translateX(calc(100%/var(--kendo-scrollview-views, 1)*(var(--kendo-scrollview-current, 1) - 1)));\n}\n\n.k-scrollview-wrap.k-scrollview-animate .k-scrollview-view {\n    width: calc(100%/var(--kendo-scrollview-views, 1));\n    flex: 0 0 calc(100%/var(--kendo-scrollview-views, 1));\n}\n\n.k-scrollview-nav-wrap {\n    padding: 0;\n    margin: 0;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 50px;\n    text-align: center;\n}\n\nkendo-scrollview.k-scrollview kendo-scrollview-pager {\n    pointer-events: none;\n}\n\nkendo-scrollview.k-scrollview .k-scrollview-nav {\n    pointer-events: initial;\n}\n\n.k-scrollview-nav {\n    margin: 0;\n    padding: 20px;\n    max-width: 100%;\n    box-sizing: border-box;\n    line-height: 0;\n    text-align: center;\n    white-space: nowrap;\n    list-style: none;\n    display: inline-flex;\n    align-items: center;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    pointer-events: initial;\n}\n\n.k-scrollview-nav:focus {\n    outline: none;\n}\n\n.k-scrollview-nav > .k-link {\n    margin-block: 0;\n    margin-inline: 10px;\n    padding: 0;\n    width: 10px;\n    height: 10px;\n    border-width: 0px;\n    border-style: solid;\n    border-radius: 50%;\n    box-sizing: content-box;\n    display: inline-block;\n    position: relative;\n    flex: 0 0 auto;\n    cursor: pointer;\n    pointer-events: all;\n    vertical-align: top;\n}\n\n.k-scrollview-nav > .k-link::before {\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    display: block;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    pointer-events: initial;\n    border-radius: 0;\n}\n\n.k-scrollview-next,\n.k-scrollview-prev {\n    display: table;\n    position: absolute;\n    padding: 0;\n    height: 60%;\n    top: 20%;\n    text-decoration: none;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n}\n\n.k-scrollview-next .k-icon,\n.k-scrollview-prev .k-icon {\n    display: table-cell;\n    overflow: visible;\n    margin: 0;\n    padding: 0;\n    vertical-align: middle;\n    font-weight: normal;\n}\n\n.k-scrollview-prev {\n    inset-inline-start: 0;\n}\n\n.k-scrollview-next {\n    inset-inline-end: 0;\n}\n\n.k-scrollview-animation {\n    transition-duration: .3s;\n    transition-timing-function: ease-in-out;\n}\n\n.k-scrollview {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-scrollview.k-scrollview-dark kendo-scrollview-pager,\n.k-scrollview.k-scrollview-dark .k-scrollview-nav-wrap {\n    background-color: rgba(0, 0, 0, 0.4);\n}\n\n.k-scrollview.k-scrollview-dark .k-scrollview-next,\n.k-scrollview.k-scrollview-dark .k-scrollview-prev {\n    color: rgba(0, 0, 0, 0.4);\n}\n\n.k-scrollview.k-scrollview-light kendo-scrollview-pager,\n.k-scrollview.k-scrollview-light .k-scrollview-nav-wrap {\n    background-color: rgba(255, 255, 255, 0.4);\n}\n\n.k-scrollview:focus,\n.k-scrollview-wrap:focus {\n    outline: none;\n}\n\n.k-scrollview-next,\n.k-scrollview-prev {\n    color: white;\n    background-color: rgba(0, 0, 0, 0);\n    text-shadow: rgba(0, 0, 0, 0.3) 0 0 15px;\n    opacity: 0.7;\n    outline-width: 0;\n}\n\n.k-scrollview-next:focus, .k-scrollview-next.k-focus,\n.k-scrollview-prev:focus,\n.k-scrollview-prev.k-focus {\n    color: white;\n    opacity: 1;\n}\n\n.k-scrollview-next:focus .k-icon::before, .k-scrollview-next.k-focus .k-icon::before,\n.k-scrollview-prev:focus .k-icon::before,\n.k-scrollview-prev.k-focus .k-icon::before {\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13);\n}\n\n.k-scrollview-next:hover, .k-scrollview-next.k-hover,\n.k-scrollview-prev:hover,\n.k-scrollview-prev.k-hover {\n    color: white;\n    opacity: 1;\n}\n\n.k-scrollview-nav > .k-link {\n    background-color: #e4e7eb;\n    border-color: #e4e7eb;\n}\n\n.k-scrollview-nav > .k-link.k-primary {\n    background: #0d6efd;\n    border: #0d6efd;\n}\n\n.k-scrollview-nav > .k-link:focus, .k-scrollview-nav > .k-link.k-focus {\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13);\n}\n\n.k-scrollview-nav > .k-link:hover, .k-scrollview-nav > .k-link.k-hover {\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.13);\n}\n\n.k-prompt {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n}\n\n.k-prompt-content {\n    padding-block: 1rem;\n    padding-inline: 1rem;\n    display: flex;\n    flex-flow: column nowrap;\n    flex: 1 1 auto;\n    gap: 1rem;\n    overflow: auto;\n}\n\n.k-prompt-view {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    gap: 1rem;\n}\n\n.k-prompt-expander {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    align-items: flex-start;\n    gap: 0.5rem;\n}\n\n.k-prompt-expander-content {\n    display: flex;\n    flex-flow: column;\n    flex: 0 0 auto;\n    gap: 0.5rem;\n    align-self: stretch;\n}\n\n.k-prompt-suggestion {\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 0.375rem;\n    padding-block: 0.5rem;\n    padding-inline: 0.5rem;\n    cursor: pointer;\n}\n\n.k-prompt-setting {\n    display: flex;\n    flex-direction: column;\n}\n\n.k-prompt-actions.k-actions, .k-prompt-actions.k-edit-buttons,\n.k-prompt-actions.k-action-buttons,\n.k-prompt-actions.k-columnmenu-actions, .k-prompt-actions.k-form-buttons {\n    margin: 0;\n}\n\n.k-prompt {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-prompt-header {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-prompt-content {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-prompt-suggestion {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n    box-shadow: var(--kendo-elevation-1, 0px 1px 2px rgba(0, 0, 0, 0.038));\n}\n\n.k-barcode {\n    display: inline-block;\n}\n\n.k-barcode > div {\n    height: 150px;\n}\n\n.k-var--chart-font {\n    font-size: 1rem;\n}\n\n.k-var--chart-title-font {\n    font-size: 1.143em;\n}\n\n.k-var--chart-pane-title-font {\n    font-size: 0.857em;\n    font-weight: 400;\n}\n\n.k-var--chart-label-font {\n    font-size: 0.857em;\n}\n\n.k-chart,\n.k-sparkline,\n.k-stockchart {\n    border-width: 0px;\n    border-style: solid;\n    box-sizing: border-box;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-chart,\n.k-stockchart {\n    display: block;\n    height: 400px;\n}\n\n.k-chart-surface {\n    height: 100%;\n}\n\n.k-chart .k-popup {\n    border-width: 0;\n}\n\n.k-chart-tooltip-wrapper .k-animation-container-shown,\n.k-chart-tooltip-wrapper.k-animation-container-shown {\n    transition: left 300ms cubic-bezier(0, 0.33, 0.19, 1), top 300ms cubic-bezier(0, 0.33, 0.19, 1);\n}\n\n.k-sparkline-tooltip-wrapper,\n.k-chart-tooltip-wrapper {\n    z-index: 12000;\n}\n\n.k-sparkline-tooltip-wrapper .k-popup,\n.k-chart-tooltip-wrapper .k-popup {\n    padding: 0;\n    border-width: 0;\n    background: transparent;\n}\n\n.k-chart-tooltip table {\n    border-spacing: 0;\n    border-collapse: collapse;\n}\n\n.k-chart-tooltip {\n    border-radius: 0.375rem;\n    font-size: 0.929rem;\n    line-height: 1.5;\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n}\n\n.k-chart-tooltip th {\n    width: auto;\n    text-align: center;\n    padding: 1px;\n}\n\n.k-chart-tooltip td {\n    width: auto;\n    text-align: start;\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    line-height: 1.5;\n    vertical-align: middle;\n}\n\n.k-chart-crosshair-tooltip,\n.k-chart-shared-tooltip {\n    border-width: 1px;\n    border-style: solid;\n}\n\n.k-chart-shared-tooltip .k-chart-shared-tooltip-marker {\n    display: block;\n    width: 15px;\n    height: 3px;\n    vertical-align: middle;\n}\n\n.k-selector {\n    position: absolute;\n    transform: translateZ(0);\n}\n\n.k-selection {\n    position: absolute;\n    height: 100%;\n    border-width: 1px;\n    border-style: solid;\n    border-bottom: 0;\n}\n\n.k-selection-bg {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n}\n\n.k-handle {\n    border-radius: 50%;\n    width: 22px;\n    height: 22px;\n    border-width: 1px;\n    border-style: solid;\n    z-index: 1;\n    position: absolute;\n    box-sizing: content-box;\n}\n\n.k-handle div {\n    width: 100%;\n    height: 100%;\n}\n\n.k-left-handle {\n    left: -11px;\n}\n\n.k-right-handle {\n    right: -11px;\n}\n\n.k-left-handle div {\n    margin: -22px 0 0 -14.6666666667px;\n    padding: 44px 29.3333333333px 0 0;\n}\n\n.k-right-handle div {\n    margin: -22px 0 0 -14.6666666667px;\n    padding: 44px 0 0 29.3333333333px;\n}\n\n.k-left-handle.k-handle-active div {\n    margin-left: -44px;\n    padding-left: 58.6666666667px;\n}\n\n.k-right-handle.k-handle-active div {\n    margin-left: -44px;\n    padding-right: 58.6666666667px;\n}\n\n.k-mask {\n    position: absolute;\n    height: 100%;\n}\n\n.k-navigator-hint div {\n    position: absolute;\n}\n\n.k-navigator-hint .k-scroll {\n    border-radius: 0.375rem;\n    position: absolute;\n    height: 4px;\n}\n\n.k-navigator-hint .k-tooltip {\n    margin-top: 20px;\n    min-width: 160px;\n    opacity: 1;\n    text-align: center;\n}\n\n.k-sparkline,\n.k-sparkline span {\n    display: inline-block;\n    vertical-align: top;\n}\n\n.k-sparkline span {\n    height: 100%;\n    width: 100%;\n}\n\n.k-chart-dragging {\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.k-chart-donut-center {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    border-radius: 50%;\n    text-align: center;\n    border: 4px solid transparent;\n    box-sizing: border-box;\n}\n\n.k-pdf-export .k-chart .k-animation-container,\n.k-pdf-export .k-sparkline .k-animation-container,\n.k-pdf-export .k-stockchart .k-animation-container {\n    display: none;\n}\n\n.k-diagram {\n    height: 600px;\n}\n\n.k-diagram .km-scroll-wrapper {\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n\n.k-diagram .km-scroll-wrapper {\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n\n.k-canvas-container {\n    width: 100%;\n    height: 100%;\n}\n\n.k-treemap {\n    height: 400px;\n    box-sizing: border-box;\n    border-width: 1px;\n    border-style: solid;\n    outline: 0;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    line-height: 1.5;\n    display: block;\n    overflow: hidden;\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-treemap .k-treemap-tile {\n    margin: -1px 0 0 -1px;\n    height: 100%;\n    box-sizing: border-box;\n    border: 1px solid;\n    border-color: inherit;\n    color: inherit;\n    background-color: inherit;\n    overflow: hidden;\n    position: absolute;\n}\n\n.k-treemap > .k-treemap-tile {\n    position: relative;\n}\n\n.k-treemap .k-treemap-title {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    border-width: 0 0 1px;\n    border-style: solid;\n    border-color: inherit;\n    font-size: 1rem;\n    background-position: 0 0;\n    background-repeat: repeat-x;\n}\n\n.k-treemap .k-treemap-title-vertical {\n    padding-block: 0.5rem;\n    padding-inline: 0.25rem;\n    width: 1.5em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n}\n\n.k-treemap .k-treemap-title-vertical > div {\n    transform-origin: right;\n    transform: rotate(-90deg);\n    position: absolute;\n    top: 0;\n    right: 1em;\n}\n\n.k-treemap .k-treemap-wrap {\n    border-color: inherit;\n    color: inherit;\n    background-color: inherit;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.k-treemap .k-treemap-title + .k-treemap-wrap {\n    top: calc(2rem + 1px);\n}\n\n.k-treemap .k-treemap-title-vertical + .k-treemap-wrap {\n    left: calc(2rem + 1px);\n}\n\n.k-treemap .k-leaf {\n    padding: 0.5rem;\n}\n\n.k-gauge {\n    text-align: start;\n    position: relative;\n}\n\n.k-arcgauge,\n.k-circulargauge {\n    display: inline-block;\n}\n\n.k-arcgauge-label,\n.k-circulargauge-label {\n    position: absolute;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n}\n\n.k-qrcode {\n    display: inline-block;\n}\n\n.k-qrcode > div {\n    height: 150px;\n}\n\n.k-var--primary {\n    background-color: #0d6efd;\n}\n\n.k-var--primary-contrast {\n    background-color: white;\n}\n\n.k-var--base {\n    background-color: #f8f9fa;\n}\n\n.k-var--background {\n    background-color: #ffffff;\n}\n\n.k-var--border-radius {\n    margin-top: 0.375rem;\n}\n\n.k-var--normal-background {\n    background-color: #f8f9fa;\n}\n\n.k-var--normal-text-color {\n    background-color: #212529;\n}\n\n.k-var--hover-background {\n    background-color: #e9ecef;\n}\n\n.k-var--hover-text-color {\n    background-color: #212529;\n}\n\n.k-var--selected-background {\n    background-color: #0d6efd;\n}\n\n.k-var--selected-text-color {\n    background-color: white;\n}\n\n.k-var--success {\n    background-color: #198754;\n}\n\n.k-var--info {\n    background-color: #0dcaf0;\n}\n\n.k-var--warning {\n    background-color: #ffc107;\n}\n\n.k-var--error {\n    background-color: #dc3545;\n}\n\n.k-var--series-a {\n    background-color: #0d6efd;\n}\n\n.k-var--series-b {\n    background-color: #6f42c1;\n}\n\n.k-var--series-c {\n    background-color: #20c997;\n}\n\n.k-var--series-d {\n    background-color: #198754;\n}\n\n.k-var--series-e {\n    background-color: #ffc107;\n}\n\n.k-var--series-f {\n    background-color: #dc3545;\n}\n\n.k-var--series-1 {\n    background-color: #0d6efd;\n}\n\n.k-var--series-2 {\n    background-color: #6f42c1;\n}\n\n.k-var--series-3 {\n    background-color: #20c997;\n}\n\n.k-var--series-4 {\n    background-color: #198754;\n}\n\n.k-var--series-5 {\n    background-color: #ffc107;\n}\n\n.k-var--series-6 {\n    background-color: #dc3545;\n}\n\n.k-var--series-7 {\n    background-color: #4a92fe;\n}\n\n.k-var--series-8 {\n    background-color: #9371d1;\n}\n\n.k-var--series-9 {\n    background-color: #58d7b1;\n}\n\n.k-var--series-10 {\n    background-color: #53a57f;\n}\n\n.k-var--series-11 {\n    background-color: #ffd145;\n}\n\n.k-var--series-12 {\n    background-color: #e56874;\n}\n\n.k-var--series-13 {\n    background-color: #0a53be;\n}\n\n.k-var--series-14 {\n    background-color: #533291;\n}\n\n.k-var--series-15 {\n    background-color: #189771;\n}\n\n.k-var--series-16 {\n    background-color: #13653f;\n}\n\n.k-var--series-17 {\n    background-color: #bf9105;\n}\n\n.k-var--series-18 {\n    background-color: #a52834;\n}\n\n.k-var--series-19 {\n    background-color: #86b7fe;\n}\n\n.k-var--series-20 {\n    background-color: #b7a1e0;\n}\n\n.k-var--series-21 {\n    background-color: #90e4cb;\n}\n\n.k-var--series-22 {\n    background-color: #8cc3aa;\n}\n\n.k-var--series-23 {\n    background-color: #ffe083;\n}\n\n.k-var--series-24 {\n    background-color: #ee9aa2;\n}\n\n.k-var--series-25 {\n    background-color: #07377f;\n}\n\n.k-var--series-26 {\n    background-color: #382161;\n}\n\n.k-var--series-27 {\n    background-color: #10654c;\n}\n\n.k-var--series-28 {\n    background-color: #0d442a;\n}\n\n.k-var--series-29 {\n    background-color: #806104;\n}\n\n.k-var--series-30 {\n    background-color: #6e1b23;\n}\n\n.k-var--gauge-pointer {\n    background-color: #0d6efd;\n}\n\n.k-var--gauge-track {\n    background-color: #ebebeb;\n}\n\n.k-var--chart-inactive {\n    background-color: rgba(33, 37, 41, 0.5);\n}\n\n.k-var--chart-major-lines {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n.k-var--chart-minor-lines {\n    background-color: rgba(0, 0, 0, 0.04);\n}\n\n.k-var--chart-area-opacity {\n    opacity: 0.6;\n}\n\n.k-var--chart-area-inactive-opacity {\n    opacity: 0.1;\n}\n\n.k-var--chart-line-inactive-opacity {\n    opacity: 0.3;\n}\n\n.k-var--chart-notes-background {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.k-var--chart-notes-border {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.k-var--chart-notes-lines {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.k-var--chart-crosshair-background {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.k-var--chart-error-bars-background {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.k-chart,\n.k-sparkline,\n.k-stockchart {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: transparent;\n}\n\n.k-chart .k-popup,\n.k-sparkline .k-popup,\n.k-stockchart .k-popup {\n    background: transparent;\n}\n\n.k-chart-tooltip {\n    color: #ffffff;\n}\n\n.k-chart-tooltip-inverse {\n    color: #000000;\n}\n\n.k-chart-crosshair-tooltip,\n.k-chart-shared-tooltip {\n    color: #212529;\n    background-color: #ebebeb;\n    border-color: rgba(0, 0, 0, 0.08);\n}\n\n.k-selection {\n    border-color: rgba(0, 0, 0, 0.08);\n    box-shadow: inset 0 1px 7px rgba(0, 0, 0, 0.15);\n}\n\n.k-selection-bg {\n    background-color: transparent;\n}\n\n.k-handle {\n    cursor: e-resize;\n    border-color: #e4e7eb;\n    color: #212529;\n    background-color: #e4e7eb;\n}\n\n.k-handle:hover {\n    border-color: #c7cdd5;\n    background-color: #ced3db;\n}\n\n.k-handle div {\n    background-color: transparent;\n}\n\n.k-mask {\n    background-color: #ffffff;\n    opacity: .8;\n}\n\n.k-treemap {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-treemap .k-treemap-title {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-treemap .k-leaf {\n    color: #ffffff;\n}\n\n.k-treemap .k-leaf.k-inverse {\n    color: #212529;\n}\n\n.k-treemap .k-leaf:hover,\n.k-treemap .k-leaf.k-hover {\n    box-shadow: inset 0 0 0 3px #dee2e6;\n}\n\n.k-map {\n    height: 600px;\n    box-sizing: border-box;\n    border-width: 0px;\n    border-style: solid;\n    font-size: 1rem;\n    line-height: 1.5;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n\n.k-map *,\n.k-map *::before,\n.k-map *::after {\n    box-sizing: border-box;\n}\n\n.k-map .km-scroll-wrapper {\n    width: 100%;\n    height: 100%;\n    -webkit-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    position: absolute;\n}\n\n.k-map .km-scroll-container {\n    height: 100%;\n}\n\n.k-map .k-touch-scrollbar {\n    display: none;\n}\n\n.k-map .k-layer {\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n\n.k-map .k-marker {\n    transform: translate(-50%, -100%);\n    cursor: pointer;\n    position: absolute;\n    overflow: visible;\n}\n\n.k-map .k-attribution {\n    padding-block: 0.25rem;\n    padding-inline: 0.5rem;\n    border-width: 0;\n    font-size: 0.75rem;\n    z-index: 1000;\n}\n\n.k-map-controls {\n    position: absolute;\n    display: flex;\n    align-items: center;\n}\n\n.k-navigator {\n    margin: 1rem;\n    width: 52px;\n    height: 52px;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    border-radius: 50%;\n    position: relative;\n}\n\n.k-pdf-export .k-navigator {\n    display: none;\n}\n\n.k-navigator .k-button {\n    padding: 0;\n    width: auto;\n    height: auto;\n    line-height: 1;\n    box-shadow: none;\n    position: absolute;\n}\n\n.k-navigator .k-button .k-icon {\n    min-width: 0;\n    min-height: 0;\n}\n\n.k-navigator .k-navigator-n,\n.k-navigator .k-navigator-up {\n    transform: translateX(-50%);\n    top: 2px;\n    left: 50%;\n}\n\n.k-navigator .k-navigator-e,\n.k-navigator .k-navigator-right {\n    transform: translateY(-50%);\n    right: 2px;\n    top: 50%;\n}\n\n.k-navigator .k-navigator-s,\n.k-navigator .k-navigator-down {\n    transform: translateX(-50%);\n    bottom: 2px;\n    left: 50%;\n}\n\n.k-navigator .k-navigator-w,\n.k-navigator .k-navigator-left {\n    transform: translateY(-50%);\n    left: 2px;\n    top: 50%;\n}\n\n.k-zoom-control {\n    margin: 1rem;\n    border: 0;\n    background: none;\n    display: flex;\n}\n\n.k-pdf-export .k-zoom-control {\n    display: none;\n}\n\n.k-map {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-map .k-navigator {\n    border-color: #e4e7eb;\n    color: #212529;\n    background-color: #e4e7eb;\n}\n\n.k-map .k-marker {\n    color: #0d6efd;\n}\n\n.k-map .k-attribution {\n    background-color: rgba(255, 255, 255, 0.8);\n}\n\n.k-orgchart {\n    width: 100%;\n    padding-block: 1.5rem;\n    padding-inline: 1.5rem;\n    box-sizing: border-box;\n    font-size: 1rem;\n    font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    line-height: 1.5;\n    overflow: auto;\n}\n\n.k-orgchart *,\n.k-orgchart *::before,\n.k-orgchart *::after {\n    box-sizing: border-box;\n}\n\n.k-orgchart-container {\n    margin-block: 0;\n    margin-inline: auto;\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n\n.k-orgchart-group {\n    gap: 1.5rem;\n}\n\n.k-orgchart-group.k-vstack > .k-orgchart-node-container, .k-orgchart-group.k-vbox > .k-orgchart-node-container {\n    gap: 0;\n}\n\n.k-orgchart-node-container {\n    gap: 1.5rem;\n}\n\n.k-orgchart-node-group-container {\n    border-radius: 0.375rem;\n    padding-block: 1.5rem;\n    padding-inline: 1.5rem;\n    border-width: 1px;\n    border-style: solid;\n    outline: 0;\n}\n\n.k-orgchart-node-group-title {\n    margin: 0 0 0.375rem;\n    font-size: 1.25rem;\n    line-height: 1.25;\n}\n\n.k-orgchart-node-group-subtitle {\n    margin: 0 0 1.5rem;\n    font-size: 1rem;\n}\n\n.k-orgchart-card {\n    width: 300px;\n    border-width: 1px;\n}\n\n.k-orgchart-card .k-card-title {\n    margin: 0 0 0px;\n}\n\n.k-orgchart-card .k-card-subtitle {\n    margin: 0 0 0px;\n}\n\n.k-orgchart-card .k-card-body {\n    border-width: 2px 0 0;\n    border-style: solid;\n    flex-grow: 0;\n}\n\n.k-orgchart-card .k-card-body .k-card-title-wrap {\n    margin: 0 0.75rem 0 0;\n    min-width: 0;\n    min-height: 45px;\n}\n\n.k-orgchart-line {\n    background-color: currentColor;\n}\n\n.k-orgchart-line-h {\n    height: 1px;\n}\n\n.k-orgchart-line-v {\n    margin-block: 0;\n    margin-inline: auto;\n    width: 1px;\n    height: 25px;\n}\n\n.k-orgchart-button {\n    z-index: 1;\n}\n\n.k-orgchart {\n    border-color: #dee2e6;\n    color: #212529;\n    background-color: #ffffff;\n}\n\n.k-orgchart-card .k-card-body {\n    border-color: transparent;\n}\n\n.k-orgchart-card:focus, .k-orgchart-card.k-focus {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-orgchart-node-group-container {\n    border-color: #e4e5e6;\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.k-orgchart-node-group-container:focus,\n.k-orgchart-node-group-container.k-focus {\n    box-shadow: var(--kendo-elevation-3, 0px 4px 10px rgba(0, 0, 0, 0.1));\n}\n\n.k-orgchart-node-group-subtitle {\n    color: #6c757d;\n}\n\n.k-orgchart-line-h,\n.k-orgchart-line-v {\n    color: #e4e5e6;\n}\n\n.k-signature {\n    width: 246px;\n    min-height: 108px;\n    position: relative;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.k-signature.k-signature-maximized {\n    width: 750px;\n    height: 252px;\n}\n\n.k-signature.k-signature-maximized > .k-signature-line {\n    border-bottom-width: 3px;\n}\n\n.k-signature-actions {\n    display: flex;\n    width: min-content;\n    margin-inline-start: auto;\n    gap: 0.25rem;\n    z-index: 2;\n}\n\n.k-signature-canvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: block;\n    z-index: 1;\n    outline: none;\n}\n\n.k-signature-line {\n    position: absolute;\n    bottom: 33%;\n    z-index: 2;\n    pointer-events: none;\n    border-bottom-width: 1px;\n    border-bottom-style: dashed;\n}\n\n.k-signature-sm {\n    padding-inline: 0.5rem;\n    padding-block: 0.125rem;\n}\n\n.k-signature-sm .k-signature-line {\n    width: calc(100% - 1rem);\n}\n\n.k-signature-md {\n    padding-inline: 0.75rem;\n    padding-block: 0.25rem;\n}\n\n.k-signature-md .k-signature-line {\n    width: calc(100% - 1.5rem);\n}\n\n.k-signature-lg {\n    padding-inline: 1rem;\n    padding-block: 0.5rem;\n}\n\n.k-signature-lg .k-signature-line {\n    width: calc(100% - 2rem);\n}\n\n.k-signature-lg {\n    min-height: 110px;\n}\n\n.k-signature .k-signature-line {\n    border-bottom-color: rgba(13, 202, 240, 0.24);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
